import { withPaginationDetails } from "../utils/decorators/withPaginationDetails";
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '../legacy/apollo/codegenReactApolloHooks';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: string;
  DateTime: any;
  EmailAddress: any;
  GoogleProtobufAnyScalar: any;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
  JSONObject: any;
  ObjMap: any;
  PermissionsInput: any;
  PositiveInt: any;
  RetailerContactManagement_query_getContacts_oneOf_0_items_name: any;
  RetailerContactManagement_query_getContacts_oneOf_0_items_role: any;
  Time: string;
  True: true;
  Url: any;
  Void: any;
  google_protobuf_Empty: any;
  google_protobuf_Empty_Input: any;
  instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext: any;
  instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext_Input: any;
  instacart_ads_targeting_v1_NewToInstacartCondition: any;
  instacart_ads_targeting_v1_NewToInstacartCondition_Input: any;
  instacart_caper_admin_v1_CancelScheduledActionResponse: any;
  instacart_caper_admin_v1_CreateConfigKeyResponse: any;
  instacart_caper_admin_v1_CreateDeviceResponse: any;
  instacart_caper_admin_v1_CreateFeatureResponse: any;
  instacart_caper_admin_v1_CreatePartnerResponse: any;
  instacart_caper_admin_v1_CreateRetailerResponse: any;
  instacart_caper_admin_v1_GetAllEntitiesRequest_Input: any;
  instacart_caper_admin_v1_GetAvailableProfilesRequest_Input: any;
  instacart_caper_admin_v1_GetFeaturesRequest_Input: any;
  instacart_caper_admin_v1_LockCartsResponse: any;
  instacart_caper_admin_v1_ReviewNofResponse: any;
  instacart_caper_admin_v1_SendReceiptResponse: any;
  instacart_caper_admin_v1_SetBanEntryArchivedResponse: any;
  instacart_caper_admin_v1_UpdateConfigKeyResponse: any;
  instacart_caper_admin_v1_UpdateConfigResponse: any;
  instacart_caper_admin_v1_UpdateFeatureResponse: any;
  instacart_caper_admin_v1_UpdateGlobalResponse: any;
  instacart_catalog_admin_v1_MakeMissingCodeDecisionResponse: any;
  instacart_catalog_admin_v1_SetRetailerDiscountThresholdBringBacksResponse: any;
  instacart_catalog_admin_v1_SetRetailerDiscountThresholdsResponse: any;
  instacart_catalog_admin_v1_TempOverrideServiceCreateResponse: any;
  instacart_catalog_catflow_v1_RevertToStepVersionResponse: any;
  instacart_catalog_catflow_v1_UpdateStepResponse: any;
  instacart_catalog_catflow_v1_UpdateStepVersionStateResponse: any;
  instacart_customers_basket_products_orchestrators_v1_GetBasketProductsRequest_NoUser_Input: any;
  instacart_customers_business_admin_v1_DeleteBusinessProgramContentResponse: any;
  instacart_customers_business_admin_v1_DeleteBusinessProgramOfferResponse: any;
  instacart_customers_business_admin_v1_DeleteBusinessProgramResponse: any;
  instacart_customers_campaigns_v1_TestOfflineCampaignResponse: any;
  instacart_customers_commerce_coupons_v1_BulkCreateChildCouponCodesResponse: any;
  instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_DirectedSpendProgramEnrollmentRequired: any;
  instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipExcluded: any;
  instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipRequired: any;
  instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario: any;
  instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario_Input: any;
  instacart_customers_flyer_pdf_v1_ClassificationFilter_Debug: any;
  instacart_customers_flyer_pdf_v1_ClassificationFlagger_Debug: any;
  instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition: any;
  instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_FilterClassification_Debug: any;
  instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default: any;
  instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default_Input: any;
  instacart_customers_flyer_pdf_v1_ImageClassifier_Definition: any;
  instacart_customers_flyer_pdf_v1_ImageClassifier_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_ImageCluster_Debug: any;
  instacart_customers_flyer_pdf_v1_PdfPageParser_Debug: any;
  instacart_customers_flyer_pdf_v1_PromptFilter_Debug: any;
  instacart_customers_flyer_pdf_v1_PromptFlagger_Debug: any;
  instacart_customers_flyer_pdf_v1_QualityReviewer_Debug: any;
  instacart_customers_flyer_pdf_v1_TextClassifier_Definition: any;
  instacart_customers_flyer_pdf_v1_TextClassifier_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_TextCorrect_Debug: any;
  instacart_customers_flyer_pdf_v1_TextCorrect_Definition: any;
  instacart_customers_flyer_pdf_v1_TextCorrect_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_TextHeightCorrect_Debug: any;
  instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition: any;
  instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition_Input: any;
  instacart_customers_recipes_v1_GetCoreIngredientsRequest_Input: any;
  instacart_customers_search_v1_DeleteSearchTermOverridesByIdResponse: any;
  instacart_enterprise_boba_core_types_v1_OfferDetails_UncategorizedScenario: any;
  instacart_enterprise_frigate_delivery_software_v1_CancelPartnerBulkDeliveryRouteResponse: any;
  instacart_enterprise_frigate_delivery_software_v1_UpdatePartnerBulkDeliveryRouteResponse: any;
  instacart_flawless_inventory_v1_GetJobSourcesRequest_Input: any;
  instacart_flawless_inventory_v1_GetMapleSupportedModelsRequest_Input: any;
  instacart_fulfillment_shopper_transaction_integrity_v1_GetStepTypesRequest_Input: any;
  instacart_logistics_v1_ListCreatorsRequest_Input: any;
  instacart_logistics_v1_ListTagsRequest_Input: any;
  instacart_partners_partners_v1_GetFlipFeatureGroupsRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_CheckHealthResponse: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetAutomationsRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetConnectionsRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetStoresRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetSyncStrategiesRequest_Input: any;
  instacart_upos_config_v1_GetIntegrationsRequest_Input: any;
  instacart_upos_config_v1_GetProfilesRequest_Input: any;
  instacart_upos_config_v1_GetRetailersRequest_Input: any;
  instacart_upos_config_v1_GetStoresRequest_Input: any;
  instacart_upos_config_v1_Version_Create: any;
  instacart_upos_status_v1_GetIntegrationStatusesRequest_Input: any;
  instacart_upos_status_v1_IntegrationStatus_Undetermined: any;
};

export type AccessControlAuthorizationAuthorizationCheck = {
  __typename?: 'AccessControlAuthorizationAuthorizationCheck';
  /** Determines whether the current account has access to the given rules */
  authorized: Scalars['Boolean'];
  /** An array of reasons why validation failed, if any */
  reasons: Array<RejectionReasonEnum>;
  /** Details about why validation failed, if any */
  rejectDetails: Maybe<AccessControlAuthorizationRejectionReasonDetails>;
};

export type AccessControlAuthorizationNoPartnerWriteAccess = {
  __typename?: 'AccessControlAuthorizationNoPartnerWriteAccess';
  /** The partners which the account does not have write access to */
  partnerDetails: Maybe<Array<AccessControlAuthorizationPartnerWriteAccessErrorDetails>>;
  /** The partners names which the account does not have write access to */
  partners: Maybe<Array<Scalars['String']>>;
};

export type AccessControlAuthorizationPartnerWriteAccessErrorDetails = {
  __typename?: 'AccessControlAuthorizationPartnerWriteAccessErrorDetails';
  /** A unique identifier for the partner */
  id: Maybe<Scalars['ID']>;
  /** The name of the partner */
  name: Maybe<Scalars['String']>;
};

export type AccessControlAuthorizationRejectionReasonDetails = {
  __typename?: 'AccessControlAuthorizationRejectionReasonDetails';
  /** The rejection reason details for no partner write access */
  noPartnerWriteAccess: Maybe<AccessControlAuthorizationNoPartnerWriteAccess>;
};

export type AccessControlConfiguration = {
  __typename?: 'AccessControlConfiguration';
  /** The policies associated with the account */
  policies: AccessControlPolicies;
  /** The access control details for the retailer */
  retailerDetails: AccessControlRetailerDetails;
};


export type AccessControlConfigurationRetailerDetailsArgs = {
  retailerId: Scalars['ID'];
};

export type AccessControlPolicies = {
  __typename?: 'AccessControlPolicies';
  /** Permission to view the admin tools section */
  viewAdminToolsSection: Scalars['Boolean'];
  /** Permission to view the retailer dashboard section */
  viewRetailerDashboardSection: Scalars['Boolean'];
};

export type AccessControlRetailerDetails = {
  __typename?: 'AccessControlRetailerDetails';
  /** The policies associated with the retailer */
  policies: AccessControlRetailerPolicies;
};

export type AccessControlRetailerPolicies = {
  __typename?: 'AccessControlRetailerPolicies';
  /** Permission to modify retailer location groups */
  modifyRetailerLocationGroups: Scalars['Boolean'];
  /** Permission to modify retailer reports */
  modifyRetailerReports: Scalars['Boolean'];
  /** Permission to view retailer location groups */
  viewRetailerLocationGroups: Scalars['Boolean'];
  /** Permission to view retailer reports */
  viewRetailerReports: Scalars['Boolean'];
};

export type AccessToken = {
  __typename?: 'AccessToken';
  /** The account associated with the token */
  enterpriseAccount: Maybe<EnterpriseAccount>;
  /** A unique token for authentication purposes */
  token: Scalars['ID'];
};

export type AccountInput = {
  /** A unique identifier for the account */
  id: Scalars['ID'];
};

export type AccountOrdersEmptyState = {
  __typename?: 'AccountOrdersEmptyState';
  enabled: Maybe<Scalars['Boolean']>;
  imageUrl: Maybe<Scalars['String']>;
};

export type AccountRequestAccountRequest = {
  __typename?: 'AccountRequestAccountRequest';
  /** Canonical account ID */
  accountCanonicalId: Maybe<Scalars['String']>;
  /** Time this request was created */
  createdAt: Scalars['Time'];
  /** Country associated with this retailer */
  email: Scalars['String'];
  /** Country associated with this retailer */
  fullName: Scalars['String'];
  /** A unique identifier for the retailer */
  id: Scalars['ID'];
  /** justification from retailer employee for account creation */
  requestReason: Scalars['String'];
  /** Current state of the request */
  requestState: RequestStateEnum;
  /** The name of the retailer */
  retailerId: Scalars['ID'];
  /** Requested role IDs */
  roles: Array<EnterpriseRole>;
};

export type AccountRequestPreviousRequestExists = {
  __typename?: 'AccountRequestPreviousRequestExists';
  /** Does a previous account request exist */
  requestExists: Scalars['Boolean'];
};

export enum AccountSortEnum {
  /** Sort by creation date */
  CreatedAt = 'CREATED_AT',
  /** Sort by email address */
  Email = 'EMAIL',
  /** Sort by account ID */
  Id = 'ID',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by account status */
  Status = 'STATUS'
}

export enum AccountStatusEnum {
  /** Active status */
  Active = 'ACTIVE',
  /** Disabled status */
  Disabled = 'DISABLED',
  /** Pending status */
  Pending = 'PENDING'
}

export type AddRetailerCampaignTreatmentsRequestInput = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<CreateRetailerCampaignTreatmentParamsInput>>>;
};

export type AddRetailerCampaignTreatmentsResponse = {
  __typename?: 'AddRetailerCampaignTreatmentsResponse';
  treatments: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
};

export type AdditionalEnvVariableInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  apartmentNumber: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  streetAddress: Maybe<Scalars['String']>;
};

export type AddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
};

export type AdminNavigationV2 = {
  __typename?: 'AdminNavigationV2';
  desktopFlexibleHeaderLayoutV1: Maybe<DesktopFlexibleHeaderLayoutV1Navigations>;
  desktopSidebarLayoutV1: Maybe<DesktopSidebarLayoutV1Navigations>;
  mobileWebHamburgerMenuLayoutV1: Maybe<MobileWebHamburgerMenuLayoutV1Navigations>;
  nativeMoreMenuLayoutV1: Maybe<NativeMoreMenuLayoutV1Navigations>;
};

export type AdminNavigationV2Input = {
  desktopFlexibleHeaderLayoutV1?: InputMaybe<DesktopFlexibleHeaderLayoutV1NavigationsInput>;
  desktopSidebarLayoutV1?: InputMaybe<DesktopSidebarLayoutV1NavigationsInput>;
  mobileWebHamburgerMenuLayoutV1?: InputMaybe<MobileWebHamburgerMenuLayoutV1NavigationsInput>;
  nativeMoreMenuLayoutV1?: InputMaybe<NativeMoreMenuLayoutV1NavigationsInput>;
};

export type AdminRequestContextInput = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type AdsSchema = {
  __typename?: 'AdsSchema';
  allowAlcoholSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowBiaPageSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowBrowseSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowCartSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowCheckoutSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowExperimentalPlacements: Maybe<Scalars['Boolean']>;
  allowItemDetailsSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowSearchGridSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowSearchOtherSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowSponsoredProducts: Maybe<Scalars['Boolean']>;
  allowStorefrontSponsoredProducts: Maybe<Scalars['Boolean']>;
};

export type AdvanceBatchStateRequestInput = {
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type AdvanceBatchStateResponse = {
  __typename?: 'AdvanceBatchStateResponse';
  id: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<Scalars['String']>;
};

/** Defines a single affecting scope for querying approval requests. */
export type AffectingScopeInput = {
  /** Filter by partner IDs affected by the approval request. */
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by retailer IDs affected by the approval request. */
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by retailer location IDs affected by the approval request. */
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by store configuration IDs affected by the approval request. */
  storeConfigIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Defines filtering criteria for affecting scopes in a request to list approval requests. */
export type AffectingScopeSearchInput = {
  /** Returns ARs that match ANY of the provided AffectingScopes. To match, the AR's AffectingScope must be a superset of the provided AffectingScope. */
  affectingScopes?: InputMaybe<Array<AffectingScopeInput>>;
  /** Returns ARs that have no AffectingScope; i.e., empty partners/retailers/locations/store-configs. */
  includeGlobalScope?: InputMaybe<Scalars['Boolean']>;
};

export type AgentRequestInput = {
  messages: Array<MessageInput>;
  tools?: InputMaybe<Array<ToolInput>>;
  uiContext: UiContextInput;
};

export type AgentResponse = {
  __typename?: 'AgentResponse';
  finalResult: Maybe<Scalars['String']>;
  messages: Array<Message>;
  summary: Maybe<Scalars['String']>;
};

/** The type of agreement being accepted */
export enum AgreementTypeEnum {
  /** IDP Terms and Conditions v1 */
  IdpV1 = 'IDP_V1',
  /** Partner Dashboard Terms and Conditions v1 */
  PartnerDashboardV1 = 'PARTNER_DASHBOARD_V1'
}

/** Autogenerated return type of AiAgentConversationUpsert */
export type AiAgentConversationUpsertPayload = {
  __typename?: 'AiAgentConversationUpsertPayload';
  /** Whether the conversation was upserted successfully */
  success: Scalars['True'];
};

export type AiCarouselConfiguration = {
  __typename?: 'AiCarouselConfiguration';
  attributeFilters: Maybe<Array<Maybe<Scalars['String']>>>;
  carouselTargeting: Maybe<Scalars['String']>;
  carouselTitle: Maybe<Scalars['String']>;
  duplicationFlag: Maybe<Scalars['Boolean']>;
  endDate: Maybe<Scalars['DateTime']>;
  itemRanking: Maybe<Scalars['String']>;
  itemRetrievalFilters: Maybe<Array<Maybe<Scalars['String']>>>;
  itemRetrievalLogic: Maybe<Scalars['String']>;
  keywords: Maybe<Array<Maybe<Scalars['String']>>>;
  rawAttributeFilters: Maybe<Array<Maybe<Scalars['String']>>>;
  rawKeywords: Maybe<Array<Maybe<Scalars['String']>>>;
  similarCarousels: Maybe<Array<Maybe<Scalars['String']>>>;
  startDate: Maybe<Scalars['DateTime']>;
};

export type AisleGroup = {
  __typename?: 'AisleGroup';
  aisleDisplayName: Maybe<Scalars['String']>;
  aisleId: Maybe<Scalars['String']>;
  estimatedLostSales: Maybe<Scalars['Float']>;
  items: Maybe<Array<Maybe<AisleRestockItem>>>;
  lowStockCount: Maybe<Scalars['Int']>;
  oosCount: Maybe<Scalars['Int']>;
};

export type AisleOrder = {
  __typename?: 'AisleOrder';
  inventoryAreaAisleId: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  rank: Maybe<Scalars['BigInt']>;
};

export type AisleOrderInput = {
  inventoryAreaAisleId?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['BigInt']>;
};

export type AisleRestockItem = {
  __typename?: 'AisleRestockItem';
  backstockStatus: Maybe<BackstockStatus>;
  category: Maybe<Scalars['String']>;
  currentFacings: Maybe<Scalars['Int']>;
  department: Maybe<Scalars['String']>;
  estimatedLostSales: Maybe<Scalars['Float']>;
  imageUrl: Maybe<Scalars['String']>;
  isKeyItem: Maybe<Scalars['Boolean']>;
  lastScanDatetime: Maybe<Scalars['DateTime']>;
  name: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  salesVelocity: Maybe<Scalars['Float']>;
  shelfImageTimestamp: Maybe<Scalars['DateTime']>;
  shelfImageUrl: Maybe<Scalars['String']>;
  stockStatus: Maybe<StockStatus>;
  upc: Maybe<Scalars['String']>;
  urgencyScore: Maybe<Scalars['Float']>;
};

export type AisleRestockSummaryMetadata = {
  __typename?: 'AisleRestockSummaryMetadata';
  aisleScansToday: Maybe<Scalars['Int']>;
  generatedAt: Maybe<Scalars['DateTime']>;
  totalAislesScanned: Maybe<Scalars['Int']>;
  totalEstimatedLostSales: Maybe<Scalars['Float']>;
  totalLowStockItems: Maybe<Scalars['Int']>;
  totalOosItems: Maybe<Scalars['Int']>;
};

export type AllNavigationWithContainersItems = {
  __typename?: 'AllNavigationWithContainersItems';
  container: Maybe<Container>;
  flatNavigation: Maybe<FlatNavigation>;
  navigationItem: Maybe<NavigationV2Item>;
};

export type AllNavigationWithContainersItemsInput = {
  container?: InputMaybe<ContainerInput>;
  flatNavigation?: InputMaybe<FlatNavigationInput>;
  navigationItem?: InputMaybe<NavigationV2ItemInput>;
};

export type Analytics = {
  __typename?: 'Analytics';
  cadence: Maybe<Cadence>;
  dateRange: Maybe<InstacartAdsSharedV1DateRange>;
  entity: Maybe<Entity>;
  metric: Maybe<Metric>;
  valueToDate: Maybe<Array<Maybe<AnalyticsUnit>>>;
  valueToDateV2: Maybe<Array<Maybe<AnalyticsUnitV2>>>;
};

export type AnalyticsUnit = {
  __typename?: 'AnalyticsUnit';
  date: Maybe<Scalars['DateTime']>;
  value: Maybe<Scalars['Float']>;
};

export type AnalyticsUnitV2 = {
  __typename?: 'AnalyticsUnitV2';
  date: Maybe<GoogleTypeDate>;
  value: Maybe<Scalars['Float']>;
};

export type AnomalousItemDateCount = {
  __typename?: 'AnomalousItemDateCount';
  count: Maybe<Scalars['BigInt']>;
  date: Maybe<Scalars['DateTime']>;
};

export enum AnomalyDetectionAlertLevel {
  Critical = 'critical',
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  None = 'none'
}

export type AnomalyDetectionEntropyProfile = {
  __typename?: 'AnomalyDetectionEntropyProfile';
  high: Scalars['Int'];
  low: Scalars['Int'];
  moderate: Scalars['Int'];
  veryLow: Scalars['Int'];
};

export type AnomalyDetectionEntry = {
  __typename?: 'AnomalyDetectionEntry';
  alertLevel: AnomalyDetectionAlertLevel;
  avgEntropyScore: Scalars['Float'];
  avgSensitivityScore: Scalars['Float'];
  clientIps: Array<Scalars['String']>;
  compositeScore: Scalars['Int'];
  entropyProfile: AnomalyDetectionEntropyProfile;
  ipVariations: Scalars['Int'];
  ja3HashVariations: Scalars['Int'];
  ja3Hashes: Array<Scalars['String']>;
  lastActivity: Scalars['String'];
  recentRequestsCount: Scalars['Int'];
  requests: Array<AnomalyDetectionRequest>;
  sensitivityProfile: AnomalyDetectionSensitivityProfile;
  userAgentVariations: Scalars['Int'];
  userAgents: Array<Scalars['String']>;
  userInfo: AnomalyDetectionUserInfo;
};

export type AnomalyDetectionFilters = {
  alertLevel?: InputMaybe<AnomalyDetectionAlertLevel>;
  maxEntropyScore?: InputMaybe<Scalars['Int']>;
  maxJa3HashVariations?: InputMaybe<Scalars['Int']>;
  maxScore?: InputMaybe<Scalars['Int']>;
  minEntropyScore?: InputMaybe<Scalars['Int']>;
  minJa3HashVariations?: InputMaybe<Scalars['Int']>;
  minRequests?: InputMaybe<Scalars['Int']>;
  minScore?: InputMaybe<Scalars['Int']>;
  sensitivityCategory?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};

export type AnomalyDetectionRequest = {
  __typename?: 'AnomalyDetectionRequest';
  clientIp: Scalars['String'];
  entropyScore: Scalars['Float'];
  operation: Scalars['String'];
  sensitivityCategory: Scalars['String'];
  sensitivityScore: Scalars['Int'];
  timestamp: Scalars['Float'];
};

export type AnomalyDetectionSensitivityProfile = {
  __typename?: 'AnomalyDetectionSensitivityProfile';
  financial: Scalars['Int'];
  pii: Scalars['Int'];
};

export enum AnomalyDetectionSortField {
  AlertLevel = 'alertLevel',
  CompositeScore = 'compositeScore',
  EntropyScore = 'entropyScore',
  LastActivity = 'lastActivity',
  RecentRequests = 'recentRequests',
  SensitivityScore = 'sensitivityScore'
}

export type AnomalyDetectionUserInfo = {
  __typename?: 'AnomalyDetectionUserInfo';
  email: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ApiIntegrationStoreLocation = {
  __typename?: 'ApiIntegrationStoreLocation';
  active: Maybe<Scalars['Boolean']>;
  currentlySynced: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** Defines the current state of the Approval Request. */
export enum ApprovalRequestState {
  /** Approval Request has been approved. */
  Approved = 'APPROVED',
  /** Approval Request has been cancelled. */
  Cancelled = 'CANCELLED',
  /** Approval Request is pending. */
  Pending = 'PENDING',
  /** Approval Request has been published. */
  Published = 'PUBLISHED',
  /** Approval Request is in the process of being published. */
  Publishing = 'PUBLISHING'
}

export type ApprovalRequestStatusResult = {
  __typename?: 'ApprovalRequestStatusResult';
  approvalRequest: Maybe<LaunchOnboardingApprovalRequest>;
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

/** Defines the resources that the Approval Request affects. */
export type ApprovalsManagementTypesAffectingScope = {
  __typename?: 'ApprovalsManagementTypesAffectingScope';
  /** The partner IDs affected by the approval request */
  partnerIds: Array<Scalars['String']>;
  /** The retailer IDs affected by the approval request */
  retailerIds: Array<Scalars['String']>;
  /** The retailer location IDs affected by the approval request */
  retailerLocationIds: Array<Scalars['String']>;
  /** The store configuration IDs affected by the approval request */
  storeConfigIds: Array<Scalars['String']>;
};

/** The Approval Request object. */
export type ApprovalsManagementTypesApprovalRequest = {
  __typename?: 'ApprovalsManagementTypesApprovalRequest';
  /** The resources affected by the changes underlying this approval request */
  affectingScope: ApprovalsManagementTypesAffectingScope;
  /** The base snapshot */
  baseSnapshot: Maybe<ApprovalsManagementTypesContentSnapshotShallow>;
  /** Foreign keys pointing to the record(s) in the content's database */
  contentIds: Maybe<Array<Scalars['String']>>;
  /** The content type, defined statically in AMS */
  contentType: Scalars['String'];
  /** The creation time of the approval request */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created the approval request */
  createdByUser: EnterpriseAccount;
  /** The unique UUID for the Approval Request */
  id: Scalars['ID'];
  /** Used to de-duplicate Approval Requests */
  idempotencyId: Scalars['String'];
  /** Optional opaque metadata for the Approval Request */
  metadata: Maybe<Scalars['JSON']>;
  /** A user-provided name/description for the Approval Request */
  name: Scalars['String'];
  /** The current state of the approval request */
  requestState: ApprovalRequestState;
  /** Reviews posted on this approval request */
  reviews: Array<ApprovalsManagementTypesUserReviewReference>;
  /** The list of revision snapshots */
  revisionSnapshots: Maybe<Array<ApprovalsManagementTypesContentSnapshotShallow>>;
};

/** A shallow snapshot, used primarily for referencing content revisions. */
export type ApprovalsManagementTypesContentSnapshot = {
  __typename?: 'ApprovalsManagementTypesContentSnapshot';
  /** The ID of the request associated with the snapshot */
  approvalRequestId: Scalars['ID'];
  /** The content of the snapshot, serialized as a string */
  contentBytes: Scalars['String'];
  /** Metadata associated with the content at the time of the snapshot */
  contentMetadata: Scalars['JSON'];
  /** The time at which the snapshot was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the snapshot */
  id: Scalars['ID'];
  /** The ID of the review associated with the snapshot */
  reviewId: Maybe<Scalars['ID']>;
  /** The type of the snapshot: [BASE, REVISION] */
  snapshotType: ContentSnapshot;
};

/** A shallow snapshot, used primarily for referencing content revisions. */
export type ApprovalsManagementTypesContentSnapshotShallow = {
  __typename?: 'ApprovalsManagementTypesContentSnapshotShallow';
  /** The ID of the request associated with the snapshot */
  approvalRequestId: Scalars['ID'];
  /** Metadata associated with the content at the time of the snapshot */
  contentMetadata: Scalars['JSON'];
  /** The time at which the snapshot was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the snapshot */
  id: Scalars['ID'];
  /** The ID of the review associated with the snapshot */
  reviewId: Maybe<Scalars['ID']>;
  /** The type of the snapshot: [BASE, REVISION] */
  snapshotType: ContentSnapshot;
};

/** Defines the resources that the Approval Request affects. */
export type ApprovalsManagementTypesListApprovalRequestsResult = {
  __typename?: 'ApprovalsManagementTypesListApprovalRequestsResult';
  /** The approval requests */
  approvalRequests: Array<ApprovalsManagementTypesApprovalRequest>;
  /** The total number of approval requests that match the scope, regardless of offset and limit */
  totalCount: Scalars['Int'];
};

/** Describes the actions a user is permitted to take on an approval request */
export type ApprovalsManagementTypesUserPermittedActions = {
  __typename?: 'ApprovalsManagementTypesUserPermittedActions';
  /** The unique ID of the Approval Request. */
  approvalRequestId: Scalars['ID'];
  /** Whether the user can approve the approval request. */
  canApprove: Scalars['Boolean'];
  /** Whether the user can publish the approval request via break glass. */
  canBreakGlassPublish: Scalars['Boolean'];
  /** Whether the user can cancel the approval request. */
  canCancel: Scalars['Boolean'];
  /** Whether the user can comment on the approval request. */
  canComment: Scalars['Boolean'];
  /** Whether the user can publish the approval request. */
  canPublish: Scalars['Boolean'];
  /** Whether the user can revise the approval request. */
  canRevise: Scalars['Boolean'];
};

/** The content of a user's review. */
export type ApprovalsManagementTypesUserReviewContent = {
  __typename?: 'ApprovalsManagementTypesUserReviewContent';
  /** The action the user performed */
  action: ReviewAction;
  /** Optional user comment */
  comment: Maybe<Scalars['String']>;
};

/** A User Review Content with a unique identifier. */
export type ApprovalsManagementTypesUserReviewReference = {
  __typename?: 'ApprovalsManagementTypesUserReviewReference';
  /** The ID of the Approval Request this review is posted on */
  arId: Scalars['ID'];
  /** The time the review was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the User Review */
  id: Scalars['ID'];
  /** The User Review content */
  reviewContent: ApprovalsManagementTypesUserReviewContent;
  /** The user that made the review */
  reviewedBy: EnterpriseAccount;
  /** The revision snapshot, if the review was posting a new revision */
  revisionSnapshot: Maybe<ApprovalsManagementTypesContentSnapshot>;
  /** Time the review was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum AreaOfInterest {
  AreaOfInterestUnknown = 'AREA_OF_INTEREST_UNKNOWN',
  Claims = 'CLAIMS',
  DistributionVolume = 'DISTRIBUTION_VOLUME',
  ItemImage = 'ITEM_IMAGE',
  ProductSales = 'PRODUCT_SALES',
  UnitLevelPricing = 'UNIT_LEVEL_PRICING'
}

export enum AssetType {
  AppleTouchIcon = 'APPLE_TOUCH_ICON',
  CreativeAsset = 'CREATIVE_ASSET',
  Favicon = 'FAVICON',
  Font = 'FONT',
  ItemAttributeIcon = 'ITEM_ATTRIBUTE_ICON',
  LandingPageBackgroundImage = 'LANDING_PAGE_BACKGROUND_IMAGE',
  Logo = 'LOGO',
  Loyalty = 'LOYALTY',
  MobileBackgroundImage = 'MOBILE_BACKGROUND_IMAGE',
  MobileLogo = 'MOBILE_LOGO',
  RetailerLogos = 'RETAILER_LOGOS',
  RewardsProgramLogo = 'REWARDS_PROGRAM_LOGO',
  Unknown = 'UNKNOWN'
}

/** Autogenerated return type of AssignPermissionToRole */
export type AssignPermissionToRolePayload = {
  __typename?: 'AssignPermissionToRolePayload';
  /** The role with the new permissions */
  role: EnterpriseRole;
};

export type AssignVirtualBatchRequestInput = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  batchType?: InputMaybe<BatchType>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  order?: InputMaybe<OrderInput>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
};

export type AssignVirtualBatchResponse = {
  __typename?: 'AssignVirtualBatchResponse';
  id: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<Scalars['String']>;
};

export enum AtomsColor {
  AtomsColorUnknown = 'ATOMS_COLOR_UNKNOWN',
  BrandHighlightDark = 'BRAND_HIGHLIGHT_DARK',
  BrandHighlightLight = 'BRAND_HIGHLIGHT_LIGHT',
  BrandHighlightRegular = 'BRAND_HIGHLIGHT_REGULAR',
  BrandLoyaltyDark = 'BRAND_LOYALTY_DARK',
  BrandLoyaltyLight = 'BRAND_LOYALTY_LIGHT',
  BrandLoyaltyRegular = 'BRAND_LOYALTY_REGULAR',
  BrandPrimaryDark = 'BRAND_PRIMARY_DARK',
  BrandPrimaryExtraDark = 'BRAND_PRIMARY_EXTRA_DARK',
  BrandPrimaryRegular = 'BRAND_PRIMARY_REGULAR',
  BrandPromotionalDark = 'BRAND_PROMOTIONAL_DARK',
  BrandPromotionalLight = 'BRAND_PROMOTIONAL_LIGHT',
  BrandPromotionalRegular = 'BRAND_PROMOTIONAL_REGULAR',
  BrandSecondaryDark = 'BRAND_SECONDARY_DARK',
  BrandSecondaryLight = 'BRAND_SECONDARY_LIGHT',
  BrandSecondaryRegular = 'BRAND_SECONDARY_REGULAR',
  BrandTertiaryRegular = 'BRAND_TERTIARY_REGULAR',
  MaxYellow = 'MAX_YELLOW',
  PlusDark = 'PLUS_DARK',
  PlusExtraDark = 'PLUS_EXTRA_DARK',
  PlusExtraLight = 'PLUS_EXTRA_LIGHT',
  PlusLight = 'PLUS_LIGHT',
  PlusRegular = 'PLUS_REGULAR',
  SystemDetrimentalDark = 'SYSTEM_DETRIMENTAL_DARK',
  SystemDetrimentalExtraDark = 'SYSTEM_DETRIMENTAL_EXTRA_DARK',
  SystemDetrimentalLight = 'SYSTEM_DETRIMENTAL_LIGHT',
  SystemDetrimentalRegular = 'SYSTEM_DETRIMENTAL_REGULAR',
  SystemGrayscale00 = 'SYSTEM_GRAYSCALE00',
  SystemGrayscale10 = 'SYSTEM_GRAYSCALE10',
  SystemGrayscale20 = 'SYSTEM_GRAYSCALE20',
  SystemGrayscale30 = 'SYSTEM_GRAYSCALE30',
  SystemGrayscale50 = 'SYSTEM_GRAYSCALE50',
  SystemGrayscale70 = 'SYSTEM_GRAYSCALE70',
  SystemSuccessDark = 'SYSTEM_SUCCESS_DARK',
  SystemSuccessLight = 'SYSTEM_SUCCESS_LIGHT',
  SystemSuccessRegular = 'SYSTEM_SUCCESS_REGULAR'
}

export type AttributeData = {
  __typename?: 'AttributeData';
  attributeName: Maybe<Scalars['String']>;
  attributeValue: Maybe<Scalars['String']>;
  productSourceId: Maybe<Scalars['BigInt']>;
  sourceId: Maybe<Scalars['BigInt']>;
  sourceType: Maybe<Scalars['String']>;
};

export type AttributeSourceData = {
  __typename?: 'AttributeSourceData';
  attribute: Maybe<Scalars['String']>;
  sourceDetail: Maybe<Scalars['String']>;
};

export type AuditBatch = {
  __typename?: 'AuditBatch';
  allowSuggestedValues: Maybe<Scalars['Boolean']>;
  assignee: Maybe<Scalars['String']>;
  assigneeAt: Maybe<Scalars['DateTime']>;
  auditableTaskCount: Maybe<Scalars['BigInt']>;
  auditableTasks: Maybe<Array<Maybe<AuditTask>>>;
  auditedTaskCount: Maybe<Scalars['BigInt']>;
  batchId: Maybe<Scalars['BigInt']>;
  batchMetadata: Maybe<Scalars['String']>;
  batchState: Maybe<Scalars['String']>;
  batchUuid: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['DateTime']>;
  correctnessThresholdCount: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  extComment: Maybe<Scalars['String']>;
  incorrectTaskCount: Maybe<Scalars['BigInt']>;
  intComment: Maybe<Scalars['String']>;
  isExplicitFailedRedrive: Maybe<Scalars['Boolean']>;
  owner: Maybe<Scalars['String']>;
  ownerAt: Maybe<Scalars['DateTime']>;
  recommendedSampleSize: Maybe<Scalars['BigInt']>;
  reviewer: Maybe<Scalars['String']>;
  reviewerAt: Maybe<Scalars['DateTime']>;
  sampleTaskCount: Maybe<Scalars['BigInt']>;
  sampleTasks: Maybe<Array<Maybe<AuditTask>>>;
  secondaryStateId: Maybe<Scalars['BigInt']>;
  slaDueDate: Maybe<Scalars['DateTime']>;
  tasksRequiredToReviewCount: Maybe<Scalars['BigInt']>;
  version: Maybe<Scalars['BigInt']>;
  workflow: Maybe<Scalars['String']>;
};

export type AuditDetectionRequestInput = {
  auditedBy?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  state?: InputMaybe<DetectionStatusState>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type AuditDetectionResponse = {
  __typename?: 'AuditDetectionResponse';
  _: Maybe<Scalars['Boolean']>;
};

export enum AuditLogEntityTypeEnum {
  /** Account entity */
  Account = 'ACCOUNT',
  /** Aisle entity */
  Aisle = 'AISLE',
  /** Collection entity */
  Collection = 'COLLECTION',
  /** ContentPage entity */
  ContentPage = 'CONTENT_PAGE',
  /** ContentPageVersion entity */
  ContentPageVersion = 'CONTENT_PAGE_VERSION',
  /** ContentPageVersionMeta entity */
  ContentPageVersionMeta = 'CONTENT_PAGE_VERSION_META',
  /** Department entity */
  Department = 'DEPARTMENT',
  /** DepartmentNavigation entity */
  DepartmentNavigation = 'DEPARTMENT_NAVIGATION',
  /** Item entity */
  Item = 'ITEM',
  /** Placement entity */
  Placement = 'PLACEMENT',
  /** Product entity */
  Product = 'PRODUCT',
  /** RetailerCampaign entity */
  RetailerCampaign = 'RETAILER_CAMPAIGN',
  /** Role entity */
  Role = 'ROLE'
}

export type AuditLogsAuditLog = {
  __typename?: 'AuditLogsAuditLog';
  /** The email of the account that made the change */
  accountEmail: Scalars['String'];
  /** The UUID of the account that made the change */
  accountUuid: Scalars['ID'];
  /** The entities related to this change */
  entities: Maybe<Array<AuditLogsAuditLogEntity>>;
  /** Event name */
  eventName: Maybe<Scalars['String']>;
  /** Time that the audit log event took place */
  eventTime: Scalars['ISO8601DateTime'];
  /** The internal unique identifier for the audit log */
  id: Scalars['ID'];
  /** The email of the account being impersonated */
  impersonatedAccountEmail: Maybe<Scalars['String']>;
  /** The UUID of the account being impersonated */
  impersonatedAccountUuid: Maybe<Scalars['ID']>;
  /** Whether or not the change was successful */
  success: Maybe<Scalars['Boolean']>;
};

/** The connection type for AuditLogsAuditLog. */
export type AuditLogsAuditLogConnection = {
  __typename?: 'AuditLogsAuditLogConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AuditLogsAuditLogEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<AuditLogsAuditLog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditLogsAuditLogEdge = {
  __typename?: 'AuditLogsAuditLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<AuditLogsAuditLog>;
};

export type AuditLogsAuditLogEntity = {
  __typename?: 'AuditLogsAuditLogEntity';
  /** The entity display name */
  entityDisplayName: Maybe<Scalars['String']>;
  /** The identifier of the entity */
  entityIds: Array<Scalars['ID']>;
  /** The entity type */
  entityType: AuditLogEntityTypeEnum;
  /** The internal unique identifier for the audit log entity */
  id: Scalars['ID'];
};

export type AuditTask = {
  __typename?: 'AuditTask';
  batchUuid: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Maybe<Scalars['DateTime']>;
  entityId: Maybe<EntityId>;
  extComment: Maybe<Scalars['String']>;
  inputData: Maybe<Scalars['String']>;
  intComment: Maybe<Scalars['String']>;
  reviewState: Maybe<Scalars['String']>;
  taskComponents: Maybe<Array<Maybe<AuditTaskTaskComponent>>>;
  taskState: Maybe<Scalars['String']>;
  taskUuid: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
  workflow: Maybe<Scalars['String']>;
};

export type AuditTaskTaskComponent = {
  __typename?: 'AuditTaskTaskComponent';
  explicitAuditFailed: Maybe<Scalars['Boolean']>;
  extComment: Maybe<Scalars['String']>;
  groupName: Maybe<Scalars['String']>;
  intComment: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  reviewState: Maybe<Scalars['String']>;
  suggestedValue: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
  valueType: Maybe<Scalars['String']>;
};

export type AuditWorkflow = {
  __typename?: 'AuditWorkflow';
  approvedTaskCount: Maybe<Scalars['BigInt']>;
  auditableTaskCount: Maybe<Scalars['BigInt']>;
  correctnessThresholdPct: Maybe<Scalars['Float']>;
  defaultSamplePct: Maybe<Scalars['Float']>;
  defaultSlaDays: Maybe<Scalars['BigInt']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  failOverPct: Maybe<Scalars['Float']>;
  firstPendingSlaDueDate: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  numTasksPerBatch: Maybe<Scalars['BigInt']>;
  rejectedTaskCount: Maybe<Scalars['BigInt']>;
  taskReviewPct: Maybe<Scalars['Float']>;
};

export type AuditWorkflowConfig = {
  __typename?: 'AuditWorkflowConfig';
  configType: Maybe<Scalars['String']>;
  configValue: Maybe<Scalars['String']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  workflowL1: Maybe<Scalars['String']>;
  workflowL2: Maybe<Scalars['String']>;
  workflowL3: Maybe<Scalars['String']>;
};

export type AuditWorkflowConfigInput = {
  configType?: InputMaybe<Scalars['String']>;
  configValue?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  workflowL1?: InputMaybe<Scalars['String']>;
  workflowL2?: InputMaybe<Scalars['String']>;
  workflowL3?: InputMaybe<Scalars['String']>;
};

export type AuditWorkflowInput = {
  approvedTaskCount?: InputMaybe<Scalars['BigInt']>;
  auditableTaskCount?: InputMaybe<Scalars['BigInt']>;
  correctnessThresholdPct?: InputMaybe<Scalars['Float']>;
  defaultSamplePct?: InputMaybe<Scalars['Float']>;
  defaultSlaDays?: InputMaybe<Scalars['BigInt']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  failOverPct?: InputMaybe<Scalars['Float']>;
  firstPendingSlaDueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  numTasksPerBatch?: InputMaybe<Scalars['BigInt']>;
  rejectedTaskCount?: InputMaybe<Scalars['BigInt']>;
  taskReviewPct?: InputMaybe<Scalars['Float']>;
};

export type AuthUserData = {
  __typename?: 'AuthUserData';
  /** Whether the user uses a password or not */
  usesPassword: Scalars['Boolean'];
};

export type Authentication = {
  __typename?: 'Authentication';
  postAuthPaths: Maybe<PostAuthPaths>;
};

export type AuthenticationInput = {
  postAuthPaths?: InputMaybe<PostAuthPathsInput>;
};

/** The method of authentication associated with an account */
export type AuthenticationInterface = {
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID'];
};

export type AuthorizationContextInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export enum BackstockStatus {
  BackstockStatusAvailable = 'BACKSTOCK_STATUS_AVAILABLE',
  BackstockStatusNone = 'BACKSTOCK_STATUS_NONE',
  BackstockStatusUnknown = 'BACKSTOCK_STATUS_UNKNOWN'
}

export type Banner = {
  __typename?: 'Banner';
  action: Maybe<Scalars['String']>;
  actionData: Maybe<Scalars['String']>;
  backgroundColorHex: Maybe<Scalars['String']>;
  buttonStyle: Maybe<ButtonStyle>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaColorHex: Maybe<Scalars['String']>;
  dataQuery: Maybe<DataQuery>;
  id: Maybe<Scalars['BigInt']>;
  imageAltText: Maybe<Scalars['String']>;
  imageMobileUrl: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  status: Maybe<Status>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  tagline: Maybe<Scalars['String']>;
  taglineColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type BannerAction = {
  __typename?: 'BannerAction';
  dismissBusinessIdentication: Maybe<DismissBusinessIdentication>;
  doNotNavigate: Maybe<DoNotNavigate>;
  navigateToAskInstacart: Maybe<NavigateToAskInstacart>;
  navigateToAuthentication: Maybe<NavigateToAuthentication>;
  navigateToBenefitsModal: Maybe<NavigateToBenefitsModal>;
  navigateToCategorySurface: Maybe<NavigateToCategorySurface>;
  navigateToCollaborativeShopInfoModal: Maybe<NavigateToCollaborativeShopInfoModal>;
  navigateToCollection: Maybe<NavigateToCollection>;
  navigateToCollectionHub: Maybe<NavigateToCollectionHub>;
  navigateToContainerPathViaStoreselector: Maybe<NavigateToContainerPathViaStoreSelector>;
  navigateToContentPage: Maybe<NavigateToContentPage>;
  navigateToCouponRedemption: Maybe<NavigateToCouponRedemption>;
  navigateToDepartment: Maybe<NavigateToDepartment>;
  navigateToExpressAccountPage: Maybe<NavigateToExpressAccountPage>;
  navigateToFlyers: Maybe<NavigateToFlyers>;
  navigateToHouseholdAccountSharingFlow: Maybe<NavigateToHouseholdAccountSharingFlow>;
  navigateToPartnershipModal: Maybe<NavigateToPartnershipModal>;
  navigateToPickupStoreselector: Maybe<NavigateToPickupStoreSelector>;
  navigateToProduct: Maybe<NavigateToProduct>;
  navigateToPromoModal: Maybe<NavigateToPromoModal>;
  navigateToPromotionDetail: Maybe<NavigateToPromotionDetail>;
  navigateToRetailerCollection: Maybe<NavigateToRetailerCollection>;
  navigateToRetailerCollectionViaStoreselector: Maybe<NavigateToRetailerCollectionViaStoreSelector>;
  navigateToSsaStoreselector: Maybe<NavigateToSsaStoreSelector>;
  navigateToStorefront: Maybe<NavigateToStorefront>;
  navigateToStoreselector: Maybe<NavigateToStoreSelector>;
  navigateToUrl: Maybe<NavigateToUrl>;
  openExpressPaidModal: Maybe<OpenExpressPaidModal>;
  openExpressTrialModal: Maybe<OpenExpressTrialModal>;
  optInUser: Maybe<OptInUser>;
  redeemPartnershipOffer: Maybe<RedeemPartnershipOffer>;
  renewSubscriptionIntoAnnual: Maybe<RenewSubscriptionIntoAnnual>;
  renewSubscriptionIntoMonthly: Maybe<RenewSubscriptionIntoMonthly>;
};

export type BannerActionInput = {
  dismissBusinessIdentication?: InputMaybe<DismissBusinessIdenticationInput>;
  doNotNavigate?: InputMaybe<DoNotNavigateInput>;
  navigateToAskInstacart?: InputMaybe<NavigateToAskInstacartInput>;
  navigateToAuthentication?: InputMaybe<NavigateToAuthenticationInput>;
  navigateToBenefitsModal?: InputMaybe<NavigateToBenefitsModalInput>;
  navigateToCategorySurface?: InputMaybe<NavigateToCategorySurfaceInput>;
  navigateToCollaborativeShopInfoModal?: InputMaybe<NavigateToCollaborativeShopInfoModalInput>;
  navigateToCollection?: InputMaybe<NavigateToCollectionInput>;
  navigateToCollectionHub?: InputMaybe<NavigateToCollectionHubInput>;
  navigateToContainerPathViaStoreselector?: InputMaybe<NavigateToContainerPathViaStoreSelectorInput>;
  navigateToContentPage?: InputMaybe<NavigateToContentPageInput>;
  navigateToCouponRedemption?: InputMaybe<NavigateToCouponRedemptionInput>;
  navigateToDepartment?: InputMaybe<NavigateToDepartmentInput>;
  navigateToExpressAccountPage?: InputMaybe<NavigateToExpressAccountPageInput>;
  navigateToFlyers?: InputMaybe<NavigateToFlyersInput>;
  navigateToHouseholdAccountSharingFlow?: InputMaybe<NavigateToHouseholdAccountSharingFlowInput>;
  navigateToPartnershipModal?: InputMaybe<NavigateToPartnershipModalInput>;
  navigateToPickupStoreselector?: InputMaybe<NavigateToPickupStoreSelectorInput>;
  navigateToProduct?: InputMaybe<NavigateToProductInput>;
  navigateToPromoModal?: InputMaybe<NavigateToPromoModalInput>;
  navigateToPromotionDetail?: InputMaybe<NavigateToPromotionDetailInput>;
  navigateToRetailerCollection?: InputMaybe<NavigateToRetailerCollectionInput>;
  navigateToRetailerCollectionViaStoreselector?: InputMaybe<NavigateToRetailerCollectionViaStoreSelectorInput>;
  navigateToSsaStoreselector?: InputMaybe<NavigateToSsaStoreSelectorInput>;
  navigateToStorefront?: InputMaybe<NavigateToStorefrontInput>;
  navigateToStoreselector?: InputMaybe<NavigateToStoreSelectorInput>;
  navigateToUrl?: InputMaybe<NavigateToUrlInput>;
  openExpressPaidModal?: InputMaybe<OpenExpressPaidModalInput>;
  openExpressTrialModal?: InputMaybe<OpenExpressTrialModalInput>;
  optInUser?: InputMaybe<OptInUserInput>;
  redeemPartnershipOffer?: InputMaybe<RedeemPartnershipOfferInput>;
  renewSubscriptionIntoAnnual?: InputMaybe<RenewSubscriptionIntoAnnualInput>;
  renewSubscriptionIntoMonthly?: InputMaybe<RenewSubscriptionIntoMonthlyInput>;
};

export type BannerInput = {
  action?: InputMaybe<Scalars['String']>;
  actionData?: InputMaybe<Scalars['String']>;
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  buttonStyle?: InputMaybe<ButtonStyle>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  dataQuery?: InputMaybe<DataQueryInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageMobileUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  status?: InputMaybe<Status>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  taglineColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export enum BannerLocaleEnum {
  /** Canadian English */
  EnCa = 'EN_CA',
  /** American English */
  EnUs = 'EN_US',
  /** Canadian French */
  FrCa = 'FR_CA'
}

export type BannerType = {
  __typename?: 'BannerType';
  compactBanner: Maybe<CompactBanner>;
  defaultBanner: Maybe<Banner>;
  heroBanner: Maybe<HeroBanner>;
  imageForward: Maybe<ImageForward>;
  imageForwardFlex: Maybe<ImageForwardFlex>;
  infoSheet: Maybe<StandardInfoModalSheet>;
  logoWithTextBanner: Maybe<LogoWithTextBanner>;
  secondaryBanner: Maybe<SecondaryBanner>;
  textWithThumbnail: Maybe<TextWithThumbnail>;
  textWithThumbnailFlex: Maybe<TextWithThumbnailFlex>;
  unknownBanner: Maybe<UnknownBanner>;
};

export type BannerTypeInput = {
  compactBanner?: InputMaybe<CompactBannerInput>;
  defaultBanner?: InputMaybe<BannerInput>;
  heroBanner?: InputMaybe<HeroBannerInput>;
  imageForward?: InputMaybe<ImageForwardInput>;
  imageForwardFlex?: InputMaybe<ImageForwardFlexInput>;
  infoSheet?: InputMaybe<StandardInfoModalSheetInput>;
  logoWithTextBanner?: InputMaybe<LogoWithTextBannerInput>;
  secondaryBanner?: InputMaybe<SecondaryBannerInput>;
  textWithThumbnail?: InputMaybe<TextWithThumbnailInput>;
  textWithThumbnailFlex?: InputMaybe<TextWithThumbnailFlexInput>;
  unknownBanner?: InputMaybe<UnknownBannerInput>;
};

export enum BannerVariant {
  AnchorLink = 'ANCHOR_LINK',
  AsyncImage = 'ASYNC_IMAGE',
  AsyncModal = 'ASYNC_MODAL',
  BannerRow = 'BANNER_ROW',
  BottomTracker = 'BOTTOM_TRACKER',
  BusinessIdentificationShopBanner = 'BUSINESS_IDENTIFICATION_SHOP_BANNER',
  BusinessProfileModalIcPlus = 'BUSINESS_PROFILE_MODAL_IC_PLUS',
  BusinessProfileModalNonIcPlus = 'BUSINESS_PROFILE_MODAL_NON_IC_PLUS',
  BusinessProfileUpsellFlyout = 'BUSINESS_PROFILE_UPSELL_FLYOUT',
  CarouselCard = 'CAROUSEL_CARD',
  CartIncentiveTrackerDetailSavingMessageBanner = 'CART_INCENTIVE_TRACKER_DETAIL_SAVING_MESSAGE_BANNER',
  CartIncentiveTrackerFlyOutBanner = 'CART_INCENTIVE_TRACKER_FLY_OUT_BANNER',
  CartTracker = 'CART_TRACKER',
  CategoryHub = 'CATEGORY_HUB',
  ChurnedUserSurvey = 'CHURNED_USER_SURVEY',
  Coachmark = 'COACHMARK',
  CompactBanner = 'COMPACT_BANNER',
  ContentCard = 'CONTENT_CARD',
  ContentPageEntry = 'CONTENT_PAGE_ENTRY',
  FeedUnit = 'FEED_UNIT',
  FlyerBanner = 'FLYER_BANNER',
  FullWidth = 'FULL_WIDTH',
  Gamification = 'GAMIFICATION',
  Header = 'HEADER',
  HeroBanner = 'HERO_BANNER',
  Image = 'IMAGE',
  ImageForward = 'IMAGE_FORWARD',
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  ImageTileCard = 'IMAGE_TILE_CARD',
  InformationModal = 'INFORMATION_MODAL',
  LandingFaq = 'LANDING_FAQ',
  LandingHero = 'LANDING_HERO',
  LandingModule = 'LANDING_MODULE',
  LandingValueProp = 'LANDING_VALUE_PROP',
  Large = 'LARGE',
  LogoWithText = 'LOGO_WITH_TEXT',
  LoyaltyHubHeader = 'LOYALTY_HUB_HEADER',
  LoyaltySavingsModal = 'LOYALTY_SAVINGS_MODAL',
  Mega = 'MEGA',
  MultiOfferSheet = 'MULTI_OFFER_SHEET',
  NavigationBanner = 'NAVIGATION_BANNER',
  OccasionHub = 'OCCASION_HUB',
  OffersForYouCard = 'OFFERS_FOR_YOU_CARD',
  OfferCard = 'OFFER_CARD',
  OverHeader = 'OVER_HEADER',
  PartnershipModal = 'PARTNERSHIP_MODAL',
  PartnershipRedemptionModal = 'PARTNERSHIP_REDEMPTION_MODAL',
  PromotionSheetCard = 'PROMOTION_SHEET_CARD',
  QuickLinkPill = 'QUICK_LINK_PILL',
  RetailerStory = 'RETAILER_STORY',
  RichInformationModal = 'RICH_INFORMATION_MODAL',
  RichText = 'RICH_TEXT',
  SavingsCardV2Banner = 'SAVINGS_CARD_V2_BANNER',
  SecondaryBanner = 'SECONDARY_BANNER',
  ShortcutBanner = 'SHORTCUT_BANNER',
  StandardInformationModal = 'STANDARD_INFORMATION_MODAL',
  StorefrontSavingsCard = 'STOREFRONT_SAVINGS_CARD',
  StoreMenuCard = 'STORE_MENU_CARD',
  Survey = 'SURVEY',
  Text = 'TEXT',
  TextIconHeader = 'TEXT_ICON_HEADER',
  TextSlim = 'TEXT_SLIM',
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  TitledMedia = 'TITLED_MEDIA',
  TopTrackerBanner = 'TOP_TRACKER_BANNER',
  ValueCarouselCard = 'VALUE_CAROUSEL_CARD',
  WaveCard = 'WAVE_CARD'
}

export type BarNav = {
  __typename?: 'BarNav';
  column1FeaturedLinksBlock: Maybe<FlatNavigationWithVariants>;
  column1LinksBlock: Maybe<NavigationWithContainers>;
  column2FeaturedLinksBlock: Maybe<FlatNavigationWithVariants>;
};

export type BarNavInput = {
  column1FeaturedLinksBlock?: InputMaybe<FlatNavigationWithVariantsInput>;
  column1LinksBlock?: InputMaybe<NavigationWithContainersInput>;
  column2FeaturedLinksBlock?: InputMaybe<FlatNavigationWithVariantsInput>;
};

export type BaseSubject = {
  __typename?: 'BaseSubject';
  criteria: Maybe<SubjectCriteria>;
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  requiredAlcoholContext: Maybe<Scalars['String']>;
  requiredRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  sourceCollectionId: Maybe<Scalars['BigInt']>;
};

export type BatchGetUsersByIdsStrictRequestInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type BatchGetUsersByIdsStrictResponse = {
  __typename?: 'BatchGetUsersByIdsStrictResponse';
  users: Maybe<Array<Maybe<User>>>;
};

export enum BatchType {
  BatchTypeUnspecified = 'BATCH_TYPE_UNSPECIFIED',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DriveAndPick = 'DRIVE_AND_PICK'
}

export type BatchUpdatePlacementsRequestInput = {
  layout?: InputMaybe<Layout>;
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type BatchUpdateSlotCreativesRequestInput = {
  slotCreatives?: InputMaybe<Array<InputMaybe<SlotCreativeInput>>>;
};

export type BatchUpdateSlotCreativesResponse = {
  __typename?: 'BatchUpdateSlotCreativesResponse';
  slotCreatives: Maybe<Array<Maybe<SlotCreative>>>;
};

export type BorderRadiusSchema = {
  __typename?: 'BorderRadiusSchema';
  isCircle: Maybe<Scalars['Boolean']>;
  radius: Maybe<Scalars['BigInt']>;
};

export enum BotAccountAssignableRoleEnum {
  /** Engineer role */
  Engineer = 'ENGINEER',
  /** Admin role */
  NonEngineer = 'NON_ENGINEER'
}

export enum BotAccountOperationTypeEnum {
  /** Account was created */
  Created = 'CREATED',
  /** Account was updated */
  Updated = 'UPDATED'
}

/** Autogenerated return type of BotEnterpriseAccountDisable */
export type BotEnterpriseAccountDisablePayload = {
  __typename?: 'BotEnterpriseAccountDisablePayload';
  /** The newly created or updated account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of BotEnterpriseAccountUpsert */
export type BotEnterpriseAccountUpsertPayload = {
  __typename?: 'BotEnterpriseAccountUpsertPayload';
  /** The newly created or updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** What kind of operation was executed */
  operationType: BotAccountOperationTypeEnum;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height: Maybe<Scalars['Int']>;
  width: Maybe<Scalars['Int']>;
  x: Maybe<Scalars['Int']>;
  y: Maybe<Scalars['Int']>;
};

export type Brand = {
  __typename?: 'Brand';
  brandId: Maybe<Scalars['BigInt']>;
  brandName: Maybe<Scalars['String']>;
};

export type BrandContact = {
  __typename?: 'BrandContact';
  email: Maybe<Scalars['String']>;
  jobTitle: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
};

export type BrandContactRequestInput = {
  accountInformation?: InputMaybe<IppAccountInformationInput>;
  areasOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  areasOfInterestEnums?: InputMaybe<Array<InputMaybe<AreaOfInterest>>>;
  brandProfileId?: InputMaybe<Scalars['String']>;
  interestedSellSheetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDebug?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
};

export type BrandContactResponse = {
  __typename?: 'BrandContactResponse';
  brandContactId: Maybe<Scalars['String']>;
};

export type BrandNameMapping = {
  __typename?: 'BrandNameMapping';
  brandName: Maybe<Scalars['String']>;
  brandProfileId: Maybe<Scalars['String']>;
};

export type BrandProfileAttributes = {
  __typename?: 'BrandProfileAttributes';
  aboutBrand: Maybe<Scalars['String']>;
  brandContacts: Maybe<Array<Maybe<BrandContact>>>;
  brandName: Maybe<Scalars['String']>;
  certifications: Maybe<Array<Maybe<Scalars['String']>>>;
  distributors: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Maybe<Scalars['String']>;
  imageAssets: Maybe<Array<Maybe<ImageAsset>>>;
  regionalAreas: Maybe<Array<Maybe<InstacartAdsNexusV1RegionalArea>>>;
  storeTypes: Maybe<Array<Maybe<InstacartAdsNexusV1StoreType>>>;
  website: Maybe<Scalars['String']>;
};

export type BrandProfileAttributesRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>;
};

export type BrandProfileAttributesResponse = {
  __typename?: 'BrandProfileAttributesResponse';
  brandProfileAttributes: Maybe<BrandProfileAttributes>;
};

export type BrandProfileSellSheetCardsRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>;
  paginationRequest?: InputMaybe<InstacartAdsSharedV1PaginationRequestInput>;
};

export type BrandProfileSellSheetCardsResponse = {
  __typename?: 'BrandProfileSellSheetCardsResponse';
  paginationResponse: Maybe<InstacartAdsSharedV1PaginationResponse>;
  sellSheetCards: Maybe<Array<Maybe<SellSheetCard>>>;
};

export type BrandSellSheetsAttributesRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>;
};

export type BrandSellSheetsAttributesResponse = {
  __typename?: 'BrandSellSheetsAttributesResponse';
  sellSheetsOverviewAttributes: Maybe<Array<Maybe<SellSheetOverviewAttributes>>>;
};

export type BrandingSchema = {
  __typename?: 'BrandingSchema';
  appleTouchIcon: Maybe<Scalars['String']>;
  customImages: Maybe<CustomImages>;
  favicon: Maybe<Scalars['String']>;
  loadingIcons: Maybe<Array<Maybe<Scalars['String']>>>;
  logos: Maybe<Logos>;
  retailerLogos: Maybe<Array<Maybe<RetailerLogo>>>;
  retailerOverrides: Maybe<Array<Maybe<RetailerOverride>>>;
};

export type BuildJobDetail = {
  __typename?: 'BuildJobDetail';
  artifactsUrl: Maybe<Scalars['String']>;
  failureDetails: Maybe<BuildJobFailureDetails>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  webUrl: Maybe<Scalars['String']>;
};

export type BuildJobFailureDetails = {
  __typename?: 'BuildJobFailureDetails';
  summary: Maybe<Scalars['String']>;
};

export type BuildkiteArtifactInfo = {
  __typename?: 'BuildkiteArtifactInfo';
  downloadUrl: Maybe<Scalars['String']>;
  fileSize: Maybe<Scalars['BigInt']>;
  filename: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['String']>;
  mimeType: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  stepKey: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type BulkUpdateApprovalRequestStatusRequestInput = {
  approvalRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  comment?: InputMaybe<Scalars['String']>;
  statusAction?: InputMaybe<Scalars['String']>;
  userUuid?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateApprovalRequestStatusResponse = {
  __typename?: 'BulkUpdateApprovalRequestStatusResponse';
  failureCount: Maybe<Scalars['Int']>;
  results: Maybe<Array<Maybe<ApprovalRequestStatusResult>>>;
  successCount: Maybe<Scalars['Int']>;
  totalCount: Maybe<Scalars['Int']>;
};

export enum BusinessDerivedAttributesSourceType {
  LangchainAi = 'LANGCHAIN_AI'
}

export type BusinessSchema = {
  __typename?: 'BusinessSchema';
  businessAccountOnly: Maybe<Scalars['Boolean']>;
  enableDefaultBusinessFeatures: Maybe<Scalars['Boolean']>;
};

export enum ButtonStyle {
  Detrimental = 'DETRIMENTAL',
  Plus = 'PLUS',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export enum ButtonVariantEnum {
  /** Use the dismiss button style */
  Dismiss = 'DISMISS',
  /** Use the link button style */
  Link = 'LINK',
  /** Use the plus button style */
  Plus = 'PLUS',
  /** Use the primary button style */
  Primary = 'PRIMARY',
  /** Use the secondary button style */
  Secondary = 'SECONDARY'
}

export enum Cadence {
  Weekly = 'WEEKLY'
}

export enum CampaignField {
  OfferData = 'OFFER_DATA',
  RetailerData = 'RETAILER_DATA'
}

export type CampaignFilter = {
  __typename?: 'CampaignFilter';
  filterType: Maybe<FilterType>;
  filterValue: Maybe<Scalars['String']>;
};

export type CampaignFilterInput = {
  filterType?: InputMaybe<FilterType>;
  filterValue?: InputMaybe<Scalars['String']>;
};

export type CampaignFiltersInput = {
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
};

export enum CampaignObjective {
  Acquisition = 'ACQUISITION',
  Activation = 'ACTIVATION',
  Awareness = 'AWARENESS',
  Custom = 'CUSTOM',
  Invalid = 'INVALID',
  Loyalty = 'LOYALTY',
  Merchandising = 'MERCHANDISING',
  Moment = 'MOMENT',
  Occasion = 'OCCASION',
  Reactivation = 'REACTIVATION',
  Resurrection = 'RESURRECTION',
  Retention = 'RETENTION'
}

export enum CampaignProgress {
  /** The campaign has been cancelled */
  Cancelled = 'cancelled',
  /** The campaign has completed successfully */
  Completed = 'completed',
  /** The campaign is waiting for the segment export to complete */
  ExportingSegment = 'exporting_segment',
  /** The campaign has failed for some users */
  Failed = 'failed',
  /** The campaign is in progress */
  InProgress = 'in_progress',
  /** The campaign is downloading and parsing the segment from S3 */
  LoadingSegment = 'loading_segment',
  /** The campaign has completed for some users */
  PartiallyCompleted = 'partially_completed',
  /** The campaign is not currently running */
  Pending = 'pending'
}

export type CampaignPropertyFilterInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CampaignPropertyFilterOrListInput = {
  orList?: InputMaybe<Array<InputMaybe<CampaignPropertyFilterInput>>>;
};

export type CampaignReference = {
  __typename?: 'CampaignReference';
  directLink: Maybe<Scalars['String']>;
  utmCampaign: Maybe<Scalars['String']>;
  utmContent: Maybe<Scalars['String']>;
  utmId: Maybe<Scalars['String']>;
  utmMedium: Maybe<Scalars['String']>;
  utmSource: Maybe<Scalars['String']>;
  utmTerm: Maybe<Scalars['String']>;
};

export type CampaignReferenceInput = {
  directLink?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmId?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type CampaignRouletteFeature = {
  __typename?: 'CampaignRouletteFeature';
  featureName: Maybe<Scalars['String']>;
  featureVariant: Maybe<Scalars['String']>;
};

export type CampaignRouletteFeatureInput = {
  featureName?: InputMaybe<Scalars['String']>;
  featureVariant?: InputMaybe<Scalars['String']>;
};

export type CampaignServiceData = {
  __typename?: 'CampaignServiceData';
  cancelledAt: Maybe<Scalars['DateTime']>;
  slotIds: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentPolicyIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CampaignTreatmentTask = {
  __typename?: 'CampaignTreatmentTask';
  definitionParams: Maybe<Scalars['JSONObject']>;
  definitionType: Maybe<Scalars['String']>;
  taskDescription: Maybe<Scalars['String']>;
  treatmentPolicyId: Maybe<Scalars['String']>;
};

export type CampaignTreatmentTaskRequestParamsInput = {
  definitionParams?: InputMaybe<Scalars['JSONObject']>;
  definitionType?: InputMaybe<Scalars['String']>;
  taskDescription?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CancelCampaign */
export type CancelCampaignPayload = {
  __typename?: 'CancelCampaignPayload';
  /** Whether it succesfully cancelled */
  success: Scalars['Boolean'];
};

export type CancelMomentRequestInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type CancelMomentResponse = {
  __typename?: 'CancelMomentResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type CancelOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CancelOrderResponse = {
  __typename?: 'CancelOrderResponse';
  instrumentationData: Maybe<Scalars['String']>;
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>;
};

export type CancelRetailerCampaignRequestInput = {
  disableOffer?: InputMaybe<Scalars['Boolean']>;
  ippContext?: InputMaybe<IppContextInput>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CancelRetailerCampaignResponse = {
  __typename?: 'CancelRetailerCampaignResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type CardList = {
  __typename?: 'CardList';
  action: Maybe<Scalars['String']>;
  actionData: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaVisibilityLimit: Maybe<Scalars['BigInt']>;
  ctaVisibilityMin: Maybe<Scalars['BigInt']>;
  dataQuery: Maybe<DataQuery>;
  dataQueryValue: Maybe<Scalars['JSONObject']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  layout: Maybe<Layout>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
  requestId: Maybe<Scalars['String']>;
  settings: Maybe<CardListSettings>;
  settingsValue: Maybe<Scalars['JSONObject']>;
  subtitleIcon: Maybe<Scalars['String']>;
  subtitleText: Maybe<Scalars['String']>;
  subtitleTextHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<CardListVariant>;
};

export type CardListInput = {
  action?: InputMaybe<Scalars['String']>;
  actionData?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaVisibilityLimit?: InputMaybe<Scalars['BigInt']>;
  ctaVisibilityMin?: InputMaybe<Scalars['BigInt']>;
  dataQuery?: InputMaybe<DataQueryInput>;
  dataQueryValue?: InputMaybe<Scalars['JSONObject']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Layout>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  requestId?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<CardListSettingsInput>;
  settingsValue?: InputMaybe<Scalars['JSONObject']>;
  subtitleIcon?: InputMaybe<Scalars['String']>;
  subtitleText?: InputMaybe<Scalars['String']>;
  subtitleTextHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<CardListVariant>;
};

export type CardListSettings = {
  __typename?: 'CardListSettings';
  autoScrollEnabled: Maybe<Scalars['Boolean']>;
  autoScrollInterval: Maybe<Scalars['BigInt']>;
  cardAlignment: Maybe<CardListSettingsCardAlignment>;
  cardCtaStyle: Maybe<CardListSettingsCardCtaStyle>;
  cardHeightPixelLarge: Maybe<Scalars['BigInt']>;
  cardHeightPixelSmall: Maybe<Scalars['BigInt']>;
  cardOrientation: Maybe<CardListSettingsCardOrientation>;
  cardRowCount: Maybe<Scalars['BigInt']>;
  cardWidthPixelLarge: Maybe<Scalars['BigInt']>;
  cardWidthPixelSmall: Maybe<Scalars['BigInt']>;
  carouselIncidatorType: Maybe<CarouselIndicatorType>;
  carouselIncidatorVariant: Maybe<Scalars['BigInt']>;
  carouselIndicatorType: Maybe<CarouselIndicatorType>;
  carouselType: Maybe<CarouselType>;
  filledIndicatorColorHex: Maybe<Scalars['String']>;
  fullScreenWidth: Maybe<Scalars['Boolean']>;
  maxNumOfCards: Maybe<Scalars['BigInt']>;
  navigationMappingKey: Maybe<Scalars['String']>;
  numOfCardsLarge: Maybe<Scalars['BigInt']>;
  numOfCardsSmall: Maybe<Scalars['BigInt']>;
  showCarouselIndicator: Maybe<Scalars['Boolean']>;
  unfilledIndicatorColorHex: Maybe<Scalars['String']>;
  valuePropsCardType: Maybe<ValuePropsCardType>;
};

export enum CardListSettingsCardAlignment {
  CardAlignmentCenter = 'CARD_ALIGNMENT_CENTER',
  CardAlignmentLeft = 'CARD_ALIGNMENT_LEFT',
  CardAlignmentUnknown = 'CARD_ALIGNMENT_UNKNOWN'
}

export enum CardListSettingsCardCtaStyle {
  CardCtaStylePrimary = 'CARD_CTA_STYLE_PRIMARY',
  CardCtaStyleText = 'CARD_CTA_STYLE_TEXT',
  CardCtaStyleUnknown = 'CARD_CTA_STYLE_UNKNOWN'
}

export enum CardListSettingsCardOrientation {
  CardOrientationHorizontal = 'CARD_ORIENTATION_HORIZONTAL',
  CardOrientationUnknown = 'CARD_ORIENTATION_UNKNOWN',
  CardOrientationVertical = 'CARD_ORIENTATION_VERTICAL'
}

export type CardListSettingsInput = {
  autoScrollEnabled?: InputMaybe<Scalars['Boolean']>;
  autoScrollInterval?: InputMaybe<Scalars['BigInt']>;
  cardAlignment?: InputMaybe<CardListSettingsCardAlignment>;
  cardCtaStyle?: InputMaybe<CardListSettingsCardCtaStyle>;
  cardHeightPixelLarge?: InputMaybe<Scalars['BigInt']>;
  cardHeightPixelSmall?: InputMaybe<Scalars['BigInt']>;
  cardOrientation?: InputMaybe<CardListSettingsCardOrientation>;
  cardRowCount?: InputMaybe<Scalars['BigInt']>;
  cardWidthPixelLarge?: InputMaybe<Scalars['BigInt']>;
  cardWidthPixelSmall?: InputMaybe<Scalars['BigInt']>;
  carouselIncidatorType?: InputMaybe<CarouselIndicatorType>;
  carouselIncidatorVariant?: InputMaybe<Scalars['BigInt']>;
  carouselIndicatorType?: InputMaybe<CarouselIndicatorType>;
  carouselType?: InputMaybe<CarouselType>;
  filledIndicatorColorHex?: InputMaybe<Scalars['String']>;
  fullScreenWidth?: InputMaybe<Scalars['Boolean']>;
  maxNumOfCards?: InputMaybe<Scalars['BigInt']>;
  navigationMappingKey?: InputMaybe<Scalars['String']>;
  numOfCardsLarge?: InputMaybe<Scalars['BigInt']>;
  numOfCardsSmall?: InputMaybe<Scalars['BigInt']>;
  showCarouselIndicator?: InputMaybe<Scalars['Boolean']>;
  unfilledIndicatorColorHex?: InputMaybe<Scalars['String']>;
  valuePropsCardType?: InputMaybe<ValuePropsCardType>;
};

export enum CardListVariant {
  AnchorLinksList = 'ANCHOR_LINKS_LIST',
  AsyncPlacements = 'ASYNC_PLACEMENTS',
  CardList = 'CARD_LIST',
  GridList = 'GRID_LIST',
  HomeSpotlight = 'HOME_SPOTLIGHT',
  ImageTileList = 'IMAGE_TILE_LIST',
  ItemBundles = 'ITEM_BUNDLES',
  LandingFaqsList = 'LANDING_FAQS_LIST',
  LandingRetailersList = 'LANDING_RETAILERS_LIST',
  LandingValuePropsList = 'LANDING_VALUE_PROPS_LIST',
  MarketplaceList = 'MARKETPLACE_LIST',
  PillList = 'PILL_LIST',
  QuickLinkList = 'QUICK_LINK_LIST',
  RetailerForwardList = 'RETAILER_FORWARD_LIST',
  RetailerStoriesList = 'RETAILER_STORIES_LIST',
  Slot = 'SLOT',
  StoreDirectoryStoreForwardList = 'STORE_DIRECTORY_STORE_FORWARD_LIST',
  StoreForwardList = 'STORE_FORWARD_LIST',
  StoreMenuList = 'STORE_MENU_LIST',
  StoreSpotlight = 'STORE_SPOTLIGHT',
  TaskCenter = 'TASK_CENTER',
  TileGridList = 'TILE_GRID_LIST',
  TileList = 'TILE_LIST',
  WindowShoppingList = 'WINDOW_SHOPPING_LIST'
}

export enum CarouselIndicatorType {
  CarouselIndicatorTypeDot = 'CAROUSEL_INDICATOR_TYPE_DOT',
  CarouselIndicatorTypeProgressBar = 'CAROUSEL_INDICATOR_TYPE_PROGRESS_BAR',
  CarouselIndicatorTypeUnknown = 'CAROUSEL_INDICATOR_TYPE_UNKNOWN'
}

export enum CarouselType {
  CarouselTypeContentCard = 'CAROUSEL_TYPE_CONTENT_CARD',
  CarouselTypeDiscoveryPage = 'CAROUSEL_TYPE_DISCOVERY_PAGE',
  CarouselTypeFeaturedCollection = 'CAROUSEL_TYPE_FEATURED_COLLECTION',
  CarouselTypeHero = 'CAROUSEL_TYPE_HERO',
  CarouselTypeHomeUniversalValue = 'CAROUSEL_TYPE_HOME_UNIVERSAL_VALUE',
  CarouselTypeImageTile = 'CAROUSEL_TYPE_IMAGE_TILE',
  CarouselTypeQuickLink = 'CAROUSEL_TYPE_QUICK_LINK',
  CarouselTypeRecipeCollectionCarousel = 'CAROUSEL_TYPE_RECIPE_COLLECTION_CAROUSEL',
  CarouselTypeRetailerSimplifiedCard = 'CAROUSEL_TYPE_RETAILER_SIMPLIFIED_CARD',
  CarouselTypeSecondary = 'CAROUSEL_TYPE_SECONDARY',
  CarouselTypeSlim = 'CAROUSEL_TYPE_SLIM',
  CarouselTypeUnknown = 'CAROUSEL_TYPE_UNKNOWN'
}

export type CartEmptyState = {
  __typename?: 'CartEmptyState';
  enabled: Maybe<Scalars['Boolean']>;
  imageUrl: Maybe<Scalars['String']>;
};

export enum CartState {
  CartStateUnspecified = 'CART_STATE_UNSPECIFIED',
  Empty = 'EMPTY',
  InProgress = 'IN_PROGRESS',
  Qualified = 'QUALIFIED'
}

export type CashflowAuditItem = {
  __typename?: 'CashflowAuditItem';
  cashflowAuditItemId: Maybe<Scalars['String']>;
};

export type CatalogAisle = {
  __typename?: 'CatalogAisle';
  /** The department associated with this aisle */
  department: CatalogDepartment;
  /** A unique identifier for the aisle */
  id: Scalars['ID'];
  /** The aisle's name - ('Candy & Chocolates', 'Chips & Pretzels', ...) */
  name: Scalars['String'];
};

export type CatalogClassificationInfo = {
  __typename?: 'CatalogClassificationInfo';
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String'];
  /** The associated retailer (for in-house products) */
  retailer: Maybe<Retailer>;
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum;
};

export type CatalogDepartment = {
  __typename?: 'CatalogDepartment';
  /** An array of the department's aisles */
  aisles: Array<CatalogAisle>;
  /** A unique identifier for the department */
  id: Scalars['ID'];
  /** The department's name - ('Snacks', 'Meat & Seafood', ...) */
  name: Scalars['String'];
};

export type CatalogProduct = {
  __typename?: 'CatalogProduct';
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo;
  /**
   * The classified code associated with the product (Also referred to as UPC - '034000170388')
   * @deprecated Use `classification info` instead, as it has more details than `classified_code`
   */
  classifiedCode: Maybe<Scalars['String']>;
  /** Details about the product, e.g. 'Brown, overripe bananas, suitable for baking */
  description: Maybe<Scalars['String']>;
  /** The product's name - 'Hershey's Extra Large Chocolate Bar' */
  displayName: Scalars['String'];
  /** A unique identifier for the product */
  id: Scalars['ID'];
  /**
   * The product's name - 'Hershey's Extra Large Chocolate Bar'
   * @deprecated Use `display name` instead, as it has more details than `name`
   */
  name: Scalars['String'];
  /** An absolute url of the primary image associated with the product - 'https://www.example.com/etc' */
  primaryImageUrl: Maybe<Scalars['String']>;
};

export type CatalogRetailerProduct = {
  __typename?: 'CatalogRetailerProduct';
  /** The available item count of the retailer product */
  availableItemsCount: Maybe<Scalars['Int']>;
  /** The details of the retailer product */
  details: Maybe<Scalars['String']>;
  /** The display_name of the retailer product */
  displayName: Maybe<Scalars['String']>;
  /** A unique identifier for the retailer product */
  id: Scalars['ID'];
  /** The Url of the retailer product's primary image */
  primaryImageUrl: Maybe<Scalars['Url']>;
  /** The unique identifier for the associated product */
  productId: Maybe<Scalars['ID']>;
  /** The size of the retailer product (e.g., 4 oz) */
  size: Maybe<Scalars['String']>;
  /** The unit count of the retailer product */
  unitCount: Maybe<Scalars['Int']>;
};

/** The connection type for CatalogRetailerProduct. */
export type CatalogRetailerProductConnection = {
  __typename?: 'CatalogRetailerProductConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogRetailerProductEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogRetailerProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CatalogRetailerProductEdge = {
  __typename?: 'CatalogRetailerProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CatalogRetailerProduct>;
};

export type CatalogSchema = {
  __typename?: 'CatalogSchema';
  _: Maybe<Scalars['Boolean']>;
};

export type CatalogSearchDownloadsCatalogSearchDownloadSignedUrl = {
  __typename?: 'CatalogSearchDownloadsCatalogSearchDownloadSignedUrl';
  /** Signed url for the object */
  signedUrl: Scalars['String'];
};

export type CatalogTaxonomyNode = {
  __typename?: 'CatalogTaxonomyNode';
  /** A unique identifier for the taxonomy node */
  id: Scalars['ID'];
  /** The taxonomy nodes's name - ('Food', 'Meat', ...) */
  name: Scalars['String'];
  /** The parent taxonomy node */
  parentId: Scalars['ID'];
};

export enum CategorySurfaceType {
  AlcoholSurface = 'ALCOHOL_SURFACE',
  RetailerRecommendation = 'RETAILER_RECOMMENDATION'
}

export type ChatMessageInput = {
  /** A comment for the feedback */
  comment?: InputMaybe<Scalars['String']>;
  /** The content of the message */
  content: Scalars['String'];
  /** The feedback for the message */
  feedback?: InputMaybe<FeedbackEnum>;
  /** The role of the message sender */
  role: Scalars['String'];
  /** The timestamp when the message was created */
  timestamp?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The ID of the tool call */
  toolCallId?: InputMaybe<Scalars['ID']>;
  /** The tool calls in the message */
  toolCalls?: InputMaybe<Array<ToolCallInput>>;
};

export type CheckLaunchOnboardingProgressByPartnerRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type CheckLaunchOnboardingProgressByPartnerResponse = {
  __typename?: 'CheckLaunchOnboardingProgressByPartnerResponse';
  workflowState: Maybe<Scalars['String']>;
};

export type CheckoutSchema = {
  __typename?: 'CheckoutSchema';
  giftingEnabled: Maybe<Scalars['Boolean']>;
  multiStepTippingEnabled: Maybe<Scalars['Boolean']>;
  noRushSameDayDeliveryEnabled: Maybe<Scalars['Boolean']>;
  smsMarketingOptIn: Maybe<Scalars['Boolean']>;
  trackExtUserId: Maybe<Scalars['Boolean']>;
};

export enum ClassifiedTypeEnum {
  /** A commodity (bananas, apples, ...) */
  Commodity = 'COMMODITY',
  /** A product that is specific to a retailer (not universal) */
  InHouse = 'IN_HOUSE',
  /** A universal product (standard product with a UPC) */
  Universal = 'UNIVERSAL',
  /** The classification type is not known */
  Unknown = 'UNKNOWN'
}

export type ClearOverrideHoursCriteriaInput = {
  date?: InputMaybe<GoogleTypeDateInput>;
  serviceType?: InputMaybe<RetailerServiceType>;
};

export type ClientConfiguration = {
  __typename?: 'ClientConfiguration';
  applicationType: Maybe<Scalars['String']>;
  clientConfigurationId: Maybe<Scalars['Int']>;
  countryId: Maybe<Scalars['BigInt']>;
  isUnata: Maybe<Scalars['Boolean']>;
  partnerId: Maybe<Scalars['BigInt']>;
  retailerName: Maybe<Scalars['String']>;
  retailerSlug: Maybe<Scalars['String']>;
  settings: Maybe<Scalars['JSONObject']>;
  storeConfigurationIds: Maybe<Scalars['String']>;
  userIsolationContextId: Maybe<Scalars['Int']>;
};

export type ClientConfigurationInput = {
  applicationType?: InputMaybe<Scalars['String']>;
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  isUnata?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerName?: InputMaybe<Scalars['String']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['JSONObject']>;
  storeConfigurationIds?: InputMaybe<Scalars['String']>;
  userIsolationContextId?: InputMaybe<Scalars['Int']>;
};

export enum ClientContextClient {
  Ipp = 'IPP',
  Unknown = 'UNKNOWN'
}

export type ClientContextInput = {
  canonicalId?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<ClientContextClient>;
  email?: InputMaybe<Scalars['String']>;
};

export type ClientInput = {
  appName?: InputMaybe<Scalars['String']>;
  contextJson?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type ClonePartnerOauthApplicationRequestInput = {
  newName?: InputMaybe<Scalars['String']>;
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type ClonePartnerOauthApplicationResponse = {
  __typename?: 'ClonePartnerOauthApplicationResponse';
  clientId: Maybe<Scalars['String']>;
  clientSecret: Maybe<Scalars['String']>;
};

export type Collection = {
  __typename?: 'Collection';
  active: Maybe<Scalars['Boolean']>;
  activeAdminOnly: Maybe<Scalars['Boolean']>;
  archivedAt: Maybe<Scalars['DateTime']>;
  associatedRetailerCollectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  collectionStoreConfigurations: Maybe<Array<Maybe<CollectionStoreConfiguration>>>;
  collectionType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  endDate: Maybe<Scalars['DateTime']>;
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  headerImageUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  imagePath: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  legacyId: Maybe<Scalars['BigInt']>;
  mobileHeaderImageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  nestedCollections: Maybe<Array<Maybe<Collection>>>;
  parentId: Maybe<Scalars['BigInt']>;
  position: Maybe<Scalars['BigInt']>;
  products: Maybe<Array<Maybe<Product>>>;
  replaceDepartmentIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  requiredAlcoholContext: Maybe<Scalars['String']>;
  requiredRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  searchThumbWideImageUrl: Maybe<Scalars['String']>;
  showDepartmentTile: Maybe<Scalars['Boolean']>;
  slug: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['DateTime']>;
  subjects: Maybe<Array<Maybe<BaseSubject>>>;
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type CollectionStoreConfiguration = {
  __typename?: 'CollectionStoreConfiguration';
  id: Maybe<Scalars['BigInt']>;
  pinned: Maybe<Scalars['Boolean']>;
};

export type ColorsSchema = {
  __typename?: 'ColorsSchema';
  brandExpressDark: Maybe<Scalars['String']>;
  brandExpressExtraDark: Maybe<Scalars['String']>;
  brandExpressLight: Maybe<Scalars['String']>;
  brandExpressRegular: Maybe<Scalars['String']>;
  brandHighlightDark: Maybe<Scalars['String']>;
  brandHighlightLight: Maybe<Scalars['String']>;
  brandHighlightRegular: Maybe<Scalars['String']>;
  brandLoyaltyDark: Maybe<Scalars['String']>;
  brandLoyaltyLight: Maybe<Scalars['String']>;
  brandLoyaltyRegular: Maybe<Scalars['String']>;
  brandMaxDark: Maybe<Scalars['String']>;
  brandMaxLight: Maybe<Scalars['String']>;
  brandPrimaryDark: Maybe<Scalars['String']>;
  brandPrimaryExtraDark: Maybe<Scalars['String']>;
  brandPrimaryExtraLight: Maybe<Scalars['String']>;
  brandPrimaryRegular: Maybe<Scalars['String']>;
  brandPromotionalDark: Maybe<Scalars['String']>;
  brandPromotionalLight: Maybe<Scalars['String']>;
  brandPromotionalRegular: Maybe<Scalars['String']>;
  brandSecondaryDark: Maybe<Scalars['String']>;
  brandSecondaryLight: Maybe<Scalars['String']>;
  brandSecondaryRegular: Maybe<Scalars['String']>;
  brandTertiaryLight: Maybe<Scalars['String']>;
  brandTertiaryRegular: Maybe<Scalars['String']>;
  highContrastColors: Maybe<HighContrastColorsSchema>;
  plusDark: Maybe<Scalars['String']>;
  plusExtraDark: Maybe<Scalars['String']>;
  plusExtraLight: Maybe<Scalars['String']>;
  plusLight: Maybe<Scalars['String']>;
  plusRegular: Maybe<Scalars['String']>;
  systemDetrimentalDark: Maybe<Scalars['String']>;
  systemDetrimentalExtraDark: Maybe<Scalars['String']>;
  systemDetrimentalLight: Maybe<Scalars['String']>;
  systemDetrimentalRegular: Maybe<Scalars['String']>;
  systemGrayscale_00: Maybe<Scalars['String']>;
  systemGrayscale_10: Maybe<Scalars['String']>;
  systemGrayscale_20: Maybe<Scalars['String']>;
  systemGrayscale_30: Maybe<Scalars['String']>;
  systemGrayscale_50: Maybe<Scalars['String']>;
  systemGrayscale_70: Maybe<Scalars['String']>;
  systemSuccessDark: Maybe<Scalars['String']>;
  systemSuccessLight: Maybe<Scalars['String']>;
  systemSuccessRegular: Maybe<Scalars['String']>;
  tertiaryRegular: Maybe<Scalars['String']>;
};

export type CombineAuditBatchesRequestInput = {
  batchUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<Scalars['String']>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type CombineAuditBatchesResponse = {
  __typename?: 'CombineAuditBatchesResponse';
  batchUuid: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
};

export type CompactBanner = {
  __typename?: 'CompactBanner';
  backgroundColorHex: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaBackgroundColorHex: Maybe<Scalars['String']>;
  ctaColorHex: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type CompactBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ComponentValueFilterInput = {
  groupName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ConfigurableButtonInput = {
  /** Background color of the button */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Color of the button text */
  color?: InputMaybe<Scalars['String']>;
  /** The button text */
  label: Scalars['String'];
  /** The button style to use */
  styleVariant?: InputMaybe<ButtonVariantEnum>;
};

export type ConfigurableTextInput = {
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String'];
  /** The text to display */
  text: Scalars['String'];
};

export type ConfirmedStoreHours = {
  __typename?: 'ConfirmedStoreHours';
  confirmed: Maybe<Scalars['Boolean']>;
  date: Maybe<GoogleTypeDate>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
};

export type ConfirmedStoreHoursInput = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type ConnectApiKey = {
  __typename?: 'ConnectApiKey';
  applicationId: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  expiresIn: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  ipWhitelist: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  revokedAt: Maybe<Scalars['DateTime']>;
  rotatedAt: Maybe<Scalars['DateTime']>;
  rotatedFromId: Maybe<Scalars['BigInt']>;
  scopes: Maybe<Scalars['String']>;
  token: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ConnectPlatformEvent = {
  __typename?: 'ConnectPlatformEvent';
  clientConfigurationId: Maybe<Scalars['Int']>;
  consumerJobId: Maybe<Scalars['String']>;
  domain: Maybe<Scalars['String']>;
  domainObjectId: Maybe<Scalars['String']>;
  domainObjectType: Maybe<Scalars['String']>;
  eventMetadata: Maybe<Scalars['String']>;
  eventName: Maybe<Scalars['String']>;
  eventTimestamp: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
};

export type ConnectPlatformEventCallback = {
  __typename?: 'ConnectPlatformEventCallback';
  eventId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  notificationStatus: Maybe<Scalars['String']>;
  notifiedAt: Maybe<Scalars['DateTime']>;
  payload: Maybe<Scalars['String']>;
  retailerCallbackConfigurationId: Maybe<Scalars['BigInt']>;
  successful: Maybe<Scalars['Boolean']>;
  version: Maybe<Scalars['String']>;
};

export type ConnectPlatformEventCallbackResponse = {
  __typename?: 'ConnectPlatformEventCallbackResponse';
  callbackId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  payload: Maybe<Scalars['String']>;
  statusCode: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ConnectPlatformEventCallbackWithResponses = {
  __typename?: 'ConnectPlatformEventCallbackWithResponses';
  callback: Maybe<ConnectPlatformEventCallback>;
  responses: Maybe<Array<Maybe<ConnectPlatformEventCallbackResponse>>>;
};

export type ConnectPlatformEventWithCallbacks = {
  __typename?: 'ConnectPlatformEventWithCallbacks';
  callbacks: Maybe<Array<Maybe<ConnectPlatformEventCallbackWithResponses>>>;
  event: Maybe<ConnectPlatformEvent>;
};

export type ConnectRetailerCallbackConfiguration = {
  __typename?: 'ConnectRetailerCallbackConfiguration';
  accessTokenTtl: Maybe<Scalars['Int']>;
  authUri: Maybe<Scalars['String']>;
  clientConfigurationId: Maybe<Scalars['BigInt']>;
  credentials: Maybe<ConnectRetailerCallbackCredentials>;
  enabled: Maybe<Scalars['Boolean']>;
  environment: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']>;
  name: Maybe<Scalars['String']>;
  returnsPaymentAck: Maybe<Scalars['Boolean']>;
  v1Settings: Maybe<ConnectRetailerCallbackV1Settings>;
  v2Settings: Maybe<ConnectRetailerCallbackV2Settings>;
};

export type ConnectRetailerCallbackConfigurationInput = {
  accessTokenTtl?: InputMaybe<Scalars['Int']>;
  authUri?: InputMaybe<Scalars['String']>;
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  credentials?: InputMaybe<ConnectRetailerCallbackCredentialsInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  environment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  returnsPaymentAck?: InputMaybe<Scalars['Boolean']>;
  v1Settings?: InputMaybe<ConnectRetailerCallbackV1SettingsInput>;
  v2Settings?: InputMaybe<ConnectRetailerCallbackV2SettingsInput>;
};

export type ConnectRetailerCallbackCredentials = {
  __typename?: 'ConnectRetailerCallbackCredentials';
  apiKey: Maybe<Scalars['String']>;
  clientId: Maybe<Scalars['String']>;
  clientSecret: Maybe<Scalars['String']>;
  clientSecretEnvKey: Maybe<Scalars['String']>;
  customKey: Maybe<Scalars['String']>;
  customTokenEnvKey: Maybe<Scalars['String']>;
  grantType: Maybe<Scalars['String']>;
  resource: Maybe<Scalars['String']>;
  scope: Maybe<Scalars['String']>;
};

export type ConnectRetailerCallbackCredentialsInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  clientSecretEnvKey?: InputMaybe<Scalars['String']>;
  customKey?: InputMaybe<Scalars['String']>;
  customTokenEnvKey?: InputMaybe<Scalars['String']>;
  grantType?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
};

export type ConnectRetailerCallbackV1Settings = {
  __typename?: 'ConnectRetailerCallbackV1Settings';
  callbackUri: Maybe<Scalars['String']>;
  statusesOfInterest: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ConnectRetailerCallbackV1SettingsInput = {
  callbackUri?: InputMaybe<Scalars['String']>;
  statusesOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ConnectRetailerCallbackV2Settings = {
  __typename?: 'ConnectRetailerCallbackV2Settings';
  callbackUri: Maybe<Scalars['String']>;
  exposeRetailerId: Maybe<Scalars['Boolean']>;
  orderLocationCallbackFrequency: Maybe<Scalars['BigInt']>;
  redactShopperPii: Maybe<Scalars['Boolean']>;
  statusesOfInterest: Maybe<Array<Maybe<Scalars['String']>>>;
  useApiKey: Maybe<Scalars['Boolean']>;
  useSignatureVerification: Maybe<Scalars['Boolean']>;
};

export type ConnectRetailerCallbackV2SettingsInput = {
  callbackUri?: InputMaybe<Scalars['String']>;
  exposeRetailerId?: InputMaybe<Scalars['Boolean']>;
  orderLocationCallbackFrequency?: InputMaybe<Scalars['BigInt']>;
  redactShopperPii?: InputMaybe<Scalars['Boolean']>;
  statusesOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useApiKey?: InputMaybe<Scalars['Boolean']>;
  useSignatureVerification?: InputMaybe<Scalars['Boolean']>;
};

export type ConnectionMeta = {
  __typename?: 'ConnectionMeta';
  /** The total number of connection elements */
  totalCount: Scalars['Int'];
};

export type Contact = {
  __typename?: 'Contact';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Container = {
  __typename?: 'Container';
  hasDepartments: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  navs: Maybe<Array<Maybe<ContainerNav>>>;
  navsV2: Maybe<Array<Maybe<ContainerNav>>>;
  placementId: Maybe<Scalars['BigInt']>;
  position: Maybe<Scalars['BigInt']>;
  title: Maybe<Scalars['String']>;
};

export type ContainerInput = {
  hasDepartments?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  navs?: InputMaybe<Array<InputMaybe<ContainerNavInput>>>;
  navsV2?: InputMaybe<Array<InputMaybe<ContainerNavInput>>>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ContainerNav = {
  __typename?: 'ContainerNav';
  departmentsPlaceholderNavigation: Maybe<DepartmentsPlaceholderNavigation>;
  flatNavWithVariants: Maybe<FlatNavigationWithVariants>;
};

export type ContainerNavInput = {
  departmentsPlaceholderNavigation?: InputMaybe<DepartmentsPlaceholderNavigationInput>;
  flatNavWithVariants?: InputMaybe<FlatNavigationWithVariantsInput>;
};

export type ContentManagementAnnouncementBannerGenericImages = {
  __typename?: 'ContentManagementAnnouncementBannerGenericImages';
  /** The foreground image url in the placement to be used on desktop clients */
  desktop: Maybe<Scalars['Url']>;
  /** The foreground image url in the placement to be used on mobile clients */
  mobile: Scalars['Url'];
};

export type ContentManagementConfigurableButton = {
  __typename?: 'ContentManagementConfigurableButton';
  /** The background color of the button (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>;
  /** Color of the button text (Eg. #000000) */
  color: Maybe<Scalars['String']>;
  /** The button text */
  label: Scalars['String'];
  /** The button style to use */
  styleVariant: ButtonVariantEnum;
};

export type ContentManagementConfigurableText = {
  __typename?: 'ContentManagementConfigurableText';
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String'];
  /** The text to display */
  text: Maybe<Scalars['String']>;
};

export type ContentManagementFlyoutPlacement = {
  __typename?: 'ContentManagementFlyoutPlacement';
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** The style and text of the subheading */
  descriptionText: ContentManagementConfigurableText;
  /** The style and text of the secondary text */
  disclaimerText: Maybe<ContentManagementConfigurableText>;
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds: Array<Scalars['Int']>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds: Array<Scalars['Int']>;
  /** The layout the placement should appear on */
  layout: Scalars['String'];
  /** The style and text of the button within the placement */
  linkButton: Maybe<ContentManagementConfigurableButton>;
  /** Where interacting with the placement leads */
  linkDestination: Maybe<ContentManagementPlacementDestination>;
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The style and text of the button within the placement */
  primaryButton: Maybe<ContentManagementConfigurableButton>;
  /** Where interacting with the placement leads */
  primaryDestination: Maybe<ContentManagementPlacementDestination>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The style and text of the button within the placement */
  secondaryButton: Maybe<ContentManagementConfigurableButton>;
  /** Where interacting with the placement leads */
  secondaryDestination: Maybe<ContentManagementPlacementDestination>;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The layout the placement should appear on */
  stringLayout: Scalars['String'];
  /** The style and text of the heading */
  titleText: ContentManagementConfigurableText;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
  /** The variant of the banner */
  variant: Scalars['String'];
};

export type ContentManagementHeroBannerPlacement = {
  __typename?: 'ContentManagementHeroBannerPlacement';
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>;
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>;
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>;
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>;
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds: Array<Scalars['Int']>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds: Array<Scalars['Int']>;
  /** The layout the placement should appear on */
  layout: Scalars['String'];
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The layout the placement should appear on */
  stringLayout: Scalars['String'];
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
  /** The color of the text area (Eg. #FFFFFF) */
  textareaColor: Maybe<Scalars['String']>;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
  /** The variant of the banner */
  variant: Scalars['String'];
};

export type ContentManagementPbiConfiguration = {
  __typename?: 'ContentManagementPbiConfiguration';
  /** The url for the retailer's pbi instance */
  domainName: Scalars['String'];
  /** The unique slug for the retailer */
  slug: Scalars['String'];
};

export type ContentManagementPlacementDestination = {
  __typename?: 'ContentManagementPlacementDestination';
  /** The human readable value of the target */
  displayValue: Maybe<Scalars['String']>;
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String'];
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum;
};

export type ContentManagementPlacementExperiment = {
  __typename?: 'ContentManagementPlacementExperiment';
  /** Experiment Assignment or Lookup */
  accessMethod: Maybe<PlacementExperimentMethodEnum>;
  /** Name of the Experiment */
  name: Maybe<Scalars['String']>;
  /** Variant of the Experiment for which placement should be visible */
  variant: Maybe<Scalars['String']>;
};

export type ContentManagementPlacementImages = {
  __typename?: 'ContentManagementPlacementImages';
  /** The image url of the placement to display for large viewports */
  large: Maybe<Scalars['Url']>;
  /** The image url of the placement to display for small viewports */
  small: Maybe<Scalars['Url']>;
};

export type ContentManagementPlacementSchedule = {
  __typename?: 'ContentManagementPlacementSchedule';
  /** When the placement should stop being active */
  endDate: Maybe<Scalars['Time']>;
  /** When the placement should become active */
  startDate: Scalars['Time'];
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Maybe<Scalars['String']>;
};

export type ContentManagementSecondaryBannerPlacement = {
  __typename?: 'ContentManagementSecondaryBannerPlacement';
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>;
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>;
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>;
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>;
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds: Array<Scalars['Int']>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds: Array<Scalars['Int']>;
  /** The layout the placement should appear on */
  layout: Scalars['String'];
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The style and text of the secondary text */
  secondaryText: Maybe<ContentManagementConfigurableText>;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The layout the placement should appear on */
  stringLayout: Scalars['String'];
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
  /** The variant of the banner */
  variant: Scalars['String'];
};

export type ContentManagementStorefrontPlacement = {
  __typename?: 'ContentManagementStorefrontPlacement';
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>;
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>;
  /** The banners configured to the placement */
  banners: Array<ContentManagementStorefrontPlacementBanner>;
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText;
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>;
  /** Whether or not the placement can be dismissed */
  dismissable: Scalars['Boolean'];
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: ContentManagementPlacementImages;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds: Maybe<Array<Scalars['Int']>>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** A unique identifier for the retailer */
  retailerId: Scalars['ID'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
};

export type ContentManagementStorefrontPlacementBanner = {
  __typename?: 'ContentManagementStorefrontPlacementBanner';
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>;
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>;
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText;
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier of the banner associated with the placement */
  id: Maybe<Scalars['ID']>;
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: ContentManagementPlacementImages;
  /** The banner's locale */
  locale: Maybe<BannerLocaleEnum>;
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
};

/** The connection type for ContentManagementStorefrontPlacement. */
export type ContentManagementStorefrontPlacementConnection = {
  __typename?: 'ContentManagementStorefrontPlacementConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ContentManagementStorefrontPlacementEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ContentManagementStorefrontPlacement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentManagementStorefrontPlacementEdge = {
  __typename?: 'ContentManagementStorefrontPlacementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ContentManagementStorefrontPlacement>;
};

export type ContentManagementUnknownBannerPlacement = {
  __typename?: 'ContentManagementUnknownBannerPlacement';
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
};

export type ContentManagementVisibilityConditionCountryIds = {
  __typename?: 'ContentManagementVisibilityConditionCountryIds';
  /** list of country ids */
  countryIds: Array<Scalars['Int']>;
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionDayOfWeek = {
  __typename?: 'ContentManagementVisibilityConditionDayOfWeek';
  /** list of days within the week */
  days: Array<Scalars['String']>;
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionExperimentVariant = {
  __typename?: 'ContentManagementVisibilityConditionExperimentVariant';
  /** The method of the experiment */
  experimentMethod: PlacementExperimentMethodEnum;
  /** The name of the experiment */
  experimentName: Scalars['String'];
  /** The name of the experiment variant */
  experimentVariant: Scalars['String'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionExpressMembership = {
  __typename?: 'ContentManagementVisibilityConditionExpressMembership';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>;
};

export type ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout = {
  __typename?: 'ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>;
};

export type ContentManagementVisibilityConditionMatchesAnyRetailerId = {
  __typename?: 'ContentManagementVisibilityConditionMatchesAnyRetailerId';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of retailer ids */
  retailerIds: Array<Scalars['Int']>;
};

export type ContentManagementVisibilityConditionMinimumPlatformVersion = {
  __typename?: 'ContentManagementVisibilityConditionMinimumPlatformVersion';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum;
  /** Version used for the check */
  version: Scalars['String'];
};

export type ContentManagementVisibilityConditionNewVerticalUserTargeting = {
  __typename?: 'ContentManagementVisibilityConditionNewVerticalUserTargeting';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** The module type */
  moduleType: Scalars['String'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionRetailerAvailability = {
  __typename?: 'ContentManagementVisibilityConditionRetailerAvailability';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** A unique identifier of the retailer associated with the visibility condition */
  retailerId: Scalars['Int'];
};

export type ContentManagementVisibilityConditionShopped = {
  __typename?: 'ContentManagementVisibilityConditionShopped';
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int'];
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int'];
  /** Number of times in the past to check */
  numberOfTimes: Scalars['Int'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int'];
};

export type ContentManagementVisibilityConditionShoppedAtRetailer = {
  __typename?: 'ContentManagementVisibilityConditionShoppedAtRetailer';
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int'];
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the Retailer */
  retailerId: Scalars['Int'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int'];
};

export type ContentManagementVisibilityConditionUnknownVisibilityCondition = {
  __typename?: 'ContentManagementVisibilityConditionUnknownVisibilityCondition';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionUserInteractionLimit = {
  __typename?: 'ContentManagementVisibilityConditionUserInteractionLimit';
  /** Number of seconds to wait before resetting the counter */
  countCooldownSec: Maybe<Scalars['Int']>;
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Maximum number of dismiss events */
  maxDismissedCount: Maybe<Scalars['Int']>;
  /** Maximum number of click events */
  maxEngagementsCount: Maybe<Scalars['Int']>;
  /** Maximum number of view events */
  maxImpressionsCount: Maybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionUtmParameters = {
  __typename?: 'ContentManagementVisibilityConditionUtmParameters';
  /** coupon_code */
  couponCode: Scalars['String'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** utm_campaign */
  utmCampaign: Scalars['String'];
  /** utm_content */
  utmContent: Scalars['String'];
  /** utm_medium */
  utmMedium: Scalars['String'];
  /** utm_source */
  utmSource: Scalars['String'];
  /** utm_term */
  utmTerm: Scalars['String'];
};

export type ContentManagementVisibilityConditionWhitelistedPostalCodes = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedPostalCodes';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>;
};

export type ContentManagementVisibilityConditionWhitelistedZones = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedZones';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of zone ids */
  zones: Array<Scalars['String']>;
};

export type ContentPage = {
  __typename?: 'ContentPage';
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  internalName: Maybe<Scalars['String']>;
  layout: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  slug: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
};

export type ContentPageMetaInfoStatusFound302 = {
  __typename?: 'ContentPageMetaInfoStatusFound302';
  redirectUrl: Maybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusFound302Input = {
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusMovedPermanently301 = {
  __typename?: 'ContentPageMetaInfoStatusMovedPermanently301';
  redirectUrl: Maybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusMovedPermanently301Input = {
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusNotFound404 = {
  __typename?: 'ContentPageMetaInfoStatusNotFound404';
  _: Maybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusNotFound404Input = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusOk200 = {
  __typename?: 'ContentPageMetaInfoStatusOk200';
  _: Maybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusOk200Input = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusOneOf = {
  __typename?: 'ContentPageMetaInfoStatusOneOf';
  found302: Maybe<ContentPageMetaInfoStatusFound302>;
  movedPermanently301: Maybe<ContentPageMetaInfoStatusMovedPermanently301>;
  notFound404: Maybe<ContentPageMetaInfoStatusNotFound404>;
  ok200: Maybe<ContentPageMetaInfoStatusOk200>;
};

export type ContentPageMetaInfoStatusOneOfInput = {
  found302?: InputMaybe<ContentPageMetaInfoStatusFound302Input>;
  movedPermanently301?: InputMaybe<ContentPageMetaInfoStatusMovedPermanently301Input>;
  notFound404?: InputMaybe<ContentPageMetaInfoStatusNotFound404Input>;
  ok200?: InputMaybe<ContentPageMetaInfoStatusOk200Input>;
};

export type ContentPageSlots = {
  __typename?: 'ContentPageSlots';
  archivedAt: Maybe<Scalars['DateTime']>;
  contentPageVersionId: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  internalName: Maybe<Scalars['String']>;
  pageType: Maybe<Scalars['String']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  slotCreatives: Maybe<Array<Maybe<SlotCreative>>>;
  slots: Maybe<Array<Maybe<Slot>>>;
  slug: Maybe<Scalars['String']>;
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ContentPageV2 = {
  __typename?: 'ContentPageV2';
  activeVersionId: Maybe<Scalars['BigInt']>;
  archivedAt: Maybe<Scalars['DateTime']>;
  createdAt: Maybe<Scalars['DateTime']>;
  endsAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  internalName: Maybe<Scalars['String']>;
  pageType: Maybe<Scalars['String']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  schedule: Maybe<Scalars['String']>;
  scheduleEnabled: Maybe<Scalars['Boolean']>;
  slug: Maybe<Scalars['String']>;
  startsAt: Maybe<Scalars['DateTime']>;
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  teamOwner: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ContentPageVersion = {
  __typename?: 'ContentPageVersion';
  contentPageId: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  previewToken: Maybe<Scalars['String']>;
  routingStatus: Maybe<ContentPageMetaInfoStatusOneOf>;
  seoCanonicalUrl: Maybe<Scalars['String']>;
  seoNoIndex: Maybe<Scalars['Boolean']>;
  trackingProperties: Maybe<Scalars['JSONObject']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ContentPageVersionMeta = {
  __typename?: 'ContentPageVersionMeta';
  contentPageVersionId: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  title: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Defines filtering criteria based on content attributes in a request to list approval requests. */
export type ContentSearchInput = {
  /** Returns ARs that match the provided content_type. */
  equalsContentType?: InputMaybe<Scalars['String']>;
  /** Returns ARs that contain a superset of the provided set of IDs. */
  hasContentIds?: InputMaybe<Array<Scalars['String']>>;
};

/** The type of content snapshot. */
export enum ContentSnapshot {
  /** A snapshot of the original content as it currently is published today. */
  Base = 'BASE',
  /** A snapshot of the proposed changes to the content. */
  Revision = 'REVISION'
}

export type ContractRenderData = {
  __typename?: 'ContractRenderData';
  companyAddress: Maybe<Scalars['String']>;
  companyContactName: Maybe<Scalars['String']>;
  companyContactTitle: Maybe<Scalars['String']>;
  companyName: Maybe<Scalars['String']>;
  currentDate: Maybe<Scalars['String']>;
  stateOfIncorporation: Maybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  /** country code */
  alpha2: Maybe<Scalars['String']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** country name */
  name: Scalars['String'];
};

export type CountryIdsInput = {
  /** list of country ids */
  countryIds: Array<Scalars['Int']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of CountryIdsVisibilityConditionCreate */
export type CountryIdsVisibilityConditionCreatePayload = {
  __typename?: 'CountryIdsVisibilityConditionCreatePayload';
  /** The newly created CountryIds visibility condition */
  countryIdsVisibilityCondition: ContentManagementVisibilityConditionCountryIds;
};

/** Autogenerated return type of CountryIdsVisibilityConditionUpdate */
export type CountryIdsVisibilityConditionUpdatePayload = {
  __typename?: 'CountryIdsVisibilityConditionUpdatePayload';
  /** The newly updated CountryIds visibility condition */
  countryIdsVisibilityCondition: ContentManagementVisibilityConditionCountryIds;
};

export type CreateAiCarouselRequestInput = {
  userPrompt?: InputMaybe<Scalars['String']>;
};

export type CreateAiCarouselResponse = {
  __typename?: 'CreateAiCarouselResponse';
  aiCarouselConfiguration: Maybe<AiCarouselConfiguration>;
};

export type CreateAuditWorkflowRequestInput = {
  auditWorkflow?: InputMaybe<AuditWorkflowInput>;
};

export type CreateAuditWorkflowResponse = {
  __typename?: 'CreateAuditWorkflowResponse';
  id: Maybe<Scalars['BigInt']>;
};

export type CreateAutomatedTestRunRequestInput = {
  additionalEnv?: InputMaybe<Scalars['String']>;
  additionalEnvVariables?: InputMaybe<Array<InputMaybe<AdditionalEnvVariableInput>>>;
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  testCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateAutomatedTestRunResponse = {
  __typename?: 'CreateAutomatedTestRunResponse';
  branch: Maybe<Scalars['String']>;
  buildUrl: Maybe<Scalars['String']>;
  commit: Maybe<Scalars['String']>;
};

export type CreateClientConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>;
  clientConfiguration?: InputMaybe<ClientConfigurationInput>;
};

export type CreateClientConfigurationResponse = {
  __typename?: 'CreateClientConfigurationResponse';
  clientConfiguration: Maybe<ClientConfiguration>;
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type CreateConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfiguration?: InputMaybe<ConnectRetailerCallbackConfigurationInput>;
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'CreateConnectRetailerCallbackConfigurationResponse';
  callbackConfiguration: Maybe<ConnectRetailerCallbackConfiguration>;
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type CreateContentPageRequestInput = {
  internalName?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateContentPageRequestV2Input = {
  endsAt?: InputMaybe<Scalars['DateTime']>;
  internalName?: InputMaybe<Scalars['String']>;
  pageType?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  schedule?: InputMaybe<Scalars['String']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  teamOwner?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateContentPageResponse = {
  __typename?: 'CreateContentPageResponse';
  contentPage: Maybe<ContentPage>;
};

export type CreateContentPageResponseV2 = {
  __typename?: 'CreateContentPageResponseV2';
  contentPage: Maybe<ContentPageV2>;
};

export type CreateContentPageVersionMetaRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  description?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateContentPageVersionMetaResponse = {
  __typename?: 'CreateContentPageVersionMetaResponse';
  contentPageVersionMeta: Maybe<ContentPageVersionMeta>;
};

export type CreateContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  baseContentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  routingStatus?: InputMaybe<ContentPageMetaInfoStatusOneOfInput>;
  seoCanonicalUrl?: InputMaybe<Scalars['String']>;
  seoNoIndex?: InputMaybe<Scalars['Boolean']>;
  trackingProperties?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateContentPageVersionResponse = {
  __typename?: 'CreateContentPageVersionResponse';
  contentPageVersion: Maybe<ContentPageVersion>;
};

export type CreateCreativePlacementsRequestInput = {
  creatives?: InputMaybe<Array<InputMaybe<PlacementContentInput>>>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type CreateCreativePlacementsResponse = {
  __typename?: 'CreateCreativePlacementsResponse';
  creatives: Maybe<Array<Maybe<CreateCreativePlacementsResponseCreativePlacementResult>>>;
};

export type CreateCreativePlacementsResponseCreativePlacementResult = {
  __typename?: 'CreateCreativePlacementsResponseCreativePlacementResult';
  creativeRank: Maybe<Scalars['Int']>;
  placement: Maybe<PlacementContent>;
  slotCreative: Maybe<SlotCreative>;
};

export type CreateDetectionRequestInput = {
  attributes?: InputMaybe<DetectionVersionAttributesInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateDetectionResponse = {
  __typename?: 'CreateDetectionResponse';
  id: Maybe<Scalars['BigInt']>;
  version: Maybe<Scalars['BigInt']>;
};

export type CreateDetectionVersionRequestInput = {
  attributes?: InputMaybe<DetectionVersionAttributesInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CreateDetectionVersionResponse = {
  __typename?: 'CreateDetectionVersionResponse';
  version: Maybe<Scalars['BigInt']>;
};

export type CreateDriverRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateDriverResponse = {
  __typename?: 'CreateDriverResponse';
  id: Maybe<Scalars['BigInt']>;
};

export type CreateImageUploadBatchRequestInput = {
  imagesAwsDetails?: InputMaybe<ImagesAwsDetailsInput>;
  imagesZipKey?: InputMaybe<Scalars['String']>;
  importType?: InputMaybe<Scalars['String']>;
  localeId?: InputMaybe<Scalars['BigInt']>;
  sourceType?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateImageUploadBatchResponse = {
  __typename?: 'CreateImageUploadBatchResponse';
  imageUploadBatchId: Maybe<Scalars['BigInt']>;
  status: Maybe<Scalars['String']>;
};

export type CreateLastmileOrderFromDashboardRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateLastmileOrderFromDashboardResponse = {
  __typename?: 'CreateLastmileOrderFromDashboardResponse';
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

export type CreateLayoutVariantRequestInput = {
  layoutVariant?: InputMaybe<LayoutVariantInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateLayoutVariantResponse = {
  __typename?: 'CreateLayoutVariantResponse';
  layoutVariant: Maybe<LayoutVariant>;
};

export type CreateMomentRequestInput = {
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  discoverability?: InputMaybe<Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type CreateMomentResponse = {
  __typename?: 'CreateMomentResponse';
  moment: Maybe<Moment>;
};

export type CreateNativeTabBarNavigationRequestInput = {
  navigation?: InputMaybe<NativeTabBarNavigationInput>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateNativeTabBarNavigationResponse = {
  __typename?: 'CreateNativeTabBarNavigationResponse';
  navigation: Maybe<NativeTabBarNavigation>;
};

export type CreateNavigationPreviewRequestInput = {
  navigation?: InputMaybe<NavigationInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateNavigationPreviewResponse = {
  __typename?: 'CreateNavigationPreviewResponse';
  previewToken: Maybe<Scalars['String']>;
};

export type CreateNavigationRequestInput = {
  layout?: InputMaybe<Scalars['String']>;
  navigation?: InputMaybe<NavigationInput>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateNavigationResponse = {
  __typename?: 'CreateNavigationResponse';
  navigation: Maybe<Navigation>;
};

export type CreateOnboardingStoreLocationRequestInput = {
  address?: InputMaybe<AddressInput>;
  token?: InputMaybe<Scalars['String']>;
};

export type CreateOnboardingStoreLocationResponse = {
  __typename?: 'CreateOnboardingStoreLocationResponse';
  onboarding: Maybe<Onboarding>;
};

export type CreateOosAcknowledgmentRequestInput = {
  oosId?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateOosAcknowledgmentResponse = {
  __typename?: 'CreateOosAcknowledgmentResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type CreateOrUpdateLinkAutosuggestionAdminParametersInput = {
  linkAutosuggestion?: InputMaybe<LinkAutosuggestionAdminInput>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateOrUpdateLinkAutosuggestionAdminRequestInput = {
  parameters?: InputMaybe<CreateOrUpdateLinkAutosuggestionAdminParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type CreateOrUpdateLinkAutosuggestionAdminResponse = {
  __typename?: 'CreateOrUpdateLinkAutosuggestionAdminResponse';
  linkAutosuggestion: Maybe<LinkAutosuggestionAdmin>;
};

export type CreateOrUpdateReturnRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  returnData?: InputMaybe<ProposedReturnInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateOrUpdateReturnResponse = {
  __typename?: 'CreateOrUpdateReturnResponse';
  message: Maybe<Scalars['String']>;
  status: Maybe<ResponseStatus>;
};

export type CreatePartnerApiKeyRequestInput = {
  environment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  userUuid?: InputMaybe<Scalars['String']>;
};

export type CreatePatchApprovalRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  expectedExpiryAt?: InputMaybe<Scalars['DateTime']>;
  investigationId?: InputMaybe<Scalars['String']>;
  patchName?: InputMaybe<Scalars['String']>;
  patchType?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type CreatePatchApprovalResponse = {
  __typename?: 'CreatePatchApprovalResponse';
  approvalRequestId: Maybe<Scalars['String']>;
  investigationId: Maybe<Scalars['String']>;
  patchStatus: Maybe<PatchStatus>;
};

export type CreatePiiRequestForRetailerRequestInput = {
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  requestType?: InputMaybe<RequestType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerNotes?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CreatePiiRequestForRetailerResponse = {
  __typename?: 'CreatePiiRequestForRetailerResponse';
  piiRequestCreationStatus: Maybe<PiiRequestCreationStatus>;
  piiRequestId: Maybe<Scalars['BigInt']>;
};

export type CreatePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>;
  content?: InputMaybe<PlacementContentInput>;
};

export type CreatePlacementContentResponse = {
  __typename?: 'CreatePlacementContentResponse';
  content: Maybe<PlacementContent>;
};

export type CreatePlacementRequestInput = {
  placement?: InputMaybe<PlacementInput>;
};

export type CreatePlacementResponse = {
  __typename?: 'CreatePlacementResponse';
  placement: Maybe<Placement>;
};

export type CreatePriceAnomalyInvestigationRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  createdWhy?: InputMaybe<Scalars['String']>;
  investigationParameters?: InputMaybe<Scalars['JSONObject']>;
  investigationType?: InputMaybe<InvestigationType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreatePriceAnomalyInvestigationResponse = {
  __typename?: 'CreatePriceAnomalyInvestigationResponse';
  investigation: Maybe<Investigation>;
};

export type CreatePriceAnomalyPatchRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  expectedExpiryAt?: InputMaybe<Scalars['DateTime']>;
  investigationId?: InputMaybe<Scalars['String']>;
  patchName?: InputMaybe<Scalars['String']>;
  patchType?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type CreatePriceAnomalyPatchResponse = {
  __typename?: 'CreatePriceAnomalyPatchResponse';
  investigationId: Maybe<Scalars['String']>;
  patchId: Maybe<Scalars['String']>;
  patchStatus: Maybe<PatchStatus>;
};

export type CreateRetailerCampaignRequestInput = {
  automaticBudgetCappingEnrolled?: InputMaybe<Scalars['Boolean']>;
  automaticBudgetPausingEnrolled?: InputMaybe<Scalars['Boolean']>;
  budgetPacingEnabled?: InputMaybe<Scalars['Boolean']>;
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignReference?: InputMaybe<CampaignReferenceInput>;
  campaignType?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  countryIdValue?: InputMaybe<Scalars['BigInt']>;
  couponCount?: InputMaybe<Scalars['BigInt']>;
  creatorIppUserId?: InputMaybe<Scalars['BigInt']>;
  crmsIntentionConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  customProperties?: InputMaybe<Array<InputMaybe<CustomPropertyInput>>>;
  discountPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  discoverability?: InputMaybe<Discoverability>;
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  enableOnlineCampaignCrm?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  exclusivityGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
  forInternalTestingOnly?: InputMaybe<Scalars['Boolean']>;
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  ippUserCanonicalUuid?: InputMaybe<Scalars['String']>;
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  marketingMessagingDetails?: InputMaybe<MarketingMessagingDetailsInput>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferInput>>>;
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  redemptionMethod?: InputMaybe<RedemptionMethod>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  reissuable?: InputMaybe<Scalars['Boolean']>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<RestaurantRewardPolicyInput>;
  retailerAgnostic?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  rouletteFeature?: InputMaybe<CampaignRouletteFeatureInput>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  separateTreatmentPolicies?: InputMaybe<Scalars['Boolean']>;
  skipCreateCouponCode?: InputMaybe<Scalars['Boolean']>;
  slotCreatives?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementAdminV1SlotCreativeInput>>>;
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  targeting?: InputMaybe<Array<InputMaybe<Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<TargetingRulesInput>>>;
  templateId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  treatmentTask?: InputMaybe<CampaignTreatmentTaskRequestParamsInput>;
  treatments?: InputMaybe<RetailerCampaignTreatmentsInput>;
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type CreateRetailerCampaignTreatmentParamsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<RetailerCampaignTreatmentDetailsInput>>>;
  treatmentType?: InputMaybe<RetailerCampaignTreatmentType>;
};

export type CreateRoleInput = {
  /** A description of the role */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the role */
  name: Scalars['String'];
  partnerId?: InputMaybe<Scalars['ID']>;
  /** The permissions associated with this role */
  permissions?: InputMaybe<Array<PermissionInput>>;
  retailerId?: InputMaybe<Scalars['ID']>;
};

export type CreateSignupRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  signupPartnerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateSignupResponse = {
  __typename?: 'CreateSignupResponse';
  token: Maybe<Scalars['String']>;
};

export type CreateSlotCreativeRequestInput = {
  cartState?: InputMaybe<CartState>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
};

export type CreateSlotCreativeResponse = {
  __typename?: 'CreateSlotCreativeResponse';
  slotCreative: Maybe<SlotCreative>;
};

export type CreateSlotPlacementRequestInput = {
  placement?: InputMaybe<PlacementContentInput>;
  slot?: InputMaybe<CreateSlotPlacementRequestSlotConfigInput>;
};

export type CreateSlotPlacementRequestSlotConfigInput = {
  description?: InputMaybe<Scalars['String']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateSlotPlacementResponse = {
  __typename?: 'CreateSlotPlacementResponse';
  placement: Maybe<PlacementContent>;
  slot: Maybe<Slot>;
};

export type CreateSlotRequestInput = {
  description?: InputMaybe<Scalars['String']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  legacySlotId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateSlotResponse = {
  __typename?: 'CreateSlotResponse';
  slot: Maybe<Slot>;
};

export type CreateStoreConfigurationDraftRequestInput = {
  draftName?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateStoreConfigurationDraftResponse = {
  __typename?: 'CreateStoreConfigurationDraftResponse';
  domainConfigurations: Maybe<DomainConfiguration>;
  domainConfigurationsRaw: Maybe<Scalars['JSONObject']>;
  draftId: Maybe<Scalars['String']>;
  draftName: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  errorReason: Maybe<ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
};

export type CreateStoreConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>;
  storeConfiguration?: InputMaybe<StoreConfigurationInput>;
};

export type CreateStoreConfigurationResponse = {
  __typename?: 'CreateStoreConfigurationResponse';
  errorMessage: Maybe<Scalars['String']>;
  storeConfiguration: Maybe<StoreConfiguration>;
  success: Maybe<Scalars['Boolean']>;
};

export type CreateThemePageRequestInput = {
  themePage?: InputMaybe<ThemePageInput>;
};

export type CreateThemePageResponse = {
  __typename?: 'CreateThemePageResponse';
  themePage: Maybe<ThemePage>;
};

export type CreateTicketRequestInput = {
  assignee?: InputMaybe<UserInput>;
  client?: InputMaybe<ClientInput>;
  description?: InputMaybe<Scalars['String']>;
  entityIds?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  entityType?: InputMaybe<EntityType>;
  localeCode?: InputMaybe<Scalars['String']>;
  problemType?: InputMaybe<ProblemType>;
  reportedOnBehalfOf?: InputMaybe<UserInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateTicketResponse = {
  __typename?: 'CreateTicketResponse';
  cptTicketId: Maybe<Scalars['BigInt']>;
};

export type CreateValueBasedOverrideRequestInput = {
  valueBasedOverride?: InputMaybe<ValueBasedOverrideRequestInput>;
};

export type CreateValueBasedOverrideResponse = {
  __typename?: 'CreateValueBasedOverrideResponse';
  valueBasedOverride: Maybe<ValueBasedOverrideResponse>;
};

export type CreateWhitelabelSiteCustomizableStringRequestInput = {
  whitelabelSiteCustomizableString?: InputMaybe<WhitelabelSiteCustomizableStringInput>;
};

export type CreateWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'CreateWhitelabelSiteCustomizableStringResponse';
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
  whitelabelSiteCustomizableString: Maybe<WhitelabelSiteCustomizableString>;
};

export type CreateWhitelabelSiteRequestInput = {
  delayRetailerEmail?: InputMaybe<Scalars['Boolean']>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  ownerUserUuid?: InputMaybe<Scalars['String']>;
  retailerUserUuid?: InputMaybe<Scalars['String']>;
  skipRetailerForm?: InputMaybe<Scalars['Boolean']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  tier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateWhitelabelSiteResponse = {
  __typename?: 'CreateWhitelabelSiteResponse';
  whitelabelSite: Maybe<WhitelabelSite>;
};

export type CreateWhitelabelStoreConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>;
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  setupOptions?: InputMaybe<Scalars['JSONObject']>;
  storeConfiguration?: InputMaybe<StoreConfigurationInput>;
};

export type CreateWhitelabelStoreConfigurationResponse = {
  __typename?: 'CreateWhitelabelStoreConfigurationResponse';
  errorMessage: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['Int']>;
  success: Maybe<Scalars['Boolean']>;
};

export type CustomFontFamilySchema = {
  __typename?: 'CustomFontFamilySchema';
  customFontFamily: Maybe<FontFamily>;
};

export type CustomImages = {
  __typename?: 'CustomImages';
  accountOrdersEmptyState: Maybe<AccountOrdersEmptyState>;
  cartEmptyState: Maybe<CartEmptyState>;
  mobileAppWelcomeScreen: Maybe<MobileAppWelcomeScreen>;
};

export type CustomProperty = {
  __typename?: 'CustomProperty';
  key: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type CustomPropertyInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum CustomersAddressType {
  AddressTypeUnspecified = 'ADDRESS_TYPE_UNSPECIFIED',
  Business = 'BUSINESS',
  Residential = 'RESIDENTIAL'
}

export type CustomersAdminRequestContextInput = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersAmounts = {
  __typename?: 'CustomersAmounts';
  amount: Maybe<CustomersGoogleTypeMoney>;
  labelInEnglish: Maybe<Scalars['String']>;
};

export type CustomersContext = {
  __typename?: 'CustomersContext';
  clientConfigurationId: Maybe<Scalars['Int']>;
  clientName: Maybe<Scalars['String']>;
  countryId: Maybe<Scalars['Int']>;
  storeConfigurationId: Maybe<Scalars['Int']>;
};

export type CustomersGetHandlingDetailsRequestInput = {
  omitOrdersWithErrors?: InputMaybe<Scalars['Boolean']>;
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersGetHandlingDetailsResponse = {
  __typename?: 'CustomersGetHandlingDetailsResponse';
  handlingDetails: Maybe<CustomersGetHandlingDetailsResponseHandlingDetails>;
  handlingDetailsByOrderReference: Maybe<CustomersGetHandlingDetailsResponseHandlingDetails>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetails = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetails';
  acceptableRetailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  delivery: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsDelivery>;
  pickup: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsPickup>;
  requiresAgeVerification: Maybe<Scalars['Boolean']>;
  retailerPosCorrelationIdentifier: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifier>;
  specialRequirements: Maybe<Array<Maybe<CustomersSpecialRequirement>>>;
  unacceptableRetailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetailsDelivery = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsDelivery';
  address: Maybe<CustomersGoogleTypePostalAddress>;
  addressId: Maybe<Scalars['BigInt']>;
  addressType: Maybe<CustomersAddressType>;
  customerManualLatLng: Maybe<CustomersGoogleTypeLatLng>;
  doorCode: Maybe<Scalars['String']>;
  dropoffLocation: Maybe<Scalars['String']>;
  instructions: Maybe<Scalars['String']>;
  latLng: Maybe<CustomersGoogleTypeLatLng>;
  notes: Maybe<Scalars['String']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetailsPickup = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsPickup';
  address: Maybe<CustomersGoogleTypePostalAddress>;
  addressId: Maybe<Scalars['BigInt']>;
  instructions: Maybe<Scalars['String']>;
  latLng: Maybe<CustomersGoogleTypeLatLng>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifier = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifier';
  referenceId: Maybe<Scalars['String']>;
  referenceType: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifierReferenceType>;
};

export enum CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifierReferenceType {
  Appcard = 'APPCARD',
  ReferenceTypeUnspecified = 'REFERENCE_TYPE_UNSPECIFIED'
}

export type CustomersGetOrderAmountsSummaryV0RequestInput = {
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersGetOrderAmountsSummaryV0Response = {
  __typename?: 'CustomersGetOrderAmountsSummaryV0Response';
  orderAmountsSummary: Maybe<CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary>;
  orderAmountsSummaryByOrderReference: Maybe<CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary>;
};

export type CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary = {
  __typename?: 'CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary';
  orderAmounts: Maybe<Array<Maybe<CustomersAmounts>>>;
};

export type CustomersGetOrderRequestInput = {
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersGetOrderResponse = {
  __typename?: 'CustomersGetOrderResponse';
  order: Maybe<CustomersOrder>;
  ordersByOrderReference: Maybe<CustomersOrder>;
};

export type CustomersGetPaymentMethodSummaryRequestInput = {
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersGetPaymentMethodSummaryResponse = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponse';
  paymentMethodSummariesByOrderReference: Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary>;
  paymentMethodSummary: Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary>;
};

export type CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary';
  paymentMethod: Maybe<Array<Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod>>>;
};

export type CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod';
  label: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type CustomersGoogleTypeDate = {
  __typename?: 'CustomersGoogleTypeDate';
  day: Maybe<Scalars['Int']>;
  month: Maybe<Scalars['Int']>;
  year: Maybe<Scalars['Int']>;
};

export type CustomersGoogleTypeLatLng = {
  __typename?: 'CustomersGoogleTypeLatLng';
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
};

export type CustomersGoogleTypeMoney = {
  __typename?: 'CustomersGoogleTypeMoney';
  currencyCode: Maybe<Scalars['String']>;
  nanos: Maybe<Scalars['Int']>;
  units: Maybe<Scalars['BigInt']>;
};

export type CustomersGoogleTypePostalAddress = {
  __typename?: 'CustomersGoogleTypePostalAddress';
  addressLines: Maybe<Array<Maybe<Scalars['String']>>>;
  administrativeArea: Maybe<Scalars['String']>;
  languageCode: Maybe<Scalars['String']>;
  locality: Maybe<Scalars['String']>;
  organization: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  recipients: Maybe<Array<Maybe<Scalars['String']>>>;
  regionCode: Maybe<Scalars['String']>;
  revision: Maybe<Scalars['Int']>;
  sortingCode: Maybe<Scalars['String']>;
  sublocality: Maybe<Scalars['String']>;
};

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalData = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalData';
  cartExternalData: Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalDataCartExternalData>;
  connectExternalData: Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalDataConnectExternalData>;
  embeddedPartnerIdentifiers: Maybe<Array<Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalDataEmbeddedPartnerIdentifier>>>;
  externalId: Maybe<Scalars['String']>;
};

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalDataCartExternalData = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalDataCartExternalData';
  _: Maybe<Scalars['Boolean']>;
};

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalDataConnectExternalData = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalDataConnectExternalData';
  appliedExpress: Maybe<Scalars['Boolean']>;
  barcodeIdentifier: Maybe<Scalars['String']>;
  paidWithEbtSnap: Maybe<Scalars['Boolean']>;
  retailerRequiredCertifiedDelivery: Maybe<Scalars['Boolean']>;
};

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalDataEmbeddedPartnerIdentifier = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalDataEmbeddedPartnerIdentifier';
  identifier: Maybe<Scalars['String']>;
  key: Maybe<Scalars['String']>;
};

export enum CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType {
  AffordableDelivery = 'AFFORDABLE_DELIVERY',
  Asap = 'ASAP',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  Eta = 'ETA',
  FiveHour = 'FIVE_HOUR',
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  HyperFast = 'HYPER_FAST',
  InstoreOrderAheadAsap = 'INSTORE_ORDER_AHEAD_ASAP',
  InstoreOrderAheadScheduled = 'INSTORE_ORDER_AHEAD_SCHEDULED',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  OneHour = 'ONE_HOUR',
  Pickup = 'PICKUP',
  PickupEta = 'PICKUP_ETA',
  PriorityEta = 'PRIORITY_ETA',
  RetailerInstore = 'RETAILER_INSTORE',
  RetailerManaged = 'RETAILER_MANAGED',
  ScanAndPay = 'SCAN_AND_PAY',
  Scheduled = 'SCHEDULED',
  ThreeHour = 'THREE_HOUR',
  TwoHour = 'TWO_HOUR',
  Ultrafast = 'ULTRAFAST',
  VirtualExpress = 'VIRTUAL_EXPRESS',
  VirtualRetailerMembership = 'VIRTUAL_RETAILER_MEMBERSHIP'
}

export type CustomersInstacartCustomersSharedV1RequestContextInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum CustomersInstacartCustomersSharedV1ServiceType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  Pickup = 'PICKUP',
  ScanAndPay = 'SCAN_AND_PAY',
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  Virtual = 'VIRTUAL'
}

export type CustomersInstacartInternalRequestContextInput = {
  instacartInternalAppId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersListOrdersRequestFilterSetDateRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type CustomersListOrdersRequestFilterSetInput = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  creationDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>;
  fulfillmentDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>;
  orderLifecycleDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersListOrdersRequestFilterSetOrderStatusCriteria>>>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceType?: InputMaybe<CustomersInstacartCustomersSharedV1ServiceType>;
};

export enum CustomersListOrdersRequestFilterSetOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  OrderStatusCriteriaUnspecified = 'ORDER_STATUS_CRITERIA_UNSPECIFIED'
}

export type CustomersListOrdersRequestInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  filters?: InputMaybe<CustomersListOrdersRequestFilterSetInput>;
  instacartInternalRequestContext?: InputMaybe<CustomersInstacartInternalRequestContextInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersListOrdersResponse = {
  __typename?: 'CustomersListOrdersResponse';
  orderSummaries: Maybe<Array<Maybe<CustomersListOrdersResponseOrderSummary>>>;
  orders: Maybe<Array<Maybe<CustomersOrder>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type CustomersListOrdersResponseOrderSummary = {
  __typename?: 'CustomersListOrdersResponseOrderSummary';
  creationDate: Maybe<Scalars['DateTime']>;
  externalId: Maybe<Scalars['String']>;
  fulfillmentDate: Maybe<Scalars['DateTime']>;
  fulfillmentType: Maybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>;
  id: Maybe<Scalars['BigInt']>;
  legacyOrderId: Maybe<Scalars['BigInt']>;
  orderReference: Maybe<Scalars['String']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  totalAmount: Maybe<CustomersGoogleTypeMoney>;
  userId: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<CustomersWorkflowState>;
};

export type CustomersOrder = {
  __typename?: 'CustomersOrder';
  businessId: Maybe<Scalars['BigInt']>;
  canceledAt: Maybe<Scalars['DateTime']>;
  certifiedDelivery: Maybe<Scalars['Boolean']>;
  checkoutRetailerLocationId: Maybe<Scalars['BigInt']>;
  clientConfigurationId: Maybe<Scalars['BigInt']>;
  closestRetailerLocationId: Maybe<Scalars['BigInt']>;
  communicationLocale: Maybe<Scalars['String']>;
  confirmedAt: Maybe<Scalars['DateTime']>;
  countryId: Maybe<Scalars['BigInt']>;
  creationClientIdentifier: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  customerOrderNumber: Maybe<Scalars['BigInt']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  deliveryStartedAt: Maybe<Scalars['DateTime']>;
  deliveryStatus: Maybe<CustomersOrderDeliveryStatus>;
  estimatedCustomerFulfillmentWindow: Maybe<CustomersOrderOrderFulfillmentWindow>;
  expressSubscriptionId: Maybe<Scalars['BigInt']>;
  externalData: Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalData>;
  finalizedAt: Maybe<Scalars['DateTime']>;
  fulfillmentOperationWindow: Maybe<CustomersOrderOrderFulfillmentWindow>;
  fulfillmentProviderId: Maybe<Scalars['BigInt']>;
  fulfillmentType: Maybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>;
  fulfillmentWindow: Maybe<CustomersOrderOrderFulfillmentWindow>;
  id: Maybe<Scalars['BigInt']>;
  legacyOrderId: Maybe<Scalars['BigInt']>;
  loyaltyNumber: Maybe<Scalars['String']>;
  orderAhead: Maybe<Scalars['Boolean']>;
  orderReference: Maybe<Scalars['String']>;
  plannedDeliveredAt: Maybe<Scalars['DateTime']>;
  plannedDeliveryStartedAt: Maybe<Scalars['DateTime']>;
  redelivery: Maybe<Scalars['Boolean']>;
  retailerExternalOrderId: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerOriginatedData: Maybe<CustomersOrderRetailerOriginatedData>;
  retailerReceiptBarcodeValue: Maybe<Scalars['String']>;
  retailerReferenceId: Maybe<Scalars['String']>;
  serviceOptionId: Maybe<Scalars['BigInt']>;
  serviceType: Maybe<CustomersInstacartCustomersSharedV1ServiceType>;
  shoppedRetailerLocationId: Maybe<Scalars['BigInt']>;
  shopperOriginatedData: Maybe<CustomersOrderShopperOriginatedData>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  subWorkflowState: Maybe<CustomersSubWorkflowState>;
  userBirthday: Maybe<CustomersGoogleTypeDate>;
  userId: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<CustomersWorkflowState>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export enum CustomersOrderDeliveryStatus {
  AcknowledgedByFulfillment = 'ACKNOWLEDGED_BY_FULFILLMENT',
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  DeliveryStatusUnspecified = 'DELIVERY_STATUS_UNSPECIFIED',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Received = 'RECEIVED',
  Shopping = 'SHOPPING',
  ShoppingComplete = 'SHOPPING_COMPLETE'
}

export type CustomersOrderOrderFulfillmentWindow = {
  __typename?: 'CustomersOrderOrderFulfillmentWindow';
  windowEnd: Maybe<Scalars['DateTime']>;
  windowStart: Maybe<Scalars['DateTime']>;
};

export type CustomersOrderRetailerOriginatedData = {
  __typename?: 'CustomersOrderRetailerOriginatedData';
  bagLabel: Maybe<Scalars['String']>;
  barcodeIdentifier: Maybe<Scalars['String']>;
};

export type CustomersOrderShopperOriginatedData = {
  __typename?: 'CustomersOrderShopperOriginatedData';
  customerBagCount: Maybe<Scalars['Int']>;
};

export enum CustomersOrdersSortByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  DirectionUnspecified = 'DIRECTION_UNSPECIFIED'
}

export type CustomersOrdersSortByInput = {
  direction?: InputMaybe<CustomersOrdersSortByDirection>;
  name?: InputMaybe<CustomersOrdersSortByOrdersAttributes>;
};

export enum CustomersOrdersSortByOrdersAttributes {
  OrdersAttributesUnspecified = 'ORDERS_ATTRIBUTES_UNSPECIFIED',
  OrderDeliveryId = 'ORDER_DELIVERY_ID',
  WindowEndsAt = 'WINDOW_ENDS_AT'
}

export type CustomersQueryOrderReferenceRequestInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersQueryOrderReferenceResponse = {
  __typename?: 'CustomersQueryOrderReferenceResponse';
  deliveryReference: Maybe<Scalars['String']>;
  orderReference: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestInput = {
  ordersSortBy?: InputMaybe<CustomersOrdersSortByInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  scenarioActivePickupOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActivePickupOrdersAtRetailerLocationInput>;
  scenarioActiveScanAndPayOrders?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveScanAndPayOrdersInput>;
  scenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocationInput>;
  scenarioActiveStoreManagerOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveStoreManagerOrdersAtRetailerLocationInput>;
  scenarioActiveUltrafastOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveUltrafastOrdersAtRetailerLocationInput>;
  scenarioCompletedScanAndPayOrders?: InputMaybe<CustomersQueryOrdersRequestScenarioCompletedScanAndPayOrdersInput>;
  scenarioCoordinatedOrderGroup?: InputMaybe<CustomersQueryOrdersRequestScenarioCoordinatedOrderGroupInput>;
  scenarioEnterpriseRppOrdersByCreationDate?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByCreationDateInput>;
  scenarioEnterpriseRppOrdersByFulfillmentDate?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByFulfillmentDateInput>;
  scenarioEnterpriseRppOrdersByOrderIdentifier?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByOrderIdentifierInput>;
  scenarioOrdersById?: InputMaybe<CustomersQueryOrdersRequestScenarioOrdersByIdInput>;
};

export type CustomersQueryOrdersRequestScenarioActivePickupOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioActiveScanAndPayOrdersInput = {
  createdAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
};

export type CustomersQueryOrdersRequestScenarioActiveStoreManagerOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
};

export type CustomersQueryOrdersRequestScenarioActiveUltrafastOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
};

export type CustomersQueryOrdersRequestScenarioCompletedScanAndPayOrdersInput = {
  createdAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioCoordinatedOrderGroupInput = {
  coordinatedOrderGroupId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByCreationDateInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  creationDateRange?: InputMaybe<CustomersTimestampRangeInput>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>;
  orderType?: InputMaybe<CustomersRppOrderType>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  useCheckoutRetailerLocationAsFallback?: InputMaybe<Scalars['Boolean']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByFulfillmentDateInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>;
  orderType?: InputMaybe<CustomersRppOrderType>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  useCheckoutRetailerLocationAsFallback?: InputMaybe<Scalars['Boolean']>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByOrderIdentifierInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  orderIdentifier?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersQueryOrdersRequestScenarioOrdersByIdInput = {
  orderDeliveryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersResponse = {
  __typename?: 'CustomersQueryOrdersResponse';
  orders: Maybe<Array<Maybe<CustomersOrder>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export enum CustomersRppOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  New = 'NEW',
  Processing = 'PROCESSING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  RppOrderStatusCriteriaUnspecified = 'RPP_ORDER_STATUS_CRITERIA_UNSPECIFIED',
  Shopping = 'SHOPPING'
}

export enum CustomersRppOrderType {
  Delivery = 'DELIVERY',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  Pickup = 'PICKUP',
  RppOrderTypeUnspecified = 'RPP_ORDER_TYPE_UNSPECIFIED'
}

export enum CustomersSpecialRequirement {
  AlcoholCompliant = 'ALCOHOL_COMPLIANT',
  AllowUnattendedTransition = 'ALLOW_UNATTENDED_TRANSITION',
  CertifiedDelivery = 'CERTIFIED_DELIVERY',
  CustomerFundingOptionDoesNotSupportTip = 'CUSTOMER_FUNDING_OPTION_DOES_NOT_SUPPORT_TIP',
  DisableShopperAdds = 'DISABLE_SHOPPER_ADDS',
  EbtRetailerLocationConstrained = 'EBT_RETAILER_LOCATION_CONSTRAINED',
  ExtraLongDistanceDelivery = 'EXTRA_LONG_DISTANCE_DELIVERY',
  FrozenItems = 'FROZEN_ITEMS',
  HempBasedCannabisCompliant = 'HEMP_BASED_CANNABIS_COMPLIANT',
  IncludesEbtPayment = 'INCLUDES_EBT_PAYMENT',
  MealItems = 'MEAL_ITEMS',
  OrderAhead = 'ORDER_AHEAD',
  OrderCreatedWithBigBulky = 'ORDER_CREATED_WITH_BIG_BULKY',
  RequiresShopperBgcProcess_1 = 'REQUIRES_SHOPPER_BGC_PROCESS_1',
  RestrictedOtcCompliant = 'RESTRICTED_OTC_COMPLIANT',
  RxCompliant = 'RX_COMPLIANT',
  RxOnlyCompliant = 'RX_ONLY_COMPLIANT',
  SecondStoreCheck = 'SECOND_STORE_CHECK',
  SpecialRequirementUnspecified = 'SPECIAL_REQUIREMENT_UNSPECIFIED',
  UnattendedDelivery = 'UNATTENDED_DELIVERY'
}

export enum CustomersSubWorkflowState {
  BrandNewProcessingFinalAcceptance = 'BRAND_NEW_PROCESSING_FINAL_ACCEPTANCE',
  BrandNewReadyForFulfillment = 'BRAND_NEW_READY_FOR_FULFILLMENT',
  PickingEarly = 'PICKING_EARLY',
  PickingFinal = 'PICKING_FINAL',
  PickingPause = 'PICKING_PAUSE',
  PickingStandardBasket = 'PICKING_STANDARD_BASKET',
  PickingStandardBasketDoneAwaitingTopUp = 'PICKING_STANDARD_BASKET_DONE_AWAITING_TOP_UP',
  PickingTopUpBasket = 'PICKING_TOP_UP_BASKET',
  StagedConfirmedHandoffToPartnerForDelivery = 'STAGED_CONFIRMED_HANDOFF_TO_PARTNER_FOR_DELIVERY',
  SubWorkflowStateNone = 'SUB_WORKFLOW_STATE_NONE',
  SubWorkflowStateUnspecified = 'SUB_WORKFLOW_STATE_UNSPECIFIED'
}

export type CustomersTimestampRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export enum CustomersWorkflowState {
  Acknowledged = 'ACKNOWLEDGED',
  AcknowledgedForDelivery = 'ACKNOWLEDGED_FOR_DELIVERY',
  AcknowledgedForRunning = 'ACKNOWLEDGED_FOR_RUNNING',
  AtStore = 'AT_STORE',
  BagsCheck = 'BAGS_CHECK',
  BagsVerified = 'BAGS_VERIFIED',
  BrandNew = 'BRAND_NEW',
  Canceled = 'CANCELED',
  Checkout = 'CHECKOUT',
  CustomerSamples = 'CUSTOMER_SAMPLES',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  Notified = 'NOTIFIED',
  PendingIdentityVerification = 'PENDING_IDENTITY_VERIFICATION',
  PendingReschedule = 'PENDING_RESCHEDULE',
  Picking = 'PICKING',
  ReceiptSanityCheck = 'RECEIPT_SANITY_CHECK',
  Returning = 'RETURNING',
  RunnerAwaiting = 'RUNNER_AWAITING',
  RunnerNotFound = 'RUNNER_NOT_FOUND',
  RxCheckout = 'RX_CHECKOUT',
  RxPicking = 'RX_PICKING',
  Staged = 'STAGED',
  StagedForCbt = 'STAGED_FOR_CBT',
  StagedForDelivery = 'STAGED_FOR_DELIVERY',
  StagingForCbt = 'STAGING_FOR_CBT',
  VerifyingReplacements = 'VERIFYING_REPLACEMENTS',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
  WorkflowStateUnspecified = 'WORKFLOW_STATE_UNSPECIFIED'
}

export type DataDescriptionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  description: Scalars['String'];
  key: Scalars['String'];
};

export type DataEntryItem = {
  __typename?: 'DataEntryItem';
  deiId: Maybe<Scalars['String']>;
};

export type DataQuery = {
  __typename?: 'DataQuery';
  resourceDataQuery: Maybe<ResourceDataQuery>;
};

export type DataQueryInput = {
  resourceDataQuery?: InputMaybe<ResourceDataQueryInput>;
};

/** Attributes for a date range filter */
export type DateRange = {
  /** End date of date range */
  endDate: Scalars['ISO8601Date'];
  /** Start date of date range */
  startDate: Scalars['ISO8601Date'];
};

export type DateRangeInput = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type DayOfWeekInput = {
  /** list of days within the week */
  days: Array<Scalars['String']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of DayOfWeekVisibilityConditionCreate */
export type DayOfWeekVisibilityConditionCreatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionCreatePayload';
  /** The newly created express_membership visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek;
};

/** Autogenerated return type of DayOfWeekVisibilityConditionUpdate */
export type DayOfWeekVisibilityConditionUpdatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionUpdatePayload';
  /** The newly created shopped_at_retailer visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek;
};

export type DeactivatePriceAnomalyPatchRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  investigationId?: InputMaybe<Scalars['String']>;
};

export type DeactivatePriceAnomalyPatchResponse = {
  __typename?: 'DeactivatePriceAnomalyPatchResponse';
  patchStatus: Maybe<PatchStatus>;
};

export type DeleteApiSettingRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteApiSettingResponse = {
  __typename?: 'DeleteApiSettingResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type DeleteConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'DeleteConnectRetailerCallbackConfigurationResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type DeleteContentPageRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteContentPageResponse = {
  __typename?: 'DeleteContentPageResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DeleteContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteContentPageVersionResponse = {
  __typename?: 'DeleteContentPageVersionResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DeleteImageRequestInput = {
  imageId?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteImageResponse = {
  __typename?: 'DeleteImageResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DeleteLaunchOnboardingWarehouseLocationRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLaunchOnboardingWarehouseLocationResponse = {
  __typename?: 'DeleteLaunchOnboardingWarehouseLocationResponse';
  launchOnboarding: Maybe<LaunchOnboarding>;
  message: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type DeleteLayoutVariantRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLayoutVariantResponse = {
  __typename?: 'DeleteLayoutVariantResponse';
  response: Maybe<Scalars['Boolean']>;
};

export type DeleteLinkAutosuggestionAdminParametersInput = {
  linkId?: InputMaybe<Scalars['BigInt']>;
  linkName?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLinkAutosuggestionAdminRequestInput = {
  parameters?: InputMaybe<DeleteLinkAutosuggestionAdminParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLinkAutosuggestionAdminResponse = {
  __typename?: 'DeleteLinkAutosuggestionAdminResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type DeleteNativeTabBarNavigationRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteNativeTabBarNavigationResponse = {
  __typename?: 'DeleteNativeTabBarNavigationResponse';
  response: Maybe<Scalars['Boolean']>;
};

export type DeleteNavigationRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteNavigationResponse = {
  __typename?: 'DeleteNavigationResponse';
  response: Maybe<Scalars['Boolean']>;
};

export type DeletePartnerOauthApplicationRequestInput = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeletePartnerOauthApplicationResponse = {
  __typename?: 'DeletePartnerOauthApplicationResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type DeletePlacementRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeletePlacementResponse = {
  __typename?: 'DeletePlacementResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DeleteSlotCreativeRequestInput = {
  creativeId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteSlotCreativeResponse = {
  __typename?: 'DeleteSlotCreativeResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DeleteSlotRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteSlotResponse = {
  __typename?: 'DeleteSlotResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DeleteWhitelabelSiteCustomizableStringRequestInput = {
  whitelabelSiteCustomizableStringId?: InputMaybe<Scalars['Int']>;
};

export type DeleteWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'DeleteWhitelabelSiteCustomizableStringResponse';
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type DemeterResponseStatus = {
  __typename?: 'DemeterResponseStatus';
  statusCode: Maybe<Scalars['BigInt']>;
  statusMessage: Maybe<Scalars['String']>;
};

export type DepartmentOosCount = {
  __typename?: 'DepartmentOosCount';
  department: Maybe<Scalars['String']>;
  oosCount: Maybe<Scalars['Int']>;
};

export type DepartmentsPlaceholderNavigation = {
  __typename?: 'DepartmentsPlaceholderNavigation';
  id: Maybe<Scalars['BigInt']>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
};

export type DepartmentsPlaceholderNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type DesktopFlexibleHeaderLayoutV1Navigations = {
  __typename?: 'DesktopFlexibleHeaderLayoutV1Navigations';
  bar1: Maybe<BarNav>;
  bar2: Maybe<BarNav>;
};

export type DesktopFlexibleHeaderLayoutV1NavigationsInput = {
  bar1?: InputMaybe<BarNavInput>;
  bar2?: InputMaybe<BarNavInput>;
};

export type DesktopSidebarLayoutV1Navigations = {
  __typename?: 'DesktopSidebarLayoutV1Navigations';
  navs: Maybe<Array<Maybe<NavigationWithSubNavigation>>>;
};

export type DesktopSidebarLayoutV1NavigationsInput = {
  navs?: InputMaybe<Array<InputMaybe<NavigationWithSubNavigationInput>>>;
};

export enum DestinationBucket {
  Assets = 'ASSETS',
  StoreConfiguration = 'STORE_CONFIGURATION',
  UnkownDestinationBucket = 'UNKOWN_DESTINATION_BUCKET'
}

export enum DetectionStatusState {
  DetectionStatusStateAdminAudit = 'DETECTION_STATUS_STATE_ADMIN_AUDIT',
  DetectionStatusStateApproved = 'DETECTION_STATUS_STATE_APPROVED',
  DetectionStatusStateRejected = 'DETECTION_STATUS_STATE_REJECTED',
  DetectionStatusStateRunningAutomatedTests = 'DETECTION_STATUS_STATE_RUNNING_AUTOMATED_TESTS',
  DetectionStatusStateUnknown = 'DETECTION_STATUS_STATE_UNKNOWN'
}

export type DetectionVersionAttributes = {
  __typename?: 'DetectionVersionAttributes';
  cadence: Maybe<Scalars['String']>;
  createdBy: Maybe<Scalars['String']>;
  createdWhy: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  fixDefectTag: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['BigInt']>;
  owner: Maybe<Scalars['String']>;
  query: Maybe<Scalars['String']>;
};

export type DetectionVersionAttributesInput = {
  cadence?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdWhy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fixDefectTag?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  owner?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type DetectionVersionState = {
  __typename?: 'DetectionVersionState';
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  metadata: Maybe<Scalars['String']>;
  state: Maybe<DetectionStatusState>;
};

export type DetectionVersionStats = {
  __typename?: 'DetectionVersionStats';
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  metadata: Maybe<Scalars['String']>;
  stats: Maybe<Scalars['String']>;
};

export enum DeviceTypeEnum {
  /** Phone plan */
  Phone = 'phone',
  /** Wi-Fi */
  Wifi = 'wifi'
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type DisablePartnerOauthApplicationRequestInput = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type DisablePartnerOauthApplicationResponse = {
  __typename?: 'DisablePartnerOauthApplicationResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type DisablePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DisablePlacementContentResponse = {
  __typename?: 'DisablePlacementContentResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DisableThemePageRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DisableThemePageResponse = {
  __typename?: 'DisableThemePageResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type DiscountDiscountablesData = {
  __typename?: 'DiscountDiscountablesData';
  appliedAmount: Maybe<GoogleTypeMoney>;
  discountableId: Maybe<Scalars['BigInt']>;
  discountableType: Maybe<DiscountDiscountablesDataDiscountableType>;
  id: Maybe<Scalars['BigInt']>;
  offerId: Maybe<Scalars['BigInt']>;
  offerInstanceId: Maybe<Scalars['BigInt']>;
  orderId: Maybe<Scalars['BigInt']>;
};

export enum DiscountDiscountablesDataDiscountableType {
  BasketLevelOffer = 'BASKET_LEVEL_OFFER',
  CustomerFeeOffer = 'CUSTOMER_FEE_OFFER',
  DiscountableTypeUnspecified = 'DISCOUNTABLE_TYPE_UNSPECIFIED',
  ItemLevelOffer = 'ITEM_LEVEL_OFFER'
}

export enum Discoverability {
  AdminOnly = 'ADMIN_ONLY',
  Browse = 'BROWSE',
  CouponCode = 'COUPON_CODE',
  Crm = 'CRM',
  DirectLink = 'DIRECT_LINK',
  DiscoverabilityUnknown = 'DISCOVERABILITY_UNKNOWN',
  EventBasedCrm = 'EVENT_BASED_CRM',
  Offline = 'OFFLINE',
  OfflineMl = 'OFFLINE_ML',
  OnlineEvent = 'ONLINE_EVENT',
  PartnerInitiated = 'PARTNER_INITIATED',
  TsDirectLink = 'TS_DIRECT_LINK'
}

export type DismissBusinessIdentication = {
  __typename?: 'DismissBusinessIdentication';
  id: Maybe<Scalars['BigInt']>;
  source: Maybe<BusinessDerivedAttributesSourceType>;
};

export type DismissBusinessIdenticationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<BusinessDerivedAttributesSourceType>;
};

export type DoNotNavigate = {
  __typename?: 'DoNotNavigate';
  recordClickAttempt: Maybe<Scalars['Boolean']>;
};

export type DoNotNavigateInput = {
  recordClickAttempt?: InputMaybe<Scalars['Boolean']>;
};

export type DomainConfiguration = {
  __typename?: 'DomainConfiguration';
  ads: Maybe<AdsSchema>;
  branding: Maybe<BrandingSchema>;
  business: Maybe<BusinessSchema>;
  catalog: Maybe<CatalogSchema>;
  checkout: Maybe<CheckoutSchema>;
  icplus: Maybe<IcPlusSchema>;
  idsTheme: Maybe<IdsThemeSchema>;
  inStore: Maybe<InStoreSchema>;
  landing: Maybe<LandingSchema>;
  loyalty: Maybe<LoyaltySchema>;
  offers: Maybe<OffersSchema>;
  orders: Maybe<OrdersSchema>;
  payments: Maybe<PaymentsSchema>;
  pricing: Maybe<PricingSchema>;
  storefront: Maybe<StorefrontSchema>;
  theme: Maybe<ThemeSchema>;
  users: Maybe<UsersSchema>;
};

export type DownloadCatalogSearchResultsRequestInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  costUnitType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  creationDate?: InputMaybe<DateRangeInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  isParWeighted?: InputMaybe<Scalars['Boolean']>;
  itemFilename?: InputMaybe<Scalars['String']>;
  itemsOnPromoDateRange?: InputMaybe<DateRangeInput>;
  itemsOnSaleDateRange?: InputMaybe<DateRangeInput>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  loyaltyPricing?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  primaryImageUrl?: InputMaybe<Scalars['Boolean']>;
  productAvailability?: InputMaybe<Scalars['Boolean']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productFilename?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  query?: InputMaybe<Scalars['String']>;
  requestItemData?: InputMaybe<Scalars['Boolean']>;
  requestProductData?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  snapEbtEligible?: InputMaybe<Scalars['Boolean']>;
  storeBrandProduct?: InputMaybe<Scalars['Boolean']>;
};

export type DownloadCatalogSearchResultsResponse = {
  __typename?: 'DownloadCatalogSearchResultsResponse';
  filename: Maybe<Scalars['String']>;
};

export type DuplicateContentPageRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DuplicateContentPageResponse = {
  __typename?: 'DuplicateContentPageResponse';
  contentPage: Maybe<ContentPageV2>;
};

export type EbpAnalyticsRequestInput = {
  dateRange?: InputMaybe<InstacartAdsSharedV1DateRangeInput>;
  entity?: InputMaybe<Entity>;
  entityId?: InputMaybe<EntityIdInput>;
  metric?: InputMaybe<Metric>;
};

export type EbpAnalyticsResponse = {
  __typename?: 'EbpAnalyticsResponse';
  analytics: Maybe<Analytics>;
};

export type EnablePartnerOauthApplicationRequestInput = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type EnablePartnerOauthApplicationResponse = {
  __typename?: 'EnablePartnerOauthApplicationResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type EnterpriseAcceptedPartnerAgreement = {
  __typename?: 'EnterpriseAcceptedPartnerAgreement';
  /** The type of agreement accepted */
  agreementType: AgreementTypeEnum;
  createdAt: Scalars['Time'];
  /** The ID of the partner */
  partnerId: Scalars['ID'];
};

export type EnterpriseAccount = {
  __typename?: 'EnterpriseAccount';
  /** The terms accepted by the account */
  acceptedPartnerAgreements: Maybe<Array<EnterpriseAcceptedPartnerAgreement>>;
  /** Whether or not the user is fully set up */
  accountStateValid: Maybe<Scalars['Boolean']>;
  /** The IDs of the partners assigned to the account */
  assignedPartnerIds: Array<Scalars['ID']>;
  /** The IDs of the retailers assigned to the account */
  assignedRetailerIds: Array<Scalars['ID']>;
  /** The IDs of the retailer locations assigned to the account */
  assignedRetailerLocationIds: Array<Scalars['ID']>;
  /** Whether account must use SSO/auth service for authentication */
  authServiceRequired: Scalars['Boolean'];
  /** The user data from the auth service */
  authUserData: Maybe<AuthUserData>;
  /** The associated authentication */
  authentication: Maybe<AuthenticationInterface>;
  /** Whether the current user can impersonate the account */
  canImpersonate: Scalars['Boolean'];
  /** Whether account can be activated/reactivated by the current user */
  canSetDisabled: Scalars['Boolean'];
  /** Whether the current user can update partner write access for other users */
  canUpdatePartnerWriteAccess: Maybe<Scalars['Boolean']>;
  /** The external unique identifier for the enterprise account */
  canonicalId: Scalars['ID'];
  /** When the account was created */
  createdAt: Scalars['Time'];
  /** The direct permissions associated with this account */
  directlyAssignedPermissions: Array<EnterprisePermission>;
  /** Whether account is active */
  disabled: Scalars['Boolean'];
  /** The roles that the current user cannot assign that the target account has */
  editUnassignableRoles: Maybe<Array<EnterpriseRole>>;
  /** The email associated with the account */
  email: Maybe<Scalars['String']>;
  /** The feature experiments associated with the account */
  featureExperiments: Array<FeatureExperiment>;
  /** The feature toggles associated with the account */
  featureToggles: Array<FeatureToggle>;
  /** Given name of user */
  givenName: Maybe<Scalars['String']>;
  /** Whether the account has all partners write access */
  hasAllPartnersWriteAccess: Maybe<Scalars['Boolean']>;
  /** The hidden settings for the user account */
  hiddenSettings: Maybe<EnterpriseAccountSettingsHiddenSettings>;
  /** The internal unique identifier for the enterprise account */
  id: Scalars['ID'];
  /** The reason why the current user cannot impersonate the account */
  impersonateFailureReason: Maybe<Scalars['String']>;
  /** The permissions slugs that the current user is missing to impersonate the account */
  impersonateMissingPermissionsSlugs: Maybe<Array<Scalars['String']>>;
  /** The associated internal access configuration for the account */
  internalAccessConfiguration: EnterpriseInternalAccessConfiguration;
  /** Whether account is editable by the current user */
  isEditable: Scalars['Boolean'];
  /** Whether the current user is impersonating the account */
  isImpersonating: Scalars['Boolean'];
  /** Whether account is an internal account */
  isInternal: Scalars['Boolean'];
  /** When MFA was disabled for the account */
  mfaDeactivatedAt: Maybe<Scalars['Time']>;
  /** Whether account has MFA enabled */
  mfaEnabled: Scalars['Boolean'];
  /** When MFA was enabled for the account */
  mfaEnabledAt: Maybe<Scalars['Time']>;
  /** The partner write access assigned to the account */
  partnerWriteAccess: Maybe<Array<EnterprisePartnerWriteAccess>>;
  /** The permissions associated with this account */
  permissions: Array<EnterprisePermission>;
  /** Phone number for the user */
  phone: Maybe<Scalars['String']>;
  /** The policies associated with the account */
  policies: AccessControlPolicies;
  /** The reason why the account cannot be edited by the current user */
  preventEditReason: Maybe<Scalars['String']>;
  /** The permissions associated with this account via roles */
  roleAssignedPermissions: Array<EnterprisePermission>;
  /** The roles associated with this account */
  roles: Array<EnterpriseRole>;
  /** Surname of user */
  surname: Maybe<Scalars['String']>;
  /** The title of the user */
  title: Maybe<Scalars['String']>;
  /** The user locale for the user account */
  userLocale: Maybe<Scalars['String']>;
};

/** Autogenerated return type of EnterpriseAccountAcceptPartnerAgreement */
export type EnterpriseAccountAcceptPartnerAgreementPayload = {
  __typename?: 'EnterpriseAccountAcceptPartnerAgreementPayload';
  acceptedPartnerAgreement: EnterpriseAcceptedPartnerAgreement;
};

/** Autogenerated return type of EnterpriseAccountAccountSetup */
export type EnterpriseAccountAccountSetupPayload = {
  __typename?: 'EnterpriseAccountAccountSetupPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

/** Autogenerated return type of EnterpriseAccountAuthenticateEmailPassword */
export type EnterpriseAccountAuthenticateEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountAuthenticateEmailPasswordPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

/** Autogenerated return type of EnterpriseAccountAuthenticatePreflight */
export type EnterpriseAccountAuthenticatePreflightPayload = {
  __typename?: 'EnterpriseAccountAuthenticatePreflightPayload';
  canRequestAccount: Scalars['Boolean'];
  useAuthService: Scalars['Boolean'];
};

/** The connection type for EnterpriseAccount. */
export type EnterpriseAccountConnection = {
  __typename?: 'EnterpriseAccountConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EnterpriseAccountEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EnterpriseAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated return type of EnterpriseAccountCreateNoPartnerAccess */
export type EnterpriseAccountCreateNoPartnerAccessPayload = {
  __typename?: 'EnterpriseAccountCreateNoPartnerAccessPayload';
  /** The newly created account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountCreate */
export type EnterpriseAccountCreatePayload = {
  __typename?: 'EnterpriseAccountCreatePayload';
  /** The newly created account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountDisableImpersonation */
export type EnterpriseAccountDisableImpersonationPayload = {
  __typename?: 'EnterpriseAccountDisableImpersonationPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** An edge in a connection. */
export type EnterpriseAccountEdge = {
  __typename?: 'EnterpriseAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<EnterpriseAccount>;
};

/** Autogenerated return type of EnterpriseAccountEnableImpersonation */
export type EnterpriseAccountEnableImpersonationPayload = {
  __typename?: 'EnterpriseAccountEnableImpersonationPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountMfaDeactivate */
export type EnterpriseAccountMfaDeactivatePayload = {
  __typename?: 'EnterpriseAccountMfaDeactivatePayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountMfaEnable */
export type EnterpriseAccountMfaEnablePayload = {
  __typename?: 'EnterpriseAccountMfaEnablePayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountMfaReset */
export type EnterpriseAccountMfaResetPayload = {
  __typename?: 'EnterpriseAccountMfaResetPayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountPartnerOnboardingRequestAccountSetupEmail */
export type EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountRequestAccountSetupEmail */
export type EnterpriseAccountRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountRequestAccountSetupEmailPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountRequestBreakGlassPartnerWriteAccess */
export type EnterpriseAccountRequestBreakGlassPartnerWriteAccessPayload = {
  __typename?: 'EnterpriseAccountRequestBreakGlassPartnerWriteAccessPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountRequestEmailVerification */
export type EnterpriseAccountRequestEmailVerificationPayload = {
  __typename?: 'EnterpriseAccountRequestEmailVerificationPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountResetPassword */
export type EnterpriseAccountResetPasswordPayload = {
  __typename?: 'EnterpriseAccountResetPasswordPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

/** Autogenerated return type of EnterpriseAccountSetDisabled */
export type EnterpriseAccountSetDisabledPayload = {
  __typename?: 'EnterpriseAccountSetDisabledPayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
};

export type EnterpriseAccountSettingsHiddenSettings = {
  __typename?: 'EnterpriseAccountSettingsHiddenSettings';
  /** Last seen RSAT pulse survey data */
  rsatPulseSurvey: Maybe<EnterpriseAccountSettingsRsatPulseSurvey>;
};

export type EnterpriseAccountSettingsRsatPulseSurvey = {
  __typename?: 'EnterpriseAccountSettingsRsatPulseSurvey';
  /** Whether the user has submitted the survey */
  hasSubmitted: Scalars['Boolean'];
  /** The UTC time when the survey was last seen */
  lastSeenTime: Scalars['Time'];
  /** The number of times the survey has been seen */
  seenCount: Scalars['Int'];
  /** The unique slug identifier for the survey */
  slug: RsatPulseSurveySlugEnum;
};

/** Autogenerated return type of EnterpriseAccountUpdateHiddenSettings */
export type EnterpriseAccountUpdateHiddenSettingsPayload = {
  __typename?: 'EnterpriseAccountUpdateHiddenSettingsPayload';
  /** Whether the hidden settings were updated */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnterpriseAccountUpdatePassword */
export type EnterpriseAccountUpdatePasswordPayload = {
  __typename?: 'EnterpriseAccountUpdatePasswordPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountUpdate */
export type EnterpriseAccountUpdatePayload = {
  __typename?: 'EnterpriseAccountUpdatePayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountUpdateRoles */
export type EnterpriseAccountUpdateRolesPayload = {
  __typename?: 'EnterpriseAccountUpdateRolesPayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountUpdateUserLocale */
export type EnterpriseAccountUpdateUserLocalePayload = {
  __typename?: 'EnterpriseAccountUpdateUserLocalePayload';
  /** Whether the user locale was updated */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnterpriseAccountVerifyAccountSetupToken */
export type EnterpriseAccountVerifyAccountSetupTokenPayload = {
  __typename?: 'EnterpriseAccountVerifyAccountSetupTokenPayload';
  /** Email of the verified account */
  email: Scalars['String'];
  /** List of partners with partner id and name */
  partners: Array<Partner>;
};

/** Autogenerated return type of EnterpriseAccountVerifyEmail */
export type EnterpriseAccountVerifyEmailPayload = {
  __typename?: 'EnterpriseAccountVerifyEmailPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

export type EnterpriseAuthenticationEmailPassword = AuthenticationInterface & {
  __typename?: 'EnterpriseAuthenticationEmailPassword';
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID'];
  /** Whether or not the email has been verified */
  emailVerified: Scalars['Boolean'];
  /** Whether or not the password has been set */
  passwordSet: Scalars['Boolean'];
};

export type EnterpriseInternalAccessConfiguration = {
  __typename?: 'EnterpriseInternalAccessConfiguration';
  /** The associated assigned partners */
  assignedPartners: Array<Partner>;
  /** The associated assigned retailer locations */
  assignedRetailerLocations: Array<RetailerLocation>;
  /** The associated assigned retailers */
  assignedRetailers: Array<Retailer>;
  /** Whether access is granted for every partner, retailer and location */
  hasAllPartnersFullAccess: Scalars['Boolean'];
  /** Whether access is granted for every retailer and location for partners assigned */
  hasFullPartnerAccess: Scalars['Boolean'];
  /** Whether access is granted for every location for retailers assigned */
  hasFullRetailerAccess: Scalars['Boolean'];
  /** Whether access is not granted to any partner, retailer or location */
  hasNothingAccessible: Scalars['Boolean'];
};

/** An individual partner write access record for an account */
export type EnterprisePartnerWriteAccess = {
  __typename?: 'EnterprisePartnerWriteAccess';
  /** The ID of the account that has this entity access */
  accountId: Scalars['ID'];
  /** Whether this access applies to all entities of the given type */
  allEntitiesAccess: Maybe<Scalars['Boolean']>;
  /** The action on the entity */
  entityAction: EntityActionEnum;
  /** The ID of the specific entity (null if all_entities_access is true) */
  entityId: Maybe<Scalars['String']>;
  /** The type of entity */
  entityType: EntityTypeEnum;
  /** The time at which the access expires */
  expiresAt: Maybe<Scalars['Time']>;
  /** The internal unique identifier for the account entity access */
  id: Scalars['ID'];
  /** The partner this access applies to */
  partner: Maybe<Partner>;
  /** The partner ID (alias for entity_id) */
  partnerId: Maybe<Scalars['String']>;
};

export type EnterprisePermission = {
  __typename?: 'EnterprisePermission';
  /** A description of the permission */
  description: Maybe<Scalars['String']>;
  /** Indicates if the Permission can be used to assign to a Retailer role */
  isRetailerRoleAssignable: Scalars['Boolean'];
  /** A unique identifier for the permission */
  slug: Scalars['ID'];
};

export type EnterpriseRole = {
  __typename?: 'EnterpriseRole';
  /** The number of accounts currently attached to the role */
  attachedAccounts: Maybe<Scalars['Int']>;
  /** Localized description of the role */
  description: Maybe<Scalars['String']>;
  /** The role ID */
  id: Scalars['ID'];
  /** Whether this role can only be assigned to internal IC employees */
  internalOnly: Scalars['Boolean'];
  /** Localized name of the role */
  name: Scalars['String'];
  partnerId: Maybe<Scalars['ID']>;
  /** The permissions associated with this role */
  permissions: Array<EnterprisePermission>;
  retailerId: Maybe<Scalars['ID']>;
  /** A unique identifier for the role */
  slug: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type EnterpriseUserAccessSettings = {
  __typename?: 'EnterpriseUserAccessSettings';
  /** Whether the user has write access to all partners */
  hasAllPartnersWriteAccess: Scalars['Boolean'];
  /** The IDs of the partners assigned to the account */
  partnerIds: Array<Scalars['ID']>;
  /** The IDs of the partners the user has write access to */
  partnerWriteAccessIds: Array<Scalars['ID']>;
  /** The IDs of the retailers assigned to the account */
  retailerIds: Array<Scalars['ID']>;
  /** The roles assigned to the account */
  roles: Array<EnterpriseRole>;
};

export type EnterpriseWelcomeModal = {
  __typename?: 'EnterpriseWelcomeModal';
  /** slug identifying type of welcome modal to be shown. */
  slug: Scalars['String'];
};

export enum Entity {
  Product = 'PRODUCT',
  SellSheet = 'SELL_SHEET'
}

/** The supported actions for account entity access, e.g write */
export enum EntityActionEnum {
  /** write access to the entity */
  Write = 'WRITE'
}

export type EntityId = {
  __typename?: 'EntityId';
  cashflowAuditItem: Maybe<CashflowAuditItem>;
  dataEntryItem: Maybe<DataEntryItem>;
  itemId: Maybe<ItemId>;
  localeProduct: Maybe<LocaleProduct>;
  localeRetailerProduct: Maybe<LocaleRetailerProduct>;
  outsourceDataEntryItem: Maybe<OutsourceDataEntryItem>;
  productId: Maybe<ProductId>;
  qasTaskItem: Maybe<QasTaskItem>;
  recipeEntryItem: Maybe<RecipeEntryItem>;
  retailerProductId: Maybe<RetailerProductId>;
  upc: Maybe<Upc>;
};

export type EntityIdInput = {
  int64Id?: InputMaybe<Scalars['BigInt']>;
  itemId?: InputMaybe<ItemIdInput>;
  productId?: InputMaybe<ProductIdInput>;
  retailerProductId?: InputMaybe<RetailerProductIdInput>;
  stringId?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<UpcInput>;
};

export enum EntityStatus {
  EntityStatusCancelled = 'ENTITY_STATUS_CANCELLED',
  EntityStatusCompleted = 'ENTITY_STATUS_COMPLETED',
  EntityStatusDeduplicated = 'ENTITY_STATUS_DEDUPLICATED',
  EntityStatusEntityNotFound = 'ENTITY_STATUS_ENTITY_NOT_FOUND',
  EntityStatusFailed = 'ENTITY_STATUS_FAILED',
  EntityStatusFailedUncaught = 'ENTITY_STATUS_FAILED_UNCAUGHT',
  EntityStatusInProgress = 'ENTITY_STATUS_IN_PROGRESS',
  EntityStatusNonNormalizedUpc = 'ENTITY_STATUS_NON_NORMALIZED_UPC',
  EntityStatusStarted = 'ENTITY_STATUS_STARTED',
  EntityStatusSubmittedToFixService = 'ENTITY_STATUS_SUBMITTED_TO_FIX_SERVICE',
  EntityStatusUnknown = 'ENTITY_STATUS_UNKNOWN',
  EntityStatusUnknownError = 'ENTITY_STATUS_UNKNOWN_ERROR',
  EntityStatusUpcCollision = 'ENTITY_STATUS_UPC_COLLISION',
  EntityStatusWarning = 'ENTITY_STATUS_WARNING',
  EntityStatusWontDo = 'ENTITY_STATUS_WONT_DO'
}

export enum EntityType {
  EntityTypeItemIds = 'ENTITY_TYPE_ITEM_IDS',
  EntityTypeProductIds = 'ENTITY_TYPE_PRODUCT_IDS',
  EntityTypeRetailerProductIds = 'ENTITY_TYPE_RETAILER_PRODUCT_IDS',
  EntityTypeUnknown = 'ENTITY_TYPE_UNKNOWN',
  EntityTypeUpcs = 'ENTITY_TYPE_UPCS'
}

/** The supported types for account entity access, e.g partner */
export enum EntityTypeEnum {
  /** partner entity access */
  Partner = 'PARTNER'
}

export enum ErrorReason {
  DraftErrorConflict = 'DRAFT_ERROR_CONFLICT',
  DraftErrorNotFound = 'DRAFT_ERROR_NOT_FOUND',
  DraftErrorUnexpectedState = 'DRAFT_ERROR_UNEXPECTED_STATE',
  ErrorEnumUnknown = 'ERROR_ENUM_UNKNOWN',
  ErrorReasonBadRequest = 'ERROR_REASON_BAD_REQUEST',
  ErrorReasonModificationNotPermitted = 'ERROR_REASON_MODIFICATION_NOT_PERMITTED',
  ErrorReasonUnknown = 'ERROR_REASON_UNKNOWN'
}

export enum ExperimentMethod {
  Assign = 'ASSIGN',
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  Lookup = 'LOOKUP',
  Preview = 'PREVIEW'
}

export type ExperimentVariantInput = {
  /** The method of the experiment */
  experimentMethod: PlacementExperimentMethodEnum;
  /** The name of the experiment */
  experimentName: Scalars['String'];
  /** The name of the experiment variant */
  experimentVariant: Scalars['String'];
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of ExperimentVariantVisibilityConditionCreate */
export type ExperimentVariantVisibilityConditionCreatePayload = {
  __typename?: 'ExperimentVariantVisibilityConditionCreatePayload';
  /** The newly created ExperimentVariant visibility condition */
  experimentVariantVisibilityCondition: ContentManagementVisibilityConditionExperimentVariant;
};

/** Autogenerated return type of ExperimentVariantVisibilityConditionUpdate */
export type ExperimentVariantVisibilityConditionUpdatePayload = {
  __typename?: 'ExperimentVariantVisibilityConditionUpdatePayload';
  /** The newly updated ExperimentVariant visibility condition */
  experimentVariantVisibilityCondition: ContentManagementVisibilityConditionExperimentVariant;
};

export type ExpressMembershipInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ExpressMembershipVisibilityConditionCreate */
export type ExpressMembershipVisibilityConditionCreatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionCreatePayload';
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership;
};

/** Autogenerated return type of ExpressMembershipVisibilityConditionUpdate */
export type ExpressMembershipVisibilityConditionUpdatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionUpdatePayload';
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership;
};

export type ExpressNonmemberLongTermHoldoutInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ExpressNonmemberLongTermHoldoutVisibilityConditionCreate */
export type ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload = {
  __typename?: 'ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload';
  /** The newly created ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityCondition: ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout;
};

export type ExternalHealthDashboard_Error = {
  __typename?: 'ExternalHealthDashboard_Error';
  error: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export enum ExternalHealthDashboard_HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type ExternalHealthDashboard_HealthCheck = {
  __typename?: 'ExternalHealthDashboard_HealthCheck';
  HttpCode: Maybe<Scalars['String']>;
};

export type ExternalHealthDashboard_MonitorStatus = {
  __typename?: 'ExternalHealthDashboard_MonitorStatus';
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Float']>;
  lastUpdated: Maybe<Scalars['DateTime']>;
  name: Maybe<Scalars['String']>;
  status: Maybe<ExternalHealthDashboard_Query_GetMonitorStatuses_OneOf_0_Items_Statuses_Items_Status>;
};

export type ExternalHealthDashboard_RetailerMonitorStatusGroup = {
  __typename?: 'ExternalHealthDashboard_RetailerMonitorStatusGroup';
  /** The ID of the retailer */
  retailerId: Scalars['String'];
  /** Array of monitor statuses for this retailer */
  statuses: Array<Maybe<ExternalHealthDashboard_MonitorStatus>>;
};

export type ExternalHealthDashboard_String_Container = {
  __typename?: 'ExternalHealthDashboard_String_container';
  String: Maybe<Scalars['String']>;
};

export type ExternalHealthDashboard_GetMonitorStatuses_Response = ExternalHealthDashboard_Error | ExternalHealthDashboard_RetailerMonitorStatusGroup;

export type ExternalHealthDashboard_GetOpenApiSpec_Response = ExternalHealthDashboard_Error | ExternalHealthDashboard_String_Container;

export enum ExternalHealthDashboard_Query_GetMonitorStatuses_OneOf_0_Items_Statuses_Items_Status {
  Degraded = 'degraded',
  MajorOutage = 'major_outage',
  Operational = 'operational',
  PartialOutage = 'partial_outage'
}

export type FailedUpdate = {
  __typename?: 'FailedUpdate';
  reason: Maybe<Scalars['String']>;
  retailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type FeatureEntitlement = {
  __typename?: 'FeatureEntitlement';
  /** The unique referable identifier of this entitlement */
  id: Scalars['String'];
  /** The display name of this entitlement */
  name: Scalars['String'];
};

export type FeatureExperiment = {
  __typename?: 'FeatureExperiment';
  /** The name of this feature */
  name: Scalars['String'];
  /** The variant picked */
  variant: Scalars['String'];
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  /** The name of this feature toggle */
  name: Scalars['String'];
};

export type FeatureToggleByRetailerId = {
  __typename?: 'FeatureToggleByRetailerId';
  /** feature toggles */
  featureToggles: Array<FeatureToggle>;
  /** The retailer ID */
  retailerId: Scalars['ID'];
};

export type FeatureTogglesEnabledCheck = {
  __typename?: 'FeatureTogglesEnabledCheck';
  /** Whether the feature toggle is enabled */
  enabled: Scalars['Boolean'];
};

export enum FeedbackEnum {
  /** Negative feedback */
  Negative = 'negative',
  /** Positive feedback */
  Positive = 'positive'
}

export enum FilterType {
  FilterTypeAdminOnly = 'FILTER_TYPE_ADMIN_ONLY',
  FilterTypeCollectionId = 'FILTER_TYPE_COLLECTION_ID',
  FilterTypeCollectionSlug = 'FILTER_TYPE_COLLECTION_SLUG',
  FilterTypeCreatedBy = 'FILTER_TYPE_CREATED_BY',
  FilterTypeMoment = 'FILTER_TYPE_MOMENT',
  FilterTypeMomentApproved = 'FILTER_TYPE_MOMENT_APPROVED',
  FilterTypeMomentRejected = 'FILTER_TYPE_MOMENT_REJECTED',
  FilterTypeMomentSubmitted = 'FILTER_TYPE_MOMENT_SUBMITTED',
  FilterTypeOccasion = 'FILTER_TYPE_OCCASION',
  FilterTypeOccasionApproved = 'FILTER_TYPE_OCCASION_APPROVED',
  FilterTypeOccasionRejected = 'FILTER_TYPE_OCCASION_REJECTED',
  FilterTypeOccasionSubmitted = 'FILTER_TYPE_OCCASION_SUBMITTED',
  FilterTypePartnershipOfferId = 'FILTER_TYPE_PARTNERSHIP_OFFER_ID',
  FilterTypeTag = 'FILTER_TYPE_TAG',
  FilterTypeUnknown = 'FILTER_TYPE_UNKNOWN'
}

export type FlatNavigation = {
  __typename?: 'FlatNavigation';
  icon: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
  position: Maybe<Scalars['BigInt']>;
  title: Maybe<Scalars['String']>;
};

export type FlatNavigationInput = {
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FlatNavigationWithVariants = {
  __typename?: 'FlatNavigationWithVariants';
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
  title: Maybe<Scalars['String']>;
};

export type FlatNavigationWithVariantsInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FlattenedTaxonomy = {
  __typename?: 'FlattenedTaxonomy';
  createdAt: Maybe<Scalars['DateTime']>;
  productCategoryId: Maybe<Scalars['BigInt']>;
  productCategoryPath: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type FlattenedTaxonomyFilterInput = {
  updatedSince?: InputMaybe<Scalars['DateTime']>;
};

/** Autogenerated return type of FlyoutPlacementCreate */
export type FlyoutPlacementCreatePayload = {
  __typename?: 'FlyoutPlacementCreatePayload';
  /** The newly created flyout placement */
  flyoutPlacement: ContentManagementFlyoutPlacement;
};

export type FlyoutPlacementInput = {
  /** The style and text of the subheading */
  descriptionText: ConfigurableTextInput;
  /** The style and text of the secondary text */
  disclaimerText?: InputMaybe<ConfigurableTextInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>;
  /** The images on the banner */
  images: GenericImagesInput;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The layout the placement should appear on */
  layout?: InputMaybe<Scalars['String']>;
  /** The style and text of the button within the placement */
  linkButton: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  linkDestination?: InputMaybe<PlacementDestinationInput>;
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The style and text of the button within the placement */
  primaryButton: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  primaryDestination?: InputMaybe<PlacementDestinationInput>;
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The style and text of the button within the placement */
  secondaryButton: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  secondaryDestination?: InputMaybe<PlacementDestinationInput>;
  /** The layout the placement should appear on */
  stringLayout?: InputMaybe<Scalars['String']>;
  /** The style and text of the heading */
  titleText: ConfigurableTextInput;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** The variant of the banner */
  variant?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of FlyoutPlacementUpdate */
export type FlyoutPlacementUpdatePayload = {
  __typename?: 'FlyoutPlacementUpdatePayload';
  /** The updated flyout placement */
  flyoutPlacement: ContentManagementFlyoutPlacement;
};

export type FontFamily = {
  __typename?: 'FontFamily';
  files: Maybe<FontFiles>;
  name: Maybe<Scalars['String']>;
};

export type FontFile = {
  __typename?: 'FontFile';
  otf: Maybe<Scalars['String']>;
  ttf: Maybe<Scalars['String']>;
  woff: Maybe<Scalars['String']>;
  woff2: Maybe<Scalars['String']>;
};

export type FontFiles = {
  __typename?: 'FontFiles';
  bold: Maybe<FontFile>;
  normal: Maybe<FontFile>;
  semiBold: Maybe<FontFile>;
};

export type Footer = {
  __typename?: 'Footer';
  variant: Maybe<FooterVariant>;
};

export enum FooterVariant {
  MultiColumn = 'MULTI_COLUMN',
  NoFooter = 'NO_FOOTER',
  VariantUnknown = 'VARIANT_UNKNOWN'
}

export enum FulfillmentModelEnum {
  /** Carrotwork */
  Carrotwork = 'CARROTWORK',
  /** In store shoppers */
  Iss = 'ISS',
  /** Locker */
  Locker = 'LOCKER',
  /** Partner managed */
  Retailer = 'RETAILER'
}

export type Function = {
  __typename?: 'Function';
  arguments: Scalars['String'];
  name: Scalars['String'];
};

export type FunctionDefinitionInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parameters?: InputMaybe<Scalars['JSON']>;
};

export type FunctionInput = {
  arguments: Scalars['String'];
  name: Scalars['String'];
};

export type GenerateBatchRequestInput = {
  adminRequestContext?: InputMaybe<AdminRequestContextInput>;
  batchType?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type GenerateBatchResponse = {
  __typename?: 'GenerateBatchResponse';
  id: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<Scalars['String']>;
};

export type GeneratePresignedAssetDownloadUrlRequestInput = {
  assetUrl?: InputMaybe<Scalars['String']>;
};

export type GeneratePresignedAssetDownloadUrlResponse = {
  __typename?: 'GeneratePresignedAssetDownloadUrlResponse';
  presignedUrl: Maybe<Scalars['String']>;
};

export type GeneratePresignedAssetUploadUrlRequestInput = {
  fileContentType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};

export type GeneratePresignedAssetUploadUrlResponse = {
  __typename?: 'GeneratePresignedAssetUploadUrlResponse';
  uploadFieldsJson: Maybe<Scalars['String']>;
  uploadUrl: Maybe<Scalars['String']>;
};

export type GeneratePrsForStringOverrideRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteStringOverrides?: InputMaybe<Array<InputMaybe<WhitelabelSiteStringOverrideInput>>>;
};

export type GeneratePrsForStringOverrideResponse = {
  __typename?: 'GeneratePrsForStringOverrideResponse';
  errorMessage: Maybe<Scalars['String']>;
  githubPrLink: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type GenericImagesInput = {
  /** The image url of the placement to display for large viewports */
  desktop?: InputMaybe<Scalars['Url']>;
  /** The image url of the placement to display for small viewports */
  mobile: Scalars['Url'];
};

export type GetAcknowledgedOosIdsRequestInput = {
  retailerId?: InputMaybe<Scalars['String']>;
};

export type GetAcknowledgedOosIdsResponse = {
  __typename?: 'GetAcknowledgedOosIdsResponse';
  oosIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetAdminNavigationV2RequestInput = {
  layoutType?: InputMaybe<Scalars['String']>;
  layoutTypes?: InputMaybe<Array<InputMaybe<LayoutType>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAdminNavigationV2Response = {
  __typename?: 'GetAdminNavigationV2Response';
  adminNavigationV2: Maybe<AdminNavigationV2>;
};

export type GetAisleRestockSummaryRequestInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<RestockFilterTogglesInput>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAisleRestockSummaryResponse = {
  __typename?: 'GetAisleRestockSummaryResponse';
  aisleGroups: Maybe<Array<Maybe<AisleGroup>>>;
  metadata: Maybe<AisleRestockSummaryMetadata>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
};

export type GetAnomalousItemsListRequestInput = {
  currentOnly?: InputMaybe<Scalars['Boolean']>;
  filterEndAtDate?: InputMaybe<Scalars['DateTime']>;
  filterStartAtDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAnomalousItemsListResponse = {
  __typename?: 'GetAnomalousItemsListResponse';
  dateCounts: Maybe<Array<Maybe<AnomalousItemDateCount>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type GetAnomalousItemsReportRequestInput = {
  currentOnly?: InputMaybe<Scalars['Boolean']>;
  filterEndAtDate?: InputMaybe<Scalars['DateTime']>;
  filterStartAtDate?: InputMaybe<Scalars['DateTime']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  selectedDates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type GetAnomalousItemsReportResponse = {
  __typename?: 'GetAnomalousItemsReportResponse';
  filename: Maybe<Scalars['String']>;
};

export type GetApiSettingsRequestInput = {
  apiType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetApiSettingsResponse = {
  __typename?: 'GetApiSettingsResponse';
  apiSettings: Maybe<Array<Maybe<GetApiSettingsResponseApiSetting>>>;
};

export type GetApiSettingsResponseApiSetting = {
  __typename?: 'GetApiSettingsResponseApiSetting';
  apiType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  cron: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  integrationType: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['BigInt']>;
  storeLocationIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetApprovalRequestsRequestInput = {
  attributeGroup?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetApprovalRequestsResponse = {
  __typename?: 'GetApprovalRequestsResponse';
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
};

export type GetAuditBatchMetadataRequestInput = {
  client?: InputMaybe<Scalars['String']>;
};

export type GetAuditBatchMetadataResponse = {
  __typename?: 'GetAuditBatchMetadataResponse';
  secondaryStates: Maybe<Array<Maybe<GetAuditBatchMetadataResponseSecondaryState>>>;
};

export type GetAuditBatchMetadataResponseSecondaryState = {
  __typename?: 'GetAuditBatchMetadataResponseSecondaryState';
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

export type GetAuditBatchRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  componentValueFilters?: InputMaybe<Array<InputMaybe<ComponentValueFilterInput>>>;
  hasExternalComment?: InputMaybe<Scalars['Boolean']>;
  hasInternalComment?: InputMaybe<Scalars['Boolean']>;
  orderByComponent?: InputMaybe<OrderByComponentInput>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PaginationInput>;
  returnAuditableTasks?: InputMaybe<Scalars['Boolean']>;
  returnSampleTasks?: InputMaybe<Scalars['Boolean']>;
  reviewState?: InputMaybe<Scalars['String']>;
  taskStateId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAuditBatchResponse = {
  __typename?: 'GetAuditBatchResponse';
  auditBatch: Maybe<AuditBatch>;
};

export type GetAuditTaskRequestInput = {
  client?: InputMaybe<Scalars['String']>;
  taskUuid?: InputMaybe<Scalars['String']>;
};

export type GetAuditTaskResponse = {
  __typename?: 'GetAuditTaskResponse';
  auditTask: Maybe<AuditTask>;
};

export type GetAuditWorkflowConfigsRequestInput = {
  client?: InputMaybe<Scalars['String']>;
  configType?: InputMaybe<Scalars['String']>;
  workflowL1?: InputMaybe<Scalars['String']>;
  workflowL2?: InputMaybe<Scalars['String']>;
  workflowL3?: InputMaybe<Scalars['String']>;
};

export type GetAuditWorkflowConfigsResponse = {
  __typename?: 'GetAuditWorkflowConfigsResponse';
  configs: Maybe<Array<Maybe<AuditWorkflowConfig>>>;
};

export type GetAuthenticationUrlRequestInput = {
  errorRedirectUrl?: InputMaybe<Scalars['String']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  successRedirectUrl?: InputMaybe<Scalars['String']>;
};

export type GetAuthenticationUrlResponse = {
  __typename?: 'GetAuthenticationUrlResponse';
  authenticationUrl: Maybe<Scalars['String']>;
};

export type GetAvailabilityScoreOverrideRequestInput = {
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAvailabilityScoreOverrideResponse = {
  __typename?: 'GetAvailabilityScoreOverrideResponse';
  entities: Maybe<Array<Maybe<GetAvailabilityScoreOverrideResponseOverrideEntity>>>;
};

export type GetAvailabilityScoreOverrideResponseOverrideEntity = {
  __typename?: 'GetAvailabilityScoreOverrideResponseOverrideEntity';
  entityId: Maybe<EntityId>;
  isEnabled: Maybe<Scalars['Boolean']>;
  productId: Maybe<Scalars['BigInt']>;
};

export type GetAvailableStoreLocationsRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAvailableStoreLocationsResponse = {
  __typename?: 'GetAvailableStoreLocationsResponse';
  storeLocations: Maybe<Array<Maybe<ApiIntegrationStoreLocation>>>;
};

export type GetBuildkiteArtifactDownloadUrlRequestInput = {
  artifactId?: InputMaybe<Scalars['String']>;
  buildUrl?: InputMaybe<Scalars['String']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
};

export type GetBuildkiteArtifactDownloadUrlResponse = {
  __typename?: 'GetBuildkiteArtifactDownloadUrlResponse';
  presignedUrl: Maybe<Scalars['String']>;
};

export type GetBuildkiteArtifactsRequestInput = {
  buildUrl?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
};

export type GetBuildkiteArtifactsResponse = {
  __typename?: 'GetBuildkiteArtifactsResponse';
  artifacts: Maybe<Array<Maybe<BuildkiteArtifactInfo>>>;
};

export type GetCatalogFaqFileRequestInput = {
  fileName?: InputMaybe<Scalars['String']>;
};

export type GetCatalogFaqFileResponse = {
  __typename?: 'GetCatalogFaqFileResponse';
  file: Maybe<Scalars['String']>;
};

export type GetClientConfigurationByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetClientConfigurationByIdResponse = {
  __typename?: 'GetClientConfigurationByIdResponse';
  clientConfiguration: Maybe<ClientConfiguration>;
};

export type GetCollectionsRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['Boolean']>;
  collectionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeDynamicRetailerCollections?: InputMaybe<Scalars['Boolean']>;
  excludedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includeAlcohol?: InputMaybe<Scalars['Boolean']>;
  includeArchivedCollections?: InputMaybe<Scalars['Boolean']>;
  includeAssociatedRetailerCollections?: InputMaybe<Scalars['Boolean']>;
  includedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>;
  parentId?: InputMaybe<Scalars['String']>;
  replaceDepartmentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  showDepartmentTile?: InputMaybe<Scalars['Boolean']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  useFullNamePath?: InputMaybe<Scalars['Boolean']>;
  useRetailerTypeMapping?: InputMaybe<Scalars['Boolean']>;
};

export type GetCollectionsResponse = {
  __typename?: 'GetCollectionsResponse';
  collections: Maybe<Array<Maybe<Collection>>>;
};

export type GetConfirmedStoreHoursRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type GetConfirmedStoreHoursResponse = {
  __typename?: 'GetConfirmedStoreHoursResponse';
  confirmations: Maybe<Array<Maybe<ConfirmedStoreHours>>>;
};

export type GetConnectPlatformEventsByDomainRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  domain?: InputMaybe<Scalars['String']>;
  domainObjectId?: InputMaybe<Scalars['String']>;
  domainObjectType?: InputMaybe<Scalars['String']>;
};

export type GetConnectPlatformEventsByDomainResponse = {
  __typename?: 'GetConnectPlatformEventsByDomainResponse';
  events: Maybe<Array<Maybe<ConnectPlatformEventWithCallbacks>>>;
};

export type GetConnectRetailerCallbackConfigurationByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetConnectRetailerCallbackConfigurationByIdResponse = {
  __typename?: 'GetConnectRetailerCallbackConfigurationByIdResponse';
  callbackConfiguration: Maybe<ConnectRetailerCallbackConfiguration>;
};

export type GetConnectRetailerCallbackConfigurationsRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  environment?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetConnectRetailerCallbackConfigurationsResponse = {
  __typename?: 'GetConnectRetailerCallbackConfigurationsResponse';
  callbackConfigurations: Maybe<Array<Maybe<ConnectRetailerCallbackConfiguration>>>;
};

export type GetConnectSettingsRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
};

export type GetConnectSettingsResponse = {
  __typename?: 'GetConnectSettingsResponse';
  enableEtaServiceOptions: Maybe<Scalars['Boolean']>;
  postCheckoutAppDomain: Maybe<Scalars['String']>;
};

export type GetCustomersContextRequestInput = {
  parameters?: InputMaybe<GetCustomersContextRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetCustomersContextRequestParametersInput = {
  partnerId?: InputMaybe<Scalars['Int']>;
};

export type GetCustomersContextResponse = {
  __typename?: 'GetCustomersContextResponse';
  contexts: Maybe<Array<Maybe<CustomersContext>>>;
};

export type GetDashboardOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetDashboardOrderResponse = {
  __typename?: 'GetDashboardOrderResponse';
  dashboardOrder: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrder>;
};

export type GetDashboardOrdersRequestFilterSetInput = {
  orderIdentifier?: InputMaybe<Scalars['String']>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<GetDashboardOrdersRequestFilterSetOrderStatusCriteria>>>;
  orderType?: InputMaybe<GetDashboardOrdersRequestFilterSetOrderType>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<GetDashboardOrdersRequestFilterSetTimestampRangeInput>;
};

export enum GetDashboardOrdersRequestFilterSetOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  New = 'NEW',
  OrderStatusCriteriaUnspecified = 'ORDER_STATUS_CRITERIA_UNSPECIFIED',
  Processing = 'PROCESSING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Shopping = 'SHOPPING'
}

export enum GetDashboardOrdersRequestFilterSetOrderType {
  Delivery = 'DELIVERY',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  OrderTypeUnspecified = 'ORDER_TYPE_UNSPECIFIED',
  Pickup = 'PICKUP'
}

export type GetDashboardOrdersRequestFilterSetTimestampRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type GetDashboardOrdersRequestInput = {
  filterSet?: InputMaybe<GetDashboardOrdersRequestFilterSetInput>;
  ordersSortBy?: InputMaybe<GetDashboardOrdersRequestOrdersSortByInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
};

export enum GetDashboardOrdersRequestOrdersSortByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  DirectionUnspecified = 'DIRECTION_UNSPECIFIED'
}

export type GetDashboardOrdersRequestOrdersSortByInput = {
  direction?: InputMaybe<GetDashboardOrdersRequestOrdersSortByDirection>;
  name?: InputMaybe<GetDashboardOrdersRequestOrdersSortByOrdersAttributes>;
};

export enum GetDashboardOrdersRequestOrdersSortByOrdersAttributes {
  OrdersAttributesUnspecified = 'ORDERS_ATTRIBUTES_UNSPECIFIED',
  OrderDeliveryId = 'ORDER_DELIVERY_ID',
  WindowEndsAt = 'WINDOW_ENDS_AT'
}

export type GetDashboardOrdersResponse = {
  __typename?: 'GetDashboardOrdersResponse';
  dashboardOrderSummary: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummary>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type GetDetectionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetDetectionResponse = {
  __typename?: 'GetDetectionResponse';
  name: Maybe<Scalars['String']>;
  versions: Maybe<Array<Maybe<GetDetectionResponseDetectionVersion>>>;
};

export type GetDetectionResponseDetectionVersion = {
  __typename?: 'GetDetectionResponseDetectionVersion';
  attributes: Maybe<DetectionVersionAttributes>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  states: Maybe<Array<Maybe<DetectionVersionState>>>;
  stats: Maybe<Array<Maybe<DetectionVersionStats>>>;
  tombstoned: Maybe<Scalars['Boolean']>;
  version: Maybe<Scalars['BigInt']>;
};

export type GetFlattenedTaxonomiesParametersInput = {
  filter?: InputMaybe<FlattenedTaxonomyFilterInput>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetFlattenedTaxonomiesRequestInput = {
  parameters?: InputMaybe<GetFlattenedTaxonomiesParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetFlattenedTaxonomiesResponse = {
  __typename?: 'GetFlattenedTaxonomiesResponse';
  taxonomies: Maybe<Array<Maybe<FlattenedTaxonomy>>>;
};

export type GetFormGroupsRequestInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type GetFormGroupsResponse = {
  __typename?: 'GetFormGroupsResponse';
  androidFormAdditionalGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  androidFormDefaultGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  iosFormAdditionalGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  iosFormDefaultGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerFormAdditionalGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerFormDefaultGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  saFormGroups: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetHolidaysStatusRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetHolidaysStatusResponse = {
  __typename?: 'GetHolidaysStatusResponse';
  holidays: Maybe<Array<Maybe<HolidayStatus>>>;
};

export type GetImageUploadBatchDetailsRequestInput = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type GetImageUploadBatchDetailsResponse = {
  __typename?: 'GetImageUploadBatchDetailsResponse';
  imageUploadBatchDetails: Maybe<Array<Maybe<ImageUploadBatchDetails>>>;
  imageUploadBatchMetadata: Maybe<ImageUploadBatchMetadata>;
};

export type GetImageUploadBatchesRequestInput = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  timeRange?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type GetImageUploadBatchesResponse = {
  __typename?: 'GetImageUploadBatchesResponse';
  imageUploadBatch: Maybe<Array<Maybe<ImageUploadBatch>>>;
  imageUploadBatchMetadata: Maybe<ImageUploadBatchMetadata>;
};

export type GetIsGrocerRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetIsGrocerResponse = {
  __typename?: 'GetIsGrocerResponse';
  isGrocer: Maybe<Scalars['Boolean']>;
};

export type GetItemsRequestInput = {
  parameters?: InputMaybe<GetItemsRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetItemsRequestParametersInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetItemsResponse = {
  __typename?: 'GetItemsResponse';
  results: Maybe<Array<Maybe<Item>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type GetKpiRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetKpiResponse = {
  __typename?: 'GetKpiResponse';
  departmentOosDistribution: Maybe<Array<Maybe<DepartmentOosCount>>>;
  kpiCards: Maybe<KpiCards>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
};

export type GetLaunchOnboardingRequestInput = {
  includeApprovalRequests?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  token?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type GetLaunchOnboardingResponse = {
  __typename?: 'GetLaunchOnboardingResponse';
  launchOnboarding: Maybe<LaunchOnboarding>;
};

export type GetLaunchOnboardingWarehouseLocationsRequestInput = {
  pagination?: InputMaybe<PaginationDetailsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetLaunchOnboardingWarehouseLocationsResponse = {
  __typename?: 'GetLaunchOnboardingWarehouseLocationsResponse';
  pagination: Maybe<PaginationDetails>;
  warehouseLocations: Maybe<Array<Maybe<LaunchOnboardingWarehouseLocation>>>;
};

export type GetLayoutVariantsRequestInput = {
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Status>;
};

export type GetLayoutVariantsResponse = {
  __typename?: 'GetLayoutVariantsResponse';
  layoutVariants: Maybe<Array<Maybe<LayoutVariant>>>;
};

export type GetLegacyElasticsearchRequestInput = {
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetLegacyItemsShoppersRequestBoostWhereBoostObjectInput = {
  factor?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['BigInt']>;
};

export type GetLegacyItemsShoppersRequestBoostWhereInput = {
  primaryDepartmentId?: InputMaybe<GetLegacyItemsShoppersRequestBoostWhereBoostObjectInput>;
};

export type GetLegacyItemsShoppersRequestInput = {
  aisleId?: InputMaybe<Scalars['BigInt']>;
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  anyMatchingProductCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Scalars['Boolean']>;
  boostWhere?: InputMaybe<GetLegacyItemsShoppersRequestBoostWhereInput>;
  departmentId?: InputMaybe<Scalars['BigInt']>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasImage?: InputMaybe<Scalars['Boolean']>;
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>;
  productCodes?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerReferenceCode?: InputMaybe<Scalars['String']>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  tsqueryQuery?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type GetLegacyProductsRequestInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  availableInventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  inventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  query?: InputMaybe<Scalars['String']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
};

export type GetLocalesByRetailerRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetLocalesByRetailerResponse = {
  __typename?: 'GetLocalesByRetailerResponse';
  retailerLocales: Maybe<Array<Maybe<RetailerLocale>>>;
};

export type GetManagedAttributeValuesForRetailerRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetManagedAttributeValuesForRetailerResponse = {
  __typename?: 'GetManagedAttributeValuesForRetailerResponse';
  managedAttributeValues: Maybe<Array<Maybe<ManagedAttributeValue>>>;
};

export type GetMomentParticipatingRetailersRequestInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetMomentParticipatingRetailersResponse = {
  __typename?: 'GetMomentParticipatingRetailersResponse';
  participatingRetailerCampaigns: Maybe<RetailerCampaign>;
  retailerMomentCampaigns: Maybe<Array<Maybe<RetailerMomentCampaign>>>;
};

export type GetMomentRequestInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type GetMomentResponse = {
  __typename?: 'GetMomentResponse';
  moment: Maybe<Moment>;
};

export type GetMomentsRequestInput = {
  momentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetMomentsResponse = {
  __typename?: 'GetMomentsResponse';
  moments: Maybe<Array<Maybe<Moment>>>;
};

export type GetNativeTabBarNavigationRequestInput = {
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetNativeTabBarNavigationResponse = {
  __typename?: 'GetNativeTabBarNavigationResponse';
  navigation: Maybe<NativeTabBarNavigation>;
};

export type GetNavigationRequestInput = {
  layout?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetNavigationResponse = {
  __typename?: 'GetNavigationResponse';
  navigation: Maybe<Navigation>;
};

export type GetNextAuditBatchRequestInput = {
  userUuid?: InputMaybe<Scalars['String']>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type GetNextAuditBatchResponse = {
  __typename?: 'GetNextAuditBatchResponse';
  batchUuid: Maybe<Scalars['String']>;
};

export type GetOnboardingAttributesRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  attributeSubgroupName?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDetailsInput>;
  released?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  statuses?: InputMaybe<Array<InputMaybe<OnboardingAttributeStatus>>>;
  visibilityTiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetOnboardingAttributesResponse = {
  __typename?: 'GetOnboardingAttributesResponse';
  onboardingAttributes: Maybe<Array<Maybe<OnboardingAttribute>>>;
  pagination: Maybe<PaginationDetails>;
};

export type GetOnboardingRequestInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type GetOnboardingResponse = {
  __typename?: 'GetOnboardingResponse';
  onboarding: Maybe<Onboarding>;
};

export type GetOrderDiscountDetailsRequestInput = {
  orderId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderDiscountDetailsResponse = {
  __typename?: 'GetOrderDiscountDetailsResponse';
  discountDiscountables: Maybe<Array<Maybe<DiscountDiscountablesData>>>;
};

export type GetOrderFulfillmentOverviewRequestInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderFulfillmentOverviewResponse = {
  __typename?: 'GetOrderFulfillmentOverviewResponse';
  activeShopper: Maybe<Scalars['Int']>;
  isFullService: Maybe<Scalars['Boolean']>;
  shoppers: Maybe<Array<Maybe<ShopperOrderProfile>>>;
  warehouseLocationId: Maybe<Scalars['BigInt']>;
};

export type GetOrderLocationRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderLocationResponse = {
  __typename?: 'GetOrderLocationResponse';
  shopperCoordinates: Maybe<GoogleTypeLatLng>;
};

export type GetOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderResponse = {
  __typename?: 'GetOrderResponse';
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>;
};

export type GetOrderStateChangesRequestInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
};

export type GetOrderStateChangesResponse = {
  __typename?: 'GetOrderStateChangesResponse';
  currentState: Maybe<GetOrderStateChangesResponseState>;
  stateChanges: Maybe<Array<Maybe<GetOrderStateChangesResponseState>>>;
};

export type GetOrderStateChangesResponseState = {
  __typename?: 'GetOrderStateChangesResponseState';
  actor: Maybe<GetOrderStateChangesResponseStateActor>;
  issues: Maybe<Array<Maybe<GetOrderStateChangesResponseStateIssue>>>;
  stateDisplayName: Maybe<Scalars['String']>;
  stateType: Maybe<GetOrderStateChangesResponseStateStateType>;
  transitionedAt: Maybe<Scalars['DateTime']>;
  transitionedEta: Maybe<Scalars['DateTime']>;
};

export type GetOrderStateChangesResponseStateActor = {
  __typename?: 'GetOrderStateChangesResponseStateActor';
  id: Maybe<Scalars['BigInt']>;
  type: Maybe<Scalars['String']>;
};

export type GetOrderStateChangesResponseStateIssue = {
  __typename?: 'GetOrderStateChangesResponseStateIssue';
  issueDescription: Maybe<Scalars['String']>;
  issueType: Maybe<GetOrderStateChangesResponseStateIssueIssueType>;
};

export enum GetOrderStateChangesResponseStateIssueIssueType {
  IssueTypeCanceled = 'ISSUE_TYPE_CANCELED',
  IssueTypeDelayed = 'ISSUE_TYPE_DELAYED',
  IssueTypeFailedDelivery = 'ISSUE_TYPE_FAILED_DELIVERY',
  IssueTypePartiallyDelivery = 'ISSUE_TYPE_PARTIALLY_DELIVERY',
  IssueTypeUnknown = 'ISSUE_TYPE_UNKNOWN'
}

export enum GetOrderStateChangesResponseStateStateType {
  StateTypeArrived = 'STATE_TYPE_ARRIVED',
  StateTypeAssigned = 'STATE_TYPE_ASSIGNED',
  StateTypeAtStore = 'STATE_TYPE_AT_STORE',
  StateTypeAwaitingReturn = 'STATE_TYPE_AWAITING_RETURN',
  StateTypeBagsPickedUp = 'STATE_TYPE_BAGS_PICKED_UP',
  StateTypeCheckingOut = 'STATE_TYPE_CHECKING_OUT',
  StateTypeDelivered = 'STATE_TYPE_DELIVERED',
  StateTypeInTransit = 'STATE_TYPE_IN_TRANSIT',
  StateTypeOrderPlaced = 'STATE_TYPE_ORDER_PLACED',
  StateTypePicking = 'STATE_TYPE_PICKING',
  StateTypeReadyForPickup = 'STATE_TYPE_READY_FOR_PICKUP',
  StateTypeReturnCompleted = 'STATE_TYPE_RETURN_COMPLETED',
  StateTypeReturnInProgress = 'STATE_TYPE_RETURN_IN_PROGRESS',
  StateTypeRunningOrder = 'STATE_TYPE_RUNNING_ORDER',
  StateTypeStaging = 'STATE_TYPE_STAGING',
  StateTypeUnknown = 'STATE_TYPE_UNKNOWN'
}

export type GetParkingSettingsRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<PickupType>;
};

export type GetParkingSettingsResponse = {
  __typename?: 'GetParkingSettingsResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  imageConfigs: Maybe<Array<Maybe<ImageConfig>>>;
  instruction: Maybe<Scalars['String']>;
  retailerLocationConfig: Maybe<RetailerLocationInfo>;
};

export type GetPartnerApiKeysRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPartnerApiKeysResponse = {
  __typename?: 'GetPartnerApiKeysResponse';
  connectApiKeys: Maybe<Array<Maybe<ConnectApiKey>>>;
};

export type GetPartnerIdRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPartnerIdResponse = {
  __typename?: 'GetPartnerIdResponse';
  partnerId: Maybe<Scalars['BigInt']>;
};

export type GetPartnerOauthApplicationsRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPartnerOauthApplicationsResponse = {
  __typename?: 'GetPartnerOauthApplicationsResponse';
  oauthApplications: Maybe<Array<Maybe<OauthApplication>>>;
};

export type GetPickupSettingsMetadataRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPickupSettingsMetadataResponse = {
  __typename?: 'GetPickupSettingsMetadataResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  isCurbsidePickupEnabled: Maybe<Scalars['Boolean']>;
  isReadyForPickup: Maybe<Scalars['Boolean']>;
  isSettingsOnboardingComplete: Maybe<Scalars['Boolean']>;
  pickupEnableDate: Maybe<GoogleTypeDate>;
};

export type GetPiiRequestsForRetailerRequestInput = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  requestCreatedAfter?: InputMaybe<Scalars['DateTime']>;
  requestCreatedBefore?: InputMaybe<Scalars['DateTime']>;
  requestTypes?: InputMaybe<Array<InputMaybe<RequestType>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  workflowStatus?: InputMaybe<Array<InputMaybe<WorkflowStatus>>>;
};

export type GetPiiRequestsForRetailerResponse = {
  __typename?: 'GetPiiRequestsForRetailerResponse';
  piiRequests: Maybe<Array<Maybe<PiiRequest>>>;
};

export type GetPlacementContentByIdRequestInput = {
  generateVisibilityConditions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetPlacementContentByIdResponse = {
  __typename?: 'GetPlacementContentByIdResponse';
  content: Maybe<PlacementContent>;
};

export type GetPlacementsRequestInput = {
  collectionSlug?: InputMaybe<Scalars['String']>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  enabledOnly?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Layout>;
  layoutVariantId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  placementIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Direction>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  stringLayout?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  variant?: InputMaybe<Array<InputMaybe<BannerVariant>>>;
};

export type GetPlatformVersionsRequestInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type GetPlatformVersionsResponse = {
  __typename?: 'GetPlatformVersionsResponse';
  nextPlatformVersion: Maybe<Scalars['String']>;
  nextPlatformVersionRouletteName: Maybe<Scalars['String']>;
  platformVersion: Maybe<Scalars['String']>;
  platformVersionRouletteName: Maybe<Scalars['String']>;
};

export type GetPriceInvestigationRequestInput = {
  investigationId?: InputMaybe<Scalars['String']>;
};

export type GetPriceInvestigationResponse = {
  __typename?: 'GetPriceInvestigationResponse';
  investigation: Maybe<Investigation>;
};

export type GetProductDataRequestInput = {
  productId?: InputMaybe<ProductIdInput>;
};

export type GetProductDataResponse = {
  __typename?: 'GetProductDataResponse';
  productData: Maybe<Array<Maybe<ProductData>>>;
  productId: Maybe<ProductId>;
};

export type GetProductSourcesRequestInput = {
  sourceLevel?: InputMaybe<SourceLevel>;
};

export type GetProductSourcesResponse = {
  __typename?: 'GetProductSourcesResponse';
  sourceCount: Maybe<Scalars['BigInt']>;
  sources: Maybe<Array<Maybe<ProductSource>>>;
};

export type GetRequestContextsRequestInput = {
  partnerId?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['Int']>;
};

export type GetRequestContextsResponse = {
  __typename?: 'GetRequestContextsResponse';
  requestContexts: Maybe<Array<Maybe<InstacartCustomersSharedV1RequestContext>>>;
};

export type GetRestockRankingListRequestInput = {
  departmentId?: InputMaybe<Scalars['BigInt']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<RestockSortBy>;
  sortDir?: InputMaybe<SortDirection>;
};

export type GetRestockRankingListResponse = {
  __typename?: 'GetRestockRankingListResponse';
  items: Maybe<Array<Maybe<RestockItem>>>;
  metadata: Maybe<RestockMetadata>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
};

export type GetRetailerAisleTemplateRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shopperType?: InputMaybe<ShopperType>;
};

export type GetRetailerAisleTemplateResponse = {
  __typename?: 'GetRetailerAisleTemplateResponse';
  activeAt: Maybe<Scalars['DateTime']>;
  aisleOrders: Maybe<Array<Maybe<AisleOrder>>>;
  aisleTemplateId: Maybe<Scalars['BigInt']>;
  layoutId: Maybe<Scalars['String']>;
};

export type GetRetailerCampaignRequestInput = {
  ippContext?: InputMaybe<IppContextInput>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerLocationByLayoutRequestInput = {
  layoutId?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerLocationByLayoutResponse = {
  __typename?: 'GetRetailerLocationByLayoutResponse';
  retailerLocationAisles: Maybe<Array<Maybe<RetailerLocationAisle>>>;
};

export type GetRetailerLocationsByLocationCodesRequestInput = {
  locationCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
  skipStatusCheck?: InputMaybe<Scalars['Boolean']>;
};

export type GetRetailerLocationsByLocationCodesResponse = {
  __typename?: 'GetRetailerLocationsByLocationCodesResponse';
  retailerLocations: Maybe<Array<Maybe<RetailerLocationDetails>>>;
};

export type GetRetailerLocationsDetailsRequestInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetRetailerLocationsDetailsResponse = {
  __typename?: 'GetRetailerLocationsDetailsResponse';
  retailerLocations: Maybe<Array<Maybe<RetailerLocationDetails>>>;
};

export type GetRetailerProductAssortmentRequestInput = {
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  filter?: InputMaybe<RetailerProductAssortmentFilterInput>;
};

export type GetRetailerProductAssortmentResponse = {
  __typename?: 'GetRetailerProductAssortmentResponse';
  retailerProductAssortment: Maybe<Array<Maybe<RetailerProductAssortment>>>;
};

export type GetRetailerProductAttributeSourcesRequestInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  localeId?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductAttributeSourcesResponse = {
  __typename?: 'GetRetailerProductAttributeSourcesResponse';
  attributeSources: Maybe<Array<Maybe<AttributeSourceData>>>;
};

export type GetRetailerProductDataRequestInput = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductDataResponse = {
  __typename?: 'GetRetailerProductDataResponse';
  retailerProductData: Maybe<Array<Maybe<RetailerProductData>>>;
};

export type GetRetailerProductsRequestInput = {
  parameters?: InputMaybe<GetRetailerProductsRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductsRequestParametersDateTimeRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type GetRetailerProductsRequestParametersInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  hasPrimaryImageUrl?: InputMaybe<Scalars['Boolean']>;
  includeManagedAttributeValues?: InputMaybe<Scalars['Boolean']>;
  isStoreBrandProduct?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  omniSearchTerm?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCreationDateRange?: InputMaybe<GetRetailerProductsRequestParametersDateTimeRangeInput>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerProductIds?: InputMaybe<Array<InputMaybe<GetRetailerProductsRequestParametersRetailerProductIdInput>>>;
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  surfaceIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  withUnclassifiedProducts?: InputMaybe<Scalars['Boolean']>;
};

export type GetRetailerProductsRequestParametersRetailerProductIdInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductsResponse = {
  __typename?: 'GetRetailerProductsResponse';
  results: Maybe<Array<Maybe<RetailerProduct>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type GetRetailerRegionsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
};

export type GetRetailerRegionsResponse = {
  __typename?: 'GetRetailerRegionsResponse';
  regions: Maybe<Array<Maybe<Region>>>;
};

export type GetRetailersForShortcutsRequestInput = {
  isShortcutsBarOverridden?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  retailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type GetRetailersForShortcutsResponse = {
  __typename?: 'GetRetailersForShortcutsResponse';
  retailers: Maybe<Array<Maybe<RetailerForShortcut>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type GetRppConfigurableItemsRequestInput = {
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRppConfigurableItemsResponse = {
  __typename?: 'GetRppConfigurableItemsResponse';
  configurableProducts: Maybe<Scalars['String']>;
};

export type GetServiceOptionsFiltersInput = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  cartTotal?: InputMaybe<Scalars['Float']>;
  earliestOptionStartAt?: InputMaybe<Scalars['DateTime']>;
  itemsCount?: InputMaybe<Scalars['Int']>;
  postalCode?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<Scalars['String']>;
  unitsCount?: InputMaybe<Scalars['Float']>;
  warehouseId?: InputMaybe<Scalars['Int']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
  withEtaOptions?: InputMaybe<Scalars['Boolean']>;
  withPriorityEtaOptions?: InputMaybe<Scalars['Boolean']>;
};

export type GetServiceOptionsRequestInput = {
  filters?: InputMaybe<GetServiceOptionsFiltersInput>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetServiceOptionsResponse = {
  __typename?: 'GetServiceOptionsResponse';
  serviceOptions: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOption>>>;
};

export type GetSettingRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
};

export type GetSettingResponse = {
  __typename?: 'GetSettingResponse';
  settingRecord: Maybe<RetailerSettingRecord>;
};

export type GetShelfViewRequestInput = {
  maxImages?: InputMaybe<Scalars['Int']>;
  numScans?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  scanOffset?: InputMaybe<Scalars['Int']>;
};

export type GetShelfViewResponse = {
  __typename?: 'GetShelfViewResponse';
  category: Maybe<Scalars['String']>;
  currentFacings: Maybe<Scalars['Int']>;
  department: Maybe<Scalars['String']>;
  locations: Maybe<Array<Maybe<ShelfLocation>>>;
  name: Maybe<Scalars['String']>;
  onShelfCountHistory: Maybe<Array<Maybe<OnShelfCountEntry>>>;
  productId: Maybe<Scalars['BigInt']>;
  productImageUrl: Maybe<Scalars['String']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  scanSnapshots: Maybe<Array<Maybe<ScanSnapshot>>>;
  scanTimestamp: Maybe<Scalars['DateTime']>;
  totalScansAvailable: Maybe<Scalars['Int']>;
  upc: Maybe<Scalars['String']>;
};

export type GetSignupPartnerRequestInput = {
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type GetSignupPartnerResponse = {
  __typename?: 'GetSignupPartnerResponse';
  signupPartner: Maybe<SignupPartner>;
};

export type GetSlotByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetSlotByIdResponse = {
  __typename?: 'GetSlotByIdResponse';
  slot: Maybe<Slot>;
};

export type GetSlotsByContentPagesRequestInput = {
  contentPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetSlotsByContentPagesResponse = {
  __typename?: 'GetSlotsByContentPagesResponse';
  contentPageSlots: Maybe<Array<Maybe<ContentPageSlots>>>;
};

export type GetSlotsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetSlotsResponse = {
  __typename?: 'GetSlotsResponse';
  slots: Maybe<Array<Maybe<Slot>>>;
};

export type GetSocialIconsNavigationRequestInput = {
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetSocialIconsNavigationResponse = {
  __typename?: 'GetSocialIconsNavigationResponse';
  socialIcons: Maybe<SocialIconNav>;
};

export type GetStagingSettingsRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetStagingSettingsResponse = {
  __typename?: 'GetStagingSettingsResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  freezer: Maybe<Array<Maybe<Scalars['String']>>>;
  fridge: Maybe<Array<Maybe<Scalars['String']>>>;
  hotArea: Maybe<Array<Maybe<Scalars['String']>>>;
  imageUrl: Maybe<Scalars['String']>;
  instruction: Maybe<Scalars['String']>;
  retailerLocationConfig: Maybe<RetailerLocationInfo>;
  shelf: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetStoreConfigurationDraftsRequestInput = {
  includeOutdatedDrafts?: InputMaybe<Scalars['Boolean']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetStoreConfigurationDraftsResponse = {
  __typename?: 'GetStoreConfigurationDraftsResponse';
  drafts: Maybe<Array<Maybe<StoreConfigurationDraft>>>;
  errorMessage: Maybe<Scalars['String']>;
  errorReason: Maybe<ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type GetStoreHoursByDateRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
  verticalType?: InputMaybe<VerticalType>;
};

export type GetStoreHoursByDateResponse = {
  __typename?: 'GetStoreHoursByDateResponse';
  storeHours: Maybe<Array<Maybe<StoreHoursByDate>>>;
};

export type GetStoreHoursByDayOfWeekRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<GoogleTypeDayOfWeek>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
  verticalType?: InputMaybe<VerticalType>;
};

export type GetStoreHoursByDayOfWeekResponse = {
  __typename?: 'GetStoreHoursByDayOfWeekResponse';
  storeHours: Maybe<Array<Maybe<StoreHoursByDayOfWeek>>>;
};

export type GetStoreHoursByZoneRetailerRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<GoogleTypeDateInput>;
  includeClosedRetailer?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
  verticalType?: InputMaybe<VerticalType>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type GetStoreHoursByZoneRetailerResponse = {
  __typename?: 'GetStoreHoursByZoneRetailerResponse';
  storeHours: Maybe<Array<Maybe<StoreHoursByZoneRetailer>>>;
};

export type GetStoreHoursRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceTypes?: InputMaybe<Array<InputMaybe<RetailerServiceType>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type GetStoreHoursResponse = {
  __typename?: 'GetStoreHoursResponse';
  storeHours: Maybe<Array<Maybe<StoreHours>>>;
};

export type GetStoreHoursUpdateTasksRequestInput = {
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type GetStoreHoursUpdateTasksResponse = {
  __typename?: 'GetStoreHoursUpdateTasksResponse';
  tasks: Maybe<Array<Maybe<StoreHoursUpdateTask>>>;
};

export type GetTestCasesRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetTestCasesResponse = {
  __typename?: 'GetTestCasesResponse';
  automatedTestCases: Maybe<Array<Maybe<TestCase>>>;
  manualTestCases: Maybe<Array<Maybe<TestCase>>>;
};

export type GetThemePageRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type GetThemePageResponse = {
  __typename?: 'GetThemePageResponse';
  themePage: Maybe<ThemePage>;
};

export type GetTicketRequestInput = {
  client?: InputMaybe<ClientInput>;
  cptTicketId?: InputMaybe<Scalars['BigInt']>;
};

export type GetTicketResponse = {
  __typename?: 'GetTicketResponse';
  comments: Maybe<Array<Maybe<ProblemTrackerTicketComment>>>;
  entities: Maybe<Array<Maybe<ProblemTrackerEntityStatus>>>;
  ticket: Maybe<ProblemTrackerTicket>;
  watchers: Maybe<Array<Maybe<User>>>;
};

export type GetToolingShortcutsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerType?: InputMaybe<Scalars['String']>;
};

export type GetToolingShortcutsResponse = {
  __typename?: 'GetToolingShortcutsResponse';
  shortcuts: Maybe<Array<Maybe<ToolingShortcut>>>;
};

export type GetUserByIdFilteredByIsolationContextParametersInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type GetUserByIdFilteredByIsolationContextRequestInput = {
  parameters?: InputMaybe<GetUserByIdFilteredByIsolationContextParametersInput>;
};

export type GetUsersByStoreConfigurationIdRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type GetUsersByStoreConfigurationIdResponse = {
  __typename?: 'GetUsersByStoreConfigurationIdResponse';
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  users: Maybe<Array<Maybe<User>>>;
};

export type GetValueBasedOverridesRequestInput = {
  entityId?: InputMaybe<EntityIdInput>;
};

export type GetValueBasedOverridesResponse = {
  __typename?: 'GetValueBasedOverridesResponse';
  entityId: Maybe<EntityId>;
  valueBasedOverride: Maybe<Array<Maybe<ValueBasedOverrideResponse>>>;
};

export type GetVirtualRetailersRequestInput = {
  parameters?: InputMaybe<GetVirtualRetailersRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetVirtualRetailersRequestParametersInput = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetVirtualRetailersResponse = {
  __typename?: 'GetVirtualRetailersResponse';
  virtualRetailers: Maybe<Array<Maybe<VirtualRetailer>>>;
};

export type GetWaterfallEffectRequestInput = {
  externalReference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  targetType?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWaterfallEffectResponse = {
  __typename?: 'GetWaterfallEffectResponse';
  waterfallEffect: Maybe<WaterfallEffect>;
};

export type GetWaterfallEffectsRequestInput = {
  pagination?: InputMaybe<PaginationDetailsInput>;
  parentWaterfallEffectId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  targetService?: InputMaybe<Scalars['String']>;
  targetType?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWaterfallEffectsResponse = {
  __typename?: 'GetWaterfallEffectsResponse';
  pagination: Maybe<PaginationDetails>;
  waterfallEffects: Maybe<Array<Maybe<WaterfallEffect>>>;
};

export type GetWhitelabelGumloopWorkflowResultsRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  waterfallEffectId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowRunId?: InputMaybe<Scalars['String']>;
};

export type GetWhitelabelGumloopWorkflowResultsResponse = {
  __typename?: 'GetWhitelabelGumloopWorkflowResultsResponse';
  childWaterfallEffectId: Maybe<Scalars['BigInt']>;
  dataPropagationStatus: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  waterfallEffectId: Maybe<Scalars['BigInt']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
  workflowRunId: Maybe<Scalars['String']>;
};

export type GetWhitelabelSiteTestRunBuildRequestInput = {
  buildUrl?: InputMaybe<Scalars['String']>;
  includeFailureDetails?: InputMaybe<Scalars['Boolean']>;
  testRunId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWhitelabelSiteTestRunBuildResponse = {
  __typename?: 'GetWhitelabelSiteTestRunBuildResponse';
  branch: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  envVariables: Maybe<Scalars['JSONObject']>;
  finishedAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['String']>;
  jobs: Maybe<Array<Maybe<BuildJobDetail>>>;
  startedAt: Maybe<Scalars['DateTime']>;
  state: Maybe<Scalars['String']>;
  webUrl: Maybe<Scalars['String']>;
};

export type GetWhitelabelSiteTestRunsRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWhitelabelSiteTestRunsResponse = {
  __typename?: 'GetWhitelabelSiteTestRunsResponse';
  testRuns: Maybe<Array<Maybe<WhitelabelSiteTestRun>>>;
};

export type GetWhitelabelSitesAdminRequestInput = {
  pagination?: InputMaybe<PaginationDetailsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type GetWhitelabelSitesAdminResponse = {
  __typename?: 'GetWhitelabelSitesAdminResponse';
  pagination: Maybe<PaginationDetails>;
  whitelabelSites: Maybe<Array<Maybe<WhitelabelSite>>>;
};

export type GetWhitelabelSitesRequestInput = {
  pagination?: InputMaybe<PaginationDetailsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type GetWhitelabelSitesResponse = {
  __typename?: 'GetWhitelabelSitesResponse';
  pagination: Maybe<PaginationDetails>;
  whitelabelSites: Maybe<Array<Maybe<WhitelabelSite>>>;
};

export type GoogleTypeDate = {
  __typename?: 'GoogleTypeDate';
  day: Maybe<Scalars['Int']>;
  month: Maybe<Scalars['Int']>;
  year: Maybe<Scalars['Int']>;
};

export type GoogleTypeDateInput = {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Represents a day of week. */
export enum GoogleTypeDayOfWeek {
  /** The unspecified day-of-week. */
  DayOfWeekUnspecified = 'DAY_OF_WEEK_UNSPECIFIED',
  /** The day-of-week of Friday. */
  Friday = 'FRIDAY',
  /** The day-of-week of Monday. */
  Monday = 'MONDAY',
  /** The day-of-week of Saturday. */
  Saturday = 'SATURDAY',
  /** The day-of-week of Sunday. */
  Sunday = 'SUNDAY',
  /** The day-of-week of Thursday. */
  Thursday = 'THURSDAY',
  /** The day-of-week of Tuesday. */
  Tuesday = 'TUESDAY',
  /** The day-of-week of Wednesday. */
  Wednesday = 'WEDNESDAY'
}

export type GoogleTypeLatLng = {
  __typename?: 'GoogleTypeLatLng';
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
};

/** Represents an amount of money with its currency type. */
export type GoogleTypeMoney = {
  __typename?: 'GoogleTypeMoney';
  /** The 3-letter currency code defined in ISO 4217. */
  currencyCode: Maybe<Scalars['String']>;
  /**
   * Number of nano (10^-9) units of the amount.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   */
  nanos: Maybe<Scalars['Int']>;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units: Maybe<Scalars['BigInt']>;
};

/** Represents an amount of money with its currency type. */
export type GoogleTypeMoneyInput = {
  /** The 3-letter currency code defined in ISO 4217. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /**
   * Number of nano (10^-9) units of the amount.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   */
  nanos?: InputMaybe<Scalars['Int']>;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units?: InputMaybe<Scalars['BigInt']>;
};

export type GoogleTypeTimeOfDay = {
  __typename?: 'GoogleTypeTimeOfDay';
  hours: Maybe<Scalars['Int']>;
  minutes: Maybe<Scalars['Int']>;
  nanos: Maybe<Scalars['Int']>;
  seconds: Maybe<Scalars['Int']>;
};

export type GoogleTypeTimeOfDayInput = {
  hours?: InputMaybe<Scalars['Int']>;
  minutes?: InputMaybe<Scalars['Int']>;
  nanos?: InputMaybe<Scalars['Int']>;
  seconds?: InputMaybe<Scalars['Int']>;
};

export type GrantImpersonationRequestInput = {
  clientContext?: InputMaybe<ClientContextInput>;
  impersonatedUserId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GrantImpersonationResponse = {
  __typename?: 'GrantImpersonationResponse';
  authorizationCode: Maybe<Scalars['String']>;
};

export type GridNavigation = {
  __typename?: 'GridNavigation';
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
  title: Maybe<Scalars['String']>;
};

export type GridNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Header = {
  __typename?: 'Header';
  desktopHeader: Maybe<UnionType>;
  mobileHeader: Maybe<UnionType>;
};

export type HealthCheck = {
  __typename?: 'HealthCheck';
  /** Server health status */
  alive: Scalars['True'];
  /** Postgresql health status */
  postgresql: Maybe<Scalars['Boolean']>;
  /** Redis health status */
  redis: Maybe<Scalars['Boolean']>;
  /** Snowflake health status */
  snowflake: Maybe<Scalars['Boolean']>;
};

export type HeroBanner = {
  __typename?: 'HeroBanner';
  backgroundColorHex: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaBackgroundColorHex: Maybe<Scalars['String']>;
  ctaColorHex: Maybe<Scalars['String']>;
  desktopImageUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  locale: Maybe<Scalars['String']>;
  mobileImageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  textAreaColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type HeroBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Scalars['String']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  textAreaColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

/** Autogenerated return type of HeroBannerPlacementCreate */
export type HeroBannerPlacementCreatePayload = {
  __typename?: 'HeroBannerPlacementCreatePayload';
  /** The newly created hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement;
};

export type HeroBannerPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** The images on the banner */
  images: GenericImagesInput;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The layout the placement should appear on */
  layout?: InputMaybe<Scalars['String']>;
  /** Locale */
  locale?: InputMaybe<BannerLocaleEnum>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The layout the placement should appear on */
  stringLayout?: InputMaybe<Scalars['String']>;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
  /** The color of the text area for placements (Eg. #FFFFFF) */
  textareaColor?: InputMaybe<Scalars['String']>;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** The variant of the banner */
  variant?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of HeroBannerPlacementUpdate */
export type HeroBannerPlacementUpdatePayload = {
  __typename?: 'HeroBannerPlacementUpdatePayload';
  /** The updated hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement;
};

export type HiddenSettingsInput = {
  /** Last seen RSAT pulse survey data */
  rsatPulseSurvey?: InputMaybe<RsatPulseSurveyInput>;
};

export type HighContrastColorsSchema = {
  __typename?: 'HighContrastColorsSchema';
  brandExpressDark: Maybe<Scalars['String']>;
  brandExpressExtraDark: Maybe<Scalars['String']>;
  brandExpressLight: Maybe<Scalars['String']>;
  brandExpressRegular: Maybe<Scalars['String']>;
  brandHighlightDark: Maybe<Scalars['String']>;
  brandHighlightLight: Maybe<Scalars['String']>;
  brandHighlightRegular: Maybe<Scalars['String']>;
  brandLoyaltyDark: Maybe<Scalars['String']>;
  brandLoyaltyLight: Maybe<Scalars['String']>;
  brandLoyaltyRegular: Maybe<Scalars['String']>;
  brandMaxDark: Maybe<Scalars['String']>;
  brandMaxLight: Maybe<Scalars['String']>;
  brandPrimaryDark: Maybe<Scalars['String']>;
  brandPrimaryExtraDark: Maybe<Scalars['String']>;
  brandPrimaryRegular: Maybe<Scalars['String']>;
  brandPromotionalDark: Maybe<Scalars['String']>;
  brandPromotionalLight: Maybe<Scalars['String']>;
  brandPromotionalRegular: Maybe<Scalars['String']>;
  brandSecondaryDark: Maybe<Scalars['String']>;
  brandSecondaryLight: Maybe<Scalars['String']>;
  brandSecondaryRegular: Maybe<Scalars['String']>;
};

export type HistoricalPerformanceOverviewRecord = {
  __typename?: 'HistoricalPerformanceOverviewRecord';
  currentValue: Maybe<InstacartTypesV1BigDecimal>;
  metricType: Maybe<MetricType>;
  pastValue: Maybe<InstacartTypesV1BigDecimal>;
};

export type HistoricalStorePerformanceRecord = {
  __typename?: 'HistoricalStorePerformanceRecord';
  dedicatedMatchRate: Maybe<InstacartTypesV1BigDecimal>;
  dedicatedUtilizationRate: Maybe<InstacartTypesV1BigDecimal>;
  fiveHourAvailabilityRate: Maybe<InstacartTypesV1BigDecimal>;
  fssOrdersCount: Maybe<Scalars['Int']>;
  matchRate: Maybe<InstacartTypesV1BigDecimal>;
  name: Maybe<Scalars['String']>;
  partnerPickOrdersCount: Maybe<Scalars['Int']>;
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>;
  scheduledGaps: Maybe<Scalars['Int']>;
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>;
  utilizationRate: Maybe<InstacartTypesV1BigDecimal>;
  warehouseLocationId: Maybe<Scalars['BigInt']>;
};

export type HistoricalStorePerformanceRequestInput = {
  devicePrioritizationEnabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<GoogleTypeDateInput>;
  metricThresholds?: InputMaybe<Array<InputMaybe<MetricThresholdInput>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type HistoricalStorePerformanceResponse = {
  __typename?: 'HistoricalStorePerformanceResponse';
  metrics: Maybe<Array<Maybe<HistoricalStorePerformanceRecord>>>;
  overviewMetrics: Maybe<Array<Maybe<HistoricalPerformanceOverviewRecord>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
  warehouseId: Maybe<Scalars['BigInt']>;
};

export type Holiday = {
  __typename?: 'Holiday';
  date: Maybe<GoogleTypeDate>;
  holidaySlug: Maybe<Scalars['String']>;
  regions: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HolidayStatus = {
  __typename?: 'HolidayStatus';
  confirmedRetailerLocationCount: Maybe<Scalars['Int']>;
  holiday: Maybe<Holiday>;
  unconfirmedRetailerLocationCount: Maybe<Scalars['Int']>;
};

/** Types of Home Placements which may be returned */
export type HomePlacement = ContentManagementFlyoutPlacement | ContentManagementHeroBannerPlacement | ContentManagementSecondaryBannerPlacement | ContentManagementUnknownBannerPlacement;

export type HubPaginationMeta = {
  __typename?: 'HubPaginationMeta';
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type IcPlusSchema = {
  __typename?: 'IcPlusSchema';
  enabledFeatures: Maybe<Array<Maybe<IcPlusSchemaIcPlusFeature>>>;
};

export enum IcPlusSchemaIcPlusFeature {
  CreditBack = 'CREDIT_BACK',
  EnterpriseUpsell = 'ENTERPRISE_UPSELL',
  Unknown = 'UNKNOWN',
  Upsell = 'UPSELL'
}

export type IdsThemeSchema = {
  __typename?: 'IdsThemeSchema';
  buttonBorderRadius: Maybe<BorderRadiusSchema>;
  colors: Maybe<ColorsSchema>;
  fonts: Maybe<Array<Maybe<CustomFontFamilySchema>>>;
  inputBorderRadius: Maybe<BorderRadiusSchema>;
  radius: Maybe<RadiusSchema>;
  typography: Maybe<TypographySchema>;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  altText: Maybe<Scalars['String']>;
  identifier: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ImageConfig = {
  __typename?: 'ImageConfig';
  caption: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  url: Maybe<Scalars['String']>;
};

export type ImageConfigInput = {
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ImageForward = {
  __typename?: 'ImageForward';
  backgroundColorHex: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaBackgroundColorHex: Maybe<Scalars['String']>;
  ctaColorHex: Maybe<Scalars['String']>;
  desktopImageUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  mobileImageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type ImageForwardFlex = {
  __typename?: 'ImageForwardFlex';
  backgroundColorHex: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaBackgroundColorHex: Maybe<Scalars['String']>;
  ctaColorHex: Maybe<Scalars['String']>;
  desktopImageUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  mobileImageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type ImageForwardFlexInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ImageForwardInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ImageUploadBatch = {
  __typename?: 'ImageUploadBatch';
  batchId: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  processedImageUploads: Maybe<Scalars['BigInt']>;
  state: Maybe<Scalars['String']>;
  successfulImageUploads: Maybe<Scalars['BigInt']>;
  totalImageUploads: Maybe<Scalars['BigInt']>;
};

export type ImageUploadBatchDetails = {
  __typename?: 'ImageUploadBatchDetails';
  filename: Maybe<Scalars['String']>;
  imageUploadId: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  isSuccessful: Maybe<Scalars['Boolean']>;
  productName: Maybe<Scalars['String']>;
};

export type ImageUploadBatchMetadata = {
  __typename?: 'ImageUploadBatchMetadata';
  perPage: Maybe<Scalars['BigInt']>;
  totalCount: Maybe<Scalars['BigInt']>;
  totalPages: Maybe<Scalars['BigInt']>;
};

export type ImagesAwsDetailsInput = {
  bucket?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

export type InStoreSchema = {
  __typename?: 'InStoreSchema';
  inStoreModeEnabled: Maybe<Scalars['Boolean']>;
  scanItemBarcodeEnabled: Maybe<Scalars['Boolean']>;
};

export type IndexBrandNamesRequestInput = {
  isDebug?: InputMaybe<Scalars['Boolean']>;
  superCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IndexBrandNamesResponse = {
  __typename?: 'IndexBrandNamesResponse';
  brandNameMappings: Maybe<Array<Maybe<BrandNameMapping>>>;
  brandProfileIdToName: Maybe<Scalars['String']>;
};

export type IndexEbpCategoriesRequestInput = {
  brandProfileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDebug?: InputMaybe<Scalars['Boolean']>;
};

export type IndexEbpCategoriesResponse = {
  __typename?: 'IndexEbpCategoriesResponse';
  superCategories: Maybe<Array<Maybe<Scalars['String']>>>;
  superCategoryIdToString: Maybe<Scalars['String']>;
};

export enum InstacartAdsNexusV1RegionalArea {
  Midwest = 'MIDWEST',
  Mountain = 'MOUNTAIN',
  Northeast = 'NORTHEAST',
  Pacific = 'PACIFIC',
  RegionalAreaUnknown = 'REGIONAL_AREA_UNKNOWN',
  Southeast = 'SOUTHEAST',
  Southwest = 'SOUTHWEST'
}

export enum InstacartAdsNexusV1StoreType {
  Alcohol = 'ALCOHOL',
  Asian = 'ASIAN',
  Baby = 'BABY',
  ClubWarehouse = 'CLUB_WAREHOUSE',
  Convenience = 'CONVENIENCE',
  ConventionalTraditional = 'CONVENTIONAL_TRADITIONAL',
  Coop = 'COOP',
  DepartmentStore = 'DEPARTMENT_STORE',
  Drugstore = 'DRUGSTORE',
  HomeKitchenBath = 'HOME_KITCHEN_BATH',
  LatinAmerican = 'LATIN_AMERICAN',
  LocalSpecialty = 'LOCAL_SPECIALTY',
  NaturalOrganic = 'NATURAL_ORGANIC',
  Other = 'OTHER',
  Pet = 'PET',
  StoreTypeUnknown = 'STORE_TYPE_UNKNOWN',
  Supplement = 'SUPPLEMENT',
  Value = 'VALUE'
}

export type InstacartAdsSharedV1DateRange = {
  __typename?: 'InstacartAdsSharedV1DateRange';
  endDate: Maybe<GoogleTypeDate>;
  startDate: Maybe<GoogleTypeDate>;
};

export type InstacartAdsSharedV1DateRangeInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type InstacartAdsSharedV1PaginationRequestInput = {
  page?: InputMaybe<Scalars['BigInt']>;
  resultsPerPage?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartAdsSharedV1PaginationResponse = {
  __typename?: 'InstacartAdsSharedV1PaginationResponse';
  page: Maybe<Scalars['BigInt']>;
  resultsPerPage: Maybe<Scalars['BigInt']>;
  totalPages: Maybe<Scalars['BigInt']>;
};

export type InstacartCatalogAdminV1ClientInput = {
  appName?: InputMaybe<Scalars['String']>;
  contextJson?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export enum InstacartCustomersCommerceTypesV1FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  Retailer = 'RETAILER'
}

export type InstacartCustomersCommerceTypesV1SlimOffer = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOffer';
  buyMAmountGetNQtyWithXPercentOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenario>;
  buyMAmountGetXAmountOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenario>;
  buyMAmountGetXPercentOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenario>;
  buyMAmountOfAGetBForXAmountPerUnitScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOfAGetBForXAmountScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenario>;
  buyMAmountOfAGetXAmountOffOnBScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenario>;
  buyMAmountOfAGetXPercentOffOnBScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenario>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenario>;
  buyMOfAGetBForXAmountPerUnitScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenario>;
  buyMQtyForXAmountScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenario>;
  buyMQtyGetNForFreeScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenario>;
  buyMQtyGetNQtyForXAmountScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenario>;
  buyMQtyGetNQtyWithXAmountOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenario>;
  buyMQtyGetNQtyWithXPercentOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenario>;
  buyMQtyGetXAmountOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenario>;
  buyMQtyGetXPercentOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenario>;
  buyMQtyOfAGetBForXAmountScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenario>;
  buyMQtyOfAGetXAmountOffOnBScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenario>;
  buyMQtyOfAGetXPercentOffOnBScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenario>;
  buyMQtyOrMoreForXAmountEachScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenario>;
  buyMQtyOrMoreGetXAmountOffEachScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenario>;
  buyMQtyOrMoreGetXAmountOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenario>;
  buyMQtyOrMoreGetXPercentOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenario>;
  buyMRangeQtyGetXPercentOffTieredScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenario>;
  buyMUnitsGetNUnitsForFreeScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenario>;
  buyMUnitsGetXAmountOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenario>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenario>;
  buyMUnitsGetXPercentOffScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenario>;
  buyMUnitsOfAGetXPercentOffOnBScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenario>;
  buyMWeightForXAmountPerWeightUnitScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenario>;
  buyMWeightGetXAmountOffPerWeightUnitScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenario>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenario>;
  conditionRewardString: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  discountCategoryId: Maybe<Scalars['BigInt']>;
  discountToken: Maybe<Scalars['String']>;
  endsAt: Maybe<Scalars['DateTime']>;
  fundingDetail: Maybe<InstacartCustomersCommerceTypesV1SlimOfferFundingDetail>;
  imageUrl: Maybe<Scalars['String']>;
  isLoyaltyOffer: Maybe<Scalars['Boolean']>;
  metadata: Maybe<InstacartCustomersCommerceTypesV1SlimOfferMetadata>;
  name: Maybe<Scalars['String']>;
  offerConditions: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferCondition>>>;
  offerExternalReference: Maybe<Scalars['String']>;
  offerId: Maybe<Scalars['String']>;
  offerLabelString: Maybe<Scalars['String']>;
  offerRequestKey: Maybe<Scalars['String']>;
  offerRewards: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferReward>>>;
  offerSource: Maybe<Scalars['String']>;
  offerStackability: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferStackability>;
  offerType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferType>;
  promoCode: Maybe<Scalars['String']>;
  redemptionLimits: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits>;
  startsAt: Maybe<Scalars['DateTime']>;
  terms: Maybe<Scalars['String']>;
  uncategorizedScenario: Maybe<InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenario>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenario';
  mUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  nQty: Maybe<InstacartTypesV1BigDecimal>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenario';
  mQty: Maybe<InstacartTypesV1BigDecimal>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenario';
  mQtyMax: Maybe<InstacartTypesV1BigDecimal>;
  mQtyMin: Maybe<InstacartTypesV1BigDecimal>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenarioInput = {
  mQtyMax?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  mQtyMin?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenario';
  currentTier: Maybe<Scalars['BigInt']>;
  tiers: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenario>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenarioInput = {
  currentTier?: InputMaybe<Scalars['BigInt']>;
  tiers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenarioInput>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenario';
  mUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
  nUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  nUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenario';
  mUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenario';
  mUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenario';
  mUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenario';
  mUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
  nUnits: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  nUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenario';
  mWeight: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenarioInput = {
  mWeight?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenario';
  mWeight: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenarioInput = {
  mWeight?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenario';
  mWeight: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenarioInput = {
  mWeight?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadata = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadata';
  retailerDepartmentTaxonomyCategories: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory>>>;
  taxonomyCategory: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadataInput = {
  retailerDepartmentTaxonomyCategories?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategoryInput>>>;
  taxonomyCategory?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategoryInput>>>;
};

export enum InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType {
  AmountOff = 'AMOUNT_OFF',
  AmountPerUnit = 'AMOUNT_PER_UNIT',
  AmountPerUnitWeight = 'AMOUNT_PER_UNIT_WEIGHT',
  DiscountRewardTypeUnspecified = 'DISCOUNT_REWARD_TYPE_UNSPECIFIED',
  PercentMille = 'PERCENT_MILLE',
  PercentMillePerUnit = 'PERCENT_MILLE_PER_UNIT',
  PercentOff = 'PERCENT_OFF',
  SetPrice = 'SET_PRICE',
  SetPricePerUnit = 'SET_PRICE_PER_UNIT',
  SetPricePerUnitWeight = 'SET_PRICE_PER_UNIT_WEIGHT'
}

export type InstacartCustomersCommerceTypesV1SlimOfferFundingDetail = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferFundingDetail';
  budgetLimit: Maybe<GoogleTypeMoney>;
  fundingProviderInfo: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferFundingDetailInput = {
  budgetLimit?: InputMaybe<GoogleTypeMoneyInput>;
  fundingProviderInfo?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformationInput>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation';
  percent: Maybe<Scalars['BigInt']>;
  source: Maybe<InstacartCustomersCommerceTypesV1FundingSource>;
  sourceName: Maybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformationInput = {
  percent?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<InstacartCustomersCommerceTypesV1FundingSource>;
  sourceName?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferInput = {
  buyMAmountGetNQtyWithXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenarioInput>;
  buyMAmountGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenarioInput>;
  buyMAmountGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenarioInput>;
  buyMAmountOfAGetBForXAmountPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenarioInput>;
  buyMAmountOfAGetBForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenarioInput>;
  buyMAmountOfAGetXAmountOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenarioInput>;
  buyMAmountOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenarioInput>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenarioInput>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenarioInput>;
  buyMOfAGetBForXAmountPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenarioInput>;
  buyMQtyForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenarioInput>;
  buyMQtyGetNForFreeScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenarioInput>;
  buyMQtyGetNQtyForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenarioInput>;
  buyMQtyGetNQtyWithXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenarioInput>;
  buyMQtyGetNQtyWithXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenarioInput>;
  buyMQtyGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenarioInput>;
  buyMQtyGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenarioInput>;
  buyMQtyOfAGetBForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenarioInput>;
  buyMQtyOfAGetXAmountOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenarioInput>;
  buyMQtyOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenarioInput>;
  buyMQtyOrMoreForXAmountEachScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenarioInput>;
  buyMQtyOrMoreGetXAmountOffEachScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenarioInput>;
  buyMQtyOrMoreGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenarioInput>;
  buyMQtyOrMoreGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenarioInput>;
  buyMRangeQtyGetXPercentOffTieredScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenarioInput>;
  buyMUnitsGetNUnitsForFreeScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenarioInput>;
  buyMUnitsGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenarioInput>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenarioInput>;
  buyMUnitsGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenarioInput>;
  buyMUnitsOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenarioInput>;
  buyMWeightForXAmountPerWeightUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenarioInput>;
  buyMWeightGetXAmountOffPerWeightUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenarioInput>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenarioInput>;
  conditionRewardString?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountToken?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  fundingDetail?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferFundingDetailInput>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isLoyaltyOffer?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferMetadataInput>;
  name?: InputMaybe<Scalars['String']>;
  offerConditions?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionInput>>>;
  offerExternalReference?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerLabelString?: InputMaybe<Scalars['String']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  offerRewards?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardInput>>>;
  offerSource?: InputMaybe<Scalars['String']>;
  offerStackability?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferStackability>;
  offerType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferType>;
  promoCode?: InputMaybe<Scalars['String']>;
  redemptionLimits?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimitsInput>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  terms?: InputMaybe<Scalars['String']>;
  uncategorizedScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenarioInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferLocaleCategories = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferLocaleCategories';
  category: Maybe<Array<Maybe<Scalars['String']>>>;
  locale: Maybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferLocaleCategoriesInput = {
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locale?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferMetadata = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferMetadata';
  categoryMetadata: Maybe<InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadata>;
  termsAndConditions: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditions>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferMetadataInput = {
  categoryMetadata?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadataInput>;
  termsAndConditions?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditionsInput>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferCondition = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferCondition';
  allowPartialApplication: Maybe<Scalars['Boolean']>;
  collectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  conditionProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedCollectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  maximumQuantity: Maybe<Scalars['BigInt']>;
  minimumQuantity: Maybe<Scalars['BigInt']>;
  minimumSpend: Maybe<GoogleTypeMoney>;
  offerConditionType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType>;
  retailerDepartments: Maybe<Array<Maybe<Scalars['String']>>>;
  serviceType: Maybe<InstacartCustomersSharedV1ServiceType>;
  taxonomyNodeIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferConditionInput = {
  allowPartialApplication?: InputMaybe<Scalars['Boolean']>;
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  conditionProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedCollectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  maximumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumSpend?: InputMaybe<GoogleTypeMoneyInput>;
  offerConditionType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType>;
  retailerDepartments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceType?: InputMaybe<InstacartCustomersSharedV1ServiceType>;
  taxonomyNodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType {
  OfferConditionTypeBasket = 'OFFER_CONDITION_TYPE_BASKET',
  OfferConditionTypeBrands = 'OFFER_CONDITION_TYPE_BRANDS',
  OfferConditionTypeCategories = 'OFFER_CONDITION_TYPE_CATEGORIES',
  OfferConditionTypeCollections = 'OFFER_CONDITION_TYPE_COLLECTIONS',
  OfferConditionTypeCommerceClassifications = 'OFFER_CONDITION_TYPE_COMMERCE_CLASSIFICATIONS',
  OfferConditionTypeFees = 'OFFER_CONDITION_TYPE_FEES',
  OfferConditionTypeProducts = 'OFFER_CONDITION_TYPE_PRODUCTS',
  OfferConditionTypeRegions = 'OFFER_CONDITION_TYPE_REGIONS',
  OfferConditionTypeRetailerDepartments = 'OFFER_CONDITION_TYPE_RETAILER_DEPARTMENTS',
  OfferConditionTypeUnspecified = 'OFFER_CONDITION_TYPE_UNSPECIFIED',
  OfferConditionTypeWeightUnit = 'OFFER_CONDITION_TYPE_WEIGHT_UNIT'
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits';
  redemptionLimit: Maybe<Scalars['BigInt']>;
  redemptionLimitPerOrder: Maybe<Scalars['BigInt']>;
  redemptionLimitPerUser: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimitsInput = {
  redemptionLimit?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerOrder?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferReward = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferReward';
  amountDiscount: Maybe<GoogleTypeMoney>;
  discountRewardType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType>;
  includeConditionGroup: Maybe<Scalars['Boolean']>;
  maximumDiscount: Maybe<GoogleTypeMoney>;
  offerPrice: Maybe<GoogleTypeMoney>;
  offerRewardType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType>;
  percentDiscount: Maybe<InstacartTypesV1BigDecimal>;
  quantityLimit: Maybe<Scalars['BigInt']>;
  rewardProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  serviceItemType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferServiceItemType>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRewardInput = {
  amountDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  discountRewardType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType>;
  includeConditionGroup?: InputMaybe<Scalars['Boolean']>;
  maximumDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  offerPrice?: InputMaybe<GoogleTypeMoneyInput>;
  offerRewardType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType>;
  percentDiscount?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  quantityLimit?: InputMaybe<Scalars['BigInt']>;
  rewardProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceItemType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferServiceItemType>;
};

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType {
  OfferRewardTypeBasket = 'OFFER_REWARD_TYPE_BASKET',
  OfferRewardTypeBrands = 'OFFER_REWARD_TYPE_BRANDS',
  OfferRewardTypeCategories = 'OFFER_REWARD_TYPE_CATEGORIES',
  OfferRewardTypeCollections = 'OFFER_REWARD_TYPE_COLLECTIONS',
  OfferRewardTypeProducts = 'OFFER_REWARD_TYPE_PRODUCTS',
  OfferRewardTypeRetailerDepartments = 'OFFER_REWARD_TYPE_RETAILER_DEPARTMENTS',
  OfferRewardTypeServiceItem = 'OFFER_REWARD_TYPE_SERVICE_ITEM',
  OfferRewardTypeUnspecified = 'OFFER_REWARD_TYPE_UNSPECIFIED',
  OfferRewardTypeWeightUnit = 'OFFER_REWARD_TYPE_WEIGHT_UNIT'
}

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferStackability {
  AlwaysStackable = 'ALWAYS_STACKABLE',
  NonStackable = 'NON_STACKABLE',
  OfferStackabilityUnspecified = 'OFFER_STACKABILITY_UNSPECIFIED',
  Stackable = 'STACKABLE'
}

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferType {
  AutoApply = 'AUTO_APPLY',
  AutoApplyCreditBack = 'AUTO_APPLY_CREDIT_BACK',
  AutoApplyInKindBack = 'AUTO_APPLY_IN_KIND_BACK',
  CheckoutCodeBasedDiscount = 'CHECKOUT_CODE_BASED_DISCOUNT',
  Coupon = 'COUPON',
  CouponBasedCreditBack = 'COUPON_BASED_CREDIT_BACK',
  CouponBasedInKindBack = 'COUPON_BASED_IN_KIND_BACK',
  OfferTypeUnspecified = 'OFFER_TYPE_UNSPECIFIED',
  PointsBasedDiscount = 'POINTS_BASED_DISCOUNT',
  ValueIssuedInKind = 'VALUE_ISSUED_IN_KIND'
}

export enum InstacartCustomersCommerceTypesV1SlimOfferServiceItemType {
  DeliveryFee = 'DELIVERY_FEE',
  ServiceItemTypeUnspecified = 'SERVICE_ITEM_TYPE_UNSPECIFIED'
}

export type InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory';
  localeCategories: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferLocaleCategories>>>;
  taxonomyLevel: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategoryInput = {
  localeCategories?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferLocaleCategoriesInput>>>;
  taxonomyLevel?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditions = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditions';
  locale: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditionsInput = {
  locale?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenario';
  _: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenarioInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export enum InstacartCustomersContentManagementAdminV1CartState {
  CartStateUnspecified = 'CART_STATE_UNSPECIFIED',
  Empty = 'EMPTY',
  InProgress = 'IN_PROGRESS',
  Qualified = 'QUALIFIED'
}

export type InstacartCustomersContentManagementAdminV1SlotCreative = {
  __typename?: 'InstacartCustomersContentManagementAdminV1SlotCreative';
  cartState: Maybe<InstacartCustomersContentManagementAdminV1CartState>;
  createdAt: Maybe<Scalars['DateTime']>;
  creativeId: Maybe<Scalars['BigInt']>;
  creativeRank: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  slotId: Maybe<Scalars['BigInt']>;
  treatmentOfferState: Maybe<InstacartCustomersContentManagementAdminV1TreatmentOfferState>;
  treatmentPolicyId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type InstacartCustomersContentManagementAdminV1SlotCreativeInput = {
  cartState?: InputMaybe<InstacartCustomersContentManagementAdminV1CartState>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<InstacartCustomersContentManagementAdminV1TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum InstacartCustomersContentManagementAdminV1TreatmentOfferState {
  Activated = 'ACTIVATED',
  Applied = 'APPLIED',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Redeemed = 'REDEEMED',
  TreatmentOfferStateUnspecified = 'TREATMENT_OFFER_STATE_UNSPECIFIED',
  Unredeemable = 'UNREDEEMABLE'
}

export type InstacartCustomersContentManagementV1Authentication = {
  __typename?: 'InstacartCustomersContentManagementV1Authentication';
  postAuthPaths: Maybe<InstacartCustomersContentManagementV1PostAuthPaths>;
};

export type InstacartCustomersContentManagementV1AuthenticationInput = {
  postAuthPaths?: InputMaybe<InstacartCustomersContentManagementV1PostAuthPathsInput>;
};

export type InstacartCustomersContentManagementV1BannerAction = {
  __typename?: 'InstacartCustomersContentManagementV1BannerAction';
  dismissBusinessIdentication: Maybe<InstacartCustomersContentManagementV1DismissBusinessIdentication>;
  doNotNavigate: Maybe<InstacartCustomersContentManagementV1DoNotNavigate>;
  navigateToAskInstacart: Maybe<InstacartCustomersContentManagementV1NavigateToAskInstacart>;
  navigateToAuthentication: Maybe<InstacartCustomersContentManagementV1NavigateToAuthentication>;
  navigateToBenefitsModal: Maybe<InstacartCustomersContentManagementV1NavigateToBenefitsModal>;
  navigateToCategorySurface: Maybe<InstacartCustomersContentManagementV1NavigateToCategorySurface>;
  navigateToCollaborativeShopInfoModal: Maybe<InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModal>;
  navigateToCollection: Maybe<InstacartCustomersContentManagementV1NavigateToCollection>;
  navigateToCollectionHub: Maybe<InstacartCustomersContentManagementV1NavigateToCollectionHub>;
  navigateToContainerPathViaStoreselector: Maybe<InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelector>;
  navigateToContentPage: Maybe<InstacartCustomersContentManagementV1NavigateToContentPage>;
  navigateToCouponRedemption: Maybe<InstacartCustomersContentManagementV1NavigateToCouponRedemption>;
  navigateToDepartment: Maybe<InstacartCustomersContentManagementV1NavigateToDepartment>;
  navigateToExpressAccountPage: Maybe<InstacartCustomersContentManagementV1NavigateToExpressAccountPage>;
  navigateToFlyers: Maybe<InstacartCustomersContentManagementV1NavigateToFlyers>;
  navigateToHouseholdAccountSharingFlow: Maybe<InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlow>;
  navigateToPartnershipModal: Maybe<InstacartCustomersContentManagementV1NavigateToPartnershipModal>;
  navigateToPickupStoreselector: Maybe<InstacartCustomersContentManagementV1NavigateToPickupStoreSelector>;
  navigateToProduct: Maybe<InstacartCustomersContentManagementV1NavigateToProduct>;
  navigateToPromoModal: Maybe<InstacartCustomersContentManagementV1NavigateToPromoModal>;
  navigateToPromotionDetail: Maybe<InstacartCustomersContentManagementV1NavigateToPromotionDetail>;
  navigateToRetailerCollection: Maybe<InstacartCustomersContentManagementV1NavigateToRetailerCollection>;
  navigateToRetailerCollectionViaStoreselector: Maybe<InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelector>;
  navigateToSsaStoreselector: Maybe<InstacartCustomersContentManagementV1NavigateToSsaStoreSelector>;
  navigateToStorefront: Maybe<InstacartCustomersContentManagementV1NavigateToStorefront>;
  navigateToStoreselector: Maybe<InstacartCustomersContentManagementV1NavigateToStoreSelector>;
  navigateToUrl: Maybe<InstacartCustomersContentManagementV1NavigateToUrl>;
  openExpressPaidModal: Maybe<InstacartCustomersContentManagementV1OpenExpressPaidModal>;
  openExpressTrialModal: Maybe<InstacartCustomersContentManagementV1OpenExpressTrialModal>;
  optInUser: Maybe<InstacartCustomersContentManagementV1OptInUser>;
  redeemPartnershipOffer: Maybe<InstacartCustomersContentManagementV1RedeemPartnershipOffer>;
  renewSubscriptionIntoAnnual: Maybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnual>;
  renewSubscriptionIntoMonthly: Maybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthly>;
};

export type InstacartCustomersContentManagementV1BannerActionInput = {
  dismissBusinessIdentication?: InputMaybe<InstacartCustomersContentManagementV1DismissBusinessIdenticationInput>;
  doNotNavigate?: InputMaybe<InstacartCustomersContentManagementV1DoNotNavigateInput>;
  navigateToAskInstacart?: InputMaybe<InstacartCustomersContentManagementV1NavigateToAskInstacartInput>;
  navigateToAuthentication?: InputMaybe<InstacartCustomersContentManagementV1NavigateToAuthenticationInput>;
  navigateToBenefitsModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToBenefitsModalInput>;
  navigateToCategorySurface?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCategorySurfaceInput>;
  navigateToCollaborativeShopInfoModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModalInput>;
  navigateToCollection?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCollectionInput>;
  navigateToCollectionHub?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCollectionHubInput>;
  navigateToContainerPathViaStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelectorInput>;
  navigateToContentPage?: InputMaybe<InstacartCustomersContentManagementV1NavigateToContentPageInput>;
  navigateToCouponRedemption?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCouponRedemptionInput>;
  navigateToDepartment?: InputMaybe<InstacartCustomersContentManagementV1NavigateToDepartmentInput>;
  navigateToExpressAccountPage?: InputMaybe<InstacartCustomersContentManagementV1NavigateToExpressAccountPageInput>;
  navigateToFlyers?: InputMaybe<InstacartCustomersContentManagementV1NavigateToFlyersInput>;
  navigateToHouseholdAccountSharingFlow?: InputMaybe<InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlowInput>;
  navigateToPartnershipModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPartnershipModalInput>;
  navigateToPickupStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPickupStoreSelectorInput>;
  navigateToProduct?: InputMaybe<InstacartCustomersContentManagementV1NavigateToProductInput>;
  navigateToPromoModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPromoModalInput>;
  navigateToPromotionDetail?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPromotionDetailInput>;
  navigateToRetailerCollection?: InputMaybe<InstacartCustomersContentManagementV1NavigateToRetailerCollectionInput>;
  navigateToRetailerCollectionViaStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelectorInput>;
  navigateToSsaStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToSsaStoreSelectorInput>;
  navigateToStorefront?: InputMaybe<InstacartCustomersContentManagementV1NavigateToStorefrontInput>;
  navigateToStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToStoreSelectorInput>;
  navigateToUrl?: InputMaybe<InstacartCustomersContentManagementV1NavigateToUrlInput>;
  openExpressPaidModal?: InputMaybe<InstacartCustomersContentManagementV1OpenExpressPaidModalInput>;
  openExpressTrialModal?: InputMaybe<InstacartCustomersContentManagementV1OpenExpressTrialModalInput>;
  optInUser?: InputMaybe<InstacartCustomersContentManagementV1OptInUserInput>;
  redeemPartnershipOffer?: InputMaybe<InstacartCustomersContentManagementV1RedeemPartnershipOfferInput>;
  renewSubscriptionIntoAnnual?: InputMaybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnualInput>;
  renewSubscriptionIntoMonthly?: InputMaybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthlyInput>;
};

export enum InstacartCustomersContentManagementV1BusinessDerivedAttributesSourceType {
  LangchainAi = 'LANGCHAIN_AI'
}

export enum InstacartCustomersContentManagementV1CategorySurfaceType {
  AlcoholSurface = 'ALCOHOL_SURFACE',
  RetailerRecommendation = 'RETAILER_RECOMMENDATION'
}

export type InstacartCustomersContentManagementV1DismissBusinessIdentication = {
  __typename?: 'InstacartCustomersContentManagementV1DismissBusinessIdentication';
  id: Maybe<Scalars['BigInt']>;
  source: Maybe<InstacartCustomersContentManagementV1BusinessDerivedAttributesSourceType>;
};

export type InstacartCustomersContentManagementV1DismissBusinessIdenticationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<InstacartCustomersContentManagementV1BusinessDerivedAttributesSourceType>;
};

export type InstacartCustomersContentManagementV1DoNotNavigate = {
  __typename?: 'InstacartCustomersContentManagementV1DoNotNavigate';
  recordClickAttempt: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1DoNotNavigateInput = {
  recordClickAttempt?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToAskInstacart = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToAskInstacart';
  prompt: Maybe<Scalars['String']>;
  useBusinessDerivedAttributes: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToAskInstacartInput = {
  prompt?: InputMaybe<Scalars['String']>;
  useBusinessDerivedAttributes?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToAuthentication = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToAuthentication';
  authentication: Maybe<InstacartCustomersContentManagementV1Authentication>;
};

export type InstacartCustomersContentManagementV1NavigateToAuthenticationInput = {
  authentication?: InputMaybe<InstacartCustomersContentManagementV1AuthenticationInput>;
};

export type InstacartCustomersContentManagementV1NavigateToBenefitsModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToBenefitsModal';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToBenefitsModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToCategorySurface = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCategorySurface';
  categorySurfaceType: Maybe<InstacartCustomersContentManagementV1CategorySurfaceType>;
};

export type InstacartCustomersContentManagementV1NavigateToCategorySurfaceInput = {
  categorySurfaceType?: InputMaybe<InstacartCustomersContentManagementV1CategorySurfaceType>;
};

export type InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModal';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollection = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCollection';
  legacyPath: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollectionHub = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCollectionHub';
  category: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollectionHubInput = {
  category?: InputMaybe<Scalars['String']>;
  collection?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollectionInput = {
  legacyPath?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelector';
  retailers: Maybe<Array<Maybe<InstacartCustomersContentManagementV1RetailerContainerPath>>>;
};

export type InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelectorInput = {
  retailers?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementV1RetailerContainerPathInput>>>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPage = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToContentPage';
  slug: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPageInput = {
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToCouponRedemption = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCouponRedemption';
  couponCode: Maybe<Scalars['String']>;
  landingUrl: Maybe<Scalars['String']>;
  validateDays: Maybe<Scalars['BigInt']>;
  visibleAfterRedeem: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToCouponRedemptionInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  landingUrl?: InputMaybe<Scalars['String']>;
  validateDays?: InputMaybe<Scalars['BigInt']>;
  visibleAfterRedeem?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToDepartment = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToDepartment';
  departmentId: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToDepartmentInput = {
  departmentId?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToExpressAccountPage = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToExpressAccountPage';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToExpressAccountPageInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToFlyers = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToFlyers';
  isDigitalFlyer: Maybe<Scalars['Boolean']>;
  tag: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToFlyersInput = {
  isDigitalFlyer?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlow = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlow';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlowInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPartnershipModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPartnershipModal';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPartnershipModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPickupStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPickupStoreSelector';
  showDistance: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToPickupStoreSelectorInput = {
  showDistance?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToProduct = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToProduct';
  productId: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToProductInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromoModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPromoModal';
  discountPolicyId: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromoModalInput = {
  discountPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromotionDetail = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPromotionDetail';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromotionDetailInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollection = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToRetailerCollection';
  retailerId: Maybe<Scalars['BigInt']>;
  slug: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelector';
  retailerCollections: Maybe<Array<Maybe<InstacartCustomersContentManagementV1RetailerCollection>>>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelectorInput = {
  retailerCollections?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementV1RetailerCollectionInput>>>;
};

export type InstacartCustomersContentManagementV1NavigateToSsaStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToSsaStoreSelector';
  serviceAreaType: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToSsaStoreSelectorInput = {
  serviceAreaType?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToStoreSelector';
  collectionSlug: Maybe<Scalars['String']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  storeForwardModuleType: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToStoreSelectorInput = {
  collectionSlug?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeForwardModuleType?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToStorefront = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToStorefront';
  retailerId: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToStorefrontInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToUrl = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToUrl';
  openInNewTab: Maybe<Scalars['Boolean']>;
  openInNewWindow: Maybe<Scalars['Boolean']>;
  url: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToUrlInput = {
  openInNewTab?: InputMaybe<Scalars['Boolean']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1OpenExpressPaidModal = {
  __typename?: 'InstacartCustomersContentManagementV1OpenExpressPaidModal';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OpenExpressPaidModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OpenExpressTrialModal = {
  __typename?: 'InstacartCustomersContentManagementV1OpenExpressTrialModal';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OpenExpressTrialModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OptInUser = {
  __typename?: 'InstacartCustomersContentManagementV1OptInUser';
  id: Maybe<Scalars['BigInt']>;
  optOut: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1OptInUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  optOut?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1PostAuthPaths = {
  __typename?: 'InstacartCustomersContentManagementV1PostAuthPaths';
  loginPath: Maybe<Scalars['String']>;
  signupPath: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1PostAuthPathsInput = {
  loginPath?: InputMaybe<Scalars['String']>;
  signupPath?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RedeemPartnershipOffer = {
  __typename?: 'InstacartCustomersContentManagementV1RedeemPartnershipOffer';
  partnershipBenefitName: Maybe<Scalars['String']>;
  partnershipOfferName: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RedeemPartnershipOfferInput = {
  partnershipBenefitName?: InputMaybe<Scalars['String']>;
  partnershipOfferName?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnual = {
  __typename?: 'InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnual';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnualInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthly = {
  __typename?: 'InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthly';
  id: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthlyInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RetailerCollection = {
  __typename?: 'InstacartCustomersContentManagementV1RetailerCollection';
  retailerId: Maybe<Scalars['BigInt']>;
  slug: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RetailerContainerPath = {
  __typename?: 'InstacartCustomersContentManagementV1RetailerContainerPath';
  containerPath: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RetailerContainerPathInput = {
  containerPath?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export enum InstacartCustomersProductsV1StockLevel {
  HighlyInStock = 'HIGHLY_IN_STOCK',
  InStock = 'IN_STOCK',
  LowStock = 'LOW_STOCK',
  NotWorthAdvertisingFor = 'NOT_WORTH_ADVERTISING_FOR',
  OutOfStock = 'OUT_OF_STOCK',
  SeverelyLowStock = 'SEVERELY_LOW_STOCK'
}

export enum InstacartCustomersSharedV1Locale {
  DeAt = 'DE_AT',
  EnAt = 'EN_AT',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnUk = 'EN_UK',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  EsSp = 'ES_SP',
  EsUs = 'ES_US',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  LocaleUnspecified = 'LOCALE_UNSPECIFIED'
}

export enum InstacartCustomersSharedV1OrderAttributeDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type InstacartCustomersSharedV1OrderAttributeInput = {
  direction?: InputMaybe<InstacartCustomersSharedV1OrderAttributeDirection>;
  name?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersSharedV1OrderInput = {
  attributes?: InputMaybe<Array<InputMaybe<InstacartCustomersSharedV1OrderAttributeInput>>>;
};

/** Represents pagination info extracted from Domain::PageInfo objects */
export type InstacartCustomersSharedV1PageInfo = {
  __typename?: 'InstacartCustomersSharedV1PageInfo';
  /** The last cursor of the current page */
  endCursor: Maybe<Scalars['String']>;
  /** Indicates whether or not there is a next page */
  hasNextPage: Maybe<Scalars['Boolean']>;
};

/** Pagination request parameters for Domain::Shared::Pagination */
export type InstacartCustomersSharedV1PaginationInput = {
  /** Cursor to start from when fetching. */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type InstacartCustomersSharedV1RequestContext = {
  __typename?: 'InstacartCustomersSharedV1RequestContext';
  clientConfigurationId: Maybe<Scalars['Int']>;
  countryId: Maybe<Scalars['Int']>;
  storeConfigurationId: Maybe<Scalars['Int']>;
};

export type InstacartCustomersSharedV1RequestContextInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum InstacartCustomersSharedV1ServiceType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  Pickup = 'PICKUP',
  ScanAndPay = 'SCAN_AND_PAY',
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  Virtual = 'VIRTUAL'
}

export type InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1AddressInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1AddressInformation';
  city: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  streetName: Maybe<Scalars['String']>;
  unitNumber: Maybe<Scalars['String']>;
  zipCode: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1CustomerInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1CustomerInformation';
  customerEmail: Maybe<Scalars['String']>;
  customerFirstName: Maybe<Scalars['String']>;
  customerFullName: Maybe<Scalars['String']>;
  customerLastName: Maybe<Scalars['String']>;
  customerPhoneNumber: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrder = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrder';
  addressInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1AddressInformation>;
  addressLatitude: Maybe<Scalars['Float']>;
  addressLongitude: Maybe<Scalars['Float']>;
  alcoholic: Maybe<Scalars['Boolean']>;
  areDeliveryOrderPhotosExpired: Maybe<Scalars['Boolean']>;
  cancellationOrigin: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCancellationOrigin>;
  cancellationReason: Maybe<Scalars['String']>;
  carModelAndColor: Maybe<Scalars['String']>;
  customerContext: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext>;
  customerInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1CustomerInformation>;
  dashboardOptions: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions>;
  deliveryPhotos: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderDeliveryPhoto>>>;
  displayId: Maybe<Scalars['BigInt']>;
  estimatedDeliveryTime: Maybe<Scalars['DateTime']>;
  estimatedPickupTime: Maybe<Scalars['DateTime']>;
  externalId: Maybe<Scalars['String']>;
  formattedTipAmount: Maybe<Scalars['String']>;
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>;
  id: Maybe<Scalars['BigInt']>;
  initialTip: Maybe<Scalars['Float']>;
  isExpress: Maybe<Scalars['Boolean']>;
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  orderHistoryEvents: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent>>>;
  previouslyRescheduled: Maybe<Scalars['Boolean']>;
  retailerProvidedAmounts: Maybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts>;
  shopperAvatarUrl: Maybe<Scalars['String']>;
  shopperFirstName: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
  warehouseId: Maybe<Scalars['Int']>;
  warehouseLocationId: Maybe<Scalars['BigInt']>;
  warehouseLocationName: Maybe<Scalars['String']>;
  workflowState: Maybe<Scalars['String']>;
};

export enum InstacartEnterpriseBobaCoreTypesV1DashboardOrderCancellationOrigin {
  CancellationOriginUnspecified = 'CANCELLATION_ORIGIN_UNSPECIFIED',
  Customer = 'CUSTOMER',
  Instacart = 'INSTACART',
  Other = 'OTHER',
  Retailer = 'RETAILER',
  Shopper = 'SHOPPER'
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext';
  clientConfigurationId: Maybe<Scalars['Int']>;
  countryId: Maybe<Scalars['Int']>;
  storeConfigurationId: Maybe<Scalars['Int']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderDeliveryPhoto = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderDeliveryPhoto';
  id: Maybe<Scalars['BigInt']>;
  photoUrl: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions';
  leaveUnattended: Maybe<Scalars['Boolean']>;
  specialInstructions: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummary = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummary';
  bagCount: Maybe<Scalars['Int']>;
  bagLabel: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  deliveryWindow: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryDeliveryWindow>;
  fulfillmentTimes: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryFulfillmentTimes>;
  id: Maybe<Scalars['BigInt']>;
  legacyOrderId: Maybe<Scalars['BigInt']>;
  orderReference: Maybe<Scalars['String']>;
  orderStatus: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryOrderStatus>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  retailerReferenceId: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryDeliveryWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryDeliveryWindow';
  windowEndsAt: Maybe<Scalars['DateTime']>;
  windowStartsAt: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryFulfillmentTimes = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryFulfillmentTimes';
  shopperDeliveredAt: Maybe<Scalars['DateTime']>;
  shopperDispatchedAt: Maybe<Scalars['DateTime']>;
  shopperEstimatedDeliveredAt: Maybe<Scalars['DateTime']>;
  shopperEstimatedPickedAt: Maybe<Scalars['DateTime']>;
  shopperPickedAt: Maybe<Scalars['DateTime']>;
  shopperStartedDeliveryAt: Maybe<Scalars['DateTime']>;
};

export enum InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryOrderStatus {
  OrderCancelled = 'ORDER_CANCELLED',
  OrderComplete = 'ORDER_COMPLETE',
  OrderDelayed = 'ORDER_DELAYED',
  OrderEnRoute = 'ORDER_EN_ROUTE',
  OrderInProgress = 'ORDER_IN_PROGRESS',
  OrderPlaced = 'ORDER_PLACED',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY'
}

export type InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails';
  addressId: Maybe<Scalars['BigInt']>;
  fulfillmentType: Maybe<Scalars['String']>;
  numOfBags: Maybe<Scalars['BigInt']>;
  serviceOptionId: Maybe<Scalars['BigInt']>;
  warehouseLocationId: Maybe<Scalars['BigInt']>;
  windowEndsAt: Maybe<Scalars['DateTime']>;
  windowStartsAt: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ItemReplacement = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ItemReplacement';
  itemRrc: Maybe<Scalars['String']>;
  itemUpc: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput = {
  addressCreationParams?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput>;
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  endAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>;
  initialTip?: InputMaybe<Scalars['Float']>;
  locale?: InputMaybe<Scalars['String']>;
  locationCode?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput>;
  retailerProvidedAmounts?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput>;
  serviceOptionId?: InputMaybe<Scalars['BigInt']>;
  serviceOptionReference?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
  userBirthday?: InputMaybe<Scalars['String']>;
  userCreationParams?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput>;
  userPhone?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ModificationEventInput = {
  reason?: InputMaybe<Scalars['String']>;
  reasonDetailed?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType>;
};

export enum InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType {
  Rpp = 'RPP',
  UserTypeUnspecified = 'USER_TYPE_UNSPECIFIED'
}

export type InstacartEnterpriseBobaCoreTypesV1Order = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1Order';
  batchId: Maybe<Scalars['BigInt']>;
  canceledAt: Maybe<Scalars['DateTime']>;
  cancellationReason: Maybe<Scalars['String']>;
  cancellationType: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  deliveryEta: Maybe<Scalars['DateTime']>;
  displayId: Maybe<Scalars['BigInt']>;
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalData>;
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>;
  id: Maybe<Scalars['BigInt']>;
  isExpress: Maybe<Scalars['Boolean']>;
  locale: Maybe<Scalars['String']>;
  loyaltyCardId: Maybe<Scalars['BigInt']>;
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  postCheckoutLink: Maybe<Scalars['String']>;
  statusUrl: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  userId: Maybe<Scalars['BigInt']>;
  warehouseId: Maybe<Scalars['BigInt']>;
  warnings: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderWarning>>>;
  workflowState: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderExternalData';
  externalId: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput = {
  externalId?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent';
  action: Maybe<Scalars['String']>;
  actionedAt: Maybe<Scalars['DateTime']>;
  windowEndsAt: Maybe<Scalars['DateTime']>;
  windowStartsAt: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItem = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItem';
  createdAt: Maybe<Scalars['DateTime']>;
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData>;
  id: Maybe<Scalars['BigInt']>;
  isAddOnItem: Maybe<Scalars['Boolean']>;
  itemCodes: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemCodes>;
  itemId: Maybe<Scalars['BigInt']>;
  itemProperties: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemProperties>;
  itemType: Maybe<Scalars['String']>;
  orderId: Maybe<Scalars['BigInt']>;
  pickedAt: Maybe<Scalars['DateTime']>;
  quantity: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity>;
  replacementItem: Maybe<InstacartEnterpriseBobaCoreTypesV1ItemReplacement>;
  replacementPolicy: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  substituteId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemCodes = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemCodes';
  deliveredRrc: Maybe<Scalars['String']>;
  deliveredUpc: Maybe<Scalars['String']>;
  requestedRrc: Maybe<Scalars['String']>;
  requestedUpc: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData';
  itemRrc: Maybe<Scalars['String']>;
  itemUpc: Maybe<Scalars['String']>;
  lineNum: Maybe<Scalars['String']>;
  scanCode: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemProperties = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemProperties';
  name: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  productType: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity';
  countDelivered: Maybe<Scalars['Int']>;
  countOrdered: Maybe<Scalars['Int']>;
  unit: Maybe<Scalars['String']>;
  weightDelivered: Maybe<Scalars['Float']>;
  weightOrdered: Maybe<Scalars['Float']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput = {
  leaveUnattended?: InputMaybe<Scalars['Boolean']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderWarning = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderWarning';
  errorCode: Maybe<Scalars['Int']>;
  itemCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  message: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput = {
  canceledExternalOrderId?: InputMaybe<Scalars['String']>;
  canceledOrderId?: InputMaybe<Scalars['BigInt']>;
  endAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>;
  serviceOptionId?: InputMaybe<Scalars['BigInt']>;
  serviceOptionReference?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput = {
  endAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  serviceOptionId?: InputMaybe<Scalars['BigInt']>;
  serviceOptionReference?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts';
  bagLabel: Maybe<Scalars['String']>;
  bagScanCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  bagsCount: Maybe<Scalars['Int']>;
  cartTotal: Maybe<Scalars['Float']>;
  itemsCount: Maybe<Scalars['Int']>;
  itemsWeight: Maybe<Scalars['Float']>;
};

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput = {
  bagLabel?: InputMaybe<Scalars['String']>;
  bagScanCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bagsCount?: InputMaybe<Scalars['Int']>;
  cartTotal?: InputMaybe<Scalars['Float']>;
  itemsCount?: InputMaybe<Scalars['Int']>;
  itemsWeight?: InputMaybe<Scalars['Float']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOption = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOption';
  asapWindow: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow>;
  availability: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability>;
  date: Maybe<GoogleTypeDate>;
  id: Maybe<Scalars['BigInt']>;
  immediateWindow: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow>;
  scheduledWindow: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow>;
  serviceOptionReference: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  warehouseId: Maybe<Scalars['Int']>;
  warehouseLocationId: Maybe<Scalars['Int']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow';
  asap: Maybe<Scalars['Boolean']>;
  descriptor: Maybe<Scalars['String']>;
  endAt: Maybe<Scalars['DateTime']>;
  startAt: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability';
  available: Maybe<Scalars['Boolean']>;
  itemCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  reasons: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow';
  descriptor: Maybe<Scalars['String']>;
  endAt: Maybe<Scalars['DateTime']>;
  immediateHour: Maybe<Scalars['Int']>;
  startAt: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow';
  descriptor: Maybe<Scalars['String']>;
  endAt: Maybe<Scalars['DateTime']>;
  startAt: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userPhone?: InputMaybe<Scalars['String']>;
};

export type InstacartStoreConfiguration = {
  __typename?: 'InstacartStoreConfiguration';
  /** Indicates if the Store Configuration is active or not */
  active: Scalars['Boolean'];
  /** Flag to indicate if this StoreConfiguration is associated to all warehouses */
  allowAllWarehouses: Scalars['Boolean'];
  /** The brand name as customers would see on Instacart, PBI, etc */
  brandedName: Scalars['String'];
  /** The list of associated client configurations */
  clientConfigurationIds: Maybe<Array<Scalars['ID']>>;
  /** When the Store Configuration was created */
  createdAt: Scalars['Time'];
  /** Unata, etc... */
  deApplicationPlatform: Maybe<Scalars['String']>;
  /** The domain name of the Storefront (eg. costco.ca) */
  domainName: Maybe<Scalars['String']>;
  /** A unique identifier for the Store Configuration */
  id: Scalars['ID'];
  /** Legal data */
  legal: Maybe<InstacartStoreConfigurationLegal>;
  /** The primary logo URL */
  logoUrl: Scalars['String'];
  /** The rules on how Partners can access this Store Configuration */
  partnerAccessSettings: InstacartStoreConfigurationPartnerAccessSettings;
  /** The unique slug for this Store Configuration */
  slug: Scalars['String'];
  /** When the Store Configuration was last updated */
  updatedAt: Scalars['Time'];
  /** Indicates if the user is permitted to modify data related to this Store Configuration */
  userAccessToModify: Scalars['Boolean'];
  /** The unique identifier for the User Isolation Context this Store Configuration uses */
  userIsolationContextId: Scalars['ID'];
  /** The list of associated warehouses */
  whitelistedWarehouseIds: Maybe<Array<Scalars['ID']>>;
};

export type InstacartStoreConfigurationLegal = {
  __typename?: 'InstacartStoreConfigurationLegal';
  /** The shorter name for business entity */
  shortName: Scalars['String'];
};

export type InstacartStoreConfigurationModificationRules = {
  __typename?: 'InstacartStoreConfigurationModificationRules';
  /** The list of Partner IDs who are permitted to make modificaftions to this Store Configuration */
  allowlistPartnerIds: Maybe<Array<Scalars['ID']>>;
};

export type InstacartStoreConfigurationPartnerAccessSettings = {
  __typename?: 'InstacartStoreConfigurationPartnerAccessSettings';
  /** The ruleset for allowing modifications for this Store Configuration */
  modificationRules: Maybe<InstacartStoreConfigurationModificationRules>;
  /** True if Partners are allow to view this Store Configuration on IPP */
  visibleToPartnersOnIpp: Scalars['Boolean'];
};

export type InstacartTypesV1BigDecimal = {
  __typename?: 'InstacartTypesV1BigDecimal';
  nanos: Maybe<Scalars['Int']>;
  units: Maybe<Scalars['BigInt']>;
};

export type InstacartTypesV1BigDecimalInput = {
  nanos?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartTypesV1MeasuredQuantity = {
  __typename?: 'InstacartTypesV1MeasuredQuantity';
  quantity: Maybe<Scalars['Float']>;
  unit: Maybe<InstacartTypesV1MeasurementUnit>;
};

export type InstacartTypesV1MeasuredQuantityInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<InstacartTypesV1MeasurementUnitInput>;
};

export type InstacartTypesV1MeasurementUnit = {
  __typename?: 'InstacartTypesV1MeasurementUnit';
  costUnit: Maybe<InstacartTypesV1MeasurementUnitCostUnit>;
  unitCode: Maybe<Scalars['String']>;
};

export enum InstacartTypesV1MeasurementUnitCostUnit {
  CostUnitUnspecified = 'COST_UNIT_UNSPECIFIED',
  Each = 'EACH',
  FlOz = 'FL_OZ',
  Gallon = 'GALLON',
  Gram = 'GRAM',
  Kg = 'KG',
  Lb = 'LB',
  Liter = 'LITER',
  Ml = 'ML',
  Oz = 'OZ',
  Pint = 'PINT',
  Quart = 'QUART'
}

export type InstacartTypesV1MeasurementUnitInput = {
  costUnit?: InputMaybe<InstacartTypesV1MeasurementUnitCostUnit>;
  unitCode?: InputMaybe<Scalars['String']>;
};

export type InstacartTypesV1RequestContextInput = {
  applicationId?: InputMaybe<Scalars['Int']>;
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export type Investigation = {
  __typename?: 'Investigation';
  createdAt: Maybe<Scalars['DateTime']>;
  createdBy: Maybe<Scalars['JSONObject']>;
  id: Maybe<Scalars['BigInt']>;
  investigationParameters: Maybe<Scalars['JSONObject']>;
  investigationType: Maybe<InvestigationType>;
  patchApprovalId: Maybe<Scalars['String']>;
  patchCreatedAt: Maybe<Scalars['DateTime']>;
  patchCreatedBy: Maybe<Scalars['JSONObject']>;
  patchDeletedAt: Maybe<Scalars['DateTime']>;
  patchDeletedBy: Maybe<Scalars['JSONObject']>;
  patchDetails: Maybe<Scalars['String']>;
  patchId: Maybe<Scalars['String']>;
  patchStatus: Maybe<PatchStatus>;
  priceHistorySummary: Maybe<Scalars['JSONObject']>;
  reason: Maybe<Scalars['String']>;
  resultsFileUrl: Maybe<Scalars['String']>;
  resultsSummary: Maybe<Scalars['JSONObject']>;
  status: Maybe<InvestigationStatus>;
  temporaryOverrideRequestId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum InvestigationStatus {
  InvestigationStatusFailed = 'INVESTIGATION_STATUS_FAILED',
  InvestigationStatusInProgress = 'INVESTIGATION_STATUS_IN_PROGRESS',
  InvestigationStatusSuccessful = 'INVESTIGATION_STATUS_SUCCESSFUL',
  InvestigationStatusUnspecified = 'INVESTIGATION_STATUS_UNSPECIFIED'
}

export enum InvestigationType {
  InvestigationTypeCostUnitChanges = 'INVESTIGATION_TYPE_COST_UNIT_CHANGES',
  InvestigationTypeItemId = 'INVESTIGATION_TYPE_ITEM_ID',
  InvestigationTypeLoyalty = 'INVESTIGATION_TYPE_LOYALTY',
  InvestigationTypePriceDrop = 'INVESTIGATION_TYPE_PRICE_DROP',
  InvestigationTypePriceHike = 'INVESTIGATION_TYPE_PRICE_HIKE',
  InvestigationTypeProductId = 'INVESTIGATION_TYPE_PRODUCT_ID',
  InvestigationTypePromotions = 'INVESTIGATION_TYPE_PROMOTIONS',
  InvestigationTypeSales = 'INVESTIGATION_TYPE_SALES',
  InvestigationTypeUnspecified = 'INVESTIGATION_TYPE_UNSPECIFIED'
}

export type IppAccountInformationInput = {
  canonicalId?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type IppContextInput = {
  ippUserId?: InputMaybe<Scalars['BigInt']>;
  isAdminUser?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type IroncladData = {
  __typename?: 'IroncladData';
  isaGroupKey: Maybe<Scalars['String']>;
  ndaGroupKey: Maybe<Scalars['String']>;
  siteId: Maybe<Scalars['String']>;
  useIronclad: Maybe<Scalars['Boolean']>;
};

export type Item = {
  __typename?: 'Item';
  localeCode: Maybe<Scalars['String']>;
  primaryAisleId: Maybe<Scalars['BigInt']>;
  primaryDepartmentId: Maybe<Scalars['BigInt']>;
  primaryImageUrl: Maybe<Scalars['String']>;
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  productDisplayName: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
};

export type ItemId = {
  __typename?: 'ItemId';
  itemId: Maybe<Scalars['BigInt']>;
};

export type ItemIdInput = {
  itemId?: InputMaybe<Scalars['BigInt']>;
};

export type ItemList = {
  __typename?: 'ItemList';
  cta: Maybe<Scalars['String']>;
  ctaVisibilityMin: Maybe<Scalars['BigInt']>;
  dataQuery: Maybe<DataQuery>;
  dataQueryValue: Maybe<Scalars['JSONObject']>;
  disclaimer: Maybe<Scalars['String']>;
  iconUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  placementId: Maybe<Scalars['BigInt']>;
  selectable: Maybe<Scalars['Boolean']>;
  subTitle: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<ItemListVariant>;
};

export type ItemListInput = {
  cta?: InputMaybe<Scalars['String']>;
  ctaVisibilityMin?: InputMaybe<Scalars['BigInt']>;
  dataQuery?: InputMaybe<DataQueryInput>;
  dataQueryValue?: InputMaybe<Scalars['JSONObject']>;
  disclaimer?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  selectable?: InputMaybe<Scalars['Boolean']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<ItemListVariant>;
};

export enum ItemListVariant {
  CarouselItemList = 'CAROUSEL_ITEM_LIST',
  CategoryForwardList = 'CATEGORY_FORWARD_LIST',
  CompactShoppable = 'COMPACT_SHOPPABLE',
  CouponList = 'COUPON_LIST',
  DoubleDeckerItemList = 'DOUBLE_DECKER_ITEM_LIST',
  FilterableItemList = 'FILTERABLE_ITEM_LIST',
  GridCouponList = 'GRID_COUPON_LIST',
  GridItemList = 'GRID_ITEM_LIST',
  ItemForwardList = 'ITEM_FORWARD_LIST',
  ItemList = 'ITEM_LIST',
  UnspecifiedItemList = 'UNSPECIFIED_ITEM_LIST'
}

export type ItemsSchema = {
  __typename?: 'ItemsSchema';
  promoPricingBackgroundColor: Maybe<AtomsColor>;
  promoPricingTextColor: Maybe<AtomsColor>;
};

export type KpiCards = {
  __typename?: 'KpiCards';
  estimatedDailyLoss: Maybe<Scalars['Float']>;
  lowStockItems: Maybe<Scalars['Int']>;
  restockableItemCount: Maybe<Scalars['Int']>;
  totalOosItems: Maybe<Scalars['Int']>;
};

export type LandingSchema = {
  __typename?: 'LandingSchema';
  landingSkipPostalCode: Maybe<Scalars['Boolean']>;
};

export type LaunchOnboarding = {
  __typename?: 'LaunchOnboarding';
  createdAt: Maybe<Scalars['DateTime']>;
  createdByUserId: Maybe<Scalars['BigInt']>;
  entityName: Maybe<Scalars['String']>;
  expansionsOwnerUserId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  ippAccountUuid: Maybe<Scalars['String']>;
  partner: Maybe<LaunchOnboardingPartner>;
  tamOnboardingOwnerUserId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  warehouse: Maybe<LaunchOnboardingWarehouse>;
  warehouseLocations: Maybe<Array<Maybe<LaunchOnboardingWarehouseLocation>>>;
  workflowState: Maybe<Scalars['String']>;
};

export type LaunchOnboardingAddress = {
  __typename?: 'LaunchOnboardingAddress';
  apartmentNumber: Maybe<Scalars['String']>;
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  approved: Maybe<Scalars['Boolean']>;
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  streetAddress: Maybe<Scalars['String']>;
};

export type LaunchOnboardingAddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>;
  approvalRequests?: InputMaybe<Array<InputMaybe<LaunchOnboardingApprovalRequestInput>>>;
  approved?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
};

export type LaunchOnboardingApprovalRequest = {
  __typename?: 'LaunchOnboardingApprovalRequest';
  approveableId: Maybe<Scalars['BigInt']>;
  approveableType: Maybe<Scalars['String']>;
  attributeGroup: Maybe<Scalars['String']>;
  attributeName: Maybe<Scalars['String']>;
  attributeValue: Maybe<Scalars['String']>;
  comment: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdByIppAccountCanonicalId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  iscConfId: Maybe<Scalars['BigInt']>;
  iscConfName: Maybe<Scalars['String']>;
  secretRefId: Maybe<Scalars['BigInt']>;
  source: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  updatedByIppAccountCanonicalId: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type LaunchOnboardingApprovalRequestInput = {
  approveableId?: InputMaybe<Scalars['BigInt']>;
  approveableType?: InputMaybe<Scalars['String']>;
  attributeGroup?: InputMaybe<Scalars['String']>;
  attributeName?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  iscConfId?: InputMaybe<Scalars['BigInt']>;
  iscConfName?: InputMaybe<Scalars['String']>;
  secretRefId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type LaunchOnboardingPartner = {
  __typename?: 'LaunchOnboardingPartner';
  createdAt: Maybe<Scalars['DateTime']>;
  externalId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  partnerType: Maybe<Scalars['String']>;
  salesforceId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type LaunchOnboardingWarehouse = {
  __typename?: 'LaunchOnboardingWarehouse';
  aliasName: Maybe<Scalars['String']>;
  allowAlcohol: Maybe<Scalars['Boolean']>;
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  approved: Maybe<Scalars['Boolean']>;
  backgroundColor: Maybe<Scalars['String']>;
  categories: Maybe<Array<Maybe<Scalars['String']>>>;
  certifiedDeliveryThreshold: Maybe<Scalars['Float']>;
  country: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  description: Maybe<Scalars['String']>;
  externalId: Maybe<Scalars['BigInt']>;
  franchiseeId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  logo: Maybe<Scalars['String']>;
  logoBackgroundColor: Maybe<Scalars['String']>;
  merchantId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  pricingPolicy: Maybe<Scalars['String']>;
  pricingPolicyOverride: Maybe<Scalars['String']>;
  pricingPolicyOverrideText: Maybe<Scalars['String']>;
  pricingPolicyText: Maybe<Scalars['String']>;
  retailerType: Maybe<Scalars['String']>;
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
  visible: Maybe<Scalars['Boolean']>;
  warehouseLocations: Maybe<Array<Maybe<LaunchOnboardingWarehouseLocation>>>;
};

export type LaunchOnboardingWarehouseLocation = {
  __typename?: 'LaunchOnboardingWarehouseLocation';
  address: Maybe<LaunchOnboardingAddress>;
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  approvalRequestsStatus: Maybe<Scalars['String']>;
  approved: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  externalId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  isochroneData: Maybe<Scalars['String']>;
  locationCode: Maybe<Scalars['String']>;
  merchantId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum LaunchOnboardingWorkflowStateAction {
  LaunchOnboardingWorkflowStateActionCompleteInitialOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE_INITIAL_ONBOARDING',
  LaunchOnboardingWorkflowStateActionCompleteLaunchOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE_LAUNCH_ONBOARDING',
  LaunchOnboardingWorkflowStateActionCreateIppAccount = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_CREATE_IPP_ACCOUNT',
  LaunchOnboardingWorkflowStateActionLaunch = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_LAUNCH',
  LaunchOnboardingWorkflowStateActionProvideInitialWarehouseInfo = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_INITIAL_WAREHOUSE_INFO',
  LaunchOnboardingWorkflowStateActionProvideInitialWarehouseLocationsInfo = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_INITIAL_WAREHOUSE_LOCATIONS_INFO',
  LaunchOnboardingWorkflowStateActionSendEmailInvite = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_SEND_EMAIL_INVITE',
  LaunchOnboardingWorkflowStateActionStartInitialOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_START_INITIAL_ONBOARDING',
  LaunchOnboardingWorkflowStateActionStartLaunchOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_START_LAUNCH_ONBOARDING',
  LaunchOnboardingWorkflowStateActionUnknown = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_UNKNOWN'
}

export enum Layout {
  ActionSheet = 'ACTION_SHEET',
  BloomTargetStorefront = 'BLOOM_TARGET_STOREFRONT',
  BloomTargetStorefrontDealsLists = 'BLOOM_TARGET_STOREFRONT_DEALS_LISTS',
  BrowseDepartments = 'BROWSE_DEPARTMENTS',
  BrowseFeed = 'BROWSE_FEED',
  CampaignPlacement = 'CAMPAIGN_PLACEMENT',
  CartCoachmark = 'CART_COACHMARK',
  CartIncentiveTracker = 'CART_INCENTIVE_TRACKER',
  CartIncentiveTrackerDetailSavingMessage = 'CART_INCENTIVE_TRACKER_DETAIL_SAVING_MESSAGE',
  CartIncentiveTrackerDetailSavingMessageNonIncentive = 'CART_INCENTIVE_TRACKER_DETAIL_SAVING_MESSAGE_NON_INCENTIVE',
  CartIncentiveTrackerNonIncentive = 'CART_INCENTIVE_TRACKER_NON_INCENTIVE',
  CartMessages = 'CART_MESSAGES',
  CartMessagesNonIncentive = 'CART_MESSAGES_NON_INCENTIVE',
  CartMessagesNonIncentives = 'CART_MESSAGES_NON_INCENTIVES',
  CartOnLoad = 'CART_ON_LOAD',
  CartRecommendations = 'CART_RECOMMENDATIONS',
  CheckoutAisle = 'CHECKOUT_AISLE',
  CheckoutAisleNewUser = 'CHECKOUT_AISLE_NEW_USER',
  CheckoutBanner = 'CHECKOUT_BANNER',
  CollectionDepartment = 'COLLECTION_DEPARTMENT',
  CollectionHub = 'COLLECTION_HUB',
  CollectionHubOnLoad = 'COLLECTION_HUB_ON_LOAD',
  ContentLibraryPreferencesBroadCategory = 'CONTENT_LIBRARY_PREFERENCES_BROAD_CATEGORY',
  ContentLibraryPreferencesRecuratedKeywords = 'CONTENT_LIBRARY_PREFERENCES_RECURATED_KEYWORDS',
  CreativeManager = 'CREATIVE_MANAGER',
  CrossRetailerSearchEyebrow = 'CROSS_RETAILER_SEARCH_EYEBROW',
  CustomStorefront = 'CUSTOM_STOREFRONT',
  DealsTabHero = 'DEALS_TAB_HERO',
  DealsTabSecondary = 'DEALS_TAB_SECONDARY',
  EntStorefront = 'ENT_STOREFRONT',
  FloatingCart = 'FLOATING_CART',
  FloatingCartNonIncentive = 'FLOATING_CART_NON_INCENTIVE',
  FlyerDestination = 'FLYER_DESTINATION',
  FlyoutModal = 'FLYOUT_MODAL',
  Home = 'HOME',
  HomeAboveTheFold = 'HOME_ABOVE_THE_FOLD',
  HomeCategoryAlcohol = 'HOME_CATEGORY_ALCOHOL',
  HomeCategoryApparel = 'HOME_CATEGORY_APPAREL',
  HomeCategoryBaby = 'HOME_CATEGORY_BABY',
  HomeCategoryBeauty = 'HOME_CATEGORY_BEAUTY',
  HomeCategoryConvenience = 'HOME_CATEGORY_CONVENIENCE',
  HomeCategoryDiscount = 'HOME_CATEGORY_DISCOUNT',
  HomeCategoryElectronics = 'HOME_CATEGORY_ELECTRONICS',
  HomeCategoryForward = 'HOME_CATEGORY_FORWARD',
  HomeCategoryGifts = 'HOME_CATEGORY_GIFTS',
  HomeCategoryGrocery = 'HOME_CATEGORY_GROCERY',
  HomeCategoryHome = 'HOME_CATEGORY_HOME',
  HomeCategoryOffice = 'HOME_CATEGORY_OFFICE',
  HomeCategoryPet = 'HOME_CATEGORY_PET',
  HomeCategoryPharmacy = 'HOME_CATEGORY_PHARMACY',
  HomeCategoryRetail = 'HOME_CATEGORY_RETAIL',
  HomeCategorySports = 'HOME_CATEGORY_SPORTS',
  HomeCoachmark = 'HOME_COACHMARK',
  HomeEyebrow = 'HOME_EYEBROW',
  HomeFeed = 'HOME_FEED',
  HomeFeedAlcohol = 'HOME_FEED_ALCOHOL',
  HomeFeedBackToSchool = 'HOME_FEED_BACK_TO_SCHOOL',
  HomeFeedBeauty = 'HOME_FEED_BEAUTY',
  HomeFeedBecauseYouBought = 'HOME_FEED_BECAUSE_YOU_BOUGHT',
  HomeFeedConvenience = 'HOME_FEED_CONVENIENCE',
  HomeFeedDefault = 'HOME_FEED_DEFAULT',
  HomeFeedGifts = 'HOME_FEED_GIFTS',
  HomeFeedGrocery = 'HOME_FEED_GROCERY',
  HomeFeedHeader = 'HOME_FEED_HEADER',
  HomeFeedNewUser = 'HOME_FEED_NEW_USER',
  HomeFeedOpenLate = 'HOME_FEED_OPEN_LATE',
  HomeFeedPets = 'HOME_FEED_PETS',
  HomeFeedPharmacy = 'HOME_FEED_PHARMACY',
  HomeFeedUseCaseTiles = 'HOME_FEED_USE_CASE_TILES',
  HomeFeedWholesale = 'HOME_FEED_WHOLESALE',
  HomeHero = 'HOME_HERO',
  HomeHeroUnit = 'HOME_HERO_UNIT',
  HomeItemForward = 'HOME_ITEM_FORWARD',
  HomeMarketplace = 'HOME_MARKETPLACE',
  HomeOnLoad = 'HOME_ON_LOAD',
  HomeOnLoadCsc = 'HOME_ON_LOAD_CSC',
  HomeOnLoadIncentive = 'HOME_ON_LOAD_INCENTIVE',
  HomeSecondary = 'HOME_SECONDARY',
  HomeSuperSaver = 'HOME_SUPER_SAVER',
  Hub = 'HUB',
  HubHeader = 'HUB_HEADER',
  InStoreDeals = 'IN_STORE_DEALS',
  IsolatedStorefront = 'ISOLATED_STOREFRONT',
  ItemDetailsRecommendations = 'ITEM_DETAILS_RECOMMENDATIONS',
  ItemDetailsRecommendationsPostAtc = 'ITEM_DETAILS_RECOMMENDATIONS_POST_ATC',
  ItemDetailsRecommendationsPrimary = 'ITEM_DETAILS_RECOMMENDATIONS_PRIMARY',
  ItemDetailsRecommendationsSecondary = 'ITEM_DETAILS_RECOMMENDATIONS_SECONDARY',
  LandingContentPage = 'LANDING_CONTENT_PAGE',
  MealsHub = 'MEALS_HUB',
  MealsTabOnStorefront = 'MEALS_TAB_ON_STOREFRONT',
  MultiOfferCartTrackerIncentive = 'MULTI_OFFER_CART_TRACKER_INCENTIVE',
  MultiRetailerFlyerDestination = 'MULTI_RETAILER_FLYER_DESTINATION',
  NewVerticalsStorefront = 'NEW_VERTICALS_STOREFRONT',
  OffersForYouNonIncentive = 'OFFERS_FOR_YOU_NON_INCENTIVE',
  OnLoadRedemptionCsc = 'ON_LOAD_REDEMPTION_CSC',
  OnLoadRedemptionTemplate = 'ON_LOAD_REDEMPTION_TEMPLATE',
  OrderStatusRecommendations = 'ORDER_STATUS_RECOMMENDATIONS',
  OrderStatusSecondary = 'ORDER_STATUS_SECONDARY',
  PostCheckoutRecommendations = 'POST_CHECKOUT_RECOMMENDATIONS',
  PostCheckoutSheet = 'POST_CHECKOUT_SHEET',
  PostCheckoutSlot_1 = 'POST_CHECKOUT_SLOT_1',
  PromotionSheet = 'PROMOTION_SHEET',
  RecipeOnLoad = 'RECIPE_ON_LOAD',
  RecommendationsTray = 'RECOMMENDATIONS_TRAY',
  RedemptionModal = 'REDEMPTION_MODAL',
  RestaurantFlyoutLarge = 'RESTAURANT_FLYOUT_LARGE',
  RestaurantFlyoutMedium = 'RESTAURANT_FLYOUT_MEDIUM',
  RestaurantFlyoutMediumCombined_40DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_40_DOLLAR_OFF',
  RestaurantFlyoutMediumCombined_60DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_60_DOLLAR_OFF',
  RestaurantFlyoutMediumCombined_80DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_80_DOLLAR_OFF',
  RestaurantFlyoutMediumCombinedDollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_DOLLAR_OFF',
  RestaurantFlyoutMediumFreeDelivery = 'RESTAURANT_FLYOUT_MEDIUM_FREE_DELIVERY',
  RestaurantFlyoutMediumRestaurant_20DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_20_DOLLAR_OFF',
  RestaurantFlyoutMediumRestaurant_30DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_30_DOLLAR_OFF',
  RestaurantFlyoutMediumRestaurant_40DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_40_DOLLAR_OFF',
  RestaurantFlyoutMediumRestaurantDollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_DOLLAR_OFF',
  RestaurantFlyoutSmall = 'RESTAURANT_FLYOUT_SMALL',
  RestaurantFlyoutSmallIcPlusUpsell = 'RESTAURANT_FLYOUT_SMALL_IC_PLUS_UPSELL',
  RetailerStories = 'RETAILER_STORIES',
  SavingsCardV2 = 'SAVINGS_CARD_V2',
  Search = 'SEARCH',
  ShopContentPage = 'SHOP_CONTENT_PAGE',
  Shortcuts = 'SHORTCUTS',
  Storefront = 'STOREFRONT',
  StorefrontCoachmark = 'STOREFRONT_COACHMARK',
  StorefrontDesktopSidebarNavigationV2 = 'STOREFRONT_DESKTOP_SIDEBAR_NAVIGATION_V2',
  StorefrontEyebrow = 'STOREFRONT_EYEBROW',
  StorefrontHeaderBottomFeaturedNavigationV2 = 'STOREFRONT_HEADER_BOTTOM_FEATURED_NAVIGATION_V2',
  StorefrontHeaderBottomNavigationV2 = 'STOREFRONT_HEADER_BOTTOM_NAVIGATION_V2',
  StorefrontHeaderTopFeaturedNavigationV2 = 'STOREFRONT_HEADER_TOP_FEATURED_NAVIGATION_V2',
  StorefrontHeaderTopNavigationV2 = 'STOREFRONT_HEADER_TOP_NAVIGATION_V2',
  StorefrontHero = 'STOREFRONT_HERO',
  StorefrontMobileWebMenuNavigationV2 = 'STOREFRONT_MOBILE_WEB_MENU_NAVIGATION_V2',
  StorefrontNativeMoreMenuNavigationV2 = 'STOREFRONT_NATIVE_MORE_MENU_NAVIGATION_V2',
  StorefrontNavigationAccount = 'STOREFRONT_NAVIGATION_ACCOUNT',
  StorefrontNavigationEmbeddedApp = 'STOREFRONT_NAVIGATION_EMBEDDED_APP',
  StorefrontNavigationFooter = 'STOREFRONT_NAVIGATION_FOOTER',
  StorefrontNavigationGrid = 'STOREFRONT_NAVIGATION_GRID',
  StorefrontNavigationHeader = 'STOREFRONT_NAVIGATION_HEADER',
  StorefrontNavigationItem = 'STOREFRONT_NAVIGATION_ITEM',
  StorefrontNavigationNativeTabbar = 'STOREFRONT_NAVIGATION_NATIVE_TABBAR',
  StorefrontNavigationSocialIcons = 'STOREFRONT_NAVIGATION_SOCIAL_ICONS',
  StorefrontNavigationV2 = 'STOREFRONT_NAVIGATION_V2',
  StorefrontNavigationWarehouseSelector = 'STOREFRONT_NAVIGATION_WAREHOUSE_SELECTOR',
  StorefrontNewUser = 'STOREFRONT_NEW_USER',
  StorefrontOnLoad = 'STOREFRONT_ON_LOAD',
  StorefrontOnLoadCsc = 'STOREFRONT_ON_LOAD_CSC',
  StorefrontOnLoadIncentive = 'STOREFRONT_ON_LOAD_INCENTIVE',
  StorefrontOverHeader = 'STOREFRONT_OVER_HEADER',
  StorefrontPostAtc = 'STOREFRONT_POST_ATC',
  StorefrontSuperSaver = 'STOREFRONT_SUPER_SAVER',
  StoreDirectoryAlcohol = 'STORE_DIRECTORY_ALCOHOL',
  StoreDirectoryAll = 'STORE_DIRECTORY_ALL',
  StoreDirectoryConvenience = 'STORE_DIRECTORY_CONVENIENCE',
  StoreDirectoryGrocery = 'STORE_DIRECTORY_GROCERY',
  StoreDirectoryRetail = 'STORE_DIRECTORY_RETAIL',
  TopTracker = 'TOP_TRACKER',
  TreatmentOffersForYou = 'TREATMENT_OFFERS_FOR_YOU',
  TreatmentOffersForYouNonIncentive = 'TREATMENT_OFFERS_FOR_YOU_NON_INCENTIVE',
  TreatmentSheet = 'TREATMENT_SHEET',
  TreatmentTracker = 'TREATMENT_TRACKER',
  TreatmentTrackerNonIncentive = 'TREATMENT_TRACKER_NON_INCENTIVE',
  TreatmentWave = 'TREATMENT_WAVE',
  UniversalValueCarousel = 'UNIVERSAL_VALUE_CAROUSEL',
  UniversalValueCarouselIncentive = 'UNIVERSAL_VALUE_CAROUSEL_INCENTIVE',
  UniversalValueCarouselNonIncentive = 'UNIVERSAL_VALUE_CAROUSEL_NON_INCENTIVE',
  UserSurvey = 'USER_SURVEY',
  YourItems = 'YOUR_ITEMS'
}

export enum LayoutType {
  DesktopFlexibleHeaderLayoutV1 = 'DESKTOP_FLEXIBLE_HEADER_LAYOUT_V1',
  DesktopSidebarLayoutV1 = 'DESKTOP_SIDEBAR_LAYOUT_V1',
  MobileWebHamburgerMenuLayoutV1 = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_V1',
  NativeMoreMenuLayoutV1 = 'NATIVE_MORE_MENU_LAYOUT_V1'
}

export type LayoutVariant = {
  __typename?: 'LayoutVariant';
  contentPageId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  placements: Maybe<Array<Maybe<Placement>>>;
  platform: Maybe<Array<Maybe<PlatformType>>>;
  previewToken: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  status: Maybe<Status>;
};

export type LayoutVariantInput = {
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Status>;
};

export type LegacyElasticsearchResponse = {
  __typename?: 'LegacyElasticsearchResponse';
  docs: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
};

export type LegacyItemTyped = {
  __typename?: 'LegacyItemTyped';
  aisleId: Maybe<Scalars['BigInt']>;
  aisleName: Maybe<Scalars['String']>;
  alcoholic: Maybe<Scalars['Boolean']>;
  allergensKeywords: Maybe<Array<Maybe<Scalars['String']>>>;
  available: Maybe<Scalars['Boolean']>;
  brandName: Maybe<Scalars['String']>;
  configurableProducts: Maybe<Scalars['JSONObject']>;
  costPricePerUnit: Maybe<InstacartTypesV1BigDecimal>;
  costUnit: Maybe<Scalars['String']>;
  dairyFree: Maybe<Scalars['Boolean']>;
  departmentId: Maybe<Scalars['BigInt']>;
  departmentName: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  fullPrice: Maybe<InstacartTypesV1BigDecimal>;
  halal: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  inStoreLocation: Maybe<Scalars['String']>;
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  isCatering: Maybe<Scalars['Boolean']>;
  isHot: Maybe<Scalars['Boolean']>;
  isPackagedByWeight: Maybe<Scalars['Boolean']>;
  ketoDiet: Maybe<Scalars['Boolean']>;
  largeImageUrl: Maybe<Scalars['String']>;
  localeCode: Maybe<Scalars['String']>;
  lowSodium: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  nonenumeratedManagedAttributes: Maybe<NonenumeratedManagedAttributes>;
  normalizedHeightCm: Maybe<InstacartTypesV1BigDecimal>;
  normalizedLengthCm: Maybe<InstacartTypesV1BigDecimal>;
  normalizedWeightG: Maybe<InstacartTypesV1BigDecimal>;
  normalizedWidthCm: Maybe<InstacartTypesV1BigDecimal>;
  parWeight: Maybe<InstacartTypesV1BigDecimal>;
  price: Maybe<InstacartTypesV1BigDecimal>;
  pricePerUnit: Maybe<InstacartTypesV1BigDecimal>;
  primaryImageUrl: Maybe<Scalars['String']>;
  productCategory: Maybe<ProductCategory>;
  productCategoryTaxonomy: Maybe<ProductCategoryTaxonomy>;
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  productEnrichmentKeywords: Maybe<Array<Maybe<Scalars['String']>>>;
  productId: Maybe<Scalars['BigInt']>;
  productType: Maybe<Scalars['String']>;
  requestUnit: Maybe<LegacyItemTypedRequestUnit>;
  restrictedOtc: Maybe<Scalars['Boolean']>;
  restrictedReasons: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerLookupCode: Maybe<Scalars['String']>;
  retailerMetadata: Maybe<LegacyItemTypedLegacyRetailerMetadataTyped>;
  retailerOmsEligible: Maybe<Scalars['Boolean']>;
  retailerPreferredLookupCode: Maybe<Scalars['String']>;
  retailerProductSize: Maybe<Scalars['String']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  retailerSpecificMetadata: Maybe<LegacyItemTypedLegacyRetailerSpecificMetadataTyped>;
  shopperHeroImageUrl: Maybe<Scalars['String']>;
  shopperHeroLargeImageUrl: Maybe<Scalars['String']>;
  shouldScan: Maybe<Scalars['Boolean']>;
  size: Maybe<Scalars['String']>;
  sizeUomVariable: Maybe<Scalars['String']>;
  storageTemp: Maybe<Scalars['String']>;
  sugarFree: Maybe<Scalars['Boolean']>;
  suggestedReplacementIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  syntheticCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  tobacco: Maybe<Scalars['Boolean']>;
  unitCount: Maybe<Scalars['BigInt']>;
  unitPrice: Maybe<InstacartTypesV1BigDecimal>;
  unlisted: Maybe<Scalars['Boolean']>;
  usaSnapEligible: Maybe<Scalars['Boolean']>;
  variantDimensionValues: Maybe<Array<Maybe<LegacyItemTypedLegacyVariantDimensionValueTyped>>>;
  warehouseId: Maybe<Scalars['BigInt']>;
};

export type LegacyItemTypedLegacyRetailerMetadataTyped = {
  __typename?: 'LegacyItemTypedLegacyRetailerMetadataTyped';
  aldiProductCode: Maybe<Scalars['String']>;
};

export type LegacyItemTypedLegacyRetailerSpecificMetadataTyped = {
  __typename?: 'LegacyItemTypedLegacyRetailerSpecificMetadataTyped';
  aldiProductCode: Maybe<Scalars['String']>;
};

export type LegacyItemTypedLegacyVariantDimensionValueTyped = {
  __typename?: 'LegacyItemTypedLegacyVariantDimensionValueTyped';
  heading: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export enum LegacyItemTypedRequestUnit {
  Each = 'EACH',
  Kg = 'KG',
  Lb = 'LB',
  Package = 'PACKAGE',
  RequestUnitUnspecified = 'REQUEST_UNIT_UNSPECIFIED'
}

export type LegacyItemsTyped = {
  __typename?: 'LegacyItemsTyped';
  items: Maybe<Array<Maybe<LegacyItemTyped>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type LegacyProducts = {
  __typename?: 'LegacyProducts';
  items: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  totalCount: Maybe<Scalars['BigInt']>;
  totalPages: Maybe<Scalars['BigInt']>;
};

export enum LegalFilterType {
  FullyFiltered = 'FULLY_FILTERED',
  LegalFilterTypeUnknown = 'LEGAL_FILTER_TYPE_UNKNOWN',
  NotFiltered = 'NOT_FILTERED',
  PartiallyFiltered = 'PARTIALLY_FILTERED'
}

export type LinkAutosuggestion = {
  __typename?: 'LinkAutosuggestion';
  endDate: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  linkDescription: Maybe<Scalars['String']>;
  linkId: Maybe<Scalars['BigInt']>;
  linkImageUrl: Maybe<Scalars['String']>;
  linkName: Maybe<Scalars['String']>;
  linkTitle: Maybe<Scalars['String']>;
  linkType: Maybe<LinkAutosuggestionLinkType>;
  linkUrl: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  startDate: Maybe<Scalars['DateTime']>;
};

export type LinkAutosuggestionAdmin = {
  __typename?: 'LinkAutosuggestionAdmin';
  keywords: Maybe<Array<Maybe<Scalars['String']>>>;
  linkAutosuggestion: Maybe<LinkAutosuggestion>;
};

export type LinkAutosuggestionAdminInput = {
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkAutosuggestion?: InputMaybe<LinkAutosuggestionInput>;
};

export type LinkAutosuggestionInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  linkDescription?: InputMaybe<Scalars['String']>;
  linkId?: InputMaybe<Scalars['BigInt']>;
  linkImageUrl?: InputMaybe<Scalars['String']>;
  linkName?: InputMaybe<Scalars['String']>;
  linkTitle?: InputMaybe<Scalars['String']>;
  linkType?: InputMaybe<LinkAutosuggestionLinkType>;
  linkUrl?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export enum LinkAutosuggestionLinkType {
  LinkTypeHard = 'LINK_TYPE_HARD',
  LinkTypeSoft = 'LINK_TYPE_SOFT',
  LinkTypeUnknown = 'LINK_TYPE_UNKNOWN'
}

export type ListAuditBatchesRequestInput = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  batchMetadata?: InputMaybe<Scalars['String']>;
  batchSecondaryStateIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  batchStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<OrderByInput>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page?: InputMaybe<PaginationInput>;
  showReassignmentMappings?: InputMaybe<Scalars['Boolean']>;
  showStatistics?: InputMaybe<Scalars['Boolean']>;
  submissionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  workflows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListAuditBatchesResponse = {
  __typename?: 'ListAuditBatchesResponse';
  aggregateStatistics: Maybe<ListAuditBatchesResponseAggregateStatistics>;
  auditBatches: Maybe<Array<Maybe<AuditBatch>>>;
  totalResultCount: Maybe<Scalars['BigInt']>;
  workflowReassignmentMappings: Maybe<Array<Maybe<ListAuditBatchesResponseWorkflowReassignmentMapping>>>;
};

export type ListAuditBatchesResponseAggregateStatistics = {
  __typename?: 'ListAuditBatchesResponseAggregateStatistics';
  totalAudited: Maybe<Scalars['BigInt']>;
  totalCorrected: Maybe<Scalars['BigInt']>;
  totalTasks: Maybe<Scalars['BigInt']>;
};

export type ListAuditBatchesResponseWorkflowReassignmentMapping = {
  __typename?: 'ListAuditBatchesResponseWorkflowReassignmentMapping';
  fromWorkflow: Maybe<Scalars['String']>;
  toWorkflows: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ListAuditTaskComponentsRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  componentValueFilters?: InputMaybe<Array<InputMaybe<ComponentValueFilterInput>>>;
  groupName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PaginationInput>;
  searchTerm?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ListAuditTaskComponentsResponse = {
  __typename?: 'ListAuditTaskComponentsResponse';
  totalResultCount: Maybe<Scalars['BigInt']>;
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ListAuditWorkflowsRequestInput = {
  batchStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  returnTaskInformation?: InputMaybe<Scalars['Boolean']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  workflows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListAuditWorkflowsResponse = {
  __typename?: 'ListAuditWorkflowsResponse';
  auditWorkflows: Maybe<Array<Maybe<AuditWorkflow>>>;
};

export type ListContentPageVersionMetasRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
};

export type ListContentPageVersionMetasResponse = {
  __typename?: 'ListContentPageVersionMetasResponse';
  contentPageVersionMetas: Maybe<Array<Maybe<ContentPageVersionMeta>>>;
};

export type ListContentPageVersionsRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ListContentPageVersionsResponse = {
  __typename?: 'ListContentPageVersionsResponse';
  contentPageVersions: Maybe<Array<Maybe<ContentPageVersion>>>;
};

export type ListContentPagesRequestV2Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  isOverlapAnyRetailerIds?: InputMaybe<Scalars['Boolean']>;
  isOverlapAnyStoreConfigurationIds?: InputMaybe<Scalars['Boolean']>;
  matchBySlugAcrossRetailers?: InputMaybe<Scalars['Boolean']>;
  pageType?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  slug?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type ListContentPagesResponseV2 = {
  __typename?: 'ListContentPagesResponseV2';
  contentPages: Maybe<Array<Maybe<ContentPageV2>>>;
};

export type ListDetectionsRequestFiltersInput = {
  hideRejectedVersions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
};

export type ListDetectionsRequestInput = {
  filters?: InputMaybe<ListDetectionsRequestFiltersInput>;
  page?: InputMaybe<PaginationInput>;
};

export type ListDetectionsResponse = {
  __typename?: 'ListDetectionsResponse';
  detections: Maybe<Array<Maybe<ListDetectionsResponseDetection>>>;
  totalResultCount: Maybe<Scalars['BigInt']>;
};

export type ListDetectionsResponseDetection = {
  __typename?: 'ListDetectionsResponseDetection';
  createdAt: Maybe<Scalars['DateTime']>;
  currentAttributes: Maybe<DetectionVersionAttributes>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  state: Maybe<DetectionStatusState>;
  tombstone: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  updatedBy: Maybe<Scalars['String']>;
  updatedWhy: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
};

export type ListLinkAutosuggestionAdminParametersInput = {
  keyword?: InputMaybe<Scalars['String']>;
  linkIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  linkNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type ListLinkAutosuggestionAdminRequestInput = {
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  parameters?: InputMaybe<ListLinkAutosuggestionAdminParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type ListLinkAutosuggestionAdminResponse = {
  __typename?: 'ListLinkAutosuggestionAdminResponse';
  linkAutosuggestions: Maybe<Array<Maybe<LinkAutosuggestionAdmin>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type ListMomentsRequestFilterSetInput = {
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListMomentsRequestInput = {
  filters?: InputMaybe<ListMomentsRequestFilterSetInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type ListMomentsResponse = {
  __typename?: 'ListMomentsResponse';
  moments: Maybe<Array<Maybe<Moment>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type ListPlacementContentParamsInput = {
  campaignEndsAfter?: InputMaybe<Scalars['DateTime']>;
  campaignEndsBefore?: InputMaybe<Scalars['DateTime']>;
  campaignStartsAfter?: InputMaybe<Scalars['DateTime']>;
  campaignStartsBefore?: InputMaybe<Scalars['DateTime']>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  contentPageVersionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  createdByCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  creativeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledOnly?: InputMaybe<Scalars['Boolean']>;
  excludedLayoutVariants?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedLayouts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedNamesRegex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedPlatforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedRetailers?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  experimentNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedLayoutVariants?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedLayouts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedPlatforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedRetailers?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  internalNameRegex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PlacementContentRequestPaginationInput>;
  parentPlacementId?: InputMaybe<Scalars['BigInt']>;
  placementIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  placementSurface?: InputMaybe<PlacementContentSurfaceInput>;
  placementTypeVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placementTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  updatedByCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListPlacementContentRequestInput = {
  excludingLocales?: InputMaybe<InstacartCustomersSharedV1Locale>;
  params?: InputMaybe<ListPlacementContentParamsInput>;
};

export type ListPlacementContentResponse = {
  __typename?: 'ListPlacementContentResponse';
  contents: Maybe<Array<Maybe<PlacementContent>>>;
  pagination: Maybe<PlacementContentResponsePagination>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type ListPriceInvestigationsRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  investigationStatus?: InputMaybe<InvestigationStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patchStatus?: InputMaybe<PatchStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ListPriceInvestigationsResponse = {
  __typename?: 'ListPriceInvestigationsResponse';
  investigations: Maybe<Array<Maybe<Investigation>>>;
  totalCount: Maybe<Scalars['Int']>;
};

export type ListRetailerCampaignTreatmentsRequestInput = {
  ippContext?: InputMaybe<IppContextInput>;
  retailerCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type ListRetailerCampaignTreatmentsResponse = {
  __typename?: 'ListRetailerCampaignTreatmentsResponse';
  treatments: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
};

export type ListRetailerCampaignsRequestFilterSetInput = {
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignReference?: InputMaybe<CampaignReferenceInput>;
  discoverability?: InputMaybe<Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludeAdminOnlyCampaigns?: InputMaybe<Scalars['Boolean']>;
  excludeRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
  includeCampaignFromInternalTemplate?: InputMaybe<Scalars['Boolean']>;
  isActiveOnDatetime?: InputMaybe<Scalars['DateTime']>;
  propertyFilters?: InputMaybe<Array<InputMaybe<CampaignPropertyFilterOrListInput>>>;
  queryFields?: InputMaybe<Array<InputMaybe<ListRetailerCampaignsRequestFilterSetQueryFieldInput>>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchValue?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withEnrichedProperties?: InputMaybe<Scalars['Boolean']>;
};

export type ListRetailerCampaignsRequestFilterSetQueryFieldInput = {
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListRetailerCampaignsRequestInput = {
  filters?: InputMaybe<ListRetailerCampaignsRequestFilterSetInput>;
  includeFields?: InputMaybe<Array<InputMaybe<CampaignField>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type ListRetailerCampaignsResponse = {
  __typename?: 'ListRetailerCampaignsResponse';
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  retailerCampaigns: Maybe<Array<Maybe<RetailerCampaign>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type ListThemePagesRequestInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  includeSections?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type ListThemePagesResponse = {
  __typename?: 'ListThemePagesResponse';
  themePages: Maybe<Array<Maybe<ThemePage>>>;
};

export type ListTicketsRequestInput = {
  associatedUser?: InputMaybe<UserInput>;
  client?: InputMaybe<ClientInput>;
  createdBy?: InputMaybe<UserInput>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  entityType?: InputMaybe<EntityType>;
  getSummaryStatus?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<PaginationInput>;
  problemType?: InputMaybe<ProblemType>;
  reportedOnBehalfOf?: InputMaybe<UserInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  severity?: InputMaybe<Scalars['BigInt']>;
  sourceAppNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type ListTicketsResponse = {
  __typename?: 'ListTicketsResponse';
  includesOnBehalfOf: Maybe<Scalars['Boolean']>;
  page: Maybe<Pagination>;
  tickets: Maybe<Array<Maybe<ProblemTrackerTicket>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type ListUserSettingsRequestInput = {
  appNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<ClientInput>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListUserSettingsResponse = {
  __typename?: 'ListUserSettingsResponse';
  settings: Maybe<Array<Maybe<UserSetting>>>;
};

export type ListUsersByPersonalIdentifiersStrictRequestInput = {
  firstName?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type ListUsersByPersonalIdentifiersStrictResponse = {
  __typename?: 'ListUsersByPersonalIdentifiersStrictResponse';
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  users: Maybe<Array<Maybe<User>>>;
};

export type LocaleProduct = {
  __typename?: 'LocaleProduct';
  localeId: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['String']>;
};

export type LocaleRetailerProduct = {
  __typename?: 'LocaleRetailerProduct';
  localeId: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['String']>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  locale: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export enum LocationFeatureEnum {
  /** Indicator whether retailer does alcohol delivery */
  RetailerAlcoholDelivery = 'RETAILER_ALCOHOL_DELIVERY',
  /** Indicator of whether retailer location does pickup */
  RetailerPickup = 'RETAILER_PICKUP'
}

export type Logo = {
  __typename?: 'Logo';
  /** full url of the image */
  url: Maybe<Scalars['String']>;
};

export type LogoWithTextBanner = {
  __typename?: 'LogoWithTextBanner';
  backgroundColorHex: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  id: Maybe<Scalars['BigInt']>;
  imageAltText: Maybe<Scalars['String']>;
  imageMobileUrl: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type LogoWithTextBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageMobileUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type Logos = {
  __typename?: 'Logos';
  defaultSiteLogoImageUrl: Maybe<Scalars['String']>;
  mobileBackgroundUrl: Maybe<Scalars['String']>;
  mobileLogoUrl: Maybe<Scalars['String']>;
  showPoweredByBranding: Maybe<Scalars['Boolean']>;
};

export type LoyaltySchema = {
  __typename?: 'LoyaltySchema';
  showLoyaltyActionsInList: Maybe<Scalars['Boolean']>;
};

export type ManagedAttributeValue = {
  __typename?: 'ManagedAttributeValue';
  valueDisplayName: Maybe<Scalars['String']>;
  valueId: Maybe<Scalars['BigInt']>;
};

export type MarketingFeatureTypesBrazeSegment = {
  __typename?: 'MarketingFeatureTypesBrazeSegment';
  /** Warehouse ids the segment is visible by */
  accessibleWarehouseIds: Array<Scalars['Int']>;
  /** A unique identifier for the braze segment. For Braze's API */
  brazeSegmentId: Scalars['String'];
  /** The role ID */
  id: Scalars['ID'];
  /** The visible name of the segment */
  segmentName: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export type MarketingFeatureTypesBrazeSegmentSize = {
  __typename?: 'MarketingFeatureTypesBrazeSegmentSize';
  /** The size of the segment */
  size: Scalars['Int'];
};

export type MarketingFeatureTypesCampaignConfiguration = {
  __typename?: 'MarketingFeatureTypesCampaignConfiguration';
  /** The id of the campaign returned from the campaign domain */
  campaignId: Scalars['ID'];
  /** The name of the experiment to run the campaign for */
  experimentName: Maybe<Scalars['String']>;
  /** The push_notification id of the push notification template returned */
  pushNotificationId: Maybe<Scalars['String']>;
  /** A unique identifier for the segment. Currently for Braze's API */
  segmentId: Scalars['String'];
  /** The external id of the template returned */
  templateId: Maybe<Scalars['String']>;
  /** The warehouse id to run the campaign for */
  warehouseId: Scalars['ID'];
};

export type MarketingFeatureTypesCampaignStatus = {
  __typename?: 'MarketingFeatureTypesCampaignStatus';
  /** The name of the associated experiment */
  experimentName: Maybe<Scalars['String']>;
  /** The id of the braze template */
  failedUserCount: Maybe<Scalars['Int']>;
  /** The id of the braze template */
  pendingUserCount: Maybe<Scalars['Int']>;
  /** The id of the associated push notification */
  pushNotificationId: Maybe<Scalars['ID']>;
  /** The send types of the campaign */
  sendTypes: Maybe<Array<Send>>;
  /** The id of the push notification */
  sentUserCount: Maybe<Scalars['Int']>;
  /** The internal id of the template */
  status: CampaignProgress;
  /** The id of the associated template */
  templateId: Maybe<Scalars['ID']>;
  /** The name of the template */
  totalUserCount: Scalars['Int'];
};

export type MarketingFeatureTypesEmailTemplatePreview = {
  __typename?: 'MarketingFeatureTypesEmailTemplatePreview';
  /** The full html preview of the email body */
  body: Scalars['String'];
  /** the preheader of the email */
  preheader: Maybe<Scalars['String']>;
  /** The subject of the email */
  subject: Maybe<Scalars['String']>;
  /** The external id of the template returned */
  templateId: Maybe<Scalars['String']>;
  /** The name of the template */
  templateName: Maybe<Scalars['String']>;
  /** Variables used in the template */
  variables: Maybe<Array<Scalars['String']>>;
};

export type MarketingFeatureTypesPushTemplatePreview = {
  __typename?: 'MarketingFeatureTypesPushTemplatePreview';
  /** The body of the push notification returned */
  body: Maybe<Scalars['String']>;
  /** The id of the push notification returned */
  id: Scalars['String'];
  /** The title of the push notification returned */
  title: Maybe<Scalars['String']>;
};

export type MarketingFeatureTypesTemplate = {
  __typename?: 'MarketingFeatureTypesTemplate';
  /** The id of the braze template */
  brazeTemplateId: Maybe<Scalars['String']>;
  /** The name of the template */
  emailTemplateName: Scalars['String'];
  /** The internal id of the template */
  id: Scalars['ID'];
  /** Preview of the template */
  preview: Maybe<MarketingFeatureTypesTemplatePreview>;
  /** The id of the push notification */
  pushNotificationId: Maybe<Scalars['String']>;
};


export type MarketingFeatureTypesTemplatePreviewArgs = {
  useCache?: InputMaybe<Scalars['Boolean']>;
  variables?: InputMaybe<TemplateVariablesInput>;
};

export type MarketingFeatureTypesTemplatePreview = {
  __typename?: 'MarketingFeatureTypesTemplatePreview';
  email: Maybe<MarketingFeatureTypesEmailTemplatePreview>;
  push: Maybe<MarketingFeatureTypesPushTemplatePreview>;
};

export type MarketingMessagingDetailsInput = {
  experimentName?: InputMaybe<Scalars['String']>;
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  pushNotificationId?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVariables?: InputMaybe<Scalars['JSONObject']>;
  userEmailOverrides?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MatchesAnyRetailerIdInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of retailer ids */
  retailerIds: Array<Scalars['Int']>;
};

/** Autogenerated return type of MatchesAnyRetailerIdVisibilityConditionCreate */
export type MatchesAnyRetailerIdVisibilityConditionCreatePayload = {
  __typename?: 'MatchesAnyRetailerIdVisibilityConditionCreatePayload';
  /** The newly created MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityCondition: ContentManagementVisibilityConditionMatchesAnyRetailerId;
};

/** Autogenerated return type of MatchesAnyRetailerIdVisibilityConditionUpdate */
export type MatchesAnyRetailerIdVisibilityConditionUpdatePayload = {
  __typename?: 'MatchesAnyRetailerIdVisibilityConditionUpdatePayload';
  /** The newly updated MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityCondition: ContentManagementVisibilityConditionMatchesAnyRetailerId;
};

export enum MergeableReportTypeEnum {
  /** In Store Transactions */
  InStoreTransactions = 'IN_STORE_TRANSACTIONS',
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** Shopper Reimbursements Monthly */
  ShopperReimbursementsMonthly = 'SHOPPER_REIMBURSEMENTS_MONTHLY',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
  /** Transaction Logs */
  TransactionLogs = 'TRANSACTION_LOGS'
}

export type Message = {
  __typename?: 'Message';
  content: Maybe<Scalars['String']>;
  role: Role;
  toolCallId: Maybe<Scalars['String']>;
  toolCalls: Maybe<Array<ToolCall>>;
};

export type MessageInput = {
  content?: InputMaybe<Scalars['String']>;
  role: Role;
  toolCallId?: InputMaybe<Scalars['String']>;
  toolCalls?: InputMaybe<Array<InputMaybe<ToolCallInput>>>;
};

export enum Metric {
  Orders = 'ORDERS',
  OrderPerStore = 'ORDER_PER_STORE',
  Sales = 'SALES',
  SalesPerStore = 'SALES_PER_STORE',
  Stores = 'STORES'
}

export type MetricThresholdInput = {
  metricType?: InputMaybe<MetricType>;
  threshold?: InputMaybe<Scalars['BigInt']>;
};

export enum MetricType {
  DedicatedMatchRate = 'DEDICATED_MATCH_RATE',
  DedicatedUtilizationRate = 'DEDICATED_UTILIZATION_RATE',
  Default = 'DEFAULT',
  FiveHourAvailabilityRate = 'FIVE_HOUR_AVAILABILITY_RATE',
  FulfilledOrders = 'FULFILLED_ORDERS',
  MatchRate = 'MATCH_RATE',
  RecommendedHours = 'RECOMMENDED_HOURS',
  ScheduledGaps = 'SCHEDULED_GAPS',
  ScheduledHours = 'SCHEDULED_HOURS',
  StaffingRate = 'STAFFING_RATE',
  UtilizationRate = 'UTILIZATION_RATE'
}

export type MinimumPlatformVersionInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>;
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum;
  /** Version used for the check */
  version: Scalars['String'];
};

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionCreate */
export type MinimumPlatformVersionVisibilityConditionCreatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionCreatePayload';
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion;
};

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionUpdate */
export type MinimumPlatformVersionVisibilityConditionUpdatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionUpdatePayload';
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion;
};

export type MobileAppWelcomeScreen = {
  __typename?: 'MobileAppWelcomeScreen';
  enabled: Maybe<Scalars['Boolean']>;
  valueProps: Maybe<Array<Maybe<ValueProp>>>;
};

export type MobileWebHamburgerMenuLayoutV1Navigations = {
  __typename?: 'MobileWebHamburgerMenuLayoutV1Navigations';
  navs: Maybe<Array<Maybe<NavigationWithSubNavigation>>>;
};

export type MobileWebHamburgerMenuLayoutV1NavigationsInput = {
  navs?: InputMaybe<Array<InputMaybe<NavigationWithSubNavigationInput>>>;
};

export type Moment = {
  __typename?: 'Moment';
  campaigns: Maybe<Array<Maybe<RetailerCampaign>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  endsAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  momentCampaignId: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  startsAt: Maybe<Scalars['DateTime']>;
  status: Maybe<Scalars['String']>;
  submissionDeadline: Maybe<Scalars['DateTime']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type MomentCampaignStatusInput = {
  campaignId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<Array<InputMaybe<StatusMapInput>>>;
};

export type MoveRetailerAssetsFromFilestackBucketRequestInput = {
  assetType?: InputMaybe<AssetType>;
  destinationBucket?: InputMaybe<DestinationBucket>;
  isPublicAccessible?: InputMaybe<Scalars['Boolean']>;
  objectKeyMappings?: InputMaybe<Array<InputMaybe<ObjectKeyMappingInput>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type MoveRetailerAssetsFromFilestackBucketResponse = {
  __typename?: 'MoveRetailerAssetsFromFilestackBucketResponse';
  assetKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  assetUrls: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MutableS3Asset = {
  __typename?: 'MutableS3Asset';
  /** The s3 file exists */
  exists: Scalars['Boolean'];
  /** The idenfitier for the asset */
  id: Scalars['String'];
  /** The s3 read url for getting the asset */
  s3ReadUrl: Maybe<Scalars['String']>;
  /** The s3 upload url for putting the asset */
  s3WriteUrl: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Adds scopes to an existing ban entry (additive only, safe for automation)
   * Never removes existing scopes - only adds new ones
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_AddBanEntryScopes: Maybe<Instacart_Caper_Admin_V1_AddBanEntryScopesResponse>;
  /** Creates a new ban entry with scopes */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_CreateBanEntry: Maybe<Instacart_Caper_Admin_V1_CreateBanEntryResponse>;
  /**
   * Removes specific scopes from an existing ban entry
   * Only removes the specified scopes - other scopes remain unchanged
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_RemoveBanEntryScopes: Maybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesResponse>;
  /**
   * Sets the archived status of a ban entry
   * Archived entries are soft-deleted and can be viewed with include_archived filter
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryArchived: Maybe<Scalars['instacart_caper_admin_v1_SetBanEntryArchivedResponse']>;
  /**
   * Sets the complete list of scopes for a ban entry (full replacement)
   * Replaces all existing scopes with the provided list - convenient for UI toggle states
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryScopes: Maybe<Instacart_Caper_Admin_V1_SetBanEntryScopesResponse>;
  /**
   * Adds scopes to an existing ban entry (additive only, safe for automation)
   * Never removes existing scopes - only adds new ones
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_AddBanEntryScopes: Maybe<Instacart_Caper_Admin_V1_AddBanEntryScopesResponse>;
  /** Creates a new ban entry with scopes */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_CreateBanEntry: Maybe<Instacart_Caper_Admin_V1_CreateBanEntryResponse>;
  /**
   * Removes specific scopes from an existing ban entry
   * Only removes the specified scopes - other scopes remain unchanged
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_RemoveBanEntryScopes: Maybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesResponse>;
  /**
   * Sets the archived status of a ban entry
   * Archived entries are soft-deleted and can be viewed with include_archived filter
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryArchived: Maybe<Scalars['instacart_caper_admin_v1_SetBanEntryArchivedResponse']>;
  /**
   * Sets the complete list of scopes for a ban entry (full replacement)
   * Replaces all existing scopes with the provided list - convenient for UI toggle states
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryScopes: Maybe<Instacart_Caper_Admin_V1_SetBanEntryScopesResponse>;
  /** Cancels scheduled actions before execution */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CancelScheduledAction: Maybe<Scalars['instacart_caper_admin_v1_CancelScheduledActionResponse']>;
  /** Creates a config key in the db */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateConfigKey: Maybe<Scalars['instacart_caper_admin_v1_CreateConfigKeyResponse']>;
  /** Creates a new device */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateDevice: Maybe<Scalars['instacart_caper_admin_v1_CreateDeviceResponse']>;
  /** Creates new devices */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateDevices: Maybe<Instacart_Caper_Admin_V1_CreateDevicesResponse>;
  /** Creates a new feature */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateFeature: Maybe<Scalars['instacart_caper_admin_v1_CreateFeatureResponse']>;
  /** Creates a new partner */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreatePartner: Maybe<Scalars['instacart_caper_admin_v1_CreatePartnerResponse']>;
  /** Creates a presigned asset url */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreatePresignedAssetUrl: Maybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlResponse>;
  /** Creates a new retailer */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateRetailer: Maybe<Scalars['instacart_caper_admin_v1_CreateRetailerResponse']>;
  /** Creates a new store */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateStore: Maybe<Instacart_Caper_Admin_V1_CreateStoreResponse>;
  /** Lock or unlock carts at a given entity level */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_LockCarts: Maybe<Scalars['instacart_caper_admin_v1_LockCartsResponse']>;
  /** Scheduled Actions - Creates a scheduled config or feature change */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ScheduleAction: Maybe<Instacart_Caper_Admin_V1_ScheduleActionResponse>;
  /** Batch Scheduled Actions - Creates multiple scheduled config/feature changes in one call */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ScheduleBatchActions: Maybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsResponse>;
  /** Updates configs for an entity, can include adding, editing, or deleting a config */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfig: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigResponse']>;
  /** Updates a config key in the db */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfigKey: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigKeyResponse']>;
  /** Update a device */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateDevice: Maybe<Instacart_Caper_Admin_V1_UpdateDeviceResponse>;
  /** Updates an existing feature */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateFeature: Maybe<Scalars['instacart_caper_admin_v1_UpdateFeatureResponse']>;
  /** Updates the global level */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateGlobal: Maybe<Scalars['instacart_caper_admin_v1_UpdateGlobalResponse']>;
  /** Update a partner */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdatePartner: Maybe<Instacart_Caper_Admin_V1_UpdatePartnerResponse>;
  /** Update a retailer */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateRetailer: Maybe<Instacart_Caper_Admin_V1_UpdateRetailerResponse>;
  /** Update a store */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateStore: Maybe<Instacart_Caper_Admin_V1_UpdateStoreResponse>;
  /** Cancels scheduled actions before execution */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CancelScheduledAction: Maybe<Scalars['instacart_caper_admin_v1_CancelScheduledActionResponse']>;
  /** Creates a config key in the db */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateConfigKey: Maybe<Scalars['instacart_caper_admin_v1_CreateConfigKeyResponse']>;
  /** Creates a new device */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateDevice: Maybe<Scalars['instacart_caper_admin_v1_CreateDeviceResponse']>;
  /** Creates new devices */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateDevices: Maybe<Instacart_Caper_Admin_V1_CreateDevicesResponse>;
  /** Creates a new feature */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateFeature: Maybe<Scalars['instacart_caper_admin_v1_CreateFeatureResponse']>;
  /** Creates a new partner */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreatePartner: Maybe<Scalars['instacart_caper_admin_v1_CreatePartnerResponse']>;
  /** Creates a presigned asset url */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreatePresignedAssetUrl: Maybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlResponse>;
  /** Creates a new retailer */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateRetailer: Maybe<Scalars['instacart_caper_admin_v1_CreateRetailerResponse']>;
  /** Creates a new store */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateStore: Maybe<Instacart_Caper_Admin_V1_CreateStoreResponse>;
  /** Lock or unlock carts at a given entity level */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_LockCarts: Maybe<Scalars['instacart_caper_admin_v1_LockCartsResponse']>;
  /** Scheduled Actions - Creates a scheduled config or feature change */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ScheduleAction: Maybe<Instacart_Caper_Admin_V1_ScheduleActionResponse>;
  /** Batch Scheduled Actions - Creates multiple scheduled config/feature changes in one call */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ScheduleBatchActions: Maybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsResponse>;
  /** Updates configs for an entity, can include adding, editing, or deleting a config */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfig: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigResponse']>;
  /** Updates a config key in the db */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfigKey: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigKeyResponse']>;
  /** Update a device */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateDevice: Maybe<Instacart_Caper_Admin_V1_UpdateDeviceResponse>;
  /** Updates an existing feature */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateFeature: Maybe<Scalars['instacart_caper_admin_v1_UpdateFeatureResponse']>;
  /** Updates the global level */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateGlobal: Maybe<Scalars['instacart_caper_admin_v1_UpdateGlobalResponse']>;
  /** Update a partner */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdatePartner: Maybe<Instacart_Caper_Admin_V1_UpdatePartnerResponse>;
  /** Update a retailer */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateRetailer: Maybe<Instacart_Caper_Admin_V1_UpdateRetailerResponse>;
  /** Update a store */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateStore: Maybe<Instacart_Caper_Admin_V1_UpdateStoreResponse>;
  /**
   * Triggers a new warehouse provisioning pipeline run.
   * Generates a task_id, persists a PENDING run, and initiates the pipeline
   * asynchronously. Returns immediately with the PENDING run record.
   */
  CaperDeviceProvisioningPipelineService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_TriggerPipeline: Maybe<Instacart_Caper_Admin_V1_TriggerPipelineResponse>;
  /**
   * Triggers a new warehouse provisioning pipeline run.
   * Generates a task_id, persists a PENDING run, and initiates the pipeline
   * asynchronously. Returns immediately with the PENDING run record.
   */
  CaperDeviceProvisioningPipelineStagingService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_TriggerPipeline: Maybe<Instacart_Caper_Admin_V1_TriggerPipelineResponse>;
  /** Sends a receipt */
  CaperIPPReceiptService_instacart_caper_admin_v1_IPPReceiptService_SendReceipt: Maybe<Scalars['instacart_caper_admin_v1_SendReceiptResponse']>;
  /** Reviews a specific NOF item with category and sub-category */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_ReviewNof: Maybe<Scalars['instacart_caper_admin_v1_ReviewNofResponse']>;
  /** Reviews a specific NOF item with category and sub-category */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_ReviewNof: Maybe<Scalars['instacart_caper_admin_v1_ReviewNofResponse']>;
  /** Creates a new merchant for a store with optional terminals. */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_CreateMerchant: Maybe<Instacart_Caper_Admin_V1_CreateMerchantResponse>;
  /** Creates payment terminals for devices in a store (partial-success semantics). */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_CreateTerminals: Maybe<Instacart_Caper_Admin_V1_CreateTerminalsResponse>;
  /** Transfers terminal credentials from one device to another (device replacement). */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_TransferTerminal: Maybe<Instacart_Caper_Admin_V1_TransferTerminalResponse>;
  /** Creates a new merchant for a store with optional terminals. */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_CreateMerchant: Maybe<Instacart_Caper_Admin_V1_CreateMerchantResponse>;
  /** Creates payment terminals for devices in a store (partial-success semantics). */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_CreateTerminals: Maybe<Instacart_Caper_Admin_V1_CreateTerminalsResponse>;
  /** Transfers terminal credentials from one device to another (device replacement). */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_TransferTerminal: Maybe<Instacart_Caper_Admin_V1_TransferTerminalResponse>;
  /** Initiates async datadog triage summary generation */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_CreateDatadogSummaryAsync: Maybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncResponse>;
  /** Initiates async session summary generation */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_CreateSessionSummaryAsync: Maybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncResponse>;
  /** Updates feedback and rating for an existing session summary */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_UpdateSessionSummaryFeedback: Maybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackResponse>;
  /** Initiates async datadog triage summary generation */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_CreateDatadogSummaryAsync: Maybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncResponse>;
  /** Initiates async session summary generation */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_CreateSessionSummaryAsync: Maybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncResponse>;
  /** Updates feedback and rating for an existing session summary */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_UpdateSessionSummaryFeedback: Maybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunCarouselGroupQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunContentDesignQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunFilterQualityQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunKeywordCompletenessQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunKeywordQualityQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunPageQualityQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunPolicyQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunProductQualityQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunTopicQualityQa: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaResponse>;
  /**
   * CompileTemplate transforms a template string into a TreeNode[] AST.
   * The AST is the server-authoritative representation of the template — compiling
   * server-side ensures the AST is always derived from the stored template source,
   * preventing clients from submitting arbitrary ASTs.
   */
  FrothProcessing_instacart_customers_froth_v1_FrothProcessingService_CompileTemplate: Maybe<Instacart_Customers_Froth_V1_CompileTemplateResponse>;
  /** Create a new response configuration */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_CreateResponseConfig: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigResponse>;
  /** Delete a response configuration */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_DeleteResponseConfig: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigResponse>;
  /** Send an inbound event that would normally come from partner/retailer to Relay */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_TriggerInboundEvent: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventResponse>;
  /** Update an existing response configuration */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_UpdateResponseConfig: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigResponse>;
  /** Create strings for a resource */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_CreateStrings: Maybe<Instacart_Customers_Commerce_Garnish_V1_CreateStringsResponse>;
  /** Delete resources */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_DeleteResources: Maybe<Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesResponse>;
  /** Update strings for a resource */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_UpdateStrings: Maybe<Instacart_Customers_Commerce_Garnish_V1_UpdateStringsResponse>;
  /** Sends a marketing campaign email blast */
  MarketingToolingService_instacart_growth_crm_messaging_service_v1_CRMMessagingService_CreateMarketingCampaign: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignResponse>;
  /**
   * CreateMarketingCampaign creates a new marketing campaign with all associated
   * configurations across integrated systems (targeting, messaging, discounts, experiments).
   */
  MarketingToolingService_instacart_growth_marketing_tooling_v1_MarketingToolingService_CreateMarketingCampaign: Maybe<Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignResponse>;
  /** Creates a new contact for the specified retailer */
  RetailerContactManagement_addContact: Maybe<RetailerContactManagement_AddContact_Response>;
  /** Deletes all contacts associated with the specified retailer */
  RetailerContactManagement_deleteAllContacts: Maybe<RetailerContactManagement_DeleteAllContacts_Response>;
  /** Deletes a specific contact by email address */
  RetailerContactManagement_deleteContact: Maybe<RetailerContactManagement_DeleteContact_Response>;
  /** Updates an existing contact's information */
  RetailerContactManagement_updateContact: Maybe<RetailerContactManagement_UpdateContact_Response>;
  _empty: Maybe<Scalars['String']>;
  /** Upsert an AI agent conversation */
  aiAgentConversationUpsert: Maybe<AiAgentConversationUpsertPayload>;
  aiAgentExecute: AgentResponse;
  apiIntegrationsServiceDeleteApiSetting: Maybe<DeleteApiSettingResponse>;
  apiIntegrationsServiceUpdateApiSetting: Maybe<UpdateApiSettingResponse>;
  /** Adds a review to an approval request. */
  approvalsManagementAddReview: Maybe<ReviewAddPayload>;
  /** Deletes an existing review. */
  approvalsManagementDeleteReview: Maybe<ReviewDeletePayload>;
  /** Edits an existing review. */
  approvalsManagementEditReview: Maybe<ReviewEditPayload>;
  /** Publishes an approved approval request. */
  approvalsManagementPublishApprovalRequest: Maybe<PublishApprovalRequestPayload>;
  /** Assign a permission to a role */
  assignPermissionToRole: Maybe<AssignPermissionToRolePayload>;
  /** Disable an enterprise account and associated alias accounts by its email */
  botEnterpriseAccountDisable: Maybe<BotEnterpriseAccountDisablePayload>;
  /** Create/update a new enterprise account by its email */
  botEnterpriseAccountUpsert: Maybe<BotEnterpriseAccountUpsertPayload>;
  catalogProblemTrackerServiceCreateTicket: Maybe<CreateTicketResponse>;
  catalogToolsApiServiceCreatePatchApproval: Maybe<CreatePatchApprovalResponse>;
  catalogToolsApiServiceCreatePriceAnomalyInvestigation: Maybe<CreatePriceAnomalyInvestigationResponse>;
  catalogToolsApiServiceCreatePriceAnomalyPatch: Maybe<CreatePriceAnomalyPatchResponse>;
  catalogToolsApiServiceDeactivatePriceAnomalyPatch: Maybe<DeactivatePriceAnomalyPatchResponse>;
  collectionsServiceSetMultiRetailerPageCollectionsCache: Maybe<SetMultiRetailerPageCollectionsCacheResponse>;
  configurableItemsServicePublishRppConfigurableItems: Maybe<PublishRppConfigurableItemsResponse>;
  connectPlatformServiceAdvanceBatchState: Maybe<AdvanceBatchStateResponse>;
  connectPlatformServiceAssignVirtualBatch: Maybe<AssignVirtualBatchResponse>;
  connectPlatformServiceCreateDriver: Maybe<CreateDriverResponse>;
  connectPlatformServiceCreatePartnerApiKey: Maybe<ConnectApiKey>;
  connectPlatformServiceGenerateBatch: Maybe<GenerateBatchResponse>;
  connectPlatformServiceRevokePartnerApiKey: Maybe<RevokePartnerApiKeyResponse>;
  connectPlatformServiceUpdateShopperOrderItem: Maybe<UpdateShopperOrderItemResponse>;
  contentManagementAdminServiceBatchUpdateSlotCreatives: Maybe<BatchUpdateSlotCreativesResponse>;
  contentManagementAdminServiceCreateAiCarousel: Maybe<CreateAiCarouselResponse>;
  contentManagementAdminServiceCreateContentPage: Maybe<CreateContentPageResponse>;
  contentManagementAdminServiceCreateContentPageV2: Maybe<CreateContentPageResponseV2>;
  contentManagementAdminServiceCreateContentPageVersion: Maybe<CreateContentPageVersionResponse>;
  contentManagementAdminServiceCreateContentPageVersionMeta: Maybe<CreateContentPageVersionMetaResponse>;
  contentManagementAdminServiceCreateCreativePlacements: Maybe<CreateCreativePlacementsResponse>;
  contentManagementAdminServiceCreateNativeTabBarNavigation: Maybe<CreateNativeTabBarNavigationResponse>;
  contentManagementAdminServiceCreateNavigation: Maybe<CreateNavigationResponse>;
  contentManagementAdminServiceCreateNavigationPreview: Maybe<CreateNavigationPreviewResponse>;
  contentManagementAdminServiceCreatePlacementContent: Maybe<CreatePlacementContentResponse>;
  contentManagementAdminServiceCreateSlot: Maybe<CreateSlotResponse>;
  contentManagementAdminServiceCreateSlotCreative: Maybe<CreateSlotCreativeResponse>;
  contentManagementAdminServiceCreateSlotPlacement: Maybe<CreateSlotPlacementResponse>;
  contentManagementAdminServiceDeleteContentPage: Maybe<DeleteContentPageResponse>;
  contentManagementAdminServiceDeleteContentPageVersion: Maybe<DeleteContentPageVersionResponse>;
  contentManagementAdminServiceDeleteNativeTabBarNavigation: Maybe<DeleteNativeTabBarNavigationResponse>;
  contentManagementAdminServiceDeleteNavigation: Maybe<DeleteNavigationResponse>;
  contentManagementAdminServiceDeleteSlot: Maybe<DeleteSlotResponse>;
  contentManagementAdminServiceDeleteSlotCreative: Maybe<DeleteSlotCreativeResponse>;
  contentManagementAdminServiceDisablePlacementContent: Maybe<DisablePlacementContentResponse>;
  contentManagementAdminServiceDuplicateContentPage: Maybe<DuplicateContentPageResponse>;
  contentManagementAdminServiceSaveToolingShortcuts: Maybe<SaveToolingShortcutsResponse>;
  contentManagementAdminServiceStartConvertPlacementVideo: Maybe<StartConvertPlacementVideoResponse>;
  contentManagementAdminServiceUpdateAdminNavigationV2: Maybe<UpdateAdminNavigationV2Response>;
  contentManagementAdminServiceUpdateContentPageV2: Maybe<UpdateContentPageResponseV2>;
  contentManagementAdminServiceUpdateContentPageVersion: Maybe<UpdateContentPageVersionResponse>;
  contentManagementAdminServiceUpdateContentPageVersionMeta: Maybe<UpdateContentPageVersionMetaResponse>;
  contentManagementAdminServiceUpdateNativeTabBarNavigation: Maybe<UpdateNativeTabBarNavigationResponse>;
  contentManagementAdminServiceUpdateNavigation: Maybe<UpdateNavigationResponse>;
  contentManagementAdminServiceUpdatePlacementContent: Maybe<UpdatePlacementContentResponse>;
  contentManagementAdminServiceUpdateSocialIconsNavigation: Maybe<UpdateSocialIconsNavigationResponse>;
  contentManagementServiceBatchUpdatePlacements: Maybe<PlacementsResponse>;
  contentManagementServiceCreateLayoutVariant: Maybe<CreateLayoutVariantResponse>;
  contentManagementServiceCreatePlacement: Maybe<CreatePlacementResponse>;
  contentManagementServiceCreateThemePage: Maybe<CreateThemePageResponse>;
  contentManagementServiceDeleteLayoutVariant: Maybe<DeleteLayoutVariantResponse>;
  contentManagementServiceDeletePlacement: Maybe<DeletePlacementResponse>;
  contentManagementServiceDisableThemePage: Maybe<DisableThemePageResponse>;
  contentManagementServiceUpdateLayoutVariant: Maybe<UpdateLayoutVariantResponse>;
  contentManagementServiceUpdateThemePage: Maybe<UpdateThemePageResponse>;
  /** Create a CountryIds visibility condition */
  countryIdsVisibilityConditionCreate: Maybe<CountryIdsVisibilityConditionCreatePayload>;
  /** Update a CountryIds visibility condition */
  countryIdsVisibilityConditionUpdate: Maybe<CountryIdsVisibilityConditionUpdatePayload>;
  /** Create a ExpressMembership visibility condition */
  dayOfWeekVisibilityConditionCreate: Maybe<DayOfWeekVisibilityConditionCreatePayload>;
  /** Update an existing ShoppedAtRetailer visibility condition */
  dayOfWeekVisibilityConditionUpdate: Maybe<DayOfWeekVisibilityConditionUpdatePayload>;
  demeterServiceAuditDetection: Maybe<AuditDetectionResponse>;
  demeterServiceCombineAuditBatches: Maybe<CombineAuditBatchesResponse>;
  demeterServiceCreateAuditWorkflow: Maybe<CreateAuditWorkflowResponse>;
  demeterServiceCreateDetection: Maybe<CreateDetectionResponse>;
  demeterServiceCreateDetectionVersion: Maybe<CreateDetectionVersionResponse>;
  demeterServiceReassignAuditBatchWorkflow: Maybe<ReassignAuditBatchWorkflowResponse>;
  demeterServiceTombstoneDetectionVersion: Maybe<TombstoneDetectionVersionResponse>;
  demeterServiceUpdateAuditBatch: Maybe<UpdateAuditBatchResponse>;
  demeterServiceUpdateAuditTask: Maybe<UpdateAuditTaskResponse>;
  demeterServiceUpdateAuditWorkflow: Maybe<UpdateAuditWorkflowResponse>;
  emergingBrandPortalServiceContactBrand: Maybe<BrandContactResponse>;
  /** Accept a partner agreement for the current account */
  enterpriseAccountAcceptPartnerAgreement: Maybe<EnterpriseAccountAcceptPartnerAgreementPayload>;
  /** Set up a new account using an account setup token */
  enterpriseAccountAccountSetup: Maybe<EnterpriseAccountAccountSetupPayload>;
  /** Authenticate an account using an email and password */
  enterpriseAccountAuthenticateEmailPassword: Maybe<EnterpriseAccountAuthenticateEmailPasswordPayload>;
  /** Preflight authentication info per email address */
  enterpriseAccountAuthenticatePreflight: Maybe<EnterpriseAccountAuthenticatePreflightPayload>;
  /** Create a new enterprise account */
  enterpriseAccountCreate: Maybe<EnterpriseAccountCreatePayload>;
  /** Create a new enterprise account that can only access documentation */
  enterpriseAccountCreateNoPartnerAccess: Maybe<EnterpriseAccountCreateNoPartnerAccessPayload>;
  /** Disable the impersonation for the current account */
  enterpriseAccountDisableImpersonation: Maybe<EnterpriseAccountDisableImpersonationPayload>;
  /** Enable impersonation for the current account */
  enterpriseAccountEnableImpersonation: Maybe<EnterpriseAccountEnableImpersonationPayload>;
  /** Deactivate MFA for an account */
  enterpriseAccountMfaDeactivate: Maybe<EnterpriseAccountMfaDeactivatePayload>;
  /** Enable MFA for an account */
  enterpriseAccountMfaEnable: Maybe<EnterpriseAccountMfaEnablePayload>;
  /** Reset MFA for an account */
  enterpriseAccountMfaReset: Maybe<EnterpriseAccountMfaResetPayload>;
  /** Partner Onboarding new account token request, generate new email that will be sent to an Account's email address */
  enterpriseAccountPartnerOnboardingRequestAccountSetupEmail: Maybe<EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload>;
  /** Request that an account setup email be sent to an Account's email address */
  enterpriseAccountRequestAccountSetupEmail: Maybe<EnterpriseAccountRequestAccountSetupEmailPayload>;
  /** Request for partner write access for a specific partner */
  enterpriseAccountRequestBreakGlassPartnerWriteAccess: Maybe<EnterpriseAccountRequestBreakGlassPartnerWriteAccessPayload>;
  /** Request that a verification email be sent to an Account's email address */
  enterpriseAccountRequestEmailVerification: Maybe<EnterpriseAccountRequestEmailVerificationPayload>;
  /** Set/Reset an account's password using a password reset token */
  enterpriseAccountResetPassword: Maybe<EnterpriseAccountResetPasswordPayload>;
  /** Sets the disabled flag on an account to true/false */
  enterpriseAccountSetDisabled: Maybe<EnterpriseAccountSetDisabledPayload>;
  /** Update an enterprise account */
  enterpriseAccountUpdate: Maybe<EnterpriseAccountUpdatePayload>;
  /** Updates the hidden settings for an account */
  enterpriseAccountUpdateHiddenSettings: Maybe<EnterpriseAccountUpdateHiddenSettingsPayload>;
  /** Update the password for the currently logged-in account */
  enterpriseAccountUpdatePassword: Maybe<EnterpriseAccountUpdatePasswordPayload>;
  /** Update an enterprise account's roles */
  enterpriseAccountUpdateRoles: Maybe<EnterpriseAccountUpdateRolesPayload>;
  /** Updates the user locale for an account */
  enterpriseAccountUpdateUserLocale: Maybe<EnterpriseAccountUpdateUserLocalePayload>;
  /** Verify an account via account setup token */
  enterpriseAccountVerifyAccountSetupToken: Maybe<EnterpriseAccountVerifyAccountSetupTokenPayload>;
  /** Verify an account's email using a verification token */
  enterpriseAccountVerifyEmail: Maybe<EnterpriseAccountVerifyEmailPayload>;
  /** Create a ExperimentVariant visibility condition */
  experimentVariantVisibilityConditionCreate: Maybe<ExperimentVariantVisibilityConditionCreatePayload>;
  /** Update a ExperimentVariant visibility condition */
  experimentVariantVisibilityConditionUpdate: Maybe<ExperimentVariantVisibilityConditionUpdatePayload>;
  /** Create a ExpressMembership visibility condition */
  expressMembershipVisibilityConditionCreate: Maybe<ExpressMembershipVisibilityConditionCreatePayload>;
  /** Update an existing ExpressMembership visibility condition */
  expressMembershipVisibilityConditionUpdate: Maybe<ExpressMembershipVisibilityConditionUpdatePayload>;
  /** Create an ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityConditionCreate: Maybe<ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload>;
  /** Create a new flyout placement */
  flyoutPlacementCreate: Maybe<FlyoutPlacementCreatePayload>;
  /** Update an existing flyout placement */
  flyoutPlacementUpdate: Maybe<FlyoutPlacementUpdatePayload>;
  /** Create a new home placement with HeroBanner banner */
  heroBannerPlacementCreate: Maybe<HeroBannerPlacementCreatePayload>;
  /** Update an existing hero_banner placement placement */
  heroBannerPlacementUpdate: Maybe<HeroBannerPlacementUpdatePayload>;
  instacart_ads_nexus_v1_AdsBlockingService_UpsertAdReview: Maybe<Instacart_Ads_Nexus_V1_UpsertAdReviewsResponse>;
  /** Creates a segment based on user intention using generative AI */
  instacart_ads_platform_taas_v1_SegmentRegistryService_CreateGenerativeAudienceSegmentDefinition: Maybe<Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentResponse>;
  /**
   * CREATE
   *
   * The response will have a newly-minted ID, which always have version_number
   * 1, and the definition will be the same as what was passed in the request.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_CreateSegment: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  /**
   * DELETE
   *
   * The response will have the version number one greater than the request,
   * and the definition will be empty.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_DeleteSegment: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  /**
   * UDPATE
   *
   * The response will have the version number one greater than the request,
   * and the definition will be the same as what was passed in the request.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_UpdateSegment: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  instacart_ads_v3_RetailerBlockedAdsService_RetailerBlockAd: Maybe<Instacart_Ads_V3_RetailerBlockAdResponse>;
  /** Creates a new carousel based on a user prompt and other criteria. */
  instacart_algorithms_ai_carousel_creator_v1_AiCarouselCreatorService_CreateCarousel: Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselResponse>;
  instacart_care_tools_v1_CareToolsService_CreateNoteForOrder: Maybe<Instacart_Care_Tools_V1_CreateNoteForOrderResponse>;
  instacart_care_tools_v1_CareToolsService_CreateNoteForUser: Maybe<Instacart_Care_Tools_V1_CreateNoteForUserResponse>;
  instacart_care_tools_v1_CareToolsService_LinkIsolatedUser: Maybe<Instacart_Care_Tools_V1_LinkIsolatedUserResponse>;
  instacart_care_tools_v1_CareToolsService_UnlinkIsolatedUser: Maybe<Instacart_Care_Tools_V1_UnlinkIsolatedUserResponse>;
  instacart_care_tools_v1_CareToolsService_UpdateAddressForUser: Maybe<Instacart_Care_Tools_V1_UpdateAddressForUserResponse>;
  instacart_care_tools_v1_CareToolsService_UpdateSubscriptionAutorenew: Maybe<Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewResponse>;
  /** The SetAuditFindings API persists audit findings */
  instacart_cashflow_nutella_v1_NutellaService_SetAuditFindings: Maybe<Instacart_Cashflow_Nutella_V1_SetAuditFindingsResponse>;
  /** GetMissingCodesForcemarkDetails retrieves missing codes forcemark details for a specific forcemark. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_MakeMissingCodeDecision: Maybe<Scalars['instacart_catalog_admin_v1_MakeMissingCodeDecisionResponse']>;
  /** SetRetailerDiscountThresholdBringBacks will bring back any selected items that were taken down due to this tool */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_SetRetailerDiscountThresholdBringBacks: Maybe<Scalars['instacart_catalog_admin_v1_SetRetailerDiscountThresholdBringBacksResponse']>;
  /** SetRetailerDiscountThresholds sets retailer discount thresholds in the db for a particular retailer */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_SetRetailerDiscountThresholds: Maybe<Scalars['instacart_catalog_admin_v1_SetRetailerDiscountThresholdsResponse']>;
  /** Create Item Bring Back Requests from a CSV uploaded to Filestack */
  instacart_catalog_admin_v1_TakeDownService_ItemBringBackBatchCsv: Maybe<Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvResponse>;
  /** Create a temporary override for a retailer product or item. */
  instacart_catalog_admin_v1_TempOverrideService_Create: Maybe<Scalars['instacart_catalog_admin_v1_TempOverrideServiceCreateResponse']>;
  /** CAMP Pipeline Step Endpoints */
  instacart_catalog_catflow_v1_CatflowAPI_CreateNewStep: Maybe<Instacart_Catalog_Catflow_V1_CreateNewStepResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_CreateNewStepVersion: Maybe<Instacart_Catalog_Catflow_V1_CreateNewStepVersionResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_RevertToStepVersion: Maybe<Scalars['instacart_catalog_catflow_v1_RevertToStepVersionResponse']>;
  instacart_catalog_catflow_v1_CatflowAPI_RunManualStepTest: Maybe<Instacart_Catalog_Catflow_V1_RunManualStepTestResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_UpdateStep: Maybe<Scalars['instacart_catalog_catflow_v1_UpdateStepResponse']>;
  instacart_catalog_catflow_v1_CatflowAPI_UpdateStepVersionState: Maybe<Scalars['instacart_catalog_catflow_v1_UpdateStepVersionStateResponse']>;
  /**
   * Batch Execution APIs
   * Creates a new batch execution for a bridge
   */
  instacart_catalog_data_bridge_v1_DataBridgeService_CreateBatch: Maybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchResponse>;
  /** Creates a new batch event for tracking batch lifecycle */
  instacart_catalog_data_bridge_v1_DataBridgeService_CreateBatchEvent: Maybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchEventResponse>;
  /**
   * Bridge Management APIs
   * Creates a new bridge configuration for connecting data systems
   */
  instacart_catalog_data_bridge_v1_DataBridgeService_CreateBridge: Maybe<Instacart_Catalog_Data_Bridge_V1_CreateBridgeResponse>;
  /** Soft deletes a bridge by setting tombstoned flag */
  instacart_catalog_data_bridge_v1_DataBridgeService_DeleteBridge: Maybe<Instacart_Catalog_Data_Bridge_V1_DeleteBridgeResponse>;
  /** Updates an existing bridge configuration */
  instacart_catalog_data_bridge_v1_DataBridgeService_UpdateBridge: Maybe<Instacart_Catalog_Data_Bridge_V1_UpdateBridgeResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_CreateBusinessProgram: Maybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_CreateBusinessProgramContent: Maybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_CreateBusinessProgramOffer: Maybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_DeleteBusinessProgram: Maybe<Scalars['instacart_customers_business_admin_v1_DeleteBusinessProgramResponse']>;
  instacart_customers_business_admin_v1_BusinessAdminService_DeleteBusinessProgramContent: Maybe<Scalars['instacart_customers_business_admin_v1_DeleteBusinessProgramContentResponse']>;
  instacart_customers_business_admin_v1_BusinessAdminService_DeleteBusinessProgramOffer: Maybe<Scalars['instacart_customers_business_admin_v1_DeleteBusinessProgramOfferResponse']>;
  instacart_customers_business_admin_v1_BusinessAdminService_UpdateBusinessProgram: Maybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_UpdateBusinessProgramContent: Maybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_UpdateBusinessProgramOffer: Maybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferResponse>;
  instacart_customers_campaigns_v1_CampaignsService_BulkUpdateCampaignSlotRanking: Maybe<Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingResponse>;
  instacart_customers_campaigns_v1_CampaignsService_MarketingAgentCalculatePerformanceMetrics: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsResponse>;
  instacart_customers_campaigns_v1_CampaignsService_ProcessEmailCsv: Maybe<Instacart_Customers_Campaigns_V1_ProcessEmailCsvResponse>;
  instacart_customers_campaigns_v1_CampaignsService_SaveMarketingAgentCampaign: Maybe<Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignResponse>;
  instacart_customers_campaigns_v1_CampaignsService_TestOfflineCampaign: Maybe<Scalars['instacart_customers_campaigns_v1_TestOfflineCampaignResponse']>;
  instacart_customers_commerce_coupons_v1_CommerceCouponsService_BulkCreateChildCouponCodes: Maybe<Scalars['instacart_customers_commerce_coupons_v1_BulkCreateChildCouponCodesResponse']>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_CreateValueGrantPolicy: Maybe<Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyResponse>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_PublishValueGrantPolicy: Maybe<Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyResponse>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_UpdateValueGrantPolicy: Maybe<Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyResponse>;
  instacart_customers_connect_platform_v1_ConnectPlatformService_GenerateBatch: Maybe<Instacart_Customers_Connect_Platform_V1_GenerateBatchResponse>;
  instacart_customers_connect_platform_v1_ConnectPlatformService_UpdateShopperOrderItem: Maybe<Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_AddRetailerCampaignTreatments: Maybe<Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CancelMoment: Maybe<Instacart_Customers_Coupons_V1_CancelMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CancelRetailerCampaign: Maybe<Instacart_Customers_Coupons_V1_CancelRetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CreateMoment: Maybe<Instacart_Customers_Coupons_V1_CreateMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CreateRetailerCampaign: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateCampaignBudget: Maybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateMoment: Maybe<Instacart_Customers_Coupons_V1_UpdateMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateMomentCampaignStatus: Maybe<Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateRetailerCampaign: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateRetailerCampaignTreatments: Maybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsResponse>;
  /** Run the ruleset */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_EvaluateRuleSet: Maybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse>;
  /** Publish rule set run results to flyer service */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_PublishRuleSetRunResults: Maybe<Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsResponse>;
  /** Updates/Creates a rule set */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_UpdateRuleSet: Maybe<Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetResponse>;
  /** Creates a new gift order digital card */
  instacart_customers_gifting_v1_GiftOrderDigitalCardService_CreateGiftOrderDigitalCard: Maybe<Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardResponse>;
  /** Updates an existing gift order digital card */
  instacart_customers_gifting_v1_GiftOrderDigitalCardService_UpdateGiftOrderDigitalCard: Maybe<Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardResponse>;
  /** Create a loyalty benefit for a program. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_CreateLoyaltyBenefit: Maybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitResponse>;
  /** Create a loyalty card validation. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_CreateLoyaltyCardValidation: Maybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationResponse>;
  /** Create a loyalty program for a retailer. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_CreateLoyaltyProgram: Maybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramResponse>;
  /** Update a loyalty benefit for a program. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_UpdateLoyaltyBenefit: Maybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitResponse>;
  /** Update a loyalty card validation. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_UpdateLoyaltyCardValidation: Maybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationResponse>;
  /** Update a loyalty program for a retailer. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_UpdateLoyaltyProgram: Maybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramResponse>;
  instacart_customers_partners_v1_PartnersService_CreateOrUpdatePartner: Maybe<Instacart_Customers_Partners_V1_CreateOrUpdatePartnerResponse>;
  instacart_customers_partnership_offer_v1_PartnershipOfferService_CreateRedemptionUrls: Maybe<Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsResponse>;
  instacart_customers_recipes_v1_RecipesService_BulkUpdateRecipes: Maybe<Instacart_Customers_Recipes_V1_BulkUpdateRecipesResponse>;
  instacart_customers_recipes_v1_RecipesService_IngestRecipesCsv: Maybe<Instacart_Customers_Recipes_V1_IngestRecipesCsvResponse>;
  instacart_customers_recipes_v1_RecipesService_UpdateRecipes: Maybe<Instacart_Customers_Recipes_V1_UpdateRecipesResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CopyFlyerClickableAreas: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CreateFlyerActivity: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CreateFlyerClickableArea: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CreateOrUpdateFlyerMetadata: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_DeleteFlyerClickableAreas: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_ProcessFlyerIngestionFileUpload: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_TriggerFlyerSync: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_UpdateFlyerActivity: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_UpdateFlyerClickableArea: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_UpdateFlyers: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateGlobalCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateInvfMapping: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateRootNode: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteGlobalCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteInvfMapping: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteNavigationNode: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DuplicateDepartment: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_OrderNavigationNodes: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_QueueNavigationMigration: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateCollectionProducts: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateGlobalCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateNavigationConfiguration: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpsertNavigationNode: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeResponse>;
  instacart_customers_retailer_management_orchestrator_v1_RetailerManagementService_DeleteIppDraft: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftResponse>;
  instacart_customers_retailer_management_orchestrator_v1_RetailerManagementService_PublishIppDraft: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftResponse>;
  instacart_customers_retailer_management_orchestrator_v1_RetailerManagementService_RevertIppDraft: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_CreateIppDraft: Maybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_DeleteIppDraft: Maybe<Instacart_Customers_Retailer_Management_V1_DeleteIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_PublishIppDraft: Maybe<Instacart_Customers_Retailer_Management_V1_PublishIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_RevertIppDraft: Maybe<Instacart_Customers_Retailer_Management_V1_RevertIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_UpdateIppDraftContent: Maybe<Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentResponse>;
  instacart_customers_retailer_management_v1_IppDraftPreviewService_CreateIppDraftPreview: Maybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewResponse>;
  /** Enable CMS site widgets for a store configuration */
  instacart_customers_retailer_management_v1_WidgetConfigurationService_EnableCmsSiteWidgets: Maybe<Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsResponse>;
  /** Update a client configuration */
  instacart_customers_retailer_management_v1_WidgetConfigurationService_UpdateClientConfiguration: Maybe<Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationResponse>;
  instacart_customers_search_v1_SearchService_CreateOrUpdateSearchTermOverrides: Maybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesResponse>;
  instacart_customers_search_v1_SearchService_DeleteSearchTermOverridesById: Maybe<Scalars['instacart_customers_search_v1_DeleteSearchTermOverridesByIdResponse']>;
  /** Cancels a partner bulk delivery route and transfers all orders to specified destinations. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_CancelPartnerBulkDeliveryRoute: Maybe<Scalars['instacart_enterprise_frigate_delivery_software_v1_CancelPartnerBulkDeliveryRouteResponse']>;
  /** Updates a partner bulk delivery route with reordering and/or transfer operations. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_UpdatePartnerBulkDeliveryRoute: Maybe<Scalars['instacart_enterprise_frigate_delivery_software_v1_UpdatePartnerBulkDeliveryRouteResponse']>;
  /** Creates a new vehicle for a warehouse location. */
  instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehiclesService_CreateWarehouseLocationVehicle: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleResponse>;
  /** Updates an existing warehouse location vehicle. */
  instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehiclesService_UpdateWarehouseLocationVehicle: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleResponse>;
  /** Process an adjustment request (e.g. a refund) */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_AdjustDashboardOrder: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderResponse>;
  /** Cancels an order via an OrderCancellationPolicy. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_CancelDashboardOrder: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderResponse>;
  /** Reschedules an order via an OrderReschedulePolicy. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_RescheduleDashboardOrder: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderResponse>;
  /** Generates a shifts report based on the provided criteria */
  instacart_enterprise_frigate_shifts_v1_BulkShiftDownloadService_GenerateShiftsReport: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportResponse>;
  /** Service for getting presigned file upload URL */
  instacart_enterprise_frigate_shifts_v1_BulkShiftUploadService_GeneratePresignedFileUploadUrl: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlResponse>;
  /** Process uploaded CSV file for shift management */
  instacart_enterprise_frigate_shifts_v1_BulkShiftUploadService_ProcessUploadedCsv: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvResponse>;
  /** Service for validating uploaded bulk shift CSV */
  instacart_enterprise_frigate_shifts_v1_BulkShiftUploadService_ValidateUploadedBulkShiftFile: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse>;
  /** Creates a new partner-managed shift (either single or recurring). */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_CreatePartnerManagedShift: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftResponse>;
  /** Deletes a partner-managed shift. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_DeletePartnerManagedShift: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftResponse>;
  /** Updates an existing partner-managed shift. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_UpdatePartnerManagedShift: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftResponse>;
  /** Unlocks a partner-managed driver's device. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShoppersService_UnlockPartnerManagedDriverDevice: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceResponse>;
  /**
   * Matches the existing Connect Platform RPC as we move this out of
   * customers-backend
   */
  instacart_enterprise_fulfillment_simulation_engine_v1_OrderSimulationService_AdvanceBatch: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchResponse>;
  /**
   * Generate a batch for the order(s)
   * Matches the existing Connect Platform RPC as we move this out of
   * customers-backend
   */
  instacart_enterprise_fulfillment_simulation_engine_v1_OrderSimulationService_GenerateBatch: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchResponse>;
  /** Create a shopper (driver) given an email, phone number and password. */
  instacart_enterprise_fulfillment_simulation_engine_v1_ShopperSimulationService_CreateShopper: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperResponse>;
  /** Updates an existing shopper order item */
  instacart_enterprise_fulfillment_simulation_engine_v1_ShopperSimulationService_UpdateShopperOrderItem: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemResponse>;
  /** Create a secondary review for a primary step log audit */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_CreateSecondaryStepLogAudit: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateSecondaryStepLogAuditResponse>;
  /** Create a step log audit */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_CreateStepLogAudit: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditResponse>;
  /**
   * Replay reconciliation for a batch for debugging purposes.
   * This will NOT execute any reconciliation actions, but only performs
   * calculations and generates logs for inspection.
   */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_ReplayReconciliation: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationResponse>;
  /** Run a decision component from input */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_RunDecision: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionResponse>;
  /** Categorize line items by batch ID */
  instacart_fulfillment_shopper_transaction_integrity_v1_CategorizationService_CategorizeByBatch: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchResponse>;
  /** Create categorization analysis record */
  instacart_fulfillment_shopper_transaction_integrity_v1_CategorizationService_CreateCategorizationAnalysis: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisResponse>;
  /** Cancels a marketing campaign in progress */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_CancelMarketingCampaign: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignResponse>;
  /** Creates an intention configuration for a future message */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_CreateIntentionConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationResponse>;
  /** Update an intention configuration */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_UpdateIntentionConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationResponse>;
  /** Update the settings of a retailer_configuration */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_UpdateRetailerConfigurationSettings: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsResponse>;
  /** Upsert email unsubscribers */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_UpsertEmailUnsubscribers: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersResponse>;
  /** Endpoint to create a new Module */
  instacart_infra_instaform_v1_InstaformService_CreateModule: Maybe<Instacart_Infra_Instaform_V1_CreateModuleResponse>;
  /** Create a new request note */
  instacart_logistics_marketplace_ops_v1_MarketplaceOps_CreateRequestNote: Maybe<Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteResponse>;
  /** Delete an existing note */
  instacart_logistics_marketplace_ops_v1_MarketplaceOps_DeleteRequestNote: Maybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteResponse>;
  /** Update an existing note */
  instacart_logistics_marketplace_ops_v1_MarketplaceOps_UpdateRequestNote: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteResponse>;
  /** Adding a request note to OpsEscalationRequest */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_AddRequestNoteToOpsEscalationRequest: Maybe<Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestResponse>;
  /** Update the status of multiple OpsEscalationRequests */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_BulkUpdateOpsEscalationRequestStatus: Maybe<Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusResponse>;
  /** Bulk create OpsEscalationRequests */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_CreateOpsEscalationRequests: Maybe<Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsResponse>;
  /** Deleting request notes (bulk) */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_DeleteOpsEscalationRequestRequestNotes: Maybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesResponse>;
  /** Bulk delete OpsEscalationRequests by IDs */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_DeleteOpsEscalationRequests: Maybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsResponse>;
  /** Updating a request note */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_UpdateOpsEscalationRequestRequestNote: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteResponse>;
  /** Update the status of an OpsEscalationRequest */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_UpdateOpsEscalationRequestStatus: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusResponse>;
  /** Bulk update OpsEscalationRequests */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_UpdateOpsEscalationRequests: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsResponse>;
  /** Add 1 or more locations to an existing event */
  instacart_logistics_v1_FulfillmentEvents_AddLocationsToParentEvent: Maybe<Instacart_Logistics_V1_AddLocationsToParentEventResponse>;
  /** Cancel/stop a list of fulfillment events */
  instacart_logistics_v1_FulfillmentEvents_CancelFulfillmentEvents: Maybe<Instacart_Logistics_V1_CancelFulfillmentEventsResponse>;
  /** Create a new closure event */
  instacart_logistics_v1_FulfillmentEvents_CreateClosureEvent: Maybe<Instacart_Logistics_V1_CreateClosureEventResponse>;
  /** Create a closure event approval request */
  instacart_logistics_v1_FulfillmentEvents_CreateClosureEventApprovalRequest: Maybe<Instacart_Logistics_V1_CreateClosureEventApprovalRequestResponse>;
  /** Create a new fulfillment capacity-impacting event */
  instacart_logistics_v1_FulfillmentEvents_CreateFulfillmentEvent: Maybe<Instacart_Logistics_V1_CreateFulfillmentEventResponse>;
  /** Create a new restricted availability event */
  instacart_logistics_v1_FulfillmentEvents_CreateRestrictedAvailabilityEvent: Maybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventResponse>;
  /** Create a restricted availability event approval request */
  instacart_logistics_v1_FulfillmentEvents_CreateRestrictedAvailabilityEventApprovalRequest: Maybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestResponse>;
  /** Update a closure event */
  instacart_logistics_v1_FulfillmentEvents_UpdateClosureEvents: Maybe<Instacart_Logistics_V1_UpdateClosureEventsResponse>;
  /** Update a fulfillment capacity-impacting event */
  instacart_logistics_v1_FulfillmentEvents_UpdateFulfillmentEvents: Maybe<Instacart_Logistics_V1_UpdateFulfillmentEventsResponse>;
  /** Update a restricted availability event */
  instacart_logistics_v1_FulfillmentEvents_UpdateRestrictedAvailabilityEvents: Maybe<Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsResponse>;
  /**
   * CancelIntervention cancels an intervention that is in a pre-execution state.
   * Interventions can be canceled when they are in draft, pending_approval, or approved states.
   */
  instacart_massops_v1_MassOpsService_CancelIntervention: Maybe<Instacart_Massops_V1_CancelInterventionResponse>;
  /**
   * CreateIntervention creates a new intervention instance with the specified type and parameters.
   * The intervention is created in a pending state and must be executed separately.
   */
  instacart_massops_v1_MassOpsService_CreateIntervention: Maybe<Instacart_Massops_V1_CreateInterventionResponse>;
  /**
   * ExecuteIntervention starts the execution of a previously created intervention.
   * This will begin processing all tasks associated with the intervention.
   */
  instacart_massops_v1_MassOpsService_ExecuteIntervention: Maybe<Instacart_Massops_V1_ExecuteInterventionResponse>;
  /**
   * RequestInterventionApproval requests approval for an intervention that is in draft state.
   * This transitions the intervention from draft to pending_approval state.
   */
  instacart_massops_v1_MassOpsService_RequestInterventionApproval: Maybe<Instacart_Massops_V1_RequestInterventionApprovalResponse>;
  /**
   * SyncInterventionApprovalResult receives approval callback from external systems and syncs
   * the approval decision state. This is a passive endpoint that records externally-made
   * decisions, not an action trigger. Future ApproveIntervention/RejectIntervention
   * endpoints will be added to actually trigger approval flows.
   */
  instacart_massops_v1_MassOpsService_SyncInterventionApprovalResult: Maybe<Instacart_Massops_V1_SyncInterventionApprovalResultResponse>;
  /**
   * UpdateIntervention updates an existing intervention's name, description, and parameters.
   * Only the fields provided in the request will be updated.
   */
  instacart_massops_v1_MassOpsService_UpdateIntervention: Maybe<Instacart_Massops_V1_UpdateInterventionResponse>;
  /**
   * UpdateInterventionCommunicationSettings updates the communication settings for an intervention.
   * This includes email and SMS notification configurations with multi-locale support.
   */
  instacart_massops_v1_MassOpsService_UpdateInterventionCommunicationSettings: Maybe<Instacart_Massops_V1_UpdateInterventionCommunicationSettingsResponse>;
  /**
   * UploadInterventionData uploads CSV data containing the entities or tasks to be processed
   * by the intervention. This data defines what the intervention will operate on.
   */
  instacart_massops_v1_MassOpsService_UploadInterventionData: Maybe<Instacart_Massops_V1_UploadInterventionDataResponse>;
  /** Create a note on a site × feature intersection */
  instacart_partners_partners_v1_FlipService_CreateFlipNote: Maybe<Instacart_Partners_Partners_V1_CreateFlipNoteResponse>;
  /** Soft-delete a note */
  instacart_partners_partners_v1_FlipService_DeleteFlipNote: Maybe<Instacart_Partners_Partners_V1_DeleteFlipNoteResponse>;
  /** Update an existing note's body */
  instacart_partners_partners_v1_FlipService_UpdateFlipNote: Maybe<Instacart_Partners_Partners_V1_UpdateFlipNoteResponse>;
  /** Release an App to Production.  This RPC starts an asyncrhonous process which submits this app to App Store (or Play Store) */
  instacart_partners_partners_v1_MobileAppsManagementService_ReleaseAppToProduction: Maybe<Instacart_Partners_Partners_V1_ReleaseAppToProductionResponse>;
  /** Update a WhitelabelApp. */
  instacart_partners_partners_v1_MobileAppsManagementService_UpdateWhitelabelApp: Maybe<Instacart_Partners_Partners_V1_UpdateWhitelabelAppResponse>;
  /** Bulk create partner configurations; can support creating different configurations for different entities */
  instacart_partners_partners_v1_PartnerConfigurationsService_BulkCreatePartnerConfigurations: Maybe<Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsResponse>;
  /** Bulk delete partner configurations; only does a soft delete. Can support deleting different configurations for different entities */
  instacart_partners_partners_v1_PartnerConfigurationsService_BulkDeletePartnerConfigurations: Maybe<Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsResponse>;
  /** Bulk update partner configurations; can support updating different configurations for different entities */
  instacart_partners_partners_v1_PartnerConfigurationsService_BulkUpdatePartnerConfigurations: Maybe<Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsResponse>;
  /** Create a new partner configuration type; after create, configuration type must be added to PartnerConfigurationType to support reads */
  instacart_partners_partners_v1_PartnerConfigurationsService_CreatePartnerConfigurationType: Maybe<Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeResponse>;
  /** delete an existing partner configuration type; only does a soft delete. */
  instacart_partners_partners_v1_PartnerConfigurationsService_DeletePartnerConfigurationType: Maybe<Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeResponse>;
  /** Update an existing partner configuration type */
  instacart_partners_partners_v1_PartnerConfigurationsService_UpdatePartnerConfigurationType: Maybe<Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeResponse>;
  /** CheckHealth */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_CheckHealth: Maybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_CheckHealthResponse']>;
  /** PutAutomation */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutAutomation: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationResponse>;
  /** PutConnection */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutConnection: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionResponse>;
  /** PutStore */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutStore: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreResponse>;
  /** PutSyncStrategy */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutSyncStrategy: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_CreateInsightsPortalCustomExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_CreateInsightsPortalCustomReport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_DeleteInsightsPortalCustomExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_RegenerateInsightsPortalCustomExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_SetInsightsPortalCustomReportDisabled: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_UpdateInsightsPortalCustomReport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportResponse>;
  instacart_retailers_v1_AppeasementsService_GiveAppeasements: Maybe<Instacart_Retailers_V1_GiveAppeasementsResponse>;
  instacart_retailers_v1_RetailersService_UpsertWidgetsConfig: Maybe<Instacart_Retailers_V1_UpsertWidgetsConfigResponse>;
  /** Create or modify a feature. */
  instacart_roulette_v1_RouletteService_StoreFeature: Maybe<Instacart_Roulette_V1_StoreFeatureResponse>;
  /** PutIntegration */
  instacart_upos_config_v1_ConfigService_PutIntegration: Maybe<Instacart_Upos_Config_V1_PutIntegrationResponse>;
  /** PutProfile */
  instacart_upos_config_v1_ConfigService_PutProfile: Maybe<Instacart_Upos_Config_V1_PutProfileResponse>;
  /** PutRetailer */
  instacart_upos_config_v1_ConfigService_PutRetailer: Maybe<Instacart_Upos_Config_V1_PutRetailerResponse>;
  /** PutStore */
  instacart_upos_config_v1_ConfigService_PutStore: Maybe<Instacart_Upos_Config_V1_PutStoreResponse>;
  /** Creates a new step with an initial version */
  instacart_waves_v1_WavesService_CreateNewStep: Maybe<Instacart_Waves_V1_CreateNewStepResponse>;
  /** Creates a new version of an existing step */
  instacart_waves_v1_WavesService_CreateNewStepVersion: Maybe<Instacart_Waves_V1_CreateNewStepVersionResponse>;
  /** Creates a new scheduled workflow or updates an existing one. */
  instacart_waves_v1_WavesService_CreateOrUpdateScheduledWorkflow: Maybe<Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowResponse>;
  /** Creates a new step filter tag */
  instacart_waves_v1_WavesService_CreateStepFilterTag: Maybe<Instacart_Waves_V1_CreateStepFilterTagResponse>;
  /** Deletes an existing scheduled workflow by step_id. */
  instacart_waves_v1_WavesService_DeleteScheduledWorkflow: Maybe<Instacart_Waves_V1_DeleteScheduledWorkflowResponse>;
  /** Deletes a step filter tag by step_id and tag_name */
  instacart_waves_v1_WavesService_DeleteStepFilterTag: Maybe<Instacart_Waves_V1_DeleteStepFilterTagResponse>;
  /** Soft deletes a step by step_id */
  instacart_waves_v1_WavesService_TombstoneStep: Maybe<Instacart_Waves_V1_TombstoneStepResponse>;
  /** Updates a step's owner and/or description */
  instacart_waves_v1_WavesService_UpdateStep: Maybe<Instacart_Waves_V1_UpdateStepResponse>;
  inventoryIntelligenceServiceCreateOosAcknowledgment: Maybe<CreateOosAcknowledgmentResponse>;
  linkAutosuggestServiceCreateOrUpdateLinkAutosuggestionAdmin: Maybe<CreateOrUpdateLinkAutosuggestionAdminResponse>;
  linkAutosuggestServiceDeleteLinkAutosuggestionAdmin: Maybe<DeleteLinkAutosuggestionAdminResponse>;
  /** Cancels a marketing email campaign in progress */
  marketingFeatureCancelCampaign: Maybe<CancelCampaignPayload>;
  /** Starts a marketing email campaign */
  marketingFeatureStartCampaign: Maybe<StartCampaignPayload>;
  /** Triggers the send for an existing marketing campaign */
  marketingFeatureTriggerCampaign: Maybe<TriggerCampaignPayload>;
  /** Create a MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityConditionCreate: Maybe<MatchesAnyRetailerIdVisibilityConditionCreatePayload>;
  /** Update a MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityConditionUpdate: Maybe<MatchesAnyRetailerIdVisibilityConditionUpdatePayload>;
  /** Create a MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionCreate: Maybe<MinimumPlatformVersionVisibilityConditionCreatePayload>;
  /** Update an existing MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionUpdate: Maybe<MinimumPlatformVersionVisibilityConditionUpdatePayload>;
  /** Create a NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityConditionCreate: Maybe<NewVerticalUserTargetingVisibilityConditionCreatePayload>;
  /** Update a NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityConditionUpdate: Maybe<NewVerticalUserTargetingVisibilityConditionUpdatePayload>;
  /** Merges two or more normalized-reports by combining their contents into one file */
  normalizedReportsMerge: Maybe<NormalizedReportsMergePayload>;
  /** Subscribe an account to a notification type for a retailer */
  notificationSubscriptionCreate: Maybe<NotificationSubscriptionCreatePayload>;
  /** Unsubscribe an account to a notification type for a retailer */
  notificationSubscriptionDelete: Maybe<NotificationSubscriptionDeletePayload>;
  /** Delete notifications from the current account */
  notificationsDelete: Maybe<NotificationsDeletePayload>;
  /** Mark notifications as read */
  notificationsMarkRead: Maybe<NotificationsMarkReadPayload>;
  /** Sets properties for mobile apps */
  onboardingMobileAppPropertiesUpdate: Maybe<SetMobilePropertiesPayload>;
  onboardingServiceBulkUpdateApprovalRequestStatus: Maybe<BulkUpdateApprovalRequestStatusResponse>;
  onboardingServiceCreateAutomatedTestRun: Maybe<CreateAutomatedTestRunResponse>;
  onboardingServiceCreateOnboardingStoreLocation: Maybe<CreateOnboardingStoreLocationResponse>;
  onboardingServiceCreateSignup: Maybe<CreateSignupResponse>;
  onboardingServiceCreateWhitelabelSite: Maybe<CreateWhitelabelSiteResponse>;
  onboardingServiceCreateWhitelabelSiteCustomizableString: Maybe<CreateWhitelabelSiteCustomizableStringResponse>;
  onboardingServiceCreateWhitelabelStoreConfiguration: Maybe<CreateWhitelabelStoreConfigurationResponse>;
  onboardingServiceDeleteLaunchOnboardingWarehouseLocation: Maybe<DeleteLaunchOnboardingWarehouseLocationResponse>;
  onboardingServiceDeleteWhitelabelSiteCustomizableString: Maybe<DeleteWhitelabelSiteCustomizableStringResponse>;
  onboardingServiceGeneratePresignedAssetDownloadUrl: Maybe<GeneratePresignedAssetDownloadUrlResponse>;
  onboardingServiceGeneratePresignedAssetUploadUrl: Maybe<GeneratePresignedAssetUploadUrlResponse>;
  onboardingServiceGeneratePrsForStringOverride: Maybe<GeneratePrsForStringOverrideResponse>;
  onboardingServiceSendWhitelabelSiteRetailerEmail: Maybe<SendWhitelabelSiteRetailerEmailResponse>;
  onboardingServiceStartWhitelabelGumloopWorkflow: Maybe<StartWhitelabelGumloopWorkflowResponse>;
  onboardingServiceTriggerRakeTaskForStoreConfiguration: Maybe<TriggerRakeTaskForStoreConfigurationResponse>;
  onboardingServiceUpdateApprovalRequestStatus: Maybe<UpdateApprovalRequestStatusResponse>;
  onboardingServiceUpdateLaunchOnboardingWarehouseInfo: Maybe<UpdateLaunchOnboardingWarehouseInfoResponse>;
  onboardingServiceUpdateLaunchOnboardingWarehouseLocationInfo: Maybe<UpdateLaunchOnboardingWarehouseLocationInfoResponse>;
  onboardingServiceUpdateLaunchOnboardingWorkflowState: Maybe<UpdateLaunchOnboardingWorkflowStateResponse>;
  onboardingServiceUpdateOnboarding: Maybe<UpdateOnboardingResponse>;
  onboardingServiceUpdateOnboardingBillingAddress: Maybe<UpdateOnboardingBillingAddressResponse>;
  onboardingServiceUpdateOnboardingWorkflowState: Maybe<UpdateOnboardingWorkflowStateResponse>;
  onboardingServiceUpdateRetailerFormGroupVisibility: Maybe<UpdateRetailerFormGroupVisibilityResponse>;
  onboardingServiceUpdateWhitelabelSite: Maybe<UpdateWhitelabelSiteResponse>;
  onboardingServiceUpdateWhitelabelSiteAttributes: Maybe<UpdateWhitelabelSiteAttributesResponse>;
  onboardingServiceUpdateWhitelabelSiteAttributesAdmin: Maybe<UpdateWhitelabelSiteAttributesAdminResponse>;
  onboardingServiceUpdateWhitelabelSiteCustomizableString: Maybe<UpdateWhitelabelSiteCustomizableStringResponse>;
  onboardingServiceUpdateWhitelabelSiteWorkflowState: Maybe<UpdateWhitelabelSiteWorkflowStateResponse>;
  /** Trigger a workflow */
  onboardingTriggerWorkflow: Maybe<TriggerWorkflowPayload>;
  orderServiceCancelOrder: Maybe<CancelOrderResponse>;
  orderServiceCreateLastmileOrderFromDashboard: Maybe<CreateLastmileOrderFromDashboardResponse>;
  orderServiceReopenLastmileOrder: Maybe<ReopenLastmileOrderResponse>;
  orderServiceRescheduleOrder: Maybe<RescheduleOrderResponse>;
  orderServiceStageLastmileOrder: Maybe<StageLastmileOrderResponse>;
  /** Create a new partner pick device */
  partnerPickDeviceCreate: Maybe<PartnerPickDeviceCreatePayload>;
  /** Update an existing partner pick device's status */
  partnerPickDeviceSetStatus: Maybe<PartnerPickDeviceSetStatusPayload>;
  /** Update an existing partner pick device */
  partnerPickDeviceUpdate: Maybe<PartnerPickDeviceUpdatePayload>;
  /** Create a new partner pick recurring shift */
  partnerPickRecurringShiftCreate: Maybe<PartnerPickRecurringShiftCreatePayload>;
  /** Delete a partner pick recurring shift by id, from some date onward */
  partnerPickRecurringShiftDelete: Maybe<PartnerPickRecurringShiftDeletePayload>;
  /** Update an existing partner pick recurring shift */
  partnerPickRecurringShiftUpdate: Maybe<PartnerPickRecurringShiftUpdatePayload>;
  privacyServiceCreatePiiRequestForRetailer: Maybe<CreatePiiRequestForRetailerResponse>;
  /** Create a new report request */
  reportRequestCreate: Maybe<ReportRequestCreatePayload>;
  /** Resync partners from main to our enterprise_api database */
  resyncPartners: Maybe<ResyncPartnersPayload>;
  retailerAislesUpdateRetailerAisleTemplate: Maybe<UpdateRetailerAisleTemplateResponse>;
  /** Create a RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityConditionCreate: Maybe<RetailerAvailabilityVisibilityConditionCreatePayload>;
  /** Update a RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityConditionUpdate: Maybe<RetailerAvailabilityVisibilityConditionUpdatePayload>;
  retailerCampaignServiceAddRetailerCampaignTreatments: Maybe<AddRetailerCampaignTreatmentsResponse>;
  retailerCampaignServiceCancelMoment: Maybe<CancelMomentResponse>;
  retailerCampaignServiceCancelRetailerCampaign: Maybe<CancelRetailerCampaignResponse>;
  retailerCampaignServiceCreateMoment: Maybe<CreateMomentResponse>;
  retailerCampaignServiceCreateRetailerCampaign: Maybe<RetailerCampaignResponse>;
  retailerCampaignServiceUpdateMoment: Maybe<UpdateMomentResponse>;
  retailerCampaignServiceUpdateMomentCampaignStatus: Maybe<UpdateMomentCampaignStatusResponse>;
  retailerCampaignServiceUpdateRetailerCampaign: Maybe<RetailerCampaignResponse>;
  retailerCampaignServiceUpdateRetailerCampaignTreatments: Maybe<UpdateRetailerCampaignTreatmentsResponse>;
  /** Create a new retailer location group */
  retailerLocationGroupCreate: Maybe<RetailerLocationGroupCreatePayload>;
  /** Delete an existing retailer location group */
  retailerLocationGroupDelete: Maybe<RetailerLocationGroupDeletePayload>;
  /** Update an existing retailer location group */
  retailerLocationGroupUpdate: Maybe<RetailerLocationGroupUpdatePayload>;
  retailerManagementServiceClonePartnerOauthApplication: Maybe<ClonePartnerOauthApplicationResponse>;
  retailerManagementServiceCreateClientConfiguration: Maybe<CreateClientConfigurationResponse>;
  retailerManagementServiceCreateConnectRetailerCallbackConfiguration: Maybe<CreateConnectRetailerCallbackConfigurationResponse>;
  retailerManagementServiceCreateStoreConfiguration: Maybe<CreateStoreConfigurationResponse>;
  retailerManagementServiceDeleteConnectRetailerCallbackConfiguration: Maybe<DeleteConnectRetailerCallbackConfigurationResponse>;
  retailerManagementServiceDeletePartnerOauthApplication: Maybe<DeletePartnerOauthApplicationResponse>;
  retailerManagementServiceDisablePartnerOauthApplication: Maybe<DisablePartnerOauthApplicationResponse>;
  retailerManagementServiceEnablePartnerOauthApplication: Maybe<EnablePartnerOauthApplicationResponse>;
  retailerManagementServiceUpdateClientConfigurationForOrdersDashboard: Maybe<UpdateClientConfigurationForOrdersDashboardResponse>;
  retailerManagementServiceUpdateConnectRetailerCallbackConfiguration: Maybe<UpdateConnectRetailerCallbackConfigurationResponse>;
  /** Set MFA enabled status for a retailer */
  retailerMfaSetEnabled: Maybe<RetailerMfaSetEnabledPayload>;
  retailerProductAttributeEditServiceUpdateAvailabilityScoreOverride: Maybe<UpdateAvailabilityScoreOverrideResponse>;
  retailerProductAttributeEditServiceUpdateRetailerProductVisibilities: Maybe<UpdateRetailerProductVisibilitiesResponse>;
  /** Submit the results of the Retailer Satisfication Survey form */
  retailerSatisfactionSurveySubmissionCreate: Maybe<SubmissionCreatePayload>;
  retailerSettingsServiceDeleteImage: Maybe<DeleteImageResponse>;
  retailerSettingsServiceUpdateParkingSettings: Maybe<UpdateParkingSettingsResponse>;
  retailerSettingsServiceUpdateStagingSettings: Maybe<UpdateStagingSettingsResponse>;
  retailerStoreHoursUpdateConfirmStoreHours: Maybe<UpdateConfirmedStoreHoursResponse>;
  retailerStoreHoursUpdateStoreHours: Maybe<UpdateStoreHoursResponse>;
  retailersServiceMoveRetailerAssetsFromFilestackBucket: Maybe<MoveRetailerAssetsFromFilestackBucketResponse>;
  returnsServiceCreateOrUpdateReturn: Maybe<CreateOrUpdateReturnResponse>;
  /** Create a role */
  roleCreate: Maybe<RoleCreatePayload>;
  /** Delete a role */
  roleDelete: Maybe<RoleDeletePayload>;
  /** Update a role */
  roleUpdate: Maybe<RoleUpdatePayload>;
  rppBulkImageUploadsServiceCreateImageUploadBatch: Maybe<CreateImageUploadBatchResponse>;
  /** Create a new home placement with SecondaryBanner banner */
  secondaryBannerPlacementCreate: Maybe<SecondaryBannerPlacementCreatePayload>;
  /** Update an existing secondary_banner placement placement */
  secondaryBannerPlacementUpdate: Maybe<SecondaryBannerPlacementUpdatePayload>;
  /** Create a ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionCreate: Maybe<ShoppedAtRetailerVisibilityConditionCreatePayload>;
  /** Update an existing ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionUpdate: Maybe<ShoppedAtRetailerVisibilityConditionUpdatePayload>;
  /** Create a shopped visibility condition */
  shoppedVisibilityConditionCreate: Maybe<ShoppedVisibilityConditionCreatePayload>;
  /** Update an existing Shopped visibility condition */
  shoppedVisibilityConditionUpdate: Maybe<ShoppedVisibilityConditionUpdatePayload>;
  storeConfigurationsDraftServiceCreateStoreConfigurationDraft: Maybe<CreateStoreConfigurationDraftResponse>;
  storeConfigurationsDraftServicePublishStoreConfigurationDraft: Maybe<PublishStoreConfigurationDraftResponse>;
  storeConfigurationsDraftServiceRollbackStoreConfiguration: Maybe<RollbackStoreConfigurationResponse>;
  storeConfigurationsDraftServiceUpdateStoreConfigurationDraft: Maybe<UpdateStoreConfigurationDraftResponse>;
  /** Create a new storefront placement */
  storefrontPlacementCreate: Maybe<StorefrontPlacementCreatePayload>;
  /** Delete an existing storefront placement */
  storefrontPlacementDelete: Maybe<StorefrontPlacementDeletePayload>;
  /** Update an existing storefront placement placement */
  storefrontPlacementUpdate: Maybe<StorefrontPlacementUpdatePayload>;
  /** Create a UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityConditionCreate: Maybe<UserInteractionLimitVisibilityConditionCreatePayload>;
  /** Update a UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityConditionUpdate: Maybe<UserInteractionLimitVisibilityConditionUpdatePayload>;
  userSettingServiceSetUserSetting: Maybe<SetUserSettingResponse>;
  usersServiceGrantImpersonation: Maybe<GrantImpersonationResponse>;
  /** Create a UtmParameters visibility condition */
  utmParametersVisibilityConditionCreate: Maybe<UtmParametersVisibilityConditionCreatePayload>;
  /** Update a UtmParameters visibility condition */
  utmParametersVisibilityConditionUpdate: Maybe<UtmParametersVisibilityConditionUpdatePayload>;
  valueBasedOverrideServiceCreateValueBasedOverride: Maybe<CreateValueBasedOverrideResponse>;
  /** Update the retailers for a virtual partner */
  virtualPartnerUpdateRetailers: Maybe<VirtualPartnerUpdateRetailersPayload>;
  /** Delete an existing visibility condition */
  visibilityConditionDelete: Maybe<VisibilityConditionDeletePayload>;
  /** Create a WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionCreate: Maybe<WhitelistedPostalCodesVisibilityConditionCreatePayload>;
  /** Update an existing WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionUpdate: Maybe<WhitelistedPostalCodesVisibilityConditionUpdatePayload>;
  /** Create a WhitelistedZones visibility condition */
  whitelistedZonesVisibilityConditionCreate: Maybe<WhitelistedZonesVisibilityConditionCreatePayload>;
  /** Update a WhitelistedZones visibility condition */
  whitelistedZonesVisibilityConditionUpdate: Maybe<WhitelistedZonesVisibilityConditionUpdatePayload>;
  /** Update the wizard progress for the currently logged in account */
  wizardProgressUpdate: Maybe<WizardProgressUpdatePayload>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_AddBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_AddBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_CreateBanEntryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateBanEntryRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_RemoveBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryArchivedArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryArchivedRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_AddBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_AddBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_CreateBanEntryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateBanEntryRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_RemoveBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryArchivedArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryArchivedRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryScopesRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CancelScheduledActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CancelScheduledActionRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDevicesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDevicesRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePresignedAssetUrlArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateStoreRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_LockCartsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_LockCartsRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleActionRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleBatchActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateGlobalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateGlobalRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateStoreRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CancelScheduledActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CancelScheduledActionRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDevicesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDevicesRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePresignedAssetUrlArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateStoreRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_LockCartsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_LockCartsRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleActionRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleBatchActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateGlobalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateGlobalRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateStoreRequest_Input>;
};


export type MutationCaperDeviceProvisioningPipelineService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_TriggerPipelineArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TriggerPipelineRequest_Input>;
};


export type MutationCaperDeviceProvisioningPipelineStagingService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_TriggerPipelineArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TriggerPipelineRequest_Input>;
};


export type MutationCaperIppReceiptService_Instacart_Caper_Admin_V1_IppReceiptService_SendReceiptArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SendReceiptRequest_Input>;
};


export type MutationCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_ReviewNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ReviewNofRequest_Input>;
};


export type MutationCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_ReviewNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ReviewNofRequest_Input>;
};


export type MutationCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateMerchantArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateMerchantRequest_Input>;
};


export type MutationCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateTerminalsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateTerminalsRequest_Input>;
};


export type MutationCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_TransferTerminalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TransferTerminalRequest_Input>;
};


export type MutationCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateMerchantArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateMerchantRequest_Input>;
};


export type MutationCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateTerminalsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateTerminalsRequest_Input>;
};


export type MutationCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_TransferTerminalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TransferTerminalRequest_Input>;
};


export type MutationCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_CreateDatadogSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_CreateSessionSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_UpdateSessionSummaryFeedbackArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackRequest_Input>;
};


export type MutationCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_CreateDatadogSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_CreateSessionSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_UpdateSessionSummaryFeedbackArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunCarouselGroupQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunContentDesignQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunFilterQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunKeywordCompletenessQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunKeywordQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunPageQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunPolicyQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunProductQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunTopicQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaRequest_Input>;
};


export type MutationFrothProcessing_Instacart_Customers_Froth_V1_FrothProcessingService_CompileTemplateArgs = {
  input?: InputMaybe<Instacart_Customers_Froth_V1_CompileTemplateRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_CreateResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_DeleteResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_TriggerInboundEventArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_UpdateResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigRequest_Input>;
};


export type MutationGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_CreateStringsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_CreateStringsRequest_Input>;
};


export type MutationGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_DeleteResourcesArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesRequest_Input>;
};


export type MutationGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_UpdateStringsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_UpdateStringsRequest_Input>;
};


export type MutationMarketingToolingService_Instacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_CreateMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignRequest_Input>;
};


export type MutationMarketingToolingService_Instacart_Growth_Marketing_Tooling_V1_MarketingToolingService_CreateMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignRequest_Input>;
};


export type MutationRetailerContactManagement_AddContactArgs = {
  input?: InputMaybe<RetailerContactManagement_Contact_Input>;
  retailerId: Scalars['String'];
};


export type MutationRetailerContactManagement_DeleteAllContactsArgs = {
  retailerId: Scalars['String'];
};


export type MutationRetailerContactManagement_DeleteContactArgs = {
  email: Scalars['EmailAddress'];
  retailerId: Scalars['String'];
};


export type MutationRetailerContactManagement_UpdateContactArgs = {
  email: Scalars['EmailAddress'];
  input?: InputMaybe<RetailerContactManagement_Contact_Input>;
  retailerId: Scalars['String'];
};


export type MutationAiAgentConversationUpsertArgs = {
  conversationId: Scalars['ID'];
  messages: Array<ChatMessageInput>;
};


export type MutationAiAgentExecuteArgs = {
  input: AgentRequestInput;
};


export type MutationApiIntegrationsServiceDeleteApiSettingArgs = {
  input?: InputMaybe<DeleteApiSettingRequestInput>;
};


export type MutationApiIntegrationsServiceUpdateApiSettingArgs = {
  input?: InputMaybe<UpdateApiSettingRequestInput>;
};


export type MutationApprovalsManagementAddReviewArgs = {
  input: ReviewAddInput;
};


export type MutationApprovalsManagementDeleteReviewArgs = {
  input: ReviewDeleteInput;
};


export type MutationApprovalsManagementEditReviewArgs = {
  input: ReviewEditInput;
};


export type MutationApprovalsManagementPublishApprovalRequestArgs = {
  input: PublishApprovalRequestInput;
};


export type MutationAssignPermissionToRoleArgs = {
  permission: PermissionInput;
  role: RoleInput;
};


export type MutationBotEnterpriseAccountDisableArgs = {
  email: Scalars['String'];
};


export type MutationBotEnterpriseAccountUpsertArgs = {
  email: Scalars['String'];
  extraRoleSlugs?: InputMaybe<Array<Scalars['String']>>;
  givenName: Scalars['String'];
  hasAllPartnersWriteAccess?: InputMaybe<Scalars['Boolean']>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  partnerWriteAccessIds?: InputMaybe<Array<Scalars['ID']>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  role: BotAccountAssignableRoleEnum;
  slackParentMessageTs?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
};


export type MutationCatalogProblemTrackerServiceCreateTicketArgs = {
  input?: InputMaybe<CreateTicketRequestInput>;
};


export type MutationCatalogToolsApiServiceCreatePatchApprovalArgs = {
  input?: InputMaybe<CreatePatchApprovalRequestInput>;
};


export type MutationCatalogToolsApiServiceCreatePriceAnomalyInvestigationArgs = {
  input?: InputMaybe<CreatePriceAnomalyInvestigationRequestInput>;
};


export type MutationCatalogToolsApiServiceCreatePriceAnomalyPatchArgs = {
  input?: InputMaybe<CreatePriceAnomalyPatchRequestInput>;
};


export type MutationCatalogToolsApiServiceDeactivatePriceAnomalyPatchArgs = {
  input?: InputMaybe<DeactivatePriceAnomalyPatchRequestInput>;
};


export type MutationCollectionsServiceSetMultiRetailerPageCollectionsCacheArgs = {
  input?: InputMaybe<SetMultiRetailerPageCollectionsCacheRequestInput>;
};


export type MutationConfigurableItemsServicePublishRppConfigurableItemsArgs = {
  input?: InputMaybe<PublishRppConfigurableItemsRequestInput>;
};


export type MutationConnectPlatformServiceAdvanceBatchStateArgs = {
  input?: InputMaybe<AdvanceBatchStateRequestInput>;
};


export type MutationConnectPlatformServiceAssignVirtualBatchArgs = {
  input?: InputMaybe<AssignVirtualBatchRequestInput>;
};


export type MutationConnectPlatformServiceCreateDriverArgs = {
  input?: InputMaybe<CreateDriverRequestInput>;
};


export type MutationConnectPlatformServiceCreatePartnerApiKeyArgs = {
  input?: InputMaybe<CreatePartnerApiKeyRequestInput>;
};


export type MutationConnectPlatformServiceGenerateBatchArgs = {
  input?: InputMaybe<GenerateBatchRequestInput>;
};


export type MutationConnectPlatformServiceRevokePartnerApiKeyArgs = {
  input?: InputMaybe<RevokePartnerApiKeyRequestInput>;
};


export type MutationConnectPlatformServiceUpdateShopperOrderItemArgs = {
  input?: InputMaybe<UpdateShopperOrderItemRequestInput>;
};


export type MutationContentManagementAdminServiceBatchUpdateSlotCreativesArgs = {
  input?: InputMaybe<BatchUpdateSlotCreativesRequestInput>;
};


export type MutationContentManagementAdminServiceCreateAiCarouselArgs = {
  input?: InputMaybe<CreateAiCarouselRequestInput>;
};


export type MutationContentManagementAdminServiceCreateContentPageArgs = {
  input?: InputMaybe<CreateContentPageRequestInput>;
};


export type MutationContentManagementAdminServiceCreateContentPageV2Args = {
  input?: InputMaybe<CreateContentPageRequestV2Input>;
};


export type MutationContentManagementAdminServiceCreateContentPageVersionArgs = {
  input?: InputMaybe<CreateContentPageVersionRequestInput>;
};


export type MutationContentManagementAdminServiceCreateContentPageVersionMetaArgs = {
  input?: InputMaybe<CreateContentPageVersionMetaRequestInput>;
};


export type MutationContentManagementAdminServiceCreateCreativePlacementsArgs = {
  input?: InputMaybe<CreateCreativePlacementsRequestInput>;
};


export type MutationContentManagementAdminServiceCreateNativeTabBarNavigationArgs = {
  input?: InputMaybe<CreateNativeTabBarNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceCreateNavigationArgs = {
  input?: InputMaybe<CreateNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceCreateNavigationPreviewArgs = {
  input?: InputMaybe<CreateNavigationPreviewRequestInput>;
};


export type MutationContentManagementAdminServiceCreatePlacementContentArgs = {
  input?: InputMaybe<CreatePlacementContentRequestInput>;
};


export type MutationContentManagementAdminServiceCreateSlotArgs = {
  input?: InputMaybe<CreateSlotRequestInput>;
};


export type MutationContentManagementAdminServiceCreateSlotCreativeArgs = {
  input?: InputMaybe<CreateSlotCreativeRequestInput>;
};


export type MutationContentManagementAdminServiceCreateSlotPlacementArgs = {
  input?: InputMaybe<CreateSlotPlacementRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteContentPageArgs = {
  input?: InputMaybe<DeleteContentPageRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteContentPageVersionArgs = {
  input?: InputMaybe<DeleteContentPageVersionRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteNativeTabBarNavigationArgs = {
  input?: InputMaybe<DeleteNativeTabBarNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteNavigationArgs = {
  input?: InputMaybe<DeleteNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteSlotArgs = {
  input?: InputMaybe<DeleteSlotRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteSlotCreativeArgs = {
  input?: InputMaybe<DeleteSlotCreativeRequestInput>;
};


export type MutationContentManagementAdminServiceDisablePlacementContentArgs = {
  input?: InputMaybe<DisablePlacementContentRequestInput>;
};


export type MutationContentManagementAdminServiceDuplicateContentPageArgs = {
  input?: InputMaybe<DuplicateContentPageRequestInput>;
};


export type MutationContentManagementAdminServiceSaveToolingShortcutsArgs = {
  input?: InputMaybe<SaveToolingShortcutsRequestInput>;
};


export type MutationContentManagementAdminServiceStartConvertPlacementVideoArgs = {
  input?: InputMaybe<StartConvertPlacementVideoRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateAdminNavigationV2Args = {
  input?: InputMaybe<UpdateAdminNavigationV2RequestInput>;
};


export type MutationContentManagementAdminServiceUpdateContentPageV2Args = {
  input?: InputMaybe<UpdateContentPageRequestV2Input>;
};


export type MutationContentManagementAdminServiceUpdateContentPageVersionArgs = {
  input?: InputMaybe<UpdateContentPageVersionRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateContentPageVersionMetaArgs = {
  input?: InputMaybe<UpdateContentPageVersionMetaRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateNativeTabBarNavigationArgs = {
  input?: InputMaybe<UpdateNativeTabBarNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateNavigationArgs = {
  input?: InputMaybe<UpdateNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceUpdatePlacementContentArgs = {
  input?: InputMaybe<UpdatePlacementContentRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateSocialIconsNavigationArgs = {
  input?: InputMaybe<UpdateSocialIconsNavigationRequestInput>;
};


export type MutationContentManagementServiceBatchUpdatePlacementsArgs = {
  input?: InputMaybe<BatchUpdatePlacementsRequestInput>;
};


export type MutationContentManagementServiceCreateLayoutVariantArgs = {
  input?: InputMaybe<CreateLayoutVariantRequestInput>;
};


export type MutationContentManagementServiceCreatePlacementArgs = {
  input?: InputMaybe<CreatePlacementRequestInput>;
};


export type MutationContentManagementServiceCreateThemePageArgs = {
  input?: InputMaybe<CreateThemePageRequestInput>;
};


export type MutationContentManagementServiceDeleteLayoutVariantArgs = {
  input?: InputMaybe<DeleteLayoutVariantRequestInput>;
};


export type MutationContentManagementServiceDeletePlacementArgs = {
  input?: InputMaybe<DeletePlacementRequestInput>;
};


export type MutationContentManagementServiceDisableThemePageArgs = {
  input?: InputMaybe<DisableThemePageRequestInput>;
};


export type MutationContentManagementServiceUpdateLayoutVariantArgs = {
  input?: InputMaybe<UpdateLayoutVariantRequestInput>;
};


export type MutationContentManagementServiceUpdateThemePageArgs = {
  input?: InputMaybe<UpdateThemePageRequestInput>;
};


export type MutationCountryIdsVisibilityConditionCreateArgs = {
  countryIdsVisibilityConditionData: CountryIdsInput;
};


export type MutationCountryIdsVisibilityConditionUpdateArgs = {
  countryIdsVisibilityConditionData: CountryIdsInput;
};


export type MutationDayOfWeekVisibilityConditionCreateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput;
};


export type MutationDayOfWeekVisibilityConditionUpdateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput;
};


export type MutationDemeterServiceAuditDetectionArgs = {
  input?: InputMaybe<AuditDetectionRequestInput>;
};


export type MutationDemeterServiceCombineAuditBatchesArgs = {
  input?: InputMaybe<CombineAuditBatchesRequestInput>;
};


export type MutationDemeterServiceCreateAuditWorkflowArgs = {
  input?: InputMaybe<CreateAuditWorkflowRequestInput>;
};


export type MutationDemeterServiceCreateDetectionArgs = {
  input?: InputMaybe<CreateDetectionRequestInput>;
};


export type MutationDemeterServiceCreateDetectionVersionArgs = {
  input?: InputMaybe<CreateDetectionVersionRequestInput>;
};


export type MutationDemeterServiceReassignAuditBatchWorkflowArgs = {
  input?: InputMaybe<ReassignAuditBatchWorkflowRequestInput>;
};


export type MutationDemeterServiceTombstoneDetectionVersionArgs = {
  input?: InputMaybe<TombstoneDetectionVersionRequestInput>;
};


export type MutationDemeterServiceUpdateAuditBatchArgs = {
  input?: InputMaybe<UpdateAuditBatchRequestInput>;
};


export type MutationDemeterServiceUpdateAuditTaskArgs = {
  input?: InputMaybe<UpdateAuditTaskRequestInput>;
};


export type MutationDemeterServiceUpdateAuditWorkflowArgs = {
  input?: InputMaybe<UpdateAuditWorkflowRequestInput>;
};


export type MutationEmergingBrandPortalServiceContactBrandArgs = {
  input?: InputMaybe<BrandContactRequestInput>;
};


export type MutationEnterpriseAccountAcceptPartnerAgreementArgs = {
  agreementType: AgreementTypeEnum;
  partnerId: Scalars['ID'];
};


export type MutationEnterpriseAccountAccountSetupArgs = {
  givenName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  rawToken: Scalars['String'];
  surname?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountAuthenticateEmailPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountAuthenticatePreflightArgs = {
  email: Scalars['String'];
};


export type MutationEnterpriseAccountCreateArgs = {
  accountRequestId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  givenName: Scalars['String'];
  hasAllPartnersFullAccess: Scalars['Boolean'];
  hasAllPartnersWriteAccess?: InputMaybe<Scalars['Boolean']>;
  hasFullPartnerAccess: Scalars['Boolean'];
  hasFullRetailerAccess: Scalars['Boolean'];
  partnerIds: Array<Scalars['ID']>;
  partnerWriteAccessIds?: InputMaybe<Array<Scalars['ID']>>;
  permissionSlugs?: InputMaybe<Array<Scalars['String']>>;
  phone?: InputMaybe<Scalars['String']>;
  retailerIds: Array<Scalars['ID']>;
  retailerLocationIds: Array<Scalars['ID']>;
  roleIds: Array<Scalars['ID']>;
  surname?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userLocale?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountCreateNoPartnerAccessArgs = {
  email: Scalars['String'];
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationEnterpriseAccountEnableImpersonationArgs = {
  breakglass?: InputMaybe<Scalars['Boolean']>;
  breakglassAdditionalInfo?: InputMaybe<Scalars['String']>;
  breakglassJiraTicket?: InputMaybe<Scalars['String']>;
  breakglassReason?: InputMaybe<Scalars['String']>;
  impersonatedCanonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountMfaDeactivateArgs = {
  canonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountMfaEnableArgs = {
  canonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountMfaResetArgs = {
  canonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountPartnerOnboardingRequestAccountSetupEmailArgs = {
  email: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountRequestAccountSetupEmailArgs = {
  email: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountRequestBreakGlassPartnerWriteAccessArgs = {
  partnerIds: Array<Scalars['ID']>;
  ticketUrl: Scalars['String'];
  userJustification: Scalars['String'];
};


export type MutationEnterpriseAccountRequestEmailVerificationArgs = {
  email: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountResetPasswordArgs = {
  password: Scalars['String'];
  rawToken: Scalars['String'];
};


export type MutationEnterpriseAccountSetDisabledArgs = {
  accountCanonicalId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationEnterpriseAccountUpdateArgs = {
  canonicalId: Scalars['ID'];
  givenName: Scalars['String'];
  hasAllPartnersFullAccess: Scalars['Boolean'];
  hasAllPartnersWriteAccess?: InputMaybe<Scalars['Boolean']>;
  hasFullPartnerAccess: Scalars['Boolean'];
  hasFullRetailerAccess: Scalars['Boolean'];
  partnerIds: Array<Scalars['ID']>;
  partnerWriteAccessIds?: InputMaybe<Array<Scalars['ID']>>;
  permissionSlugs?: InputMaybe<Array<Scalars['String']>>;
  phone?: InputMaybe<Scalars['String']>;
  retailerIds: Array<Scalars['ID']>;
  retailerLocationIds: Array<Scalars['ID']>;
  roleIds: Array<Scalars['ID']>;
  surname?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userLocale?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountUpdateHiddenSettingsArgs = {
  hiddenSettings: HiddenSettingsInput;
};


export type MutationEnterpriseAccountUpdatePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationEnterpriseAccountUpdateRolesArgs = {
  addRoleIds?: InputMaybe<Array<Scalars['ID']>>;
  canonicalId: Scalars['ID'];
  removeRoleIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationEnterpriseAccountUpdateUserLocaleArgs = {
  userLocale: Scalars['String'];
};


export type MutationEnterpriseAccountVerifyAccountSetupTokenArgs = {
  rawToken: Scalars['String'];
};


export type MutationEnterpriseAccountVerifyEmailArgs = {
  rawToken: Scalars['String'];
};


export type MutationExperimentVariantVisibilityConditionCreateArgs = {
  experimentVariantVisibilityConditionData: ExperimentVariantInput;
};


export type MutationExperimentVariantVisibilityConditionUpdateArgs = {
  experimentVariantVisibilityConditionData: ExperimentVariantInput;
};


export type MutationExpressMembershipVisibilityConditionCreateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput;
};


export type MutationExpressMembershipVisibilityConditionUpdateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput;
};


export type MutationExpressNonmemberLongTermHoldoutVisibilityConditionCreateArgs = {
  expressNonmemberLongTermHoldoutVisibilityConditionData: ExpressNonmemberLongTermHoldoutInput;
};


export type MutationFlyoutPlacementCreateArgs = {
  flyoutPlacementData: FlyoutPlacementInput;
};


export type MutationFlyoutPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  flyoutPlacementData: FlyoutPlacementInput;
  id: Scalars['ID'];
};


export type MutationHeroBannerPlacementCreateArgs = {
  heroBannerPlacementData: HeroBannerPlacementInput;
};


export type MutationHeroBannerPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  heroBannerPlacementData: HeroBannerPlacementInput;
  id: Scalars['ID'];
};


export type MutationInstacart_Ads_Nexus_V1_AdsBlockingService_UpsertAdReviewArgs = {
  input?: InputMaybe<Instacart_Ads_Nexus_V1_UpsertAdReviewsRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_CreateGenerativeAudienceSegmentDefinitionArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_CreateSegmentArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_CreateSegmentRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_DeleteSegmentArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_DeleteSegmentRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_UpdateSegmentArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_UpdateSegmentRequest_Input>;
};


export type MutationInstacart_Ads_V3_RetailerBlockedAdsService_RetailerBlockAdArgs = {
  input?: InputMaybe<Instacart_Ads_V3_RetailerBlockAdRequest_Input>;
};


export type MutationInstacart_Algorithms_Ai_Carousel_Creator_V1_AiCarouselCreatorService_CreateCarouselArgs = {
  input?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_CreateNoteForOrderArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateNoteForOrderRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_CreateNoteForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateNoteForUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_LinkIsolatedUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_LinkIsolatedUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UnlinkIsolatedUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UnlinkIsolatedUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UpdateAddressForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UpdateAddressForUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UpdateSubscriptionAutorenewArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewRequest_Input>;
};


export type MutationInstacart_Cashflow_Nutella_V1_NutellaService_SetAuditFindingsArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_SetAuditFindingsRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_MakeMissingCodeDecisionArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_MakeMissingCodeDecisionRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_SetRetailerDiscountThresholdBringBacksArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_SetRetailerDiscountThresholdsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdsRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_TakeDownService_ItemBringBackBatchCsvArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_TempOverrideService_CreateArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideServiceCreateRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_CreateNewStepArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_CreateNewStepRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_CreateNewStepVersionArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_CreateNewStepVersionRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_RevertToStepVersionArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_RevertToStepVersionRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_RunManualStepTestArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_RunManualStepTestRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_UpdateStepArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_UpdateStepRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_UpdateStepVersionStateArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_UpdateStepVersionStateRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_CreateBatchArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_CreateBatchEventArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchEventRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_CreateBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_CreateBridgeRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_DeleteBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_DeleteBridgeRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_UpdateBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_UpdateBridgeRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_CreateBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_CreateBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_CreateBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_DeleteBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_DeleteBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramContentRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_DeleteBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramOfferRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_UpdateBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_UpdateBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_UpdateBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_BulkUpdateCampaignSlotRankingArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_MarketingAgentCalculatePerformanceMetricsArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_ProcessEmailCsvArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_ProcessEmailCsvRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_SaveMarketingAgentCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_TestOfflineCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_TestOfflineCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Coupons_V1_CommerceCouponsService_BulkCreateChildCouponCodesArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Coupons_V1_BulkCreateChildCouponCodesRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_CreateValueGrantPolicyArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_PublishValueGrantPolicyArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_UpdateValueGrantPolicyArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyRequest_Input>;
};


export type MutationInstacart_Customers_Connect_Platform_V1_ConnectPlatformService_GenerateBatchArgs = {
  input?: InputMaybe<Instacart_Customers_Connect_Platform_V1_GenerateBatchRequest_Input>;
};


export type MutationInstacart_Customers_Connect_Platform_V1_ConnectPlatformService_UpdateShopperOrderItemArgs = {
  input?: InputMaybe<Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_AddRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CancelMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CancelMomentRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CancelRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CancelRetailerCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CreateMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CreateMomentRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CreateRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CreateRetailerCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateCampaignBudgetArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateMomentRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateMomentCampaignStatusArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsRequest_Input>;
};


export type MutationInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_EvaluateRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_Input>;
};


export type MutationInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_PublishRuleSetRunResultsArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsRequest_Input>;
};


export type MutationInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_UpdateRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetRequest_Input>;
};


export type MutationInstacart_Customers_Gifting_V1_GiftOrderDigitalCardService_CreateGiftOrderDigitalCardArgs = {
  input?: InputMaybe<Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardRequest_Input>;
};


export type MutationInstacart_Customers_Gifting_V1_GiftOrderDigitalCardService_UpdateGiftOrderDigitalCardArgs = {
  input?: InputMaybe<Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_CreateLoyaltyBenefitArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_CreateLoyaltyCardValidationArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_CreateLoyaltyProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_UpdateLoyaltyBenefitArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_UpdateLoyaltyCardValidationArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_UpdateLoyaltyProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramRequest_Input>;
};


export type MutationInstacart_Customers_Partners_V1_PartnersService_CreateOrUpdatePartnerArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequest_Input>;
};


export type MutationInstacart_Customers_Partnership_Offer_V1_PartnershipOfferService_CreateRedemptionUrlsArgs = {
  input?: InputMaybe<Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsRequest_Input>;
};


export type MutationInstacart_Customers_Recipes_V1_RecipesService_BulkUpdateRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_BulkUpdateRecipesRequest_Input>;
};


export type MutationInstacart_Customers_Recipes_V1_RecipesService_IngestRecipesCsvArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_IngestRecipesCsvRequest_Input>;
};


export type MutationInstacart_Customers_Recipes_V1_RecipesService_UpdateRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_UpdateRecipesRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CopyFlyerClickableAreasArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CreateFlyerActivityArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CreateFlyerClickableAreaArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CreateOrUpdateFlyerMetadataArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_DeleteFlyerClickableAreasArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_ProcessFlyerIngestionFileUploadArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_TriggerFlyerSyncArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_UpdateFlyerActivityArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_UpdateFlyerClickableAreaArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_UpdateFlyersArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateGlobalCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateInvfMappingArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateRootNodeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteGlobalCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteInvfMappingArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteNavigationNodeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DuplicateDepartmentArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_OrderNavigationNodesArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_QueueNavigationMigrationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateCollectionProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateGlobalCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateNavigationConfigurationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpsertNavigationNodeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_Orchestrator_V1_RetailerManagementService_DeleteIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_Orchestrator_V1_RetailerManagementService_PublishIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_Orchestrator_V1_RetailerManagementService_RevertIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_CreateIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_DeleteIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_DeleteIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_PublishIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_PublishIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_RevertIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_RevertIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_UpdateIppDraftContentArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftPreviewService_CreateIppDraftPreviewArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_WidgetConfigurationService_EnableCmsSiteWidgetsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_WidgetConfigurationService_UpdateClientConfigurationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationRequest_Input>;
};


export type MutationInstacart_Customers_Search_V1_SearchService_CreateOrUpdateSearchTermOverridesArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesRequest_Input>;
};


export type MutationInstacart_Customers_Search_V1_SearchService_DeleteSearchTermOverridesByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_CancelPartnerBulkDeliveryRouteArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelPartnerBulkDeliveryRouteRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_UpdatePartnerBulkDeliveryRouteArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdatePartnerBulkDeliveryRouteRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehiclesService_CreateWarehouseLocationVehicleArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehiclesService_UpdateWarehouseLocationVehicleArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_AdjustDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_CancelDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_RescheduleDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftDownloadService_GenerateShiftsReportArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftUploadService_GeneratePresignedFileUploadUrlArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftUploadService_ProcessUploadedCsvArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftUploadService_ValidateUploadedBulkShiftFileArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_CreatePartnerManagedShiftArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_DeletePartnerManagedShiftArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_UpdatePartnerManagedShiftArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShoppersService_UnlockPartnerManagedDriverDeviceArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_OrderSimulationService_AdvanceBatchArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_OrderSimulationService_GenerateBatchArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperSimulationService_CreateShopperArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperSimulationService_UpdateShopperOrderItemArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_CreateSecondaryStepLogAuditArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateSecondaryStepLogAuditRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_CreateStepLogAuditArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_ReplayReconciliationArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_RunDecisionArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizationService_CategorizeByBatchArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizationService_CreateCategorizationAnalysisArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_CancelMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_CreateIntentionConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_UpdateIntentionConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_UpdateRetailerConfigurationSettingsArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_UpsertEmailUnsubscribersArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersRequest_Input>;
};


export type MutationInstacart_Infra_Instaform_V1_InstaformService_CreateModuleArgs = {
  input?: InputMaybe<Instacart_Infra_Instaform_V1_CreateModuleRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_MarketplaceOps_CreateRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_MarketplaceOps_DeleteRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_MarketplaceOps_UpdateRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_AddRequestNoteToOpsEscalationRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_BulkUpdateOpsEscalationRequestStatusArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_CreateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_DeleteOpsEscalationRequestRequestNotesArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_DeleteOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_UpdateOpsEscalationRequestRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_UpdateOpsEscalationRequestStatusArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_UpdateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_AddLocationsToParentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_AddLocationsToParentEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CancelFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CancelFulfillmentEventsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateClosureEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateClosureEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateClosureEventApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateClosureEventApprovalRequestRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateFulfillmentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateFulfillmentEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateRestrictedAvailabilityEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateRestrictedAvailabilityEventApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_UpdateClosureEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_UpdateClosureEventsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_UpdateFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_UpdateFulfillmentEventsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_UpdateRestrictedAvailabilityEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_CancelInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_CancelInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_CreateInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_CreateInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_ExecuteInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ExecuteInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_RequestInterventionApprovalArgs = {
  input?: InputMaybe<Instacart_Massops_V1_RequestInterventionApprovalRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_SyncInterventionApprovalResultArgs = {
  input?: InputMaybe<Instacart_Massops_V1_SyncInterventionApprovalResultRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_UpdateInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_UpdateInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_UpdateInterventionCommunicationSettingsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_UpdateInterventionCommunicationSettingsRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_UploadInterventionDataArgs = {
  input?: InputMaybe<Instacart_Massops_V1_UploadInterventionDataRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_FlipService_CreateFlipNoteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreateFlipNoteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_FlipService_DeleteFlipNoteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_DeleteFlipNoteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_FlipService_UpdateFlipNoteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_UpdateFlipNoteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_MobileAppsManagementService_ReleaseAppToProductionArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ReleaseAppToProductionRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_MobileAppsManagementService_UpdateWhitelabelAppArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_UpdateWhitelabelAppRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_BulkCreatePartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_BulkDeletePartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_BulkUpdatePartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_CreatePartnerConfigurationTypeArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_DeletePartnerConfigurationTypeArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_UpdatePartnerConfigurationTypeArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_CheckHealthArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_CheckHealthRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutAutomationArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutConnectionArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutStoreArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutSyncStrategyArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_CreateInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_CreateInsightsPortalCustomReportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_DeleteInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_RegenerateInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_SetInsightsPortalCustomReportDisabledArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_UpdateInsightsPortalCustomReportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportRequest_Input>;
};


export type MutationInstacart_Retailers_V1_AppeasementsService_GiveAppeasementsArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GiveAppeasementsRequest_Input>;
};


export type MutationInstacart_Retailers_V1_RetailersService_UpsertWidgetsConfigArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_UpsertWidgetsConfigRequest_Input>;
};


export type MutationInstacart_Roulette_V1_RouletteService_StoreFeatureArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_StoreFeatureRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutIntegrationArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutIntegrationRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutProfileArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutProfileRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutRetailerArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutRetailerRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutStoreArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutStoreRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateNewStepArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateNewStepRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateNewStepVersionArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateNewStepVersionRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateOrUpdateScheduledWorkflowArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateStepFilterTagArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateStepFilterTagRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_DeleteScheduledWorkflowArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DeleteScheduledWorkflowRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_DeleteStepFilterTagArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DeleteStepFilterTagRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_TombstoneStepArgs = {
  input?: InputMaybe<Instacart_Waves_V1_TombstoneStepRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_UpdateStepArgs = {
  input?: InputMaybe<Instacart_Waves_V1_UpdateStepRequest_Input>;
};


export type MutationInventoryIntelligenceServiceCreateOosAcknowledgmentArgs = {
  input?: InputMaybe<CreateOosAcknowledgmentRequestInput>;
};


export type MutationLinkAutosuggestServiceCreateOrUpdateLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<CreateOrUpdateLinkAutosuggestionAdminRequestInput>;
};


export type MutationLinkAutosuggestServiceDeleteLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<DeleteLinkAutosuggestionAdminRequestInput>;
};


export type MutationMarketingFeatureCancelCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationMarketingFeatureStartCampaignArgs = {
  campaign: StartCampaignInput;
};


export type MutationMarketingFeatureTriggerCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationMatchesAnyRetailerIdVisibilityConditionCreateArgs = {
  matchesAnyRetailerIdVisibilityConditionData: MatchesAnyRetailerIdInput;
};


export type MutationMatchesAnyRetailerIdVisibilityConditionUpdateArgs = {
  matchesAnyRetailerIdVisibilityConditionData: MatchesAnyRetailerIdInput;
};


export type MutationMinimumPlatformVersionVisibilityConditionCreateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput;
};


export type MutationMinimumPlatformVersionVisibilityConditionUpdateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput;
};


export type MutationNewVerticalUserTargetingVisibilityConditionCreateArgs = {
  newVerticalUserTargetingVisibilityConditionData: NewVerticalUserTargetingInput;
};


export type MutationNewVerticalUserTargetingVisibilityConditionUpdateArgs = {
  newVerticalUserTargetingVisibilityConditionData: NewVerticalUserTargetingInput;
};


export type MutationNormalizedReportsMergeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  partnerId: Scalars['ID'];
  reportType: MergeableReportTypeEnum;
  retailerId: Scalars['ID'];
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate: Scalars['ISO8601Date'];
};


export type MutationNotificationSubscriptionCreateArgs = {
  accountId: Scalars['ID'];
  notificationChannelId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  subscriptionMethod?: InputMaybe<NotificationSubscriptionMethodEnum>;
};


export type MutationNotificationSubscriptionDeleteArgs = {
  accountId: Scalars['ID'];
  notificationChannelId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  subscriptionMethod?: InputMaybe<NotificationSubscriptionMethodEnum>;
};


export type MutationNotificationsDeleteArgs = {
  notificationIds: Array<Scalars['ID']>;
};


export type MutationNotificationsMarkReadArgs = {
  notificationIds: Array<Scalars['ID']>;
};


export type MutationOnboardingMobileAppPropertiesUpdateArgs = {
  mobileAppProperties: Array<PropertyInput>;
  os: Os;
  storeConfigurationId: Scalars['Int'];
};


export type MutationOnboardingServiceBulkUpdateApprovalRequestStatusArgs = {
  input?: InputMaybe<BulkUpdateApprovalRequestStatusRequestInput>;
};


export type MutationOnboardingServiceCreateAutomatedTestRunArgs = {
  input?: InputMaybe<CreateAutomatedTestRunRequestInput>;
};


export type MutationOnboardingServiceCreateOnboardingStoreLocationArgs = {
  input?: InputMaybe<CreateOnboardingStoreLocationRequestInput>;
};


export type MutationOnboardingServiceCreateSignupArgs = {
  input?: InputMaybe<CreateSignupRequestInput>;
};


export type MutationOnboardingServiceCreateWhitelabelSiteArgs = {
  input?: InputMaybe<CreateWhitelabelSiteRequestInput>;
};


export type MutationOnboardingServiceCreateWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<CreateWhitelabelSiteCustomizableStringRequestInput>;
};


export type MutationOnboardingServiceCreateWhitelabelStoreConfigurationArgs = {
  input?: InputMaybe<CreateWhitelabelStoreConfigurationRequestInput>;
};


export type MutationOnboardingServiceDeleteLaunchOnboardingWarehouseLocationArgs = {
  input?: InputMaybe<DeleteLaunchOnboardingWarehouseLocationRequestInput>;
};


export type MutationOnboardingServiceDeleteWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<DeleteWhitelabelSiteCustomizableStringRequestInput>;
};


export type MutationOnboardingServiceGeneratePresignedAssetDownloadUrlArgs = {
  input?: InputMaybe<GeneratePresignedAssetDownloadUrlRequestInput>;
};


export type MutationOnboardingServiceGeneratePresignedAssetUploadUrlArgs = {
  input?: InputMaybe<GeneratePresignedAssetUploadUrlRequestInput>;
};


export type MutationOnboardingServiceGeneratePrsForStringOverrideArgs = {
  input?: InputMaybe<GeneratePrsForStringOverrideRequestInput>;
};


export type MutationOnboardingServiceSendWhitelabelSiteRetailerEmailArgs = {
  input?: InputMaybe<SendWhitelabelSiteRetailerEmailRequestInput>;
};


export type MutationOnboardingServiceStartWhitelabelGumloopWorkflowArgs = {
  input?: InputMaybe<StartWhitelabelGumloopWorkflowRequestInput>;
};


export type MutationOnboardingServiceTriggerRakeTaskForStoreConfigurationArgs = {
  input?: InputMaybe<TriggerRakeTaskForStoreConfigurationRequestInput>;
};


export type MutationOnboardingServiceUpdateApprovalRequestStatusArgs = {
  input?: InputMaybe<UpdateApprovalRequestStatusRequestInput>;
};


export type MutationOnboardingServiceUpdateLaunchOnboardingWarehouseInfoArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWarehouseInfoRequestInput>;
};


export type MutationOnboardingServiceUpdateLaunchOnboardingWarehouseLocationInfoArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWarehouseLocationInfoRequestInput>;
};


export type MutationOnboardingServiceUpdateLaunchOnboardingWorkflowStateArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWorkflowStateRequestInput>;
};


export type MutationOnboardingServiceUpdateOnboardingArgs = {
  input?: InputMaybe<UpdateOnboardingRequestInput>;
};


export type MutationOnboardingServiceUpdateOnboardingBillingAddressArgs = {
  input?: InputMaybe<UpdateOnboardingBillingAddressRequestInput>;
};


export type MutationOnboardingServiceUpdateOnboardingWorkflowStateArgs = {
  input?: InputMaybe<UpdateOnboardingWorkflowStateRequestInput>;
};


export type MutationOnboardingServiceUpdateRetailerFormGroupVisibilityArgs = {
  input?: InputMaybe<UpdateRetailerFormGroupVisibilityRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteAttributesArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteAttributesRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteAttributesAdminArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteAttributesAdminRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteCustomizableStringRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteWorkflowStateArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteWorkflowStateRequestInput>;
};


export type MutationOnboardingTriggerWorkflowArgs = {
  storeConfigurationId: Scalars['Int'];
  workflowName: Scalars['String'];
  workflowParameters: Array<WorkflowParameter>;
};


export type MutationOrderServiceCancelOrderArgs = {
  input?: InputMaybe<CancelOrderRequestInput>;
};


export type MutationOrderServiceCreateLastmileOrderFromDashboardArgs = {
  input?: InputMaybe<CreateLastmileOrderFromDashboardRequestInput>;
};


export type MutationOrderServiceReopenLastmileOrderArgs = {
  input?: InputMaybe<ReopenLastmileOrderRequestInput>;
};


export type MutationOrderServiceRescheduleOrderArgs = {
  input?: InputMaybe<RescheduleOrderRequestInput>;
};


export type MutationOrderServiceStageLastmileOrderArgs = {
  input?: InputMaybe<StageLastmileOrderRequestInput>;
};


export type MutationPartnerPickDeviceCreateArgs = {
  deviceType: DeviceTypeEnum;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isPartnerPickStoreManager: Scalars['Boolean'];
  lastName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  warehouseLocationId: Scalars['ID'];
};


export type MutationPartnerPickDeviceSetStatusArgs = {
  active: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationPartnerPickDeviceUpdateArgs = {
  deviceType?: InputMaybe<DeviceTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPartnerPickStoreManager?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  warehouseLocationId?: InputMaybe<Scalars['ID']>;
};


export type MutationPartnerPickRecurringShiftCreateArgs = {
  daysOfWeek: Array<Scalars['Int']>;
  driverId: Scalars['ID'];
  onCall?: InputMaybe<Scalars['Boolean']>;
  recurEndDate?: InputMaybe<Scalars['String']>;
  recurStartDate: Scalars['String'];
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  shiftType: ShiftTypeEnum;
  warehouseLocationId: Scalars['ID'];
};


export type MutationPartnerPickRecurringShiftDeleteArgs = {
  deleteShiftsFromDate: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationPartnerPickRecurringShiftUpdateArgs = {
  daysOfWeek?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['ID'];
  onCall?: InputMaybe<Scalars['Boolean']>;
  recurEndDate?: InputMaybe<Scalars['String']>;
  recurStartDate?: InputMaybe<Scalars['String']>;
  shiftLengthSeconds?: InputMaybe<Scalars['Int']>;
  shiftStartSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
};


export type MutationPrivacyServiceCreatePiiRequestForRetailerArgs = {
  input?: InputMaybe<CreatePiiRequestForRetailerRequestInput>;
};


export type MutationReportRequestCreateArgs = {
  associatedObjectId: Scalars['ID'];
  associatedObjectType: ReportRequestAssociatedObjectTypeEnum;
  filters?: InputMaybe<ReportFilters>;
  name: Scalars['String'];
  reportId: Scalars['ID'];
};


export type MutationRetailerAislesUpdateRetailerAisleTemplateArgs = {
  input?: InputMaybe<UpdateRetailerAisleTemplateRequestInput>;
};


export type MutationRetailerAvailabilityVisibilityConditionCreateArgs = {
  retailerAvailabilityVisibilityConditionData: RetailerAvailabilityInput;
};


export type MutationRetailerAvailabilityVisibilityConditionUpdateArgs = {
  retailerAvailabilityVisibilityConditionData: RetailerAvailabilityInput;
};


export type MutationRetailerCampaignServiceAddRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<AddRetailerCampaignTreatmentsRequestInput>;
};


export type MutationRetailerCampaignServiceCancelMomentArgs = {
  input?: InputMaybe<CancelMomentRequestInput>;
};


export type MutationRetailerCampaignServiceCancelRetailerCampaignArgs = {
  input?: InputMaybe<CancelRetailerCampaignRequestInput>;
};


export type MutationRetailerCampaignServiceCreateMomentArgs = {
  input?: InputMaybe<CreateMomentRequestInput>;
};


export type MutationRetailerCampaignServiceCreateRetailerCampaignArgs = {
  input?: InputMaybe<CreateRetailerCampaignRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateMomentArgs = {
  input?: InputMaybe<UpdateMomentRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateMomentCampaignStatusArgs = {
  input?: InputMaybe<UpdateMomentCampaignStatusRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateRetailerCampaignArgs = {
  input?: InputMaybe<UpdateRetailerCampaignRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<UpdateRetailerCampaignTreatmentsRequestInput>;
};


export type MutationRetailerLocationGroupCreateArgs = {
  name: Scalars['String'];
  partnerId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRetailerLocationGroupDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationRetailerLocationGroupUpdateArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRetailerManagementServiceClonePartnerOauthApplicationArgs = {
  input?: InputMaybe<ClonePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceCreateClientConfigurationArgs = {
  input?: InputMaybe<CreateClientConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceCreateConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<CreateConnectRetailerCallbackConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceCreateStoreConfigurationArgs = {
  input?: InputMaybe<CreateStoreConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceDeleteConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<DeleteConnectRetailerCallbackConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceDeletePartnerOauthApplicationArgs = {
  input?: InputMaybe<DeletePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceDisablePartnerOauthApplicationArgs = {
  input?: InputMaybe<DisablePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceEnablePartnerOauthApplicationArgs = {
  input?: InputMaybe<EnablePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceUpdateClientConfigurationForOrdersDashboardArgs = {
  input?: InputMaybe<UpdateClientConfigurationForOrdersDashboardRequestInput>;
};


export type MutationRetailerManagementServiceUpdateConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<UpdateConnectRetailerCallbackConfigurationRequestInput>;
};


export type MutationRetailerMfaSetEnabledArgs = {
  retailerId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationRetailerProductAttributeEditServiceUpdateAvailabilityScoreOverrideArgs = {
  input?: InputMaybe<UpdateAvailabilityScoreOverrideRequestInput>;
};


export type MutationRetailerProductAttributeEditServiceUpdateRetailerProductVisibilitiesArgs = {
  input?: InputMaybe<UpdateRetailerProductVisibilitiesRequestInput>;
};


export type MutationRetailerSatisfactionSurveySubmissionCreateArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  accountUuid?: InputMaybe<Scalars['String']>;
  milestoneSlug?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  shownAt: Scalars['String'];
  submittedAt: Scalars['String'];
  surveyResponses: Array<RetailerSatisfactionSurveyResponse>;
  urlPath: Scalars['String'];
  workflowSlug?: InputMaybe<Scalars['String']>;
};


export type MutationRetailerSettingsServiceDeleteImageArgs = {
  input?: InputMaybe<DeleteImageRequestInput>;
};


export type MutationRetailerSettingsServiceUpdateParkingSettingsArgs = {
  input?: InputMaybe<UpdateParkingSettingsRequestInput>;
};


export type MutationRetailerSettingsServiceUpdateStagingSettingsArgs = {
  input?: InputMaybe<UpdateStagingSettingsRequestInput>;
};


export type MutationRetailerStoreHoursUpdateConfirmStoreHoursArgs = {
  input?: InputMaybe<UpdateConfirmedStoreHoursRequestInput>;
};


export type MutationRetailerStoreHoursUpdateStoreHoursArgs = {
  input?: InputMaybe<UpdateStoreHoursRequestInput>;
};


export type MutationRetailersServiceMoveRetailerAssetsFromFilestackBucketArgs = {
  input?: InputMaybe<MoveRetailerAssetsFromFilestackBucketRequestInput>;
};


export type MutationReturnsServiceCreateOrUpdateReturnArgs = {
  input?: InputMaybe<CreateOrUpdateReturnRequestInput>;
};


export type MutationRoleCreateArgs = {
  role: CreateRoleInput;
};


export type MutationRoleDeleteArgs = {
  roleId: Scalars['ID'];
};


export type MutationRoleUpdateArgs = {
  role: UpdateRoleInput;
};


export type MutationRppBulkImageUploadsServiceCreateImageUploadBatchArgs = {
  input?: InputMaybe<CreateImageUploadBatchRequestInput>;
};


export type MutationSecondaryBannerPlacementCreateArgs = {
  secondaryBannerPlacementData: SecondaryBannerPlacementInput;
};


export type MutationSecondaryBannerPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  id: Scalars['ID'];
  secondaryBannerPlacementData: SecondaryBannerPlacementInput;
};


export type MutationShoppedAtRetailerVisibilityConditionCreateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput;
};


export type MutationShoppedAtRetailerVisibilityConditionUpdateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput;
};


export type MutationShoppedVisibilityConditionCreateArgs = {
  shoppedVisibilityConditionData: ShoppedInput;
};


export type MutationShoppedVisibilityConditionUpdateArgs = {
  shoppedVisibilityConditionData: ShoppedInput;
};


export type MutationStoreConfigurationsDraftServiceCreateStoreConfigurationDraftArgs = {
  input?: InputMaybe<CreateStoreConfigurationDraftRequestInput>;
};


export type MutationStoreConfigurationsDraftServicePublishStoreConfigurationDraftArgs = {
  input?: InputMaybe<PublishStoreConfigurationDraftRequestInput>;
};


export type MutationStoreConfigurationsDraftServiceRollbackStoreConfigurationArgs = {
  input?: InputMaybe<RollbackStoreConfigurationRequestInput>;
};


export type MutationStoreConfigurationsDraftServiceUpdateStoreConfigurationDraftArgs = {
  input?: InputMaybe<UpdateStoreConfigurationDraftRequestInput>;
};


export type MutationStorefrontPlacementCreateArgs = {
  retailerId: Scalars['ID'];
  storefrontPlacementData: StorefrontPlacementInput;
};


export type MutationStorefrontPlacementDeleteArgs = {
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
};


export type MutationStorefrontPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
  storefrontPlacementData: StorefrontPlacementInput;
};


export type MutationUserInteractionLimitVisibilityConditionCreateArgs = {
  userInteractionLimitVisibilityConditionData: UserInteractionLimitInput;
};


export type MutationUserInteractionLimitVisibilityConditionUpdateArgs = {
  userInteractionLimitVisibilityConditionData: UserInteractionLimitInput;
};


export type MutationUserSettingServiceSetUserSettingArgs = {
  input?: InputMaybe<SetUserSettingRequestInput>;
};


export type MutationUsersServiceGrantImpersonationArgs = {
  input?: InputMaybe<GrantImpersonationRequestInput>;
};


export type MutationUtmParametersVisibilityConditionCreateArgs = {
  utmParametersVisibilityConditionData: UtmParametersInput;
};


export type MutationUtmParametersVisibilityConditionUpdateArgs = {
  utmParametersVisibilityConditionData: UtmParametersInput;
};


export type MutationValueBasedOverrideServiceCreateValueBasedOverrideArgs = {
  input?: InputMaybe<CreateValueBasedOverrideRequestInput>;
};


export type MutationVirtualPartnerUpdateRetailersArgs = {
  partnerId: Scalars['ID'];
  retailerIds: Array<Scalars['ID']>;
};


export type MutationVisibilityConditionDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationWhitelistedPostalCodesVisibilityConditionCreateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput;
};


export type MutationWhitelistedPostalCodesVisibilityConditionUpdateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput;
};


export type MutationWhitelistedZonesVisibilityConditionCreateArgs = {
  whitelistedZonesVisibilityConditionData: WhitelistedZonesInput;
};


export type MutationWhitelistedZonesVisibilityConditionUpdateArgs = {
  whitelistedZonesVisibilityConditionData: WhitelistedZonesInput;
};


export type MutationWizardProgressUpdateArgs = {
  complete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type NativeMoreMenuLayoutV1Navigations = {
  __typename?: 'NativeMoreMenuLayoutV1Navigations';
  navs: Maybe<Array<Maybe<NativeMoreMenuNavigation>>>;
};

export type NativeMoreMenuLayoutV1NavigationsInput = {
  navs?: InputMaybe<Array<InputMaybe<NativeMoreMenuNavigationInput>>>;
};

export type NativeMoreMenuNavigation = {
  __typename?: 'NativeMoreMenuNavigation';
  gridNavigation: Maybe<GridNavigation>;
  navigationWithSubNavigation: Maybe<NavigationWithSubNavigation>;
};

export type NativeMoreMenuNavigationInput = {
  gridNavigation?: InputMaybe<GridNavigationInput>;
  navigationWithSubNavigation?: InputMaybe<NavigationWithSubNavigationInput>;
};

export type NativeTabBarNavigation = {
  __typename?: 'NativeTabBarNavigation';
  displayText: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<NavigationItem>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
};

export type NativeTabBarNavigationInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToAskInstacart = {
  __typename?: 'NavigateToAskInstacart';
  prompt: Maybe<Scalars['String']>;
  useBusinessDerivedAttributes: Maybe<Scalars['Boolean']>;
};

export type NavigateToAskInstacartInput = {
  prompt?: InputMaybe<Scalars['String']>;
  useBusinessDerivedAttributes?: InputMaybe<Scalars['Boolean']>;
};

export type NavigateToAuthentication = {
  __typename?: 'NavigateToAuthentication';
  authentication: Maybe<Authentication>;
};

export type NavigateToAuthenticationInput = {
  authentication?: InputMaybe<AuthenticationInput>;
};

export type NavigateToBenefitsModal = {
  __typename?: 'NavigateToBenefitsModal';
  id: Maybe<Scalars['BigInt']>;
};

export type NavigateToBenefitsModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToCategorySurface = {
  __typename?: 'NavigateToCategorySurface';
  categorySurfaceType: Maybe<CategorySurfaceType>;
};

export type NavigateToCategorySurfaceInput = {
  categorySurfaceType?: InputMaybe<CategorySurfaceType>;
};

export type NavigateToCollaborativeShopInfoModal = {
  __typename?: 'NavigateToCollaborativeShopInfoModal';
  id: Maybe<Scalars['BigInt']>;
};

export type NavigateToCollaborativeShopInfoModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToCollection = {
  __typename?: 'NavigateToCollection';
  legacyPath: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type NavigateToCollectionHub = {
  __typename?: 'NavigateToCollectionHub';
  category: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
};

export type NavigateToCollectionHubInput = {
  category?: InputMaybe<Scalars['String']>;
  collection?: InputMaybe<Scalars['String']>;
};

export type NavigateToCollectionInput = {
  legacyPath?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type NavigateToContainerPathViaStoreSelector = {
  __typename?: 'NavigateToContainerPathViaStoreSelector';
  retailers: Maybe<Array<Maybe<RetailerContainerPath>>>;
};

export type NavigateToContainerPathViaStoreSelectorInput = {
  retailers?: InputMaybe<Array<InputMaybe<RetailerContainerPathInput>>>;
};

export type NavigateToContentPage = {
  __typename?: 'NavigateToContentPage';
  slug: Maybe<Scalars['String']>;
};

export type NavigateToContentPageInput = {
  slug?: InputMaybe<Scalars['String']>;
};

export type NavigateToCouponRedemption = {
  __typename?: 'NavigateToCouponRedemption';
  couponCode: Maybe<Scalars['String']>;
  landingUrl: Maybe<Scalars['String']>;
  validateDays: Maybe<Scalars['BigInt']>;
  visibleAfterRedeem: Maybe<Scalars['Boolean']>;
};

export type NavigateToCouponRedemptionInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  landingUrl?: InputMaybe<Scalars['String']>;
  validateDays?: InputMaybe<Scalars['BigInt']>;
  visibleAfterRedeem?: InputMaybe<Scalars['Boolean']>;
};

export type NavigateToDepartment = {
  __typename?: 'NavigateToDepartment';
  departmentId: Maybe<Scalars['BigInt']>;
};

export type NavigateToDepartmentInput = {
  departmentId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToExpressAccountPage = {
  __typename?: 'NavigateToExpressAccountPage';
  id: Maybe<Scalars['BigInt']>;
};

export type NavigateToExpressAccountPageInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToFlyers = {
  __typename?: 'NavigateToFlyers';
  isDigitalFlyer: Maybe<Scalars['Boolean']>;
  tag: Maybe<Scalars['String']>;
};

export type NavigateToFlyersInput = {
  isDigitalFlyer?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type NavigateToHouseholdAccountSharingFlow = {
  __typename?: 'NavigateToHouseholdAccountSharingFlow';
  id: Maybe<Scalars['BigInt']>;
};

export type NavigateToHouseholdAccountSharingFlowInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPartnershipModal = {
  __typename?: 'NavigateToPartnershipModal';
  id: Maybe<Scalars['BigInt']>;
};

export type NavigateToPartnershipModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPickupStoreSelector = {
  __typename?: 'NavigateToPickupStoreSelector';
  showDistance: Maybe<Scalars['Boolean']>;
};

export type NavigateToPickupStoreSelectorInput = {
  showDistance?: InputMaybe<Scalars['Boolean']>;
};

export type NavigateToProduct = {
  __typename?: 'NavigateToProduct';
  productId: Maybe<Scalars['BigInt']>;
};

export type NavigateToProductInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPromoModal = {
  __typename?: 'NavigateToPromoModal';
  discountPolicyId: Maybe<Scalars['BigInt']>;
};

export type NavigateToPromoModalInput = {
  discountPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPromotionDetail = {
  __typename?: 'NavigateToPromotionDetail';
  id: Maybe<Scalars['BigInt']>;
};

export type NavigateToPromotionDetailInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToRetailerCollection = {
  __typename?: 'NavigateToRetailerCollection';
  retailerId: Maybe<Scalars['BigInt']>;
  slug: Maybe<Scalars['String']>;
};

export type NavigateToRetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type NavigateToRetailerCollectionViaStoreSelector = {
  __typename?: 'NavigateToRetailerCollectionViaStoreSelector';
  retailerCollections: Maybe<Array<Maybe<RetailerCollection>>>;
};

export type NavigateToRetailerCollectionViaStoreSelectorInput = {
  retailerCollections?: InputMaybe<Array<InputMaybe<RetailerCollectionInput>>>;
};

export type NavigateToSsaStoreSelector = {
  __typename?: 'NavigateToSsaStoreSelector';
  serviceAreaType: Maybe<Scalars['String']>;
};

export type NavigateToSsaStoreSelectorInput = {
  serviceAreaType?: InputMaybe<Scalars['String']>;
};

export type NavigateToStoreSelector = {
  __typename?: 'NavigateToStoreSelector';
  collectionSlug: Maybe<Scalars['String']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  storeForwardModuleType: Maybe<Scalars['String']>;
};

export type NavigateToStoreSelectorInput = {
  collectionSlug?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeForwardModuleType?: InputMaybe<Scalars['String']>;
};

export type NavigateToStorefront = {
  __typename?: 'NavigateToStorefront';
  retailerId: Maybe<Scalars['BigInt']>;
};

export type NavigateToStorefrontInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToUrl = {
  __typename?: 'NavigateToUrl';
  openInNewTab: Maybe<Scalars['Boolean']>;
  openInNewWindow: Maybe<Scalars['Boolean']>;
  url: Maybe<Scalars['String']>;
};

export type NavigateToUrlInput = {
  openInNewTab?: InputMaybe<Scalars['Boolean']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Navigation = {
  __typename?: 'Navigation';
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<NavigationItem>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  logoUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
};

export type NavigationAction = {
  __typename?: 'NavigationAction';
  data: Maybe<Scalars['JSONObject']>;
  typeName: Maybe<Scalars['String']>;
};

export type NavigationActionInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  typeName?: InputMaybe<Scalars['String']>;
};

export type NavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  logoUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  actions: Maybe<Array<Maybe<NavigationAction>>>;
  groupPosition: Maybe<Scalars['String']>;
  grouping: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  icon2: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  isNested: Maybe<Scalars['Boolean']>;
  itemType: Maybe<Scalars['String']>;
  placement: Maybe<PlacementContent>;
  placementId: Maybe<Scalars['BigInt']>;
  position: Maybe<Scalars['BigInt']>;
  text: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

export type NavigationItemInput = {
  actions?: InputMaybe<Array<InputMaybe<NavigationActionInput>>>;
  groupPosition?: InputMaybe<Scalars['String']>;
  grouping?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  icon2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isNested?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['String']>;
  placement?: InputMaybe<PlacementContentInput>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  text?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type NavigationV2Action = {
  __typename?: 'NavigationV2Action';
  data: Maybe<Scalars['JSONObject']>;
  typeName: Maybe<Scalars['String']>;
};

export type NavigationV2ActionInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  typeName?: InputMaybe<Scalars['String']>;
};

export type NavigationV2Item = {
  __typename?: 'NavigationV2Item';
  action: Maybe<NavigationV2Action>;
  icon: Maybe<Scalars['String']>;
  icon2: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  itemType: Maybe<Scalars['String']>;
  placement: Maybe<PlacementContent>;
  placementId: Maybe<Scalars['BigInt']>;
  position: Maybe<Scalars['BigInt']>;
  text: Maybe<Scalars['String']>;
  variant: Maybe<Scalars['String']>;
};

export type NavigationV2ItemInput = {
  action?: InputMaybe<NavigationV2ActionInput>;
  icon?: InputMaybe<Scalars['String']>;
  icon2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<Scalars['String']>;
  placement?: InputMaybe<PlacementContentInput>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  text?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type NavigationWithContainers = {
  __typename?: 'NavigationWithContainers';
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<AllNavigationWithContainersItems>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
  title: Maybe<Scalars['String']>;
};

export type NavigationWithContainersInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<AllNavigationWithContainersItemsInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NavigationWithSubNavigation = {
  __typename?: 'NavigationWithSubNavigation';
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<SubNavigation>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
  title: Maybe<Scalars['String']>;
};

export type NavigationWithSubNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<SubNavigationInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NewVerticalUserTargetingInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** The module type */
  moduleType: Scalars['String'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of NewVerticalUserTargetingVisibilityConditionCreate */
export type NewVerticalUserTargetingVisibilityConditionCreatePayload = {
  __typename?: 'NewVerticalUserTargetingVisibilityConditionCreatePayload';
  /** The newly created NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityCondition: ContentManagementVisibilityConditionNewVerticalUserTargeting;
};

/** Autogenerated return type of NewVerticalUserTargetingVisibilityConditionUpdate */
export type NewVerticalUserTargetingVisibilityConditionUpdatePayload = {
  __typename?: 'NewVerticalUserTargetingVisibilityConditionUpdatePayload';
  /** The newly updated NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityCondition: ContentManagementVisibilityConditionNewVerticalUserTargeting;
};

export type NonenumeratedManagedAttributes = {
  __typename?: 'NonenumeratedManagedAttributes';
  digitalScaleRequired: Maybe<Scalars['Boolean']>;
  lookupCodePluOnly: Maybe<Array<Maybe<Scalars['String']>>>;
  potentialScanCodes: Maybe<Array<Maybe<PotentialScanCodesByStrategy>>>;
  retailerPreferredLookupCode: Maybe<Scalars['String']>;
};

/** Autogenerated return type of NormalizedReportsMerge */
export type NormalizedReportsMergePayload = {
  __typename?: 'NormalizedReportsMergePayload';
  /** Merge successful */
  success: Scalars['Boolean'];
};

export type NormalizedReportsNormalizedReport = {
  __typename?: 'NormalizedReportsNormalizedReport';
  /** Name of the bucket where the report comes from */
  bucketName: Scalars['String'];
  /** Date at which the report was created in YYYY-MM-DD format */
  createdAt: Scalars['Time'];
  /** Type of the file */
  fileType: Scalars['String'];
  /** Name of the file */
  name: Scalars['String'];
  /** Type of the report */
  reportType: ReportTypeEnum;
  /** Retailer ID */
  retailerId: Maybe<Scalars['String']>;
  /** Retailer Location Group ID */
  retailerLocationGroupId: Maybe<Scalars['String']>;
  /** Name of the retailer location group */
  retailerLocationGroupName: Maybe<Scalars['String']>;
  /** File path to the object in the bucket */
  s3Key: Scalars['String'];
  /** Size in bytes of the object */
  size: Scalars['Int'];
};

/** The connection type for NormalizedReportsNormalizedReport. */
export type NormalizedReportsNormalizedReportConnection = {
  __typename?: 'NormalizedReportsNormalizedReportConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NormalizedReportsNormalizedReportEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<NormalizedReportsNormalizedReport>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NormalizedReportsNormalizedReportEdge = {
  __typename?: 'NormalizedReportsNormalizedReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<NormalizedReportsNormalizedReport>;
};

export type NormalizedReportsNormalizedReportSignedUrl = {
  __typename?: 'NormalizedReportsNormalizedReportSignedUrl';
  /** Signed url for the object */
  signedUrl: Scalars['String'];
};

export type NormalizedReportsReportType = {
  __typename?: 'NormalizedReportsReportType';
  /** Report type label */
  label: Scalars['String'];
  /** The report type value */
  value: ReportTypeEnum;
};

/** The scope for the notification */
export enum NotificationScopeTypeEnum {
  /** Banner scope */
  Banner = 'banner',
  /** Global scope */
  Global = 'global',
  /** Partner scope */
  Partner = 'partner'
}

export enum NotificationSeverityEnum {
  /** Info */
  Info = 'info',
  /** Urgent */
  Urgent = 'urgent'
}

/** Autogenerated return type of NotificationSubscriptionCreate */
export type NotificationSubscriptionCreatePayload = {
  __typename?: 'NotificationSubscriptionCreatePayload';
  /** Subscription successful */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of NotificationSubscriptionDelete */
export type NotificationSubscriptionDeletePayload = {
  __typename?: 'NotificationSubscriptionDeletePayload';
  /** Unsubscribe successful */
  success: Scalars['Boolean'];
};

/** The method of subscription */
export enum NotificationSubscriptionMethodEnum {
  /** Email */
  Email = 'email',
  /** In App */
  InApp = 'in_app'
}

/** Autogenerated return type of NotificationsDelete */
export type NotificationsDeletePayload = {
  __typename?: 'NotificationsDeletePayload';
  /** Notifications deleted successfully */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of NotificationsMarkRead */
export type NotificationsMarkReadPayload = {
  __typename?: 'NotificationsMarkReadPayload';
  /** Notifications marked as read successfully */
  success: Scalars['Boolean'];
};

export type NotificationsNotification = {
  __typename?: 'NotificationsNotification';
  channelId: Scalars['ID'];
  channelName: Scalars['String'];
  channelSlug: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  scopeId: Maybe<Scalars['ID']>;
  scopeType: NotificationScopeTypeEnum;
  severity: NotificationSeverityEnum;
  templateName: Scalars['String'];
  templateValues: Maybe<Scalars['JSON']>;
};

export type NotificationsNotificationChannel = {
  __typename?: 'NotificationsNotificationChannel';
  /** Localized description of notification channel */
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** If the user making the request is subscribed to the notification channel via email */
  isEmailSubscribed: Maybe<Scalars['Boolean']>;
  /** If the user making the request is subscribed to the notification channel via the app */
  isInAppSubscribed: Maybe<Scalars['Boolean']>;
  /** Localized name of notification channel */
  name: Scalars['String'];
  /** The scope type of the notification channel */
  scopeType: NotificationScopeTypeEnum;
  /** Unique identifier for the notification channel */
  slug: Scalars['String'];
};

/** The connection type for NotificationsNotification. */
export type NotificationsNotificationConnection = {
  __typename?: 'NotificationsNotificationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NotificationsNotificationEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<NotificationsNotification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationsNotificationEdge = {
  __typename?: 'NotificationsNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<NotificationsNotification>;
};

export type OauthApplication = {
  __typename?: 'OauthApplication';
  clientId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  environment: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  moreTokensExist: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  tokenCount: Maybe<Scalars['BigInt']>;
};

export type ObjectKeyMappingInput = {
  destinationObjectKey?: InputMaybe<Scalars['String']>;
  sourceObjectKey?: InputMaybe<Scalars['String']>;
};

export type OffersSchema = {
  __typename?: 'OffersSchema';
  disableFlierPlacement: Maybe<Scalars['Boolean']>;
};

export type OnShelfCountEntry = {
  __typename?: 'OnShelfCountEntry';
  count: Maybe<Scalars['Int']>;
  timestamp: Maybe<Scalars['DateTime']>;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  billingAddress: Maybe<Address>;
  businessRegistrationDocument: Maybe<Scalars['String']>;
  contactInfo: Maybe<Contact>;
  contractRenderData: Maybe<ContractRenderData>;
  corporationType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  duns: Maybe<Scalars['String']>;
  entityName: Maybe<Scalars['String']>;
  exclusivity: Maybe<Scalars['String']>;
  ironcladData: Maybe<IroncladData>;
  isaCheckboxTimestamp: Maybe<Scalars['String']>;
  isaImageSignedUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  isaPdfSignedUrl: Maybe<Scalars['String']>;
  ndaCheckboxTimestamp: Maybe<Scalars['String']>;
  ndaImageSignedUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  ndaPdfSignedUrl: Maybe<Scalars['String']>;
  onboardingType: Maybe<Scalars['String']>;
  posSystemName: Maybe<Scalars['String']>;
  priceParity: Maybe<Scalars['String']>;
  signupPartner: Maybe<SignupPartner>;
  stateOfIncorporation: Maybe<Scalars['String']>;
  storeCount: Maybe<Scalars['String']>;
  storeLocation: Maybe<Address>;
  updatedAt: Maybe<Scalars['DateTime']>;
  w9Form: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
  workflowState: Maybe<Scalars['String']>;
};

export type OnboardingAttribute = {
  __typename?: 'OnboardingAttribute';
  allowedValues: Maybe<Array<Maybe<Scalars['String']>>>;
  attributeDisplayName: Maybe<Scalars['String']>;
  attributeName: Maybe<Scalars['String']>;
  attributeQuestion: Maybe<Scalars['String']>;
  attributeSubgroupName: Maybe<Scalars['String']>;
  config: Maybe<Scalars['String']>;
  configDetails: Maybe<OnboardingAttributeConfigDetails>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdBy: Maybe<Scalars['BigInt']>;
  dataType: Maybe<Scalars['String']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  description: Maybe<Scalars['String']>;
  entityName: Maybe<Scalars['String']>;
  groupName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  isFile: Maybe<Scalars['Boolean']>;
  isSecret: Maybe<Scalars['Boolean']>;
  maxLength: Maybe<Scalars['BigInt']>;
  minLength: Maybe<Scalars['BigInt']>;
  modifiedBy: Maybe<Scalars['BigInt']>;
  readOnly: Maybe<Scalars['Boolean']>;
  released: Maybe<Scalars['Boolean']>;
  required: Maybe<Scalars['Boolean']>;
  requiredIf: Maybe<Scalars['String']>;
  retailerAllowedToChange: Maybe<Scalars['Boolean']>;
  secretConfig: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  visibilityTiers: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OnboardingAttributeAutomation = {
  __typename?: 'OnboardingAttributeAutomation';
  propagateToStoreConfiguration: Maybe<Scalars['Boolean']>;
  storeConfigurationDetails: Maybe<OnboardingAttributeAutomationStoreConfigurationDetails>;
};

export type OnboardingAttributeAutomationStoreConfigurationDetails = {
  __typename?: 'OnboardingAttributeAutomationStoreConfigurationDetails';
  booleanInverted: Maybe<Scalars['Boolean']>;
  key: Maybe<Scalars['String']>;
  schemaKey: Maybe<Scalars['String']>;
};

export type OnboardingAttributeConfigDetails = {
  __typename?: 'OnboardingAttributeConfigDetails';
  automation: Maybe<OnboardingAttributeAutomation>;
  componentType: Maybe<Scalars['String']>;
  dimensions: Maybe<OnboardingAttributeDimensions>;
  formats: Maybe<Array<Maybe<OnboardingAttributeFormat>>>;
  maxFileSize: Maybe<Scalars['String']>;
  messages: Maybe<OnboardingAttributeMessages>;
  multiselectOptions: Maybe<Array<Maybe<OnboardingAttributeMultiselectOptions>>>;
  options: Maybe<OnboardingAttributeOptions>;
  pattern: Maybe<OnboardingAttributePattern>;
  radioOptions: Maybe<Array<Maybe<OnboardingAttributeRadioOptions>>>;
  visibleIf: Maybe<Scalars['String']>;
};

export type OnboardingAttributeDimensions = {
  __typename?: 'OnboardingAttributeDimensions';
  height: Maybe<Scalars['BigInt']>;
  width: Maybe<Scalars['BigInt']>;
};

export type OnboardingAttributeFormat = {
  __typename?: 'OnboardingAttributeFormat';
  extension: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type OnboardingAttributeMessages = {
  __typename?: 'OnboardingAttributeMessages';
  description: Maybe<Scalars['String']>;
  dropFile: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  placeholder: Maybe<Scalars['String']>;
  question: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  tooltip: Maybe<Scalars['String']>;
};

export type OnboardingAttributeMultiselectOptions = {
  __typename?: 'OnboardingAttributeMultiselectOptions';
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type OnboardingAttributeOptions = {
  __typename?: 'OnboardingAttributeOptions';
  falseValue: Maybe<Scalars['String']>;
  trueValue: Maybe<Scalars['String']>;
};

export type OnboardingAttributePattern = {
  __typename?: 'OnboardingAttributePattern';
  message: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type OnboardingAttributeRadioOptions = {
  __typename?: 'OnboardingAttributeRadioOptions';
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export enum OnboardingAttributeStatus {
  OnboardingAttributeStatusArchived = 'ONBOARDING_ATTRIBUTE_STATUS_ARCHIVED',
  OnboardingAttributeStatusDraft = 'ONBOARDING_ATTRIBUTE_STATUS_DRAFT',
  OnboardingAttributeStatusPreReleased = 'ONBOARDING_ATTRIBUTE_STATUS_PRE_RELEASED',
  OnboardingAttributeStatusReleased = 'ONBOARDING_ATTRIBUTE_STATUS_RELEASED',
  OnboardingAttributeStatusUnknown = 'ONBOARDING_ATTRIBUTE_STATUS_UNKNOWN'
}

export type OnboardingFeatureTypesMobileAppConfig = {
  __typename?: 'OnboardingFeatureTypesMobileAppConfig';
  /** The asset information for uploaded items */
  assets: Array<MutableS3Asset>;
  /** The properties for the app */
  properties: Array<OnboardingFeatureTypesProperty>;
};

export type OnboardingFeatureTypesProperty = {
  __typename?: 'OnboardingFeatureTypesProperty';
  /** The property name */
  name: Scalars['String'];
  /** The property value */
  value: Maybe<Scalars['JSON']>;
};

export type OnboardingFeatureTypesWorkflow = {
  __typename?: 'OnboardingFeatureTypesWorkflow';
  /** The time the workflow was created */
  createdAt: Maybe<Scalars['ISO8601DateTime']>;
  /** The workflow id */
  id: Scalars['Int'];
  /** The workflow being run */
  name: Scalars['String'];
  /** The status of the workflow */
  status: Scalars['String'];
  /** The time the status was last updated */
  statusUpdatedAt: Maybe<Scalars['ISO8601DateTime']>;
  /** The url to the workflow */
  url: Maybe<Scalars['String']>;
};

export enum OnboardingWorkflowStateAction {
  OnboardingWorkflowStateActionComplete = 'ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE',
  OnboardingWorkflowStateActionProvideBillingAddress = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_BILLING_ADDRESS',
  OnboardingWorkflowStateActionProvideOnboardingInfo = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_ONBOARDING_INFO',
  OnboardingWorkflowStateActionProvideStoreLocations = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_STORE_LOCATIONS',
  OnboardingWorkflowStateActionSignIsa = 'ONBOARDING_WORKFLOW_STATE_ACTION_SIGN_ISA',
  OnboardingWorkflowStateActionSignNda = 'ONBOARDING_WORKFLOW_STATE_ACTION_SIGN_NDA',
  OnboardingWorkflowStateActionStart = 'ONBOARDING_WORKFLOW_STATE_ACTION_START',
  OnboardingWorkflowStateActionUnknown = 'ONBOARDING_WORKFLOW_STATE_ACTION_UNKNOWN',
  OnboardingWorkflowStateActionViewIsa = 'ONBOARDING_WORKFLOW_STATE_ACTION_VIEW_ISA',
  OnboardingWorkflowStateActionViewNda = 'ONBOARDING_WORKFLOW_STATE_ACTION_VIEW_NDA'
}

export type OpenExpressPaidModal = {
  __typename?: 'OpenExpressPaidModal';
  id: Maybe<Scalars['BigInt']>;
};

export type OpenExpressPaidModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type OpenExpressTrialModal = {
  __typename?: 'OpenExpressTrialModal';
  id: Maybe<Scalars['BigInt']>;
};

export type OpenExpressTrialModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type OperationalHours = {
  __typename?: 'OperationalHours';
  displayableTimePeriods: Maybe<Array<Maybe<TimePeriod>>>;
  isCrossDay: Maybe<Scalars['Boolean']>;
  isOpenAllDay: Maybe<Scalars['Boolean']>;
  timePeriods: Maybe<Array<Maybe<TimePeriod>>>;
};

export type OptInUser = {
  __typename?: 'OptInUser';
  id: Maybe<Scalars['BigInt']>;
  optOut: Maybe<Scalars['Boolean']>;
};

export type OptInUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  optOut?: InputMaybe<Scalars['Boolean']>;
};

export type OrderByComponentInput = {
  asc?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<Scalars['String']>;
};

export type OrderByInput = {
  asc?: InputMaybe<Scalars['Boolean']>;
  attribute?: InputMaybe<Scalars['String']>;
};

export type OrderInput = {
  checkoutRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  shoppedRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type OrderSources = {
  __typename?: 'OrderSources';
  /** Order Sources */
  orderSources: Maybe<Array<Scalars['String']>>;
};

export type OrdersSchema = {
  __typename?: 'OrdersSchema';
  disablePostCheckoutDeliveryFallbackImage: Maybe<Scalars['Boolean']>;
  disableSpecialRequests: Maybe<Scalars['Boolean']>;
  liveActivitiesOptIn: Maybe<Scalars['Boolean']>;
  tlogIngestionEnabled: Maybe<Scalars['Boolean']>;
};

export enum Os {
  /** Android app */
  Android = 'android',
  /** iOS app */
  IOs = 'iOS'
}

export type OutsourceDataEntryItem = {
  __typename?: 'OutsourceDataEntryItem';
  outsourceItemId: Maybe<Scalars['String']>;
};

export type OverrideHours = {
  __typename?: 'OverrideHours';
  date: Maybe<GoogleTypeDate>;
  description: Maybe<Scalars['String']>;
  endTime: Maybe<GoogleTypeTimeOfDay>;
  serviceType: Maybe<RetailerServiceType>;
  startTime: Maybe<GoogleTypeTimeOfDay>;
};

export type OverrideHoursInput = {
  date?: InputMaybe<GoogleTypeDateInput>;
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
  serviceType?: InputMaybe<RetailerServiceType>;
  startTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
};

export enum OverrideType {
  OverrideTypeExclude = 'OVERRIDE_TYPE_EXCLUDE',
  OverrideTypeReplace = 'OVERRIDE_TYPE_REPLACE',
  OverrideTypeUnknown = 'OVERRIDE_TYPE_UNKNOWN'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  limit: Maybe<Scalars['BigInt']>;
  offset: Maybe<Scalars['BigInt']>;
};

export type PaginationDetails = {
  __typename?: 'PaginationDetails';
  page: Maybe<Scalars['BigInt']>;
  perPage: Maybe<Scalars['BigInt']>;
  totalCount: Maybe<Scalars['BigInt']>;
  totalPages: Maybe<Scalars['BigInt']>;
};

export type PaginationDetailsInput = {
  page?: InputMaybe<Scalars['BigInt']>;
  perPage?: InputMaybe<Scalars['BigInt']>;
  totalCount?: InputMaybe<Scalars['BigInt']>;
  totalPages?: InputMaybe<Scalars['BigInt']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

export type Partner = {
  __typename?: 'Partner';
  /** The feature toggles associated with the partner */
  featureToggles: Array<FeatureToggle>;
  /** The feature toggles associated with the partner broken down by retailer */
  featureTogglesByRetailer: Array<FeatureToggleByRetailerId>;
  /** A unique identifier for the partner */
  id: Scalars['ID'];
  /** The name of the partner */
  name: Scalars['String'];
  /** A unique identifier for the partner */
  partnerId: Maybe<Scalars['ID']>;
  /** The type of partner */
  partnerType: Maybe<Scalars['String']>;
  /** List of retailer IDs for this partner */
  retailerIds: Array<Scalars['ID']>;
  /** The retailers belonging to this partner */
  retailers: Array<Retailer>;
};


export type PartnerRetailersArgs = {
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** The connection type for Partner. */
export type PartnerConnection = {
  __typename?: 'PartnerConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PartnerEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Partner>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerEdge = {
  __typename?: 'PartnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Partner>;
};

export type PartnerPickCapacityGetCapacityRecommendationsResponse = {
  __typename?: 'PartnerPickCapacityGetCapacityRecommendationsResponse';
  allowedRecommendationTypes: Array<RecommendationTypeEnum>;
  recommendations: Array<PartnerPickCapacityRecommendation>;
};

export type PartnerPickCapacityRecommendation = {
  __typename?: 'PartnerPickCapacityRecommendation';
  date: Scalars['ISO8601Date'];
  endsAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  recommendationType: RecommendationTypeEnum;
  retailerLocationId: Scalars['ID'];
  shiftType: ShiftTypeEnum;
  startsAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of PartnerPickDeviceCreate */
export type PartnerPickDeviceCreatePayload = {
  __typename?: 'PartnerPickDeviceCreatePayload';
  /** The newly created device */
  partnerPickDevice: PartnerPickDevicesDevice;
};

/** Autogenerated return type of PartnerPickDeviceSetStatus */
export type PartnerPickDeviceSetStatusPayload = {
  __typename?: 'PartnerPickDeviceSetStatusPayload';
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice;
};

/** Autogenerated return type of PartnerPickDeviceUpdate */
export type PartnerPickDeviceUpdatePayload = {
  __typename?: 'PartnerPickDeviceUpdatePayload';
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice;
};

export type PartnerPickDevicesDevice = {
  __typename?: 'PartnerPickDevicesDevice';
  /** Status for the device */
  active: Scalars['Boolean'];
  /** Type of device */
  deviceType: DeviceTypeEnum;
  /** Email address for the device */
  email: Scalars['String'];
  /** First name for the device */
  firstName: Scalars['String'];
  /** A unique identifier for the device */
  id: Scalars['ID'];
  /** Whether the device belongs to a store manager */
  isPartnerPickStoreManager: Scalars['Boolean'];
  /** Last name for the device */
  lastName: Scalars['String'];
  /** marqeta cards metatdata for the device */
  marqetaCardsMetadata: Maybe<PartnerPickDevicesMarqetaCardsMetadata>;
  /** Phone number for the device */
  phone: Scalars['String'];
};

export type PartnerPickDevicesDeviceSearch = {
  __typename?: 'PartnerPickDevicesDeviceSearch';
  devices: Array<PartnerPickDevicesDevice>;
  meta: HubPaginationMeta;
};

export type PartnerPickDevicesMarqetaCardsMetadata = {
  __typename?: 'PartnerPickDevicesMarqetaCardsMetadata';
  digital: Maybe<Scalars['Int']>;
  inactive: Maybe<Scalars['Int']>;
  physical: Maybe<Scalars['Int']>;
  suspended: Maybe<Scalars['Int']>;
  terminated: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of PartnerPickRecurringShiftCreate */
export type PartnerPickRecurringShiftCreatePayload = {
  __typename?: 'PartnerPickRecurringShiftCreatePayload';
  /** The newly created recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift;
};

/** Autogenerated return type of PartnerPickRecurringShiftDelete */
export type PartnerPickRecurringShiftDeletePayload = {
  __typename?: 'PartnerPickRecurringShiftDeletePayload';
  errorMessage: Maybe<Scalars['String']>;
  /** Whether the deletion succeeded or not */
  success: Scalars['True'];
};

/** Autogenerated return type of PartnerPickRecurringShiftUpdate */
export type PartnerPickRecurringShiftUpdatePayload = {
  __typename?: 'PartnerPickRecurringShiftUpdatePayload';
  /** The updated recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift;
};

export type PartnerPickRecurringShiftsConflict = {
  __typename?: 'PartnerPickRecurringShiftsConflict';
  recurringShiftConflicts: Array<PartnerPickRecurringShiftsRecurringShiftConflict>;
  singleShiftConflicts: Array<PartnerPickRecurringShiftsSingleShiftConflict>;
};

export type PartnerPickRecurringShiftsRecurringShift = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShift';
  /** an array of Ruby Date wday that a shift recurs on (0-6, Sunday is zero) */
  daysOfWeek: Array<Scalars['Int']>;
  driverId: Scalars['ID'];
  driverShiftId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  onCall: Maybe<Scalars['Boolean']>;
  recurEndDate: Maybe<Scalars['ISO8601Date']>;
  recurStartDate: Maybe<Scalars['ISO8601Date']>;
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  shiftType: ShiftTypeEnum;
};

export type PartnerPickRecurringShiftsRecurringShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShiftConflict';
  /** Days of the week when a shift occurs, represented as an Int (0-6). Sunday is 0 */
  daysOfWeek: Array<Scalars['Int']>;
  id: Scalars['ID'];
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  shiftType: ShiftTypeEnum;
};

export type PartnerPickRecurringShiftsSingleShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsSingleShiftConflict';
  date: Scalars['ISO8601Date'];
  endsAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  shiftType: ShiftTypeEnum;
  startsAt: Scalars['ISO8601DateTime'];
};

export enum PatchStatus {
  PatchStatusApplyingOverrides = 'PATCH_STATUS_APPLYING_OVERRIDES',
  PatchStatusApproved = 'PATCH_STATUS_APPROVED',
  PatchStatusDeleted = 'PATCH_STATUS_DELETED',
  PatchStatusFailed = 'PATCH_STATUS_FAILED',
  PatchStatusPatchCreationInProgress = 'PATCH_STATUS_PATCH_CREATION_IN_PROGRESS',
  PatchStatusPendingApproval = 'PATCH_STATUS_PENDING_APPROVAL',
  PatchStatusRejected = 'PATCH_STATUS_REJECTED',
  PatchStatusSuccessful = 'PATCH_STATUS_SUCCESSFUL',
  PatchStatusUnspecified = 'PATCH_STATUS_UNSPECIFIED'
}

export type PaymentsSchema = {
  __typename?: 'PaymentsSchema';
  useSiteNameForIcWalletBranding: Maybe<Scalars['Boolean']>;
};

export type Permission = {
  __typename?: 'Permission';
  /** Indicates if the permission can be used for Retailer custom roles */
  isRetailerRoleAssignable: Scalars['Boolean'];
  /** A unique identifier for the permission */
  slug: Scalars['ID'];
};

export type PermissionInput = {
  /** A unique identifier for the permission */
  slug: Scalars['ID'];
};

export enum PickingModelEnum {
  /** Carrotwork */
  Carrotwork = 'CARROTWORK',
  /** Full service shoppers */
  FullService = 'FULL_SERVICE',
  /** In store shoppers */
  Iss = 'ISS',
  /** Partner managed */
  Retailer = 'RETAILER'
}

export enum PickupType {
  PickupTypeCurbside = 'PICKUP_TYPE_CURBSIDE',
  PickupTypeInStore = 'PICKUP_TYPE_IN_STORE',
  PickupTypeUnknown = 'PICKUP_TYPE_UNKNOWN'
}

export type PiiRequest = {
  __typename?: 'PiiRequest';
  createdAt: Maybe<Scalars['DateTime']>;
  downloadLink: Maybe<Scalars['String']>;
  requestId: Maybe<Scalars['BigInt']>;
  requestType: Maybe<RequestType>;
  retailerNotes: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  userEmail: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
  workflowStatus: Maybe<WorkflowStatus>;
};

export enum PiiRequestCreationStatus {
  PiiRequestCreationStatusDuplicateError = 'PII_REQUEST_CREATION_STATUS_DUPLICATE_ERROR',
  PiiRequestCreationStatusInternalError = 'PII_REQUEST_CREATION_STATUS_INTERNAL_ERROR',
  PiiRequestCreationStatusNotFound = 'PII_REQUEST_CREATION_STATUS_NOT_FOUND',
  PiiRequestCreationStatusSuccess = 'PII_REQUEST_CREATION_STATUS_SUCCESS',
  PiiRequestCreationStatusUnspecified = 'PII_REQUEST_CREATION_STATUS_UNSPECIFIED',
  PiiRequestCreationStatusUserNotFound = 'PII_REQUEST_CREATION_STATUS_USER_NOT_FOUND',
  PiiRequestCreationStatusUserStoreConfigurationNotFound = 'PII_REQUEST_CREATION_STATUS_USER_STORE_CONFIGURATION_NOT_FOUND'
}

export type Placement = {
  __typename?: 'Placement';
  banner: Maybe<BannerType>;
  banners: Maybe<Array<Maybe<BannerType>>>;
  cardList: Maybe<CardList>;
  contentPageVersionId: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  creativeRank: Maybe<Scalars['BigInt']>;
  enabled: Maybe<Scalars['Boolean']>;
  endDate: Maybe<Scalars['DateTime']>;
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  experimentMethod: Maybe<ExperimentMethod>;
  experimentName: Maybe<Scalars['String']>;
  experimentVariant: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  includedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  includedStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  internalName: Maybe<Scalars['String']>;
  itemList: Maybe<ItemList>;
  layout: Maybe<Layout>;
  layoutVariantId: Maybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior: Maybe<Scalars['Boolean']>;
  placementContext: Maybe<PlacementContext>;
  platform: Maybe<Array<Maybe<PlatformType>>>;
  rank: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  startDate: Maybe<Scalars['DateTime']>;
  status: Maybe<Status>;
  stringLayout: Maybe<Scalars['String']>;
  teamOwner: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  userOwner: Maybe<Scalars['BigInt']>;
  widget: Maybe<Widget>;
};

export enum PlacementAdminContextAudience {
  AdminContextAudienceUnspecified = 'ADMIN_CONTEXT_AUDIENCE_UNSPECIFIED',
  InstacartAdmins = 'INSTACART_ADMINS',
  ThirdPartyAdmins = 'THIRD_PARTY_ADMINS'
}

export type PlacementAdminContextInput = {
  audience?: InputMaybe<PlacementAdminContextAudience>;
};

export type PlacementContent = {
  __typename?: 'PlacementContent';
  contentPageVersionId: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdByCanonicalId: Maybe<Scalars['String']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  enabled: Maybe<Scalars['Boolean']>;
  endsAt: Maybe<Scalars['DateTime']>;
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedRetailerTypes: Maybe<Array<Maybe<Scalars['String']>>>;
  excludedStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  experimentMethod: Maybe<Scalars['String']>;
  experimentName: Maybe<Scalars['String']>;
  experimentVariant: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  includedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  includedRetailerTypes: Maybe<Array<Maybe<Scalars['String']>>>;
  includedStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  internalName: Maybe<Scalars['String']>;
  layout: Maybe<Scalars['String']>;
  layoutVariantId: Maybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior: Maybe<Scalars['Boolean']>;
  parentPlacementId: Maybe<Scalars['BigInt']>;
  placementBucketId: Maybe<Scalars['BigInt']>;
  placementType: Maybe<Scalars['String']>;
  placementTypeData: Maybe<Array<Maybe<PlacementContentDataStruct>>>;
  platform: Maybe<Array<Maybe<Scalars['String']>>>;
  rank: Maybe<Scalars['BigInt']>;
  slotCreatives: Maybe<Array<Maybe<SlotCreative>>>;
  slots: Maybe<Array<Maybe<Slot>>>;
  startsAt: Maybe<Scalars['DateTime']>;
  teamOwner: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  updatedByCanonicalId: Maybe<Scalars['String']>;
  userOwner: Maybe<Scalars['String']>;
  visibilityConditions: Maybe<Array<Maybe<VisibilityConditionStruct>>>;
};

export type PlacementContentDataStruct = {
  __typename?: 'PlacementContentDataStruct';
  contentData: Maybe<Scalars['JSONObject']>;
  contentDataId: Maybe<Scalars['BigInt']>;
  contentType: Maybe<Scalars['String']>;
  contentVariant: Maybe<Scalars['String']>;
};

export type PlacementContentDataStructInput = {
  contentData?: InputMaybe<Scalars['JSONObject']>;
  contentDataId?: InputMaybe<Scalars['BigInt']>;
  contentType?: InputMaybe<Scalars['String']>;
  contentVariant?: InputMaybe<Scalars['String']>;
};

export type PlacementContentInput = {
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByCanonicalId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  experimentMethod?: InputMaybe<Scalars['String']>;
  experimentName?: InputMaybe<Scalars['String']>;
  experimentVariant?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  includedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  internalName?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['String']>;
  layoutVariantId?: InputMaybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior?: InputMaybe<Scalars['Boolean']>;
  parentPlacementId?: InputMaybe<Scalars['BigInt']>;
  placementBucketId?: InputMaybe<Scalars['BigInt']>;
  placementType?: InputMaybe<Scalars['String']>;
  placementTypeData?: InputMaybe<Array<InputMaybe<PlacementContentDataStructInput>>>;
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rank?: InputMaybe<Scalars['BigInt']>;
  slotCreatives?: InputMaybe<Array<InputMaybe<SlotCreativeInput>>>;
  slots?: InputMaybe<Array<InputMaybe<SlotInput>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  teamOwner?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByCanonicalId?: InputMaybe<Scalars['String']>;
  userOwner?: InputMaybe<Scalars['String']>;
  visibilityConditions?: InputMaybe<Array<InputMaybe<VisibilityConditionStructInput>>>;
};

export type PlacementContentRequestPagination = {
  __typename?: 'PlacementContentRequestPagination';
  orderBy: Maybe<Array<Maybe<PlacementContentRequestPaginationOrder>>>;
  pageNumber: Maybe<Scalars['BigInt']>;
  pageSize: Maybe<Scalars['BigInt']>;
};

export type PlacementContentRequestPaginationInput = {
  orderBy?: InputMaybe<Array<InputMaybe<PlacementContentRequestPaginationOrderInput>>>;
  pageNumber?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
};

export type PlacementContentRequestPaginationOrder = {
  __typename?: 'PlacementContentRequestPaginationOrder';
  descending: Maybe<Scalars['Boolean']>;
  placementId: Maybe<Scalars['BigInt']>;
  placementRank: Maybe<Scalars['BigInt']>;
};

export type PlacementContentRequestPaginationOrderInput = {
  descending?: InputMaybe<Scalars['Boolean']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  placementRank?: InputMaybe<Scalars['BigInt']>;
};

export type PlacementContentResponsePagination = {
  __typename?: 'PlacementContentResponsePagination';
  hasNextPage: Maybe<Scalars['Boolean']>;
  requestPagination: Maybe<PlacementContentRequestPagination>;
};

export type PlacementContentSurfaceInput = {
  surfaceIdentifier?: InputMaybe<Scalars['String']>;
  surfaceType?: InputMaybe<Scalars['String']>;
};

export type PlacementContext = {
  __typename?: 'PlacementContext';
  searchMetadata: Maybe<SearchPlacementMetadata>;
};

export type PlacementContextInput = {
  searchMetadata?: InputMaybe<SearchPlacementMetadataInput>;
};

export type PlacementDestinationInput = {
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String'];
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum;
};

export enum PlacementDestinationTypeEnum {
  /** The placement links to a collection */
  Collection = 'COLLECTION',
  /** The placement links to a collection hub */
  CollectionHub = 'COLLECTION_HUB',
  /** The placement links to containers via a store selector */
  ContainerPathViaStoreSelector = 'CONTAINER_PATH_VIA_STORE_SELECTOR',
  /** The placement links to a department */
  Department = 'DEPARTMENT',
  /** The placement does not have an action */
  DoNotNavigate = 'DO_NOT_NAVIGATE',
  /** The placement links to an external url */
  External = 'EXTERNAL',
  /** The placement links to the pickup store selector */
  PickupStoreselector = 'PICKUP_STORESELECTOR',
  /** The placement links to a product */
  Product = 'PRODUCT',
  /** The placement links to the SSA store selector */
  SsaStoreselector = 'SSA_STORESELECTOR',
  /** The placement links to a storefront */
  Storefront = 'STOREFRONT',
  /** The placement links to a store selector */
  StoreSelector = 'STORE_SELECTOR',
  /** Unfamiliar Banner Action */
  Unknown = 'UNKNOWN'
}

export type PlacementExperimentInput = {
  /** Experiment Assignment or Lookup */
  accessMethod?: InputMaybe<PlacementExperimentMethodEnum>;
  /** Name of the Experiment */
  name: Scalars['String'];
  /** Variant of the Experiment for which placement should be visible */
  variant: Scalars['String'];
};

export enum PlacementExperimentMethodEnum {
  /** Whether variant assignment should happen */
  Assign = 'ASSIGN',
  /** Not specified */
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  /** Whether a variant lookup should occur */
  Lookup = 'LOOKUP',
  /** Whether a variant preview should occur */
  Preview = 'PREVIEW'
}

export type PlacementFilterInput = {
  /** The locale of the placement (Eg. en_US) */
  locale?: InputMaybe<Scalars['String']>;
  /** The platform(s) the placement is configured for (Eg. [MOBILE, WEB]) */
  platform?: InputMaybe<Array<PlacementPlatformEnum>>;
  /** A term to use to search for a placement */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** The current status of the placement (Eg. ACTIVE) */
  status?: InputMaybe<PlacementStatusEnum>;
  /** The type of the placement (Eg. TEXT) */
  type?: InputMaybe<PlacementTypeEnum>;
};

export type PlacementImagesInput = {
  /** The image url of the placement to display for large viewports */
  large: Scalars['Url'];
  /** The image url of the placement to display for small viewports */
  small: Scalars['Url'];
};

export type PlacementInput = {
  banner?: InputMaybe<BannerTypeInput>;
  banners?: InputMaybe<Array<InputMaybe<BannerTypeInput>>>;
  cardList?: InputMaybe<CardListInput>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  experimentMethod?: InputMaybe<ExperimentMethod>;
  experimentName?: InputMaybe<Scalars['String']>;
  experimentVariant?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  includedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  internalName?: InputMaybe<Scalars['String']>;
  itemList?: InputMaybe<ItemListInput>;
  layout?: InputMaybe<Layout>;
  layoutVariantId?: InputMaybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior?: InputMaybe<Scalars['Boolean']>;
  placementContext?: InputMaybe<PlacementContextInput>;
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  rank?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Status>;
  stringLayout?: InputMaybe<Scalars['String']>;
  teamOwner?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOwner?: InputMaybe<Scalars['BigInt']>;
  widget?: InputMaybe<WidgetInput>;
};

export enum PlacementPlatformEnum {
  /** This placement should display on android */
  Android = 'ANDROID',
  /** This placement should display on ios */
  Ios = 'IOS',
  /** This placement should display on mobile */
  Mobile = 'MOBILE',
  /** This placement should display on web */
  Web = 'WEB'
}

export type PlacementScheduleInput = {
  /** When the placement should stop being active */
  endDate?: InputMaybe<Scalars['Time']>;
  /** When the placement should become active */
  startDate: Scalars['Time'];
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Scalars['String'];
};

export type PlacementSortInput = {
  /** The direction to sort */
  direction?: InputMaybe<PlacementSortInputDirectionEnum>;
  /** The field to sort on */
  field: PlacementSortInputFieldEnum;
};

export enum PlacementSortInputDirectionEnum {
  /** Sort the results in ascending order */
  Asc = 'ASC',
  /** Sort the results in descending order */
  Desc = 'DESC'
}

export enum PlacementSortInputFieldEnum {
  /** Sort the results based on the status of the placement */
  CreatedAt = 'CREATED_AT',
  /** Sort the results based on the status of the placement */
  Status = 'STATUS'
}

export enum PlacementStatusEnum {
  /** The placement is currently active */
  Active = 'ACTIVE',
  /** The placement is not currently active */
  Inactive = 'INACTIVE',
  /** The placement is currently the live banner */
  Live = 'LIVE'
}

export enum PlacementTypeEnum {
  /** This is ASYNC_IMAGE placement */
  AsyncImage = 'ASYNC_IMAGE',
  /** This is ASYNC_MODAL placement */
  AsyncModal = 'ASYNC_MODAL',
  /** This is CAROUSEL_CARD placement */
  CarouselCard = 'CAROUSEL_CARD',
  /** This is CATEGORY_HUB placement */
  CategoryHub = 'CATEGORY_HUB',
  /** This is HEADER placement */
  Header = 'HEADER',
  /** This placement displays a HeroBanner Home Announcement Banner */
  HeroBanner = 'HERO_BANNER',
  /** This placement displays an image */
  Image = 'IMAGE',
  /** This placement displays an ImageForward Home Announcement Banner */
  ImageForward = 'IMAGE_FORWARD',
  /** This placement displays a ImageForwardFlex Home Announcement Banner */
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  /** This is INFORMATION_MODAL placement */
  InformationModal = 'INFORMATION_MODAL',
  /** This is LARGE placement */
  Large = 'LARGE',
  /** This is LOGO_WITH_TEXT placement */
  LogoWithText = 'LOGO_WITH_TEXT',
  /** This is MEGA placement */
  Mega = 'MEGA',
  /** This is OCCASION_HUB placement */
  OccasionHub = 'OCCASION_HUB',
  /** This is RICH_TEXT placement */
  RichText = 'RICH_TEXT',
  /** This placement displays a SecondaryBanner Home Announcement Banner */
  SecondaryBanner = 'SECONDARY_BANNER',
  /** This is flyout placement */
  StandardInformationModal = 'STANDARD_INFORMATION_MODAL',
  /** This is SURVEY placement */
  Survey = 'SURVEY',
  /** This placement displays text */
  Text = 'TEXT',
  /** This is TEXT_SLIM placement */
  TextSlim = 'TEXT_SLIM',
  /** This placement displays a TextWithThumbnail Home Announcement Banner */
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  /** This placement displays a TextWithThumbnailFlex Home Announcement Banner */
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  /** This is TITLED_MEDIA placement */
  TitledMedia = 'TITLED_MEDIA',
  /** This placement displays an ImageForward Home Announcement Banner */
  Unknown = 'UNKNOWN'
}

export type PlacementsResponse = {
  __typename?: 'PlacementsResponse';
  placements: Maybe<Array<Maybe<Placement>>>;
};

export enum PlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type PostAuthPaths = {
  __typename?: 'PostAuthPaths';
  loginPath: Maybe<Scalars['String']>;
  signupPath: Maybe<Scalars['String']>;
};

export type PostAuthPathsInput = {
  loginPath?: InputMaybe<Scalars['String']>;
  signupPath?: InputMaybe<Scalars['String']>;
};

export type PotentialScanCodesByStrategy = {
  __typename?: 'PotentialScanCodesByStrategy';
  codes: Maybe<Array<Maybe<Scalars['String']>>>;
  strategy: Maybe<ScanCodeStrategy>;
  strategyName: Maybe<Scalars['String']>;
};

export type PrepareToSubmitAuditBatchRequestInput = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  batchMetadata?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  correctnessThresholdPct?: InputMaybe<Scalars['Float']>;
  dataType?: InputMaybe<Scalars['String']>;
  dataValue?: InputMaybe<Scalars['String']>;
  maxBatchSize?: InputMaybe<Scalars['BigInt']>;
  maxNumOfBatches?: InputMaybe<Scalars['BigInt']>;
  overrideDueDate?: InputMaybe<Scalars['DateTime']>;
  owner?: InputMaybe<Scalars['String']>;
  reviewers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showPreview?: InputMaybe<Scalars['Boolean']>;
  taskReviewPct?: InputMaybe<Scalars['Float']>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type PrepareToSubmitAuditBatchResponse = {
  __typename?: 'PrepareToSubmitAuditBatchResponse';
  previewTasks: Maybe<Array<Maybe<AuditTask>>>;
  status: Maybe<DemeterResponseStatus>;
  submissionUuid: Maybe<Scalars['String']>;
};

export type PricingSchema = {
  __typename?: 'PricingSchema';
  _: Maybe<Scalars['Boolean']>;
};

export type ProblemTrackerEntityStatus = {
  __typename?: 'ProblemTrackerEntityStatus';
  calculatedEntityId: Maybe<EntityId>;
  createdAt: Maybe<Scalars['DateTime']>;
  explanation: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  providedEntityId: Maybe<EntityId>;
  providedEntityType: Maybe<EntityType>;
  status: Maybe<EntityStatus>;
  ticketId: Maybe<Scalars['BigInt']>;
};

export type ProblemTrackerTicket = {
  __typename?: 'ProblemTrackerTicket';
  assignee: Maybe<User>;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdBy: Maybe<User>;
  description: Maybe<Scalars['String']>;
  entities: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  entityType: Maybe<EntityType>;
  fixTaskGroupUuid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  localeCode: Maybe<Scalars['String']>;
  problemType: Maybe<ProblemType>;
  reportedOnBehalfOf: Maybe<User>;
  retailerId: Maybe<Scalars['BigInt']>;
  severity: Maybe<Scalars['BigInt']>;
  sourceAppName: Maybe<Scalars['String']>;
  status: Maybe<TicketStatus>;
  summaryStatus: Maybe<Array<Maybe<SummaryStatus>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ProblemTrackerTicketComment = {
  __typename?: 'ProblemTrackerTicketComment';
  comment: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdBy: Maybe<User>;
  id: Maybe<Scalars['BigInt']>;
};

export enum ProblemType {
  ProblemTypeOther = 'PROBLEM_TYPE_OTHER',
  ProblemTypeProductAlcohol = 'PROBLEM_TYPE_PRODUCT_ALCOHOL',
  ProblemTypeProductAvailability = 'PROBLEM_TYPE_PRODUCT_AVAILABILITY',
  ProblemTypeProductBrand = 'PROBLEM_TYPE_PRODUCT_BRAND',
  ProblemTypeProductCharacteristics = 'PROBLEM_TYPE_PRODUCT_CHARACTERISTICS',
  ProblemTypeProductClassification = 'PROBLEM_TYPE_PRODUCT_CLASSIFICATION',
  ProblemTypeProductDetails = 'PROBLEM_TYPE_PRODUCT_DETAILS',
  ProblemTypeProductIdentity = 'PROBLEM_TYPE_PRODUCT_IDENTITY',
  ProblemTypeProductImage = 'PROBLEM_TYPE_PRODUCT_IMAGE',
  ProblemTypeProductSize = 'PROBLEM_TYPE_PRODUCT_SIZE',
  ProblemTypeProductTaxonomy = 'PROBLEM_TYPE_PRODUCT_TAXONOMY',
  ProblemTypeUnknown = 'PROBLEM_TYPE_UNKNOWN'
}

export type Product = {
  __typename?: 'Product';
  displayName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  primaryImageUrl: Maybe<Scalars['String']>;
};

export type ProductAnalyticSummaryRequestInput = {
  dateRange?: InputMaybe<InstacartAdsSharedV1DateRangeInput>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductAnalyticsSummary = {
  __typename?: 'ProductAnalyticsSummary';
  avgOrdersPerStore: Maybe<Scalars['Float']>;
  avgSalesPerStoreUsd: Maybe<Scalars['Float']>;
  avgStoreCount: Maybe<Scalars['Float']>;
  productId: Maybe<Scalars['BigInt']>;
  totalOrders: Maybe<Scalars['BigInt']>;
  totalSalesUsd: Maybe<Scalars['Float']>;
  totalStores: Maybe<Scalars['BigInt']>;
};

export type ProductAnalyticsSummaryGrowthMetrics = {
  __typename?: 'ProductAnalyticsSummaryGrowthMetrics';
  avgOrdersPerStoreGrowth: Maybe<Scalars['Float']>;
  avgSalesPerStoreUsdGrowth: Maybe<Scalars['Float']>;
  productId: Maybe<Scalars['BigInt']>;
  totalOrdersGrowth: Maybe<Scalars['Float']>;
  totalSalesUsdGrowth: Maybe<Scalars['Float']>;
  totalStoresGrowth: Maybe<Scalars['Float']>;
};

export type ProductAnalyticsSummaryResponse = {
  __typename?: 'ProductAnalyticsSummaryResponse';
  analyticsSummary: Maybe<ProductAnalyticsSummary>;
  growthMetrics: Maybe<ProductAnalyticsSummaryGrowthMetrics>;
  previousPeriodMetrics: Maybe<ProductAnalyticsSummary>;
};

export type ProductAttributes = {
  __typename?: 'ProductAttributes';
  avgUnitPrice: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  legalFilterType: Maybe<LegalFilterType>;
  name: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  unitCount: Maybe<Scalars['String']>;
  upc: Maybe<Scalars['String']>;
};

export type ProductAttributesRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductAttributesResponse = {
  __typename?: 'ProductAttributesResponse';
  productAttributes: Maybe<ProductAttributes>;
};

export type ProductBrandProfileAttributesRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductBrandProfileAttributesResponse = {
  __typename?: 'ProductBrandProfileAttributesResponse';
  brandProfileAttributes: Maybe<BrandProfileAttributes>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  l1Category: Maybe<Scalars['String']>;
  l1CategoryId: Maybe<Scalars['BigInt']>;
  l2Category: Maybe<Scalars['String']>;
  l2CategoryId: Maybe<Scalars['BigInt']>;
  l3Category: Maybe<Scalars['String']>;
  l3CategoryId: Maybe<Scalars['BigInt']>;
  l4Category: Maybe<Scalars['String']>;
  l4CategoryId: Maybe<Scalars['BigInt']>;
  l5Category: Maybe<Scalars['String']>;
  l5CategoryId: Maybe<Scalars['BigInt']>;
  l6Category: Maybe<Scalars['String']>;
  l6CategoryId: Maybe<Scalars['BigInt']>;
  productCategory: Maybe<Scalars['String']>;
  productCategoryId: Maybe<Scalars['BigInt']>;
};

export type ProductCategoryTaxonomy = {
  __typename?: 'ProductCategoryTaxonomy';
  l1: Maybe<Scalars['String']>;
  l2: Maybe<Scalars['String']>;
  l3: Maybe<Scalars['String']>;
  l4: Maybe<Scalars['String']>;
  l5: Maybe<Scalars['String']>;
  l6: Maybe<Scalars['String']>;
};

export type ProductData = {
  __typename?: 'ProductData';
  attributeData: Maybe<Array<Maybe<AttributeData>>>;
  localeId: Maybe<Scalars['String']>;
};

export type ProductDisplay = {
  __typename?: 'ProductDisplay';
  imageAsset: Maybe<ImageAsset>;
  productId: Maybe<Scalars['BigInt']>;
};

export type ProductId = {
  __typename?: 'ProductId';
  locale: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
};

export type ProductIdInput = {
  locale?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductSellSheetCardsRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductSellSheetCardsResponse = {
  __typename?: 'ProductSellSheetCardsResponse';
  sellSheetCards: Maybe<Array<Maybe<SellSheetCard>>>;
};

export type ProductSource = {
  __typename?: 'ProductSource';
  defaultPriority: Maybe<Scalars['BigInt']>;
  description: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  sourceLevel: Maybe<SourceLevel>;
};

export type ProductSummaryMetrics = {
  __typename?: 'ProductSummaryMetrics';
  avgSalesPerStoreUsd: Maybe<Scalars['Float']>;
  dateRange: Maybe<InstacartAdsSharedV1DateRange>;
  storeCount: Maybe<Scalars['BigInt']>;
  totalSalesUsd: Maybe<Scalars['Float']>;
};

export type ProductSummaryTraits = {
  __typename?: 'ProductSummaryTraits';
  isCarriedByRetailer: Maybe<Scalars['Boolean']>;
  productAttributes: Maybe<ProductAttributes>;
  productSummaryMetrics: Maybe<ProductSummaryMetrics>;
};

export type PropertyInput = {
  /** The property name */
  name: Scalars['String'];
  /** The property value */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ProposedReturnInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  returnItems?: InputMaybe<Array<InputMaybe<ReturnItemInput>>>;
  returnStatus?: InputMaybe<ProposedReturnStatus>;
  returnType?: InputMaybe<ProposedReturnType>;
};

export enum ProposedReturnStatus {
  Accepted = 'Accepted',
  Canceled = 'Canceled',
  Expired = 'Expired',
  Pending = 'Pending',
  ProposedReturnStatusUnspecified = 'ProposedReturnStatusUnspecified',
  Refunded = 'Refunded'
}

export enum ProposedReturnType {
  Manual = 'Manual',
  ProposedReturnTypeUnspecified = 'ProposedReturnTypeUnspecified',
  RetailerIntegration = 'RetailerIntegration'
}

export type PublicRetailer = {
  __typename?: 'PublicRetailer';
  /** Country associated with this retailer */
  country: Country;
  /** A unique identifier for the retailer */
  id: Scalars['ID'];
  /** The name of the retailer */
  name: Scalars['String'];
};

/** Input parameters for publishing an approval request */
export type PublishApprovalRequestInput = {
  /** The unique ID of the Approval Request to publish. */
  approvalRequestId: Scalars['ID'];
  /** Flag to indicate if the publish action should proceed despite normal restrictions. */
  isBreakGlass?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of PublishApprovalRequest */
export type PublishApprovalRequestPayload = {
  __typename?: 'PublishApprovalRequestPayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

export type PublishRppConfigurableItemsRequestInput = {
  configurableProducts?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type PublishRppConfigurableItemsResponse = {
  __typename?: 'PublishRppConfigurableItemsResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type PublishStoreConfigurationDraftRequestInput = {
  draftId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type PublishStoreConfigurationDraftResponse = {
  __typename?: 'PublishStoreConfigurationDraftResponse';
  errorMessage: Maybe<Scalars['String']>;
  errorReason: Maybe<ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type QasTaskItem = {
  __typename?: 'QasTaskItem';
  itemType: Maybe<Scalars['String']>;
  itemValue: Maybe<Scalars['String']>;
};

/** Aggregated quality scorecard metrics per tool */
export type QualityScorecardsAggScorecard = {
  __typename?: 'QualityScorecardsAggScorecard';
  /** Average user rating score for the tool */
  averageRatingScore: Maybe<Scalars['Float']>;
  /** Human-readable IPP Tool name */
  ippToolName: Maybe<Scalars['String']>;
  /** IPP Totem Entity identifier */
  ippTotemEntity: Maybe<Scalars['String']>;
  /** Total number of views in the period */
  monthlyViews: Maybe<Scalars['Int']>;
  /** P90 page loading time in seconds */
  p90LoadingTime: Maybe<Scalars['Float']>;
  /** Team responsible for the tool */
  team: Maybe<Scalars['String']>;
  /** Percentage of views that had errors */
  viewsWithErrorsPercentage: Maybe<Scalars['Float']>;
};

/** Response containing aggregated Quality Scorecard metrics */
export type QualityScorecardsAggScorecardsResponse = {
  __typename?: 'QualityScorecardsAggScorecardsResponse';
  /** List of aggregated scorecards */
  scorecards: Array<QualityScorecardsAggScorecard>;
  /** Total number of scorecards returned */
  totalCount: Scalars['Int'];
};

/** Aggregated platform-wide statistics from RUM data */
export type QualityScorecardsPlatformStats = {
  __typename?: 'QualityScorecardsPlatformStats';
  /** End of the date range queried */
  endDate: Scalars['ISO8601Date'];
  /** Total number of views in the date range */
  monthlyViews: Maybe<Scalars['Int']>;
  /** P90 page loading time in seconds across all views */
  p90LoadingTime: Maybe<Scalars['Float']>;
  /** Percentage of sessions that had errors */
  sessionsWithErrorsPercentage: Maybe<Scalars['Float']>;
  /** Start of the date range queried */
  startDate: Scalars['ISO8601Date'];
};

export type Query = {
  __typename?: 'Query';
  /** Lists ban entries with optional filtering and pagination */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_ListBanEntries: Maybe<Instacart_Caper_Admin_V1_ListBanEntriesResponse>;
  /** Lists ban entries with optional filtering and pagination */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_ListBanEntries: Maybe<Instacart_Caper_Admin_V1_ListBanEntriesResponse>;
  /** Returns all Caper entities (partner, retailer, store, device) and their configs */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_GetAllEntities: Maybe<Instacart_Caper_Admin_V1_GetAllEntitiesResponse>;
  /** Returns all available configuration keys and metadata about them */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_GetConfigKeys: Maybe<Instacart_Caper_Admin_V1_GetConfigKeysResponse>;
  /** Get all Features */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_GetFeatures: Maybe<Instacart_Caper_Admin_V1_GetFeaturesResponse>;
  /** Lists batch scheduled actions with filtering options */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ListBatchScheduledActions: Maybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsResponse>;
  /** Lists scheduled actions with filtering options */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ListScheduledActions: Maybe<Instacart_Caper_Admin_V1_ListScheduledActionsResponse>;
  /** Returns all Caper entities (partner, retailer, store, device) and their configs */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_GetAllEntities: Maybe<Instacart_Caper_Admin_V1_GetAllEntitiesResponse>;
  /** Returns all available configuration keys and metadata about them */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_GetConfigKeys: Maybe<Instacart_Caper_Admin_V1_GetConfigKeysResponse>;
  /** Get all Features */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_GetFeatures: Maybe<Instacart_Caper_Admin_V1_GetFeaturesResponse>;
  /** Lists batch scheduled actions with filtering options */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ListBatchScheduledActions: Maybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsResponse>;
  /** Lists scheduled actions with filtering options */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ListScheduledActions: Maybe<Instacart_Caper_Admin_V1_ListScheduledActionsResponse>;
  /**
   * Returns the current state of a single pipeline run, including the full
   * per-stage status list derived from stage_index and the known stage order.
   */
  CaperDeviceProvisioningPipelineService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_GetPipelineRun: Maybe<Instacart_Caper_Admin_V1_GetPipelineRunResponse>;
  /**
   * Returns a paginated list of pipeline runs, sorted by created_at descending.
   * All filter fields are optional.
   */
  CaperDeviceProvisioningPipelineService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_ListPipelineRuns: Maybe<Instacart_Caper_Admin_V1_ListPipelineRunsResponse>;
  /**
   * Returns the current state of a single pipeline run, including the full
   * per-stage status list derived from stage_index and the known stage order.
   */
  CaperDeviceProvisioningPipelineStagingService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_GetPipelineRun: Maybe<Instacart_Caper_Admin_V1_GetPipelineRunResponse>;
  /**
   * Returns a paginated list of pipeline runs, sorted by created_at descending.
   * All filter fields are optional.
   */
  CaperDeviceProvisioningPipelineStagingService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_ListPipelineRuns: Maybe<Instacart_Caper_Admin_V1_ListPipelineRunsResponse>;
  /** Returns holistic receipt identification information based on the receipt identifiers passed in the request */
  CaperIPPReceiptService_instacart_caper_admin_v1_IPPReceiptService_GetReceiptsMetadata: Maybe<Instacart_Caper_Admin_V1_GetReceiptsMetadataResponse>;
  /**
   * Retrieves entity information (partners/retailers/stores) with hierarchical relationships.
   * Supports querying by partner, retailer, or store IDs and returns related entities.
   */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_GetEntities: Maybe<Instacart_Caper_Admin_V1_GetEntitiesResponse>;
  /** Retrieves a specific NOF item by its ID */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_GetNof: Maybe<Instacart_Caper_Admin_V1_GetNofResponse>;
  /** Returns a paginated list of NOF items based on filter criteria */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_ListNofs: Maybe<Instacart_Caper_Admin_V1_ListNofsResponse>;
  /**
   * Retrieves entity information (partners/retailers/stores) with hierarchical relationships.
   * Supports querying by partner, retailer, or store IDs and returns related entities.
   */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_GetEntities: Maybe<Instacart_Caper_Admin_V1_GetEntitiesResponse>;
  /** Retrieves a specific NOF item by its ID */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_GetNof: Maybe<Instacart_Caper_Admin_V1_GetNofResponse>;
  /** Returns a paginated list of NOF items based on filter criteria */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_ListNofs: Maybe<Instacart_Caper_Admin_V1_ListNofsResponse>;
  /** Gets available payment profiles for merchant creation. */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_GetAvailableProfiles: Maybe<Instacart_Caper_Admin_V1_GetAvailableProfilesResponse>;
  /** Gets available payment profiles for merchant creation. */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_GetAvailableProfiles: Maybe<Instacart_Caper_Admin_V1_GetAvailableProfilesResponse>;
  /** Retrieves structured cart event data including basket and video audit events */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetCartData: Maybe<Instacart_Caper_Admin_V1_GetCartDataResponse>;
  /**
   * Retrieves async datadog triage summary by ID
   * Used to poll for the status and results of a datadog summary initiated by CreateDatadogSummaryAsync.
   * Returns the current processing status and the generated markdown summary when completed.
   * This allows clients to check if the summary generation has finished and retrieve the results.
   */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetDatadogSummaryByIdAsync: Maybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncResponse>;
  /**
   * Retrieves events, logs, and other detailed information about a Caper
   * session. To eventually be extended with summarization and other data
   */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionInfo: Maybe<Instacart_Caper_Admin_V1_GetSessionInfoResponse>;
  /** Retrieves session screenshots from GCS with signed URLs */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionScreenshots: Maybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsResponse>;
  /** Retrieves an LLM-derived summary of a session's events and logs */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummary: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryResponse>;
  /** Retrieves async session summary by ID */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummaryByIdAsync: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncResponse>;
  /** Retrieves structured cart event data including basket and video audit events */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetCartData: Maybe<Instacart_Caper_Admin_V1_GetCartDataResponse>;
  /**
   * Retrieves async datadog triage summary by ID
   * Used to poll for the status and results of a datadog summary initiated by CreateDatadogSummaryAsync.
   * Returns the current processing status and the generated markdown summary when completed.
   * This allows clients to check if the summary generation has finished and retrieve the results.
   */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetDatadogSummaryByIdAsync: Maybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncResponse>;
  /**
   * Retrieves events, logs, and other detailed information about a Caper
   * session. To eventually be extended with summarization and other data
   */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionInfo: Maybe<Instacart_Caper_Admin_V1_GetSessionInfoResponse>;
  /** Retrieves session screenshots from GCS with signed URLs */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionScreenshots: Maybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsResponse>;
  /** Retrieves an LLM-derived summary of a session's events and logs */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummary: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryResponse>;
  /** Retrieves async session summary by ID */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummaryByIdAsync: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_GetWorkflowResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultResponse>;
  /** --- Common APIs for checking job status and retrieving results (async) --- */
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_GetWorkflowStatus: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusResponse>;
  /** This field indicates that the EnterpriseStatusPage source is unavailable. */
  EnterpriseStatusPage__EnterpriseStatusPage_unavailable: Maybe<Scalars['String']>;
  /** Returns the status of Datadog monitors for a specific retailer */
  ExternalHealthDashboard_getMonitorStatuses: Maybe<Array<Maybe<ExternalHealthDashboard_GetMonitorStatuses_Response>>>;
  /** Returns the OpenAPI specification for this API in YAML format */
  ExternalHealthDashboard_getOpenApiSpec: Maybe<ExternalHealthDashboard_GetOpenApiSpec_Response>;
  /** Handles the OIDC authentication callback and redirects users */
  ExternalHealthDashboard_handleAuthCallback: Maybe<ExternalHealthDashboard_Error>;
  /** Returns the health status of the API */
  ExternalHealthDashboard_healthCheck: Maybe<ExternalHealthDashboard_HealthCheck>;
  /** Get a response configuration by ID */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_GetResponseConfig: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigResponse>;
  /** List response configurations with optional filters */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_ListResponseConfigs: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsResponse>;
  /** Get strings for a resource */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_GetStrings: Maybe<Instacart_Customers_Commerce_Garnish_V1_GetStringsResponse>;
  /** List resources */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_ListResources: Maybe<Instacart_Customers_Commerce_Garnish_V1_ListResourcesResponse>;
  /**
   * GetMarketingCampaign retrieves a marketing campaign by ID along with all its
   * associated entities (segment, VGP, roulette experiment, CRM configuration).
   * Returns partial results if some entity fetches fail.
   */
  MarketingToolingService_instacart_growth_marketing_tooling_v1_MarketingToolingService_GetMarketingCampaign: Maybe<Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignResponse>;
  /** Returns a single contact by email address */
  RetailerContactManagement_getContact: Maybe<RetailerContactManagement_GetContact_Response>;
  /** Returns array of contacts matching filters, sorted by priority */
  RetailerContactManagement_getContacts: Maybe<Array<Maybe<RetailerContactManagement_GetContacts_Response>>>;
  /** Returns the OpenAPI specification for this API in YAML format */
  RetailerContactManagement_getOpenApiSpec: Maybe<RetailerContactManagement_GetOpenApiSpec_Response>;
  /** Returns the health status of the API. Available at both /health and /api/v1/health */
  RetailerContactManagement_healthCheck: Maybe<RetailerContactManagement_HealthCheck>;
  _empty: Maybe<Scalars['String']>;
  _noop: Maybe<Scalars['String']>;
  /** The access control details for the account */
  accessControlConfiguration: AccessControlConfiguration;
  /** Check if account request for given email already exists */
  accountRequestPreviousRequestExistByEmail: AccountRequestPreviousRequestExists;
  /** Search for retailers matching a set of criteria - without an account */
  accountRequestRetailerSearch: Array<PublicRetailer>;
  /** Search for an previously created Account Request by ID */
  accountRequestSearchById: AccountRequestAccountRequest;
  /** Check if an account token (reset password or verify email) is valid */
  accountTokenValidate: TokensValidation;
  aiAgentAvailable: Maybe<Scalars['Boolean']>;
  anomalyDetectionSummary: Array<AnomalyDetectionEntry>;
  apiIntegrationsServiceGetApiSettings: Maybe<GetApiSettingsResponse>;
  apiIntegrationsServiceGetAuthenticationUrl: Maybe<GetAuthenticationUrlResponse>;
  apiIntegrationsServiceGetAvailableStoreLocations: Maybe<GetAvailableStoreLocationsResponse>;
  /** Retrieves a specific approval request by its ID. */
  approvalsManagementGetRequest: Maybe<ApprovalsManagementTypesApprovalRequest>;
  /** Retrieves a list of content snapshots by their IDs. */
  approvalsManagementGetSnapshots: Array<ApprovalsManagementTypesContentSnapshot>;
  /** Retrieves permitted actions for a user on a set of approval requests. */
  approvalsManagementGetUserPermittedActions: Array<ApprovalsManagementTypesUserPermittedActions>;
  /** Retrieves a list of approval requests. */
  approvalsManagementListRequests: ApprovalsManagementTypesListApprovalRequestsResult;
  assignmentsGetOrderFulfillmentOverview: Maybe<GetOrderFulfillmentOverviewResponse>;
  /** Search for Audit Logs */
  auditLogSearch: AuditLogsAuditLogConnection;
  availabilityGetStoreHoursByDate: Maybe<GetStoreHoursByDateResponse>;
  availabilityGetStoreHoursByDayOfWeek: Maybe<GetStoreHoursByDayOfWeekResponse>;
  availabilityGetStoreHoursByZoneRetailer: Maybe<GetStoreHoursByZoneRetailerResponse>;
  /** Fetch a specific aisle by id */
  catalogAisle: CatalogAisle;
  /** Fetch a specific department by id */
  catalogDepartment: CatalogDepartment;
  catalogProblemTrackerServiceGetTicket: Maybe<GetTicketResponse>;
  catalogProblemTrackerServiceListTickets: Maybe<ListTicketsResponse>;
  /** Retrieve products by IDs */
  catalogProducts: Array<CatalogProduct>;
  /** Retrieve a retailer-product by its ID */
  catalogRetailerProduct: CatalogRetailerProduct;
  /** Search for retailer-products matching a set of criteria */
  catalogRetailerProductSearch: CatalogRetailerProductConnection;
  /** Fetch a signed url for an S3 report */
  catalogSearchDownloadSignedUrl: CatalogSearchDownloadsCatalogSearchDownloadSignedUrl;
  catalogToolsApiServiceDownloadCatalogSearchResults: Maybe<DownloadCatalogSearchResultsResponse>;
  catalogToolsApiServiceGetAnomalousItemsList: Maybe<GetAnomalousItemsListResponse>;
  catalogToolsApiServiceGetAnomalousItemsReport: Maybe<GetAnomalousItemsReportResponse>;
  catalogToolsApiServiceGetLocalesByRetailer: Maybe<GetLocalesByRetailerResponse>;
  catalogToolsApiServiceGetPriceInvestigation: Maybe<GetPriceInvestigationResponse>;
  catalogToolsApiServiceGetRetailerProductAttributeSources: Maybe<GetRetailerProductAttributeSourcesResponse>;
  catalogToolsApiServiceGetRetailerProductData: Maybe<GetRetailerProductDataResponse>;
  catalogToolsApiServiceListPriceInvestigations: Maybe<ListPriceInvestigationsResponse>;
  collectionsServiceGetCollections: Maybe<GetCollectionsResponse>;
  commerceInvoicingServiceGetOrderDiscountDetails: Maybe<GetOrderDiscountDetailsResponse>;
  configurableItemsServiceGetRppConfigurableItems: Maybe<GetRppConfigurableItemsResponse>;
  connectPlatformServiceGetConnectPlatformEventsByDomain: Maybe<GetConnectPlatformEventsByDomainResponse>;
  connectPlatformServiceGetConnectSettings: Maybe<GetConnectSettingsResponse>;
  connectPlatformServiceGetPartnerApiKeys: Maybe<GetPartnerApiKeysResponse>;
  connectPlatformServiceGetPartnerId: Maybe<GetPartnerIdResponse>;
  connectPlatformServiceGetRequestContexts: Maybe<GetRequestContextsResponse>;
  contentManagementAdminServiceGetAdminNavigationV2: Maybe<GetAdminNavigationV2Response>;
  contentManagementAdminServiceGetNativeTabBarNavigation: Maybe<GetNativeTabBarNavigationResponse>;
  contentManagementAdminServiceGetNavigation: Maybe<GetNavigationResponse>;
  contentManagementAdminServiceGetPlacementContentById: Maybe<GetPlacementContentByIdResponse>;
  contentManagementAdminServiceGetRetailersForShortcuts: Maybe<GetRetailersForShortcutsResponse>;
  contentManagementAdminServiceGetSlotById: Maybe<GetSlotByIdResponse>;
  contentManagementAdminServiceGetSlots: Maybe<GetSlotsResponse>;
  contentManagementAdminServiceGetSlotsByContentPages: Maybe<GetSlotsByContentPagesResponse>;
  contentManagementAdminServiceGetSocialIconsNavigation: Maybe<GetSocialIconsNavigationResponse>;
  contentManagementAdminServiceGetToolingShortcuts: Maybe<GetToolingShortcutsResponse>;
  contentManagementAdminServiceListContentPageVersionMetas: Maybe<ListContentPageVersionMetasResponse>;
  contentManagementAdminServiceListContentPageVersions: Maybe<ListContentPageVersionsResponse>;
  contentManagementAdminServiceListContentPagesV2: Maybe<ListContentPagesResponseV2>;
  contentManagementAdminServiceListPlacementContent: Maybe<ListPlacementContentResponse>;
  contentManagementServiceGetLayoutVariants: Maybe<GetLayoutVariantsResponse>;
  contentManagementServiceGetPlacements: Maybe<PlacementsResponse>;
  contentManagementServiceGetThemePage: Maybe<GetThemePageResponse>;
  contentManagementServiceListThemePages: Maybe<ListThemePagesResponse>;
  /** The currently authenticated account */
  currentEnterpriseAccount: EnterpriseAccount;
  /** Check if user has access to the given arguments */
  currentEnterpriseAccountAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck;
  customersOrdersServiceGetHandlingDetails: Maybe<CustomersGetHandlingDetailsResponse>;
  customersOrdersServiceGetOrder: Maybe<CustomersGetOrderResponse>;
  customersOrdersServiceGetOrderAmountsSummaryV0: Maybe<CustomersGetOrderAmountsSummaryV0Response>;
  customersOrdersServiceGetPaymentMethodSummary: Maybe<CustomersGetPaymentMethodSummaryResponse>;
  customersOrdersServiceListOrders: Maybe<CustomersListOrdersResponse>;
  customersOrdersServiceQueryOrderReference: Maybe<CustomersQueryOrderReferenceResponse>;
  customersOrdersServiceQueryOrders: Maybe<CustomersQueryOrdersResponse>;
  demeterServiceGetAuditBatch: Maybe<GetAuditBatchResponse>;
  demeterServiceGetAuditBatchMetadata: Maybe<GetAuditBatchMetadataResponse>;
  demeterServiceGetAuditTask: Maybe<GetAuditTaskResponse>;
  demeterServiceGetAuditWorkflowConfigs: Maybe<GetAuditWorkflowConfigsResponse>;
  demeterServiceGetDetection: Maybe<GetDetectionResponse>;
  demeterServiceGetNextAuditBatch: Maybe<GetNextAuditBatchResponse>;
  demeterServiceListAuditBatches: Maybe<ListAuditBatchesResponse>;
  demeterServiceListAuditTaskComponents: Maybe<ListAuditTaskComponentsResponse>;
  demeterServiceListAuditWorkflows: Maybe<ListAuditWorkflowsResponse>;
  demeterServiceListDetections: Maybe<ListDetectionsResponse>;
  demeterServicePrepareToSubmitAuditBatch: Maybe<PrepareToSubmitAuditBatchResponse>;
  emergingBrandPortalServiceGetBrandProfileAttributes: Maybe<BrandProfileAttributesResponse>;
  emergingBrandPortalServiceGetBrandProfileSellSheetCards: Maybe<BrandProfileSellSheetCardsResponse>;
  emergingBrandPortalServiceGetBrandSellSheetsAttributes: Maybe<BrandSellSheetsAttributesResponse>;
  emergingBrandPortalServiceGetEBPAnalytics: Maybe<EbpAnalyticsResponse>;
  emergingBrandPortalServiceGetEBPProductAnalyticsSummary: Maybe<ProductAnalyticsSummaryResponse>;
  emergingBrandPortalServiceGetEBPProductAttributes: Maybe<ProductAttributesResponse>;
  emergingBrandPortalServiceGetIndexBrandNames: Maybe<IndexBrandNamesResponse>;
  emergingBrandPortalServiceGetIndexEBPCategories: Maybe<IndexEbpCategoriesResponse>;
  emergingBrandPortalServiceGetIndexSellSheetCards: Maybe<SellSheetCardsResponse>;
  emergingBrandPortalServiceGetProductBrandProfileAttributes: Maybe<ProductBrandProfileAttributesResponse>;
  emergingBrandPortalServiceGetProductSellSheetCards: Maybe<ProductSellSheetCardsResponse>;
  emergingBrandPortalServiceGetSellSheetAnalyticsSummary: Maybe<SellSheetAnalyticsSummaryResponse>;
  emergingBrandPortalServiceGetSellSheetAttributes: Maybe<SellSheetAttributesResponse>;
  emergingBrandPortalServiceGetSellSheetBrandProfileAttributes: Maybe<SellSheetBrandProfileAttributesResponse>;
  emergingBrandPortalServiceGetSellSheetProductsAttributes: Maybe<SellSheetProductsAttributesResponse>;
  emergingBrandPortalServiceGetSellSheetProductsSummaryTraits: Maybe<SellSheetProductsSummaryTraitsResponse>;
  /** Fetch an EnterpriseAccount by its canonical id */
  enterpriseAccount: EnterpriseAccount;
  /** Search for EnterpriseAccounts matching a set of criteria */
  enterpriseAccountSearch: EnterpriseAccountConnection;
  /** Check whether a given feature flag is fully/publicly enabled. */
  featureToggleFullyEnabled: FeatureTogglesEnabledCheck;
  /** Check the health of the server */
  healthCheck: HealthCheck;
  historicalStorePerformanceServiceGetAggregatedHistoricalStorePerformance: Maybe<HistoricalStorePerformanceResponse>;
  /** Fetch a list of Marketplace Home placements */
  homePlacementSearch: Array<HomePlacement>;
  /** Check if user has access to the given arguments */
  insightsPortalAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck;
  /**
   * READ (Batch)
   *
   * Returns the set of segments matching the given context. Useful for
   * finding, e.g., all targeting segments in use by a particular retailer.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_GetAllSegmentDefinitions: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentStates>;
  /**
   * READ
   *
   * The response will have the same version number as the request (or the
   * greatest available if none was specified; see below) and the definition
   * associated with that version.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_GetSegmentDefinition: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  /**
   * READ
   *
   * The response will have the same version number as the request (or the
   * greatest available if none was specified; see below) and the audience size of the segment
   * associated with that version.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_GetSegmentSize: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentSize>;
  instacart_ads_v3_EmergingBrandPortalService_GetIndexBrandNames: Maybe<Instacart_Ads_V3_IndexBrandNamesResponse>;
  instacart_ads_v3_EmergingBrandPortalService_GetProductAdditionalInfo: Maybe<Instacart_Ads_V3_ProductAdditionalInfoResponse>;
  instacart_ads_v3_RetailerBlockedAdsService_GetRetailerBlockedAdIds: Maybe<Instacart_Ads_V3_GetRetailerBlockedAdIdsResponse>;
  instacart_ads_v3_RetailerReviewToolService_GetDisplayPreviewData: Maybe<Instacart_Ads_V3_GetDisplayPreviewDataResponse>;
  /** Finds existing carousels that are similar to the provided carousel configuration. */
  instacart_algorithms_ai_carousel_creator_v1_AiCarouselCreatorService_GetSimilarCarousels: Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsResponse>;
  /** Express endpoints */
  instacart_care_tools_v1_CareToolsService_GetActiveBenefits: Maybe<Instacart_Care_Tools_V1_GetActiveBenefitsResponse>;
  instacart_care_tools_v1_CareToolsService_GetCommonIdentityUsers: Maybe<Instacart_Care_Tools_V1_GetCommonIdentityUsersResponse>;
  /** Spending endpoints */
  instacart_care_tools_v1_CareToolsService_GetCustomerSpendingSummary: Maybe<Instacart_Care_Tools_V1_GetCustomerSpendingSummaryResponse>;
  instacart_care_tools_v1_CareToolsService_GetHouseholdByUser: Maybe<Instacart_Care_Tools_V1_GetHouseholdByUserResponse>;
  /** User endpoints */
  instacart_care_tools_v1_CareToolsService_GetInstacartPlusMembership: Maybe<Instacart_Care_Tools_V1_GetInstacartPlusMembershipResponse>;
  instacart_care_tools_v1_CareToolsService_GetLatestActiveAttributeForUser: Maybe<Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserResponse>;
  instacart_care_tools_v1_CareToolsService_GetLinkedUserAccounts: Maybe<Instacart_Care_Tools_V1_GetLinkedUserAccountsResponse>;
  /** Returns detailed fields for an order. */
  instacart_care_tools_v1_CareToolsService_GetOrder: Maybe<Instacart_Care_Tools_V1_GetOrderResponse>;
  instacart_care_tools_v1_CareToolsService_GetUser: Maybe<Instacart_Care_Tools_V1_GetUserResponse>;
  instacart_care_tools_v1_CareToolsService_ListAddressesForUser: Maybe<Instacart_Care_Tools_V1_ListAddressesForUserResponse>;
  instacart_care_tools_v1_CareToolsService_ListNotesForUser: Maybe<Instacart_Care_Tools_V1_ListNotesForUserResponse>;
  instacart_care_tools_v1_CareToolsService_ListOrderChatMessagesAndNotes: Maybe<Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesResponse>;
  /**
   * Order endpoints
   * Returns summarized fields for orders, best used for table/list views.
   */
  instacart_care_tools_v1_CareToolsService_ListOrdersByCustomer: Maybe<Instacart_Care_Tools_V1_ListOrdersByCustomerResponse>;
  /** Returns restaurant orders for a customer. */
  instacart_care_tools_v1_CareToolsService_ListRestaurantOrdersByCustomer: Maybe<Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerResponse>;
  /** The GetAuditReview API returns an audit review */
  instacart_cashflow_nutella_v1_NutellaService_GetAuditReview: Maybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewResponse>;
  /** The GetAuditReviewsWithFeedback API returns audit reviews and pagination info */
  instacart_cashflow_nutella_v1_NutellaService_GetAuditReviewsWithFeedback: Maybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackResponse>;
  /** The GetNextAuditReview API returns the current audit review assigned to a user or returns the next unassigned audit review */
  instacart_cashflow_nutella_v1_NutellaService_GetNextAuditReview: Maybe<Instacart_Cashflow_Nutella_V1_GetNextAuditReviewResponse>;
  /** The GetWorkflowMetadata API returns metadata for a workflow */
  instacart_cashflow_nutella_v1_NutellaService_GetWorkflowMetadata: Maybe<Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataResponse>;
  /** GetL2Categories retrieves all l2 categories from the list of forcemark retailer reports based on the list of provided retailer IDs. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetL2Categories: Maybe<Instacart_Catalog_Admin_V1_GetL2CategoriesResponse>;
  /** GetMissingCodesForcemarkDetails retrieves missing codes forcemark details for a specific forcemark. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetMissingCodesForcemarkDetails: Maybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsResponse>;
  /** GetMissingCodesForcemarks retrieves missing codes forcemarks for a specific retailer. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetMissingCodesForcemarks: Maybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksResponse>;
  /** GetMissingCodesReviewedForcemarks retrieves reviewed missing codes forcemarks for a specific retailer. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetMissingCodesReviewedForcemarks: Maybe<Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksResponse>;
  /** GetMlPriceAnomalyProductDetails retrieves item-level details for a specific product flagged by the ML price anomaly model */
  instacart_catalog_admin_v1_MlPriceAnomalyService_GetMlPriceAnomalyProductDetails: Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse>;
  /** GetMlPriceAnomalyProducts retrieves a paginated list of products flagged by the ML price anomaly model */
  instacart_catalog_admin_v1_MlPriceAnomalyService_GetMlPriceAnomalyProducts: Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse>;
  /** GetPriceAlertProductDetails gets details on product that triggered a price alert */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetPriceAlertProductDetails: Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse>;
  /** GetPriceAlertProducts gets list of products that triggered price alert */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetPriceAlertProducts: Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse>;
  /** GetPriceAlertProductsCategories gets list of categories for use by the FE category filter */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetPriceAlertProductsCategories: Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse>;
  /** GetRetailerDiscountInitialThresholds retrieves global thresholds by partner_id or retailer_id */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetRetailerDiscountInitialThresholds: Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse>;
  /** GetRetailerDiscountThresholds retrieves all retailer discount thresholds from the DB */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetRetailerDiscountThresholds: Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse>;
  /** Search for a taxonomy node */
  instacart_catalog_admin_v1_TaxonomyService_SearchTaxonomyNodes: Maybe<Instacart_Catalog_Admin_V1_SearchTaxonomyNodesResponse>;
  /** List temporary overrides for a set of retailer products or items. */
  instacart_catalog_admin_v1_TempOverrideService_List: Maybe<Instacart_Catalog_Admin_V1_TempOverrideServiceListResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_DescribeSnowflakeTable: Maybe<Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetPresignedUploadUrl: Maybe<Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetStepRunResults: Maybe<Instacart_Catalog_Catflow_V1_GetStepRunResultsResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetStepVersion: Maybe<Instacart_Catalog_Catflow_V1_GetStepVersionResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetStepVersionHistory: Maybe<Instacart_Catalog_Catflow_V1_GetStepVersionHistoryResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_ListStepRuns: Maybe<Instacart_Catalog_Catflow_V1_ListStepRunsResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_ListStepVersions: Maybe<Instacart_Catalog_Catflow_V1_ListStepVersionsResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_ListSteps: Maybe<Instacart_Catalog_Catflow_V1_ListStepsResponse>;
  /** Retrieves batch information without event history */
  instacart_catalog_data_bridge_v1_DataBridgeService_GetBatch: Maybe<Instacart_Catalog_Data_Bridge_V1_GetBatchResponse>;
  /** Retrieves batch status with event history */
  instacart_catalog_data_bridge_v1_DataBridgeService_GetBatchStatus: Maybe<Instacart_Catalog_Data_Bridge_V1_GetBatchStatusResponse>;
  /** Retrieves a bridge by its name */
  instacart_catalog_data_bridge_v1_DataBridgeService_GetBridge: Maybe<Instacart_Catalog_Data_Bridge_V1_GetBridgeResponse>;
  /** Lists batches with optional filtering and pagination */
  instacart_catalog_data_bridge_v1_DataBridgeService_ListBatches: Maybe<Instacart_Catalog_Data_Bridge_V1_ListBatchesResponse>;
  /** Lists all bridges with optional filtering and pagination */
  instacart_catalog_data_bridge_v1_DataBridgeService_ListBridges: Maybe<Instacart_Catalog_Data_Bridge_V1_ListBridgesResponse>;
  /** GetProductCounts returns product count metrics from the catalog health data warehouse. */
  instacart_catalog_health_v1_CatalogHealthService_GetProductCounts: Maybe<Instacart_Catalog_Health_V1_GetProductCountsResponse>;
  /** Get tender transactions for a list of WHLs */
  instacart_checkout_v1_PosDataService_GetTenderTransactionsByWhlIds: Maybe<Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsResponse>;
  /** get basket product. */
  instacart_customers_basket_products_orchestrators_v1_BasketProductsOrchestratorsService_GetBasketProducts: Maybe<Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsReponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgram: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramContent: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramContentByProgramId: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramOffer: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramOffersByProgramId: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_ListBusinessProgram: Maybe<Instacart_Customers_Business_Admin_V1_ListBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_ListBusinesses: Maybe<Instacart_Customers_Business_Admin_V1_ListBusinessesResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetBucketDownloadUrl: Maybe<Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetBucketUploadUrl: Maybe<Instacart_Customers_Campaigns_V1_GetBucketUploadUrlResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetCsvFoundEntriesCount: Maybe<Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetCsvProcessingSummary: Maybe<Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetGroupedSlots: Maybe<Instacart_Customers_Campaigns_V1_GetGroupedSlotsResponse>;
  /** BEGIN Marketing AI Agent */
  instacart_customers_campaigns_v1_CampaignsService_GetMarketingAgentCampaign: Maybe<Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignResponse>;
  instacart_customers_campaigns_v1_CampaignsService_ListMarketingAgentCampaigns: Maybe<Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsResponse>;
  instacart_customers_campaigns_v1_CampaignsService_ValidateMarketingAgentSchedule: Maybe<Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleResponse>;
  instacart_customers_commerce_coupons_v1_CommerceCouponsService_GetRedemptionCodeExists: Maybe<Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsResponse>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_GetValueGrantPolicyFacade: Maybe<Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeResponse>;
  instacart_customers_coupons_v1_CouponsDomainService_GetCouponCodeExists: Maybe<Instacart_Customers_Coupons_V1_GetCouponCodeExistsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetCampaignLinks: Maybe<Instacart_Customers_Coupons_V1_GetCampaignLinksResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetMoment: Maybe<Instacart_Customers_Coupons_V1_GetMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetMomentParticipatingRetailers: Maybe<Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetMoments: Maybe<Instacart_Customers_Coupons_V1_GetMomentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetRetailerCampaign: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_ListMoments: Maybe<Instacart_Customers_Coupons_V1_ListMomentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_ListRetailerCampaignTreatments: Maybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_ListRetailerCampaigns: Maybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsResponse>;
  instacart_customers_express_v1_ExpressService_GetCurrentExpressMemberStatusForUser: Maybe<Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserResponse>;
  /** Gets a rule set */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSet: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetResponse>;
  /** Gets a rule set run (debug data) */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRun: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunResponse>;
  /** Get rule set run debug data */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRunDebug: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugResponse>;
  /** Get image by stub ref */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRunImage: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageResponse>;
  /** Get run status and details */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRunStatus: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusResponse>;
  /** List runs by status */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_ListRuleSetRunStatuses: Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse>;
  /** List rule set runs (debug data) */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_ListRuleSetRuns: Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse>;
  /** Validates a rule set */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_ValidateRuleSet: Maybe<Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetResponse>;
  /** Gets a gift order digital card by ID */
  instacart_customers_gifting_v1_GiftOrderDigitalCardService_GetGiftOrderDigitalCardById: Maybe<Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdResponse>;
  /** Get loyalty benefits for a program. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_GetLoyaltyBenefits: Maybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsResponse>;
  /** Get loyalty card validations for a warehouse. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_GetLoyaltyCardValidations: Maybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsResponse>;
  /** Get a loyalty program for a retailer. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_GetLoyaltyProgram: Maybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramResponse>;
  /** Get loyalty cards by card number. */
  instacart_customers_loyalty_v1_LoyaltyService_GetLoyaltyCardsByCardNumber: Maybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberResponse>;
  /** Get loyalty cards for a user. */
  instacart_customers_loyalty_v1_LoyaltyService_GetLoyaltyCardsForUser: Maybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserResponse>;
  instacart_customers_offers_tooling_orchestrator_v1_OffersToolingService_PrepareCreateOfferPayload: Maybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadResponse>;
  /** API to return order items details. */
  instacart_customers_orders_v1_OrdersService_GetOrderLines: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse>;
  /** Countries API */
  instacart_customers_partners_v1_PartnersService_GetCountries: Maybe<Instacart_Customers_Partners_V1_GetCountriesResponse>;
  /** Partners API */
  instacart_customers_partners_v1_PartnersService_GetPartners: Maybe<Instacart_Customers_Partners_V1_GetPartnersResponse>;
  /**
   * PostalCodes API
   * Search postal codes by name or id. Not recommended unless you can't use GetPostalCodesByZones, as
   * the list can be very long.
   */
  instacart_customers_partners_v1_PartnersService_GetPostalCodes: Maybe<Instacart_Customers_Partners_V1_GetPostalCodesResponse>;
  /** Search postal codes within a zone. This is the preferred method for searching postal codes. */
  instacart_customers_partners_v1_PartnersService_GetPostalCodesByZones: Maybe<Instacart_Customers_Partners_V1_GetPostalCodesByZonesResponse>;
  /** Regions API */
  instacart_customers_partners_v1_PartnersService_GetRegions: Maybe<Instacart_Customers_Partners_V1_GetRegionsResponse>;
  /** RetailerLocations aka WarehouseLocations API */
  instacart_customers_partners_v1_PartnersService_GetRetailerLocations: Maybe<Instacart_Customers_Partners_V1_GetRetailerLocationsResponse>;
  instacart_customers_partners_v1_PartnersService_GetRetailerLocationsByRetailer: Maybe<Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerResponse>;
  instacart_customers_partners_v1_PartnersService_GetRetailerZones: Maybe<Instacart_Customers_Partners_V1_GetRetailerZonesResponse>;
  instacart_customers_partners_v1_PartnersService_GetRetailers: Maybe<Instacart_Customers_Partners_V1_GetRetailersResponse>;
  /**
   * Zones API
   * Gets all zones, optionally filtered by name. Using GetZonesByRegion is preferred where possible as
   * the list of zones is very long when not filtered by region.
   */
  instacart_customers_partners_v1_PartnersService_GetZones: Maybe<Instacart_Customers_Partners_V1_GetZonesResponse>;
  /** Gets all zones in a region, optionally filtered by name. Preferred where possible. */
  instacart_customers_partners_v1_PartnersService_GetZonesByRegion: Maybe<Instacart_Customers_Partners_V1_GetZonesByRegionResponse>;
  instacart_customers_partnership_offer_v1_PartnershipOfferService_GetPartnershipManagementUrlDownloadLink: Maybe<Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkResponse>;
  instacart_customers_partnership_offer_v1_PartnershipOfferService_ListPartnershipManagementUrls: Maybe<Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsResponse>;
  instacart_customers_product_retrieval_v1_ProductRetrievalService_GetLegacyProductsWithFilters: Maybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetAggregatedItemData: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetItems: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetRetailerProducts: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_SearchRetailerBrands: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse>;
  instacart_customers_recipes_v1_RecipesService_GetCategoriesByName: Maybe<Instacart_Customers_Recipes_V1_GetCategoriesByNameResponse>;
  instacart_customers_recipes_v1_RecipesService_GetCoreIngredients: Maybe<Instacart_Customers_Recipes_V1_GetCoreIngredientsResponse>;
  instacart_customers_recipes_v1_RecipesService_GetRecipeById: Maybe<Instacart_Customers_Recipes_V1_GetRecipeByIdResponse>;
  instacart_customers_recipes_v1_RecipesService_GetRecipeByIdForDashboard: Maybe<Instacart_Customers_Recipes_V1_GetRecipeByIdResponse>;
  instacart_customers_recipes_v1_RecipesService_GetRecipes: Maybe<Instacart_Customers_Recipes_V1_GetRecipesResponse>;
  instacart_customers_recipes_v1_RecipesService_ListRecipes: Maybe<Instacart_Customers_Recipes_V1_ListRecipesResponse>;
  instacart_customers_recipes_v1_RecipesService_ValidateAndUploadRecipes: Maybe<Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CheckBulkEditStatus: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyer: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerActivities: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerClickableAreas: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerMetadata: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerPipelineDebug: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerPresignedUrls: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerStats: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerTags: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerUploadDetails: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_ListFlyers: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetCollectionPreviewProducts: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetCollectionRules: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetLowerPriceDefinitions: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetNavigationTree: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetRetailerCsv: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListCollectionProducts: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListCollections: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListGlobalCollections: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListRetailerDepartments: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_SearchCollectionProducts: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ValidateCollectionSlug: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_GetIppDraftById: Maybe<Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_ListIppDrafts: Maybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsResponse>;
  instacart_customers_retailer_management_v1_IppDraftPreviewService_GetIppPreviewByToken: Maybe<Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenResponse>;
  instacart_customers_retailer_management_v1_IppDraftPreviewService_GetPreviewAuthToken: Maybe<Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenResponse>;
  instacart_customers_retailer_management_v1_WidgetConfigurationService_GetWidgetConfiguration: Maybe<Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationResponse>;
  /**
   * Internal request for getting esci labels for products
   * This is created specifically for validating product relevance for IPP custom boosting rules
   */
  instacart_customers_search_results_v2_SearchResultsService_GetProductEsciLabel: Maybe<Instacart_Customers_Search_Results_V2_GetProductEsciLabelResponse>;
  instacart_customers_search_v1_SearchService_GetSearchTermOverrides: Maybe<Instacart_Customers_Search_V1_GetSearchTermOverridesResponse>;
  instacart_customers_search_v1_SearchService_GetSearchTermOverridesById: Maybe<Instacart_Customers_Search_V1_GetSearchTermOverridesByIdResponse>;
  instacart_enterprise_boba_core_offers_v1_OfferService_GetOrderDiscountInfo: Maybe<Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoResponse>;
  /** Retrieves bulk delivery configurations for a specific retailer location. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurations: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsResponse>;
  /** Retrieves bulk delivery configurations for multiple retailer locations in a single call. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurationsList: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListResponse>;
  /** Retrieves an overview of order statuses for a retailer location on a given date. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryOrderOverview: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewResponse>;
  /** Retrieves detailed information about a single delivery route including orders. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRoute: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteResponse>;
  /** Retrieves a list of bulk delivery routes for a specific retailer location and date. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRouteList: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListResponse>;
  /** Retrieves a paginated list of vehicles for a warehouse location. */
  instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehiclesService_GetWarehouseLocationVehicleList: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListResponse>;
  /** fetches a Dashboard Order. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetDashboardOrder: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderResponse>;
  /** Get a list of orders from filters or order ID. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetDashboardOrderSearchResultList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse>;
  /** Get an operation for an order */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOperation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationResponse>;
  /** Get Order Adjustment Policies and validates adjustment request */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderAdjustmentPolicyList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListResponse>;
  /**
   * Get a list of OrderCancellationPolicies in order to cancel an order.
   *
   * TODO: contrary to the naming, this endpoint also fetches reschedule policies.
   * When we upgrade from the experimental ICP service we should rename this
   * to GetOrderChangePolicyList, which also should include refunds.
   */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderCancellationPolicyList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListResponse>;
  /** Get order lines for an order */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderLineList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListResponse>;
  /** Get a list of state changes for an order. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderStateChangeList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListResponse>;
  /** Fetches a list of users by email, phone, or loyalty id. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardUserService_GetDashboardUserSearchResultList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse>;
  instacart_enterprise_frigate_fulfillment_v1_EnterpriseServiceOptionService_GetEnterpriseServiceOptionList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse>;
  /** Fetches detailed information about retailer products */
  instacart_enterprise_frigate_fulfillment_v1_RetailerProductDetailsService_GetRetailerProductDetails: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse>;
  /** Get messages for conversation */
  instacart_enterprise_frigate_post_checkout_v1_EnterpriseChatService_GetEnterpriseChatMessageList: Maybe<Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListResponse>;
  /** Retrieves a list of partner-managed shifts for a specific retailer location and date. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_GetPartnerManagedShiftList: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListResponse>;
  /** Retrieves a paginated list of partner-managed shoppers with optional filtering. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShoppersService_GetPartnerManagedShopperList: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListResponse>;
  /** Retrieves staffing hours for a specific retailer location and date. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedStaffingService_GetStaffingHoursListByDate: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateResponse>;
  /** GetPresignedDownloadUrl generates a presigned URL for downloading a file from cloud storage */
  instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationsService_GetPresignedDownloadUrl: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlResponse>;
  /** GetShiftManagementOperationRecord retrieves a single shift management operation record by ID */
  instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationsService_GetShiftManagementOperationRecord: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordResponse>;
  /**
   * GetShiftManagementOperationRecordList retrieves shift management operation records
   * for a given retailer with pagination support
   */
  instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationsService_GetShiftManagementOperationRecordList: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListResponse>;
  /** Retrieves staffing allocation data for a specified date range. */
  instacart_enterprise_frigate_shifts_v1_StaffingAllocationService_GetStaffingAllocationList: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListResponse>;
  /** Get checkout state and barcode for an order delivery */
  instacart_enterprise_fulfillment_simulation_engine_v1_OrderSimulationService_GetCheckoutStateAndBarcode: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeResponse>;
  /**
   * Gets detailed information about a single MAPLE job.
   * Use this for the job details/monitoring view.
   */
  instacart_flawless_inventory_v1_MapleService_GetJobDetails: Maybe<Instacart_Flawless_Inventory_V1_GetJobDetailsResponse>;
  /** Gets details about the run of a job. */
  instacart_flawless_inventory_v1_MapleService_GetJobResults: Maybe<Instacart_Flawless_Inventory_V1_GetJobResultsResponse>;
  /**
   * Gets all unique AI Gateway sources that have been used in MAPLE jobs.
   * Use this for populating filter dropdowns in the dashboard.
   */
  instacart_flawless_inventory_v1_MapleService_GetJobSources: Maybe<Instacart_Flawless_Inventory_V1_GetJobSourcesResponse>;
  /** Gets the status of a given job. Is one of ['completed', 'in_progress', 'failed'] */
  instacart_flawless_inventory_v1_MapleService_GetJobStatus: Maybe<Instacart_Flawless_Inventory_V1_GetJobStatusResponse>;
  /**
   * Dashboard APIs
   * Lists all MAPLE jobs with optional filtering and pagination.
   * Use this for the job browser/dashboard view.
   */
  instacart_flawless_inventory_v1_MapleService_GetJobs: Maybe<Instacart_Flawless_Inventory_V1_GetJobsResponse>;
  /** Get a list of all the AI models supported for MAPLE. */
  instacart_flawless_inventory_v1_MapleService_GetMapleSupportedModels: Maybe<Instacart_Flawless_Inventory_V1_GetMapleSupportedModelsResponse>;
  /** Get audit logs for debugging reconciliation actions */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_GetAuditLogs: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsResponse>;
  /** Get step log audit metrics for a given step type */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_GetStepLogAuditMetrics: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditMetricsResponse>;
  /** Get step log audits with optional filters */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_GetStepLogAudits: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsResponse>;
  /** Get step logs for debugging reconciliation pipeline */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_GetStepLogs: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogsResponse>;
  /** Get all available step types */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_GetStepTypes: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepTypesResponse>;
  /** Get categorization analysis result for a batch */
  instacart_fulfillment_shopper_transaction_integrity_v1_CategorizationService_GetCategorizationAnalysis: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisResponse>;
  /** Gets the status of a campaign */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetCampaignStatus: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusResponse>;
  /** Gets the email unsubscribe lists */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetEmailUnsubscribeLists: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsResponse>;
  /** Get an IntentionConfiguration */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetIntentionConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationResponse>;
  /** Get a single retailer configuration based on retailer_id/store_configuration_id */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetRetailerConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationResponse>;
  /** Gets the size of a segment */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetSegmentSize: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeResponse>;
  /** Gets a template */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetTemplate: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateResponse>;
  /** List supported editable template variables */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_ListEditableTemplateVariables: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesResponse>;
  /** Lists segments for a warehouse */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_ListSegments: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsResponse>;
  /** Lists templates */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_ListTemplates: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesResponse>;
  /** Fetch Module by Name */
  instacart_infra_instaform_v1_InstaformService_GetModuleByName: Maybe<Instacart_Infra_Instaform_V1_GetModuleByNameResponse>;
  /** Fetch all the Modules */
  instacart_infra_instaform_v1_InstaformService_GetModules: Maybe<Instacart_Infra_Instaform_V1_GetModulesResponse>;
  /** Get the details of an Entity */
  instacart_infra_totem_v1_TotemService_GetEntity: Maybe<Instacart_Infra_Totem_V1_GetEntityResponse>;
  /** Get the details of a system */
  instacart_infra_totem_v1_TotemService_GetSystem: Maybe<Instacart_Infra_Totem_V1_GetSystemResponse>;
  /** Get a single OpsEscalationRequest by ID. */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_GetOpsEscalationRequest: Maybe<Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestResponse>;
  /** List all OpsEscalationRequests matching the ones in request based on a list of OpsEscalationRequest IDs */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_ListBulkDuplicateOpsEscalationRequests: Maybe<Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsResponse>;
  /** List all OpsEscalationRequests matching the one in request based on Warehouse Location IDs */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_ListDuplicateOpsEscalationRequests: Maybe<Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsResponse>;
  /** List all OpsEscalationRequests that match the given criteria */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_ListOpsEscalationRequests: Maybe<Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsResponse>;
  instacart_logistics_v1_FulfillmentEvents_GetFulfillmentEvent: Maybe<Instacart_Logistics_V1_GetFulfillmentEventResponse>;
  /** Get many fulfillment events by id */
  instacart_logistics_v1_FulfillmentEvents_GetFulfillmentEventsById: Maybe<Instacart_Logistics_V1_GetFulfillmentEventsByIdResponse>;
  /** List all child fulfillment events for a specified parent event that match the given criteria */
  instacart_logistics_v1_FulfillmentEvents_ListChildFulfillmentEvents: Maybe<Instacart_Logistics_V1_ListChildFulfillmentEventsResponse>;
  /** List all creators */
  instacart_logistics_v1_FulfillmentEvents_ListCreators: Maybe<Instacart_Logistics_V1_ListCreatorsResponse>;
  /** List all fulfillment events that match the given criteria */
  instacart_logistics_v1_FulfillmentEvents_ListFulfillmentEvents: Maybe<Instacart_Logistics_V1_ListFulfillmentEventsResponse>;
  /** List all tags */
  instacart_logistics_v1_FulfillmentEvents_ListTags: Maybe<Instacart_Logistics_V1_ListTagsResponse>;
  /** Validate a new closure event */
  instacart_logistics_v1_FulfillmentEvents_ValidateNewClosureEvent: Maybe<Instacart_Logistics_V1_ValidateNewClosureEventResponse>;
  /** Validate a new fulfillment capacity-impacting event */
  instacart_logistics_v1_FulfillmentEvents_ValidateNewFulfillmentEvent: Maybe<Instacart_Logistics_V1_ValidateNewFulfillmentEventResponse>;
  /** Validate a new restricted availability event */
  instacart_logistics_v1_FulfillmentEvents_ValidateNewRestrictedAvailabilityEvent: Maybe<Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventResponse>;
  /**
   * DownloadInterventionData generates a presigned URL to download the full CSV data uploaded for an intervention.
   * This allows downloading the complete dataset for offline analysis or processing.
   */
  instacart_massops_v1_MassOpsService_DownloadInterventionData: Maybe<Instacart_Massops_V1_DownloadInterventionDataResponse>;
  /** GetIncident returns a single incident from the incident service based on the provided filter. */
  instacart_massops_v1_MassOpsService_GetIncident: Maybe<Instacart_Massops_V1_GetIncidentResponse>;
  /**
   * GetIntervention retrieves detailed information about a specific intervention,
   * including its current state, execution progress, and parameters.
   */
  instacart_massops_v1_MassOpsService_GetIntervention: Maybe<Instacart_Massops_V1_GetInterventionResponse>;
  /**
   * GetInterventionCommunicationSettings retrieves the communication settings for an intervention.
   * Returns the current email and SMS notification configurations.
   */
  instacart_massops_v1_MassOpsService_GetInterventionCommunicationSettings: Maybe<Instacart_Massops_V1_GetInterventionCommunicationSettingsResponse>;
  /**
   * GetInterventionCountsByArtifactType returns the number of interventions grouped by artifact type
   * over time periods based on the specified aggregation (week, month, or quarter).
   */
  instacart_massops_v1_MassOpsService_GetInterventionCountsByArtifactType: Maybe<Instacart_Massops_V1_GetInterventionCountsByArtifactTypeResponse>;
  /**
   * GetInterventionCountsByIncident returns the number of incident-related interventions
   * grouped by incident reference and intervention type.
   */
  instacart_massops_v1_MassOpsService_GetInterventionCountsByIncident: Maybe<Instacart_Massops_V1_GetInterventionCountsByIncidentResponse>;
  /**
   * GetInterventionCountsByInterventionType returns the number of interventions categorized by
   * incident-related and non-incident-related types, broken down by intervention type.
   */
  instacart_massops_v1_MassOpsService_GetInterventionCountsByInterventionType: Maybe<Instacart_Massops_V1_GetInterventionCountsByInterventionTypeResponse>;
  /**
   * GetInterventionPreExecutionSummary retrieves the pre-execution summary for a specific intervention.
   * This includes estimated impact, validation results, and readiness checks before execution begins.
   */
  instacart_massops_v1_MassOpsService_GetInterventionPreExecutionSummary: Maybe<Instacart_Massops_V1_GetInterventionPreExecutionSummaryResponse>;
  /**
   * GetInterventionStatistics returns aggregate statistics about interventions
   * within the specified date range, including counts for each workflow state.
   */
  instacart_massops_v1_MassOpsService_GetInterventionStatistics: Maybe<Instacart_Massops_V1_GetInterventionStatisticsResponse>;
  /**
   * GetInterventionType retrieves detailed information about a specific intervention type,
   * including its required task and intervention parameters.
   */
  instacart_massops_v1_MassOpsService_GetInterventionType: Maybe<Instacart_Massops_V1_GetInterventionTypeResponse>;
  /**
   * GetInterventionTypeIdForIntervention retrieves the intervention type ID
   * for a given intervention UUID.
   */
  instacart_massops_v1_MassOpsService_GetInterventionTypeIdForIntervention: Maybe<Instacart_Massops_V1_GetInterventionTypeIdForInterventionResponse>;
  /**
   * GetNotificationTemplate retrieves full details of a specific notification template
   * including all locale contents.
   */
  instacart_massops_v1_MassOpsService_GetNotificationTemplate: Maybe<Instacart_Massops_V1_GetNotificationTemplateResponse>;
  /**
   * GetTotalFinancialImpact returns the current aggregated financial impact total
   * across interventions within the specified filter (e.g., date range). This reflects actual
   * realized impact from completed tasks, not pre-execution estimates.
   */
  instacart_massops_v1_MassOpsService_GetTotalFinancialImpact: Maybe<Instacart_Massops_V1_GetTotalFinancialImpactResponse>;
  /**
   * ListInterventionApprovalRequests returns a list of approval requests for a specific intervention.
   * Supports filtering by active status to show current or historical approval requests.
   */
  instacart_massops_v1_MassOpsService_ListInterventionApprovalRequests: Maybe<Instacart_Massops_V1_ListInterventionApprovalRequestsResponse>;
  /**
   * ListInterventionTypes returns all available intervention types that can be used
   * to create new interventions. Each type defines the required parameters and behavior.
   */
  instacart_massops_v1_MassOpsService_ListInterventionTypes: Maybe<Instacart_Massops_V1_ListInterventionTypesResponse>;
  /**
   * ListInterventions returns a paginated list of all interventions in the system,
   * including their current state and execution metadata.
   */
  instacart_massops_v1_MassOpsService_ListInterventions: Maybe<Instacart_Massops_V1_ListInterventionsResponse>;
  /**
   * ListNotificationTemplates returns a list of available notification templates
   * for customer communication in interventions.
   */
  instacart_massops_v1_MassOpsService_ListNotificationTemplates: Maybe<Instacart_Massops_V1_ListNotificationTemplatesResponse>;
  /**
   * ListTasks returns a paginated list of all tasks associated with a specific intervention.
   * Each task represents an individual operation to be performed.
   */
  instacart_massops_v1_MassOpsService_ListTasks: Maybe<Instacart_Massops_V1_ListTasksResponse>;
  /**
   * ListTemplateVariables returns all supported template variables.
   * Variables are global and can be used in any notification template.
   */
  instacart_massops_v1_MassOpsService_ListTemplateVariables: Maybe<Instacart_Massops_V1_ListTemplateVariablesResponse>;
  /**
   * PreviewInterventionData returns the first 10 rows of CSV data uploaded for an intervention.
   * This provides a quick preview of the data without needing to download the entire file.
   */
  instacart_massops_v1_MassOpsService_PreviewInterventionData: Maybe<Instacart_Massops_V1_PreviewInterventionDataResponse>;
  /** Retrieves a change approval request by its ID */
  instacart_partners_data_ingestion_v1_ChangeApprovalService_GetChangeApprovalRequest: Maybe<Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestResponse>;
  /** Get CSV validation result by ID */
  instacart_partners_partners_v1_FileService_GetCsvValidationResult: Maybe<Instacart_Partners_Partners_V1_GetCsvValidationResultResponse>;
  /** Main dashboard matrix view: paginated enrollments with feature statuses */
  instacart_partners_partners_v1_FlipService_GetFlipDashboard: Maybe<Instacart_Partners_Partners_V1_GetFlipDashboardResponse>;
  /** Single enrollment detail with full feature groups and items */
  instacart_partners_partners_v1_FlipService_GetFlipEnrollmentDetail: Maybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailResponse>;
  /** Paginated enrollments with site metadata (no feature matrix) */
  instacart_partners_partners_v1_FlipService_GetFlipEnrollments: Maybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentsResponse>;
  /** Feature group catalog for dashboard organization */
  instacart_partners_partners_v1_FlipService_GetFlipFeatureGroups: Maybe<Instacart_Partners_Partners_V1_GetFlipFeatureGroupsResponse>;
  /** Feature catalog for filter dropdowns and column configuration */
  instacart_partners_partners_v1_FlipService_GetFlipFeatures: Maybe<Instacart_Partners_Partners_V1_GetFlipFeaturesResponse>;
  /** Get the full edit history of a note (all versions from root to latest) */
  instacart_partners_partners_v1_FlipService_GetFlipNoteHistory: Maybe<Instacart_Partners_Partners_V1_GetFlipNoteHistoryResponse>;
  /** List all notes for a site × feature intersection (feed order) */
  instacart_partners_partners_v1_FlipService_ListFlipNotes: Maybe<Instacart_Partners_Partners_V1_ListFlipNotesResponse>;
  /** Get a single WhitelabelApp by ID. */
  instacart_partners_partners_v1_MobileAppsManagementService_GetWhitelabelApp: Maybe<Instacart_Partners_Partners_V1_GetWhitelabelAppResponse>;
  /** Get, filter, and paginate WhitelabelApps. */
  instacart_partners_partners_v1_MobileAppsManagementService_GetWhitelabelApps: Maybe<Instacart_Partners_Partners_V1_GetWhitelabelAppsResponse>;
  /** Bulk fetch partner configuration types; supports filtering by configurable type (e.g. RetailerLocation) */
  instacart_partners_partners_v1_PartnerConfigurationsService_GetPartnerConfigurationTypesPaginated: Maybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedResponse>;
  /**
   * Bulk look up by configuration type. Look up a single configuration for multiple entities like WHL or WH IDs
   * Does not have `Bulk` in the method name even though it should have, and it's too late to change as it's been live since early 2024
   */
  instacart_partners_partners_v1_PartnerConfigurationsService_GetPartnerConfigurations: Maybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsResponse>;
  /** Paginated bulk look up configurations */
  instacart_partners_partners_v1_PartnerConfigurationsService_GetPartnerConfigurationsPaginated: Maybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedResponse>;
  /** GetAutomations */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetAutomations: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetAutomationsResponse>;
  /** GetConnections */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetConnections: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetConnectionsResponse>;
  /** GetStores */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetStores: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetStoresResponse>;
  /** GetSyncStrategies */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetSyncStrategies: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetSyncStrategiesResponse>;
  instacart_retailer_tools_growth_targeting_v1_GrowthTargetingToolingService_GetTargetingFeatures: Maybe<Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesResponse>;
  /** fetches detailed entitlement data for a single entitlement */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetEntitlementDetails: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsResponse>;
  /** fetches shallow entitlement data for many entitlements */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetEntitlements: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsResponse>;
  /** fetches detailed package data for a single package */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetPackageDetails: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsResponse>;
  /** fetches shallow package data for many packages */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetPackages: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesResponse>;
  /** fetches detailed entitlement profile data for a single retailer */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetRetailerEntitlementProfileDetails: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsResponse>;
  /** fetches shallow entitlement profile data for many retailers */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetRetailerEntitlementProfiles: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_DownloadInsightsPortalCustomExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalCustomExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalCustomReport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalFilterOptions: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalMultiDimensionDataset: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_ListInsightsPortalCustomExports: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_ListInsightsPortalCustomReports: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsResponse>;
  instacart_retailers_v1_AppeasementsService_GetAppeasementsByUser: Maybe<Instacart_Retailers_V1_GetAppeasementsByUserResponse>;
  instacart_retailers_v1_AppeasementsService_GetCreditsByUser: Maybe<Instacart_Retailers_V1_GetCreditsByUserResponse>;
  instacart_retailers_v1_RetailersService_GetWidgetsConfig: Maybe<Instacart_Retailers_V1_GetWidgetsConfigResponse>;
  instacart_retailers_v1_RetailersService_ValidateWidgetsConfig: Maybe<Instacart_Retailers_V1_ValidateWidgetsConfigResponse>;
  instacart_retailers_v1_StoreConfigurationsService_GetStoreConfigurationsForRetailers: Maybe<Instacart_Retailers_V1_StoreConfigurationsForRetailersResponse>;
  /** Get the specific version of a feature by its name */
  instacart_roulette_v1_RouletteService_GetFeatureByNameAndVersion: Maybe<Instacart_Roulette_V1_GetFeatureByNameAndVersionResponse>;
  /** Retrieves all active features matching the given request criteria. */
  instacart_roulette_v1_RouletteService_ListFeatures: Maybe<Instacart_Roulette_V1_GetFeaturesResponse>;
  /** Search Features */
  instacart_roulette_v1_RouletteService_SearchFeatures: Maybe<Instacart_Roulette_V1_SearchFeaturesResponse>;
  /** GetIntegrationVersions */
  instacart_upos_config_v1_ConfigService_GetIntegrationVersions: Maybe<Instacart_Upos_Config_V1_GetIntegrationVersionsResponse>;
  /** GetIntegrations */
  instacart_upos_config_v1_ConfigService_GetIntegrations: Maybe<Instacart_Upos_Config_V1_GetIntegrationsResponse>;
  /** GetProfileVersions */
  instacart_upos_config_v1_ConfigService_GetProfileVersions: Maybe<Instacart_Upos_Config_V1_GetProfileVersionsResponse>;
  /** GetProfiles */
  instacart_upos_config_v1_ConfigService_GetProfiles: Maybe<Instacart_Upos_Config_V1_GetProfilesResponse>;
  /** GetRetailerVersions */
  instacart_upos_config_v1_ConfigService_GetRetailerVersions: Maybe<Instacart_Upos_Config_V1_GetRetailerVersionsResponse>;
  /** GetRetailers */
  instacart_upos_config_v1_ConfigService_GetRetailers: Maybe<Instacart_Upos_Config_V1_GetRetailersResponse>;
  /** GetStoreVersions */
  instacart_upos_config_v1_ConfigService_GetStoreVersions: Maybe<Instacart_Upos_Config_V1_GetStoreVersionsResponse>;
  /** GetStores */
  instacart_upos_config_v1_ConfigService_GetStores: Maybe<Instacart_Upos_Config_V1_GetStoresResponse>;
  /** Returns a list of statuses for every retailer location */
  instacart_upos_status_v1_StatusService_GetIntegrationStatuses: Maybe<Instacart_Upos_Status_V1_GetIntegrationStatusesResponse>;
  /** Describe snowflake table's schema */
  instacart_waves_v1_WavesService_DescribeSnowflakeTable: Maybe<Instacart_Waves_V1_DescribeSnowflakeTableResponse>;
  /** Gets a specific step version by step_id and version number */
  instacart_waves_v1_WavesService_GetStepVersion: Maybe<Instacart_Waves_V1_GetStepVersionResponse>;
  /** Gets paginated version history for a step */
  instacart_waves_v1_WavesService_GetStepVersionHistory: Maybe<Instacart_Waves_V1_GetStepVersionHistoryResponse>;
  /** Returns the details about the specific workflow run */
  instacart_waves_v1_WavesService_GetWorkflowRun: Maybe<Instacart_Waves_V1_GetWorkflowRunResponse>;
  /** Lists step filter tags for a given step */
  instacart_waves_v1_WavesService_ListStepFilterTags: Maybe<Instacart_Waves_V1_ListStepFilterTagsResponse>;
  /** Lists step runs with pagination */
  instacart_waves_v1_WavesService_ListStepRuns: Maybe<Instacart_Waves_V1_ListStepRunsResponse>;
  /** Lists step versions with optional filters */
  instacart_waves_v1_WavesService_ListStepVersions: Maybe<Instacart_Waves_V1_ListStepVersionsResponse>;
  /** Lists steps with optional filters */
  instacart_waves_v1_WavesService_ListSteps: Maybe<Instacart_Waves_V1_ListStepsResponse>;
  /** Returns a list of workflow runs by pipeline step id */
  instacart_waves_v1_WavesService_ListWorkflowRuns: Maybe<Instacart_Waves_V1_ListWorkflowRunsResponse>;
  inventoryIntelligenceServiceGetAcknowledgedOosIds: Maybe<GetAcknowledgedOosIdsResponse>;
  inventoryIntelligenceServiceGetAisleRestockSummary: Maybe<GetAisleRestockSummaryResponse>;
  inventoryIntelligenceServiceGetKpi: Maybe<GetKpiResponse>;
  inventoryIntelligenceServiceGetRestockRankingList: Maybe<GetRestockRankingListResponse>;
  inventoryIntelligenceServiceGetShelfView: Maybe<GetShelfViewResponse>;
  linkAutosuggestServiceListLinkAutosuggestionAdmin: Maybe<ListLinkAutosuggestionAdminResponse>;
  /** Retrieve the size of the Braze Segment */
  marketingFeatureBrazeSegmentSize: MarketingFeatureTypesBrazeSegmentSize;
  /** Retrieve a list of available braze segments for the retailer */
  marketingFeatureBrazeSegments: Array<MarketingFeatureTypesBrazeSegment>;
  /** Fetches the status of a marketing campaign */
  marketingFeatureCampaignStatus: MarketingFeatureTypesCampaignStatus;
  /** Fetches an email template */
  marketingFeatureTemplate: MarketingFeatureTypesTemplate;
  /** Retrieves a list of email templates */
  marketingFeatureTemplateSearch: Array<MarketingFeatureTypesTemplate>;
  /** Fetch a signed url for a single S3 report */
  normalizedReportSignedUrl: NormalizedReportsNormalizedReportSignedUrl;
  /** Fetch a list of S3 report types */
  normalizedReportTypes: Array<NormalizedReportsReportType>;
  /** Fetch a list of S3 reports */
  normalizedReportsSearch: NormalizedReportsNormalizedReportConnection;
  /** Fetch list of notification channels for the current account */
  notificationChannelsForCurrentAccount: Array<NotificationsNotificationChannel>;
  /** Fetch list of notifications for the current account */
  notifications: NotificationsNotificationConnection;
  /** Get mobile app config */
  onboardingMobileAppConfig: OnboardingFeatureTypesMobileAppConfig;
  onboardingServiceCheckLaunchOnboardingProgressByPartner: Maybe<CheckLaunchOnboardingProgressByPartnerResponse>;
  onboardingServiceGetApprovalRequests: Maybe<GetApprovalRequestsResponse>;
  onboardingServiceGetBuildkiteArtifactDownloadUrl: Maybe<GetBuildkiteArtifactDownloadUrlResponse>;
  onboardingServiceGetBuildkiteArtifacts: Maybe<GetBuildkiteArtifactsResponse>;
  onboardingServiceGetCatalogFaqFile: Maybe<GetCatalogFaqFileResponse>;
  onboardingServiceGetFormGroups: Maybe<GetFormGroupsResponse>;
  onboardingServiceGetLaunchOnboarding: Maybe<GetLaunchOnboardingResponse>;
  onboardingServiceGetLaunchOnboardingWarehouseLocations: Maybe<GetLaunchOnboardingWarehouseLocationsResponse>;
  onboardingServiceGetOnboarding: Maybe<GetOnboardingResponse>;
  onboardingServiceGetOnboardingAttributes: Maybe<GetOnboardingAttributesResponse>;
  onboardingServiceGetSignupPartner: Maybe<GetSignupPartnerResponse>;
  onboardingServiceGetTestCases: Maybe<GetTestCasesResponse>;
  onboardingServiceGetWaterfallEffect: Maybe<GetWaterfallEffectResponse>;
  onboardingServiceGetWaterfallEffects: Maybe<GetWaterfallEffectsResponse>;
  onboardingServiceGetWhitelabelGumloopWorkflowResults: Maybe<GetWhitelabelGumloopWorkflowResultsResponse>;
  onboardingServiceGetWhitelabelSiteTestRunBuild: Maybe<GetWhitelabelSiteTestRunBuildResponse>;
  onboardingServiceGetWhitelabelSiteTestRuns: Maybe<GetWhitelabelSiteTestRunsResponse>;
  onboardingServiceGetWhitelabelSites: Maybe<GetWhitelabelSitesResponse>;
  onboardingServiceGetWhitelabelSitesAdmin: Maybe<GetWhitelabelSitesAdminResponse>;
  onboardingServiceSearchWhitelabelSiteCustomizableString: Maybe<SearchWhitelabelSiteCustomizableStringResponse>;
  /** Get workflow details */
  onboardingWorkflow: Array<OnboardingFeatureTypesWorkflow>;
  orderServiceGetDashboardOrder: Maybe<GetDashboardOrderResponse>;
  orderServiceGetDashboardOrders: Maybe<GetDashboardOrdersResponse>;
  orderServiceGetOrder: Maybe<GetOrderResponse>;
  orderServiceGetOrderLocation: Maybe<GetOrderLocationResponse>;
  orderServiceGetOrderStateChanges: Maybe<GetOrderStateChangesResponse>;
  /** Fetch Types of Order Sources for a given retailer */
  orderSources: OrderSources;
  /** Fetch a specific partner by id */
  partner: Partner;
  /** Fetch a specific partner pick device by id */
  partnerPickDevice: PartnerPickDevicesDevice;
  /** Fetch list of partner pick devices */
  partnerPickDeviceSearch: PartnerPickDevicesDeviceSearch;
  /** Fetch capacity recommendations for a given retailer location and date */
  partnerPickGetCapacityRecommendations: PartnerPickCapacityGetCapacityRecommendationsResponse;
  /** Check if recurring_shift being created will conflict with existing shifts */
  partnerPickRecurringShiftConflictCheck: PartnerPickRecurringShiftsConflict;
  /** Search for partners (and its warehouses) matching a set of criteria. Returns a set of partners */
  partnerRetailerSearch: PartnerConnection;
  /** Search for partners matching a set of criteria */
  partnerSearch: PartnerConnection;
  /** Search for partners matching a set of criteria - returns an array instead of a connection type */
  partnerSearchArray: Array<Partner>;
  /** Fetches multiple partners by their ids */
  partners: Array<Partner>;
  /** Fetches the list of permissions available for the current user */
  permissions: Array<Permission>;
  /** Retrieve pickup retailer location groups that belong to a specific retailer */
  pickupRetailerLocationGroup: Array<RetailersPickupRetailerLocationGroup>;
  privacyServiceGetPiiRequestsForRetailer: Maybe<GetPiiRequestsForRetailerResponse>;
  productDataServiceGetProductData: Maybe<GetProductDataResponse>;
  productSourceServiceGetProductSources: Maybe<GetProductSourcesResponse>;
  productsServiceGetFlattenedTaxonomies: Maybe<GetFlattenedTaxonomiesResponse>;
  productsServiceGetLegacyElasticsearch: Maybe<LegacyElasticsearchResponse>;
  productsServiceGetLegacyItemsShoppers: Maybe<LegacyItemsTyped>;
  productsServiceGetLegacyProducts: Maybe<LegacyProducts>;
  productsServiceGetManagedAttributeValuesForRetailer: Maybe<GetManagedAttributeValuesForRetailerResponse>;
  productsServiceSearchBrands: Maybe<SearchBrandsResponse>;
  /** Fetch aggregated Quality Scorecard metrics per tool */
  qualityScorecardsAggScorecards: QualityScorecardsAggScorecardsResponse;
  /** Fetch aggregated platform-wide statistics from RUM data */
  qualityScorecardsPlatformStats: QualityScorecardsPlatformStats;
  /** Retrieve a list of reports requested by the retailer */
  reportRequests: ReportsReportRequestConnection;
  /** Retrieve a report view by report view id */
  reportView: ReportViewsInterface;
  /** Retrieve a list of available reports to request */
  reports: Array<ReportsReport>;
  /** Fetch a specific retailer by id */
  retailer: Retailer;
  retailerAislesGetRetailerAisleTemplate: Maybe<GetRetailerAisleTemplateResponse>;
  retailerAislesGetRetailerLocationByLayout: Maybe<GetRetailerLocationByLayoutResponse>;
  retailerCampaignServiceGetMoment: Maybe<GetMomentResponse>;
  retailerCampaignServiceGetMomentParticipatingRetailers: Maybe<GetMomentParticipatingRetailersResponse>;
  retailerCampaignServiceGetMoments: Maybe<GetMomentsResponse>;
  retailerCampaignServiceGetRetailerCampaign: Maybe<RetailerCampaignResponse>;
  retailerCampaignServiceListMoments: Maybe<ListMomentsResponse>;
  retailerCampaignServiceListRetailerCampaignTreatments: Maybe<ListRetailerCampaignTreatmentsResponse>;
  retailerCampaignServiceListRetailerCampaigns: Maybe<ListRetailerCampaignsResponse>;
  /** Fetch a specific retailer location by id */
  retailerLocation: RetailerLocation;
  /** Retrieve a retailer location group by id */
  retailerLocationGroup: RetailersRetailerLocationGroup;
  /** Retrieve retailer location groups that belong to a specific retailer */
  retailerLocationGroupsByRetailer: RetailersRetailerLocationGroupConnection;
  /** Search for retailer locations matching a set of criteria */
  retailerLocationSearch: RetailerLocationConnection;
  /** Search for retailer locations matching a set of criteria - returns an array instead of a connection type */
  retailerLocationSearchArray: Array<RetailerLocation>;
  retailerManagementServiceGetClientConfigurationById: Maybe<GetClientConfigurationByIdResponse>;
  retailerManagementServiceGetConnectRetailerCallbackConfigurationById: Maybe<GetConnectRetailerCallbackConfigurationByIdResponse>;
  retailerManagementServiceGetConnectRetailerCallbackConfigurations: Maybe<GetConnectRetailerCallbackConfigurationsResponse>;
  retailerManagementServiceGetPartnerOauthApplications: Maybe<GetPartnerOauthApplicationsResponse>;
  /** Fetch a Retailer's MFA configuration settings by id */
  retailerMfaConfig: RetailerMfaConfig;
  /** Fetch pickup metadata for a retailer by its id */
  retailerPickupMetadata: RetailersRetailerPickupMetadata;
  retailerProductAttributeEditServiceGetAvailabilityScoreOverride: Maybe<GetAvailabilityScoreOverrideResponse>;
  retailerProductAttributeEditServiceGetRetailerProductAssortment: Maybe<GetRetailerProductAssortmentResponse>;
  /** Returns recent tool survey submissions for the current account. Used by the frontend to enforce display frequency rules across browser sessions (e.g., incognito windows where local storage is unavailable). */
  retailerSatisfactionSurveySubmissionFrequency: Array<RetailerSatisfactionSurveyTypesSubmissionRecord>;
  /** Search for retailers matching a set of criteria */
  retailerSearch: RetailerConnection;
  /** Search for retailers matching a set of criteria - returns an array instead of a connection type */
  retailerSearchArray: Array<Retailer>;
  retailerSettingServiceGetSetting: Maybe<GetSettingResponse>;
  retailerSettingsServiceGetIsGrocer: Maybe<GetIsGrocerResponse>;
  retailerSettingsServiceGetParkingSettings: Maybe<GetParkingSettingsResponse>;
  retailerSettingsServiceGetPickupSettingsMetadata: Maybe<GetPickupSettingsMetadataResponse>;
  retailerSettingsServiceGetStagingSettings: Maybe<GetStagingSettingsResponse>;
  retailerStoreHoursGetConfirmedStoreHours: Maybe<GetConfirmedStoreHoursResponse>;
  retailerStoreHoursGetRetailerHolidaysStatus: Maybe<GetHolidaysStatusResponse>;
  retailerStoreHoursGetStoreHours: Maybe<GetStoreHoursResponse>;
  retailerStoreHoursGetStoreHoursUpdateTasks: Maybe<GetStoreHoursUpdateTasksResponse>;
  retailerToolsServiceGetCustomersContext: Maybe<GetCustomersContextResponse>;
  retailerToolsServiceGetItems: Maybe<GetItemsResponse>;
  retailerToolsServiceGetRetailerProducts: Maybe<GetRetailerProductsResponse>;
  retailerToolsServiceGetVirtualRetailers: Maybe<GetVirtualRetailersResponse>;
  retailersServiceGetPlatformVersions: Maybe<GetPlatformVersionsResponse>;
  retailersServiceGetRetailerLocationsByLocationCodes: Maybe<GetRetailerLocationsByLocationCodesResponse>;
  retailersServiceGetRetailerLocationsDetails: Maybe<GetRetailerLocationsDetailsResponse>;
  retailersServiceGetRetailerRegions: Maybe<GetRetailerRegionsResponse>;
  /** Search for roles */
  roleSearch: Array<EnterpriseRole>;
  rppBulkImageUploadsServiceGetImageUploadBatchDetails: Maybe<GetImageUploadBatchDetailsResponse>;
  rppBulkImageUploadsServiceGetImageUploadBatches: Maybe<GetImageUploadBatchesResponse>;
  serviceOptionServiceGetServiceOptions: Maybe<GetServiceOptionsResponse>;
  /** Fetch Store Configuration by Id */
  storeConfigurationById: InstacartStoreConfiguration;
  /** Fetch list of Store Configurations by Partner/Retailer IDs */
  storeConfigurationsByPartnerId: Array<InstacartStoreConfiguration>;
  /** Fetch list of Store Configurations by Partner/Retailer IDs */
  storeConfigurationsByRetailerIds: Array<InstacartStoreConfiguration>;
  storeConfigurationsDraftServiceGetStoreConfigurationDrafts: Maybe<GetStoreConfigurationDraftsResponse>;
  storeConfigurationsDraftServiceReadLatestStoreConfigurationDraft: Maybe<ReadLatestStoreConfigurationDraftResponse>;
  storeConfigurationsDraftServiceReadStoreConfiguration: Maybe<ReadStoreConfigurationResponse>;
  storePerformanceServiceGetAggregatedStorePerformance: Maybe<StorePerformanceResponse>;
  /** Fetch a storefront placement by id */
  storefrontPlacement: ContentManagementStorefrontPlacement;
  /** Fetch a list of storefront placements */
  storefrontPlacementSearch: ContentManagementStorefrontPlacementConnection;
  /** Fetch taxonomy nodes */
  taxonomyNodes: Array<CatalogTaxonomyNode>;
  /** Get the roles, partners, and retailers assigned to an account */
  userAccessSettings: EnterpriseUserAccessSettings;
  userSettingServiceListUserSettings: Maybe<ListUserSettingsResponse>;
  usersServiceBatchGetUsersByIdsStrict: Maybe<BatchGetUsersByIdsStrictResponse>;
  usersServiceGetUserByIdFilteredByIsolationContext: Maybe<UserResponse>;
  usersServiceGetUsersByStoreConfigurationId: Maybe<GetUsersByStoreConfigurationIdResponse>;
  usersServiceListUsersByPersonalIdentifiersStrict: Maybe<ListUsersByPersonalIdentifiersStrictResponse>;
  valueBasedOverrideServiceGetValueBasedOverrides: Maybe<GetValueBasedOverridesResponse>;
  /** Fetch visibility conditions */
  visibilityConditionSearch: Array<VisibilityCondition>;
  /** Returns a WelcomeModal that should be shown to current user */
  welcomeModal: EnterpriseWelcomeModal;
  /** Find progress of wizard for given partner/retailer/location and type */
  wizardProgress: Maybe<WizardsWizardProgress>;
};


export type QueryCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_ListBanEntriesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBanEntriesRequest_Input>;
};


export type QueryCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_ListBanEntriesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBanEntriesRequest_Input>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_GetAllEntitiesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAllEntitiesRequest_Input']>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_GetConfigKeysArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetConfigKeysRequest_Input>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_GetFeaturesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetFeaturesRequest_Input']>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ListBatchScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsRequest_Input>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ListScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListScheduledActionsRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_GetAllEntitiesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAllEntitiesRequest_Input']>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_GetConfigKeysArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetConfigKeysRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_GetFeaturesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetFeaturesRequest_Input']>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ListBatchScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ListScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListScheduledActionsRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_GetPipelineRunArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetPipelineRunRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_ListPipelineRunsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListPipelineRunsRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineStagingService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_GetPipelineRunArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetPipelineRunRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineStagingService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_ListPipelineRunsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListPipelineRunsRequest_Input>;
};


export type QueryCaperIppReceiptService_Instacart_Caper_Admin_V1_IppReceiptService_GetReceiptsMetadataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetReceiptsMetadataRequest_Input>;
};


export type QueryCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_GetEntitiesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetEntitiesRequest_Input>;
};


export type QueryCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_GetNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetNofRequest_Input>;
};


export type QueryCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_ListNofsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListNofsRequest_Input>;
};


export type QueryCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_GetEntitiesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetEntitiesRequest_Input>;
};


export type QueryCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_GetNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetNofRequest_Input>;
};


export type QueryCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_ListNofsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListNofsRequest_Input>;
};


export type QueryCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_GetAvailableProfilesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAvailableProfilesRequest_Input']>;
};


export type QueryCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_GetAvailableProfilesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAvailableProfilesRequest_Input']>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetCartDataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetCartDataRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetDatadogSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionInfoArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionInfoRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionScreenshotsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetCartDataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetCartDataRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetDatadogSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionInfoArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionInfoRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionScreenshotsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncRequest_Input>;
};


export type QueryContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_GetWorkflowResultArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultRequest_Input>;
};


export type QueryContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_GetWorkflowStatusArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusRequest_Input>;
};


export type QueryExternalHealthDashboard_GetMonitorStatusesArgs = {
  retailerId: Scalars['String'];
};


export type QueryExternalHealthDashboard_HandleAuthCallbackArgs = {
  code: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type QueryFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_GetResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigRequest_Input>;
};


export type QueryFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_ListResponseConfigsArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsRequest_Input>;
};


export type QueryGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_GetStringsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_GetStringsRequest_Input>;
};


export type QueryGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_ListResourcesArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Input>;
};


export type QueryMarketingToolingService_Instacart_Growth_Marketing_Tooling_V1_MarketingToolingService_GetMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignRequest_Input>;
};


export type QueryRetailerContactManagement_GetContactArgs = {
  email: Scalars['EmailAddress'];
  retailerId: Scalars['String'];
};


export type QueryRetailerContactManagement_GetContactsArgs = {
  domain?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['PositiveInt']>;
  retailerId: Scalars['String'];
};


export type QueryAccountRequestPreviousRequestExistByEmailArgs = {
  email: Scalars['String'];
};


export type QueryAccountRequestRetailerSearchArgs = {
  namePrefix: Scalars['String'];
};


export type QueryAccountRequestSearchByIdArgs = {
  accountRequestId: Scalars['ID'];
};


export type QueryAccountTokenValidateArgs = {
  rawToken: Scalars['String'];
  tokenType: TokenTypeEnum;
};


export type QueryAnomalyDetectionSummaryArgs = {
  filters?: InputMaybe<AnomalyDetectionFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<AnomalyDetectionSortField>;
  userUuid?: InputMaybe<Scalars['String']>;
};


export type QueryApiIntegrationsServiceGetApiSettingsArgs = {
  input?: InputMaybe<GetApiSettingsRequestInput>;
};


export type QueryApiIntegrationsServiceGetAuthenticationUrlArgs = {
  input?: InputMaybe<GetAuthenticationUrlRequestInput>;
};


export type QueryApiIntegrationsServiceGetAvailableStoreLocationsArgs = {
  input?: InputMaybe<GetAvailableStoreLocationsRequestInput>;
};


export type QueryApprovalsManagementGetRequestArgs = {
  arId: Scalars['ID'];
};


export type QueryApprovalsManagementGetSnapshotsArgs = {
  snapshotIds: Array<Scalars['ID']>;
};


export type QueryApprovalsManagementGetUserPermittedActionsArgs = {
  approvalRequestIds: Array<Scalars['ID']>;
};


export type QueryApprovalsManagementListRequestsArgs = {
  affectingScopeSearch?: InputMaybe<AffectingScopeSearchInput>;
  contentSearches?: InputMaybe<Array<ContentSearchInput>>;
  ilikeName?: InputMaybe<Scalars['String']>;
  includesStates?: InputMaybe<Array<ApprovalRequestState>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAssignmentsGetOrderFulfillmentOverviewArgs = {
  input?: InputMaybe<GetOrderFulfillmentOverviewRequestInput>;
};


export type QueryAuditLogSearchArgs = {
  accountEmails?: InputMaybe<Array<Scalars['String']>>;
  accountUuids?: InputMaybe<Array<Scalars['ID']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entityIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<AuditLogEntityTypeEnum>;
  eventName?: InputMaybe<Scalars['String']>;
  eventTimeEndAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  eventTimeStartAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryAvailabilityGetStoreHoursByDateArgs = {
  input?: InputMaybe<GetStoreHoursByDateRequestInput>;
};


export type QueryAvailabilityGetStoreHoursByDayOfWeekArgs = {
  input?: InputMaybe<GetStoreHoursByDayOfWeekRequestInput>;
};


export type QueryAvailabilityGetStoreHoursByZoneRetailerArgs = {
  input?: InputMaybe<GetStoreHoursByZoneRetailerRequestInput>;
};


export type QueryCatalogAisleArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogDepartmentArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogProblemTrackerServiceGetTicketArgs = {
  input?: InputMaybe<GetTicketRequestInput>;
};


export type QueryCatalogProblemTrackerServiceListTicketsArgs = {
  input?: InputMaybe<ListTicketsRequestInput>;
};


export type QueryCatalogProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCatalogRetailerProductArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogRetailerProductSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  aisleIds?: InputMaybe<Array<Scalars['ID']>>;
  available?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  localeCode?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  searchLimit?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
  searchType: Scalars['String'];
};


export type QueryCatalogSearchDownloadSignedUrlArgs = {
  s3Key: Scalars['String'];
};


export type QueryCatalogToolsApiServiceDownloadCatalogSearchResultsArgs = {
  input?: InputMaybe<DownloadCatalogSearchResultsRequestInput>;
};


export type QueryCatalogToolsApiServiceGetAnomalousItemsListArgs = {
  input?: InputMaybe<GetAnomalousItemsListRequestInput>;
};


export type QueryCatalogToolsApiServiceGetAnomalousItemsReportArgs = {
  input?: InputMaybe<GetAnomalousItemsReportRequestInput>;
};


export type QueryCatalogToolsApiServiceGetLocalesByRetailerArgs = {
  input?: InputMaybe<GetLocalesByRetailerRequestInput>;
};


export type QueryCatalogToolsApiServiceGetPriceInvestigationArgs = {
  input?: InputMaybe<GetPriceInvestigationRequestInput>;
};


export type QueryCatalogToolsApiServiceGetRetailerProductAttributeSourcesArgs = {
  input?: InputMaybe<GetRetailerProductAttributeSourcesRequestInput>;
};


export type QueryCatalogToolsApiServiceGetRetailerProductDataArgs = {
  input?: InputMaybe<GetRetailerProductDataRequestInput>;
};


export type QueryCatalogToolsApiServiceListPriceInvestigationsArgs = {
  input?: InputMaybe<ListPriceInvestigationsRequestInput>;
};


export type QueryCollectionsServiceGetCollectionsArgs = {
  input?: InputMaybe<GetCollectionsRequestInput>;
};


export type QueryCommerceInvoicingServiceGetOrderDiscountDetailsArgs = {
  input?: InputMaybe<GetOrderDiscountDetailsRequestInput>;
};


export type QueryConfigurableItemsServiceGetRppConfigurableItemsArgs = {
  input?: InputMaybe<GetRppConfigurableItemsRequestInput>;
};


export type QueryConnectPlatformServiceGetConnectPlatformEventsByDomainArgs = {
  input?: InputMaybe<GetConnectPlatformEventsByDomainRequestInput>;
};


export type QueryConnectPlatformServiceGetConnectSettingsArgs = {
  input?: InputMaybe<GetConnectSettingsRequestInput>;
};


export type QueryConnectPlatformServiceGetPartnerApiKeysArgs = {
  input?: InputMaybe<GetPartnerApiKeysRequestInput>;
};


export type QueryConnectPlatformServiceGetPartnerIdArgs = {
  input?: InputMaybe<GetPartnerIdRequestInput>;
};


export type QueryConnectPlatformServiceGetRequestContextsArgs = {
  input?: InputMaybe<GetRequestContextsRequestInput>;
};


export type QueryContentManagementAdminServiceGetAdminNavigationV2Args = {
  input?: InputMaybe<GetAdminNavigationV2RequestInput>;
};


export type QueryContentManagementAdminServiceGetNativeTabBarNavigationArgs = {
  input?: InputMaybe<GetNativeTabBarNavigationRequestInput>;
};


export type QueryContentManagementAdminServiceGetNavigationArgs = {
  input?: InputMaybe<GetNavigationRequestInput>;
};


export type QueryContentManagementAdminServiceGetPlacementContentByIdArgs = {
  input?: InputMaybe<GetPlacementContentByIdRequestInput>;
};


export type QueryContentManagementAdminServiceGetRetailersForShortcutsArgs = {
  input?: InputMaybe<GetRetailersForShortcutsRequestInput>;
};


export type QueryContentManagementAdminServiceGetSlotByIdArgs = {
  input?: InputMaybe<GetSlotByIdRequestInput>;
};


export type QueryContentManagementAdminServiceGetSlotsArgs = {
  input?: InputMaybe<GetSlotsRequestInput>;
};


export type QueryContentManagementAdminServiceGetSlotsByContentPagesArgs = {
  input?: InputMaybe<GetSlotsByContentPagesRequestInput>;
};


export type QueryContentManagementAdminServiceGetSocialIconsNavigationArgs = {
  input?: InputMaybe<GetSocialIconsNavigationRequestInput>;
};


export type QueryContentManagementAdminServiceGetToolingShortcutsArgs = {
  input?: InputMaybe<GetToolingShortcutsRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPageVersionMetasArgs = {
  input?: InputMaybe<ListContentPageVersionMetasRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPageVersionsArgs = {
  input?: InputMaybe<ListContentPageVersionsRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPagesV2Args = {
  input?: InputMaybe<ListContentPagesRequestV2Input>;
};


export type QueryContentManagementAdminServiceListPlacementContentArgs = {
  input?: InputMaybe<ListPlacementContentRequestInput>;
};


export type QueryContentManagementServiceGetLayoutVariantsArgs = {
  input?: InputMaybe<GetLayoutVariantsRequestInput>;
};


export type QueryContentManagementServiceGetPlacementsArgs = {
  input?: InputMaybe<GetPlacementsRequestInput>;
};


export type QueryContentManagementServiceGetThemePageArgs = {
  input?: InputMaybe<GetThemePageRequestInput>;
};


export type QueryContentManagementServiceListThemePagesArgs = {
  input?: InputMaybe<ListThemePagesRequestInput>;
};


export type QueryCurrentEnterpriseAccountAuthorizationCheckArgs = {
  accountFeatureToggles?: InputMaybe<Array<Scalars['String']>>;
  approvalRequestIds?: InputMaybe<Array<Scalars['ID']>>;
  featureEntitlementIds?: InputMaybe<Array<Scalars['ID']>>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  permissionsV2?: InputMaybe<Scalars['PermissionsInput']>;
  requireAllPartnersFullAccess?: InputMaybe<Scalars['Boolean']>;
  requireFullPartnerAccess?: InputMaybe<Scalars['Boolean']>;
  requireFullRetailerAccess?: InputMaybe<Scalars['Boolean']>;
  requireWriteAccess?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  storeConfigIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCustomersOrdersServiceGetHandlingDetailsArgs = {
  input?: InputMaybe<CustomersGetHandlingDetailsRequestInput>;
};


export type QueryCustomersOrdersServiceGetOrderArgs = {
  input?: InputMaybe<CustomersGetOrderRequestInput>;
};


export type QueryCustomersOrdersServiceGetOrderAmountsSummaryV0Args = {
  input?: InputMaybe<CustomersGetOrderAmountsSummaryV0RequestInput>;
};


export type QueryCustomersOrdersServiceGetPaymentMethodSummaryArgs = {
  input?: InputMaybe<CustomersGetPaymentMethodSummaryRequestInput>;
};


export type QueryCustomersOrdersServiceListOrdersArgs = {
  input?: InputMaybe<CustomersListOrdersRequestInput>;
};


export type QueryCustomersOrdersServiceQueryOrderReferenceArgs = {
  input?: InputMaybe<CustomersQueryOrderReferenceRequestInput>;
};


export type QueryCustomersOrdersServiceQueryOrdersArgs = {
  input?: InputMaybe<CustomersQueryOrdersRequestInput>;
};


export type QueryDemeterServiceGetAuditBatchArgs = {
  input?: InputMaybe<GetAuditBatchRequestInput>;
};


export type QueryDemeterServiceGetAuditBatchMetadataArgs = {
  input?: InputMaybe<GetAuditBatchMetadataRequestInput>;
};


export type QueryDemeterServiceGetAuditTaskArgs = {
  input?: InputMaybe<GetAuditTaskRequestInput>;
};


export type QueryDemeterServiceGetAuditWorkflowConfigsArgs = {
  input?: InputMaybe<GetAuditWorkflowConfigsRequestInput>;
};


export type QueryDemeterServiceGetDetectionArgs = {
  input?: InputMaybe<GetDetectionRequestInput>;
};


export type QueryDemeterServiceGetNextAuditBatchArgs = {
  input?: InputMaybe<GetNextAuditBatchRequestInput>;
};


export type QueryDemeterServiceListAuditBatchesArgs = {
  input?: InputMaybe<ListAuditBatchesRequestInput>;
};


export type QueryDemeterServiceListAuditTaskComponentsArgs = {
  input?: InputMaybe<ListAuditTaskComponentsRequestInput>;
};


export type QueryDemeterServiceListAuditWorkflowsArgs = {
  input?: InputMaybe<ListAuditWorkflowsRequestInput>;
};


export type QueryDemeterServiceListDetectionsArgs = {
  input?: InputMaybe<ListDetectionsRequestInput>;
};


export type QueryDemeterServicePrepareToSubmitAuditBatchArgs = {
  input?: InputMaybe<PrepareToSubmitAuditBatchRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetBrandProfileAttributesArgs = {
  input?: InputMaybe<BrandProfileAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetBrandProfileSellSheetCardsArgs = {
  input?: InputMaybe<BrandProfileSellSheetCardsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetBrandSellSheetsAttributesArgs = {
  input?: InputMaybe<BrandSellSheetsAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetEbpAnalyticsArgs = {
  input?: InputMaybe<EbpAnalyticsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetEbpProductAnalyticsSummaryArgs = {
  input?: InputMaybe<ProductAnalyticSummaryRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetEbpProductAttributesArgs = {
  input?: InputMaybe<ProductAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetIndexBrandNamesArgs = {
  input?: InputMaybe<IndexBrandNamesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetIndexEbpCategoriesArgs = {
  input?: InputMaybe<IndexEbpCategoriesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetIndexSellSheetCardsArgs = {
  input?: InputMaybe<SellSheetCardsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetProductBrandProfileAttributesArgs = {
  input?: InputMaybe<ProductBrandProfileAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetProductSellSheetCardsArgs = {
  input?: InputMaybe<ProductSellSheetCardsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetAnalyticsSummaryArgs = {
  input?: InputMaybe<SellSheetAnalyticsSummaryRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetAttributesArgs = {
  input?: InputMaybe<SellSheetAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetBrandProfileAttributesArgs = {
  input?: InputMaybe<SellSheetBrandProfileAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetProductsAttributesArgs = {
  input?: InputMaybe<SellSheetProductsAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetProductsSummaryTraitsArgs = {
  input?: InputMaybe<SellSheetProductsSummaryTraitsRequestInput>;
};


export type QueryEnterpriseAccountArgs = {
  canonicalId?: InputMaybe<Scalars['ID']>;
};


export type QueryEnterpriseAccountSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canonicalIds?: InputMaybe<Array<Scalars['ID']>>;
  email?: InputMaybe<Scalars['String']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']>;
  excludeOutsourcerUsers?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<AccountSortEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  status?: InputMaybe<AccountStatusEnum>;
};


export type QueryFeatureToggleFullyEnabledArgs = {
  featureName: Scalars['String'];
};


export type QueryHealthCheckArgs = {
  metricsToken?: InputMaybe<Scalars['String']>;
};


export type QueryHistoricalStorePerformanceServiceGetAggregatedHistoricalStorePerformanceArgs = {
  input?: InputMaybe<HistoricalStorePerformanceRequestInput>;
};


export type QueryHomePlacementSearchArgs = {
  filter?: InputMaybe<PlacementFilterInput>;
  placementId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<PlacementSortInput>;
};


export type QueryInsightsPortalAuthorizationCheckArgs = {
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_GetAllSegmentDefinitionsArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetAllSegmentDefinitionsRequest_Input>;
};


export type QueryInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_GetSegmentDefinitionArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetSegmentDefinitionRequest_Input>;
};


export type QueryInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_GetSegmentSizeArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetSegmentSizeRequest_Input>;
};


export type QueryInstacart_Ads_V3_EmergingBrandPortalService_GetIndexBrandNamesArgs = {
  input?: InputMaybe<Instacart_Ads_V3_IndexBrandNamesRequest_Input>;
};


export type QueryInstacart_Ads_V3_EmergingBrandPortalService_GetProductAdditionalInfoArgs = {
  input?: InputMaybe<Instacart_Ads_V3_ProductAdditionalInfoRequest_Input>;
};


export type QueryInstacart_Ads_V3_RetailerBlockedAdsService_GetRetailerBlockedAdIdsArgs = {
  input?: InputMaybe<Instacart_Ads_V3_GetRetailerBlockedAdIdsRequest_Input>;
};


export type QueryInstacart_Ads_V3_RetailerReviewToolService_GetDisplayPreviewDataArgs = {
  input?: InputMaybe<Instacart_Ads_V3_GetDisplayPreviewDataRequest_Input>;
};


export type QueryInstacart_Algorithms_Ai_Carousel_Creator_V1_AiCarouselCreatorService_GetSimilarCarouselsArgs = {
  input?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetActiveBenefitsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetActiveBenefitsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetCommonIdentityUsersArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetCommonIdentityUsersRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetCustomerSpendingSummaryArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetCustomerSpendingSummaryRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetHouseholdByUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetHouseholdByUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetInstacartPlusMembershipArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetInstacartPlusMembershipRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetLatestActiveAttributeForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetLinkedUserAccountsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetLinkedUserAccountsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetOrderArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetOrderRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListAddressesForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListAddressesForUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListNotesForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListNotesForUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListOrderChatMessagesAndNotesArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListOrdersByCustomerArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByCustomerRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListRestaurantOrdersByCustomerArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetAuditReviewArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetAuditReviewsWithFeedbackArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetNextAuditReviewArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetNextAuditReviewRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetWorkflowMetadataArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetL2CategoriesArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetL2CategoriesRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetMissingCodesForcemarkDetailsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetMissingCodesForcemarksArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetMissingCodesReviewedForcemarksArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MlPriceAnomalyService_GetMlPriceAnomalyProductDetailsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MlPriceAnomalyService_GetMlPriceAnomalyProductsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetPriceAlertProductDetailsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetPriceAlertProductsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetPriceAlertProductsCategoriesArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetRetailerDiscountInitialThresholdsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetRetailerDiscountThresholdsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_TaxonomyService_SearchTaxonomyNodesArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_SearchTaxonomyNodesRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_TempOverrideService_ListArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideServiceListRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_DescribeSnowflakeTableArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetPresignedUploadUrlArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetStepRunResultsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetStepRunResultsRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetStepVersionArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetStepVersionRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetStepVersionHistoryArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetStepVersionHistoryRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_ListStepRunsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_ListStepRunsRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_ListStepVersionsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_ListStepVersionsRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_ListStepsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_ListStepsRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_GetBatchArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_GetBatchRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_GetBatchStatusArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_GetBatchStatusRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_GetBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_GetBridgeRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_ListBatchesArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_ListBatchesRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_ListBridgesArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_ListBridgesRequest_Input>;
};


export type QueryInstacart_Catalog_Health_V1_CatalogHealthService_GetProductCountsArgs = {
  input?: InputMaybe<Instacart_Catalog_Health_V1_GetProductCountsRequest_Input>;
};


export type QueryInstacart_Checkout_V1_PosDataService_GetTenderTransactionsByWhlIdsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsRequest_Input>;
};


export type QueryInstacart_Customers_Basket_Products_Orchestrators_V1_BasketProductsOrchestratorsService_GetBasketProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramContentByProgramIdArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramOffersByProgramIdArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_ListBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_ListBusinessesArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetBucketDownloadUrlArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetBucketUploadUrlArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetBucketUploadUrlRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetCsvFoundEntriesCountArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetCsvProcessingSummaryArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetGroupedSlotsArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetMarketingAgentCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_ListMarketingAgentCampaignsArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_ValidateMarketingAgentScheduleArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleRequest_Input>;
};


export type QueryInstacart_Customers_Commerce_Coupons_V1_CommerceCouponsService_GetRedemptionCodeExistsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsRequest_Input>;
};


export type QueryInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_GetValueGrantPolicyFacadeArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_CouponsDomainService_GetCouponCodeExistsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetCouponCodeExistsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetCampaignLinksArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetCampaignLinksRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetMomentRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetMomentParticipatingRetailersArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetMomentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetMomentsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetRetailerCampaignRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_ListMomentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_ListMomentsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_ListRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_ListRetailerCampaignsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_Input>;
};


export type QueryInstacart_Customers_Express_V1_ExpressService_GetCurrentExpressMemberStatusForUserArgs = {
  input?: InputMaybe<Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunDebugArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunImageArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunStatusArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_ListRuleSetRunStatusesArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_ListRuleSetRunsArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_ValidateRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetRequest_Input>;
};


export type QueryInstacart_Customers_Gifting_V1_GiftOrderDigitalCardService_GetGiftOrderDigitalCardByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_GetLoyaltyBenefitsArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_GetLoyaltyCardValidationsArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_GetLoyaltyProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_V1_LoyaltyService_GetLoyaltyCardsByCardNumberArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_V1_LoyaltyService_GetLoyaltyCardsForUserArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Input>;
};


export type QueryInstacart_Customers_Offers_Tooling_Orchestrator_V1_OffersToolingService_PrepareCreateOfferPayloadArgs = {
  input?: InputMaybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadRequest_Input>;
};


export type QueryInstacart_Customers_Orders_V1_OrdersService_GetOrderLinesArgs = {
  input?: InputMaybe<Instacart_Customers_Orders_V1_GetOrderLinesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetCountriesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetCountriesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetPartnersArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetPartnersRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetPostalCodesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetPostalCodesByZonesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRegionsArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRegionsRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailerLocationsArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailerLocationsByRetailerArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailerZonesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerZonesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailersArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailersRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetZonesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetZonesByRegionArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesByRegionRequest_Input>;
};


export type QueryInstacart_Customers_Partnership_Offer_V1_PartnershipOfferService_GetPartnershipManagementUrlDownloadLinkArgs = {
  input?: InputMaybe<Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkRequest_Input>;
};


export type QueryInstacart_Customers_Partnership_Offer_V1_PartnershipOfferService_ListPartnershipManagementUrlsArgs = {
  input?: InputMaybe<Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_ProductRetrievalService_GetLegacyProductsWithFiltersArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_GetAggregatedItemDataArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_GetItemsArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_GetRetailerProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_SearchRetailerBrandsArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetCategoriesByNameArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetCategoriesByNameRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetCoreIngredientsArgs = {
  input?: InputMaybe<Scalars['instacart_customers_recipes_v1_GetCoreIngredientsRequest_Input']>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetRecipeByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetRecipeByIdRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetRecipeByIdForDashboardArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetRecipeByIdRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetRecipesRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_ListRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_ValidateAndUploadRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CheckBulkEditStatusArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerActivitiesArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerClickableAreasArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerMetadataArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerPipelineDebugArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerPresignedUrlsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerStatsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerTagsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerUploadDetailsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_ListFlyersArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetCollectionPreviewProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetCollectionRulesArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetLowerPriceDefinitionsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetNavigationTreeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetRetailerCsvArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListCollectionProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListCollectionsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListGlobalCollectionsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListRetailerDepartmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_SearchCollectionProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ValidateCollectionSlugArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_GetIppDraftByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_ListIppDraftsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftPreviewService_GetIppPreviewByTokenArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftPreviewService_GetPreviewAuthTokenArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_WidgetConfigurationService_GetWidgetConfigurationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationRequest_Input>;
};


export type QueryInstacart_Customers_Search_Results_V2_SearchResultsService_GetProductEsciLabelArgs = {
  input?: InputMaybe<Instacart_Customers_Search_Results_V2_GetProductEsciLabelRequest_Input>;
};


export type QueryInstacart_Customers_Search_V1_SearchService_GetSearchTermOverridesArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesRequest_Input>;
};


export type QueryInstacart_Customers_Search_V1_SearchService_GetSearchTermOverridesByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesByIdRequest_Input>;
};


export type QueryInstacart_Enterprise_Boba_Core_Offers_V1_OfferService_GetOrderDiscountInfoArgs = {
  input?: InputMaybe<Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurationsArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurationsListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryOrderOverviewArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRouteArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRouteListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehiclesService_GetWarehouseLocationVehicleListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetDashboardOrderSearchResultListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOperationArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderAdjustmentPolicyListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderCancellationPolicyListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderLineListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderStateChangeListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardUserService_GetDashboardUserSearchResultListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_EnterpriseServiceOptionService_GetEnterpriseServiceOptionListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_RetailerProductDetailsService_GetRetailerProductDetailsArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Post_Checkout_V1_EnterpriseChatService_GetEnterpriseChatMessageListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_GetPartnerManagedShiftListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShoppersService_GetPartnerManagedShopperListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedStaffingService_GetStaffingHoursListByDateArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationsService_GetPresignedDownloadUrlArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationsService_GetShiftManagementOperationRecordArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationsService_GetShiftManagementOperationRecordListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationService_GetStaffingAllocationListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListRequest_Input>;
};


export type QueryInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_OrderSimulationService_GetCheckoutStateAndBarcodeArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobDetailsArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobDetailsRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobResultsArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobResultsRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobSourcesArgs = {
  input?: InputMaybe<Scalars['instacart_flawless_inventory_v1_GetJobSourcesRequest_Input']>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobStatusArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobStatusRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobsArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobsRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetMapleSupportedModelsArgs = {
  input?: InputMaybe<Scalars['instacart_flawless_inventory_v1_GetMapleSupportedModelsRequest_Input']>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_GetAuditLogsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_GetStepLogAuditMetricsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditMetricsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_GetStepLogAuditsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_GetStepLogsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_GetStepTypesArgs = {
  input?: InputMaybe<Scalars['instacart_fulfillment_shopper_transaction_integrity_v1_GetStepTypesRequest_Input']>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizationService_GetCategorizationAnalysisArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetCampaignStatusArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetEmailUnsubscribeListsArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetIntentionConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetRetailerConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetSegmentSizeArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetTemplateArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_ListEditableTemplateVariablesArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_ListSegmentsArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_ListTemplatesArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesRequest_Input>;
};


export type QueryInstacart_Infra_Instaform_V1_InstaformService_GetModuleByNameArgs = {
  input?: InputMaybe<Instacart_Infra_Instaform_V1_GetModuleByNameRequest_Input>;
};


export type QueryInstacart_Infra_Instaform_V1_InstaformService_GetModulesArgs = {
  input?: InputMaybe<Instacart_Infra_Instaform_V1_GetModulesRequest_Input>;
};


export type QueryInstacart_Infra_Totem_V1_TotemService_GetEntityArgs = {
  input?: InputMaybe<Instacart_Infra_Totem_V1_GetEntityRequest_Input>;
};


export type QueryInstacart_Infra_Totem_V1_TotemService_GetSystemArgs = {
  input?: InputMaybe<Instacart_Infra_Totem_V1_GetSystemRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_GetOpsEscalationRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_ListBulkDuplicateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_ListDuplicateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_ListOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_GetFulfillmentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_GetFulfillmentEventRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_GetFulfillmentEventsByIdArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_GetFulfillmentEventsByIdRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListChildFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ListChildFulfillmentEventsRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListCreatorsArgs = {
  input?: InputMaybe<Scalars['instacart_logistics_v1_ListCreatorsRequest_Input']>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ListFulfillmentEventsRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListTagsArgs = {
  input?: InputMaybe<Scalars['instacart_logistics_v1_ListTagsRequest_Input']>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ValidateNewClosureEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ValidateNewClosureEventRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ValidateNewFulfillmentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ValidateNewFulfillmentEventRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ValidateNewRestrictedAvailabilityEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_DownloadInterventionDataArgs = {
  input?: InputMaybe<Instacart_Massops_V1_DownloadInterventionDataRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetIncidentArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetIncidentRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCommunicationSettingsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCommunicationSettingsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCountsByArtifactTypeArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCountsByArtifactTypeRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCountsByIncidentArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCountsByIncidentRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCountsByInterventionTypeArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCountsByInterventionTypeRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionPreExecutionSummaryArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionPreExecutionSummaryRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionStatisticsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionStatisticsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionTypeArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionTypeRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionTypeIdForInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionTypeIdForInterventionRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetNotificationTemplateArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetNotificationTemplateRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetTotalFinancialImpactArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetTotalFinancialImpactRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionApprovalRequestsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionTypesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionTypesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListNotificationTemplatesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListNotificationTemplatesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListTasksArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListTasksRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListTemplateVariablesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListTemplateVariablesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_PreviewInterventionDataArgs = {
  input?: InputMaybe<Instacart_Massops_V1_PreviewInterventionDataRequest_Input>;
};


export type QueryInstacart_Partners_Data_Ingestion_V1_ChangeApprovalService_GetChangeApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FileService_GetCsvValidationResultArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipDashboardArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipDashboardRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipEnrollmentDetailArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipEnrollmentsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentsRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipFeatureGroupsArgs = {
  input?: InputMaybe<Scalars['instacart_partners_partners_v1_GetFlipFeatureGroupsRequest_Input']>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipFeaturesArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipFeaturesRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipNoteHistoryArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipNoteHistoryRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_ListFlipNotesArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ListFlipNotesRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_MobileAppsManagementService_GetWhitelabelAppArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetWhitelabelAppRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_MobileAppsManagementService_GetWhitelabelAppsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetWhitelabelAppsRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_PartnerConfigurationsService_GetPartnerConfigurationTypesPaginatedArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_PartnerConfigurationsService_GetPartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_PartnerConfigurationsService_GetPartnerConfigurationsPaginatedArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_Input>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetAutomationsArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetAutomationsRequest_Input']>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetConnectionsArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetConnectionsRequest_Input']>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetStoresArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetStoresRequest_Input']>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetSyncStrategiesArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetSyncStrategiesRequest_Input']>;
};


export type QueryInstacart_Retailer_Tools_Growth_Targeting_V1_GrowthTargetingToolingService_GetTargetingFeaturesArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Growth_Targeting_V1_GetTargetingFeaturesRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetEntitlementDetailsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetEntitlementsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetPackageDetailsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetPackagesArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetRetailerEntitlementProfileDetailsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetRetailerEntitlementProfilesArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_DownloadInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalCustomReportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalFilterOptionsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalMultiDimensionDatasetArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_ListInsightsPortalCustomExportsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_ListInsightsPortalCustomReportsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsRequest_Input>;
};


export type QueryInstacart_Retailers_V1_AppeasementsService_GetAppeasementsByUserArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetAppeasementsByUserRequest_Input>;
};


export type QueryInstacart_Retailers_V1_AppeasementsService_GetCreditsByUserArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetCreditsByUserRequest_Input>;
};


export type QueryInstacart_Retailers_V1_RetailersService_GetWidgetsConfigArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetWidgetsConfigRequest_Input>;
};


export type QueryInstacart_Retailers_V1_RetailersService_ValidateWidgetsConfigArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_ValidateWidgetsConfigRequest_Input>;
};


export type QueryInstacart_Retailers_V1_StoreConfigurationsService_GetStoreConfigurationsForRetailersArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetStoreConfigurationsForRetailersRequest_Input>;
};


export type QueryInstacart_Roulette_V1_RouletteService_GetFeatureByNameAndVersionArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_GetFeatureByNameAndVersionRequest_Input>;
};


export type QueryInstacart_Roulette_V1_RouletteService_ListFeaturesArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_GetFeaturesRequest_Input>;
};


export type QueryInstacart_Roulette_V1_RouletteService_SearchFeaturesArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetIntegrationVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetIntegrationVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetIntegrationsArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetIntegrationsRequest_Input']>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetProfileVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetProfileVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetProfilesArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetProfilesRequest_Input']>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetRetailerVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetRetailerVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetRetailersArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetRetailersRequest_Input']>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetStoreVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetStoreVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetStoresArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetStoresRequest_Input']>;
};


export type QueryInstacart_Upos_Status_V1_StatusService_GetIntegrationStatusesArgs = {
  input?: InputMaybe<Scalars['instacart_upos_status_v1_GetIntegrationStatusesRequest_Input']>;
};


export type QueryInstacart_Waves_V1_WavesService_DescribeSnowflakeTableArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DescribeSnowflakeTableRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetStepVersionArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetStepVersionRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetStepVersionHistoryArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetStepVersionHistoryRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetWorkflowRunArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetWorkflowRunRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepFilterTagsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepFilterTagsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepRunsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepRunsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepVersionsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepVersionsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListWorkflowRunsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListWorkflowRunsRequest_Input>;
};


export type QueryInventoryIntelligenceServiceGetAcknowledgedOosIdsArgs = {
  input?: InputMaybe<GetAcknowledgedOosIdsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetAisleRestockSummaryArgs = {
  input?: InputMaybe<GetAisleRestockSummaryRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetKpiArgs = {
  input?: InputMaybe<GetKpiRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetRestockRankingListArgs = {
  input?: InputMaybe<GetRestockRankingListRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetShelfViewArgs = {
  input?: InputMaybe<GetShelfViewRequestInput>;
};


export type QueryLinkAutosuggestServiceListLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<ListLinkAutosuggestionAdminRequestInput>;
};


export type QueryMarketingFeatureBrazeSegmentSizeArgs = {
  segmentId: Scalars['ID'];
};


export type QueryMarketingFeatureCampaignStatusArgs = {
  campaignId: Scalars['ID'];
};


export type QueryMarketingFeatureTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
  pushNotificationId?: InputMaybe<Scalars['ID']>;
};


export type QueryNormalizedReportSignedUrlArgs = {
  bucketName: Scalars['String'];
  s3Key: Scalars['String'];
};


export type QueryNormalizedReportTypesArgs = {
  filterUnavailable?: InputMaybe<Scalars['Boolean']>;
  partnerId: Scalars['ID'];
};


export type QueryNormalizedReportsSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['ID'];
  reportType?: InputMaybe<ReportTypeEnum>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationGroupId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['ISO8601Date'];
};


export type QueryNotificationChannelsForCurrentAccountArgs = {
  scopeId?: InputMaybe<Scalars['ID']>;
  scopeType: NotificationScopeTypeEnum;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  scopeType?: InputMaybe<NotificationScopeTypeEnum>;
  severity?: InputMaybe<NotificationSeverityEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type QueryOnboardingMobileAppConfigArgs = {
  os: Os;
  storeConfigurationId: Scalars['Int'];
};


export type QueryOnboardingServiceCheckLaunchOnboardingProgressByPartnerArgs = {
  input?: InputMaybe<CheckLaunchOnboardingProgressByPartnerRequestInput>;
};


export type QueryOnboardingServiceGetApprovalRequestsArgs = {
  input?: InputMaybe<GetApprovalRequestsRequestInput>;
};


export type QueryOnboardingServiceGetBuildkiteArtifactDownloadUrlArgs = {
  input?: InputMaybe<GetBuildkiteArtifactDownloadUrlRequestInput>;
};


export type QueryOnboardingServiceGetBuildkiteArtifactsArgs = {
  input?: InputMaybe<GetBuildkiteArtifactsRequestInput>;
};


export type QueryOnboardingServiceGetCatalogFaqFileArgs = {
  input?: InputMaybe<GetCatalogFaqFileRequestInput>;
};


export type QueryOnboardingServiceGetFormGroupsArgs = {
  input?: InputMaybe<GetFormGroupsRequestInput>;
};


export type QueryOnboardingServiceGetLaunchOnboardingArgs = {
  input?: InputMaybe<GetLaunchOnboardingRequestInput>;
};


export type QueryOnboardingServiceGetLaunchOnboardingWarehouseLocationsArgs = {
  input?: InputMaybe<GetLaunchOnboardingWarehouseLocationsRequestInput>;
};


export type QueryOnboardingServiceGetOnboardingArgs = {
  input?: InputMaybe<GetOnboardingRequestInput>;
};


export type QueryOnboardingServiceGetOnboardingAttributesArgs = {
  input?: InputMaybe<GetOnboardingAttributesRequestInput>;
};


export type QueryOnboardingServiceGetSignupPartnerArgs = {
  input?: InputMaybe<GetSignupPartnerRequestInput>;
};


export type QueryOnboardingServiceGetTestCasesArgs = {
  input?: InputMaybe<GetTestCasesRequestInput>;
};


export type QueryOnboardingServiceGetWaterfallEffectArgs = {
  input?: InputMaybe<GetWaterfallEffectRequestInput>;
};


export type QueryOnboardingServiceGetWaterfallEffectsArgs = {
  input?: InputMaybe<GetWaterfallEffectsRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelGumloopWorkflowResultsArgs = {
  input?: InputMaybe<GetWhitelabelGumloopWorkflowResultsRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSiteTestRunBuildArgs = {
  input?: InputMaybe<GetWhitelabelSiteTestRunBuildRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSiteTestRunsArgs = {
  input?: InputMaybe<GetWhitelabelSiteTestRunsRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSitesArgs = {
  input?: InputMaybe<GetWhitelabelSitesRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSitesAdminArgs = {
  input?: InputMaybe<GetWhitelabelSitesAdminRequestInput>;
};


export type QueryOnboardingServiceSearchWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<SearchWhitelabelSiteCustomizableStringRequestInput>;
};


export type QueryOnboardingWorkflowArgs = {
  filter?: InputMaybe<WorkflowQueryFilter>;
  storeConfigurationId: Scalars['Int'];
};


export type QueryOrderServiceGetDashboardOrderArgs = {
  input?: InputMaybe<GetDashboardOrderRequestInput>;
};


export type QueryOrderServiceGetDashboardOrdersArgs = {
  input?: InputMaybe<GetDashboardOrdersRequestInput>;
};


export type QueryOrderServiceGetOrderArgs = {
  input?: InputMaybe<GetOrderRequestInput>;
};


export type QueryOrderServiceGetOrderLocationArgs = {
  input?: InputMaybe<GetOrderLocationRequestInput>;
};


export type QueryOrderServiceGetOrderStateChangesArgs = {
  input?: InputMaybe<GetOrderStateChangesRequestInput>;
};


export type QueryOrderSourcesArgs = {
  retailerId: Scalars['ID'];
};


export type QueryPartnerArgs = {
  id: Scalars['ID'];
};


export type QueryPartnerPickDeviceArgs = {
  id: Scalars['ID'];
};


export type QueryPartnerPickDeviceSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  warehouseLocationId: Scalars['ID'];
};


export type QueryPartnerPickGetCapacityRecommendationsArgs = {
  date: Scalars['ISO8601Date'];
  retailerLocationId: Scalars['ID'];
};


export type QueryPartnerPickRecurringShiftConflictCheckArgs = {
  daysOfWeek: Array<Scalars['Int']>;
  driverId: Scalars['ID'];
  existingDriverShiftId?: InputMaybe<Scalars['ID']>;
  existingRecurringShiftId?: InputMaybe<Scalars['ID']>;
  recurEndDate?: InputMaybe<Scalars['String']>;
  recurStartDate?: InputMaybe<Scalars['String']>;
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  warehouseLocationId: Scalars['ID'];
};


export type QueryPartnerRetailerSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerType?: InputMaybe<Scalars['String']>;
};


export type QueryPartnerSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerType?: InputMaybe<Scalars['String']>;
};


export type QueryPartnerSearchArrayArgs = {
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<Scalars['String']>;
};


export type QueryPartnersArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPermissionsArgs = {
  retailerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
};


export type QueryPickupRetailerLocationGroupArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  retailerId: Scalars['ID'];
};


export type QueryPrivacyServiceGetPiiRequestsForRetailerArgs = {
  input?: InputMaybe<GetPiiRequestsForRetailerRequestInput>;
};


export type QueryProductDataServiceGetProductDataArgs = {
  input?: InputMaybe<GetProductDataRequestInput>;
};


export type QueryProductSourceServiceGetProductSourcesArgs = {
  input?: InputMaybe<GetProductSourcesRequestInput>;
};


export type QueryProductsServiceGetFlattenedTaxonomiesArgs = {
  input?: InputMaybe<GetFlattenedTaxonomiesRequestInput>;
};


export type QueryProductsServiceGetLegacyElasticsearchArgs = {
  input?: InputMaybe<GetLegacyElasticsearchRequestInput>;
};


export type QueryProductsServiceGetLegacyItemsShoppersArgs = {
  input?: InputMaybe<GetLegacyItemsShoppersRequestInput>;
};


export type QueryProductsServiceGetLegacyProductsArgs = {
  input?: InputMaybe<GetLegacyProductsRequestInput>;
};


export type QueryProductsServiceGetManagedAttributeValuesForRetailerArgs = {
  input?: InputMaybe<GetManagedAttributeValuesForRetailerRequestInput>;
};


export type QueryProductsServiceSearchBrandsArgs = {
  input?: InputMaybe<SearchBrandsRequestInput>;
};


export type QueryQualityScorecardsAggScorecardsArgs = {
  ippTotemEntity?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
};


export type QueryQualityScorecardsPlatformStatsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type QueryReportRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId: Scalars['ID'];
};


export type QueryReportViewArgs = {
  reportViewId: Scalars['ID'];
};


export type QueryRetailerArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerAislesGetRetailerAisleTemplateArgs = {
  input?: InputMaybe<GetRetailerAisleTemplateRequestInput>;
};


export type QueryRetailerAislesGetRetailerLocationByLayoutArgs = {
  input?: InputMaybe<GetRetailerLocationByLayoutRequestInput>;
};


export type QueryRetailerCampaignServiceGetMomentArgs = {
  input?: InputMaybe<GetMomentRequestInput>;
};


export type QueryRetailerCampaignServiceGetMomentParticipatingRetailersArgs = {
  input?: InputMaybe<GetMomentParticipatingRetailersRequestInput>;
};


export type QueryRetailerCampaignServiceGetMomentsArgs = {
  input?: InputMaybe<GetMomentsRequestInput>;
};


export type QueryRetailerCampaignServiceGetRetailerCampaignArgs = {
  input?: InputMaybe<GetRetailerCampaignRequestInput>;
};


export type QueryRetailerCampaignServiceListMomentsArgs = {
  input?: InputMaybe<ListMomentsRequestInput>;
};


export type QueryRetailerCampaignServiceListRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<ListRetailerCampaignTreatmentsRequestInput>;
};


export type QueryRetailerCampaignServiceListRetailerCampaignsArgs = {
  input?: InputMaybe<ListRetailerCampaignsRequestInput>;
};


export type QueryRetailerLocationArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerLocationGroupArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerLocationGroupsByRetailerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  matchType?: InputMaybe<RetailerLocationGroupQuery>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerLocationSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeInactiveLocations?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerLocationSearchArrayArgs = {
  includeInactiveLocations?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerManagementServiceGetClientConfigurationByIdArgs = {
  input?: InputMaybe<GetClientConfigurationByIdRequestInput>;
};


export type QueryRetailerManagementServiceGetConnectRetailerCallbackConfigurationByIdArgs = {
  input?: InputMaybe<GetConnectRetailerCallbackConfigurationByIdRequestInput>;
};


export type QueryRetailerManagementServiceGetConnectRetailerCallbackConfigurationsArgs = {
  input?: InputMaybe<GetConnectRetailerCallbackConfigurationsRequestInput>;
};


export type QueryRetailerManagementServiceGetPartnerOauthApplicationsArgs = {
  input?: InputMaybe<GetPartnerOauthApplicationsRequestInput>;
};


export type QueryRetailerMfaConfigArgs = {
  retailerId: Scalars['ID'];
};


export type QueryRetailerPickupMetadataArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerProductAttributeEditServiceGetAvailabilityScoreOverrideArgs = {
  input?: InputMaybe<GetAvailabilityScoreOverrideRequestInput>;
};


export type QueryRetailerProductAttributeEditServiceGetRetailerProductAssortmentArgs = {
  input?: InputMaybe<GetRetailerProductAssortmentRequestInput>;
};


export type QueryRetailerSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerSearchArrayArgs = {
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerSettingServiceGetSettingArgs = {
  input?: InputMaybe<GetSettingRequestInput>;
};


export type QueryRetailerSettingsServiceGetIsGrocerArgs = {
  input?: InputMaybe<GetIsGrocerRequestInput>;
};


export type QueryRetailerSettingsServiceGetParkingSettingsArgs = {
  input?: InputMaybe<GetParkingSettingsRequestInput>;
};


export type QueryRetailerSettingsServiceGetPickupSettingsMetadataArgs = {
  input?: InputMaybe<GetPickupSettingsMetadataRequestInput>;
};


export type QueryRetailerSettingsServiceGetStagingSettingsArgs = {
  input?: InputMaybe<GetStagingSettingsRequestInput>;
};


export type QueryRetailerStoreHoursGetConfirmedStoreHoursArgs = {
  input?: InputMaybe<GetConfirmedStoreHoursRequestInput>;
};


export type QueryRetailerStoreHoursGetRetailerHolidaysStatusArgs = {
  input?: InputMaybe<GetHolidaysStatusRequestInput>;
};


export type QueryRetailerStoreHoursGetStoreHoursArgs = {
  input?: InputMaybe<GetStoreHoursRequestInput>;
};


export type QueryRetailerStoreHoursGetStoreHoursUpdateTasksArgs = {
  input?: InputMaybe<GetStoreHoursUpdateTasksRequestInput>;
};


export type QueryRetailerToolsServiceGetCustomersContextArgs = {
  input?: InputMaybe<GetCustomersContextRequestInput>;
};


export type QueryRetailerToolsServiceGetItemsArgs = {
  input?: InputMaybe<GetItemsRequestInput>;
};


export type QueryRetailerToolsServiceGetRetailerProductsArgs = {
  input?: InputMaybe<GetRetailerProductsRequestInput>;
};


export type QueryRetailerToolsServiceGetVirtualRetailersArgs = {
  input?: InputMaybe<GetVirtualRetailersRequestInput>;
};


export type QueryRetailersServiceGetPlatformVersionsArgs = {
  input?: InputMaybe<GetPlatformVersionsRequestInput>;
};


export type QueryRetailersServiceGetRetailerLocationsByLocationCodesArgs = {
  input?: InputMaybe<GetRetailerLocationsByLocationCodesRequestInput>;
};


export type QueryRetailersServiceGetRetailerLocationsDetailsArgs = {
  input?: InputMaybe<GetRetailerLocationsDetailsRequestInput>;
};


export type QueryRetailersServiceGetRetailerRegionsArgs = {
  input?: InputMaybe<GetRetailerRegionsRequestInput>;
};


export type QueryRoleSearchArgs = {
  assignableByAccountUuid?: InputMaybe<Scalars['ID']>;
  attainableByAccountUuid?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  includeInstacartManaged?: InputMaybe<Scalars['Boolean']>;
  instacartManagedOnly?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryRppBulkImageUploadsServiceGetImageUploadBatchDetailsArgs = {
  input?: InputMaybe<GetImageUploadBatchDetailsRequestInput>;
};


export type QueryRppBulkImageUploadsServiceGetImageUploadBatchesArgs = {
  input?: InputMaybe<GetImageUploadBatchesRequestInput>;
};


export type QueryServiceOptionServiceGetServiceOptionsArgs = {
  input?: InputMaybe<GetServiceOptionsRequestInput>;
};


export type QueryStoreConfigurationByIdArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryStoreConfigurationsByPartnerIdArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  partnerId: Scalars['ID'];
  storeConfigRelationship: StoreConfigurationRelationshipEnum;
};


export type QueryStoreConfigurationsByRetailerIdsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  retailerIds: Array<Scalars['ID']>;
  storeConfigRelationship: StoreConfigurationRelationshipEnum;
};


export type QueryStoreConfigurationsDraftServiceGetStoreConfigurationDraftsArgs = {
  input?: InputMaybe<GetStoreConfigurationDraftsRequestInput>;
};


export type QueryStoreConfigurationsDraftServiceReadLatestStoreConfigurationDraftArgs = {
  input?: InputMaybe<ReadLatestStoreConfigurationDraftRequestInput>;
};


export type QueryStoreConfigurationsDraftServiceReadStoreConfigurationArgs = {
  input?: InputMaybe<ReadStoreConfigurationRequestInput>;
};


export type QueryStorePerformanceServiceGetAggregatedStorePerformanceArgs = {
  input?: InputMaybe<StorePerformanceRequestInput>;
};


export type QueryStorefrontPlacementArgs = {
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
};


export type QueryStorefrontPlacementSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PlacementFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId: Scalars['ID'];
  sort?: InputMaybe<PlacementSortInput>;
};


export type QueryUserAccessSettingsArgs = {
  email: Scalars['String'];
};


export type QueryUserSettingServiceListUserSettingsArgs = {
  input?: InputMaybe<ListUserSettingsRequestInput>;
};


export type QueryUsersServiceBatchGetUsersByIdsStrictArgs = {
  input?: InputMaybe<BatchGetUsersByIdsStrictRequestInput>;
};


export type QueryUsersServiceGetUserByIdFilteredByIsolationContextArgs = {
  input?: InputMaybe<GetUserByIdFilteredByIsolationContextRequestInput>;
};


export type QueryUsersServiceGetUsersByStoreConfigurationIdArgs = {
  input?: InputMaybe<GetUsersByStoreConfigurationIdRequestInput>;
};


export type QueryUsersServiceListUsersByPersonalIdentifiersStrictArgs = {
  input?: InputMaybe<ListUsersByPersonalIdentifiersStrictRequestInput>;
};


export type QueryValueBasedOverrideServiceGetValueBasedOverridesArgs = {
  input?: InputMaybe<GetValueBasedOverridesRequestInput>;
};


export type QueryVisibilityConditionSearchArgs = {
  placementId?: InputMaybe<Scalars['ID']>;
  visibilityConditionId?: InputMaybe<Scalars['ID']>;
};


export type QueryWelcomeModalArgs = {
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationId?: InputMaybe<Scalars['ID']>;
};


export type QueryWizardProgressArgs = {
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationId: Scalars['ID'];
  wizardType: WizardTypeEnum;
};

export type RadiusSchema = {
  __typename?: 'RadiusSchema';
  r0: Maybe<Scalars['BigInt']>;
  r4: Maybe<Scalars['BigInt']>;
  r8: Maybe<Scalars['BigInt']>;
  r12: Maybe<Scalars['BigInt']>;
  r24: Maybe<Scalars['BigInt']>;
};

export type ReadLatestStoreConfigurationDraftRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ReadLatestStoreConfigurationDraftResponse = {
  __typename?: 'ReadLatestStoreConfigurationDraftResponse';
  domainConfigurations: Maybe<DomainConfiguration>;
  domainConfigurationsRaw: Maybe<Scalars['JSONObject']>;
  draftId: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  errorReason: Maybe<ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type ReadStoreConfigurationRequestInput = {
  draftId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ReadStoreConfigurationResponse = {
  __typename?: 'ReadStoreConfigurationResponse';
  domainConfigurations: Maybe<DomainConfiguration>;
  domainConfigurationsRaw: Maybe<Scalars['JSONObject']>;
  draftId: Maybe<Scalars['String']>;
  draftName: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  errorReason: Maybe<ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
  parentDraftId: Maybe<Scalars['String']>;
  publishedAt: Maybe<Scalars['DateTime']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
};

export type ReassignAuditBatchWorkflowRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  newWorkflow?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type ReassignAuditBatchWorkflowResponse = {
  __typename?: 'ReassignAuditBatchWorkflowResponse';
  completedAt: Maybe<Scalars['DateTime']>;
  message: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
};

export type RecipeEntryItem = {
  __typename?: 'RecipeEntryItem';
  recipeId: Maybe<Scalars['String']>;
};

export enum RecommendationTypeEnum {
  DemandSurge = 'DEMAND_SURGE',
  NoRunner = 'NO_RUNNER'
}

export type RedeemPartnershipOffer = {
  __typename?: 'RedeemPartnershipOffer';
  partnershipBenefitName: Maybe<Scalars['String']>;
  partnershipOfferName: Maybe<Scalars['String']>;
};

export type RedeemPartnershipOfferInput = {
  partnershipBenefitName?: InputMaybe<Scalars['String']>;
  partnershipOfferName?: InputMaybe<Scalars['String']>;
};

export enum RedemptionMethod {
  RedemptionMethodAutoApply = 'REDEMPTION_METHOD_AUTO_APPLY',
  RedemptionMethodAutoRedeem = 'REDEMPTION_METHOD_AUTO_REDEEM',
  RedemptionMethodClickToRedeem = 'REDEMPTION_METHOD_CLICK_TO_REDEEM',
  RedemptionMethodCouponCode = 'REDEMPTION_METHOD_COUPON_CODE',
  RedemptionMethodRedeemOnCompletion = 'REDEMPTION_METHOD_REDEEM_ON_COMPLETION',
  RedemptionMethodUnknown = 'REDEMPTION_METHOD_UNKNOWN'
}

export type Region = {
  __typename?: 'Region';
  id: Maybe<Scalars['BigInt']>;
  locationCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  states: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RegularHours = {
  __typename?: 'RegularHours';
  dayOfWeek: Maybe<GoogleTypeDayOfWeek>;
  endTime: Maybe<GoogleTypeTimeOfDay>;
  serviceType: Maybe<RetailerServiceType>;
  startTime: Maybe<GoogleTypeTimeOfDay>;
};

export type RegularHoursInput = {
  dayOfWeek?: InputMaybe<GoogleTypeDayOfWeek>;
  endTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
  serviceType?: InputMaybe<RetailerServiceType>;
  startTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
};

export enum RejectionReasonEnum {
  /** Whether the authorization check failed because of lack of all partners full access */
  NoAllPartnersFullAccess = 'no_all_partners_full_access',
  /** Whether the authorization check failed because of lack of full partner access */
  NoFullPartnerAccess = 'no_full_partner_access',
  /** Whether the authorization check failed because of lack of full retailer access */
  NoFullRetailerAccess = 'no_full_retailer_access',
  /** Whether the authorization check failed because of lack of partner write access */
  NoPartnerWriteAccess = 'no_partner_write_access',
  /** Whether the authorization check failed because of lack of write access */
  NoWriteAccess = 'no_write_access',
  /** Whether the authorization check failed because of inaccessible approval requests */
  UnauthorizedApprovalRequests = 'unauthorized_approval_requests',
  /** Whether the authorization check failed because of unauthorized partners */
  UnauthorizedPartners = 'unauthorized_partners',
  /** Whether the authorization check failed because of unauthorized retailer locations */
  UnauthorizedRetailerLocations = 'unauthorized_retailer_locations',
  /** Whether the authorization check failed because of unauthorized retailers */
  UnauthorizedRetailers = 'unauthorized_retailers',
  /** Whether the authorization check failed because of unauthorized access to store configuration */
  UnauthorizedStoreConfigs = 'unauthorized_store_configs',
  /** Whether the authorization check failed because missing entitlements */
  UnmetFeatureEntitlements = 'unmet_feature_entitlements',
  /** Whether the authorization check failed because of unmet feature toggles */
  UnmetFeatureToggles = 'unmet_feature_toggles',
  /** Whether the authorization check failed because of unmet permissions */
  UnmetPermissions = 'unmet_permissions'
}

export type RenewSubscriptionIntoAnnual = {
  __typename?: 'RenewSubscriptionIntoAnnual';
  id: Maybe<Scalars['BigInt']>;
};

export type RenewSubscriptionIntoAnnualInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RenewSubscriptionIntoMonthly = {
  __typename?: 'RenewSubscriptionIntoMonthly';
  id: Maybe<Scalars['BigInt']>;
};

export type RenewSubscriptionIntoMonthlyInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ReopenLastmileOrderRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type ReopenLastmileOrderResponse = {
  __typename?: 'ReopenLastmileOrderResponse';
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

/** A report filter definition */
export type ReportFilterDefinitionsInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Whether this filter is required */
  required: Scalars['Boolean'];
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export enum ReportFilterTypeEnum {
  /** A filter that allows selection of a date range. */
  DateRange = 'DATE_RANGE',
  /** A filter that allows selection of a list of retailer locations. */
  RetailerLocations = 'RETAILER_LOCATIONS'
}

/** Report filter values */
export type ReportFilterValuesInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Identifier for this filter */
  slug: Scalars['String'];
};

/** Report Filters */
export type ReportFilters = {
  dateRange?: InputMaybe<DateRange>;
  retailerLocations?: InputMaybe<RetailerLocations>;
};

export enum ReportRequestAssociatedObjectTypeEnum {
  /** Retailer type of associated object */
  Retailer = 'Retailer'
}

/** Autogenerated return type of ReportRequestCreate */
export type ReportRequestCreatePayload = {
  __typename?: 'ReportRequestCreatePayload';
  /** The newly created report request */
  reportRequest: Maybe<ReportsReportRequest>;
};

export enum ReportRequestStateEnum {
  /** A report request that has been successfully processed */
  Complete = 'COMPLETE',
  /** A report request that has failed processing */
  Failed = 'FAILED',
  /** A report request that is currently being processed */
  InProgress = 'IN_PROGRESS',
  /** A report request that is new and not yet processed */
  New = 'NEW'
}

export enum ReportTypeEnum {
  /** Ads report daily */
  AdsDaily = 'ADS_DAILY',
  /** Ads report monthly */
  AdsMonthly = 'ADS_MONTHLY',
  /** Ads report monthly advertiser level */
  AdsMonthlyAdvertiserLevel = 'ADS_MONTHLY_ADVERTISER_LEVEL',
  /** Ads report weekly */
  AdsWeekly = 'ADS_WEEKLY',
  /** Aldi ACI Daily Report */
  AldiAciDailyReport = 'ALDI_ACI_DAILY_REPORT',
  /** Aldi ACI Daily Store Level Report */
  AldiAciDailyStoreLevelReport = 'ALDI_ACI_DAILY_STORE_LEVEL_REPORT',
  /** Associate level performance */
  AssociateLevelPartnerPerformanceReport = 'ASSOCIATE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Bypass Order Feedback Outstanding Files Report */
  BypassOrdersFeedbackOutstandingFilesReport = 'BYPASS_ORDERS_FEEDBACK_OUTSTANDING_FILES_REPORT',
  /** Campaign Performance Weekly */
  CampaignPerformanceWeekly = 'CAMPAIGN_PERFORMANCE_WEEKLY',
  /** Caper ads report daily */
  CaperAdsDaily = 'CAPER_ADS_DAILY',
  /** Caper ads report monthly */
  CaperAdsMonthly = 'CAPER_ADS_MONTHLY',
  /** Caper ads report weekly */
  CaperAdsWeekly = 'CAPER_ADS_WEEKLY',
  /** Caper Daily Transactions Details */
  CaperDailyTransactionsDetails = 'CAPER_DAILY_TRANSACTIONS_DETAILS',
  /** Caper Daily Transactions Summary */
  CaperDailyTransactionsSummary = 'CAPER_DAILY_TRANSACTIONS_SUMMARY',
  /** Caper Force Resolve All Resolution Log */
  CaperForceResolveAllResolutionLog = 'CAPER_FORCE_RESOLVE_ALL_RESOLUTION_LOG',
  /** Monthly Caper Incentives Report */
  CaperIncentivesMonthly = 'CAPER_INCENTIVES_MONTHLY',
  /** Caper Incentives Report */
  CaperIncentivesReport = 'CAPER_INCENTIVES_REPORT',
  /** Caper Store Performance Breakdown */
  CaperStorePerformanceBreakdown = 'CAPER_STORE_PERFORMANCE_BREAKDOWN',
  /** Caper Top Line Metrics Summary */
  CaperTopLineMetricsSummary = 'CAPER_TOP_LINE_METRICS_SUMMARY',
  /** Daily Ultrafast Dashboard */
  DailyUltrafastDashboard = 'DAILY_ULTRAFAST_DASHBOARD',
  /** Daily Ultrafast Order Reporting */
  DailyUltrafastOrderReporting = 'DAILY_ULTRAFAST_ORDER_REPORTING',
  /** Delivery Now By Marianos - Daily Adjustment Report */
  DeliveryNowByMarianosDailyAdjustmentReport = 'DELIVERY_NOW_BY_MARIANOS_DAILY_ADJUSTMENT_REPORT',
  /** Ads display preview report daily */
  DisplayPreviewDaily = 'DISPLAY_PREVIEW_DAILY',
  /** Distribution System Report */
  DistributionSystemReport = 'DISTRIBUTION_SYSTEM_REPORT',
  /** Monthly DLOG report */
  DlogMonthly = 'DLOG_MONTHLY',
  /** EBT Monthly */
  EbtMonthly = 'EBT_MONTHLY',
  /** Giant Eagle Loyalty Perks Attribution Ad-Hoc Report */
  GiantEagleLoyaltyPerksAttributionAdHocReport = 'GIANT_EAGLE_LOYALTY_PERKS_ATTRIBUTION_AD_HOC_REPORT',
  /** In Store Transactions */
  InStoreTransactions = 'IN_STORE_TRANSACTIONS',
  /** Live Issue */
  LiveIssue = 'LIVE_ISSUE',
  /** Merged: In Store Transactions */
  MergedInStoreTransactions = 'MERGED_IN_STORE_TRANSACTIONS',
  /** Merged: Retailer Tax Logs */
  MergedRetailerTaxLogs = 'MERGED_RETAILER_TAX_LOGS',
  /** Merged: Shopper Reimbursements Monthly */
  MergedShopperReimbursementsMonthly = 'MERGED_SHOPPER_REIMBURSEMENTS_MONTHLY',
  /** Merged: Taxes Paid at POS */
  MergedTaxesPaidAtPos = 'MERGED_TAXES_PAID_AT_POS',
  /** Merged: Transaction Logs */
  MergedTransactionLogs = 'MERGED_TRANSACTION_LOGS',
  /** Monthly MLOG report */
  MlogMonthly = 'MLOG_MONTHLY',
  /** MPF Taxes Semi Monthly */
  MpfTaxesSemiMonthly = 'MPF_TAXES_SEMI_MONTHLY',
  /** New Verticals - Weekly Retailer Update */
  NewVerticalsWeeklyRetailerUpdate = 'NEW_VERTICALS_WEEKLY_RETAILER_UPDATE',
  /** Order ratings */
  OrderRatings = 'ORDER_RATINGS',
  /** Out of stock items */
  OutOfStock = 'OUT_OF_STOCK',
  /** Partner Pick Daily Performance Metrics */
  PartnerPickDailyPerformanceMetrics = 'PARTNER_PICK_DAILY_PERFORMANCE_METRICS',
  /** Replacements and refunds */
  ReplacementsAndRefunds = 'REPLACEMENTS_AND_REFUNDS',
  /** Retailer Managed Advertiser Campaign Performance */
  RetailerManagedAdvertiserCampaignPerformance = 'RETAILER_MANAGED_ADVERTISER_CAMPAIGN_PERFORMANCE',
  /** Retailer Pickup */
  RetailerPickup = 'RETAILER_PICKUP',
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** RTD Performance Report - Monthly */
  RtdPerformanceMonthly = 'RTD_PERFORMANCE_MONTHLY',
  /** Live Issue */
  RunnerHours = 'RUNNER_HOURS',
  /** Scan & Pay */
  ScanAndPay = 'SCAN_AND_PAY',
  /** Shopper Breaks */
  ShopperBreaks = 'SHOPPER_BREAKS',
  /** Shopper Reimbursements Monthly */
  ShopperReimbursementsMonthly = 'SHOPPER_REIMBURSEMENTS_MONTHLY',
  /** Skipped Checkout Orders */
  SkippedCheckoutOrders = 'SKIPPED_CHECKOUT_ORDERS',
  /** Store in Store Report Aggregate */
  StoreInStorePerformanceAgg = 'STORE_IN_STORE_PERFORMANCE_AGG',
  /** Store in Store Report Detail */
  StoreInStorePerformanceDtl = 'STORE_IN_STORE_PERFORMANCE_DTL',
  /** Store level performance */
  StoreLevelPartnerPerformanceReport = 'STORE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
  /** Top items */
  TopItems = 'TOP_ITEMS',
  /** Transaction Logs */
  TransactionLogs = 'TRANSACTION_LOGS',
  /** Live Issue */
  UnataExpressWeekly = 'UNATA_EXPRESS_WEEKLY',
  /** UUID Compliance */
  UuidCompliance = 'UUID_COMPLIANCE',
  /** General weekly updates */
  WeeklyRetailerUpdate = 'WEEKLY_RETAILER_UPDATE',
  /** Willcall Billing Reports */
  WillcallBillingReports = 'WILLCALL_BILLING_REPORTS'
}

/** A generated view of the report data */
export type ReportViewsInterface = {
  /** A unique identifier for the report view */
  id: Scalars['ID'];
};

export type ReportsReport = {
  __typename?: 'ReportsReport';
  /** The time at which the report was created */
  createdAt: Scalars['Time'];
  /** A unique identifier for the each report */
  id: Scalars['ID'];
  /** A url-friendly ID for this report */
  slug: Scalars['String'];
  supportedFilters: Array<ReportFilterDefinitionsInterface>;
  /** The time at which the report was updated */
  updatedAt: Scalars['Time'];
};

export type ReportsReportFilterDefinitionsDateRange = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsDateRange';
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Maximum date allowed */
  maxDate: Scalars['ISO8601Date'];
  /** Minimum date */
  minDate: Scalars['ISO8601Date'];
  /** Whether this filter is required */
  required: Scalars['Boolean'];
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export type ReportsReportFilterDefinitionsRetailerLocations = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsRetailerLocations';
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Whether this filter is required */
  required: Scalars['Boolean'];
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export type ReportsReportFilterValuesDateRange = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesDateRange';
  /** End date of date range */
  endDate: Scalars['ISO8601Date'];
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Identifier for this filter */
  slug: Scalars['String'];
  /** Start date of date range */
  startDate: Scalars['ISO8601Date'];
};

export type ReportsReportFilterValuesRetailerLocations = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesRetailerLocations';
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** A retailer location group ID */
  retailerLocationGroupId: Maybe<Scalars['ID']>;
  /** A list of retailer location IDs */
  retailerLocationIds: Maybe<Array<Scalars['ID']>>;
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export type ReportsReportRequest = {
  __typename?: 'ReportsReportRequest';
  /** The time at which the report request was created */
  createdAt: Scalars['Time'];
  enterpriseAccount: Maybe<EnterpriseAccount>;
  /** The state the report request is currently in */
  generationState: ReportRequestStateEnum;
  /** A unique identifier for the report request */
  id: Scalars['ID'];
  /** The name of the report request */
  name: Scalars['String'];
  report: ReportsReport;
  reportFilters: Array<ReportFilterValuesInterface>;
  reportViews: Array<ReportViewsInterface>;
  /** The time at which the report request was updated */
  updatedAt: Scalars['Time'];
};

/** The connection type for ReportsReportRequest. */
export type ReportsReportRequestConnection = {
  __typename?: 'ReportsReportRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportsReportRequestEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ReportsReportRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReportsReportRequestEdge = {
  __typename?: 'ReportsReportRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ReportsReportRequest>;
};

export type ReportsReportViewsCsv = ReportViewsInterface & {
  __typename?: 'ReportsReportViewsCsv';
  /** download URL for the report view */
  downloadUrl: Maybe<Scalars['String']>;
  /** A unique identifier for the report view */
  id: Scalars['ID'];
};

export enum RequestStateEnum {
  /** Account Request accepted and completed */
  Completed = 'COMPLETED',
  /** Waiting for admin to confirm request */
  PendingAdminAction = 'PENDING_ADMIN_ACTION',
  /** Waiting for requestee to verify email */
  PendingEmailVerification = 'PENDING_EMAIL_VERIFICATION',
  /** Account Request rejected */
  Rejected = 'REJECTED'
}

export enum RequestType {
  RequestTypeAccess = 'REQUEST_TYPE_ACCESS',
  RequestTypeDeletion = 'REQUEST_TYPE_DELETION',
  RequestTypeUnspecified = 'REQUEST_TYPE_UNSPECIFIED'
}

export type RescheduleOrderRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type RescheduleOrderResponse = {
  __typename?: 'RescheduleOrderResponse';
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

export type ResourceDataQuery = {
  __typename?: 'ResourceDataQuery';
  id: Maybe<Scalars['String']>;
  resource: Maybe<Scalars['String']>;
};

export type ResourceDataQueryInput = {
  id?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Scalars['String']>;
};

export enum ResponseStatus {
  Failed = 'Failed',
  Success = 'Success',
  Unknown = 'Unknown'
}

export type RestaurantRewardCondition = {
  __typename?: 'RestaurantRewardCondition';
  conditionType: Maybe<RestaurantRewardConditionType>;
  value: Maybe<GoogleTypeMoney>;
};

export type RestaurantRewardConditionInput = {
  conditionType?: InputMaybe<RestaurantRewardConditionType>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
};

export enum RestaurantRewardConditionType {
  RestaurantRewardConditionTypeDeliveryFeeMaximumValue = 'RESTAURANT_REWARD_CONDITION_TYPE_DELIVERY_FEE_MAXIMUM_VALUE',
  RestaurantRewardConditionTypeMinimumSpend = 'RESTAURANT_REWARD_CONDITION_TYPE_MINIMUM_SPEND',
  RestaurantRewardConditionTypeUnknown = 'RESTAURANT_REWARD_CONDITION_TYPE_UNKNOWN'
}

export type RestaurantRewardPolicy = {
  __typename?: 'RestaurantRewardPolicy';
  conditions: Maybe<Array<Maybe<RestaurantRewardCondition>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  maxDiscountCents: Maybe<Scalars['BigInt']>;
  rewardType: Maybe<RestaurantRewardType>;
  secondsValid: Maybe<Scalars['BigInt']>;
  value: Maybe<GoogleTypeMoney>;
  valuePercentage: Maybe<Scalars['Float']>;
};

export type RestaurantRewardPolicyInput = {
  conditions?: InputMaybe<Array<InputMaybe<RestaurantRewardConditionInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  maxDiscountCents?: InputMaybe<Scalars['BigInt']>;
  rewardType?: InputMaybe<RestaurantRewardType>;
  secondsValid?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
  valuePercentage?: InputMaybe<Scalars['Float']>;
};

export enum RestaurantRewardType {
  RestaurantRewardTypeDollarOff = 'RESTAURANT_REWARD_TYPE_DOLLAR_OFF',
  RestaurantRewardTypeFreeDelivery = 'RESTAURANT_REWARD_TYPE_FREE_DELIVERY',
  RestaurantRewardTypePercentOff = 'RESTAURANT_REWARD_TYPE_PERCENT_OFF',
  RestaurantRewardTypeUnknown = 'RESTAURANT_REWARD_TYPE_UNKNOWN'
}

export type RestockFilterTogglesInput = {
  keyItemsOnly?: InputMaybe<Scalars['Boolean']>;
  predictedLow?: InputMaybe<Scalars['Boolean']>;
  replenishableNow?: InputMaybe<Scalars['Boolean']>;
  scannedLowStock?: InputMaybe<Scalars['Boolean']>;
  scannedOos?: InputMaybe<Scalars['Boolean']>;
};

export type RestockItem = {
  __typename?: 'RestockItem';
  backInventoryQty: Maybe<Scalars['Int']>;
  category: Maybe<Scalars['String']>;
  department: Maybe<Scalars['String']>;
  estimatedLoss: Maybe<Scalars['Float']>;
  imageUrl: Maybe<Scalars['String']>;
  isPromo: Maybe<Scalars['Boolean']>;
  lastScanDatetime: Maybe<Scalars['DateTime']>;
  location: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  salesVelocity: Maybe<Scalars['Float']>;
  sales_24h: Maybe<Scalars['BigInt']>;
  upc: Maybe<Scalars['String']>;
  urgencyScore: Maybe<Scalars['Float']>;
};

export type RestockMetadata = {
  __typename?: 'RestockMetadata';
  generatedAt: Maybe<Scalars['DateTime']>;
  totalItems: Maybe<Scalars['Int']>;
};

export enum RestockSortBy {
  RestockSortByEstimatedLoss = 'RESTOCK_SORT_BY_ESTIMATED_LOSS',
  RestockSortBySales_24H = 'RESTOCK_SORT_BY_SALES_24H',
  RestockSortBySalesVelocity = 'RESTOCK_SORT_BY_SALES_VELOCITY',
  RestockSortByUnknown = 'RESTOCK_SORT_BY_UNKNOWN',
  RestockSortByUrgencyScore = 'RESTOCK_SORT_BY_URGENCY_SCORE'
}

/** Autogenerated return type of ResyncPartners */
export type ResyncPartnersPayload = {
  __typename?: 'ResyncPartnersPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
  /** The number of partners that were upserted */
  upsertedCount: Scalars['Int'];
};

export type Retailer = {
  __typename?: 'Retailer';
  /** Country associated with this retailer */
  country: Country;
  /** An array of the retailer's departments */
  departments: Array<CatalogDepartment>;
  /** The entitlements granted to the retailer */
  featureEntitlements: Array<FeatureEntitlement>;
  /** The feature toggles associated with the retailer */
  featureToggles: Array<FeatureToggle>;
  id: Maybe<Scalars['BigInt']>;
  /** The features across all locations for this retailer */
  locationFeatures: Array<LocationFeatureEnum>;
  /** A url for the logo */
  logo: Maybe<Logo>;
  logoUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** The partner that this retailer belongs to */
  partner: Partner;
  partnerId: Maybe<Scalars['BigInt']>;
  /** The store configuration for the pbi retailer */
  pbiConfiguration: Maybe<ContentManagementPbiConfiguration>;
  /** The warehouse slug for a retailer */
  slug: Scalars['String'];
  /** Warehouse group id for this retailer */
  warehouseGroup: Maybe<WarehouseGroup>;
};

export type RetailerAvailabilityInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** The ID of the retailer */
  retailerId: Scalars['Int'];
};

/** Autogenerated return type of RetailerAvailabilityVisibilityConditionCreate */
export type RetailerAvailabilityVisibilityConditionCreatePayload = {
  __typename?: 'RetailerAvailabilityVisibilityConditionCreatePayload';
  /** The newly created RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityCondition: ContentManagementVisibilityConditionRetailerAvailability;
};

/** Autogenerated return type of RetailerAvailabilityVisibilityConditionUpdate */
export type RetailerAvailabilityVisibilityConditionUpdatePayload = {
  __typename?: 'RetailerAvailabilityVisibilityConditionUpdatePayload';
  /** The newly updated RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityCondition: ContentManagementVisibilityConditionRetailerAvailability;
};

export type RetailerCampaign = {
  __typename?: 'RetailerCampaign';
  budget: Maybe<GoogleTypeMoney>;
  campaignObjective: Maybe<CampaignObjective>;
  campaignReference: Maybe<CampaignReference>;
  campaignServiceData: Maybe<CampaignServiceData>;
  coreProperties: Maybe<Scalars['JSONObject']>;
  countryIdValue: Maybe<Scalars['BigInt']>;
  couponCount: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  creatorIppUserId: Maybe<Scalars['BigInt']>;
  customProperties: Maybe<Array<Maybe<CustomProperty>>>;
  discountPolicyIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  discoverability: Maybe<Discoverability>;
  endsAt: Maybe<Scalars['DateTime']>;
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  filters: Maybe<Array<Maybe<CampaignFilter>>>;
  fundingDetails: Maybe<Scalars['String']>;
  fundingSummaryDetails: Maybe<Array<Maybe<SummaryDetails>>>;
  id: Maybe<Scalars['BigInt']>;
  intentionConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  ippUserCanonicalUuid: Maybe<Scalars['String']>;
  lookbackWindowDays: Maybe<Scalars['BigInt']>;
  metadata: Maybe<Scalars['JSONObject']>;
  name: Maybe<Scalars['String']>;
  narrowSearchTerms: Maybe<Array<Maybe<Scalars['String']>>>;
  offerDurationInDays: Maybe<Scalars['BigInt']>;
  offerRequestKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  offerSummary: Maybe<Scalars['String']>;
  offerSummaryDetails: Maybe<Array<Maybe<SummaryDetails>>>;
  rawTreatments: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
  redemptionMethod: Maybe<RedemptionMethod>;
  regionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  restaurantPromotionId: Maybe<Scalars['String']>;
  restaurantRewardPolicy: Maybe<RestaurantRewardPolicy>;
  retailerData: Maybe<Retailer>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailersData: Maybe<Array<Maybe<Retailer>>>;
  rouletteFeature: Maybe<CampaignRouletteFeature>;
  schedule: Maybe<Scalars['String']>;
  segmentId: Maybe<Scalars['String']>;
  slotCreatives: Maybe<Array<Maybe<InstacartCustomersContentManagementAdminV1SlotCreative>>>;
  startsAt: Maybe<Scalars['DateTime']>;
  status: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  targeting: Maybe<Array<Maybe<Targeting>>>;
  targetingRules: Maybe<Array<Maybe<TargetingRules>>>;
  templateId: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  treatmentTask: Maybe<CampaignTreatmentTask>;
  treatments: Maybe<RetailerCampaignTreatments>;
  updatedAt: Maybe<Scalars['DateTime']>;
  validForDays: Maybe<Scalars['BigInt']>;
};

export type RetailerCampaignCreativeTreatment = {
  __typename?: 'RetailerCampaignCreativeTreatment';
  placementId: Maybe<Scalars['BigInt']>;
  slotId: Maybe<Scalars['String']>;
};

export type RetailerCampaignCreativeTreatmentInput = {
  placementId?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type RetailerCampaignOfferTreatment = {
  __typename?: 'RetailerCampaignOfferTreatment';
  offerDurationInDays: Maybe<Scalars['BigInt']>;
  offerId: Maybe<Scalars['BigInt']>;
  offerRequestKey: Maybe<Scalars['String']>;
  slotId: Maybe<Scalars['String']>;
  validForDays: Maybe<Scalars['BigInt']>;
};

export type RetailerCampaignOfferTreatmentInput = {
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offerId?: InputMaybe<Scalars['BigInt']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  slotId?: InputMaybe<Scalars['String']>;
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type RetailerCampaignResponse = {
  __typename?: 'RetailerCampaignResponse';
  errors: Maybe<Scalars['JSONObject']>;
  offers: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOffer>>>;
  retailerCampaign: Maybe<RetailerCampaign>;
  slotCreatives: Maybe<Array<Maybe<InstacartCustomersContentManagementAdminV1SlotCreative>>>;
};

export type RetailerCampaignTreatment = {
  __typename?: 'RetailerCampaignTreatment';
  active: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  retailerCampaignId: Maybe<Scalars['BigInt']>;
  slotIds: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentDetails: Maybe<Array<Maybe<RetailerCampaignTreatmentDetails>>>;
  treatmentPolicyId: Maybe<Scalars['String']>;
  treatmentType: Maybe<RetailerCampaignTreatmentType>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type RetailerCampaignTreatmentDetails = {
  __typename?: 'RetailerCampaignTreatmentDetails';
  creativeTreatment: Maybe<RetailerCampaignCreativeTreatment>;
  offerTreatment: Maybe<RetailerCampaignOfferTreatment>;
};

export type RetailerCampaignTreatmentDetailsInput = {
  creativeTreatment?: InputMaybe<RetailerCampaignCreativeTreatmentInput>;
  offerTreatment?: InputMaybe<RetailerCampaignOfferTreatmentInput>;
};

export enum RetailerCampaignTreatmentType {
  Creative = 'CREATIVE',
  InvalidTreatment = 'INVALID_TREATMENT',
  Offer = 'OFFER'
}

export type RetailerCampaignTreatments = {
  __typename?: 'RetailerCampaignTreatments';
  treatments: Maybe<Array<Maybe<RetailerCampaignTreatmentsTreatment>>>;
};

export type RetailerCampaignTreatmentsInput = {
  treatments?: InputMaybe<Array<InputMaybe<RetailerCampaignTreatmentsTreatmentInput>>>;
};

export type RetailerCampaignTreatmentsTreatment = {
  __typename?: 'RetailerCampaignTreatmentsTreatment';
  placements: Maybe<Array<Maybe<Placement>>>;
  slotId: Maybe<Scalars['BigInt']>;
  treatmentVisibilityConditions: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RetailerCampaignTreatmentsTreatmentInput = {
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentVisibilityConditions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RetailerCollection = {
  __typename?: 'RetailerCollection';
  retailerId: Maybe<Scalars['BigInt']>;
  slug: Maybe<Scalars['String']>;
};

export type RetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** The connection type for Retailer. */
export type RetailerConnection = {
  __typename?: 'RetailerConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Retailer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RetailerContactManagement_Contact = {
  __typename?: 'RetailerContactManagement_Contact';
  /** Areas of responsibility (API, Payments, etc.) */
  domains: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contact email address (unique within retailer) */
  email: Scalars['EmailAddress'];
  /** Display name */
  name: Maybe<Scalars['RetailerContactManagement_query_getContacts_oneOf_0_items_name']>;
  /** Phone number */
  phone: Maybe<Scalars['String']>;
  /** Escalation order, lower = higher priority */
  priority: Maybe<Scalars['PositiveInt']>;
  /** Job title */
  role: Maybe<Scalars['RetailerContactManagement_query_getContacts_oneOf_0_items_role']>;
  /** IANA timezone for scheduling */
  timezone: Maybe<Scalars['String']>;
};

export type RetailerContactManagement_Contact_Input = {
  /** Areas of responsibility (API, Payments, etc.) */
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contact email address (unique within retailer) */
  email: Scalars['EmailAddress'];
  /** Display name */
  name?: InputMaybe<Scalars['RetailerContactManagement_query_getContacts_oneOf_0_items_name']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Escalation order, lower = higher priority */
  priority?: InputMaybe<Scalars['PositiveInt']>;
  /** Job title */
  role?: InputMaybe<Scalars['RetailerContactManagement_query_getContacts_oneOf_0_items_role']>;
  /** IANA timezone for scheduling */
  timezone?: InputMaybe<Scalars['String']>;
};

export type RetailerContactManagement_Error = {
  __typename?: 'RetailerContactManagement_Error';
  details: Maybe<Array<Maybe<RetailerContactManagement_Query_GetOpenApiSpec_OneOf_1_Details_Items>>>;
  error: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export enum RetailerContactManagement_HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type RetailerContactManagement_HealthCheck = {
  __typename?: 'RetailerContactManagement_HealthCheck';
  service: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  timestamp: Maybe<Scalars['DateTime']>;
};

export type RetailerContactManagement_String_Container = {
  __typename?: 'RetailerContactManagement_String_container';
  String: Maybe<Scalars['String']>;
};

export type RetailerContactManagement_Void_Container = {
  __typename?: 'RetailerContactManagement_Void_container';
  Void: Maybe<Scalars['Void']>;
};

export type RetailerContactManagement_AddContact_Response = RetailerContactManagement_Contact | RetailerContactManagement_Error;

export type RetailerContactManagement_DeleteAllContacts_200_Response = {
  __typename?: 'RetailerContactManagement_deleteAllContacts_200_response';
  deletedCount: Maybe<Scalars['Int']>;
  message: Maybe<Scalars['String']>;
};

export type RetailerContactManagement_DeleteAllContacts_Response = RetailerContactManagement_Error | RetailerContactManagement_DeleteAllContacts_200_Response;

export type RetailerContactManagement_DeleteContact_Response = RetailerContactManagement_Error | RetailerContactManagement_Void_Container;

export type RetailerContactManagement_GetContact_Response = RetailerContactManagement_Contact | RetailerContactManagement_Error;

export type RetailerContactManagement_GetContacts_Response = RetailerContactManagement_Contact | RetailerContactManagement_Error;

export type RetailerContactManagement_GetOpenApiSpec_Response = RetailerContactManagement_Error | RetailerContactManagement_String_Container;

export type RetailerContactManagement_Query_GetOpenApiSpec_OneOf_1_Details_Items = {
  __typename?: 'RetailerContactManagement_query_getOpenApiSpec_oneOf_1_details_items';
  field: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export type RetailerContactManagement_UpdateContact_Response = RetailerContactManagement_Contact | RetailerContactManagement_Error;

export type RetailerContainerPath = {
  __typename?: 'RetailerContainerPath';
  containerPath: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export type RetailerContainerPathInput = {
  containerPath?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** An edge in a connection. */
export type RetailerEdge = {
  __typename?: 'RetailerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Retailer>;
};

export type RetailerForShortcut = {
  __typename?: 'RetailerForShortcut';
  id: Maybe<Scalars['BigInt']>;
  isShortcutsBarOverridden: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  retailerType: Maybe<Scalars['String']>;
};

export type RetailerLocale = {
  __typename?: 'RetailerLocale';
  localeCode: Maybe<Scalars['String']>;
  localeId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export type RetailerLocation = {
  __typename?: 'RetailerLocation';
  /** The active status for the location */
  active: Scalars['Boolean'];
  /** The location's city */
  city: Maybe<Scalars['String']>;
  /** Represents the set of 'Fullfillment Models' (how fulfillment is facilitated for the location) */
  fulfillmentModels: Maybe<Array<FulfillmentModelEnum>>;
  /** Hybrid Picking setting for the location indicates combined ISS and Partner Pick */
  hybridPickingEnabled: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the retailer location */
  id: Scalars['ID'];
  /** The retailer-assigned location code */
  locationCode: Maybe<Scalars['String']>;
  /** The name of the retailer location */
  name: Maybe<Scalars['String']>;
  /** Identifies if the location does partner run alcohol delivery */
  partnerAlcoholDelivery: Scalars['Boolean'];
  /** Identifies if the location can deliver orders with partner delivery drivers */
  partnerDeliveryDriversEnabled: Maybe<Scalars['Boolean']>;
  /** Represents the 'Picking Model' (how picking is facilitated for the location) */
  pickingModel: Maybe<PickingModelEnum>;
  /** A flag representing whether pickup is enabled */
  pickup: Scalars['Boolean'];
  /** Identifies if the location does platform only deliveries */
  platformOnlyEnabled: Maybe<Scalars['Boolean']>;
  /** The retailer that this location belongs to */
  retailer: Retailer;
  /** The retailer ID that this location belongs to */
  retailerId: Scalars['ID'];
  /** The location's state */
  state: Maybe<Scalars['String']>;
  /** The location's street (including street #) */
  street: Maybe<Scalars['String']>;
  /** The location's zip code or postal code */
  zipCode: Maybe<Scalars['String']>;
  /** The location's ZIP+4 (US-specific) */
  zipPlusFour: Maybe<Scalars['String']>;
};

export type RetailerLocationAisle = {
  __typename?: 'RetailerLocationAisle';
  aisleCount: Maybe<Scalars['BigInt']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  retailerLocationName: Maybe<Scalars['String']>;
};

/** The connection type for RetailerLocation. */
export type RetailerLocationConnection = {
  __typename?: 'RetailerLocationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerLocationEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailerLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RetailerLocationDetails = {
  __typename?: 'RetailerLocationDetails';
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  coordinates: Maybe<GoogleTypeLatLng>;
  countryId: Maybe<Scalars['BigInt']>;
  flags: Maybe<RetailerLocationFlags>;
  id: Maybe<Scalars['Int']>;
  inventoryAreaId: Maybe<Scalars['Int']>;
  locationCode: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  regionCode: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['Int']>;
  state: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type RetailerLocationEdge = {
  __typename?: 'RetailerLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<RetailerLocation>;
};

export type RetailerLocationFlags = {
  __typename?: 'RetailerLocationFlags';
  active: Maybe<Scalars['Boolean']>;
  alcohol: Maybe<Scalars['Boolean']>;
  available: Maybe<Scalars['Boolean']>;
  closed: Maybe<Scalars['Boolean']>;
  curbsidePickup: Maybe<Scalars['Boolean']>;
  pickup: Maybe<Scalars['Boolean']>;
  pickupOnly: Maybe<Scalars['Boolean']>;
  rx: Maybe<Scalars['Boolean']>;
  serviceable: Maybe<Scalars['Boolean']>;
  unavailable: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of RetailerLocationGroupCreate */
export type RetailerLocationGroupCreatePayload = {
  __typename?: 'RetailerLocationGroupCreatePayload';
  /** The newly created group */
  retailerLocationGroup: RetailersRetailerLocationGroup;
};

/** Autogenerated return type of RetailerLocationGroupDelete */
export type RetailerLocationGroupDeletePayload = {
  __typename?: 'RetailerLocationGroupDeletePayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

export enum RetailerLocationGroupQuery {
  /** Return all Store Groups where client query matches retailer IDs exactly */
  Equal = 'EQUAL',
  /** Return all Store Groups where client query intersects retailer IDs */
  Intersect = 'INTERSECT',
  /** Return all Store Groups where client query is a subset of retailer IDs */
  Subset = 'SUBSET'
}

/** Autogenerated return type of RetailerLocationGroupUpdate */
export type RetailerLocationGroupUpdatePayload = {
  __typename?: 'RetailerLocationGroupUpdatePayload';
  /** The updated group */
  retailerLocationGroup: RetailersRetailerLocationGroup;
};

export type RetailerLocationInfo = {
  __typename?: 'RetailerLocationInfo';
  name: Maybe<Scalars['String']>;
  retailerName: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
};

/** Attributes for a retailer location filter */
export type RetailerLocations = {
  /** A retailer location group ID */
  retailerLocationGroupId?: InputMaybe<Scalars['ID']>;
  /** A list of retailer location IDs */
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type RetailerLogo = {
  __typename?: 'RetailerLogo';
  dark: Maybe<RetailerLogoImage>;
  darkFillColorHex: Maybe<Scalars['String']>;
  darkSquare: Maybe<RetailerLogoImage>;
  light: Maybe<RetailerLogoImage>;
  lightFillColorHex: Maybe<Scalars['String']>;
  lightSquare: Maybe<RetailerLogoImage>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export type RetailerLogoImage = {
  __typename?: 'RetailerLogoImage';
  filename: Maybe<Scalars['String']>;
  height: Maybe<Scalars['BigInt']>;
  width: Maybe<Scalars['BigInt']>;
};

export type RetailerMfaConfig = {
  __typename?: 'RetailerMfaConfig';
  /** Whether or not MFA is enabled for the retailer */
  mfaEnabled: Scalars['Boolean'];
  /** A unique identifier for the retailer */
  retailerId: Scalars['ID'];
};

/** Autogenerated return type of RetailerMfaSetEnabled */
export type RetailerMfaSetEnabledPayload = {
  __typename?: 'RetailerMfaSetEnabledPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

export type RetailerMomentCampaign = {
  __typename?: 'RetailerMomentCampaign';
  collectionData: Maybe<Collection>;
  offers: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOffer>>>;
  retailerCampaign: Maybe<RetailerCampaign>;
  retailerData: Maybe<Retailer>;
};

export type RetailerNav = {
  __typename?: 'RetailerNav';
  navId: Maybe<Scalars['BigInt']>;
};

export type RetailerOverride = {
  __typename?: 'RetailerOverride';
  retailerId: Maybe<Scalars['BigInt']>;
  retailerName: Maybe<Scalars['String']>;
};

export type RetailerProduct = {
  __typename?: 'RetailerProduct';
  aisleName: Maybe<Scalars['String']>;
  aisles: Maybe<Array<Maybe<RetailerProductAisle>>>;
  alcoholic: Maybe<Scalars['Boolean']>;
  atkinsDiet: Maybe<Scalars['Boolean']>;
  bottle: Maybe<Scalars['Boolean']>;
  brandId: Maybe<Scalars['BigInt']>;
  brandName: Maybe<Scalars['String']>;
  calories: Maybe<Scalars['Float']>;
  carbFree: Maybe<Scalars['Boolean']>;
  carbohydrate: Maybe<Scalars['Float']>;
  cchGroupCode: Maybe<Scalars['String']>;
  cchItemCode: Maybe<Scalars['String']>;
  coldPrepared: Maybe<Scalars['Boolean']>;
  containsFlour: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  dairyFree: Maybe<Scalars['Boolean']>;
  departments: Maybe<Array<Maybe<RetailerProductDepartment>>>;
  description: Maybe<Scalars['String']>;
  details: Maybe<Scalars['String']>;
  directions: Maybe<Scalars['String']>;
  fatFree: Maybe<Scalars['Boolean']>;
  glutenFree: Maybe<Scalars['Boolean']>;
  hasImage: Maybe<Scalars['Boolean']>;
  highCarb: Maybe<Scalars['Boolean']>;
  highFat: Maybe<Scalars['Boolean']>;
  highProtein: Maybe<Scalars['Boolean']>;
  imageList: Maybe<Array<Maybe<RetailerProductImageInfo>>>;
  ingredients: Maybe<Scalars['String']>;
  isOrganic: Maybe<Scalars['Boolean']>;
  ketoDiet: Maybe<Scalars['Boolean']>;
  kidFriendly: Maybe<Scalars['Boolean']>;
  kosher: Maybe<Scalars['Boolean']>;
  lactoseFree: Maybe<Scalars['Boolean']>;
  localeCode: Maybe<Scalars['String']>;
  lowCarb: Maybe<Scalars['Boolean']>;
  lowFat: Maybe<Scalars['Boolean']>;
  lowSodium: Maybe<Scalars['Boolean']>;
  lowSugar: Maybe<Scalars['Boolean']>;
  managedAttributeValues: Maybe<Array<Maybe<RetailerProductManagedAttributeValue>>>;
  name: Maybe<Scalars['String']>;
  organic: Maybe<Scalars['Boolean']>;
  originalName: Maybe<Scalars['String']>;
  paleoDiet: Maybe<Scalars['Boolean']>;
  prepSlicedRepackagedPasteurizedByRetailer: Maybe<Scalars['Boolean']>;
  primaryAisleId: Maybe<Scalars['BigInt']>;
  primaryDepartmentId: Maybe<Scalars['BigInt']>;
  primaryImageUrl: Maybe<Scalars['String']>;
  productCategory: Maybe<Scalars['String']>;
  productCategoryTaxonomy: Maybe<RetailerProductProductCategoryTaxonomy>;
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  productDisplayName: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  productTags: Maybe<Scalars['String']>;
  prop65Text: Maybe<Scalars['String']>;
  requireReheating: Maybe<Scalars['Boolean']>;
  requiresKeepFrozen: Maybe<Scalars['Boolean']>;
  requiresRefrigeration: Maybe<Scalars['Boolean']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  score: Maybe<Scalars['Float']>;
  seasonality: Maybe<Scalars['JSONObject']>;
  servingSize: Maybe<Scalars['String']>;
  servingsPerContainer: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  sizeUom: Maybe<Scalars['String']>;
  storeBrand: Maybe<Scalars['Boolean']>;
  sugarFree: Maybe<Scalars['Boolean']>;
  suggestedIncrementalWeight: Maybe<Scalars['Float']>;
  unitCount: Maybe<Scalars['BigInt']>;
  vegan: Maybe<Scalars['Boolean']>;
  vegetarian: Maybe<Scalars['Boolean']>;
  vertexTaxOverrideAttribute: Maybe<Scalars['String']>;
  weightWatchers: Maybe<Scalars['Boolean']>;
  wholeGrain: Maybe<Scalars['Boolean']>;
};

export type RetailerProductAisle = {
  __typename?: 'RetailerProductAisle';
  departmentId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

export type RetailerProductAssortment = {
  __typename?: 'RetailerProductAssortment';
  entityId: Maybe<EntityId>;
  inAssortment: Maybe<Scalars['Boolean']>;
  outOfAssortmentEndAt: Maybe<Scalars['DateTime']>;
  outOfAssortmentStartAt: Maybe<Scalars['DateTime']>;
};

export type RetailerProductAssortmentFilterInput = {
  inAssortment?: InputMaybe<Scalars['Boolean']>;
};

export type RetailerProductData = {
  __typename?: 'RetailerProductData';
  availableItemsCount: Maybe<Scalars['BigInt']>;
  generatedAt: Maybe<Scalars['DateTime']>;
  itemsCount: Maybe<Scalars['BigInt']>;
  maxPriceCents: Maybe<Scalars['BigInt']>;
  minPriceCents: Maybe<Scalars['BigInt']>;
  productId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  visibleItemsCount: Maybe<Scalars['BigInt']>;
};

export type RetailerProductDepartment = {
  __typename?: 'RetailerProductDepartment';
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

export type RetailerProductId = {
  __typename?: 'RetailerProductId';
  locale: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerProductId: Maybe<Scalars['BigInt']>;
};

export type RetailerProductIdInput = {
  locale?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerProductId?: InputMaybe<Scalars['BigInt']>;
};

export type RetailerProductImageInfo = {
  __typename?: 'RetailerProductImageInfo';
  cacheType: Maybe<Scalars['String']>;
  imageId: Maybe<Scalars['String']>;
  imageType: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  sourceType: Maybe<Scalars['String']>;
};

export type RetailerProductManagedAttributeValue = {
  __typename?: 'RetailerProductManagedAttributeValue';
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
  valueDisplayName: Maybe<Scalars['String']>;
};

export type RetailerProductProductCategoryTaxonomy = {
  __typename?: 'RetailerProductProductCategoryTaxonomy';
  l1: Maybe<Scalars['String']>;
  l2: Maybe<Scalars['String']>;
  l3: Maybe<Scalars['String']>;
  l4: Maybe<Scalars['String']>;
  l5: Maybe<Scalars['String']>;
  l6: Maybe<Scalars['String']>;
};

export type RetailerSatisfactionSurveyResponse = {
  /** Text that was displayed to user */
  surveyQuestion: Scalars['String'];
  /** Can be either numeric or text based on survey type */
  surveyResponse: Scalars['String'];
};

/** A survey submission record used for client-side display frequency control */
export type RetailerSatisfactionSurveyTypesSubmissionRecord = {
  __typename?: 'RetailerSatisfactionSurveyTypesSubmissionRecord';
  /** Tool identifier (Totem entity external ID) */
  milestoneSlug: Maybe<Scalars['String']>;
  /** Timestamp of when the survey was submitted */
  submittedAt: Scalars['ISO8601DateTime'];
  /** Workflow that triggered the survey */
  workflowSlug: Maybe<Scalars['String']>;
};

export enum RetailerServiceType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  ServiceTypeUndefined = 'SERVICE_TYPE_UNDEFINED'
}

export type RetailerSettingDetailRecord = {
  __typename?: 'RetailerSettingDetailRecord';
  detailName: Maybe<Scalars['String']>;
  detailType: Maybe<Scalars['String']>;
  detailValue: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  settingName: Maybe<Scalars['String']>;
  validValues: Maybe<Scalars['String']>;
};

export type RetailerSettingRecord = {
  __typename?: 'RetailerSettingRecord';
  comment: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  details: Maybe<Array<Maybe<RetailerSettingDetailRecord>>>;
  retailerId: Maybe<Scalars['BigInt']>;
  settingName: Maybe<Scalars['String']>;
  settingType: Maybe<RetailerSettingType>;
  updatedAt: Maybe<Scalars['DateTime']>;
  value: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
};

export enum RetailerSettingType {
  RetailerSettingTypeBoolean = 'RETAILER_SETTING_TYPE_BOOLEAN',
  RetailerSettingTypeInteger = 'RETAILER_SETTING_TYPE_INTEGER',
  RetailerSettingTypeString = 'RETAILER_SETTING_TYPE_STRING',
  RetailerSettingTypeUnknown = 'RETAILER_SETTING_TYPE_UNKNOWN'
}

export type RetailerSlot = {
  __typename?: 'RetailerSlot';
  slotId: Maybe<Scalars['BigInt']>;
};

export type RetailersPickupRetailerLocationGroup = {
  __typename?: 'RetailersPickupRetailerLocationGroup';
  /** A unique identifier for the location group */
  id: Scalars['ID'];
  /** A name for this location group */
  name: Scalars['String'];
  /** The identifier for the retailer which all locations in the group belong to */
  retailerId: Scalars['ID'];
  /** The retailer locations associated with the group */
  retailerLocations: Array<RetailerLocation>;
};

export type RetailersRetailerLocationGroup = {
  __typename?: 'RetailersRetailerLocationGroup';
  /** A unique identifier for the location group */
  id: Scalars['ID'];
  /** A name for this location group */
  name: Scalars['String'];
  /** The identifier for the partner which all locations in the group belong to */
  partnerId: Scalars['ID'];
  /** The identifier for the retailer which all locations in the group belong to (deprecated) */
  retailerId: Maybe<Scalars['ID']>;
  /** The identifiers for the retailers which all locations in the group belong to */
  retailerIds: Maybe<Array<Scalars['ID']>>;
  /** The ids for the retailer locations associated with the group */
  retailerLocationIds: Array<Scalars['ID']>;
  /** The retailer locations associated with the group */
  retailerLocations: RetailerLocationConnection;
  /** The time at which the group was last updated */
  updatedAt: Scalars['Time'];
};


export type RetailersRetailerLocationGroupRetailerLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The connection type for RetailersRetailerLocationGroup. */
export type RetailersRetailerLocationGroupConnection = {
  __typename?: 'RetailersRetailerLocationGroupConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailersRetailerLocationGroupEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailersRetailerLocationGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RetailersRetailerLocationGroupEdge = {
  __typename?: 'RetailersRetailerLocationGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<RetailersRetailerLocationGroup>;
};

export type RetailersRetailerPickupMetadata = {
  __typename?: 'RetailersRetailerPickupMetadata';
  /** Warehouse early picking hour [if one is set] */
  earlyPickingHour: Maybe<Scalars['Int']>;
};

export type ReturnItemInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
  returnedQuantity?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
};

/** The possible actions performed during a review on an Approval Request. */
export enum ReviewAction {
  /** A approval for the update to the content. */
  Approval = 'APPROVAL',
  /** An approval and publication of the content in one atomic step. */
  ApprovalAndPublish = 'APPROVAL_AND_PUBLISH',
  /** A publication of the content without the required approvals. */
  BreakGlassPublish = 'BREAK_GLASS_PUBLISH',
  /** A cancellation of the content update. */
  Cancel = 'CANCEL',
  /** A comment on the Approval Request. No state updates. */
  Comment = 'COMMENT',
  /** A publication for the content. */
  Publish = 'PUBLISH',
  /** A request for changes to the content update. */
  RequestChanges = 'REQUEST_CHANGES',
  /** A revision of the content (invalidates approvals). */
  ReviseContent = 'REVISE_CONTENT'
}

/** Input parameters for adding a review to an Approval Request */
export type ReviewAddInput = {
  /** The action to take on the approval request. */
  action: ReviewAction;
  /** The unique ID of the Approval Request. */
  arId: Scalars['ID'];
  /** A comment to add to the approval request. */
  userComment?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ReviewAdd */
export type ReviewAddPayload = {
  __typename?: 'ReviewAddPayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

/** Input parameters for deleting a review on an Approval Request */
export type ReviewDeleteInput = {
  /** The unique ID of the Review. */
  reviewId: Scalars['ID'];
};

/** Autogenerated return type of ReviewDelete */
export type ReviewDeletePayload = {
  __typename?: 'ReviewDeletePayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

/** Input parameters for editing a review to an Approval Request */
export type ReviewEditInput = {
  /** The unique ID of the Review. */
  reviewId: Scalars['ID'];
  /** Update the comment on the approval request. */
  userComment?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ReviewEdit */
export type ReviewEditPayload = {
  __typename?: 'ReviewEditPayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

export type RevokePartnerApiKeyRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type RevokePartnerApiKeyResponse = {
  __typename?: 'RevokePartnerApiKeyResponse';
  success: Maybe<Scalars['Boolean']>;
};

export enum Role {
  Assistant = 'ASSISTANT',
  Developer = 'DEVELOPER',
  Tool = 'TOOL',
  User = 'USER'
}

/** Autogenerated return type of RoleCreate */
export type RoleCreatePayload = {
  __typename?: 'RoleCreatePayload';
  /** The created role object */
  role: EnterpriseRole;
};

/** Autogenerated return type of RoleDelete */
export type RoleDeletePayload = {
  __typename?: 'RoleDeletePayload';
  /** The delete role object */
  role: EnterpriseRole;
};

export type RoleInput = {
  /** A unique identifier for the role */
  id: Scalars['ID'];
};

/** Autogenerated return type of RoleUpdate */
export type RoleUpdatePayload = {
  __typename?: 'RoleUpdatePayload';
  /** The update role object */
  role: EnterpriseRole;
};

export type RollbackStoreConfigurationRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type RollbackStoreConfigurationResponse = {
  __typename?: 'RollbackStoreConfigurationResponse';
  errorMessage: Maybe<Scalars['String']>;
  errorReason: Maybe<ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type RsatPulseSurveyInput = {
  /** Whether the user has submitted the survey */
  hasSubmitted: Scalars['Boolean'];
  /** Whether the user has seen the survey */
  seen: Scalars['Boolean'];
  /** The unique slug identifier for the survey */
  slug: RsatPulseSurveySlugEnum;
};

export enum RsatPulseSurveySlugEnum {
  /** RETAILER_SATISFACTION_SURVEY_R202507 survey */
  RetailerSatisfactionSurveyR202507 = 'RETAILER_SATISFACTION_SURVEY_R202507'
}

export type SaveToolingShortcutsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerType?: InputMaybe<Scalars['String']>;
  shortcuts?: InputMaybe<Array<InputMaybe<ToolingShortcutInput>>>;
};

export type SaveToolingShortcutsResponse = {
  __typename?: 'SaveToolingShortcutsResponse';
  shortcuts: Maybe<Array<Maybe<ToolingShortcut>>>;
};

export enum ScanCodeStrategy {
  ScanCodeStrategy_004To_002 = 'SCAN_CODE_STRATEGY_004_TO_002',
  ScanCodeStrategyCostco_004To_002 = 'SCAN_CODE_STRATEGY_COSTCO_004_to_002',
  ScanCodeStrategyCrossRetailerDataExactMatch = 'SCAN_CODE_STRATEGY_CROSS_RETAILER_DATA_EXACT_MATCH',
  ScanCodeStrategyCrossRetailerUnbrandedForcemarksExactMatch = 'SCAN_CODE_STRATEGY_CROSS_RETAILER_UNBRANDED_FORCEMARKS_EXACT_MATCH',
  ScanCodeStrategyCspExactMatch = 'SCAN_CODE_STRATEGY_CSP_EXACT_MATCH',
  ScanCodeStrategyMlV1 = 'SCAN_CODE_STRATEGY_ML_V1',
  ScanCodeStrategyRetailerDataExactMatch = 'SCAN_CODE_STRATEGY_RETAILER_DATA_EXACT_MATCH',
  ScanCodeStrategyRetailerUnbrandedForcemarksExactMatch = 'SCAN_CODE_STRATEGY_RETAILER_UNBRANDED_FORCEMARKS_EXACT_MATCH',
  ScanCodeStrategyUnknown = 'SCAN_CODE_STRATEGY_UNKNOWN'
}

export type ScanSnapshot = {
  __typename?: 'ScanSnapshot';
  currentFacings: Maybe<Scalars['Int']>;
  locations: Maybe<Array<Maybe<ShelfLocation>>>;
  scanTimestamp: Maybe<Scalars['DateTime']>;
};

export type SearchBrandsRequestInput = {
  limit?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  storeBrandsOnly?: InputMaybe<Scalars['Boolean']>;
};

export type SearchBrandsResponse = {
  __typename?: 'SearchBrandsResponse';
  brands: Maybe<Array<Maybe<Brand>>>;
};

export type SearchPlacementMetadata = {
  __typename?: 'SearchPlacementMetadata';
  allowInterleaving: Maybe<Scalars['Boolean']>;
  contentType: Maybe<SearchPlacementMetadataSearchContentType>;
  isPinned: Maybe<Scalars['Boolean']>;
  maxPosition: Maybe<Scalars['BigInt']>;
  minPosition: Maybe<Scalars['BigInt']>;
  sectionType: Maybe<SearchPlacementMetadataSearchSectionType>;
};

export type SearchPlacementMetadataInput = {
  allowInterleaving?: InputMaybe<Scalars['Boolean']>;
  contentType?: InputMaybe<SearchPlacementMetadataSearchContentType>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  maxPosition?: InputMaybe<Scalars['BigInt']>;
  minPosition?: InputMaybe<Scalars['BigInt']>;
  sectionType?: InputMaybe<SearchPlacementMetadataSearchSectionType>;
};

export enum SearchPlacementMetadataSearchContentType {
  SearchContentTypeAsyncDisplay = 'SEARCH_CONTENT_TYPE_ASYNC_DISPLAY',
  SearchContentTypeAsyncSpAds = 'SEARCH_CONTENT_TYPE_ASYNC_SP_ADS',
  SearchContentTypeBundle = 'SEARCH_CONTENT_TYPE_BUNDLE',
  SearchContentTypeComplementary = 'SEARCH_CONTENT_TYPE_COMPLEMENTARY',
  SearchContentTypeExact = 'SEARCH_CONTENT_TYPE_EXACT',
  SearchContentTypeFlyer = 'SEARCH_CONTENT_TYPE_FLYER',
  SearchContentTypeHeader = 'SEARCH_CONTENT_TYPE_HEADER',
  SearchContentTypeOtherExactContent = 'SEARCH_CONTENT_TYPE_OTHER_EXACT_CONTENT',
  SearchContentTypeOtherRelatedContent = 'SEARCH_CONTENT_TYPE_OTHER_RELATED_CONTENT',
  SearchContentTypeRelated = 'SEARCH_CONTENT_TYPE_RELATED',
  SearchContentTypeSubstitute = 'SEARCH_CONTENT_TYPE_SUBSTITUTE',
  SearchContentTypeSyncDisplay = 'SEARCH_CONTENT_TYPE_SYNC_DISPLAY',
  SearchContentTypeSyncSpAds = 'SEARCH_CONTENT_TYPE_SYNC_SP_ADS',
  SearchContentTypeTheme = 'SEARCH_CONTENT_TYPE_THEME',
  SearchContentTypeUnspecified = 'SEARCH_CONTENT_TYPE_UNSPECIFIED'
}

export enum SearchPlacementMetadataSearchSectionType {
  SearchSectionTypeExact = 'SEARCH_SECTION_TYPE_EXACT',
  SearchSectionTypeOther = 'SEARCH_SECTION_TYPE_OTHER',
  SearchSectionTypeRelated = 'SEARCH_SECTION_TYPE_RELATED',
  SearchSectionTypeUnknown = 'SEARCH_SECTION_TYPE_UNKNOWN'
}

export type SearchWhitelabelSiteCustomizableStringRequestInput = {
  copySubstring?: InputMaybe<Scalars['String']>;
  keySubstring?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDetailsInput>;
  sorting?: InputMaybe<SortingDetailsInput>;
};

export type SearchWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'SearchWhitelabelSiteCustomizableStringResponse';
  errorMessage: Maybe<Scalars['String']>;
  pagination: Maybe<PaginationDetails>;
  success: Maybe<Scalars['Boolean']>;
  whitelabelSiteCustomizableString: Maybe<Array<Maybe<WhitelabelSiteCustomizableString>>>;
};

export type SecondaryBanner = {
  __typename?: 'SecondaryBanner';
  backgroundColorHex: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaBackgroundColorHex: Maybe<Scalars['String']>;
  ctaColorHex: Maybe<Scalars['String']>;
  desktopImageUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  locale: Maybe<Scalars['String']>;
  mobileImageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  secondaryText: Maybe<Scalars['String']>;
  secondaryTextColorHex: Maybe<Scalars['String']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type SecondaryBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Scalars['String']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  secondaryText?: InputMaybe<Scalars['String']>;
  secondaryTextColorHex?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

/** Autogenerated return type of SecondaryBannerPlacementCreate */
export type SecondaryBannerPlacementCreatePayload = {
  __typename?: 'SecondaryBannerPlacementCreatePayload';
  /** The newly created secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement;
};

export type SecondaryBannerPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** The images on the banner */
  images: GenericImagesInput;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The layout the placement should appear on */
  layout?: InputMaybe<Scalars['String']>;
  /** Locale */
  locale?: InputMaybe<BannerLocaleEnum>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The style and text of the secondary text */
  secondaryText?: InputMaybe<ConfigurableTextInput>;
  /** The layout the placement should appear on */
  stringLayout?: InputMaybe<Scalars['String']>;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** The variant of the banner */
  variant?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SecondaryBannerPlacementUpdate */
export type SecondaryBannerPlacementUpdatePayload = {
  __typename?: 'SecondaryBannerPlacementUpdatePayload';
  /** The updated secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement;
};

export type SellSheetAnalyticsSummary = {
  __typename?: 'SellSheetAnalyticsSummary';
  sellSheetId: Maybe<Scalars['String']>;
  totalOrders: Maybe<Scalars['BigInt']>;
  totalSalesUsd: Maybe<Scalars['Float']>;
};

export type SellSheetAnalyticsSummaryGrowthMetrics = {
  __typename?: 'SellSheetAnalyticsSummaryGrowthMetrics';
  sellSheetId: Maybe<Scalars['String']>;
  totalOrdersGrowth: Maybe<Scalars['Float']>;
  totalSalesUsdGrowth: Maybe<Scalars['Float']>;
};

export type SellSheetAnalyticsSummaryRequestInput = {
  dateRange?: InputMaybe<InstacartAdsSharedV1DateRangeInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetAnalyticsSummaryResponse = {
  __typename?: 'SellSheetAnalyticsSummaryResponse';
  analyticsSummary: Maybe<SellSheetAnalyticsSummary>;
  growthMetrics: Maybe<SellSheetAnalyticsSummaryGrowthMetrics>;
  previousPeriodMetrics: Maybe<SellSheetAnalyticsSummary>;
};

export type SellSheetAttributes = {
  __typename?: 'SellSheetAttributes';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  overview: Maybe<Scalars['String']>;
};

export type SellSheetAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetAttributesResponse = {
  __typename?: 'SellSheetAttributesResponse';
  legalFilterType: Maybe<LegalFilterType>;
  sellSheetAttributes: Maybe<SellSheetAttributes>;
};

export type SellSheetBrandProfileAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetBrandProfileAttributesResponse = {
  __typename?: 'SellSheetBrandProfileAttributesResponse';
  brandProfileAttributes: Maybe<BrandProfileAttributes>;
};

export type SellSheetCard = {
  __typename?: 'SellSheetCard';
  brandImages: Maybe<Array<Maybe<ImageAsset>>>;
  brandName: Maybe<Scalars['String']>;
  brandProfileId: Maybe<Scalars['String']>;
  productDisplays: Maybe<Array<Maybe<ProductDisplay>>>;
  productImages: Maybe<Array<Maybe<ImageAsset>>>;
  sellSheetAnalyticsGrowthMetrics: Maybe<SellSheetAnalyticsSummaryGrowthMetrics>;
  sellSheetAnalyticsSummary: Maybe<SellSheetAnalyticsSummary>;
  sellSheetAttributes: Maybe<SellSheetAttributes>;
};

export type SellSheetCardsRequestInput = {
  brandProfileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDebug?: InputMaybe<Scalars['Boolean']>;
  paginationRequest?: InputMaybe<InstacartAdsSharedV1PaginationRequestInput>;
  regionalAreas?: InputMaybe<Array<InputMaybe<InstacartAdsNexusV1RegionalArea>>>;
  retailerCarriedState?: InputMaybe<SellSheetRetailerCarriedState>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sortKeys?: InputMaybe<Array<InputMaybe<SellSheetSortKey>>>;
  superCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  superCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type SellSheetCardsResponse = {
  __typename?: 'SellSheetCardsResponse';
  paginationResponse: Maybe<InstacartAdsSharedV1PaginationResponse>;
  sellSheetCards: Maybe<Array<Maybe<SellSheetCard>>>;
};

export type SellSheetOverviewAttributes = {
  __typename?: 'SellSheetOverviewAttributes';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  productCount: Maybe<Scalars['BigInt']>;
};

export type SellSheetProductsAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetProductsAttributesResponse = {
  __typename?: 'SellSheetProductsAttributesResponse';
  productsAttributes: Maybe<Array<Maybe<ProductAttributes>>>;
};

export type SellSheetProductsSummaryTraitsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetProductsSummaryTraitsResponse = {
  __typename?: 'SellSheetProductsSummaryTraitsResponse';
  productsSummaryTraits: Maybe<Array<Maybe<ProductSummaryTraits>>>;
};

export enum SellSheetRetailerCarriedState {
  PartiallyCarried = 'PARTIALLY_CARRIED',
  RetailerCarriedUnkown = 'RETAILER_CARRIED_UNKOWN'
}

export enum SellSheetSortKey {
  BrandName = 'BRAND_NAME',
  CreatedAt = 'CREATED_AT',
  ProductOrders = 'PRODUCT_ORDERS',
  ProductOrdersGrowth = 'PRODUCT_ORDERS_GROWTH',
  SalesAmount = 'SALES_AMOUNT',
  SalesGrowth = 'SALES_GROWTH',
  SortKeyUnkwown = 'SORT_KEY_UNKWOWN',
  UnitsSold = 'UNITS_SOLD',
  UnitsSoldGrowth = 'UNITS_SOLD_GROWTH'
}

export enum Send {
  /** The campaign has an email template */
  Email = 'email',
  /** The campaign has a push notification template */
  Push = 'push'
}

export type SendWhitelabelSiteRetailerEmailRequestInput = {
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type SendWhitelabelSiteRetailerEmailResponse = {
  __typename?: 'SendWhitelabelSiteRetailerEmailResponse';
  whitelabelSite: Maybe<WhitelabelSite>;
};

/** Autogenerated return type of SetMobileProperties */
export type SetMobilePropertiesPayload = {
  __typename?: 'SetMobilePropertiesPayload';
  /** The full set of properties */
  mobileAppProperties: Array<OnboardingFeatureTypesProperty>;
};

export type SetMultiRetailerPageCollectionsCacheRequestInput = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type SetMultiRetailerPageCollectionsCacheResponse = {
  __typename?: 'SetMultiRetailerPageCollectionsCacheResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type SetUserSettingRequestInput = {
  client?: InputMaybe<ClientInput>;
  setting?: InputMaybe<UserSettingInput>;
};

export type SetUserSettingResponse = {
  __typename?: 'SetUserSettingResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type ShelfImage = {
  __typename?: 'ShelfImage';
  boundingBox: Maybe<BoundingBox>;
  capturedAt: Maybe<Scalars['DateTime']>;
  imageUrl: Maybe<Scalars['String']>;
};

export type ShelfLocation = {
  __typename?: 'ShelfLocation';
  currentFacings: Maybe<Scalars['Int']>;
  images: Maybe<Array<Maybe<ShelfImage>>>;
  location: Maybe<Scalars['String']>;
};

export enum ShiftTypeEnum {
  FullService = 'FULL_SERVICE',
  PickingOnly = 'PICKING_ONLY',
  Runner = 'RUNNER'
}

export type ShopSidebar = {
  __typename?: 'ShopSidebar';
  collapsed: Maybe<Scalars['Boolean']>;
};

export type ShoppedAtRetailerInput = {
  /** Id of the country where the check is to be performed */
  countryId?: InputMaybe<Scalars['Int']>;
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** Number of days in the past to check */
  numberOfDays?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the Retailer */
  retailerId: Scalars['Int'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionCreate */
export type ShoppedAtRetailerVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionCreatePayload';
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer;
};

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionUpdate */
export type ShoppedAtRetailerVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionUpdatePayload';
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer;
};

export type ShoppedInput = {
  /** Id of the country where the check is to be performed */
  countryId?: InputMaybe<Scalars['Int']>;
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** Number of days in the past to check */
  numberOfDays?: InputMaybe<Scalars['Int']>;
  /** Number of times in the past to check */
  numberOfTimes?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ShoppedVisibilityConditionCreate */
export type ShoppedVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedVisibilityConditionCreatePayload';
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped;
};

/** Autogenerated return type of ShoppedVisibilityConditionUpdate */
export type ShoppedVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedVisibilityConditionUpdatePayload';
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped;
};

export type ShopperOrderItemScanInput = {
  scannedString?: InputMaybe<Scalars['String']>;
  scannedStringType?: InputMaybe<Scalars['String']>;
};

export type ShopperOrderProfile = {
  __typename?: 'ShopperOrderProfile';
  avatarUrl: Maybe<Scalars['String']>;
  batchId: Maybe<Scalars['BigInt']>;
  canChat: Maybe<Scalars['Boolean']>;
  canReceiveTips: Maybe<Scalars['Boolean']>;
  canTakeAlcoholOrders: Maybe<Scalars['Boolean']>;
  deliverer: Maybe<Scalars['Boolean']>;
  displayName: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  lastName: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['BigInt']>;
  partnerType: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  picker: Maybe<Scalars['Boolean']>;
  primaryZoneId: Maybe<Scalars['BigInt']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  rolesMask: Maybe<Scalars['Int']>;
  runner: Maybe<Scalars['Boolean']>;
  shareCode: Maybe<Scalars['String']>;
  signatureUrl: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
};

export enum ShopperType {
  ShopperTypeFss = 'SHOPPER_TYPE_FSS',
  ShopperTypePartnerPick = 'SHOPPER_TYPE_PARTNER_PICK',
  ShopperTypeUnknown = 'SHOPPER_TYPE_UNKNOWN'
}

export type SignupPartner = {
  __typename?: 'SignupPartner';
  description: Maybe<Scalars['String']>;
  hasExclusiveOption: Maybe<Scalars['Boolean']>;
  hasPriceParityOption: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  logo: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  skipCreditCheck: Maybe<Scalars['Boolean']>;
  slug: Maybe<Scalars['String']>;
};

export type Slot = {
  __typename?: 'Slot';
  createdAt: Maybe<Scalars['DateTime']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  isStatic: Maybe<Scalars['Boolean']>;
  legacySlotId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type SlotCreative = {
  __typename?: 'SlotCreative';
  cartState: Maybe<CartState>;
  createdAt: Maybe<Scalars['DateTime']>;
  creativeId: Maybe<Scalars['BigInt']>;
  creativeRank: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  slotId: Maybe<Scalars['BigInt']>;
  treatmentOfferState: Maybe<TreatmentOfferState>;
  treatmentPolicyId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type SlotCreativeInput = {
  cartState?: InputMaybe<CartState>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SlotInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  legacySlotId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SocialIconNav = {
  __typename?: 'SocialIconNav';
  icons: Maybe<SocialIconsNavigation>;
  text: Maybe<SocialIconsTextNavigation>;
};

export type SocialIconNavInput = {
  icons?: InputMaybe<SocialIconsNavigationInput>;
  text?: InputMaybe<SocialIconsTextNavigationInput>;
};

export type SocialIconsNavigation = {
  __typename?: 'SocialIconsNavigation';
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
};

export type SocialIconsNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type SocialIconsTextNavigation = {
  __typename?: 'SocialIconsTextNavigation';
  id: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  placementId: Maybe<Scalars['BigInt']>;
};

export type SocialIconsTextNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export enum SortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnknown = 'SORT_DIRECTION_UNKNOWN'
}

export enum SortDirectionEnum {
  /** Sort in ascending order */
  Asc = 'ASC',
  /** Sort in descending order */
  Desc = 'DESC'
}

export type SortingDetailsInput = {
  direction?: InputMaybe<SortingDirection>;
  fieldName?: InputMaybe<Scalars['String']>;
};

export enum SortingDirection {
  SortingDirectionAsc = 'SORTING_DIRECTION_ASC',
  SortingDirectionDesc = 'SORTING_DIRECTION_DESC',
  SortingDirectionUnknown = 'SORTING_DIRECTION_UNKNOWN'
}

export enum SourceLevel {
  SourceLevelMulti = 'SOURCE_LEVEL_MULTI',
  SourceLevelProduct = 'SOURCE_LEVEL_PRODUCT',
  SourceLevelRetailerProduct = 'SOURCE_LEVEL_RETAILER_PRODUCT',
  SourceLevelUnknown = 'SOURCE_LEVEL_UNKNOWN'
}

export type StageLastmileOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerProvidedAmounts?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type StageLastmileOrderResponse = {
  __typename?: 'StageLastmileOrderResponse';
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

export type StandardInfoModalSheet = {
  __typename?: 'StandardInfoModalSheet';
  description: Maybe<Scalars['String']>;
  desktopImageUrl: Maybe<Scalars['String']>;
  disclaimer: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  imageAltText: Maybe<Scalars['String']>;
  linkCta: Maybe<Scalars['String']>;
  linkCtaAction: Maybe<BannerAction>;
  linkCtaButtonStyle: Maybe<ButtonStyle>;
  locale: Maybe<Scalars['String']>;
  mobileImageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  primaryCta: Maybe<Scalars['String']>;
  primaryCtaAction: Maybe<BannerAction>;
  primaryCtaButtonStyle: Maybe<ButtonStyle>;
  secondaryCta: Maybe<Scalars['String']>;
  secondaryCtaAction: Maybe<BannerAction>;
  secondaryCtaButtonStyle: Maybe<ButtonStyle>;
  title: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type StandardInfoModalSheetInput = {
  description?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  disclaimer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  linkCta?: InputMaybe<Scalars['String']>;
  linkCtaAction?: InputMaybe<BannerActionInput>;
  linkCtaButtonStyle?: InputMaybe<ButtonStyle>;
  locale?: InputMaybe<Scalars['String']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  primaryCta?: InputMaybe<Scalars['String']>;
  primaryCtaAction?: InputMaybe<BannerActionInput>;
  primaryCtaButtonStyle?: InputMaybe<ButtonStyle>;
  secondaryCta?: InputMaybe<Scalars['String']>;
  secondaryCtaAction?: InputMaybe<BannerActionInput>;
  secondaryCtaButtonStyle?: InputMaybe<ButtonStyle>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type StartCampaignInput = {
  /** The id of the campaign returned from the campaign domain */
  campaignId: Scalars['ID'];
  /** The user friendly name of the campaign returned from the campaign domain */
  campaignName?: InputMaybe<Scalars['String']>;
  /** Whether or not to create a split experiment */
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the push notification template returned */
  pushNotificationId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the segment. Currently for Braze's API */
  segmentId: Scalars['ID'];
  /** The start time for the email to send. A null value indicates immediately */
  startTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The external id of the template returned */
  templateId?: InputMaybe<Scalars['ID']>;
  /** Variables to append to the Braze template */
  templateVariables: TemplateVariablesInput;
  /** The experiment name to use for the CRM Campaign */
  userProvidedExperimentName?: InputMaybe<Scalars['String']>;
  /** The warehouse id to run the campaign for */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of StartCampaign */
export type StartCampaignPayload = {
  __typename?: 'StartCampaignPayload';
  /** The campaign configuration object */
  campaignConfiguration: MarketingFeatureTypesCampaignConfiguration;
};

export type StartConvertPlacementVideoRequestInput = {
  localeCode?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  subtitlesUri?: InputMaybe<Scalars['String']>;
  videoUri?: InputMaybe<Scalars['String']>;
};

export type StartConvertPlacementVideoResponse = {
  __typename?: 'StartConvertPlacementVideoResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type StartWhitelabelGumloopWorkflowRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowName?: InputMaybe<Scalars['String']>;
  workflowParameters?: InputMaybe<WhitelabelGumloopWorkflowParametersInput>;
};

export type StartWhitelabelGumloopWorkflowResponse = {
  __typename?: 'StartWhitelabelGumloopWorkflowResponse';
  errorMessage: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  waterfallEffectId: Maybe<Scalars['BigInt']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
  workflowRunId: Maybe<Scalars['String']>;
};

export enum Status {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
  Live = 'LIVE'
}

export type StatusMapInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<FilterType>;
  status?: InputMaybe<FilterType>;
};

export enum StockStatus {
  StockStatusLow = 'STOCK_STATUS_LOW',
  StockStatusOos = 'STOCK_STATUS_OOS',
  StockStatusPredictedLow = 'STOCK_STATUS_PREDICTED_LOW',
  StockStatusUnknown = 'STOCK_STATUS_UNKNOWN'
}

export enum Store {
  /** Retailer with 1 hour delivery */
  OneHour = 'one_hour',
  /** Retailer with 30 min delivery */
  ThirtyMin = 'thirty_min'
}

export type StoreConfiguration = {
  __typename?: 'StoreConfiguration';
  enterpriseRetailerSettings: Maybe<Scalars['JSONObject']>;
  id: Maybe<Scalars['Int']>;
  settings: Maybe<Scalars['JSONObject']>;
  userIsolationContextId: Maybe<Scalars['Int']>;
};

export type StoreConfigurationDraft = {
  __typename?: 'StoreConfigurationDraft';
  createdAt: Maybe<Scalars['DateTime']>;
  domainConfigurations: Maybe<DomainConfiguration>;
  domainConfigurationsRaw: Maybe<Scalars['JSONObject']>;
  draftId: Maybe<Scalars['String']>;
  draftName: Maybe<Scalars['String']>;
  parentDraftId: Maybe<Scalars['String']>;
  publishedAt: Maybe<Scalars['DateTime']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type StoreConfigurationInput = {
  enterpriseRetailerSettings?: InputMaybe<Scalars['JSONObject']>;
  id?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Scalars['JSONObject']>;
  userIsolationContextId?: InputMaybe<Scalars['Int']>;
};

export enum StoreConfigurationRelationshipEnum {
  /** StoreConfigurations that are associated */
  Associated = 'ASSOCIATED',
  /** StoreConfigurations that are owned */
  Owner = 'OWNER'
}

export type StoreHours = {
  __typename?: 'StoreHours';
  overrideHours: Maybe<Array<Maybe<OverrideHours>>>;
  regularHours: Maybe<Array<Maybe<RegularHours>>>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type StoreHoursByDate = {
  __typename?: 'StoreHoursByDate';
  createdAt: Maybe<Scalars['DateTime']>;
  date: Maybe<GoogleTypeDate>;
  endsAt: Maybe<GoogleTypeTimeOfDay>;
  operationalHours: Maybe<OperationalHours>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerLocationFlags: Maybe<RetailerLocationFlags>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  startsAt: Maybe<GoogleTypeTimeOfDay>;
  updatedAt: Maybe<Scalars['DateTime']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export type StoreHoursByDayOfWeek = {
  __typename?: 'StoreHoursByDayOfWeek';
  createdAt: Maybe<Scalars['DateTime']>;
  dayOfWeek: Maybe<GoogleTypeDayOfWeek>;
  endsAt: Maybe<GoogleTypeTimeOfDay>;
  operationalHours: Maybe<OperationalHours>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerLocationFlags: Maybe<RetailerLocationFlags>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  startsAt: Maybe<GoogleTypeTimeOfDay>;
  updatedAt: Maybe<Scalars['DateTime']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export type StoreHoursByZoneRetailer = {
  __typename?: 'StoreHoursByZoneRetailer';
  createdAt: Maybe<Scalars['DateTime']>;
  date: Maybe<GoogleTypeDate>;
  endsAt: Maybe<GoogleTypeTimeOfDay>;
  retailerId: Maybe<Scalars['BigInt']>;
  startsAt: Maybe<GoogleTypeTimeOfDay>;
  updatedAt: Maybe<Scalars['DateTime']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export type StoreHoursUpdateTask = {
  __typename?: 'StoreHoursUpdateTask';
  author: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Maybe<Scalars['DateTime']>;
  failedUpdates: Maybe<Array<Maybe<FailedUpdate>>>;
  id: Maybe<Scalars['BigInt']>;
  status: Maybe<TaskStatus>;
  updateSource: Maybe<Scalars['String']>;
  updatedRetailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type StorePerformanceRecord = {
  __typename?: 'StorePerformanceRecord';
  name: Maybe<Scalars['String']>;
  overstaffedHours: Maybe<InstacartTypesV1BigDecimal>;
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>;
  scheduledDevices: Maybe<Scalars['Int']>;
  scheduledGaps: Maybe<Scalars['Int']>;
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>;
  understaffedHours: Maybe<InstacartTypesV1BigDecimal>;
  warehouseLocationId: Maybe<Scalars['BigInt']>;
};

export type StorePerformanceRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type StorePerformanceResponse = {
  __typename?: 'StorePerformanceResponse';
  metric: Maybe<Array<Maybe<StorePerformanceRecord>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
  warehouseId: Maybe<Scalars['BigInt']>;
};

export enum Storefront {
  /** Marketplace storefront */
  Instacart = 'instacart',
  /** Storefront / Storefront PRO storefronts */
  Pbi = 'pbi'
}

export type StorefrontHiddenBadges = {
  __typename?: 'StorefrontHiddenBadges';
  highlyInStock: Maybe<Scalars['Boolean']>;
};

export type StorefrontLayouts = {
  __typename?: 'StorefrontLayouts';
  activeVariants: Maybe<StorefrontLayoutsActiveVariants>;
  desktopFlexibleHeaderLayoutV1: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1>;
  desktopSidebarLayoutV1: Maybe<StorefrontLayoutsDesktopSidebarLayoutV1>;
  mobileWebHamburgerMenuLayoutV1: Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1>;
  mobileWebHeaderLayoutV1: Maybe<StorefrontLayoutsMobileWebHeaderLayoutV1>;
  nativeAppHeaderLayoutV1: Maybe<StorefrontLayoutsNativeAppHeaderLayoutV1>;
  nativeMoreMenuLayoutV1: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1>;
  nativeStoreMenuLayoutV1: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1>;
};

export type StorefrontLayoutsActiveVariants = {
  __typename?: 'StorefrontLayoutsActiveVariants';
  desktop: Maybe<StorefrontLayoutsActiveVariantsDesktop>;
  mobileWeb: Maybe<StorefrontLayoutsActiveVariantsMobileWeb>;
  nativeApp: Maybe<StorefrontLayoutsActiveVariantsNativeApp>;
};

export type StorefrontLayoutsActiveVariantsDesktop = {
  __typename?: 'StorefrontLayoutsActiveVariantsDesktop';
  footerVariant: Maybe<StorefrontLayoutsActiveVariantsDesktopFooterVariants>;
  hamburgerMenuVariant: Maybe<StorefrontLayoutsActiveVariantsDesktopHamburgerMenuVariants>;
  headerVariant: Maybe<StorefrontLayoutsActiveVariantsDesktopHeaderVariants>;
  sidebarVariant: Maybe<StorefrontLayoutsActiveVariantsDesktopSidebarVariants>;
};

export enum StorefrontLayoutsActiveVariantsDesktopFooterVariants {
  DesktopFooterLayoutUnknown = 'DESKTOP_FOOTER_LAYOUT_UNKNOWN',
  DesktopFooterLayoutV1 = 'DESKTOP_FOOTER_LAYOUT_V1',
  FooterVariantsUnknown = 'FOOTER_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsDesktopHamburgerMenuVariants {
  DesktopHamburgerMenuLayoutUnknown = 'DESKTOP_HAMBURGER_MENU_LAYOUT_UNKNOWN',
  DesktopHamburgerMenuLayoutV1 = 'DESKTOP_HAMBURGER_MENU_LAYOUT_V1',
  HamburgerMenuVariantsUnknown = 'HAMBURGER_MENU_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsDesktopHeaderVariants {
  DesktopFlexibleHeaderLayoutV1 = 'DESKTOP_FLEXIBLE_HEADER_LAYOUT_V1',
  DesktopHeaderLayoutUnknown = 'DESKTOP_HEADER_LAYOUT_UNKNOWN',
  HeaderVariantsUnknown = 'HEADER_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsDesktopSidebarVariants {
  DesktopSidebarLayoutUnknown = 'DESKTOP_SIDEBAR_LAYOUT_UNKNOWN',
  DesktopSidebarLayoutV1 = 'DESKTOP_SIDEBAR_LAYOUT_V1',
  SidebarVariantsUnknown = 'SIDEBAR_VARIANTS_UNKNOWN'
}

export type StorefrontLayoutsActiveVariantsMobileWeb = {
  __typename?: 'StorefrontLayoutsActiveVariantsMobileWeb';
  hamburgerMenuVariant: Maybe<StorefrontLayoutsActiveVariantsMobileWebMobileWebHamburgerMenuVariants>;
  headerVariant: Maybe<StorefrontLayoutsActiveVariantsMobileWebMobileWebHeaderVariants>;
};

export enum StorefrontLayoutsActiveVariantsMobileWebMobileWebHamburgerMenuVariants {
  MobileWebHamburgerMenuLayoutUnspecified = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_UNSPECIFIED',
  MobileWebHamburgerMenuLayoutV1 = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_V1',
  MobileWebHamburgerMenuVariantsUnknown = 'MOBILE_WEB_HAMBURGER_MENU_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsMobileWebMobileWebHeaderVariants {
  MobileWebHeaderLayoutUnspecified = 'MOBILE_WEB_HEADER_LAYOUT_UNSPECIFIED',
  MobileWebHeaderLayoutV1 = 'MOBILE_WEB_HEADER_LAYOUT_V1',
  MobileWebHeaderVariantsUnknown = 'MOBILE_WEB_HEADER_VARIANTS_UNKNOWN'
}

export type StorefrontLayoutsActiveVariantsNativeApp = {
  __typename?: 'StorefrontLayoutsActiveVariantsNativeApp';
  headerVariant: Maybe<StorefrontLayoutsActiveVariantsNativeAppNativeAppHeaderVariants>;
  moreMenuVariant: Maybe<StorefrontLayoutsActiveVariantsNativeAppNativeMoreMenuVariants>;
  storeMenuVariant: Maybe<StorefrontLayoutsActiveVariantsNativeAppNativeStoreMenuVariants>;
};

export enum StorefrontLayoutsActiveVariantsNativeAppNativeAppHeaderVariants {
  NativeAppHeaderLayoutUnspecified = 'NATIVE_APP_HEADER_LAYOUT_UNSPECIFIED',
  NativeAppHeaderLayoutV1 = 'NATIVE_APP_HEADER_LAYOUT_V1',
  NativeAppHeaderVariantsUnknown = 'NATIVE_APP_HEADER_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsNativeAppNativeMoreMenuVariants {
  NativeMoreMenuLayoutUnknown = 'NATIVE_MORE_MENU_LAYOUT_UNKNOWN',
  NativeMoreMenuLayoutV1 = 'NATIVE_MORE_MENU_LAYOUT_V1',
  NativeMoreMenuVariantsUnknown = 'NATIVE_MORE_MENU_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsNativeAppNativeStoreMenuVariants {
  NativeStoreMenuLayoutUnspecified = 'NATIVE_STORE_MENU_LAYOUT_UNSPECIFIED',
  NativeStoreMenuLayoutV1 = 'NATIVE_STORE_MENU_LAYOUT_V1',
  NativeStoreMenuVariantsUnknown = 'NATIVE_STORE_MENU_VARIANTS_UNKNOWN'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1 = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1';
  clientElementConfigurations: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurations>;
  dynamicElementConfigurationsHeaderBar1: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations>;
  dynamicElementConfigurationsHeaderBar2: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations>;
  headerBar1: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar>;
  headerBar2: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurations = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurations';
  account: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsAccount>;
  cart: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCart>;
  fulfillmentSelector: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelector>;
  search: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearch>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsAccount = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsAccount';
  showName: Maybe<Scalars['Boolean']>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCart = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCart';
  variant: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCartCartVariant>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCartCartVariant {
  CartVariantUnknown = 'CART_VARIANT_UNKNOWN',
  Default = 'DEFAULT',
  Outlined = 'OUTLINED'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelector = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelector';
  storeLabel: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorStoreLabelType>;
  variant: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorFulfillmentSelectorVariant>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorFulfillmentSelectorVariant {
  FulfillmentSelectorVariantUnknown = 'FULFILLMENT_SELECTOR_VARIANT_UNKNOWN',
  MultiLine = 'MULTI_LINE',
  SingleLine = 'SINGLE_LINE'
}

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorStoreLabelType {
  StoreAddress = 'STORE_ADDRESS',
  StoreLabelTypeUnknown = 'STORE_LABEL_TYPE_UNKNOWN',
  StoreName = 'STORE_NAME'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearch = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearch';
  variant: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearchSearchVariant>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearchSearchVariant {
  Branded = 'BRANDED',
  Default = 'DEFAULT',
  SearchVariantUnknown = 'SEARCH_VARIANT_UNKNOWN'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations';
  adminColumn1FeaturedLinksBlock: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock>;
  adminColumn1LinksBlock: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsHeaderBarLinksBlock>;
  adminColumn2FeaturedLinksBlock: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock';
  navs: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsHeaderBarLinksBlock = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsHeaderBarLinksBlock';
  navs: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar';
  column1Elements: Maybe<Array<Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn1Elements>>>;
  column2Elements: Maybe<Array<Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn2Elements>>>;
  size: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarSize>;
  sticky: Maybe<Scalars['Boolean']>;
  theme: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarTheme>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn1Elements {
  Column1ElementsSearch = 'COLUMN1_ELEMENTS_SEARCH',
  Column1ElementsUnknown = 'COLUMN1_ELEMENTS_UNKNOWN',
  HamburgerMenu = 'HAMBURGER_MENU',
  HeaderBarLinksBlock = 'HEADER_BAR_LINKS_BLOCK',
  Logo = 'LOGO',
  WarehouseSelector = 'WAREHOUSE_SELECTOR'
}

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn2Elements {
  Account = 'ACCOUNT',
  Cart = 'CART',
  Column2ElementsUnknown = 'COLUMN2_ELEMENTS_UNKNOWN',
  FeaturedLinksBlock = 'FEATURED_LINKS_BLOCK',
  FulfillmentSelector = 'FULFILLMENT_SELECTOR',
  LanguageSelector = 'LANGUAGE_SELECTOR',
  Search = 'SEARCH'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarTheme = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarTheme';
  backgroundColor: Maybe<AtomsColor>;
  backgroundColorHex: Maybe<Scalars['String']>;
  backgroundType: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarThemeBackgroundType>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarThemeBackgroundType {
  BackgroundTypeUnknown = 'BACKGROUND_TYPE_UNKNOWN',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarSize {
  Large = 'LARGE',
  SizeUnknown = 'SIZE_UNKNOWN',
  Small = 'SMALL'
}

export type StorefrontLayoutsDesktopSidebarLayoutV1 = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1';
  dynamicElementConfigurations: Maybe<StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurations>;
  retailerElements: Maybe<Array<Maybe<StorefrontLayoutsDesktopSidebarLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurations';
  navigations: Maybe<StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurationsNavigations>;
};

export type StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurationsNavigations';
  navs: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsDesktopSidebarLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1RetailerElements';
  elements: Maybe<Array<Maybe<StorefrontLayoutsDesktopSidebarLayoutV1RetailerElementsElementsType>>>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsDesktopSidebarLayoutV1RetailerElementsElementsType {
  Departments = 'DEPARTMENTS',
  DesktopSidebarLayoutV1ElementsTypeUnknown = 'DESKTOP_SIDEBAR_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR'
}

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1 = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1';
  dynamicElementConfigurations: Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurations>;
  retailerElements: Maybe<Array<Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurations';
  navigations: Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurationsNavigations>;
};

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurationsNavigations';
  navs: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElements';
  elements: Maybe<Array<Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElementsElementsType>>>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElementsElementsType {
  AccountOrAuthenticationArea = 'ACCOUNT_OR_AUTHENTICATION_AREA',
  Departments = 'DEPARTMENTS',
  FooterDisclaimer = 'FOOTER_DISCLAIMER',
  LanguageSelector = 'LANGUAGE_SELECTOR',
  MobileWebHamburgerMenuLayoutV1ElementsTypeUnknown = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR',
  SocialLinks = 'SOCIAL_LINKS',
  WarehouseSelector = 'WAREHOUSE_SELECTOR'
}

export type StorefrontLayoutsMobileWebHeaderLayoutV1 = {
  __typename?: 'StorefrontLayoutsMobileWebHeaderLayoutV1';
  theme: Maybe<StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarTheme>;
};

export type StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarTheme = {
  __typename?: 'StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarTheme';
  backgroundColor: Maybe<AtomsColor>;
  backgroundColorHex: Maybe<Scalars['String']>;
  backgroundType: Maybe<StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarThemeBackgroundType>;
};

export enum StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarThemeBackgroundType {
  BackgroundTypeUnknown = 'BACKGROUND_TYPE_UNKNOWN',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type StorefrontLayoutsNativeAppHeaderLayoutV1 = {
  __typename?: 'StorefrontLayoutsNativeAppHeaderLayoutV1';
  theme: Maybe<StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarTheme>;
};

export type StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarTheme = {
  __typename?: 'StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarTheme';
  backgroundColor: Maybe<AtomsColor>;
  backgroundType: Maybe<StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarThemeBackgroundType>;
};

export enum StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarThemeBackgroundType {
  BackgroundTypeUnknown = 'BACKGROUND_TYPE_UNKNOWN',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type StorefrontLayoutsNativeMoreMenuLayoutV1 = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1';
  dynamicElementConfigurations: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurations>;
  retailerElements: Maybe<Array<Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurations';
  navigations: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsNavigations>;
  slots: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsSlots>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsNavigations';
  navs: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsSlots = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsSlots';
  slots: Maybe<Array<Maybe<RetailerSlot>>>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElements';
  elements: Maybe<Array<Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElementsElementsType>>>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElementsElementsType {
  AccountLinks = 'ACCOUNT_LINKS',
  AuthLinks = 'AUTH_LINKS',
  FooterDisclaimer = 'FOOTER_DISCLAIMER',
  NativeMoreMenuLayoutV1ElementsTypeUnknown = 'NATIVE_MORE_MENU_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR',
  SocialLinks = 'SOCIAL_LINKS'
}

export type StorefrontLayoutsNativeStoreMenuLayoutV1 = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1';
  dynamicElementConfigurations: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurations>;
  retailerElements: Maybe<Array<Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurations';
  navigations: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsNavigations>;
  slots: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsSlots>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsNavigations';
  navs: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsSlots = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsSlots';
  slots: Maybe<Array<Maybe<RetailerSlot>>>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElements';
  elements: Maybe<Array<Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElementsElementsType>>>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElementsElementsType {
  Departments = 'DEPARTMENTS',
  NativeStoreMenuLayoutV1ElementsTypeUnknown = 'NATIVE_STORE_MENU_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR'
}

export type StorefrontLocationSelector = {
  __typename?: 'StorefrontLocationSelector';
  showCrossRetailerInStoreLocations: Maybe<Scalars['Boolean']>;
  showCrossRetailerPickupLocations: Maybe<Scalars['Boolean']>;
  showNameForDeliveryLocation: Maybe<Scalars['Boolean']>;
  showRetailerNameForHeaderStoreLocation: Maybe<Scalars['Boolean']>;
};

export type StorefrontPlacementBannerInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** A unique identifier of the banner associated with the placement */
  id?: InputMaybe<Scalars['ID']>;
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: PlacementImagesInput;
  /** The banner's locale (not used right now) */
  locale: BannerLocaleEnum;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
};

/** Autogenerated return type of StorefrontPlacementCreate */
export type StorefrontPlacementCreatePayload = {
  __typename?: 'StorefrontPlacementCreatePayload';
  /** The newly created storefront storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement;
};

/** Autogenerated return type of StorefrontPlacementDelete */
export type StorefrontPlacementDeletePayload = {
  __typename?: 'StorefrontPlacementDeletePayload';
  /** Whether deleting the storefront placement succeeded or not */
  success: Scalars['Boolean'];
};

export type StorefrontPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The banners configured to the placement */
  banners?: InputMaybe<Array<StorefrontPlacementBannerInput>>;
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput;
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: PlacementImagesInput;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
  /** The type of this placement */
  type: PlacementTypeEnum;
};

/** Autogenerated return type of StorefrontPlacementUpdate */
export type StorefrontPlacementUpdatePayload = {
  __typename?: 'StorefrontPlacementUpdatePayload';
  /** The updated storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement;
};

export type StorefrontSchema = {
  __typename?: 'StorefrontSchema';
  crossRetailersCustomStorefrontAllowed: Maybe<Scalars['Boolean']>;
  crossRetailersDepartmentsAllowed: Maybe<Scalars['Boolean']>;
  crossRetailersDepartmentsPrimaryRetailerId: Maybe<Scalars['BigInt']>;
  defaultServiceType: Maybe<InstacartCustomersSharedV1ServiceType>;
  displayCustomAttributes: Maybe<Scalars['Boolean']>;
  hiddenBadges: Maybe<StorefrontHiddenBadges>;
  hideOutOfStockItemsInSearch: Maybe<Scalars['Boolean']>;
  layouts: Maybe<StorefrontLayouts>;
  locationSelector: Maybe<StorefrontLocationSelector>;
  minOnSaleCarouselItems: Maybe<Scalars['BigInt']>;
  minStockLevel: Maybe<InstacartCustomersProductsV1StockLevel>;
  onlyShowInStockItems: Maybe<Scalars['Boolean']>;
  salePromotionBadgeInDollars: Maybe<Scalars['Boolean']>;
  showRetailerReferenceCodeOnItemDetails: Maybe<Scalars['Boolean']>;
};

export type StringsInput = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubNavigation = {
  __typename?: 'SubNavigation';
  flatNavigation: Maybe<FlatNavigation>;
  navigationItem: Maybe<NavigationV2Item>;
};

export type SubNavigationInput = {
  flatNavigation?: InputMaybe<FlatNavigationInput>;
  navigationItem?: InputMaybe<NavigationV2ItemInput>;
};

export type SubjectCriteria = {
  __typename?: 'SubjectCriteria';
  categoryIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l1CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l2CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l3CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l4CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l5CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l6CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notCategoryIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL1CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL2CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL3CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL4CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL5CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL6CategoryId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  onSale: Maybe<Scalars['Boolean']>;
  productId: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  term: Maybe<Array<Maybe<Scalars['String']>>>;
  termRelevanceThreshold: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of SubmissionCreate */
export type SubmissionCreatePayload = {
  __typename?: 'SubmissionCreatePayload';
  /** Survey submit successful */
  success: Scalars['Boolean'];
};

export type SummaryDetails = {
  __typename?: 'SummaryDetails';
  details: Maybe<Scalars['String']>;
};

export type SummaryStatus = {
  __typename?: 'SummaryStatus';
  count: Maybe<Scalars['BigInt']>;
  status: Maybe<Scalars['String']>;
};

export enum Targeting {
  ActivatedCustomer = 'ACTIVATED_CUSTOMER',
  ChurnedCustomer = 'CHURNED_CUSTOMER',
  LoyaltyCustomer = 'LOYALTY_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  NonLoyaltyCustomer = 'NON_LOYALTY_CUSTOMER',
  Unknown = 'UNKNOWN'
}

export type TargetingRules = {
  __typename?: 'TargetingRules';
  lookbackWindowDays: Maybe<Scalars['BigInt']>;
  targetingType: Maybe<Targeting>;
};

export type TargetingRulesInput = {
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  targetingType?: InputMaybe<Targeting>;
};

export enum TaskStatus {
  CompletedFailure = 'COMPLETED_FAILURE',
  CompletedSuccess = 'COMPLETED_SUCCESS',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  TaskStatusUndefined = 'TASK_STATUS_UNDEFINED'
}

export type TemplateVariablesInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  daysValid?: InputMaybe<Scalars['Int']>;
  editableTemplateVariables?: InputMaybe<Scalars['JSON']>;
  offerDetailsDollarOff?: InputMaybe<Scalars['String']>;
  offerDetailsMinimumOrder?: InputMaybe<Scalars['String']>;
  retailerLogoUrl?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
  storeType?: InputMaybe<Store>;
  storefrontType?: InputMaybe<Storefront>;
};

export type TestCase = {
  __typename?: 'TestCase';
  applicable: Maybe<Scalars['Boolean']>;
  capabilityPath: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  scenario: Maybe<Scalars['String']>;
  scope: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type TextWithThumbnail = {
  __typename?: 'TextWithThumbnail';
  backgroundColorHex: Maybe<Scalars['String']>;
  backgroundImageUrl: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaBackgroundColorHex: Maybe<Scalars['String']>;
  ctaColorHex: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type TextWithThumbnailFlex = {
  __typename?: 'TextWithThumbnailFlex';
  backgroundColorHex: Maybe<Scalars['String']>;
  backgroundImageUrl: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<BannerAction>;
  ctaBackgroundColorHex: Maybe<Scalars['String']>;
  ctaColorHex: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['BigInt']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
  variant: Maybe<BannerVariant>;
};

export type TextWithThumbnailFlexInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  backgroundImageUrl?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type TextWithThumbnailInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  backgroundImageUrl?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ThemePage = {
  __typename?: 'ThemePage';
  active: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  headerSection: Maybe<ThemePageHeader>;
  id: Maybe<Scalars['BigInt']>;
  retailerPicker: Maybe<ThemePageRetailerPicker>;
  searchBar: Maybe<ThemePageSearchBar>;
  slug: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type ThemePageHeader = {
  __typename?: 'ThemePageHeader';
  backgroundColorHex: Maybe<Scalars['String']>;
  disclaimerUrl: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  imageAltText: Maybe<Scalars['String']>;
  imageMobileUrl: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleColorHex: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  titleColorHex: Maybe<Scalars['String']>;
};

export type ThemePageHeaderInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  disclaimerUrl?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageMobileUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
};

export type ThemePageInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  headerSection?: InputMaybe<ThemePageHeaderInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  retailerPicker?: InputMaybe<ThemePageRetailerPickerInput>;
  searchBar?: InputMaybe<ThemePageSearchBarInput>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ThemePageRetailerPicker = {
  __typename?: 'ThemePageRetailerPicker';
  enabled: Maybe<Scalars['Boolean']>;
};

export type ThemePageRetailerPickerInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ThemePageSearchBar = {
  __typename?: 'ThemePageSearchBar';
  enabled: Maybe<Scalars['Boolean']>;
};

export type ThemePageSearchBarInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ThemeSchema = {
  __typename?: 'ThemeSchema';
  footer: Maybe<Footer>;
  header: Maybe<Header>;
  idsTheme: Maybe<IdsThemeSchema>;
  items: Maybe<ItemsSchema>;
  shopSidebar: Maybe<ShopSidebar>;
};

export enum TicketStatus {
  TicketStatusCompleted = 'TICKET_STATUS_COMPLETED',
  TicketStatusInProgress = 'TICKET_STATUS_IN_PROGRESS',
  TicketStatusUnknown = 'TICKET_STATUS_UNKNOWN',
  TicketStatusWontDo = 'TICKET_STATUS_WONT_DO'
}

export type TimePeriod = {
  __typename?: 'TimePeriod';
  closesAt: Maybe<Scalars['DateTime']>;
  opensAt: Maybe<Scalars['DateTime']>;
};

export enum TokenTypeEnum {
  /** Account Setup Token Type */
  AccountSetup = 'account_setup',
  /** Email Verification Token Type */
  EmailVerification = 'email_verification',
  /** Password Reset Token Type */
  PasswordReset = 'password_reset'
}

export type TokensValidation = {
  __typename?: 'TokensValidation';
  /** Whether account is already set up */
  accountStateValid: Scalars['Boolean'];
  /** Email associated with the token */
  email: Maybe<Scalars['String']>;
  /** Whether the token is valid */
  valid: Scalars['Boolean'];
};

export type TombstoneDetectionVersionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  tombstonedBy?: InputMaybe<Scalars['String']>;
  tombstonedWhy?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type TombstoneDetectionVersionResponse = {
  __typename?: 'TombstoneDetectionVersionResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type ToolCall = {
  __typename?: 'ToolCall';
  function: Function;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ToolCallInput = {
  function: FunctionInput;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ToolInput = {
  function: FunctionDefinitionInput;
  type: Scalars['String'];
};

export type ToolingShortcut = {
  __typename?: 'ToolingShortcut';
  country: Maybe<Scalars['String']>;
  cta: Maybe<Scalars['String']>;
  ctaAction: Maybe<InstacartCustomersContentManagementV1BannerAction>;
  experimentName: Maybe<Scalars['String']>;
  imageAltText: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  isAbsoluteRanking: Maybe<Scalars['Boolean']>;
  isBusinessPriority: Maybe<Scalars['Boolean']>;
  isPriceParity: Maybe<Scalars['Boolean']>;
  localizedData: Maybe<Array<Maybe<ToolingShortcutLocalizedData>>>;
  placementId: Maybe<Scalars['BigInt']>;
  rank: Maybe<Scalars['Int']>;
  shortcutScope: Maybe<Scalars['String']>;
  subTitle: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  userStatus: Maybe<Scalars['String']>;
};

export type ToolingShortcutInput = {
  country?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<InstacartCustomersContentManagementV1BannerActionInput>;
  experimentName?: InputMaybe<Scalars['String']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isAbsoluteRanking?: InputMaybe<Scalars['Boolean']>;
  isBusinessPriority?: InputMaybe<Scalars['Boolean']>;
  isPriceParity?: InputMaybe<Scalars['Boolean']>;
  localizedData?: InputMaybe<Array<InputMaybe<ToolingShortcutLocalizedDataInput>>>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  rank?: InputMaybe<Scalars['Int']>;
  shortcutScope?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userStatus?: InputMaybe<Scalars['String']>;
};

export type ToolingShortcutLocalizedData = {
  __typename?: 'ToolingShortcutLocalizedData';
  imageAltText: Maybe<Scalars['String']>;
  locale: Maybe<InstacartCustomersSharedV1Locale>;
  subTitle: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ToolingShortcutLocalizedDataInput = {
  imageAltText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum TreatmentOfferState {
  Activated = 'ACTIVATED',
  Applied = 'APPLIED',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Redeemed = 'REDEEMED',
  TreatmentOfferStateUnspecified = 'TREATMENT_OFFER_STATE_UNSPECIFIED',
  Unredeemable = 'UNREDEEMABLE'
}

/** Autogenerated return type of TriggerCampaign */
export type TriggerCampaignPayload = {
  __typename?: 'TriggerCampaignPayload';
  /** Whether it succesfully triggered */
  success: Scalars['Boolean'];
};

export type TriggerRakeTaskForStoreConfigurationRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type TriggerRakeTaskForStoreConfigurationResponse = {
  __typename?: 'TriggerRakeTaskForStoreConfigurationResponse';
  errorMessage: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
};

/** Autogenerated return type of TriggerWorkflow */
export type TriggerWorkflowPayload = {
  __typename?: 'TriggerWorkflowPayload';
  /** The triggered workflow */
  workflow: OnboardingFeatureTypesWorkflow;
};

export type TypographyFontSchema = {
  __typename?: 'TypographyFontSchema';
  fontFamily: Maybe<Scalars['String']>;
  fontWeight: Maybe<Scalars['String']>;
};

export type TypographySchema = {
  __typename?: 'TypographySchema';
  headline: Maybe<TypographyFontSchema>;
  headlineLarge2: Maybe<TypographyFontSchema>;
  rootElement: Maybe<TypographyFontSchema>;
  subtitle: Maybe<TypographyFontSchema>;
  subtitleLarge: Maybe<TypographyFontSchema>;
  subtitleMedium: Maybe<TypographyFontSchema>;
  subtitleSmall: Maybe<TypographyFontSchema>;
  title: Maybe<TypographyFontSchema>;
  titleLarge: Maybe<TypographyFontSchema>;
  titleMedium: Maybe<TypographyFontSchema>;
};

export type UiContextInput = {
  urlPath: Scalars['String'];
};

export type UnionType = {
  __typename?: 'UnionType';
  content: Maybe<Scalars['JSONObject']>;
  type: Maybe<Scalars['String']>;
};

export type UnknownBanner = {
  __typename?: 'UnknownBanner';
  id: Maybe<Scalars['BigInt']>;
};

export type UnknownBannerInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Upc = {
  __typename?: 'Upc';
  upc: Maybe<Scalars['String']>;
};

export type UpcInput = {
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateAdminNavigationV2RequestInput = {
  adminNavigationV2?: InputMaybe<AdminNavigationV2Input>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAdminNavigationV2Response = {
  __typename?: 'UpdateAdminNavigationV2Response';
  adminNavigationV2: Maybe<AdminNavigationV2>;
};

export type UpdateApiSettingRequestInput = {
  apiType?: InputMaybe<Scalars['String']>;
  cron?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateApiSettingResponse = {
  __typename?: 'UpdateApiSettingResponse';
  apiType: Maybe<Scalars['String']>;
  cron: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  integrationType: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['BigInt']>;
};

export type UpdateApprovalRequestStatusRequestInput = {
  approvalRequestId?: InputMaybe<Scalars['BigInt']>;
  comment?: InputMaybe<Scalars['String']>;
  statusAction?: InputMaybe<Scalars['String']>;
  userUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateApprovalRequestStatusResponse = {
  __typename?: 'UpdateApprovalRequestStatusResponse';
  approvalRequest: Maybe<LaunchOnboardingApprovalRequest>;
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type UpdateAuditBatchRequestInput = {
  action?: InputMaybe<Scalars['String']>;
  batchUuid?: InputMaybe<Scalars['String']>;
  changeSampleSizeValue?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Scalars['String']>;
  newSecondaryStateId?: InputMaybe<Scalars['BigInt']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  overrideDueDate?: InputMaybe<Scalars['DateTime']>;
  userUuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAuditBatchResponse = {
  __typename?: 'UpdateAuditBatchResponse';
  completedAt: Maybe<Scalars['DateTime']>;
  message: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
};

export type UpdateAuditTaskRequestInput = {
  client?: InputMaybe<Scalars['String']>;
  extComment?: InputMaybe<Scalars['String']>;
  intComment?: InputMaybe<Scalars['String']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  reviewState?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taskComponents?: InputMaybe<Array<InputMaybe<UpdateAuditTaskRequestUpdateTaskComponentInput>>>;
  taskUuid?: InputMaybe<Scalars['String']>;
  userUuid?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAuditTaskRequestUpdateTaskComponentInput = {
  explicitAuditFailed?: InputMaybe<Scalars['Boolean']>;
  extComment?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  intComment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  reviewState?: InputMaybe<Scalars['String']>;
  suggestedValue?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateAuditTaskResponse = {
  __typename?: 'UpdateAuditTaskResponse';
  batchVersion: Maybe<Scalars['BigInt']>;
  message: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
};

export type UpdateAuditWorkflowRequestInput = {
  auditWorkflow?: InputMaybe<AuditWorkflowInput>;
  configs?: InputMaybe<Array<InputMaybe<AuditWorkflowConfigInput>>>;
  tombstone?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAuditWorkflowResponse = {
  __typename?: 'UpdateAuditWorkflowResponse';
  _: Maybe<Scalars['Boolean']>;
};

export type UpdateAvailabilityScoreOverrideRequestInput = {
  enable?: InputMaybe<Scalars['Boolean']>;
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  overrideEndAt?: InputMaybe<Scalars['DateTime']>;
  overrideStartAt?: InputMaybe<Scalars['DateTime']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAvailabilityScoreOverrideResponse = {
  __typename?: 'UpdateAvailabilityScoreOverrideResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateClientConfigurationForOrdersDashboardRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  isUnata?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Scalars['String']>;
};

export type UpdateClientConfigurationForOrdersDashboardResponse = {
  __typename?: 'UpdateClientConfigurationForOrdersDashboardResponse';
  clientConfiguration: Maybe<ClientConfiguration>;
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type UpdateConfirmedStoreHoursRequestInput = {
  confirmations?: InputMaybe<Array<InputMaybe<ConfirmedStoreHoursInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateConfirmedStoreHoursResponse = {
  __typename?: 'UpdateConfirmedStoreHoursResponse';
  confirmations: Maybe<Array<Maybe<ConfirmedStoreHours>>>;
};

export type UpdateConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfiguration?: InputMaybe<ConnectRetailerCallbackConfigurationInput>;
  callbackConfigurationId?: InputMaybe<Scalars['BigInt']>;
  ignoreV1Settings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'UpdateConnectRetailerCallbackConfigurationResponse';
  callbackConfiguration: Maybe<ConnectRetailerCallbackConfiguration>;
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type UpdateContentPageRequestV2Input = {
  activeVersionId?: InputMaybe<Scalars['BigInt']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  authContext?: InputMaybe<AuthorizationContextInput>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  internalName?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateContentPageResponseV2 = {
  __typename?: 'UpdateContentPageResponseV2';
  contentPage: Maybe<ContentPageV2>;
};

export type UpdateContentPageVersionMetaRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateContentPageVersionMetaResponse = {
  __typename?: 'UpdateContentPageVersionMetaResponse';
  contentPageVersionMeta: Maybe<ContentPageVersionMeta>;
};

export type UpdateContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  routingStatus?: InputMaybe<ContentPageMetaInfoStatusOneOfInput>;
  seoCanonicalUrl?: InputMaybe<Scalars['String']>;
  seoNoIndex?: InputMaybe<Scalars['Boolean']>;
  trackingProperties?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateContentPageVersionResponse = {
  __typename?: 'UpdateContentPageVersionResponse';
  contentPageVersion: Maybe<ContentPageVersion>;
};

export type UpdateLaunchOnboardingWarehouseInfoRequestInput = {
  aliasName?: InputMaybe<Scalars['String']>;
  allowAlcohol?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  certifiedDeliveryThreshold?: InputMaybe<Scalars['Float']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  logoBackgroundColor?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  pricingPolicy?: InputMaybe<Scalars['String']>;
  pricingPolicyText?: InputMaybe<Scalars['String']>;
  retailerType?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLaunchOnboardingWarehouseInfoResponse = {
  __typename?: 'UpdateLaunchOnboardingWarehouseInfoResponse';
  launchOnboarding: Maybe<LaunchOnboarding>;
};

export type UpdateLaunchOnboardingWarehouseLocationInfoRequestInput = {
  address?: InputMaybe<LaunchOnboardingAddressInput>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  locationCode?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLaunchOnboardingWarehouseLocationInfoResponse = {
  __typename?: 'UpdateLaunchOnboardingWarehouseLocationInfoResponse';
  launchOnboarding: Maybe<LaunchOnboarding>;
  warehouseLocation: Maybe<LaunchOnboardingWarehouseLocation>;
};

export type UpdateLaunchOnboardingWorkflowStateRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  stateAction?: InputMaybe<LaunchOnboardingWorkflowStateAction>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLaunchOnboardingWorkflowStateResponse = {
  __typename?: 'UpdateLaunchOnboardingWorkflowStateResponse';
  launchOnboarding: Maybe<LaunchOnboarding>;
};

export type UpdateLayoutVariantRequestInput = {
  layoutVariant?: InputMaybe<LayoutVariantInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLayoutVariantResponse = {
  __typename?: 'UpdateLayoutVariantResponse';
  layoutVariant: Maybe<LayoutVariant>;
};

export type UpdateMomentCampaignStatusRequestInput = {
  momentCampaignStatus?: InputMaybe<Array<InputMaybe<MomentCampaignStatusInput>>>;
  momentCampaigns?: InputMaybe<StatusMapInput>;
};

export type UpdateMomentCampaignStatusResponse = {
  __typename?: 'UpdateMomentCampaignStatusResponse';
  campaigns: Maybe<Array<Maybe<RetailerCampaign>>>;
};

export type UpdateMomentRequestInput = {
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  momentId?: InputMaybe<Scalars['BigInt']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateMomentResponse = {
  __typename?: 'UpdateMomentResponse';
  moment: Maybe<Moment>;
};

export type UpdateNativeTabBarNavigationRequestInput = {
  navigation?: InputMaybe<NativeTabBarNavigationInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateNativeTabBarNavigationResponse = {
  __typename?: 'UpdateNativeTabBarNavigationResponse';
  navigation: Maybe<NativeTabBarNavigation>;
};

export type UpdateNavigationRequestInput = {
  navigation?: InputMaybe<NavigationInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateNavigationResponse = {
  __typename?: 'UpdateNavigationResponse';
  navigation: Maybe<Navigation>;
};

export type UpdateOnboardingBillingAddressRequestInput = {
  billingAddress?: InputMaybe<AddressInput>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateOnboardingBillingAddressResponse = {
  __typename?: 'UpdateOnboardingBillingAddressResponse';
  onboarding: Maybe<Onboarding>;
};

export type UpdateOnboardingRequestInput = {
  businessRegistrationDocument?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<ContactInput>;
  corporationType?: InputMaybe<Scalars['String']>;
  duns?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  exclusivity?: InputMaybe<Scalars['String']>;
  isaCheckboxTimestamp?: InputMaybe<Scalars['String']>;
  ndaCheckboxTimestamp?: InputMaybe<Scalars['String']>;
  onboardingType?: InputMaybe<Scalars['String']>;
  posSystemName?: InputMaybe<Scalars['String']>;
  priceParity?: InputMaybe<Scalars['String']>;
  stateOfIncorporation?: InputMaybe<Scalars['String']>;
  storeCount?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  w9Form?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateOnboardingResponse = {
  __typename?: 'UpdateOnboardingResponse';
  onboarding: Maybe<Onboarding>;
};

export type UpdateOnboardingWorkflowStateRequestInput = {
  ipAddress?: InputMaybe<Scalars['String']>;
  stateAction?: InputMaybe<OnboardingWorkflowStateAction>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateOnboardingWorkflowStateResponse = {
  __typename?: 'UpdateOnboardingWorkflowStateResponse';
  onboarding: Maybe<Onboarding>;
};

export type UpdateParkingSettingsRequestInput = {
  imageConfigs?: InputMaybe<Array<InputMaybe<ImageConfigInput>>>;
  instruction?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  setDefault?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<PickupType>;
};

export type UpdateParkingSettingsResponse = {
  __typename?: 'UpdateParkingSettingsResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  imageConfigs: Maybe<Array<Maybe<ImageConfig>>>;
  instruction: Maybe<Scalars['String']>;
  retailerLocationConfig: Maybe<RetailerLocationInfo>;
};

export type UpdatePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>;
  content?: InputMaybe<PlacementContentInput>;
  localesToDelete?: InputMaybe<Array<InputMaybe<InstacartCustomersSharedV1Locale>>>;
};

export type UpdatePlacementContentResponse = {
  __typename?: 'UpdatePlacementContentResponse';
  content: Maybe<PlacementContent>;
};

export type UpdateRetailerAisleTemplateRequestInput = {
  aisleOrders?: InputMaybe<Array<InputMaybe<AisleOrderInput>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  shopperType?: InputMaybe<ShopperType>;
};

export type UpdateRetailerAisleTemplateResponse = {
  __typename?: 'UpdateRetailerAisleTemplateResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  updated: Maybe<Scalars['Boolean']>;
};

export type UpdateRetailerCampaignRequestInput = {
  budget?: InputMaybe<GoogleTypeMoneyInput>;
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignReference?: InputMaybe<CampaignReferenceInput>;
  couponCount?: InputMaybe<Scalars['BigInt']>;
  disableTreatmentPolicy?: InputMaybe<Scalars['Boolean']>;
  discoverability?: InputMaybe<Discoverability>;
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
  filtersV2?: InputMaybe<CampaignFiltersInput>;
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  ippContext?: InputMaybe<IppContextInput>;
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferInput>>>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<RestaurantRewardPolicyInput>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  rouletteFeature?: InputMaybe<CampaignRouletteFeatureInput>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  slotCreatives?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementAdminV1SlotCreativeInput>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  targeting?: InputMaybe<Array<InputMaybe<Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<TargetingRulesInput>>>;
  treatments?: InputMaybe<RetailerCampaignTreatmentsInput>;
};

export type UpdateRetailerCampaignTreatmentParamsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<RetailerCampaignTreatmentDetailsInput>>>;
  treatmentType?: InputMaybe<RetailerCampaignTreatmentType>;
};

export type UpdateRetailerCampaignTreatmentsRequestInput = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<UpdateRetailerCampaignTreatmentParamsInput>>>;
};

export type UpdateRetailerCampaignTreatmentsResponse = {
  __typename?: 'UpdateRetailerCampaignTreatmentsResponse';
  treatments: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
};

export type UpdateRetailerFormGroupVisibilityRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  retailerFormGroupVisibility?: InputMaybe<Scalars['JSONObject']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateRetailerFormGroupVisibilityResponse = {
  __typename?: 'UpdateRetailerFormGroupVisibilityResponse';
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type UpdateRetailerProductVisibilitiesRequestInput = {
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  inAssortment?: InputMaybe<Scalars['Boolean']>;
  outOfAssortmentEndAt?: InputMaybe<Scalars['DateTime']>;
  outOfAssortmentStartAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateRetailerProductVisibilitiesResponse = {
  __typename?: 'UpdateRetailerProductVisibilitiesResponse';
  entityId: Maybe<Array<Maybe<EntityId>>>;
};

export type UpdateRoleInput = {
  /** The accounts to add to the role */
  addedAccounts?: InputMaybe<Array<AccountInput>>;
  /** A description of the role */
  description?: InputMaybe<Scalars['String']>;
  /** The role ID */
  id: Scalars['ID'];
  /** The name of the role */
  name?: InputMaybe<Scalars['String']>;
  /** The permissions associated with this role */
  permissions?: InputMaybe<Array<PermissionInput>>;
  /** The accounts to remove from the role */
  removedAccounts?: InputMaybe<Array<AccountInput>>;
};

export type UpdateShopperOrderItemRequestInput = {
  adminRequestContext?: InputMaybe<AdminRequestContextInput>;
  deliveredCount?: InputMaybe<Scalars['BigInt']>;
  deliveredWeight?: InputMaybe<Scalars['Float']>;
  lineNum?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  rrc?: InputMaybe<Scalars['String']>;
  scans?: InputMaybe<Array<InputMaybe<ShopperOrderItemScanInput>>>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  substituteId?: InputMaybe<Scalars['BigInt']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateShopperOrderItemResponse = {
  __typename?: 'UpdateShopperOrderItemResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type UpdateSocialIconsNavigationRequestInput = {
  navigation?: InputMaybe<SocialIconNavInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateSocialIconsNavigationResponse = {
  __typename?: 'UpdateSocialIconsNavigationResponse';
  navigation: Maybe<SocialIconNav>;
};

export type UpdateStagingSettingsRequestInput = {
  freezer?: InputMaybe<StringsInput>;
  fridge?: InputMaybe<StringsInput>;
  hotArea?: InputMaybe<StringsInput>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shelf?: InputMaybe<StringsInput>;
};

export type UpdateStagingSettingsResponse = {
  __typename?: 'UpdateStagingSettingsResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  freezer: Maybe<Array<Maybe<Scalars['String']>>>;
  fridge: Maybe<Array<Maybe<Scalars['String']>>>;
  hotArea: Maybe<Array<Maybe<Scalars['String']>>>;
  imageUrl: Maybe<Scalars['String']>;
  instruction: Maybe<Scalars['String']>;
  retailerLocationConfig: Maybe<RetailerLocationInfo>;
  shelf: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateStoreConfigurationDraftRequestInput = {
  domainConfigurations?: InputMaybe<Scalars['JSONObject']>;
  draftId?: InputMaybe<Scalars['String']>;
  draftName?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateStoreConfigurationDraftResponse = {
  __typename?: 'UpdateStoreConfigurationDraftResponse';
  domainConfigurations: Maybe<DomainConfiguration>;
  domainConfigurationsRaw: Maybe<Scalars['JSONObject']>;
  draftId: Maybe<Scalars['String']>;
  draftName: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  errorReason: Maybe<ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type UpdateStoreHoursRequestInput = {
  author?: InputMaybe<Scalars['String']>;
  clearOverrideHoursByType?: InputMaybe<Array<InputMaybe<RetailerServiceType>>>;
  clearOverrideHoursCriteria?: InputMaybe<Array<InputMaybe<ClearOverrideHoursCriteriaInput>>>;
  confirmations?: InputMaybe<Array<InputMaybe<ConfirmedStoreHoursInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  updateRegularHours?: InputMaybe<Array<InputMaybe<RegularHoursInput>>>;
  updateSource?: InputMaybe<Scalars['String']>;
  upsertOverrideHours?: InputMaybe<Array<InputMaybe<OverrideHoursInput>>>;
};

export type UpdateStoreHoursResponse = {
  __typename?: 'UpdateStoreHoursResponse';
  taskId: Maybe<Scalars['BigInt']>;
};

export type UpdateThemePageRequestInput = {
  themePage?: InputMaybe<ThemePageInput>;
};

export type UpdateThemePageResponse = {
  __typename?: 'UpdateThemePageResponse';
  themePage: Maybe<ThemePage>;
};

export type UpdateWhitelabelSiteAttributesAdminRequestInput = {
  attributes?: InputMaybe<Array<InputMaybe<WhitelabelSiteAttributeInput>>>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteAttributesAdminResponse = {
  __typename?: 'UpdateWhitelabelSiteAttributesAdminResponse';
  whitelabelSite: Maybe<WhitelabelSite>;
};

export type UpdateWhitelabelSiteAttributesRequestInput = {
  attributes?: InputMaybe<Array<InputMaybe<WhitelabelSiteAttributeInput>>>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteAttributesResponse = {
  __typename?: 'UpdateWhitelabelSiteAttributesResponse';
  whitelabelSite: Maybe<WhitelabelSite>;
};

export type UpdateWhitelabelSiteCustomizableStringRequestInput = {
  whitelabelSiteCustomizableString?: InputMaybe<WhitelabelSiteCustomizableStringInput>;
};

export type UpdateWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'UpdateWhitelabelSiteCustomizableStringResponse';
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
  whitelabelSiteCustomizableString: Maybe<WhitelabelSiteCustomizableString>;
};

export type UpdateWhitelabelSiteRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  ownerUserUuid?: InputMaybe<Scalars['String']>;
  retailerUserUuid?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  tier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteResponse = {
  __typename?: 'UpdateWhitelabelSiteResponse';
  whitelabelSite: Maybe<WhitelabelSite>;
};

export type UpdateWhitelabelSiteWorkflowStateRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  stateAction?: InputMaybe<WhitelabelSiteWorkflowStateAction>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteWorkflowStateResponse = {
  __typename?: 'UpdateWhitelabelSiteWorkflowStateResponse';
  whitelabelSite: Maybe<WhitelabelSite>;
};

export type User = {
  __typename?: 'User';
  active: Maybe<Scalars['Boolean']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  guest: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  lastName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  roles: Maybe<Array<Maybe<Scalars['String']>>>;
  userId: Maybe<Scalars['String']>;
  userType: Maybe<Scalars['String']>;
  vip: Maybe<Scalars['Boolean']>;
};

export type UserInput = {
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type UserInteractionLimitInput = {
  /** number of seconds to wait before resetting the counter */
  countCooldownSec?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** maximum number of dismiss events */
  maxDismissedCount?: InputMaybe<Scalars['Int']>;
  /** maximum number of click events */
  maxEngagementsCount?: InputMaybe<Scalars['Int']>;
  /** maximum number of view events */
  maxImpressionsCount?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of UserInteractionLimitVisibilityConditionCreate */
export type UserInteractionLimitVisibilityConditionCreatePayload = {
  __typename?: 'UserInteractionLimitVisibilityConditionCreatePayload';
  /** The newly created UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityCondition: ContentManagementVisibilityConditionUserInteractionLimit;
};

/** Autogenerated return type of UserInteractionLimitVisibilityConditionUpdate */
export type UserInteractionLimitVisibilityConditionUpdatePayload = {
  __typename?: 'UserInteractionLimitVisibilityConditionUpdatePayload';
  /** The newly updated UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityCondition: ContentManagementVisibilityConditionUserInteractionLimit;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  active: Maybe<Scalars['Boolean']>;
  completedOrdersCount: Maybe<Scalars['BigInt']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  guest: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  lastName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  ordersCount: Maybe<Scalars['BigInt']>;
  phone: Maybe<Scalars['String']>;
  roles: Maybe<Array<Maybe<Scalars['String']>>>;
  vip: Maybe<Scalars['Boolean']>;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  key: Maybe<UserSettingKey>;
  value: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
};

export type UserSettingInput = {
  key?: InputMaybe<UserSettingKeyInput>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type UserSettingKey = {
  __typename?: 'UserSettingKey';
  app: Maybe<Scalars['String']>;
  domain: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
};

export type UserSettingKeyInput = {
  app?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UsersSchema = {
  __typename?: 'UsersSchema';
  additionalExternalCanSendPushTarget: Maybe<Scalars['String']>;
  additionalExternalSendPushTarget: Maybe<Scalars['String']>;
  afterSignOutPathOrUrl: Maybe<Scalars['String']>;
  displayRetailerPrivacyPolicyOnSignup: Maybe<Scalars['Boolean']>;
  manageAccountUrl: Maybe<Scalars['String']>;
  notificationSettingsCallBeforeCheckoutOptionsEnabled: Maybe<Scalars['Boolean']>;
  notificationSettingsEmailOptionsEnabled: Maybe<Scalars['Boolean']>;
  notificationSettingsPushNotificationOptionsEnabled: Maybe<Scalars['Boolean']>;
  notificationSettingsTextMessageOptionsEnabled: Maybe<Scalars['Boolean']>;
  privacyOptOutCookieDomain: Maybe<Scalars['String']>;
  signupPhoneNumberLoyaltyLinkage: Maybe<Scalars['Boolean']>;
};

export type UtmParametersInput = {
  /** coupon_code */
  couponCode?: InputMaybe<Scalars['String']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** utm_campaign */
  utmCampaign?: InputMaybe<Scalars['String']>;
  /** utm_content */
  utmContent?: InputMaybe<Scalars['String']>;
  /** utm_medium */
  utmMedium?: InputMaybe<Scalars['String']>;
  /** utm_source */
  utmSource?: InputMaybe<Scalars['String']>;
  /** utm_term */
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UtmParametersVisibilityConditionCreate */
export type UtmParametersVisibilityConditionCreatePayload = {
  __typename?: 'UtmParametersVisibilityConditionCreatePayload';
  /** The newly created UtmParameters visibility condition */
  utmParametersVisibilityCondition: ContentManagementVisibilityConditionUtmParameters;
};

/** Autogenerated return type of UtmParametersVisibilityConditionUpdate */
export type UtmParametersVisibilityConditionUpdatePayload = {
  __typename?: 'UtmParametersVisibilityConditionUpdatePayload';
  /** The newly updated UtmParameters visibility condition */
  utmParametersVisibilityCondition: ContentManagementVisibilityConditionUtmParameters;
};

export type ValueBasedOverrideRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<ClientInput>;
  createdWhy?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<EntityIdInput>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  overrideType?: InputMaybe<OverrideType>;
  overrideValue?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
  sourceValue?: InputMaybe<Scalars['String']>;
  ticketUrl?: InputMaybe<Scalars['String']>;
};

export type ValueBasedOverrideResponse = {
  __typename?: 'ValueBasedOverrideResponse';
  attributeName: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdByJson: Maybe<Scalars['String']>;
  createdWhy: Maybe<Scalars['String']>;
  entityId: Maybe<EntityId>;
  expiryDate: Maybe<Scalars['DateTime']>;
  overrideType: Maybe<OverrideType>;
  overrideValue: Maybe<Scalars['String']>;
  rowId: Maybe<Scalars['BigInt']>;
  sourceType: Maybe<Scalars['String']>;
  sourceValue: Maybe<Scalars['String']>;
  ticketUrl: Maybe<Scalars['String']>;
};

export type ValueProp = {
  __typename?: 'ValueProp';
  darkModeImageAlt: Maybe<Array<Maybe<LocalizedString>>>;
  darkModeImageUrl: Maybe<Scalars['String']>;
  header: Maybe<Array<Maybe<LocalizedString>>>;
  imageAlt: Maybe<Array<Maybe<LocalizedString>>>;
  imageUrl: Maybe<Scalars['String']>;
  subheader: Maybe<Array<Maybe<LocalizedString>>>;
};

export enum ValuePropsCardType {
  ValuePropsCardTypeBorder = 'VALUE_PROPS_CARD_TYPE_BORDER',
  ValuePropsCardTypeFilled = 'VALUE_PROPS_CARD_TYPE_FILLED',
  ValuePropsCardTypeFlushed = 'VALUE_PROPS_CARD_TYPE_FLUSHED',
  ValuePropsCardTypeOrderedList = 'VALUE_PROPS_CARD_TYPE_ORDERED_LIST',
  ValuePropsCardTypeUnknown = 'VALUE_PROPS_CARD_TYPE_UNKNOWN'
}

export enum VerticalType {
  AlcoholHours = 'ALCOHOL_HOURS',
  DeliveryHours = 'DELIVERY_HOURS',
  IssHours = 'ISS_HOURS',
  PharmacyHours = 'PHARMACY_HOURS',
  PickupHours = 'PICKUP_HOURS',
  PickupOverrideHours = 'PICKUP_OVERRIDE_HOURS'
}

/** Autogenerated return type of VirtualPartnerUpdateRetailers */
export type VirtualPartnerUpdateRetailersPayload = {
  __typename?: 'VirtualPartnerUpdateRetailersPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

export type VirtualRetailer = {
  __typename?: 'VirtualRetailer';
  coreRetailerId: Maybe<Scalars['BigInt']>;
  virtualRetailerId: Maybe<Scalars['BigInt']>;
};

/** Union of the Types of Visibility Conditions which may be returned */
export type VisibilityCondition = ContentManagementVisibilityConditionCountryIds | ContentManagementVisibilityConditionDayOfWeek | ContentManagementVisibilityConditionExperimentVariant | ContentManagementVisibilityConditionExpressMembership | ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout | ContentManagementVisibilityConditionMatchesAnyRetailerId | ContentManagementVisibilityConditionMinimumPlatformVersion | ContentManagementVisibilityConditionNewVerticalUserTargeting | ContentManagementVisibilityConditionRetailerAvailability | ContentManagementVisibilityConditionShopped | ContentManagementVisibilityConditionShoppedAtRetailer | ContentManagementVisibilityConditionUnknownVisibilityCondition | ContentManagementVisibilityConditionUserInteractionLimit | ContentManagementVisibilityConditionUtmParameters | ContentManagementVisibilityConditionWhitelistedPostalCodes | ContentManagementVisibilityConditionWhitelistedZones;

/** Autogenerated return type of VisibilityConditionDelete */
export type VisibilityConditionDeletePayload = {
  __typename?: 'VisibilityConditionDeletePayload';
  /** Whether deleting the visibility condition succeeded or not */
  success: Scalars['Boolean'];
};

export type VisibilityConditionStruct = {
  __typename?: 'VisibilityConditionStruct';
  data: Maybe<Scalars['JSONObject']>;
  typeName: Maybe<Scalars['String']>;
};

export type VisibilityConditionStructInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  typeName?: InputMaybe<Scalars['String']>;
};

export type WarehouseGroup = {
  __typename?: 'WarehouseGroup';
  /** The franchisee ID for this warehouse group */
  franchiseeId: Scalars['ID'];
  /** The franchisee name for this warehouse group */
  franchiseeName: Scalars['String'];
  /** The franchisor ID for this warehouse group */
  franchisorId: Scalars['ID'];
  /** The franchisor name for this warehouse group */
  franchisorName: Scalars['String'];
  /** The retailer ID for this warehouse group */
  retailerId: Scalars['ID'];
  /** The retailer name for this warehouse group */
  retailerName: Scalars['String'];
};

export type WaterfallEffect = {
  __typename?: 'WaterfallEffect';
  childWaterfallEffectIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  depth: Maybe<Scalars['Int']>;
  errorMessage: Maybe<Scalars['String']>;
  externalReference: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  isAsync: Maybe<Scalars['Boolean']>;
  isLeaf: Maybe<Scalars['Boolean']>;
  isRoot: Maybe<Scalars['Boolean']>;
  launchOnboardingId: Maybe<Scalars['BigInt']>;
  launchOnboardingPartnerId: Maybe<Scalars['BigInt']>;
  launchOnboardingWarehouseId: Maybe<Scalars['BigInt']>;
  launchOnboardingWarehouseLocationId: Maybe<Scalars['BigInt']>;
  metadata: Maybe<Scalars['JSONObject']>;
  params: Maybe<Scalars['JSONObject']>;
  parentWaterfallEffectId: Maybe<Scalars['BigInt']>;
  partnerId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  status: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  targetId: Maybe<Scalars['BigInt']>;
  targetService: Maybe<Scalars['String']>;
  targetType: Maybe<Scalars['String']>;
  timeSpent: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
  workflowType: Maybe<Scalars['String']>;
};

export type WhitelabelGumloopWorkflowParametersInput = {
  url?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSite = {
  __typename?: 'WhitelabelSite';
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  launchOnboardingWarehouseId: Maybe<Scalars['BigInt']>;
  ownerUserUuid: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['BigInt']>;
  retailerFormGroupVisibility: Maybe<Scalars['JSONObject']>;
  retailerUserUuid: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  tier: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  warehouseId: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<Scalars['String']>;
};

export type WhitelabelSiteAttributeInput = {
  group?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSiteCustomizableString = {
  __typename?: 'WhitelabelSiteCustomizableString';
  app: Maybe<Scalars['String']>;
  customizable: Maybe<Scalars['Boolean']>;
  defaultCopy: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  key: Maybe<Scalars['String']>;
  ymlFilePath: Maybe<Scalars['String']>;
};

export type WhitelabelSiteCustomizableStringInput = {
  app?: InputMaybe<Scalars['String']>;
  customizable?: InputMaybe<Scalars['Boolean']>;
  defaultCopy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  ymlFilePath?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSiteStringOverrideInput = {
  customizableStringId?: InputMaybe<Scalars['Int']>;
  customizableStringYmlKey?: InputMaybe<Scalars['String']>;
  overrideStringCopy?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSiteTestRun = {
  __typename?: 'WhitelabelSiteTestRun';
  buildUrl: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdByIppAccountCanonicalId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  status: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  testCaseIds: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
};

export enum WhitelabelSiteWorkflowStateAction {
  WhitelabelSiteWorkflowStateActionPublish = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_PUBLISH',
  WhitelabelSiteWorkflowStateActionSendInitialEmailInvite = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_SEND_INITIAL_EMAIL_INVITE',
  WhitelabelSiteWorkflowStateActionStartProgress = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_START_PROGRESS',
  WhitelabelSiteWorkflowStateActionStartReview = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_START_REVIEW',
  WhitelabelSiteWorkflowStateActionUnknown = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_UNKNOWN'
}

export type WhitelistedPostalCodesInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>;
};

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionCreate */
export type WhitelistedPostalCodesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionCreatePayload';
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes;
};

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionUpdate */
export type WhitelistedPostalCodesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionUpdatePayload';
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes;
};

export type WhitelistedZonesInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of zones ids */
  zones: Array<Scalars['String']>;
};

/** Autogenerated return type of WhitelistedZonesVisibilityConditionCreate */
export type WhitelistedZonesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedZonesVisibilityConditionCreatePayload';
  /** The newly created whitelisted_zones visibility condition */
  whitelistedZonesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedZones;
};

/** Autogenerated return type of WhitelistedZonesVisibilityConditionUpdate */
export type WhitelistedZonesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedZonesVisibilityConditionUpdatePayload';
  /** The updated WhitelistedZones visibility condition */
  whitelistedZonesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedZones;
};

export type Widget = {
  __typename?: 'Widget';
  dataQuery: Maybe<DataQuery>;
  id: Maybe<Scalars['BigInt']>;
  variant: Maybe<WidgetVariant>;
};

export type WidgetInput = {
  dataQuery?: InputMaybe<DataQueryInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  variant?: InputMaybe<WidgetVariant>;
};

export enum WidgetVariant {
  IframeEmbed = 'IFRAME_EMBED',
  NavigationList = 'NAVIGATION_LIST',
  OrderHistory = 'ORDER_HISTORY',
  QuickLinks = 'QUICK_LINKS',
  ServiceOptionSelector = 'SERVICE_OPTION_SELECTOR',
  UnspecifiedWidget = 'UNSPECIFIED_WIDGET',
  WaysToShop = 'WAYS_TO_SHOP'
}

/** Autogenerated return type of WizardProgressUpdate */
export type WizardProgressUpdatePayload = {
  __typename?: 'WizardProgressUpdatePayload';
  /** A status which is true if no errors were encountered while performing the update */
  success: Scalars['True'];
};

export enum WizardStatusEnum {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export enum WizardTypeEnum {
  PickupSettingsOnboarding = 'PICKUP_SETTINGS_ONBOARDING'
}

export type WizardsWizardProgress = {
  __typename?: 'WizardsWizardProgress';
  id: Scalars['ID'];
  status: WizardStatusEnum;
  wizardType: WizardTypeEnum;
};

export type WorkflowParameter = {
  /** The parameter name */
  name: Scalars['String'];
  /** The value of the parameter */
  value: Scalars['JSON'];
};

export type WorkflowQueryFilter = {
  /** Query by specific statuses */
  status?: InputMaybe<Scalars['String']>;
  /** Query by specific workflow id */
  workflowId?: InputMaybe<Scalars['Int']>;
  /** Query by specific workflow definition */
  workflowName?: InputMaybe<Scalars['String']>;
};

export enum WorkflowStatus {
  WorkflowStatusCompleted = 'WORKFLOW_STATUS_COMPLETED',
  WorkflowStatusDeactivate = 'WORKFLOW_STATUS_DEACTIVATE',
  WorkflowStatusExpired = 'WORKFLOW_STATUS_EXPIRED',
  WorkflowStatusFailed = 'WORKFLOW_STATUS_FAILED',
  WorkflowStatusGetData = 'WORKFLOW_STATUS_GET_DATA',
  WorkflowStatusInProgress = 'WORKFLOW_STATUS_IN_PROGRESS',
  WorkflowStatusReadyToDelete = 'WORKFLOW_STATUS_READY_TO_DELETE',
  WorkflowStatusUnspecified = 'WORKFLOW_STATUS_UNSPECIFIED'
}

export type Google_Protobuf_ListValue = {
  __typename?: 'google_protobuf_ListValue';
  values: Maybe<Array<Maybe<Google_Protobuf_Value>>>;
};

export enum Google_Protobuf_NullValue {
  NullValue = 'NULL_VALUE'
}

export type Google_Protobuf_Value = {
  __typename?: 'google_protobuf_Value';
  boolValue: Maybe<Scalars['Boolean']>;
  listValue: Maybe<Google_Protobuf_ListValue>;
  nullValue: Maybe<Google_Protobuf_NullValue>;
  numberValue: Maybe<Scalars['Float']>;
  stringValue: Maybe<Scalars['String']>;
  structValue: Maybe<Scalars['JSON']>;
};

/**
 * Represents a whole or partial calendar date, e.g. a birthday. The time of day
 * and time zone are either specified elsewhere or are not significant. The date
 * is relative to the Proleptic Gregorian Calendar. This can represent:
 *
 * * A full date, with non-zero year, month and day values
 * * A month and day value, with a zero year, e.g. an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, e.g. a credit card expiration date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and `google.protobuf.Timestamp`.
 */
export type Google_Type_Date = {
  __typename?: 'google_type_Date';
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year by itself or a year and month where the day is not
   * significant.
   */
  day: Maybe<Scalars['Int']>;
  /**
   * Month of year. Must be from 1 to 12, or 0 if specifying a year without a
   * month and day.
   */
  month: Maybe<Scalars['Int']>;
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year: Maybe<Scalars['Int']>;
};

/**
 * Represents a whole or partial calendar date, e.g. a birthday. The time of day
 * and time zone are either specified elsewhere or are not significant. The date
 * is relative to the Proleptic Gregorian Calendar. This can represent:
 *
 * * A full date, with non-zero year, month and day values
 * * A month and day value, with a zero year, e.g. an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, e.g. a credit card expiration date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and `google.protobuf.Timestamp`.
 */
export type Google_Type_Date_Input = {
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year by itself or a year and month where the day is not
   * significant.
   */
  day?: InputMaybe<Scalars['Int']>;
  /**
   * Month of year. Must be from 1 to 12, or 0 if specifying a year without a
   * month and day.
   */
  month?: InputMaybe<Scalars['Int']>;
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year?: InputMaybe<Scalars['Int']>;
};

/**
 * An object representing a latitude/longitude pair. This is expressed as a pair
 * of doubles representing degrees latitude and degrees longitude. Unless
 * specified otherwise, this must conform to the
 * <a href="http://www.unoosa.org/pdf/icg/2012/template/WGS_84.pdf">WGS84
 * standard</a>. Values must be within normalized ranges.
 */
export type Google_Type_LatLng = {
  __typename?: 'google_type_LatLng';
  /** The latitude in degrees. It must be in the range [-90.0, +90.0]. */
  latitude: Maybe<Scalars['Float']>;
  /** The longitude in degrees. It must be in the range [-180.0, +180.0]. */
  longitude: Maybe<Scalars['Float']>;
};

/**
 * Represents a postal address, e.g. for postal delivery or payments addresses.
 * Given a postal address, a postal service can deliver items to a premise, P.O.
 * Box or similar.
 * It is not intended to model geographical locations (roads, towns,
 * mountains).
 *
 * In typical usage an address would be created via user input or from importing
 * existing data, depending on the type of process.
 *
 * Advice on address input / editing:
 * - Use an i18n-ready address widget such as
 * https://github.com/google/libaddressinput)
 * - Users should not be presented with UI elements for input or editing of
 * fields outside countries where that field is used.
 *
 * For more guidance on how to use this schema, please see:
 * https://support.google.com/business/answer/6397478
 */
export type Google_Type_PostalAddress = {
  __typename?: 'google_type_PostalAddress';
  /**
   * Unstructured address lines describing the lower levels of an address.
   *
   * Because values in address_lines do not have type information and may
   * sometimes contain multiple values in a single field (e.g.
   * "Austin, TX"), it is important that the line order is clear. The order of
   * address lines should be "envelope order" for the country/region of the
   * address. In places where this can vary (e.g. Japan), address_language is
   * used to make it explicit (e.g. "ja" for large-to-small ordering and
   * "ja-Latn" or "en" for small-to-large). This way, the most specific line of
   * an address can be selected based on the language.
   *
   * The minimum permitted structural representation of an address consists
   * of a region_code with all remaining information placed in the
   * address_lines. It would be possible to format such an address very
   * approximately without geocoding, but no semantic reasoning could be
   * made about any of the address components until it was at least
   * partially resolved.
   *
   * Creating an address only containing a region_code and address_lines, and
   * then geocoding is the recommended way to handle completely unstructured
   * addresses (as opposed to guessing which parts of the address should be
   * localities or administrative areas).
   */
  addressLines: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional. Highest administrative subdivision which is used for postal
   * addresses of a country or region.
   * For example, this can be a state, a province, an oblast, or a prefecture.
   * Specifically, for Spain this is the province and not the autonomous
   * community (e.g. "Barcelona" and not "Catalonia").
   * Many countries don't use an administrative area in postal addresses. E.g.
   * in Switzerland this should be left unpopulated.
   */
  administrativeArea: Maybe<Scalars['String']>;
  /**
   * Optional. BCP-47 language code of the contents of this address (if
   * known). This is often the UI language of the input form or is expected
   * to match one of the languages used in the address' country/region, or their
   * transliterated equivalents.
   * This can affect formatting in certain countries, but is not critical
   * to the correctness of the data and will never affect any validation or
   * other non-formatting related operations.
   *
   * If this value is not known, it should be omitted (rather than specifying a
   * possibly incorrect default).
   *
   * Examples: "zh-Hant", "ja", "ja-Latn", "en".
   */
  languageCode: Maybe<Scalars['String']>;
  /**
   * Optional. Generally refers to the city/town portion of the address.
   * Examples: US city, IT comune, UK post town.
   * In regions of the world where localities are not well defined or do not fit
   * into this structure well, leave locality empty and use address_lines.
   */
  locality: Maybe<Scalars['String']>;
  /** Optional. The name of the organization at the address. */
  organization: Maybe<Scalars['String']>;
  /**
   * Optional. Postal code of the address. Not all countries use or require
   * postal codes to be present, but where they are used, they may trigger
   * additional validation with other parts of the address (e.g. state/zip
   * validation in the U.S.A.).
   */
  postalCode: Maybe<Scalars['String']>;
  /**
   * Optional. The recipient at the address.
   * This field may, under certain circumstances, contain multiline information.
   * For example, it might contain "care of" information.
   */
  recipients: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Required. CLDR region code of the country/region of the address. This
   * is never inferred and it is up to the user to ensure the value is
   * correct. See http://cldr.unicode.org/ and
   * http://www.unicode.org/cldr/charts/30/supplemental/territory_information.html
   * for details. Example: "CH" for Switzerland.
   */
  regionCode: Maybe<Scalars['String']>;
  /**
   * The schema revision of the `PostalAddress`.
   * All new revisions **must** be backward compatible with old revisions.
   */
  revision: Maybe<Scalars['Int']>;
  /**
   * Optional. Additional, country-specific, sorting code. This is not used
   * in most regions. Where it is used, the value is either a string like
   * "CEDEX", optionally followed by a number (e.g. "CEDEX 7"), or just a number
   * alone, representing the "sector code" (Jamaica), "delivery area indicator"
   * (Malawi) or "post office indicator" (e.g. Côte d'Ivoire).
   */
  sortingCode: Maybe<Scalars['String']>;
  /**
   * Optional. Sublocality of the address.
   * For example, this can be neighborhoods, boroughs, districts.
   */
  sublocality: Maybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier';
  adGroup: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup>;
  campaign: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign>;
  creative: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative>;
  product: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_AdGroup';
  identifier: Maybe<Instacart_Ads_Shared_V1_VersionedIdentifier>;
  internalId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup_Input = {
  identifier?: InputMaybe<Instacart_Ads_Shared_V1_VersionedIdentifier_Input>;
  internalId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_Campaign';
  identifier: Maybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign_Input = {
  identifier?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_Creative';
  identifier: Maybe<Instacart_Ads_Shared_V1_VersionedIdentifier>;
  internalId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative_Input = {
  identifier?: InputMaybe<Instacart_Ads_Shared_V1_VersionedIdentifier_Input>;
  internalId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Input = {
  adGroup?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup_Input>;
  campaign?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign_Input>;
  creative?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative_Input>;
  product?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product_Input>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_Product';
  identifier: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product_Input = {
  identifier?: InputMaybe<Scalars['BigInt']>;
};

/** Represents a human review of an ad that has been flagged. */
export type Instacart_Ads_Nexus_V1_AdReviewStatus = {
  __typename?: 'instacart_ads_nexus_v1_AdReviewStatus';
  /** Use reviewed. */
  approved: Maybe<Scalars['Boolean']>;
  /** The ad entity in question. */
  blockingEntityIdentifier: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier>;
  /** When the review was last updated. */
  lastReview: Maybe<Scalars['DateTime']>;
  /** The retailer who reviewed the request. */
  retailerId: Maybe<Scalars['BigInt']>;
  /** Whether the ad was reviewed by a human. */
  reviewed: Maybe<Scalars['Boolean']>;
  /** The user who submitted the most recent review. */
  userId: Maybe<Scalars['String']>;
};

/** Represents a human review of an ad that has been flagged. */
export type Instacart_Ads_Nexus_V1_AdReviewStatus_Input = {
  /** Use reviewed. */
  approved?: InputMaybe<Scalars['Boolean']>;
  /** The ad entity in question. */
  blockingEntityIdentifier?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Input>;
  /** When the review was last updated. */
  lastReview?: InputMaybe<Scalars['DateTime']>;
  /** The retailer who reviewed the request. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Whether the ad was reviewed by a human. */
  reviewed?: InputMaybe<Scalars['Boolean']>;
  /** The user who submitted the most recent review. */
  userId?: InputMaybe<Scalars['String']>;
};

/** Submits a new review for a given ad blocking identifier. */
export type Instacart_Ads_Nexus_V1_UpsertAdReviewsRequest_Input = {
  /** The review to save. */
  newStatus?: InputMaybe<Instacart_Ads_Nexus_V1_AdReviewStatus_Input>;
};

export type Instacart_Ads_Nexus_V1_UpsertAdReviewsResponse = {
  __typename?: 'instacart_ads_nexus_v1_UpsertAdReviewsResponse';
  /** The new review data after it has been persisted. */
  updatedStatus: Maybe<Instacart_Ads_Nexus_V1_AdReviewStatus>;
};

/**
 * Contextual scope restrictions that are handled first-class.
 *
 * MOST scoping should come from the targeting rule itself. The ones here are
 * special and use-case specific.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction = {
  __typename?: 'instacart_ads_platform_taas_v1_ContextRestriction';
  global: Maybe<Scalars['instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext']>;
  partner: Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext>;
  retailer: Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext>;
};

/**
 * Contextual scope restrictions that are handled first-class.
 *
 * MOST scoping should come from the targeting rule itself. The ones here are
 * special and use-case specific.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input = {
  global?: InputMaybe<Scalars['instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext_Input']>;
  partner?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext_Input>;
  retailer?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext_Input>;
};

export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext = {
  __typename?: 'instacart_ads_platform_taas_v1_ContextRestriction_PartnerContext';
  partnerId: Maybe<Scalars['BigInt']>;
  retailerContexts: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext>>>;
};

export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerContexts?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext_Input>>>;
};

/**
 * Controls a particular segment to only be valid at a particular
 * retailer/whitelabel combination. For Marketplace, use whitelabel_id = 1.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext = {
  __typename?: 'instacart_ads_platform_taas_v1_ContextRestriction_RetailerContext';
  retailerId: Maybe<Scalars['BigInt']>;
  whitelabelId: Maybe<Scalars['BigInt']>;
};

/**
 * Controls a particular segment to only be valid at a particular
 * retailer/whitelabel combination. For Marketplace, use whitelabel_id = 1.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  whitelabelId?: InputMaybe<Scalars['BigInt']>;
};

/** Creates a new segment with the given definition. */
export type Instacart_Ads_Platform_Taas_V1_CreateSegmentRequest_Input = {
  /**
   * Specific context in which this segment is valid.
   *
   * NOT editable after the segment is created!
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** Definition of the new segment. */
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  /** Optional description of the segment. */
  description?: InputMaybe<Scalars['String']>;
  /** Optional IPP user ID who favorited this segment. */
  favoritedByIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** Optional flag to mark the segment as favorited for the creator. */
  isFavoritedSegment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optional flag to mark the favorited segment as a Golden Segment.
   * When true, the segment is inserted into taas.favorited_segments with is_golden_segment = true.
   */
  isGoldenSegment?: InputMaybe<Scalars['Boolean']>;
  /** Optional name of the segment. */
  name?: InputMaybe<Scalars['String']>;
  /** Data to be returned from TaaS when this segment matches. */
  payload?: InputMaybe<Scalars['GoogleProtobufAnyScalar']>;
  /**
   * Optional flag to return existing segment by name instead of creating a new one.
   * When true, if a segment with the same name already exists, returns that segment's UUID.
   * When false (default), creates a new segment even if a segment with the same name exists.
   */
  returnExistingByName?: InputMaybe<Scalars['Boolean']>;
  /** Scope in which to create the new segment. */
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
};

export type Instacart_Ads_Platform_Taas_V1_DeleteSegmentRequest_Input = {
  /** This field is REQUIRED. */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /**
   * The ID of the favorited segment to be deleted. If the segment does not exist, or if
   * the version number in this field does not match the actual most-recent
   * version number for the segment, then the request will fail.
   */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
  /**
   * When true, the caller is a golden-segment admin (authorization validated in GraphQL mesh).
   * The backend allows deletion of any Golden Segment without requiring user_id to match
   * favorited_by_ipp_user_id. Ignored if the segment is not a Golden Segment.
   */
  isGoldenAdmin?: InputMaybe<Scalars['Boolean']>;
  /** User ID representing the user who initiated the deletion of favorited_segments. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** Supported feature */
export type Instacart_Ads_Platform_Taas_V1_EntityId = {
  __typename?: 'instacart_ads_platform_taas_v1_EntityId';
  /** Name of the entity id */
  name: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Ads_Platform_Taas_V1_EntityIdType>;
};

/** Type of entity id */
export enum Instacart_Ads_Platform_Taas_V1_EntityIdType {
  /** The value of entity id is passed from API payload */
  Context = 'CONTEXT',
  /** The value of entity id is defined as the key of the map type feature such as order count in the taas segment */
  MapKey = 'MAP_KEY',
  /** The value of entity id is defined in the taas segment */
  Segment = 'SEGMENT'
}

/** Type of the data source of the feature */
export enum Instacart_Ads_Platform_Taas_V1_FeatureDataSourceType {
  BrazeSnowflake = 'BRAZE_SNOWFLAKE',
  Contextual = 'CONTEXTUAL',
  Csv = 'CSV',
  FeatureStore = 'FEATURE_STORE',
  HubEvent = 'HUB_EVENT',
  KafkaEvent = 'KAFKA_EVENT',
  Snowflake = 'SNOWFLAKE'
}

/** feature data used by ingestion job to populate necessary feature data */
export type Instacart_Ads_Platform_Taas_V1_FeatureSourceDetails = {
  __typename?: 'instacart_ads_platform_taas_v1_FeatureSourceDetails';
  /** feature column */
  column: Maybe<Scalars['String']>;
  /** feature database */
  database: Maybe<Scalars['String']>;
  /** feature schema */
  schema: Maybe<Scalars['String']>;
  /** feature table */
  table: Maybe<Scalars['String']>;
};

/** Request to generate audience segment from user intention */
export type Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentRequest_Input = {
  /**
   * Specific context in which this segment is valid.
   * The reason we have this field is because we want to generate a segment for a particular universe and context
   * and we want to make sure the generated segment only leverage the features that are supported by the universe and context
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** Scope in which to create the new segment. */
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
  /** User intention/description in natural language */
  userIntention?: InputMaybe<Scalars['String']>;
};

/** Response containing generated audience segment definition */
export type Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentResponse = {
  __typename?: 'instacart_ads_platform_taas_v1_GenerativeAudienceSegmentResponse';
  /** The generated segment definition */
  definition: Maybe<Instacart_Ads_Targeting_V1_TargetingRule>;
};

export type Instacart_Ads_Platform_Taas_V1_GetAllSegmentDefinitionsRequest_Input = {
  /**
   * Only segments matching this context will be returned.
   *
   * This field is REQUIRED. It is not valid to request all segments for an
   * entire universe via this interface.
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** Optional IPP user ID to filter favorited segments by. */
  favoritedByIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** When ignore_deleted is true then filter out deleted segments */
  ignoreDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Optional filter to return only favorited segments. */
  isFavoritedSegment?: InputMaybe<Scalars['Boolean']>;
  /** Optional pagination parameters. If not specified, all results are returned (unpaginated). */
  pagination?: InputMaybe<Instacart_Ads_Platform_Taas_V1_PaginationRequest_Input>;
  /**
   * Optional filter by segment types. If empty or not specified, all segment types are returned.
   * Multiple types can be specified to get segments matching any of the specified types.
   */
  segmentTypes?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentType>>>;
  /** Optional sorting parameters. If not specified, defaults to sorting by updated_at DESC. */
  sortOptions?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SortOptions_Input>;
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
};

/** Request to get all supported features */
export type Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesRequest_Input = {
  /**
   * Only features matching this context via restricted_whitelabel_ids and restricted_retailer_ids will be returned.
   * This field is REQUIRED.
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** list of feature types to be queried */
  featureTypes?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_SupportedFeatureType>>>;
  ignoreToolingEnabled?: InputMaybe<Scalars['Boolean']>;
  offlineEvalOnly?: InputMaybe<Scalars['Boolean']>;
};

/** Response to get all supported features */
export type Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesResponse = {
  __typename?: 'instacart_ads_platform_taas_v1_GetAllSupportedFeaturesResponse';
  /** List of supported features */
  supportedFeatures: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_SupportedFeature>>>;
};

export type Instacart_Ads_Platform_Taas_V1_GetSegmentDefinitionRequest_Input = {
  /** This field is REQUIRED. */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /**
   * The segment to look up.
   *
   * Must contain an ID, but the version_number is optional. If provided, the
   * response will be the definition for that exact version, which may or may
   * not be the latest (currently live) version. If not provided, then the
   * response will be for the latest (currently live) version of that segment.
   */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
};

export type Instacart_Ads_Platform_Taas_V1_GetSegmentSizeRequest_Input = {
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
};

/** Pagination metadata returned with paginated results */
export type Instacart_Ads_Platform_Taas_V1_PaginationMetadata = {
  __typename?: 'instacart_ads_platform_taas_v1_PaginationMetadata';
  /** Current page number (1-indexed) */
  page: Maybe<Scalars['Int']>;
  /** Number of items per page */
  pageSize: Maybe<Scalars['Int']>;
  /** Total number of segments matching the query (across all pages) */
  totalCount: Maybe<Scalars['Int']>;
  /** Total number of pages available */
  totalPages: Maybe<Scalars['Int']>;
};

/** Pagination request parameters */
export type Instacart_Ads_Platform_Taas_V1_PaginationRequest_Input = {
  /** Page number (1-indexed). Defaults to 1 if not specified. */
  page?: InputMaybe<Scalars['Int']>;
  /**
   * Number of items per page. Defaults to 20 if not specified.
   * Maximum allowed value is 100.
   */
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentId = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentId';
  /** Universe to which the segment belongs. */
  universe: Maybe<Instacart_Ads_Platform_V1_Universe>;
  /**
   * Unique identifier for a segment. This is guaranteed to be unique among all
   * segments ever created.
   */
  uuid: Maybe<Scalars['String']>;
  /** Counts the number of revisions that have been made (via UpdateSegment). */
  versionNumber: Maybe<Scalars['Int']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentId_Input = {
  /** Universe to which the segment belongs. */
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
  /**
   * Unique identifier for a segment. This is guaranteed to be unique among all
   * segments ever created.
   */
  uuid?: InputMaybe<Scalars['String']>;
  /** Counts the number of revisions that have been made (via UpdateSegment). */
  versionNumber?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentSize = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentSize';
  /** Audience size of the segment */
  size: Maybe<Scalars['Int']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentState = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentState';
  /**
   * Specific context in which this segment is valid.
   *
   * NOT editable after the segment is created!
   */
  context: Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction>;
  /**
   * The definition of the segment, after the operation.
   *
   * If this field is unset (null), then the segment has been deleted; note
   * that this is semantically very different from an extant definition with no
   * fields filled.
   */
  definition: Maybe<Instacart_Ads_Targeting_V1_TargetingRule>;
  /** Optional description of the segment. */
  description: Maybe<Scalars['String']>;
  /** Optional IPP user ID who favorited this segment. */
  favoritedByIppUserId: Maybe<Scalars['BigInt']>;
  /** The ID of the segment, with the version number after the operation. */
  id: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentId>;
  /** Optional name of the segment. */
  name: Maybe<Scalars['String']>;
  /** Data to be returned from TaaS when this segment matches. */
  payload: Maybe<Scalars['GoogleProtobufAnyScalar']>;
  /** Date-Time Segment was last updated */
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentState_Input = {
  /**
   * Specific context in which this segment is valid.
   *
   * NOT editable after the segment is created!
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /**
   * The definition of the segment, after the operation.
   *
   * If this field is unset (null), then the segment has been deleted; note
   * that this is semantically very different from an extant definition with no
   * fields filled.
   */
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  /** Optional description of the segment. */
  description?: InputMaybe<Scalars['String']>;
  /** Optional IPP user ID who favorited this segment. */
  favoritedByIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** The ID of the segment, with the version number after the operation. */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
  /** Optional name of the segment. */
  name?: InputMaybe<Scalars['String']>;
  /** Data to be returned from TaaS when this segment matches. */
  payload?: InputMaybe<Scalars['GoogleProtobufAnyScalar']>;
  /** Date-Time Segment was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentStates = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentStates';
  /** Optional pagination metadata when pagination is requested */
  paginationMetadata: Maybe<Instacart_Ads_Platform_Taas_V1_PaginationMetadata>;
  segments: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>>>;
};

/** Enum representing different segment types based on their features */
export enum Instacart_Ads_Platform_Taas_V1_SegmentType {
  /** All customers segments - segments with no specific feature restrictions */
  SegmentTypeAllCustomers = 'SEGMENT_TYPE_ALL_CUSTOMERS',
  /** API segments - identified by 'dynamic_segment_membership' feature */
  SegmentTypeApi = 'SEGMENT_TYPE_API',
  /** Default value when segment type is not specified */
  SegmentTypeDefault = 'SEGMENT_TYPE_DEFAULT',
  /** Email CSV segments - identified by 'present_in_email_csv' or 'user_id_csvs' features */
  SegmentTypeEmailCsv = 'SEGMENT_TYPE_EMAIL_CSV',
  /** Filter: Golden Segments only. */
  SegmentTypeGolden = 'SEGMENT_TYPE_GOLDEN',
  /** Filter: user's saved ruleset (favorited) segments plus Golden Segments (saved-or-golden combined). */
  SegmentTypeSavedOrGolden = 'SEGMENT_TYPE_SAVED_OR_GOLDEN',
  /** Saved ruleset segments - identified by favorited_by_ipp_user_id being set */
  SegmentTypeSavedRuleset = 'SEGMENT_TYPE_SAVED_RULESET',
  /** Store group segments - identified by 'store_group' feature */
  SegmentTypeStoreGroup = 'SEGMENT_TYPE_STORE_GROUP',
  /**
   * Tooling all customers segments - segments with empty conjunctions AND payload.value.all_customers = true
   * This is stricter than SEGMENT_TYPE_ALL_CUSTOMERS and filters for segments created by the marketing tooling
   */
  SegmentTypeToolingAllCustomers = 'SEGMENT_TYPE_TOOLING_ALL_CUSTOMERS'
}

/** Sort direction */
export enum Instacart_Ads_Platform_Taas_V1_SortDirection {
  /** Ascending order */
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  /** Descending order */
  SortDirectionDesc = 'SORT_DIRECTION_DESC'
}

/** Fields available for sorting */
export enum Instacart_Ads_Platform_Taas_V1_SortField {
  /** Sort by creation timestamp */
  SortFieldCreatedAt = 'SORT_FIELD_CREATED_AT',
  /** Sort by segment name */
  SortFieldName = 'SORT_FIELD_NAME',
  /** Unknown or unspecified sort field - defaults to updated_at */
  SortFieldUnknown = 'SORT_FIELD_UNKNOWN',
  /** Sort by last updated timestamp */
  SortFieldUpdatedAt = 'SORT_FIELD_UPDATED_AT'
}

/** Sorting options for segment results */
export type Instacart_Ads_Platform_Taas_V1_SortOptions_Input = {
  /** Sort direction (ascending or descending) */
  sortDirection?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SortDirection>;
  /** Field to sort by */
  sortField?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SortField>;
};

/** Supported feature */
export type Instacart_Ads_Platform_Taas_V1_SupportedFeature = {
  __typename?: 'instacart_ads_platform_taas_v1_SupportedFeature';
  /** Whether the feature is contextual or regular feature */
  contextual: Maybe<Scalars['Boolean']>;
  /** data granularity of the feature */
  dataGranularity: Maybe<Scalars['String']>;
  /** data refreshness of the feature such as daily, every 2 hours, near real-time */
  dataRefreshness: Maybe<Scalars['String']>;
  /** Description of the feature */
  description: Maybe<Scalars['String']>;
  /** the source of the eligible values of the feature */
  eligibleValueSource: Maybe<Scalars['String']>;
  /** the eligible values of the feature */
  eligibleValues: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the logical primary key in TaaS storage */
  entityIds: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_EntityId>>>;
  /** whether the feature is enabled */
  featureEnabled: Maybe<Scalars['Boolean']>;
  /** feature data used by offline jobs to populate necessary feature data */
  featureSourceDetails: Maybe<Instacart_Ads_Platform_Taas_V1_FeatureSourceDetails>;
  /** ipp specific meta info such as required_permissions, roulette */
  ippMetadata: Maybe<Scalars['JSON']>;
  /** Name of the feature */
  name: Maybe<Scalars['String']>;
  /** offline support for the feature */
  offlineEvalSupport: Maybe<Scalars['Boolean']>;
  /** Online eval Support for the feature */
  onlineEvalSupport: Maybe<Scalars['Boolean']>;
  /** the supported retailers. If this is not specified, it means the feature is available for all the retailers */
  restrictedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** the supported whitelabel site. If this is not specified, it means the feature is available for all the whitelabel sites */
  restrictedWhitelabelIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** whether the feature is enabled in serving */
  servingEnabled: Maybe<Scalars['Boolean']>;
  /** data source type of the feature */
  sourceType: Maybe<Instacart_Ads_Platform_Taas_V1_FeatureDataSourceType>;
  /** whether the feature is enabled in tooling */
  toolingEnabled: Maybe<Scalars['Boolean']>;
  /** Type of the feature */
  type: Maybe<Instacart_Ads_Platform_Taas_V1_SupportedFeatureType>;
};

/**
 * Type of the feature this is mapped to taas_config.go
 * https://github.com/instacart/carrot/blob/master/ads/targeting/rule-engine/taas_config.go#L12
 */
export enum Instacart_Ads_Platform_Taas_V1_SupportedFeatureType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING',
  StringList = 'STRING_LIST',
  Time = 'TIME',
  /** Unknown type placeholder */
  Unknown = 'UNKNOWN'
}

/**
 * This request has OVERWRITE semantics - any existing definition for the segment
 * or its payload will be dropped entirely. Merge semantics, if necessary, are
 * left to the client - the client can get the current definition with
 * GetSegmentDefinition, then assemble what they want the final state to be.
 */
export type Instacart_Ads_Platform_Taas_V1_UpdateSegmentRequest_Input = {
  /** This field is REQUIRED. */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** The new definition of the segment. */
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  /** Optional description of the segment. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the segment to be modified. If the segment does not exist, or if
   * the version number in this field does not match the actual most-recent
   * version number for the segment, then the request will fail.
   */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
  /** Optional name of the segment. */
  name?: InputMaybe<Scalars['String']>;
  /** New data to be returned from TaaS when this segment matches. */
  payload?: InputMaybe<Scalars['GoogleProtobufAnyScalar']>;
};

/**
 * A set of distinct tenants of Ads Platform services. All requests should be
 * scoped to a particular universe, which may imply additional restrictions on
 * available functionality.
 */
export enum Instacart_Ads_Platform_V1_Universe {
  ScopeAds = 'SCOPE_ADS',
  ScopeAdsDiscounts = 'SCOPE_ADS_DISCOUNTS',
  ScopeCmdMarketplace = 'SCOPE_CMD_MARKETPLACE',
  ScopeCmdSfx = 'SCOPE_CMD_SFX',
  ScopeIbottaPromotions = 'SCOPE_IBOTTA_PROMOTIONS',
  ScopeInternalTesting = 'SCOPE_INTERNAL_TESTING',
  ScopeItemAvailability = 'SCOPE_ITEM_AVAILABILITY',
  ScopeRetailerPromotion = 'SCOPE_RETAILER_PROMOTION',
  ScopeRetailerRankingAndBoosting = 'SCOPE_RETAILER_RANKING_AND_BOOSTING',
  /** Default/invalid */
  ScopeUnknown = 'SCOPE_UNKNOWN'
}

/**
 * VersionedIdentifier contains a set of fields that give metadata for the current
 * record version.
 */
export type Instacart_Ads_Shared_V1_VersionedIdentifier = {
  __typename?: 'instacart_ads_shared_v1_VersionedIdentifier';
  /**
   * Indicates the first time this entity was created (i.e. the creation of the first
   * version). This should **NEVER** be used in any kind of optimistic locking.
   */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The unique identifier of this particular entity across the models. */
  id: Maybe<Scalars['String']>;
  /**
   * Indicates the last time this particular version was updated. This should **NEVER**
   * be used as a lock key of any sort. This should **NEVER** be used in any kind
   * of optimistic locking.
   */
  updatedAt: Maybe<Scalars['DateTime']>;
  /**
   * The particular version of this entity. This usually changes whenever of its
   * fields does. Please note that, while this is an increasing number, it should **NOT**
   * be used as a lock key for optimistic locking or similar.
   */
  version: Maybe<Scalars['BigInt']>;
};

/**
 * VersionedIdentifier contains a set of fields that give metadata for the current
 * record version.
 */
export type Instacart_Ads_Shared_V1_VersionedIdentifier_Input = {
  /**
   * Indicates the first time this entity was created (i.e. the creation of the first
   * version). This should **NEVER** be used in any kind of optimistic locking.
   */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** The unique identifier of this particular entity across the models. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Indicates the last time this particular version was updated. This should **NEVER**
   * be used as a lock key of any sort. This should **NEVER** be used in any kind
   * of optimistic locking.
   */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The particular version of this entity. This usually changes whenever of its
   * fields does. Please note that, while this is an increasing number, it should **NOT**
   * be used as a lock key for optimistic locking or similar.
   */
  version?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Ads_Targeting_V1_AlcoholBuyerLicense {
  /** off_premise implies that they sell alcohol for consumption off premise (eg. Bevmo) */
  AlcoholOffPremises = 'ALCOHOL_OFF_PREMISES',
  /**
   * on_and_off_premise implies that they sell alcohol for consumption both on and off premises (eg. Brewery)
   * This is a distinct license and NOT equivalent to having both an on_premise and an off_premise license.
   */
  AlcoholOnAndOffPremises = 'ALCOHOL_ON_AND_OFF_PREMISES',
  /** on_premise implies that they only sell alcohol on premise (eg. restaurant) */
  AlcoholOnPremises = 'ALCOHOL_ON_PREMISES',
  BuyerLicenseUnknown = 'BUYER_LICENSE_UNKNOWN'
}

export type Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition = {
  __typename?: 'instacart_ads_targeting_v1_AlcoholBuyerLicenseCondition';
  /**
   * This represents the Alcohol license for a user.
   * The license is relevent only for retailers at the moment.
   * This is an OR, the licenses list is a form of A || B || C
   * For example, ALCOHOL_ON_PREMISES OR ALCOHOL_OFF_PREMISES can be combined for both cases
   * Like (eg. brewery)
   */
  licenses: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicense>>>;
};

export type Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition_Input = {
  /**
   * This represents the Alcohol license for a user.
   * The license is relevent only for retailers at the moment.
   * This is an OR, the licenses list is a form of A || B || C
   * For example, ALCOHOL_ON_PREMISES OR ALCOHOL_OFF_PREMISES can be combined for both cases
   * Like (eg. brewery)
   */
  licenses?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicense>>>;
};

export type Instacart_Ads_Targeting_V1_Audience = {
  __typename?: 'instacart_ads_targeting_v1_Audience';
  audienceId: Maybe<Scalars['String']>;
};

/** Condition for predefined audiences generated from ML models. */
export type Instacart_Ads_Targeting_V1_AudienceCondition = {
  __typename?: 'instacart_ads_targeting_v1_AudienceCondition';
  /** Only target users that are assigned any of the audiences. */
  audiences: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_Audience>>>;
};

/** Condition for predefined audiences generated from ML models. */
export type Instacart_Ads_Targeting_V1_AudienceCondition_Input = {
  /** Only target users that are assigned any of the audiences. */
  audiences?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_Audience_Input>>>;
};

export type Instacart_Ads_Targeting_V1_Audience_Input = {
  audienceId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Targeting_V1_BoolCondition = {
  __typename?: 'instacart_ads_targeting_v1_BoolCondition';
  mapKey: Maybe<Scalars['String']>;
  retailerDetails: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
};

export type Instacart_Ads_Targeting_V1_BoolCondition_Input = {
  mapKey?: InputMaybe<Scalars['String']>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
};

/**
 * Condition that requires a user to have bought a product from one of the
 * given brands.
 */
export type Instacart_Ads_Targeting_V1_BrandIdCondition = {
  __typename?: 'instacart_ads_targeting_v1_BrandIdCondition';
  /** Brands in which purchases are considered. */
  brandIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * A single BrandIdCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two BrandIdCondition, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow: Maybe<Scalars['String']>;
};

/**
 * Condition that requires a user to have bought a product from one of the
 * given brands.
 */
export type Instacart_Ads_Targeting_V1_BrandIdCondition_Input = {
  /** Brands in which purchases are considered. */
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * A single BrandIdCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two BrandIdCondition, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: InputMaybe<Scalars['String']>;
};

/**
 * Condition that requires a user to have bought a product from
 * one of the given categories.
 */
export type Instacart_Ads_Targeting_V1_CategoryCondition = {
  __typename?: 'instacart_ads_targeting_v1_CategoryCondition';
  /** Product categories in which purchases are considered. */
  categories: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single CategoryCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two CategoryConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow: Maybe<Scalars['String']>;
};

/**
 * Condition that requires a user to have bought a product from
 * one of the given categories.
 */
export type Instacart_Ads_Targeting_V1_CategoryCondition_Input = {
  /** Product categories in which purchases are considered. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single CategoryCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two CategoryConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Ads_Targeting_V1_ComparisonOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  /** only for string, time, time window types */
  IsEmpty = 'IS_EMPTY',
  LessThan = 'LESS_THAN',
  Unknown = 'UNKNOWN'
}

export enum Instacart_Ads_Targeting_V1_CrossRetailerReducer {
  Max = 'MAX',
  Min = 'MIN',
  None = 'NONE',
  Sum = 'SUM'
}

export type Instacart_Ads_Targeting_V1_EmailCsvCondition = {
  __typename?: 'instacart_ads_targeting_v1_EmailCsvCondition';
  /** This represents the name of the uploaded csv file. */
  emailCsvName: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  whitelabelId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_EmailCsvCondition_Input = {
  /** This represents the name of the uploaded csv file. */
  emailCsvName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  whitelabelId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_FloatCondition = {
  __typename?: 'instacart_ads_targeting_v1_FloatCondition';
  crossRetailerReducer: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  operator: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  threshold: Maybe<Scalars['Float']>;
};

export type Instacart_Ads_Targeting_V1_FloatCondition_Input = {
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  threshold?: InputMaybe<Scalars['Float']>;
};

/** For geo targeting. */
export type Instacart_Ads_Targeting_V1_Geo = {
  __typename?: 'instacart_ads_targeting_v1_Geo';
  /** Currently ignored. All Geo matching elements must specify a state. */
  countryCode: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  stateCode: Maybe<Scalars['String']>;
};

/** Condition for geo check. */
export type Instacart_Ads_Targeting_V1_GeoCondition = {
  __typename?: 'instacart_ads_targeting_v1_GeoCondition';
  /** Only target users in any of the regions. */
  geo: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_Geo>>>;
};

/** Condition for geo check. */
export type Instacart_Ads_Targeting_V1_GeoCondition_Input = {
  /** Only target users in any of the regions. */
  geo?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_Geo_Input>>>;
};

/** For geo targeting. */
export type Instacart_Ads_Targeting_V1_Geo_Input = {
  /** Currently ignored. All Geo matching elements must specify a state. */
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Targeting_V1_IntCondition = {
  __typename?: 'instacart_ads_targeting_v1_IntCondition';
  crossRetailerReducer: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  operator: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  threshold: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_IntCondition_Input = {
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  threshold?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_Region = {
  __typename?: 'instacart_ads_targeting_v1_Region';
  regionCode: Maybe<Instacart_Ads_Targeting_V1_RegionCode>;
};

export enum Instacart_Ads_Targeting_V1_RegionCode {
  AlcoholEast = 'ALCOHOL_EAST',
  AlcoholEastNorthCentral = 'ALCOHOL_EAST_NORTH_CENTRAL',
  /** alcohol advertiser region codes */
  AlcoholWest = 'ALCOHOL_WEST',
  AlcoholWestNorthCentral = 'ALCOHOL_WEST_NORTH_CENTRAL',
  CcConsolidated = 'CC_CONSOLIDATED',
  CcHeartland = 'CC_HEARTLAND',
  CcLiberty = 'CC_LIBERTY',
  CcReyes = 'CC_REYES',
  CcSouthwest = 'CC_SOUTHWEST',
  /** Coca Cola region codes */
  CcSwire = 'CC_SWIRE',
  DefaultEastNorthCentral = 'DEFAULT_EAST_NORTH_CENTRAL',
  DefaultMiddleAtlantic = 'DEFAULT_MIDDLE_ATLANTIC',
  DefaultMidwest = 'DEFAULT_MIDWEST',
  DefaultMountain = 'DEFAULT_MOUNTAIN',
  DefaultNewEngland = 'DEFAULT_NEW_ENGLAND',
  /** default region codes */
  DefaultPacific = 'DEFAULT_PACIFIC',
  DefaultSouthAtlantic = 'DEFAULT_SOUTH_ATLANTIC',
  DefaultSouthCentral = 'DEFAULT_SOUTH_CENTRAL',
  DefaultWestNorthCentral = 'DEFAULT_WEST_NORTH_CENTRAL',
  UnknownRegion = 'UNKNOWN_REGION'
}

export type Instacart_Ads_Targeting_V1_RegionCondition = {
  __typename?: 'instacart_ads_targeting_v1_RegionCondition';
  /** Create by mistake. Use regions instead. */
  region: Maybe<Instacart_Ads_Targeting_V1_Region>;
  regions: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_Region>>>;
};

export type Instacart_Ads_Targeting_V1_RegionCondition_Input = {
  /** Create by mistake. Use regions instead. */
  region?: InputMaybe<Instacart_Ads_Targeting_V1_Region_Input>;
  regions?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_Region_Input>>>;
};

export type Instacart_Ads_Targeting_V1_Region_Input = {
  regionCode?: InputMaybe<Instacart_Ads_Targeting_V1_RegionCode>;
};

export type Instacart_Ads_Targeting_V1_RetailerDetails = {
  __typename?: 'instacart_ads_targeting_v1_RetailerDetails';
  orderSource: Maybe<Scalars['String']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context. This allows one rule to be reused across contexts, but
   * be evaluated with context-specific data.
   */
  retailerFromContext: Maybe<Scalars['google_protobuf_Empty']>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_RetailerDetails_Input = {
  orderSource?: InputMaybe<Scalars['String']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context. This allows one rule to be reused across contexts, but
   * be evaluated with context-specific data.
   */
  retailerFromContext?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Ads_Targeting_V1_SetComparisonOperator {
  /** Elements must exactly match between target and feature sets. */
  EqualElements = 'EQUAL_ELEMENTS',
  /** Check if the feature set is null or empty */
  IsEmptySet = 'IS_EMPTY_SET',
  /** At least one element is common between target and feature sets. */
  NonEmptyIntersection = 'NON_EMPTY_INTERSECTION',
  NonEmptyIntersectionWithContext = 'NON_EMPTY_INTERSECTION_WITH_CONTEXT',
  UnknownSetOperator = 'UNKNOWN_SET_OPERATOR'
}

export type Instacart_Ads_Targeting_V1_StringCondition = {
  __typename?: 'instacart_ads_targeting_v1_StringCondition';
  isRegex: Maybe<Scalars['Boolean']>;
  mapKey: Maybe<Scalars['String']>;
  operator: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  /** For matching against a single target string. */
  targetValue: Maybe<Scalars['String']>;
  /** For matching against any of multiple target strings. */
  targetValues: Maybe<Instacart_Ads_Targeting_V1_StringTargetValues>;
};

export type Instacart_Ads_Targeting_V1_StringCondition_Input = {
  isRegex?: InputMaybe<Scalars['Boolean']>;
  mapKey?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  /** For matching against a single target string. */
  targetValue?: InputMaybe<Scalars['String']>;
  /** For matching against any of multiple target strings. */
  targetValues?: InputMaybe<Instacart_Ads_Targeting_V1_StringTargetValues_Input>;
};

/** This condition compares two lists of strings with one of the available operators */
export type Instacart_Ads_Targeting_V1_StringListCondition = {
  __typename?: 'instacart_ads_targeting_v1_StringListCondition';
  isCaseInsensitive: Maybe<Scalars['Boolean']>;
  mapKey: Maybe<Scalars['String']>;
  /** Operator defaults to NON_EMPTY_INTERSECTION for backward compatibility */
  operator: Maybe<Instacart_Ads_Targeting_V1_SetComparisonOperator>;
  retailerDetails: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  targetValues: Maybe<Scalars['JSON']>;
};

/** This condition compares two lists of strings with one of the available operators */
export type Instacart_Ads_Targeting_V1_StringListCondition_Input = {
  isCaseInsensitive?: InputMaybe<Scalars['Boolean']>;
  mapKey?: InputMaybe<Scalars['String']>;
  /** Operator defaults to NON_EMPTY_INTERSECTION for backward compatibility */
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_SetComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  targetValues?: InputMaybe<Scalars['JSON']>;
};

export type Instacart_Ads_Targeting_V1_StringTargetValues = {
  __typename?: 'instacart_ads_targeting_v1_StringTargetValues';
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Ads_Targeting_V1_StringTargetValues_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * A TargetingRule is a Boolean-logic rule over features of a user or serving
 * context. Rules are stored with creatives/adgroups. At serving time, each
 * creative is eligible to participate in an auction only if its TargetingRule
 * is satisfied by that auction's context.
 *
 * A rule is defined in disjunctive-normal form (an OR of ANDs). (Note,
 * however, that individual rule elements may themselves implicitly be
 * disjunctions - for instance, by specifying a list of product categories on
 * which to match behavior.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule = {
  __typename?: 'instacart_ads_targeting_v1_TargetingRule';
  /**
   * If any of the conjunctions in this list is satisfied, then the rule is
   * satisfied.
   *
   * As a special case, if this list is empty, then the rule is also satisfied.
   * That means that a rule with no conjunctions is semantically equivalent to
   * a rule with a single, empty conjunction.
   */
  conjunctions: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_TargetingRule_Conjunction>>>;
};

export type Instacart_Ads_Targeting_V1_TargetingRuleElement = {
  __typename?: 'instacart_ads_targeting_v1_TargetingRuleElement';
  alcoholBuyerLicenseCondition: Maybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition>;
  /**
   * Special value for conditions that are always true. For system-internal
   * use only (e.g., as a simplification of A OR !A); should not be set
   * normally. If 'not' is set, then this element should always evaulate to
   * false.
   */
  alwaysTrue: Maybe<Scalars['google_protobuf_Empty']>;
  audience: Maybe<Instacart_Ads_Targeting_V1_AudienceCondition>;
  boolCondition: Maybe<Instacart_Ads_Targeting_V1_BoolCondition>;
  brandId: Maybe<Instacart_Ads_Targeting_V1_BrandIdCondition>;
  brandIdInterest: Maybe<Instacart_Ads_Targeting_V1_BrandIdCondition>;
  category: Maybe<Instacart_Ads_Targeting_V1_CategoryCondition>;
  categoryInterest: Maybe<Instacart_Ads_Targeting_V1_CategoryCondition>;
  emailCsvCondition: Maybe<Instacart_Ads_Targeting_V1_EmailCsvCondition>;
  /** The feature dependency for a given targeting rule. */
  feature: Maybe<Scalars['String']>;
  floatCondition: Maybe<Instacart_Ads_Targeting_V1_FloatCondition>;
  geo: Maybe<Instacart_Ads_Targeting_V1_GeoCondition>;
  /** These conditions are used for implementing generic use cases and should be used by retailers to set up all taas segments */
  intCondition: Maybe<Instacart_Ads_Targeting_V1_IntCondition>;
  newToInstacart: Maybe<Scalars['instacart_ads_targeting_v1_NewToInstacartCondition']>;
  /**
   * Logical NOT: inverts the condition to match users/contexts where the
   * condition is otherwise not true.
   */
  not: Maybe<Scalars['Boolean']>;
  region: Maybe<Instacart_Ads_Targeting_V1_RegionCondition>;
  stringCondition: Maybe<Instacart_Ads_Targeting_V1_StringCondition>;
  stringListCondition: Maybe<Instacart_Ads_Targeting_V1_StringListCondition>;
  timeCondition: Maybe<Instacart_Ads_Targeting_V1_TimeCondition>;
  timeIntervalCondition: Maybe<Instacart_Ads_Targeting_V1_TimeIntervalCondition>;
  upc: Maybe<Instacart_Ads_Targeting_V1_UpcCondition>;
  upcInterest: Maybe<Instacart_Ads_Targeting_V1_UpcCondition>;
  userOrdersCount: Maybe<Instacart_Ads_Targeting_V1_UserOrdersCountCondition>;
};

export type Instacart_Ads_Targeting_V1_TargetingRuleElement_Input = {
  alcoholBuyerLicenseCondition?: InputMaybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition_Input>;
  /**
   * Special value for conditions that are always true. For system-internal
   * use only (e.g., as a simplification of A OR !A); should not be set
   * normally. If 'not' is set, then this element should always evaulate to
   * false.
   */
  alwaysTrue?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  audience?: InputMaybe<Instacart_Ads_Targeting_V1_AudienceCondition_Input>;
  boolCondition?: InputMaybe<Instacart_Ads_Targeting_V1_BoolCondition_Input>;
  brandId?: InputMaybe<Instacart_Ads_Targeting_V1_BrandIdCondition_Input>;
  brandIdInterest?: InputMaybe<Instacart_Ads_Targeting_V1_BrandIdCondition_Input>;
  category?: InputMaybe<Instacart_Ads_Targeting_V1_CategoryCondition_Input>;
  categoryInterest?: InputMaybe<Instacart_Ads_Targeting_V1_CategoryCondition_Input>;
  emailCsvCondition?: InputMaybe<Instacart_Ads_Targeting_V1_EmailCsvCondition_Input>;
  /** The feature dependency for a given targeting rule. */
  feature?: InputMaybe<Scalars['String']>;
  floatCondition?: InputMaybe<Instacart_Ads_Targeting_V1_FloatCondition_Input>;
  geo?: InputMaybe<Instacart_Ads_Targeting_V1_GeoCondition_Input>;
  /** These conditions are used for implementing generic use cases and should be used by retailers to set up all taas segments */
  intCondition?: InputMaybe<Instacart_Ads_Targeting_V1_IntCondition_Input>;
  newToInstacart?: InputMaybe<Scalars['instacart_ads_targeting_v1_NewToInstacartCondition_Input']>;
  /**
   * Logical NOT: inverts the condition to match users/contexts where the
   * condition is otherwise not true.
   */
  not?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Instacart_Ads_Targeting_V1_RegionCondition_Input>;
  stringCondition?: InputMaybe<Instacart_Ads_Targeting_V1_StringCondition_Input>;
  stringListCondition?: InputMaybe<Instacart_Ads_Targeting_V1_StringListCondition_Input>;
  timeCondition?: InputMaybe<Instacart_Ads_Targeting_V1_TimeCondition_Input>;
  timeIntervalCondition?: InputMaybe<Instacart_Ads_Targeting_V1_TimeIntervalCondition_Input>;
  upc?: InputMaybe<Instacart_Ads_Targeting_V1_UpcCondition_Input>;
  upcInterest?: InputMaybe<Instacart_Ads_Targeting_V1_UpcCondition_Input>;
  userOrdersCount?: InputMaybe<Instacart_Ads_Targeting_V1_UserOrdersCountCondition_Input>;
};

/**
 * Within a single conjunction, /all/ elements must be satisfied in order for
 * the conjunction to be satisfied.
 *
 * As a special case, if the list of elements is empty, then the conjunction
 * is also satisfied. (Another way of looking at this: every conjunction
 * implicitly includes literal TRUE.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule_Conjunction = {
  __typename?: 'instacart_ads_targeting_v1_TargetingRule_Conjunction';
  elements: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_TargetingRuleElement>>>;
};

/**
 * Within a single conjunction, /all/ elements must be satisfied in order for
 * the conjunction to be satisfied.
 *
 * As a special case, if the list of elements is empty, then the conjunction
 * is also satisfied. (Another way of looking at this: every conjunction
 * implicitly includes literal TRUE.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule_Conjunction_Input = {
  elements?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_TargetingRuleElement_Input>>>;
};

/**
 * A TargetingRule is a Boolean-logic rule over features of a user or serving
 * context. Rules are stored with creatives/adgroups. At serving time, each
 * creative is eligible to participate in an auction only if its TargetingRule
 * is satisfied by that auction's context.
 *
 * A rule is defined in disjunctive-normal form (an OR of ANDs). (Note,
 * however, that individual rule elements may themselves implicitly be
 * disjunctions - for instance, by specifying a list of product categories on
 * which to match behavior.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule_Input = {
  /**
   * If any of the conjunctions in this list is satisfied, then the rule is
   * satisfied.
   *
   * As a special case, if this list is empty, then the rule is also satisfied.
   * That means that a rule with no conjunctions is semantically equivalent to
   * a rule with a single, empty conjunction.
   */
  conjunctions?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Conjunction_Input>>>;
};

export type Instacart_Ads_Targeting_V1_TimeCondition = {
  __typename?: 'instacart_ads_targeting_v1_TimeCondition';
  crossRetailerReducer: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  operator: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  threshold: Maybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Targeting_V1_TimeCondition_Input = {
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  threshold?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Targeting_V1_TimeIntervalCondition = {
  __typename?: 'instacart_ads_targeting_v1_TimeIntervalCondition';
  /**
   * MAX/MIN here means we will take the max/min of the times and then compare with the time interval specified
   * We will not be taking max/min of the intervals
   */
  crossRetailerReducer: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapIndices: Maybe<Array<Maybe<Scalars['String']>>>;
  mapKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  operator: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  timeWindow: Maybe<Scalars['String']>;
};

export type Instacart_Ads_Targeting_V1_TimeIntervalCondition_Input = {
  /**
   * MAX/MIN here means we will take the max/min of the times and then compare with the time interval specified
   * We will not be taking max/min of the intervals
   */
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapIndices?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  timeWindow?: InputMaybe<Scalars['String']>;
};

/** Condition for availability check. */
export type Instacart_Ads_Targeting_V1_UpcCondition = {
  __typename?: 'instacart_ads_targeting_v1_UPCCondition';
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single UPCCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * If the time window is empty, this field is for availability check.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two UPCConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow: Maybe<Scalars['String']>;
  /**
   * At least 1 of the UPCs must be available at the stores
   * in which the user has shopped (or is shopping).
   */
  upcs: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Condition for availability check. */
export type Instacart_Ads_Targeting_V1_UpcCondition_Input = {
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single UPCCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * If the time window is empty, this field is for availability check.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two UPCConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: InputMaybe<Scalars['String']>;
  /**
   * At least 1 of the UPCs must be available at the stores
   * in which the user has shopped (or is shopping).
   */
  upcs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Ads_Targeting_V1_UserOrdersCountCondition = {
  __typename?: 'instacart_ads_targeting_v1_UserOrdersCountCondition';
  /**
   * If set, the condition considers all completed orders.
   *
   * Valid only if order_source == "marketplace"
   */
  includeAllOrders: Maybe<Scalars['Boolean']>;
  operator: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  orderSource: Maybe<Scalars['String']>;
  orderThreshold: Maybe<Scalars['BigInt']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context.
   */
  retailerFromContext: Maybe<Scalars['google_protobuf_Empty']>;
  /** If set, the condition applies to only the orders from the given retailer. */
  retailerId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_UserOrdersCountCondition_Input = {
  /**
   * If set, the condition considers all completed orders.
   *
   * Valid only if order_source == "marketplace"
   */
  includeAllOrders?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  orderSource?: InputMaybe<Scalars['String']>;
  orderThreshold?: InputMaybe<Scalars['BigInt']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context.
   */
  retailerFromContext?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  /** If set, the condition applies to only the orders from the given retailer. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_V3_BrandNameMapping = {
  __typename?: 'instacart_ads_v3_BrandNameMapping';
  brandName: Maybe<Scalars['String']>;
  brandProfileId: Maybe<Scalars['String']>;
};

export type Instacart_Ads_V3_DisplayPreviewData = {
  __typename?: 'instacart_ads_v3_DisplayPreviewData';
  accountName: Maybe<Scalars['String']>;
  adGroupUuid: Maybe<Scalars['String']>;
  assetType: Maybe<Scalars['String']>;
  bannerPreview: Maybe<Scalars['String']>;
  blocked: Maybe<Scalars['Boolean']>;
  brandPageSlug: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['String']>;
  creativeId: Maybe<Scalars['String']>;
  creativeType: Maybe<Scalars['String']>;
  demandSource: Maybe<Scalars['String']>;
  displayAssetId: Maybe<Scalars['String']>;
  entityNames: Maybe<Scalars['String']>;
  flaggedByAi: Maybe<Scalars['Boolean']>;
  modifiedAt: Maybe<Scalars['String']>;
  productIds: Maybe<Scalars['JSON']>;
  retailerId: Maybe<Scalars['BigInt']>;
  reviewed: Maybe<Scalars['Boolean']>;
  thumbnail: Maybe<Scalars['String']>;
  upcMatchPercentage: Maybe<Scalars['Float']>;
  upcs: Maybe<Scalars['JSON']>;
};

export type Instacart_Ads_V3_Filter_Input = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Request message to get display preview data */
export type Instacart_Ads_V3_GetDisplayPreviewDataRequest_Input = {
  creativeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandSources?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Ads_V3_Filter_Input>>>;
  pageCriteria?: InputMaybe<Instacart_Ads_V3_PageCriteria_Input>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sortCriteria?: InputMaybe<Instacart_Ads_V3_SortCriteria_Input>;
};

/** Response message for display preview data */
export type Instacart_Ads_V3_GetDisplayPreviewDataResponse = {
  __typename?: 'instacart_ads_v3_GetDisplayPreviewDataResponse';
  displayPreviewData: Maybe<Array<Maybe<Instacart_Ads_V3_DisplayPreviewData>>>;
  pagination: Maybe<Instacart_Ads_V3_Pagination>;
};

/** Request message to get the ID of Ads blocked by the retailer */
export type Instacart_Ads_V3_GetRetailerBlockedAdIdsRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message to get the ID of Ads blocked by the retailer */
export type Instacart_Ads_V3_GetRetailerBlockedAdIdsResponse = {
  __typename?: 'instacart_ads_v3_GetRetailerBlockedAdIdsResponse';
  ids: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Ads_V3_IndexBrandNamesRequest_Input = {
  isDebug?: InputMaybe<Scalars['Boolean']>;
  superCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Ads_V3_IndexBrandNamesResponse = {
  __typename?: 'instacart_ads_v3_IndexBrandNamesResponse';
  brandNameMappings: Maybe<Array<Maybe<Instacart_Ads_V3_BrandNameMapping>>>;
  /** This message is in path to deprecation, since maps do not support ordering */
  brandProfileIdToName: Maybe<Scalars['JSON']>;
};

export type Instacart_Ads_V3_PageCriteria_Input = {
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Ads_V3_Pagination = {
  __typename?: 'instacart_ads_v3_Pagination';
  currentPage: Maybe<Scalars['Int']>;
  totalCount: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type Instacart_Ads_V3_ProductAdditionalInfoRequest_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_V3_ProductAdditionalInfoResponse = {
  __typename?: 'instacart_ads_v3_ProductAdditionalInfoResponse';
  details: Maybe<Scalars['String']>;
  ingredients: Maybe<Scalars['String']>;
};

/** Request message to block/unblock an Ad */
export type Instacart_Ads_V3_RetailerBlockAdRequest_Input = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message to block/unblock an Ad */
export type Instacart_Ads_V3_RetailerBlockAdResponse = {
  __typename?: 'instacart_ads_v3_RetailerBlockAdResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Ads_V3_SortCriteria_Input = {
  direction?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
};

/** Request message for creating a carousel. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselRequest_Input = {
  /** Optional parameters that control how content is generated */
  generation_params?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationParams_Input>;
  /**
   * The user's natural language prompt for the carousel.
   * e.g. "I want a carousel featuring budget-friendly, healthy weeknight dinners"
   */
  user_prompt?: InputMaybe<Scalars['String']>;
};

/** Response message containing the generated carousel configuration. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselResponse = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_CreateCarouselResponse';
  /**
   * Attribute filters for refining item selection.
   * e.g. ["organic", "low sugar", "low sodium", "low fat", "high protein", "nut-free"]
   */
  attribute_filters: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Description of the target audience for the carousel.
   * e.g. "users who have toddlers"
   */
  carousel_targeting: Maybe<Scalars['String']>;
  /**
   * The generated title for the carousel (<=45 characters).
   * e.g. "Healthy lunchbox heroes"
   */
  carousel_title: Maybe<Scalars['String']>;
  /**
   * Flag indicating if the carousel is similar to an existing one
   * (based on keyword overlap).
   */
  duplication_flag: Maybe<Scalars['Boolean']>;
  /**
   * Optional end date for the carousel's validity.
   * Only applies to holiday related carousels (e.g. Valentine's day).
   */
  end_date: Maybe<Scalars['DateTime']>;
  /**
   * The method used for ranking items within the carousel.
   * Defaults to "best match" (unified item ranker).
   */
  item_ranking: Maybe<Scalars['String']>;
  /**
   * Filters to apply for item retrieval.
   * e.g. ["price < $10"]
   */
  item_retrieval_filters: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The logic used to retrieve items for the carousel.
   * Currently supports "keywords"
   */
  item_retrieval_logic: Maybe<Scalars['String']>;
  /**
   * Keywords used for item retrieval.
   * e.g. ["whole-grain bread", "baby carrots", "hummus cups", "string cheese",
   * "apple slices", "low-sugar yogurt", "turkey slices", "whole-grain crackers",
   * "mini cucumbers", "almond butter packets"]
   */
  keywords: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Raw attribute filters before processing or filtering.
   * Used to store immediate media output for attribute filters.
   */
  raw_attribute_filters: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Raw keywords before processing or filtering.
   * Used to store immediate media output for keywords.
   */
  raw_keywords: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of existing carousels that are similar to the generated one.
   * Empty if no duplicates found.
   */
  similar_carousels: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional start date for the carousel's validity.
   * Only applies to holiday related carousels (e.g. Valentine's day).
   */
  start_date: Maybe<Scalars['DateTime']>;
};

/** Enum describing generation modes used by the creator */
export enum Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode {
  /** Select from an existing pool/catalog only */
  ExistingPool = 'EXISTING_POOL',
  /** Accept user-provided values without mapping to existing pools */
  FreeForm = 'FREE_FORM',
  /** Generate candidate values and map them to an existing pool */
  GenerateAndMap = 'GENERATE_AND_MAP',
  GenerationModeUnspecified = 'GENERATION_MODE_UNSPECIFIED'
}

/** Parameters controlling how different assets are generated */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationParams_Input = {
  /** Mode for generating attribute filters */
  attribute_filters_mode?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode>;
  /** Mode for generating brand terms */
  brand_mode?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode>;
  /** Mode for generating keywords */
  keywords_mode?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode>;
  /** Parameters for the underlying model */
  model_params?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_ModelParams_Input>;
};

/** Request message for finding similar carousels. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsRequest_Input = {
  /**
   * Optional attribute filters to include in similarity comparison.
   * e.g. ["organic", "low sugar", "low sodium", "low fat", "high protein", "nut-free"]
   */
  attribute_filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The carousel title to compare against existing carousels.
   * e.g. "Healthy lunchbox heroes"
   */
  carousel_title?: InputMaybe<Scalars['String']>;
  /**
   * Optional item retrieval filters to include in similarity comparison.
   * e.g. ["price < $10"]
   */
  item_retrieval_filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Keywords used for similarity comparison.
   * This is the primary field used for similarity matching via vector embeddings.
   * e.g. ["whole-grain bread", "baby carrots", "hummus cups", "string cheese"]
   */
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Maximum number of similar carousels to return.
   * Defaults to 5 if not specified or 0.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Minimum similarity threshold (0.0 to 1.0).
   * Only carousels with similarity scores above this threshold will be returned.
   */
  similarity_threshold?: InputMaybe<Scalars['Float']>;
};

/** Response message containing similar carousels. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsResponse = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_GetSimilarCarouselsResponse';
  /** List of similar carousels found, ordered by similarity score (highest first). */
  similar_carousels: Maybe<Array<Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_SimilarCarousel>>>;
  /** Total number of similar carousels found (may be higher than returned if limit was applied). */
  total_count: Maybe<Scalars['Int']>;
};

/** Parameters for the LLM/model used during generation */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_ModelParams_Input = {
  /** Identifier of the LLM/model to use (e.g., "gpt-4o", "claude-3-sonnet") */
  llm_model?: InputMaybe<Scalars['String']>;
  /** Temperature for sampling; typical range [0.0, 1.0] */
  llm_temperature?: InputMaybe<Scalars['Float']>;
};

/** Information about a similar carousel. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_SimilarCarousel = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_SimilarCarousel';
  /** Unique identifier of the similar carousel from the content library. */
  content_intent_id: Maybe<Scalars['String']>;
  /** Keywords from the similar carousel. */
  keywords: Maybe<Scalars['String']>;
  /** Similarity score (0.0 to 1.0, where 1.0 is identical). */
  similarity_score: Maybe<Scalars['Float']>;
};

/** For when we have many small requests, we can handle throughput more effectively */
export type Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input = {
  inlineCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCarouselSummaries_Input>;
  inlineCookingSteps?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCookingSteps_Input>;
  inlineFilters?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineFilters_Input>;
  inlineKeywordProductBuckets?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywordProductBuckets_Input>;
  inlineKeywords?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywords_Input>;
  inlinePageCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePageCarousels_Input>;
  inlinePolicy?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePolicy_Input>;
  inlineProducts?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineProducts_Input>;
};

/** Used for large offline batch analysis */
export type Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input = {
  s3Input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_S3Input_Input>;
  snowflakeInput?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SnowflakeInput_Input>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_CarouselGroupQaResult';
  dimensionScores: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult_DimensionScore>>>;
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
};

/** Detailed assessments across key dimensions */
export type Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult_DimensionScore = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_CarouselGroupQaResult_DimensionScore';
  /** e.g., "diversity", "coherence", "complementarity", "balance", "user_experience" */
  dimension: Maybe<Scalars['String']>;
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
  /** Optional numeric score 0-1 (0.0 if not set) */
  score: Maybe<Scalars['Float']>;
};

/** Lightweight carousel representation for group evaluation */
export type Instacart_Algorithms_Content_Ai_Qa_V1_CarouselSummary_Input = {
  carouselId?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ContentDesignQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ContentDesignQaResult';
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_CookingStepsQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_CookingStepsQualityQaResult';
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_FilterQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_FilterQualityQaResult';
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultRequest_Input = {
  jobUuid?: InputMaybe<Scalars['String']>;
};

/**
 * A single response message for all result-fetching, using `oneof`
 * to provide the correctly typed result.
 */
export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_GetWorkflowResultResponse';
  carouselGroupQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult>;
  contentDesignQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ContentDesignQaResult>;
  cookingStepsQualityQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CookingStepsQualityQaResult>;
  filterQualityQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_FilterQualityQaResult>;
  jobUuid: Maybe<Scalars['String']>;
  keywordCompletenessQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordCompletenessQaResult>;
  keywordQualityQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordQualityQaResult>;
  pageQualityQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult>;
  policyQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult>;
  productCompletenessQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductCompletenessQaResult>;
  productQualityQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult>;
  s3Uri: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_WorkflowStatus>;
  topicQualityQaResult: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_TopicQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusRequest_Input = {
  jobUuid?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_GetWorkflowStatusResponse';
  errorDetails: Maybe<Scalars['String']>;
  jobUuid: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_WorkflowStatus>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineCarouselSummaries_Input = {
  carousels?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselSummary_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineCookingSteps_Input = {
  cookingSteps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineFilters_Input = {
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Combined keyword + mapped products input for product completeness evaluation. */
export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywordProductBuckets_Input = {
  keywordBuckets?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordProductBucket_Input>>>;
};

/** Inline wrappers for repeated fields */
export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywords_Input = {
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlinePageCarousels_Input = {
  carousels?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageCarousel_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlinePolicy_Input = {
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineProducts_Input = {
  products?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_Product_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordCompletenessQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_KeywordCompletenessQaResult';
  additionalFields: Maybe<Scalars['JSON']>;
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
};

/** KeywordProductBucket groups a single keyword with its associated products. */
export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordProductBucket_Input = {
  /** Stable identifier for tracking within a workflow */
  bucketId?: InputMaybe<Scalars['String']>;
  /** The keyword this group represents (e.g., "low sugar") */
  keyword?: InputMaybe<Scalars['String']>;
  /** Candidate products associated with the keyword */
  products?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_Product_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_KeywordQualityQaResult';
  keywordResults: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordResult>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_KeywordResult';
  /**
   * Flexible additional fields that can vary per request
   * e.g., {"confidence": 0.92, "quality_score": 8.5}
   */
  additionalFields: Maybe<Scalars['JSON']>;
  explanation: Maybe<Scalars['String']>;
  /** the individual keyword */
  keyword: Maybe<Scalars['String']>;
  /** whether this keyword satisfies requirement */
  passed: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageCarousel_Input = {
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
};

/** Result for page quality evaluation with multiple carousels */
export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult';
  carouselEvaluations: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation>>>;
  pageEvaluation: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_PageEvaluation>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_CarouselEvaluation';
  filtersQuality: Maybe<Scalars['Boolean']>;
  filtersQualityReasoning: Maybe<Scalars['String']>;
  filtersUserAlignment: Maybe<Scalars['Boolean']>;
  filtersUserAlignmentReasoning: Maybe<Scalars['String']>;
  keywords: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_KeywordEvaluation>>>;
  products: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_ProductEvaluation>>>;
  titleClarity: Maybe<Scalars['Boolean']>;
  titleClarityReasoning: Maybe<Scalars['String']>;
  titleQuality: Maybe<Scalars['Boolean']>;
  titleQualityReasoning: Maybe<Scalars['String']>;
  titleSafety: Maybe<Scalars['Boolean']>;
  titleSafetyReasoning: Maybe<Scalars['String']>;
  titleUserAlignment: Maybe<Scalars['Boolean']>;
  titleUserAlignmentReasoning: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_KeywordEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_CarouselEvaluation_KeywordEvaluation';
  keywordTitleAlignment: Maybe<Scalars['Boolean']>;
  keywordTitleAlignmentReasoning: Maybe<Scalars['String']>;
  keywordUserAlignment: Maybe<Scalars['Boolean']>;
  keywordUserAlignmentReasoning: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_ProductEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_CarouselEvaluation_ProductEvaluation';
  productTitleAlignment: Maybe<Scalars['Boolean']>;
  productTitleAlignmentReasoning: Maybe<Scalars['String']>;
  productUserAlignment: Maybe<Scalars['Boolean']>;
  productUserAlignmentReasoning: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_PageEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_PageEvaluation';
  consistency: Maybe<Scalars['Boolean']>;
  consistencyReasoning: Maybe<Scalars['String']>;
  familyCoverage: Maybe<Scalars['Boolean']>;
  familyCoverageReasoning: Maybe<Scalars['String']>;
  householdCoverage: Maybe<Scalars['Boolean']>;
  householdCoverageReasoning: Maybe<Scalars['String']>;
  noRedundancy: Maybe<Scalars['Boolean']>;
  noRedundancyReasoning: Maybe<Scalars['String']>;
  restockingBreadth: Maybe<Scalars['Boolean']>;
  restockingBreadthReasoning: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PolicyQaResult';
  passed: Maybe<Scalars['Boolean']>;
  violations: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult_Violation>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult_Violation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PolicyQaResult_Violation';
  explanation: Maybe<Scalars['String']>;
  /** e.g., "Health Inference", "Cultural Insensitivity" */
  violationType: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ProductCompletenessQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ProductCompletenessQaResult';
  additionalFields: Maybe<Scalars['JSON']>;
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ProductQualityQaResult';
  conclusions: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult_Conclusion>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult_Conclusion = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ProductQualityQaResult_Conclusion';
  additionalFields: Maybe<Scalars['JSON']>;
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
  productId: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_Product_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  /** From the file proto's `ProductRef` */
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunCarouselGroupQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunContentDesignQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ContentDesignQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunFilterQualityQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_FilterQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunKeywordCompletenessQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordCompletenessQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunKeywordQualityQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  purchaseHistory?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userPersona?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunPageQualityQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunPolicyQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunProductQualityQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunTopicQualityQaResponse';
  jobUuid: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_TopicQualityQaResult>;
};

export enum Instacart_Algorithms_Content_Ai_Qa_V1_S3FileFormat {
  S3FileFormatCsv = 'S3_FILE_FORMAT_CSV',
  S3FileFormatNdjson = 'S3_FILE_FORMAT_NDJSON',
  S3FileFormatParquet = 'S3_FILE_FORMAT_PARQUET',
  S3FileFormatUnspecified = 'S3_FILE_FORMAT_UNSPECIFIED'
}

/** Input source configurations */
export type Instacart_Algorithms_Content_Ai_Qa_V1_S3Input_Input = {
  bucket?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_S3FileFormat>;
  /** optional file listing keys; if omitted, service lists by prefix */
  manifestKey?: InputMaybe<Scalars['String']>;
  /** optional subset for pilots */
  maxRecords?: InputMaybe<Scalars['Int']>;
  /** e.g., s3://bucket/prefix/... */
  prefix?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_SnowflakeInput_Input = {
  database?: InputMaybe<Scalars['String']>;
  /** optional WHERE clause (safe-listed) */
  filterSql?: InputMaybe<Scalars['String']>;
  /** optional subset for pilots */
  maxRecords?: InputMaybe<Scalars['Int']>;
  schema?: InputMaybe<Scalars['String']>;
  tableOrView?: InputMaybe<Scalars['String']>;
  warehouse?: InputMaybe<Scalars['String']>;
};

/** Execution mode messages - enforces input constraints at schema level */
export type Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input = {
  inlineCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCarouselSummaries_Input>;
  inlineCookingSteps?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCookingSteps_Input>;
  inlineFilters?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineFilters_Input>;
  inlineKeywordProductBuckets?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywordProductBuckets_Input>;
  inlineKeywords?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywords_Input>;
  inlinePageCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePageCarousels_Input>;
  inlinePolicy?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePolicy_Input>;
  inlineProducts?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineProducts_Input>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_TopicQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_TopicQualityQaResult';
  /**
   * Flexible additional fields for hard failure rule checks
   * Stored as nested pass/explanation pairs (length_check, grammar_spelling_check)
   */
  additionalFields: Maybe<Scalars['JSON']>;
  explanation: Maybe<Scalars['String']>;
  passed: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Algorithms_Content_Ai_Qa_V1_WorkflowStatus {
  WorkflowStatusCompleted = 'WORKFLOW_STATUS_COMPLETED',
  WorkflowStatusFailed = 'WORKFLOW_STATUS_FAILED',
  WorkflowStatusQueued = 'WORKFLOW_STATUS_QUEUED',
  WorkflowStatusRunning = 'WORKFLOW_STATUS_RUNNING',
  WorkflowStatusUnspecified = 'WORKFLOW_STATUS_UNSPECIFIED'
}

/** Request message for adding scopes to a ban entry (additive only) */
export type Instacart_Caper_Admin_V1_AddBanEntryScopesRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  /** The ban entry ID to add scopes to */
  banEntryId?: InputMaybe<Scalars['String']>;
  /**
   * Scopes to add to this ban entry
   * Only adds new scopes - never removes existing ones
   */
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for adding scopes to a ban entry */
export type Instacart_Caper_Admin_V1_AddBanEntryScopesResponse = {
  __typename?: 'instacart_caper_admin_v1_AddBanEntryScopesResponse';
  /** The updated list of all scopes for this ban entry after addition */
  scopes: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/** Represents a single ban list entry (barcode or regex pattern) */
export type Instacart_Caper_Admin_V1_BanEntry = {
  __typename?: 'instacart_caper_admin_v1_BanEntry';
  /**
   * Whether this entry is archived (soft-deleted)
   * Archived entries are only returned when include_archived filter is true
   */
  archived: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Caper_Admin_V1_BanEntryType>;
  /**
   * Raw Barcode or regex pattern
   * For type=REGEX, the Cart will:
   * 1. Match using RE2 or equivalent engine
   * 2. Treat all patterns as case-sensitive
   * 3. NOT anchor automatically - pattern author must use ^ and $ if needed
   *
   * Examples:
   * "^18\d{5}$"     - matches exactly 7 digits starting with 18
   * "^40000\d{6}$"  - matches exactly 11 digits starting with 40000
   */
  value: Maybe<Scalars['String']>;
};

/** Type of audit operation */
export enum Instacart_Caper_Admin_V1_BanEntryAuditOperation {
  BanEntryAuditOperationDelete = 'BAN_ENTRY_AUDIT_OPERATION_DELETE',
  BanEntryAuditOperationInsert = 'BAN_ENTRY_AUDIT_OPERATION_INSERT',
  BanEntryAuditOperationUnknown = 'BAN_ENTRY_AUDIT_OPERATION_UNKNOWN',
  BanEntryAuditOperationUpdate = 'BAN_ENTRY_AUDIT_OPERATION_UPDATE'
}

/** Audit record representing a point in the ban entry's edit history timeline */
export type Instacart_Caper_Admin_V1_BanEntryAuditRecord = {
  __typename?: 'instacart_caper_admin_v1_BanEntryAuditRecord';
  /** Who made the change */
  author: Maybe<Scalars['String']>;
  /** Type of operation performed */
  operation: Maybe<Instacart_Caper_Admin_V1_BanEntryAuditOperation>;
  /** The scopes at this point in time (snapshot after this change) */
  scopes: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
  /** When the change was made */
  timestamp: Maybe<Scalars['DateTime']>;
};

/** Filter criteria for listing ban entries */
export type Instacart_Caper_Admin_V1_BanEntryFilter_Input = {
  /** Include archived entries (default: false) */
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  /** Filter by partner IDs (OR within this list; empty means no partner filter) */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by retailer IDs (OR within this list; empty means no retailer filter) */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by store IDs (OR within this list; empty means no store filter) */
  storeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by ban entry type */
  type?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryType>;
  /** Filter by value (partial match) */
  value?: InputMaybe<Scalars['String']>;
};

/** Information about a ban entry's scope */
export type Instacart_Caper_Admin_V1_BanEntryScopeInfo = {
  __typename?: 'instacart_caper_admin_v1_BanEntryScopeInfo';
  /**
   * Category of the ban entry at this scope (e.g., "reusable_bag", "flyer")
   * Same barcode may have different categories for different retailers/stores
   */
  category: Maybe<Scalars['String']>;
  level: Maybe<Instacart_Caper_Admin_V1_BanEntryScopeLevel>;
  overrideCatalog: Maybe<Scalars['Boolean']>;
  /**
   * Entity ID based on level (ignored for GLOBAL):
   * PARTNER -> partner_id
   * RETAILER -> retailer_id
   * STORE -> store_id
   */
  scopeId: Maybe<Scalars['BigInt']>;
};

/** Information about a ban entry's scope */
export type Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input = {
  /**
   * Category of the ban entry at this scope (e.g., "reusable_bag", "flyer")
   * Same barcode may have different categories for different retailers/stores
   */
  category?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeLevel>;
  overrideCatalog?: InputMaybe<Scalars['Boolean']>;
  /**
   * Entity ID based on level (ignored for GLOBAL):
   * PARTNER -> partner_id
   * RETAILER -> retailer_id
   * STORE -> store_id
   */
  scopeId?: InputMaybe<Scalars['BigInt']>;
};

/** Scope level for ban entries */
export enum Instacart_Caper_Admin_V1_BanEntryScopeLevel {
  BanEntryScopeLevelGlobal = 'BAN_ENTRY_SCOPE_LEVEL_GLOBAL',
  BanEntryScopeLevelPartner = 'BAN_ENTRY_SCOPE_LEVEL_PARTNER',
  BanEntryScopeLevelRetailer = 'BAN_ENTRY_SCOPE_LEVEL_RETAILER',
  BanEntryScopeLevelStore = 'BAN_ENTRY_SCOPE_LEVEL_STORE',
  BanEntryScopeLevelUnknown = 'BAN_ENTRY_SCOPE_LEVEL_UNKNOWN'
}

/** Type of ban list entry */
export enum Instacart_Caper_Admin_V1_BanEntryType {
  BanEntryTypeRawBarcode = 'BAN_ENTRY_TYPE_RAW_BARCODE',
  BanEntryTypeRegex = 'BAN_ENTRY_TYPE_REGEX',
  BanEntryTypeUnknown = 'BAN_ENTRY_TYPE_UNKNOWN'
}

/** Ban entry with full scope information */
export type Instacart_Caper_Admin_V1_BanEntryWithScopes = {
  __typename?: 'instacart_caper_admin_v1_BanEntryWithScopes';
  /** Audit history timeline, ordered by timestamp descending (newest first) */
  auditHistory: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryAuditRecord>>>;
  entry: Maybe<Instacart_Caper_Admin_V1_BanEntry>;
  scopes: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/** Represents a single ban list entry (barcode or regex pattern) */
export type Instacart_Caper_Admin_V1_BanEntry_Input = {
  /**
   * Whether this entry is archived (soft-deleted)
   * Archived entries are only returned when include_archived filter is true
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryType>;
  /**
   * Raw Barcode or regex pattern
   * For type=REGEX, the Cart will:
   * 1. Match using RE2 or equivalent engine
   * 2. Treat all patterns as case-sensitive
   * 3. NOT anchor automatically - pattern author must use ^ and $ if needed
   *
   * Examples:
   * "^18\d{5}$"     - matches exactly 7 digits starting with 18
   * "^40000\d{6}$"  - matches exactly 11 digits starting with 40000
   */
  value?: InputMaybe<Scalars['String']>;
};

/** Basket changed event containing current basket state */
export type Instacart_Caper_Admin_V1_BasketChanged = {
  __typename?: 'instacart_caper_admin_v1_BasketChanged';
  /** List of all items currently in the basket */
  basketItems: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BasketItem>>>;
  /** Total discount in cents */
  discount: Maybe<Scalars['Int']>;
  /** Subtotal amount in cents */
  subTotalAmount: Maybe<Scalars['Int']>;
  /** Total weight of all items in grams */
  totalWeight: Maybe<Scalars['Float']>;
};

/** Basket event with timestamp and sequence information */
export type Instacart_Caper_Admin_V1_BasketEventData = {
  __typename?: 'instacart_caper_admin_v1_BasketEventData';
  /** The basket state at this event */
  basketChanged: Maybe<Instacart_Caper_Admin_V1_BasketChanged>;
  /** Sequence number of this event within the session */
  eventSequence: Maybe<Scalars['Int']>;
  /** When this event occurred */
  eventTimestamp: Maybe<Scalars['DateTime']>;
};

/** Individual basket item with full details */
export type Instacart_Caper_Admin_V1_BasketItem = {
  __typename?: 'instacart_caper_admin_v1_BasketItem';
  /** Actual weight in grams (if weighed) */
  actualWeightGrams: Maybe<Scalars['Float']>;
  /** Barcode of the item */
  barcode: Maybe<Scalars['String']>;
  /** Unique ID for this basket item */
  basketItemId: Maybe<Scalars['String']>;
  /** Location in basket (e.g., "MAIN_BASKET", "CHILD_SEAT") */
  basketLocation: Maybe<Scalars['String']>;
  /** Catalog product ID */
  catalogProductId: Maybe<Scalars['String']>;
  /** Discount information */
  discount: Maybe<Instacart_Caper_Admin_V1_PriceData>;
  /** Expected weight with tolerance */
  expectedWeight: Maybe<Instacart_Caper_Admin_V1_ExpectedWeightData>;
  /** Price information */
  price: Maybe<Instacart_Caper_Admin_V1_PriceData>;
  /** Quantity of items */
  quantity: Maybe<Scalars['Int']>;
  /** URL to product thumbnail image */
  thumbnailUrl: Maybe<Scalars['String']>;
  /** Display title of the item */
  title: Maybe<Scalars['String']>;
  /** Timestamp when item was last updated */
  updateTimestamp: Maybe<Scalars['String']>;
  /** Amount sold by weight in grams (alternative to quantity for produce items) */
  weightGrams: Maybe<Scalars['Float']>;
};

/** A batch scheduled action with all its details */
export type Instacart_Caper_Admin_V1_BatchScheduledAction = {
  __typename?: 'instacart_caper_admin_v1_BatchScheduledAction';
  /** Multiple action details (all actions share same schedule_id and workflow_id) */
  actionDetails: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScheduledActionBatchItem>>>;
  /** Cancellation details */
  cancellationReason: Maybe<Scalars['String']>;
  /** cancelled_at */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** cancelled_by */
  cancelledBy: Maybe<Scalars['String']>;
  /** created_at */
  createdAt: Maybe<Scalars['DateTime']>;
  /** created_by */
  createdBy: Maybe<Scalars['String']>;
  executionEndTime: Maybe<Scalars['DateTime']>;
  /** execution_start_time */
  executionStartTime: Maybe<Scalars['DateTime']>;
  scheduleId: Maybe<Scalars['String']>;
  /** scheduled_time */
  scheduledTime: Maybe<Scalars['DateTime']>;
  /** overall batch status */
  status: Maybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** updated_at */
  updatedAt: Maybe<Scalars['DateTime']>;
  workflowId: Maybe<Scalars['String']>;
};

/** Request to cancel a scheduled action */
export type Instacart_Caper_Admin_V1_CancelScheduledActionRequest_Input = {
  /** Maps to cancellation_reason */
  cancellationReason?: InputMaybe<Scalars['String']>;
  /** Maps to cancelled_by */
  cancelledBy?: InputMaybe<Scalars['String']>;
  scheduleId?: InputMaybe<Scalars['String']>;
};

/** Categorizes the reason for a cart lock to enable accurate incident classification. */
export enum Instacart_Caper_Admin_V1_CartLockReasonType {
  /** Cart-level network/WiFi failure */
  CartLockReasonTypeConnectivityIssue = 'CART_LOCK_REASON_TYPE_CONNECTIVITY_ISSUE',
  /** Physical cart hardware failure */
  CartLockReasonTypeHardwareIssue = 'CART_LOCK_REASON_TYPE_HARDWARE_ISSUE',
  /** Default catch-all */
  CartLockReasonTypeOther = 'CART_LOCK_REASON_TYPE_OTHER',
  /** Scheduled maintenance or batch job */
  CartLockReasonTypePeriodicJob = 'CART_LOCK_REASON_TYPE_PERIODIC_JOB',
  /** Point-of-sale system failure */
  CartLockReasonTypePosIssue = 'CART_LOCK_REASON_TYPE_POS_ISSUE',
  /** Automated system-initiated lock via a randomized selection process */
  CartLockReasonTypeRoulette = 'CART_LOCK_REASON_TYPE_ROULETTE',
  /** Cart software / app crash or bug */
  CartLockReasonTypeSoftwareIssue = 'CART_LOCK_REASON_TYPE_SOFTWARE_ISSUE',
  /** Store staffing or operational decision */
  CartLockReasonTypeStaffingIssue = 'CART_LOCK_REASON_TYPE_STAFFING_ISSUE',
  /** Store-system integration failure (e.g. third-party POS or inventory system) */
  CartLockReasonTypeStoreIntegration = 'CART_LOCK_REASON_TYPE_STORE_INTEGRATION',
  /** Retailer or store-wide network outage */
  CartLockReasonTypeStoreNetwork = 'CART_LOCK_REASON_TYPE_STORE_NETWORK',
  /** Do not use, Other is defaulted in the backend */
  CartLockReasonTypeUnknown = 'CART_LOCK_REASON_TYPE_UNKNOWN',
  /** Hardware Ops requirement for weight calibration failed */
  CartLockReasonTypeWeightCalibration = 'CART_LOCK_REASON_TYPE_WEIGHT_CALIBRATION'
}

/**
 * Inputs for the Cart Replacement pipeline.
 * Provisions a single new cart into a store.
 */
export type Instacart_Caper_Admin_V1_CartReplacementConfig_Input = {
  /** CSC name of the device being replaced (e.g. "P_WAKEFERN_15_M3_001"). */
  cscDeviceName?: InputMaybe<Scalars['String']>;
  /** Warehouse IPv4 address of the device (e.g. "192.168.1.100"). */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Whether the cart has a bottom tray. Defaults to false. */
  isBottomTray?: InputMaybe<Scalars['Boolean']>;
  /** Whether the cart is an M3S model (no Jetson board). Defaults to false. */
  isM3s?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the cart is a 2CV model.
   * Proto3 bool defaults to false if unset; the backend treats unset as true.
   */
  is_2cv?: InputMaybe<Scalars['Boolean']>;
  /** OTA bundle version to deploy. Backend uses the default version if omitted. */
  packageVersion?: InputMaybe<Scalars['String']>;
  /**
   * Physical product ID of the cart (printed on the cart; referred to as
   * productId in IoT Platform).
   */
  productId?: InputMaybe<Scalars['String']>;
  /** Store identifier (e.g. "prod-wakefern-25"). */
  storeId?: InputMaybe<Scalars['String']>;
};

/** Cart session data containing device info and all events */
export type Instacart_Caper_Admin_V1_CartSessionData = {
  __typename?: 'instacart_caper_admin_v1_CartSessionData';
  /** List of basket events showing cart contents over time */
  basketEvents: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BasketEventData>>>;
  /** Device information for the cart */
  deviceInfo: Maybe<Instacart_Caper_Admin_V1_DeviceInfo>;
  /** The session ID for this data */
  sessionId: Maybe<Scalars['String']>;
  /** List of video audit events */
  videoAuditEvents: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_VideoAuditEventData>>>;
};

export enum Instacart_Caper_Admin_V1_CatalogAvailability {
  CatalogAvailabilityExtInCaperCatalog = 'CATALOG_AVAILABILITY_EXT_IN_CAPER_CATALOG',
  CatalogAvailabilityExtInIcCatalog = 'CATALOG_AVAILABILITY_EXT_IN_IC_CATALOG',
  CatalogAvailabilityExtInRetailerCatalog = 'CATALOG_AVAILABILITY_EXT_IN_RETAILER_CATALOG',
  CatalogAvailabilityExtNotInAny = 'CATALOG_AVAILABILITY_EXT_NOT_IN_ANY',
  CatalogAvailabilityExtProcessingFailure = 'CATALOG_AVAILABILITY_EXT_PROCESSING_FAILURE',
  CatalogAvailabilityInIcCatalog = 'CATALOG_AVAILABILITY_IN_IC_CATALOG',
  CatalogAvailabilityInRetailerCatalog = 'CATALOG_AVAILABILITY_IN_RETAILER_CATALOG',
  CatalogAvailabilityInStoreCatalog = 'CATALOG_AVAILABILITY_IN_STORE_CATALOG',
  CatalogAvailabilityNotInAny = 'CATALOG_AVAILABILITY_NOT_IN_ANY',
  CatalogAvailabilityUnknown = 'CATALOG_AVAILABILITY_UNKNOWN'
}

/** Config action for scheduled changes */
export type Instacart_Caper_Admin_V1_ConfigAction = {
  __typename?: 'instacart_caper_admin_v1_ConfigAction';
  /** Optional: config ID for future enhancement */
  configKeyId: Maybe<Scalars['BigInt']>;
  /** Required: config name (aligns with current ConfigValue.name usage) */
  configName: Maybe<Scalars['String']>;
  /** set/update to this value */
  configValue: Maybe<Scalars['String']>;
  /** explicitly remove/reset to default */
  unset: Maybe<Scalars['Boolean']>;
};

/** Config action for scheduled changes */
export type Instacart_Caper_Admin_V1_ConfigAction_Input = {
  /** Optional: config ID for future enhancement */
  configKeyId?: InputMaybe<Scalars['BigInt']>;
  /** Required: config name (aligns with current ConfigValue.name usage) */
  configName?: InputMaybe<Scalars['String']>;
  /** set/update to this value */
  configValue?: InputMaybe<Scalars['String']>;
  /** explicitly remove/reset to default */
  unset?: InputMaybe<Scalars['Boolean']>;
};

/** A config key and metadata about it */
export type Instacart_Caper_Admin_V1_ConfigKey = {
  __typename?: 'instacart_caper_admin_v1_ConfigKey';
  /**
   * For TYPE_ENUM configs, this defines the allowed enum values.
   * Each string in this array represents a valid enum value that can be set for this config.
   * This field is required when type = TYPE_ENUM and ignored for other types.
   * When validating config values, the value must exactly match one of these strings (case-sensitive).
   */
  allowedEnumValues: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * You can mark config fields that are no longer read by the cart as "archived".
   * In the future, this will prevent these options from showing up in the UI.
   */
  archived: Maybe<Scalars['Boolean']>;
  /** A link to the relevant SOP, JIRA, or other doc. Must be a link. */
  contextLink: Maybe<Scalars['String']>;
  /** free form text field to indicate Ii this config relies on Roulette Flags or other configs. If there are none, leave blank */
  dependencies: Maybe<Scalars['String']>;
  /**
   * A description of the config, visible in CSC UI. Must be at least 100 characters, and should at minimum
   * communicate expected input values, their expected behavior, and the default value.
   * For TYPE_ENUM configs, should also document the meaning of each enum value.
   */
  description: Maybe<Scalars['String']>;
  /** What feature this is a part of, such as Streaks, GI, USF. If it's not a specific feature, leave blank */
  feature: Maybe<Scalars['String']>;
  /**
   * This will be empty if the data is being returned from the config_keys.json instead of the database.
   * Do not set during creation.
   */
  id: Maybe<Scalars['BigInt']>;
  /**
   * An optional field that defines the minimum required version of the Caper Core app for a configuration to be enabled.
   * Inclusion Criteria: If the app version is greater than or equal to min_app_version, the feature is included. If the app version is lower, the feature is excluded.
   * Example: min_app_version = "24.1.1-v04" If the app version is 24.2.0, the feature is included. If the app version is 24.1.1-v03, the feature is excluded.
   * Version Requirements: The min_app_version must be a string and follow valid semantic versioning (major, minor, patch, and pre-release tags). Build metadata is ignored when comparing versions.
   * Invalid Versions: If min_app_version is invalid or cannot be parsed correctly, tests will fail. However, in production, the logic will exclude the feature by default to prevent configuration errors.
   */
  minAppVersion: Maybe<Scalars['String']>;
  /**
   * This should be the name of the config in snake case. It should be as descriptive as possible.
   * There is a 10 char minimum, but no character limit.
   */
  name: Maybe<Scalars['String']>;
  /** DRI, either an individual or a team (eg, value, deployment, hsi) */
  owner: Maybe<Scalars['String']>;
  /** this controls how it can be set in the CSC UI, and the type of validation */
  type: Maybe<Instacart_Caper_Admin_V1_ConfigKey_Type>;
};

/** A config key and metadata about it */
export type Instacart_Caper_Admin_V1_ConfigKey_Input = {
  /**
   * For TYPE_ENUM configs, this defines the allowed enum values.
   * Each string in this array represents a valid enum value that can be set for this config.
   * This field is required when type = TYPE_ENUM and ignored for other types.
   * When validating config values, the value must exactly match one of these strings (case-sensitive).
   */
  allowedEnumValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * You can mark config fields that are no longer read by the cart as "archived".
   * In the future, this will prevent these options from showing up in the UI.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** A link to the relevant SOP, JIRA, or other doc. Must be a link. */
  contextLink?: InputMaybe<Scalars['String']>;
  /** free form text field to indicate Ii this config relies on Roulette Flags or other configs. If there are none, leave blank */
  dependencies?: InputMaybe<Scalars['String']>;
  /**
   * A description of the config, visible in CSC UI. Must be at least 100 characters, and should at minimum
   * communicate expected input values, their expected behavior, and the default value.
   * For TYPE_ENUM configs, should also document the meaning of each enum value.
   */
  description?: InputMaybe<Scalars['String']>;
  /** What feature this is a part of, such as Streaks, GI, USF. If it's not a specific feature, leave blank */
  feature?: InputMaybe<Scalars['String']>;
  /**
   * This will be empty if the data is being returned from the config_keys.json instead of the database.
   * Do not set during creation.
   */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * An optional field that defines the minimum required version of the Caper Core app for a configuration to be enabled.
   * Inclusion Criteria: If the app version is greater than or equal to min_app_version, the feature is included. If the app version is lower, the feature is excluded.
   * Example: min_app_version = "24.1.1-v04" If the app version is 24.2.0, the feature is included. If the app version is 24.1.1-v03, the feature is excluded.
   * Version Requirements: The min_app_version must be a string and follow valid semantic versioning (major, minor, patch, and pre-release tags). Build metadata is ignored when comparing versions.
   * Invalid Versions: If min_app_version is invalid or cannot be parsed correctly, tests will fail. However, in production, the logic will exclude the feature by default to prevent configuration errors.
   */
  minAppVersion?: InputMaybe<Scalars['String']>;
  /**
   * This should be the name of the config in snake case. It should be as descriptive as possible.
   * There is a 10 char minimum, but no character limit.
   */
  name?: InputMaybe<Scalars['String']>;
  /** DRI, either an individual or a team (eg, value, deployment, hsi) */
  owner?: InputMaybe<Scalars['String']>;
  /** this controls how it can be set in the CSC UI, and the type of validation */
  type?: InputMaybe<Instacart_Caper_Admin_V1_ConfigKey_Type>;
};

export enum Instacart_Caper_Admin_V1_ConfigKey_Type {
  /** A subset of url, this is for configs that should be animation urls */
  TypeAnimationUrl = 'TYPE_ANIMATION_URL',
  TypeBoolean = 'TYPE_BOOLEAN',
  /** Enum type with allowed values defined in allowed_enum_values field */
  TypeEnum = 'TYPE_ENUM',
  /** A subset of url, this is for configs that should be general file urls except image and animation */
  TypeFileUrl = 'TYPE_FILE_URL',
  /** A subset of url, this is for configs that should be image urls */
  TypeImageUrl = 'TYPE_IMAGE_URL',
  TypeInt = 'TYPE_INT',
  /** JSON type for configs that should be JSON objects or arrays */
  TypeJson = 'TYPE_JSON',
  TypeString = 'TYPE_STRING',
  /** should never be set to this */
  TypeUnknown = 'TYPE_UNKNOWN',
  /** not currently supported */
  TypeUrl = 'TYPE_URL'
}

/** Configs to remove or update/add for a specified entity */
export type Instacart_Caper_Admin_V1_ConfigUpdate_Input = {
  cartId?: InputMaybe<Scalars['BigInt']>;
  /**
   * To make a config use the default value hardcoded on the Android side
   * you must unset the config in the database by providing the key name in
   * the following field
   */
  configsKeysToUnset?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  configsToUpdate?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  global?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Name and value pair for a configuration */
export type Instacart_Caper_Admin_V1_ConfigValue = {
  __typename?: 'instacart_caper_admin_v1_ConfigValue';
  /** the time of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAt: Maybe<Scalars['DateTime']>;
  /** the author of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAtAuthor: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Name and value pair for a configuration */
export type Instacart_Caper_Admin_V1_ConfigValue_Input = {
  /** the time of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** the author of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Request message for creating a ban entry */
export type Instacart_Caper_Admin_V1_CreateBanEntryRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<Instacart_Caper_Admin_V1_BanEntry_Input>;
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for creating a ban entry */
export type Instacart_Caper_Admin_V1_CreateBanEntryResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateBanEntryResponse';
  /** The created ban entry ID */
  id: Maybe<Scalars['String']>;
};

/** Request for creating a new config key */
export type Instacart_Caper_Admin_V1_CreateConfigKeyRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  configKey?: InputMaybe<Instacart_Caper_Admin_V1_ConfigKey_Input>;
};

/** Request to initiate async generation of a session summary */
export type Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncRequest_Input = {
  sessionId?: InputMaybe<Scalars['String']>;
  /** Id of generated user journey report */
  summaryId?: InputMaybe<Scalars['String']>;
  /** Enable fetching cached results for the session summary generation */
  useCache?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Response for initiating asynchronous datadog triage report creation
 * Returns the initial status of the datadog triage report generation process
 */
export type Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateDatadogSummaryAsyncResponse';
  status: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for creating a new device */
export type Instacart_Caper_Admin_V1_CreateDeviceRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  device?: InputMaybe<Instacart_Caper_Admin_V1_Device_Input>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Request for creating new devices */
export type Instacart_Caper_Admin_V1_CreateDevicesRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Cart hardware model, e.g. "M3", "M3S". Used for auto-generating device names. */
  cartModel?: InputMaybe<Scalars['String']>;
  /** base names for the devices about to be created, this name will be appended with numbers */
  deviceNamePrefix?: InputMaybe<Scalars['String']>;
  /** The purpose of the devices about to be created */
  devicePurpose?: InputMaybe<Instacart_Caper_Admin_V1_Device_DevicePurpose>;
  /** number of devices that will be created */
  numDevices?: InputMaybe<Scalars['BigInt']>;
  /** The ID of the store that the devices will be created for */
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for creating new devices */
export type Instacart_Caper_Admin_V1_CreateDevicesResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateDevicesResponse';
  /** IDs of all newly created devices, for use in provisioning workflows */
  deviceIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Request for creating a new feature */
export type Instacart_Caper_Admin_V1_CreateFeatureRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  feature?: InputMaybe<Instacart_Caper_Admin_V1_Feature_Input>;
};

/**
 * A request to create a new payment merchant for a store.
 * The merchant_id (MID) must match the format provided in the VAR sheet.
 */
export type Instacart_Caper_Admin_V1_CreateMerchantRequest_Input = {
  /** Email of the CSC user making the request. Used for audit trail. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** "Doing Business As" name - the merchant's display name. */
  dbaName?: InputMaybe<Scalars['String']>;
  /** Merchant Identification Number (MID) from VAR sheet. */
  merchantId?: InputMaybe<Scalars['String']>;
  /**
   * The payment profile ID. Determines the Worldline parent organization
   * and processor configuration (e.g., Vantiv, FDC RapidConnect).
   */
  profileId?: InputMaybe<Scalars['BigInt']>;
  /** The Caper store ID. The store must exist in the entity database. */
  storeId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Terminals to create along with the merchant. */
  terminals?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_TerminalInput_Input>>>;
};

/** Response from CreateMerchant. Returned with gRPC status OK on success. */
export type Instacart_Caper_Admin_V1_CreateMerchantResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateMerchantResponse';
  /** The created merchant entity. */
  merchant: Maybe<Instacart_Caper_Admin_V1_PaymentMerchant>;
  /** Terminals created if terminals were provided in the request. */
  terminals: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PaymentTerminal>>>;
};

/** Request for creating a new partner */
export type Instacart_Caper_Admin_V1_CreatePartnerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Instacart_Caper_Admin_V1_Partner_Input>;
};

/** Request for creating a presigned asset url */
export type Instacart_Caper_Admin_V1_CreatePresignedAssetUrlRequest_Input = {
  configName?: InputMaybe<Scalars['String']>;
  /** png, riv supported */
  fileExtension?: InputMaybe<Scalars['String']>;
};

/** Response for creating a presigned asset url */
export type Instacart_Caper_Admin_V1_CreatePresignedAssetUrlResponse = {
  __typename?: 'instacart_caper_admin_v1_CreatePresignedAssetUrlResponse';
  readUrl: Maybe<Scalars['String']>;
  writeUrl: Maybe<Scalars['String']>;
};

/** Request for creating a new retailer */
export type Instacart_Caper_Admin_V1_CreateRetailerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailer?: InputMaybe<Instacart_Caper_Admin_V1_Retailer_Input>;
};

/** Request to initiate async generation of a session summary */
export type Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncRequest_Input = {
  sessionId?: InputMaybe<Scalars['String']>;
  /** Enable fetching cached results for the session summary generation */
  useCache?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Response for initiating asynchronous session summary creation
 * Returns the initial status of the summary generation process
 */
export type Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateSessionSummaryAsyncResponse';
  status: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for creating a new store */
export type Instacart_Caper_Admin_V1_CreateStoreRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Cart hardware model, e.g. "M3", "M3S". Used for auto-generating device names. */
  cartModel?: InputMaybe<Scalars['String']>;
  /** base names for the devices about to be created, this name will be appended with numbers */
  deviceNamePrefix?: InputMaybe<Scalars['String']>;
  /** number of devices that will be created for this store */
  numDevices?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  store?: InputMaybe<Instacart_Caper_Admin_V1_Store_Input>;
};

/** Response for creating a new store */
export type Instacart_Caper_Admin_V1_CreateStoreResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateStoreResponse';
  /** IDs of devices created with the store, for use in provisioning workflows */
  deviceIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * A request to create payment terminals for devices in a store.
 * The store must already have a merchant.
 */
export type Instacart_Caper_Admin_V1_CreateTerminalsRequest_Input = {
  /** Email of the CSC user making the request. Used for audit trail. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The Caper store ID. The store must have an existing merchant. */
  storeId?: InputMaybe<Scalars['BigInt']>;
  /** List of terminals to create. Each entry maps a device to a TID. */
  terminals?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_TerminalInput_Input>>>;
};

/**
 * Response from CreateTerminals. Uses partial-success semantics:
 * the RPC returns OK even if some terminals failed.
 */
export type Instacart_Caper_Admin_V1_CreateTerminalsResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateTerminalsResponse';
  /** Per-terminal errors for items that failed to create. */
  errors: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_TerminalCreationError>>>;
  /** Count of terminals that failed to create. */
  failureCount: Maybe<Scalars['Int']>;
  /** Count of successfully created terminals. */
  successCount: Maybe<Scalars['Int']>;
  /** Successfully created terminal entities. */
  terminals: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PaymentTerminal>>>;
};

/** Represents a default value for a config key associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureDefaultValue = {
  __typename?: 'instacart_caper_admin_v1_CscFeatureDefaultValue';
  /** The config key ID this default value is for (references the ConfigKey entity) */
  configKeyId: Maybe<Scalars['BigInt']>;
  /** The default value for the config key */
  defaultValue: Maybe<Scalars['String']>;
  /** Database ID of the default value. Does not need to be set for creation. */
  id: Maybe<Scalars['BigInt']>;
};

/** Represents a default value for a config key associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureDefaultValue_Input = {
  /** The config key ID this default value is for (references the ConfigKey entity) */
  configKeyId?: InputMaybe<Scalars['BigInt']>;
  /** The default value for the config key */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Database ID of the default value. Does not need to be set for creation. */
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Represents a roulette link associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureRouletteLink = {
  __typename?: 'instacart_caper_admin_v1_CscFeatureRouletteLink';
  /** Database ID of the roulette link. Does not need to be set for creation. */
  id: Maybe<Scalars['BigInt']>;
  /** The roulette link URL */
  link: Maybe<Scalars['String']>;
  /** Status of this roulette link */
  status: Maybe<Instacart_Caper_Admin_V1_RouletteLinkStatus>;
};

/** Represents a roulette link associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureRouletteLink_Input = {
  /** Database ID of the roulette link. Does not need to be set for creation. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The roulette link URL */
  link?: InputMaybe<Scalars['String']>;
  /** Status of this roulette link */
  status?: InputMaybe<Instacart_Caper_Admin_V1_RouletteLinkStatus>;
};

/** Date field type for date range filtering */
export enum Instacart_Caper_Admin_V1_DateField {
  /** Filter by NOF creation date */
  DateFieldCreationDate = 'DATE_FIELD_CREATION_DATE',
  /** Filter by last updated date */
  DateFieldLastUpdatedDate = 'DATE_FIELD_LAST_UPDATED_DATE',
  /** Filter by resolution date */
  DateFieldResolutionDate = 'DATE_FIELD_RESOLUTION_DATE',
  DateFieldUnknown = 'DATE_FIELD_UNKNOWN'
}

/** A Caper device, aka a cart. This is the lowest level of the hierarchy */
export type Instacart_Caper_Admin_V1_Device = {
  __typename?: 'instacart_caper_admin_v1_Device';
  configs: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** For record soft deletion if the field is set */
  deletedAt: Maybe<Scalars['DateTime']>;
  devicePurpose: Maybe<Instacart_Caper_Admin_V1_Device_DevicePurpose>;
  /** Features associated with this device */
  featureValues: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  /** Attributes of a store, separate from configs */
  id: Maybe<Scalars['BigInt']>;
  iotDeviceName: Maybe<Scalars['String']>;
  /** whether this config is synced to the latest version, this does not need to be set when creating, it's for display purposes */
  isSyncedToLatest: Maybe<Scalars['Boolean']>;
  /** the time the device was last synced with the device config */
  lastSyncedAt: Maybe<Scalars['DateTime']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor: Maybe<Scalars['String']>;
  legacyNgcpObjectId: Maybe<Scalars['String']>;
  mdmDeviceId: Maybe<Scalars['String']>;
  mdmDeviceName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  operationalState: Maybe<Instacart_Caper_Admin_V1_Device_OperationalState>;
  /** the effective time for the operational_state change, only set this if the operational_state has been changed */
  operationalStateEffectiveTime: Maybe<Scalars['DateTime']>;
  publicKey: Maybe<Scalars['String']>;
};

/** Device information for a cart */
export type Instacart_Caper_Admin_V1_DeviceInfo = {
  __typename?: 'instacart_caper_admin_v1_DeviceInfo';
  /** Device label (e.g., "Cart #3") */
  deviceLabel: Maybe<Scalars['String']>;
  /** Device purpose (e.g., "SHOPPING_CART") */
  devicePurpose: Maybe<Scalars['String']>;
  /** Store ID where the device is located */
  storeId: Maybe<Scalars['String']>;
};

/** The purpose of the device */
export enum Instacart_Caper_Admin_V1_Device_DevicePurpose {
  DevicePurposeDemo = 'DEVICE_PURPOSE_DEMO',
  /** Only standard devices are included in analytics */
  DevicePurposeStandard = 'DEVICE_PURPOSE_STANDARD',
  /** Testing devices cannot finalize orders */
  DevicePurposeTesting = 'DEVICE_PURPOSE_TESTING',
  DevicePurposeUat = 'DEVICE_PURPOSE_UAT',
  DevicePurposeUnknown = 'DEVICE_PURPOSE_UNKNOWN'
}

/** A Caper device, aka a cart. This is the lowest level of the hierarchy */
export type Instacart_Caper_Admin_V1_Device_Input = {
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  devicePurpose?: InputMaybe<Instacart_Caper_Admin_V1_Device_DevicePurpose>;
  /** Features associated with this device */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  /** Attributes of a store, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  iotDeviceName?: InputMaybe<Scalars['String']>;
  /** whether this config is synced to the latest version, this does not need to be set when creating, it's for display purposes */
  isSyncedToLatest?: InputMaybe<Scalars['Boolean']>;
  /** the time the device was last synced with the device config */
  lastSyncedAt?: InputMaybe<Scalars['DateTime']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  legacyNgcpObjectId?: InputMaybe<Scalars['String']>;
  mdmDeviceId?: InputMaybe<Scalars['String']>;
  mdmDeviceName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  operationalState?: InputMaybe<Instacart_Caper_Admin_V1_Device_OperationalState>;
  /** the effective time for the operational_state change, only set this if the operational_state has been changed */
  operationalStateEffectiveTime?: InputMaybe<Scalars['DateTime']>;
  publicKey?: InputMaybe<Scalars['String']>;
};

/** The operational state of the device */
export enum Instacart_Caper_Admin_V1_Device_OperationalState {
  /** Decommissioned means the device can no longer be used at any store, it is returned to warehouse */
  OperationalStateDecommisioned = 'OPERATIONAL_STATE_DECOMMISIONED',
  /** In circulation means the device is in the store and can be used */
  OperationalStateInCirculation = 'OPERATIONAL_STATE_IN_CIRCULATION',
  /** Undeployed means the device is put aside due to business reason */
  OperationalStateInStoreUndeployed = 'OPERATIONAL_STATE_IN_STORE_UNDEPLOYED',
  /** New means the device has just been created in the factory */
  OperationalStateNew = 'OPERATIONAL_STATE_NEW',
  /** Out of circulation means the device is in the field but possibly in an error state and not being used */
  OperationalStateOutOfCirculation = 'OPERATIONAL_STATE_OUT_OF_CIRCULATION',
  /** Unknown */
  OperationalStateUnknown = 'OPERATIONAL_STATE_UNKNOWN'
}

/** The type of entity */
export enum Instacart_Caper_Admin_V1_EntityType {
  EntityTypeDevice = 'ENTITY_TYPE_DEVICE',
  EntityTypePartner = 'ENTITY_TYPE_PARTNER',
  EntityTypeRetailer = 'ENTITY_TYPE_RETAILER',
  EntityTypeStore = 'ENTITY_TYPE_STORE',
  EntityTypeUnknown = 'ENTITY_TYPE_UNKNOWN'
}

/** Expected weight information with tolerance */
export type Instacart_Caper_Admin_V1_ExpectedWeightData = {
  __typename?: 'instacart_caper_admin_v1_ExpectedWeightData';
  /** Tolerance in grams */
  toleranceGrams: Maybe<Scalars['Float']>;
  /** Expected weight in grams */
  weightGrams: Maybe<Scalars['Float']>;
};

/** A CSC feature, which is a product feature with various metadata, including how to turn it on */
export type Instacart_Caper_Admin_V1_Feature = {
  __typename?: 'instacart_caper_admin_v1_Feature';
  /** Allowed user emails stored as JSON array in DB, modeled as repeated string in protobuf */
  allowedUserEmails: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * You can mark features that are no longer actively used as "archived".
   * In the future, this will prevent these features from showing up in the UI by default.
   */
  archived: Maybe<Scalars['Boolean']>;
  /**
   * The names of the config keys that are related to this feature
   * Note: a config key can be associated with more than one feature at a time.
   */
  configKeyName: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of default values for config keys associated with this feature */
  defaultValues: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_CscFeatureDefaultValue>>>;
  /** Freeform text about this feature, for display purposes */
  description: Maybe<Scalars['String']>;
  /** Primarily used for RPM/TPMs to contact correct feature owner for roulette or other dependencies outside csc configs. */
  dri: Maybe<Scalars['String']>;
  /** External-facing feature identifier used to map CSC to external sources */
  externalFeatureName: Maybe<Scalars['String']>;
  /** Status of the feature in its lifecycle */
  featureStatus: Maybe<Instacart_Caper_Admin_V1_FeatureStatus>;
  /** GA (General Availability) version. Official sign off version by QA for production deployment. */
  gaVersion: Maybe<Scalars['String']>;
  /** database ID of the feature, which is is unique per environment. Does not need to be set for creation. */
  id: Maybe<Scalars['BigInt']>;
  /** Locking a feature */
  isLocked: Maybe<Scalars['Boolean']>;
  /** The email of the person who last modified this feature. Does not need to be set for creation. */
  lastModifiedBy: Maybe<Scalars['String']>;
  /** Timestamp when last modified. Does not need to be set for creation. */
  lastUpdatedAt: Maybe<Scalars['DateTime']>;
  /** min app version same as used in config keys. Not actively used, for display purposes */
  minAppVersion: Maybe<Scalars['String']>;
  /** Name of the feature, unique per environment */
  name: Maybe<Scalars['String']>;
  /** Owner of the feature used for locking a feature, must be valid email. */
  ownerEmail: Maybe<Scalars['String']>;
  /** Contact person for roulette experiments. Valid user instacart emails. */
  rouletteExperimentContact: Maybe<Scalars['String']>;
  /** List of roulette links associated with this feature */
  rouletteLinks: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_CscFeatureRouletteLink>>>;
  /** This should be a link to an extended guide to the feature, usually called an SOP within Caper */
  sopLink: Maybe<Scalars['String']>;
  /** List of retailers whom are the primary target for a given Feature. */
  targetRetailers: Maybe<Scalars['String']>;
  /** Version introduced, for display purpose */
  versionIntroduced: Maybe<Scalars['String']>;
};

/** Feature action for scheduled changes */
export type Instacart_Caper_Admin_V1_FeatureAction = {
  __typename?: 'instacart_caper_admin_v1_FeatureAction';
  /** Maps to feature_action */
  actionType: Maybe<Instacart_Caper_Admin_V1_FeatureActionType>;
  /**
   * Maps to csc_feature_id
   * Optional: feature name for display/logging
   */
  cscFeatureId: Maybe<Scalars['BigInt']>;
  featureName: Maybe<Scalars['String']>;
};

/** Feature action type for scheduled feature changes */
export enum Instacart_Caper_Admin_V1_FeatureActionType {
  FeatureActionTypeSet = 'FEATURE_ACTION_TYPE_SET',
  FeatureActionTypeUnknown = 'FEATURE_ACTION_TYPE_UNKNOWN',
  FeatureActionTypeUnset = 'FEATURE_ACTION_TYPE_UNSET'
}

/** Feature action for scheduled changes */
export type Instacart_Caper_Admin_V1_FeatureAction_Input = {
  /** Maps to feature_action */
  actionType?: InputMaybe<Instacart_Caper_Admin_V1_FeatureActionType>;
  /**
   * Maps to csc_feature_id
   * Optional: feature name for display/logging
   */
  cscFeatureId?: InputMaybe<Scalars['BigInt']>;
  featureName?: InputMaybe<Scalars['String']>;
};

/** Status of a features */
export enum Instacart_Caper_Admin_V1_FeatureStatus {
  FeatureStatusDeprecated = 'FEATURE_STATUS_DEPRECATED',
  FeatureStatusFullyRolledOut = 'FEATURE_STATUS_FULLY_ROLLED_OUT',
  /** (General Availability): Marks the field as signed off by QA and fully released for production use. */
  FeatureStatusGaApproved = 'FEATURE_STATUS_GA_APPROVED',
  FeatureStatusOngoingExperiment = 'FEATURE_STATUS_ONGOING_EXPERIMENT',
  FeatureStatusUnknown = 'FEATURE_STATUS_UNKNOWN'
}

/** Association between an entity and a feature (many-to-many relationship) */
export type Instacart_Caper_Admin_V1_FeatureValue = {
  __typename?: 'instacart_caper_admin_v1_FeatureValue';
  /** The email of the person who created this association */
  authorEmail: Maybe<Scalars['String']>;
  /** Timestamp when this association was created */
  createdAt: Maybe<Scalars['DateTime']>;
  featureId: Maybe<Scalars['BigInt']>;
};

/** Association between an entity and a feature (many-to-many relationship) */
export type Instacart_Caper_Admin_V1_FeatureValue_Input = {
  /** The email of the person who created this association */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Timestamp when this association was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  featureId?: InputMaybe<Scalars['BigInt']>;
};

/** A CSC feature, which is a product feature with various metadata, including how to turn it on */
export type Instacart_Caper_Admin_V1_Feature_Input = {
  /** Allowed user emails stored as JSON array in DB, modeled as repeated string in protobuf */
  allowedUserEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * You can mark features that are no longer actively used as "archived".
   * In the future, this will prevent these features from showing up in the UI by default.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /**
   * The names of the config keys that are related to this feature
   * Note: a config key can be associated with more than one feature at a time.
   */
  configKeyName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of default values for config keys associated with this feature */
  defaultValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_CscFeatureDefaultValue_Input>>>;
  /** Freeform text about this feature, for display purposes */
  description?: InputMaybe<Scalars['String']>;
  /** Primarily used for RPM/TPMs to contact correct feature owner for roulette or other dependencies outside csc configs. */
  dri?: InputMaybe<Scalars['String']>;
  /** External-facing feature identifier used to map CSC to external sources */
  externalFeatureName?: InputMaybe<Scalars['String']>;
  /** Status of the feature in its lifecycle */
  featureStatus?: InputMaybe<Instacart_Caper_Admin_V1_FeatureStatus>;
  /** GA (General Availability) version. Official sign off version by QA for production deployment. */
  gaVersion?: InputMaybe<Scalars['String']>;
  /** database ID of the feature, which is is unique per environment. Does not need to be set for creation. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Locking a feature */
  isLocked?: InputMaybe<Scalars['Boolean']>;
  /** The email of the person who last modified this feature. Does not need to be set for creation. */
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  /** Timestamp when last modified. Does not need to be set for creation. */
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** min app version same as used in config keys. Not actively used, for display purposes */
  minAppVersion?: InputMaybe<Scalars['String']>;
  /** Name of the feature, unique per environment */
  name?: InputMaybe<Scalars['String']>;
  /** Owner of the feature used for locking a feature, must be valid email. */
  ownerEmail?: InputMaybe<Scalars['String']>;
  /** Contact person for roulette experiments. Valid user instacart emails. */
  rouletteExperimentContact?: InputMaybe<Scalars['String']>;
  /** List of roulette links associated with this feature */
  rouletteLinks?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_CscFeatureRouletteLink_Input>>>;
  /** This should be a link to an extended guide to the feature, usually called an SOP within Caper */
  sopLink?: InputMaybe<Scalars['String']>;
  /** List of retailers whom are the primary target for a given Feature. */
  targetRetailers?: InputMaybe<Scalars['String']>;
  /** Version introduced, for display purpose */
  versionIntroduced?: InputMaybe<Scalars['String']>;
};

/** Filter criteria for listing NOF items */
export type Instacart_Caper_Admin_V1_Filter_Input = {
  catalog?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_CatalogAvailability>>>;
  /** which timestamp field to filter on */
  dateField?: InputMaybe<Instacart_Caper_Admin_V1_DateField>;
  /** optional: end of date range (inclusive) */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** whether to apply external view filtering */
  isExternalView?: InputMaybe<Scalars['Boolean']>;
  /** default 5 */
  minOccurrences?: InputMaybe<Scalars['Int']>;
  /** OR within this list; empty means "no POS filter" */
  pos?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_PosAvailability>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** filter by review category, null or REVIEW_CATEGORY_UNKNOWN represents needs review */
  reviewCategory?: InputMaybe<Instacart_Caper_Admin_V1_ReviewCategory>;
  /** Date range filtering fields */
  startDate?: InputMaybe<Scalars['DateTime']>;
  storeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** default all */
  tab?: InputMaybe<Instacart_Caper_Admin_V1_Tab>;
  /** exact */
  upcQuery?: InputMaybe<Scalars['String']>;
};

/** All Caper entities, starting with partner, and global level configs */
export type Instacart_Caper_Admin_V1_GetAllEntitiesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetAllEntitiesResponse';
  /**
   * These are global configs that should apply to all devices that do not have
   * lower level overrides
   */
  configs: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** These are globally enabled features */
  featureValues: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  partners: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Partner>>>;
};

/** Response containing available payment profiles. */
export type Instacart_Caper_Admin_V1_GetAvailableProfilesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetAvailableProfilesResponse';
  /** List of available payment profiles. */
  profiles: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PaymentProfile>>>;
};

/** Request to fetch cart event data for a session */
export type Instacart_Caper_Admin_V1_GetCartDataRequest_Input = {
  /** Optional timestamp to filter events (returns events before this time) */
  latestTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** The Caper session ID to fetch cart events for */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Response containing structured cart event data */
export type Instacart_Caper_Admin_V1_GetCartDataResponse = {
  __typename?: 'instacart_caper_admin_v1_GetCartDataResponse';
  /** Structured cart event data with device info and events */
  cartData: Maybe<Instacart_Caper_Admin_V1_CartSessionData>;
};

/** The request for Config Keys */
export type Instacart_Caper_Admin_V1_GetConfigKeysRequest_Input = {
  /**
   * Originally used to migrate from the json config keys to the db one. This migration is now complete
   * and the db config keys are always returned and this value is not read.
   */
  pullFromDb?: InputMaybe<Scalars['Boolean']>;
};

/** The list of available config keys that the frontend should allow to be set */
export type Instacart_Caper_Admin_V1_GetConfigKeysResponse = {
  __typename?: 'instacart_caper_admin_v1_GetConfigKeysResponse';
  configKeys: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigKey>>>;
};

/** Request to retrieve an existing datadog summary by its ID */
export type Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncRequest_Input = {
  /**
   * The summary ID returned from CreateDatadogSummaryAsync
   * (found in CreateDatadogSummaryAsyncResponse.status.id)
   */
  summaryId?: InputMaybe<Scalars['String']>;
};

/**
 * Response for retrieving an existing datadog summary by its ID
 * Returns the current status and content of a previously created datadog summary
 */
export type Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_GetDatadogSummaryByIdAsyncResponse';
  status: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for retrieving entity information with hierarchical relationships */
export type Instacart_Caper_Admin_V1_GetEntitiesRequest_Input = {
  /** Query by retailer Instacart warehouse IDs to retrieve full partner/retailer/store hierarchy */
  instacartWarehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Query by store Instacart warehouse location IDs to retrieve full partner/retailer/store hierarchy */
  instacartWarehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Response containing entity information with hierarchical relationships */
export type Instacart_Caper_Admin_V1_GetEntitiesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetEntitiesResponse';
  partners: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PartnerInfo>>>;
};

/** Response for getting features */
export type Instacart_Caper_Admin_V1_GetFeaturesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetFeaturesResponse';
  features: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Feature>>>;
};

/** Request message for retrieving a specific NOF item */
export type Instacart_Caper_Admin_V1_GetNofRequest_Input = {
  isExternalView?: InputMaybe<Scalars['Boolean']>;
  nofId?: InputMaybe<Scalars['String']>;
};

/** Response message containing the requested NOF item */
export type Instacart_Caper_Admin_V1_GetNofResponse = {
  __typename?: 'instacart_caper_admin_v1_GetNofResponse';
  item: Maybe<Instacart_Caper_Admin_V1_NofItem>;
};

/** Request to fetch a single pipeline run by task_id. */
export type Instacart_Caper_Admin_V1_GetPipelineRunRequest_Input = {
  /** UUID task_id of the pipeline run to fetch. */
  taskId?: InputMaybe<Scalars['String']>;
};

/** Response from GetPipelineRun. */
export type Instacart_Caper_Admin_V1_GetPipelineRunResponse = {
  __typename?: 'instacart_caper_admin_v1_GetPipelineRunResponse';
  /** The pipeline run with the full derived stages list populated. */
  run: Maybe<Instacart_Caper_Admin_V1_PipelineRun>;
};

/** The request message to get receipts metadata */
export type Instacart_Caper_Admin_V1_GetReceiptsMetadataRequest_Input = {
  /** last 4 digits of the ebt card number */
  ebtCardLast_4Digits?: InputMaybe<Scalars['String']>;
  /** the unique identifier for each ebt transaction that is also used as the ebt refund id, at least one of either this field or the ebt_card_last_4_digits field is required to retrieve ebt receipt metadata */
  ebtId?: InputMaybe<Scalars['String']>;
  /** the instacart warehouse location id of the store where receipt metadata is being requested, authorization is handled by the IPP graphql tier which is trusted infrastructure that will then make this rpc request */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** The response message for getting receipt metadata */
export type Instacart_Caper_Admin_V1_GetReceiptsMetadataResponse = {
  __typename?: 'instacart_caper_admin_v1_GetReceiptsMetadataResponse';
  orderSummaries: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_OrderSummary>>>;
};

/** Describes the Caper session to fetch details for */
export type Instacart_Caper_Admin_V1_GetSessionInfoRequest_Input = {
  /** The Caper session ID, typically a UUID generated by the cart */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Contains the Caper session details, including events */
export type Instacart_Caper_Admin_V1_GetSessionInfoResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionInfoResponse';
  /**
   * For MVP/fast prototyping: semi-structured details about the session
   * As the shape of this solidifies, this will be replaced by a more
   * structured contract
   */
  sessionInfo: Maybe<Scalars['JSON']>;
};

/** Request to fetch session screenshots */
export type Instacart_Caper_Admin_V1_GetSessionScreenshotsRequest_Input = {
  /** The Caper session ID to fetch screenshots for */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Response containing session screenshot information */
export type Instacart_Caper_Admin_V1_GetSessionScreenshotsResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionScreenshotsResponse';
  /** List of screenshot information with signed URLs */
  screenshots: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScreenshotInfo>>>;
  /** Whether screenshots are available for this session */
  screenshotsAvailable: Maybe<Scalars['Boolean']>;
  /** Reason why screenshots are unavailable (if screenshots_available is false) */
  unavailableReason: Maybe<Scalars['String']>;
};

/** Request to retrieve an existing session summary by its ID */
export type Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncRequest_Input = {
  summaryId?: InputMaybe<Scalars['String']>;
};

/**
 * Response for retrieving an existing session summary by its ID
 * Returns the current status and content of a previously created summary
 */
export type Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionSummaryByIdAsyncResponse';
  status: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Describes the Caper session to create a summary for */
export type Instacart_Caper_Admin_V1_GetSessionSummaryRequest_Input = {
  /** The Caper session ID, typically a UUID generated by the cart */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Contains the Caper session details, including events */
export type Instacart_Caper_Admin_V1_GetSessionSummaryResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionSummaryResponse';
  /** A Markdown-formatted summary of the session */
  markdownSummary: Maybe<Scalars['String']>;
};

/** Request message for listing ban entries */
export type Instacart_Caper_Admin_V1_ListBanEntriesRequest_Input = {
  /** Optional filter criteria */
  filter?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryFilter_Input>;
  /** Pagination: maximum number of entries to return (default: 100) */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Pagination: token for fetching next page */
  pageToken?: InputMaybe<Scalars['String']>;
};

/** Response message for listing ban entries */
export type Instacart_Caper_Admin_V1_ListBanEntriesResponse = {
  __typename?: 'instacart_caper_admin_v1_ListBanEntriesResponse';
  /** List of ban entries with their scopes */
  entries: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryWithScopes>>>;
  /** Token for fetching next page (empty if no more results) */
  nextPageToken: Maybe<Scalars['String']>;
  /** Total count of entries matching the filter */
  totalCount: Maybe<Scalars['Int']>;
};

/** Request to list batch scheduled actions with filtering */
export type Instacart_Caper_Admin_V1_ListBatchScheduledActionsRequest_Input = {
  actionTypes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionType>>>;
  /** Author filter */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Entity filter - can filter by any entity involved in batch actions */
  entityFilter?: InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionTarget_Input>;
  /** Time range filter */
  scheduledAfter?: InputMaybe<Scalars['DateTime']>;
  scheduledBefore?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>>>;
};

/** Response containing list of batch scheduled actions */
export type Instacart_Caper_Admin_V1_ListBatchScheduledActionsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListBatchScheduledActionsResponse';
  actions: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BatchScheduledAction>>>;
};

/** Request message for listing NOF items with filtering and pagination */
export type Instacart_Caper_Admin_V1_ListNofsRequest_Input = {
  filter?: InputMaybe<Instacart_Caper_Admin_V1_Filter_Input>;
  /**
   * Sorting order for NOF items. Options:
   * - FREQUENCY_DESC, FREQUENCY_ASC
   * - RECENCY_DESC, RECENCY_ASC
   * - LATEST_REVIEW_DATE_DESC, LATEST_REVIEW_DATE_ASC
   */
  orderBy?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};

/** Response message containing paginated NOF items */
export type Instacart_Caper_Admin_V1_ListNofsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListNofsResponse';
  items: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_NofItem>>>;
  nextPageToken: Maybe<Scalars['String']>;
  /** total across current filter scope */
  totalCount: Maybe<Scalars['BigInt']>;
};

/**
 * Request to list pipeline runs with optional filters and cursor-based pagination.
 * Omitting a filter field disables that filter (returns all values).
 */
export type Instacart_Caper_Admin_V1_ListPipelineRunsRequest_Input = {
  /**
   * Filter by device name (exact match against old_device_name or new_device_name).
   * Empty string disables this filter.
   */
  deviceName?: InputMaybe<Scalars['String']>;
  /** Maximum number of runs to return. Defaults to 20; maximum 100. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /**
   * Opaque pagination cursor from a previous ListPipelineRunsResponse.
   * Empty string or omitted fetches the first page.
   */
  pageToken?: InputMaybe<Scalars['String']>;
  /** Filter by pipeline type. Set to PIPELINE_TYPE_UNKNOWN to return all types. */
  pipelineType?: InputMaybe<Instacart_Caper_Admin_V1_PipelineType>;
  /** Filter by run status. Set to PIPELINE_RUN_STATUS_UNKNOWN to return all statuses. */
  status?: InputMaybe<Instacart_Caper_Admin_V1_PipelineRunStatus>;
};

/** Response from ListPipelineRuns. */
export type Instacart_Caper_Admin_V1_ListPipelineRunsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListPipelineRunsResponse';
  /** Opaque cursor for the next page. Empty when there are no more results. */
  nextPageToken: Maybe<Scalars['String']>;
  /**
   * Matching pipeline runs sorted by created_at descending.
   * stages is empty on each run; use GetPipelineRun to retrieve stages.
   */
  runs: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PipelineRun>>>;
};

/** Request to list scheduled actions with filtering */
export type Instacart_Caper_Admin_V1_ListScheduledActionsRequest_Input = {
  actionTypes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionType>>>;
  /** Author filter */
  createdBy?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['BigInt']>;
  globalOnly?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Time range filter */
  scheduledAfter?: InputMaybe<Scalars['DateTime']>;
  scheduledBefore?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>>>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing list of scheduled actions */
export type Instacart_Caper_Admin_V1_ListScheduledActionsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListScheduledActionsResponse';
  actions: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScheduledAction>>>;
};

/** Action to perform when locking/unlocking carts */
export enum Instacart_Caper_Admin_V1_LockAction {
  LockActionLock = 'LOCK_ACTION_LOCK',
  LockActionUnknown = 'LOCK_ACTION_UNKNOWN',
  LockActionUnlock = 'LOCK_ACTION_UNLOCK'
}

/** Request for locking/unlocking devices */
export type Instacart_Caper_Admin_V1_LockCartsRequest_Input = {
  /** The main action to perform */
  action?: InputMaybe<Instacart_Caper_Admin_V1_LockAction>;
  /** Single device */
  deviceId?: InputMaybe<Scalars['BigInt']>;
  /** All devices under a partner */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Freeform description of the lock reason, e.g. incident link or additional context */
  reasonDescription?: InputMaybe<Scalars['String']>;
  /**
   * Classifiable reason type to customer and store staff.
   * Required for LOCK actions; defaults to OTHER if omitted.
   */
  reasonType?: InputMaybe<Instacart_Caper_Admin_V1_CartLockReasonType>;
  /** The email of the person performing the action */
  requesterEmail?: InputMaybe<Scalars['String']>;
  /** All devices under a retailer */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** All devices in a store */
  storeId?: InputMaybe<Scalars['BigInt']>;
  /** Store-level by Instacart WHLID UPOS request */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** Error details returned when an operation fails due to a locked feature */
export type Instacart_Caper_Admin_V1_LockedFeatureError = {
  __typename?: 'instacart_caper_admin_v1_LockedFeatureError';
  /** Database ID of the locked feature */
  featureId: Maybe<Scalars['BigInt']>;
  /** The name of the locked feature */
  featureName: Maybe<Scalars['String']>;
  /** Error message, e.g., "Feature is locked. Contact owner@email.com for access." */
  message: Maybe<Scalars['String']>;
};

/** A NOF (Not on File) item with all details */
export type Instacart_Caper_Admin_V1_NofItem = {
  __typename?: 'instacart_caper_admin_v1_NofItem';
  /**
   * For MVP/fast prototyping: semi-structured details about NOF Item
   * As the shape of this solidifies, this will be replaced by a more
   * structured contract
   */
  info: Maybe<Scalars['JSON']>;
};

/** The identifying information for a receipt */
export type Instacart_Caper_Admin_V1_OrderSummary = {
  __typename?: 'instacart_caper_admin_v1_OrderSummary';
  /** last 4 digits of the ebt card number */
  ebtCardLast_4Digits: Maybe<Scalars['String']>;
  /** the unique identifier for each ebt transaction that is also used as the ebt refund id */
  ebtId: Maybe<Scalars['String']>;
  /** the payment amount */
  paymentAmount: Maybe<GoogleTypeMoney>;
  /** the time when the order was finalized */
  paymentTimestamp: Maybe<Scalars['DateTime']>;
};

/**
 * A Caper partner, the highest level of the Caper hierarchy.
 * Example is Wakefern, Kroger, Schnucks
 */
export type Instacart_Caper_Admin_V1_Partner = {
  __typename?: 'instacart_caper_admin_v1_Partner';
  configs: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** For record soft deletion if the field is set */
  deletedAt: Maybe<Scalars['DateTime']>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts. Set by support team during store setup.
   */
  esperBlueprintId: Maybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId: Maybe<Scalars['String']>;
  /** Features associated with this partner */
  featureValues: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  /** Attributes of a partner, separate from configs */
  id: Maybe<Scalars['BigInt']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  retailers: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Retailer>>>;
};

/**
 * Partner information with nested retailers and stores
 * Maintains the full hierarchy: Partner -> Retailers -> Stores
 */
export type Instacart_Caper_Admin_V1_PartnerInfo = {
  __typename?: 'instacart_caper_admin_v1_PartnerInfo';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  retailers: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_RetailerInfo>>>;
};

/**
 * A Caper partner, the highest level of the Caper hierarchy.
 * Example is Wakefern, Kroger, Schnucks
 */
export type Instacart_Caper_Admin_V1_Partner_Input = {
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts. Set by support team during store setup.
   */
  esperBlueprintId?: InputMaybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId?: InputMaybe<Scalars['String']>;
  /** Features associated with this partner */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  /** Attributes of a partner, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailers?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_Retailer_Input>>>;
};

/**
 * Store-level payment merchant entity.
 * One merchant per store, representing the store's payment processing identity.
 */
export type Instacart_Caper_Admin_V1_PaymentMerchant = {
  __typename?: 'instacart_caper_admin_v1_PaymentMerchant';
  /** Email of the CSC user who created/modified this merchant. */
  author: Maybe<Scalars['String']>;
  /** Timestamp when the merchant was created. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** "Doing Business As" name. */
  dbaName: Maybe<Scalars['String']>;
  /** Merchant database ID. */
  id: Maybe<Scalars['BigInt']>;
  /** Merchant Identification Number (MID). */
  merchantId: Maybe<Scalars['String']>;
  /** Worldline's internal organization ID for this merchant. */
  organizationId: Maybe<Scalars['BigInt']>;
  /** The profile ID used when creating this merchant. */
  profileId: Maybe<Scalars['BigInt']>;
  /** Current lifecycle status of the merchant. */
  status: Maybe<Instacart_Caper_Admin_V1_PaymentMerchantStatus>;
  /** The Caper store ID this merchant belongs to. */
  storeId: Maybe<Scalars['BigInt']>;
  /** Timestamp when the merchant was last updated. */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/**
 * Lifecycle status of a payment merchant.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_PaymentMerchantStatus {
  /** Merchant is operational and can process payments. */
  PaymentMerchantStatusActive = 'PAYMENT_MERCHANT_STATUS_ACTIVE',
  /** Merchant has been deactivated. */
  PaymentMerchantStatusInactive = 'PAYMENT_MERCHANT_STATUS_INACTIVE',
  /** Merchant is temporarily suspended. */
  PaymentMerchantStatusSuspended = 'PAYMENT_MERCHANT_STATUS_SUSPENDED',
  /** buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX */
  PaymentMerchantStatusUnspecified = 'PAYMENT_MERCHANT_STATUS_UNSPECIFIED'
}

/**
 * Payment processor type for a terminal.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_PaymentProcessorType {
  /**
   * First Data Corporation RapidConnect processor.
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  FdcRapidConnect = 'FDC_RAPID_CONNECT',
  /** buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX */
  PaymentProcessorTypeUnspecified = 'PAYMENT_PROCESSOR_TYPE_UNSPECIFIED',
  /**
   * Vantiv processor.
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Vantiv = 'VANTIV'
}

/**
 * Worldline profile configuration template.
 * Profiles are pre-configured with processor-specific settings
 * and serve as parent templates when onboarding new merchants.
 */
export type Instacart_Caper_Admin_V1_PaymentProfile = {
  __typename?: 'instacart_caper_admin_v1_PaymentProfile';
  /** Bank identifier. Required by some processors. */
  bankId: Maybe<Scalars['String']>;
  /** Transaction capture type configuration. */
  captureType: Maybe<Scalars['String']>;
  /** Timestamp when the profile was created. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Optional description of this profile's purpose. */
  description: Maybe<Scalars['String']>;
  /** Group identifier. Required for FDC RapidConnect processor. */
  groupId: Maybe<Scalars['String']>;
  /** Profile database ID. */
  id: Maybe<Scalars['BigInt']>;
  /** Industry type classification. */
  industryType: Maybe<Scalars['String']>;
  /** Whether this profile is available for use. */
  isActive: Maybe<Scalars['Boolean']>;
  /** Merchant Category Code - industry classification. */
  mccCode: Maybe<Scalars['String']>;
  /** Payment processor name, e.g., "Fiserv", "Vantiv". */
  processor: Maybe<Scalars['String']>;
  /** Human-readable name for this profile. */
  profileName: Maybe<Scalars['String']>;
  /** Support contact email. */
  supportEmail: Maybe<Scalars['String']>;
  /** Support contact first name. */
  supportFirstName: Maybe<Scalars['String']>;
  /** Support contact last name. */
  supportLastName: Maybe<Scalars['String']>;
  /** Timestamp when the profile was last updated. */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Display name of the organization in Worldline's system. */
  worldlineOrgName: Maybe<Scalars['String']>;
  /** Worldline's internal organization ID. */
  worldlineOrganizationId: Maybe<Scalars['BigInt']>;
};

/**
 * Device-level payment terminal entity.
 * One terminal per device, representing a physical payment device.
 */
export type Instacart_Caper_Admin_V1_PaymentTerminal = {
  __typename?: 'instacart_caper_admin_v1_PaymentTerminal';
  /** Email of the CSC user who created/modified this terminal. */
  author: Maybe<Scalars['String']>;
  /** Timestamp when the terminal was created. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The Caper device ID this terminal is assigned to. */
  deviceId: Maybe<Scalars['BigInt']>;
  /** Terminal database ID. */
  id: Maybe<Scalars['BigInt']>;
  /** The merchant ID this terminal belongs to. */
  merchantId: Maybe<Scalars['BigInt']>;
  /** The payment processor type for this terminal. */
  processorType: Maybe<Instacart_Caper_Admin_V1_PaymentProcessorType>;
  /** Current lifecycle status of the terminal. */
  status: Maybe<Instacart_Caper_Admin_V1_PaymentTerminalStatus>;
  /** Terminal Identification Number (TID). */
  terminalId: Maybe<Scalars['String']>;
  /** Timestamp when the terminal was last updated. */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/**
 * Lifecycle status of a payment terminal.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_PaymentTerminalStatus {
  /** Terminal is operational and can process payments. */
  PaymentTerminalStatusActive = 'PAYMENT_TERMINAL_STATUS_ACTIVE',
  /** Terminal has been deactivated. */
  PaymentTerminalStatusInactive = 'PAYMENT_TERMINAL_STATUS_INACTIVE',
  /** Terminal credentials have been transferred to a different device. */
  PaymentTerminalStatusTransferred = 'PAYMENT_TERMINAL_STATUS_TRANSFERRED',
  /** buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX */
  PaymentTerminalStatusUnspecified = 'PAYMENT_TERMINAL_STATUS_UNSPECIFIED'
}

/**
 * Audit trail for payment terminal credential transfers.
 * Immutable - records are only inserted, never updated or deleted.
 */
export type Instacart_Caper_Admin_V1_PaymentTerminalTransfer = {
  __typename?: 'instacart_caper_admin_v1_PaymentTerminalTransfer';
  /** The source device ID (the old/replaced cart). */
  fromDeviceId: Maybe<Scalars['BigInt']>;
  /** Transfer record database ID. */
  id: Maybe<Scalars['BigInt']>;
  /** Human-readable reason for the transfer. */
  reason: Maybe<Scalars['String']>;
  /** The terminal ID that was transferred. */
  terminalId: Maybe<Scalars['BigInt']>;
  /** The target device ID (the new/replacement cart). */
  toDeviceId: Maybe<Scalars['BigInt']>;
  /** Timestamp when the transfer was executed. */
  transferredAt: Maybe<Scalars['DateTime']>;
  /** Email of the CSC user who initiated the transfer. */
  transferredBy: Maybe<Scalars['String']>;
};

/** Target environment for a pipeline run. */
export enum Instacart_Caper_Admin_V1_PipelineEnvironment {
  PipelineEnvironmentProd = 'PIPELINE_ENVIRONMENT_PROD',
  PipelineEnvironmentStage = 'PIPELINE_ENVIRONMENT_STAGE',
  PipelineEnvironmentUnknown = 'PIPELINE_ENVIRONMENT_UNKNOWN'
}

/**
 * A warehouse pipeline run record.
 *
 * Stage sequences (hardcoded in DeviceProvisioningPipelineService):
 * Cart Replacement (11 stages):
 * device_liveness_check → setup_esper → setup_zerotier →
 * start_horae_agent → link_iot_devices → register_bottom_tray →
 * deregister_front_unit → pre_ota_check → deploy_ota →
 * post_ota_check → cleanup_old_device
 * TU Swap (9 stages):
 * device_liveness_check → setup_esper → setup_zerotier →
 * start_horae → register_iot → link_csc →
 * pre_ota_check → post_ota_check → cleanup_old_device
 */
export type Instacart_Caper_Admin_V1_PipelineRun = {
  __typename?: 'instacart_caper_admin_v1_PipelineRun';
  /** Physical charger location in the warehouse (e.g. "Charger 1", "Misc"). Empty if not set. */
  charger: Maybe<Scalars['String']>;
  /**
   * Timestamp when the run reached a terminal status (SUCCESS or FAILED).
   * Not set while the run is still active.
   */
  completedAt: Maybe<Scalars['DateTime']>;
  /** Timestamp when the run record was created. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Snake-case name of the currently executing stage (e.g. "setup_esper"). */
  currentStage: Maybe<Scalars['String']>;
  /** Target environment for this run. */
  env: Maybe<Instacart_Caper_Admin_V1_PipelineEnvironment>;
  /** Error message set when status is PIPELINE_RUN_STATUS_FAILED. */
  errorMessage: Maybe<Scalars['String']>;
  /**
   * CSC name of the newly provisioned device.
   * Populated for Cart Replacement only; empty for TU Swap (cart identity unchanged).
   */
  newDeviceName: Maybe<Scalars['String']>;
  /** Free-form note entered by the triggering user at trigger time. Empty if not set. */
  note: Maybe<Scalars['String']>;
  /** CSC name of the device being replaced/worked on. Populated for both pipeline types. */
  oldDeviceName: Maybe<Scalars['String']>;
  /** Type of provisioning pipeline. */
  pipelineType: Maybe<Instacart_Caper_Admin_V1_PipelineType>;
  /** 1-based index of the currently executing stage. */
  stageIndex: Maybe<Scalars['Int']>;
  /**
   * Derived ordered stage list for this pipeline type with per-stage statuses.
   * Populated by GetPipelineRun. Empty in TriggerPipeline and ListPipelineRuns
   * responses to keep list payloads compact.
   */
  stages: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PipelineStage>>>;
  /** Overall run status. */
  status: Maybe<Instacart_Caper_Admin_V1_PipelineRunStatus>;
  /**
   * Store identifier (e.g. "prod-wakefern-25").
   * Populated for Cart Replacement only; empty for TU Swap.
   */
  storeId: Maybe<Scalars['String']>;
  /**
   * UUID primary key generated at trigger time.
   * Used as the sole correlation identifier across all status updates for this run.
   */
  taskId: Maybe<Scalars['String']>;
  /**
   * Total number of stages for this pipeline type.
   * 11 for Cart Replacement; 9 for TU Swap.
   */
  totalStages: Maybe<Scalars['Int']>;
  /** Email of the IPP user who triggered the run. */
  triggeredBy: Maybe<Scalars['String']>;
  /** Timestamp when the run record was last updated. */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Lifecycle status of a pipeline run or individual stage. */
export enum Instacart_Caper_Admin_V1_PipelineRunStatus {
  /** Pipeline failed at one or more stages. */
  PipelineRunStatusFailed = 'PIPELINE_RUN_STATUS_FAILED',
  /** At least one stage has started. */
  PipelineRunStatusInProgress = 'PIPELINE_RUN_STATUS_IN_PROGRESS',
  /** Run created; Jenkins trigger in flight. */
  PipelineRunStatusPending = 'PIPELINE_RUN_STATUS_PENDING',
  /** All stages completed successfully. */
  PipelineRunStatusSuccess = 'PIPELINE_RUN_STATUS_SUCCESS',
  PipelineRunStatusUnknown = 'PIPELINE_RUN_STATUS_UNKNOWN'
}

/**
 * A single stage within a pipeline run.
 *
 * The stages list on PipelineRun is derived server-side from stage_index,
 * the hardcoded ordered stage list for the pipeline type, and stage_history
 * — it is not stored directly. Derivation rule:
 * - index < stage_index  → PIPELINE_RUN_STATUS_SUCCESS
 * - index == stage_index → current run status
 * - index > stage_index  → PIPELINE_RUN_STATUS_UNKNOWN (not yet started)
 * started_at and completed_at are populated from the stage history.
 */
export type Instacart_Caper_Admin_V1_PipelineStage = {
  __typename?: 'instacart_caper_admin_v1_PipelineStage';
  /** Timestamp when this stage reached SUCCESS or FAILED. Not set if not yet complete. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** 1-based position of this stage in the full ordered stage list. */
  index: Maybe<Scalars['Int']>;
  /** Human-readable label for display (e.g. "Setup Esper"). */
  label: Maybe<Scalars['String']>;
  /** Snake-case name as published by Jenkins (e.g. "setup_esper"). */
  name: Maybe<Scalars['String']>;
  /** Timestamp when this stage entered IN_PROGRESS. Not set if not yet started. */
  startedAt: Maybe<Scalars['DateTime']>;
  /** Status of this stage. */
  status: Maybe<Instacart_Caper_Admin_V1_PipelineRunStatus>;
};

/** Type of warehouse provisioning pipeline. */
export enum Instacart_Caper_Admin_V1_PipelineType {
  /** Full cart replacement: same stages as E2E provision plus cleanup_old_device. */
  PipelineTypeCartReplacement = 'PIPELINE_TYPE_CART_REPLACEMENT',
  /** Top Unit swap: replaces the Top Unit of a single existing cart. */
  PipelineTypeTuSwap = 'PIPELINE_TYPE_TU_SWAP',
  PipelineTypeUnknown = 'PIPELINE_TYPE_UNKNOWN'
}

export enum Instacart_Caper_Admin_V1_PosAvailability {
  PosAvailabilityExtInRetailerPos = 'POS_AVAILABILITY_EXT_IN_RETAILER_POS',
  PosAvailabilityExtNotInRetailerPos = 'POS_AVAILABILITY_EXT_NOT_IN_RETAILER_POS',
  PosAvailabilityInRetailerPos = 'POS_AVAILABILITY_IN_RETAILER_POS',
  PosAvailabilityNotInRetailerPos = 'POS_AVAILABILITY_NOT_IN_RETAILER_POS',
  PosAvailabilityUnknown = 'POS_AVAILABILITY_UNKNOWN'
}

/** Price information for basket items */
export type Instacart_Caper_Admin_V1_PriceData = {
  __typename?: 'instacart_caper_admin_v1_PriceData';
  /** Currency code (e.g., "USD") */
  currencyCode: Maybe<Scalars['String']>;
  /** Price amount in currency units */
  units: Maybe<Scalars['String']>;
};

/** Request message for removing scopes from a ban entry */
export type Instacart_Caper_Admin_V1_RemoveBanEntryScopesRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  /** The ban entry ID to remove scopes from */
  banEntryId?: InputMaybe<Scalars['String']>;
  /**
   * Scopes to remove from this ban entry
   * Only removes the specified scopes - other scopes remain unchanged
   */
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for removing scopes from a ban entry */
export type Instacart_Caper_Admin_V1_RemoveBanEntryScopesResponse = {
  __typename?: 'instacart_caper_admin_v1_RemoveBanEntryScopesResponse';
  /** The updated list of all remaining scopes for this ban entry after removal */
  scopes: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/** A Caper retailer, such as Shoprite, Kroger, QFC. Same thing as a Banner */
export type Instacart_Caper_Admin_V1_Retailer = {
  __typename?: 'instacart_caper_admin_v1_Retailer';
  configs: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** For record soft deletion if the field is set */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Features associated with this retailer */
  featureValues: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  /** Attributes of a retailer, separate from configs */
  id: Maybe<Scalars['BigInt']>;
  instacartStoreConfigurationId: Maybe<Scalars['String']>;
  instacartWarehouseId: Maybe<Scalars['String']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  programmaticName: Maybe<Scalars['String']>;
  stores: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Store>>>;
};

/** Retailer information with nested stores */
export type Instacart_Caper_Admin_V1_RetailerInfo = {
  __typename?: 'instacart_caper_admin_v1_RetailerInfo';
  id: Maybe<Scalars['String']>;
  instacartWarehouseId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  stores: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_StoreInfo>>>;
};

/** A Caper retailer, such as Shoprite, Kroger, QFC. Same thing as a Banner */
export type Instacart_Caper_Admin_V1_Retailer_Input = {
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  /** Features associated with this retailer */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  /** Attributes of a retailer, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  instacartStoreConfigurationId?: InputMaybe<Scalars['String']>;
  instacartWarehouseId?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  programmaticName?: InputMaybe<Scalars['String']>;
  stores?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_Store_Input>>>;
};

/** Category for reviewing and resolving NOF items */
export enum Instacart_Caper_Admin_V1_ReviewCategory {
  /** Represents External Escalation: REVIEW_CATEGORY_ESCALATION_EXTERNAL */
  ReviewCategoryExternal = 'REVIEW_CATEGORY_EXTERNAL',
  ReviewCategoryExtNeedsAttentionFromInstacart = 'REVIEW_CATEGORY_EXT_NEEDS_ATTENTION_FROM_INSTACART',
  ReviewCategoryExtNeedsMoreData = 'REVIEW_CATEGORY_EXT_NEEDS_MORE_DATA',
  ReviewCategoryExtResolved = 'REVIEW_CATEGORY_EXT_RESOLVED',
  ReviewCategoryFalsePositive = 'REVIEW_CATEGORY_FALSE_POSITIVE',
  ReviewCategoryFixed = 'REVIEW_CATEGORY_FIXED',
  /** Represents Internal Escalation: REVIEW_CATEGORY_ESCALATION_INTERNAL */
  ReviewCategoryInternal = 'REVIEW_CATEGORY_INTERNAL',
  ReviewCategoryNeedsMoreData = 'REVIEW_CATEGORY_NEEDS_MORE_DATA',
  ReviewCategoryResolved = 'REVIEW_CATEGORY_RESOLVED',
  ReviewCategoryUnknown = 'REVIEW_CATEGORY_UNKNOWN'
}

/** Request message for reviewing a NOF item */
export type Instacart_Caper_Admin_V1_ReviewNofRequest_Input = {
  author?: InputMaybe<Scalars['String']>;
  nofId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  reviewCategory?: InputMaybe<Instacart_Caper_Admin_V1_ReviewCategory>;
  reviewSubCategory?: InputMaybe<Scalars['String']>;
};

/** Status of a roulette link */
export enum Instacart_Caper_Admin_V1_RouletteLinkStatus {
  /** The roulette link is completely deployed either enabled by min app verison or list of affected partners */
  RouletteLinkStatusFullyRolledOut = 'ROULETTE_LINK_STATUS_FULLY_ROLLED_OUT',
  /** The roulette link is active but may still be in an experimental phase. */
  RouletteLinkStatusInUse = 'ROULETTE_LINK_STATUS_IN_USE',
  RouletteLinkStatusNotUsed = 'ROULETTE_LINK_STATUS_NOT_USED',
  RouletteLinkStatusUnknown = 'ROULETTE_LINK_STATUS_UNKNOWN'
}

/** Weekly & date-specific schedule for store/cart operating hours */
export type Instacart_Caper_Admin_V1_Schedule = {
  __typename?: 'instacart_caper_admin_v1_Schedule';
  /** Special dates: ISO dates ("2025-12-26") to time ranges for overrides */
  special: Maybe<Scalars['JSON']>;
  /** Weekly schedule: explicit day-to-ranges mapping */
  weekly: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_WeeklySchedule>>>;
};

/** Request to schedule a config or feature change */
export type Instacart_Caper_Admin_V1_ScheduleActionRequest_Input = {
  configAction?: InputMaybe<Instacart_Caper_Admin_V1_ConfigAction_Input>;
  /** Maps to created_by */
  createdBy?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['BigInt']>;
  featureAction?: InputMaybe<Instacart_Caper_Admin_V1_FeatureAction_Input>;
  global?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for scheduling an action */
export type Instacart_Caper_Admin_V1_ScheduleActionResponse = {
  __typename?: 'instacart_caper_admin_v1_ScheduleActionResponse';
  scheduleId: Maybe<Scalars['String']>;
  workflowId: Maybe<Scalars['String']>;
};

/** Request to schedule multiple config/feature changes in batch */
export type Instacart_Caper_Admin_V1_ScheduleBatchActionsRequest_Input = {
  /** Multiple actions to schedule (all will share same schedule_id and workflow_id) */
  actions?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionBatchItem_Input>>>;
  /** Maps to created_by */
  createdBy?: InputMaybe<Scalars['String']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
};

/** Response for batch scheduling actions */
export type Instacart_Caper_Admin_V1_ScheduleBatchActionsResponse = {
  __typename?: 'instacart_caper_admin_v1_ScheduleBatchActionsResponse';
  /** Individual results for each action with status and error details */
  actionResults: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScheduledActionBatchItem>>>;
  failedActions: Maybe<Scalars['Int']>;
  /** Same for all actions in the batch */
  scheduleId: Maybe<Scalars['String']>;
  /** Number of actions successfully scheduled */
  successfulActions: Maybe<Scalars['Int']>;
  /** Total number of actions attempted */
  totalActions: Maybe<Scalars['Int']>;
  /** Same for all actions in the batch */
  workflowId: Maybe<Scalars['String']>;
};

/** Weekly & date-specific schedule for store/cart operating hours */
export type Instacart_Caper_Admin_V1_Schedule_Input = {
  /** Special dates: ISO dates ("2025-12-26") to time ranges for overrides */
  special?: InputMaybe<Scalars['JSON']>;
  /** Weekly schedule: explicit day-to-ranges mapping */
  weekly?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_WeeklySchedule_Input>>>;
};

/** A scheduled action with all its details */
export type Instacart_Caper_Admin_V1_ScheduledAction = {
  __typename?: 'instacart_caper_admin_v1_ScheduledAction';
  /** Cancellation details */
  cancellationReason: Maybe<Scalars['String']>;
  /** cancelled_at */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** cancelled_by */
  cancelledBy: Maybe<Scalars['String']>;
  configAction: Maybe<Instacart_Caper_Admin_V1_ConfigAction>;
  /** created_at */
  createdAt: Maybe<Scalars['DateTime']>;
  /** created_by */
  createdBy: Maybe<Scalars['String']>;
  /** Execution details */
  errorMessage: Maybe<Scalars['String']>;
  executionEndTime: Maybe<Scalars['DateTime']>;
  /** execution_start_time */
  executionStartTime: Maybe<Scalars['DateTime']>;
  featureAction: Maybe<Instacart_Caper_Admin_V1_FeatureAction>;
  scheduleId: Maybe<Scalars['String']>;
  /** scheduled_time */
  scheduledTime: Maybe<Scalars['DateTime']>;
  /** status */
  status: Maybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** Target entity */
  target: Maybe<Instacart_Caper_Admin_V1_ScheduledActionTarget>;
  /** updated_at */
  updatedAt: Maybe<Scalars['DateTime']>;
  workflowId: Maybe<Scalars['String']>;
};

/** Unified action item for batch scheduling (used in both requests and responses) */
export type Instacart_Caper_Admin_V1_ScheduledActionBatchItem = {
  __typename?: 'instacart_caper_admin_v1_ScheduledActionBatchItem';
  configAction: Maybe<Instacart_Caper_Admin_V1_ConfigAction>;
  errorMessage: Maybe<Scalars['String']>;
  featureAction: Maybe<Instacart_Caper_Admin_V1_FeatureAction>;
  /** Optional fields (only populated in responses, ignored in requests) */
  status: Maybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** Target entity for this action */
  target: Maybe<Instacart_Caper_Admin_V1_ScheduledActionTarget>;
};

/** Unified action item for batch scheduling (used in both requests and responses) */
export type Instacart_Caper_Admin_V1_ScheduledActionBatchItem_Input = {
  configAction?: InputMaybe<Instacart_Caper_Admin_V1_ConfigAction_Input>;
  errorMessage?: InputMaybe<Scalars['String']>;
  featureAction?: InputMaybe<Instacart_Caper_Admin_V1_FeatureAction_Input>;
  /** Optional fields (only populated in responses, ignored in requests) */
  status?: InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** Target entity for this action */
  target?: InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionTarget_Input>;
};

/** Status of a scheduled action */
export enum Instacart_Caper_Admin_V1_ScheduledActionStatus {
  ScheduledActionStatusCancelled = 'SCHEDULED_ACTION_STATUS_CANCELLED',
  ScheduledActionStatusCompleted = 'SCHEDULED_ACTION_STATUS_COMPLETED',
  ScheduledActionStatusFailed = 'SCHEDULED_ACTION_STATUS_FAILED',
  ScheduledActionStatusPending = 'SCHEDULED_ACTION_STATUS_PENDING',
  ScheduledActionStatusRunning = 'SCHEDULED_ACTION_STATUS_RUNNING',
  ScheduledActionStatusUnknown = 'SCHEDULED_ACTION_STATUS_UNKNOWN'
}

/** Target entity information for a scheduled action */
export type Instacart_Caper_Admin_V1_ScheduledActionTarget = {
  __typename?: 'instacart_caper_admin_v1_ScheduledActionTarget';
  /** target_entity_id (-1 for global) */
  entityId: Maybe<Scalars['BigInt']>;
  /** target_entity_type */
  type: Maybe<Instacart_Caper_Admin_V1_EntityType>;
};

/** Target entity information for a scheduled action */
export type Instacart_Caper_Admin_V1_ScheduledActionTarget_Input = {
  /** target_entity_id (-1 for global) */
  entityId?: InputMaybe<Scalars['BigInt']>;
  /** target_entity_type */
  type?: InputMaybe<Instacart_Caper_Admin_V1_EntityType>;
};

/** Type of scheduled action */
export enum Instacart_Caper_Admin_V1_ScheduledActionType {
  ScheduledActionTypeConfig = 'SCHEDULED_ACTION_TYPE_CONFIG',
  ScheduledActionTypeFeature = 'SCHEDULED_ACTION_TYPE_FEATURE',
  ScheduledActionTypeUnknown = 'SCHEDULED_ACTION_TYPE_UNKNOWN'
}

/** Information about a single session screenshot */
export type Instacart_Caper_Admin_V1_ScreenshotInfo = {
  __typename?: 'instacart_caper_admin_v1_ScreenshotInfo';
  /** Original filename of the screenshot */
  filename: Maybe<Scalars['String']>;
  /** GCS signed URL for accessing the screenshot */
  signedUrl: Maybe<Scalars['String']>;
  /** Unix milliseconds timestamp for sorting screenshots chronologically */
  timestampMs: Maybe<Scalars['BigInt']>;
};

/** The request message to send a receipt */
export type Instacart_Caper_Admin_V1_SendReceiptRequest_Input = {
  /** the unique identifier for each ebt transaction that is also used as the ebt refund id, at least one of either this field or the ebt_card_last_4_digits field is required to retrieve ebt receipt metadata */
  ebtId?: InputMaybe<Scalars['String']>;
  /** the email of the user to whom the receipt will be sent */
  email?: InputMaybe<Scalars['String']>;
};

/** Response containing session/datadog summary data and processing status */
export type Instacart_Caper_Admin_V1_SessionSummaryCreationStatus = {
  __typename?: 'instacart_caper_admin_v1_SessionSummaryCreationStatus';
  /** Error details if summary generation failed */
  errorMessage: Maybe<Scalars['String']>;
  /** User feedback text about the summary quality */
  feedback: Maybe<Scalars['String']>;
  /** Unique identifier for this summary record */
  id: Maybe<Scalars['String']>;
  /** Generated markdown summary (only present when status is COMPLETED) */
  markdownSummary: Maybe<Scalars['String']>;
  /** User rating for the summary (1-5 scale) */
  rating: Maybe<Scalars['Int']>;
  /** The original session ID this summary was created for */
  sessionId: Maybe<Scalars['String']>;
  /** Current processing status of the summary generation */
  status: Maybe<Instacart_Caper_Admin_V1_SummaryStatus>;
};

/** Request message for setting archived status of a ban entry */
export type Instacart_Caper_Admin_V1_SetBanEntryArchivedRequest_Input = {
  /** Whether the entry should be archived (true) or active (false) */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** The ban entry ID to update */
  banEntryId?: InputMaybe<Scalars['String']>;
};

/** Request message for setting complete scope list for a ban entry (full replacement) */
export type Instacart_Caper_Admin_V1_SetBanEntryScopesRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  /** The ban entry ID to set scopes for */
  banEntryId?: InputMaybe<Scalars['String']>;
  /**
   * Scopes that should be the complete set for this ban entry
   * Replaces all existing scopes with this list
   */
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for setting scopes for a ban entry */
export type Instacart_Caper_Admin_V1_SetBanEntryScopesResponse = {
  __typename?: 'instacart_caper_admin_v1_SetBanEntryScopesResponse';
  /** The updated list of all scopes for this ban entry */
  scopes: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/** A Caper store, a specific physical location of a store under a retailer */
export type Instacart_Caper_Admin_V1_Store = {
  __typename?: 'instacart_caper_admin_v1_Store';
  /** Smart cart availability hours (may differ from store hours) */
  cartHours: Maybe<Instacart_Caper_Admin_V1_Schedule>;
  city: Maybe<Scalars['String']>;
  configs: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  country: Maybe<Scalars['String']>;
  /** For record soft deletion if the field is set */
  deletedAt: Maybe<Scalars['DateTime']>;
  demoStore: Maybe<Scalars['Boolean']>;
  deploymentState: Maybe<Instacart_Caper_Admin_V1_Store_StoreDeploymentState>;
  devices: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Device>>>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts for this specific store. Set by support team during store setup.
   */
  esperBlueprintId: Maybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId: Maybe<Scalars['String']>;
  externalStoreId: Maybe<Scalars['String']>;
  /** Features associated with this store */
  featureValues: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  flippStoreName: Maybe<Scalars['String']>;
  /** Attributes of a store, separate from configs */
  id: Maybe<Scalars['BigInt']>;
  instacartWarehouseLocationId: Maybe<Scalars['String']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor: Maybe<Scalars['String']>;
  /** This is the legacy_ngcp_store_id from the database */
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  pricingOverrideInstacartWarehouseLocationId: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  /** Store operating hours (when front door is open to customers) */
  storeOpenHours: Maybe<Instacart_Caper_Admin_V1_Schedule>;
  street: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  /**
   * ZeroTier Network ID for store-specific cart networking used for cart maintenance only.
   * Each store has its own virtual network that carts join, allowing teams to connect remotely for
   * debugging and maintenance purposes. Set by support team during store setup.
   */
  zerotierNetworkId: Maybe<Scalars['String']>;
  zipCode: Maybe<Scalars['String']>;
};

/** Store information */
export type Instacart_Caper_Admin_V1_StoreInfo = {
  __typename?: 'instacart_caper_admin_v1_StoreInfo';
  id: Maybe<Scalars['String']>;
  instacartWarehouseLocationId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** A Caper store, a specific physical location of a store under a retailer */
export type Instacart_Caper_Admin_V1_Store_Input = {
  /** Smart cart availability hours (may differ from store hours) */
  cartHours?: InputMaybe<Instacart_Caper_Admin_V1_Schedule_Input>;
  city?: InputMaybe<Scalars['String']>;
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  country?: InputMaybe<Scalars['String']>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  demoStore?: InputMaybe<Scalars['Boolean']>;
  deploymentState?: InputMaybe<Instacart_Caper_Admin_V1_Store_StoreDeploymentState>;
  devices?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_Device_Input>>>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts for this specific store. Set by support team during store setup.
   */
  esperBlueprintId?: InputMaybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId?: InputMaybe<Scalars['String']>;
  externalStoreId?: InputMaybe<Scalars['String']>;
  /** Features associated with this store */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  flippStoreName?: InputMaybe<Scalars['String']>;
  /** Attributes of a store, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  instacartWarehouseLocationId?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  /** This is the legacy_ngcp_store_id from the database */
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pricingOverrideInstacartWarehouseLocationId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  /** Store operating hours (when front door is open to customers) */
  storeOpenHours?: InputMaybe<Instacart_Caper_Admin_V1_Schedule_Input>;
  street?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  /**
   * ZeroTier Network ID for store-specific cart networking used for cart maintenance only.
   * Each store has its own virtual network that carts join, allowing teams to connect remotely for
   * debugging and maintenance purposes. Set by support team during store setup.
   */
  zerotierNetworkId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** The current deployment state of the store */
export enum Instacart_Caper_Admin_V1_Store_StoreDeploymentState {
  StoreDeploymentStateActive = 'STORE_DEPLOYMENT_STATE_ACTIVE',
  StoreDeploymentStateInactive = 'STORE_DEPLOYMENT_STATE_INACTIVE',
  StoreDeploymentStatePreLaunch = 'STORE_DEPLOYMENT_STATE_PRE_LAUNCH',
  StoreDeploymentStateUnknown = 'STORE_DEPLOYMENT_STATE_UNKNOWN'
}

/** Status of session summary generation process */
export enum Instacart_Caper_Admin_V1_SummaryStatus {
  SummaryStatusCompleted = 'SUMMARY_STATUS_COMPLETED',
  SummaryStatusFailed = 'SUMMARY_STATUS_FAILED',
  SummaryStatusPending = 'SUMMARY_STATUS_PENDING',
  SummaryStatusProcessing = 'SUMMARY_STATUS_PROCESSING',
  SummaryStatusUnknown = 'SUMMARY_STATUS_UNKNOWN'
}

/** Dashboard status tabs for NOF items */
export enum Instacart_Caper_Admin_V1_Tab {
  TabEscalationFromRetailer = 'TAB_ESCALATION_FROM_RETAILER',
  TabExtNeedsAttentionFromInstacart = 'TAB_EXT_NEEDS_ATTENTION_FROM_INSTACART',
  TabExtNeedsMoreData = 'TAB_EXT_NEEDS_MORE_DATA',
  TabExtNeedsReview = 'TAB_EXT_NEEDS_REVIEW',
  TabExtResolved = 'TAB_EXT_RESOLVED',
  TabInternalEscalation = 'TAB_INTERNAL_ESCALATION',
  TabNeedsReview = 'TAB_NEEDS_REVIEW',
  TabReadyForRetesting = 'TAB_READY_FOR_RETESTING',
  TabResolved = 'TAB_RESOLVED',
  TabRetailerEscalation = 'TAB_RETAILER_ESCALATION',
  TabReviewed = 'TAB_REVIEWED',
  TabUnknown = 'TAB_UNKNOWN'
}

/** Error details for a terminal that failed to create. */
export type Instacart_Caper_Admin_V1_TerminalCreationError = {
  __typename?: 'instacart_caper_admin_v1_TerminalCreationError';
  /** The device ID that failed. */
  deviceId: Maybe<Scalars['BigInt']>;
  /**
   * Error code for programmatic handling (e.g., "DEVICE_NOT_FOUND",
   * "DUPLICATE_TID", "WORLDLINE_ERROR").
   */
  errorCode: Maybe<Scalars['String']>;
  /** Human-readable error message. */
  errorMessage: Maybe<Scalars['String']>;
  /** The Worldline TID that was attempted. */
  worldlineTid: Maybe<Scalars['String']>;
};

/** Input data for a single terminal to be created. */
export type Instacart_Caper_Admin_V1_TerminalInput_Input = {
  /** The Caper device ID (cart). Must be a device in the specified store. */
  deviceId?: InputMaybe<Scalars['BigInt']>;
  /** Worldline Terminal Identification Number (TID) from VAR sheet. */
  worldlineTid?: InputMaybe<Scalars['String']>;
};

/**
 * Single time range [open, close) within a day. Times in store's local timezone.
 * Special case: when open equals close, represents a full 24-hour period (all day open)
 */
export type Instacart_Caper_Admin_V1_TimeRange = {
  __typename?: 'instacart_caper_admin_v1_TimeRange';
  /** Closing time with built-in validation */
  close: Maybe<GoogleTypeTimeOfDay>;
  /** Opening time with built-in validation */
  open: Maybe<GoogleTypeTimeOfDay>;
};

/**
 * Single time range [open, close) within a day. Times in store's local timezone.
 * Special case: when open equals close, represents a full 24-hour period (all day open)
 */
export type Instacart_Caper_Admin_V1_TimeRange_Input = {
  /** Closing time with built-in validation */
  close?: InputMaybe<GoogleTypeTimeOfDayInput>;
  /** Opening time with built-in validation */
  open?: InputMaybe<GoogleTypeTimeOfDayInput>;
};

/**
 * A request to transfer terminal credentials from one device to another.
 * Used for device replacement scenarios (RMA, hardware failure).
 */
export type Instacart_Caper_Admin_V1_TransferTerminalRequest_Input = {
  /** Email of the CSC user making the request. Used for audit trail. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The source Caper device ID from which credentials are being transferred. */
  fromDeviceId?: InputMaybe<Scalars['BigInt']>;
  /** The payment terminal database ID to transfer. */
  paymentTerminalId?: InputMaybe<Scalars['BigInt']>;
  /** Human-readable reason for the transfer. */
  reason?: InputMaybe<Scalars['String']>;
  /** The target Caper device ID to receive the credentials. */
  toDeviceId?: InputMaybe<Scalars['BigInt']>;
};

/** Response from TransferTerminal. Returned with gRPC status OK on success. */
export type Instacart_Caper_Admin_V1_TransferTerminalResponse = {
  __typename?: 'instacart_caper_admin_v1_TransferTerminalResponse';
  /** The newly created terminal on the target device. */
  terminal: Maybe<Instacart_Caper_Admin_V1_PaymentTerminal>;
  /** The audit record for this transfer. */
  transferRecord: Maybe<Instacart_Caper_Admin_V1_PaymentTerminalTransfer>;
};

/**
 * Request to trigger a new device provisioning pipeline run.
 * The pipeline type is inferred from whichever config branch is set.
 */
export type Instacart_Caper_Admin_V1_TriggerPipelineRequest_Input = {
  /** Email of the IPP user triggering the run. */
  authorEmail?: InputMaybe<Scalars['String']>;
  cartReplacement?: InputMaybe<Instacart_Caper_Admin_V1_CartReplacementConfig_Input>;
  /** Physical charger location in the warehouse (e.g. "Charger 1", "Misc"). Empty if not set. */
  charger?: InputMaybe<Scalars['String']>;
  /** Target environment. Defaults to PIPELINE_ENVIRONMENT_PROD if unset. */
  env?: InputMaybe<Instacart_Caper_Admin_V1_PipelineEnvironment>;
  /** Free-form note for this run, entered by the triggering user. Empty if not set. */
  note?: InputMaybe<Scalars['String']>;
  tuSwap?: InputMaybe<Instacart_Caper_Admin_V1_TuSwapConfig_Input>;
};

/** Response from TriggerPipeline. */
export type Instacart_Caper_Admin_V1_TriggerPipelineResponse = {
  __typename?: 'instacart_caper_admin_v1_TriggerPipelineResponse';
  /**
   * Newly created run record in PENDING status.
   * stages is empty in this response; use GetPipelineRun to retrieve them.
   */
  run: Maybe<Instacart_Caper_Admin_V1_PipelineRun>;
};

/**
 * Inputs for the TU Swap pipeline.
 * Replaces the Top Unit of a single Caper Cart.
 */
export type Instacart_Caper_Admin_V1_TuSwapConfig_Input = {
  /** CSC name of the device being replaced (e.g. "P_WAKEFERN_15_M3_001"). */
  cscDeviceName?: InputMaybe<Scalars['String']>;
  /** Warehouse IPv4 address of the device (e.g. "192.168.1.100"). */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Store identifier the device belongs to (e.g. "prod-wakefern-25"). */
  storeId?: InputMaybe<Scalars['String']>;
};

/** Requested changes to a config key */
export type Instacart_Caper_Admin_V1_UpdateConfigKeyRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Set the ID of the config key to update, and any fields you wish to change */
  configKey?: InputMaybe<Instacart_Caper_Admin_V1_ConfigKey_Input>;
};

/** Requested changes to configs */
export type Instacart_Caper_Admin_V1_UpdateConfigRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigUpdate_Input>>>;
};

/** Request for updating a device */
export type Instacart_Caper_Admin_V1_UpdateDeviceRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the device to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  device?: InputMaybe<Instacart_Caper_Admin_V1_Device_Input>;
};

/** Response for updating a device */
export type Instacart_Caper_Admin_V1_UpdateDeviceResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateDeviceResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Request for updating an existing feature */
export type Instacart_Caper_Admin_V1_UpdateFeatureRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The full feature object, including the ID and all fields to update. */
  feature?: InputMaybe<Instacart_Caper_Admin_V1_Feature_Input>;
};

/** Request for updating the global level */
export type Instacart_Caper_Admin_V1_UpdateGlobalRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * All features that should be set on the global level, including existing ones.
   * If you leave out features that are already set, they will be unset.
   */
  featuresValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
};

/** Request for updating a partner */
export type Instacart_Caper_Admin_V1_UpdatePartnerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the partner to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  partner?: InputMaybe<Instacart_Caper_Admin_V1_Partner_Input>;
};

/** Response for updating a partner */
export type Instacart_Caper_Admin_V1_UpdatePartnerResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdatePartnerResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Request for updating a retailer */
export type Instacart_Caper_Admin_V1_UpdateRetailerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the retailer to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  retailer?: InputMaybe<Instacart_Caper_Admin_V1_Retailer_Input>;
};

/** Response for updating a retailer */
export type Instacart_Caper_Admin_V1_UpdateRetailerResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateRetailerResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Request to update feedback and rating for an existing session summary */
export type Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackRequest_Input = {
  /**
   * Optional: Feedback text (empty string means no feedback update)
   * Business logic will only update feedback if non-empty
   */
  feedback?: InputMaybe<Scalars['String']>;
  /**
   * Optional: Rating from 1-5
   * Business logic will only update rating if not 0
   * Application logic will validate range and reject invalid values
   */
  rating?: InputMaybe<Scalars['Int']>;
  /** Required: The ID of the session summary to update */
  summaryId?: InputMaybe<Scalars['String']>;
};

/**
 * Response for updating session summary feedback and rating
 * Returns the updated session summary status with the newly applied feedback/rating
 */
export type Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateSessionSummaryFeedbackResponse';
  status: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for updating a store */
export type Instacart_Caper_Admin_V1_UpdateStoreRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the store to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  store?: InputMaybe<Instacart_Caper_Admin_V1_Store_Input>;
};

/** Response for updating a store */
export type Instacart_Caper_Admin_V1_UpdateStoreResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateStoreResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Video audit event with timestamp */
export type Instacart_Caper_Admin_V1_VideoAuditEventData = {
  __typename?: 'instacart_caper_admin_v1_VideoAuditEventData';
  /** When this event occurred */
  eventTimestamp: Maybe<Scalars['DateTime']>;
  /** Video audit properties */
  properties: Maybe<Instacart_Caper_Admin_V1_VideoAuditProperties>;
};

/** Video audit event properties */
export type Instacart_Caper_Admin_V1_VideoAuditProperties = {
  __typename?: 'instacart_caper_admin_v1_VideoAuditProperties';
  /** Asset ID for the video */
  assetId: Maybe<Scalars['String']>;
  /** When the video was created */
  createTimestamp: Maybe<Scalars['String']>;
  /** Duration of the video in milliseconds */
  duration: Maybe<Scalars['BigInt']>;
  /** Encoding duration in milliseconds */
  encodeDurationMillis: Maybe<Scalars['BigInt']>;
  /** Whether this is a long-term upload */
  isLongTermUpload: Maybe<Scalars['Boolean']>;
  /** URL to access the video */
  url: Maybe<Scalars['String']>;
  /** Video duration in milliseconds */
  videoDuration: Maybe<Scalars['BigInt']>;
};

/** Single day's schedule with type-safe day specification */
export type Instacart_Caper_Admin_V1_WeeklySchedule = {
  __typename?: 'instacart_caper_admin_v1_WeeklySchedule';
  day: Maybe<GoogleTypeDayOfWeek>;
  ranges: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_TimeRange>>>;
};

/** Single day's schedule with type-safe day specification */
export type Instacart_Caper_Admin_V1_WeeklySchedule_Input = {
  day?: InputMaybe<GoogleTypeDayOfWeek>;
  ranges?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_TimeRange_Input>>>;
};

export enum Instacart_Care_Tools_V1_AccountType {
  AccountTypeIpp = 'ACCOUNT_TYPE_IPP',
  AccountTypeUnspecified = 'ACCOUNT_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_AddressResponse = {
  __typename?: 'instacart_care_tools_v1_AddressResponse';
  apartmentNumber: Maybe<Scalars['String']>;
  businessName: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  countryId: Maybe<Scalars['BigInt']>;
  floorNumber: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  postalCode: Maybe<Scalars['String']>;
  regionName: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  streetAddress: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
  zoneId: Maybe<Scalars['BigInt']>;
  zoneName: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_AdminAuditContext_Input = {
  accountId?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Instacart_Care_Tools_V1_AccountType>;
  remoteIp?: InputMaybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_ChatMessage = {
  __typename?: 'instacart_care_tools_v1_ChatMessage';
  /** The body of the message. */
  body: Maybe<Scalars['String']>;
  /** The time of creation. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The ID of the message. */
  id: Maybe<Scalars['BigInt']>;
  /**
   * The URL of the image in the message.
   * e.g. https://d2syimmrmqkckt.cloudfront.net/chatmessage/image/254f4bf8-2d13-11ec-8d3d-0242ac130003.jpg
   */
  image: Maybe<Scalars['String']>;
  /** The order delivery ID. */
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  /** Whether or not the message was read. */
  read: Maybe<Scalars['Boolean']>;
  /** Time the message was read at. */
  readAt: Maybe<Scalars['DateTime']>;
  /** The recipient ID. */
  recipientId: Maybe<Scalars['BigInt']>;
  /** The type of recipient. */
  recipientType: Maybe<Scalars['String']>;
  /** The sender ID. */
  senderId: Maybe<Scalars['BigInt']>;
  /** The type of sender. */
  senderType: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_CommonIdentityUser = {
  __typename?: 'instacart_care_tools_v1_CommonIdentityUser';
  active: Maybe<Scalars['Boolean']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  lastName: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_CreateNoteForOrderRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  note?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_CreateNoteForOrderResponse = {
  __typename?: 'instacart_care_tools_v1_CreateNoteForOrderResponse';
  note: Maybe<Instacart_Care_Tools_V1_Note>;
};

export type Instacart_Care_Tools_V1_CreateNoteForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  note?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CreateNoteForUserResponse = {
  __typename?: 'instacart_care_tools_v1_CreateNoteForUserResponse';
  note: Maybe<Instacart_Care_Tools_V1_Note>;
};

/** Probably will use another enum in final version, but this is fine for dev. */
export enum Instacart_Care_Tools_V1_DeliveryStatus {
  AcknowledgedByFulfillment = 'ACKNOWLEDGED_BY_FULFILLMENT',
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  DeliveryStatusUnspecified = 'DELIVERY_STATUS_UNSPECIFIED',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Received = 'RECEIVED',
  Shopping = 'SHOPPING',
  ShoppingComplete = 'SHOPPING_COMPLETE'
}

export type Instacart_Care_Tools_V1_GetActiveBenefitsRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetActiveBenefitsResponse = {
  __typename?: 'instacart_care_tools_v1_GetActiveBenefitsResponse';
  benefits: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Care_Tools_V1_GetCommonIdentityUsersRequest_Input = {
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetCommonIdentityUsersResponse = {
  __typename?: 'instacart_care_tools_v1_GetCommonIdentityUsersResponse';
  users: Maybe<Array<Maybe<Instacart_Care_Tools_V1_CommonIdentityUser>>>;
};

export type Instacart_Care_Tools_V1_GetCustomerSpendingSummaryRequest_Input = {
  countryId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetCustomerSpendingSummaryResponse = {
  __typename?: 'instacart_care_tools_v1_GetCustomerSpendingSummaryResponse';
  avgBasketSize: Maybe<Scalars['Float']>;
  creditAvailable: Maybe<Scalars['Float']>;
  creditRefundPct: Maybe<Scalars['Float']>;
  creditSpendPct: Maybe<Scalars['Float']>;
  currencyCode: Maybe<Scalars['String']>;
  lifetimeCredits: Maybe<Scalars['Float']>;
  totalOrders: Maybe<Scalars['BigInt']>;
  totalSpend: Maybe<Scalars['Float']>;
};

export type Instacart_Care_Tools_V1_GetHouseholdByUserRequest_Input = {
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetHouseholdByUserResponse = {
  __typename?: 'instacart_care_tools_v1_GetHouseholdByUserResponse';
  household: Maybe<Instacart_Care_Tools_V1_Household>;
};

export type Instacart_Care_Tools_V1_GetInstacartPlusMembershipRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetInstacartPlusMembershipResponse = {
  __typename?: 'instacart_care_tools_v1_GetInstacartPlusMembershipResponse';
  memberships: Maybe<Array<Maybe<Instacart_Care_Tools_V1_InstacartPlusMembership>>>;
};

export type Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserResponse = {
  __typename?: 'instacart_care_tools_v1_GetLatestActiveAttributeForUserResponse';
  activeAttribute: Maybe<Instacart_Care_Tools_V1_LatestActiveAttributeForUser>;
};

export type Instacart_Care_Tools_V1_GetLinkedUserAccountsRequest_Input = {
  includeDeactivatedAccounts?: InputMaybe<Scalars['Boolean']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetLinkedUserAccountsResponse = {
  __typename?: 'instacart_care_tools_v1_GetLinkedUserAccountsResponse';
  linkedUserAccounts: Maybe<Array<Maybe<Instacart_Care_Tools_V1_LinkedUserAccount>>>;
};

export type Instacart_Care_Tools_V1_GetOrderRequest_Input = {
  orderReference?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_GetOrderResponse = {
  __typename?: 'instacart_care_tools_v1_GetOrderResponse';
  order: Maybe<Instacart_Care_Tools_V1_Order>;
};

export type Instacart_Care_Tools_V1_GetUserRequest_Input = {
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetUserResponse = {
  __typename?: 'instacart_care_tools_v1_GetUserResponse';
  user: Maybe<Instacart_Care_Tools_V1_User>;
};

export type Instacart_Care_Tools_V1_Household = {
  __typename?: 'instacart_care_tools_v1_Household';
  householdMembers: Maybe<Array<Maybe<Instacart_Care_Tools_V1_HouseholdUser>>>;
  id: Maybe<Scalars['BigInt']>;
  isFull: Maybe<Scalars['Boolean']>;
  ownerUserId: Maybe<Scalars['BigInt']>;
  setupComplete: Maybe<Scalars['Boolean']>;
  sharableInviteUrl: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_HouseholdUser = {
  __typename?: 'instacart_care_tools_v1_HouseholdUser';
  avatarImageUrl: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  isOwner: Maybe<Scalars['Boolean']>;
  lastName: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_InstacartPlusMembership = {
  __typename?: 'instacart_care_tools_v1_InstacartPlusMembership';
  autorenew: Maybe<Scalars['Boolean']>;
  canceledAt: Maybe<Scalars['DateTime']>;
  countryId: Maybe<Scalars['BigInt']>;
  endsOn: Maybe<Scalars['DateTime']>;
  renewalPrice: Maybe<GoogleTypeMoney>;
  startsOn: Maybe<Scalars['DateTime']>;
  subscriptionId: Maybe<Scalars['BigInt']>;
  termLength: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_LatestActiveAttributeForUser = {
  __typename?: 'instacart_care_tools_v1_LatestActiveAttributeForUser';
  addressId: Maybe<Scalars['BigInt']>;
  countryId: Maybe<Scalars['BigInt']>;
  locale: Maybe<Scalars['String']>;
  oauthApplicationId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  timeZoneName: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_LinkIsolatedUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  isolatedUserId?: InputMaybe<Scalars['BigInt']>;
  marketplaceUserId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_LinkIsolatedUserResponse = {
  __typename?: 'instacart_care_tools_v1_LinkIsolatedUserResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_LinkedUserAccount = {
  __typename?: 'instacart_care_tools_v1_LinkedUserAccount';
  accountType: Maybe<Instacart_Care_Tools_V1_LinkedUserAccount_AccountType>;
  active: Maybe<Scalars['Boolean']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  lastName: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

export enum Instacart_Care_Tools_V1_LinkedUserAccount_AccountType {
  AccountTypeUnknown = 'ACCOUNT_TYPE_UNKNOWN',
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export type Instacart_Care_Tools_V1_ListAddressesForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListAddressesForUserResponse = {
  __typename?: 'instacart_care_tools_v1_ListAddressesForUserResponse';
  nodes: Maybe<Array<Maybe<Instacart_Care_Tools_V1_AddressResponse>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Care_Tools_V1_ListNotesForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListNotesForUserResponse = {
  __typename?: 'instacart_care_tools_v1_ListNotesForUserResponse';
  notes: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Note>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesResponse = {
  __typename?: 'instacart_care_tools_v1_ListOrderChatMessagesAndNotesResponse';
  chatMessages: Maybe<Array<Maybe<Instacart_Care_Tools_V1_ChatMessage>>>;
  notes: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Note>>>;
};

export type Instacart_Care_Tools_V1_ListOrdersByCustomerRequest_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  /** If true, the customer's name will be included in the response. Adds a network request. */
  includeCustomerName?: InputMaybe<Scalars['Boolean']>;
  /** If true, the store's name for each order will be included in the response. Adds a network request. */
  includeRetailerLocationName?: InputMaybe<Scalars['Boolean']>;
  /** If true, the retailer's name for each order will be included in the response. Adds a network request. */
  includeRetailerName?: InputMaybe<Scalars['Boolean']>;
  /** If true, the shopper's summary for each order will be included in the response. Adds a network request. */
  includeShopperSummary?: InputMaybe<Scalars['Boolean']>;
  /**
   * If order_id is provided, other filters will be ignored.
   * Used to get the order_delivery_id from the order_id.
   */
  orderId?: InputMaybe<Scalars['BigInt']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListOrdersByCustomerResponse = {
  __typename?: 'instacart_care_tools_v1_ListOrdersByCustomerResponse';
  orders: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderSummary>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerRequest_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerResponse = {
  __typename?: 'instacart_care_tools_v1_ListRestaurantOrdersByCustomerResponse';
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  restaurantOrders: Maybe<Array<Maybe<Instacart_Care_Tools_V1_RestaurantOrder>>>;
};

export type Instacart_Care_Tools_V1_Note = {
  __typename?: 'instacart_care_tools_v1_Note';
  createdAt: Maybe<Scalars['DateTime']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  lastName: Maybe<Scalars['String']>;
  notableId: Maybe<Scalars['BigInt']>;
  notableType: Maybe<Instacart_Care_Tools_V1_Note_NotableType>;
  note: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  userId: Maybe<Scalars['BigInt']>;
  userType: Maybe<Scalars['String']>;
};

export enum Instacart_Care_Tools_V1_Note_NotableType {
  Order = 'ORDER',
  User = 'USER'
}

/**
 * This is a subset of fields from the full Order message in OrdersService, plus additional information, that we can show to external users.
 * Do not add any data that is meant to be internal only, like workflow_state.
 * It's the result of orchestrating calls to multiple different services to fetch data for the Order management page.
 */
export type Instacart_Care_Tools_V1_Order = {
  __typename?: 'instacart_care_tools_v1_Order';
  batchIds: Maybe<Instacart_Care_Tools_V1_Order_BatchIds>;
  /** Branded name of the website, e.g. "Instacart" */
  brandedName: Maybe<Scalars['String']>;
  /** Indicates if the order is a certified delivery order. */
  certifiedDelivery: Maybe<Scalars['Boolean']>;
  /** Store present at the time of customer's order checkout */
  checkoutRetailerLocation: Maybe<Instacart_Customers_Partners_V1_RetailerLocation>;
  clientConfigurationId: Maybe<Scalars['BigInt']>;
  /** Closest Store determined by Instacart for shopping this order. */
  closestRetailerLocation: Maybe<Instacart_Customers_Partners_V1_RetailerLocation>;
  /**
   * Customer's preferred locale for order chats and notifications.
   * POSIX identifier format (aa_BB):
   * https://en.wikipedia.org/wiki/Locale_(computer_software)
   * Ex. "en", "en_US", "fr_CA"
   */
  communicationLocale: Maybe<Scalars['String']>;
  /** When the order was confirmed. */
  confirmedAt: Maybe<Scalars['DateTime']>;
  /** Indicates if the order is a connect order. */
  connectOrder: Maybe<Scalars['Boolean']>;
  /** The country for the order. */
  country: Maybe<Instacart_Customers_Partners_V1_Country>;
  /** The client identifier that was used during order creation. */
  creationClientIdentifier: Maybe<Scalars['String']>;
  /** The date the order was created */
  creationDate: Maybe<Scalars['DateTime']>;
  /** How many bags the shopper purchased. */
  customerBagCount: Maybe<Scalars['BigInt']>;
  /** The customer's Nth order. */
  customerOrderNumber: Maybe<Scalars['BigInt']>;
  /** If delivery performed (delivered or picked up), timestamp of that event */
  deliveredAt: Maybe<Scalars['DateTime']>;
  /** If delivery started, timestamp of that event */
  deliveryStartedAt: Maybe<Scalars['DateTime']>;
  /** The status of the order. */
  deliveryStatus: Maybe<Instacart_Care_Tools_V1_DeliveryStatus>;
  /** The id of the Express membership subscribed by user that creates the order or any linked user. */
  expressSubscriptionId: Maybe<Scalars['BigInt']>;
  /**
   * For delivered order, when the order got done with completion reconciliations
   * For canceled order, when the order can not be uncanceled
   */
  finalizedAt: Maybe<Scalars['DateTime']>;
  /** Type of fulfillment service option. */
  fulfillmentType: Maybe<Instacart_Customers_Shared_V1_FulfillmentTypeWrapper_FulfillmentType>;
  /** Scheduled fulfillment window. */
  fulfillmentWindow: Maybe<Instacart_Care_Tools_V1_Order_OrderFulfillmentWindow>;
  /** Heavy pay information for this order and associated batch. */
  heavyPayInfo: Maybe<Instacart_Care_Tools_V1_Order_HeavyPayInfo>;
  id: Maybe<Scalars['BigInt']>;
  /** The loyalty number associated with this order. */
  loyaltyNumber: Maybe<Scalars['String']>;
  /** Indicates if the order is a marketplace order. */
  marketplaceOrder: Maybe<Scalars['Boolean']>;
  /** Order ahead flag */
  orderAhead: Maybe<Scalars['Boolean']>;
  /** The different charges for the order. */
  orderChargeLines: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Order_OrderChargeLine>>>;
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  /** Order handling details */
  orderHandlingDetails: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails>;
  /** The order lines for the order. */
  orderLines: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderLine>>>;
  orderReference: Maybe<Scalars['String']>;
  /** Timestamped state changes of the order */
  orderStateChanges: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderStateChange>>>;
  /** When we expect the delivery will be completed at */
  plannedDeliveredAt: Maybe<Scalars['DateTime']>;
  /** When we expect the shopper to start delivering */
  plannedDeliveryStartedAt: Maybe<Scalars['DateTime']>;
  /** Indicates if the order is a redelivery order. */
  redelivery: Maybe<Scalars['Boolean']>;
  /** The retailer the order belongs to. */
  retailer: Maybe<Instacart_Customers_Partners_V1_Retailer>;
  /** This is the id used by retailer to identify an order. */
  retailerReferenceId: Maybe<Scalars['String']>;
  /** DeliveryOption id */
  serviceOptionId: Maybe<Scalars['BigInt']>;
  /** Service type of the order. */
  serviceType: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** Indicates if the order is a sfx order. */
  sfxOrder: Maybe<Scalars['Boolean']>;
  /** The store the order was shopped at. */
  shoppedRetailerLocation: Maybe<Instacart_Customers_Partners_V1_RetailerLocation>;
  /** The shopper summary for the order. */
  shopperSummary: Maybe<Instacart_Care_Tools_V1_ShopperSummary>;
  /** Source website of the order, e.g. instacart.com */
  sourceWebsite: Maybe<Scalars['String']>;
  /** Store Configuration ID. (whitelabel_id) */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  /** The customer who placed the order. */
  user: Maybe<Instacart_Care_Tools_V1_User>;
  /**
   * Order user's birthday.
   * Needed for alcoholic orders. Shopper presents this to the cashier.
   */
  userBirthday: Maybe<Google_Type_Date>;
  /** The zone for the order. */
  zone: Maybe<Instacart_Customers_Partners_V1_Zone>;
};

export type Instacart_Care_Tools_V1_OrderHandlingDetails = {
  __typename?: 'instacart_care_tools_v1_OrderHandlingDetails';
  /** Delivery to customer. */
  delivery: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails_Delivery>;
  /** Pickup from location. */
  pickup: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails_Pickup>;
};

export enum Instacart_Care_Tools_V1_OrderHandlingDetails_AddressType {
  /** Business address. */
  AddressTypeBusiness = 'ADDRESS_TYPE_BUSINESS',
  /** Residential/home address. */
  AddressTypeResidential = 'ADDRESS_TYPE_RESIDENTIAL',
  AddressTypeUnspecified = 'ADDRESS_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_OrderHandlingDetails_Delivery = {
  __typename?: 'instacart_care_tools_v1_OrderHandlingDetails_Delivery';
  /** Address to deliver the order. */
  address: Maybe<Google_Type_PostalAddress>;
  /** User's DB Address ID. */
  addressId: Maybe<Scalars['BigInt']>;
  /** Address type. */
  addressType: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails_AddressType>;
  /** Customer specified manual Lat/Lng coordinates. Unset if unspecified. */
  customerManualLatLng: Maybe<Google_Type_LatLng>;
  /** Door code from Customer. Ex. "*1234" */
  doorCode: Maybe<Scalars['String']>;
  /** Drop-off location instructions from Customer. Ex. "Front door" */
  dropoffLocation: Maybe<Scalars['String']>;
  /**
   * Instructions associated with the delivery. This is specific to the
   * Order or falls back to the Address notes.
   */
  instructions: Maybe<Scalars['String']>;
  /** Lat/Lng coordinates. */
  latLng: Maybe<Google_Type_LatLng>;
  /** Persisted notes about the address. */
  notes: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_OrderHandlingDetails_Pickup = {
  __typename?: 'instacart_care_tools_v1_OrderHandlingDetails_Pickup';
  /** Address to pickup the order. */
  address: Maybe<Google_Type_PostalAddress>;
  /** User's DB Address ID. */
  addressId: Maybe<Scalars['BigInt']>;
  /** Instructions associated with the pickup. */
  instructions: Maybe<Scalars['String']>;
  /** Lat/Lng coordinates. */
  latLng: Maybe<Google_Type_LatLng>;
};

/** Order item for care tools */
export type Instacart_Care_Tools_V1_OrderItem = {
  __typename?: 'instacart_care_tools_v1_OrderItem';
  /** Item is alcoholic */
  alcoholic: Maybe<Scalars['Boolean']>;
  imageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** Product category */
  productCategory: Maybe<Instacart_Care_Tools_V1_OrderItem_ProductCategory>;
  productId: Maybe<Scalars['BigInt']>;
  /** Quantity including units displayed to customer. */
  quantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Item is OTC */
  restrictedOtc: Maybe<Scalars['Boolean']>;
  /** Item is rx */
  rx: Maybe<Scalars['Boolean']>;
  /** Display size of item. */
  sizeDetails: Maybe<Scalars['String']>;
  /** Price per unit displayed to customer. */
  unitPrice: Maybe<GoogleTypeMoney>;
};

export type Instacart_Care_Tools_V1_OrderItem_ProductCategory = {
  __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory';
  l1Category: Maybe<Scalars['String']>;
  l2Category: Maybe<Scalars['String']>;
  l3Category: Maybe<Scalars['String']>;
  l4Category: Maybe<Scalars['String']>;
  l5Category: Maybe<Scalars['String']>;
  l6Category: Maybe<Scalars['String']>;
  productCategory: Maybe<Scalars['String']>;
};

/** Order line for care tools */
export type Instacart_Care_Tools_V1_OrderLine = {
  __typename?: 'instacart_care_tools_v1_OrderLine';
  /** Id of the shopper that added the order item. */
  addedByDriverId: Maybe<Scalars['BigInt']>;
  /**
   * Specifies if the customer explicitly allowed a substitution.
   * Possible values:
   * nil - customer did not decide.
   * false - customer asked for no substitution.
   * true - customer asked for a substitute.
   */
  allowedSubstitution: Maybe<Scalars['Boolean']>;
  /** The date the order line was created. */
  creationDate: Maybe<Scalars['DateTime']>;
  /** Price shown to customer at order time. */
  customerOrderedPrice: Maybe<GoogleTypeMoney>;
  /** Price displayed at storefront. */
  customerPrice: Maybe<GoogleTypeMoney>;
  /**
   * Customer specified replacement at checkout/post-checkout.
   * Available only when allowed_substitution is True.
   */
  customerSelectedReplacement: Maybe<Instacart_Care_Tools_V1_OrderItem>;
  /** Full price for this item. */
  fullPrice: Maybe<GoogleTypeMoney>;
  /** Original item requested at checkout. */
  item: Maybe<Instacart_Care_Tools_V1_OrderItem>;
  /** A unique identifier for this OrderLine that can be exposed externally. */
  obfuscatedId: Maybe<Scalars['String']>;
  /** Quantity including units ordered by customer. */
  orderedQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity including units picked. */
  pickedQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity including units refunded. */
  refundQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  replacementPolicy: Maybe<Instacart_Care_Tools_V1_OrderLine_ReplacementPolicy>;
  /** Special instructions about the order item. */
  specialInstructions: Maybe<Scalars['String']>;
  /** Original requested item status. */
  status: Maybe<Instacart_Care_Tools_V1_OrderLine_Status>;
  /** Substitute if replaced by shopper. If present, this is the current item on the order. */
  substitute: Maybe<Instacart_Care_Tools_V1_OrderItem>;
  /** The current status of the substitution for this item, if it exists. */
  substitutionStatus: Maybe<Instacart_Care_Tools_V1_OrderLine_SubstitutionStatus>;
};

/** Chosen replacement policy for the order item. */
export enum Instacart_Care_Tools_V1_OrderLine_ReplacementPolicy {
  NoReplacements = 'NO_REPLACEMENTS',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ShoppersChoice = 'SHOPPERS_CHOICE',
  UsersChoice = 'USERS_CHOICE'
}

export enum Instacart_Care_Tools_V1_OrderLine_Status {
  /** Original item requested found by shopper. */
  Found = 'FOUND',
  /** Not yet picked. */
  NotPicked = 'NOT_PICKED',
  /** Item replaced. */
  Replaced = 'REPLACED',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  /** Item to be refunded. */
  ToRefund = 'TO_REFUND'
}

export enum Instacart_Care_Tools_V1_OrderLine_SubstitutionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SubstitutionStatusUnspecified = 'SUBSTITUTION_STATUS_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_OrderStateChange = {
  __typename?: 'instacart_care_tools_v1_OrderStateChange';
  /** Extra data associated with the state change. */
  eventArgs: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The OrderDelivery's old state */
  fromState: Maybe<Scalars['String']>;
  /** The ID of the corresponding OrderDeliveryEvent */
  orderDeliveryEventId: Maybe<Scalars['BigInt']>;
  /** The order delivery ID itself */
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  /** The OrderDelivery's new state */
  toState: Maybe<Scalars['String']>;
  /** The time at which the state change occurred. */
  transitionedAt: Maybe<Scalars['DateTime']>;
  /** The proximate cause of the state change; optional. */
  trigger: Maybe<Scalars['String']>;
};

/**
 * Less fields than the Order type, but includes additional fields like shopper and store info.
 * Mostly used for list/table views.
 */
export type Instacart_Care_Tools_V1_OrderSummary = {
  __typename?: 'instacart_care_tools_v1_OrderSummary';
  /** (not yet supported) The batch ID of the order. Only included if include_batch_id request param is true. */
  batchId: Maybe<Scalars['BigInt']>;
  /** The date the order was created. */
  confirmedAt: Maybe<Scalars['DateTime']>;
  /** The customer's Nth order. */
  customerOrderNumber: Maybe<Scalars['BigInt']>;
  /** The delivery status of the order. */
  deliveryStatus: Maybe<Instacart_Care_Tools_V1_DeliveryStatus>;
  /** The id of the Express membership subscribed by the user at order time. */
  expressSubscriptionId: Maybe<Scalars['BigInt']>;
  /**
   * This is the earliest date for fulfillment for new or in-progress orders.
   * For delivered orders, this is the date at which they got delivered.
   */
  fulfillmentDate: Maybe<Scalars['DateTime']>;
  /** The order ID. */
  id: Maybe<Scalars['BigInt']>;
  /** Indicates if the order is a marketplace order. */
  marketplaceOrder: Maybe<Scalars['Boolean']>;
  /** The order delivery ID. */
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  /** The order reference. */
  orderReference: Maybe<Scalars['String']>;
  /** The retailer ID of the order. */
  retailerId: Maybe<Scalars['BigInt']>;
  /** The retailer location ID of the order. */
  retailerLocationId: Maybe<Scalars['BigInt']>;
  /** The name of the store that the order was shopped at. Only included if include_retailer_location_name request param is true. */
  retailerLocationName: Maybe<Scalars['String']>;
  /** The name of the retailer that the order was placed at. Only included if include_retailer_name request param is true. */
  retailerName: Maybe<Scalars['String']>;
  /** The service type of the order (delivery, pickup, etc.) */
  serviceType: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** The full profile of shoppers that shopped the order. Only included if include_shopper_summary request param is true. */
  shopperSummary: Maybe<Instacart_Care_Tools_V1_ShopperSummary>;
  /** The total amount of the order. */
  totalAmount: Maybe<GoogleTypeMoney>;
  /** The full name of the user. Only included if include_customer_name request param is true. */
  userFullName: Maybe<Scalars['String']>;
  /** The user ID of the order. */
  userId: Maybe<Scalars['BigInt']>;
};

/**
 * The batch IDs for the order.
 * Currently for some handoff cases, an order can be fulfilled by different batches (one for driving to the store, one for shopping and one for delivering).
 * Each phase can have multiple batches as well.
 */
export type Instacart_Care_Tools_V1_Order_BatchIds = {
  __typename?: 'instacart_care_tools_v1_Order_BatchIds';
  deliveringBatchIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  drivingToStoreBatchIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  shoppingBatchIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Care_Tools_V1_Order_HeavyPayInfo = {
  __typename?: 'instacart_care_tools_v1_Order_HeavyPayInfo';
  /** Total weight of 8lb+ items for the batch, in pounds. */
  batchHeavyPayLbs: Maybe<Scalars['Float']>;
  /** Total weight of 8lb+ items for this order (delivery), in pounds. */
  orderHeavyPayLbs: Maybe<Scalars['Float']>;
  /** Whether the shopper was paid heavy pay wage for the selected batch. */
  shopperPaidForHeavyPay: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_Order_OrderChargeLine = {
  __typename?: 'instacart_care_tools_v1_Order_OrderChargeLine';
  amount: Maybe<GoogleTypeMoney>;
  /** eg: Sugar_tax, Delivery_fee, Bottle_deposit etc. */
  labelInEnglish: Maybe<Scalars['String']>;
};

/**
 * Scheduled fulfillment window.
 * Time window used for notifications, view, and communication with customers
 */
export type Instacart_Care_Tools_V1_Order_OrderFulfillmentWindow = {
  __typename?: 'instacart_care_tools_v1_Order_OrderFulfillmentWindow';
  windowEnd: Maybe<Scalars['DateTime']>;
  windowStart: Maybe<Scalars['DateTime']>;
};

export type Instacart_Care_Tools_V1_RestaurantOrder = {
  __typename?: 'instacart_care_tools_v1_RestaurantOrder';
  createdAt: Maybe<Scalars['DateTime']>;
  /** Estimated time of arrival. */
  eta: Maybe<Scalars['DateTime']>;
  /** Time zone offset for the eta, eg: -04:00 */
  etaTimeZoneOffset: Maybe<Scalars['String']>;
  /** External order id. */
  externalOrderId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  /** Name of the restaurant. */
  restaurantName: Maybe<Scalars['String']>;
  /** Service type of the order. */
  serviceType: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** Status of the order. */
  status: Maybe<Scalars['String']>;
  /** The amount on the order (this is an estimate). */
  total: Maybe<GoogleTypeMoney>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Care_Tools_V1_ServiceUser {
  ServiceUserGenesys = 'SERVICE_USER_GENESYS',
  ServiceUserIppCxAdmin = 'SERVICE_USER_IPP_CX_ADMIN',
  ServiceUserSalesforce = 'SERVICE_USER_SALESFORCE',
  ServiceUserUnspecified = 'SERVICE_USER_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_ShopperSummary = {
  __typename?: 'instacart_care_tools_v1_ShopperSummary';
  /** Current shopper */
  currentShopperProfile: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
  /** Driver details */
  driverProfile: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
  /** Full Service? */
  fullService: Maybe<Scalars['Boolean']>;
  /** Picker details */
  pickerProfile: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
  /** Runner details */
  runnerProfile: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
};

/** Shopper profile information relevant to an order. */
export type Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile = {
  __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile';
  /** Avatar url of shopper. */
  avatarUrl: Maybe<Scalars['String']>;
  /** First name of the shopper. */
  firstName: Maybe<Scalars['String']>;
  /** Id of the shopper. */
  id: Maybe<Scalars['BigInt']>;
  /** Optional map icon url of shopper. */
  mapIconUrl: Maybe<Scalars['String']>;
  /** Name of the shopper. */
  name: Maybe<Scalars['String']>;
  /** Shopper start date. */
  startDate: Maybe<Google_Type_Date>;
};

export type Instacart_Care_Tools_V1_UnlinkIsolatedUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  isolatedUserId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_UnlinkIsolatedUserResponse = {
  __typename?: 'instacart_care_tools_v1_UnlinkIsolatedUserResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_UpdateAddressForUserRequest_Input = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  apartmentNumber?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_UpdateAddressForUserResponse = {
  __typename?: 'instacart_care_tools_v1_UpdateAddressForUserResponse';
  address: Maybe<Instacart_Care_Tools_V1_AddressResponse>;
};

export type Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  autorenew?: InputMaybe<Scalars['Boolean']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  subscriptionId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewResponse = {
  __typename?: 'instacart_care_tools_v1_UpdateSubscriptionAutorenewResponse';
  membership: Maybe<Instacart_Care_Tools_V1_InstacartPlusMembership>;
};

export type Instacart_Care_Tools_V1_User = {
  __typename?: 'instacart_care_tools_v1_User';
  active: Maybe<Scalars['Boolean']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

/** AuditFinding object */
export type Instacart_Cashflow_Nutella_V1_AuditFinding = {
  __typename?: 'instacart_cashflow_nutella_v1_AuditFinding';
  finding: Maybe<Scalars['JSON']>;
  metadata: Maybe<Scalars['JSON']>;
  uuid: Maybe<Scalars['String']>;
};

/** AuditItem object */
export type Instacart_Cashflow_Nutella_V1_AuditItem = {
  __typename?: 'instacart_cashflow_nutella_v1_AuditItem';
  auditFindings: Maybe<Array<Maybe<Instacart_Cashflow_Nutella_V1_AuditFinding>>>;
  createdDuringAuditReview: Maybe<Scalars['Boolean']>;
  data: Maybe<Scalars['JSON']>;
  entityType: Maybe<Scalars['String']>;
  uuid: Maybe<Scalars['String']>;
};

/** AuditItemFindings object */
export type Instacart_Cashflow_Nutella_V1_AuditItemFindings_Input = {
  auditItemUuid?: InputMaybe<Scalars['String']>;
  findings?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  newAuditItem?: InputMaybe<Instacart_Cashflow_Nutella_V1_NewAuditItem_Input>;
};

/** AuditReview object */
export type Instacart_Cashflow_Nutella_V1_AuditReview = {
  __typename?: 'instacart_cashflow_nutella_v1_AuditReview';
  auditItems: Maybe<Array<Maybe<Instacart_Cashflow_Nutella_V1_AuditItem>>>;
  escalationSourceAuditReview: Maybe<Instacart_Cashflow_Nutella_V1_AuditReview>;
  isCompleted: Maybe<Scalars['Boolean']>;
  isEscalation: Maybe<Scalars['Boolean']>;
  owner: Maybe<Scalars['String']>;
  requestContext: Maybe<Scalars['JSON']>;
  uuid: Maybe<Scalars['String']>;
  workflowName: Maybe<Scalars['String']>;
};

/** FeedbackAuditReview object */
export type Instacart_Cashflow_Nutella_V1_FeedbackAuditReview = {
  __typename?: 'instacart_cashflow_nutella_v1_FeedbackAuditReview';
  auditReviewCompletedAt: Maybe<Scalars['String']>;
  auditReviewUuid: Maybe<Scalars['String']>;
  escalatedAuditReviewCompletedAt: Maybe<Scalars['String']>;
  escalatedAuditReviewUuid: Maybe<Scalars['String']>;
};

/** FeedbackPagination object */
export type Instacart_Cashflow_Nutella_V1_FeedbackPagination = {
  __typename?: 'instacart_cashflow_nutella_v1_FeedbackPagination';
  pageNumber: Maybe<Scalars['BigInt']>;
  pageSize: Maybe<Scalars['BigInt']>;
  totalPages: Maybe<Scalars['BigInt']>;
};

/** FeedbackPagination object */
export type Instacart_Cashflow_Nutella_V1_FeedbackPagination_Input = {
  pageNumber?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  totalPages?: InputMaybe<Scalars['BigInt']>;
};

/** Request object for GetAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewRequest_Input = {
  auditReviewUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
};

/** Response object for GetAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetAuditReviewResponse';
  auditReview: Maybe<Instacart_Cashflow_Nutella_V1_AuditReview>;
};

/** Request object for GetAuditReviewsWithFeedback API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackRequest_Input = {
  client?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<Instacart_Cashflow_Nutella_V1_FeedbackPagination_Input>;
  userId?: InputMaybe<Scalars['String']>;
  workflowName?: InputMaybe<Scalars['String']>;
};

/** Response object for GetAuditReviewsWithFeedback API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetAuditReviewsWithFeedbackResponse';
  auditReviews: Maybe<Array<Maybe<Instacart_Cashflow_Nutella_V1_FeedbackAuditReview>>>;
  pagination: Maybe<Instacart_Cashflow_Nutella_V1_FeedbackPagination>;
};

/** Request object for GetNextAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetNextAuditReviewRequest_Input = {
  client?: InputMaybe<Scalars['String']>;
  isEscalation?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  workflowName?: InputMaybe<Scalars['String']>;
};

/** Response object for GetNextAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetNextAuditReviewResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetNextAuditReviewResponse';
  auditReview: Maybe<Instacart_Cashflow_Nutella_V1_AuditReview>;
};

/** Request object for GetWorkflowMetadata API */
export type Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataRequest_Input = {
  client?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  workflowName?: InputMaybe<Scalars['String']>;
};

/** Response object for GetWorkflowMetadata API */
export type Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetWorkflowMetadataResponse';
  metadata: Maybe<Scalars['JSON']>;
};

/** NewAuditItem object */
export type Instacart_Cashflow_Nutella_V1_NewAuditItem_Input = {
  data?: InputMaybe<Scalars['JSON']>;
  entityType?: InputMaybe<Scalars['String']>;
};

/** Request object for SetAuditFindings API */
export type Instacart_Cashflow_Nutella_V1_SetAuditFindingsRequest_Input = {
  auditItemFindings?: InputMaybe<Array<InputMaybe<Instacart_Cashflow_Nutella_V1_AuditItemFindings_Input>>>;
  auditReviewUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  isFinal?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Response object for SetAuditFindings API */
export type Instacart_Cashflow_Nutella_V1_SetAuditFindingsResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_SetAuditFindingsResponse';
  auditReviewUuid: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['String']>;
};

/** This is for auditing purposes, to record who made a change to the database. */
export type Instacart_Catalog_Admin_V1_Client_Input = {
  /**
   * Which service is requesting this change?
   * Possible values: "IPP", "CatalogAdmin", or "Storefront"
   */
  appName?: InputMaybe<Scalars['String']>;
  /** Any additional context needed for your particular API */
  contextJson?: InputMaybe<Scalars['String']>;
  /**
   * Deprecated
   * The remote user email of the user who is making the request
   * Deprecated because this potentially exposes PII and thus will not be used or stored in the future
   */
  userEmail?: InputMaybe<Scalars['String']>;
  /** The remote ID of the user who is making the request */
  userId?: InputMaybe<Scalars['String']>;
  /**
   * Deprecated
   * The remote user name of the user who is making the request
   * Deprecated because this potentially exposes PII and thus will not be used or stored in the future
   */
  userName?: InputMaybe<Scalars['String']>;
  /** The "type" of user ID being supplied. We currently support IPP and Instacart user types */
  userType?: InputMaybe<Scalars['String']>;
};

/** GetL2CategoriesRequest represents a request to retrieve all l2 categories belonging to the forcemark retailer reports for a list of retailer IDs */
export type Instacart_Catalog_Admin_V1_GetL2CategoriesRequest_Input = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetL2CategoriesResponse represents the response for all l2 categories belonging to the forcemark retailer reports for a list of retailer IDs */
export type Instacart_Catalog_Admin_V1_GetL2CategoriesResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetL2CategoriesResponse';
  l2Categories: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** GetMissingCodesForcemarksProductDetailsRequest represents a request to retrieve product details for a missing codes forcemark */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsRequest_Input = {
  missingCodeId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetMissingCodesForcemarkDetailsResponse represents the response containing missing codes forcemark details */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMissingCodesForcemarkDetailsResponse';
  localeId: Maybe<Scalars['BigInt']>;
  missingCode: Maybe<Scalars['String']>;
  nextMissingCodeId: Maybe<Scalars['BigInt']>;
  productId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  scannedCount: Maybe<Scalars['BigInt']>;
  scannedImages: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_ScannedImage>>>;
};

/** GetMissingCodesForcemarksRequest represents a request to retrieve missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksRequest_Input = {
  l2Category?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFilter?: InputMaybe<Scalars['String']>;
};

/** GetMissingCodesForcemarksResponse represents the response containing missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMissingCodesForcemarksResponse';
  /** Number of forcemarks returned */
  forcemarkCount: Maybe<Scalars['BigInt']>;
  /** Detailed list of forcemarks */
  forcemarks: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_MissingCodesForcemark>>>;
};

/** GetMissingCodesReviewedForcemarksRequest represents a request to retrieve reviewed missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksRequest_Input = {
  l2Category?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFilter?: InputMaybe<Scalars['String']>;
};

/** GetMissingCodesReviewedForcemarksResponse represents the response containing reviewed missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMissingCodesReviewedForcemarksResponse';
  /** Number of forcemarks returned */
  forcemarkCount: Maybe<Scalars['BigInt']>;
  /** Detailed list of reviewed forcemarks */
  forcemarks: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_MissingCodesReviewedForcemark>>>;
};

/** GetMlPriceAnomalyProductDetailsRequest represents a request to retrieve detailed information about a specific ML price anomaly product. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsRequest_Input = {
  /** For pagination of items */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetMlPriceAnomalyProductDetailsResponse represents the response containing product-level and item-level details for an ML price anomaly product. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductDetailsResponse';
  anomalyGroup: Maybe<Scalars['String']>;
  anomalyReason: Maybe<Scalars['String']>;
  detectedAt: Maybe<Scalars['DateTime']>;
  items: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse_MlPriceAnomalyItem>>>;
  mlExplanation: Maybe<Scalars['String']>;
  productImageUrl: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
  productSize: Maybe<Scalars['String']>;
  productUnitCount: Maybe<Scalars['String']>;
  sizeUom: Maybe<Scalars['String']>;
  /** Total number of items for this product (for pagination) */
  totalItemCount: Maybe<Scalars['BigInt']>;
};

/** MlPriceAnomalyItem represents an individual item within a product flagged by the ML price anomaly model. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse_MlPriceAnomalyItem = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductDetailsResponse_MlPriceAnomalyItem';
  actualCppu: Maybe<Scalars['String']>;
  actualLpp: Maybe<Scalars['String']>;
  anomalyGroup: Maybe<Scalars['String']>;
  costUnit: Maybe<Scalars['String']>;
  cppuIsAnomaly: Maybe<Scalars['Boolean']>;
  expectedCppuMax: Maybe<Scalars['String']>;
  expectedCppuMin: Maybe<Scalars['String']>;
  expectedLppMax: Maybe<Scalars['String']>;
  expectedLppMin: Maybe<Scalars['String']>;
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  itemId: Maybe<Scalars['BigInt']>;
  lppIsAnomaly: Maybe<Scalars['Boolean']>;
  mlExplanation: Maybe<Scalars['String']>;
};

/** GetMlPriceAnomalyProductsRequest represents a request to retrieve ML price anomaly products with optional filtering and pagination. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsRequest_Input = {
  /** Optional filter on anomaly group (e.g. "Base Price", "Sales", "Loyalty", "Promotion") */
  anomalyGroupFilter?: InputMaybe<Scalars['String']>;
  detectionEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional filter for detection date */
  detectionStartDate?: InputMaybe<Scalars['DateTime']>;
  /** For pagination */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  /** For sorting */
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional filter on product name */
  searchFilter?: InputMaybe<Scalars['String']>;
};

/** GetMlPriceAnomalyProductsResponse represents the response containing a list of ML price anomaly products and pagination metadata. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductsResponse';
  products: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse_MlPriceAnomalyProduct>>>;
  /** For pagination */
  totalCount: Maybe<Scalars['BigInt']>;
};

/** MlPriceAnomalyProduct represents a product flagged by the ML price anomaly model. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse_MlPriceAnomalyProduct = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductsResponse_MlPriceAnomalyProduct';
  anomalyGroup: Maybe<Scalars['String']>;
  anomalyReason: Maybe<Scalars['String']>;
  detectedAt: Maybe<Scalars['DateTime']>;
  itemCount: Maybe<Scalars['BigInt']>;
  mlExplanation: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  productImageUrl: Maybe<Scalars['String']>;
  /** These will be displayed in the table */
  productName: Maybe<Scalars['String']>;
};

/** GetPriceAlertProductDetailsRequest represents a request to retrieve detailed information about a specific product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsRequest_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetPriceAlertProductDetailsResponse represents the response containing detailed item-level information for a product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductDetailsResponse';
  alertPercentage: Maybe<Scalars['BigInt']>;
  detectionDate: Maybe<Scalars['DateTime']>;
  discountLimit: Maybe<Scalars['BigInt']>;
  items: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse_PriceAlertItem>>>;
};

/** PriceAlertItem represents an individual item within a product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse_PriceAlertItem = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductDetailsResponse_PriceAlertItem';
  basePrice: Maybe<Scalars['String']>;
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  isOverriden: Maybe<Scalars['Boolean']>;
  itemId: Maybe<Scalars['BigInt']>;
  salePrice: Maybe<Scalars['String']>;
};

/** GetPriceAlertProductsCategoriesRequest represents a request to retrieve categories for price alert products. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetPriceAlertProductsCategoriesResponse represents the response containing a hierarchical list of L1 and L2 categories for filtering price alerts. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsCategoriesResponse';
  l1Categories: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L1Category>>>;
};

/** L1Category represents a Level 1 category that contains multiple L2 categories. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L1Category = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsCategoriesResponse_L1Category';
  l1CategoryName: Maybe<Scalars['String']>;
  l2Categories: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L2Category>>>;
};

/** L2Category represents a Level 2 category. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L2Category = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsCategoriesResponse_L2Category';
  categoryId: Maybe<Scalars['BigInt']>;
  l2CategoryName: Maybe<Scalars['String']>;
};

/** GetPriceAlertProductsRequest represents a request to retrieve products that triggered price alerts with optional filtering and pagination. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsRequest_Input = {
  detectionEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional filter for detection date, use to filter on updated_at */
  detectionStartDate?: InputMaybe<Scalars['DateTime']>;
  /** For pagination */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  /** For sorting */
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional filter on product name */
  searchFilter?: InputMaybe<Scalars['String']>;
  /** Optional filter param for displaying specific categories */
  selectedCategories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetPriceAlertProductsResponse represents the response containing a list of products that triggered price alerts and pagination metadata. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsResponse';
  products: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse_PriceAlertProduct>>>;
  /** For pagination */
  totalCount: Maybe<Scalars['BigInt']>;
};

/** PriceAlertProduct represents a product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse_PriceAlertProduct = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsResponse_PriceAlertProduct';
  itemCount: Maybe<Scalars['BigInt']>;
  l2CategoryName: Maybe<Scalars['String']>;
  lowestSalePricePercentage: Maybe<Scalars['BigInt']>;
  productId: Maybe<Scalars['BigInt']>;
  /** These will be displayed in the table */
  productName: Maybe<Scalars['String']>;
  threshold: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/**
 * GetRetailerDiscountInitialThresholdsRequest represents a request to retrieve global discount thresholds.
 * Provide either partner_id to get thresholds for all retailers under that partner, or retailer_id for a specific retailer.
 */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsRequest_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetRetailerDiscountInitialThresholdsResponse represents the response containing global threshold data. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountInitialThresholdsResponse';
  /** Returns list of retailer thresholds (single item when querying by retailer_id, multiple when querying by partner_id) */
  retailerThresholds: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse_RetailerGlobalThreshold>>>;
};

/** RetailerGlobalThreshold represents a retailer's global discount threshold. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse_RetailerGlobalThreshold = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountInitialThresholdsResponse_RetailerGlobalThreshold';
  globalThreshold: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
};

/** GetRetailerDiscountThresholdsRequest represents a request to retrieve retailer discount thresholds with optional filtering and pagination. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsRequest_Input = {
  /** For pagination */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  /** For sorting */
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional search filter for category name, has priority over selected_categories */
  searchCategory?: InputMaybe<Scalars['String']>;
  /** Optional filter param for displaying specific categories (empty = display all categories) */
  selectedCategories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetRetailerDiscountThresholdsResponse represents the response containing a list of retailer discount thresholds and pagination metadata. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountThresholdsResponse';
  thresholds: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse_RetailerDiscountThreshold>>>;
  /** For pagination */
  totalCount: Maybe<Scalars['BigInt']>;
};

/** RetailerDiscountThreshold represents a discount threshold configuration for a specific category. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse_RetailerDiscountThreshold = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountThresholdsResponse_RetailerDiscountThreshold';
  categoryId: Maybe<Scalars['BigInt']>;
  /** These will be displayed in the table */
  l1CategoryName: Maybe<Scalars['String']>;
  l2CategoryName: Maybe<Scalars['String']>;
  productCount: Maybe<Scalars['BigInt']>;
  threshold: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Make a request to bring back one or more items via a CSV file */
export type Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvRequest_Input = {
  /** Required: Client making the request, already existing message. But we will add validations */
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** optional. Reason why item needs to be taken down */
  createdWhy?: InputMaybe<Scalars['String']>;
  /** Required: Filestack key used to retrieve the CSV */
  fileZipKey?: InputMaybe<Scalars['String']>;
  /** Optional. stringified json. Can be used to pass any metadata specific to a client. */
  metadata?: InputMaybe<Scalars['String']>;
};

/** A uuid to keep track is sent in the response */
export type Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvResponse = {
  __typename?: 'instacart_catalog_admin_v1_ItemBringBackBatchCsvResponse';
  bringBackBatchRequestUuid: Maybe<Scalars['String']>;
};

/** MakeMissingCodeDecisionRequest represents a request to submit a retailer decision on a missing codes forcemark */
export type Instacart_Catalog_Admin_V1_MakeMissingCodeDecisionRequest_Input = {
  decision?: InputMaybe<Scalars['String']>;
  localeId?: InputMaybe<Scalars['BigInt']>;
  missingCodeId?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scanCode?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** MissingCodesForcemark represents a forcemark entry for products with missing codes. */
export type Instacart_Catalog_Admin_V1_MissingCodesForcemark = {
  __typename?: 'instacart_catalog_admin_v1_MissingCodesForcemark';
  createdAt: Maybe<Scalars['String']>;
  forcemarkAuditCandidateId: Maybe<Scalars['BigInt']>;
  l2Category: Maybe<Scalars['String']>;
  missingCode: Maybe<Scalars['String']>;
  missingCodeId: Maybe<Scalars['BigInt']>;
  numberOfScans: Maybe<Scalars['BigInt']>;
  productDisplayName: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
};

/** MissingCodesReviewedForcemark represents a reviewed forcemark entry for products with missing codes. */
export type Instacart_Catalog_Admin_V1_MissingCodesReviewedForcemark = {
  __typename?: 'instacart_catalog_admin_v1_MissingCodesReviewedForcemark';
  actionTaken: Maybe<Scalars['String']>;
  dateOfAction: Maybe<Scalars['String']>;
  forcemarkAuditCandidateId: Maybe<Scalars['BigInt']>;
  l2Category: Maybe<Scalars['String']>;
  missingCode: Maybe<Scalars['String']>;
  missingCodeId: Maybe<Scalars['BigInt']>;
  productDisplayName: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
};

/** ScannedImage represents a scanned image with ranking and URL */
export type Instacart_Catalog_Admin_V1_ScannedImage = {
  __typename?: 'instacart_catalog_admin_v1_ScannedImage';
  ranking: Maybe<Scalars['BigInt']>;
  url: Maybe<Scalars['String']>;
};

/** Request to search for taxonomy nodes */
export type Instacart_Catalog_Admin_V1_SearchTaxonomyNodesRequest_Input = {
  /** Required. Client making the request */
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** Required. A string to match against the taxonomy path of a taxonomy node */
  taxonomyPathFuzzyWord?: InputMaybe<Scalars['String']>;
};

/** Response object from searching for taxonomy nodes */
export type Instacart_Catalog_Admin_V1_SearchTaxonomyNodesResponse = {
  __typename?: 'instacart_catalog_admin_v1_SearchTaxonomyNodesResponse';
  /** A list of matching taxonomy nodes */
  nodes: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_TaxonomyNode>>>;
};

/** SetRetailerDiscountThresholdBringBacksRequest represents a request to bring back items that were taken down due to discount thresholds or reverse a previous bring back. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_Input = {
  /** Indicates if it's a bringback or reversing a bringback */
  isBringback?: InputMaybe<Scalars['Boolean']>;
  itemIdsList?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ItemIds_Input>;
  productIdsList?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ProductIds_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** ItemIds represents a list of item IDs to bring back. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ItemIds_Input = {
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  productId?: InputMaybe<Scalars['BigInt']>;
};

/** ProductIds represents a list of product IDs to bring back. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ProductIds_Input = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** SetRetailerDiscountThresholdsRequest represents a request to set or update retailer discount thresholds for specific categories or globally. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdsRequest_Input = {
  /** A list of l2 category IDs */
  categories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** If this is true, instead update the global default threshold, ignore categories list */
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Taxonomy Node */
export type Instacart_Catalog_Admin_V1_TaxonomyNode = {
  __typename?: 'instacart_catalog_admin_v1_TaxonomyNode';
  /** Identifier for the node */
  id: Maybe<Scalars['String']>;
  /** The name of the category for this node */
  productCategory: Maybe<Scalars['String']>;
  /** Category path for the node */
  productCategoryPath: Maybe<Scalars['String']>;
};

/** This is used to specify the attribute and value to override. */
export type Instacart_Catalog_Admin_V1_TempOverrideAttrInput_Input = {
  /**
   * This should be a JSON value in the form of { "<ATTRIBUTE_NAME>": ATTRIBUTE_VALUE }.
   * e.g. "{\"name\": \"Pickles\"}"
   * This form allows you to pass any type of value.
   * Only include one attribute per TempOverrideAttrInput.
   */
  attribute?: InputMaybe<Scalars['String']>;
  /**
   * This is field is required for updating some attributes.
   * For the "name" attribute, you must include the brand name here like this:
   * "{\"brand_name\": \"<BRAND_NAME>\"}"
   * e.g. "{\"brand_name\": \"Klaussen\"}"
   */
  metadata?: InputMaybe<Scalars['String']>;
  /**
   * Optional field. If true, the any override for the named attribute will be
   * tombstoned, regardless of metadata or value.
   */
  tombstone?: InputMaybe<Scalars['Boolean']>;
};

/** This is the output for a single temporary override attribute. */
export type Instacart_Catalog_Admin_V1_TempOverrideAttrOutput = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideAttrOutput';
  /** This is a JSON value in the form of { "<ATTRIBUTE_NAME>": ATTRIBUTE_VALUE }. */
  attribute: Maybe<Scalars['String']>;
  /** This is when the override was created. */
  createdAt: Maybe<Scalars['DateTime']>;
};

/** This message is used to specify the entity for which the temporary override applies to. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityId = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideEntityId';
  /** Only required for Items. This should be left empty for retailer products. */
  itemId: Maybe<Scalars['BigInt']>;
  /** Required */
  localeId: Maybe<Scalars['BigInt']>;
  /** Required */
  productId: Maybe<Scalars['BigInt']>;
  /** Required */
  retailerId: Maybe<Scalars['BigInt']>;
  /** Required */
  surfaceId: Maybe<Scalars['BigInt']>;
};

/** This message is used to specify the entity for which the temporary override applies to. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input = {
  /** Only required for Items. This should be left empty for retailer products. */
  itemId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  localeId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  productId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

/** This is used to specify the entity and attrs for which the temporary override applies to. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityInput_Input = {
  /** Required */
  entityId?: InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input>;
  /**
   * Required
   * You can specify multiple attributes to override.
   */
  tempOverrideAttrs?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideAttrInput_Input>>>;
};

/** This is the output for the temporary overrides for a single entity. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityOutput = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideEntityOutput';
  /** This can be "pending", "applied", or "published" */
  currentState: Maybe<Scalars['String']>;
  /** The entity the attribute data corresponds to. */
  entityId: Maybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId>;
  /** The patch ID for the Temp Override. */
  patchId: Maybe<Scalars['BigInt']>;
  /**
   * The attributes that have been overridden.
   * This is a combo of Pending Temp Overrides and Published Temp Overrides.
   */
  tempOverrideAttrs: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_TempOverrideAttrOutput>>>;
  /** The ID for the Temp Override. */
  tempOverrideId: Maybe<Scalars['BigInt']>;
};

/** Used to create a temporary override for a retailer product or item. */
export type Instacart_Catalog_Admin_V1_TempOverrideServiceCreateRequest_Input = {
  /** Put the app name, user name, and user ID here. This will be added to the "created_why" field. */
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** Required */
  tempOverrideEntities?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityInput_Input>>>;
};

/** Used to request a list of temporary overrides for a set of retailer products or items. */
export type Instacart_Catalog_Admin_V1_TempOverrideServiceListRequest_Input = {
  /**
   * Required
   * You need to specify at least one entity to get the overrides for.
   */
  entities?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input>>>;
  /**
   * Optional.
   * Set this to "item" if you specify an RP and you want the item overrides
   * All other values will default to match the same entity that you requested.
   */
  responseEntityType?: InputMaybe<Scalars['String']>;
};

/** Response for listing temporary overrides. */
export type Instacart_Catalog_Admin_V1_TempOverrideServiceListResponse = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideServiceListResponse';
  tempOverrideEntities: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_TempOverrideEntityOutput>>>;
};

/** Representation of Create New Step Request */
export type Instacart_Catalog_Catflow_V1_CreateNewStepRequest_Input = {
  /** required */
  attributes?: InputMaybe<Scalars['JSON']>;
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  step?: InputMaybe<Instacart_Catalog_Catflow_V1_Step_Input>;
};

/** Representation of Create New Step Response */
export type Instacart_Catalog_Catflow_V1_CreateNewStepResponse = {
  __typename?: 'instacart_catalog_catflow_v1_CreateNewStepResponse';
  id: Maybe<Scalars['BigInt']>;
};

/** Representation of Create New Step Version Request */
export type Instacart_Catalog_Catflow_V1_CreateNewStepVersionRequest_Input = {
  attributes?: InputMaybe<Scalars['JSON']>;
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  createdBy?: InputMaybe<Scalars['String']>;
  /** required */
  createdWhy?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  state?: InputMaybe<Scalars['String']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
};

/** Representation of Create New Step Version Response */
export type Instacart_Catalog_Catflow_V1_CreateNewStepVersionResponse = {
  __typename?: 'instacart_catalog_catflow_v1_CreateNewStepVersionResponse';
  id: Maybe<Scalars['BigInt']>;
};

/** Input for DescribeSnowflakeTable endpoint */
export type Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required - fully qualified name of the table you wish to describe. */
  tableName?: InputMaybe<Scalars['String']>;
};

/** Output for DescribeSnowflakeTable endpoint */
export type Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableResponse = {
  __typename?: 'instacart_catalog_catflow_v1_DescribeSnowflakeTableResponse';
  columns: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_SnowflakeTableColumn>>>;
};

export type Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
};

export type Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetPresignedUploadUrlResponse';
  bucket: Maybe<Scalars['String']>;
  key: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** Representation of Get Step Run Results Request */
export type Instacart_Catalog_Catflow_V1_GetStepRunResultsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  stepRunId?: InputMaybe<Scalars['BigInt']>;
};

/** Representation of Get Step Run Results Response */
export type Instacart_Catalog_Catflow_V1_GetStepRunResultsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetStepRunResultsResponse';
  results: Maybe<Scalars['String']>;
};

export type Instacart_Catalog_Catflow_V1_GetStepVersionHistoryRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_GetStepVersionHistoryResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetStepVersionHistoryResponse';
  stepVersion: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_StepVersion>>>;
};

/** Representation of Get Step Version Request */
export type Instacart_Catalog_Catflow_V1_GetStepVersionRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

/** Representation of Get Step Version Response */
export type Instacart_Catalog_Catflow_V1_GetStepVersionResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetStepVersionResponse';
  stepVersion: Maybe<Instacart_Catalog_Catflow_V1_StepVersion>;
};

/** Representation of List Step Runs Request */
export type Instacart_Catalog_Catflow_V1_ListStepRunsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  stepVersionId?: InputMaybe<Scalars['BigInt']>;
};

/** Representation of List Step Run Response */
export type Instacart_Catalog_Catflow_V1_ListStepRunsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_ListStepRunsResponse';
  currentPage: Maybe<Scalars['BigInt']>;
  pageCount: Maybe<Scalars['BigInt']>;
  stepRuns: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_StepRun>>>;
};

export type Instacart_Catalog_Catflow_V1_ListStepVersionsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  stepId?: InputMaybe<Scalars['BigInt']>;
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_ListStepVersionsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_ListStepVersionsResponse';
  stepVersions: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_StepVersion>>>;
};

export type Instacart_Catalog_Catflow_V1_ListStepsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  stepType?: InputMaybe<Scalars['String']>;
};

/** Representation of List Steps Response */
export type Instacart_Catalog_Catflow_V1_ListStepsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_ListStepsResponse';
  steps: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_Step>>>;
  totalResultCount: Maybe<Scalars['BigInt']>;
};

/** Representation of Revert To Step Version Request */
export type Instacart_Catalog_Catflow_V1_RevertToStepVersionRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  /** required */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_RunManualStepTestRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  createdBy?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  inputS3File?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** required */
  stepVersionId?: InputMaybe<Scalars['BigInt']>;
  /** required */
  testInputs?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Instacart_Catalog_Catflow_V1_RunManualStepTestResponse = {
  __typename?: 'instacart_catalog_catflow_v1_RunManualStepTestResponse';
  warningMessage: Maybe<Scalars['String']>;
  workflowRunId: Maybe<Scalars['String']>;
};

/** Representation of a column of a snowflake table */
export type Instacart_Catalog_Catflow_V1_SnowflakeTableColumn = {
  __typename?: 'instacart_catalog_catflow_v1_SnowflakeTableColumn';
  default: Maybe<Scalars['String']>;
  kind: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  nullable: Maybe<Scalars['Boolean']>;
  primaryKey: Maybe<Scalars['Boolean']>;
  type: Maybe<Scalars['String']>;
  uniqueKey: Maybe<Scalars['Boolean']>;
};

/** Representation of Step Object */
export type Instacart_Catalog_Catflow_V1_Step = {
  __typename?: 'instacart_catalog_catflow_v1_Step';
  /** required */
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  /** required */
  name: Maybe<Scalars['String']>;
  /** required */
  owner: Maybe<Scalars['String']>;
  /** required */
  stepCategory: Maybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  tombstoned: Maybe<Scalars['Boolean']>;
  /** required */
  type: Maybe<Scalars['String']>;
};

/**
 * CAMP Pipeline Step APIs                //
 *
 * Enum Representation for Step Category
 */
export enum Instacart_Catalog_Catflow_V1_StepCategory {
  ApiService = 'API_SERVICE',
  Audit = 'AUDIT',
  ExtractionModel = 'EXTRACTION_MODEL',
  Input = 'INPUT',
  Normalization = 'NORMALIZATION',
  Pipeline = 'PIPELINE',
  Publish = 'PUBLISH',
  Unknown = 'UNKNOWN',
  Validation = 'VALIDATION'
}

export type Instacart_Catalog_Catflow_V1_StepRun = {
  __typename?: 'instacart_catalog_catflow_v1_StepRun';
  /** required */
  createdAt: Maybe<Scalars['DateTime']>;
  dashboardUrl: Maybe<Scalars['String']>;
  failedReasons: Maybe<Scalars['String']>;
  failedTaskCount: Maybe<Scalars['BigInt']>;
  /** required */
  id: Maybe<Scalars['BigInt']>;
  /** required */
  productCount: Maybe<Scalars['BigInt']>;
  /** required */
  requester: Maybe<Scalars['String']>;
  /** required */
  state: Maybe<Scalars['String']>;
  stateMessage: Maybe<Scalars['String']>;
  /** required */
  version: Maybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_StepVersion = {
  __typename?: 'instacart_catalog_catflow_v1_StepVersion';
  /** required */
  attributes: Maybe<Scalars['JSON']>;
  /** required */
  createdAt: Maybe<Scalars['DateTime']>;
  /** required */
  createdBy: Maybe<Scalars['String']>;
  /** required */
  createdWhy: Maybe<Scalars['String']>;
  /** required */
  id: Maybe<Scalars['BigInt']>;
  /** required */
  state: Maybe<Scalars['String']>;
  step: Maybe<Instacart_Catalog_Catflow_V1_Step>;
  /** required */
  stepId: Maybe<Scalars['BigInt']>;
  tombstoned: Maybe<Scalars['Boolean']>;
  /** required */
  version: Maybe<Scalars['BigInt']>;
};

/** Representation of Step Object */
export type Instacart_Catalog_Catflow_V1_Step_Input = {
  /** required */
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** required */
  name?: InputMaybe<Scalars['String']>;
  /** required */
  owner?: InputMaybe<Scalars['String']>;
  /** required */
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
  /** required */
  type?: InputMaybe<Scalars['String']>;
};

export type Instacart_Catalog_Catflow_V1_UpdateStepRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_UpdateStepVersionStateRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  newState?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  /** required */
  stepVersionId?: InputMaybe<Scalars['BigInt']>;
};

/** ApiConfig configures direct API integration */
export type Instacart_Catalog_Data_Bridge_V1_ApiConfig = {
  __typename?: 'instacart_catalog_data_bridge_v1_ApiConfig';
  /** Required: API endpoint URL */
  endpoint: Maybe<Scalars['String']>;
  /** Optional: request timeout in seconds (default: 30) */
  timeout_seconds: Maybe<Scalars['Int']>;
};

/** ApiConfig configures direct API integration */
export type Instacart_Catalog_Data_Bridge_V1_ApiConfig_Input = {
  /** Required: API endpoint URL */
  endpoint?: InputMaybe<Scalars['String']>;
  /** Optional: request timeout in seconds (default: 30) */
  timeout_seconds?: InputMaybe<Scalars['Int']>;
};

/** Batch represents a single execution of a bridge */
export type Instacart_Catalog_Data_Bridge_V1_Batch = {
  __typename?: 'instacart_catalog_data_bridge_v1_Batch';
  /** UUID, unique identifier for this batch */
  batch_id: Maybe<Scalars['String']>;
  /** Name of the bridge that created this batch */
  bridge_name: Maybe<Scalars['String']>;
  /** When the batch was created */
  created_at: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the creator (user or system) */
  created_by: Maybe<Scalars['String']>;
  /** S3 path to input data */
  input_s3_location: Maybe<Scalars['String']>;
  /** User-provided metadata */
  metadata: Maybe<Scalars['JSON']>;
  /** Optional: S3 path where output should be written */
  output_s3_location: Maybe<Scalars['String']>;
  /** Current status of the batch */
  status: Maybe<Scalars['String']>;
};

/** BatchEvent represents a single event in a batch's lifecycle (event-sourced status tracking) */
export type Instacart_Catalog_Data_Bridge_V1_BatchEvent = {
  __typename?: 'instacart_catalog_data_bridge_v1_BatchEvent';
  /** When the event occurred */
  created_at: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the actor (user or system) */
  created_by: Maybe<Scalars['String']>;
  /** Event-specific data */
  data: Maybe<Scalars['JSON']>;
  /** Event type (e.g., "batch.submitted", "batch.started", "batch.completed") */
  type: Maybe<Scalars['String']>;
};

/** Bridge represents a data connector between two systems */
export type Instacart_Catalog_Data_Bridge_V1_Bridge = {
  __typename?: 'instacart_catalog_data_bridge_v1_Bridge';
  /** Bridge configuration (schemas, execution, SLA, etc.) */
  config: Maybe<Instacart_Catalog_Data_Bridge_V1_BridgeConfig>;
  /** When the bridge was created */
  created_at: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the creator (user or system) */
  created_by: Maybe<Scalars['String']>;
  /** Human-readable description of what this bridge does */
  description: Maybe<Scalars['String']>;
  /** Bridge ID */
  id: Maybe<Scalars['BigInt']>;
  /** Unique identifier (e.g., "product-tax-taxonomy-classification") */
  name: Maybe<Scalars['String']>;
  /** Whether the bridge is deleted (false = active) */
  tombstoned: Maybe<Scalars['Boolean']>;
  /** When the bridge was last updated */
  updated_at: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the last updater (user or system) */
  updated_by: Maybe<Scalars['String']>;
  /** Reason for the last update */
  updated_why: Maybe<Scalars['String']>;
};

/** BridgeConfig contains schemas and execution configuration for a bridge */
export type Instacart_Catalog_Data_Bridge_V1_BridgeConfig = {
  __typename?: 'instacart_catalog_data_bridge_v1_BridgeConfig';
  /** Direct API integration */
  api: Maybe<Instacart_Catalog_Data_Bridge_V1_ApiConfig>;
  /** Required: input data schema (JSON Schema format) */
  input_schema: Maybe<Scalars['JSON']>;
  /** ISC (Instacart Service Cloud) task execution */
  isc_task: Maybe<Instacart_Catalog_Data_Bridge_V1_IscTaskConfig>;
  /** Optional: maximum retry attempts on failure (default: 0) */
  max_retries: Maybe<Scalars['Int']>;
  output_schema: Maybe<Scalars['JSON']>;
  /** Optional: when true, validate input/output S3 files against input_schema/output_schema (default: false) */
  schema_validation_enabled: Maybe<Scalars['Boolean']>;
  /** Required: SLA in hours (supports fractional, e.g., 0.5 = 30 min) */
  sla_hours: Maybe<Scalars['Float']>;
};

/** BridgeConfig contains schemas and execution configuration for a bridge */
export type Instacart_Catalog_Data_Bridge_V1_BridgeConfig_Input = {
  /** Direct API integration */
  api?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_ApiConfig_Input>;
  /** Required: input data schema (JSON Schema format) */
  input_schema?: InputMaybe<Scalars['JSON']>;
  /** ISC (Instacart Service Cloud) task execution */
  isc_task?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_IscTaskConfig_Input>;
  /** Optional: maximum retry attempts on failure (default: 0) */
  max_retries?: InputMaybe<Scalars['Int']>;
  output_schema?: InputMaybe<Scalars['JSON']>;
  /** Optional: when true, validate input/output S3 files against input_schema/output_schema (default: false) */
  schema_validation_enabled?: InputMaybe<Scalars['Boolean']>;
  /** Required: SLA in hours (supports fractional, e.g., 0.5 = 30 min) */
  sla_hours?: InputMaybe<Scalars['Float']>;
};

/** CreateBatchEventRequest contains parameters for creating a batch event */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchEventRequest_Input = {
  /** Required: batch ID to add event to */
  batch_id?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the event creator (user or system) */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: event-specific data */
  data?: InputMaybe<Scalars['JSON']>;
  /** Required: event type (e.g., "batch.processing_started", "batch.completed") */
  event_type?: InputMaybe<Scalars['String']>;
};

/** CreateBatchEventResponse returns the created batch event */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchEventResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_CreateBatchEventResponse';
  /** The created batch event */
  event: Maybe<Instacart_Catalog_Data_Bridge_V1_BatchEvent>;
};

/** CreateBatchRequest contains parameters for creating a new batch execution */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchRequest_Input = {
  /** Required: bridge name to execute */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the creator (user or system) */
  created_by?: InputMaybe<Scalars['String']>;
  /** Required: S3 path to input data */
  input_s3_location?: InputMaybe<Scalars['String']>;
  /** Optional: user-provided metadata (tags, labels, etc.) */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Optional: S3 path where output should be written */
  output_s3_location?: InputMaybe<Scalars['String']>;
};

/** CreateBatchResponse returns the newly created batch */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_CreateBatchResponse';
  /** The created batch */
  batch: Maybe<Instacart_Catalog_Data_Bridge_V1_Batch>;
};

/** CreateBridgeRequest contains parameters for creating a new bridge */
export type Instacart_Catalog_Data_Bridge_V1_CreateBridgeRequest_Input = {
  /** Required: bridge configuration */
  config?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_BridgeConfig_Input>;
  /** Required: human-readable name of the creator (user or system) */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: human-readable description */
  description?: InputMaybe<Scalars['String']>;
  /** Required: unique bridge identifier (alphanumeric, lowercase, hyphens) */
  name?: InputMaybe<Scalars['String']>;
  /** Optional: whether bridge is active (default: false = active) */
  tombstoned?: InputMaybe<Scalars['Boolean']>;
};

/** CreateBridgeResponse returns the newly created bridge */
export type Instacart_Catalog_Data_Bridge_V1_CreateBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_CreateBridgeResponse';
  /** The created bridge */
  bridge: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** DeleteBridgeRequest contains parameters for soft deleting a bridge */
export type Instacart_Catalog_Data_Bridge_V1_DeleteBridgeRequest_Input = {
  /** Required: bridge name to delete (soft delete, sets tombstoned=true) */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the deleter (user or system) */
  deleted_by?: InputMaybe<Scalars['String']>;
  /** Required: reason for the deletion */
  deleted_why?: InputMaybe<Scalars['String']>;
};

/** DeleteBridgeResponse returns the soft-deleted bridge */
export type Instacart_Catalog_Data_Bridge_V1_DeleteBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_DeleteBridgeResponse';
  /** The deleted bridge (with tombstoned=true) */
  bridge: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** GetBatchRequest contains parameters for retrieving a batch */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchRequest_Input = {
  /** Required: batch ID to query */
  batch_id?: InputMaybe<Scalars['String']>;
};

/** GetBatchResponse returns batch information without event history */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_GetBatchResponse';
  /** Batch information without events */
  batch: Maybe<Instacart_Catalog_Data_Bridge_V1_Batch>;
};

/** GetBatchStatusRequest contains parameters for retrieving batch status with event history */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchStatusRequest_Input = {
  /** Required: batch ID to query */
  batch_id?: InputMaybe<Scalars['String']>;
  /** Optional: limit number of events returned (default: 10) */
  max_events?: InputMaybe<Scalars['Int']>;
};

/** GetBatchStatusResponse returns the current status and event history */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchStatusResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_GetBatchStatusResponse';
  /** Convenience: echoed from request */
  batch_id: Maybe<Scalars['String']>;
  /** Event history (most recent first) */
  events: Maybe<Array<Maybe<Instacart_Catalog_Data_Bridge_V1_BatchEvent>>>;
  /** Current status of the batch */
  status: Maybe<Scalars['String']>;
};

/** GetBridgeRequest contains parameters for retrieving a bridge */
export type Instacart_Catalog_Data_Bridge_V1_GetBridgeRequest_Input = {
  /** Required: bridge name */
  bridge_name?: InputMaybe<Scalars['String']>;
};

/** GetBridgeResponse returns the requested bridge */
export type Instacart_Catalog_Data_Bridge_V1_GetBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_GetBridgeResponse';
  /** The requested bridge */
  bridge: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** IscTaskConfig configures ISC (Instacart Service Cloud) task execution */
export type Instacart_Catalog_Data_Bridge_V1_IscTaskConfig = {
  __typename?: 'instacart_catalog_data_bridge_v1_IscTaskConfig';
  /** Optional: key-value pairs for {additional_parameters} placeholder */
  additional_task_parameters: Maybe<Scalars['JSON']>;
  /** Required: command template with placeholders {input_file}, {output_file}, {additional_parameters} */
  command_template: Maybe<Scalars['String']>;
  /** Required: ISC app name for build lookup */
  isc_app_name: Maybe<Scalars['String']>;
  /** Required: name of the ISC task to execute */
  isc_task_name: Maybe<Scalars['String']>;
};

/** IscTaskConfig configures ISC (Instacart Service Cloud) task execution */
export type Instacart_Catalog_Data_Bridge_V1_IscTaskConfig_Input = {
  /** Optional: key-value pairs for {additional_parameters} placeholder */
  additional_task_parameters?: InputMaybe<Scalars['JSON']>;
  /** Required: command template with placeholders {input_file}, {output_file}, {additional_parameters} */
  command_template?: InputMaybe<Scalars['String']>;
  /** Required: ISC app name for build lookup */
  isc_app_name?: InputMaybe<Scalars['String']>;
  /** Required: name of the ISC task to execute */
  isc_task_name?: InputMaybe<Scalars['String']>;
};

/** ListBatchesRequest contains parameters for listing batches with optional filters */
export type Instacart_Catalog_Data_Bridge_V1_ListBatchesRequest_Input = {
  /** Optional: filter by bridge name */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Optional: filter by creator */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: start of date range filter */
  from_date?: InputMaybe<Scalars['DateTime']>;
  /** Optional: max results to return (default: 50) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Optional: pagination offset (default: 0) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Optional: end of date range filter */
  to_date?: InputMaybe<Scalars['DateTime']>;
};

/** ListBatchesResponse returns a list of batches with total count */
export type Instacart_Catalog_Data_Bridge_V1_ListBatchesResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_ListBatchesResponse';
  /** List of batches */
  batches: Maybe<Array<Maybe<Instacart_Catalog_Data_Bridge_V1_Batch>>>;
  /** Total number of batches matching the query */
  total_count: Maybe<Scalars['Int']>;
};

/** ListBridgesRequest contains parameters for listing bridges */
export type Instacart_Catalog_Data_Bridge_V1_ListBridgesRequest_Input = {
  /** Optional: filter by creator */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: include deleted bridges (default: false) */
  include_tombstoned?: InputMaybe<Scalars['Boolean']>;
  /** Optional: max results to return (default: 50) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Optional: pagination offset (default: 0) */
  offset?: InputMaybe<Scalars['Int']>;
};

/** ListBridgesResponse returns a list of bridges with total count */
export type Instacart_Catalog_Data_Bridge_V1_ListBridgesResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_ListBridgesResponse';
  /** List of bridges */
  bridges: Maybe<Array<Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>>>;
  /** Total number of bridges matching the query */
  total_count: Maybe<Scalars['Int']>;
};

/** UpdateBridgeRequest contains parameters for updating a bridge */
export type Instacart_Catalog_Data_Bridge_V1_UpdateBridgeRequest_Input = {
  /** Required: bridge name to update */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Optional: updated bridge configuration */
  config?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_BridgeConfig_Input>;
  /** Optional: updated description */
  description?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the updater (user or system) */
  updated_by?: InputMaybe<Scalars['String']>;
  /** Required: reason for the update */
  updated_why?: InputMaybe<Scalars['String']>;
};

/** UpdateBridgeResponse returns the updated bridge */
export type Instacart_Catalog_Data_Bridge_V1_UpdateBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_UpdateBridgeResponse';
  /** The updated bridge */
  bridge: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** GetProductCountsRequest is the request message for GetProductCounts. */
export type Instacart_Catalog_Health_V1_GetProductCountsRequest_Input = {
  /** The name of the query to run. Valid values: available_parity, file_ingestion_failures, items_on_sale_promo_loyalty, product_size_dimensions, unmatched_lead_codes */
  queryName?: InputMaybe<Scalars['String']>;
  /** Optional. If set, polls for result of a previous async request. */
  requestId?: InputMaybe<Scalars['String']>;
  /** The retailer ID to filter queries by. */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** GetProductCountsResponse is the response message for GetProductCounts. */
export type Instacart_Catalog_Health_V1_GetProductCountsResponse = {
  __typename?: 'instacart_catalog_health_v1_GetProductCountsResponse';
  /** Populated when status = STATUS_ERROR. */
  errorMessage: Maybe<Scalars['String']>;
  /** The list of product count metrics as key-value pairs. */
  productCounts: Maybe<Array<Maybe<Instacart_Catalog_Health_V1_ProductCount>>>;
  /** The request ID for polling. */
  requestId: Maybe<Scalars['String']>;
  /** The status of the async query. */
  status: Maybe<Instacart_Catalog_Health_V1_Status>;
};

/** ProductCount represents a single key-value metric from the product counts query. */
export type Instacart_Catalog_Health_V1_ProductCount = {
  __typename?: 'instacart_catalog_health_v1_ProductCount';
  /** The name of the column or metric. */
  columnName: Maybe<Scalars['String']>;
  /**
   * The value of the column or metric, represented as a string.
   * Values may be numeric, date, or text depending on the Snowflake query.
   */
  columnValue: Maybe<Scalars['String']>;
};

/** Status of an async query. */
export enum Instacart_Catalog_Health_V1_Status {
  StatusComplete = 'STATUS_COMPLETE',
  StatusError = 'STATUS_ERROR',
  StatusPending = 'STATUS_PENDING',
  StatusUnknown = 'STATUS_UNKNOWN'
}

export type Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsReponse = {
  __typename?: 'instacart_customers_basket_products_orchestrators_v1_GetBasketProductsReponse';
  /** a list of BasketProduct */
  basketProducts: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct>>>;
};

export type Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsRequest_Input = {
  includeComboPromotions?: InputMaybe<Scalars['Boolean']>;
  loadUnattachedCoupons?: InputMaybe<Scalars['Boolean']>;
  noUser?: InputMaybe<Scalars['instacart_customers_basket_products_orchestrators_v1_GetBasketProductsRequest_NoUser_Input']>;
  references?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_Input>>>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  restrictUnpurchasable?: InputMaybe<Scalars['Boolean']>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  snapshottable?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentRequest_Input = {
  programContent?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent_Input>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentResponse = {
  __typename?: 'instacart_customers_business_admin_v1_CreateBusinessProgramContentResponse';
  programContent: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
  programOffer?: InputMaybe<Instacart_Customers_Business_Types_V1_ProgramOffer_Input>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferResponse = {
  __typename?: 'instacart_customers_business_admin_v1_CreateBusinessProgramOfferResponse';
  programOffer: Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>;
};

/** Requests & Responses */
export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramRequest_Input = {
  businessProgramWithoutOffers?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgram_Input>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_CreateBusinessProgramResponse';
  businessProgramWithoutOffers: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>;
};

export type Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramContentRequest_Input = {
  businessProgramContentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramOfferRequest_Input = {
  businessProgramOfferId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramContentByProgramIdResponse';
  programContent: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>>>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentRequest_Input = {
  programContentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramContentResponse';
  programContent: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferRequest_Input = {
  businessProgramOfferId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramOfferResponse';
  programOffer: Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramOffersByProgramIdResponse';
  programOffers: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>>>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramResponse';
  businessProgram: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>;
};

export type Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_Input = {
  orderBy?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_ListBusinessProgramRequestOrderBy>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export enum Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_ListBusinessProgramRequestOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  OrderByUnspecified = 'ORDER_BY_UNSPECIFIED'
}

export type Instacart_Customers_Business_Admin_V1_ListBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_ListBusinessProgramResponse';
  businessPrograms: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessFilterSet_Input = {
  businessMemberEmail?: InputMaybe<Scalars['String']>;
  businessMemberId?: InputMaybe<Scalars['BigInt']>;
  businessMemberUserId?: InputMaybe<Scalars['BigInt']>;
  businessType?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessType>;
};

export enum Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  OrderByUnspecified = 'ORDER_BY_UNSPECIFIED'
}

export type Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_Input = {
  filters?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessFilterSet_Input>;
  orderBy?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessOrderBy>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Business_Admin_V1_ListBusinessesResponse = {
  __typename?: 'instacart_customers_business_admin_v1_ListBusinessesResponse';
  businesses: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_Business>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentRequest_Input = {
  programContent?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent_Input>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentResponse = {
  __typename?: 'instacart_customers_business_admin_v1_UpdateBusinessProgramContentResponse';
  programContent: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferRequest_Input = {
  programOffer?: InputMaybe<Instacart_Customers_Business_Types_V1_ProgramOffer_Input>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferResponse = {
  __typename?: 'instacart_customers_business_admin_v1_UpdateBusinessProgramOfferResponse';
  programOffer: Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramRequest_Input = {
  businessProgramWithoutOffers?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgram_Input>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_UpdateBusinessProgramResponse';
  businessProgramWithoutOffers: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>;
};

export type Instacart_Customers_Business_Types_V1_Business = {
  __typename?: 'instacart_customers_business_types_v1_Business';
  businessCategory: Maybe<Scalars['String']>;
  businessType: Maybe<Instacart_Customers_Business_Types_V1_BusinessType>;
  countryId: Maybe<Scalars['BigInt']>;
  createdAtUtc: Maybe<Scalars['DateTime']>;
  deactivatedAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  updatedAtUtc: Maybe<Scalars['DateTime']>;
  verified: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgram = {
  __typename?: 'instacart_customers_business_types_v1_BusinessProgram';
  active: Maybe<Scalars['Boolean']>;
  businessId: Maybe<Scalars['BigInt']>;
  createdAtUtc: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  offers: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>>>;
  programCode: Maybe<Scalars['String']>;
  programType: Maybe<Instacart_Customers_Business_Types_V1_ProgramType>;
  updatedAtUtc: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgramContent = {
  __typename?: 'instacart_customers_business_types_v1_BusinessProgramContent';
  availabilityCondition: Maybe<Scalars['String']>;
  businessProgramId: Maybe<Scalars['BigInt']>;
  cobrandedLogoAlt: Maybe<Scalars['String']>;
  cobrandedLogoUrl: Maybe<Scalars['String']>;
  createdAtUtc: Maybe<Scalars['DateTime']>;
  ctaText: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  heading: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  locale: Maybe<Instacart_Customers_Shared_V1_Locale>;
  offerImageUrl: Maybe<Scalars['String']>;
  terms: Maybe<Scalars['String']>;
  updatedAtUtc: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgramContent_Input = {
  availabilityCondition?: InputMaybe<Scalars['String']>;
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
  cobrandedLogoAlt?: InputMaybe<Scalars['String']>;
  cobrandedLogoUrl?: InputMaybe<Scalars['String']>;
  createdAtUtc?: InputMaybe<Scalars['DateTime']>;
  ctaText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  offerImageUrl?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['String']>;
  updatedAtUtc?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgram_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  businessId?: InputMaybe<Scalars['BigInt']>;
  createdAtUtc?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  offers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Business_Types_V1_ProgramOffer_Input>>>;
  programCode?: InputMaybe<Scalars['String']>;
  programType?: InputMaybe<Instacart_Customers_Business_Types_V1_ProgramType>;
  updatedAtUtc?: InputMaybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Business_Types_V1_BusinessType {
  /** Unspecified business type; accounts for protobuf enum defaults on the wire. */
  BusinessTypeUnspecified = 'BUSINESS_TYPE_UNSPECIFIED',
  /** Legacy business type; do not use. This stores old businesses we launched via a form. */
  Legacy = 'LEGACY',
  /** Employees of the same business organization */
  OrganizationBasic = 'ORGANIZATION_BASIC',
  /** Business Program that groups a set of Business users together, but not yet tied to the same business organization */
  Program = 'PROGRAM'
}

export type Instacart_Customers_Business_Types_V1_ProgramOffer = {
  __typename?: 'instacart_customers_business_types_v1_ProgramOffer';
  active: Maybe<Scalars['Boolean']>;
  countryId: Maybe<Scalars['BigInt']>;
  couponCode: Maybe<Scalars['String']>;
  createdAtUtc: Maybe<Scalars['DateTime']>;
  existingUsersEnabled: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  updatedAtUtc: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_ProgramOffer_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  couponCode?: InputMaybe<Scalars['String']>;
  createdAtUtc?: InputMaybe<Scalars['DateTime']>;
  existingUsersEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  updatedAtUtc?: InputMaybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Business_Types_V1_ProgramType {
  /** Business Program that is applicable to a business organization */
  Business = 'BUSINESS',
  /** BUsiness program that is applicable to a group of business users */
  Partnership = 'PARTNERSHIP',
  /** Unspecified program type; accounts for protobuf enum defaults on the wire. */
  ProgramTypeUnspecified = 'PROGRAM_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingRequest_Input = {
  list?: InputMaybe<Array<InputMaybe<Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingResponse = {
  __typename?: 'instacart_customers_campaigns_v1_BulkUpdateCampaignSlotRankingResponse';
  failedSlots: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters>>>;
  updatedSlots: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_Slot>>>;
};

export type Instacart_Customers_Campaigns_V1_CsvProcessingCount = {
  __typename?: 'instacart_customers_campaigns_v1_CsvProcessingCount';
  errorCount: Maybe<Scalars['BigInt']>;
  fileName: Maybe<Scalars['String']>;
  isProcessed: Maybe<Scalars['Boolean']>;
  successCount: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Campaigns_V1_CsvReportType {
  Errors = 'ERRORS',
  Processed = 'PROCESSED',
  Results = 'RESULTS',
  Unknown = 'UNKNOWN'
}

export type Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlRequest_Input = {
  fileName?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Instacart_Customers_Campaigns_V1_CsvReportType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetBucketDownloadUrlResponse';
  downloadUrl: Maybe<Scalars['String']>;
  expiresAt: Maybe<Scalars['DateTime']>;
  key: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_GetBucketUploadUrlRequest_Input = {
  fileName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** if dynamic csv feature is being used */
  useDynamicCsvUploadBucket?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Campaigns_V1_GetBucketUploadUrlResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetBucketUploadUrlResponse';
  expiresAt: Maybe<Scalars['DateTime']>;
  key: Maybe<Scalars['String']>;
  uploadUrl: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountRequest_Input = {
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetCsvFoundEntriesCountResponse';
  fileCounts: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_CsvProcessingCount>>>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryRequest_Input = {
  fileName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetCsvProcessingSummaryResponse';
  duplicateCount: Maybe<Scalars['BigInt']>;
  incorrectFormatCount: Maybe<Scalars['BigInt']>;
  isProcessed: Maybe<Scalars['Boolean']>;
  matchedCount: Maybe<Scalars['BigInt']>;
  unmatchedCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Filter_Input = {
  campaignActiveDate?: InputMaybe<Scalars['DateTime']>;
  campaignName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Input = {
  filter?: InputMaybe<Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Filter_Input>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetGroupedSlotsResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetGroupedSlotsResponse';
  groupedSlots: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_GroupedSlot>>>;
};

export type Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignRequest_Input = {
  marketingAgentCampaignId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetMarketingAgentCampaignResponse';
  marketingAgentCampaign: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>;
};

export type Instacart_Customers_Campaigns_V1_GroupedSlot = {
  __typename?: 'instacart_customers_campaigns_v1_GroupedSlot';
  slotId: Maybe<Scalars['String']>;
  slots: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_Slot>>>;
};

export type Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsRequest_Input = {
  overwriteLocalChanges?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  sync?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsResponse = {
  __typename?: 'instacart_customers_campaigns_v1_ListMarketingAgentCampaignsResponse';
  campaigns: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

/** BEGIN Marketing AI Agent */
export type Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsRequest_Input = {
  marketingAgentCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsResponse = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCalculatePerformanceMetricsResponse';
  performanceMetrics: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaignPerformanceMetrics>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign';
  brazeSegmentIds: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds>;
  campaignBucket: Maybe<Scalars['String']>;
  campaignName: Maybe<Scalars['String']>;
  desiredAudienceSize: Maybe<Scalars['Int']>;
  desiredBudget: Maybe<GoogleTypeMoney>;
  desiredBudgetDollars: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['BigInt']>;
  locallyUpdatedAt: Maybe<Scalars['DateTime']>;
  maxConversionPercentile: Maybe<Instacart_Types_V1_BigDecimal>;
  maxRelevanceScore: Maybe<Instacart_Types_V1_BigDecimal>;
  maxSpendPercentile: Maybe<Instacart_Types_V1_BigDecimal>;
  maxUnsubscribePercentile: Maybe<Instacart_Types_V1_BigDecimal>;
  minConversionPercentile: Maybe<Instacart_Types_V1_BigDecimal>;
  minRelevanceScore: Maybe<Instacart_Types_V1_BigDecimal>;
  minSpendPercentile: Maybe<Instacart_Types_V1_BigDecimal>;
  minUnsubscribePercentile: Maybe<Instacart_Types_V1_BigDecimal>;
  offerValue: Maybe<GoogleTypeMoney>;
  performanceMetrics: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics>;
  sendDates: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates>;
  taasSegmentIds: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaignPerformanceMetrics = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaignPerformanceMetrics';
  errorMessage: Maybe<Scalars['String']>;
  marketingAgentCampaignId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaignValidationResult';
  marketingAgentCampaign: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>;
  validationErrors: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult_ValidationError>>>;
};

export enum Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult_ValidationError {
  ValidationErrorAudienceMismatch = 'VALIDATION_ERROR_AUDIENCE_MISMATCH',
  ValidationErrorBrazeDataIsStale = 'VALIDATION_ERROR_BRAZE_DATA_IS_STALE',
  ValidationErrorBudgetMismatch = 'VALIDATION_ERROR_BUDGET_MISMATCH',
  ValidationErrorTooManyDailySends = 'VALIDATION_ERROR_TOO_MANY_DAILY_SENDS',
  ValidationErrorUnspecified = 'VALIDATION_ERROR_UNSPECIFIED'
}

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_BrazeSegmentIds';
  brazeSegmentIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds_Input = {
  brazeSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_Input = {
  brazeSegmentIds?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds_Input>;
  campaignBucket?: InputMaybe<Scalars['String']>;
  campaignName?: InputMaybe<Scalars['String']>;
  desiredAudienceSize?: InputMaybe<Scalars['Int']>;
  desiredBudget?: InputMaybe<GoogleTypeMoneyInput>;
  desiredBudgetDollars?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locallyUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  maxConversionPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  maxRelevanceScore?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  maxSpendPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  maxUnsubscribePercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minConversionPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minRelevanceScore?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minSpendPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minUnsubscribePercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  offerValue?: InputMaybe<GoogleTypeMoneyInput>;
  performanceMetrics?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics_Input>;
  sendDates?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates_Input>;
  taasSegmentIds?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds_Input>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_PerformanceMetrics';
  avgConversionRate: Maybe<Instacart_Types_V1_BigDecimal>;
  avgUnsubscribeRate: Maybe<Instacart_Types_V1_BigDecimal>;
  estimatedAudienceSize: Maybe<Scalars['Int']>;
  estimatedSpend: Maybe<GoogleTypeMoney>;
  estimatedUnsubscribers: Maybe<Scalars['Int']>;
  numSendDates: Maybe<Scalars['Int']>;
  selectedSendDates: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics_Input = {
  avgConversionRate?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  avgUnsubscribeRate?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  estimatedAudienceSize?: InputMaybe<Scalars['Int']>;
  estimatedSpend?: InputMaybe<GoogleTypeMoneyInput>;
  estimatedUnsubscribers?: InputMaybe<Scalars['Int']>;
  numSendDates?: InputMaybe<Scalars['Int']>;
  selectedSendDates?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates_Input>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_SendDates';
  sendDates: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates_Input = {
  sendDates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_TaasSegmentIds';
  taasSegmentIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds_Input = {
  taasSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_ProcessEmailCsvRequest_Input = {
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** full path for the CSV file stored in S3 */
  csvPathKey?: InputMaybe<Scalars['String']>;
  /** email of the IPP user that uploaded the file, used to send an email once the processing is complete. */
  notifyUserEmail?: InputMaybe<Scalars['String']>;
  /** id of the IPP user that uploaded the file, used to send an email once the processing is complete. */
  notifyUserId?: InputMaybe<Scalars['BigInt']>;
  /** identifies the retailer that uploaded the file */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** description of the taas segment being created. */
  segmentDescription?: InputMaybe<Scalars['String']>;
  /** name of the taas segment being created. */
  segmentName?: InputMaybe<Scalars['String']>;
  /** if dynamic csv feature is being used */
  useDynamicCsvUploadBucket?: InputMaybe<Scalars['Boolean']>;
  /** whitelabel_id, use 1 for marketplace */
  whitelabelId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_ProcessEmailCsvResponse = {
  __typename?: 'instacart_customers_campaigns_v1_ProcessEmailCsvResponse';
  jobId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignRequest_Input = {
  campaign?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_Input>;
};

export type Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignResponse = {
  __typename?: 'instacart_customers_campaigns_v1_SaveMarketingAgentCampaignResponse';
  campaign: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>;
};

export type Instacart_Customers_Campaigns_V1_Slot = {
  __typename?: 'instacart_customers_campaigns_v1_Slot';
  campaignId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  rank: Maybe<Scalars['BigInt']>;
  slotId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_TestOfflineCampaignRequest_Input = {
  campaignId?: InputMaybe<Scalars['BigInt']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  generateHubEvent?: InputMaybe<Scalars['Boolean']>;
  offersExpireAt?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters = {
  __typename?: 'instacart_customers_campaigns_v1_UpdateCampaignSlotRankingParameters';
  rank: Maybe<Scalars['BigInt']>;
  retailerCampaignId: Maybe<Scalars['BigInt']>;
  slotId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters_Input = {
  rank?: InputMaybe<Scalars['BigInt']>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleRequest_Input = {
  marketingAgentCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleResponse = {
  __typename?: 'instacart_customers_campaigns_v1_ValidateMarketingAgentScheduleResponse';
  marketingAgentCampaignValidationResults: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult>>>;
};

export type Instacart_Customers_Commerce_Coupons_V1_BulkCreateChildCouponCodesRequest_Input = {
  couponCodePrefix?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  generateCount?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsRequest_Input = {
  code?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsResponse = {
  __typename?: 'instacart_customers_commerce_coupons_v1_GetRedemptionCodeExistsResponse';
  couponCodeExists: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Customers_Commerce_Discount_Types_V1_RecurringBenefitTimePeriod {
  CalendarMonth = 'CALENDAR_MONTH',
  NonRecurringBenefit = 'NON_RECURRING_BENEFIT',
  RecurringBenefitTimePeriodUnspecified = 'RECURRING_BENEFIT_TIME_PERIOD_UNSPECIFIED',
  RollingMonth = 'ROLLING_MONTH'
}

export type Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata = {
  __typename?: 'instacart_customers_commerce_discount_v1_AdditionalMetadata';
  key: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_ApiCallerDetails';
  callerId: Maybe<Scalars['BigInt']>;
  callerPermissions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerPermission>>>;
  callerType: Maybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerType>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerPermission {
  CallerPermissionUnspecified = 'CALLER_PERMISSION_UNSPECIFIED',
  Default = 'DEFAULT',
  OverrideBusinessRuleValidation = 'OVERRIDE_BUSINESS_RULE_VALIDATION'
}

export enum Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerType {
  CallerTypeIc = 'CALLER_TYPE_IC',
  CallerTypeIpp = 'CALLER_TYPE_IPP',
  CallerTypeUnspecified = 'CALLER_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_Input = {
  callerId?: InputMaybe<Scalars['BigInt']>;
  callerPermissions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerPermission>>>;
  callerType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerType>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedCreditBackInCoupon';
  autoAppliedCreditBackExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditCouponDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails>;
  creditCouponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditCouponIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input = {
  autoAppliedCreditBackExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input>;
  creditCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedCreditBackInDigitalWallet';
  autoAppliedCreditBackExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  digitalWalletDepositDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails>;
  digitalWalletDepositIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input = {
  autoAppliedCreditBackExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  digitalWalletDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input>;
  digitalWalletDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedDiscount';
  autoAppliedDiscountExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input = {
  autoAppliedDiscountExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedInKindBack';
  autoAppliedInKindBackExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  inKindDepositDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails>;
  inKindDepositIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input = {
  autoAppliedInKindBackExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  inKindDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input>;
  inKindDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export enum Instacart_Customers_Commerce_Discount_V1_BusinessLogicValidationRule {
  AutoRedeemTargetingSegmentValidation = 'AUTO_REDEEM_TARGETING_SEGMENT_VALIDATION',
  BasketRewardIncludeConditionGroupValidation = 'BASKET_REWARD_INCLUDE_CONDITION_GROUP_VALIDATION',
  BusinessLogicValidationRuleUnspecified = 'BUSINESS_LOGIC_VALIDATION_RULE_UNSPECIFIED',
  CouponInstanceCountValidation = 'COUPON_INSTANCE_COUNT_VALIDATION',
  LowRiskConditionCriteriaExistsValidation = 'LOW_RISK_CONDITION_CRITERIA_EXISTS_VALIDATION',
  MaximumBasketDiscountValidation = 'MAXIMUM_BASKET_DISCOUNT_VALIDATION',
  MaximumBudgetValidation = 'MAXIMUM_BUDGET_VALIDATION',
  MinimumSpendValidation = 'MINIMUM_SPEND_VALIDATION',
  UnlimitedOfferRedemptionLimitValidation = 'UNLIMITED_OFFER_REDEMPTION_LIMIT_VALIDATION'
}

export type Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_CheckoutBenefitCodeDiscount';
  checkoutBenefitCodeDiscountExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input = {
  checkoutBenefitCodeDiscountExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
};

/** Discount using Clippable Coupon */
export type Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_ClippableCouponBasedDiscount';
  couponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  couponIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

/** Discount using Clippable Coupon */
export type Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input = {
  couponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  couponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

/**
 * This is a generic condition which can support different types of keys.
 * For the supported keys in ConditionKey, this will be used to check if the condition is met.
 * For example, quantity greater than 2 would be defined as:
 * {
 * key = ConditionKey.QUANTITY,
 * operator : ConditionOperator.GREATER_THAN
 * value: 2
 * }
 */
export type Instacart_Customers_Commerce_Discount_V1_Condition = {
  __typename?: 'instacart_customers_commerce_discount_v1_Condition';
  key: Maybe<Instacart_Customers_Commerce_Discount_V1_ConditionKey>;
  operator: Maybe<Instacart_Customers_Commerce_Discount_V1_ConditionOperator>;
  value: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ConditionKey {
  /** Condition that checks if a user is an Instacart administrator. */
  AdminUser = 'ADMIN_USER',
  BenefitTier = 'BENEFIT_TIER',
  ConditionKeyUnspecified = 'CONDITION_KEY_UNSPECIFIED',
  DevicePlatform = 'DEVICE_PLATFORM',
  /** Condition that checks the directed spend program code in order benefit qualifier */
  DirectedSpendProgramCode = 'DIRECTED_SPEND_PROGRAM_CODE',
  DiscountTags = 'DISCOUNT_TAGS',
  FirstNOrders = 'FIRST_N_ORDERS',
  FulfillmentType = 'FULFILLMENT_TYPE',
  GiftOrder = 'GIFT_ORDER',
  IcPlusMember = 'IC_PLUS_MEMBER',
  ItemsTotalPrice = 'ITEMS_TOTAL_PRICE',
  LoyaltyMember = 'LOYALTY_MEMBER',
  LoyaltyTier = 'LOYALTY_TIER',
  NamedScenario = 'NAMED_SCENARIO',
  /** Condition that checks the day of the week of order creation. Valid values are Sun, Mon, Tue, Wed, Thu, Fri, Sat (case-insensitive) */
  OrderCreationDayOfWeek = 'ORDER_CREATION_DAY_OF_WEEK',
  OrderDeliveryTags = 'ORDER_DELIVERY_TAGS',
  PaymentInstrumentType = 'PAYMENT_INSTRUMENT_TYPE',
  Quantity = 'QUANTITY',
  RegularItemsPrice = 'REGULAR_ITEMS_PRICE',
  RetailerTotalPrice = 'RETAILER_TOTAL_PRICE',
  ServiceOptionType = 'SERVICE_OPTION_TYPE',
  UniqueProductsCount = 'UNIQUE_PRODUCTS_COUNT',
  WeightKg = 'WEIGHT_KG',
  WeightLb = 'WEIGHT_LB'
}

export enum Instacart_Customers_Commerce_Discount_V1_ConditionOperator {
  ConditionOperatorUnspecified = 'CONDITION_OPERATOR_UNSPECIFIED',
  ContainsAll = 'CONTAINS_ALL',
  ContainsAny = 'CONTAINS_ANY',
  Equal = 'EQUAL',
  Exclude = 'EXCLUDE',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL'
}

/**
 * This is a generic condition which can support different types of keys.
 * For the supported keys in ConditionKey, this will be used to check if the condition is met.
 * For example, quantity greater than 2 would be defined as:
 * {
 * key = ConditionKey.QUANTITY,
 * operator : ConditionOperator.GREATER_THAN
 * value: 2
 * }
 */
export type Instacart_Customers_Commerce_Discount_V1_Condition_Input = {
  key?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ConditionKey>;
  operator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ConditionOperator>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedCreditBackInCoupon';
  creditBackCouponDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  creditBackCouponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditBackCouponIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  creditCouponDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails>;
  creditCouponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input = {
  creditBackCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  creditBackCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditBackCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  creditCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input>;
  creditCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedCreditBackInDigitalWallet';
  creditBackCouponDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  creditBackCouponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditBackCouponIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  digitalWalletDepositDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input = {
  creditBackCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  creditBackCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditBackCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  digitalWalletDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedDiscount';
  couponDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  couponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  couponIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input = {
  couponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  couponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  couponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedInKindBack';
  inKindBackCouponDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  inKindBackCouponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  inKindBackCouponIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindBackCouponIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  inKindDepositDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input = {
  inKindBackCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  inKindBackCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  inKindBackCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindBackCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  inKindDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_CouponCodeType {
  CouponCodeTypeUnspecified = 'COUPON_CODE_TYPE_UNSPECIFIED',
  SharedCode = 'SHARED_CODE',
  SingleUserAssignedCode = 'SINGLE_USER_ASSIGNED_CODE',
  SingleUserUnassignedCode = 'SINGLE_USER_UNASSIGNED_CODE'
}

/** Details of Coupon which will be granted. */
export type Instacart_Customers_Commerce_Discount_V1_CouponDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponDetails';
  couponCodeType: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponCodeType>;
  redeemableCouponGrant: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo>;
  redemptionCondition: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** Details of Coupon which will be granted. */
export type Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input = {
  couponCodeType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponCodeType>;
  redeemableCouponGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** Coupon's Grant which will be awarded/redeemed if condition satisfied */
export type Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponGrantInfo';
  couponGrantMethod: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod>;
  expiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  instanceCount: Maybe<Scalars['BigInt']>;
  valueGrantGuaranteeBasis: Maybe<Instacart_Customers_Commerce_Types_V1_ValueGrantGuaranteeBasis>;
};

/** Coupon's Grant which will be awarded/redeemed if condition satisfied */
export type Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo_Input = {
  couponGrantMethod?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod>;
  expiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
  instanceCount?: InputMaybe<Scalars['BigInt']>;
  valueGrantGuaranteeBasis?: InputMaybe<Instacart_Customers_Commerce_Types_V1_ValueGrantGuaranteeBasis>;
};

export enum Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod {
  AutomatedCouponGrant = 'AUTOMATED_COUPON_GRANT',
  ClickToRedeem = 'CLICK_TO_REDEEM',
  CouponGrantMethodUnspecified = 'COUPON_GRANT_METHOD_UNSPECIFIED',
  ManualCodeRedemption = 'MANUAL_CODE_REDEMPTION'
}

export type Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyRequest_Input = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input>>>;
  apiCallerDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_Input>;
  autoAppliedDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input>;
  autoCreditBackInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input>;
  autoCreditBackInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input>;
  autoInKindBack?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input>;
  checkoutBenefitCodeDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_Creator_Input>;
  creditBackInCouponUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input>;
  creditBackInDigitalWalletUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input>;
  creditInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input>;
  creditInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input>;
  /** any description for the policy */
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountUsingClippableCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input>;
  discountUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference?: InputMaybe<Scalars['String']>;
  fundingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inKindBackUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input>;
  inKindDeposit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input>;
  /** name of the policy */
  name?: InputMaybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription?: InputMaybe<Scalars['String']>;
  /** Request id. */
  requestId?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  source?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** status of the policy */
  status?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userSegments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationRulesToSkip?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_BusinessLogicValidationRule>>>;
  valueGrantCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreateValueGrantPolicyResponse';
  valueGrantPolicy: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy>;
};

export type Instacart_Customers_Commerce_Discount_V1_Creator = {
  __typename?: 'instacart_customers_commerce_discount_v1_Creator';
  creatorId: Maybe<Scalars['BigInt']>;
  creatorType: Maybe<Instacart_Customers_Commerce_Discount_V1_CreatorType>;
};

export enum Instacart_Customers_Commerce_Discount_V1_CreatorType {
  CreatorTypeAdsPlatform = 'CREATOR_TYPE_ADS_PLATFORM',
  CreatorTypeIc = 'CREATOR_TYPE_IC',
  CreatorTypeIpp = 'CREATOR_TYPE_IPP',
  CreatorTypeUnspecified = 'CREATOR_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_Creator_Input = {
  creatorId?: InputMaybe<Scalars['BigInt']>;
  creatorType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreatorType>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditBackGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditBackGrantCalculator';
  fixedValueCreditBackAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentCreditBackInfo: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

/** Credit in Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditCouponDetails';
  redeemableCreditCouponGrant: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant>;
  redemptionCondition: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** Credit in Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input = {
  redeemableCreditCouponGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** Credit grant in form of Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditCouponGrant';
  credit: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo>;
  grant: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo>;
};

/** Credit grant in form of Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant_Input = {
  credit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input>;
  grant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo_Input>;
};

/** Credit in Digital wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditDigitalWalletDepositDetails';
  redeemableCreditDwDepositGrant: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant>;
  redemptionCondition: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** Credit in Digital wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input = {
  redeemableCreditDwDepositGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** Credit grant in form of Digital Wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditDigitalWalletDepositGrant';
  creditDwDepositTargetDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail>;
  expiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  grant: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo>;
  storedValueService: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

/** Credit grant in form of Digital Wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant_Input = {
  creditDwDepositTargetDetail?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_Input>;
  expiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
  grant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input>;
  storedValueService?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditGrantCalculator';
  fixedValueCreditAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentCreditInfo: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator_Input = {
  fixedValueCreditAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentCreditInfo?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input>;
};

/** Credit Grant (represent by coupon OR will store in Digital Wallet) */
export type Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditGrantInfo';
  grantQuantityDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  grantQuantityType: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityType>;
  refundExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
};

/** Credit Grant (represent by coupon OR will store in Digital Wallet) */
export type Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input = {
  grantQuantityDetail?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  grantQuantityType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityType>;
  refundExpiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInCoupon = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditInCoupon';
  creditCouponDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails>;
  creditCouponExercisingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditCouponIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditCouponIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input = {
  creditCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input>;
  creditCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditInDigitalWallet';
  digitalWalletDepositDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails>;
  digitalWalletDepositIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  digitalWalletDepositIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input = {
  digitalWalletDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input>;
  digitalWalletDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  digitalWalletDepositIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_DiscountGrantCalculator';
  fixedPriceDiscount: Maybe<GoogleTypeMoney>;
  fixedPricePerUnitDiscountInfo: Maybe<Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo>;
  fixedValueDiscountAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  fixedValueDiscountAmountPerUnit: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentDiscountInfo: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator_Input = {
  fixedPriceDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  fixedPricePerUnitDiscountInfo?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo_Input>;
  fixedValueDiscountAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  fixedValueDiscountAmountPerUnit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentDiscountInfo?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_DiscountTag {
  DiscountTagUnspecified = 'DISCOUNT_TAG_UNSPECIFIED',
  ServiceOptionDiscountGroupTagFivePercent = 'SERVICE_OPTION_DISCOUNT_GROUP_TAG_FIVE_PERCENT',
  /** tags to indicate service option discount groups */
  ServiceOptionDiscountGroupTagTwoDollar = 'SERVICE_OPTION_DISCOUNT_GROUP_TAG_TWO_DOLLAR',
  ValueMealSuperSaverFivePercentCreditBack = 'VALUE_MEAL_SUPER_SAVER_FIVE_PERCENT_CREDIT_BACK',
  ValueMealSuperSaverTenPercentCreditBack = 'VALUE_MEAL_SUPER_SAVER_TEN_PERCENT_CREDIT_BACK',
  ValueMealSuperSaverTwoPercentCreditBack = 'VALUE_MEAL_SUPER_SAVER_TWO_PERCENT_CREDIT_BACK'
}

export type Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria = {
  __typename?: 'instacart_customers_commerce_discount_v1_ExclusionCriteria';
  key: Maybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteriaKey>;
  value: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ExclusionCriteriaKey {
  /** Excludes items with any listed brand id from offer condition */
  ExcludedBrandId = 'EXCLUDED_BRAND_ID',
  /** Exclude items with any listed discount tag */
  ExcludedItemDiscountTag = 'EXCLUDED_ITEM_DISCOUNT_TAG',
  /** Excludes items that belong to one or more retailer-defined departments from offer condition */
  ExcludedRetailerDepartment = 'EXCLUDED_RETAILER_DEPARTMENT',
  /** Excludes items with any listed brand id from offer reward */
  ExcludedRewardBrandId = 'EXCLUDED_REWARD_BRAND_ID',
  /** Excludes items that belong to one or more retailer-defined departments from offer reward */
  ExcludedRewardRetailerDepartment = 'EXCLUDED_REWARD_RETAILER_DEPARTMENT',
  ExclusionCriteriaKeyUnspecified = 'EXCLUSION_CRITERIA_KEY_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria_Input = {
  key?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteriaKey>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_FixedPricePerUnitDiscountInfo';
  perUnitPrice: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo_Input = {
  perUnitPrice?: InputMaybe<GoogleTypeMoneyInput>;
};

export enum Instacart_Customers_Commerce_Discount_V1_FulfillmentType {
  Delivery = 'DELIVERY',
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  Instore = 'INSTORE',
  Pickup = 'PICKUP'
}

export type Instacart_Customers_Commerce_Discount_V1_FundingDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_FundingDetail';
  /** the amount of budget available before the offer is exhausted */
  budgetLimit: Maybe<GoogleTypeMoney>;
  fundingProviderInfo: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input = {
  /** the amount of budget available before the offer is exhausted */
  budgetLimit?: InputMaybe<GoogleTypeMoneyInput>;
  fundingProviderInfo?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation_Input>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation = {
  __typename?: 'instacart_customers_commerce_discount_v1_FundingProviderInformation';
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent: Maybe<Scalars['BigInt']>;
  /** who is funding this part */
  source: Maybe<Instacart_Customers_Commerce_Discount_V1_FundingSource>;
  /** name of the funding source */
  sourceName: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation_Input = {
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent?: InputMaybe<Scalars['BigInt']>;
  /** who is funding this part */
  source?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingSource>;
  /** name of the funding source */
  sourceName?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  Retailer = 'RETAILER'
}

export type Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeRequest_Input = {
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_GetValueGrantPolicyFacadeResponse';
  facade: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade>;
};

/** Grant/Value (i.e. coupon/credit) Exercising */
export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails';
  attachmentLevel: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantAttachmentLevel>;
  conditions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition>>>;
  exercisingLimits: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits>;
  reward: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward>>>;
  stackability: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStackability>;
  storeAvailability: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStoreAvailability>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantAttachmentLevel {
  GrantAttachmentBasketLevel = 'GRANT_ATTACHMENT_BASKET_LEVEL',
  GrantAttachmentFeeLevel = 'GRANT_ATTACHMENT_FEE_LEVEL',
  GrantAttachmentItemLevel = 'GRANT_ATTACHMENT_ITEM_LEVEL',
  GrantAttachmentLevelUnspecified = 'GRANT_ATTACHMENT_LEVEL_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantExercisingCondition';
  allowPartialApplication: Maybe<Scalars['Boolean']>;
  conditions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
  exclusionCriteria: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria>>>;
  groupCriteria: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteria>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition_Input = {
  allowPartialApplication?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
  exclusionCriteria?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria_Input>>>;
  groupCriteria?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteria_Input>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantExercisingLimits';
  exercisingLimit: Maybe<Scalars['BigInt']>;
  exercisingLimitPerOrder: Maybe<Scalars['BigInt']>;
  exercisingLimitPerUser: Maybe<Scalars['BigInt']>;
  recurringBenefitLimitPerUser: Maybe<Instacart_Customers_Commerce_Discount_V1_RecurringBenefit>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits_Input = {
  exercisingLimit?: InputMaybe<Scalars['BigInt']>;
  exercisingLimitPerOrder?: InputMaybe<Scalars['BigInt']>;
  exercisingLimitPerUser?: InputMaybe<Scalars['BigInt']>;
  recurringBenefitLimitPerUser?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_RecurringBenefit_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStackability {
  /** Indicates the grant exercising is not stackable with other stackable and non-stackable grant exercising */
  GrantExercisingNonStackable = 'GRANT_EXERCISING_NON_STACKABLE',
  /** Indicates the grant exercising bypasses all stackability rules and always allowed to apply irrespective of other competing grant exercising */
  GrantExercisingPolicyAlwaysStackable = 'GRANT_EXERCISING_POLICY_ALWAYS_STACKABLE',
  GrantExercisingStackabilityUnspecified = 'GRANT_EXERCISING_STACKABILITY_UNSPECIFIED',
  /** Indicates the grant exercising is stackable with grant exercising */
  GrantExercisingStackable = 'GRANT_EXERCISING_STACKABLE'
}

export enum Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStoreAvailability {
  GrantExercisingStoreAvailabilityInStoreOnly = 'GRANT_EXERCISING_STORE_AVAILABILITY_IN_STORE_ONLY',
  GrantExercisingStoreAvailabilityOnlineOnly = 'GRANT_EXERCISING_STORE_AVAILABILITY_ONLINE_ONLY',
  GrantExercisingStoreAvailabilityUnspecified = 'GRANT_EXERCISING_STORE_AVAILABILITY_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward';
  credit: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward>;
  discount: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward>;
  inKind: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward>;
  rewardGroup: Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroup>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward_CreditReward';
  creditGrantCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward_Input = {
  creditGrantCalculator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward_DiscountReward';
  discountCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward_Input = {
  discountCalculator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward_InKindReward';
  inKindGrantCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward_Input = {
  inKindGrantCalculator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_Input = {
  credit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward_Input>;
  discount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward_Input>;
  inKind?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward_Input>;
  rewardGroup?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_RewardGroup_Input>;
};

/** Grant/Value (i.e. coupon/credit) Exercising */
export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input = {
  attachmentLevel?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantAttachmentLevel>;
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition_Input>>>;
  exercisingLimits?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits_Input>;
  reward?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_Input>>>;
  stackability?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStackability>;
  storeAvailability?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStoreAvailability>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantQuantityDetail';
  monetaryAmount: Maybe<GoogleTypeMoney>;
  nonMonetaryAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input = {
  monetaryAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nonMonetaryAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantQuantityDetail_NonMonetaryAmount';
  fundTypeIdentifier: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['BigInt']>;
  unit: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_NonMonetaryUnit>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_Input = {
  fundTypeIdentifier?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['BigInt']>;
  unit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_NonMonetaryUnit>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_NonMonetaryUnit {
  NonMonetaryChasePoints = 'NON_MONETARY_CHASE_POINTS',
  NonMonetaryUnitUnspecified = 'NON_MONETARY_UNIT_UNSPECIFIED'
}

export enum Instacart_Customers_Commerce_Discount_V1_GrantQuantityType {
  Fixed = 'FIXED',
  GrantValueTypeUnspecified = 'GRANT_VALUE_TYPE_UNSPECIFIED',
  NotApplicable = 'NOT_APPLICABLE',
  Variable = 'VARIABLE'
}

export type Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantTargetDetail';
  fundTypeIdentifier: Maybe<Scalars['String']>;
  walletProduct: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_WalletProduct>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_Input = {
  fundTypeIdentifier?: InputMaybe<Scalars['String']>;
  walletProduct?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_WalletProduct>;
};

/** This is currently defined as non shared type in payment service */
export enum Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_WalletProduct {
  BusinessContractualBenefit = 'BUSINESS_CONTRACTUAL_BENEFIT',
  CaperCredit = 'CAPER_CREDIT',
  ChaseCardCredit = 'CHASE_CARD_CREDIT',
  ChasePwp = 'CHASE_PWP',
  DirectedSpend = 'DIRECTED_SPEND',
  ExpressCredit = 'EXPRESS_CREDIT',
  GamificationCredit = 'GAMIFICATION_CREDIT',
  GeneralRetailerCredit = 'GENERAL_RETAILER_CREDIT',
  GiftCards = 'GIFT_CARDS',
  HappinessAppeasements = 'HAPPINESS_APPEASEMENTS',
  IcPromotionalCreditBack = 'IC_PROMOTIONAL_CREDIT_BACK',
  LegacyGiftCards = 'LEGACY_GIFT_CARDS',
  RefundCredit = 'REFUND_CREDIT',
  RetailerGiftCard = 'RETAILER_GIFT_CARD',
  ValueGrantCredit = 'VALUE_GRANT_CREDIT',
  WalletProductUnspecified = 'WALLET_PRODUCT_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_GroupCriteria = {
  __typename?: 'instacart_customers_commerce_discount_v1_GroupCriteria';
  key: Maybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteriaKey>;
  value: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GroupCriteriaKey {
  /** Matches alcohol items that are allowed in the specified states */
  AlcoholStateAllowed = 'ALCOHOL_STATE_ALLOWED',
  /** Matches items with any listed brand name */
  BrandName = 'BRAND_NAME',
  /** Matches all items in cart */
  Cart = 'CART',
  /** Matches items with any listed commerce classifications */
  CommerceClassification = 'COMMERCE_CLASSIFICATION',
  GroupCriteriaKeyUnspecified = 'GROUP_CRITERIA_KEY_UNSPECIFIED',
  /** Matches items in any listed collection */
  ItemCollection = 'ITEM_COLLECTION',
  /** Matches items with any listed discount tag */
  ItemDiscountTag = 'ITEM_DISCOUNT_TAG',
  /** Matches items with any listed product id */
  ProductId = 'PRODUCT_ID',
  /** Matches items with any listed region */
  Region = 'REGION',
  /** Matches items that belong to one or more retailer-defined departments */
  RetailerDepartment = 'RETAILER_DEPARTMENT',
  /** Matches retailer products in any listed collection */
  RetailerProductCollectionId = 'RETAILER_PRODUCT_COLLECTION_ID',
  /** Matches retailer products in any excluded listed collection */
  RetailerProductCollectionIdExcluded = 'RETAILER_PRODUCT_COLLECTION_ID_EXCLUDED',
  /** Matches retailer products in any included listed collection */
  RetailerProductCollectionIdIncluded = 'RETAILER_PRODUCT_COLLECTION_ID_INCLUDED',
  /** Matches items with any listed taxonomy node id */
  TaxonomyNodeId = 'TAXONOMY_NODE_ID',
  /** Matches items that have their cost_unit set to the specified unit(s) */
  WeightUnit = 'WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Discount_V1_GroupCriteria_Input = {
  key?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteriaKey>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindBackGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindBackGrantCalculator';
  fixedValueInKindBackAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  fixedValueInKindBackAmountPerUnit: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentInKindBackAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindDeposit = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindDeposit';
  inKindDepositDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails>;
  inKindDepositIssuingAuthority: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindDepositIssuingFlow: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

/** In-kind deposit details */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindDepositDetails';
  inKindDepositGrant: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant>;
  redemptionCondition: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** In-kind deposit details */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input = {
  inKindDepositGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** In-kind grant in form of deposit */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindDepositGrant';
  expiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  grant: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo>;
  inKindDepositTargetDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail>;
  storedValueService: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

/** In-kind grant in form of deposit */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant_Input = {
  expiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
  grant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input>;
  inKindDepositTargetDetail?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_Input>;
  storedValueService?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input = {
  inKindDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input>;
  inKindDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindDepositIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindGrantCalculator';
  fixedValueInKindAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  fixedValueInKindAmountPerUnit: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentInKindAmount: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator_Input = {
  fixedValueInKindAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  fixedValueInKindAmountPerUnit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentInKindAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_OfferStackability {
  /** Indicates the offer bypasses all stackability rules and always allowed to apply irrespective of other competing offers */
  AlwaysStackable = 'ALWAYS_STACKABLE',
  /** Indicates the offer is not stackable with other stackable and non-stackable offers */
  NonStackable = 'NON_STACKABLE',
  OfferStackabilityUnspecified = 'OFFER_STACKABILITY_UNSPECIFIED',
  /** Indicates the offer is stackable with any offer */
  Stackable = 'STACKABLE'
}

export type Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_PercentGrantInfo';
  maximumGrantQuantity: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentValue: Maybe<Instacart_Types_V1_BigDecimal>;
};

export type Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input = {
  maximumGrantQuantity?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentValue?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy';
  endsAt: Maybe<Scalars['DateTime']>;
  presentableConditions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition>>>;
  presentableGrantDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail>;
  startsAt: Maybe<Scalars['DateTime']>;
  status: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  valueGrantPolicyId: Maybe<Scalars['BigInt']>;
  valueGrantPolicyKey: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition';
  allValueGrantTags: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_AllValueGrantTags>;
  country: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_Country>;
  customTermsCondition: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition>;
  directedSpendProgramEnrollmentRequired: Maybe<Scalars['instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_DirectedSpendProgramEnrollmentRequired']>;
  firstNOrders: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_FirstNOrders>;
  fulfillmentType: Maybe<Instacart_Customers_Commerce_Discount_V1_FulfillmentType>;
  icMembershipExcluded: Maybe<Scalars['instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipExcluded']>;
  icMembershipRequired: Maybe<Scalars['instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipRequired']>;
  itemCollection: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollection>;
  itemCollectionMinimumSpend: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollectionMinimumSpend>;
  minimumSpend: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_MinimumSpend>;
  notOneOfRetailers: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfRetailers>;
  notOneOfStoreConfigurations: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfStoreConfigurations>;
  oneOfPaymentInstruments: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfPaymentInstruments>;
  oneOfRegions: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRegions>;
  oneOfRetailers: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRetailers>;
  oneOfStoreConfigurations: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfStoreConfigurations>;
  taxonomyCollection: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_TaxonomyCollection>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_AllValueGrantTags = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_AllValueGrantTags';
  valueGrantTags: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountTag>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_Country = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_Country';
  countryId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition';
  localeTermsConditions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition_LocaleTermsCondition>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition_LocaleTermsCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition_LocaleTermsCondition';
  locale: Maybe<Scalars['String']>;
  termsConditions: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_FirstNOrders = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_FirstNOrders';
  orderCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollection = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ItemCollection';
  collectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  minimumSpend: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollectionMinimumSpend = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ItemCollectionMinimumSpend';
  groupCriteria: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteria>>>;
  minimumSpend: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_MinimumSpend = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_MinimumSpend';
  commerceClassifications: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_CommerceClassification>>>;
  exclusionCriteria: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria>>>;
  minimumSpend: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfRetailers = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfRetailers';
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfStoreConfigurations = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfStoreConfigurations';
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfPaymentInstruments = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfPaymentInstruments';
  paymentInstructions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_PaymentInstruction>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRegions = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfRegions';
  regionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRetailers = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfRetailers';
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfStoreConfigurations = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfStoreConfigurations';
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_TaxonomyCollection = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_TaxonomyCollection';
  collectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  minimumSpend: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail';
  couponDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CouponDetail>;
  couponGrantCount: Maybe<Scalars['BigInt']>;
  creditBackGrantDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditBackGrantDetail>;
  creditGrantDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditGrantDetail>;
  discountGrantDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail>;
  grantStackability: Maybe<Instacart_Customers_Commerce_Discount_V1_OfferStackability>;
  inKindBackGrantDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindBackGrantDetail>;
  inKindGrantDetail: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindGrantDetail>;
  presentableGrantType: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_PresentableGrantType>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CouponDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_CouponDetail';
  couponGrantCount: Maybe<Scalars['BigInt']>;
  couponGrantMaximumDuration: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  couponGrantMethod: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditBackGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditBackGrantDetail';
  creditBackGrantCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditBackGrantCalculator>;
  grantExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  refundExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditGrantDetail';
  creditGrantCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator>;
  grantExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  refundExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  storedValueService: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail';
  discountGrantCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator>;
  discountedCollection: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCollection>;
  discountedCommerceClassifications: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCommerceClassifications>;
  discountedServiceItems: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedServiceItems>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCollection = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCollection';
  groupingKeys: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroupKey>>>;
  rewardGroups: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroup>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCommerceClassifications = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCommerceClassifications';
  commerceClassifications: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_CommerceClassification>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedServiceItems = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedServiceItems';
  serviceItemTypes: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ServiceItemType>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindBackGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindBackGrantDetail';
  grantExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  inKindBackGrantCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindBackGrantCalculator>;
  refundExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindGrantDetail';
  grantExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  inKindGrantCalculator: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator>;
  refundExpiresIn: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  storedValueService: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export enum Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_PresentableGrantType {
  /** On order credit that is evaluated for all orders of a customer */
  GrantTypeAutoAppliedCreditBack = 'GRANT_TYPE_AUTO_APPLIED_CREDIT_BACK',
  /** Basket level discount that is evaluated for all orders of a customer. */
  GrantTypeAutoAppliedDiscount = 'GRANT_TYPE_AUTO_APPLIED_DISCOUNT',
  /** On order in-kind evaluated for all orders of a customer */
  GrantTypeAutoAppliedInKindBack = 'GRANT_TYPE_AUTO_APPLIED_IN_KIND_BACK',
  /** Checkout code based discount */
  GrantTypeCheckoutCodeBasedDiscount = 'GRANT_TYPE_CHECKOUT_CODE_BASED_DISCOUNT',
  /** On order credit backed evaluated for only customers having credit back coupon */
  GrantTypeCouponCreditBack = 'GRANT_TYPE_COUPON_CREDIT_BACK',
  /**
   * Basket level discount evaluated for only customers having discount coupon
   * Ex: Discount of $10 on order placed from Costco for customers having the coupon
   */
  GrantTypeCouponDiscount = 'GRANT_TYPE_COUPON_DISCOUNT',
  /** On order in-kind evaluated only for customers having in-kind back coupon */
  GrantTypeCouponInKindBack = 'GRANT_TYPE_COUPON_IN_KIND_BACK',
  /**
   * Off order credit that is granted independent of an order, Ex: $10 credit
   * when a customer places 3 orders in a week
   */
  GrantTypeCredit = 'GRANT_TYPE_CREDIT',
  /** Off order in-kind granted independent of an order, Ex: 500 miles */
  GrantTypeInKind = 'GRANT_TYPE_IN_KIND',
  PresentableGrantTypeUnspecified = 'PRESENTABLE_GRANT_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyRequest_Input = {
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_PublishValueGrantPolicyResponse';
  facade: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade>;
};

export type Instacart_Customers_Commerce_Discount_V1_RecurringBenefit = {
  __typename?: 'instacart_customers_commerce_discount_v1_RecurringBenefit';
  rewardCount: Maybe<Scalars['BigInt']>;
  rewardMonetaryAmount: Maybe<GoogleTypeMoney>;
  timePeriod: Maybe<Instacart_Customers_Commerce_Discount_Types_V1_RecurringBenefitTimePeriod>;
};

export type Instacart_Customers_Commerce_Discount_V1_RecurringBenefit_Input = {
  rewardCount?: InputMaybe<Scalars['BigInt']>;
  rewardMonetaryAmount?: InputMaybe<GoogleTypeMoneyInput>;
  timePeriod?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_RecurringBenefitTimePeriod>;
};

export type Instacart_Customers_Commerce_Discount_V1_RewardGroup = {
  __typename?: 'instacart_customers_commerce_discount_v1_RewardGroup';
  includeConditionGroup: Maybe<Scalars['Boolean']>;
  measuredQuantityLimit: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  quantityLimit: Maybe<Scalars['BigInt']>;
  rewardGroupKey: Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroupKey>;
  value: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_RewardGroupKey {
  /** Includes items whose brand name appears in the values list. */
  RewardBrandName = 'REWARD_BRAND_NAME',
  /** Includes all items in cart */
  RewardCart = 'REWARD_CART',
  /** Includes all items in the given commerce_classifications. */
  RewardCommerceClassification = 'REWARD_COMMERCE_CLASSIFICATION',
  RewardGroupKeyUnspecified = 'REWARD_GROUP_KEY_UNSPECIFIED',
  /** Includes all items in the specified collections. */
  RewardItemCollection = 'REWARD_ITEM_COLLECTION',
  /** Includes all items with specified discount tags. */
  RewardItemDiscountTag = 'REWARD_ITEM_DISCOUNT_TAG',
  /** Includes items whose product ID appears in the values list. */
  RewardProductId = 'REWARD_PRODUCT_ID',
  /** Includes items that belong to one or more retailer-defined departments */
  RewardRetailerDepartment = 'REWARD_RETAILER_DEPARTMENT',
  /** Excludes all items with specified retailer product collection ids. */
  RewardRetailerProductCollectionIdExcluded = 'REWARD_RETAILER_PRODUCT_COLLECTION_ID_EXCLUDED',
  /** Includes all items with specified retailer product collection ids. */
  RewardRetailerProductCollectionIdIncluded = 'REWARD_RETAILER_PRODUCT_COLLECTION_ID_INCLUDED',
  /** Includes all service items */
  RewardServiceItem = 'REWARD_SERVICE_ITEM',
  /** Includes items whose (any) taxonomy node ID appears in the values list. */
  RewardTaxonomyNodeId = 'REWARD_TAXONOMY_NODE_ID',
  /** Matches items that have their cost_unit set to the specified unit(s) */
  RewardWeightUnit = 'REWARD_WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Discount_V1_RewardGroup_Input = {
  includeConditionGroup?: InputMaybe<Scalars['Boolean']>;
  measuredQuantityLimit?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  quantityLimit?: InputMaybe<Scalars['BigInt']>;
  rewardGroupKey?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_RewardGroupKey>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ServiceItemType {
  /** alcohol service fee */
  AlcoholServiceFee = 'ALCOHOL_SERVICE_FEE',
  CancellationFee = 'CANCELLATION_FEE',
  DeliveryFee = 'DELIVERY_FEE',
  /** other service fee except alcohol and rx */
  GeneralServiceFee = 'GENERAL_SERVICE_FEE',
  HeavyDeliveryFee = 'HEAVY_DELIVERY_FEE',
  LongDistanceFee = 'LONG_DISTANCE_FEE',
  PriorityFee = 'PRIORITY_FEE',
  /** total service fee (general + alcohol + rx) */
  RegularServiceFee = 'REGULAR_SERVICE_FEE',
  /** rx service fee */
  RxServiceFee = 'RX_SERVICE_FEE',
  ServiceFee = 'SERVICE_FEE',
  ServiceItemTypeUnspecified = 'SERVICE_ITEM_TYPE_UNSPECIFIED'
}

export enum Instacart_Customers_Commerce_Discount_V1_StoredValueService {
  StoredValueServiceCheddar = 'STORED_VALUE_SERVICE_CHEDDAR',
  StoredValueServiceCoupon = 'STORED_VALUE_SERVICE_COUPON',
  /** Represent 3PI layer as Store Value Service. 3PI layer will delegate call to right endpoint to store value */
  StoredValueServiceThirdParty = 'STORED_VALUE_SERVICE_THIRD_PARTY',
  StoredValueServiceUnspecified = 'STORED_VALUE_SERVICE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_TimeDuration = {
  __typename?: 'instacart_customers_commerce_discount_v1_TimeDuration';
  timePeriod: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_TimePeriod>;
  timePeriodCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input = {
  timePeriod?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_TimePeriod>;
  timePeriodCount?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_TimeDuration_TimePeriod {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  TimePeriodUnspecified = 'TIME_PERIOD_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyRequest_Input = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input>>>;
  autoAppliedDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input>;
  autoCreditBackInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input>;
  autoCreditBackInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input>;
  autoInKindBack?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input>;
  checkoutBenefitCodeDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_Creator_Input>;
  creditBackInCouponUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input>;
  creditBackInDigitalWalletUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input>;
  creditInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input>;
  creditInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input>;
  /** any description for the policy */
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountUsingClippableCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input>;
  discountUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference?: InputMaybe<Scalars['String']>;
  fundingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inKindBackUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input>;
  inKindDeposit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input>;
  /** name of the policy */
  name?: InputMaybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription?: InputMaybe<Scalars['String']>;
  /** Request id. */
  requestId?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  source?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** status of the policy */
  status?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userSegments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_UpdateValueGrantPolicyResponse';
  errors: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError>>>;
  valueGrantPolicy: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicyFacade';
  additionalMetadata: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata>>>;
  apiCallerDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails>;
  autoAppliedDiscount: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount>;
  autoCreditBackInCoupon: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon>;
  autoCreditBackInDigitalWallet: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet>;
  autoInKindBack: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack>;
  checkoutBenefitCodeDiscount: Maybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount>;
  countryId: Maybe<Scalars['BigInt']>;
  creator: Maybe<Instacart_Customers_Commerce_Discount_V1_Creator>;
  creditBackInCouponUsingCoupon: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon>;
  creditBackInDigitalWalletUsingCoupon: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet>;
  creditInCoupon: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon>;
  creditInDigitalWallet: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet>;
  /** any description for the policy */
  description: Maybe<Scalars['String']>;
  discountCategoryId: Maybe<Scalars['BigInt']>;
  discountUsingClippableCoupon: Maybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount>;
  discountUsingCoupon: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount>;
  endsAt: Maybe<Scalars['DateTime']>;
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference: Maybe<Scalars['String']>;
  fundingDetails: Maybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail>;
  imageUrl: Maybe<Scalars['String']>;
  inKindBackUsingCoupon: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack>;
  inKindDeposit: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit>;
  /** name of the policy */
  name: Maybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription: Maybe<Scalars['String']>;
  /** Request id. */
  requestId: Maybe<Scalars['String']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  source: Maybe<Scalars['String']>;
  startsAt: Maybe<Scalars['DateTime']>;
  /** status of the policy */
  status: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  userSegments: Maybe<Array<Maybe<Scalars['String']>>>;
  valueGrantCode: Maybe<Scalars['String']>;
  valueGrantPolicyId: Maybe<Scalars['BigInt']>;
  valueGrantPolicyKey: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade_Input = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input>>>;
  apiCallerDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_Input>;
  autoAppliedDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input>;
  autoCreditBackInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input>;
  autoCreditBackInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input>;
  autoInKindBack?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input>;
  checkoutBenefitCodeDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_Creator_Input>;
  creditBackInCouponUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input>;
  creditBackInDigitalWalletUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input>;
  creditInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input>;
  creditInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input>;
  /** any description for the policy */
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountUsingClippableCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input>;
  discountUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference?: InputMaybe<Scalars['String']>;
  fundingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inKindBackUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input>;
  inKindDeposit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input>;
  /** name of the policy */
  name?: InputMaybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription?: InputMaybe<Scalars['String']>;
  /** Request id. */
  requestId?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  source?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** status of the policy */
  status?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userSegments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueGrantCode?: InputMaybe<Scalars['String']>;
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus {
  ValueGrantPolicyStatusActive = 'VALUE_GRANT_POLICY_STATUS_ACTIVE',
  /** Budget-related pause (e.g., rate limit reached) */
  ValueGrantPolicyStatusBudgetPaused = 'VALUE_GRANT_POLICY_STATUS_BUDGET_PAUSED',
  ValueGrantPolicyStatusDiscarded = 'VALUE_GRANT_POLICY_STATUS_DISCARDED',
  ValueGrantPolicyStatusDraft = 'VALUE_GRANT_POLICY_STATUS_DRAFT',
  ValueGrantPolicyStatusInactive = 'VALUE_GRANT_POLICY_STATUS_INACTIVE',
  ValueGrantPolicyStatusUnspecified = 'VALUE_GRANT_POLICY_STATUS_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicyUpdateError';
  requestId: Maybe<Scalars['String']>;
  retriable: Maybe<Scalars['Boolean']>;
  updateError: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError_UpdateError>;
  valueGrantPolicyId: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError_UpdateError {
  /** end_at is invalid */
  UpdateErrorInvalidEndDate = 'UPDATE_ERROR_INVALID_END_DATE',
  /** update payload invalid */
  UpdateErrorInvalidPayload = 'UPDATE_ERROR_INVALID_PAYLOAD',
  /** indicates that moving to the new status is not allowed */
  UpdateErrorInvalidStatusTransition = 'UPDATE_ERROR_INVALID_STATUS_TRANSITION',
  UpdateErrorUnspecified = 'UPDATE_ERROR_UNSPECIFIED',
  /** indicates the current status does not allow edits */
  UpdateErrorUnsupportedStatusForUpdates = 'UPDATE_ERROR_UNSUPPORTED_STATUS_FOR_UPDATES',
  /** vgp needs to be published first */
  UpdateErrorVgpNotPublished = 'UPDATE_ERROR_VGP_NOT_PUBLISHED'
}

export enum Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority {
  ValueIssuingAuthorityBenefitProgram = 'VALUE_ISSUING_AUTHORITY_BENEFIT_PROGRAM',
  ValueIssuingAuthorityCaper = 'VALUE_ISSUING_AUTHORITY_CAPER',
  ValueIssuingAuthorityChaseCobrandPwp = 'VALUE_ISSUING_AUTHORITY_CHASE_COBRAND_PWP',
  ValueIssuingAuthorityChaseCobrandSignupService = 'VALUE_ISSUING_AUTHORITY_CHASE_COBRAND_SIGNUP_SERVICE',
  ValueIssuingAuthorityCpg = 'VALUE_ISSUING_AUTHORITY_CPG',
  ValueIssuingAuthorityCx = 'VALUE_ISSUING_AUTHORITY_CX',
  ValueIssuingAuthorityDirectedSpend = 'VALUE_ISSUING_AUTHORITY_DIRECTED_SPEND',
  ValueIssuingAuthorityGiftCard = 'VALUE_ISSUING_AUTHORITY_GIFT_CARD',
  ValueIssuingAuthorityIcPlus = 'VALUE_ISSUING_AUTHORITY_IC_PLUS',
  ValueIssuingAuthorityInstacartEmployeeBenefit = 'VALUE_ISSUING_AUTHORITY_INSTACART_EMPLOYEE_BENEFIT',
  /** Authority will not be applicable for Policies that don't have any value part. */
  ValueIssuingAuthorityNotApplicable = 'VALUE_ISSUING_AUTHORITY_NOT_APPLICABLE',
  ValueIssuingAuthorityRetailer = 'VALUE_ISSUING_AUTHORITY_RETAILER',
  ValueIssuingAuthoritySuperSaver = 'VALUE_ISSUING_AUTHORITY_SUPER_SAVER',
  /** Keeping Authority name generic for 2 reason (1. Source field contain source of offer, 2. it helps to extend offer ingestion to new 3rd party without making code change here) */
  ValueIssuingAuthorityThirdPartyOffersIngestion = 'VALUE_ISSUING_AUTHORITY_THIRD_PARTY_OFFERS_INGESTION',
  ValueIssuingAuthorityTreatmentService = 'VALUE_ISSUING_AUTHORITY_TREATMENT_SERVICE',
  ValueIssuingAuthorityUnspecified = 'VALUE_ISSUING_AUTHORITY_UNSPECIFIED'
}

export enum Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow {
  ValueIssuingFlowAppeasements = 'VALUE_ISSUING_FLOW_APPEASEMENTS',
  ValueIssuingFlowCaperCredits = 'VALUE_ISSUING_FLOW_CAPER_CREDITS',
  ValueIssuingFlowCarebot = 'VALUE_ISSUING_FLOW_CAREBOT',
  ValueIssuingFlowCharm = 'VALUE_ISSUING_FLOW_CHARM',
  ValueIssuingFlowChaseCobrandPwp = 'VALUE_ISSUING_FLOW_CHASE_COBRAND_PWP',
  ValueIssuingFlowChaseCobrandSignup = 'VALUE_ISSUING_FLOW_CHASE_COBRAND_SIGNUP',
  ValueIssuingFlowCiao = 'VALUE_ISSUING_FLOW_CIAO',
  ValueIssuingFlowConversion = 'VALUE_ISSUING_FLOW_CONVERSION',
  ValueIssuingFlowCxContact = 'VALUE_ISSUING_FLOW_CX_CONTACT',
  ValueIssuingFlowDirectedSpendOnboarding = 'VALUE_ISSUING_FLOW_DIRECTED_SPEND_ONBOARDING',
  ValueIssuingFlowDirectedSpendTopUp = 'VALUE_ISSUING_FLOW_DIRECTED_SPEND_TOP_UP',
  ValueIssuingFlowEmployeeParentalBenefit = 'VALUE_ISSUING_FLOW_EMPLOYEE_PARENTAL_BENEFIT',
  ValueIssuingFlowGiftCardRedemption = 'VALUE_ISSUING_FLOW_GIFT_CARD_REDEMPTION',
  ValueIssuingFlowIcPlusPickup = 'VALUE_ISSUING_FLOW_IC_PLUS_PICKUP',
  ValueIssuingFlowManualRedemption = 'VALUE_ISSUING_FLOW_MANUAL_REDEMPTION',
  /** Flow name will not be applicable for Policies that don't have off order part. */
  ValueIssuingFlowNotApplicable = 'VALUE_ISSUING_FLOW_NOT_APPLICABLE',
  /** Growth system flow which is similar to CIAO, but use rule base system to make decision */
  ValueIssuingFlowOffline = 'VALUE_ISSUING_FLOW_OFFLINE',
  ValueIssuingFlowOrderCompletion = 'VALUE_ISSUING_FLOW_ORDER_COMPLETION',
  ValueIssuingFlowRetailerContact = 'VALUE_ISSUING_FLOW_RETAILER_CONTACT',
  ValueIssuingFlowRti = 'VALUE_ISSUING_FLOW_RTI',
  /** Order problem/appeasement resolution flows */
  ValueIssuingFlowSelfService = 'VALUE_ISSUING_FLOW_SELF_SERVICE',
  ValueIssuingFlowThirdPartyOffersIngestion = 'VALUE_ISSUING_FLOW_THIRD_PARTY_OFFERS_INGESTION',
  ValueIssuingFlowUnitedAccountLinking = 'VALUE_ISSUING_FLOW_UNITED_ACCOUNT_LINKING',
  ValueIssuingFlowUnspecified = 'VALUE_ISSUING_FLOW_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Garnish_V1_Assignment = {
  __typename?: 'instacart_customers_commerce_garnish_v1_Assignment';
  name: Maybe<Instacart_Customers_Commerce_Garnish_V1_AssignmentType>;
  value: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Garnish_V1_AssignmentType {
  /** Free form string representing where the string will be displayed, for example at checkout or homepage, etc. */
  AssignmentContext = 'ASSIGNMENT_CONTEXT',
  /** To override the string in a specific country */
  AssignmentCountry = 'ASSIGNMENT_COUNTRY',
  /** To override the string in a specific store config */
  AssignmentStoreConfiguration = 'ASSIGNMENT_STORE_CONFIGURATION',
  AssignmentUnknown = 'ASSIGNMENT_UNKNOWN'
}

export type Instacart_Customers_Commerce_Garnish_V1_Assignment_Input = {
  name?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_AssignmentType>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ContentAssignment = {
  __typename?: 'instacart_customers_commerce_garnish_v1_ContentAssignment';
  assignments: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_Assignment>>>;
  localizedContents: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_LocalizedContent>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ContentAssignment_Input = {
  assignments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Assignment_Input>>>;
  localizedContents?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_LocalizedContent_Input>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_CreateStringsRequest_Input = {
  contentAssignments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment_Input>>>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Creator_Input>;
  resource?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>;
};

export type Instacart_Customers_Commerce_Garnish_V1_CreateStringsResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_CreateStringsResponse';
  contentAssignments: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment>>>;
  resource: Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>;
};

export enum Instacart_Customers_Commerce_Garnish_V1_CreatorType {
  CreatorTypeIpp = 'CREATOR_TYPE_IPP',
  CreatorTypeUnspecified = 'CREATOR_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Garnish_V1_Creator_Input = {
  creatorId?: InputMaybe<Scalars['BigInt']>;
  creatorType?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_CreatorType>;
};

export type Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesRequest_Input = {
  creator?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Creator_Input>;
  resources?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_DeleteResourcesResponse';
  deletedCount: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_GetStringsRequest_Input = {
  resource?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>;
};

export type Instacart_Customers_Commerce_Garnish_V1_GetStringsResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_GetStringsResponse';
  contentAssignments: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment>>>;
  resource: Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Filter_Input = {
  resourceIdentifier?: InputMaybe<Scalars['String']>;
  resourceName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Input = {
  filter?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Filter_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ListResourcesResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_ListResourcesResponse';
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  resource: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_LocalizedContent = {
  __typename?: 'instacart_customers_commerce_garnish_v1_LocalizedContent';
  content: Maybe<Scalars['String']>;
  locale: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_LocalizedContent_Input = {
  content?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_Resource = {
  __typename?: 'instacart_customers_commerce_garnish_v1_Resource';
  identifier: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_Resource_Input = {
  identifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_UpdateStringsRequest_Input = {
  contentAssignments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment_Input>>>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Creator_Input>;
  resource?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>;
};

export type Instacart_Customers_Commerce_Garnish_V1_UpdateStringsResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_UpdateStringsResponse';
  contentAssignments: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment>>>;
  resource: Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>;
};

/** Represent basket item restrictions */
export type Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketItemRestrictions';
  attributes: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions_ItemRestrictionType>>>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions_ItemRestrictionType {
  Alcohol = 'ALCOHOL',
  ItemRestrictionTypeUnspecified = 'ITEM_RESTRICTION_TYPE_UNSPECIFIED',
  OverTheCounter = 'OVER_THE_COUNTER',
  SprayPaint = 'SPRAY_PAINT'
}

/**
 * BasketProduct representation.
 * NOTE: Currently basket_product.rb is not auto generated by this proto.
 * Fields defined in basket_product.rb that are not included here: [legacy_attributes, _legacy_basket_product]
 * Next ID: 108
 */
export type Instacart_Customers_Commerce_Types_V1_BasketProduct = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct';
  alcoholByVolume: Maybe<Instacart_Types_V1_BigDecimal>;
  alcoholic: Maybe<Scalars['Boolean']>;
  artificiallyCarbonated: Maybe<Scalars['Boolean']>;
  brandId: Maybe<Scalars['BigInt']>;
  brandName: Maybe<Scalars['String']>;
  calories: Maybe<Instacart_Types_V1_BigDecimal>;
  catalog: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_Catalog>;
  catalogEntityId: Maybe<Scalars['BigInt']>;
  claimMedicinal: Maybe<Scalars['Boolean']>;
  coldPrepared: Maybe<Scalars['Boolean']>;
  comboPromotions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion>>>;
  /** commerce classfication */
  commerceClassification: Maybe<Instacart_Customers_Commerce_Types_V1_CommerceClassification>;
  configurableProducts: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts>;
  configured: Maybe<Scalars['Boolean']>;
  containerType: Maybe<Scalars['String']>;
  containsFlour: Maybe<Scalars['Boolean']>;
  costPricePerUnit: Maybe<GoogleTypeMoney>;
  costUnit: Maybe<Instacart_Types_V1_MeasurementUnit>;
  countryId: Maybe<Scalars['BigInt']>;
  custom: Maybe<Scalars['Boolean']>;
  customerSpecialRequest: Maybe<Scalars['Boolean']>;
  departmentName: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  disallowedServiceTypes: Maybe<Array<Maybe<Instacart_Customers_Shared_V1_ServiceType>>>;
  /**
   * Contains private data for discount services.
   * Message structure is defined in ::Orchestrators::Types::Commerce::Private::DiscountData
   */
  discountData: Maybe<Scalars['String']>;
  displayScreenSize: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_DisplayScreenSize>;
  displaySize: Maybe<Scalars['String']>;
  excludeMarkup: Maybe<Scalars['Boolean']>;
  /** External retailer specific metadata is not intended for internal system consumption. */
  externalRetailerSpecificMetadata: Maybe<Scalars['String']>;
  /** 0..100, eg. "12.30", nil means we don't know what fruit_juice_percent is */
  fruitJuicePercent: Maybe<Instacart_Types_V1_BigDecimal>;
  fulfillExtraLongDistanceDelivery: Maybe<Scalars['Boolean']>;
  imageUrl: Maybe<Scalars['String']>;
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  isCatering: Maybe<Scalars['Boolean']>;
  isHot: Maybe<Scalars['Boolean']>;
  /** Create first class variables for basket_product */
  isMedicated: Maybe<Scalars['Boolean']>;
  /** DEPRECATED use retailer_department_id */
  itemDepartmentId: Maybe<Scalars['String']>;
  itemRestrictions: Maybe<Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions>;
  /** Contains private data for items pricing services. */
  itemsPricingData: Maybe<Scalars['String']>;
  /** 0..100 */
  juicePercent: Maybe<Instacart_Types_V1_BigDecimal>;
  l1CategoryName: Maybe<Scalars['String']>;
  l1TaxonomyNodeId: Maybe<Scalars['BigInt']>;
  l2CategoryName: Maybe<Scalars['String']>;
  l2TaxonomyNodeId: Maybe<Scalars['BigInt']>;
  l3CategoryName: Maybe<Scalars['String']>;
  l3TaxonomyNodeId: Maybe<Scalars['BigInt']>;
  l4CategoryName: Maybe<Scalars['String']>;
  l4TaxonomyNodeId: Maybe<Scalars['BigInt']>;
  l5CategoryName: Maybe<Scalars['String']>;
  l5TaxonomyNodeId: Maybe<Scalars['BigInt']>;
  l6CategoryName: Maybe<Scalars['String']>;
  l6TaxonomyNodeId: Maybe<Scalars['BigInt']>;
  legacyFrozenItem: Maybe<Scalars['Boolean']>;
  legacyItemId: Maybe<Scalars['BigInt']>;
  legacyV3Id: Maybe<Scalars['String']>;
  legacyV3IdInt: Maybe<Scalars['BigInt']>;
  loyaltyAttributes: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_LoyaltyAttributes>;
  managedAttributeIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  name: Maybe<Scalars['String']>;
  nonRegulatoryItemDeposit: Maybe<GoogleTypeMoney>;
  normalizedDimensions: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_NormalizedDimensions>;
  normalizedWeightG: Maybe<Instacart_Types_V1_BigDecimal>;
  orderLeadTime: Maybe<Scalars['BigInt']>;
  parWeight: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  priceComparisonSize: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_LabeledQuantity>;
  priceMultiple: Maybe<Instacart_Types_V1_BigDecimal>;
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  productId: Maybe<Scalars['BigInt']>;
  productLocale: Maybe<Scalars['String']>;
  productType: Maybe<Scalars['String']>;
  quantityAttributes: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes>;
  reference: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference>;
  regionId: Maybe<Scalars['BigInt']>;
  requiresKeepFrozen: Maybe<Scalars['Boolean']>;
  requiresRefrigeration: Maybe<Scalars['Boolean']>;
  restrictedOtc: Maybe<Scalars['Boolean']>;
  restrictedReasons: Maybe<Array<Maybe<Scalars['String']>>>;
  /** retailer department. */
  retailerDepartment: Maybe<Scalars['String']>;
  retailerDepartmentId: Maybe<Scalars['String']>;
  /** Data about flyers the item is subscribed to */
  retailerFlyerData: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerFlyerDatum>>>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  retailerOmsEligible: Maybe<Scalars['Boolean']>;
  /** retailer product collection ids */
  retailerProductCollectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Retailer provided value to allow special size attributes to be displayed on storefront, i.e. Spirit Halloween's Costume sizes. */
  retailerProductSizeLabel: Maybe<Scalars['String']>;
  retailerPromotionDetails: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  rx: Maybe<Scalars['Boolean']>;
  /** rx_type is used to determine if the item is a prescription item, eg. rx_human, rx_pet */
  rxType: Maybe<Scalars['String']>;
  saleAttributes: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_SaleAttributes>;
  selectedConfigurations: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_SelectedConfiguration>>>;
  sheetCount: Maybe<Instacart_Types_V1_BigDecimal>;
  sizeMeasurement: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /**
   * Contains the label for the unit of size measurement (size_uom) provided by the retailer.
   * NOTE: This label is only for rendering purpose and should be used as-is.
   * Do not parse this value. To get the normalized unit of measure, use size_measurement.
   */
  sizeUomLabel: Maybe<Scalars['String']>;
  storeBrand: Maybe<Scalars['Boolean']>;
  /** Only to be used for offline auditing */
  surfaceId: Maybe<Scalars['BigInt']>;
  /** Create TaxableAttributes group on basket_product */
  taxableAttributes: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes>;
  tobacco: Maybe<Scalars['Boolean']>;
  unattachedCoupon: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_UnattachedCoupon>;
  unitCount: Maybe<Scalars['BigInt']>;
  usaSnapEligible: Maybe<Scalars['Boolean']>;
  v4ItemId: Maybe<Scalars['String']>;
  /** Retailer provided value to display special size attributes for a variant group. */
  variantGroupDisplaySizeLabel: Maybe<Scalars['String']>;
  /** 0..100 */
  vegetableJuicePercent: Maybe<Instacart_Types_V1_BigDecimal>;
  zoneIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** BasketProduceReference representation. */
export type Instacart_Customers_Commerce_Types_V1_BasketProductReference = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference';
  configuredItem: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem>;
  item: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item>;
  pricedItemSnapshot: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot>;
  rxItem: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem>;
  specialRequest: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_ConfiguredItem';
  id: Maybe<Scalars['BigInt']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** BasketProduceReference representation. */
export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_Input = {
  configuredItem?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem_Input>;
  item?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item_Input>;
  pricedItemSnapshot?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot_Input>;
  rxItem?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem_Input>;
  specialRequest?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest_Input>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_Item';
  productId: Maybe<Scalars['BigInt']>;
  productLocale: Maybe<Scalars['String']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
  productLocale?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_PricedItemSnapshot';
  id: Maybe<Scalars['BigInt']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_RxItem';
  id: Maybe<Scalars['BigInt']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_SpecialRequest';
  id: Maybe<Scalars['BigInt']>;
  userId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketProduct_Catalog {
  CatalogUnspecified = 'CATALOG_UNSPECIFIED',
  Configured = 'CONFIGURED',
  Custom = 'CUSTOM',
  Product = 'PRODUCT',
  Rx = 'RX'
}

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ComboPromotion';
  comboGroupId: Maybe<Scalars['String']>;
  discountBeginsAt: Maybe<Scalars['DateTime']>;
  discountEndsAt: Maybe<Scalars['DateTime']>;
  metadata: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Metadata>;
  name: Maybe<Scalars['String']>;
  promotionGroupId: Maybe<Scalars['String']>;
  rules: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Metadata = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ComboPromotion_Metadata';
  comboRequirements: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Requirement>>>;
  discountValue: Maybe<GoogleTypeMoney>;
  fixedPriceValue: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Requirement = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ComboPromotion_Requirement';
  comboGroupId: Maybe<Scalars['String']>;
  qty: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts';
  configId: Maybe<Scalars['String']>;
  configType: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigType>;
  optionGroups: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionGroup>>>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigOptionItem = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts_ConfigOptionItem';
  configOptionItemId: Maybe<Scalars['String']>;
  costPricePerUnit: Maybe<GoogleTypeMoney>;
  enabled: Maybe<Scalars['Boolean']>;
  overrides: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionOverride>>>;
  saleAttributes: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_SaleAttributes>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigType {
  Builder = 'BUILDER',
  ConfigTypeUnspecified = 'CONFIG_TYPE_UNSPECIFIED',
  Custom = 'CUSTOM',
  Pack = 'PACK',
  PrepStyle = 'PREP_STYLE',
  UnknownType = 'UNKNOWN_TYPE'
}

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionGroup = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts_OptionGroup';
  configOptionItems: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigOptionItem>>>;
  enabled: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionOverride = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts_OptionOverride';
  configOptionItemId: Maybe<Scalars['String']>;
  costPricePerUnit: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_DisplayScreenSize = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_DisplayScreenSize';
  /** e.g. "in", "inches", "ft", "yd", "m", "cm", "mm" etc. */
  uom: Maybe<Scalars['String']>;
  /** e.g., 15.6 */
  value: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Represents a quantity with a display label for its unit.
 * This is useful when dealing with retailer-provided units that may not map
 * cleanly to standardized measurement units.
 */
export type Instacart_Customers_Commerce_Types_V1_BasketProduct_LabeledQuantity = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_LabeledQuantity';
  /**
   * The label for the unit of the quantity.
   * This label is only for rendering purpose and should be used as-is. Do not parse this value.
   */
  label: Maybe<Scalars['String']>;
  /** The quantity in relevant units. */
  quantity: Maybe<Instacart_Types_V1_BigDecimal>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_LoyaltyAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_LoyaltyAttributes';
  loyaltyCostPricePerUnit: Maybe<GoogleTypeMoney>;
  loyaltyPriceEndAt: Maybe<Scalars['DateTime']>;
  loyaltyPriceStartAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_NormalizedDimensions = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_NormalizedDimensions';
  normalizedHeightCm: Maybe<Instacart_Types_V1_BigDecimal>;
  normalizedLengthCm: Maybe<Instacart_Types_V1_BigDecimal>;
  normalizedWidthCm: Maybe<Instacart_Types_V1_BigDecimal>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_QuantityAttributes';
  increment: Maybe<Instacart_Types_V1_BigDecimal>;
  max: Maybe<Instacart_Types_V1_BigDecimal>;
  min: Maybe<Instacart_Types_V1_BigDecimal>;
  produceOrderUnit: Maybe<Scalars['String']>;
  quantityType: Maybe<Instacart_Customers_Shared_V1_QuantityType>;
  requestUnit: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes_RequestUnit>;
  variableWeight: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes_RequestUnit {
  Each = 'EACH',
  Kg = 'KG',
  Lb = 'LB',
  Package = 'PACKAGE',
  RequestUnitUnspecified = 'REQUEST_UNIT_UNSPECIFIED'
}

/** Data about a flyer the item is subscribed to */
export type Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerFlyerDatum = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_RetailerFlyerDatum';
  endsAt: Maybe<Scalars['DateTime']>;
  startsAt: Maybe<Scalars['DateTime']>;
  /** The type of flyer (e.g. weekly, monthly, biweekly, summer splash, etc.) */
  tag: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_RetailerPromotionDetails';
  discountBeginsAt: Maybe<Scalars['DateTime']>;
  discountCategoryId: Maybe<Scalars['BigInt']>;
  discountEndsAt: Maybe<Scalars['DateTime']>;
  loyaltyMembersOnly: Maybe<Scalars['Boolean']>;
  metadata: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails_Metadata>;
  name: Maybe<Scalars['String']>;
  promotionGroupId: Maybe<Scalars['String']>;
  rules: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails_Metadata = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_RetailerPromotionDetails_Metadata';
  bundlePrice: Maybe<GoogleTypeMoney>;
  buy: Maybe<Scalars['BigInt']>;
  discountPercentages: Maybe<Array<Maybe<Instacart_Types_V1_BigDecimal>>>;
  discountValue: Maybe<GoogleTypeMoney>;
  get: Maybe<Scalars['BigInt']>;
  limitPerOrder: Maybe<Scalars['BigInt']>;
  maxQty: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  minQty: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** If true, all items need to be purchased and fulfilled for pomo discount. */
  qtyEnforced: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_SaleAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_SaleAttributes';
  saleCostPricePerUnit: Maybe<GoogleTypeMoney>;
  saleEndAt: Maybe<Scalars['DateTime']>;
  saleStartAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_SelectedConfiguration = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_SelectedConfiguration';
  /** Only set when config_type is PACK. */
  catalogItemId: Maybe<Scalars['BigInt']>;
  configOptionId: Maybe<Scalars['String']>;
  configOptionItemId: Maybe<Scalars['String']>;
  configOptionItemName: Maybe<Scalars['String']>;
  configOptionItemPrice: Maybe<GoogleTypeMoney>;
  configOptionName: Maybe<Scalars['String']>;
  /** Number of units of the catalog item selected. */
  quantity: Maybe<Scalars['BigInt']>;
  textValue: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes';
  retailerProvidedTaxes: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax>>>;
  /** 0..1 */
  retailerSalesTaxRate: Maybe<Instacart_Types_V1_BigDecimal>;
  vertexAttributes: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_VertexAttributes>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes_RetailerProvidedTax';
  /** indicates if the tax is already included in the price */
  priceEmbedded: Maybe<Scalars['Boolean']>;
  taxImpositions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax_RetailerProvidedTaxImposition>>>;
  taxName: Maybe<Scalars['String']>;
  /** 0..1 */
  taxRate: Maybe<Instacart_Types_V1_BigDecimal>;
  taxRateType: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax_RetailerProvidedTaxImposition = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes_RetailerProvidedTax_RetailerProvidedTaxImposition';
  imposition: Maybe<Scalars['String']>;
  isMpf: Maybe<Scalars['Boolean']>;
  isTaxable: Maybe<Scalars['Boolean']>;
  /** 0..1 */
  taxRate: Maybe<Instacart_Types_V1_BigDecimal>;
  taxRateType: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_VertexAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes_VertexAttributes';
  vertexCategoryTdc: Maybe<Scalars['String']>;
  vertexTaxOverrideAttribute: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_UnattachedCoupon = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_UnattachedCoupon';
  adminOnly: Maybe<Scalars['Boolean']>;
  countryId: Maybe<Scalars['BigInt']>;
  description: Maybe<Scalars['String']>;
  discountBeginsAt: Maybe<Scalars['DateTime']>;
  discountEndsAt: Maybe<Scalars['DateTime']>;
  exclusive: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  itemsPerDeal: Maybe<Scalars['BigInt']>;
  maxRedemptionsPerOrder: Maybe<Scalars['BigInt']>;
  maxRedemptionsTotal: Maybe<Scalars['BigInt']>;
  promotionGroupId: Maybe<Scalars['String']>;
  publicDescription: Maybe<Scalars['String']>;
  rules: Maybe<Array<Maybe<Scalars['String']>>>;
  sponsorName: Maybe<Scalars['String']>;
  subtractValueCents: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Types_V1_CommerceClassification {
  Alcoholic = 'ALCOHOLIC',
  CommerceClassificationUnknown = 'COMMERCE_CLASSIFICATION_UNKNOWN',
  DiscretionaryTip = 'DISCRETIONARY_TIP',
  GeneralMerchandise = 'GENERAL_MERCHANDISE',
  Rx = 'RX',
  VirtualRetailerMembership = 'VIRTUAL_RETAILER_MEMBERSHIP'
}

/** Enumerates the reasons a customer may choose to cancel an order. */
export enum Instacart_Customers_Commerce_Types_V1_CustomerCancelReason_CustomerReason {
  /** Customer wants to cancel the current order and place a new one. */
  CancelAndReorder = 'CANCEL_AND_REORDER',
  /** Want to modify the delivery time. */
  ChangeDeliveryTime = 'CHANGE_DELIVERY_TIME',
  /** Want to modify the pickup time. */
  ChangePickupTime = 'CHANGE_PICKUP_TIME',
  /** Customer reason isn't specified. */
  CustomerReasonUnspecified = 'CUSTOMER_REASON_UNSPECIFIED',
  /** Customer no longer needs the specific order. */
  DoNotNeedThisOrderAnymore = 'DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Inventory items were not available. */
  ItemsWereOutOfStock = 'ITEMS_WERE_OUT_OF_STOCK',
  /** The order is duplicated by the customer. */
  ICreatedADuplicateOrder = 'I_CREATED_A_DUPLICATE_ORDER',
  /** Customer no longer requires the order. */
  IDoNotNeedThisOrderAnymore = 'I_DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Customer wants to change the order. */
  IWantToChangeMyOrder = 'I_WANT_TO_CHANGE_MY_ORDER',
  /** Order scheduled for delivery too late. */
  LateOrder = 'LATE_ORDER',
  /** Customer needs to modify the items in the order. */
  NeedToAddOrRemoveItems = 'NEED_TO_ADD_OR_REMOVE_ITEMS',
  /** Customer needs to reschedule the order. */
  NeedToReschedule = 'NEED_TO_RESCHEDULE',
  /** Rescheduled delivery time didn't work. */
  NewTimeDidNotWorkDelivery = 'NEW_TIME_DID_NOT_WORK_DELIVERY',
  /** Rescheduled pickup time didn't work. */
  NewTimeDidNotWorkPickup = 'NEW_TIME_DID_NOT_WORK_PICKUP',
  /** Delivery is taking too long. */
  OrderTakingTooLong = 'ORDER_TAKING_TOO_LONG',
  /** Order time no longer works. */
  OrderTimeNoLongerWorks = 'ORDER_TIME_NO_LONGER_WORKS',
  /** Other unspecified reasons. */
  Other = 'OTHER',
  /** Redirection for unspecified reason. */
  OtherRedirect = 'OTHER_REDIRECT',
  /** Switch to delivery instead of pickup. */
  SwitchToDelivery = 'SWITCH_TO_DELIVERY',
  /** Switch to pickup instead of delivery. */
  SwitchToPickup = 'SWITCH_TO_PICKUP',
  /** General issue with the order. */
  ThereIsAProblemWithMyOrder = 'THERE_IS_A_PROBLEM_WITH_MY_ORDER',
  /** Order is pricier than expected. */
  TooExpensve = 'TOO_EXPENSVE',
  /** Too many replacements in the order. */
  TooManyReplacements = 'TOO_MANY_REPLACEMENTS',
  /** Embedded Instacart order associated trip was canceled. */
  TripCanceled = 'TRIP_CANCELED',
  /** Incorrect delivery address in a different city. */
  WrongAddressDifferentCity = 'WRONG_ADDRESS_DIFFERENT_CITY',
  /** Incorrect delivery address within the same city. */
  WrongAddressSameCity = 'WRONG_ADDRESS_SAME_CITY',
  /** Wrong delivery location specified in the order. */
  WrongDeliveryLocation = 'WRONG_DELIVERY_LOCATION',
  /** Wrong payment method. */
  WrongPaymentMethod = 'WRONG_PAYMENT_METHOD',
  /** Wrong payment details or tip adjustment. */
  WrongPaymentOrChangeTip = 'WRONG_PAYMENT_OR_CHANGE_TIP',
  /** Wrong location for order pickup. */
  WrongPickupLocation = 'WRONG_PICKUP_LOCATION',
  /** Incorrect store location was chosen. */
  WrongRetailerLocation = 'WRONG_RETAILER_LOCATION'
}

/** Funding source */
export enum Instacart_Customers_Commerce_Types_V1_FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  Retailer = 'RETAILER'
}

/** Order Cancellation Category */
export enum Instacart_Customers_Commerce_Types_V1_OrderCancellationCategory {
  CustomerResponsible = 'CUSTOMER_RESPONSIBLE',
  InstacartPolicyEnforcement = 'INSTACART_POLICY_ENFORCEMENT',
  IntacartUnbatchable = 'INTACART_UNBATCHABLE',
  OrderCancellationCategoryUnspecified = 'ORDER_CANCELLATION_CATEGORY_UNSPECIFIED',
  OtherCancellationCategory = 'OTHER_CANCELLATION_CATEGORY',
  RetailerStoreIssue = 'RETAILER_STORE_ISSUE',
  ShopperRequested = 'SHOPPER_REQUESTED'
}

/** The specific reason why the order is canceled. */
export enum Instacart_Customers_Commerce_Types_V1_OrderCancellationType {
  /** Admin Refund. */
  AdminRefund = 'ADMIN_REFUND',
  /** Audit failure in bypass checkout. */
  AuditFailureInBypassCheckout = 'AUDIT_FAILURE_IN_BYPASS_CHECKOUT',
  /** Auto cancellation from order management workflow */
  AutoCompletionCancellation = 'AUTO_COMPLETION_CANCELLATION',
  /** Unrecoverable error during BJS bypass. */
  BjsBypassUnrecoverableError = 'BJS_BYPASS_UNRECOVERABLE_ERROR',
  /** Cancellation due to blocked completion. */
  BlockedCompletionCancellation = 'BLOCKED_COMPLETION_CANCELLATION',
  /** Order canceled by the customer. */
  CanceledByCustomer = 'CANCELED_BY_CUSTOMER',
  /** Order canceled by the retailer. */
  CancelledByRetailer = 'CANCELLED_BY_RETAILER',
  /** Order canceled via script. */
  CancelledViaScript = 'CANCELLED_VIA_SCRIPT',
  /** Card declined during reauthorization. */
  CardDeclineOnReauth = 'CARD_DECLINE_ON_REAUTH',
  /** Cancellation due to a car accident. */
  CarAccident = 'CAR_ACCIDENT',
  /** Cancellation due to car issues. */
  CarIssue = 'CAR_ISSUE',
  /** Payment method needed to be changed. */
  ChangePaymentMethod = 'CHANGE_PAYMENT_METHOD',
  /** Customer faced issues with app navigation. */
  CustomerAppNavigationIssue = 'CUSTOMER_APP_NAVIGATION_ISSUE',
  /** Customer MIA. */
  CustomerMia = 'CUSTOMER_MIA',
  /** Customer is missing in action during drop-off. */
  CustomerMiaOnDropOffOrder = 'CUSTOMER_MIA_ON_DROP_OFF_ORDER',
  /** Customer requested cancellation because the order is early. */
  CustomerRequestedSinceOrderIsEarly = 'CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested cancellation because the order is late. */
  CustomerRequestedSinceOrderIsLate = 'CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Customer requested to cancel the order. */
  CustomerRequestToCancel = 'CUSTOMER_REQUEST_TO_CANCEL',
  /** Order delivered outside the scheduled window. */
  DeliveredOutsideOfWindow = 'DELIVERED_OUTSIDE_OF_WINDOW',
  /**
   * Order canceled due to cancellation of a related dependent order.
   * E.g. in the case of a party order, if the host order is canceled we may cancel the member orders.
   */
  DependentOrderCanceled = 'DEPENDENT_ORDER_CANCELED',
  /** Duplicate order. */
  DuplicateOrder = 'DUPLICATE_ORDER',
  /** Cancellation due to an emergency. */
  Emergency = 'EMERGENCY',
  /** Empty Delivery. */
  EmptyDelivery = 'EMPTY_DELIVERY',
  /** Cancellation due to failed completion. */
  FailedCompletionCancellation = 'FAILED_COMPLETION_CANCELLATION',
  /** Fraudulent Customer. */
  FraudulentCustomer = 'FRAUDULENT_CUSTOMER',
  /** Fulfillment initiated due to out-of-stock items. */
  FulfillmentInitiatedDueToOutOfStock = 'FULFILLMENT_INITIATED_DUE_TO_OUT_OF_STOCK',
  /** Incorrect accessibility information. */
  IncorrectAccessibilityInformation = 'INCORRECT_ACCESSIBILITY_INFORMATION',
  /** Incorrect customer information. */
  IncorrectCustomerInformation = 'INCORRECT_CUSTOMER_INFORMATION',
  /** All items refunded in an Instacart Connect order. */
  InstacartConnectOrderWithAllItemsRefunded = 'INSTACART_CONNECT_ORDER_WITH_ALL_ITEMS_REFUNDED',
  /** Failed to get a suspended transaction for Kroger Connect. */
  KrogerConnectFailedToGetSuspendedTransaction = 'KROGER_CONNECT_FAILED_TO_GET_SUSPENDED_TRANSACTION',
  /** Manual fraud. */
  ManualFraud = 'MANUAL_FRAUD',
  /** Mass cancellation of orders. */
  MassCancellation = 'MASS_CANCELLATION',
  /** Missing charge log for delivery. */
  MissingChargeLogForDelivery = 'MISSING_CHARGE_LOG_FOR_DELIVERY',
  /** No cancellation reason specified. */
  None = 'NONE',
  /** Online Payment Failure. */
  OnlinePayFailure = 'ONLINE_PAY_FAILURE',
  /** Unspecified cancellation type. */
  OrderCancellationTypeUnspecified = 'ORDER_CANCELLATION_TYPE_UNSPECIFIED',
  /** Cancellation due to other unspecified reasons. */
  OtherCancellationType = 'OTHER_CANCELLATION_TYPE',
  /** Order is in pre-picking stage. */
  PrePicking = 'PRE_PICKING',
  /** Cancellation due to related accounts fraud abuse. */
  RelatedAccountsAbuse = 'RELATED_ACCOUNTS_ABUSE',
  /** Retailer initiated cancellation because the customer is MIA. */
  RetailerInitiatedCustomerMia = 'RETAILER_INITIATED_CUSTOMER_MIA',
  /** Retailer initiated cancellation due to out-of-stock items. */
  RetailerInitiatedOutOfStock = 'RETAILER_INITIATED_OUT_OF_STOCK',
  /** Cancellation due to safety concerns. */
  SafetyConcerns = 'SAFETY_CONCERNS',
  /** Cancellation due to a severe weather event. */
  SevereWeatherEvent = 'SEVERE_WEATHER_EVENT',
  /** Shopper couldn't locate the delivery address. */
  ShopperCouldNotFindAddress = 'SHOPPER_COULD_NOT_FIND_ADDRESS',
  /** Shopper initiated cancellation due to out-of-stock items. */
  ShopperInitiatedOutOfStock = 'SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Shopper is unable to complete the order. */
  ShopperUnableToCompleteOrder = 'SHOPPER_UNABLE_TO_COMPLETE_ORDER',
  /** Single item order is out of stock. */
  SingleItemOrderOutOfStock = 'SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Early closure of store. */
  StoreEarlyClosure = 'STORE_EARLY_CLOSURE',
  /** Store experiencing an outage. */
  StoreOutage = 'STORE_OUTAGE',
  /** Too many items are out of stock. */
  TooManyOutOfStockItem = 'TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements in the order. */
  TooManyReplacements = 'TOO_MANY_REPLACEMENTS',
  /** Cancellation due to traffic conditions. */
  TrafficConditions = 'TRAFFIC_CONDITIONS',
  /** Unable to reschedule the order as no options were available. */
  UnableToRescheduleAsNoOptionFound = 'UNABLE_TO_RESCHEDULE_AS_NO_OPTION_FOUND',
  /** Unable to reschedule due to unbatchable order. */
  UnableToRescheduleUnbatchable = 'UNABLE_TO_RESCHEDULE_UNBATCHABLE',
  /** Order is unbatchable. */
  Unbatchable = 'UNBATCHABLE',
  /** Incorrect store operating hours. */
  WrongStoreHours = 'WRONG_STORE_HOURS'
}

export type Instacart_Customers_Commerce_Types_V1_PaymentInstruction = {
  __typename?: 'instacart_customers_commerce_types_v1_PaymentInstruction';
  /** Additional payment method specific data */
  additionalData: Maybe<Instacart_Customers_Commerce_Types_V1_PaymentInstruction_AdditionalData>;
  default: Maybe<Scalars['Boolean']>;
  instrumentReference: Maybe<Scalars['String']>;
  /** instrument type used to match the existing v3 payment instruction field. */
  legacyPaymentInstrumentType: Maybe<Instacart_Customers_Commerce_Types_V1_PaymentInstruction_LegacyPaymentInstrumentType>;
  /**
   * TODO: we should deprecate this and move to AdditionalData
   * payment method token id
   */
  paymentMethodTokenReference: Maybe<Scalars['String']>;
  userSpecifiedMaximumAmount: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Types_V1_PaymentInstruction_AdditionalData = {
  __typename?: 'instacart_customers_commerce_types_v1_PaymentInstruction_AdditionalData';
  /**
   * Payment transaction log ID for the InitiatePayment call
   * (This must be left as nil if not applicable.)
   * Currently, this is only required for Paysecure when creating a payment.
   */
  ebtInitiatePaymentTransactionLogId: Maybe<Scalars['BigInt']>;
  /** Preferred card network for routing. */
  preferredNetwork: Maybe<Instacart_Customers_Commerce_Types_V1_PaymentNetwork>;
};

export enum Instacart_Customers_Commerce_Types_V1_PaymentInstruction_LegacyPaymentInstrumentType {
  ApplePay = 'APPLE_PAY',
  CashApp = 'CASH_APP',
  ChasePwp = 'CHASE_PWP',
  CreditCard = 'CREDIT_CARD',
  DigitalWallet = 'DIGITAL_WALLET',
  DirectedSpend = 'DIRECTED_SPEND',
  Ebt = 'EBT',
  GooglePay = 'GOOGLE_PAY',
  /** deprecated use 14 */
  Hsa = 'HSA',
  HsaFsaCard = 'HSA_FSA_CARD',
  IcbBalance = 'ICB_BALANCE',
  KlarnaMultiUse = 'KLARNA_MULTI_USE',
  KlarnaSingleUse = 'KLARNA_SINGLE_USE',
  LegacyPaymentInstrumentTypeUnspecified = 'LEGACY_PAYMENT_INSTRUMENT_TYPE_UNSPECIFIED',
  LoyaltyWallet = 'LOYALTY_WALLET',
  Medicare = 'MEDICARE',
  Paypal = 'PAYPAL',
  RetailerGiftCard = 'RETAILER_GIFT_CARD',
  Venmo = 'VENMO'
}

/**
 * Shared enum representing payment networks.
 * Values align with the PGS Network enum in
 * instacart/customers/payment_gateway/v1/card_network_transaction_data.proto
 * and with Stripe's card network identifiers
 * (see https://stripe.com/docs/api/charges/object#charge_object-payment_method_details-card-network).
 */
export enum Instacart_Customers_Commerce_Types_V1_PaymentNetwork {
  PaymentNetworkAmex = 'PAYMENT_NETWORK_AMEX',
  PaymentNetworkCartesBancaires = 'PAYMENT_NETWORK_CARTES_BANCAIRES',
  PaymentNetworkDiners = 'PAYMENT_NETWORK_DINERS',
  PaymentNetworkDiscover = 'PAYMENT_NETWORK_DISCOVER',
  PaymentNetworkInterac = 'PAYMENT_NETWORK_INTERAC',
  PaymentNetworkJcb = 'PAYMENT_NETWORK_JCB',
  PaymentNetworkMastercard = 'PAYMENT_NETWORK_MASTERCARD',
  PaymentNetworkUnionpay = 'PAYMENT_NETWORK_UNIONPAY',
  PaymentNetworkUnspecified = 'PAYMENT_NETWORK_UNSPECIFIED',
  PaymentNetworkVisa = 'PAYMENT_NETWORK_VISA'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer';
  buyMAmountGetNQtyWithXPercentOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario>;
  buyMAmountGetXAmountOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario>;
  buyMAmountGetXPercentOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario>;
  buyMAmountOfAGetBForXAmountPerUnitScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOfAGetBForXAmountScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario>;
  buyMAmountOfAGetXAmountOffOnBScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario>;
  buyMAmountOfAGetXPercentOffOnBScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario>;
  buyMOfAGetBForXAmountPerUnitScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario>;
  buyMQtyForXAmountScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario>;
  buyMQtyGetNForFreeScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario>;
  buyMQtyGetNQtyForXAmountScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario>;
  buyMQtyGetNQtyWithXAmountOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario>;
  buyMQtyGetNQtyWithXPercentOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario>;
  buyMQtyGetXAmountOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario>;
  buyMQtyGetXPercentOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario>;
  buyMQtyOfAGetBForXAmountScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario>;
  buyMQtyOfAGetXAmountOffOnBScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario>;
  buyMQtyOfAGetXPercentOffOnBScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario>;
  buyMQtyOrMoreForXAmountEachScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario>;
  buyMQtyOrMoreGetXAmountOffEachScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario>;
  buyMQtyOrMoreGetXAmountOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario>;
  buyMQtyOrMoreGetXPercentOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario>;
  buyMRangeQtyGetXPercentOffTieredScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario>;
  buyMUnitsGetNUnitsForFreeScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario>;
  buyMUnitsGetXAmountOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario>;
  buyMUnitsGetXPercentOffScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario>;
  buyMUnitsOfAGetXPercentOffOnBScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario>;
  buyMWeightForXAmountPerWeightUnitScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario>;
  buyMWeightGetXAmountOffPerWeightUnitScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario>;
  conditionRewardString: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  discountCategoryId: Maybe<Scalars['BigInt']>;
  discountToken: Maybe<Scalars['String']>;
  endsAt: Maybe<Scalars['DateTime']>;
  fundingDetail: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail>;
  imageUrl: Maybe<Scalars['String']>;
  isLoyaltyOffer: Maybe<Scalars['Boolean']>;
  metadata: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata>;
  name: Maybe<Scalars['String']>;
  offerConditions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition>>>;
  offerExternalReference: Maybe<Scalars['String']>;
  offerId: Maybe<Scalars['String']>;
  offerLabelString: Maybe<Scalars['String']>;
  offerRequestKey: Maybe<Scalars['String']>;
  offerRewards: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward>>>;
  offerSource: Maybe<Scalars['String']>;
  offerStackability: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferStackability>;
  offerType: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferType>;
  promoCode: Maybe<Scalars['String']>;
  redemptionLimits: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits>;
  startsAt: Maybe<Scalars['DateTime']>;
  terms: Maybe<Scalars['String']>;
  uncategorizedScenario: Maybe<Scalars['instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario']>;
};

/** Buy M amount of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M amount of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M amount of eligible products and get X amount off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetXAmountOffScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M amount of eligible products and get X amount off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M amount of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetXPercentOffScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M amount of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M amount of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M amount of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M amount or more of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount or more of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount or more of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario';
  mAmount: Maybe<GoogleTypeMoney>;
  nQty: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M amount or more of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M units of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario';
  mUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M units of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyForXAmountScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get additional N qty for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyForFreeScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty of eligible products and get additional N qty for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M qty of eligible products and be eligible to buy N eligible products for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and be eligible to buy N eligible products for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get additional N qty with X amount off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get additional N qty with X amount off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M qty of eligible products and get X (monetary value) off the original price. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetXAmountOffScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get X (monetary value) off the original price. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetXPercentOffScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M qty of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M qty of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M qty of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M qty of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M qty of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M qty of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M qty or more qty of eligible products for X amount each (set price per item). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty or more qty of eligible products for X amount each (set price per item). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty or more, get X dollars off each */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty or more, get X dollars off each */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty or more qty of eligible products and get X amount off the total price (of M or more). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty or more qty of eligible products and get X amount off the total price (of M or more). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty or more qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario';
  mQty: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty or more qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M range qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario';
  mQtyMax: Maybe<Instacart_Types_V1_BigDecimal>;
  mQtyMin: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M range qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario_Input = {
  mQtyMax?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  mQtyMin?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * An offer in a group of BuyMRangeQtyGetXPercentOffScenario offers that forms a tiered reward, where a higher quantity M
 * matches a higher ranked tier with a different reward percentage.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario';
  currentTier: Maybe<Scalars['BigInt']>;
  tiers: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario>>>;
};

/**
 * An offer in a group of BuyMRangeQtyGetXPercentOffScenario offers that forms a tiered reward, where a higher quantity M
 * matches a higher ranked tier with a different reward percentage.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario_Input = {
  currentTier?: InputMaybe<Scalars['BigInt']>;
  tiers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario_Input>>>;
};

/** Buy M units of eligible products and get additional N units for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario';
  mUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  nUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
};

/** Buy M units of eligible products and get additional N units for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  nUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
};

/** Buy M units of eligible products for X amount off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetXAmountOffScenario';
  mUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M units of eligible products for X amount off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M units of eligible products for X percent off per measurement unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario';
  mUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M units of eligible products for X percent off per measurement unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M units of eligible products for X percent off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetXPercentOffScenario';
  mUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M units of eligible products for X percent off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M units of A and get X percent off on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario';
  mUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  nUnits: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M units of A and get X percent off on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  nUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario';
  mWeight: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario_Input = {
  mWeight?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario';
  mWeight: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario_Input = {
  mWeight?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M weight or more of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario';
  mWeight: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M weight or more of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario_Input = {
  mWeight?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_CategoryMetadata';
  retailerDepartmentTaxonomyCategories: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory>>>;
  taxonomyCategory: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata_Input = {
  retailerDepartmentTaxonomyCategories?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory_Input>>>;
  taxonomyCategory?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory_Input>>>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_DiscountRewardType {
  AmountOff = 'AMOUNT_OFF',
  /** Used to provide X dollars off per unit e.g buy 5 or more apples, get $1 off each apple */
  AmountPerUnit = 'AMOUNT_PER_UNIT',
  /** Used to provide X amount off per unit weight e.g buy 2 lb of chicken salad, get $3 off price-per-pound */
  AmountPerUnitWeight = 'AMOUNT_PER_UNIT_WEIGHT',
  DiscountRewardTypeUnspecified = 'DISCOUNT_REWARD_TYPE_UNSPECIFIED',
  /** Parts per 100,000. Used to represent fractional percent values (up to 3 decimal places) as an integer. i.e, 1.234 percent is 1234 per cent mille */
  PercentMille = 'PERCENT_MILLE',
  /**
   * Similar to amount and set price per unit, used to provide X percent off per measurement unit e.g. buy 5 lbs or more of apples, get 10% off each lb
   * This is required for measurement units because calculation of certain aspects of the discount
   * like share of discount are different from regular quantity based offers
   */
  PercentMillePerUnit = 'PERCENT_MILLE_PER_UNIT',
  PercentOff = 'PERCENT_OFF',
  SetPrice = 'SET_PRICE',
  /** Used to set the specific price per unit e.g. buy 3 bananas or more for $2 each */
  SetPricePerUnit = 'SET_PRICE_PER_UNIT',
  /** Used to set the specific price per unit weight e.g buy 2 lb of chicken salad for $3.99 / lb */
  SetPricePerUnitWeight = 'SET_PRICE_PER_UNIT_WEIGHT'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_FundingDetail';
  /** the amount of budget available before the offer is exhausted */
  budgetLimit: Maybe<GoogleTypeMoney>;
  fundingProviderInfo: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail_Input = {
  /** the amount of budget available before the offer is exhausted */
  budgetLimit?: InputMaybe<GoogleTypeMoneyInput>;
  fundingProviderInfo?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation_Input>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_FundingProviderInformation';
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent: Maybe<Scalars['BigInt']>;
  /** who is funding this part */
  source: Maybe<Instacart_Customers_Commerce_Types_V1_FundingSource>;
  /** name of the funding source */
  sourceName: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation_Input = {
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent?: InputMaybe<Scalars['BigInt']>;
  /** who is funding this part */
  source?: InputMaybe<Instacart_Customers_Commerce_Types_V1_FundingSource>;
  /** name of the funding source */
  sourceName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_Input = {
  buyMAmountGetNQtyWithXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario_Input>;
  buyMAmountGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario_Input>;
  buyMAmountGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario_Input>;
  buyMAmountOfAGetBForXAmountPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario_Input>;
  buyMAmountOfAGetBForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario_Input>;
  buyMAmountOfAGetXAmountOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario_Input>;
  buyMAmountOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario_Input>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario_Input>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario_Input>;
  buyMOfAGetBForXAmountPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario_Input>;
  buyMQtyForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario_Input>;
  buyMQtyGetNForFreeScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario_Input>;
  buyMQtyGetNQtyForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario_Input>;
  buyMQtyGetNQtyWithXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario_Input>;
  buyMQtyGetNQtyWithXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario_Input>;
  buyMQtyGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario_Input>;
  buyMQtyGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario_Input>;
  buyMQtyOfAGetBForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario_Input>;
  buyMQtyOfAGetXAmountOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario_Input>;
  buyMQtyOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario_Input>;
  buyMQtyOrMoreForXAmountEachScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario_Input>;
  buyMQtyOrMoreGetXAmountOffEachScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario_Input>;
  buyMQtyOrMoreGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario_Input>;
  buyMQtyOrMoreGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario_Input>;
  buyMRangeQtyGetXPercentOffTieredScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario_Input>;
  buyMUnitsGetNUnitsForFreeScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario_Input>;
  buyMUnitsGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario_Input>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario_Input>;
  buyMUnitsGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario_Input>;
  buyMUnitsOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario_Input>;
  buyMWeightForXAmountPerWeightUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario_Input>;
  buyMWeightGetXAmountOffPerWeightUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario_Input>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario_Input>;
  conditionRewardString?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountToken?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  fundingDetail?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isLoyaltyOffer?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata_Input>;
  name?: InputMaybe<Scalars['String']>;
  offerConditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition_Input>>>;
  offerExternalReference?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerLabelString?: InputMaybe<Scalars['String']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  offerRewards?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward_Input>>>;
  offerSource?: InputMaybe<Scalars['String']>;
  offerStackability?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferStackability>;
  offerType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferType>;
  promoCode?: InputMaybe<Scalars['String']>;
  redemptionLimits?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits_Input>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  terms?: InputMaybe<Scalars['String']>;
  uncategorizedScenario?: InputMaybe<Scalars['instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario_Input']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_LocaleCategories';
  category: Maybe<Array<Maybe<Scalars['String']>>>;
  locale: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories_Input = {
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locale?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_Metadata';
  categoryMetadata: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata>;
  termsAndConditions: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata_Input = {
  categoryMetadata?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata_Input>;
  termsAndConditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions_Input>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_OfferCondition';
  allowPartialApplication: Maybe<Scalars['Boolean']>;
  collectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  conditionProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedCollectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  maximumQuantity: Maybe<Scalars['BigInt']>;
  minimumQuantity: Maybe<Scalars['BigInt']>;
  minimumSpend: Maybe<GoogleTypeMoney>;
  offerConditionType: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferConditionType>;
  retailerDepartments: Maybe<Array<Maybe<Scalars['String']>>>;
  serviceType: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  taxonomyNodeIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferConditionType {
  OfferConditionTypeBasket = 'OFFER_CONDITION_TYPE_BASKET',
  OfferConditionTypeBrands = 'OFFER_CONDITION_TYPE_BRANDS',
  OfferConditionTypeCategories = 'OFFER_CONDITION_TYPE_CATEGORIES',
  OfferConditionTypeCollections = 'OFFER_CONDITION_TYPE_COLLECTIONS',
  OfferConditionTypeCommerceClassifications = 'OFFER_CONDITION_TYPE_COMMERCE_CLASSIFICATIONS',
  OfferConditionTypeFees = 'OFFER_CONDITION_TYPE_FEES',
  OfferConditionTypeProducts = 'OFFER_CONDITION_TYPE_PRODUCTS',
  OfferConditionTypeRegions = 'OFFER_CONDITION_TYPE_REGIONS',
  OfferConditionTypeRetailerDepartments = 'OFFER_CONDITION_TYPE_RETAILER_DEPARTMENTS',
  OfferConditionTypeUnspecified = 'OFFER_CONDITION_TYPE_UNSPECIFIED',
  OfferConditionTypeWeightUnit = 'OFFER_CONDITION_TYPE_WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition_Input = {
  allowPartialApplication?: InputMaybe<Scalars['Boolean']>;
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  conditionProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedCollectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  maximumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumSpend?: InputMaybe<GoogleTypeMoneyInput>;
  offerConditionType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferConditionType>;
  retailerDepartments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  taxonomyNodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_OfferRedemptionLimits';
  redemptionLimit: Maybe<Scalars['BigInt']>;
  redemptionLimitPerOrder: Maybe<Scalars['BigInt']>;
  redemptionLimitPerUser: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits_Input = {
  redemptionLimit?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerOrder?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_OfferReward';
  amountDiscount: Maybe<GoogleTypeMoney>;
  discountRewardType: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_DiscountRewardType>;
  includeConditionGroup: Maybe<Scalars['Boolean']>;
  maximumDiscount: Maybe<GoogleTypeMoney>;
  offerPrice: Maybe<GoogleTypeMoney>;
  offerRewardType: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRewardType>;
  percentDiscount: Maybe<Instacart_Types_V1_BigDecimal>;
  quantityLimit: Maybe<Scalars['BigInt']>;
  rewardProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  serviceItemType: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_ServiceItemType>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRewardType {
  OfferRewardTypeBasket = 'OFFER_REWARD_TYPE_BASKET',
  OfferRewardTypeBrands = 'OFFER_REWARD_TYPE_BRANDS',
  OfferRewardTypeCategories = 'OFFER_REWARD_TYPE_CATEGORIES',
  OfferRewardTypeCollections = 'OFFER_REWARD_TYPE_COLLECTIONS',
  OfferRewardTypeProducts = 'OFFER_REWARD_TYPE_PRODUCTS',
  OfferRewardTypeRetailerDepartments = 'OFFER_REWARD_TYPE_RETAILER_DEPARTMENTS',
  OfferRewardTypeServiceItem = 'OFFER_REWARD_TYPE_SERVICE_ITEM',
  OfferRewardTypeUnspecified = 'OFFER_REWARD_TYPE_UNSPECIFIED',
  OfferRewardTypeWeightUnit = 'OFFER_REWARD_TYPE_WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward_Input = {
  amountDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  discountRewardType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_DiscountRewardType>;
  includeConditionGroup?: InputMaybe<Scalars['Boolean']>;
  maximumDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  offerPrice?: InputMaybe<GoogleTypeMoneyInput>;
  offerRewardType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRewardType>;
  percentDiscount?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  quantityLimit?: InputMaybe<Scalars['BigInt']>;
  rewardProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceItemType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_ServiceItemType>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferStackability {
  /** Indicates the offer bypasses all stackability rules and always allowed to apply irrespective of other competing offers */
  AlwaysStackable = 'ALWAYS_STACKABLE',
  /** Indicates the offer is not stackable with other stackable and non-stackable offers */
  NonStackable = 'NON_STACKABLE',
  OfferStackabilityUnspecified = 'OFFER_STACKABILITY_UNSPECIFIED',
  /** Indicates the offer is stackable with any offer */
  Stackable = 'STACKABLE'
}

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferType {
  AutoApply = 'AUTO_APPLY',
  /** Auto apply credit back */
  AutoApplyCreditBack = 'AUTO_APPLY_CREDIT_BACK',
  /** Auto apply in-kind back */
  AutoApplyInKindBack = 'AUTO_APPLY_IN_KIND_BACK',
  CheckoutCodeBasedDiscount = 'CHECKOUT_CODE_BASED_DISCOUNT',
  Coupon = 'COUPON',
  /** Coupon based credit back */
  CouponBasedCreditBack = 'COUPON_BASED_CREDIT_BACK',
  /** Coupon based in-kind back */
  CouponBasedInKindBack = 'COUPON_BASED_IN_KIND_BACK',
  OfferTypeUnspecified = 'OFFER_TYPE_UNSPECIFIED',
  /** Discount that requires loyalty point redemption */
  PointsBasedDiscount = 'POINTS_BASED_DISCOUNT',
  /** In-kind (non-monetary) value */
  ValueIssuedInKind = 'VALUE_ISSUED_IN_KIND'
}

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_ServiceItemType {
  DeliveryFee = 'DELIVERY_FEE',
  ServiceItemTypeUnspecified = 'SERVICE_ITEM_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_TaxonomyCategory';
  localeCategories: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories>>>;
  taxonomyLevel: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory_Input = {
  localeCategories?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories_Input>>>;
  taxonomyLevel?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_TermsAndConditions';
  locale: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions_Input = {
  locale?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Types_V1_SupportRescheduleDeliveryReason {
  /** Customer is missing in action. */
  SupportRescheduleDeliveryReasonCustomerMia = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_MIA',
  /** Customer requested since order is early. */
  SupportRescheduleDeliveryReasonCustomerRequestedSinceOrderIsEarly = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested since order is late. */
  SupportRescheduleDeliveryReasonCustomerRequestedSinceOrderIsLate = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Incorrect customer information was provided. */
  SupportRescheduleDeliveryReasonIncorrectCustomerInformation = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_INCORRECT_CUSTOMER_INFORMATION',
  /** Retailer initiated out of stock. */
  SupportRescheduleDeliveryReasonRetailerInitiatedOutOfStock = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_RETAILER_INITIATED_OUT_OF_STOCK',
  /** Shopper initiated out of stock. */
  SupportRescheduleDeliveryReasonShopperInitiatedOutOfStock = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Single item in the order was out of stock. */
  SupportRescheduleDeliveryReasonSingleItemOrderOutOfStock = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Store early closure. */
  SupportRescheduleDeliveryReasonStoreEarlyClosure = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_STORE_EARLY_CLOSURE',
  /** Store outage. */
  SupportRescheduleDeliveryReasonStoreOutage = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_STORE_OUTAGE',
  /** Too many items out of stock. */
  SupportRescheduleDeliveryReasonTooManyOutOfStockItem = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements. */
  SupportRescheduleDeliveryReasonTooManyReplacements = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_TOO_MANY_REPLACEMENTS',
  /** Unspecified. */
  SupportRescheduleDeliveryReasonUnspecified = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_UNSPECIFIED',
  /** Wrong store hours. */
  SupportRescheduleDeliveryReasonWrongStoreHours = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_WRONG_STORE_HOURS'
}

/** ValueGrantGuaranteeBasis defines the basis for guaranteeing that a value-grant is honoured at checkout. */
export enum Instacart_Customers_Commerce_Types_V1_ValueGrantGuaranteeBasis {
  /**
   * Available Budget: value-grant is only guaranteed if budget is available.
   * Budget IS checked at order confirmation time.
   */
  ValueGrantGuaranteeBasisAvailableBudget = 'VALUE_GRANT_GUARANTEE_BASIS_AVAILABLE_BUDGET',
  /**
   * Engaged User Action: value-grant is only guaranteed if the user has meaningfully performed an action intending to receive the value-grant.
   * Budget is NOT checked (commitment was made).
   */
  ValueGrantGuaranteeBasisEngagedUserAction = 'VALUE_GRANT_GUARANTEE_BASIS_ENGAGED_USER_ACTION',
  /**
   * Unconditional: value-grant will always be honoured and used for evaluation at checkout.
   * Budget is NOT checked (always honoured).
   */
  ValueGrantGuaranteeBasisUnconditional = 'VALUE_GRANT_GUARANTEE_BASIS_UNCONDITIONAL',
  /** Default unspecified value. Treated as VALUE_GRANT_GUARANTEE_BASIS_UNCONDITIONAL for backward compatibility. */
  ValueGrantGuaranteeBasisUnspecified = 'VALUE_GRANT_GUARANTEE_BASIS_UNSPECIFIED'
}

export type Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Connect_Platform_V1_GenerateBatchRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  batchType?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  orders?: InputMaybe<Array<InputMaybe<Instacart_Customers_Connect_Platform_V1_Order_Input>>>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_GenerateBatchResponse = {
  __typename?: 'instacart_customers_connect_platform_v1_GenerateBatchResponse';
  id: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_Order_Input = {
  checkoutRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  shoppedRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Connect_Platform_V1_ShopperOrderItemScan_Input = {
  scannedString?: InputMaybe<Scalars['String']>;
  scannedStringType?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  deliveredCount?: InputMaybe<Scalars['BigInt']>;
  deliveredWeight?: InputMaybe<Scalars['Float']>;
  lineNum?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  rrc?: InputMaybe<Scalars['String']>;
  scans?: InputMaybe<Array<InputMaybe<Instacart_Customers_Connect_Platform_V1_ShopperOrderItemScan_Input>>>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  substituteId?: InputMaybe<Scalars['BigInt']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemResponse = {
  __typename?: 'instacart_customers_connect_platform_v1_UpdateShopperOrderItemResponse';
  success: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Customers_Content_Management_Admin_V1_CartState {
  CartStateUnspecified = 'CART_STATE_UNSPECIFIED',
  Empty = 'EMPTY',
  InProgress = 'IN_PROGRESS',
  Qualified = 'QUALIFIED'
}

export type Instacart_Customers_Content_Management_Admin_V1_SlotCreative = {
  __typename?: 'instacart_customers_content_management_admin_v1_SlotCreative';
  cartState: Maybe<Instacart_Customers_Content_Management_Admin_V1_CartState>;
  createdAt: Maybe<Scalars['DateTime']>;
  creativeId: Maybe<Scalars['BigInt']>;
  creativeRank: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  slotId: Maybe<Scalars['BigInt']>;
  treatmentOfferState: Maybe<Instacart_Customers_Content_Management_Admin_V1_TreatmentOfferState>;
  treatmentPolicyId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Content_Management_Admin_V1_SlotCreative_Input = {
  cartState?: InputMaybe<Instacart_Customers_Content_Management_Admin_V1_CartState>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<Instacart_Customers_Content_Management_Admin_V1_TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Content_Management_Admin_V1_TreatmentOfferState {
  Activated = 'ACTIVATED',
  Applied = 'APPLIED',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Redeemed = 'REDEEMED',
  TreatmentOfferStateUnspecified = 'TREATMENT_OFFER_STATE_UNSPECIFIED',
  Unredeemable = 'UNREDEEMABLE'
}

export type Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsRequest_Input = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  /** @deprecated: Use retailer_ids instead */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CreateRetailerCampaignTreatmentParams_Input>>>;
};

export type Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_AddRetailerCampaignTreatmentsResponse';
  treatments: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
};

export enum Instacart_Customers_Coupons_V1_CampaignField {
  OfferData = 'OFFER_DATA',
  RetailerData = 'RETAILER_DATA'
}

export type Instacart_Customers_Coupons_V1_CampaignFilter = {
  __typename?: 'instacart_customers_coupons_v1_CampaignFilter';
  filterType: Maybe<Instacart_Customers_Coupons_V1_FilterType>;
  filterValue: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignFilter_Input = {
  filterType?: InputMaybe<Instacart_Customers_Coupons_V1_FilterType>;
  filterValue?: InputMaybe<Scalars['String']>;
};

/** Wrapper for repeated CampaignFilter to distinguish nil from empty array. */
export type Instacart_Customers_Coupons_V1_CampaignFilters_Input = {
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
};

export enum Instacart_Customers_Coupons_V1_CampaignObjective {
  Acquisition = 'ACQUISITION',
  Activation = 'ACTIVATION',
  Awareness = 'AWARENESS',
  Custom = 'CUSTOM',
  Invalid = 'INVALID',
  Loyalty = 'LOYALTY',
  Merchandising = 'MERCHANDISING',
  Moment = 'MOMENT',
  Occasion = 'OCCASION',
  Reactivation = 'REACTIVATION',
  Resurrection = 'RESURRECTION',
  Retention = 'RETENTION'
}

export type Instacart_Customers_Coupons_V1_CampaignPropertyFilterOrList_Input = {
  orList?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignPropertyFilter_Input>>>;
};

export type Instacart_Customers_Coupons_V1_CampaignPropertyFilter_Input = {
  /** key can be campaign core property or metadata, not support custom property for now */
  key?: InputMaybe<Scalars['String']>;
  /** value is the serialized value of String or Enum, can also be any which means match any property value */
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignReference = {
  __typename?: 'instacart_customers_coupons_v1_CampaignReference';
  /** Unique identifier for a direct link campaign. Format: "ts_<uuid>". */
  directLink: Maybe<Scalars['String']>;
  utmCampaign: Maybe<Scalars['String']>;
  utmContent: Maybe<Scalars['String']>;
  utmId: Maybe<Scalars['String']>;
  utmMedium: Maybe<Scalars['String']>;
  utmSource: Maybe<Scalars['String']>;
  utmTerm: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignReference_Input = {
  /** Unique identifier for a direct link campaign. Format: "ts_<uuid>". */
  directLink?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmId?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignRouletteFeature = {
  __typename?: 'instacart_customers_coupons_v1_CampaignRouletteFeature';
  featureName: Maybe<Scalars['String']>;
  featureVariant: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input = {
  featureName?: InputMaybe<Scalars['String']>;
  featureVariant?: InputMaybe<Scalars['String']>;
};

/**
 * Lightweight campaign data populated by Campaign Service, replacing raw_treatments.
 * Contains only the fields needed for serving-path filtering and treatment resolution.
 */
export type Instacart_Customers_Coupons_V1_CampaignServiceData = {
  __typename?: 'instacart_customers_coupons_v1_CampaignServiceData';
  cancelledAt: Maybe<Scalars['DateTime']>;
  slotIds: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentPolicyIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_CampaignTreatmentTask = {
  __typename?: 'instacart_customers_coupons_v1_CampaignTreatmentTask';
  /** [key: value] pairs matching the fields from TreatmentTaskSchema */
  definitionParams: Maybe<Scalars['JSON']>;
  /** string value from TreatmentTaskTemplate message */
  definitionType: Maybe<Scalars['String']>;
  /** this value is used in CRM and in app to tell the user how to complete the task */
  taskDescription: Maybe<Scalars['String']>;
  treatmentPolicyId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams = {
  __typename?: 'instacart_customers_coupons_v1_CampaignTreatmentTaskRequestParams';
  /**
   * [key: value] pairs matching the fields from TreatmentTaskSchema
   * this value is used in CRM and in app to tell the user how to complete the task
   */
  definitionParams: Maybe<Scalars['JSON']>;
  /** string value from TreatmentTaskTemplate message */
  definitionType: Maybe<Scalars['String']>;
  taskDescription: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams_Input = {
  /**
   * [key: value] pairs matching the fields from TreatmentTaskSchema
   * this value is used in CRM and in app to tell the user how to complete the task
   */
  definitionParams?: InputMaybe<Scalars['JSON']>;
  /** string value from TreatmentTaskTemplate message */
  definitionType?: InputMaybe<Scalars['String']>;
  taskDescription?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CancelMomentRequest_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_CancelMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_CancelMomentResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_CancelRetailerCampaignRequest_Input = {
  /** Input whether to disable treatment policy, discount policy and coupon code, by default it will be true to make artifacts sync */
  disableOffer?: InputMaybe<Scalars['Boolean']>;
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is use to do authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_CancelRetailerCampaignResponse = {
  __typename?: 'instacart_customers_coupons_v1_CancelRetailerCampaignResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_Collection = {
  __typename?: 'instacart_customers_coupons_v1_Collection';
  id: Maybe<Scalars['BigInt']>;
  products: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Product>>>;
};

export type Instacart_Customers_Coupons_V1_CreateMomentRequest_Input = {
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CreateMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_CreateMomentResponse';
  moment: Maybe<Instacart_Customers_Coupons_V1_Moment>;
};

export type Instacart_Customers_Coupons_V1_CreateRetailerCampaignRequest_Input = {
  automaticBudgetCappingEnrolled?: InputMaybe<Scalars['Boolean']>;
  /** When true, the campaign is enrolled in automatic budget pausing (budget preference created in Nexus) */
  automaticBudgetPausingEnrolled?: InputMaybe<Scalars['Boolean']>;
  /** When true, enables budget pacing for the campaign (budget validation is enforced) */
  budgetPacingEnabled?: InputMaybe<Scalars['Boolean']>;
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  /** Campaign type for categorizing campaigns (e.g. sfx_activation, sfx_stale_activation, sfx_deep_churn) */
  campaignType?: InputMaybe<Scalars['String']>;
  /** This is a country_id that is a number, not to be confused with country code. */
  countryId?: InputMaybe<Scalars['String']>;
  countryIdValue?: InputMaybe<Scalars['BigInt']>;
  /** coupon_count, number of coupons to be created when redeeming the campaign */
  couponCount?: InputMaybe<Scalars['BigInt']>;
  creatorIppUserId?: InputMaybe<Scalars['BigInt']>;
  crmsIntentionConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional array of custom key-value properties */
  customProperties?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CustomProperty_Input>>>;
  discountPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /** Flag to indicate the campaign is enabled for offline serve */
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  /** When true, enables online CRM notifications for this campaign */
  enableOnlineCampaignCrm?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Exclusivity groups for the campaign */
  exclusivityGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /** Flag to indicate the campaign is for internal testing only */
  forInternalTestingOnly?: InputMaybe<Scalars['Boolean']>;
  /** Indicates the campaign assignment is guaranteed (unconditional assignment) */
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  ippUserCanonicalUuid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use targeting_rules.lookback_window_days instead. */
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  marketingMessagingDetails?: InputMaybe<Instacart_Customers_Coupons_V1_MarketingMessagingDetails_Input>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Input>>>;
  /** @deprecated use treatments instead */
  placements?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Placement_Input>>>;
  redemptionMethod?: InputMaybe<Instacart_Customers_Coupons_V1_RedemptionMethod>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** When true, allows treatment offers to be reissued after order delivery reconciliation */
  reissuable?: InputMaybe<Scalars['Boolean']>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardPolicy_Input>;
  retailerAgnostic?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated: Use retailer_ids instead */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  rouletteFeature?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  /** indicate whether the treatment policy should be created separately for each offer */
  separateTreatmentPolicies?: InputMaybe<Scalars['Boolean']>;
  skipCreateCouponCode?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated use treatments instead */
  slotCreatives?: InputMaybe<Array<InputMaybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative_Input>>>;
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  /** @deprecated: Use store_configuration_ids instead */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of store_configuration_id */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Deprecated: Use targeting_rules instead. */
  targeting?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_TargetingRules_Input>>>;
  templateId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  treatmentTask?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams_Input>;
  treatments?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input>;
  /** @deprecated: Use offer_duration_in_days instead */
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_CreateRetailerCampaignTreatmentParams_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails_Input>>>;
  treatmentType?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType>;
};

export type Instacart_Customers_Coupons_V1_CustomProperty = {
  __typename?: 'instacart_customers_coupons_v1_CustomProperty';
  key: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CustomProperty_Input = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Coupons_V1_Discoverability {
  /** ADMIN_ONLY means the campaign should not be discoverable on IC. It's only for IPP usage by internal users */
  AdminOnly = 'ADMIN_ONLY',
  /** BROWSE means the campaign will be discoverable when user browse the app or web, it's the current behavior of RFM campaigns. */
  Browse = 'BROWSE',
  /** COUPON_CODE means the campaign will be discoverable only by a coupon code */
  CouponCode = 'COUPON_CODE',
  /** CRM means the campaign will be discoverable only by a CRM (eg. Braze) email send. */
  Crm = 'CRM',
  /** DIRECT_LINK means the campaign will be discoverable only when user click on a link, or scan a QR code. */
  DirectLink = 'DIRECT_LINK',
  DiscoverabilityUnknown = 'DISCOVERABILITY_UNKNOWN',
  /** EVENT_BASED_CRM means the campaign will be discoverable by a CRM (eg. Braze) email send triggered by activity events. */
  EventBasedCrm = 'EVENT_BASED_CRM',
  /** Offline: Campaign is assigned via an offline non ML flow (S3 CSV, SQL, etc.) */
  Offline = 'OFFLINE',
  /** Offline_ml: Campaign is evaluated and assigned via ML flow (Ciao, Charm, etc.) */
  OfflineMl = 'OFFLINE_ML',
  /** ONLINE_EVENT means the campaign will be discoverable when specific events occur (e.g. OrderDeliveryPlacedEvent). */
  OnlineEvent = 'ONLINE_EVENT',
  /** PARTNER_INITIATED means the campaign should only be assigned by a 3rd party partner (e.g. Airbnb). */
  PartnerInitiated = 'PARTNER_INITIATED',
  /**
   * TS_DIRECT_LINK means the campaign will be discoverable only when user click on a link, or scan a QR code.
   * and the redemption / lifecycle will be handled by Treatment Serving
   */
  TsDirectLink = 'TS_DIRECT_LINK'
}

export enum Instacart_Customers_Coupons_V1_FilterType {
  FilterTypeAdminOnly = 'FILTER_TYPE_ADMIN_ONLY',
  FilterTypeCollectionId = 'FILTER_TYPE_COLLECTION_ID',
  FilterTypeCollectionSlug = 'FILTER_TYPE_COLLECTION_SLUG',
  FilterTypeCreatedBy = 'FILTER_TYPE_CREATED_BY',
  FilterTypeMoment = 'FILTER_TYPE_MOMENT',
  FilterTypeMomentApproved = 'FILTER_TYPE_MOMENT_APPROVED',
  FilterTypeMomentRejected = 'FILTER_TYPE_MOMENT_REJECTED',
  FilterTypeMomentSubmitted = 'FILTER_TYPE_MOMENT_SUBMITTED',
  FilterTypeOccasion = 'FILTER_TYPE_OCCASION',
  FilterTypeOccasionApproved = 'FILTER_TYPE_OCCASION_APPROVED',
  FilterTypeOccasionRejected = 'FILTER_TYPE_OCCASION_REJECTED',
  FilterTypeOccasionSubmitted = 'FILTER_TYPE_OCCASION_SUBMITTED',
  FilterTypePartnershipOfferId = 'FILTER_TYPE_PARTNERSHIP_OFFER_ID',
  FilterTypeTag = 'FILTER_TYPE_TAG',
  FilterTypeUnknown = 'FILTER_TYPE_UNKNOWN'
}

/** Returns deep links and related URLs for a given campaign context */
export type Instacart_Customers_Coupons_V1_GetCampaignLinksRequest_Input = {
  /** IPP context provides retailer, store configuration, and auth context */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  /** Required campaign identifier */
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_GetCampaignLinksResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetCampaignLinksResponse';
  /** All links that can be used to access the campaign */
  links: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_GetCouponCodeExistsRequest_Input = {
  code?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_GetCouponCodeExistsResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetCouponCodeExistsResponse';
  couponCodeExists: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersRequest_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetMomentParticipatingRetailersResponse';
  participatingRetailerCampaigns: Maybe<Scalars['JSON']>;
  retailerMomentCampaigns: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerMomentCampaign>>>;
};

export type Instacart_Customers_Coupons_V1_GetMomentRequest_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_GetMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetMomentResponse';
  moment: Maybe<Instacart_Customers_Coupons_V1_Moment>;
};

export type Instacart_Customers_Coupons_V1_GetMomentsRequest_Input = {
  momentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Coupons_V1_GetMomentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetMomentsResponse';
  moments: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Moment>>>;
};

export type Instacart_Customers_Coupons_V1_GetRetailerCampaignRequest_Input = {
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is use to do authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_IppContext_Input = {
  ippUserId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: True if the user is admin, false otherwise */
  isAdminUser?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Coupons_V1_ListMomentsRequest_FilterSet_Input = {
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_ListMomentsRequest_Input = {
  filters?: InputMaybe<Instacart_Customers_Coupons_V1_ListMomentsRequest_FilterSet_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Coupons_V1_ListMomentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_ListMomentsResponse';
  moments: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Moment>>>;
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsRequest_Input = {
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is use to do authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_ListRetailerCampaignTreatmentsResponse';
  treatments: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_Input = {
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** Exclude campaigns with FILTER_TYPE_ADMIN_ONLY = "true" */
  excludeAdminOnlyCampaigns?: InputMaybe<Scalars['Boolean']>;
  excludeRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /** by default, the API will not return campaign from internal template */
  includeCampaignFromInternalTemplate?: InputMaybe<Scalars['Boolean']>;
  /** checks if this date is included in the campaign's active date range */
  isActiveOnDatetime?: InputMaybe<Scalars['DateTime']>;
  /**
   * Property filters for filtering by campaign properties (e.g. campaign_type).
   * AND-of-ORs semantics: each OrList is an OR group, all OrLists must match.
   */
  propertyFilters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignPropertyFilterOrList_Input>>>;
  queryFields?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_QueryField_Input>>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchValue?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  /** @deprecated: Use store_configuration_ids instead */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of store_configuration_id */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** by default, the API will not return campaign with enriched properties */
  withEnrichedProperties?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_QueryField_Input = {
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_Input = {
  /** Optional filters. */
  filters?: InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_Input>;
  /** Optional includeFields. */
  includeFields?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignField>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsResponse = {
  __typename?: 'instacart_customers_coupons_v1_ListRetailerCampaignsResponse';
  /** pagination info */
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  retailerCampaigns: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>>>;
  /** total number of unpaginated results */
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_MarketingMessagingDetails_Input = {
  experimentName?: InputMaybe<Scalars['String']>;
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  pushNotificationId?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVariables?: InputMaybe<Scalars['JSON']>;
  userEmailOverrides?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_Moment = {
  __typename?: 'instacart_customers_coupons_v1_Moment';
  campaigns: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  endsAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  momentCampaignId: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  startsAt: Maybe<Scalars['DateTime']>;
  status: Maybe<Scalars['String']>;
  submissionDeadline: Maybe<Scalars['DateTime']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Coupons_V1_MomentCampaignStatus_Input = {
  campaignId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_StatusMap_Input>>>;
};

export type Instacart_Customers_Coupons_V1_Placement = {
  __typename?: 'instacart_customers_coupons_v1_Placement';
  creativeRank: Maybe<Scalars['BigInt']>;
  /** placement_id */
  id: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_Placement_Input = {
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  /** placement_id */
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_Product = {
  __typename?: 'instacart_customers_coupons_v1_Product';
  displayName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  primaryImageUrl: Maybe<Scalars['String']>;
};

/** redemption method includes method from serving, offer, and other system that controls redemption in the future. */
export enum Instacart_Customers_Coupons_V1_RedemptionMethod {
  RedemptionMethodAutoApply = 'REDEMPTION_METHOD_AUTO_APPLY',
  RedemptionMethodAutoRedeem = 'REDEMPTION_METHOD_AUTO_REDEEM',
  RedemptionMethodClickToRedeem = 'REDEMPTION_METHOD_CLICK_TO_REDEEM',
  RedemptionMethodCouponCode = 'REDEMPTION_METHOD_COUPON_CODE',
  RedemptionMethodRedeemOnCompletion = 'REDEMPTION_METHOD_REDEEM_ON_COMPLETION',
  RedemptionMethodUnknown = 'REDEMPTION_METHOD_UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_RestaurantRewardCondition = {
  __typename?: 'instacart_customers_coupons_v1_RestaurantRewardCondition';
  conditionType: Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardConditionType>;
  value: Maybe<GoogleTypeMoney>;
};

export enum Instacart_Customers_Coupons_V1_RestaurantRewardConditionType {
  RestaurantRewardConditionTypeDeliveryFeeMaximumValue = 'RESTAURANT_REWARD_CONDITION_TYPE_DELIVERY_FEE_MAXIMUM_VALUE',
  RestaurantRewardConditionTypeMinimumSpend = 'RESTAURANT_REWARD_CONDITION_TYPE_MINIMUM_SPEND',
  RestaurantRewardConditionTypeUnknown = 'RESTAURANT_REWARD_CONDITION_TYPE_UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_RestaurantRewardCondition_Input = {
  conditionType?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardConditionType>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
};

export type Instacart_Customers_Coupons_V1_RestaurantRewardPolicy = {
  __typename?: 'instacart_customers_coupons_v1_RestaurantRewardPolicy';
  conditions: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardCondition>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  maxDiscountCents: Maybe<Scalars['BigInt']>;
  rewardType: Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardType>;
  secondsValid: Maybe<Scalars['BigInt']>;
  value: Maybe<GoogleTypeMoney>;
  valuePercentage: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Coupons_V1_RestaurantRewardPolicy_Input = {
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardCondition_Input>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  maxDiscountCents?: InputMaybe<Scalars['BigInt']>;
  rewardType?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardType>;
  secondsValid?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
  valuePercentage?: InputMaybe<Scalars['Float']>;
};

export enum Instacart_Customers_Coupons_V1_RestaurantRewardType {
  RestaurantRewardTypeDollarOff = 'RESTAURANT_REWARD_TYPE_DOLLAR_OFF',
  RestaurantRewardTypeFreeDelivery = 'RESTAURANT_REWARD_TYPE_FREE_DELIVERY',
  RestaurantRewardTypePercentOff = 'RESTAURANT_REWARD_TYPE_PERCENT_OFF',
  RestaurantRewardTypeUnknown = 'RESTAURANT_REWARD_TYPE_UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_Retailer = {
  __typename?: 'instacart_customers_coupons_v1_Retailer';
  id: Maybe<Scalars['BigInt']>;
  logoUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaign = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaign';
  budget: Maybe<GoogleTypeMoney>;
  campaignObjective: Maybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference: Maybe<Instacart_Customers_Coupons_V1_CampaignReference>;
  /** Data needed by Golang Campaign Service */
  campaignServiceData: Maybe<Instacart_Customers_Coupons_V1_CampaignServiceData>;
  coreProperties: Maybe<Scalars['JSON']>;
  countryIdValue: Maybe<Scalars['BigInt']>;
  couponCount: Maybe<Scalars['BigInt']>;
  createdAt: Maybe<Scalars['DateTime']>;
  creatorIppUserId: Maybe<Scalars['BigInt']>;
  /** Optional array of custom key-value properties */
  customProperties: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CustomProperty>>>;
  discountPolicyIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  discoverability: Maybe<Instacart_Customers_Coupons_V1_Discoverability>;
  endsAt: Maybe<Scalars['DateTime']>;
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  filters: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CampaignFilter>>>;
  fundingDetails: Maybe<Scalars['String']>;
  fundingSummaryDetails: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_SummaryDetails>>>;
  id: Maybe<Scalars['BigInt']>;
  intentionConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  ippUserCanonicalUuid: Maybe<Scalars['String']>;
  /** Deprecated: Use targeting_rules.lookback_window_days instead. */
  lookbackWindowDays: Maybe<Scalars['BigInt']>;
  metadata: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  narrowSearchTerms: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Number of days the campaign offer is valid. If nil, valid until ends_at */
  offerDurationInDays: Maybe<Scalars['BigInt']>;
  offerRequestKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  offerSummary: Maybe<Scalars['String']>;
  offerSummaryDetails: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_SummaryDetails>>>;
  /** Domain-level treatment information with legacy slot_ids. Use 'treatments' field for display/rendering, only use this for filtering by slot_id or accessing treatment_policy_id. */
  rawTreatments: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
  redemptionMethod: Maybe<Instacart_Customers_Coupons_V1_RedemptionMethod>;
  regionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  restaurantPromotionId: Maybe<Scalars['String']>;
  restaurantRewardPolicy: Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardPolicy>;
  /** @deprecated: Use retailers_data instead */
  retailerData: Maybe<Instacart_Customers_Coupons_V1_Retailer>;
  /** @deprecated: Use retailer_ids instead */
  retailerId: Maybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** replacement of retailer_data */
  retailersData: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Retailer>>>;
  rouletteFeature: Maybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature>;
  /** Schedule is a cron expression string. ex "0 0 * * 2" */
  schedule: Maybe<Scalars['String']>;
  segmentId: Maybe<Scalars['String']>;
  /** @deprecated use treatments instead */
  slotCreatives: Maybe<Array<Maybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative>>>;
  startsAt: Maybe<Scalars['DateTime']>;
  status: Maybe<Scalars['String']>;
  /** @deprecated: Use store_configuration_ids instead */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  /** replacement of store_configuration_id */
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Deprecated: Use targeting_rules instead. */
  targeting: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Targeting>>>;
  targetingRules: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_TargetingRules>>>;
  templateId: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  treatmentTask: Maybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTask>;
  treatments: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments>;
  updatedAt: Maybe<Scalars['DateTime']>;
  /**
   * @deprecated: Use offer_duration_in_days instead
   * TODO: Remove this
   * https://docs.google.com/document/d/1vbtlXVAoce6mkWwRib9mh5b_ZXtrUruFrNeRc13oJ78
   * Days the personal coupon will expire once assigned to the user
   */
  validForDays: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignCreativeTreatment';
  placementId: Maybe<Scalars['BigInt']>;
  slotId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment_Input = {
  placementId?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignOfferTreatment';
  offerDurationInDays: Maybe<Scalars['BigInt']>;
  offerId: Maybe<Scalars['BigInt']>;
  offerRequestKey: Maybe<Scalars['String']>;
  slotId: Maybe<Scalars['String']>;
  validForDays: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment_Input = {
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offerId?: InputMaybe<Scalars['BigInt']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  slotId?: InputMaybe<Scalars['String']>;
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignResponse = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignResponse';
  errors: Maybe<Scalars['JSON']>;
  offers: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer>>>;
  retailerCampaign: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>;
  /** deprecated: opting to return slot_creatives as part of retailer_campaign instead */
  slotCreatives: Maybe<Array<Maybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatment';
  active: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  retailerCampaignId: Maybe<Scalars['BigInt']>;
  slotIds: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentDetails: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails>>>;
  treatmentPolicyId: Maybe<Scalars['String']>;
  treatmentType: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatmentDetails';
  creativeTreatment: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment>;
  offerTreatment: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails_Input = {
  creativeTreatment?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment_Input>;
  offerTreatment?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment_Input>;
};

export enum Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType {
  Creative = 'CREATIVE',
  InvalidTreatment = 'INVALID_TREATMENT',
  Offer = 'OFFER'
}

/**
 * When defined, this represents the slots a campaign will show in.
 * examples:
 * - Incentive campaign which shows in various GS slots
 * {
 * treatments: [
 *
 *
 * slot_id: 1, // slot_id references `content_slots.id`
 * placements: [], // incentive campaigns don't define placements as they have TrUX placement matching
 * treatment_visibility_conditions: [] // treatment_visibility_conditions: [] - means all states
 * }
 * proto arrays don't differ from nil, so placement, and treatment_visibility_conditions are the same as above
 * { slot_id: 2 }
 * ]
 * }
 * - Incentive campaign which only shows after it's been redeemd (CRM/CIAO)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * ]
 * }
 * - Incentive campaign which only shows after it's been DxGy Activated (CRM/CHARM + dxgy)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * }
 *
 * - A campaign that shows only in 1 slot
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: [] }
 * note how slot_id: 2 is missing - this is intentional as treatment_visibility_conditions: [] implies all states, not no-states
 * ]
 * }
 *
 * - A non-incentive campaign
 * {
 * treatments: [
 * non-incentives define a placement_id and creative_rank, but not treatment_visibility_conditions
 * { slot_id: 1, placements: [{ id: 456, creative_rank: 5 }] },
 * we can have multiple placements
 * --- but only 1 will be shown at a time - depending on the placement level VCs
 * { slot_id: 2, placements: [{ id: 789, creative_rank: 5 }, { id: 101, creative_rank: 4 }] },
 * ]
 * }
 * }
 */
export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatments';
  /** list of slots in which the campaign will show */
  treatments: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment>>>;
};

/**
 * When defined, this represents the slots a campaign will show in.
 * examples:
 * - Incentive campaign which shows in various GS slots
 * {
 * treatments: [
 *
 *
 * slot_id: 1, // slot_id references `content_slots.id`
 * placements: [], // incentive campaigns don't define placements as they have TrUX placement matching
 * treatment_visibility_conditions: [] // treatment_visibility_conditions: [] - means all states
 * }
 * proto arrays don't differ from nil, so placement, and treatment_visibility_conditions are the same as above
 * { slot_id: 2 }
 * ]
 * }
 * - Incentive campaign which only shows after it's been redeemd (CRM/CIAO)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * ]
 * }
 * - Incentive campaign which only shows after it's been DxGy Activated (CRM/CHARM + dxgy)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * }
 *
 * - A campaign that shows only in 1 slot
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: [] }
 * note how slot_id: 2 is missing - this is intentional as treatment_visibility_conditions: [] implies all states, not no-states
 * ]
 * }
 *
 * - A non-incentive campaign
 * {
 * treatments: [
 * non-incentives define a placement_id and creative_rank, but not treatment_visibility_conditions
 * { slot_id: 1, placements: [{ id: 456, creative_rank: 5 }] },
 * we can have multiple placements
 * --- but only 1 will be shown at a time - depending on the placement level VCs
 * { slot_id: 2, placements: [{ id: 789, creative_rank: 5 }, { id: 101, creative_rank: 4 }] },
 * ]
 * }
 * }
 */
export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input = {
  /** list of slots in which the campaign will show */
  treatments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment_Input>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatments_Treatment';
  /**
   * optional for both TS and awareness campaigns.
   * curently TS campaigns are either strictly non-incentive or incentive,
   * but that will change in the future.
   */
  placements: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Placement>>>;
  /**
   * Required for all campaigns.
   *
   * Slots have both, there's a numeric id, and a "legacy_id".
   *
   * For GS - legacy ids are: 'uvc:home, tracker:store_front` etc.
   * For SFX - legacy ids are uuids
   * For GS future - we'll also have generated ids for each mrp/content page.
   *
   * The this is `campaign_slots.id` (in DB)
   * this is what's references by the underlying `content_slot_creatives` table,
   * and by `card_list_placement.data_query.slot_id`
   */
  slotId: Maybe<Scalars['BigInt']>;
  /**
   * defined for TS campaigns, ignored for awareness campaigns
   * values of: TreatmentsDomain::Api::Types::RewardState
   * note: this is a string and not an enum because of restrictions on proto3 enums that don't play nice with GQL
   */
  treatmentVisibilityConditions: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment_Input = {
  /**
   * optional for both TS and awareness campaigns.
   * curently TS campaigns are either strictly non-incentive or incentive,
   * but that will change in the future.
   */
  placements?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Placement_Input>>>;
  /**
   * Required for all campaigns.
   *
   * Slots have both, there's a numeric id, and a "legacy_id".
   *
   * For GS - legacy ids are: 'uvc:home, tracker:store_front` etc.
   * For SFX - legacy ids are uuids
   * For GS future - we'll also have generated ids for each mrp/content page.
   *
   * The this is `campaign_slots.id` (in DB)
   * this is what's references by the underlying `content_slot_creatives` table,
   * and by `card_list_placement.data_query.slot_id`
   */
  slotId?: InputMaybe<Scalars['BigInt']>;
  /**
   * defined for TS campaigns, ignored for awareness campaigns
   * values of: TreatmentsDomain::Api::Types::RewardState
   * note: this is a string and not an enum because of restrictions on proto3 enums that don't play nice with GQL
   */
  treatmentVisibilityConditions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerMomentCampaign = {
  __typename?: 'instacart_customers_coupons_v1_RetailerMomentCampaign';
  collectionData: Maybe<Instacart_Customers_Coupons_V1_Collection>;
  offers: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer>>>;
  retailerCampaign: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>;
  retailerData: Maybe<Instacart_Customers_Coupons_V1_Retailer>;
};

export type Instacart_Customers_Coupons_V1_StatusMap_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Instacart_Customers_Coupons_V1_FilterType>;
};

export type Instacart_Customers_Coupons_V1_SummaryDetails = {
  __typename?: 'instacart_customers_coupons_v1_SummaryDetails';
  details: Maybe<Scalars['JSON']>;
};

export enum Instacart_Customers_Coupons_V1_Targeting {
  ActivatedCustomer = 'ACTIVATED_CUSTOMER',
  ChurnedCustomer = 'CHURNED_CUSTOMER',
  LoyaltyCustomer = 'LOYALTY_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  NonLoyaltyCustomer = 'NON_LOYALTY_CUSTOMER',
  Unknown = 'UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_TargetingRules = {
  __typename?: 'instacart_customers_coupons_v1_TargetingRules';
  lookbackWindowDays: Maybe<Scalars['BigInt']>;
  targetingType: Maybe<Instacart_Customers_Coupons_V1_Targeting>;
};

export type Instacart_Customers_Coupons_V1_TargetingRules_Input = {
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  targetingType?: InputMaybe<Instacart_Customers_Coupons_V1_Targeting>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusRequest_Input = {
  momentCampaignStatus?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_MomentCampaignStatus_Input>>>;
  momentCampaigns?: InputMaybe<Scalars['JSON']>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateMomentCampaignStatusResponse';
  campaigns: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>>>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentRequest_Input = {
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  momentId?: InputMaybe<Scalars['BigInt']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateMomentResponse';
  moment: Maybe<Instacart_Customers_Coupons_V1_Moment>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetRequest_Input = {
  budget?: InputMaybe<GoogleTypeMoneyInput>;
  /** IPP will provide the context when calling this API */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateRetailerCampaignBudgetResponse';
  errors: Maybe<Scalars['JSON']>;
  retailerCampaign: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignRequest_Input = {
  budget?: InputMaybe<GoogleTypeMoneyInput>;
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  couponCount?: InputMaybe<Scalars['BigInt']>;
  /**
   * Flag to indicate whether to disable treatment policies when updating campaign status
   * When set to true, will disable all treatment policies associated with the campaign
   * Similar to CancelRetailerCampaign's disable_offer behavior but for update operations
   */
  disableTreatmentPolicy?: InputMaybe<Scalars['Boolean']>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /** Flag to indicate the campaign is enabled for offline serve */
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /** Nilable wrapper for filters; takes precedence over `filters` field when present. */
  filtersV2?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilters_Input>;
  /** Indicates the campaign assignment is guaranteed (unconditional assignment) */
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is used for authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  /** Deprecated: Use targeting_rules.lookback_window instead. */
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Input>>>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardPolicy_Input>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  rouletteFeature?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  /** @deprecated use treatments instead */
  slotCreatives?: InputMaybe<Array<InputMaybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative_Input>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** Deprecated: Use targeting_rules instead. */
  targeting?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_TargetingRules_Input>>>;
  treatments?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentParams_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails_Input>>>;
  treatmentType?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsRequest_Input = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  /** @deprecated: Use retailer_ids instead */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentParams_Input>>>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateRetailerCampaignTreatmentsResponse';
  treatments: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
};

export type Instacart_Customers_Discovery_V1_RankingContext = {
  __typename?: 'instacart_customers_discovery_v1_RankingContext';
  /** Optional: Anchor Product */
  anchorProductId: Maybe<Scalars['BigInt']>;
  /** Optional: Boolean indicating if Post Ranker should apply category diversification, default is false */
  applyCategoryDiversification: Maybe<Scalars['Boolean']>;
  /** Optional: boolean indicating whether we should go through post ranking, default is true */
  applyMlRanker: Maybe<Scalars['Boolean']>;
  /** Optional: Array of product IDs to re-rank and boost to top of list; maintained in order passed */
  boostedProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** PostRankerDomain::Api::Types::CallerSurface */
  caller: Maybe<Scalars['String']>;
  /** Optional: Unique string to distinguish the carousel the request came from (category ID or collection slug) */
  categoryInfo: Maybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking */
  disableRouletteTracking: Maybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank low stock items, default is false */
  downrankLowStockItems: Maybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank OOS items, default is false */
  downrankOutOfStockItems: Maybe<Scalars['Boolean']>;
  /** Optional: Max number of products to return */
  limit: Maybe<Scalars['BigInt']>;
  /** Optional: Limit of number of items to send for ML ranking */
  mlRankingLimit: Maybe<Scalars['BigInt']>;
  /** Optional: Ranking model for ML ranking */
  mlRankingModel: Maybe<Scalars['String']>;
  /** Optional: Requesting user's order_count */
  userOrderCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Discovery_V1_RankingContext_Input = {
  /** Optional: Anchor Product */
  anchorProductId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Boolean indicating if Post Ranker should apply category diversification, default is false */
  applyCategoryDiversification?: InputMaybe<Scalars['Boolean']>;
  /** Optional: boolean indicating whether we should go through post ranking, default is true */
  applyMlRanker?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Array of product IDs to re-rank and boost to top of list; maintained in order passed */
  boostedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** PostRankerDomain::Api::Types::CallerSurface */
  caller?: InputMaybe<Scalars['String']>;
  /** Optional: Unique string to distinguish the carousel the request came from (category ID or collection slug) */
  categoryInfo?: InputMaybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking */
  disableRouletteTracking?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank low stock items, default is false */
  downrankLowStockItems?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank OOS items, default is false */
  downrankOutOfStockItems?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Max number of products to return */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Limit of number of items to send for ML ranking */
  mlRankingLimit?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Ranking model for ML ranking */
  mlRankingModel?: InputMaybe<Scalars['String']>;
  /** Optional: Requesting user's order_count */
  userOrderCount?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalContext = {
  __typename?: 'instacart_customers_discovery_v1_RetrievalContext';
  /** Optional - alcohol allowed flag */
  alcoholAllowed: Maybe<Scalars['Boolean']>;
  /** Optional - some retrieval sources may need anchor product ids to retrieve products */
  anchorProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: Brand IDs to filter by */
  brandIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: collection_slug of the collection we wish to query */
  collectionSlug: Maybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking (currently does not take affect) */
  disableRouletteTracking: Maybe<Scalars['Boolean']>;
  /** Optional - GetDiscoverItems API caller */
  discoverApiCaller: Maybe<Scalars['String']>;
  /**
   * The followings are mostly used for item availability filtering
   * Optional - exclude BIA flag
   */
  excludeBia: Maybe<Scalars['Boolean']>;
  /** Optional - Product category (Taxonomy) IDs to exclude */
  excludeProductCategoryIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional - Product category (Taxonomy) IDs to include */
  includeProductCategoryIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: Item filters to apply */
  itemFilters: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: Limit for the number of items returned */
  limit: Maybe<Scalars['BigInt']>;
  /** Optinoal: Minimum availabilty score for product filtering */
  minimumAvailabilityScore: Maybe<Scalars['Float']>;
  /** Optional: Dedup item variants if from same group variant */
  onlyKeepUniqVariants: Maybe<Scalars['Boolean']>;
  /** List of retrieval sources that caller wants to use to retrieve products */
  retrievalSources: Maybe<Array<Maybe<Instacart_Customers_Discovery_V1_RetrievalSource>>>;
  /** Optional - version string used for unified product recommendations service */
  version: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalContext_Input = {
  /** Optional - alcohol allowed flag */
  alcoholAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Optional - some retrieval sources may need anchor product ids to retrieve products */
  anchorProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: Brand IDs to filter by */
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: collection_slug of the collection we wish to query */
  collectionSlug?: InputMaybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking (currently does not take affect) */
  disableRouletteTracking?: InputMaybe<Scalars['Boolean']>;
  /** Optional - GetDiscoverItems API caller */
  discoverApiCaller?: InputMaybe<Scalars['String']>;
  /**
   * The followings are mostly used for item availability filtering
   * Optional - exclude BIA flag
   */
  excludeBia?: InputMaybe<Scalars['Boolean']>;
  /** Optional - Product category (Taxonomy) IDs to exclude */
  excludeProductCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional - Product category (Taxonomy) IDs to include */
  includeProductCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: Item filters to apply */
  itemFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: Limit for the number of items returned */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** Optinoal: Minimum availabilty score for product filtering */
  minimumAvailabilityScore?: InputMaybe<Scalars['Float']>;
  /** Optional: Dedup item variants if from same group variant */
  onlyKeepUniqVariants?: InputMaybe<Scalars['Boolean']>;
  /** List of retrieval sources that caller wants to use to retrieve products */
  retrievalSources?: InputMaybe<Array<InputMaybe<Instacart_Customers_Discovery_V1_RetrievalSource_Input>>>;
  /** Optional - version string used for unified product recommendations service */
  version?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalSource = {
  __typename?: 'instacart_customers_discovery_v1_RetrievalSource';
  limit: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalSource_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserParameters_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserParameters_Input>;
};

export type Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserResponse = {
  __typename?: 'instacart_customers_express_v1_GetCurrentExpressMemberStatusForUserResponse';
  isExpressMember: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_AdvancedTextCluster_Debug';
  defaultDebug: Maybe<Instacart_Customers_Flyer_Pdf_V1_StubableDebugContext>;
};

export type Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_AdvancedTextCluster_Definition';
  /** Buffer is basically a grace for intersection */
  buffer: Maybe<Scalars['BigInt']>;
  priceDetectionStrategy: Maybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_PriceDetectionStrategy>;
};

export type Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_Input = {
  /** Buffer is basically a grace for intersection */
  buffer?: InputMaybe<Scalars['BigInt']>;
  priceDetectionStrategy?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_PriceDetectionStrategy>;
};

export enum Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_PriceDetectionStrategy {
  /** Looks at large fonts and its styles and searches around */
  FontStylePriceDetectionStrategy = 'FONT_STYLE_PRICE_DETECTION_STRATEGY',
  /** Look for symbols like $ % or cent signs */
  SymbolicPriceDetectionStrategy = 'SYMBOLIC_PRICE_DETECTION_STRATEGY'
}

export type Instacart_Customers_Flyer_Pdf_V1_BoundingBox = {
  __typename?: 'instacart_customers_flyer_pdf_v1_BoundingBox';
  /** ll, lr, ur, ul */
  corners: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>>>;
  /** The elements that are inside/intersecting the bounding box */
  elements: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  /** Should human verify */
  requiresReview: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationCondition';
  /** The left operand of the condition */
  left: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand>;
  /** Whether to negate the condition */
  not: Maybe<Scalars['Boolean']>;
  /** The operator to use for the condition */
  operator: Maybe<Instacart_Customers_Flyer_Pdf_V1_ComparisonOperator>;
  /** The right operand of the condition */
  right: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Input = {
  /** The left operand of the condition */
  left?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand_Input>;
  /** Whether to negate the condition */
  not?: InputMaybe<Scalars['Boolean']>;
  /** The operator to use for the condition */
  operator?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ComparisonOperator>;
  /** The right operand of the condition */
  right?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand_Input>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationCondition_Operand';
  /** Specific classification count */
  classification: Maybe<Scalars['String']>;
  /** The constant value */
  constantValue: Maybe<Scalars['BigInt']>;
  /** all classifications count */
  totalCount: Maybe<Scalars['google_protobuf_Empty']>;
  /** unique classifications count (includes unknown) */
  uniqueCount: Maybe<Scalars['google_protobuf_Empty']>;
  /** unique classifications count (without unknown) */
  uniqueMinusUnknownCount: Maybe<Scalars['google_protobuf_Empty']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand_Input = {
  /** Specific classification count */
  classification?: InputMaybe<Scalars['String']>;
  /** The constant value */
  constantValue?: InputMaybe<Scalars['BigInt']>;
  /** all classifications count */
  totalCount?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  /** unique classifications count (includes unknown) */
  uniqueCount?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  /** unique classifications count (without unknown) */
  uniqueMinusUnknownCount?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationFilter_Definition';
  /** Conditions that are AND together */
  conditions: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition_Input = {
  /** Conditions that are AND together */
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationFlagger_Definition';
  /** Conditions that are AND together */
  conditions: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition_Input = {
  /** Conditions that are AND together */
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_Color = {
  __typename?: 'instacart_customers_flyer_pdf_v1_Color';
  /** Color Space */
  colorSpace: Maybe<Instacart_Customers_Flyer_Pdf_V1_ColorSpace>;
  /** Color Values */
  values: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export enum Instacart_Customers_Flyer_Pdf_V1_ColorSpace {
  /** CMYK */
  Cmyk = 'CMYK',
  /** Gray */
  Gray = 'GRAY',
  /** RGB */
  Rgb = 'RGB',
  /** UJniversal */
  Universal = 'UNIVERSAL',
  /** Unknown */
  UnknownColorSpace = 'UNKNOWN_COLOR_SPACE'
}

export enum Instacart_Customers_Flyer_Pdf_V1_ComparisonOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  Unknown = 'UNKNOWN'
}

export type Instacart_Customers_Flyer_Pdf_V1_ContextualAssociation_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ContextualAssociation_Debug';
  defaultDebug: Maybe<Instacart_Customers_Flyer_Pdf_V1_StubableDebugContext>;
};

/** Represents a debug context that can contain events and other contexts */
export type Instacart_Customers_Flyer_Pdf_V1_DebugContext = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugContext';
  /** Items in this context - can be events or nested contexts */
  items: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugItem>>>;
  /** Additional metadata for the context */
  metadata: Maybe<Scalars['JSON']>;
  /** Name of the context */
  name: Maybe<Scalars['String']>;
};

/** Represents a debug event with multiple shapes */
export type Instacart_Customers_Flyer_Pdf_V1_DebugEvent = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugEvent';
  /** Name of the event */
  name: Maybe<Scalars['String']>;
  /** Shapes associated with this event */
  shapes: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugShape>>>;
};

/** Wrapper message for items that can appear in a context */
export type Instacart_Customers_Flyer_Pdf_V1_DebugItem = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugItem';
  context: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugContext>;
  event: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugEvent>;
};

/**
 * Represents a shape with attributes and category for debugging geometric
 * operations. Shape type is determined by number of vertices:
 */
export type Instacart_Customers_Flyer_Pdf_V1_DebugShape = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugShape';
  /** Additional metadata for the shape */
  attributes: Maybe<Scalars['JSON']>;
  /** Category for grouping/coloring shapes */
  category: Maybe<Scalars['String']>;
  /** Optional associated PDF element */
  pdfElement: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>;
  /** The vertices that define the shape */
  vertices: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_Input = {
  /** flyer to target */
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: use singular evaluation instead */
  flyerPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Optional partial run, if provided we will resume from the offset of an
   * existing job
   */
  partialRun?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_PartialRun_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_PartialRun_Input = {
  offset?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_Input = {
  /**
   * flag to indicate if we should just run the rule set but not actually create
   * bounding boxes in flyer service
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /** retailer to target */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** List of flyer IDs to target */
  targets?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_EvaluateRuleSetResponse';
  references: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse_Reference>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse_Reference = {
  __typename?: 'instacart_customers_flyer_pdf_v1_EvaluateRuleSetResponse_Reference';
  flyerId: Maybe<Scalars['BigInt']>;
  flyerPageId: Maybe<Scalars['BigInt']>;
  ruleSetRunId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_FilterClassification_Definition';
  /** Use default filtering behavior (no specific include/exclude rules) */
  default: Maybe<Scalars['instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default']>;
  /** Exclude these specific values from results */
  exclude: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude>;
  /** Include only these specific values in results */
  include: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include>;
  /** The type of PDF elements to target for filtering */
  target: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Target>;
};

/** Excludes PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude = {
  __typename?: 'instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Exclude';
  /** Excludes PDF elements with these classifications */
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Excludes PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude_Input = {
  /** Excludes PDF elements with these classifications */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Includes only PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include = {
  __typename?: 'instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Include';
  /** Includes only PDF elements with these classifications */
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Includes only PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include_Input = {
  /** Includes only PDF elements with these classifications */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Input = {
  /** Use default filtering behavior (no specific include/exclude rules) */
  default?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default_Input']>;
  /** Exclude these specific values from results */
  exclude?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude_Input>;
  /** Include only these specific values in results */
  include?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include_Input>;
  /** The type of PDF elements to target for filtering */
  target?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Target>;
};

export enum Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Target {
  TargetAll = 'TARGET_ALL',
  TargetImage = 'TARGET_IMAGE',
  TargetImageLike = 'TARGET_IMAGE_LIKE',
  TargetText = 'TARGET_TEXT',
  TargetTextLike = 'TARGET_TEXT_LIKE'
}

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetResponse';
  ruleSet: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet>;
  ruleSetJson: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  forcePresignedUrl?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
  stubRef?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunDebugResponse';
  debugContext: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugContext>;
  presignedDownloadUrl: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
  stubRef?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunImageResponse';
  /** this is a presigned url to download the image in base64 format */
  imageDownloadUrl: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunResponse';
  data: Maybe<Scalars['String']>;
  presignedDownloadUrl: Maybe<Scalars['String']>;
  /** This will never get populated, it's just here to help IPP generate types */
  run: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSetRun>;
};

/** Run tracking messages */
export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunStatusResponse';
  details: Maybe<Scalars['JSON']>;
  error: Maybe<Scalars['String']>;
  flyerId: Maybe<Scalars['BigInt']>;
  flyerPageId: Maybe<Scalars['BigInt']>;
  progress: Maybe<Scalars['BigInt']>;
  result: Maybe<Scalars['String']>;
  ruleSetRunId: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageClassifier_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageClassifier_Debug';
  classificationSystemPrompt: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageCluster_Definition';
  /** Buffer is basically a grace for intersection */
  buffer: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition_Input = {
  /** Buffer is basically a grace for intersection */
  buffer?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageElement = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageElement';
  /** The generic data for the element */
  data: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /**
   * Form object_id stack, images can be part of a xobject form (PDF construct
   * not what you are thinking), forms can be nested in forms
   */
  formObjectIdStack: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** same as above except it tracks the names */
  formXobjectNameStack: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The image data in base64 format */
  image: Maybe<Scalars['String']>;
  /** Randomly generated unique instance ID to be used for debugging */
  instanceId: Maybe<Scalars['String']>;
  /** indirect object id from the PDF file of the image */
  objectId: Maybe<Scalars['BigInt']>;
  /** smask form object id */
  smaskFormObjectId: Maybe<Scalars['BigInt']>;
  /** The soft mask data in base64 format */
  softMask: Maybe<Scalars['String']>;
  /**
   * The transformed image data in base64 format, this is image at it's location
   * in the page
   */
  transformedImage: Maybe<Scalars['String']>;
  /**
   * The transformed soft mask data in base64 format, this is soft mask at it's
   * location in the page
   */
  transformedSmask: Maybe<Scalars['String']>;
  /** The name of the xobject */
  xobjectName: Maybe<Scalars['String']>;
};

/** A group of image elements */
export type Instacart_Customers_Flyer_Pdf_V1_ImageGroup = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageGroup';
  /** The generic data for the element */
  data: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /** The images in the group */
  images: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageElement>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_InitializationRuleDebug';
  pdfPageParser: Maybe<Scalars['instacart_customers_flyer_pdf_v1_PdfPageParser_Debug']>;
};

/** Base Rule Definitions */
export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_InitializationRuleDefinition';
  pdfPageParser: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition>;
};

/** Base Rule Definitions */
export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition_Input = {
  pdfPageParser?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition_Input>;
};

/** Base Rule Results */
export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_InitializationRuleResult';
  /** Implementation specific debug information */
  debug: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition>;
  input: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPage>;
  /** Default page information */
  metadata: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageData>;
  output: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
};

/** This is ephermeral sidekiq-redis run status */
export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunStatusesResponse';
  runs: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse_RuleSetRunSummary>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse_RuleSetRunSummary = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunStatusesResponse_RuleSetRunSummary';
  completedAt: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['String']>;
  flyerId: Maybe<Scalars['BigInt']>;
  flyerPageId: Maybe<Scalars['BigInt']>;
  ruleSetRunId: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunsResponse';
  /** We can't return the full rule set run because it's too big */
  items: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse_Result>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse_Result = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunsResponse_Result';
  createdAt: Maybe<Scalars['String']>;
  flyerId: Maybe<Scalars['BigInt']>;
  flyerPageId: Maybe<Scalars['BigInt']>;
  ruleSetRunId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Debug';
  /** Attempted row spans */
  candidateRowSpans: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans>>>;
  /** Attempted row spans */
  colSpans: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans>>>;
  /** Attempted column spans */
  selectedRowSpan: Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans>;
  /** Test lines */
  testLines: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_TestLine>>>;
};

/**
 * Spans definition e.g. [2, 1, 1] means 5 equal sized rows/columns total
 * (sum of values) where first takes up 2 rows/cols and the rest take up 1.
 * Note that if it's a row span it starts from the bottom due to bottom-left
 * origin, so you'll see the results in reverse
 */
export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Debug_Spans';
  /**
   * Spans definition e.g. [2, 1, 1] means 5 equal sized rows/columns total
   * (sum of values) where first takes up 2 rows/cols and the rest take up 1.
   * Note that if it's a row span it starts from the bottom due to bottom-left
   * origin, so you'll see the results in reverse
   */
  values: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Lines used to test row/col spans */
export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_TestLine = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Debug_TestLine';
  end: Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>;
  intersectedElements: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  start: Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>;
};

export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Definition';
  buffer: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition_Input = {
  buffer?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfElement = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfElement';
  image: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageElement>;
  imageGroup: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageGroup>;
  text: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextElement>;
  textGroup: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextGroup>;
};

/**
 * Common data for all element types
 * The reason this is on the PdfElement base type is that we want to preserve
 * grouped elements data without adding a circular schema And reduces extra type
 * inference
 */
export type Instacart_Customers_Flyer_Pdf_V1_PdfElementData = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfElementData';
  /** flag that another rule is setting element an anchor point */
  anchorPoint: Maybe<Scalars['Boolean']>;
  classification: Maybe<Scalars['String']>;
  filtered: Maybe<Scalars['Boolean']>;
  /**
   * If we think it might not be something rendered due to say blending options
   * We only process PDF data not render it so we don't handle all logic but
   * there are hints that it might not be rendered, this is a tip to ask a
   * VLM/LLM against an already rendered image to see if we actually have
   * anything there
   */
  possiblyNotRendered: Maybe<Scalars['Boolean']>;
  uuid: Maybe<Scalars['String']>;
  vertices: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPage = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPage';
  /** The id of the flyer this page belongs to */
  flyerId: Maybe<Scalars['BigInt']>;
  /** idf of the flyer page */
  flyerPageId: Maybe<Scalars['BigInt']>;
  /** Page number of the PDF Page */
  pageNumber: Maybe<Scalars['BigInt']>;
  /** Source of PDF Page */
  source: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageData = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPageData';
  /** Height of the PDF Page in points */
  height: Maybe<Scalars['Float']>;
  /** the rasterized/rendered image of the page */
  image: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageData_Image>;
  /** Width of the PDF Page in points */
  width: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageData_Image = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPageData_Image';
  /** Base64 data of the image */
  data: Maybe<Scalars['String']>;
  /** Height of the image in pixels */
  height: Maybe<Scalars['BigInt']>;
  /** Width of the image in pixels */
  width: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPageParser_Definition';
  /**
   * Minimum area of a clipping polygon to be considered valid (i.e. not too
   * small) This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingMinPolygonArea: Maybe<Scalars['BigInt']>;
  /**
   * Relative threshold factor for clipping polygon area
   * This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingRelativeThresholdFactor: Maybe<Scalars['Float']>;
  /**
   * PDF reader will negative CYMK images from PDF if true
   * This is used when you are getting weird (dark negative looking) images
   * The current PDF parsing library does not handle CYMK images properly
   */
  cmykImageNegation: Maybe<Scalars['Boolean']>;
  /** related to above  - the dpi to render the pdf page as */
  textHeightCorrectDpi: Maybe<Scalars['BigInt']>;
  /** Attempts to correct text height by looking at the rendered pdf text */
  textHeightCorrectEnabled: Maybe<Scalars['Boolean']>;
  /**
   * how much we should morph the width of the text to catch words/sentences
   * pts are 1/72 of an inch default should be 5 but check actual code
   */
  textHeightCorrectMorphWidthPts: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition_Input = {
  /**
   * Minimum area of a clipping polygon to be considered valid (i.e. not too
   * small) This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingMinPolygonArea?: InputMaybe<Scalars['BigInt']>;
  /**
   * Relative threshold factor for clipping polygon area
   * This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingRelativeThresholdFactor?: InputMaybe<Scalars['Float']>;
  /**
   * PDF reader will negative CYMK images from PDF if true
   * This is used when you are getting weird (dark negative looking) images
   * The current PDF parsing library does not handle CYMK images properly
   */
  cmykImageNegation?: InputMaybe<Scalars['Boolean']>;
  /** related to above  - the dpi to render the pdf page as */
  textHeightCorrectDpi?: InputMaybe<Scalars['BigInt']>;
  /** Attempts to correct text height by looking at the rendered pdf text */
  textHeightCorrectEnabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * how much we should morph the width of the text to catch words/sentences
   * pts are 1/72 of an inch default should be 5 but check actual code
   */
  textHeightCorrectMorphWidthPts?: InputMaybe<Scalars['Float']>;
};

/**
 * Basic Types
 * Bottom left origin - meaning (0, 0) is the bottom left of the image and not
 * the top left like in CSS or HTML Canvas
 */
export type Instacart_Customers_Flyer_Pdf_V1_Point = {
  __typename?: 'instacart_customers_flyer_pdf_v1_Point';
  x: Maybe<Scalars['Float']>;
  y: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PostProcessingRuleDebug';
  classificationFilter: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ClassificationFilter_Debug']>;
  classificationFlagger: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ClassificationFlagger_Debug']>;
  promptFilter: Maybe<Scalars['instacart_customers_flyer_pdf_v1_PromptFilter_Debug']>;
  promptFlagger: Maybe<Scalars['instacart_customers_flyer_pdf_v1_PromptFlagger_Debug']>;
  qualityReviewer: Maybe<Scalars['instacart_customers_flyer_pdf_v1_QualityReviewer_Debug']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PostProcessingRuleDefinition';
  classificationFilter: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition>;
  classificationFlagger: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition>;
  promptFilter: Maybe<Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition>;
  promptFlagger: Maybe<Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition>;
  qualityReviewer: Maybe<Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition_Input = {
  classificationFilter?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition_Input>;
  classificationFlagger?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition_Input>;
  promptFilter?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition_Input>;
  promptFlagger?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition_Input>;
  qualityReviewer?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition_Input>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PostProcessingRuleResult';
  /** Implementation specific debug information */
  debug: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition>;
  input: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_BoundingBox>>>;
  output: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_BoundingBox>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PreProcessingRuleDebug';
  advancedTextCluster: Maybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Debug>;
  filterClassification: Maybe<Scalars['instacart_customers_flyer_pdf_v1_FilterClassification_Debug']>;
  imageClassifier: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageClassifier_Debug>;
  imageCluster: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ImageCluster_Debug']>;
  textClassifier: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextClassifier_Debug>;
  textCluster: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextCluster_Debug>;
  textCorrect: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextCorrect_Debug']>;
  textHeightCorrect: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextHeightCorrect_Debug']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PreProcessingRuleDefinition';
  advancedTextCluster: Maybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition>;
  filterClassification: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition>;
  imageClassifier: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ImageClassifier_Definition']>;
  imageCluster: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition>;
  textClassifier: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextClassifier_Definition']>;
  textCluster: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition>;
  textCorrect: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextCorrect_Definition']>;
  textHeightCorrect: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition_Input = {
  advancedTextCluster?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_Input>;
  filterClassification?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Input>;
  imageClassifier?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_ImageClassifier_Definition_Input']>;
  imageCluster?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition_Input>;
  textClassifier?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_TextClassifier_Definition_Input']>;
  textCluster?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition_Input>;
  textCorrect?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_TextCorrect_Definition_Input']>;
  textHeightCorrect?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition_Input']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PreProcessingRuleResult';
  /** Implementation specific debug information */
  debug: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition>;
  input: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  output: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ProcessingRuleDebug';
  contextualAssociation: Maybe<Instacart_Customers_Flyer_Pdf_V1_ContextualAssociation_Debug>;
  mergeableGrid: Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ProcessingRuleDefinition';
  contextualAssociation: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition']>;
  mergeableGrid: Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition_Input = {
  contextualAssociation?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition_Input']>;
  mergeableGrid?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition_Input>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ProcessingRuleResult';
  /** Implementation specific debug information */
  debug: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition>;
  input: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  output: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_BoundingBox>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PromptFilter_Definition';
  /** Conditions that we will use */
  prompts: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition_Input = {
  /** Conditions that we will use */
  prompts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PromptFlagger_Definition';
  /** prompts that we will use to flag bounding boxes */
  prompts: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition_Input = {
  /** prompts that we will use to flag bounding boxes */
  prompts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PublishRuleSetRunResultsResponse';
  error: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_QualityReviewer_Definition';
  flagOnly: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition_Input = {
  flagOnly?: InputMaybe<Scalars['Boolean']>;
};

/** Definition of a rule */
export type Instacart_Customers_Flyer_Pdf_V1_RuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleDefinition';
  init: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition>;
  postProcess: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition>;
  preProcess: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition>;
  process: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition>;
};

/** Definition of a rule */
export type Instacart_Customers_Flyer_Pdf_V1_RuleDefinition_Input = {
  init?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition_Input>;
  postProcess?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition_Input>;
  preProcess?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition_Input>;
  process?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition_Input>;
};

/**
 * Rule Evaluation Result - the result of a rule evaluation this is a wrapper
 * for a rule node
 */
export type Instacart_Customers_Flyer_Pdf_V1_RuleEvaluationResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleEvaluationResult';
  init: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleResult>;
  postProcess: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleResult>;
  preProcess: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleResult>;
  process: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleResult>;
};

/** Rule Set - */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSet = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleSet';
  retailerId: Maybe<Scalars['BigInt']>;
  ruleDefinitions: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleDefinition>>>;
};

/**
 * Rule Definition Evaluation - actual evaluation of rules works with a specific
 * pdf page
 */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSetEvaluation = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleSetEvaluation';
  /** The id of the flyer page */
  flyerPageId: Maybe<Scalars['BigInt']>;
  /** The results of the rule evaluations */
  results: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleEvaluationResult>>>;
};

/**
 * Rule Run/Instance - works with a specific flyer 1-to-many PDF files, we
 * will use this for both runtime and debug/observability
 */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSetRun = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleSetRun';
  evaluation: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSetEvaluation>;
  /** DEPRECATED: use singular evaluation instead */
  evaluations: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSetEvaluation>>>;
  /** The input flyer */
  flyerId: Maybe<Scalars['BigInt']>;
  flyerPageId: Maybe<Scalars['BigInt']>;
  /** The retailer id */
  retailerId: Maybe<Scalars['BigInt']>;
  /** Reference rule_set */
  ruleSet: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet>;
  /** The id of the rule set run; uuid */
  ruleSetRunId: Maybe<Scalars['String']>;
};

/** Rule Set - */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSet_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleDefinitions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_RuleDefinition_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_StubableDebugContext = {
  __typename?: 'instacart_customers_flyer_pdf_v1_StubableDebugContext';
  context: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugContext>;
  stubRef: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextClassifier_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextClassifier_Debug';
  classificationSystemPrompt: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextCluster_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextCluster_Debug';
  correctionSystemPrompt: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextCluster_Definition';
  /** Buffer is basically a grace for intersection */
  buffer: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition_Input = {
  /** Buffer is basically a grace for intersection */
  buffer?: InputMaybe<Scalars['BigInt']>;
};

/** A text element */
export type Instacart_Customers_Flyer_Pdf_V1_TextElement = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextElement';
  /** Block ID - BT/ET based on processing order - starts at 0 */
  blockId: Maybe<Scalars['BigInt']>;
  /**
   * Block Instance ID - Each Tj/TJ  based on processing order - starts at 0,
   * resets each block
   */
  blockInstanceId: Maybe<Scalars['BigInt']>;
  /** The generic data for the element */
  data: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /** Effective Height */
  effectiveHeight: Maybe<Scalars['Float']>;
  /** Font Family */
  fontFamily: Maybe<Scalars['String']>;
  /** Font Name */
  fontName: Maybe<Scalars['String']>;
  /** font object id */
  fontObjectId: Maybe<Scalars['BigInt']>;
  /** font resource name */
  fontResourceName: Maybe<Scalars['String']>;
  /** Font Stretch */
  fontStretch: Maybe<Scalars['String']>;
  /** Font Weight */
  fontWeight: Maybe<Scalars['BigInt']>;
  /** Font Non-Stroking Alpha */
  nonStrokingAlpha: Maybe<Scalars['Float']>;
  /** Font Non-Stroking Color (basically fill color) */
  nonStrokingColor: Maybe<Instacart_Customers_Flyer_Pdf_V1_Color>;
  /**
   * Render mode
   * 0	Fill text (default, uses non-stroking color)
   * 1	Stroke text (uses stroking color)
   * 2	Fill, then stroke text (uses both)
   * 3	Invisible
   * 4	Fill text and add to clipping path
   * 5	Stroke text and add to clipping path
   * 6	Fill, stroke, and add to clipping path
   * 7	Add text to clipping path (no fill or stroke)
   */
  renderMode: Maybe<Scalars['BigInt']>;
  /** Font Stroking Alpha */
  strokingAlpha: Maybe<Scalars['Float']>;
  /** Font Non-Stroking Color (basically fill color) */
  strokingColor: Maybe<Instacart_Customers_Flyer_Pdf_V1_Color>;
  /** The text of the element */
  text: Maybe<Scalars['String']>;
  /** Transform Angle */
  transformAngle: Maybe<Scalars['Float']>;
};

/** A group of text elements */
export type Instacart_Customers_Flyer_Pdf_V1_TextGroup = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextGroup';
  /** The combined text of the group */
  combinedText: Maybe<Scalars['String']>;
  /** The generic data for the element */
  data: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /** The text elements in the group */
  texts: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_TextElement>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetEntity?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet_Input>;
  ruleSetJson?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_UpdateRuleSetResponse';
  ruleSet: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet>;
  ruleSetJson: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetJson?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ValidateRuleSetResponse';
  errorMessage: Maybe<Scalars['String']>;
  valid: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Froth_V1_CompileTemplateRequest_Input = {
  /** The template source string to compile. */
  template?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Froth_V1_CompileTemplateResponse = {
  __typename?: 'instacart_customers_froth_v1_CompileTemplateResponse';
  /** The compiled TreeNode[] AST as a JSON string. */
  astJson: Maybe<Scalars['String']>;
};

/** Request to create a new gift order digital card */
export type Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardRequest_Input = {
  /** Description of the digital card (e.g., "Happy Birthday") */
  description?: InputMaybe<Scalars['String']>;
  /** Image URL path for the digital card (e.g., "gifting/digital-card-happy-birthday.png") */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Locale for the digital card (e.g., "en_US") */
  locale?: InputMaybe<Scalars['String']>;
  /** Request context containing user and session information */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** Response containing the newly created gift order digital card */
export type Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardResponse = {
  __typename?: 'instacart_customers_gifting_v1_CreateGiftOrderDigitalCardResponse';
  /** The created digital card */
  giftOrderDigitalCard: Maybe<Instacart_Customers_Gifting_V1_GiftOrderDigitalCard>;
};

/** Request to get a gift order digital card by ID */
export type Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdRequest_Input = {
  /** ID of the digital card to retrieve */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Request context containing user and session information */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** Response containing the requested gift order digital card */
export type Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdResponse = {
  __typename?: 'instacart_customers_gifting_v1_GetGiftOrderDigitalCardByIdResponse';
  /** The requested digital card */
  giftOrderDigitalCard: Maybe<Instacart_Customers_Gifting_V1_GiftOrderDigitalCard>;
};

/** GiftOrderDigitalCard represents a digital card that can be attached to a gift order */
export type Instacart_Customers_Gifting_V1_GiftOrderDigitalCard = {
  __typename?: 'instacart_customers_gifting_v1_GiftOrderDigitalCard';
  /** CDN URL for the digital card image */
  cdnUrl: Maybe<Scalars['String']>;
  /** Timestamp when the card was created */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Description of the digital card (e.g., "Happy Birthday") */
  description: Maybe<Scalars['String']>;
  /** Unique identifier for the digital card */
  id: Maybe<Scalars['BigInt']>;
  /** Image URL path for the digital card (e.g., "gifting/digital-card-happy-birthday.png") */
  imageUrl: Maybe<Scalars['String']>;
  /** Locale for the digital card (e.g., "en_US") */
  locale: Maybe<Scalars['String']>;
  /** Timestamp when the card was last updated */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Request to update an existing gift order digital card */
export type Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardRequest_Input = {
  /** Optional: Updated description of the digital card */
  description?: InputMaybe<Scalars['String']>;
  /** ID of the digital card to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Updated image URL path */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Optional: Updated locale */
  locale?: InputMaybe<Scalars['String']>;
  /** Request context containing user and session information */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** Response containing the updated gift order digital card */
export type Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardResponse = {
  __typename?: 'instacart_customers_gifting_v1_UpdateGiftOrderDigitalCardResponse';
  /** The updated digital card */
  giftOrderDigitalCard: Maybe<Instacart_Customers_Gifting_V1_GiftOrderDigitalCard>;
};

/** DEPRECATED: This enum is no longer used. */
export enum Instacart_Customers_Loyalty_Admin_V1_BenefitType {
  AdditionalBenefits = 'ADDITIONAL_BENEFITS',
  /** Unspecified benefit type. */
  BenefitTypeUnspecified = 'BENEFIT_TYPE_UNSPECIFIED',
  DigitalCoupons = 'DIGITAL_COUPONS',
  LoyaltyPricing = 'LOYALTY_PRICING',
  PersonalizedDeals = 'PERSONALIZED_DEALS',
  PointsBalance = 'POINTS_BALANCE',
  PointsEarning = 'POINTS_EARNING',
  PointsRedemptionGas = 'POINTS_REDEMPTION_GAS',
  PointsRedemptionGrocery = 'POINTS_REDEMPTION_GROCERY'
}

/** Request to create a loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitRequest_Input = {
  /** Loyalty benefit to create. */
  loyaltyBenefit?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitCreate_Input>;
};

/** Response containing the created loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_CreateLoyaltyBenefitResponse';
  /** Created loyalty benefit. */
  loyaltyBenefit: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit>;
};

/** Request to create a loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationRequest_Input = {
  /** Loyalty card validation to create. */
  loyaltyCardValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationCreate_Input>;
};

/** Response containing the created loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_CreateLoyaltyCardValidationResponse';
  /** Created loyalty card validation. */
  loyaltyCardValidation: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation>;
};

/** Request to create a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramRequest_Input = {
  /** Loyalty program to create. */
  loyaltyProgram?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramCreate_Input>;
};

/** Response containing the created loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_CreateLoyaltyProgramResponse';
  /** Created loyalty program. */
  loyaltyProgram: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram>;
};

/** Request to get loyalty benefits for a program. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsRequest_Input = {
  /** Loyalty program the benefits belong to. */
  loyaltyProgramId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the loyalty benefits. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_GetLoyaltyBenefitsResponse';
  /** Loyalty benefits. */
  loyaltyBenefits: Maybe<Array<Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit>>>;
};

/** Request to get loyalty card validations for a retailer. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsRequest_Input = {
  /** Retailer ID to get validations for. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the loyalty card validations. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_GetLoyaltyCardValidationsResponse';
  /** Loyalty card validations. */
  loyaltyCardValidations: Maybe<Array<Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation>>>;
};

/** Request to get a loyalty program by retailer and store configuration. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramRequest_Input = {
  /** Retailer ID the loyalty program is subject to. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Store configuration ID the loyalty program is subject to. */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_GetLoyaltyProgramResponse';
  /** Get loyalty program. */
  loyaltyProgram: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram>;
};

export type Instacart_Customers_Loyalty_Admin_V1_Image = {
  __typename?: 'instacart_customers_loyalty_admin_v1_Image';
  /** Alt text for accessibility. */
  altText: Maybe<Scalars['String']>;
  /** Image URL. */
  imageUrl: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Loyalty_Admin_V1_Image_Input = {
  /** Alt text for accessibility. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  imageUrl?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Loyalty_Admin_V1_InputFieldType {
  /** Loyalty card number input. */
  CardNumber = 'CARD_NUMBER',
  /** Email address input. */
  Email = 'EMAIL',
  /** Unspecified input field type. */
  InputFieldTypeUnspecified = 'INPUT_FIELD_TYPE_UNSPECIFIED',
  /** Phone number input. */
  PhoneNumber = 'PHONE_NUMBER',
  /** Single Sign-On authentication. */
  Sso = 'SSO'
}

/** A benefit offered as part of a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyBenefit';
  /** Benefit description text. */
  benefitDescription: Maybe<Scalars['String']>;
  /** Logo image for the benefit. */
  benefitLogo: Maybe<Instacart_Customers_Loyalty_Admin_V1_Image>;
  /** Benefit name/heading. */
  benefitName: Maybe<Scalars['String']>;
  /** Display rank/order for the benefit. */
  benefitRank: Maybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  benefitType: Maybe<Instacart_Customers_Loyalty_Admin_V1_BenefitType>;
  /** Whether this benefit is enabled. */
  enabled: Maybe<Scalars['Boolean']>;
  /** Loyalty benefit ID */
  loyaltyBenefitId: Maybe<Scalars['BigInt']>;
  /** Loyalty program ID this benefit belongs to. */
  loyaltyProgramId: Maybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
};

/** Create payload for LoyaltyBenefit (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitCreate_Input = {
  benefitDescription?: InputMaybe<Scalars['String']>;
  benefitLogo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  benefitName?: InputMaybe<Scalars['String']>;
  benefitRank?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  benefitType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_BenefitType>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  loyaltyProgramId?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/** Update payload for LoyaltyBenefit (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitUpdate_Input = {
  benefitDescription?: InputMaybe<Scalars['String']>;
  benefitLogo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  benefitName?: InputMaybe<Scalars['String']>;
  benefitRank?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  benefitType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_BenefitType>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/** A rule used to validate loyalty card numbers. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation';
  /** Validate that the card number begins with specific leading digits. */
  leadingDigitValidation: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation>;
  /** Validate that the card number has an exact length. */
  lengthValidation: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation>;
  /** Loyalty card validation ID. */
  loyaltyCardValidationId: Maybe<Scalars['BigInt']>;
  /** Validate that the card number falls within a numeric range. */
  rangeValidation: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation>;
  /** Validate that the card number matches a regular expression. */
  regex: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation>;
  /** Retailer ID this validation applies to. */
  retailerId: Maybe<Scalars['BigInt']>;
};

/** Create payload for LoyaltyCardValidation (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationCreate_Input = {
  leadingDigitValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation_Input>;
  lengthValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation_Input>;
  rangeValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation_Input>;
  regex?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Update payload for LoyaltyCardValidation (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationUpdate_Input = {
  leadingDigitValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation_Input>;
  lengthValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation_Input>;
  rangeValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation_Input>;
  regex?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation_Input>;
};

/** Validation based on the leading digits of the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_LeadingDigitValidation';
  /** Optional. Length condition for validation applicability. */
  forLength: Maybe<Scalars['BigInt']>;
  /** Leading digits that the card number must start with. */
  leadingDigits: Maybe<Scalars['String']>;
};

/** Validation based on the leading digits of the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation_Input = {
  /** Optional. Length condition for validation applicability. */
  forLength?: InputMaybe<Scalars['BigInt']>;
  /** Leading digits that the card number must start with. */
  leadingDigits?: InputMaybe<Scalars['String']>;
};

/** Exact length required for the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_LengthValidation';
  /** Exact length to match. */
  length: Maybe<Scalars['BigInt']>;
};

/** Exact length required for the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation_Input = {
  /** Exact length to match. */
  length?: InputMaybe<Scalars['BigInt']>;
};

/** Inclusive numeric range for card numbers. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_RangeValidation';
  /** Optional. Length condition for validation applicability. */
  forLength: Maybe<Scalars['BigInt']>;
  /** Inclusive upper bound of the range. */
  high: Maybe<Scalars['String']>;
  /** Inclusive lower bound of the range. */
  low: Maybe<Scalars['String']>;
};

/** Inclusive numeric range for card numbers. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation_Input = {
  /** Optional. Length condition for validation applicability. */
  forLength?: InputMaybe<Scalars['BigInt']>;
  /** Inclusive upper bound of the range. */
  high?: InputMaybe<Scalars['String']>;
  /** Inclusive lower bound of the range. */
  low?: InputMaybe<Scalars['String']>;
};

/** Regex card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_RegexValidation';
  /** Regex pattern (this is used by Ruby's Regexp.new class to validate numbers). */
  regex: Maybe<Scalars['String']>;
};

/** Regex card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation_Input = {
  /** Regex pattern (this is used by Ruby's Regexp.new class to validate numbers). */
  regex?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyProgram';
  /** Whether this is an admin loyalty program. */
  admin: Maybe<Scalars['Boolean']>;
  /** Background color theme for the UI. */
  backgroundColorTheme: Maybe<Instacart_Customers_Loyalty_Admin_V1_Theme>;
  /** Background image for the loyalty program UI. */
  backgroundImage: Maybe<Instacart_Customers_Loyalty_Admin_V1_Image>;
  /** Primary disclaimer text. */
  disclaimer_1: Maybe<Scalars['String']>;
  /** Secondary disclaimer text. */
  disclaimer_2: Maybe<Scalars['String']>;
  /** Whether this loyalty program earns points. */
  earnsPoints: Maybe<Scalars['Boolean']>;
  /** Formatted description text displayed to users. */
  formattedDescriptionText: Maybe<Scalars['String']>;
  /** Input type for linking loyalty programs. Can be email, phone, card number, or SSO. */
  inputFieldType: Maybe<Instacart_Customers_Loyalty_Admin_V1_InputFieldType>;
  /** Logo image for the loyalty program. */
  logo: Maybe<Instacart_Customers_Loyalty_Admin_V1_Image>;
  /** Label text for loyalty input field. */
  loyaltyInputLabel: Maybe<Scalars['String']>;
  /** Loyalty program ID */
  loyaltyProgramId: Maybe<Scalars['BigInt']>;
  /** Loyalty program name. */
  loyaltyProgramName: Maybe<Scalars['String']>;
  /** URL for loyalty program signup. */
  loyaltySignupUrl: Maybe<Scalars['String']>;
  /** Privacy policy URL. */
  privacyPolicyUrl: Maybe<Scalars['String']>;
  /** Retailer ID for the retailer the loyalty program is subject to. */
  retailerId: Maybe<Scalars['BigInt']>;
  /** SSO configuration for authentication. */
  ssoConfiguration: Maybe<Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration>;
  /** Store configuration ID the loyalty program is subject to. */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  /** Terms of service URL. */
  termsUrl: Maybe<Scalars['String']>;
};

/** Create payload for LoyaltyProgram (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramCreate_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  backgroundColorTheme?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Theme>;
  backgroundImage?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  disclaimer_1?: InputMaybe<Scalars['String']>;
  disclaimer_2?: InputMaybe<Scalars['String']>;
  earnsPoints?: InputMaybe<Scalars['Boolean']>;
  formattedDescriptionText?: InputMaybe<Scalars['String']>;
  inputFieldType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_InputFieldType>;
  logo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  loyaltyInputLabel?: InputMaybe<Scalars['String']>;
  loyaltyProgramName?: InputMaybe<Scalars['String']>;
  loyaltySignupUrl?: InputMaybe<Scalars['String']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ssoConfiguration?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration_Input>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  termsUrl?: InputMaybe<Scalars['String']>;
};

/** Update payload for LoyaltyProgram (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramUpdate_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  backgroundColorTheme?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Theme>;
  backgroundImage?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  disclaimer_1?: InputMaybe<Scalars['String']>;
  disclaimer_2?: InputMaybe<Scalars['String']>;
  earnsPoints?: InputMaybe<Scalars['Boolean']>;
  formattedDescriptionText?: InputMaybe<Scalars['String']>;
  inputFieldType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_InputFieldType>;
  logo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  loyaltyInputLabel?: InputMaybe<Scalars['String']>;
  loyaltyProgramName?: InputMaybe<Scalars['String']>;
  loyaltySignupUrl?: InputMaybe<Scalars['String']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']>;
  ssoConfiguration?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration_Input>;
  termsUrl?: InputMaybe<Scalars['String']>;
};

/** SSO Configuration for authenticating and linking users to a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration = {
  __typename?: 'instacart_customers_loyalty_admin_v1_SsoConfiguration';
  /** Access token URI for SSO token exchange. */
  accessTokenUri: Maybe<Scalars['String']>;
  /** Authorization URI for SSO flow. */
  authorizeUri: Maybe<Scalars['String']>;
  /** Client ID for SSO authentication. */
  clientId: Maybe<Scalars['String']>;
  /** Client secret for SSO authentication. */
  clientSecret: Maybe<Scalars['String']>;
  /** Redirect URI for SSO callback. */
  redirectUri: Maybe<Scalars['String']>;
  /** SSO response type (e.g., "code"). */
  responseType: Maybe<Scalars['String']>;
  /** OAuth scope for SSO authentication. */
  scope: Maybe<Scalars['String']>;
};

/** SSO Configuration for authenticating and linking users to a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration_Input = {
  /** Access token URI for SSO token exchange. */
  accessTokenUri?: InputMaybe<Scalars['String']>;
  /** Authorization URI for SSO flow. */
  authorizeUri?: InputMaybe<Scalars['String']>;
  /** Client ID for SSO authentication. */
  clientId?: InputMaybe<Scalars['String']>;
  /** Client secret for SSO authentication. */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** Redirect URI for SSO callback. */
  redirectUri?: InputMaybe<Scalars['String']>;
  /** SSO response type (e.g., "code"). */
  responseType?: InputMaybe<Scalars['String']>;
  /** OAuth scope for SSO authentication. */
  scope?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Loyalty_Admin_V1_Theme {
  /** Dark color theme. */
  Dark = 'DARK',
  /** Light color theme. */
  Light = 'LIGHT',
  /** Unspecified theme. */
  ThemeUnspecified = 'THEME_UNSPECIFIED'
}

/** Request to update a loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitRequest_Input = {
  /** Loyalty beneift subject to update */
  loyaltyBenefit?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitUpdate_Input>;
  /** ID of the loyalty benefit to update. */
  loyaltyBenefitId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_UpdateLoyaltyBenefitResponse';
  /** Updated loyalty benefit. */
  loyaltyBenefit: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit>;
};

/** Request to update a loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationRequest_Input = {
  /** Loyalty card validation to update */
  loyaltyCardValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationUpdate_Input>;
  /** ID of the card validation to update. */
  loyaltyCardValidationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_UpdateLoyaltyCardValidationResponse';
  /** Updated loyalty card validation. */
  loyaltyCardValidation: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation>;
};

/** Request to update a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramRequest_Input = {
  /** Updated Loyalty Program Data */
  loyaltyProgram?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramUpdate_Input>;
  /** ID of the loyalty program to update. */
  loyaltyProgramId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_UpdateLoyaltyProgramResponse';
  /** Updated loyalty program. */
  loyaltyProgram: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram>;
};

/** Get loyalty cards by card number */
export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberRequest_Input = {
  /** Card number. */
  cardNumber?: InputMaybe<Scalars['String']>;
  /** Retailer IDs. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberResponse = {
  __typename?: 'instacart_customers_loyalty_v1_GetLoyaltyCardsByCardNumberResponse';
  /** Loyalty cards. */
  loyaltyCards: Maybe<Array<Maybe<Instacart_Customers_Loyalty_V1_LoyaltyCard>>>;
};

/** Optional filters for the operation. */
export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Filter_Input = {
  /** Filter to Limit the loyalty card retrieval to the specified retailers. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Input = {
  /** Optional filters, if applicable. */
  filter?: InputMaybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Filter_Input>;
  /** This parameter is no longer used, it used to provide pagination controls for the request. */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  /** The Request Context. */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  /** Optional field to skip loyalty card status check. Defaults to false. */
  skipLoyaltyStatusCheck?: InputMaybe<Scalars['Boolean']>;
  /** The user ID of the user to query loyalty cards for. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserResponse = {
  __typename?: 'instacart_customers_loyalty_v1_GetLoyaltyCardsForUserResponse';
  /** Loyalty cards that were found. */
  loyaltyCards: Maybe<Array<Maybe<Instacart_Customers_Loyalty_V1_LoyaltyCard>>>;
  /** This parameter is no longer used. It used to provide page info to work in conjunction with the pagination parameter. */
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Loyalty_V1_LoyaltyCard = {
  __typename?: 'instacart_customers_loyalty_v1_LoyaltyCard';
  /** Authentication type. */
  authenticatedType: Maybe<Scalars['String']>;
  /** Loyalty card number. */
  cardNumber: Maybe<Scalars['String']>;
  /** Loyalty card ID. */
  id: Maybe<Scalars['BigInt']>;
  /**
   * Loyalty membership tier.
   * mirror the loyalty_tier in instacart.customers.commerce.types.v1.LoyaltyCard
   */
  loyaltyTier: Maybe<Scalars['String']>;
  /** Retailer ID. */
  retailerId: Maybe<Scalars['BigInt']>;
  /** Loyalty card status. */
  status: Maybe<Instacart_Customers_Loyalty_V1_LoyaltyCard_Status>;
  /** User ID. */
  userId: Maybe<Scalars['BigInt']>;
};

/** Loyalty card status enum. */
export enum Instacart_Customers_Loyalty_V1_LoyaltyCard_Status {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Invalid = 'INVALID',
  NotFound = 'NOT_FOUND',
  PendingOtp = 'PENDING_OTP',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  Temp = 'TEMP',
  Valid = 'VALID'
}

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetailExpanded = {
  __typename?: 'instacart_customers_offers_tooling_orchestrator_v1_CollectionDetailExpanded';
  collectionId: Maybe<Scalars['BigInt']>;
  /** Member ids that make up the collection. */
  collectionMemberIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  collectionType: Maybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionType>;
};

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetail_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  collectionType?: InputMaybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionType>;
};

export enum Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionType {
  CollectionTypeUnspecified = 'COLLECTION_TYPE_UNSPECIFIED',
  /** Department collections are IC defined collections (i.e. Produce, Dairy, etc). */
  Department = 'DEPARTMENT'
}

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadRequest_Input = {
  /** Create Offer collection details. */
  collectionsDetails?: InputMaybe<Array<InputMaybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetail_Input>>>;
};

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadResponse = {
  __typename?: 'instacart_customers_offers_tooling_orchestrator_v1_PrepareCreateOfferPayloadResponse';
  collectionsDetailsExpanded: Maybe<Array<Maybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetailExpanded>>>;
};

export type Instacart_Customers_Orders_V1_GetOrderLinesRequest_Input = {
  /** Single order reference. */
  orderReference?: InputMaybe<Scalars['String']>;
  /**
   * Batched order reference call.
   * Limit: 20.
   */
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** RequestContext. */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

export type Instacart_Customers_Orders_V1_GetOrderLinesResponse = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse';
  /** If a single order_reference is passed, the single order item summary. */
  orderLines: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLines>;
  /** Mapped by input order_reference values. */
  orderLinesByOrderReference: Maybe<Scalars['JSON']>;
};

/** See OrdersDomain::Api::Responses::ItemResponse. */
export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderItem';
  /** Item is alcoholic */
  alcoholic: Maybe<Scalars['Boolean']>;
  /** Additional item external data provided by the retailer. */
  externalData: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItemExternalData>;
  imageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** Product category */
  productCategory: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem_ProductCategory>;
  /** Product codes */
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  productId: Maybe<Scalars['BigInt']>;
  /** Quantity including units displayed to customer. */
  quantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Item is OTC */
  restrictedOtc: Maybe<Scalars['Boolean']>;
  /** Retailer lookup code. */
  retailerLookupCode: Maybe<Scalars['String']>;
  /**
   * Retailer reference code.
   * The current/actual RRC value (may be catalog-derived).
   * For original retailer-submitted values, use external_retailer_rrc in OrderItemExternalData.
   */
  retailerReferenceCode: Maybe<Scalars['String']>;
  /** Item is rx */
  rx: Maybe<Scalars['Boolean']>;
  /** Display size of item. */
  sizeDetails: Maybe<Scalars['String']>;
  /** Price per unit displayed to customer. */
  unitPrice: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItemExternalData = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderItemExternalData';
  externalRetailerRrc: Maybe<Scalars['String']>;
  /**
   * These fields reflect the values passed by the caller (e.g. Connect retailers)
   * and are guaranteed to match what was sent by the retailer.
   * In contrast, retailer_upc / retailer_rrc reflect catalog-derived values and
   * may differ from what the retailer originally submitted.
   */
  externalRetailerUpc: Maybe<Scalars['String']>;
  lineNum: Maybe<Scalars['String']>;
  lineNumSource: Maybe<Scalars['String']>;
  /**
   * DEPRECATED: Use external_retailer_rrc for original retailer-submitted values,
   * or retailer_reference_code for current/actual catalog-derived values.
   */
  retailerRrc: Maybe<Scalars['String']>;
  /**
   * DEPRECATED: Use external_retailer_upc for original retailer-submitted values,
   * or retailer_lookup_code for current/actual catalog-derived values.
   */
  retailerUpc: Maybe<Scalars['String']>;
  scanCode: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem_ProductCategory = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderItem_ProductCategory';
  l1Category: Maybe<Scalars['String']>;
  l1CategoryId: Maybe<Scalars['BigInt']>;
  l2Category: Maybe<Scalars['String']>;
  l2CategoryId: Maybe<Scalars['BigInt']>;
  l3Category: Maybe<Scalars['String']>;
  l3CategoryId: Maybe<Scalars['BigInt']>;
  l4Category: Maybe<Scalars['String']>;
  l4CategoryId: Maybe<Scalars['BigInt']>;
  l5Category: Maybe<Scalars['String']>;
  l5CategoryId: Maybe<Scalars['BigInt']>;
  l6Category: Maybe<Scalars['String']>;
  l6CategoryId: Maybe<Scalars['BigInt']>;
  productCategory: Maybe<Scalars['String']>;
  productCategoryId: Maybe<Scalars['BigInt']>;
};

/** See OrdersDomain::Api::Responses::OrderItemResponse. */
export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderLine';
  /** Id of the shopper that added the order item. */
  addedByDriverId: Maybe<Scalars['BigInt']>;
  /**
   * Specifies if the customer explicitly allowed a substitution.
   * Possible values:
   * nil - customer did not decide.
   * false - customer asked for no substitution.
   * true - customer asked for a substitute.
   */
  allowedSubstitution: Maybe<Scalars['Boolean']>;
  creationDate: Maybe<Scalars['DateTime']>;
  /** Price shown to customer at order time. */
  customerOrderedPrice: Maybe<GoogleTypeMoney>;
  /** Price displayed at storefront. */
  customerPrice: Maybe<GoogleTypeMoney>;
  /**
   * Customer specificed replacement at checkout/post-checkout.
   * Available only when allowed_substitution is True.
   */
  customerSelectedReplacement: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem>;
  /** When it is set, the current order line is added as a partial qty replacement for the order line with this id. */
  forOrderLineId: Maybe<Scalars['BigInt']>;
  /** Full price for this item. */
  fullPrice: Maybe<GoogleTypeMoney>;
  /** This id maps the sequence in which items were ordered. */
  id: Maybe<Scalars['BigInt']>;
  /** Original item requested at checkout. */
  item: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem>;
  /** A unique identifier for this OrderLine that can be exposed externally. */
  obfuscatedId: Maybe<Scalars['String']>;
  /** Quantity including units ordered by customer. */
  orderedQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity including units picked. */
  pickedQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity including units refunded. */
  refundQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  replacementPolicy: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_ReplacementPolicy>;
  /** Special instructions about the order item. */
  specialInstructions: Maybe<Scalars['String']>;
  /** Original requested item status. */
  status: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_Status>;
  /**
   * Substitute if replaced by shopper. If present, this is the current item
   * on the order.
   */
  substitute: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem>;
  /** The current status of the substitution for this item, if it exists. */
  substitutionStatus: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_SubstitutionStatus>;
};

/** Chosen replacement policy for the order item. */
export enum Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_ReplacementPolicy {
  NoReplacements = 'NO_REPLACEMENTS',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ShoppersChoice = 'SHOPPERS_CHOICE',
  UsersChoice = 'USERS_CHOICE'
}

export enum Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_Status {
  /**
   * DEPRECATED
   * Replacement approved by customer.
   */
  DeprecatedApproved = 'DEPRECATED_APPROVED',
  /**
   * DEPRECATED
   * Replacement rejected by customer.
   */
  DeprecatedRejected = 'DEPRECATED_REJECTED',
  /** Original item requested found by shopper. */
  Found = 'FOUND',
  /** Not yet picked. */
  NotPicked = 'NOT_PICKED',
  /** Item replaced. */
  Replaced = 'REPLACED',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  /** Item to be refunded. */
  ToRefund = 'TO_REFUND'
}

export enum Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_SubstitutionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SubstitutionStatusUnspecified = 'SUBSTITUTION_STATUS_UNSPECIFIED'
}

/** Represents result set for an order. */
export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLines = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderLines';
  lineItems: Maybe<Array<Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine>>>;
};

/** Country API Objects // */
export type Instacart_Customers_Partners_V1_Country = {
  __typename?: 'instacart_customers_partners_v1_Country';
  /** two-letter country abbreviation */
  alpha_2: Maybe<Scalars['String']>;
  /** three-letter country abbreviation */
  alpha_3: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequestParameters_Input = {
  expansionOwnerUserId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<Scalars['String']>;
  partnershipType?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  salesforceId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_CreateOrUpdatePartnerResponse = {
  __typename?: 'instacart_customers_partners_v1_CreateOrUpdatePartnerResponse';
  partner: Maybe<Instacart_Customers_Partners_V1_Partner>;
};

export type Instacart_Customers_Partners_V1_GetCountriesRequestParameters_Input = {
  /**
   * For searching by ID
   * If a search string is provided and a number or list of numbers can be extracted from it, search for those numbers as ids as well.
   */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** For searching by name or abbreviation */
  name?: InputMaybe<Scalars['String']>;
};

/** Country API Request // */
export type Instacart_Customers_Partners_V1_GetCountriesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetCountriesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** Countries API Response // */
export type Instacart_Customers_Partners_V1_GetCountriesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetCountriesResponse';
  countries: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Country>>>;
};

export type Instacart_Customers_Partners_V1_GetPartnersRequestParameters_Input = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limitValue?: InputMaybe<Scalars['BigInt']>;
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  updatedLastSec?: InputMaybe<Scalars['BigInt']>;
};

/** Partners API Request // */
export type Instacart_Customers_Partners_V1_GetPartnersRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetPartnersRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/**
 * ---------------------------------------- Responses ---------------------------------------
 * Partners API Response //
 */
export type Instacart_Customers_Partners_V1_GetPartnersResponse = {
  __typename?: 'instacart_customers_partners_v1_GetPartnersResponse';
  limitValue: Maybe<Scalars['BigInt']>;
  offsetValue: Maybe<Scalars['BigInt']>;
  partners: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Partner>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequestParameters_Input = {
  /** For searching by code, optional, fuzzy search */
  code?: InputMaybe<Scalars['String']>;
  /** will become a required field in the future as we go global */
  countryId?: InputMaybe<Scalars['BigInt']>;
  /** For searching by exact postal code, optional */
  exactCode?: InputMaybe<Scalars['String']>;
  /** For searching by ID */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  /** Required, we will only show a subset of postal codes by zone */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesByZonesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetPostalCodesByZonesResponse';
  limitValue: Maybe<Scalars['BigInt']>;
  offsetValue: Maybe<Scalars['BigInt']>;
  postalCodes: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_PostalCode>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesRequestParameters_Input = {
  /** For searching by code, optional, fuzzy search */
  code?: InputMaybe<Scalars['String']>;
  /** For searching by multiple codes, optional. Suffixed with _array to avoid confusion with other param `code` */
  codesArray?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** will become a required field in the future as we go global */
  countryId?: InputMaybe<Scalars['BigInt']>;
  /** For searching by exact postal code, optional */
  exactCode?: InputMaybe<Scalars['String']>;
  /** Codes that are unserviceable won't be included if set to true */
  excludeUnserviceable?: InputMaybe<Scalars['Boolean']>;
  /**
   * For searching by ID, optional
   * If a search string is provided and a number or list of numbers can be extracted from it, search for those numbers as ids as well.
   */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
};

/** PostalCodes API Request // */
export type Instacart_Customers_Partners_V1_GetPostalCodesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** PostalCodes API Response // */
export type Instacart_Customers_Partners_V1_GetPostalCodesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetPostalCodesResponse';
  limitValue: Maybe<Scalars['BigInt']>;
  offsetValue: Maybe<Scalars['BigInt']>;
  postalCodes: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_PostalCode>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRegionsRequestParameters_Input = {
  /** For searching by ID */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** For searching by name */
  name?: InputMaybe<Scalars['String']>;
};

/** Regions API Request // */
export type Instacart_Customers_Partners_V1_GetRegionsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRegionsRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** Regions API Response // */
export type Instacart_Customers_Partners_V1_GetRegionsResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRegionsResponse';
  regions: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Region>>>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequestParameters_Input = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  includePhysicalZone?: InputMaybe<Scalars['Boolean']>;
  includeTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /** Optionally pass in the location_codes to filter by */
  locationCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optionally pass in the name to filter by */
  name?: InputMaybe<Scalars['String']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailerLocationsByRetailerResponse';
  limitValue: Maybe<Scalars['BigInt']>;
  offsetValue: Maybe<Scalars['BigInt']>;
  retailerLocations: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_RetailerLocation>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsRequestParameters_Input = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includePhysicalZone?: InputMaybe<Scalars['Boolean']>;
  includeTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
};

/** RetailerLocations API Request // */
export type Instacart_Customers_Partners_V1_GetRetailerLocationsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** RetailerLocations API Response // */
export type Instacart_Customers_Partners_V1_GetRetailerLocationsResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailerLocationsResponse';
  limitValue: Maybe<Scalars['BigInt']>;
  offsetValue: Maybe<Scalars['BigInt']>;
  retailerLocations: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_RetailerLocation>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerZonesRequestParameters_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional for searching multiple retailers */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  visibleOnly?: InputMaybe<Scalars['Boolean']>;
  /** Optional for getting all retailers within particular zones */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Partners_V1_GetRetailerZonesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerZonesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerZonesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailerZonesResponse';
  retailerZones: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_RetailerZone>>>;
};

export type Instacart_Customers_Partners_V1_GetRetailersRequestParameters_Input = {
  /** For searching by IDs */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /**
   * For searching by name
   * Optional to only include retailers with visible=true AND at least one WHL with active=true
   */
  name?: InputMaybe<Scalars['String']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  onlyVisibleAndActive?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Partners_V1_GetRetailersRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailersRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailersResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailersResponse';
  limitValue: Maybe<Scalars['BigInt']>;
  offsetValue: Maybe<Scalars['BigInt']>;
  retailers: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Retailer>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetZonesByRegionRequestParameters_Input = {
  /** For searching by ID */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** For searching by name */
  name?: InputMaybe<Scalars['String']>;
  /** Required, we will only show a subset of zones by region */
  regionId?: InputMaybe<Scalars['BigInt']>;
};

/** Zones API Request // */
export type Instacart_Customers_Partners_V1_GetZonesByRegionRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesByRegionRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetZonesByRegionResponse = {
  __typename?: 'instacart_customers_partners_v1_GetZonesByRegionResponse';
  zones: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Zone>>>;
};

export type Instacart_Customers_Partners_V1_GetZonesRequestParameters_Input = {
  /** For searching by IDs, optional */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * For searching by name, optional
   * If a search string is provided and a number or list of numbers can be extracted from it, search for those numbers as ids as well.
   */
  name?: InputMaybe<Scalars['String']>;
};

/** Zones API Request // */
export type Instacart_Customers_Partners_V1_GetZonesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** Zones API Response // */
export type Instacart_Customers_Partners_V1_GetZonesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetZonesResponse';
  zones: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Zone>>>;
};

/** Partners API Objects // */
export type Instacart_Customers_Partners_V1_Partner = {
  __typename?: 'instacart_customers_partners_v1_Partner';
  expansionOwnerUserId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  partnerType: Maybe<Scalars['String']>;
  partnershipType: Maybe<Scalars['String']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  salesforceId: Maybe<Scalars['String']>;
};

/** PostalCode API Objects // */
export type Instacart_Customers_Partners_V1_PostalCode = {
  __typename?: 'instacart_customers_partners_v1_PostalCode';
  city: Maybe<Scalars['String']>;
  code: Maybe<Scalars['String']>;
  countryId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  state: Maybe<Scalars['String']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

/** Region API Objects // */
export type Instacart_Customers_Partners_V1_Region = {
  __typename?: 'instacart_customers_partners_v1_Region';
  countryId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

/** Retailers API Objects // */
export type Instacart_Customers_Partners_V1_Retailer = {
  __typename?: 'instacart_customers_partners_v1_Retailer';
  adminOnly: Maybe<Scalars['Boolean']>;
  aliasName: Maybe<Scalars['String']>;
  allowAlcohol: Maybe<Scalars['Boolean']>;
  allowSpecialRequests: Maybe<Scalars['Boolean']>;
  backgroundColorHex: Maybe<Scalars['String']>;
  backgroundImagePath: Maybe<Scalars['String']>;
  categories: Maybe<Array<Maybe<Scalars['String']>>>;
  countrySlug: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  franchiseeId: Maybe<Scalars['BigInt']>;
  franchisorId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  logoBackgroundColor: Maybe<Scalars['String']>;
  logoImagePath: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  priceParity: Maybe<Scalars['Boolean']>;
  priceTransparencyDescription: Maybe<Scalars['String']>;
  priceTransparencyFlag: Maybe<Scalars['String']>;
  retailerType: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** RetailerLocations API Objects // */
export type Instacart_Customers_Partners_V1_RetailerLocation = {
  __typename?: 'instacart_customers_partners_v1_RetailerLocation';
  active: Maybe<Scalars['Boolean']>;
  addressCounty: Maybe<Scalars['String']>;
  addressId: Maybe<Scalars['BigInt']>;
  bagFeeRateCents: Maybe<Scalars['BigInt']>;
  city: Maybe<Scalars['String']>;
  curbsidePickup: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  issEnabled: Maybe<Scalars['Boolean']>;
  latitude: Maybe<Scalars['Float']>;
  locationCode: Maybe<Scalars['String']>;
  longitude: Maybe<Scalars['Float']>;
  name: Maybe<Scalars['String']>;
  partnerPickup: Maybe<Scalars['Boolean']>;
  physicalZone: Maybe<Instacart_Customers_Partners_V1_Zone>;
  pickup: Maybe<Scalars['Boolean']>;
  pickupOnly: Maybe<Scalars['Boolean']>;
  postalCode: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  state: Maybe<Scalars['String']>;
  streetAddress: Maybe<Scalars['String']>;
  timeZone: Maybe<Scalars['String']>;
  unavailable: Maybe<Scalars['Boolean']>;
  zipPlusFour: Maybe<Scalars['String']>;
};

/** RetailerZone API Objects // */
export type Instacart_Customers_Partners_V1_RetailerZone = {
  __typename?: 'instacart_customers_partners_v1_RetailerZone';
  allowLocationInventory: Maybe<Scalars['Boolean']>;
  delivery: Maybe<Scalars['Boolean']>;
  handoffBatchingOnly: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  pickup: Maybe<Scalars['Boolean']>;
  promote: Maybe<Scalars['Boolean']>;
  retailerId: Maybe<Scalars['BigInt']>;
  salePriceAllowed: Maybe<Scalars['Boolean']>;
  visible: Maybe<Scalars['Boolean']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

/** Zone API Objects // */
export type Instacart_Customers_Partners_V1_Zone = {
  __typename?: 'instacart_customers_partners_v1_Zone';
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  regionId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsRequest_Input = {
  churnedDays?: InputMaybe<Scalars['BigInt']>;
  count?: InputMaybe<Scalars['BigInt']>;
  createdBy?: InputMaybe<Scalars['String']>;
  discountPolicyId?: InputMaybe<Scalars['BigInt']>;
  jobName?: InputMaybe<Scalars['String']>;
  omitUuid?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
  userSegment?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsResponse = {
  __typename?: 'instacart_customers_partnership_offer_v1_CreateRedemptionUrlsResponse';
  urlJob: Maybe<Instacart_Customers_Partnership_Offer_V1_PartnershipManagementUrl>;
};

export type Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkRequest_Input = {
  partnershipManagementUrlId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkResponse = {
  __typename?: 'instacart_customers_partnership_offer_v1_GetPartnershipManagementUrlDownloadLinkResponse';
  filePath: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsRequest_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsResponse = {
  __typename?: 'instacart_customers_partnership_offer_v1_ListPartnershipManagementUrlsResponse';
  urlJobs: Maybe<Array<Maybe<Instacart_Customers_Partnership_Offer_V1_PartnershipManagementUrl>>>;
};

export type Instacart_Customers_Partnership_Offer_V1_PartnershipManagementUrl = {
  __typename?: 'instacart_customers_partnership_offer_v1_PartnershipManagementUrl';
  createdBy: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  link: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  uniqueUrl: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_DeprecatedItemsDenormalizedsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_DeprecatedItemsDenormalizedsAttributes';
  blackoutTimes: Maybe<Scalars['String']>;
  buyNGetN: Maybe<Scalars['String']>;
  catalogEntityId: Maybe<Scalars['BigInt']>;
  comboPromotions: Maybe<Scalars['String']>;
  comboPromotionsJsonb: Maybe<Scalars['String']>;
  configurableProducts: Maybe<Scalars['String']>;
  disclaimer: Maybe<Scalars['String']>;
  displaySize: Maybe<Scalars['String']>;
  elasticItemId: Maybe<Scalars['BigInt']>;
  generatedAt: Maybe<Scalars['DateTime']>;
  inStoreLocation: Maybe<Scalars['String']>;
  inventoryAreaId: Maybe<Scalars['Int']>;
  itemId: Maybe<Scalars['BigInt']>;
  itemTaxData: Maybe<Scalars['String']>;
  mentosItemPartialRowId: Maybe<Scalars['BigInt']>;
  productId: Maybe<Scalars['Int']>;
  retailerDepartment: Maybe<Scalars['String']>;
  retailerFlyerData: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['Int']>;
  retailerLookupCode: Maybe<Scalars['String']>;
  retailerPromotionDetails: Maybe<Scalars['String']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  retailerSalesTaxCode: Maybe<Scalars['String']>;
  retailerSpecificMetadata: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  storageTemp: Maybe<Scalars['String']>;
  surfaceId: Maybe<Scalars['BigInt']>;
  temporaryOverrideElasticItemId: Maybe<Scalars['BigInt']>;
  unataFulfillmentTypes: Maybe<Scalars['String']>;
  vertexTaxCode: Maybe<Scalars['String']>;
  zoneIds: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_DeprecatedRetailerProductsCpgsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_DeprecatedRetailerProductsCpgsAttributes';
  cpgElasticRetailerProductId: Maybe<Scalars['BigInt']>;
  data: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  retailerId: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Parameters_Input>;
  /** Used for passing information about the request. */
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Parameters_Input = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  hasImage?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  /** IDs of products to get */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Text search query for product name and brand */
  query?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchable?: InputMaybe<Scalars['Boolean']>;
  /** Attributes to select */
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_GetLegacyProductsWithFiltersResponse';
  responseMeta: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results: Maybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_GetLegacyProductsWithFiltersResponse_Results';
  products: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_InventoryAreaAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_InventoryAreaAttributes';
  inventoryAreaId: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  regionId: Maybe<Scalars['BigInt']>;
  warehouseId: Maybe<Scalars['BigInt']>;
};

/**
 * An item is currently represented by a union of all the tables joined in the get items query.
 * This is because a generic select parameter exists that allows clients to request any <table>.<column>
 * that exists in the final result set. This is unfortunate because currently that means we'll have a 500 field
 * protobuf message. We should consider a v2 of what an item is by grouping cohesive fields together into nested messages.
 */
export type Instacart_Customers_Product_Retrieval_V1_Item = {
  __typename?: 'instacart_customers_product_retrieval_v1_Item';
  deprecatedItemsDenormalizedsAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_DeprecatedItemsDenormalizedsAttributes>;
  deprecatedRetailerProductsCpgsAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_DeprecatedRetailerProductsCpgsAttributes>;
  inventoryAreaAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_InventoryAreaAttributes>;
  itemAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_ItemAttributes>;
  itemId: Maybe<Scalars['BigInt']>;
  otherAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_OtherAttributes>;
  productAvailabilitiesAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_ProductAvailabilitiesAttributes>;
  retailerProductRetailerCollectionsV2Attributes: Maybe<Instacart_Customers_Product_Retrieval_V1_RetailerProductRetailerCollectionsV2Attributes>;
  retailerProductsAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_RetailerProductsAttributes>;
  retailerProductsCpgsAttributes: Maybe<Instacart_Customers_Product_Retrieval_V1_RetailerProductsCpgsAttributes>;
};

export type Instacart_Customers_Product_Retrieval_V1_ItemAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_ItemAttributes';
  alcoholic: Maybe<Scalars['Boolean']>;
  availabilityEndDate: Maybe<Scalars['DateTime']>;
  availabilityStartDate: Maybe<Scalars['DateTime']>;
  available: Maybe<Scalars['Boolean']>;
  balanceOnHandQty: Maybe<Scalars['Int']>;
  bogoBuy: Maybe<Scalars['Int']>;
  bogoGet: Maybe<Scalars['Int']>;
  bottleDepositBankId: Maybe<Scalars['Int']>;
  bottleDepositCents: Maybe<Scalars['Int']>;
  bottleDepositCurrency: Maybe<Scalars['String']>;
  cancelLeadTime: Maybe<Scalars['Int']>;
  carrotAdsCategoryIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  catalogEntityId: Maybe<Scalars['BigInt']>;
  codeSetVersion: Maybe<Scalars['Int']>;
  cost: Maybe<Scalars['String']>;
  costPricePerCase: Maybe<Scalars['String']>;
  costPricePerUnit: Maybe<Scalars['String']>;
  costUnit: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  digitalScaleRequired: Maybe<Scalars['Boolean']>;
  elasticItemId: Maybe<Scalars['BigInt']>;
  eversightPricing: Maybe<Scalars['String']>;
  excludeMarkup: Maybe<Scalars['Boolean']>;
  fizzEligible: Maybe<Scalars['Boolean']>;
  fulfillDelivery: Maybe<Scalars['Boolean']>;
  fulfillExtraLongDistanceDelivery: Maybe<Scalars['Boolean']>;
  fulfillInstore: Maybe<Scalars['Boolean']>;
  fulfillPickup: Maybe<Scalars['Boolean']>;
  fullPrice: Maybe<Scalars['String']>;
  fullText: Maybe<Scalars['String']>;
  generatedAt: Maybe<Scalars['DateTime']>;
  hasRetailerPromotion: Maybe<Scalars['Boolean']>;
  inAssortment: Maybe<Scalars['Boolean']>;
  inventoryAreaId: Maybe<Scalars['Int']>;
  isAlcoholic: Maybe<Scalars['Boolean']>;
  isCatering: Maybe<Scalars['Boolean']>;
  isHot: Maybe<Scalars['Boolean']>;
  isPackagedByWeight: Maybe<Scalars['Boolean']>;
  itemDepartmentId: Maybe<Scalars['String']>;
  itemId: Maybe<Scalars['BigInt']>;
  itemType: Maybe<Scalars['String']>;
  localeCode: Maybe<Scalars['String']>;
  loyaltyAllowed: Maybe<Scalars['Boolean']>;
  loyaltyCostPriceCents: Maybe<Scalars['Int']>;
  loyaltyCostPriceCurrency: Maybe<Scalars['String']>;
  loyaltyCostPriceEndAt: Maybe<Scalars['DateTime']>;
  loyaltyCostPricePerUnit: Maybe<Scalars['String']>;
  loyaltyCostPriceStartAt: Maybe<Scalars['DateTime']>;
  loyaltyMembersOnly: Maybe<Scalars['Boolean']>;
  loyaltyPrice: Maybe<Scalars['String']>;
  loyaltyPriceActive: Maybe<Scalars['Boolean']>;
  loyaltyPriceEndAt: Maybe<Scalars['DateTime']>;
  loyaltyPriceStartAt: Maybe<Scalars['DateTime']>;
  maxCart: Maybe<Scalars['Float']>;
  maxInCart: Maybe<Scalars['Int']>;
  mentosItemPartialRowId: Maybe<Scalars['BigInt']>;
  onSale: Maybe<Scalars['Boolean']>;
  orderLeadTime: Maybe<Scalars['Int']>;
  packagedAs: Maybe<Array<Maybe<Scalars['String']>>>;
  palletQuantity: Maybe<Scalars['BigInt']>;
  parWeight: Maybe<Scalars['Float']>;
  previewEndDate: Maybe<Scalars['DateTime']>;
  previewStartDate: Maybe<Scalars['DateTime']>;
  price: Maybe<Scalars['String']>;
  priceMultiple: Maybe<Scalars['Float']>;
  pricePerUnit: Maybe<Scalars['String']>;
  pricedBySoldByType: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  productType: Maybe<Scalars['String']>;
  promotionDiscountBeginsAt: Maybe<Scalars['DateTime']>;
  promotionDiscountEndsAt: Maybe<Scalars['DateTime']>;
  promotionGroupId: Maybe<Scalars['String']>;
  proviDistributorIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  recentlyShoppedAt: Maybe<Scalars['DateTime']>;
  regionId: Maybe<Scalars['Int']>;
  retailerDepartment: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['Int']>;
  retailerProductExperimentVariantId: Maybe<Scalars['Int']>;
  retailerProductScoreBrowseCtrPopV0: Maybe<Scalars['Float']>;
  retailerPromotionFractionApproximation: Maybe<Scalars['Float']>;
  retailerSalesTaxRate: Maybe<Scalars['Float']>;
  retailerSpecificKeyword: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerSpecifiedAlcoholic: Maybe<Scalars['Boolean']>;
  rewardProgram: Maybe<Scalars['String']>;
  rewardUnit: Maybe<Scalars['String']>;
  rewardValue: Maybe<Scalars['Float']>;
  saleAllowed: Maybe<Scalars['Boolean']>;
  saleCostPricePerUnit: Maybe<Scalars['String']>;
  saleEndAt: Maybe<Scalars['DateTime']>;
  salePriceCents: Maybe<Scalars['Int']>;
  saleStartAt: Maybe<Scalars['DateTime']>;
  salesType: Maybe<Scalars['String']>;
  searchable: Maybe<Scalars['Boolean']>;
  sfBbTempFlag: Maybe<Scalars['Boolean']>;
  sizeUomVariable: Maybe<Scalars['String']>;
  surfaceId: Maybe<Scalars['BigInt']>;
  taxable: Maybe<Scalars['Boolean']>;
  temporaryOverrideElasticItemId: Maybe<Scalars['BigInt']>;
  unataAvailable: Maybe<Scalars['Boolean']>;
  unataInAssortment: Maybe<Scalars['Boolean']>;
  unit: Maybe<Scalars['String']>;
  unitCount: Maybe<Scalars['Int']>;
  unitPrice: Maybe<Scalars['Float']>;
  unitsPerCase: Maybe<Scalars['BigInt']>;
  unlisted: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  usaEbtcashEligible: Maybe<Scalars['Boolean']>;
  usaSnapEligible: Maybe<Scalars['Boolean']>;
  useWeight: Maybe<Scalars['Boolean']>;
  visible: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute = {
  __typename?: 'instacart_customers_product_retrieval_v1_ItemPriceAttribute';
  cents: Maybe<Scalars['BigInt']>;
  endDate: Maybe<Scalars['DateTime']>;
  startDate: Maybe<Scalars['DateTime']>;
  subtype: Maybe<Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeSubtype>;
  type: Maybe<Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeType>;
};

export enum Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeSubtype {
  ItemPriceAttributeSubtypeLoyalty = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_LOYALTY',
  ItemPriceAttributeSubtypeRegular = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_REGULAR',
  ItemPriceAttributeSubtypeSale = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_SALE',
  ItemPriceAttributeSubtypeUnspecified = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_UNSPECIFIED'
}

export enum Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeType {
  ItemPriceAttributeTypeOcr = 'ITEM_PRICE_ATTRIBUTE_TYPE_OCR',
  ItemPriceAttributeTypeUnspecified = 'ITEM_PRICE_ATTRIBUTE_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct';
  /** aisle_ids integer[] DEFAULT '{}'::integer[] */
  aisleIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** aislefinity_retailer_aisles jsonb */
  aislefinityRetailerAisles: Maybe<Scalars['String']>;
  /** antibiotic_free boolean */
  antibioticFree: Maybe<Scalars['Boolean']>;
  /** available_inventory_area_ids integer[] DEFAULT '{}'::integer[] */
  availableInventoryAreaIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** available_items_count integer */
  availableItemsCount: Maybe<Scalars['Int']>;
  /** available_region_ids integer[] DEFAULT '{}'::integer[] */
  availableRegionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** available_warehouse_ids integer[] DEFAULT '{}'::integer[] */
  availableWarehouseIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** available_zone_ids integer[] DEFAULT '{}'::integer[] */
  availableZoneIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** brand jsonb */
  brand: Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_Brand>;
  /** brand_name character varying */
  brandName: Maybe<Scalars['String']>;
  /** breed_angus boolean */
  breedAngus: Maybe<Scalars['Boolean']>;
  /** breed_berkshire boolean */
  breedBerkshire: Maybe<Scalars['Boolean']>;
  /** breed_duroc_pork boolean */
  breedDurocPork: Maybe<Scalars['Boolean']>;
  /** breed_gloucestershire boolean */
  breedGloucestershire: Maybe<Scalars['Boolean']>;
  /** breed_kobe_wagyu boolean */
  breedKobeWagyu: Maybe<Scalars['Boolean']>;
  /** breed_kurobata_berkshire boolean */
  breedKurobataBerkshire: Maybe<Scalars['Boolean']>;
  /** breed_mangalitsapork boolean */
  breedMangalitsapork: Maybe<Scalars['Boolean']>;
  /** breed_piedmontese boolean */
  breedPiedmontese: Maybe<Scalars['Boolean']>;
  /** breed_veal boolean */
  breedVeal: Maybe<Scalars['Boolean']>;
  /** breed_wagyu boolean */
  breedWagyu: Maybe<Scalars['Boolean']>;
  /** cage_free boolean */
  cageFree: Maybe<Scalars['Boolean']>;
  /** color character varying */
  color: Maybe<Scalars['String']>;
  /** color_brown boolean */
  colorBrown: Maybe<Scalars['Boolean']>;
  /** color_hex_code character varying */
  colorHexCode: Maybe<Scalars['String']>;
  /** color_white boolean */
  colorWhite: Maybe<Scalars['Boolean']>;
  /** common_aisle character varying */
  commonAisle: Maybe<Scalars['String']>;
  /** contains_probiotics boolean */
  containsProbiotics: Maybe<Scalars['Boolean']>;
  /** conversions jsonb */
  conversions: Maybe<Scalars['String']>;
  /** cooking_method_braise boolean */
  cookingMethodBraise: Maybe<Scalars['Boolean']>;
  /** cooking_method_grill boolean */
  cookingMethodGrill: Maybe<Scalars['Boolean']>;
  /** cooking_method_pan_fry boolean */
  cookingMethodPanFry: Maybe<Scalars['Boolean']>;
  /** cooking_method_roast boolean */
  cookingMethodRoast: Maybe<Scalars['Boolean']>;
  /** country_ids integer[] DEFAULT '{}'::integer[] */
  countryIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** cuisine_tropical boolean */
  cuisineTropical: Maybe<Scalars['Boolean']>;
  /** dairy_free boolean */
  dairyFree: Maybe<Scalars['Boolean']>;
  /** department_ids integer[] DEFAULT '{}'::integer[] */
  departmentIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** department_names character varying[] DEFAULT '{}'::character varying[] */
  departmentNames: Maybe<Array<Maybe<Scalars['String']>>>;
  /** depth_uom character varying */
  depthUom: Maybe<Scalars['String']>;
  /** depth_value character varying */
  depthValue: Maybe<Scalars['String']>;
  /** display_name character varying */
  displayName: Maybe<Scalars['String']>;
  /** elastic_product_id bigint */
  elasticProductId: Maybe<Scalars['BigInt']>;
  /** farm character varying */
  farm: Maybe<Scalars['String']>;
  /** farmed boolean */
  farmed: Maybe<Scalars['Boolean']>;
  /** flavor character varying */
  flavor: Maybe<Scalars['String']>;
  /** fortified boolean */
  fortified: Maybe<Scalars['Boolean']>;
  /** free_range boolean */
  freeRange: Maybe<Scalars['Boolean']>;
  /** full_text tsvector */
  fullText: Maybe<Scalars['String']>;
  /** generated_at timestamp without time zone NOT NULL */
  generatedAt: Maybe<Scalars['DateTime']>;
  /** global_scan_codes character varying[] DEFAULT '{}'::character varying[] */
  globalScanCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  /** grade character varying */
  grade: Maybe<Scalars['String']>;
  /** grade_a boolean */
  gradeA: Maybe<Scalars['Boolean']>;
  /** grade_aa boolean */
  gradeAa: Maybe<Scalars['Boolean']>;
  /** grade_b boolean */
  gradeB: Maybe<Scalars['Boolean']>;
  /** grass_fed boolean */
  grassFed: Maybe<Scalars['Boolean']>;
  /** halal boolean */
  halal: Maybe<Scalars['Boolean']>;
  /** has_global_product_code boolean */
  hasGlobalProductCode: Maybe<Scalars['Boolean']>;
  /** has_image boolean */
  hasImage: Maybe<Scalars['Boolean']>;
  /** height_uom character varying */
  heightUom: Maybe<Scalars['String']>;
  /** height_value character varying */
  heightValue: Maybe<Scalars['String']>;
  /** high_protein boolean */
  highProtein: Maybe<Scalars['Boolean']>;
  /** hormone_free boolean */
  hormoneFree: Maybe<Scalars['Boolean']>;
  idpAttributeSourceOptedOut: Maybe<Array<Maybe<Scalars['String']>>>;
  idpWinningSourceData: Maybe<Scalars['String']>;
  /** image_list jsonb */
  imageList: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ImageList>>>;
  /** image_url character varying */
  imageUrl: Maybe<Scalars['String']>;
  /** infinity_weights jsonb */
  infinityWeights: Maybe<Scalars['String']>;
  /** inventory_area_ids integer[] DEFAULT '{}'::integer[] */
  inventoryAreaIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** is_catering boolean */
  isCatering: Maybe<Scalars['Boolean']>;
  /** keywords character varying[] DEFAULT '{}'::character varying[] */
  keywords: Maybe<Array<Maybe<Scalars['String']>>>;
  /** lactose_free boolean */
  lactoseFree: Maybe<Scalars['Boolean']>;
  /** landing_param character varying */
  landingParam: Maybe<Scalars['String']>;
  /** large_image_url character varying */
  largeImageUrl: Maybe<Scalars['String']>;
  /** locale_code character varying */
  localeCode: Maybe<Scalars['String']>;
  /** meat_state text */
  meatState: Maybe<Scalars['String']>;
  /** milk_type_almond boolean */
  milkTypeAlmond: Maybe<Scalars['Boolean']>;
  /** milk_type_buffalo boolean */
  milkTypeBuffalo: Maybe<Scalars['Boolean']>;
  /** milk_type_camel boolean */
  milkTypeCamel: Maybe<Scalars['Boolean']>;
  /** milk_type_cashew boolean */
  milkTypeCashew: Maybe<Scalars['Boolean']>;
  /** milk_type_coconut boolean */
  milkTypeCoconut: Maybe<Scalars['Boolean']>;
  /** milk_type_cow boolean */
  milkTypeCow: Maybe<Scalars['Boolean']>;
  /** milk_type_donkey boolean */
  milkTypeDonkey: Maybe<Scalars['Boolean']>;
  /** milk_type_flax boolean */
  milkTypeFlax: Maybe<Scalars['Boolean']>;
  /** milk_type_goat boolean */
  milkTypeGoat: Maybe<Scalars['Boolean']>;
  /** milk_type_hazelnut boolean */
  milkTypeHazelnut: Maybe<Scalars['Boolean']>;
  /** milk_type_hemp boolean */
  milkTypeHemp: Maybe<Scalars['Boolean']>;
  /** milk_type_mare boolean */
  milkTypeMare: Maybe<Scalars['Boolean']>;
  /** milk_type_moose boolean */
  milkTypeMoose: Maybe<Scalars['Boolean']>;
  /** milk_type_oat boolean */
  milkTypeOat: Maybe<Scalars['Boolean']>;
  /** milk_type_reindeer boolean */
  milkTypeReindeer: Maybe<Scalars['Boolean']>;
  /** milk_type_rice boolean */
  milkTypeRice: Maybe<Scalars['Boolean']>;
  /** milk_type_sheep boolean */
  milkTypeSheep: Maybe<Scalars['Boolean']>;
  /** milk_type_soy boolean */
  milkTypeSoy: Maybe<Scalars['Boolean']>;
  /** milk_type_sunflower boolean */
  milkTypeSunflower: Maybe<Scalars['Boolean']>;
  /** milk_type_waterbuffalo boolean */
  milkTypeWaterbuffalo: Maybe<Scalars['Boolean']>;
  /** milk_type_whole_grain boolean */
  milkTypeWholeGrain: Maybe<Scalars['Boolean']>;
  /** milk_type_yak boolean */
  milkTypeYak: Maybe<Scalars['Boolean']>;
  /** no_added_sugar boolean */
  noAddedSugar: Maybe<Scalars['Boolean']>;
  /** non_gmo boolean */
  nonGmo: Maybe<Scalars['Boolean']>;
  /** nutritional_info jsonb */
  nutritionalInfo: Maybe<Scalars['JSON']>;
  /** omega3_enriched boolean */
  omega3Enriched: Maybe<Scalars['Boolean']>;
  /** origin character varying */
  origin: Maybe<Scalars['String']>;
  /** original_name character varying */
  originalName: Maybe<Scalars['String']>;
  /** packaging character varying */
  packaging: Maybe<Scalars['String']>;
  /** packaging_bagged boolean */
  packagingBagged: Maybe<Scalars['Boolean']>;
  /** packaging_bunched boolean */
  packagingBunched: Maybe<Scalars['Boolean']>;
  /** pasture_raised boolean */
  pastureRaised: Maybe<Scalars['Boolean']>;
  /** prep_breaded_crusted boolean */
  prepBreadedCrusted: Maybe<Scalars['Boolean']>;
  /** prep_chopped boolean */
  prepChopped: Maybe<Scalars['Boolean']>;
  /** prep_chunks boolean */
  prepChunks: Maybe<Scalars['Boolean']>;
  /** prep_core boolean */
  prepCore: Maybe<Scalars['Boolean']>;
  /** prep_cured boolean */
  prepCured: Maybe<Scalars['Boolean']>;
  /** prep_cut boolean */
  prepCut: Maybe<Scalars['Boolean']>;
  /** prep_diced boolean */
  prepDiced: Maybe<Scalars['Boolean']>;
  /** prep_dry_aged boolean */
  prepDryAged: Maybe<Scalars['Boolean']>;
  /** prep_glazed boolean */
  prepGlazed: Maybe<Scalars['Boolean']>;
  /** prep_grilled boolean */
  prepGrilled: Maybe<Scalars['Boolean']>;
  /** prep_instructions character varying */
  prepInstructions: Maybe<Scalars['String']>;
  /** prep_marinated boolean */
  prepMarinated: Maybe<Scalars['Boolean']>;
  /** prep_party_tray boolean */
  prepPartyTray: Maybe<Scalars['Boolean']>;
  /** prep_roasted boolean */
  prepRoasted: Maybe<Scalars['Boolean']>;
  /** prep_rubbed boolean */
  prepRubbed: Maybe<Scalars['Boolean']>;
  /** prep_seasoned boolean */
  prepSeasoned: Maybe<Scalars['Boolean']>;
  /** prep_smoked boolean */
  prepSmoked: Maybe<Scalars['Boolean']>;
  /** prep_spirals boolean */
  prepSpirals: Maybe<Scalars['Boolean']>;
  /** prep_uncured boolean */
  prepUncured: Maybe<Scalars['Boolean']>;
  /** prep_washed boolean */
  prepWashed: Maybe<Scalars['Boolean']>;
  /** primal_cut text */
  primalCut: Maybe<Scalars['String']>;
  /** product_category jsonb */
  productCategory: Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCategory>;
  /** product_category_path character varying */
  productCategoryPath: Maybe<Scalars['String']>;
  /** product_codes jsonb */
  productCodes: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCode>>>;
  /** product_enrichment_keywords character varying[] DEFAULT '{}'::character varying[] */
  productEnrichmentKeywords: Maybe<Array<Maybe<Scalars['String']>>>;
  /** product_id bigint NOT NULL */
  productId: Maybe<Scalars['BigInt']>;
  /** product_info jsonb */
  productInfo: Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductInfo>;
  /** region_ids integer[] DEFAULT '{}'::integer[] */
  regionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** retailer_ids integer[] DEFAULT '{}'::integer[] */
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** retailer_image_list character varying[] DEFAULT '{}'::character varying[] */
  retailerImageList: Maybe<Array<Maybe<Scalars['String']>>>;
  /** retailer_product_score_smoothed_count_v0 double precision */
  retailerProductScoreSmoothedCountV0: Maybe<Scalars['Float']>;
  /** retailer_reference_codes jsonb */
  retailerReferenceCodes: Maybe<Scalars['String']>;
  /** retailer_variant_group_code character varying */
  retailerVariantGroupCode: Maybe<Scalars['String']>;
  /** romance_copy character varying */
  romanceCopy: Maybe<Scalars['String']>;
  /** searchable boolean NOT NULL */
  searchable: Maybe<Scalars['Boolean']>;
  /** seasonality jsonb */
  seasonality: Maybe<Scalars['String']>;
  /** seedless boolean */
  seedless: Maybe<Scalars['Boolean']>;
  /** size character varying */
  size: Maybe<Scalars['String']>;
  /** size_baby boolean */
  sizeBaby: Maybe<Scalars['Boolean']>;
  /** size_extra_large boolean */
  sizeExtraLarge: Maybe<Scalars['Boolean']>;
  /** size_jumbo boolean */
  sizeJumbo: Maybe<Scalars['Boolean']>;
  /** size_large boolean */
  sizeLarge: Maybe<Scalars['Boolean']>;
  /** size_medium boolean */
  sizeMedium: Maybe<Scalars['Boolean']>;
  /** size_small boolean */
  sizeSmall: Maybe<Scalars['Boolean']>;
  /** size_uom character varying */
  sizeUom: Maybe<Scalars['String']>;
  /** size_value double precision */
  sizeValue: Maybe<Scalars['Float']>;
  /** sliced boolean */
  sliced: Maybe<Scalars['Boolean']>;
  /** store_brand boolean */
  storeBrand: Maybe<Scalars['Boolean']>;
  /** trim_bone_in boolean */
  trimBoneIn: Maybe<Scalars['Boolean']>;
  /** trim_boneless boolean */
  trimBoneless: Maybe<Scalars['Boolean']>;
  /** trim_deveined boolean */
  trimDeveined: Maybe<Scalars['Boolean']>;
  /** trim_dressed boolean */
  trimDressed: Maybe<Scalars['Boolean']>;
  /** trim_frenched boolean */
  trimFrenched: Maybe<Scalars['Boolean']>;
  /** trim_head_on boolean */
  trimHeadOn: Maybe<Scalars['Boolean']>;
  /** trim_peeled boolean */
  trimPeeled: Maybe<Scalars['Boolean']>;
  /** trim_shell_on boolean */
  trimShellOn: Maybe<Scalars['Boolean']>;
  /** trim_shredded boolean */
  trimShredded: Maybe<Scalars['Boolean']>;
  /** trim_skin_on boolean */
  trimSkinOn: Maybe<Scalars['Boolean']>;
  /** trim_skinless boolean */
  trimSkinless: Maybe<Scalars['Boolean']>;
  /** trim_stuffed boolean */
  trimStuffed: Maybe<Scalars['Boolean']>;
  /** trim_tail_off boolean */
  trimTailOff: Maybe<Scalars['Boolean']>;
  /** trim_thick_cut boolean */
  trimThickCut: Maybe<Scalars['Boolean']>;
  /** trim_thin_cut boolean */
  trimThinCut: Maybe<Scalars['Boolean']>;
  /** unit_count character varying */
  unitCount: Maybe<Scalars['String']>;
  /** usa_snap_eligible boolean */
  usaSnapEligible: Maybe<Scalars['Boolean']>;
  /** variant_attributes character varying */
  variantAttributes: Maybe<Scalars['String']>;
  /** variant_dimensions character varying */
  variantDimensions: Maybe<Scalars['String']>;
  /** variant_group_code character varying */
  variantGroupCode: Maybe<Scalars['String']>;
  /** variant_salted boolean */
  variantSalted: Maybe<Scalars['Boolean']>;
  /** variant_unsalted boolean */
  variantUnsalted: Maybe<Scalars['Boolean']>;
  /** variant_with_fruit boolean */
  variantWithFruit: Maybe<Scalars['Boolean']>;
  /** variant_with_toppings boolean */
  variantWithToppings: Maybe<Scalars['Boolean']>;
  /** vegan boolean */
  vegan: Maybe<Scalars['Boolean']>;
  /** vegetarian boolean */
  vegetarian: Maybe<Scalars['Boolean']>;
  /** visible_items_count integer */
  visibleItemsCount: Maybe<Scalars['Int']>;
  /** warehouses_count integer */
  warehousesCount: Maybe<Scalars['Int']>;
  /** width_uom character varying */
  widthUom: Maybe<Scalars['String']>;
  /** width_value character varying */
  widthValue: Maybe<Scalars['String']>;
  /** wild_caught boolean */
  wildCaught: Maybe<Scalars['Boolean']>;
  /** yogurt_type_drinkable boolean */
  yogurtTypeDrinkable: Maybe<Scalars['Boolean']>;
  /** yogurt_type_goat_milk boolean */
  yogurtTypeGoatMilk: Maybe<Scalars['Boolean']>;
  /** yogurt_type_greek boolean */
  yogurtTypeGreek: Maybe<Scalars['Boolean']>;
  /** yogurt_type_icelandic boolean */
  yogurtTypeIcelandic: Maybe<Scalars['Boolean']>;
  /** yogurt_type_sheep_milk boolean */
  yogurtTypeSheepMilk: Maybe<Scalars['Boolean']>;
  /** yogurt_type_traditional boolean */
  yogurtTypeTraditional: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_Brand = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_Brand';
  id: Maybe<Scalars['BigInt']>;
  warehouseIds: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ImageList = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ImageList';
  cacheType: Maybe<Scalars['String']>;
  imageId: Maybe<Scalars['String']>;
  imageType: Maybe<Scalars['String']>;
  sourceType: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCategory = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ProductCategory';
  l1Category: Maybe<Scalars['String']>;
  l1CategoryId: Maybe<Scalars['Int']>;
  l2Category: Maybe<Scalars['String']>;
  l2CategoryId: Maybe<Scalars['Int']>;
  l3Category: Maybe<Scalars['String']>;
  l3CategoryId: Maybe<Scalars['Int']>;
  l4Category: Maybe<Scalars['String']>;
  l4CategoryId: Maybe<Scalars['Int']>;
  l5Category: Maybe<Scalars['String']>;
  l5CategoryId: Maybe<Scalars['Int']>;
  l6Category: Maybe<Scalars['String']>;
  l6CategoryId: Maybe<Scalars['Int']>;
  productCategory: Maybe<Scalars['String']>;
  productCategoryId: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCode = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ProductCode';
  code: Maybe<Scalars['String']>;
  warehouseId: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductInfo = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ProductInfo';
  alcoholByVolume: Maybe<Scalars['Float']>;
  alcoholic: Maybe<Scalars['Boolean']>;
  bottleDepositWhitelisted: Maybe<Scalars['Boolean']>;
  cchGroupCode: Maybe<Scalars['String']>;
  cchItemCode: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  details: Maybe<Scalars['String']>;
  directions: Maybe<Scalars['String']>;
  fatFree: Maybe<Scalars['Boolean']>;
  glutenFree: Maybe<Scalars['Boolean']>;
  ingredients: Maybe<Scalars['String']>;
  ingredientsSource: Maybe<Scalars['String']>;
  kosher: Maybe<Scalars['Boolean']>;
  lowFat: Maybe<Scalars['Boolean']>;
  orderUnit: Maybe<Scalars['String']>;
  organic: Maybe<Scalars['Boolean']>;
  specialInstructions: Maybe<Scalars['String']>;
  sugarFree: Maybe<Scalars['Boolean']>;
  vegan: Maybe<Scalars['Boolean']>;
  vegetarian: Maybe<Scalars['Boolean']>;
  warnings: Maybe<Scalars['String']>;
};

/** Anything not direct from a table, i.e. derived at runtime or something */
export type Instacart_Customers_Product_Retrieval_V1_OtherAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_OtherAttributes';
  availabilityRank: Maybe<Scalars['Float']>;
  availabilityScoreUpdatedAt: Maybe<Scalars['DateTime']>;
  availabilitySource: Maybe<Scalars['String']>;
  buyItAgainScore: Maybe<Scalars['Float']>;
  dynamicLowStockThreshold: Maybe<Scalars['Float']>;
  dynamicOutOfStockThreshold: Maybe<Scalars['Float']>;
  itemPriceAttributes: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute>>>;
  managedAttributeValues: Maybe<Scalars['String']>;
  purchasable: Maybe<Scalars['Boolean']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  stockLevel: Maybe<Scalars['String']>;
  variantDimensionValues: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_ProductAvailabilitiesAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_ProductAvailabilitiesAttributes';
  availabilityScore: Maybe<Scalars['Float']>;
  availabilityScore_1: Maybe<Scalars['Float']>;
  availabilityScore_2: Maybe<Scalars['Float']>;
  availabilityScore_3: Maybe<Scalars['Float']>;
  availabilityScore_4: Maybe<Scalars['Float']>;
  availabilityScore_5: Maybe<Scalars['Float']>;
  createdAt: Maybe<Scalars['DateTime']>;
  inventoryAreaId: Maybe<Scalars['Int']>;
  productId: Maybe<Scalars['Int']>;
  retailerLocationId: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RequestFlags_Input = {
  /** Used for shadow testing. Do not set this flag in your request */
  isShadowTestingReplay?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RequestMeta_Debug_Input = {
  includeNode?: InputMaybe<Scalars['Boolean']>;
  includeParameterizedSql?: InputMaybe<Scalars['Boolean']>;
  includeRawSql?: InputMaybe<Scalars['Boolean']>;
};

/**
 * used for passing information about the request.  This data should NEVER be
 * used to modify a query and should only be used for logging and rate limiting.
 */
export type Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input = {
  /** The debug information requested for the request */
  debug?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Debug_Input>;
  requestFlags?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestFlags_Input>;
  /** The tier of the request indicating its business criticality level */
  requestTier?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_RequestTier>;
  /**
   * The call source of the request.  This is used for rate limiting and event
   * logging. This should be a STATIC string that can be searched for in a code repository.
   * Do NOT dynamically change this value as it will break rate limiting.
   */
  src?: InputMaybe<Scalars['String']>;
  /**
   * The variant of the src used for tracking different variations of an API call. You can use this
   * to track request counts/latency differences across different variations of a query.
   */
  srcVariant?: InputMaybe<Scalars['String']>;
};

/**
 * RequestTier represents the business criticality level of the request
 * Please see https://instacart.atlassian.net/wiki/spaces/Customers/pages/4879451337/Request+Tiers for more details
 */
export enum Instacart_Customers_Product_Retrieval_V1_RequestMeta_RequestTier {
  /**
   * Tier 0 - Highest priority, critical requests that must be served
   * Examples: Order placement, checkout flows
   */
  RequestTier_0 = 'REQUEST_TIER_0',
  /** Tier 1 - High priority requests */
  RequestTier_1 = 'REQUEST_TIER_1',
  /** Tier 2 - Medium priority requests */
  RequestTier_2 = 'REQUEST_TIER_2',
  /** Tier 3 - Low priority requests */
  RequestTier_3 = 'REQUEST_TIER_3',
  /** Tier 4 - Lowest priority requests */
  RequestTier_4 = 'REQUEST_TIER_4',
  /** Default value - should not be used explicitly, helps us uncover requests not setting the tier */
  RequestTierUnspecified = 'REQUEST_TIER_UNSPECIFIED'
}

/** used for future use cases where we want to pass information back to the client */
export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta';
  debug: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug>;
};

export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta_Debug';
  /** The node information for the query */
  node: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Node>;
  /** The SQL information for the query */
  sql: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Sql>;
};

export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Node = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta_Debug_Node';
  /** The cluster that the query was executed on */
  cluster: Maybe<Scalars['String']>;
  /** The replica that the query was executed on */
  replica: Maybe<Scalars['Int']>;
  /** The shard that the query was executed on */
  shard: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Sql = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta_Debug_SQL';
  /** The parameterized SQL that was executed, has the parameters replaced with placeholders */
  parameterizedSql: Maybe<Scalars['String']>;
  /** The parameters that were used in the parameterized SQL */
  parameters: Maybe<Array<Maybe<Google_Protobuf_Value>>>;
  /** The raw SQL that was executed, has the parameters directly in the SQL */
  rawSql: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RetailerProductRetailerCollectionsV2Attributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_RetailerProductRetailerCollectionsV2Attributes';
  collectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  productId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RetailerProductsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_RetailerProductsAttributes';
  aisleId: Maybe<Scalars['Int']>;
  aisleIds: Maybe<Scalars['String']>;
  aisleName: Maybe<Scalars['String']>;
  aisleNames: Maybe<Scalars['String']>;
  aisleSortOrder: Maybe<Scalars['Int']>;
  aisleSortOrders: Maybe<Scalars['String']>;
  alcoholAttributes: Maybe<Scalars['String']>;
  alcoholByVolume: Maybe<Scalars['Float']>;
  alcoholRating: Maybe<Scalars['Float']>;
  alcoholType: Maybe<Scalars['String']>;
  alcoholVarietal: Maybe<Scalars['String']>;
  alcoholic: Maybe<Scalars['Boolean']>;
  allergensKeywords: Maybe<Scalars['String']>;
  antibioticFree: Maybe<Scalars['Boolean']>;
  artificiallyCarbonated: Maybe<Scalars['Boolean']>;
  atkinsDiet: Maybe<Scalars['Boolean']>;
  bottle: Maybe<Scalars['Boolean']>;
  brandId: Maybe<Scalars['Int']>;
  brandName: Maybe<Scalars['String']>;
  breedAngus: Maybe<Scalars['Boolean']>;
  breedBerkshire: Maybe<Scalars['Boolean']>;
  breedDurocPork: Maybe<Scalars['Boolean']>;
  breedGloucestershire: Maybe<Scalars['Boolean']>;
  breedKobeWagyu: Maybe<Scalars['Boolean']>;
  breedKurobataBerkshire: Maybe<Scalars['Boolean']>;
  breedMangalitsapork: Maybe<Scalars['Boolean']>;
  breedPiedmontese: Maybe<Scalars['Boolean']>;
  breedVeal: Maybe<Scalars['Boolean']>;
  breedWagyu: Maybe<Scalars['Boolean']>;
  caEwasteCed: Maybe<Scalars['Boolean']>;
  cageFree: Maybe<Scalars['Boolean']>;
  calories: Maybe<Scalars['Float']>;
  canonicalProduct: Maybe<Scalars['String']>;
  carbFree: Maybe<Scalars['Boolean']>;
  carbohydrate: Maybe<Scalars['Float']>;
  cchGroupCode: Maybe<Scalars['String']>;
  cchItemCode: Maybe<Scalars['String']>;
  cholesterol: Maybe<Scalars['Int']>;
  claimMedicinal: Maybe<Scalars['Boolean']>;
  classifiedCode: Maybe<Scalars['String']>;
  coldPrepared: Maybe<Scalars['Boolean']>;
  color: Maybe<Scalars['String']>;
  colorBrown: Maybe<Scalars['Boolean']>;
  colorHexCode: Maybe<Scalars['String']>;
  colorWhite: Maybe<Scalars['Boolean']>;
  commonWeight: Maybe<Scalars['Float']>;
  containerType: Maybe<Scalars['String']>;
  containsFlour: Maybe<Scalars['Boolean']>;
  containsProbiotics: Maybe<Scalars['Boolean']>;
  cookingMethodBraise: Maybe<Scalars['Boolean']>;
  cookingMethodGrill: Maybe<Scalars['Boolean']>;
  cookingMethodPanFry: Maybe<Scalars['Boolean']>;
  cookingMethodRoast: Maybe<Scalars['Boolean']>;
  countryId: Maybe<Scalars['Int']>;
  createdAt: Maybe<Scalars['DateTime']>;
  cuisineTropical: Maybe<Scalars['Boolean']>;
  dairyFree: Maybe<Scalars['Boolean']>;
  departmentId: Maybe<Scalars['Int']>;
  departmentIds: Maybe<Scalars['String']>;
  departmentName: Maybe<Scalars['String']>;
  departmentNames: Maybe<Scalars['String']>;
  deptSortOrder: Maybe<Scalars['Float']>;
  deptSortOrders: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  details: Maybe<Scalars['String']>;
  directions: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  displayNameVariants: Maybe<Array<Maybe<Scalars['String']>>>;
  displayScreenSize: Maybe<Scalars['Float']>;
  displayScreenSizeUom: Maybe<Scalars['String']>;
  edible: Maybe<Scalars['Boolean']>;
  elasticRetailerProductId: Maybe<Scalars['BigInt']>;
  enrolledInExperiments: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  experimentVariantId: Maybe<Scalars['Int']>;
  farm: Maybe<Scalars['String']>;
  farmed: Maybe<Scalars['Boolean']>;
  fat: Maybe<Scalars['Float']>;
  fatCalories: Maybe<Scalars['Float']>;
  fatFree: Maybe<Scalars['Boolean']>;
  fiber: Maybe<Scalars['Float']>;
  flavor: Maybe<Scalars['String']>;
  formFactor: Maybe<Scalars['String']>;
  formFactorDescriptor: Maybe<Scalars['String']>;
  fortified: Maybe<Scalars['Boolean']>;
  freeRange: Maybe<Scalars['Boolean']>;
  fruitJuicePercent: Maybe<Scalars['Float']>;
  fullTextV1: Maybe<Scalars['String']>;
  fullTextV2: Maybe<Scalars['String']>;
  generatedAt: Maybe<Scalars['DateTime']>;
  glutenFree: Maybe<Scalars['Boolean']>;
  grade: Maybe<Scalars['String']>;
  gradeA: Maybe<Scalars['Boolean']>;
  gradeAa: Maybe<Scalars['Boolean']>;
  gradeB: Maybe<Scalars['Boolean']>;
  grassFed: Maybe<Scalars['Boolean']>;
  halal: Maybe<Scalars['Boolean']>;
  hasImage: Maybe<Scalars['Boolean']>;
  highCarb: Maybe<Scalars['Boolean']>;
  highFat: Maybe<Scalars['Boolean']>;
  highProtein: Maybe<Scalars['Boolean']>;
  hormoneFree: Maybe<Scalars['Boolean']>;
  imageList: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  images: Maybe<Scalars['String']>;
  inAssortment: Maybe<Scalars['Boolean']>;
  inSeason: Maybe<Scalars['Boolean']>;
  ingredients: Maybe<Scalars['String']>;
  isCatering: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  isMedicated: Maybe<Scalars['Boolean']>;
  isOrganic: Maybe<Scalars['Boolean']>;
  isPackaged: Maybe<Scalars['Boolean']>;
  juicePercent: Maybe<Scalars['Float']>;
  ketoDiet: Maybe<Scalars['Boolean']>;
  keywords: Maybe<Scalars['String']>;
  kidFriendly: Maybe<Scalars['Boolean']>;
  kosher: Maybe<Scalars['Boolean']>;
  lactoseFree: Maybe<Scalars['Boolean']>;
  largeImageUrl: Maybe<Scalars['String']>;
  localeCode: Maybe<Scalars['String']>;
  lowCarb: Maybe<Scalars['Boolean']>;
  lowFat: Maybe<Scalars['Boolean']>;
  lowSodium: Maybe<Scalars['Boolean']>;
  lowSugar: Maybe<Scalars['Boolean']>;
  managedAttributeIdArray: Maybe<Array<Maybe<Scalars['Int']>>>;
  managedAttributeValueIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  marginMix: Maybe<Scalars['Int']>;
  meatState: Maybe<Scalars['String']>;
  mentosRetailerProductPartialRowId: Maybe<Scalars['BigInt']>;
  milkTypeAlmond: Maybe<Scalars['Boolean']>;
  milkTypeBuffalo: Maybe<Scalars['Boolean']>;
  milkTypeCamel: Maybe<Scalars['Boolean']>;
  milkTypeCashew: Maybe<Scalars['Boolean']>;
  milkTypeCoconut: Maybe<Scalars['Boolean']>;
  milkTypeCow: Maybe<Scalars['Boolean']>;
  milkTypeDonkey: Maybe<Scalars['Boolean']>;
  milkTypeFlax: Maybe<Scalars['Boolean']>;
  milkTypeGoat: Maybe<Scalars['Boolean']>;
  milkTypeHazelnut: Maybe<Scalars['Boolean']>;
  milkTypeHemp: Maybe<Scalars['Boolean']>;
  milkTypeMare: Maybe<Scalars['Boolean']>;
  milkTypeMoose: Maybe<Scalars['Boolean']>;
  milkTypeOat: Maybe<Scalars['Boolean']>;
  milkTypeReindeer: Maybe<Scalars['Boolean']>;
  milkTypeRice: Maybe<Scalars['Boolean']>;
  milkTypeSheep: Maybe<Scalars['Boolean']>;
  milkTypeSoy: Maybe<Scalars['Boolean']>;
  milkTypeSunflower: Maybe<Scalars['Boolean']>;
  milkTypeWaterbuffalo: Maybe<Scalars['Boolean']>;
  milkTypeWholeGrain: Maybe<Scalars['Boolean']>;
  milkTypeYak: Maybe<Scalars['Boolean']>;
  minPickedWeight: Maybe<Scalars['Float']>;
  monounsaturatedFat: Maybe<Scalars['Float']>;
  name: Maybe<Scalars['String']>;
  noAddedSugar: Maybe<Scalars['Boolean']>;
  nonGmo: Maybe<Scalars['Boolean']>;
  nonenumeratedManagedAttributes: Maybe<Scalars['String']>;
  normalizedHeightCm: Maybe<Scalars['Float']>;
  normalizedLengthCm: Maybe<Scalars['Float']>;
  normalizedWeightG: Maybe<Scalars['Float']>;
  normalizedWidthCm: Maybe<Scalars['Float']>;
  nutritionSources: Maybe<Scalars['String']>;
  omega3Enriched: Maybe<Scalars['Boolean']>;
  organic: Maybe<Scalars['Boolean']>;
  origin: Maybe<Scalars['String']>;
  originalName: Maybe<Scalars['String']>;
  packaging: Maybe<Scalars['String']>;
  packagingBagged: Maybe<Scalars['Boolean']>;
  packagingBunched: Maybe<Scalars['Boolean']>;
  paleoDiet: Maybe<Scalars['Boolean']>;
  paperTowelBenefitClaim: Maybe<Scalars['String']>;
  paperTowelSizeClaim: Maybe<Scalars['String']>;
  pastureRaised: Maybe<Scalars['Boolean']>;
  polyunsaturatedFat: Maybe<Scalars['Float']>;
  potassium: Maybe<Scalars['Float']>;
  ppuNormalizedSizeValue: Maybe<Scalars['Float']>;
  prepBreadedCrusted: Maybe<Scalars['Boolean']>;
  prepChopped: Maybe<Scalars['Boolean']>;
  prepChunks: Maybe<Scalars['Boolean']>;
  prepCore: Maybe<Scalars['Boolean']>;
  prepCured: Maybe<Scalars['Boolean']>;
  prepCut: Maybe<Scalars['Boolean']>;
  prepDiced: Maybe<Scalars['Boolean']>;
  prepDryAged: Maybe<Scalars['Boolean']>;
  prepGlazed: Maybe<Scalars['Boolean']>;
  prepGrilled: Maybe<Scalars['Boolean']>;
  prepInstructions: Maybe<Scalars['String']>;
  prepMarinated: Maybe<Scalars['Boolean']>;
  prepPartyTray: Maybe<Scalars['Boolean']>;
  prepRoasted: Maybe<Scalars['Boolean']>;
  prepRubbed: Maybe<Scalars['Boolean']>;
  prepSeasoned: Maybe<Scalars['Boolean']>;
  prepSlicedRepackagedPasteurizedByRetailer: Maybe<Scalars['Boolean']>;
  prepSmoked: Maybe<Scalars['Boolean']>;
  prepSpirals: Maybe<Scalars['Boolean']>;
  prepUncured: Maybe<Scalars['Boolean']>;
  prepWashed: Maybe<Scalars['Boolean']>;
  primalCut: Maybe<Scalars['String']>;
  primaryAisleId: Maybe<Scalars['Int']>;
  primaryDepartmentId: Maybe<Scalars['Int']>;
  primaryImageUrl: Maybe<Scalars['String']>;
  productCategory: Maybe<Scalars['String']>;
  productCategoryL1Id: Maybe<Scalars['Int']>;
  productCategoryL1Name: Maybe<Scalars['String']>;
  productCategoryL2Id: Maybe<Scalars['Int']>;
  productCategoryL2Name: Maybe<Scalars['String']>;
  productCategoryL3Id: Maybe<Scalars['Int']>;
  productCategoryL3Name: Maybe<Scalars['String']>;
  productCategoryL4Id: Maybe<Scalars['Int']>;
  productCategoryL4Name: Maybe<Scalars['String']>;
  productCategoryL5Id: Maybe<Scalars['Int']>;
  productCategoryL5Name: Maybe<Scalars['String']>;
  productCategoryL6Id: Maybe<Scalars['Int']>;
  productCategoryL6Name: Maybe<Scalars['String']>;
  productCategoryTaxonomy: Maybe<Scalars['String']>;
  productCategoryTaxonomyL4: Maybe<Scalars['String']>;
  productCodes: Maybe<Scalars['String']>;
  productCodesArray: Maybe<Array<Maybe<Scalars['String']>>>;
  productEnrichmentKeywords: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  productTags: Maybe<Scalars['String']>;
  prop65Chemicals: Maybe<Scalars['String']>;
  prop65Text: Maybe<Scalars['String']>;
  protein: Maybe<Scalars['Float']>;
  requireReheating: Maybe<Scalars['Boolean']>;
  requiresKeepFrozen: Maybe<Scalars['Boolean']>;
  requiresRefrigeration: Maybe<Scalars['Boolean']>;
  restrictedOtc: Maybe<Scalars['Boolean']>;
  restrictedReasons: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerId: Maybe<Scalars['Int']>;
  retailerOmsEligible: Maybe<Scalars['Boolean']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  retailerWidePrepackaging: Maybe<Scalars['Boolean']>;
  romanceCopy: Maybe<Scalars['String']>;
  saturatedFat: Maybe<Scalars['Float']>;
  scent: Maybe<Scalars['String']>;
  seasonality: Maybe<Scalars['String']>;
  seasonalityDescription: Maybe<Scalars['String']>;
  secondaryAisleIds: Maybe<Array<Maybe<Scalars['Int']>>>;
  secondaryDepartmentIds: Maybe<Array<Maybe<Scalars['Int']>>>;
  seedless: Maybe<Scalars['Boolean']>;
  servingSize: Maybe<Scalars['String']>;
  servingsPerContainer: Maybe<Scalars['String']>;
  sheetCount: Maybe<Scalars['Float']>;
  shopperHeroImageUrl: Maybe<Scalars['String']>;
  shopperHeroLargeImageUrl: Maybe<Scalars['String']>;
  shouldScan: Maybe<Scalars['Boolean']>;
  similarName: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  sizeBaby: Maybe<Scalars['Boolean']>;
  sizeExtraLarge: Maybe<Scalars['Boolean']>;
  sizeJumbo: Maybe<Scalars['Boolean']>;
  sizeLarge: Maybe<Scalars['Boolean']>;
  sizeMedium: Maybe<Scalars['Boolean']>;
  sizeSmall: Maybe<Scalars['Boolean']>;
  sizeUom: Maybe<Scalars['String']>;
  sizeValue: Maybe<Scalars['Float']>;
  sodium: Maybe<Scalars['Float']>;
  storageTemp: Maybe<Scalars['String']>;
  storeBrand: Maybe<Scalars['Boolean']>;
  sugarFree: Maybe<Scalars['Boolean']>;
  sugars: Maybe<Scalars['Float']>;
  suggestedIncrementalWeight: Maybe<Scalars['Float']>;
  surfaceId: Maybe<Scalars['BigInt']>;
  syntheticCodes: Maybe<Scalars['String']>;
  temporaryOverrideElasticRetailerProductId: Maybe<Scalars['BigInt']>;
  thumbImageUrl: Maybe<Scalars['String']>;
  tobacco: Maybe<Scalars['Boolean']>;
  transFat: Maybe<Scalars['Float']>;
  trimBoneIn: Maybe<Scalars['Boolean']>;
  trimBoneless: Maybe<Scalars['Boolean']>;
  trimDeveined: Maybe<Scalars['Boolean']>;
  trimDressed: Maybe<Scalars['Boolean']>;
  trimFrenched: Maybe<Scalars['Boolean']>;
  trimHeadOn: Maybe<Scalars['Boolean']>;
  trimPeeled: Maybe<Scalars['Boolean']>;
  trimShellOn: Maybe<Scalars['Boolean']>;
  trimShredded: Maybe<Scalars['Boolean']>;
  trimSkinOn: Maybe<Scalars['Boolean']>;
  trimSkinless: Maybe<Scalars['Boolean']>;
  trimSliced: Maybe<Scalars['Boolean']>;
  trimStuffed: Maybe<Scalars['Boolean']>;
  trimTailOff: Maybe<Scalars['Boolean']>;
  trimThickCut: Maybe<Scalars['Boolean']>;
  trimThinCut: Maybe<Scalars['Boolean']>;
  unataL1CategoryId: Maybe<Scalars['String']>;
  unataL2CategoryId: Maybe<Scalars['String']>;
  unataL3CategoryId: Maybe<Scalars['String']>;
  unataL4CategoryId: Maybe<Scalars['String']>;
  unitAttributes: Maybe<Scalars['String']>;
  unitCount: Maybe<Scalars['Int']>;
  unitValue: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  usaSnapEligible: Maybe<Scalars['Boolean']>;
  variantAttributes: Maybe<Scalars['String']>;
  variantGroupId: Maybe<Scalars['BigInt']>;
  variantSalted: Maybe<Scalars['Boolean']>;
  variantUnsalted: Maybe<Scalars['Boolean']>;
  variantWithFruit: Maybe<Scalars['Boolean']>;
  variantWithToppings: Maybe<Scalars['Boolean']>;
  vegan: Maybe<Scalars['Boolean']>;
  vegetableJuicePercent: Maybe<Scalars['Float']>;
  vegetarian: Maybe<Scalars['Boolean']>;
  vertexTaxOverrideAttribute: Maybe<Scalars['String']>;
  warehouseId: Maybe<Scalars['Int']>;
  warnings: Maybe<Scalars['String']>;
  washload: Maybe<Scalars['Float']>;
  weightWatchers: Maybe<Scalars['Boolean']>;
  wholeGrain: Maybe<Scalars['Boolean']>;
  wildCaught: Maybe<Scalars['Boolean']>;
  yogurtTypeDrinkable: Maybe<Scalars['Boolean']>;
  yogurtTypeGoatMilk: Maybe<Scalars['Boolean']>;
  yogurtTypeGreek: Maybe<Scalars['Boolean']>;
  yogurtTypeIcelandic: Maybe<Scalars['Boolean']>;
  yogurtTypeSheepMilk: Maybe<Scalars['Boolean']>;
  yogurtTypeTraditional: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RetailerProductsCpgsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_RetailerProductsCpgsAttributes';
  cpgElasticRetailerProductId: Maybe<Scalars['BigInt']>;
  cpgOfferRequestKeys: Maybe<Array<Maybe<Scalars['String']>>>;
  cpgPromotionId: Maybe<Scalars['BigInt']>;
  hasDeal: Maybe<Scalars['Boolean']>;
  possibleDeliveryPromotionIds: Maybe<Array<Maybe<Scalars['Int']>>>;
  productId: Maybe<Scalars['Int']>;
  retailerId: Maybe<Scalars['Int']>;
  unattachedCouponDiscountBeginsAt: Maybe<Scalars['DateTime']>;
  unattachedCouponDiscountEndsAt: Maybe<Scalars['DateTime']>;
  unattachedCouponId: Maybe<Scalars['BigInt']>;
  unattachedCouponItemsPerDeal: Maybe<Scalars['Int']>;
  unattachedCouponSubtractValueCents: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/**
 * Enum used to identify the client and source type of the request.
 * Will be used to determine whether custom behaviour is required for the request.
 */
export enum Instacart_Customers_Product_Retrieval_V1_Catalog_V1_ClientSourceType {
  CaperNativeFeed = 'CAPER_NATIVE_FEED',
  /** Default/unset value */
  ClientSourceTypeUnspecified = 'CLIENT_SOURCE_TYPE_UNSPECIFIED',
  CommerceDiscountIcBirdzi = 'COMMERCE_DISCOUNT_IC_BIRDZI',
  CommerceDiscountIcLms = 'COMMERCE_DISCOUNT_IC_LMS'
}

export enum Instacart_Customers_Product_Retrieval_V1_Catalog_V1_CodeType {
  /** Default value */
  CodeTypeUnspecified = 'CODE_TYPE_UNSPECIFIED',
  ExternalIntegrationId = 'EXTERNAL_INTEGRATION_ID',
  LookupCodeNormalized = 'LOOKUP_CODE_NORMALIZED',
  LookupCodeRaw = 'LOOKUP_CODE_RAW',
  RetailerReferenceCode = 'RETAILER_REFERENCE_CODE'
}

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_Brand = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_Brand';
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Parameters_Input = {
  inventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetAggregatedItemDataResponse';
  responseMeta: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_AggregatedItemData = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetAggregatedItemDataResponse_AggregatedItemData';
  availableItemsCount: Maybe<Scalars['BigInt']>;
  maxPriceCents: Maybe<Scalars['BigInt']>;
  minPriceCents: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetAggregatedItemDataResponse_Results';
  aggregatedItemData: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_AggregatedItemData>>>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Parameters_Input = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  inventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetItemsResponse';
  responseMeta: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetItemsResponse_Results';
  items: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Item>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

/** A range of time based on specifying two dates */
export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_DateTimeRange_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

/** This query will execute across all shards for a given retailer */
export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Parameters_Input = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  hasPrimaryImageUrl?: InputMaybe<Scalars['Boolean']>;
  includeEscp?: InputMaybe<Scalars['Boolean']>;
  includeManagedAttributeValues?: InputMaybe<Scalars['Boolean']>;
  isStoreBrandProduct?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  omniSearchTerm?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCreationDateRange?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_DateTimeRange_Input>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional: list of retailer_ids for batch product search across multiple retailers.
   * When non-empty, the service fans out queries to the appropriate shards for each
   * retailer_id and merges results. This avoids N separate RPC calls from the client.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerProductIds?: InputMaybe<Array<InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_RetailerProductId_Input>>>;
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  surfaceIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  withUnclassifiedProducts?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_RetailerProductId_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetRetailerProductsResponse';
  responseMeta: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetRetailerProductsResponse_Results';
  retailerProducts: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerProduct';
  _score: Maybe<Scalars['Float']>;
  aisleId: Maybe<Scalars['BigInt']>;
  aisleIds: Maybe<Scalars['String']>;
  aisleName: Maybe<Scalars['String']>;
  aisleNames: Maybe<Scalars['String']>;
  alcoholic: Maybe<Scalars['Boolean']>;
  atkinsDiet: Maybe<Scalars['Boolean']>;
  bottle: Maybe<Scalars['Boolean']>;
  brandId: Maybe<Scalars['BigInt']>;
  brandName: Maybe<Scalars['String']>;
  calories: Maybe<Scalars['Float']>;
  carbFree: Maybe<Scalars['Boolean']>;
  carbohydrate: Maybe<Scalars['Float']>;
  cchGroupCode: Maybe<Scalars['String']>;
  cchItemCode: Maybe<Scalars['String']>;
  coldPrepared: Maybe<Scalars['Boolean']>;
  containsFlour: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  dairyFree: Maybe<Scalars['Boolean']>;
  departmentId: Maybe<Scalars['BigInt']>;
  departmentIds: Maybe<Scalars['String']>;
  departmentNames: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  details: Maybe<Scalars['String']>;
  directions: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  fatFree: Maybe<Scalars['Boolean']>;
  glutenFree: Maybe<Scalars['Boolean']>;
  hasImage: Maybe<Scalars['Boolean']>;
  highCarb: Maybe<Scalars['Boolean']>;
  highFat: Maybe<Scalars['Boolean']>;
  highProtein: Maybe<Scalars['Boolean']>;
  imageList: Maybe<Scalars['String']>;
  ingredients: Maybe<Scalars['String']>;
  isOrganic: Maybe<Scalars['Boolean']>;
  ketoDiet: Maybe<Scalars['Boolean']>;
  kidFriendly: Maybe<Scalars['Boolean']>;
  kosher: Maybe<Scalars['Boolean']>;
  lactoseFree: Maybe<Scalars['Boolean']>;
  localeCode: Maybe<Scalars['String']>;
  lowCarb: Maybe<Scalars['Boolean']>;
  lowFat: Maybe<Scalars['Boolean']>;
  lowSodium: Maybe<Scalars['Boolean']>;
  lowSugar: Maybe<Scalars['Boolean']>;
  managedAttributeValues: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct_ManagedAttributeValueMap>;
  name: Maybe<Scalars['String']>;
  organic: Maybe<Scalars['Boolean']>;
  originalName: Maybe<Scalars['String']>;
  paleoDiet: Maybe<Scalars['Boolean']>;
  prepSlicedRepackagedPasteurizedByRetailer: Maybe<Scalars['Boolean']>;
  primaryAisleId: Maybe<Scalars['BigInt']>;
  primaryDepartmentId: Maybe<Scalars['BigInt']>;
  primaryImageUrl: Maybe<Scalars['String']>;
  productCategory: Maybe<Scalars['String']>;
  productCategoryTaxonomy: Maybe<Scalars['String']>;
  productCodes: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['BigInt']>;
  productTags: Maybe<Scalars['String']>;
  prop65Text: Maybe<Scalars['String']>;
  requireReheating: Maybe<Scalars['Boolean']>;
  requiresKeepFrozen: Maybe<Scalars['Boolean']>;
  requiresRefrigeration: Maybe<Scalars['Boolean']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  seasonality: Maybe<Scalars['String']>;
  secondaryAisleIds: Maybe<Scalars['String']>;
  secondaryDepartmentIds: Maybe<Scalars['String']>;
  servingSize: Maybe<Scalars['String']>;
  servingsPerContainer: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  sizeUom: Maybe<Scalars['String']>;
  storeBrand: Maybe<Scalars['Boolean']>;
  sugarFree: Maybe<Scalars['Boolean']>;
  suggestedIncrementalWeight: Maybe<Scalars['Float']>;
  syntheticCodes: Maybe<Scalars['String']>;
  unitCount: Maybe<Scalars['BigInt']>;
  vegan: Maybe<Scalars['Boolean']>;
  vegetarian: Maybe<Scalars['Boolean']>;
  vertexTaxOverrideAttribute: Maybe<Scalars['String']>;
  weightWatchers: Maybe<Scalars['Boolean']>;
  wholeGrain: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct_ManagedAttributeValueMap = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerProduct_ManagedAttributeValueMap';
  rawValues: Maybe<Scalars['JSON']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Parameters_Input = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_SearchRetailerBrandsResponse';
  responseMeta: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_SearchRetailerBrandsResponse_Results';
  brands: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_Brand>>>;
};

export enum Instacart_Customers_Recipes_V1_BulkRecipeAction {
  BulkRecipeActionArchive = 'BULK_RECIPE_ACTION_ARCHIVE',
  BulkRecipeActionDelete = 'BULK_RECIPE_ACTION_DELETE',
  BulkRecipeActionPublish = 'BULK_RECIPE_ACTION_PUBLISH',
  BulkRecipeActionUnarchive = 'BULK_RECIPE_ACTION_UNARCHIVE',
  BulkRecipeActionUnspecified = 'BULK_RECIPE_ACTION_UNSPECIFIED'
}

export type Instacart_Customers_Recipes_V1_BulkUpdateRecipesRequest_Input = {
  action?: InputMaybe<Instacart_Customers_Recipes_V1_BulkRecipeAction>;
  recipeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_BulkUpdateRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_BulkUpdateRecipesResponse';
  failureCount: Maybe<Scalars['Int']>;
  results: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeUpdateResult>>>;
  successCount: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Recipes_V1_Category = {
  __typename?: 'instacart_customers_recipes_v1_Category';
  contentCreatorId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_CoreIngredient = {
  __typename?: 'instacart_customers_recipes_v1_CoreIngredient';
  id: Maybe<Scalars['BigInt']>;
  term: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_CoreIngredientUpdate_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Recipes_V1_GetCategoriesByNameRequest_Input = {
  /** content creator ID */
  contentCreatorId?: InputMaybe<Scalars['BigInt']>;
  /** limit the number of results */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** name of the recipe category */
  name?: InputMaybe<Scalars['String']>;
  /** offset the results */
  offset?: InputMaybe<Scalars['BigInt']>;
  /** retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Recipes_V1_GetCategoriesByNameResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetCategoriesByNameResponse';
  /** list of recipe categories */
  categories: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Category>>>;
};

export type Instacart_Customers_Recipes_V1_GetCoreIngredientsResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetCoreIngredientsResponse';
  coreIngredients: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_CoreIngredient>>>;
};

export type Instacart_Customers_Recipes_V1_GetRecipeByIdRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Recipes_V1_GetRecipeByIdResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetRecipeByIdResponse';
  recipe: Maybe<Instacart_Customers_Recipes_V1_Recipe>;
};

export type Instacart_Customers_Recipes_V1_GetRecipesRequest_Input = {
  contentCreatorId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offPlatform?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  term?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Recipes_V1_GetRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetRecipesResponse';
  recipes: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Recipe>>>;
};

export type Instacart_Customers_Recipes_V1_IngestRecipesCsvRequest_Input = {
  /** CSV file lines */
  csv?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_IngestRecipesCsvResponse = {
  __typename?: 'instacart_customers_recipes_v1_IngestRecipesCsvResponse';
  /** parsings script's response message */
  parserResponse: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_Ingredient = {
  __typename?: 'instacart_customers_recipes_v1_Ingredient';
  coreIngredient: Maybe<Instacart_Customers_Recipes_V1_CoreIngredient>;
  id: Maybe<Scalars['BigInt']>;
  imageUrl: Maybe<Scalars['String']>;
  isKeyIngredient: Maybe<Scalars['Boolean']>;
  note: Maybe<Scalars['String']>;
  quantityHigh: Maybe<Scalars['Float']>;
  quantityLow: Maybe<Scalars['Float']>;
  retailerUpcs: Maybe<Array<Maybe<Scalars['String']>>>;
  text: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
  upcProductIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_IngredientGroup = {
  __typename?: 'instacart_customers_recipes_v1_IngredientGroup';
  id: Maybe<Scalars['BigInt']>;
  ingredients: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Ingredient>>>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_IngredientGroupUpdate_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  ingredients?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_IngredientUpdate_Input>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_IngredientUpdate_Input = {
  coreIngredient?: InputMaybe<Instacart_Customers_Recipes_V1_CoreIngredientUpdate_Input>;
  id?: InputMaybe<Scalars['BigInt']>;
  isKeyIngredient?: InputMaybe<Scalars['Boolean']>;
  quantityHigh?: InputMaybe<Scalars['Float']>;
  quantityLow?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipeItem = {
  __typename?: 'instacart_customers_recipes_v1_ListRecipeItem';
  banner: Maybe<Instacart_Customers_Recipes_V1_RecipeBanner>;
  categories: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeCategory>>>;
  createdAt: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  images: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeImage>>>;
  name: Maybe<Scalars['String']>;
  parsed: Maybe<Scalars['Boolean']>;
  status: Maybe<Instacart_Customers_Recipes_V1_RecipeStatus>;
  updatedAt: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesFilters_Input = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parsed?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_RecipeStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesPagination_Input = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesRequest_Input = {
  filters?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesFilters_Input>;
  pagination?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesPagination_Input>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sorting?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesSorting_Input>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_ListRecipesResponse';
  recipes: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_ListRecipeItem>>>;
  totalCount: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesSorting_Input = {
  orderBy?: InputMaybe<Instacart_Customers_Recipes_V1_SortOrderBy>;
  orderDirection?: InputMaybe<Instacart_Customers_Recipes_V1_SortDirection>;
};

export type Instacart_Customers_Recipes_V1_Recipe = {
  __typename?: 'instacart_customers_recipes_v1_Recipe';
  activeTimeMinutes: Maybe<Scalars['BigInt']>;
  adminVisible: Maybe<Scalars['Boolean']>;
  banner: Maybe<Instacart_Customers_Recipes_V1_RecipeBanner>;
  categories: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeCategory>>>;
  description: Maybe<Scalars['String']>;
  history: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  images: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeImage>>>;
  ingredientGroups: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_IngredientGroup>>>;
  instructions: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeInstruction>>>;
  metaDescription: Maybe<Scalars['String']>;
  metaTitle: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  prepTimeMinutes: Maybe<Scalars['BigInt']>;
  private: Maybe<Scalars['Boolean']>;
  proTip: Maybe<Scalars['String']>;
  /** New fields for GetRecipeById API */
  providerRecipeId: Maybe<Scalars['String']>;
  recipeSourceName: Maybe<Scalars['String']>;
  recipeSummary: Maybe<Scalars['String']>;
  recommendations: Maybe<Scalars['String']>;
  seoApproved: Maybe<Scalars['Boolean']>;
  servingsHigh: Maybe<Scalars['BigInt']>;
  servingsLow: Maybe<Scalars['BigInt']>;
  sourceKeyword: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Customers_Recipes_V1_RecipeStatus>;
  totalTimeMinutes: Maybe<Scalars['BigInt']>;
  visible: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Recipes_V1_RecipeBanner = {
  __typename?: 'instacart_customers_recipes_v1_RecipeBanner';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_RecipeCategory = {
  __typename?: 'instacart_customers_recipes_v1_RecipeCategory';
  displayName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_RecipeImage = {
  __typename?: 'instacart_customers_recipes_v1_RecipeImage';
  height: Maybe<Scalars['Int']>;
  size: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  width: Maybe<Scalars['Int']>;
};

/** A single step in the recipe instructions */
export type Instacart_Customers_Recipes_V1_RecipeInstruction = {
  __typename?: 'instacart_customers_recipes_v1_RecipeInstruction';
  description: Maybe<Scalars['String']>;
  stepNumber: Maybe<Scalars['BigInt']>;
};

/** Recipe publication status */
export enum Instacart_Customers_Recipes_V1_RecipeStatus {
  RecipeStatusArchived = 'RECIPE_STATUS_ARCHIVED',
  RecipeStatusDraft = 'RECIPE_STATUS_DRAFT',
  RecipeStatusPublished = 'RECIPE_STATUS_PUBLISHED',
  RecipeStatusUnspecified = 'RECIPE_STATUS_UNSPECIFIED'
}

export type Instacart_Customers_Recipes_V1_RecipeUpdateResult = {
  __typename?: 'instacart_customers_recipes_v1_RecipeUpdateResult';
  errorMessage: Maybe<Scalars['String']>;
  recipeId: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

/**
 * Please keep the RecipeUpdate message a subset of the Recipe message
 * The idea is you should be able to mutate the Recipe message and send it back
 * as a RecipeUpdate message
 */
export type Instacart_Customers_Recipes_V1_RecipeUpdate_Input = {
  adminVisible?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ingredientGroups?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_IngredientGroupUpdate_Input>>>;
  name?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export enum Instacart_Customers_Recipes_V1_SortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

export enum Instacart_Customers_Recipes_V1_SortOrderBy {
  SortOrderByCreatedAt = 'SORT_ORDER_BY_CREATED_AT',
  SortOrderByUnspecified = 'SORT_ORDER_BY_UNSPECIFIED',
  SortOrderByUpdatedAt = 'SORT_ORDER_BY_UPDATED_AT'
}

export type Instacart_Customers_Recipes_V1_UpdateRecipesRequest_Input = {
  recipes?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_RecipeUpdate_Input>>>;
};

export type Instacart_Customers_Recipes_V1_UpdateRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_UpdateRecipesResponse';
  recipes: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Recipe>>>;
};

export type Instacart_Customers_Recipes_V1_UploadError = {
  __typename?: 'instacart_customers_recipes_v1_UploadError';
  errorCode: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_UploadSuccess = {
  __typename?: 'instacart_customers_recipes_v1_UploadSuccess';
  message: Maybe<Scalars['String']>;
  recipeCount: Maybe<Scalars['Int']>;
  uploadId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_UploadValidationError = {
  __typename?: 'instacart_customers_recipes_v1_UploadValidationError';
  message: Maybe<Scalars['String']>;
  validationErrors: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesRequest_Input = {
  autoPublish?: InputMaybe<Scalars['Boolean']>;
  recipesData?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_ValidateAndUploadRecipesResponse';
  success: Maybe<Instacart_Customers_Recipes_V1_UploadSuccess>;
  uploadError: Maybe<Instacart_Customers_Recipes_V1_UploadError>;
  validationError: Maybe<Instacart_Customers_Recipes_V1_UploadValidationError>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_BulkEditResult = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_BulkEditResult';
  skippedFlyers: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerInfo>>>;
  updatedFlyers: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerInfo>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusRequest_Input = {
  jobId?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CheckBulkEditStatusResponse';
  result: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_BulkEditResult>;
  status: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Collection = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Collection';
  archivedAt: Maybe<Scalars['DateTime']>;
  collectionType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  defaultSortOrder: Maybe<Scalars['String']>;
  dynamicallyFedStatic: Maybe<Scalars['Boolean']>;
  endDate: Maybe<Scalars['DateTime']>;
  filters: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter>>>;
  id: Maybe<Scalars['BigInt']>;
  includedRetailerTypes: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList>;
  internalName: Maybe<Scalars['String']>;
  inventoryFileMappings: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_InventoryFileMapping>>>;
  isGlobalTemplatePublished: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  partnerMapping: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_PartnerMapping>;
  productCount: Maybe<Scalars['BigInt']>;
  productIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailerId: Maybe<Scalars['BigInt']>;
  scopeType: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
  sourceCollectionId: Maybe<Scalars['BigInt']>;
  startDate: Maybe<Scalars['DateTime']>;
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
  translations: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_CollectionStatus {
  Active = 'ACTIVE',
  ActiveAdminOnly = 'ACTIVE_ADMIN_ONLY',
  EnumTypeStatusUnspecified = 'ENUM_TYPE_STATUS_UNSPECIFIED',
  Inactive = 'INACTIVE'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CollectionTranslation';
  localeCode: Maybe<Instacart_Customers_Shared_V1_Locale>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input = {
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sourceFlyerId?: InputMaybe<Scalars['BigInt']>;
  sourceFlyerPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  targetFlyerId?: InputMaybe<Scalars['BigInt']>;
  targetFlyerPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  withFlyerActions?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CopyFlyerClickableAreasResponse';
  success: Maybe<Scalars['Boolean']>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionRequest_Input = {
  collectionType?: InputMaybe<Scalars['String']>;
  copyProductsExcludedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  copyProductsFromCollection?: InputMaybe<Scalars['BigInt']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  dynamicallyFedStatic?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  internalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productEvaluation?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  replicateMappingPartnerId?: InputMaybe<Scalars['BigInt']>;
  replicateToRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCollectionId?: InputMaybe<Scalars['BigInt']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateCollectionResponse';
  collection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  description?: InputMaybe<Scalars['String']>;
  extActivityId?: InputMaybe<Scalars['String']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  flyerRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  productCategories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateFlyerActivityResponse';
  flyerActivity: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaRequest_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  altText?: InputMaybe<Scalars['String']>;
  bulkEdit?: InputMaybe<Scalars['Boolean']>;
  dimensions?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension_Input>;
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  navigateToCollection?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection_Input>;
  navigateToFlyerPage?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage_Input>;
  navigateToRecipe?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe_Input>;
  navigateToUrl?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl_Input>;
  openFlyerActivity?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity_Input>;
  requiresReview?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateFlyerClickableAreaResponse';
  bulkEditJobId: Maybe<Scalars['String']>;
  flyerClickableArea: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionRequest_Input = {
  collectionType?: InputMaybe<Scalars['String']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  dynamicallyFedStatic?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  includedRetailerTypes?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input>;
  internalName?: InputMaybe<Scalars['String']>;
  isGlobalTemplatePublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  productEvaluation?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateGlobalCollectionResponse';
  collection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  collectionSlug?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateInvfMappingResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataRequest_Input = {
  endDate?: InputMaybe<Scalars['String']>;
  flyerTag?: InputMaybe<Scalars['String']>;
  metadataId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  previewNumDaysBefore?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduleId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  updateFrequency?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerUpdateFrequency>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateOrUpdateFlyerMetadataResponse';
  metadataId: Maybe<Scalars['BigInt']>;
  scheduleId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateRootNodeResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteCollectionResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteFlyerClickableAreasResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteGlobalCollectionResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteInvfMappingResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteNavigationNodeResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentRequest_Input = {
  destinationStoreConfigurations?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sourceDepartmentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DuplicateDepartmentResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Filter = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Filter';
  collectionId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  intersectionGroup: Maybe<Scalars['BigInt']>;
  ruleId: Maybe<Scalars['BigInt']>;
  value: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  intersectionGroup?: InputMaybe<Scalars['BigInt']>;
  ruleId?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Flyer = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Flyer';
  contentPageId: Maybe<Scalars['BigInt']>;
  fileIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  flyerPages: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPage>>>;
  flyerRetailerLocation: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerRetailerLocation>;
  id: Maybe<Scalars['BigInt']>;
  metadataId: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  tag: Maybe<Scalars['String']>;
  termsApproved: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerActivity';
  collectionId: Maybe<Scalars['BigInt']>;
  description: Maybe<Scalars['String']>;
  extActivityId: Maybe<Scalars['String']>;
  flyerPageId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  productCategories: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  title: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerAreaDimension';
  height: Maybe<Scalars['Float']>;
  heightPercent: Maybe<Scalars['Float']>;
  width: Maybe<Scalars['Float']>;
  widthPercent: Maybe<Scalars['Float']>;
  xCoord: Maybe<Scalars['Float']>;
  xPercent: Maybe<Scalars['Float']>;
  yCoord: Maybe<Scalars['Float']>;
  yPercent: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension_Input = {
  height?: InputMaybe<Scalars['Float']>;
  heightPercent?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
  widthPercent?: InputMaybe<Scalars['Float']>;
  xCoord?: InputMaybe<Scalars['Float']>;
  xPercent?: InputMaybe<Scalars['Float']>;
  yCoord?: InputMaybe<Scalars['Float']>;
  yPercent?: InputMaybe<Scalars['Float']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerClickableArea';
  active: Maybe<Scalars['Boolean']>;
  altText: Maybe<Scalars['String']>;
  dimensions: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension>;
  flyerPageId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  navigateToCollection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection>;
  navigateToFlyerPage: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage>;
  navigateToRecipe: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe>;
  navigateToUrl: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl>;
  openFlyerActivity: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity>;
  requiresReview: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileError = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerFileError';
  count: Maybe<Scalars['BigInt']>;
  message: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileErrorType>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileErrorType {
  ParseError = 'PARSE_ERROR',
  RecordError = 'RECORD_ERROR',
  RejectedMapError = 'REJECTED_MAP_ERROR',
  UnmappedLocationCodes = 'UNMAPPED_LOCATION_CODES'
}

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType {
  AssetsFile = 'ASSETS_FILE',
  DataFile = 'DATA_FILE',
  PdfFile = 'PDF_FILE',
  VersionFile = 'VERSION_FILE'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadDetails = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerFileUploadDetails';
  errors: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileError>>>;
  fileId: Maybe<Scalars['BigInt']>;
  filename: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadStatus>;
  type: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadStatus {
  LoadedIntoStream = 'LOADED_INTO_STREAM',
  Normalized = 'NORMALIZED',
  Unknown = 'UNKNOWN',
  UploadedToS3 = 'UPLOADED_TO_S3',
  UploadFailed = 'UPLOAD_FAILED'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerInfo = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerInfo';
  id: Maybe<Scalars['BigInt']>;
  versionCode: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerMetadata = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerMetadata';
  collectionId: Maybe<Scalars['BigInt']>;
  collectionSlug: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  scheduleId: Maybe<Scalars['BigInt']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  tag: Maybe<Scalars['String']>;
  updateFrequency: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerUpdateFrequency>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPage = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerPage';
  flyerId: Maybe<Scalars['BigInt']>;
  height: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  image: Maybe<Scalars['String']>;
  pageNumber: Maybe<Scalars['BigInt']>;
  sourcePdf: Maybe<Scalars['String']>;
  width: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerPresignedUrl';
  fileId: Maybe<Scalars['BigInt']>;
  filename: Maybe<Scalars['String']>;
  presignedUrl: Maybe<Scalars['String']>;
  submissionPath: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input = {
  fileId?: InputMaybe<Scalars['BigInt']>;
  filename?: InputMaybe<Scalars['String']>;
  presignedUrl?: InputMaybe<Scalars['String']>;
  submissionPath?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerRetailerLocation = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerRetailerLocation';
  endsAt: Maybe<Scalars['DateTime']>;
  flyerId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  previewsAt: Maybe<Scalars['DateTime']>;
  retailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  startsAt: Maybe<Scalars['DateTime']>;
  status: Maybe<Scalars['String']>;
  versionCode: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerStats = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerStats';
  flyerActivityCount: Maybe<Scalars['BigInt']>;
  flyerId: Maybe<Scalars['BigInt']>;
  flyerPageCount: Maybe<Scalars['BigInt']>;
  numAssignedFlyerClickableAreas: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  totalFlyerClickableAreas: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerUpdateFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Seasonal = 'SEASONAL',
  Weekly = 'WEEKLY'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsRequest_Input = {
  inputFilters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_InputFilter_Input>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetCollectionPreviewProductsResponse';
  productIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  includePublishedGlobalTemplateCollections?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetCollectionResponse';
  collection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesRequest_Input = {
  dynamicFeedEligible?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetCollectionRulesResponse';
  rules: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Rule>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerActivitiesResponse';
  flyerActivities: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerClickableAreasResponse';
  flyerClickableAreas: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerMetadataResponse';
  flyerMetadata: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerMetadata>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugRequest_Input = {
  /** Optional: debug a specific flyer from IPP list */
  flyerId?: InputMaybe<Scalars['BigInt']>;
  /** Whether to list S3 files (slower) */
  includeS3Files?: InputMaybe<Scalars['Boolean']>;
  /** FlyerMetadata ID (required if flyer_id not provided) */
  metadataId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: specific flyer date */
  startDate?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerPipelineDebugResponse';
  airflowDagName: Maybe<Scalars['String']>;
  /** Human-readable context for the debug state */
  debugContext: Maybe<Scalars['String']>;
  /** Upcoming flyer context (helps distinguish pending jobs vs actual issues) */
  expectedFlyerDate: Maybe<Scalars['String']>;
  failureSummary: Maybe<Scalars['String']>;
  flyerEndDate: Maybe<Scalars['String']>;
  /** Flyer info (when debugging a specific flyer) */
  flyerId: Maybe<Scalars['BigInt']>;
  flyerStartDate: Maybe<Scalars['String']>;
  flyerStatus: Maybe<Scalars['String']>;
  flyerTag: Maybe<Scalars['String']>;
  /** Health summary - helps differentiate API errors vs flyer issues */
  hasCriticalFailure: Maybe<Scalars['Boolean']>;
  /** Any stage WARNING */
  hasWarnings: Maybe<Scalars['Boolean']>;
  intermediateFiles: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_S3FolderContents>;
  /** True if expected_flyer_date is in the future */
  isUpcoming: Maybe<Scalars['Boolean']>;
  /** "healthy", "degraded", "critical" */
  overallHealth: Maybe<Scalars['String']>;
  /** e.g., "FlyerParser", "SaleDatesParser" */
  parserType: Maybe<Scalars['String']>;
  /** For S3 URL building */
  partnerFolder: Maybe<Scalars['String']>;
  /** S3 file listings (if requested) */
  partnersFiles: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_S3FolderContents>;
  /** Metadata for frontend to build URLs and display */
  retailerName: Maybe<Scalars['String']>;
  scheduleInfo: Maybe<Scalars['String']>;
  /** DAG stages (14 nodes) */
  stages: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStage>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsRequest_Input = {
  metadataId?: InputMaybe<Scalars['BigInt']>;
  presignedUrls?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerPresignedUrlsResponse';
  presignedUrls: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerResponse';
  flyer: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Flyer>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsRequest_Input = {
  flyerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerStatsResponse';
  flyerCount: Maybe<Scalars['BigInt']>;
  flyerStats: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerStats>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerTagsResponse';
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsRequest_Input = {
  metadataId?: InputMaybe<Scalars['BigInt']>;
  presignedUrls?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerUploadDetailsResponse';
  fileUploadDetails: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadDetails>>>;
  flyerCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsRequest_Input = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetLowerPriceDefinitionsResponse';
  definitions: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetNavigationTreeResponse';
  navigationConfiguration: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration>;
  nodes: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetRetailerCsvResponse';
  filePath: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_InputFilter_Input = {
  intersectionGroup?: InputMaybe<Scalars['BigInt']>;
  ruleId?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_InventoryFileMapping = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_InventoryFileMapping';
  collectionSlug: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  retailerCollectionId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListCollectionProductsResponse';
  products: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsRequest_Input = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  collectionStatus?: InputMaybe<Scalars['String']>;
  excludedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  globalTemplateCollectionsOnly?: InputMaybe<Scalars['Boolean']>;
  includePublishedGlobalTemplateCollections?: InputMaybe<Scalars['Boolean']>;
  includedArchivedCollections?: InputMaybe<Scalars['Boolean']>;
  includedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  productIdLimit?: InputMaybe<Scalars['BigInt']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withoutAdminCollections?: InputMaybe<Scalars['Boolean']>;
  withoutNavigationCollections?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListCollectionsResponse';
  collections: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_Input = {
  filter?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_OptionalFilter_Input>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_OptionalFilter_Input = {
  endsAt?: InputMaybe<Scalars['DateTime']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListFlyersResponse';
  flyers: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Flyer>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsRequest_Input = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  collectionStatus?: InputMaybe<Scalars['String']>;
  excludedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  globalTemplateCollectionsOnly?: InputMaybe<Scalars['Boolean']>;
  includePublishedGlobalTemplateCollections?: InputMaybe<Scalars['Boolean']>;
  includedArchivedCollections?: InputMaybe<Scalars['Boolean']>;
  includedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListGlobalCollectionsResponse';
  collections: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListRetailerDepartmentsResponse';
  departments: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_LowerPriceDefinition';
  active: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  lookbackPeriodDays: Maybe<Scalars['Int']>;
  priceType: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition_PriceType>;
  requiredDropPct: Maybe<Scalars['Float']>;
  retailerId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition_PriceType {
  Average = 'AVERAGE',
  PriceTypeUnspecified = 'PRICE_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToCollection';
  collectionSlug: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection_Input = {
  collectionSlug?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToFlyerPage';
  flyerPageId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage_Input = {
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToRecipe';
  recipeId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe_Input = {
  recipeId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToUrl';
  url: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl_Input = {
  url?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigationConfiguration';
  additionalStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  alwaysPinned: Maybe<Scalars['Boolean']>;
  inventoryCountDisabled: Maybe<Scalars['Boolean']>;
  isSyncedFromSource: Maybe<Scalars['Boolean']>;
  maxTopLevelNodes: Maybe<Scalars['BigInt']>;
  sourceDomain: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration_Input = {
  additionalStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  alwaysPinned?: InputMaybe<Scalars['Boolean']>;
  inventoryCountDisabled?: InputMaybe<Scalars['Boolean']>;
  isSyncedFromSource?: InputMaybe<Scalars['Boolean']>;
  maxTopLevelNodes?: InputMaybe<Scalars['BigInt']>;
  sourceDomain?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigationNode';
  alcoholic: Maybe<Scalars['Boolean']>;
  alwaysShow: Maybe<Scalars['Boolean']>;
  children: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode>>>;
  contentType: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode_ContentType>;
  endDate: Maybe<Scalars['DateTime']>;
  externallyManaged: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  isDynamic: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  pinned: Maybe<Scalars['Boolean']>;
  position: Maybe<Scalars['BigInt']>;
  productCount: Maybe<Scalars['BigInt']>;
  retailerCollectionId: Maybe<Scalars['BigInt']>;
  retailerId: Maybe<Scalars['BigInt']>;
  slug: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['DateTime']>;
  status: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionStatus>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  tileImageUrl: Maybe<Scalars['String']>;
  translations: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Translation>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode_ContentType {
  Collections = 'COLLECTIONS',
  Products = 'PRODUCTS',
  Root = 'ROOT',
  Unspecified = 'UNSPECIFIED'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_OpenFlyerActivity';
  flyerActivityId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity_Input = {
  flyerActivityId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesRequest_Input = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_OrderNavigationNodesResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_PartnerMapping = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_PartnerMapping';
  collectionSlug: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  partnerId: Maybe<Scalars['BigInt']>;
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStage = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_PipelineStage';
  /** stage_ids this depends on */
  dependsOn: Maybe<Array<Maybe<Scalars['String']>>>;
  /** deprecated: use label instead */
  displayName: Maybe<Scalars['String']>;
  /** e.g., "File Upload", "Parse & Normalize" */
  label: Maybe<Scalars['String']>;
  lastUpdated: Maybe<Scalars['DateTime']>;
  /** 1=data, 2=asset, 3=validation */
  row: Maybe<Scalars['Int']>;
  /** e.g., "sftp_upload", "parser_execution" */
  stageId: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStageStatus>;
  /** e.g., "8 files", "FAILED - Timeout" */
  statusDetail: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStageStatus {
  PipelineStageStatusBlocked = 'PIPELINE_STAGE_STATUS_BLOCKED',
  PipelineStageStatusComplete = 'PIPELINE_STAGE_STATUS_COMPLETE',
  PipelineStageStatusFailed = 'PIPELINE_STAGE_STATUS_FAILED',
  PipelineStageStatusQueued = 'PIPELINE_STAGE_STATUS_QUEUED',
  PipelineStageStatusRunning = 'PIPELINE_STAGE_STATUS_RUNNING',
  /** Stage not applicable for this retailer's data source */
  PipelineStageStatusSkipped = 'PIPELINE_STAGE_STATUS_SKIPPED',
  PipelineStageStatusUnspecified = 'PIPELINE_STAGE_STATUS_UNSPECIFIED',
  PipelineStageStatusWarning = 'PIPELINE_STAGE_STATUS_WARNING'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadRequest_Input = {
  metadataId?: InputMaybe<Scalars['BigInt']>;
  presignedUrls?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ProcessFlyerIngestionFileUploadResponse';
  presignedUrls: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Product = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Product';
  cachedProductId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  lookupCode: Maybe<Scalars['String']>;
  pinned: Maybe<Scalars['Boolean']>;
  position: Maybe<Scalars['BigInt']>;
  retailerReferenceCode: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ProductCategories_Input = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input = {
  cachedProductId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lookupCode?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['BigInt']>;
  retailerReferenceCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_QueueNavigationMigrationResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Rule = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Rule';
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  valueSource: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSource>;
  valueType: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSource = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_RuleValueSource';
  options: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSourceOption>>>;
  query: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSourceOption = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_RuleValueSourceOption';
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_S3File = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_S3File';
  /** "queued", "archived", "failed", "pdfs" */
  folder: Maybe<Scalars['String']>;
  key: Maybe<Scalars['String']>;
  lastModified: Maybe<Scalars['DateTime']>;
  sizeBytes: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_S3FolderContents = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_S3FolderContents';
  files: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_S3File>>>;
  folderPath: Maybe<Scalars['String']>;
  totalCount: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_SearchCollectionProductsResponse';
  products: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_StringList = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_StringList';
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Translation = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Translation';
  localeCode: Maybe<Instacart_Customers_Shared_V1_Locale>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Translation_Input = {
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncRequest_Input = {
  csvFileIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  metadataId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduleId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['String']>;
  syncFlyerAssets?: InputMaybe<Scalars['Boolean']>;
  syncFlyerData?: InputMaybe<Scalars['Boolean']>;
  syncFlyerDigital?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_TriggerFlyerSyncResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  productsToAdd?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  productsToDelete?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateCollectionProductsResponse';
  collection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionRequest_Input = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  collectionType?: InputMaybe<Scalars['String']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  id?: InputMaybe<Scalars['BigInt']>;
  internalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productsToAdd?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  productsToDelete?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  replicateMappingPartnerId?: InputMaybe<Scalars['BigInt']>;
  replicateToRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  resetAllProducts?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateCollectionResponse';
  collection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityRequest_Input = {
  collectionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  extActivityId?: InputMaybe<Scalars['String']>;
  flyerPageId?: InputMaybe<Scalars['String']>;
  flyerRetailerLocationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  productCategories?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ProductCategories_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFlyerActivityResponse';
  flyerActivity: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaRequest_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  altText?: InputMaybe<Scalars['String']>;
  bulkEdit?: InputMaybe<Scalars['Boolean']>;
  dimensions?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension_Input>;
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  navigateToCollection?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection_Input>;
  navigateToFlyerPage?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage_Input>;
  navigateToRecipe?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe_Input>;
  navigateToUrl?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl_Input>;
  openFlyerActivity?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity_Input>;
  requiresReview?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFlyerClickableAreaResponse';
  bulkEditJobId: Maybe<Scalars['String']>;
  flyerClickableArea: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersRequest_Input = {
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  /** DEPRECATED, this had the wrong type. Use terms_approved_v2 instead */
  termsApproved?: InputMaybe<Scalars['Boolean']>;
  termsApprovedV2?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFlyersResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionRequest_Input = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  collectionType?: InputMaybe<Scalars['String']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  id?: InputMaybe<Scalars['BigInt']>;
  includedRetailerTypes?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input>;
  internalName?: InputMaybe<Scalars['String']>;
  isGlobalTemplatePublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateGlobalCollectionResponse';
  collection: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationRequest_Input = {
  navigationConfiguration?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateNavigationConfigurationResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeRequest_Input = {
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  alwaysShow?: InputMaybe<Scalars['Boolean']>;
  contentType?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode_ContentType>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['BigInt']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['BigInt']>;
  retailerCollectionId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionStatus>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  tileImageUrl?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Translation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpsertNavigationNodeResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugRequest_Input = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ValidateCollectionSlugResponse';
  valid: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** namespace entity id of the draft */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** status of the draft */
  status?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_IppDraftStatus>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_orchestrator_v1_DeleteIppDraftResponse';
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

/** Represent reasons for failure */
export enum Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason {
  /** Request context or payload incomplete or invalid */
  ErrorReasonBadRequest = 'ERROR_REASON_BAD_REQUEST',
  /** Unknown error */
  ErrorUnknown = 'ERROR_UNKNOWN',
  /** No error */
  NoError = 'NO_ERROR'
}

export enum Instacart_Customers_Retailer_Management_Orchestrator_V1_IppDraftStatus {
  Deleted = 'DELETED',
  DeleteError = 'DELETE_ERROR',
  Published = 'PUBLISHED',
  PublishError = 'PUBLISH_ERROR',
  Working = 'WORKING'
}

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** namespace entity id of the draft */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** status of the draft */
  status?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_IppDraftStatus>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_orchestrator_v1_PublishIppDraftResponse';
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_orchestrator_v1_RevertIppDraftResponse';
  /** the draft id of the reverted draft that was created */
  draftId: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

/** ClientConfiguration response message */
export type Instacart_Customers_Retailer_Management_V1_ClientConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_ClientConfigurationResponse';
  /** Comma-separated origins */
  allowedOrigins: Maybe<Scalars['String']>;
  applicationType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  idpSpoofValue: Maybe<Scalars['BigInt']>;
  idpTier: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  oauthApplicationId: Maybe<Scalars['BigInt']>;
  slug: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewRequest_Input = {
  /** draft id to create the preview from */
  draftId?: InputMaybe<Scalars['String']>;
  /** redirect url */
  redirectUrl?: InputMaybe<Scalars['String']>;
  /** retailer id */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_CreateIppDraftPreviewResponse';
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
  /** auth token for the preview */
  previewAuthToken: Maybe<Scalars['String']>;
  /** password for the preview */
  previewPassword: Maybe<Scalars['String']>;
  /** url of the preview */
  previewUrl: Maybe<Scalars['String']>;
  /** redirect url */
  redirectUrl: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftRequest_Input = {
  /** optional a list of draft content that represents the draft */
  contents?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input>>>;
  /** list of draft components associated with the draft. */
  draftIds?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftComponent_Input>>>;
  /** the name of the draft */
  name?: InputMaybe<Scalars['String']>;
  /** a short description of a draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** the ID of the entity being drafted */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** partion of the draft (i.e. store_configuration, warehouse, contentpage, etc.) */
  partition?: InputMaybe<Scalars['String']>;
  /** associated partition id */
  partitionId?: InputMaybe<Scalars['BigInt']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_CreateIppDraftResponse';
  /** the draft id that was created */
  draftId: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_DeleteIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** the ID of the entity being drafted */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_DeleteIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_DeleteIppDraftResponse';
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

/** Request to enable CMS site widgets */
export type Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsRequest_Input = {
  /** Required: Partner ID */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Required: Store configuration ID */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for enable CMS site widgets */
export type Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_EnableCmsSiteWidgetsResponse';
  /** Whether client configuration was newly created */
  clientConfigurationCreated: Maybe<Scalars['Boolean']>;
  /** Client configuration ID (created or existing) */
  clientConfigurationId: Maybe<Scalars['BigInt']>;
  /** Created at timestamp */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Whether OAuth application was newly created */
  oauthApplicationCreated: Maybe<Scalars['Boolean']>;
  /** OAuth application ID (always newly created) */
  oauthApplicationId: Maybe<Scalars['BigInt']>;
  /** Partner name from client configuration */
  partnerName: Maybe<Scalars['String']>;
  /** Store configuration ID */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  /** Updated at timestamp */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Represent reasons for failure */
export enum Instacart_Customers_Retailer_Management_V1_ErrorReason {
  /** Request context or payload incomplete or invalid */
  ErrorReasonBadRequest = 'ERROR_REASON_BAD_REQUEST',
  /** Request is unauthorized */
  ErrorReasonUnauthorized = 'ERROR_REASON_UNAUTHORIZED',
  /** Unknown error */
  ErrorUnknown = 'ERROR_UNKNOWN',
  /** No error */
  NoError = 'NO_ERROR'
}

export type Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdRequest_Input = {
  /** the draft id to retrieve */
  draftId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetIppDraftByIdResponse';
  /** the draft based on the id */
  draft: Maybe<Instacart_Customers_Retailer_Management_V1_IppDraft>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenRequest_Input = {
  /** encoded preview auth token to get preview */
  authToken?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetIppPreviewByAuthTokenResponse';
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  /** draft associated with preview */
  ippDraft: Maybe<Instacart_Customers_Retailer_Management_V1_IppDraft>;
  /** preview object */
  ippPreview: Maybe<Instacart_Customers_Retailer_Management_V1_IppPreview>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenRequest_Input = {
  /** passcode for preview */
  passcode?: InputMaybe<Scalars['String']>;
  /** preview_token for request */
  previewToken?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetPreviewAuthTokenResponse';
  /** auth_token */
  authToken: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

/** Get widget configuration request */
export type Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationRequest_Input = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetWidgetConfigurationResponse';
  clientConfiguration: Maybe<Instacart_Customers_Retailer_Management_V1_ClientConfigurationResponse>;
  exists: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraft = {
  __typename?: 'instacart_customers_retailer_management_v1_IppDraft';
  /** date of creation */
  createdAt: Maybe<Scalars['DateTime']>;
  /** IPP user id of the user who created the draft */
  createdBy: Maybe<Scalars['String']>;
  /** draft id that this draft was created from (for revert purposes) */
  createdFrom: Maybe<Scalars['String']>;
  /** date of deletion */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** IPP user id that deleted the draft */
  deletedBy: Maybe<Scalars['String']>;
  /** draft id */
  draftId: Maybe<Scalars['String']>;
  /** list of draft components associated with the draft. */
  ippDraftComponents: Maybe<Array<Maybe<Instacart_Customers_Retailer_Management_V1_IppDraftComponent>>>;
  /** name of the draft */
  name: Maybe<Scalars['String']>;
  /** namespace of the draft */
  namespace: Maybe<Scalars['String']>;
  /** partion of the draft (i.e. store_configuration, warehouse, contentpage, etc.) */
  partition: Maybe<Scalars['String']>;
  /** associated partition id */
  partitionId: Maybe<Scalars['BigInt']>;
  /** date of publish */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** IPP user id that published the draft */
  publishedBy: Maybe<Scalars['String']>;
  /** date last updated */
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftComponent = {
  __typename?: 'instacart_customers_retailer_management_v1_IppDraftComponent';
  /** the domain's configuration draft id */
  configurationDraftId: Maybe<Scalars['String']>;
  /** the draft blob */
  content: Maybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent>;
  /** the domain associated with the draft */
  domain: Maybe<Scalars['String']>;
  /** the associated draft id */
  draftId: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftComponent_Input = {
  /** the domain's configuration draft id */
  configurationDraftId?: InputMaybe<Scalars['String']>;
  /** the draft blob */
  content?: InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input>;
  /** the domain associated with the draft */
  domain?: InputMaybe<Scalars['String']>;
  /** the associated draft id */
  draftId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftContent = {
  __typename?: 'instacart_customers_retailer_management_v1_IppDraftContent';
  /** the json blob representation of the draft */
  content: Maybe<Scalars['String']>;
  /** content id */
  contentId: Maybe<Scalars['BigInt']>;
  /** the type of draft content */
  contentType: Maybe<Scalars['String']>;
  /** the version of the draft content */
  version: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input = {
  /** the json blob representation of the draft */
  content?: InputMaybe<Scalars['String']>;
  /** content id */
  contentId?: InputMaybe<Scalars['BigInt']>;
  /** the type of draft content */
  contentType?: InputMaybe<Scalars['String']>;
  /** the version of the draft content */
  version?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Retailer_Management_V1_IppDraftStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Working = 'WORKING'
}

export type Instacart_Customers_Retailer_Management_V1_IppPreview = {
  __typename?: 'instacart_customers_retailer_management_v1_IppPreview';
  /** draft id associated with preview */
  draftId: Maybe<Scalars['String']>;
  /** passcode for the preview */
  passcode: Maybe<Scalars['String']>;
  /** token associated with preview */
  previewToken: Maybe<Scalars['String']>;
  /** url of the preview */
  previewUrl: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Retailer_Management_V1_ListIppDraftsColumns {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  PublishedAt = 'PUBLISHED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsFilterBy_Input = {
  /** author id of the draft */
  authorId?: InputMaybe<Scalars['String']>;
  /** created end date of the draft */
  createdEndDate?: InputMaybe<Scalars['DateTime']>;
  /** created start date of the draft */
  createdStartDate?: InputMaybe<Scalars['DateTime']>;
  /** deleted end date of the draft */
  deletedEndDate?: InputMaybe<Scalars['DateTime']>;
  /** deleted start date of the draft */
  deletedStartDate?: InputMaybe<Scalars['DateTime']>;
  /** id of the draft */
  draftId?: InputMaybe<Scalars['String']>;
  /** namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** the ID of the entity being drafted */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** partition of the draft */
  partition?: InputMaybe<Scalars['String']>;
  /** id of the partition */
  partitionId?: InputMaybe<Scalars['BigInt']>;
  /** published end date of the draft */
  publishedEndDate?: InputMaybe<Scalars['DateTime']>;
  /** published start date of the draft */
  publishedStartDate?: InputMaybe<Scalars['DateTime']>;
  /** query for searching drafts by name */
  query?: InputMaybe<Scalars['String']>;
  /** status of the draft */
  status?: InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftStatus>;
};

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsOrderBy_Input = {
  column?: InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsColumns>;
  direction?: InputMaybe<Instacart_Customers_Retailer_Management_V1_OrderByDirection>;
};

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsRequest_Input = {
  /** filters for the draft list */
  filterBy?: InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsFilterBy_Input>;
  /** order drafts list by certain criteria */
  orderBy?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsOrderBy_Input>>>;
  /** pagination info */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_ListIppDraftsResponse';
  /** list of drafts */
  drafts: Maybe<Array<Maybe<Instacart_Customers_Retailer_Management_V1_IppDraft>>>;
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
  /** page info for pagination */
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  /** drafts total count */
  totalCount: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Retailer_Management_V1_OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Instacart_Customers_Retailer_Management_V1_PublishIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_PublishIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_PublishIppDraftResponse';
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_RevertIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_RevertIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_RevertIppDraftResponse';
  /** the draft id of the reverted draft that was created */
  draftId: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful: Maybe<Scalars['Boolean']>;
};

/** Request to update client configuration */
export type Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationRequest_Input = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  settings?: InputMaybe<Scalars['JSON']>;
};

/** Response for update client configuration */
export type Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_UpdateClientConfigurationResponse';
  clientConfiguration: Maybe<Instacart_Customers_Retailer_Management_V1_ClientConfigurationResponse>;
  errorMessage: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentRequest_Input = {
  /** a list of draft content that represents the draft */
  contents?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input>>>;
  /** the draft id to update */
  draftId?: InputMaybe<Scalars['String']>;
  /** the name of the draft */
  draftName?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_UpdateIppDraftContentResponse';
  isSuccessful: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Search_Results_V2_GetProductEsciLabelRequest_Input = {
  /** product ids */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** query */
  query?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Search_Results_V2_GetProductEsciLabelResponse = {
  __typename?: 'instacart_customers_search_results_v2_GetProductEsciLabelResponse';
  productLabels: Maybe<Array<Maybe<Instacart_Customers_Search_Results_V2_ProductEsciLabel>>>;
};

export type Instacart_Customers_Search_Results_V2_ProductEsciLabel = {
  __typename?: 'instacart_customers_search_results_v2_ProductEsciLabel';
  /** product label */
  esciLabel: Maybe<Instacart_Customers_Search_V1_ItemClassifierLabel>;
  /** product_id */
  productId: Maybe<Scalars['BigInt']>;
  /** confidence score */
  score: Maybe<Scalars['Float']>;
};

export enum Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesFailureReason {
  /** Conflicts with existing rules */
  ConflictWithExistingRule = 'CONFLICT_WITH_EXISTING_RULE',
  /** No error or unspecified */
  FailureReasonUnspecified = 'FAILURE_REASON_UNSPECIFIED',
  /** Unexpected server error */
  InternalError = 'INTERNAL_ERROR',
  /** Invalid request parameters */
  InvalidParameters = 'INVALID_PARAMETERS'
}

export type Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesParameters_Input = {
  /** Optional: aisle id blacklist for term */
  aisleIdBlacklist?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: autocorrection override for term */
  autocorrectionOverride?: InputMaybe<Scalars['String']>;
  /** Optional: boost type */
  boostType?: InputMaybe<Scalars['String']>;
  /** Optional: category id boosting for term */
  boostedCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: product id boosting for term */
  boostedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: category id blacklist for term */
  categoryIdBlacklist?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: disable autocorrection for term */
  disableAutocorrection?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable EBR for term */
  disableEmbeddingRecall?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable expansion for term */
  disableExpansion?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable reformulation for term */
  disableReformulation?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable sections for term */
  disableSearchSections?: InputMaybe<Scalars['Boolean']>;
  /** Optional: expansion override for term */
  expansionOverride?: InputMaybe<Scalars['String']>;
  /** Optional： expire time */
  expireAt?: InputMaybe<Scalars['DateTime']>;
  /** Optional: id for override scope, useful when update existing overrides */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Optional: oauth_application_id for override scope */
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: override reason for term */
  overrideReason?: InputMaybe<Scalars['String']>;
  /** Optional: reformulation override for term */
  reformulationOverride?: InputMaybe<Scalars['String']>;
  /** Optional: section product ids for term */
  relatedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: section product labels (ESCI) for term */
  relatedProductLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: section product labels for term */
  relatedProductSections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: brand first smart refinements for term */
  smartRefinementsBrandFirst?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable smart refinements for term */
  smartRefinementsDisable?: InputMaybe<Scalars['Boolean']>;
  /** Optional: exclude smart refinements for term */
  smartRefinementsExclude?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: include smart refinements for term */
  smartRefinementsInclude?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: store_configuration_id for override scope */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** term: the target query term */
  term?: InputMaybe<Scalars['String']>;
  /** Optional: updated by for term */
  updatedBy?: InputMaybe<Scalars['BigInt']>;
  /** Optional: warehouse_id for override scope */
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesRequest_Input = {
  /** parameters: CreateOrUpdateSearchTermOverridesParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesResponse = {
  __typename?: 'instacart_customers_search_v1_CreateOrUpdateSearchTermOverridesResponse';
  /** failure reason */
  failureReason: Maybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesFailureReason>;
  /** present the overrides that has been successfully updated */
  overrides: Maybe<Instacart_Customers_Search_V1_SearchTermOverrides>;
  /** indicate success or failure */
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdParameters_Input = {
  /** id: the target override id */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Optional: updated by user_id */
  updatedBy?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdRequest_Input = {
  /** parameters: DeleteSearchTermOverridesByIdParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesByIdParameters_Input = {
  /** id: the target override id */
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesByIdRequest_Input = {
  /** parameters: GetSearchTermOverridesByIdParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesByIdParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesByIdResponse = {
  __typename?: 'instacart_customers_search_v1_GetSearchTermOverridesByIdResponse';
  /** present the overrides that has been successfully updated */
  overrides: Maybe<Instacart_Customers_Search_V1_SearchTermOverrides>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesParameters_Input = {
  /** limit: the max amount of overrides could be returned by request */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** offset:for pagination */
  offset?: InputMaybe<Scalars['BigInt']>;
  /** Optional: retailer_id for filtering overrides */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional: list of retailer_ids for batch fetching across multiple retailers.
   * When non-empty, takes precedence over singular retailer_id.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: store_configuration_id for filtering overrides */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesRequest_Input = {
  /** parameters: GetSearchTermOverridesParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional: list of retailer_ids for batch fetching across multiple retailers.
   * When non-empty, takes precedence over singular retailer_id.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesResponse = {
  __typename?: 'instacart_customers_search_v1_GetSearchTermOverridesResponse';
  data: Maybe<Array<Maybe<Instacart_Customers_Search_V1_SearchTermOverrides>>>;
};

export enum Instacart_Customers_Search_V1_ItemClassifierLabel {
  Complementary = 'COMPLEMENTARY',
  Exact = 'EXACT',
  None = 'NONE',
  Related = 'RELATED',
  Substitute = 'SUBSTITUTE'
}

export type Instacart_Customers_Search_V1_SearchTermOverrides = {
  __typename?: 'instacart_customers_search_v1_SearchTermOverrides';
  /** Optional: aisle id blacklist for term */
  aisleIdBlacklist: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: autocorrection override for term */
  autocorrectionOverride: Maybe<Scalars['String']>;
  /** Optional: boost type */
  boostType: Maybe<Scalars['String']>;
  /** Optional: category id boosting for term */
  boostedCategoryIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: product id boosting for term */
  boostedProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: category id blacklist for term */
  categoryIdBlacklist: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: created at for term */
  createdAt: Maybe<Scalars['String']>;
  /** Optional: disable autocorrection for term */
  disableAutocorrection: Maybe<Scalars['Boolean']>;
  /** Optional: disable EBR for term */
  disableEmbeddingRecall: Maybe<Scalars['Boolean']>;
  /** Optional: disable expansion for term */
  disableExpansion: Maybe<Scalars['Boolean']>;
  /** Optional: disable reformulation for term */
  disableReformulation: Maybe<Scalars['Boolean']>;
  /** Optional: disable sections for term */
  disableSearchSections: Maybe<Scalars['Boolean']>;
  /** Optional: expansion override for term */
  expansionOverride: Maybe<Scalars['String']>;
  /** Optional： expire time */
  expireAt: Maybe<Scalars['DateTime']>;
  /** id: identifier for a search term overrides record */
  id: Maybe<Scalars['BigInt']>;
  /** Optional: oauth_application_id for override scope */
  oauthApplicationId: Maybe<Scalars['BigInt']>;
  /** Optional: override reason for term */
  overrideReason: Maybe<Scalars['String']>;
  /** Optional: reformulation override for term */
  reformulationOverride: Maybe<Scalars['String']>;
  /** Optional: section product ids for term */
  relatedProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: section product labels (ESCI) for term */
  relatedProductLabels: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: section product labels for term */
  relatedProductSections: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: brand first smart refinements for term */
  smartRefinementsBrandFirst: Maybe<Scalars['Boolean']>;
  /** Optional: disable smart refinements for term */
  smartRefinementsDisable: Maybe<Scalars['Boolean']>;
  /** Optional: exclude smart refinements for term */
  smartRefinementsExclude: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: include smart refinements for term */
  smartRefinementsInclude: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: store_configuration_id for override scope */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  /** term: the target query term */
  term: Maybe<Scalars['String']>;
  /** Optional: updated at for term */
  updatedAt: Maybe<Scalars['String']>;
  /** Optional: updated by for term */
  updatedBy: Maybe<Scalars['BigInt']>;
  /** Optional: warehouse_id for override scope */
  warehouseId: Maybe<Scalars['BigInt']>;
};

/** The model of Fulfillment we've promised to the customer. Formerly known as delivery_type. */
export enum Instacart_Customers_Shared_V1_FulfillmentTypeWrapper_FulfillmentType {
  AffordableDelivery = 'AFFORDABLE_DELIVERY',
  Asap = 'ASAP',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  Eta = 'ETA',
  FiveHour = 'FIVE_HOUR',
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  HyperFast = 'HYPER_FAST',
  InstoreOrderAheadAsap = 'INSTORE_ORDER_AHEAD_ASAP',
  InstoreOrderAheadScheduled = 'INSTORE_ORDER_AHEAD_SCHEDULED',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  OneHour = 'ONE_HOUR',
  Pickup = 'PICKUP',
  PickupEta = 'PICKUP_ETA',
  PriorityEta = 'PRIORITY_ETA',
  RetailerInstore = 'RETAILER_INSTORE',
  RetailerManaged = 'RETAILER_MANAGED',
  ScanAndPay = 'SCAN_AND_PAY',
  Scheduled = 'SCHEDULED',
  ThreeHour = 'THREE_HOUR',
  TwoHour = 'TWO_HOUR',
  Ultrafast = 'ULTRAFAST',
  /** Express subscription fulfillment (non-physical) */
  VirtualExpress = 'VIRTUAL_EXPRESS',
  VirtualRetailerMembership = 'VIRTUAL_RETAILER_MEMBERSHIP'
}

export enum Instacart_Customers_Shared_V1_Locale {
  DeAt = 'DE_AT',
  EnAt = 'EN_AT',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  /** Soft deprecated Use EN_GB instead */
  EnUk = 'EN_UK',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  /** Soft deprecated Use ES_ES instead */
  EsSp = 'ES_SP',
  EsUs = 'ES_US',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  LocaleUnspecified = 'LOCALE_UNSPECIFIED'
}

/** An order by direction. */
export enum Instacart_Customers_Shared_V1_Order_Attribute_Direction {
  /** Ascending. */
  Asc = 'ASC',
  /** Descending. */
  Desc = 'DESC'
}

export type Instacart_Customers_Shared_V1_Order_Attribute_Input = {
  /** The direction to order by */
  direction?: InputMaybe<Instacart_Customers_Shared_V1_Order_Attribute_Direction>;
  /** The attribute to order by */
  name?: InputMaybe<Scalars['String']>;
};

/**
 * Container for ordering parameters implemented
 * using the Domain::Api::OrderBy functionality
 */
export type Instacart_Customers_Shared_V1_Order_Input = {
  attributes?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_V1_Order_Attribute_Input>>>;
};

export enum Instacart_Customers_Shared_V1_QuantityType {
  Each = 'EACH',
  Unspecified = 'UNSPECIFIED',
  Weight = 'WEIGHT'
}

/**
 * Contextual information used for identifying the
 * marketplace/pbi/connect configurations associated
 * with a request
 *
 * see Domain::Shared::RequestContext
 */
export type Instacart_Customers_Shared_V1_RequestContext_Input = {
  /**
   * Known as `oauth_application_id` in the corresponding domain object
   * But refers to the primary key on the `client_configurations` table.
   */
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  /** The ID associated with a specific country, represented as an ISO numeric code */
  countryId?: InputMaybe<Scalars['Int']>;
  /** The ID associated with a particular store configuration */
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum Instacart_Customers_Shared_V1_ServiceType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  Pickup = 'PICKUP',
  ScanAndPay = 'SCAN_AND_PAY',
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  /** Used for non-physical services */
  Virtual = 'VIRTUAL'
}

export type Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoRequest_Input = {
  orderId?: InputMaybe<Scalars['BigInt']>;
  /** used for graphql authorization */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoResponse = {
  __typename?: 'instacart_enterprise_boba_core_offers_v1_GetOrderDiscountInfoResponse';
  orderDiscountInfo: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo>>>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails';
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyForXAmountScenario: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyForXAmountScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetNForFreeScenario: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForFreeScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetNQtyForXAmountScenario: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForXAmountScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetXAmountOffScenario: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXAmountOffScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetXPercentOffScenario: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXPercentOffScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyOrMoreGetXPercentOffScenario: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyOrMoreGetXPercentOffScenario>;
  /** Human readable condition and reward string for the discount */
  conditionRewardString: Maybe<Scalars['String']>;
  /** Internal description of the discount */
  description: Maybe<Scalars['String']>;
  /** Legacy discount_category_id */
  discountCategoryId: Maybe<Scalars['BigInt']>;
  /** Discount end time */
  endsAt: Maybe<Scalars['DateTime']>;
  /** Details about the funding information for this offer */
  fundingDetail: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingDetail>;
  /** Internal name of the discount */
  name: Maybe<Scalars['String']>;
  /** List of offer conditions */
  offerConditions: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferCondition>>>;
  /** Reference to the offer in any external system */
  offerExternalReference: Maybe<Scalars['String']>;
  /** Unique offer identifier, will map to discount_policy_id post Unified Discounting Platform */
  offerId: Maybe<Scalars['String']>;
  /** The offer request key */
  offerRequestKey: Maybe<Scalars['String']>;
  /** List of offer rewards */
  offerRewards: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferReward>>>;
  /** The source system which is ingesting this offer */
  offerSource: Maybe<Scalars['String']>;
  /** Type of offer: coupon, auto apply etc */
  offerType: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferType>;
  /** Optional promo code for the discount */
  promoCode: Maybe<Scalars['String']>;
  /** Indicates the maximum allowed redemptions of this offer */
  redemptionLimits: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRedemptionLimits>;
  /** Discount start time */
  startsAt: Maybe<Scalars['DateTime']>;
  /** Legal terms and condition for the discount */
  terms: Maybe<Scalars['String']>;
  /** When present, it indicates this offer cannot be categorized into any known scenario. */
  uncategorizedScenario: Maybe<Scalars['instacart_enterprise_boba_core_types_v1_OfferDetails_UncategorizedScenario']>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BigDecimal';
  /**
   * Nano units of the amount (10^-9)
   * Must be same sign as units
   * Example: The value -1.25 is represented as units=-1 and nanos=-250000000
   */
  nanos: Maybe<Scalars['Int']>;
  /** Whole units part of the amount */
  units: Maybe<Scalars['BigInt']>;
};

/** Buy M qty of eligible products and for a total price of X. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyForXAmountScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyForXAmountScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_amount referred in the scenario name */
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get additional N qty for free. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForFreeScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetNQtyForFreeScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter n_qty referred in the scenario name */
  nQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
};

/** Buy M qty of eligible products and be eligible to buy N eligible products for a total price of X. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForXAmountScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetNQtyForXAmountScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter n_qty referred in the scenario name */
  nQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_amount referred in the scenario name */
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get X (monetary value) off the original price. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXAmountOffScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetXAmountOffScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_amount referred in the scenario name */
  xAmount: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get X% off the price (of M). */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXPercentOffScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetXPercentOffScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_percent referred in the scenario name */
  xPercent: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
};

/** Buy M or more qty of eligible products and get X% off the price (of M). */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyOrMoreGetXPercentOffScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyOrMoreGetXPercentOffScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_percent referred in the scenario name */
  xPercent: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_DiscountRewardType {
  AmountOff = 'AMOUNT_OFF',
  DiscountRewardTypeUnspecified = 'DISCOUNT_REWARD_TYPE_UNSPECIFIED',
  PercentMille = 'PERCENT_MILLE',
  PercentOff = 'PERCENT_OFF',
  SetPrice = 'SET_PRICE',
  SetPricePerUnit = 'SET_PRICE_PER_UNIT'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingDetail = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_FundingDetail';
  /** the amount of budget available before the offer is exhausted */
  budgetLimit: Maybe<GoogleTypeMoney>;
  fundingProviderInfo: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingProviderInformation>>>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingProviderInformation = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_FundingProviderInformation';
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent: Maybe<Scalars['BigInt']>;
  /** who is funding this part */
  source: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingSource>;
  /** name of the funding source */
  sourceName: Maybe<Scalars['String']>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Retailer = 'RETAILER'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferCondition = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_OfferCondition';
  /** Indicates if offer can be applied partially when quantity conditions are not met */
  allowPartialApplication: Maybe<Scalars['Boolean']>;
  /** List of collection ids for the condition */
  collectionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** List of product ids for the condition */
  conditionProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * Maximum quantity allowed in a single application of this offer.
   * Same value as minimum_quantity is used to indicate exact quantity matching, whereas nil value is used when no upper limit is set.
   */
  maximumQuantity: Maybe<Scalars['BigInt']>;
  /** Minimum quantity to have in cart (with any mix of the products) to qualify for discount */
  minimumQuantity: Maybe<Scalars['BigInt']>;
  /** Minimum amount to spend to qualify for discount */
  minimumSpend: Maybe<GoogleTypeMoney>;
  offerConditionType: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferConditionType>;
  /** List of taxonomy node ids for the condition */
  taxonomyNodeIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferConditionType {
  OfferConditionTypeBasket = 'OFFER_CONDITION_TYPE_BASKET',
  OfferConditionTypeBrands = 'OFFER_CONDITION_TYPE_BRANDS',
  OfferConditionTypeCategories = 'OFFER_CONDITION_TYPE_CATEGORIES',
  OfferConditionTypeCollections = 'OFFER_CONDITION_TYPE_COLLECTIONS',
  OfferConditionTypeCommerceClassifications = 'OFFER_CONDITION_TYPE_COMMERCE_CLASSIFICATIONS',
  OfferConditionTypeFees = 'OFFER_CONDITION_TYPE_FEES',
  OfferConditionTypeProducts = 'OFFER_CONDITION_TYPE_PRODUCTS',
  OfferConditionTypeRegions = 'OFFER_CONDITION_TYPE_REGIONS',
  OfferConditionTypeRetailerDepartments = 'OFFER_CONDITION_TYPE_RETAILER_DEPARTMENTS',
  OfferConditionTypeUnspecified = 'OFFER_CONDITION_TYPE_UNSPECIFIED'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRedemptionLimits = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_OfferRedemptionLimits';
  /** Total number of redemptions allowed on offers in the same group. */
  redemptionLimit: Maybe<Scalars['BigInt']>;
  /** Number of redemptions allowed per order on offers in the same group */
  redemptionLimitPerOrder: Maybe<Scalars['BigInt']>;
  /** Number of redemptions allowed per user on offers in the same group. */
  redemptionLimitPerUser: Maybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferReward = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_OfferReward';
  /** Discount amount */
  amountDiscount: Maybe<GoogleTypeMoney>;
  discountRewardType: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_DiscountRewardType>;
  /** Indicates if the reward group can include items in the condition group */
  includeConditionGroup: Maybe<Scalars['Boolean']>;
  /** Discount sets price for the item */
  offerPrice: Maybe<GoogleTypeMoney>;
  offerRewardType: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRewardType>;
  /** Discount percent value between 1-100. */
  percentDiscount: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Maximum quantity allowed to receive the reward in a single offer application */
  quantityLimit: Maybe<Scalars['BigInt']>;
  /** List of reward product ids" */
  rewardProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRewardType {
  OfferRewardTypeBasket = 'OFFER_REWARD_TYPE_BASKET',
  OfferRewardTypeBrands = 'OFFER_REWARD_TYPE_BRANDS',
  OfferRewardTypeCategories = 'OFFER_REWARD_TYPE_CATEGORIES',
  OfferRewardTypeCollections = 'OFFER_REWARD_TYPE_COLLECTIONS',
  OfferRewardTypeProducts = 'OFFER_REWARD_TYPE_PRODUCTS',
  OfferRewardTypeRetailerDepartments = 'OFFER_REWARD_TYPE_RETAILER_DEPARTMENTS',
  OfferRewardTypeServiceItem = 'OFFER_REWARD_TYPE_SERVICE_ITEM',
  OfferRewardTypeUnspecified = 'OFFER_REWARD_TYPE_UNSPECIFIED'
}

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferType {
  AutoApply = 'AUTO_APPLY',
  CheckoutCodeBasedDiscount = 'CHECKOUT_CODE_BASED_DISCOUNT',
  Coupon = 'COUPON',
  OfferTypeUnspecified = 'OFFER_TYPE_UNSPECIFIED'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OrderDiscountInfo';
  /** Discount amount resutling from the evaluation of the offer */
  appliedAmount: Maybe<GoogleTypeMoney>;
  /** ID of the discount_discountables record */
  discountDiscountableId: Maybe<Scalars['BigInt']>;
  /** ID of the target the offer applies to */
  discountableId: Maybe<Scalars['BigInt']>;
  /** Discountable entity: basket, item, customer fee etc. */
  discountableType: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo_DiscountableType>;
  /** Discount policy data */
  offer: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails>;
  /** ID of the target order */
  orderId: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo_DiscountableType {
  BasketLevelOffer = 'BASKET_LEVEL_OFFER',
  CustomerFeeOffer = 'CUSTOMER_FEE_OFFER',
  DiscountableTypeUnspecified = 'DISCOUNTABLE_TYPE_UNSPECIFIED',
  ItemLevelOffer = 'ITEM_LEVEL_OFFER'
}

/** Address information with coordinates. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_AddressInformation = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_AddressInformation';
  /** City */
  city: Maybe<Scalars['String']>;
  /** Geographic coordinates */
  coordinates: Maybe<Google_Type_LatLng>;
  /** State/province */
  state: Maybe<Scalars['String']>;
  /** Street address */
  streetName: Maybe<Scalars['String']>;
  /** Unit/apartment number */
  unitNumber: Maybe<Scalars['String']>;
  /** ZIP/postal code */
  zipCode: Maybe<Scalars['String']>;
};

/** Request to cancel a partner bulk delivery route */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelPartnerBulkDeliveryRouteRequest_Input = {
  /** Authorization context of the IPP user making the request */
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** The batch/route ID to cancel */
  batchId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Transfer operations specifying where all orders should go
   * Required: dispatcher must explicitly specify destination for all orders
   * Can transfer to other routes or back to Instacart
   */
  transfers?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransfers_Input>>>;
};

/** Unit of measurement for vehicle capacity. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit {
  CapacityUnitTotes = 'CAPACITY_UNIT_TOTES',
  CapacityUnitUnknown = 'CAPACITY_UNIT_UNKNOWN'
}

/** Request message for creating a new warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleRequest_Input = {
  capacityAmount?: InputMaybe<Scalars['Int']>;
  capacityUnit?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit>;
  color?: InputMaybe<Scalars['String']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for creating a warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_CreateWarehouseLocationVehicleResponse';
  vehicle: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle>;
};

/** Reasons for delivery failures. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderFailureReason {
  DeliveryRouteOrderFailureReasonAskedToWait = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_ASKED_TO_WAIT',
  DeliveryRouteOrderFailureReasonCustomerNoAnswer = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_CUSTOMER_NO_ANSWER',
  DeliveryRouteOrderFailureReasonCustomerReusedOrCanceled = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_CUSTOMER_REUSED_OR_CANCELED',
  DeliveryRouteOrderFailureReasonIncorrectAddress = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_INCORRECT_ADDRESS',
  DeliveryRouteOrderFailureReasonUnknown = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_UNKNOWN'
}

/** Order delivery statuses. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderState {
  DeliveryRouteOrderStateAssigned = 'DELIVERY_ROUTE_ORDER_STATE_ASSIGNED',
  /** Order was canceled after the driver left the store, but wasn't marked as failed */
  DeliveryRouteOrderStateCanceled = 'DELIVERY_ROUTE_ORDER_STATE_CANCELED',
  DeliveryRouteOrderStateDelivered = 'DELIVERY_ROUTE_ORDER_STATE_DELIVERED',
  DeliveryRouteOrderStateDelivering = 'DELIVERY_ROUTE_ORDER_STATE_DELIVERING',
  DeliveryRouteOrderStateFailed = 'DELIVERY_ROUTE_ORDER_STATE_FAILED',
  DeliveryRouteOrderStateOnVehicle = 'DELIVERY_ROUTE_ORDER_STATE_ON_VEHICLE',
  DeliveryRouteOrderStatePendingDeliveryReattempt = 'DELIVERY_ROUTE_ORDER_STATE_PENDING_DELIVERY_REATTEMPT',
  DeliveryRouteOrderStatePicking = 'DELIVERY_ROUTE_ORDER_STATE_PICKING',
  DeliveryRouteOrderStateStaged = 'DELIVERY_ROUTE_ORDER_STATE_STAGED',
  DeliveryRouteOrderStateUnknown = 'DELIVERY_ROUTE_ORDER_STATE_UNKNOWN'
}

/** Request message for retrieving bulk delivery configurations for multiple locations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListRequest_Input = {
  /** The retailer ID to fetch configurations for */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer location IDs to fetch configurations for */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response message containing bulk delivery configurations for multiple locations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryConfigurationsListResponse';
  /** Configurations for each requested retailer location */
  configurations: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryConfigurationsEntry>>>;
};

/** Request message for retrieving bulk delivery configurations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsRequest_Input = {
  /** The retailer ID to fetch configurations for */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer location ID to fetch configurations for */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing bulk delivery configurations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryConfigurationsResponse';
  /** Maximum number of orders allowed per route */
  maxOrdersPerRoute: Maybe<Scalars['Int']>;
  /** Whether partner bulk delivery is enabled for this retailer location */
  partnerBulkDeliveryEnabled: Maybe<Scalars['Boolean']>;
  /** Number of hours before route start time that manual edits are allowed */
  routeEditLeadTimeHours: Maybe<Scalars['Int']>;
};

/** Request message for retrieving an overview of order statuses for a retailer location on a given date. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewRequest_Input = {
  /** The date to fetch the overview for */
  date?: InputMaybe<Google_Type_Date_Input>;
  /** The retailer location ID to fetch the overview for */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing order status counts. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryOrderOverviewResponse';
  /** Order counts grouped by delivery route order state */
  orderStatusCounts: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderStatusCount>>>;
};

/** Request message for retrieving a list of partner bulk delivery routes. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListRequest_Input = {
  /** The date to fetch routes for */
  date?: InputMaybe<Google_Type_Date_Input>;
  /** Pagination information */
  pagination?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationInfo_Input>;
  /** The retailer location ID to filter routes by */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of bulk delivery routes */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryRouteListResponse';
  /** List of delivery routes with associated shift information */
  deliveryRouteShifts: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteShift>>>;
  /** Pagination information for the response */
  pagination: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationResponse>;
};

/** Request message for retrieving detailed information about a single delivery route. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteRequest_Input = {
  /** The delivery route ID (batch_id) */
  batchId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing detailed route information with orders. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryRouteResponse';
  /** Route and shift information */
  routeShift: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteShift>;
  /** Orders sorted in intended delivery sequence */
  sortedOrders: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryOrder>>>;
  /** Store address information */
  storeAddress: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_AddressInformation>;
};

/** Filter criteria for querying warehouse location vehicles. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListFilter_Input = {
  status?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_VehicleStatus>;
};

/** Request message for retrieving a list of warehouse location vehicles. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListRequest_Input = {
  filter?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListFilter_Input>;
  pagination?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationInfo_Input>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of warehouse location vehicles. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetWarehouseLocationVehicleListResponse';
  pagination: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationResponse>;
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

/** Destination options for transferred order deliveries */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransferDestination {
  /** Transfer to a specific route/device identified by target_batch_id */
  OrderDeliveryTransferDestinationDevice = 'ORDER_DELIVERY_TRANSFER_DESTINATION_DEVICE',
  /**
   * Unassign orders from this route, and let batching service automatically
   * decide what to do with them
   */
  OrderDeliveryTransferDestinationInstacart = 'ORDER_DELIVERY_TRANSFER_DESTINATION_INSTACART',
  OrderDeliveryTransferDestinationUnknown = 'ORDER_DELIVERY_TRANSFER_DESTINATION_UNKNOWN'
}

/** Defines a transfer operation for a group of order deliveries */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransfers_Input = {
  /** Where these order deliveries should be transferred */
  destination?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransferDestination>;
  /** The order delivery IDs to transfer out of the current route */
  orderDeliveryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Target batch/route ID (required when destination = DEVICE)
   * The route receiving these transferred orders
   */
  targetBatchId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Target route version (required when destination = DEVICE)
   * Version of the receiving route for consistency validation
   */
  targetRouteVersion?: InputMaybe<Scalars['BigInt']>;
};

/** Order count for a specific order state. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderStatusCount = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_OrderStatusCount';
  /** Number of orders in this state */
  count: Maybe<Scalars['Int']>;
  /** The delivery route order state */
  deliveryRouteOrderState: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderState>;
};

/** Pagination information for requests */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Pagination information for responses */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PaginationResponse';
  /** Cursor for the next page */
  after: Maybe<Scalars['String']>;
  /** Whether there are more results available */
  hasNext: Maybe<Scalars['Boolean']>;
};

/** A single entry in the bulk delivery configurations list response. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryConfigurationsEntry = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryConfigurationsEntry';
  /** Maximum number of orders allowed per route */
  maxOrdersPerRoute: Maybe<Scalars['Int']>;
  /**
   * When editing a route and transferring orders to target devices, the maximum number
   * of unique target devices in a single edit session
   */
  maxTargetDevicesPerEditSession: Maybe<Scalars['Int']>;
  /** Whether partner bulk delivery is enabled for this retailer location */
  partnerBulkDeliveryEnabled: Maybe<Scalars['Boolean']>;
  /** The retailer location ID this configuration applies to */
  retailerLocationId: Maybe<Scalars['BigInt']>;
  /** Number of hours before route start time that manual edits are allowed */
  routeEditLeadTimeHours: Maybe<Scalars['Int']>;
};

/** Represents a single order in a delivery route. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryOrder = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryOrder';
  /** Actual delivery time (null if not yet delivered) */
  actualDeliveryTime: Maybe<Scalars['DateTime']>;
  /** Client configuration ID for the order */
  clientConfigurationId: Maybe<Scalars['BigInt']>;
  /** Country ID for the order */
  countryId: Maybe<Scalars['BigInt']>;
  /** Customer delivery address */
  customerAddress: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_AddressInformation>;
  /** Customer name */
  customerName: Maybe<Scalars['String']>;
  /**
   * Delivery contact attempts for this order, sorted by created_at ascending.
   * Empty if no attempts were made.
   */
  deliveryAttempts: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryAttempt>>>;
  /** Deprecated: use delivery_failures instead. */
  deliveryFailureReason: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderFailureReason>;
  /**
   * Delivery failure records for this order, sorted by not_delivered_at ascending.
   * Populated when delivery_route_order_state is FAILED.
   */
  deliveryFailures: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryFailure>>>;
  /** Current status of the order delivery */
  deliveryRouteOrderState: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderState>;
  /** Unique identifier for the order delivery */
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  /** Unique identifier for the order */
  orderId: Maybe<Scalars['BigInt']>;
  /** Planned delivery time when the batch is created */
  plannedDeliveryEta: Maybe<Scalars['DateTime']>;
  /** Real-time delivery ETA after delivery starts, computed based on shopper location. */
  realtimeDeliveryEta: Maybe<Scalars['DateTime']>;
  /** Store configuration ID for the order */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  /** End of delivery window */
  windowEndsAt: Maybe<Scalars['DateTime']>;
  /** Start of delivery window */
  windowStartsAt: Maybe<Scalars['DateTime']>;
};

/** Represents a single bulk delivery route with associated metadata. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoute = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoute';
  /** non-canceled total order count for the route. may be null if no orders are assigned yet */
  activeOrderCount: Maybe<Scalars['Int']>;
  /** List of allowed edit actions for this route */
  allowedRouteEditActions: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkRouteEditAction>>>;
  /** delivery routes are modeled as delivery batches. batch_id is the unique identifier for a delivery route. */
  batchId: Maybe<Scalars['BigInt']>;
  /** same as warehouse_location_id. Assuming a delivery route always have an associated warehouse location */
  retailerLocationId: Maybe<Scalars['BigInt']>;
  /** Will be shown as a percentage on IPP. may be null if no orders are assigned yet */
  routeCapacityUsed: Maybe<Scalars['Int']>;
  /** whether the route has been manually edited */
  routeManuallyEdited: Maybe<Scalars['Boolean']>;
  /** Planned completion time for the route */
  routePlannedCompletionTime: Maybe<Scalars['DateTime']>;
  /** Planned start time for the route */
  routePlannedStartTime: Maybe<Scalars['DateTime']>;
  /** Current status of the route */
  routeStatus: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteStatus>;
  /** Version number for optimistic concurrency control */
  routeVersion: Maybe<Scalars['BigInt']>;
};

/** Delivery route with associated shift information. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteShift = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRouteShift';
  /** The delivery route details */
  deliveryRoute: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoute>;
  /** Shift information associated with this delivery route. Needed as we are displaying shift information on the delivery routes page */
  shift: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerManagedShift>;
};

export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteStatus {
  PartnerBulkDeliveryRouteStatusCanceled = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_CANCELED',
  PartnerBulkDeliveryRouteStatusCompleted = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_COMPLETED',
  PartnerBulkDeliveryRouteStatusDelivering = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_DELIVERING',
  PartnerBulkDeliveryRouteStatusLoadingVehicle = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_LOADING_VEHICLE',
  PartnerBulkDeliveryRouteStatusPlanned = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_PLANNED',
  PartnerBulkDeliveryRouteStatusUnknown = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_UNKNOWN'
}

/** A single delivery attempt for a partner bulk order. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryAttempt = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkOrderDeliveryAttempt';
  /** Timestamp when this attempt was created. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Customer's response to the contact attempt. */
  customerResponse: Maybe<Instacart_Fulfillment_Shared_V1_CustomerResponse>;
};

/** A delivery failure record for a partner bulk order. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryFailure = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkOrderDeliveryFailure';
  /** Timestamp when the delivery was marked as not delivered. */
  notDeliveredAt: Maybe<Scalars['DateTime']>;
  /** The reason the delivery was not completed. */
  reason: Maybe<Instacart_Fulfillment_Shared_V1_NotDeliveredReason>;
};

export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkRouteEditAction {
  PartnerBulkRouteEditActionAddOrder = 'PARTNER_BULK_ROUTE_EDIT_ACTION_ADD_ORDER',
  PartnerBulkRouteEditActionRemoveOrder = 'PARTNER_BULK_ROUTE_EDIT_ACTION_REMOVE_ORDER',
  PartnerBulkRouteEditActionShuffle = 'PARTNER_BULK_ROUTE_EDIT_ACTION_SHUFFLE',
  PartnerBulkRouteEditActionUnknown = 'PARTNER_BULK_ROUTE_EDIT_ACTION_UNKNOWN'
}

/** Information about the shift associated with delivery routes. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerManagedShift = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerManagedShift';
  /** Shopper/driver phone number */
  phoneNumber: Maybe<Scalars['String']>;
  /** Shift end time */
  shiftEndsAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the shift */
  shiftId: Maybe<Scalars['BigInt']>;
  /** Shift start time */
  shiftStartsAt: Maybe<Scalars['DateTime']>;
  /** Shopper/driver ID assigned to the shift */
  shopperId: Maybe<Scalars['BigInt']>;
  /** Shopper/driver name */
  shopperName: Maybe<Scalars['String']>;
};

/** Request to update a partner bulk delivery route with reordering and/or transfers */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdatePartnerBulkDeliveryRouteRequest_Input = {
  /** Authorization context of the IPP user making the request */
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** The batch/route ID being edited (delivery routes are modeled as delivery batches) */
  batchId?: InputMaybe<Scalars['BigInt']>;
  /**
   * The final order sequence after all edits (reordering)
   * Contains all order_delivery_ids that should remain on this route
   * Order matters: first ID = first delivery, last ID = last delivery
   */
  finalRouteOrderDeliveryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** The retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Current route version for optimistic concurrency control
   * Backend will reject the request if this doesn't match the current version
   */
  routeVersion?: InputMaybe<Scalars['BigInt']>;
  /** List of transfer operations to move orders off this route */
  transfers?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransfers_Input>>>;
};

/** Request message for updating an existing warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleRequest_Input = {
  capacityAmount?: InputMaybe<Scalars['Int']>;
  capacityUnit?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit>;
  color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for updating a warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_UpdateWarehouseLocationVehicleResponse';
  vehicle: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle>;
};

/** Status filter for querying vehicles. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_VehicleStatus {
  VehicleStatusActive = 'VEHICLE_STATUS_ACTIVE',
  VehicleStatusInactive = 'VEHICLE_STATUS_INACTIVE',
  VehicleStatusUnknown = 'VEHICLE_STATUS_UNKNOWN'
}

/** Represents a vehicle associated with a warehouse location. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehicle';
  capacityAmount: Maybe<Scalars['Int']>;
  capacityUnit: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit>;
  color: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  isActive: Maybe<Scalars['Boolean']>;
  licensePlate: Maybe<Scalars['String']>;
  make: Maybe<Scalars['String']>;
  model: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Information about the delivery or pickup address. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_AddressInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AddressInformation';
  city: Maybe<Scalars['String']>;
  coordinates: Maybe<Google_Type_LatLng>;
  state: Maybe<Scalars['String']>;
  streetName: Maybe<Scalars['String']>;
  unitNumber: Maybe<Scalars['String']>;
  zipCode: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  /** Items permitted for refund processing. */
  permitted?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** User ID. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AdjustDashboardOrderResponse';
  /** TODO(FUL-174701): deprecate after downstream migration */
  isSuccess: Maybe<Scalars['Boolean']>;
  operation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AdjustmentNotPermitted';
  /** List of denial policy IDs. */
  denialPolicyIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Reason why refund is not permitted. */
  reason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted_Reason {
  AdjustmentRequestPreviouslyProcessed = 'ADJUSTMENT_REQUEST_PREVIOUSLY_PROCESSED',
  BusinessEntityNotAuthorized = 'BUSINESS_ENTITY_NOT_AUTHORIZED',
  FailedIncompatibleStateChange = 'FAILED_INCOMPATIBLE_STATE_CHANGE',
  LineAdjustmentAmountsConflictWithCurrentState = 'LINE_ADJUSTMENT_AMOUNTS_CONFLICT_WITH_CURRENT_STATE',
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AdjustmentPermitted';
  /** Adjustment input. */
  adjustmentInput: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput>;
  /** List of approval policy IDs. */
  approvalPolicyIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted_Input = {
  /** Adjustment input. */
  adjustmentInput?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput_Input>;
  /** List of approval policy IDs. */
  approvalPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  description?: InputMaybe<Scalars['String']>;
  /** OrderCancellationPolicyInput from GetOrderCancellationPolicyListResponse */
  orderCancellationPolicyInput?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput_Input>;
  /** OrderChange token from GetOrderCancellationPolicyListResponse. Optional for certain policy inputs. */
  orderChangeToken?: InputMaybe<Scalars['String']>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer App ID. */
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_CancelDashboardOrderResponse';
  /** TODO(FUL-174701): deprecate after downstream migration */
  isSuccess: Maybe<Scalars['Boolean']>;
  operation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

/** Context information about the customer's environment. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerContext = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_CustomerContext';
  clientConfigurationId: Maybe<Scalars['BigInt']>;
  countryId: Maybe<Scalars['BigInt']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
};

/** Information about the customer who placed the order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_CustomerInformation';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  fullName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  /** Actual id for the loyalty card: orders may store one or both */
  loyaltyCardId: Maybe<Scalars['BigInt']>;
  /** Alternately called loyalty_card_number, but can technically be a string */
  loyaltyIdentifier: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrder = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardOrder';
  /** Information about the address. */
  addressInformation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AddressInformation>;
  /** Customer context. Do we need this? */
  customerContext: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerContext>;
  /** Information about the customer. */
  customerInformation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerInformation>;
  /** The external ID. */
  externalId: Maybe<Scalars['String']>;
  /** Fulfillment metadata. */
  fulfillmentDetails: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_FulfillmentDetails>;
  /** The tip amount from the latest invoice. */
  latestTip: Maybe<GoogleTypeMoney>;
  /** The tip amount from the latest invoice, string-formatted. */
  latestTipFormatted: Maybe<Scalars['String']>;
  loyaltyInformation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_LoyaltyInformation>;
  /** Details about the cancellation. */
  orderCancellationDetails: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails>;
  /** Photos of the order delivery's dropoff. */
  orderDeliveryPhotoList: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhotoList>;
  /** Events about the order lifecycle */
  orderHistoryEvents: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent>>>;
  orderId: Maybe<Scalars['BigInt']>;
  orderState: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderState>;
  /** Information about the shopper. */
  shopperInformation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_ShopperInformation>;
  /** The timezone of the sender. */
  timezone: Maybe<Scalars['String']>;
  /** The user ID. */
  userId: Maybe<Scalars['BigInt']>;
};

/** The following are mirrored from orders_service.proto */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_CreationDateScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  creationDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_FulfillmentDateScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  fulfillmentDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** TODO: rename to fulfillment_date_range */
  windowEndsAtRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Scenario parameter is used to indicate the type of search criterias applied */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  creationDateScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_CreationDateScenario_Input>;
  fulfillmentDateScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_FulfillmentDateScenario_Input>;
  loyaltySearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_LoyaltySearchScenario_Input>;
  orderDeliveryIdScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderDeliveryIdScenario_Input>;
  orderIdScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderIdScenario_Input>;
  ordersSortBy?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Input>;
  /** TODO(FUL-174701): fully deprecate once downstreams are migrated to Pagination */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  paginationInfo?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_PaginationInfo_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  userIdScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_UserIdScenario_Input>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  IppOrderStatusCriteriaUnspecified = 'IPP_ORDER_STATUS_CRITERIA_UNSPECIFIED',
  New = 'NEW',
  Processing = 'PROCESSING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Shopping = 'SHOPPING'
}

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType {
  Delivery = 'DELIVERY',
  IppOrderTypeUnspecified = 'IPP_ORDER_TYPE_UNSPECIFIED',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  Pickup = 'PICKUP'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_LoyaltySearchScenario_Input = {
  creationDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  fulfillmentDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  loyaltyId?: InputMaybe<Scalars['BigInt']>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderDeliveryIdScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderIdScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  orderIdentifier?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Direction {
  Asc = 'ASC',
  Desc = 'DESC',
  DirectionUnspecified = 'DIRECTION_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Input = {
  direction?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Direction>;
  name?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_OrdersAttributes>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_OrdersAttributes {
  OrdersAttributesUnspecified = 'ORDERS_ATTRIBUTES_UNSPECIFIED',
  OrderDeliveryId = 'ORDER_DELIVERY_ID',
  WindowEndsAt = 'WINDOW_ENDS_AT'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_UserIdScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  creationDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  fulfillmentDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardOrderSearchResultListResponse';
  /** TODO(FUL-174701): deprecate for `pagination` */
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>;
  paginationInfo: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse_PaginationInfo>;
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse_PaginationInfo = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardOrderSearchResultListResponse_PaginationInfo';
  /** The last cursor of the current page */
  after: Maybe<Scalars['String']>;
  /** Indicates if there is a next page */
  hasNextPage: Maybe<Scalars['Boolean']>;
};

/**
 * A subset or Order that is used for search results on IPP order search page
 * TODO: rename to DashboardOrderSearchResult
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardSearchOrder';
  checkoutRetailerLocationId: Maybe<Scalars['BigInt']>;
  clientConfigurationId: Maybe<Scalars['BigInt']>;
  /** From Order.communication_locale */
  communicationLocale: Maybe<Scalars['String']>;
  countryId: Maybe<Scalars['BigInt']>;
  customerName: Maybe<Scalars['String']>;
  /** From Order.fulfillment_window.window_start */
  fulfillmentDate: Maybe<Scalars['DateTime']>;
  legacyOrderId: Maybe<Scalars['BigInt']>;
  loyaltyInformation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_LoyaltyInformation>;
  /** From Order.creation_date */
  orderDate: Maybe<Scalars['DateTime']>;
  orderId: Maybe<Scalars['BigInt']>;
  orderReference: Maybe<Scalars['String']>;
  orderState: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderState>;
  orderType: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder_OrderType>;
  plannedDeliveredAt: Maybe<Scalars['DateTime']>;
  retailerExternalOrderId: Maybe<Scalars['String']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerReferenceId: Maybe<Scalars['String']>;
  shoppedRetailerLocationId: Maybe<Scalars['BigInt']>;
  /** Mapped Order.workflow_state */
  status: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  timezone: Maybe<Scalars['String']>;
  totalCharge: Maybe<GoogleTypeMoney>;
  userId: Maybe<Scalars['BigInt']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder_OrderType {
  Delivery = 'DELIVERY',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  OrderTypeUnspecified = 'ORDER_TYPE_UNSPECIFIED',
  Pickup = 'PICKUP'
}

/** Details about order fulfillment. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_FulfillmentDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_FulfillmentDetails';
  addressId: Maybe<Scalars['BigInt']>;
  estimatedDeliveryTime: Maybe<Scalars['DateTime']>;
  estimatedPickupTime: Maybe<Scalars['DateTime']>;
  isAlcoholic: Maybe<Scalars['Boolean']>;
  numOfBags: Maybe<Scalars['BigInt']>;
  orderHandlingDetails: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails>;
  previouslyRescheduled: Maybe<Scalars['Boolean']>;
  retailerId: Maybe<Scalars['BigInt']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  retailerLocationName: Maybe<Scalars['String']>;
  retailerProvidedAmounts: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_RetailerProvidedAmounts>;
  serviceOptionId: Maybe<Scalars['BigInt']>;
  windowEndsAt: Maybe<Scalars['DateTime']>;
  windowStartsAt: Maybe<Scalars['DateTime']>;
};

/** Request to get a dashboard order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** also known as `warehouse_id` internally */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing a dashboard order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetDashboardOrderResponse';
  dashboardOrder: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrder>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListRequest_Input = {
  /** Adjustment input. */
  adjustmentInput?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput_Input>;
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** User ID. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderAdjustmentPolicyListResponse';
  /** Result of adjustment request. */
  result: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicy>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer App ID. */
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
  /** Optional user ID to speed up Orders sharded query. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderCancellationPolicyListResponse';
  /** The list of OrderCancellationPolicies. */
  cancellationPolicies: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy>>>;
  /** OrderChange policy token. */
  orderChangeToken: Maybe<Scalars['String']>;
  /** The list of ReschedulePolicies. */
  reschedulePolicies: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy>>>;
  /**
   * The list of OrderCancellationPolicies.
   * TODO(FUL-174701): deprecated naming: use `cancellation_policies` instead.
   */
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListRequest_Input = {
  orderReference?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderLineListResponse';
  results: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderStateChangeListResponse';
  /** tracks the current order fulfillment state change */
  currentOrderFulfillmentStateChange: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange>;
  /** tracks the current return state change (if the order has returns) */
  currentOrderReturnStateChange: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange>;
  orderFulfillmentStateGroups: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup>>>;
  orderReturnStateGroups: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup>>>;
};

/** Request for getting retailer product details */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Input = {
  /** Combined request parameters */
  parameters?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Parameters_Input>;
  /**
   * Metadata for the request
   * TODO(FUL-174701): deprecate for `request_metadata`
   */
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
  /** Metadata for the request */
  requestMetadata?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Input>;
};

/** Query parameters for retrieving retailer product details. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Parameters_Input = {
  /** TODO(FUL-174701): deprecate for `client_source_type` */
  clientSourceType?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Catalog_V1_ClientSourceType>;
  codeType?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Catalog_V1_CodeType>;
  /**
   * List of input codes (e.g., RRCS/Input)
   * TODO(FUL-174701): deprecate for `code_type`
   */
  codes?: InputMaybe<Scalars['String']>;
  /** Optional flag, defaults to false */
  favorEscpCodes?: InputMaybe<Scalars['Boolean']>;
  /** Client source */
  productClientSourceType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ClientSourceType>;
  /** Type of the code (e.g., RETAILER_REFERENCE_CODE) */
  productCodeType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_CodeType>;
  /** Retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing retailer product details */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetRetailerProductDetailsResponse';
  /** List of products with complete details */
  products: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse_RetailerProductDetail>>>;
  /**
   * Metadata for the response
   * TODO(FUL-174701): deprecate for `response_metadata`
   */
  responseMeta: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  responseMetadata: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata>;
};

/** Detailed information about a single retailer product. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse_RetailerProductDetail = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetRetailerProductDetailsResponse_RetailerProductDetail';
  /** URL of the product image */
  imageUrl: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Product ID from matching logic */
  productId: Maybe<Scalars['BigInt']>;
  /** Retailer's Reference Code */
  rrc: Maybe<Scalars['String']>;
  /** Universal Product Code */
  upc: Maybe<Scalars['String']>;
};

/** Information about customer loyalty programs. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_LoyaltyInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_LoyaltyInformation';
  /** numeric id stored in orders */
  loyaltyCardId: Maybe<Scalars['BigInt']>;
  /** e.g., printed/program number or identifier string */
  loyaltyIdentifier: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentDetails';
  /** Individual item refunds. */
  basketContext: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext>;
  /** Funds destination preference. */
  fundsDestinationPreference: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_FundsDestinationPreference>;
};

/** Individual item adjustment context. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentDetails_BasketContext';
  basketAdjustmentDetails: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails';
  /** The quantity expected after applying the requested adjustment. */
  expectedQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Order line ID. */
  orderLineId: Maybe<Scalars['BigInt']>;
  /** Reason for the adjustment. Required in AdjustDashboardOrderRequest. */
  reason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason>;
  /** The requested quantity to be adjusted. */
  requestedAdjustmentQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails_Input = {
  /** The quantity expected after applying the requested adjustment. */
  expectedQuantity?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  /** Order line ID. */
  orderLineId?: InputMaybe<Scalars['BigInt']>;
  /** Reason for the adjustment. Required in AdjustDashboardOrderRequest. */
  reason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Input>;
  /** The requested quantity to be adjusted. */
  requestedAdjustmentQuantity?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
};

/** Individual item adjustment context. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_Input = {
  basketAdjustmentDetails?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails_Input>>>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_FundsDestinationPreference {
  FundsDestinationUnspecified = 'FUNDS_DESTINATION_UNSPECIFIED',
  OnlyOriginalPaymentMethod = 'ONLY_ORIGINAL_PAYMENT_METHOD',
  PreferInternalCredits = 'PREFER_INTERNAL_CREDITS'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_Input = {
  /** Individual item refunds. */
  basketContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_Input>;
  /** Funds destination preference. */
  fundsDestinationPreference?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_FundsDestinationPreference>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentInput';
  adjustmentDetails: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput_Input = {
  adjustmentDetails?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicy = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentPolicy';
  notPermitted: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted>;
  permitted: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted>;
  reasons: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentPolicyReason';
  label: Maybe<Scalars['String']>;
  reason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Reason>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Input = {
  label?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Reason {
  ReasonDamagedOrPoorQualityItem = 'REASON_DAMAGED_OR_POOR_QUALITY_ITEM',
  ReasonMissingItem = 'REASON_MISSING_ITEM',
  ReasonPoorReplacement = 'REASON_POOR_REPLACEMENT',
  ReasonUnspecified = 'REASON_UNSPECIFIED',
  ReasonWrongItemOrAmount = 'REASON_WRONG_ITEM_OR_AMOUNT'
}

/** Details about an order cancellation. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationDetails';
  /** TODO(FUL-174701): deprecate for `order_cancellation_category` */
  cancellationCategory: Maybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationCategory>;
  cancellationOrigin: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails_CancellationOrigin>;
  /** TODO(FUL-174701): deprecate for `order_cancellation_type` */
  cancellationType: Maybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationType>;
  orderCancellationCategory: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationCategory>;
  orderCancellationType: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails_CancellationOrigin {
  Customer = 'CUSTOMER',
  Instacart = 'INSTACART',
  Other = 'OTHER',
  Retailer = 'RETAILER',
  Shopper = 'SHOPPER'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicy';
  /** Selection details. */
  inputs: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput>>>;
  notPermitted: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted>;
  permitted: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_Permitted>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicyInput';
  /**
   * https://github.com/instacart/carrot/blob/e48992991a1c6a1a850511251ae7965a9ab19b39/shared/protos/instacart/customers/commerce/types/v1/order_cancellations.proto#L140
   * TODO(FUL-174701): deprecate for `order_cancellation_reason`
   */
  customerReason: Maybe<Instacart_Customers_Commerce_Types_V1_CustomerCancelReason_CustomerReason>;
  label: Maybe<Scalars['String']>;
  orderCancellationReason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason>;
  orderCancellationType: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType>;
  /** TODO(FUL-174701): deprecate for `order_cancellation_type` */
  reasonType: Maybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationType>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput_Input = {
  /**
   * https://github.com/instacart/carrot/blob/e48992991a1c6a1a850511251ae7965a9ab19b39/shared/protos/instacart/customers/commerce/types/v1/order_cancellations.proto#L140
   * TODO(FUL-174701): deprecate for `order_cancellation_reason`
   */
  customerReason?: InputMaybe<Instacart_Customers_Commerce_Types_V1_CustomerCancelReason_CustomerReason>;
  label?: InputMaybe<Scalars['String']>;
  orderCancellationReason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_Input>;
  orderCancellationType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType>;
  /** TODO(FUL-174701): deprecate for `order_cancellation_type` */
  reasonType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationType>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicy_NotPermitted';
  /** Reason not permitted. Defaults to UNKNOWN. */
  reason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted_Reason {
  ReasonUnspecified = 'REASON_UNSPECIFIED',
  /** if an unrecognized reason is added upstream, it will be converted to UNKNOWN */
  Unknown = 'UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_Permitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicy_Permitted';
  /** Fees associated with the action. */
  cancelFee: Maybe<GoogleTypeMoney>;
  /** When true, requires a customer_cancel_reason with input. */
  isCustomerCancelReasonRequired: Maybe<Scalars['Boolean']>;
};

/** A photo taken during order delivery. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhoto = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderDeliveryPhoto';
  id: Maybe<Scalars['BigInt']>;
  photoUrl: Maybe<Scalars['String']>;
};

/** A list of photos taken during order delivery. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhotoList = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderDeliveryPhotoList';
  areOrderDeliveryPhotosExpired: Maybe<Scalars['Boolean']>;
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhoto>>>;
};

/** Details about how an order should be handled. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHandlingDetails';
  acceptableRetailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Delivery to customer. */
  delivery: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_DeliveryDetails>;
  /** Pickup from location. */
  pickup: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_PickupDetails>;
  specialRequirements: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Details specific to delivery orders. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_DeliveryDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHandlingDetails_DeliveryDetails';
  address: Maybe<Google_Type_PostalAddress>;
  addressId: Maybe<Scalars['BigInt']>;
  addressType: Maybe<Scalars['String']>;
  coordinates: Maybe<Google_Type_LatLng>;
  customerManualLatLng: Maybe<Google_Type_LatLng>;
  doorCode: Maybe<Scalars['String']>;
  dropoffLocation: Maybe<Scalars['String']>;
  instructions: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

/** Details specific to pickup orders. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_PickupDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHandlingDetails_PickupDetails';
  address: Maybe<Google_Type_PostalAddress>;
  addressId: Maybe<Scalars['BigInt']>;
  coordinates: Maybe<Google_Type_LatLng>;
  instructions: Maybe<Scalars['String']>;
};

/** An event in the order's history. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHistoryEvent';
  action: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent_OrderHistoryEventAction>;
  actionedAt: Maybe<Scalars['DateTime']>;
  windowEndsAt: Maybe<Scalars['DateTime']>;
  windowStartsAt: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent_OrderHistoryEventAction {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Rescheduled = 'RESCHEDULED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList';
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderItem';
  alcoholic: Maybe<Scalars['Boolean']>;
  externalData: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_OrderItemExternalData>;
  imageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  productCategory: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_ProductCategory>;
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  productId: Maybe<Scalars['BigInt']>;
  quantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  retailerLookupCode: Maybe<Scalars['String']>;
  sizeDetails: Maybe<Scalars['String']>;
  unitPrice: Maybe<GoogleTypeMoney>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_OrderItemExternalData = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderItem_OrderItemExternalData';
  lineNum: Maybe<Scalars['String']>;
  retailerRrc: Maybe<Scalars['String']>;
  retailerUpc: Maybe<Scalars['String']>;
  scanCode: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_ProductCategory = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderItem_ProductCategory';
  l1Category: Maybe<Scalars['String']>;
  l1CategoryId: Maybe<Scalars['BigInt']>;
  l2Category: Maybe<Scalars['String']>;
  l2CategoryId: Maybe<Scalars['BigInt']>;
  l3Category: Maybe<Scalars['String']>;
  l3CategoryId: Maybe<Scalars['BigInt']>;
  l4Category: Maybe<Scalars['String']>;
  l4CategoryId: Maybe<Scalars['BigInt']>;
  l5Category: Maybe<Scalars['String']>;
  l5CategoryId: Maybe<Scalars['BigInt']>;
  l6Category: Maybe<Scalars['String']>;
  l6CategoryId: Maybe<Scalars['BigInt']>;
  productCategory: Maybe<Scalars['String']>;
  productCategoryId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderLine';
  addedByDriverId: Maybe<Scalars['BigInt']>;
  allowedSubstitution: Maybe<Scalars['Boolean']>;
  creationDate: Maybe<Scalars['DateTime']>;
  customerOrderedPrice: Maybe<GoogleTypeMoney>;
  customerPrice: Maybe<GoogleTypeMoney>;
  customerSelectedReplacement: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem>;
  fullPrice: Maybe<GoogleTypeMoney>;
  id: Maybe<Scalars['BigInt']>;
  item: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem>;
  obfuscatedId: Maybe<Scalars['String']>;
  orderedQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  pickedQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  refundQuantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  replacementPolicy: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_ReplacementPolicy>;
  specialInstructions: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_Status>;
  substitute: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem>;
  substitutionStatus: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_SubstitutionStatus>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_ReplacementPolicy {
  NoReplacements = 'NO_REPLACEMENTS',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ShoppersChoice = 'SHOPPERS_CHOICE',
  UsersChoice = 'USERS_CHOICE'
}

/** Mirrored from Orders Service */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_Status {
  DeprecatedApproved = 'DEPRECATED_APPROVED',
  DeprecatedRejected = 'DEPRECATED_REJECTED',
  Found = 'FOUND',
  NotPicked = 'NOT_PICKED',
  Replaced = 'REPLACED',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  ToRefund = 'TO_REFUND'
}

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_SubstitutionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SubstitutionStatusUnspecified = 'SUBSTITUTION_STATUS_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicy';
  /** Selection details. */
  inputs: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicyInput>>>;
  /** Not permitted action result. */
  notPermitted: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted>;
  /** Permitted action result. */
  permitted: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_Permitted>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicyInput = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicyInput';
  label: Maybe<Scalars['String']>;
  orderRescheduleReason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Reschedules_OrderRescheduleReason>;
  /** TODO(FUL-174701): deprecate for `order_reschedule_reason` */
  reason: Maybe<Instacart_Customers_Commerce_Types_V1_SupportRescheduleDeliveryReason>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicy_NotPermitted';
  /** Reason not permitted. Defaults to REASON_UNSPECIFIED. */
  reason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted_Reason {
  /** Reason not specified. */
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_Permitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicy_Permitted';
  /** When true, requires a reschedule_reason with input. */
  isRescheduleReasonRequired: Maybe<Scalars['Boolean']>;
  /** Fees associated with the action. */
  rescheduleFee: Maybe<GoogleTypeMoney>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderState {
  Acknowledged = 'ACKNOWLEDGED',
  AcknowledgedForDelivery = 'ACKNOWLEDGED_FOR_DELIVERY',
  AcknowledgedForRunning = 'ACKNOWLEDGED_FOR_RUNNING',
  AtStore = 'AT_STORE',
  BagsCheck = 'BAGS_CHECK',
  BagsCheckStaged = 'BAGS_CHECK_STAGED',
  BagsVerified = 'BAGS_VERIFIED',
  BrandNew = 'BRAND_NEW',
  Checkout = 'CHECKOUT',
  Completed = 'COMPLETED',
  Delivering = 'DELIVERING',
  OrderStateUnspecified = 'ORDER_STATE_UNSPECIFIED',
  Picking = 'PICKING',
  ReceiptSanityCheck = 'RECEIPT_SANITY_CHECK',
  RunnerAwaiting = 'RUNNER_AWAITING',
  RunnerNotFound = 'RUNNER_NOT_FOUND',
  Staged = 'STAGED',
  StagedForDelivery = 'STAGED_FOR_DELIVERY',
  VerifyingReplacements = 'VERIFYING_REPLACEMENTS'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateChange';
  /** optional entity directly responsible for the state change */
  actor: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Actor>;
  /** issues that happened at the state transition */
  issues: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Issue>>>;
  /** the display name of the state showed in the UI */
  label: Maybe<Scalars['String']>;
  /** actual time of the transition */
  transitionedAtActual: Maybe<Scalars['DateTime']>;
  /** estimated time of the transition */
  transitionedAtEta: Maybe<Scalars['DateTime']>;
  type: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_OrderStateChangeType>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Actor = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateChange_Actor';
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_ActorType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_ActorType {
  /** aka "Driver" */
  ActorTypeShopper = 'ACTOR_TYPE_SHOPPER',
  ActorTypeShopperDriver = 'ACTOR_TYPE_SHOPPER_DRIVER',
  ActorTypeShopperPicker = 'ACTOR_TYPE_SHOPPER_PICKER',
  ActorTypeShopperRunner = 'ACTOR_TYPE_SHOPPER_RUNNER',
  ActorTypeUnknown = 'ACTOR_TYPE_UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Issue = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateChange_Issue';
  /** more details into the issue, mainly used for the tooltip in the UI */
  issueDescription: Maybe<Scalars['String']>;
  /** field that describes the type of the issue, e.g. "Delayed", "Partially Delivered" */
  issueType: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_IssueType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_IssueType {
  IssueTypeCanceled = 'ISSUE_TYPE_CANCELED',
  IssueTypeDelayed = 'ISSUE_TYPE_DELAYED',
  IssueTypeFailedDelivery = 'ISSUE_TYPE_FAILED_DELIVERY',
  IssueTypePartiallyDelivered = 'ISSUE_TYPE_PARTIALLY_DELIVERED',
  IssueTypeUnknown = 'ISSUE_TYPE_UNKNOWN'
}

/**
 * not necessarily in order; different order types e.g. PPDO, LMD
 * can use a different combination of state change types
 */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_OrderStateChangeType {
  /** arrived at the customer location */
  OrderStateChangeTypeArrived = 'ORDER_STATE_CHANGE_TYPE_ARRIVED',
  OrderStateChangeTypeAssigned = 'ORDER_STATE_CHANGE_TYPE_ASSIGNED',
  OrderStateChangeTypeAssignedForDelivery = 'ORDER_STATE_CHANGE_TYPE_ASSIGNED_FOR_DELIVERY',
  /**
   * runner is on the way to the customer car
   * TODO: move numbers around?
   */
  OrderStateChangeTypeAssignedForRunning = 'ORDER_STATE_CHANGE_TYPE_ASSIGNED_FOR_RUNNING',
  OrderStateChangeTypeAtStore = 'ORDER_STATE_CHANGE_TYPE_AT_STORE',
  /** return related */
  OrderStateChangeTypeAwaitingReturn = 'ORDER_STATE_CHANGE_TYPE_AWAITING_RETURN',
  OrderStateChangeTypeBagsPickedUp = 'ORDER_STATE_CHANGE_TYPE_BAGS_PICKED_UP',
  OrderStateChangeTypeCanceled = 'ORDER_STATE_CHANGE_TYPE_CANCELED',
  OrderStateChangeTypeCheckingOut = 'ORDER_STATE_CHANGE_TYPE_CHECKING_OUT',
  OrderStateChangeTypeDelivered = 'ORDER_STATE_CHANGE_TYPE_DELIVERED',
  OrderStateChangeTypeInTransit = 'ORDER_STATE_CHANGE_TYPE_IN_TRANSIT',
  OrderStateChangeTypeOrderPlaced = 'ORDER_STATE_CHANGE_TYPE_ORDER_PLACED',
  OrderStateChangeTypePicking = 'ORDER_STATE_CHANGE_TYPE_PICKING',
  OrderStateChangeTypeReturnCompleted = 'ORDER_STATE_CHANGE_TYPE_RETURN_COMPLETED',
  OrderStateChangeTypeReturnInProgress = 'ORDER_STATE_CHANGE_TYPE_RETURN_IN_PROGRESS',
  OrderStateChangeTypeStagedForDelivery = 'ORDER_STATE_CHANGE_TYPE_STAGED_FOR_DELIVERY',
  OrderStateChangeTypeStagedForPickup = 'ORDER_STATE_CHANGE_TYPE_STAGED_FOR_PICKUP',
  OrderStateChangeTypeStaging = 'ORDER_STATE_CHANGE_TYPE_STAGING',
  OrderStateChangeTypeUnknown = 'ORDER_STATE_CHANGE_TYPE_UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateGroup';
  label: Maybe<Scalars['String']>;
  orderStateChanges: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange>>>;
  type: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup_OrderStateGroupType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup_OrderStateGroupType {
  OrderStateGroupTypeOrderCompleted = 'ORDER_STATE_GROUP_TYPE_ORDER_COMPLETED',
  OrderStateGroupTypeOrderInTransit = 'ORDER_STATE_GROUP_TYPE_ORDER_IN_TRANSIT',
  OrderStateGroupTypeOrderPicking = 'ORDER_STATE_GROUP_TYPE_ORDER_PICKING',
  OrderStateGroupTypeOrderPlaced = 'ORDER_STATE_GROUP_TYPE_ORDER_PLACED',
  OrderStateGroupTypeOrderReturnCompleted = 'ORDER_STATE_GROUP_TYPE_ORDER_RETURN_COMPLETED',
  OrderStateGroupTypeOrderReturnInProgress = 'ORDER_STATE_GROUP_TYPE_ORDER_RETURN_IN_PROGRESS',
  OrderStateGroupTypeOrderReturnPlaced = 'ORDER_STATE_GROUP_TYPE_ORDER_RETURN_PLACED',
  OrderStateGroupTypeUnknown = 'ORDER_STATE_GROUP_TYPE_UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderRequest_Input = {
  /** Authorization context. */
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** OrderChange token from GetOrderCancellationPolicyListResponse. Optional for certain policy inputs. */
  orderChangeToken?: InputMaybe<Scalars['String']>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  orderRescheduleReason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Reschedules_OrderRescheduleReason>;
  /**
   * OrderReschedulePolicyInput from GetOrderCancellationPolicyListResponse.
   * TODO(FUL-174701): deprecate for `order_reschedule_reason`
   */
  reason?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SupportRescheduleDeliveryReason>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Service option token to reschedule to. */
  serviceOptionToken?: InputMaybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_RescheduleDashboardOrderResponse';
  operation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

/** Amounts provided by the retailer. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_RetailerProvidedAmounts = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_RetailerProvidedAmounts';
  bagLabel: Maybe<Scalars['String']>;
};

/** Information about the shopper assigned to the order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_ShopperInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_ShopperInformation';
  avatarUrl: Maybe<Scalars['String']>;
  carModelAndColor: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  /** Parent shopper name (Device Name), populated only for bulk (e.g. truck) delivery made by partner managed drivers. */
  partnerManagedShopperDeviceName: Maybe<Scalars['String']>;
  /** Device phone number, populated only for bulk (e.g. truck) delivery made by partner managed drivers. */
  partnerManagedShopperPhoneNumber: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_DashboardUserSearchResult = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_dashboard_users_DashboardUserSearchResult';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  lastName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_EmailSearchScenario_Input = {
  emailIdentifier?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * For email/phone, we map 1:1 to ListUsersByPersonalIdentifiersRequest from
 * carrot/shared/protos/instacart/customers/users/v1/users.proto
 * For Loyalty ID, we handle by translating User IDs <-> Loyalty IDs in the Loyalty Service.
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_Input = {
  emailSearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_EmailSearchScenario_Input>;
  loyaltySearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_LoyaltySearchScenario_Input>;
  paginationInfo?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PaginationInfo_Input>;
  phoneSearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PhoneSearchScenario_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_LoyaltySearchScenario_Input = {
  loyaltyCardIdentifier?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PhoneSearchScenario_Input = {
  phoneIdentifier?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing a list of user search results. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_dashboard_users_get_dashboard_user_search_result_list_DashboardUserSearchResultListResponse';
  paginationInfo: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse_PaginationInfo>;
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_DashboardUserSearchResult>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse_PaginationInfo = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_dashboard_users_get_dashboard_user_search_result_list_DashboardUserSearchResultListResponse_PaginationInfo';
  /** The last cursor of the current page */
  after: Maybe<Scalars['String']>;
  /** Indicates if there is a next page */
  hasNextPage: Maybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_EnterpriseServiceOption';
  asapWindow: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  availability: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_OptionAvailability>;
  date: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  immediateWindow: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ImmediateWindow>;
  priorityEtaWindow: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  scheduledWindow: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  serviceOptionReference: Maybe<Scalars['String']>;
  standardEtaWindow: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  type: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOptionType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOptionType {
  EnterpriseServiceOptionTypeAsap = 'ENTERPRISE_SERVICE_OPTION_TYPE_ASAP',
  EnterpriseServiceOptionTypeImmediate = 'ENTERPRISE_SERVICE_OPTION_TYPE_IMMEDIATE',
  EnterpriseServiceOptionTypePriorityEta = 'ENTERPRISE_SERVICE_OPTION_TYPE_PRIORITY_ETA',
  EnterpriseServiceOptionTypeScheduled = 'ENTERPRISE_SERVICE_OPTION_TYPE_SCHEDULED',
  EnterpriseServiceOptionTypeStandardEta = 'ENTERPRISE_SERVICE_OPTION_TYPE_STANDARD_ETA',
  EnterpriseServiceOptionTypeUnspecified = 'ENTERPRISE_SERVICE_OPTION_TYPE_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ImmediateWindow = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_EnterpriseServiceOption_ImmediateWindow';
  endsAt: Maybe<Scalars['DateTime']>;
  immediateHour: Maybe<Scalars['BigInt']>;
  startsAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_EnterpriseServiceOption_ScheduledWindow';
  asap: Maybe<Scalars['Boolean']>;
  endsAt: Maybe<Scalars['DateTime']>;
  startsAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_OptionAvailability = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_OptionAvailability';
  isAvailable: Maybe<Scalars['Boolean']>;
  itemCodes: Maybe<Array<Maybe<Scalars['String']>>>;
  unavailabilityReasons: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_DeliveryServiceOption_Input = {
  address?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedAddress_Input>;
  /** optional location_code; if not provided, we will use `address` to find the closest retailer location */
  locationCode?: InputMaybe<Scalars['String']>;
  requestedWindowsWrapper?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindowsWrapper_Input>;
  withPriorityEtaOptions?: InputMaybe<Scalars['Boolean']>;
  withStandardEtaOptions?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  delivery?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_DeliveryServiceOption_Input>;
  earliestOptionStartsAt?: InputMaybe<Scalars['DateTime']>;
  orderItems?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Input>>>;
  pickup?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_PickupServiceOption_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_get_enterprise_service_option_list_GetEnterpriseServiceOptionListResponse';
  flags: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse_Flags>;
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption>>>;
  warnings: Maybe<Array<Maybe<Scalars['String']>>>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse_Flags = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_get_enterprise_service_option_list_GetEnterpriseServiceOptionListResponse_Flags';
  isLongDistanceDelivery: Maybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_PickupServiceOption_Input = {
  locationCode?: InputMaybe<Scalars['String']>;
  /** TODO: why is this needed for pickup? */
  withStandardEtaOptions?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedAddress_Input = {
  addressLinePrimary?: InputMaybe<Scalars['String']>;
  addressLineSecondary?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Input = {
  /**
   * Depending on the item's catalog configuration, either this field or 'count' is required.
   * The API interprets this value as whatever unit of measure is defined for the item in the catalog,
   * such as lb or kg. Must be a non-negative number.
   * https://docs.instacart.com/connect/fulfillment_guide/concepts/product_quantity#specifying-product-quantity-for-an-order
   */
  count?: InputMaybe<Scalars['BigInt']>;
  /** The item being requested. */
  item?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Item_Input>;
  /** The item's line number in the order. */
  lineNum?: InputMaybe<Scalars['String']>;
  /** The item-level metadata. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /**
   * A list of requested replacement items if the original item could not be found.
   * This field needs to be enabled via Retailer configuration.
   */
  replacementItems?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Item_Input>>>;
  /** The policy for handling item replacements. */
  replacementPolicy?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_ReplacementPolicy>;
  /** Any special instructions about the item selection. */
  specialInstructions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Item_Input = {
  /** The Retailer Reference Code (RRC) of the item. */
  rrc?: InputMaybe<Scalars['String']>;
  /** The Universal Product Code (UPC) of the item. */
  upc?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_ReplacementPolicy {
  ReplacementPolicyNoReplacement = 'REPLACEMENT_POLICY_NO_REPLACEMENT',
  ReplacementPolicyShopperChoice = 'REPLACEMENT_POLICY_SHOPPER_CHOICE',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ReplacementPolicyUserChoice = 'REPLACEMENT_POLICY_USER_CHOICE'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindow_Input = {
  endsAt?: InputMaybe<Scalars['DateTime']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

/**
 * Copied from instacart/customers/availability/v1/availability.proto
 * Want this wrapper so that we can differentiate between nil and empty array:
 * * Passing in nil means that the caller doesn't want to utilize desired windows filtering; returns default options.
 * * Passing in empty array means that there is something wrong with the input, which results in returning blackouts
 * and errors. This input should be purposefully avoided and only utilized for unsuspected error catching.
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindowsWrapper_Input = {
  requestedWindows?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindow_Input>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_operations_Operation';
  error: Maybe<Instacart_Enterprise_Frigate_Types_V1_TypedErrorsResponse>;
  isDone: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  value: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_ResultValue>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_ResultValue = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_operations_ResultValue';
  /** Reference to the delivery. */
  deliveryReference: Maybe<Scalars['String']>;
  /** Reference to the new revision. */
  revisionReference: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationRequest_Input = {
  /** The name of the operation resource. This is passed back in an Operation response. */
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_operations_get_operation_GetOperationResponse';
  operation: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

/** mirrors `instacart.customers.commerce.types.v1.OrderCancellationCategory` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationCategory {
  OrderCancellationCategoryCustomerResponsible = 'ORDER_CANCELLATION_CATEGORY_CUSTOMER_RESPONSIBLE',
  OrderCancellationCategoryInstacartPolicyEnforcement = 'ORDER_CANCELLATION_CATEGORY_INSTACART_POLICY_ENFORCEMENT',
  OrderCancellationCategoryIntacartUnbatchable = 'ORDER_CANCELLATION_CATEGORY_INTACART_UNBATCHABLE',
  OrderCancellationCategoryOtherCancellationCategory = 'ORDER_CANCELLATION_CATEGORY_OTHER_CANCELLATION_CATEGORY',
  OrderCancellationCategoryRetailerStoreIssue = 'ORDER_CANCELLATION_CATEGORY_RETAILER_STORE_ISSUE',
  OrderCancellationCategoryShopperRequested = 'ORDER_CANCELLATION_CATEGORY_SHOPPER_REQUESTED',
  OrderCancellationCategoryUnspecified = 'ORDER_CANCELLATION_CATEGORY_UNSPECIFIED'
}

/**
 * Contains a reason and optional comment for customer-initiated cancellations.
 * mirrors `instacart.customers.commerce.types.v1.CustomerCancelReason`
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_order_cancellations_OrderCancellationReason';
  /** The main reason why the cancellation was performed */
  customerReason: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_CustomerReason>;
  /** Specific comment added by the customer, used only when customer_reason is 'other' */
  otherComment: Maybe<Scalars['String']>;
};

/** Enumerates the reasons a customer may choose to cancel an order. */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_CustomerReason {
  /** Customer wants to cancel the current order and place a new one. */
  CustomerReasonCancelAndReorder = 'CUSTOMER_REASON_CANCEL_AND_REORDER',
  /** Want to modify the delivery time. */
  CustomerReasonChangeDeliveryTime = 'CUSTOMER_REASON_CHANGE_DELIVERY_TIME',
  /** Want to modify the pickup time. */
  CustomerReasonChangePickupTime = 'CUSTOMER_REASON_CHANGE_PICKUP_TIME',
  /** Customer no longer needs the specific order. */
  CustomerReasonDoNotNeedThisOrderAnymore = 'CUSTOMER_REASON_DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Inventory items were not available. */
  CustomerReasonItemsWereOutOfStock = 'CUSTOMER_REASON_ITEMS_WERE_OUT_OF_STOCK',
  /** The order is duplicated by the customer. */
  CustomerReasonICreatedADuplicateOrder = 'CUSTOMER_REASON_I_CREATED_A_DUPLICATE_ORDER',
  /** Customer no longer requires the order. */
  CustomerReasonIDoNotNeedThisOrderAnymore = 'CUSTOMER_REASON_I_DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Customer wants to change the order. */
  CustomerReasonIWantToChangeMyOrder = 'CUSTOMER_REASON_I_WANT_TO_CHANGE_MY_ORDER',
  /** Order scheduled for delivery too late. */
  CustomerReasonLateOrder = 'CUSTOMER_REASON_LATE_ORDER',
  /** Customer needs to modify the items in the order. */
  CustomerReasonNeedToAddOrRemoveItems = 'CUSTOMER_REASON_NEED_TO_ADD_OR_REMOVE_ITEMS',
  /** Customer needs to reschedule the order. */
  CustomerReasonNeedToReschedule = 'CUSTOMER_REASON_NEED_TO_RESCHEDULE',
  /** Rescheduled delivery time didn't work. */
  CustomerReasonNewTimeDidNotWorkDelivery = 'CUSTOMER_REASON_NEW_TIME_DID_NOT_WORK_DELIVERY',
  /** Rescheduled pickup time didn't work. */
  CustomerReasonNewTimeDidNotWorkPickup = 'CUSTOMER_REASON_NEW_TIME_DID_NOT_WORK_PICKUP',
  /** Delivery is taking too long. */
  CustomerReasonOrderTakingTooLong = 'CUSTOMER_REASON_ORDER_TAKING_TOO_LONG',
  /** Other unspecified reasons. */
  CustomerReasonOther = 'CUSTOMER_REASON_OTHER',
  /** Redirection for unspecified reason. */
  CustomerReasonOtherRedirect = 'CUSTOMER_REASON_OTHER_REDIRECT',
  /** Switch to delivery instead of pickup. */
  CustomerReasonSwitchToDelivery = 'CUSTOMER_REASON_SWITCH_TO_DELIVERY',
  /** Switch to pickup instead of delivery. */
  CustomerReasonSwitchToPickup = 'CUSTOMER_REASON_SWITCH_TO_PICKUP',
  /** General issue with the order. */
  CustomerReasonThereIsAProblemWithMyOrder = 'CUSTOMER_REASON_THERE_IS_A_PROBLEM_WITH_MY_ORDER',
  /** Order is pricier than expected. */
  CustomerReasonTooExpensive = 'CUSTOMER_REASON_TOO_EXPENSIVE',
  /** Too many replacements in the order. */
  CustomerReasonTooManyReplacements = 'CUSTOMER_REASON_TOO_MANY_REPLACEMENTS',
  /** Customer reason isn't specified. */
  CustomerReasonUnspecified = 'CUSTOMER_REASON_UNSPECIFIED',
  /** Incorrect delivery address in a different city. */
  CustomerReasonWrongAddressDifferentCity = 'CUSTOMER_REASON_WRONG_ADDRESS_DIFFERENT_CITY',
  /** Incorrect delivery address within the same city. */
  CustomerReasonWrongAddressSameCity = 'CUSTOMER_REASON_WRONG_ADDRESS_SAME_CITY',
  /** Wrong delivery location specified in the order. */
  CustomerReasonWrongDeliveryLocation = 'CUSTOMER_REASON_WRONG_DELIVERY_LOCATION',
  /** Wrong payment method. */
  CustomerReasonWrongPaymentMethod = 'CUSTOMER_REASON_WRONG_PAYMENT_METHOD',
  /** Wrong payment details or tip adjustment. */
  CustomerReasonWrongPaymentOrChangeTip = 'CUSTOMER_REASON_WRONG_PAYMENT_OR_CHANGE_TIP',
  /** Wrong location for order pickup. */
  CustomerReasonWrongPickupLocation = 'CUSTOMER_REASON_WRONG_PICKUP_LOCATION',
  /** Incorrect store location was chosen. */
  CustomerReasonWrongRetailerLocation = 'CUSTOMER_REASON_WRONG_RETAILER_LOCATION'
}

/**
 * Contains a reason and optional comment for customer-initiated cancellations.
 * mirrors `instacart.customers.commerce.types.v1.CustomerCancelReason`
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_Input = {
  /** The main reason why the cancellation was performed */
  customerReason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_CustomerReason>;
  /** Specific comment added by the customer, used only when customer_reason is 'other' */
  otherComment?: InputMaybe<Scalars['String']>;
};

/**
 * The specific reason why the order is canceled.
 * mirrors `instacart.customers.commerce.types.v1.OrderCancellationType`
 */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType {
  /** Admin Refund. */
  OrderCancellationTypeAdminRefund = 'ORDER_CANCELLATION_TYPE_ADMIN_REFUND',
  /** Audit failure in bypass checkout. */
  OrderCancellationTypeAuditFailureInBypassCheckout = 'ORDER_CANCELLATION_TYPE_AUDIT_FAILURE_IN_BYPASS_CHECKOUT',
  /** Auto cancellation from order management workflow */
  OrderCancellationTypeAutoCompletionCancellation = 'ORDER_CANCELLATION_TYPE_AUTO_COMPLETION_CANCELLATION',
  /** Unrecoverable error during BJS bypass. */
  OrderCancellationTypeBjsBypassUnrecoverableError = 'ORDER_CANCELLATION_TYPE_BJS_BYPASS_UNRECOVERABLE_ERROR',
  /** Cancellation due to blocked completion. */
  OrderCancellationTypeBlockedCompletionCancellation = 'ORDER_CANCELLATION_TYPE_BLOCKED_COMPLETION_CANCELLATION',
  /** Order canceled by the customer. */
  OrderCancellationTypeCanceledByCustomer = 'ORDER_CANCELLATION_TYPE_CANCELED_BY_CUSTOMER',
  /** Order canceled by the retailer. */
  OrderCancellationTypeCancelledByRetailer = 'ORDER_CANCELLATION_TYPE_CANCELLED_BY_RETAILER',
  /** Order canceled via script. */
  OrderCancellationTypeCancelledViaScript = 'ORDER_CANCELLATION_TYPE_CANCELLED_VIA_SCRIPT',
  /** Card declined during reauthorization. */
  OrderCancellationTypeCardDeclineOnReauth = 'ORDER_CANCELLATION_TYPE_CARD_DECLINE_ON_REAUTH',
  /** Cancellation due to a car accident. */
  OrderCancellationTypeCarAccident = 'ORDER_CANCELLATION_TYPE_CAR_ACCIDENT',
  /** Cancellation due to car issues. */
  OrderCancellationTypeCarIssue = 'ORDER_CANCELLATION_TYPE_CAR_ISSUE',
  /** Payment method needed to be changed. */
  OrderCancellationTypeChangePaymentMethod = 'ORDER_CANCELLATION_TYPE_CHANGE_PAYMENT_METHOD',
  /** Customer faced issues with app navigation. */
  OrderCancellationTypeCustomerAppNavigationIssue = 'ORDER_CANCELLATION_TYPE_CUSTOMER_APP_NAVIGATION_ISSUE',
  /** Customer MIA. */
  OrderCancellationTypeCustomerMia = 'ORDER_CANCELLATION_TYPE_CUSTOMER_MIA',
  /** Customer is missing in action during drop-off. */
  OrderCancellationTypeCustomerMiaOnDropOffOrder = 'ORDER_CANCELLATION_TYPE_CUSTOMER_MIA_ON_DROP_OFF_ORDER',
  /** Customer requested cancellation because the order is early. */
  OrderCancellationTypeCustomerRequestedSinceOrderIsEarly = 'ORDER_CANCELLATION_TYPE_CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested cancellation because the order is late. */
  OrderCancellationTypeCustomerRequestedSinceOrderIsLate = 'ORDER_CANCELLATION_TYPE_CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Customer requested to cancel the order. */
  OrderCancellationTypeCustomerRequestToCancel = 'ORDER_CANCELLATION_TYPE_CUSTOMER_REQUEST_TO_CANCEL',
  /** Order delivered outside the scheduled window. */
  OrderCancellationTypeDeliveredOutsideOfWindow = 'ORDER_CANCELLATION_TYPE_DELIVERED_OUTSIDE_OF_WINDOW',
  /**
   * Order canceled due to cancellation of a related dependent order.
   * E.g. in the case of a party order, if the host order is canceled we may cancel the member orders.
   */
  OrderCancellationTypeDependentOrderCanceled = 'ORDER_CANCELLATION_TYPE_DEPENDENT_ORDER_CANCELED',
  /** Duplicate order. */
  OrderCancellationTypeDuplicateOrder = 'ORDER_CANCELLATION_TYPE_DUPLICATE_ORDER',
  /** Cancellation due to an emergency. */
  OrderCancellationTypeEmergency = 'ORDER_CANCELLATION_TYPE_EMERGENCY',
  /** Empty Delivery. */
  OrderCancellationTypeEmptyDelivery = 'ORDER_CANCELLATION_TYPE_EMPTY_DELIVERY',
  /** Cancellation due to failed completion. */
  OrderCancellationTypeFailedCompletionCancellation = 'ORDER_CANCELLATION_TYPE_FAILED_COMPLETION_CANCELLATION',
  /** Fraudulent Customer. */
  OrderCancellationTypeFraudulentCustomer = 'ORDER_CANCELLATION_TYPE_FRAUDULENT_CUSTOMER',
  /** Fulfillment initiated due to out-of-stock items. */
  OrderCancellationTypeFulfillmentInitiatedDueToOutOfStock = 'ORDER_CANCELLATION_TYPE_FULFILLMENT_INITIATED_DUE_TO_OUT_OF_STOCK',
  /** Incorrect accessibility information. */
  OrderCancellationTypeIncorrectAccessibilityInformation = 'ORDER_CANCELLATION_TYPE_INCORRECT_ACCESSIBILITY_INFORMATION',
  /** Incorrect customer information. */
  OrderCancellationTypeIncorrectCustomerInformation = 'ORDER_CANCELLATION_TYPE_INCORRECT_CUSTOMER_INFORMATION',
  /** All items refunded in an Instacart Connect order. */
  OrderCancellationTypeInstacartConnectOrderWithAllItemsRefunded = 'ORDER_CANCELLATION_TYPE_INSTACART_CONNECT_ORDER_WITH_ALL_ITEMS_REFUNDED',
  /** Failed to get a suspended transaction for Kroger Connect. */
  OrderCancellationTypeKrogerConnectFailedToGetSuspendedTransaction = 'ORDER_CANCELLATION_TYPE_KROGER_CONNECT_FAILED_TO_GET_SUSPENDED_TRANSACTION',
  /** Manual fraud. */
  OrderCancellationTypeManualFraud = 'ORDER_CANCELLATION_TYPE_MANUAL_FRAUD',
  /** Mass cancellation of orders. */
  OrderCancellationTypeMassCancellation = 'ORDER_CANCELLATION_TYPE_MASS_CANCELLATION',
  /** Missing charge log for delivery. */
  OrderCancellationTypeMissingChargeLogForDelivery = 'ORDER_CANCELLATION_TYPE_MISSING_CHARGE_LOG_FOR_DELIVERY',
  /** No cancellation reason specified. */
  OrderCancellationTypeNone = 'ORDER_CANCELLATION_TYPE_NONE',
  /** Online Payment Failure. */
  OrderCancellationTypeOnlinePayFailure = 'ORDER_CANCELLATION_TYPE_ONLINE_PAY_FAILURE',
  /** Cancellation due to other unspecified reasons. */
  OrderCancellationTypeOtherCancellationType = 'ORDER_CANCELLATION_TYPE_OTHER_CANCELLATION_TYPE',
  /** Order is in pre-picking stage. */
  OrderCancellationTypePrePicking = 'ORDER_CANCELLATION_TYPE_PRE_PICKING',
  /** Cancellation due to related accounts fraud abuse. */
  OrderCancellationTypeRelatedAccountsAbuse = 'ORDER_CANCELLATION_TYPE_RELATED_ACCOUNTS_ABUSE',
  /** Retailer initiated cancellation because the customer is MIA. */
  OrderCancellationTypeRetailerInitiatedCustomerMia = 'ORDER_CANCELLATION_TYPE_RETAILER_INITIATED_CUSTOMER_MIA',
  /** Retailer initiated cancellation due to out-of-stock items. */
  OrderCancellationTypeRetailerInitiatedOutOfStock = 'ORDER_CANCELLATION_TYPE_RETAILER_INITIATED_OUT_OF_STOCK',
  /** Cancellation due to safety concerns. */
  OrderCancellationTypeSafetyConcerns = 'ORDER_CANCELLATION_TYPE_SAFETY_CONCERNS',
  /** Cancellation due to a severe weather event. */
  OrderCancellationTypeSevereWeatherEvent = 'ORDER_CANCELLATION_TYPE_SEVERE_WEATHER_EVENT',
  /** Shopper couldn't locate the delivery address. */
  OrderCancellationTypeShopperCouldNotFindAddress = 'ORDER_CANCELLATION_TYPE_SHOPPER_COULD_NOT_FIND_ADDRESS',
  /** Shopper initiated cancellation due to out-of-stock items. */
  OrderCancellationTypeShopperInitiatedOutOfStock = 'ORDER_CANCELLATION_TYPE_SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Shopper is unable to complete the order. */
  OrderCancellationTypeShopperUnableToCompleteOrder = 'ORDER_CANCELLATION_TYPE_SHOPPER_UNABLE_TO_COMPLETE_ORDER',
  /** Single item order is out of stock. */
  OrderCancellationTypeSingleItemOrderOutOfStock = 'ORDER_CANCELLATION_TYPE_SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Early closure of store. */
  OrderCancellationTypeStoreEarlyClosure = 'ORDER_CANCELLATION_TYPE_STORE_EARLY_CLOSURE',
  /** Store experiencing an outage. */
  OrderCancellationTypeStoreOutage = 'ORDER_CANCELLATION_TYPE_STORE_OUTAGE',
  /** Too many items are out of stock. */
  OrderCancellationTypeTooManyOutOfStockItem = 'ORDER_CANCELLATION_TYPE_TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements in the order. */
  OrderCancellationTypeTooManyReplacements = 'ORDER_CANCELLATION_TYPE_TOO_MANY_REPLACEMENTS',
  /** Cancellation due to traffic conditions. */
  OrderCancellationTypeTrafficConditions = 'ORDER_CANCELLATION_TYPE_TRAFFIC_CONDITIONS',
  /** Unable to reschedule the order as no options were available. */
  OrderCancellationTypeUnableToRescheduleAsNoOptionFound = 'ORDER_CANCELLATION_TYPE_UNABLE_TO_RESCHEDULE_AS_NO_OPTION_FOUND',
  /** Unable to reschedule due to unbatchable order. */
  OrderCancellationTypeUnableToRescheduleUnbatchable = 'ORDER_CANCELLATION_TYPE_UNABLE_TO_RESCHEDULE_UNBATCHABLE',
  /** Order is unbatchable. */
  OrderCancellationTypeUnbatchable = 'ORDER_CANCELLATION_TYPE_UNBATCHABLE',
  /** Unspecified cancellation type. */
  OrderCancellationTypeUnspecified = 'ORDER_CANCELLATION_TYPE_UNSPECIFIED',
  /** Incorrect store operating hours. */
  OrderCancellationTypeWrongStoreHours = 'ORDER_CANCELLATION_TYPE_WRONG_STORE_HOURS'
}

/** mirrors `instacart.customers.commerce.types.v1.SupportRescheduleDeliveryReason` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Reschedules_OrderRescheduleReason {
  /** Customer is missing in action. */
  OrderRescheduleReasonCustomerMia = 'ORDER_RESCHEDULE_REASON_CUSTOMER_MIA',
  /** Customer requested since order is early. */
  OrderRescheduleReasonCustomerRequestedSinceOrderIsEarly = 'ORDER_RESCHEDULE_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested since order is late. */
  OrderRescheduleReasonCustomerRequestedSinceOrderIsLate = 'ORDER_RESCHEDULE_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Incorrect customer information was provided. */
  OrderRescheduleReasonIncorrectCustomerInformation = 'ORDER_RESCHEDULE_REASON_INCORRECT_CUSTOMER_INFORMATION',
  /** Retailer initiated out of stock. */
  OrderRescheduleReasonRetailerInitiatedOutOfStock = 'ORDER_RESCHEDULE_REASON_RETAILER_INITIATED_OUT_OF_STOCK',
  /** Shopper initiated out of stock. */
  OrderRescheduleReasonShopperInitiatedOutOfStock = 'ORDER_RESCHEDULE_REASON_SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Single item in the order was out of stock. */
  OrderRescheduleReasonSingleItemOrderOutOfStock = 'ORDER_RESCHEDULE_REASON_SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Store early closure. */
  OrderRescheduleReasonStoreEarlyClosure = 'ORDER_RESCHEDULE_REASON_STORE_EARLY_CLOSURE',
  /** Store outage. */
  OrderRescheduleReasonStoreOutage = 'ORDER_RESCHEDULE_REASON_STORE_OUTAGE',
  /** Too many items out of stock. */
  OrderRescheduleReasonTooManyOutOfStockItem = 'ORDER_RESCHEDULE_REASON_TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements. */
  OrderRescheduleReasonTooManyReplacements = 'ORDER_RESCHEDULE_REASON_TOO_MANY_REPLACEMENTS',
  /** Unspecified. */
  OrderRescheduleReasonUnspecified = 'ORDER_RESCHEDULE_REASON_UNSPECIFIED',
  /** Wrong store hours. */
  OrderRescheduleReasonWrongStoreHours = 'ORDER_RESCHEDULE_REASON_WRONG_STORE_HOURS'
}

/** mirrors `instacart.customers.product_retrieval.v1.catalog.v1.ClientSourceType` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ClientSourceType {
  CaperNativeFeed = 'CAPER_NATIVE_FEED',
  ClientSourceTypeUnspecified = 'CLIENT_SOURCE_TYPE_UNSPECIFIED',
  CommerceDiscountIcBirdzi = 'COMMERCE_DISCOUNT_IC_BIRDZI',
  CommerceDiscountIcLms = 'COMMERCE_DISCOUNT_IC_LMS'
}

/** mirrors `instacart.customers.product_retrieval.v1.catalog.v1.CodeType` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_CodeType {
  CodeTypeUnspecified = 'CODE_TYPE_UNSPECIFIED',
  ExternalIntegrationId = 'EXTERNAL_INTEGRATION_ID',
  LookupCodeNormalized = 'LOOKUP_CODE_NORMALIZED',
  LookupCodeRaw = 'LOOKUP_CODE_RAW',
  RetailerReferenceCode = 'RETAILER_REFERENCE_CODE'
}

/** Debug options for including additional query information in responses. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Debug_Input = {
  shouldIncludeNode?: InputMaybe<Scalars['Boolean']>;
  shouldIncludeParameterizedSql?: InputMaybe<Scalars['Boolean']>;
  shouldIncludeRawSql?: InputMaybe<Scalars['Boolean']>;
};

/** mirrors `instacart.customers.product_retrieval.v1.RequestMeta`, see for more domain context */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Input = {
  /** The debug information requested for the request */
  debug?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Debug_Input>;
  /** The tier of the request indicating its business criticality level */
  requestTier?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_RequestTier>;
  /**
   * The call source of the request.  This is used for rate limiting and event
   * logging. This should be a STATIC string that can be searched for in a code repository.
   * Do NOT dynamically change this value as it will break rate limiting.
   */
  src?: InputMaybe<Scalars['String']>;
  /**
   * The variant of the src used for tracking different variations of an API call. You can use this
   * to track request counts/latency differences across different variations of a query.
   */
  srcVariant?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_RequestTier {
  /**
   * Tier 0 - Highest priority, critical requests that must be served
   * Examples: Order placement, checkout flows
   */
  RequestTier_0 = 'REQUEST_TIER_0',
  /** Tier 1 - High priority requests */
  RequestTier_1 = 'REQUEST_TIER_1',
  /** Tier 2 - Medium priority requests */
  RequestTier_2 = 'REQUEST_TIER_2',
  /** Tier 3 - Low priority requests */
  RequestTier_3 = 'REQUEST_TIER_3',
  /** Tier 4 - Lowest priority requests */
  RequestTier_4 = 'REQUEST_TIER_4',
  /** Default value - should not be used explicitly, helps us uncover requests not setting the tier */
  RequestTierUnspecified = 'REQUEST_TIER_UNSPECIFIED'
}

/** mirrors `instacart.customers.product_retrieval.v1.ResponseMeta`, see for more domain context */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata';
  debug: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug>;
};

/** Debug information included in the response when requested. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata_Debug';
  /** The node information for the query */
  node: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Node>;
  /** The SQL information for the query */
  sql: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Sql>;
};

/** Information about the database node that executed the query. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Node = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata_Debug_Node';
  /** The cluster that the query was executed on */
  cluster: Maybe<Scalars['String']>;
  /** The replica that the query was executed on */
  replica: Maybe<Scalars['Int']>;
  /** The shard that the query was executed on */
  shard: Maybe<Scalars['Int']>;
};

/** Information about the SQL query that was executed. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Sql = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata_Debug_SQL';
  /** The parameterized SQL that was executed, has the parameters replaced with placeholders */
  parameterizedSql: Maybe<Scalars['String']>;
  /** The parameters that were used in the parameterized SQL */
  parameters: Maybe<Array<Maybe<Google_Protobuf_Value>>>;
  /** The raw SQL that was executed, has the parameters directly in the SQL */
  rawSql: Maybe<Scalars['String']>;
};

/** Represents a single message in an enterprise chat conversation. */
export type Instacart_Enterprise_Frigate_Post_Checkout_V1_EnterpriseChatMessage = {
  __typename?: 'instacart_enterprise_frigate_post_checkout_v1_EnterpriseChatMessage';
  /** The body of the message. */
  body: Maybe<Scalars['String']>;
  /** The time of creation. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The ID of the message. */
  id: Maybe<Scalars['BigInt']>;
  /**
   * The URL of the image in the message.
   * e.g. https://d2syimmrmqkckt.cloudfront.net/chatmessage/image/254f4bf8-2d13-11ec-8d3d-0242ac130003.jpg
   */
  image: Maybe<Scalars['String']>;
  /** The order delivery ID. */
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  /** Whether or not the message was read. */
  read: Maybe<Scalars['Boolean']>;
  /** Time the message was read at. */
  readAt: Maybe<Scalars['DateTime']>;
  /** The recipient ID. */
  recipientId: Maybe<Scalars['BigInt']>;
  /** The type of recipient. */
  recipientType: Maybe<Scalars['String']>;
  /** The avatar URL of the sender. */
  senderAvatarUrl: Maybe<Scalars['String']>;
  /** The display name of the sender. */
  senderDisplayName: Maybe<Scalars['String']>;
  /** The sender ID. */
  senderId: Maybe<Scalars['BigInt']>;
  /** The type of sender. */
  senderType: Maybe<Scalars['String']>;
};

/** Request message for retrieving enterprise chat messages for a specific order delivery. */
export type Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** The order delivery ID associated with the conversation. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

/** Response message containing the list of chat messages for an order delivery conversation. */
export type Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListResponse = {
  __typename?: 'instacart_enterprise_frigate_post_checkout_v1_GetEnterpriseChatMessageListResponse';
  /** If the messages are from an order too old/expired */
  isExpired: Maybe<Scalars['Boolean']>;
  /** The messages of the conversation. */
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Post_Checkout_V1_EnterpriseChatMessage>>>;
};

/** Request message for creating a new partner-managed shift (either recurring or single). */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_Input = {
  deleteConflictingShifts?: InputMaybe<Scalars['Boolean']>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  isOnCall?: InputMaybe<Scalars['Boolean']>;
  recurringShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_RecurringShiftRequest_Input>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shiftType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  singleShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_SingleShiftRequest_Input>;
};

/** Request details for creating a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_RecurringShiftRequest_Input = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  recurEndDate?: InputMaybe<Google_Type_Date_Input>;
  recurStartDate?: InputMaybe<Google_Type_Date_Input>;
  shiftLengthSeconds?: InputMaybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight?: InputMaybe<Scalars['BigInt']>;
};

/** Request details for creating a single shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_SingleShiftRequest_Input = {
  date?: InputMaybe<Google_Type_Date_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

/** Response message after creating a partner-managed shift, including any conflicts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_CreatePartnerManagedShiftResponse';
  createShiftConflicts: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftConflict>>>;
  shiftId: Maybe<Scalars['BigInt']>;
};

/** Request message for deleting a partner-managed shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_Input = {
  recurringShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_RecurringShiftRequest_Input>;
  shiftId?: InputMaybe<Scalars['BigInt']>;
  singleShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_SingleShiftRequest_Input>;
};

/** Request details for deleting a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_RecurringShiftRequest_Input = {
  deleteShiftsFromDate?: InputMaybe<Google_Type_Date_Input>;
};

/** Request details for deleting a single shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_SingleShiftRequest_Input = {
  driverId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message after deleting a partner-managed shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_DeletePartnerManagedShiftResponse';
  isSuccess: Maybe<Scalars['Boolean']>;
};

/** Request to get presigned file upload URL */
export type Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlRequest_Input = {
  fileContentType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for getting presigned file upload URL */
export type Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GeneratePresignedFileUploadUrlResponse';
  /** StringValue instead of Struct to avoid automatic key transforms (e.g. x-amz-signature -> xAmzSignature) */
  uploadFieldsJson: Maybe<Scalars['String']>;
  uploadUrl: Maybe<Scalars['String']>;
};

/** Request message for generating shifts report */
export type Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportRequest_Input = {
  /** End date for the report period (optional) */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Abandoned do not use. Should use retailer_id */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** User ID of the person requesting the report */
  requestedByUserId?: InputMaybe<Scalars['BigInt']>;
  /** (Required) Identifies the retailer making the request. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Type of schedule to include in the report */
  scheduleType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Start date for the report period (required) */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Uses incorrect naming convention. This field will be removed once the service code is updated. */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** List of warehouse location IDs to include in the report (optional) */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response message for generating shifts report */
export type Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GenerateShiftsReportResponse';
  /**
   * URL to download the generated report file (S3 link)
   * This become optional since we move to a async approach.
   */
  downloadedFileUrl: Maybe<Scalars['String']>;
  /** Shift management operations record ID */
  shiftManagementOpsRecordId: Maybe<Scalars['BigInt']>;
};

/** Request message for retrieving a list of partner-managed shifts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListRequest_Input = {
  date?: InputMaybe<Google_Type_Date_Input>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shiftType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
};

/** Response message containing a list of shoppers with their associated shifts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPartnerManagedShiftListResponse';
  shopperWithShifts: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperWithShifts>>>;
};

/** Cursor for paginating through the shopper list. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPartnerManagedShopperListCursor';
  shopperId: Maybe<Scalars['String']>;
};

/** Cursor for paginating through the shopper list. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor_Input = {
  shopperId?: InputMaybe<Scalars['String']>;
};

/** Filter criteria for querying partner-managed shoppers. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListFilter_Input = {
  /** Filter by device type. UNSPECIFIED means no filtering. */
  deviceType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedDeviceType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  isPartnerPickStoreManager?: InputMaybe<Scalars['Boolean']>;
  isWifiOnly?: InputMaybe<Scalars['Boolean']>;
};

/** Request message for retrieving a paginated list of partner-managed shoppers. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListRequest_Input = {
  cursor?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor_Input>;
  filter?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListFilter_Input>;
  limit?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of partner-managed shoppers and pagination info. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPartnerManagedShopperListResponse';
  cursor: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor>;
  hasNextPage: Maybe<Scalars['Boolean']>;
  shoppers: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopper>>>;
};

/** Request message for getting presigned download URL for cloud file */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlRequest_Input = {
  objectKey?: InputMaybe<Scalars['String']>;
  /** Required. The request context */
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer ID associated with this operation */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for getting presigned download URL for cloud file */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPresignedDownloadUrlResponse';
  signedDownloadUrl: Maybe<Scalars['String']>;
};

/** Request message for getting shift management operation record list */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListRequest_Input = {
  /** Required. Filter by job type. */
  jobType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_JobType>;
  /** Pagination information */
  pagination?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PaginationInfo_Input>;
  /** Required. The retailer ID to filter records by */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Required. Filter by schedule type. */
  scheduleType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Optional. Filter by operation status. If empty, returns all statuses. */
  status?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus>>>;
};

/** Response message for getting shift management operation record list */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetShiftManagementOperationRecordListResponse';
  /** Pagination information for the response */
  pagination: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PaginationResponse>;
  /** The list of shift management operation records */
  results: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationRecord>>>;
  /** Total count of records matching the filter (if available) */
  totalCount: Maybe<Scalars['BigInt']>;
};

/** Request message for getting a shift management operation record by ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordRequest_Input = {
  /** Required. The ID of the operation record to retrieve */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Required. The request context */
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer ID associated with this operation */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for getting a shift management operation record by ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetShiftManagementOperationRecordResponse';
  /** The shift management operation record */
  record: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationRecord>;
};

/** Request message for retrieving staffing allocation data. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListRequest_Input = {
  endDate?: InputMaybe<Google_Type_Date_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shiftType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  startDate?: InputMaybe<Google_Type_Date_Input>;
};

/** Response message containing staffing allocations by date and performance metrics. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetStaffingAllocationListResponse';
  staffingAllocationsByDate: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationByDate>>>;
  staffingPerformanceMetrics: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationMetrics>;
};

/** Request message for retrieving staffing hours by date. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateRequest_Input = {
  date?: InputMaybe<Google_Type_Date_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of staffing hours. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetStaffingHoursListByDateResponse';
  staffingHours: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingHours>>>;
};

/** Job type enum */
export enum Instacart_Enterprise_Frigate_Shifts_V1_JobType {
  JobTypeDownload = 'JOB_TYPE_DOWNLOAD',
  JobTypeUnknown = 'JOB_TYPE_UNKNOWN',
  JobTypeUpload = 'JOB_TYPE_UPLOAD'
}

/** Metadata about Marqeta cards associated with a shopper. */
export type Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadata = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_MarqetaCardMetadata';
  count: Maybe<Scalars['Int']>;
  type: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadataType>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadataType {
  MarqetaCardMetadataTypeDigital = 'MARQETA_CARD_METADATA_TYPE_DIGITAL',
  MarqetaCardMetadataTypeInactive = 'MARQETA_CARD_METADATA_TYPE_INACTIVE',
  MarqetaCardMetadataTypePhysical = 'MARQETA_CARD_METADATA_TYPE_PHYSICAL',
  MarqetaCardMetadataTypeSuspended = 'MARQETA_CARD_METADATA_TYPE_SUSPENDED',
  MarqetaCardMetadataTypeTerminated = 'MARQETA_CARD_METADATA_TYPE_TERMINATED',
  MarqetaCardMetadataTypeUnknown = 'MARQETA_CARD_METADATA_TYPE_UNKNOWN'
}

/** Operation status enum */
export enum Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus {
  OperationStatusFailed = 'OPERATION_STATUS_FAILED',
  OperationStatusInit = 'OPERATION_STATUS_INIT',
  OperationStatusProcessing = 'OPERATION_STATUS_PROCESSING',
  OperationStatusSuccess = 'OPERATION_STATUS_SUCCESS',
  OperationStatusTimeout = 'OPERATION_STATUS_TIMEOUT',
  OperationStatusUnknown = 'OPERATION_STATUS_UNKNOWN',
  OperationStatusValidated = 'OPERATION_STATUS_VALIDATED',
  OperationStatusValidating = 'OPERATION_STATUS_VALIDATING',
  OperationStatusValidationFailed = 'OPERATION_STATUS_VALIDATION_FAILED'
}

/** Container for vertical-specific overrides to staffing hours. */
export type Instacart_Enterprise_Frigate_Shifts_V1_Overrides = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_Overrides';
  pickupOverrides: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PickupOverrides>;
};

/** Pagination information for requests */
export type Instacart_Enterprise_Frigate_Shifts_V1_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Pagination information for responses */
export type Instacart_Enterprise_Frigate_Shifts_V1_PaginationResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PaginationResponse';
  /** Cursor for the next page */
  after: Maybe<Scalars['String']>;
  /** Whether there are more results available */
  hasNext: Maybe<Scalars['Boolean']>;
};

/** Scenario data returned when shift_type is PARTNER_BULK_DELIVERY_ONLY. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryOnlyScenario = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerBulkDeliveryOnlyScenario';
  routes: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryRoute>>>;
};

/** Delivery route information for a delivery shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryRoute = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerBulkDeliveryRoute';
  batchId: Maybe<Scalars['BigInt']>;
  orderCount: Maybe<Scalars['BigInt']>;
  routeAcceptsOrders: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedDeviceType {
  PartnerManagedDeviceTypePhone = 'PARTNER_MANAGED_DEVICE_TYPE_PHONE',
  PartnerManagedDeviceTypeUnknown = 'PARTNER_MANAGED_DEVICE_TYPE_UNKNOWN',
  PartnerManagedDeviceTypeWifi = 'PARTNER_MANAGED_DEVICE_TYPE_WIFI'
}

/**
 * Common representation of a shift that encapsulates both driver and recurring shifts.
 * This will be used on the UI to display shift grid.
 */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShift = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShift';
  partnerBulkDeliveryOnlyScenario: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryOnlyScenario>;
  recurringShiftProperties: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_RecurringShiftProperties>;
  shiftType: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  singleShiftProperties: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_SingleShiftProperties>;
};

/** Represents a conflict when attempting to create or update a shift that overlaps with an existing shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftConflict = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftConflict';
  conflictingShiftId: Maybe<Scalars['BigInt']>;
  date: Maybe<Google_Type_Date>;
  daysOfWeek: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  endsAt: Maybe<Scalars['DateTime']>;
  shiftLengthSeconds: Maybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight: Maybe<Scalars['BigInt']>;
  shiftType: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  startsAt: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType {
  /** full service maps to legacy `normal` shift type */
  PartnerManagedShiftTypeFullService = 'PARTNER_MANAGED_SHIFT_TYPE_FULL_SERVICE',
  /** partner_bulk_delivery_only */
  PartnerManagedShiftTypePartnerBulkDeliveryOnly = 'PARTNER_MANAGED_SHIFT_TYPE_PARTNER_BULK_DELIVERY_ONLY',
  /** picking_only */
  PartnerManagedShiftTypePickingOnly = 'PARTNER_MANAGED_SHIFT_TYPE_PICKING_ONLY',
  /** runner */
  PartnerManagedShiftTypeRunner = 'PARTNER_MANAGED_SHIFT_TYPE_RUNNER',
  PartnerManagedShiftTypeUnknown = 'PARTNER_MANAGED_SHIFT_TYPE_UNKNOWN'
}

/** Represents a partner-managed shopper with their details and metadata. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopper = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShopper';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  isActive: Maybe<Scalars['Boolean']>;
  isPartnerPickStoreManager: Maybe<Scalars['Boolean']>;
  isWifiOnly: Maybe<Scalars['Boolean']>;
  lastName: Maybe<Scalars['String']>;
  lockedAt: Maybe<Scalars['DateTime']>;
  /** Marqeta card metadata is used in the IPP devices page */
  marqetaCardsMetadata: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadata>>>;
  phoneNumber: Maybe<Scalars['String']>;
  warehouseLocationName: Maybe<Scalars['String']>;
};

/** Sending only a subset of the shopper data to reduce the payload size */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperSummary = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShopperSummary';
  shopperId: Maybe<Scalars['BigInt']>;
  shopperName: Maybe<Scalars['String']>;
};

/** Represents a shopper along with their assigned shifts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperWithShifts = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShopperWithShifts';
  shifts: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShift>>>;
  shopper: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperSummary>;
};

/** Overrides specific to pickup hours. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PickupOverrides = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PickupOverrides';
  earlyPickingTime: Maybe<Scalars['DateTime']>;
};

/** Process type enum for CSV processing */
export enum Instacart_Enterprise_Frigate_Shifts_V1_ProcessType {
  ProcessTypeOneOff = 'PROCESS_TYPE_ONE_OFF',
  ProcessTypeRecurring = 'PROCESS_TYPE_RECURRING',
  ProcessTypeUnknown = 'PROCESS_TYPE_UNKNOWN'
}

/** Request to process uploaded CSV file */
export type Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvRequest_Input = {
  /** Required. Type of processing (one-off or recurring) */
  processType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ProcessType>;
  /** Required. Retailer ID for the CSV processing */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Required. Shift management operations record ID */
  shiftManagementOpsRecordId?: InputMaybe<Scalars['BigInt']>;
  /** Optional. User ID initiating the request */
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for CSV processing request */
export type Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ProcessUploadedCsvResponse';
  /** Shift management operations record ID */
  shiftManagementOpsRecordId: Maybe<Scalars['BigInt']>;
  /** Acknowledgment status of the request */
  statusMessage: Maybe<Scalars['String']>;
};

/** Properties specific to a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_RecurringShiftProperties = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_RecurringShiftProperties';
  /** the days of week that a recurring_shift recurs on */
  daysOfWeek: Maybe<Array<Maybe<GoogleTypeDayOfWeek>>>;
  recurEndDate: Maybe<Scalars['DateTime']>;
  recurStartDate: Maybe<Scalars['DateTime']>;
  recurringShiftId: Maybe<Scalars['BigInt']>;
  shiftLengthSeconds: Maybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight: Maybe<Scalars['BigInt']>;
};

/** Enum for schedule type */
export enum Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType {
  ScheduleTypeOneOff = 'SCHEDULE_TYPE_ONE_OFF',
  ScheduleTypeRecurring = 'SCHEDULE_TYPE_RECURRING',
  ScheduleTypeUnknown = 'SCHEDULE_TYPE_UNKNOWN'
}

/** Represents a shift management operation record */
export type Instacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationRecord = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationRecord';
  /** Timestamp when the record was created */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Error message if the operation failed (optional) */
  errorMessage: Maybe<Scalars['String']>;
  /** Number of rows that failed processing (optional) */
  failedRows: Maybe<Scalars['Int']>;
  /** Unique identifier for the operation record */
  id: Maybe<Scalars['BigInt']>;
  /** Type of operation */
  jobType: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_JobType>;
  /** Cloud file system key for the original file associated with this operation (optional) */
  orgFileLoc: Maybe<Scalars['String']>;
  /** Cloud file system key for the output file (optional) */
  outputFileLoc: Maybe<Scalars['String']>;
  /** End timestamp of the requested date range (optional) */
  requestDateRangeEndsAt: Maybe<Scalars['DateTime']>;
  /** Start timestamp of the requested date range (optional) */
  requestDateRangeStartsAt: Maybe<Scalars['DateTime']>;
  /** ID of the user who requested this operation (optional) */
  requestedById: Maybe<Scalars['BigInt']>;
  /** Name of the user who requested this operation (optional) */
  requestedByUserName: Maybe<Scalars['String']>;
  /** Retailer ID associated with this operation */
  retailerId: Maybe<Scalars['BigInt']>;
  /** Schedule type (one-off or recurring) */
  scheduleType: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Current status of the operation */
  status: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus>;
  /** Number of rows successfully processed (optional) */
  successfulRows: Maybe<Scalars['Int']>;
  /** Summary of the operation (optional) */
  summary: Maybe<Scalars['String']>;
  /** Total number of rows in the operation (optional) */
  totalRows: Maybe<Scalars['Int']>;
  /** Timestamp when the record was last updated */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** List of warehouse location IDs associated with this operation */
  warehouseLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Properties specific to a single (non-recurring) shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_SingleShiftProperties = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_SingleShiftProperties';
  endsAt: Maybe<Scalars['DateTime']>;
  onCall: Maybe<Scalars['Boolean']>;
  singleShiftId: Maybe<Scalars['BigInt']>;
  startsAt: Maybe<Scalars['DateTime']>;
};

/** Represents a staffing allocation time slot with recommended and actual staffing levels. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocation = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingAllocation';
  actual: Maybe<Scalars['Float']>;
  endsAt: Maybe<Scalars['DateTime']>;
  recommended: Maybe<Scalars['Float']>;
  startsAt: Maybe<Scalars['DateTime']>;
};

/** Staffing allocations for a specific date, split by dedicated and on-call. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationByDate = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingAllocationByDate';
  date: Maybe<Google_Type_Date>;
  dedicatedAllocations: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocation>>>;
  oncallAllocations: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocation>>>;
};

/** Performance metrics for staffing allocation. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationMetrics = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingAllocationMetrics';
  matchRate: Maybe<Scalars['Float']>;
  overstaffedHours: Maybe<Scalars['Float']>;
  recommendedHours: Maybe<Scalars['Float']>;
  scheduledDevices: Maybe<Scalars['Float']>;
  scheduledGaps: Maybe<Scalars['Float']>;
  totalHours: Maybe<Scalars['Float']>;
  understaffedHours: Maybe<Scalars['Float']>;
};

/** Represents staffing hours for a specific vertical type with optional overrides. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingHours = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingHours';
  closesAt: Maybe<Scalars['DateTime']>;
  opensAt: Maybe<Scalars['DateTime']>;
  overrides: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_Overrides>;
  timezoneName: Maybe<Scalars['String']>;
  verticalType: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_VerticalType>;
};

/** Request message for unlocking a partner-managed driver's device. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceRequest_Input = {
  shopperId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message after attempting to unlock a driver's device. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_UnlockPartnerManagedDriverDeviceResponse';
  isSuccess: Maybe<Scalars['Boolean']>;
};

/** Request message for updating an existing partner-managed shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_Input = {
  deleteConflictingShifts?: InputMaybe<Scalars['Boolean']>;
  isOnCall?: InputMaybe<Scalars['Boolean']>;
  recurringShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_RecurringShiftRequest_Input>;
  shiftId?: InputMaybe<Scalars['BigInt']>;
  singleShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_SingleShiftRequest_Input>;
};

/** Request details for updating a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_RecurringShiftRequest_Input = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  recurEndDate?: InputMaybe<Google_Type_Date_Input>;
  recurStartDate?: InputMaybe<Google_Type_Date_Input>;
  shiftLengthSeconds?: InputMaybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight?: InputMaybe<Scalars['BigInt']>;
};

/** Request details for updating a single shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_SingleShiftRequest_Input = {
  driverId?: InputMaybe<Scalars['BigInt']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

/** Response message after updating a partner-managed shift, including any conflicts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_UpdatePartnerManagedShiftResponse';
  updateShiftConflicts: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftConflict>>>;
};

/** Request to validate an already-uploaded bulk shift file */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileRequest_Input = {
  /** request without the record ID */
  followupScenario?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestFollowupScenario_Input>;
  /** request with the record ID */
  initialScenario?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestInitialScenario_Input>;
  /** Required request context */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for validating a bulk shift file */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse';
  /** Error payload containing validation errors */
  error: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_ErrorPayload>;
  /** Success payload containing operation record ID */
  success: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_SuccessPayload>;
};

/** Error details for validation failures */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse_Error';
  /** Human-readable error message */
  message: Maybe<Scalars['String']>;
  /** Type of error that occurred during validation */
  type: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error_ErrorType>;
};

/** Error payload returned when validation fails */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_ErrorPayload = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse_ErrorPayload';
  /** List of validation errors */
  errors: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error>>>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error_ErrorType {
  ErrorTypeCsvMalformed = 'ERROR_TYPE_CSV_MALFORMED',
  ErrorTypeShopperAssignedToClosedStore = 'ERROR_TYPE_SHOPPER_ASSIGNED_TO_CLOSED_STORE',
  ErrorTypeShopperAssignedToMultipleWhls = 'ERROR_TYPE_SHOPPER_ASSIGNED_TO_MULTIPLE_WHLS',
  ErrorTypeShopperNotAssignedToProvidedWhl = 'ERROR_TYPE_SHOPPER_NOT_ASSIGNED_TO_PROVIDED_WHL',
  ErrorTypeShopperShiftOutsideOfStoreHours = 'ERROR_TYPE_SHOPPER_SHIFT_OUTSIDE_OF_STORE_HOURS',
  ErrorTypeUnknown = 'ERROR_TYPE_UNKNOWN',
  ErrorTypeWarehouseLocationDoesNotMatchRetailerId = 'ERROR_TYPE_WAREHOUSE_LOCATION_DOES_NOT_MATCH_RETAILER_ID'
}

/** Success payload returned when validation succeeds */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_SuccessPayload = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse_SuccessPayload';
  /** operation status */
  recordStatus: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus>;
  /** ID of the shift management operation record created */
  shiftManagementOperationRecordId: Maybe<Scalars['BigInt']>;
};

/** Validate request with the record ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestFollowupScenario_Input = {
  recordId?: InputMaybe<Scalars['BigInt']>;
};

/** Validate request without the record ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestInitialScenario_Input = {
  bulkShiftFileS3Key?: InputMaybe<Scalars['String']>;
  requestedById?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduleType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Optional. Target start date for when the shifts should begin */
  targetStartAt?: InputMaybe<Scalars['DateTime']>;
};

/** This will map to the vertical type in shared/protos/instacart/availability/v1/availability.proto, we only support pickup hours from IPP right now. */
export enum Instacart_Enterprise_Frigate_Shifts_V1_VerticalType {
  PickupHours = 'PICKUP_HOURS',
  VerticalTypeUnknown = 'VERTICAL_TYPE_UNKNOWN'
}

/** Values come from: https://instacart.atlassian.net/wiki/spaces/Catalog/pages/3541893127/Request+injection+with+request+data */
export type Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input = {
  /** The account ID of the initiating user. */
  accountId?: InputMaybe<Scalars['BigInt']>;
  /** The canonical ID of the initiating user. */
  canonicalId?: InputMaybe<Scalars['String']>;
  /** The email of the initiating user. */
  email?: InputMaybe<Scalars['String']>;
};

/** TimestampRange represents a time window with start and end times */
export type Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

/** TypedError is designed to capture any error with its type represented as a string and any related data captured in the payload */
export type Instacart_Enterprise_Frigate_Types_V1_TypedError = {
  __typename?: 'instacart_enterprise_frigate_types_v1_TypedError';
  /** error_type defines the type or category of the error */
  errorType: Maybe<Scalars['String']>;
  /**
   * payload may contain any additional information that relates to the error. It could be details about the error or context data that could help debug the error cause
   * ex: OrderValidationError
   */
  payload: Maybe<Scalars['GoogleProtobufAnyScalar']>;
};

/** mirrors the Customers TypedErrorsResponse. */
export type Instacart_Enterprise_Frigate_Types_V1_TypedErrorsResponse = {
  __typename?: 'instacart_enterprise_frigate_types_v1_TypedErrorsResponse';
  typedErrors: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Types_V1_TypedError>>>;
};

/** Request to create a new response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigRequest_Input = {
  /**
   * Body matchers for filtering requests (optional)
   * Map of JSON path expressions to regex patterns
   * All matchers must match for the config to be selected
   * Example: {"$.request_context.retailer_id": "^279$"}
   */
  bodyMatchers?: InputMaybe<Scalars['JSON']>;
  /**
   * Human-readable description (optional)
   * Example: "Mock for 1-800-Flowers order acceptance"
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Whether this configuration is active (required)
   * Set to false to disable without deleting
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Fulfillment provider ID filter
   * Exactly one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /**
   * Path pattern for matching request method (required)
   * Regular expression pattern (RE2 syntax)
   * Examples: "forward_order_.*", "^v1/orders/[0-9]+$", "(create|update)_order"
   */
  pathPattern?: InputMaybe<Scalars['String']>;
  /**
   * Response payload in JSON format (required)
   * Supports JSON path references starting with "$."
   * Example: {"order_id": "$.request_context.order_id"}
   */
  responsePayload?: InputMaybe<Scalars['String']>;
  /**
   * gRPC status code to return (optional, defaults to "ok")
   * Examples: "ok", "internal", "not_found", "unavailable"
   * See pumpkin status codes for complete list
   */
  responseStatus?: InputMaybe<Scalars['String']>;
  /**
   * Retailer ID filter
   * Exactly one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
  /**
   * Optional retailer location IDs filter
   * If specified, config only matches requests from these locations
   * If empty, matches all locations
   */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional TTL as Unix epoch seconds
   * Configuration auto-deletes after this time
   * If 0 or not set, persists indefinitely
   */
  ttl?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the created response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_CreateResponseConfigResponse';
  /** The created response configuration */
  responseConfig: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>;
};

/**
 * Request to delete a response configuration.
 * WARNING: This is a destructive action and cannot be undone. Consider using
 * UpdateResponseConfig with enabled = false instead.
 */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigRequest_Input = {
  /**
   * Must match the fulfillment_provider_id of the configuration being deleted
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Configuration UUID */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Must match the retailer_id of the configuration being deleted
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** Response confirming deletion */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_DeleteResponseConfigResponse';
  /** Success indicator */
  success: Maybe<Scalars['Boolean']>;
};

/** Request to get a response configuration by ID */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigRequest_Input = {
  /**
   * Must match the fulfillment_provider_id of the configuration being retrieved
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Configuration UUID */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Must match the retailer_id of the configuration being retrieved
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** Response containing the retrieved response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_GetResponseConfigResponse';
  /** The retrieved response configuration */
  responseConfig: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>;
};

/** Request to list response configurations with filters */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsRequest_Input = {
  /**
   * Optional filter by enabled status
   * If not set, returns both enabled and disabled
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Optional filter by fulfillment provider ID */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Maximum number of results per page (default 50, max 100) */
  pageSize?: InputMaybe<Scalars['Int']>;
  /**
   * Opaque cursor token for pagination
   * Empty string for first page
   * Use next_page_token from previous response for subsequent pages
   */
  pageToken?: InputMaybe<Scalars['String']>;
  /** Optional filter by retailer ID */
  retailerId?: InputMaybe<Scalars['String']>;
  /** Optional filter by retailer location ID */
  retailerLocationId?: InputMaybe<Scalars['String']>;
};

/** Response containing list of response configurations with pagination */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_ListResponseConfigsResponse';
  /**
   * Opaque cursor token for fetching the next page
   * Empty string if this is the last page
   * Pass this value as page_token in the next request
   */
  nextPageToken: Maybe<Scalars['String']>;
  /** List of response configurations */
  responseConfigs: Maybe<Array<Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>>>;
};

/** Complete response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_ResponseConfig';
  /**
   * Map of JSON path → regex pattern for request body matching
   * All matchers must match for config to apply
   * Key: JSON path expression (e.g., "$.request_context.retailer_id")
   * Value: Regex pattern (Go regex syntax) (e.g., "^[0-9]+$")
   */
  bodyMatchers: Maybe<Scalars['JSON']>;
  /** Timestamp when configuration was created (ISO8601 format, e.g., "2025-01-01T00:00:00Z") */
  createdAt: Maybe<Scalars['String']>;
  /** String identifier of user who created this configuration */
  createdBy: Maybe<Scalars['String']>;
  /** Human-readable description of what this mock is for */
  description: Maybe<Scalars['String']>;
  /** Whether this configuration is active */
  enabled: Maybe<Scalars['Boolean']>;
  /**
   * Fulfillment provider ID to match
   * Exactly one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId: Maybe<Scalars['String']>;
  /** Unique configuration identifier (UUID format) */
  id: Maybe<Scalars['String']>;
  /**
   * Regular expression pattern (RE2 syntax) for matching request path/method
   *
   * Common patterns:
   * - "forward_order_.*" - matches any forward_order method
   * - "^v1/.*" - must start with v1/
   * - "(create|update|delete)_order" - matches any of the verbs
   * - "(?i)forward_order" - case insensitive matching
   */
  pathPattern: Maybe<Scalars['String']>;
  /**
   * Response payload in JSON format
   * String values starting with "$." are JSON path references
   */
  responsePayload: Maybe<Scalars['String']>;
  /**
   * gRPC status code to return (e.g., "ok", "internal", "not_found", "unavailable")
   * See pumpkin status codes: https://github.com/instacart/carrot/blob/master/pumpkin/pumpkin-go/status/rpc_status.go
   * Uses string type for flexibility - can support HTTP codes in future (e.g., "200", "404", "500")
   */
  responseStatus: Maybe<Scalars['String']>;
  /**
   * Retailer ID to match
   * Exactly one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId: Maybe<Scalars['String']>;
  /**
   * Optional list of retailer location IDs to match
   * If specified, config only applies to these locations
   * If empty, applies to all locations
   */
  retailerLocationIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional TTL as Unix epoch seconds
   * Configuration will be automatically deleted after this time
   * If 0, configuration persists indefinitely (defaults to 0)
   */
  ttl: Maybe<Scalars['BigInt']>;
  /**
   * Timestamp when configuration was last updated (ISO8601 format)
   * Same as created_at if never updated
   */
  updatedAt: Maybe<Scalars['String']>;
};

/** Request to trigger an inbound event from partner/retailer to Relay */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventRequest_Input = {
  /**
   * Event payload in JSON format (required)
   * Free-form JSON matching the shape that a partner/retailer would send to Instacart
   *
   * Example for updating order status event:
   *
   * {
   * "event": "order_status",
   * "data": {
   * "order_id": "abc123def456",
   * "status": "shipped"
   * }
   * }
   */
  eventPayload?: InputMaybe<Scalars['String']>;
  /**
   * DEPRECATED: Use fulfillment_provider_id instead
   * Kept for backward compatibility
   */
  fulfillmentPartnerId?: InputMaybe<Scalars['String']>;
  /**
   * Fulfillment provider ID for the event
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /**
   * Retailer ID for the event
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** Response from triggering an inbound event */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_TriggerInboundEventResponse';
  /** Indicates whether the event was successfully received and queued for processing */
  successfullyReceived: Maybe<Scalars['Boolean']>;
};

/** Request to update an existing response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigRequest_Input = {
  /**
   * Updated body matchers for filtering requests (optional)
   * Map of JSON path expressions to regex patterns
   * All matchers must match for the config to be selected
   * Example: {"$.request_context.retailer_id": "^279$"}
   */
  bodyMatchers?: InputMaybe<Scalars['JSON']>;
  /**
   * Updated human-readable description (optional)
   * Example: "Mock for 1-800-Flowers order acceptance"
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Updated enabled status (required)
   * Set to false to disable without deleting
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Updated fulfillment provider ID filter
   * Exactly one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Configuration UUID to update (required) */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Updated path pattern for matching request method (required)
   * Regular expression pattern (RE2 syntax)
   * Examples: "forward_order_.*", "^v1/orders/[0-9]+$", "(create|update)_order"
   */
  pathPattern?: InputMaybe<Scalars['String']>;
  /**
   * Updated response payload in JSON format (required)
   * Supports JSON path references starting with "$."
   * Example: {"order_id": "$.request_context.order_id"}
   */
  responsePayload?: InputMaybe<Scalars['String']>;
  /**
   * Updated gRPC status code to return (optional, defaults to "ok")
   * Examples: "ok", "internal", "not_found", "unavailable"
   * See pumpkin status codes for complete list
   */
  responseStatus?: InputMaybe<Scalars['String']>;
  /**
   * Updated retailer ID filter
   * Exactly one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
  /**
   * Updated retailer location IDs filter (optional)
   * If specified, config only matches requests from these locations
   * If empty, matches all locations
   */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Updated TTL as Unix epoch seconds (optional)
   * Configuration auto-deletes after this time
   * If 0, persists indefinitely
   */
  ttl?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_UpdateResponseConfigResponse';
  /** The updated response configuration */
  responseConfig: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>;
};

/** Request payload for the Advance Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchRequest_Input = {
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['String']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Advance Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_AdvanceBatchResponse';
  workflowState: Maybe<Scalars['String']>;
};

/**
 * AuthContext stores the account ID for the request,
 * making it possible to gate feature requests based on the logged in user.
 */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input = {
  accountId?: InputMaybe<Scalars['BigInt']>;
};

/** Request payload for the Create Shopper call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperRequest_Input = {
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Create Shopper call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_CreateShopperResponse';
  /** Response payload for the Create Shopper call */
  id: Maybe<Scalars['BigInt']>;
};

/** Request payload for the Generate Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  batchType?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Array<InputMaybe<Instacart_Customers_Connect_Platform_V1_Order_Input>>>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Generate Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GenerateBatchResponse';
  id: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<Scalars['String']>;
};

/** The response of the get barcode request. */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetBarcodeResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GetBarcodeResponse';
  /** Null if checkout has not started yet. */
  barcode: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_Barcode>;
};

/** Request payload for the Get Checkout State and Barcode call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeRequest_Input = {
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
};

/** Response payload for the Get Checkout State and Barcode call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GetCheckoutStateAndBarcodeResponse';
  barcode: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetBarcodeResponse>;
  checkoutState: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateResponse>;
};

/** The response to get the checkout state. */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GetCheckoutStateResponse';
  checkoutState: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutState>;
};

/** Entiry representing a scanned string from a Shopper Order Item */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperOrderItemScan_Input = {
  scannedString?: InputMaybe<Scalars['String']>;
  scannedStringType?: InputMaybe<Scalars['String']>;
};

/** Request payload for the Update Shopper Order Item call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  deliveredCount?: InputMaybe<Scalars['BigInt']>;
  deliveredWeight?: InputMaybe<Scalars['Float']>;
  lineNum?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  rrc?: InputMaybe<Scalars['String']>;
  scans?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperOrderItemScan_Input>>>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  substituteId?: InputMaybe<Scalars['BigInt']>;
  upc?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Update Shopper Order Item call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_UpdateShopperOrderItemResponse';
  success: Maybe<Scalars['Boolean']>;
};

/** Request to get detailed information about a single job. */
export type Instacart_Flawless_Inventory_V1_GetJobDetailsRequest_Input = {
  /** The job ID to get details for. */
  job_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing full details about a single job. */
export type Instacart_Flawless_Inventory_V1_GetJobDetailsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobDetailsResponse';
  /** Source identifier (e.g., "isc:flawless.inventory"). */
  ai_gateway_source: Maybe<Scalars['String']>;
  /** AI model used (e.g., "gpt-4o"). */
  ai_model: Maybe<Scalars['String']>;
  /** Number of batches completed (batch jobs only). */
  batches_completed: Maybe<Scalars['Int']>;
  /** Total number of batches (batch jobs only). */
  batches_total: Maybe<Scalars['Int']>;
  /** When the job finished (null if still running, ISO 8601 format). */
  completed_at: Maybe<Scalars['String']>;
  /** Progress percentage (0-100). */
  completion_percentage: Maybe<Scalars['Int']>;
  /** Total cost in USD. */
  cost: Maybe<Scalars['Float']>;
  /** When the job was created/started (ISO 8601 format). */
  created_at: Maybe<Scalars['String']>;
  /** Error message if the job failed. */
  error_message: Maybe<Scalars['String']>;
  /** Unique job identifier. */
  job_id: Maybe<Scalars['BigInt']>;
  /** Processing mode: "batch" or "sync". */
  processing_mode: Maybe<Scalars['String']>;
  /** User/service that initiated the job (e.g., "user@instacart.com"). */
  requester: Maybe<Scalars['String']>;
  /** How long the job has been running or ran (in seconds). */
  runtime_seconds: Maybe<Scalars['BigInt']>;
  /** Job status: "in_progress", "completed", "failed". */
  status: Maybe<Scalars['String']>;
  /** Number of tasks completed. */
  tasks_completed: Maybe<Scalars['Int']>;
  /** Number of tasks that failed. */
  tasks_failed: Maybe<Scalars['Int']>;
  /** Number of tasks that succeeded. */
  tasks_succeeded: Maybe<Scalars['Int']>;
  /** Total number of tasks in the job. */
  tasks_total: Maybe<Scalars['Int']>;
  /**
   * Temporal workflow ID for linking to Temporal UI.
   * This is the workflow ID of the MapleJobStartWorkflow that runs the job.
   */
  temporal_workflow_id: Maybe<Scalars['String']>;
  /** Total tokens consumed by the job. */
  total_tokens: Maybe<Scalars['BigInt']>;
};

/** Request to retrieve job results */
export type Instacart_Flawless_Inventory_V1_GetJobResultsRequest_Input = {
  /** Id of the job created in the database for the job run. */
  job_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the complete results of a job */
export type Instacart_Flawless_Inventory_V1_GetJobResultsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobResultsResponse';
  /** Timestamp of job completion - when all the job workflows for the job have been completed. */
  completed_at: Maybe<Scalars['String']>;
  /** Cost in USD for the job. */
  cost: Maybe<Scalars['Float']>;
  /** Timestamp of job creation. */
  created_at: Maybe<Scalars['String']>;
  /** Total input tokens used for the job. */
  input_tokens: Maybe<Scalars['BigInt']>;
  /** Id of the job created in the database for the job run. */
  job_id: Maybe<Scalars['BigInt']>;
  /** Name of the job created in the database for the job run. */
  job_name: Maybe<Scalars['String']>;
  /** Version of the job created in the database for the job run. */
  job_version: Maybe<Scalars['Int']>;
  /** List of details about the job workflows associated with the job. */
  job_workflows: Maybe<Array<Maybe<Instacart_Flawless_Inventory_V1_JobWorkflow>>>;
  /** Number of batches processed for the job. */
  num_batches: Maybe<Scalars['Int']>;
  /** Total output tokens used for the job. */
  output_tokens: Maybe<Scalars['BigInt']>;
  /** Aggregate status of all the job workflows for the job. This will be one of ['completed', 'in_progress', 'failed']. */
  status: Maybe<Scalars['String']>;
  /** Total tokens processed for the job. */
  total_tokens: Maybe<Scalars['BigInt']>;
};

/** Response containing all unique AI Gateway sources. */
export type Instacart_Flawless_Inventory_V1_GetJobSourcesResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobSourcesResponse';
  /** List of unique AI Gateway source identifiers (e.g., "isc:flawless.inventory", "isc:camp"). */
  sources: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Request to retrieve the completion status of a job */
export type Instacart_Flawless_Inventory_V1_GetJobStatusRequest_Input = {
  /** Id of the job created in the database for the job run. */
  job_id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional - Id of the job workflow created in the database for the job run.
   * If not provided, the status of all job workflows for the job will be returned.
   */
  job_workflow_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the completion status of a job */
export type Instacart_Flawless_Inventory_V1_GetJobStatusResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobStatusResponse';
  /** Status of the job (completed, in_progress, failed) */
  status: Maybe<Scalars['String']>;
};

/** Request to list MAPLE jobs with optional filtering and pagination. */
export type Instacart_Flawless_Inventory_V1_GetJobsRequest_Input = {
  /** Optional - Filter by AI Gateway source (e.g., "isc:camp"). */
  ai_gateway_source?: InputMaybe<Scalars['String']>;
  /**
   * Optional - Only return jobs created on or after this time (ISO 8601 format).
   * Useful for filtering out old stuck jobs from the dashboard.
   */
  created_after?: InputMaybe<Scalars['String']>;
  /** Optional - Filter by specific job ID. */
  job_id?: InputMaybe<Scalars['BigInt']>;
  /** Optional - Filter by job name (partial match). */
  job_name?: InputMaybe<Scalars['String']>;
  /** Optional - Page number for pagination (default: 1). */
  page?: InputMaybe<Scalars['Int']>;
  /** Optional - Number of items per page (default: 50, max: 100). */
  page_size?: InputMaybe<Scalars['Int']>;
  /** Optional - Filter by requester (user email or service name). */
  requester?: InputMaybe<Scalars['String']>;
  /** Optional - Filter by job status: "in_progress", "completed", "failed". */
  status_filter?: InputMaybe<Scalars['String']>;
};

/** Response containing a paginated list of jobs. */
export type Instacart_Flawless_Inventory_V1_GetJobsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobsResponse';
  /** List of job summaries. */
  jobs: Maybe<Array<Maybe<Instacart_Flawless_Inventory_V1_JobSummary>>>;
  /** Current page number. */
  page: Maybe<Scalars['Int']>;
  /** Total number of jobs matching the filter. */
  total_count: Maybe<Scalars['Int']>;
  /** Total number of pages available. */
  total_pages: Maybe<Scalars['Int']>;
};

/** Response for supported AI models */
export type Instacart_Flawless_Inventory_V1_GetMapleSupportedModelsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetMapleSupportedModelsResponse';
  /**
   * Map of AI vendors to their models as JSON string.
   * Example: `{"openai": ["gpt-4o", "gpt-4o-mini"]}`
   */
  supported_models: Maybe<Scalars['String']>;
};

/** Summary information for a single job in the list view. */
export type Instacart_Flawless_Inventory_V1_JobSummary = {
  __typename?: 'instacart_flawless_inventory_v1_JobSummary';
  /** Source identifier (e.g., "isc:flawless.inventory"). */
  ai_gateway_source: Maybe<Scalars['String']>;
  /** AI model used (e.g., "gpt-4o"). */
  ai_model: Maybe<Scalars['String']>;
  /** When the job finished (null if still running, ISO 8601 format). */
  completed_at: Maybe<Scalars['String']>;
  /** When the job was created/started (ISO 8601 format). */
  created_at: Maybe<Scalars['String']>;
  /** Unique job identifier. */
  job_id: Maybe<Scalars['BigInt']>;
  /** Name of the job. */
  job_name: Maybe<Scalars['String']>;
  /** Processing mode: "batch" or "sync". */
  processing_mode: Maybe<Scalars['String']>;
  /** User/service that initiated the job (e.g., "user@instacart.com"). */
  requester: Maybe<Scalars['String']>;
  /** Job status: "in_progress", "completed", "failed". */
  status: Maybe<Scalars['String']>;
  /** Number of tasks in the job. */
  total_tasks: Maybe<Scalars['Int']>;
};

/** A single workflow within a job */
export type Instacart_Flawless_Inventory_V1_JobWorkflow = {
  __typename?: 'instacart_flawless_inventory_v1_JobWorkflow';
  /**
   * Response codes for AI batches. This is a list of response codes for the AI batches that were sent to the AI model.
   * Response codes are the codes returned by the AI model for the batch.
   */
  ai_batch_response_codes: Maybe<Array<Maybe<Scalars['String']>>>;
  /** AI model used in this workflow */
  ai_model: Maybe<Scalars['String']>;
  /** If true, task data was appended to the prompt before sending to the AI model. */
  append_task_data: Maybe<Scalars['Boolean']>;
  /** This is the number of tasks that were sent to the AI model in a single batch. */
  batch_size: Maybe<Scalars['Int']>;
  /** Timestamp of workflow completion */
  completed_at: Maybe<Scalars['String']>;
  /** Cost for this workflow in USD */
  cost: Maybe<Scalars['Float']>;
  /** Timestamp of workflow creation */
  created_at: Maybe<Scalars['String']>;
  /**
   * Detailed status of the job workflow. This will be a more detailed status of the job workflow.
   * For all states, see: https://instacart.atlassian.net/wiki/spaces/Catalog/pages/4707778561/How+to+Use+the+Maple+Batch+API
   */
  detailed_status: Maybe<Scalars['String']>;
  /** Indicates whether this was a dry run. If true, no data was sent to the AI model. */
  dry_run: Maybe<Scalars['Boolean']>;
  /** Error message for this workflow, if any. This is the error message encountered by MAPLE during the job workflow. */
  error_message: Maybe<Scalars['String']>;
  /** Input tokens for this workflow */
  input_tokens: Maybe<Scalars['BigInt']>;
  /** Id of the job workflow created in the database for the job run. */
  job_workflow_id: Maybe<Scalars['BigInt']>;
  /** Output tokens for this workflow */
  output_tokens: Maybe<Scalars['BigInt']>;
  /**
   * Presigned URL of the results file. This is the s3 file that was used as input for the job workflow.
   * Presigned URL will be valid for min(7 days AND when the AWS token expires). After this time, the presigned URL will be invalid.
   */
  results_file: Maybe<Scalars['String']>;
  /** S3 URL and object ID of the results file. This is the raw s3 url and object id of the results file. */
  results_file_s3: Maybe<Instacart_Flawless_Inventory_V1_S3ResultFile>;
  /** Sample prompt used for the AI request. This is the prompt that was used for the AI request for the job workflow. */
  sample_prompt: Maybe<Scalars['String']>;
  /** Status of the job workflow. This will be one of ['completed', 'in_progress', 'failed']. */
  status: Maybe<Scalars['String']>;
  /** Path to the input S3 file containing the task data. */
  task_file: Maybe<Scalars['String']>;
  /**
   * This is a number used for testing. It is the total number of tasks that were sent to the AI model for the job workflow.
   * 0 means all tasks were sent to the AI model.
   */
  total_tasks: Maybe<Scalars['Int']>;
  /** Total tokens processed in this workflow */
  total_tokens: Maybe<Scalars['BigInt']>;
};

/** S3 result file with raw s3 url and object id of the result file */
export type Instacart_Flawless_Inventory_V1_S3ResultFile = {
  __typename?: 'instacart_flawless_inventory_v1_S3ResultFile';
  /** S3 result file object ID. This is the object id of the results file in s3. */
  object_id: Maybe<Scalars['String']>;
  /** S3 result file URL. This is the raw s3 url of the results file. */
  url: Maybe<Scalars['String']>;
};

/** The barcode of the checkout process. */
export type Instacart_Fulfillment_Domains_Checkout_V1_Barcode = {
  __typename?: 'instacart_fulfillment_domains_checkout_v1_Barcode';
  batchId: Maybe<Scalars['BigInt']>;
  displayValue: Maybe<Scalars['String']>;
  encodedValue: Maybe<Scalars['String']>;
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  type: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_BarcodeType>;
};

/** Barcode type. */
export enum Instacart_Fulfillment_Domains_Checkout_V1_BarcodeType {
  BarcodeTypeAztec = 'BARCODE_TYPE_AZTEC',
  BarcodeTypeCode25Interleaved = 'BARCODE_TYPE_CODE25_INTERLEAVED',
  BarcodeTypeCode39 = 'BARCODE_TYPE_CODE39',
  BarcodeTypeCode128 = 'BARCODE_TYPE_CODE128',
  BarcodeTypeDatamatrix = 'BARCODE_TYPE_DATAMATRIX',
  BarcodeTypeEan8 = 'BARCODE_TYPE_EAN8',
  BarcodeTypeEan13 = 'BARCODE_TYPE_EAN13',
  BarcodeTypeGs1Databar = 'BARCODE_TYPE_GS1_DATABAR',
  BarcodeTypeGs1DatabarExpanded = 'BARCODE_TYPE_GS1_DATABAR_EXPANDED',
  BarcodeTypeGs1DatabarLimited = 'BARCODE_TYPE_GS1_DATABAR_LIMITED',
  BarcodeTypePdf417 = 'BARCODE_TYPE_PDF417',
  BarcodeTypeQr = 'BARCODE_TYPE_QR',
  BarcodeTypeUnknown = 'BARCODE_TYPE_UNKNOWN',
  BarcodeTypeUpca = 'BARCODE_TYPE_UPCA',
  BarcodeTypeUpce = 'BARCODE_TYPE_UPCE'
}

/** The type of checkout process. */
export enum Instacart_Fulfillment_Domains_Checkout_V1_CheckoutProcessType {
  TypeBypassCheckout = 'TYPE_BYPASS_CHECKOUT',
  TypeBypassPayment = 'TYPE_BYPASS_PAYMENT',
  TypeRegularCheckout = 'TYPE_REGULAR_CHECKOUT',
  TypeUnknown = 'TYPE_UNKNOWN'
}

/** The checkout state of the checkout process. */
export type Instacart_Fulfillment_Domains_Checkout_V1_CheckoutState = {
  __typename?: 'instacart_fulfillment_domains_checkout_v1_CheckoutState';
  batchId: Maybe<Scalars['BigInt']>;
  checkoutCreatedAt: Maybe<Scalars['DateTime']>;
  checkoutFinalizedAt: Maybe<Scalars['DateTime']>;
  /** The dynamic checkout process type of the order. This can either be the same as checkout_process_static_type or TYPE_CHECKOUT_GROCERIES if the order has become ineligible for bypass */
  checkoutProcessDynamicType: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutProcessType>;
  /** The static checkout process type of the order. This stays static throughout an order's lifecycle */
  checkoutProcessStaticEnabledType: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutProcessType>;
  checkoutUpdatedAt: Maybe<Scalars['DateTime']>;
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  warehouseId: Maybe<Scalars['BigInt']>;
  workflowState: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutWorkflowState>;
};

/** The workflow state of the checkout process. */
export enum Instacart_Fulfillment_Domains_Checkout_V1_CheckoutWorkflowState {
  /** The bypass attempt has been approved. */
  StateApproved = 'STATE_APPROVED',
  /** The bypass checkout attempt is being audited. */
  StateAuditingInProgress = 'STATE_AUDITING_IN_PROGRESS',
  /** The checkout has not started yet. */
  StateCheckoutNotStarted = 'STATE_CHECKOUT_NOT_STARTED',
  /** The bypass checkout attempt is in progress. */
  StateInProgress = 'STATE_IN_PROGRESS',
  /** The order has been cancelled. */
  StateOrderCancelled = 'STATE_ORDER_CANCELLED',
  /** The bypass attempt has been rejected. */
  StateRejected = 'STATE_REJECTED',
  StateUnknown = 'STATE_UNKNOWN'
}

/** AuditLog represents an audit log entry */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditLog = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_AuditLog';
  /** JSON string from jsonb column */
  action: Maybe<Scalars['String']>;
  actionType: Maybe<Scalars['String']>;
  batchId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** AuditQuestion defines the questions asked during step log audits */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditQuestion {
  AuditQuestionHasFalseNegatives = 'AUDIT_QUESTION_HAS_FALSE_NEGATIVES',
  AuditQuestionHasFalsePositives = 'AUDIT_QUESTION_HAS_FALSE_POSITIVES',
  AuditQuestionIsGood = 'AUDIT_QUESTION_IS_GOOD',
  AuditQuestionTaxonomyFilterHasFalseNegatives = 'AUDIT_QUESTION_TAXONOMY_FILTER_HAS_FALSE_NEGATIVES',
  /** Taxonomy filter specific questions */
  AuditQuestionTaxonomyFilterHasFalsePositives = 'AUDIT_QUESTION_TAXONOMY_FILTER_HAS_FALSE_POSITIVES',
  AuditQuestionTaxonomyFilterReplacementDataGood = 'AUDIT_QUESTION_TAXONOMY_FILTER_REPLACEMENT_DATA_GOOD',
  AuditQuestionUnknown = 'AUDIT_QUESTION_UNKNOWN'
}

/** AuditResponse represents a single question-answer pair in an audit */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_AuditResponse';
  answer: Maybe<Scalars['Boolean']>;
  question: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditQuestion>;
};

/** AuditResponse represents a single question-answer pair in an audit */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse_Input = {
  answer?: InputMaybe<Scalars['Boolean']>;
  question?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditQuestion>;
};

/** CategorizationAnalysis compares GDS audit vs transaction integrity system categorizations */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_CategorizationAnalysis';
  batchId: Maybe<Scalars['BigInt']>;
  /** Line items where system and audit agree on ALL categorizations */
  matches: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
  /** All mismatched line items grouped by category type */
  mismatches: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches>;
};

/** CategorizationAnalysis compares GDS audit vs transaction integrity system categorizations */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  /** Line items where system and audit agree on ALL categorizations */
  matches?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input>>>;
  /** All mismatched line items grouped by category type */
  mismatches?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches_Input>;
};

/** CategoryMismatch represents mismatched categorizations for a specific category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_CategoryMismatch';
  auditOnly: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
  systemOnly: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
};

/** CategoryMismatch represents mismatched categorizations for a specific category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch_Input = {
  auditOnly?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input>>>;
  systemOnly?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input>>>;
};

/** LineItem */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_LineItem';
  isIllicit: Maybe<Scalars['Boolean']>;
  matchingQuality: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality>;
  product: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product>;
  quantity: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  source: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source>;
};

/** LineItem */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input = {
  isIllicit?: InputMaybe<Scalars['Boolean']>;
  matchingQuality?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality_Input>;
  product?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product_Input>;
  quantity?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  source?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source_Input>;
};

/** MatchingQuality */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_MatchingQuality';
  accuracy: Maybe<Scalars['Float']>;
  precision: Maybe<Scalars['Float']>;
  recall: Maybe<Scalars['Float']>;
};

/** MatchingQuality */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality_Input = {
  accuracy?: InputMaybe<Scalars['Float']>;
  precision?: InputMaybe<Scalars['Float']>;
  recall?: InputMaybe<Scalars['Float']>;
};

/** Mismatches contains all mismatched line items grouped by category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_Mismatches';
  refundedButCheckedOut: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch>;
};

/** Mismatches contains all mismatched line items grouped by category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches_Input = {
  refundedButCheckedOut?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch_Input>;
};

/** Product */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_Product';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  restrictedReasons: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerReferenceCode: Maybe<Scalars['String']>;
  unit: Maybe<Instacart_Types_V1_MeasurementUnit>;
  unitPriceCents: Maybe<Scalars['BigInt']>;
  universalProductCode: Maybe<Scalars['String']>;
};

/** Product */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  restrictedReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerReferenceCode?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Instacart_Types_V1_MeasurementUnit_Input>;
  unitPriceCents?: InputMaybe<Scalars['BigInt']>;
  universalProductCode?: InputMaybe<Scalars['String']>;
};

/** SecondaryStepLogAudit represents a secondary review of a primary audit */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_SecondaryStepLogAudit = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_SecondaryStepLogAudit';
  auditedBy: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['String']>;
  primaryAuditId: Maybe<Scalars['String']>;
  stepType: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  validationDecision: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ValidationDecision>;
};

/** Source */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_Source';
  batchId: Maybe<Scalars['BigInt']>;
  orderDeliveryId: Maybe<Scalars['BigInt']>;
  retailerTransactionId: Maybe<Scalars['String']>;
  retailerTransactionLineItemIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  shopperOrderItemId: Maybe<Scalars['BigInt']>;
  shopperOrderItemIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  warehouseId: Maybe<Scalars['BigInt']>;
};

/** Source */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  retailerTransactionId?: InputMaybe<Scalars['String']>;
  retailerTransactionLineItemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  shopperOrderItemId?: InputMaybe<Scalars['BigInt']>;
  shopperOrderItemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** StepLog represents a step execution log entry */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLog = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_StepLog';
  batchId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['String']>;
  /** JSON string from jsonb column */
  inputData: Maybe<Scalars['String']>;
  /** JSON string from jsonb column */
  outputData: Maybe<Scalars['String']>;
  stepType: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** StepLogAudit represents an audit record for a step log */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAudit = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_StepLogAudit';
  auditResponses: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse>>>;
  auditedBy: Maybe<Scalars['String']>;
  auditorType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  hasFalseNegatives: Maybe<Scalars['Boolean']>;
  hasFalsePositives: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  isGood: Maybe<Scalars['Boolean']>;
  status: Maybe<Scalars['String']>;
  stepLog: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLog>;
  stepLogId: Maybe<Scalars['String']>;
  stepType: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  version: Maybe<Scalars['Int']>;
};

/** StepLogAuditStatus defines the filter for step log audit state in queries */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAuditStatus {
  /** Return only audited step logs */
  StepLogAuditStatusAudited = 'STEP_LOG_AUDIT_STATUS_AUDITED',
  /** Return only unaudited step logs */
  StepLogAuditStatusUnaudited = 'STEP_LOG_AUDIT_STATUS_UNAUDITED',
  /** Unknown/unspecified: no filtering applied, returns all step logs */
  StepLogAuditStatusUnknown = 'STEP_LOG_AUDIT_STATUS_UNKNOWN'
}

/** ValidationDecision defines the outcome of a secondary review */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ValidationDecision {
  ValidationDecisionAgree = 'VALIDATION_DECISION_AGREE',
  ValidationDecisionDisagree = 'VALIDATION_DECISION_DISAGREE',
  ValidationDecisionPartiallyAgree = 'VALIDATION_DECISION_PARTIALLY_AGREE',
  ValidationDecisionUnknown = 'VALIDATION_DECISION_UNKNOWN'
}

/**
 * How the customer responded to the shopper.
 * Duplicated here from public_apis to avoid internal services depending on public_apis.
 * Keep in sync with instacart/fulfillment/public_apis/delivery/order_delivery_transitions/v1/unattended_order_delivery_transitions.proto.
 */
export enum Instacart_Fulfillment_Shared_V1_CustomerResponse {
  CustomerResponseAskedToCancel = 'CUSTOMER_RESPONSE_ASKED_TO_CANCEL',
  CustomerResponseAskedToWait = 'CUSTOMER_RESPONSE_ASKED_TO_WAIT',
  CustomerResponseFound = 'CUSTOMER_RESPONSE_FOUND',
  CustomerResponseIncorrectAddress = 'CUSTOMER_RESPONSE_INCORRECT_ADDRESS',
  CustomerResponseLeaveAtDoor = 'CUSTOMER_RESPONSE_LEAVE_AT_DOOR',
  CustomerResponseNoResponse = 'CUSTOMER_RESPONSE_NO_RESPONSE',
  CustomerResponseUnknown = 'CUSTOMER_RESPONSE_UNKNOWN'
}

/** GetTenderTransactionsByWhlIdsRequest */
export type Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsRequest_Input = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<Instacart_Fulfillment_Shared_V1_TenderTransaction_TenderTransactionState>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetTenderTransactionsByStoreIdsResponse */
export type Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsResponse = {
  __typename?: 'instacart_fulfillment_shared_v1_GetTenderTransactionsByWhlIdsResponse';
  tenderTransactions: Maybe<Array<Maybe<Instacart_Fulfillment_Shared_V1_TenderTransaction>>>;
};

/**
 * Reasons why a delivery could not be completed.
 * Used across multiple services for consistency.
 */
export enum Instacart_Fulfillment_Shared_V1_NotDeliveredReason {
  NotDeliveredReasonCustomerUnavailable = 'NOT_DELIVERED_REASON_CUSTOMER_UNAVAILABLE',
  NotDeliveredReasonDispatcherCanceled = 'NOT_DELIVERED_REASON_DISPATCHER_CANCELED',
  NotDeliveredReasonOther = 'NOT_DELIVERED_REASON_OTHER',
  NotDeliveredReasonRouteIssues = 'NOT_DELIVERED_REASON_ROUTE_ISSUES',
  NotDeliveredReasonShiftEnding = 'NOT_DELIVERED_REASON_SHIFT_ENDING',
  NotDeliveredReasonUnknown = 'NOT_DELIVERED_REASON_UNKNOWN'
}

/** Tender Merchant */
export type Instacart_Fulfillment_Shared_V1_TenderMerchant = {
  __typename?: 'instacart_fulfillment_shared_v1_TenderMerchant';
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  warehouseId: Maybe<Scalars['BigInt']>;
  warehouseLocationId: Maybe<Scalars['BigInt']>;
  zip: Maybe<Scalars['String']>;
};

/** Tender Transaction */
export type Instacart_Fulfillment_Shared_V1_TenderTransaction = {
  __typename?: 'instacart_fulfillment_shared_v1_TenderTransaction';
  amount: Maybe<GoogleTypeMoney>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  state: Maybe<Instacart_Fulfillment_Shared_V1_TenderTransaction_TenderTransactionState>;
  tenderMerchant: Maybe<Instacart_Fulfillment_Shared_V1_TenderMerchant>;
  updatedAt: Maybe<Scalars['DateTime']>;
  warehouseId: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Fulfillment_Shared_V1_TenderTransaction_TenderTransactionState {
  TenderTransactionStateCleared = 'TENDER_TRANSACTION_STATE_CLEARED',
  TenderTransactionStateCompletion = 'TENDER_TRANSACTION_STATE_COMPLETION',
  TenderTransactionStateDeclined = 'TENDER_TRANSACTION_STATE_DECLINED',
  TenderTransactionStateError = 'TENDER_TRANSACTION_STATE_ERROR',
  TenderTransactionStatePending = 'TENDER_TRANSACTION_STATE_PENDING',
  TenderTransactionStateUnknown = 'TENDER_TRANSACTION_STATE_UNKNOWN'
}

/** CategorizeByBatchRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchRequest_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
};

/** CategorizeByBatchResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_CategorizeByBatchResponse';
  refundedButCheckedOutLineItems: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
};

/** CreateCategorizationAnalysisRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisRequest_Input = {
  analysis?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis_Input>;
};

/** CreateCategorizationAnalysisResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_CreateCategorizationAnalysisResponse';
  succeeded: Maybe<Scalars['Boolean']>;
};

/** CreateSecondaryStepLogAuditRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateSecondaryStepLogAuditRequest_Input = {
  auditedBy?: InputMaybe<Scalars['String']>;
  primaryAuditId?: InputMaybe<Scalars['String']>;
  stepType?: InputMaybe<Scalars['String']>;
  validationDecision?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ValidationDecision>;
};

/** CreateSecondaryStepLogAuditResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateSecondaryStepLogAuditResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_CreateSecondaryStepLogAuditResponse';
  errorMessage: Maybe<Scalars['String']>;
  secondaryAudit: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_SecondaryStepLogAudit>;
  succeeded: Maybe<Scalars['Boolean']>;
};

/** CreateStepLogAuditRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditRequest_Input = {
  auditResponses?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse_Input>>>;
  auditedBy?: InputMaybe<Scalars['String']>;
  stepLogId?: InputMaybe<Scalars['String']>;
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** CreateStepLogAuditResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_CreateStepLogAuditResponse';
  audit: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAudit>;
  errorMessage: Maybe<Scalars['String']>;
  succeeded: Maybe<Scalars['Boolean']>;
};

/** GetAuditLogsRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsRequest_Input = {
  actionType?: InputMaybe<Scalars['String']>;
  batchId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** GetAuditLogsResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetAuditLogsResponse';
  auditLogs: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditLog>>>;
};

/** GetCategorizationAnalysisRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisRequest_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
};

/** GetCategorizationAnalysisResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetCategorizationAnalysisResponse';
  analysis: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis>;
};

/** GetStepLogAuditMetricsRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditMetricsRequest_Input = {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** GetStepLogAuditMetricsResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditMetricsResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetStepLogAuditMetricsResponse';
  stepType: Maybe<Scalars['String']>;
  totalNumAudits: Maybe<Scalars['Int']>;
  totalNumFalseNegatives: Maybe<Scalars['Int']>;
  totalNumFalsePositives: Maybe<Scalars['Int']>;
  totalNumGoodResponses: Maybe<Scalars['Int']>;
  version: Maybe<Scalars['Int']>;
};

/** GetStepLogAuditsRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsRequest_Input = {
  auditorType?: InputMaybe<Scalars['String']>;
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** GetStepLogAuditsResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetStepLogAuditsResponse';
  audits: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAudit>>>;
  version: Maybe<Scalars['Int']>;
};

/** GetStepLogsRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogsRequest_Input = {
  auditStatus?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAuditStatus>;
  batchId?: InputMaybe<Scalars['String']>;
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  stepType?: InputMaybe<Scalars['String']>;
};

/** GetStepLogsResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogsResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetStepLogsResponse';
  stepLogs: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLog>>>;
};

/** GetStepTypesResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepTypesResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetStepTypesResponse';
  stepTypes: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** ReplayReconciliationRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationRequest_Input = {
  batchId?: InputMaybe<Scalars['String']>;
};

/** ReplayReconciliationResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_ReplayReconciliationResponse';
  succeeded: Maybe<Scalars['Boolean']>;
};

/** RunDecisionRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionRequest_Input = {
  decisionType?: InputMaybe<Scalars['String']>;
  inputJson?: InputMaybe<Scalars['String']>;
};

/** RunDecisionResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_RunDecisionResponse';
  errorMessage: Maybe<Scalars['String']>;
  outputJson: Maybe<Scalars['String']>;
  succeeded: Maybe<Scalars['Boolean']>;
};

/** An error response message for the service */
export type Instacart_Growth_Crm_Messaging_Service_V1_CrmsError = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CRMSError';
  /** Contains a detailed, human readable error about the message. */
  message: Maybe<Scalars['String']>;
  /** Stacktrace if applicable */
  stacktrace: Maybe<Scalars['String']>;
  /** The type of error that was originated within the node. */
  type: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsErrorType>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_CrmsErrorType {
  /**
   * An error was registered while trying to interact with an
   * external provider such as S3 or Braze. Client can retry.
   */
  CrmsErrorTypeExternal = 'CRMS_ERROR_TYPE_EXTERNAL',
  /**
   * The message intent failed the idempotency check
   * The message intent should not be retried by client
   */
  CrmsErrorTypeIdempotency = 'CRMS_ERROR_TYPE_IDEMPOTENCY',
  /**
   * An error was registered within the CRMS system when trying to
   * perform the request. Client can retry.
   */
  CrmsErrorTypeInternal = 'CRMS_ERROR_TYPE_INTERNAL',
  /** Unknown error. See message for more details */
  CrmsErrorTypeUnknown = 'CRMS_ERROR_TYPE_UNKNOWN'
}

/** An experiment to filter on for the CRM request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input = {
  /** The experiment variant to use; defaults to control */
  experiment?: InputMaybe<Scalars['String']>;
  /**
   * The experiment name to use for the CRM Campaign
   * Will map to a Roulette experiment
   */
  providedExperimentName?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_CampaignStatus {
  CampaignStatusCancelled = 'CAMPAIGN_STATUS_CANCELLED',
  CampaignStatusCompleted = 'CAMPAIGN_STATUS_COMPLETED',
  CampaignStatusExportingSegment = 'CAMPAIGN_STATUS_EXPORTING_SEGMENT',
  CampaignStatusFailed = 'CAMPAIGN_STATUS_FAILED',
  CampaignStatusInProgress = 'CAMPAIGN_STATUS_IN_PROGRESS',
  CampaignStatusLoadingSegment = 'CAMPAIGN_STATUS_LOADING_SEGMENT',
  CampaignStatusPartiallyCompleted = 'CAMPAIGN_STATUS_PARTIALLY_COMPLETED',
  CampaignStatusPending = 'CAMPAIGN_STATUS_PENDING',
  CampaignStatusUnknown = 'CAMPAIGN_STATUS_UNKNOWN'
}

/** Attributes necessary for making the cancel marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignRequest_Input = {
  /** Associated GS campaign ID */
  extId?: InputMaybe<Scalars['BigInt']>;
  /** Internal ID */
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response for a cancel marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CancelMarketingCampaignResponse';
  /** whether or not the cancelation was successful */
  cancelationSuccessful: Maybe<Scalars['Boolean']>;
  /** the error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
};

/** Attributes representing a Canvas Template */
export type Instacart_Growth_Crm_Messaging_Service_V1_CanvasTemplate = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CanvasTemplate';
  brazeCanvasId: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
};

/** Specify configuration for future message intentions */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationRequest_Input = {
  /** Braze Canvas Id */
  brazeCanvasId?: InputMaybe<Scalars['String']>;
  /** Custom event name */
  customEventName?: InputMaybe<Scalars['String']>;
  /** The end time for the email to send. A null value indicates indefinitely */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /**
   * DEPRECATED: Experiment to be applied for message intents
   * Experiments are applied via experiment_variants
   */
  experiment?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>;
  /** Experiment variants to be applied for message intents */
  experimentVariants?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ExperimentVariant_Input>>>;
  /** list of holdouts to apply for the intent */
  holdouts?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>>>;
  /**
   * DEPRECATED: Idempotency key used for message intents
   * Current State: Only one Idempotency Key is accepted
   */
  idempotencyKey?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_IdempotencyKey_Input>;
  /** Intent type */
  intentType?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_IntentType>;
  /**
   * Properties to be utilizes by the CRMS that have
   * Not yet been designated their own field
   */
  intentionMeta?: InputMaybe<Scalars['JSON']>;
  /** Properties to forward to our External Messaging Provider */
  intentionProperties?: InputMaybe<Scalars['JSON']>;
  /** The personalization properties of the intention configuration */
  personalizationProperties?: InputMaybe<Scalars['JSON']>;
  /** The scheduled send configuration for the campaign */
  scheduledSendConfiguration?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration_Input>;
  /** Map to specify which send type i.e. email and/or push_notification OR canvas */
  sendTypeTemplateMap?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap_Input>;
  /** The sentry team that created the intent configuration eg. crm-platform */
  sentryTeam?: InputMaybe<Scalars['String']>;
  /** The upstream system that created the intent eg. CIAO */
  sourceSystem?: InputMaybe<Scalars['String']>;
  /** The start time for the email to send. A null value indicates immediately */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The store configuration id for the campaign */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** The message intent configuration after creation */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CreateIntentionConfigurationResponse';
  /** The unique CRMS intenal intent configuration */
  crmIntentConfigurationId: Maybe<Scalars['String']>;
  /** the error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
};

/** Attributes necessary for making the marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignRequest_Input = {
  /** The id of the campaign returned from the campaign domain */
  campaignId?: InputMaybe<Scalars['String']>;
  /** The user friendly name of the campaign returned from the campaign domain */
  campaignName?: InputMaybe<Scalars['String']>;
  /**
   * The experiment name to use for the CRM Campaign
   * We provide a default if none is provide for Marketing Campaigns
   */
  experiment?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>;
  /** Whether or not to create a split experiment */
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the push notification template returned */
  pushNotificationId?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the segment. Currently for Braze's API */
  segmentId?: InputMaybe<Scalars['String']>;
  /** The start time for the email to send. A null value indicates immediately */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The store configuration id for the campaign */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The external id of the template returned */
  templateId?: InputMaybe<Scalars['String']>;
  /** Variables to append to the Braze template */
  templateVariables?: InputMaybe<Scalars['JSON']>;
  /** The email of the campaign initiator */
  userEmailOverrides?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The warehouse id to run the campaign for */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response for a marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CreateMarketingCampaignResponse';
  /** whether or not the creation was successful */
  creationSuccessful: Maybe<Scalars['Boolean']>;
  /** the error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
};

/** Attributes representing an Editable Template Variable */
export type Instacart_Growth_Crm_Messaging_Service_V1_EditableTemplateVariable = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_EditableTemplateVariable';
  channels: Maybe<Array<Maybe<Scalars['String']>>>;
  inputType: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  required: Maybe<Scalars['Boolean']>;
};

/** Attributes representing an Email Template */
export type Instacart_Growth_Crm_Messaging_Service_V1_EmailTemplate = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_EmailTemplate';
  body: Maybe<Scalars['String']>;
  externalTemplateId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  preheader: Maybe<Scalars['String']>;
  subject: Maybe<Scalars['String']>;
};

/** Attributes representing an Email Unsubscribes list */
export type Instacart_Growth_Crm_Messaging_Service_V1_EmailUnsubscribeList = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_EmailUnsubscribeList';
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['String']>;
  listName: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  warehouseId: Maybe<Scalars['String']>;
};

/** Specify experiment variant */
export type Instacart_Growth_Crm_Messaging_Service_V1_ExperimentVariant_Input = {
  /** Link to the intent configuration to be triggered */
  crmIntentConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Experiment to be applied for message intents
   * CRMSExperiment specifies variant name
   */
  experiment?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>;
  /**
   * Whether or not variant delay is ML driven
   * If so `seconds_to_wait` is ignored and
   * we'll make a request to ML service?
   * All parent and child seconds to wait could be set on creation?
   * Able to be personalized to user because IntentConfiguration is
   * mapped to user via CreateIntentRequest
   */
  mlDriven?: InputMaybe<Scalars['Boolean']>;
  /**
   * Number of seconds to wait before activation
   * Start time of parent + seconds_to_wait
   */
  secondsToWait?: InputMaybe<Scalars['BigInt']>;
};

/** Request object to fetch the status of a campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusRequest_Input = {
  /** Whether or not to return additional details, e.g. campaign template variables */
  detailed?: InputMaybe<Scalars['Boolean']>;
  /** Associated GS campaign ID */
  extId?: InputMaybe<Scalars['BigInt']>;
  /** Internal ID */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The store configuration id to fetch the campaign status for */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch the status of a campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetCampaignStatusResponse';
  brazeCanvasId: Maybe<Scalars['String']>;
  experimentName: Maybe<Scalars['String']>;
  failedUserCount: Maybe<Scalars['BigInt']>;
  pendingUserCount: Maybe<Scalars['BigInt']>;
  sendTypeTemplateMap: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap>;
  sentUserCount: Maybe<Scalars['BigInt']>;
  status: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CampaignStatus>;
  templateVariables: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables>;
  totalUserCount: Maybe<Scalars['BigInt']>;
};

/** Request to get email unsubscribe lists */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsRequest_Input = {
  /** Search term to filter the list names */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** The store configuration ids to check context */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The warehouse ids context for the request */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Response to get email unsubscribe lists */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetEmailUnsubscribeListsResponse';
  /** the error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The unsubscribe lists that have been uploaded */
  lists: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_EmailUnsubscribeList>>>;
};

/** Request to get an IntentionConfiguration by id */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationRequest_Input = {
  /** Associated GS campaign ID */
  extId?: InputMaybe<Scalars['BigInt']>;
  /** Internal ID */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Used to validate authorization for the request from IPP tooling
   * The store configuration id for the configuration
   */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse id for the configuration */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response to get an IntentionConfiguration by id */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetIntentionConfigurationResponse';
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The internal id of the intention configuration */
  intentionConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_IntentionConfiguration>;
};

/** Request to get a single retailer configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationRequest_Input = {
  /** The retailer's store configuration ID */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** The retailer ID */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response for getting a single retailer configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetRetailerConfigurationResponse';
  /** The error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The retailer configuration object returned */
  retailerConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfiguration>;
};

/** Request object to fetch the size of a segment */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeRequest_Input = {
  /** The segment id to get the size for */
  segmentId?: InputMaybe<Scalars['String']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch the size of a segment */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetSegmentSizeResponse';
  /** The size of the segment */
  size: Maybe<Scalars['BigInt']>;
};

/** Request object to fetch a template */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateRequest_Input = {
  /**
   * Optional connected content mock overrides for preview rendering.
   * Keys map to connected content endpoint names (e.g. "presentable_treatment_offers").
   */
  connectedContentMockResponseData?: InputMaybe<Scalars['JSON']>;
  /** Which types of templates to include */
  includedSendTypes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  /** The store configuration id for the configuration */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The template id to get */
  templateId?: InputMaybe<Scalars['String']>;
  /** Template Variables to inject in preview */
  templateVariables?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch a template */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetTemplateResponse';
  template: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_Template>;
};

/**
 * Parameters used in conjunction with the user_id to dictate
 * idempotency for the message intent
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_IdempotencyKey_Input = {
  /** eg. [offer_id, discount_id] */
  idempotencyParameterKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_IntentType {
  IntentTypeCanvas = 'INTENT_TYPE_CANVAS',
  IntentTypeCustomEvent = 'INTENT_TYPE_CUSTOM_EVENT',
  IntentTypeTemplate = 'INTENT_TYPE_TEMPLATE',
  IntentTypeUnknown = 'INTENT_TYPE_UNKNOWN'
}

/** Object representing an intention configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_IntentionConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_IntentionConfiguration';
  campaignId: Maybe<Scalars['String']>;
  campaignName: Maybe<Scalars['String']>;
  canvasId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['JSON']>;
  personalizationProperties: Maybe<Scalars['JSON']>;
  scheduledSendConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration>;
  sendTypeTemplateMap: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap>;
  sendTypes: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  templateVariables: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables>;
};

/** The lifecycle-specific settings for the retailer */
export type Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_LifecycleSettings';
  /** Whether the retailer has opted-into the Lifecycle CRM program via IPP */
  optInStatus: Maybe<Scalars['Boolean']>;
  /** The terms and conditions for each of the various incentive types offered */
  termsAndConditions: Maybe<Scalars['JSON']>;
};

/** The lifecycle-specific settings for the retailer */
export type Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings_Input = {
  /** Whether the retailer has opted-into the Lifecycle CRM program via IPP */
  optInStatus?: InputMaybe<Scalars['Boolean']>;
  /** The terms and conditions for each of the various incentive types offered */
  termsAndConditions?: InputMaybe<Scalars['JSON']>;
};

/** Request to list supported editable template variables */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesRequest_Input = {
  /** The store configuration id to check context */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response to list supported editable template variables */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ListEditableTemplateVariablesResponse';
  /** The list of supported editable template variables */
  variables: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_EditableTemplateVariable>>>;
};

/** Request object to fetch list of segments */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsRequest_Input = {
  /** The warehouse id to list segments for */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch list of segments */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ListSegmentsResponse';
  /** The list of segments for the warehouse */
  segments: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_Segment>>>;
};

/** Request object to fetch list of templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesRequest_Input = {
  /**
   * Optional connected content mock overrides for preview rendering.
   * Keys map to connected content endpoint names (e.g. "presentable_treatment_offers").
   */
  connectedContentMockResponseData?: InputMaybe<Scalars['JSON']>;
  /** Whether or not to force write templates to cache */
  forceWriteToCache?: InputMaybe<Scalars['Boolean']>;
  /** Which types of templates to include */
  includedSendTypes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  /** The store configuration id for the request */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** Template Variables to inject in previews */
  templateVariables?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch list of templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ListTemplatesResponse';
  templates: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_Template>>>;
};

/** The scheduled send configuration for a personalized campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_PersonalizedCampaignConfiguration';
  /** Minimum items required for the campaign to send */
  minimumItemsRequired: Maybe<Scalars['BigInt']>;
  /** The ranking context */
  rankingContext: Maybe<Instacart_Customers_Discovery_V1_RankingContext>;
  /** The retrieval context */
  retrievalContext: Maybe<Instacart_Customers_Discovery_V1_RetrievalContext>;
  /** Whether or not to use the optimized warehouse location */
  useOptimizedWarehouseLocation: Maybe<Scalars['Boolean']>;
};

/** The scheduled send configuration for a personalized campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration_Input = {
  /** Minimum items required for the campaign to send */
  minimumItemsRequired?: InputMaybe<Scalars['BigInt']>;
  /** The ranking context */
  rankingContext?: InputMaybe<Instacart_Customers_Discovery_V1_RankingContext_Input>;
  /** The retrieval context */
  retrievalContext?: InputMaybe<Instacart_Customers_Discovery_V1_RetrievalContext_Input>;
  /** Whether or not to use the optimized warehouse location */
  useOptimizedWarehouseLocation?: InputMaybe<Scalars['Boolean']>;
};

/** Attributes representing a Push Notification Template */
export type Instacart_Growth_Crm_Messaging_Service_V1_PushNotifcationTemplate = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_PushNotifcationTemplate';
  body: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  title: Maybe<Scalars['String']>;
};

/** A retailer configuration object */
export type Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_RetailerConfiguration';
  /** The id of the retailer_configuration */
  id: Maybe<Scalars['String']>;
  /** The name of the retailer_configuration */
  name: Maybe<Scalars['String']>;
  /** The settings on the retailer_configuration */
  settings: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings>;
  /** The id of the associated store_configuration */
  storeConfigurationId: Maybe<Scalars['String']>;
  /** The id of the associated warehouse */
  warehouseId: Maybe<Scalars['String']>;
};

/** The settings on the retailer_configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_RetailerConfigurationSettings';
  /** The lifecycle-specific settings for the retailer */
  lifecycle: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings>;
  /** Retailer-level template variables to be appended */
  templateVariables: Maybe<Scalars['JSON']>;
};

/** The settings on the retailer_configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings_Input = {
  /** The lifecycle-specific settings for the retailer */
  lifecycle?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings_Input>;
  /** Retailer-level template variables to be appended */
  templateVariables?: InputMaybe<Scalars['JSON']>;
};

/** The scheduled send configuration for the campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ScheduledSendConfiguration';
  /** The configuration for a personalized campaign */
  personalizedCampaignConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration>;
  /** The configuration for a PNE campaign */
  personalizedNotificationEngineConfiguration: Maybe<Scalars['JSON']>;
};

/** The scheduled send configuration for the campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration_Input = {
  /** The configuration for a personalized campaign */
  personalizedCampaignConfiguration?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration_Input>;
  /** The configuration for a PNE campaign */
  personalizedNotificationEngineConfiguration?: InputMaybe<Scalars['JSON']>;
};

/** Attributes representing a user Segment */
export type Instacart_Growth_Crm_Messaging_Service_V1_Segment = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_Segment';
  accessibleWarehouseIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  externalSegmentId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  segmentName: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_SendType {
  SendTypeCanvas = 'SEND_TYPE_CANVAS',
  SendTypeEmail = 'SEND_TYPE_EMAIL',
  SendTypePush = 'SEND_TYPE_PUSH',
  SendTypeUnknown = 'SEND_TYPE_UNKNOWN'
}

/** Object mapping send type to template id */
export type Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_SendTypeTemplateMap';
  canvas: Maybe<Scalars['BigInt']>;
  email: Maybe<Scalars['BigInt']>;
  /**
   * DEPRECATED: push stores id from the push_notification_template table
   * Use push_notification instead to store id from templates table for consistency with email/canvas
   */
  push: Maybe<Scalars['BigInt']>;
  pushNotification: Maybe<Scalars['BigInt']>;
};

/** Object mapping send type to template id */
export type Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap_Input = {
  canvas?: InputMaybe<Scalars['BigInt']>;
  email?: InputMaybe<Scalars['BigInt']>;
  /**
   * DEPRECATED: push stores id from the push_notification_template table
   * Use push_notification instead to store id from templates table for consistency with email/canvas
   */
  push?: InputMaybe<Scalars['BigInt']>;
  pushNotification?: InputMaybe<Scalars['BigInt']>;
};

/** Attributes representing our internal template object */
export type Instacart_Growth_Crm_Messaging_Service_V1_Template = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_Template';
  canvasTemplate: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CanvasTemplate>;
  emailTemplate: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_EmailTemplate>;
  id: Maybe<Scalars['BigInt']>;
  pushNotificationTemplate: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_PushNotifcationTemplate>;
  templateName: Maybe<Scalars['String']>;
};

/** Set of variables we allow injecting into templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_TemplateVariables';
  couponCode: Maybe<Scalars['String']>;
  daysValid: Maybe<Scalars['String']>;
  editableTemplateVariables: Maybe<Scalars['JSON']>;
  expiresAtUnix: Maybe<Scalars['String']>;
  offerDetails: Maybe<Scalars['JSON']>;
  offerDetailsDollarOff: Maybe<Scalars['String']>;
  offerDetailsIncentiveType: Maybe<Scalars['String']>;
  offerDetailsMinimumOrder: Maybe<Scalars['String']>;
  retailerLogoUrl: Maybe<Scalars['String']>;
  retailerName: Maybe<Scalars['String']>;
  retailerSlug: Maybe<Scalars['String']>;
  storeType: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStoreType>;
  storefrontType: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStorefrontType>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStoreType {
  TemplateVariablesStoreTypeOneHour = 'TEMPLATE_VARIABLES_STORE_TYPE_ONE_HOUR',
  TemplateVariablesStoreTypeThirtyMin = 'TEMPLATE_VARIABLES_STORE_TYPE_THIRTY_MIN',
  TemplateVariablesStoreTypeUnknown = 'TEMPLATE_VARIABLES_STORE_TYPE_UNKNOWN'
}

export enum Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStorefrontType {
  TemplateVariablesStorefrontTypeInstacart = 'TEMPLATE_VARIABLES_STOREFRONT_TYPE_INSTACART',
  TemplateVariablesStorefrontTypePbi = 'TEMPLATE_VARIABLES_STOREFRONT_TYPE_PBI',
  TemplateVariablesStorefrontTypeUnknown = 'TEMPLATE_VARIABLES_STOREFRONT_TYPE_UNKNOWN'
}

/** Set of variables we allow injecting into templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input = {
  couponCode?: InputMaybe<Scalars['String']>;
  daysValid?: InputMaybe<Scalars['String']>;
  editableTemplateVariables?: InputMaybe<Scalars['JSON']>;
  expiresAtUnix?: InputMaybe<Scalars['String']>;
  offerDetails?: InputMaybe<Scalars['JSON']>;
  offerDetailsDollarOff?: InputMaybe<Scalars['String']>;
  offerDetailsIncentiveType?: InputMaybe<Scalars['String']>;
  offerDetailsMinimumOrder?: InputMaybe<Scalars['String']>;
  retailerLogoUrl?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
  storeType?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStoreType>;
  storefrontType?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStorefrontType>;
};

/** Request to update intention configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationRequest_Input = {
  /** The enabled send types for the intention configuration */
  enabledSendTypes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  /** The intention configuration to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The intention properties to update */
  intentionProperties?: InputMaybe<Scalars['JSON']>;
  /** The store_configuration_id of the intention configuration */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse_id of the intention configuration */
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response to update intention configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_UpdateIntentionConfigurationResponse';
  /** The error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** Whether or not the update was successful */
  updateSuccessful: Maybe<Scalars['Boolean']>;
};

/** Request for updating retailer configuration settings */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsRequest_Input = {
  /** The settings to update */
  settings?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings_Input>;
  /** store_configuration_id of the retailer_config to update */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** warehouse_id of the retailer_config to update */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response for updating retailer configuration settings */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_UpdateRetailerConfigurationSettingsResponse';
  /** The error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The updated retailer configuration object */
  retailerConfiguration: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfiguration>;
};

/** Request to upsert email unsubscribers */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersRequest_Input = {
  /** The email addresses to upsert */
  emailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  listName?: InputMaybe<Scalars['String']>;
  /** DEPRECATED: The retailer slug to upsert */
  retailerSlug?: InputMaybe<Scalars['String']>;
  /** The store configuration id to upsert */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** The warehouse id to upsert */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response to upsert email unsubscribers */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_UpsertEmailUnsubscribersResponse';
  /** The error message if one occurs */
  error: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** Whether or not the upsert was successful */
  upsertSuccessful: Maybe<Scalars['Boolean']>;
};

/**
 * AuthorizationContext provides the user identity and the retailer/store context
 * for a campaign operation within the Instacart Partner Platform (IPP). Every request
 * must include this context. It is validated against the user's authorized resources
 * and enforced in GraphQL Mesh.
 */
export type Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input = {
  /** Retailer IDs that define the scope of the request. These should be authorized for the user upstream */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Store Configuration IDs that define the scope of the request. These should be authorized for the user upstream */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Canonical UUID uniquely identifying the user across the Instacart Partner Platform. */
  userCanonicalUuid?: InputMaybe<Scalars['String']>;
  /** Numeric user ID for the authenticated user. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** BasketRewardInput defines a discount applied to the customer's order basket. */
export type Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_BasketRewardInput';
  /** Discount amount as a string (e.g., "5.00" for $5 off, "10" for 10% off). */
  amount: Maybe<Scalars['String']>;
  /** Type of discount (dollar off, percentage off, or credit back). */
  discountType: Maybe<Instacart_Growth_Marketing_Tooling_V1_DiscountType>;
  /** Maximum discount amount for percentage-based discounts (caps the discount). */
  maxDiscountAmount: Maybe<Scalars['String']>;
  /** Whether the reward applies to the same departments as the condition or different ones. */
  rewardApplication: Maybe<Instacart_Growth_Marketing_Tooling_V1_RewardApplication>;
  /** Department IDs the reward applies to when reward_application is set. */
  rewardDepartmentIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** BasketRewardInput defines a discount applied to the customer's order basket. */
export type Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput_Input = {
  /** Discount amount as a string (e.g., "5.00" for $5 off, "10" for 10% off). */
  amount?: InputMaybe<Scalars['String']>;
  /** Type of discount (dollar off, percentage off, or credit back). */
  discountType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_DiscountType>;
  /** Maximum discount amount for percentage-based discounts (caps the discount). */
  maxDiscountAmount?: InputMaybe<Scalars['String']>;
  /** Whether the reward applies to the same departments as the condition or different ones. */
  rewardApplication?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RewardApplication>;
  /** Department IDs the reward applies to when reward_application is set. */
  rewardDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * BudgetCapping controls whether the system automatically caps spending
 * when the budget is exhausted.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_BudgetCapping {
  BudgetCappingAutomatic = 'BUDGET_CAPPING_AUTOMATIC',
  BudgetCappingNone = 'BUDGET_CAPPING_NONE',
  BudgetCappingUnknown = 'BUDGET_CAPPING_UNKNOWN'
}

/**
 * BudgetRestrictionsInput defines budget caps and funding split configuration
 * for the offer.
 */
export type Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_BudgetRestrictionsInput';
  /** Whether budget capping is automatic or disabled. */
  budgetCapping: Maybe<Instacart_Growth_Marketing_Tooling_V1_BudgetCapping>;
  /** How the offer cost is split between Instacart and the retailer. */
  fundingType: Maybe<Instacart_Growth_Marketing_Tooling_V1_FundingType>;
  /** Instacart's share of the funding as a percentage string (e.g., "50"). */
  instacartFundingPercent: Maybe<Scalars['String']>;
  /** Total lifetime budget for this offer as a string (e.g., "10000.00"). */
  lifetimeBudget: Maybe<Scalars['String']>;
  /** Retailer's share of the funding as a percentage string (e.g., "50"). */
  retailerFundingPercent: Maybe<Scalars['String']>;
};

/**
 * BudgetRestrictionsInput defines budget caps and funding split configuration
 * for the offer.
 */
export type Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput_Input = {
  /** Whether budget capping is automatic or disabled. */
  budgetCapping?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_BudgetCapping>;
  /** How the offer cost is split between Instacart and the retailer. */
  fundingType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FundingType>;
  /** Instacart's share of the funding as a percentage string (e.g., "50"). */
  instacartFundingPercent?: InputMaybe<Scalars['String']>;
  /** Total lifetime budget for this offer as a string (e.g., "10000.00"). */
  lifetimeBudget?: InputMaybe<Scalars['String']>;
  /** Retailer's share of the funding as a percentage string (e.g., "50"). */
  retailerFundingPercent?: InputMaybe<Scalars['String']>;
};

/**
 * CRMConfiguration defines how the campaign integrates with the CRM messaging system
 * to send communications (emails, push notifications, SMS, etc.) to targeted users.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CRMConfiguration';
  /**
   * ID of a Braze Canvas for orchestrating multi-step customer journeys.
   * Canvases allow complex messaging flows with conditional logic and timing.
   */
  canvasId: Maybe<Scalars['String']>;
  /** Mapping of communication channels (email, push, SMS) to their respective message templates. */
  sendTypeTemplateMap: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap>;
  /**
   * Dynamic variables to populate in message templates (e.g., user name, discount amount).
   * These are merged with templates at send time to personalize messages.
   * Imported from CRM Proto.
   */
  templateVariables: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables>;
};

/**
 * CRMConfiguration defines how the campaign integrates with the CRM messaging system
 * to send communications (emails, push notifications, SMS, etc.) to targeted users.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration_Input = {
  /**
   * ID of a Braze Canvas for orchestrating multi-step customer journeys.
   * Canvases allow complex messaging flows with conditional logic and timing.
   */
  canvasId?: InputMaybe<Scalars['String']>;
  /** Mapping of communication channels (email, push, SMS) to their respective message templates. */
  sendTypeTemplateMap?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap_Input>;
  /**
   * Dynamic variables to populate in message templates (e.g., user name, discount amount).
   * These are merged with templates at send time to personalize messages.
   * Imported from CRM Proto.
   */
  templateVariables?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input>;
};

/**
 * CampaignConfiguration contains all operational settings for a marketing campaign,
 * including scheduling, budget management, treatment assignments, and tracking parameters.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration';
  /** Primary objective or goal of the campaign (e.g., increase orders, drive engagement). */
  campaignObjective: Maybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  /**
   * UTM parameters and other tracking references for attributing campaign performance.
   * Imported from Campaigns Proto.
   */
  campaignReference: Maybe<Instacart_Customers_Coupons_V1_CampaignReference>;
  /** Custom key-value properties for extending campaign metadata with arbitrary data. */
  customProperties: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CustomProperty>>>;
  /** Settings controlling how and where the campaign can be discovered or accessed. */
  discoverability: Maybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /**
   * Additional filters on the campaign to further refine behaviour
   * Imported from Campaigns Proto.
   */
  filters: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CampaignFilter>>>;
  /**
   * If true, this campaign is hidden from retailer-facing dashboards and reports.
   * Used for internal or test campaigns.
   */
  hideFromRetailer: Maybe<Scalars['Boolean']>;
  /** When this campaign is scheduled to run. */
  schedule: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule>;
  /** Current status of the campaign (e.g., "draft", "active", "paused", "completed"). */
  status: Maybe<Scalars['String']>;
  /** Configuration for how treatments are assigned and delivered to users. */
  treatmentConfiguration: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration>;
  /** Type of campaign (e.g., "promotional", "retention", "acquisition"). */
  type: Maybe<Scalars['String']>;
};

/** CampaignSchedule defines when a campaign is active and how it recurs over time. */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration_CampaignSchedule';
  /** End timestamp for when the campaign stops being active. */
  endsAt: Maybe<Scalars['DateTime']>;
  /**
   * Optional recurring schedule pattern (e.g., "daily", "weekly", cron expression).
   * If set, the campaign will repeat according to this schedule.
   */
  recurringSchedule: Maybe<Scalars['String']>;
  /** Start timestamp for when the campaign becomes active. */
  startsAt: Maybe<Scalars['DateTime']>;
  /**
   * Timezone for interpreting the schedule timestamps (e.g., "America/Los_Angeles").
   * Important for ensuring campaigns activate at the correct local time.
   */
  timezone: Maybe<Scalars['String']>;
};

/** CampaignSchedule defines when a campaign is active and how it recurs over time. */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule_Input = {
  /** End timestamp for when the campaign stops being active. */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Optional recurring schedule pattern (e.g., "daily", "weekly", cron expression).
   * If set, the campaign will repeat according to this schedule.
   */
  recurringSchedule?: InputMaybe<Scalars['String']>;
  /** Start timestamp for when the campaign becomes active. */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Timezone for interpreting the schedule timestamps (e.g., "America/Los_Angeles").
   * Important for ensuring campaigns activate at the correct local time.
   */
  timezone?: InputMaybe<Scalars['String']>;
};

/**
 * CampaignConfiguration contains all operational settings for a marketing campaign,
 * including scheduling, budget management, treatment assignments, and tracking parameters.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_Input = {
  /** Primary objective or goal of the campaign (e.g., increase orders, drive engagement). */
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  /**
   * UTM parameters and other tracking references for attributing campaign performance.
   * Imported from Campaigns Proto.
   */
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  /** Custom key-value properties for extending campaign metadata with arbitrary data. */
  customProperties?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CustomProperty_Input>>>;
  /** Settings controlling how and where the campaign can be discovered or accessed. */
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /**
   * Additional filters on the campaign to further refine behaviour
   * Imported from Campaigns Proto.
   */
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /**
   * If true, this campaign is hidden from retailer-facing dashboards and reports.
   * Used for internal or test campaigns.
   */
  hideFromRetailer?: InputMaybe<Scalars['Boolean']>;
  /** When this campaign is scheduled to run. */
  schedule?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule_Input>;
  /** Current status of the campaign (e.g., "draft", "active", "paused", "completed"). */
  status?: InputMaybe<Scalars['String']>;
  /** Configuration for how treatments are assigned and delivered to users. */
  treatmentConfiguration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration_Input>;
  /** Type of campaign (e.g., "promotional", "retention", "acquisition"). */
  type?: InputMaybe<Scalars['String']>;
};

/** TreatmentConfiguration defines how users are assigned to different campaign treatments */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration_TreatmentConfiguration';
  /**
   * If true, each treatment has its own policy for determining eligibility and delivery.
   * If false, treatments share a common policy.
   */
  separateTreatmentPolicies: Maybe<Scalars['Boolean']>;
  /**
   * Slot IDs represent placements or channels where this campaign's treatments can appear
   * (e.g., email slots, in-app banner slots, etc.).
   */
  slotIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Parameters for the treatment task */
  treatmentTask: Maybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams>;
  /** The actual treatment definitions including variations, content, and delivery rules. */
  treatments: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments>;
};

/** TreatmentConfiguration defines how users are assigned to different campaign treatments */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration_Input = {
  /**
   * If true, each treatment has its own policy for determining eligibility and delivery.
   * If false, treatments share a common policy.
   */
  separateTreatmentPolicies?: InputMaybe<Scalars['Boolean']>;
  /**
   * Slot IDs represent placements or channels where this campaign's treatments can appear
   * (e.g., email slots, in-app banner slots, etc.).
   */
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Parameters for the treatment task */
  treatmentTask?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams_Input>;
  /** The actual treatment definitions including variations, content, and delivery rules. */
  treatments?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input>;
};

/**
 * CampaignContext defines the scope of a marketing campaign.
 * It specifies which retailers, sites, and countries the campaign applies to.
 * This is the source of truth and propogated to all downstream systems.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignContext = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignContext';
  /** Country ID where this campaign is active. Used for international campaign management. */
  countryId: Maybe<Scalars['BigInt']>;
  /** internal IPP user ID of the person who created this campaign. Used for audit trails and permissions. */
  creatorIppUserId: Maybe<Scalars['BigInt']>;
  /** List of retailer IDs to explicitly exclude from this campaign. */
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Canonical UUID of the IPP (Instacart Partner Platform) user context. */
  ippUserCanonicalUuid: Maybe<Scalars['String']>;
  /** List of retailer IDs that this campaign targets. */
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** List of store configuration IDs that this campaign targets. */
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * CampaignContext defines the scope of a marketing campaign.
 * It specifies which retailers, sites, and countries the campaign applies to.
 * This is the source of truth and propogated to all downstream systems.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignContext_Input = {
  /** Country ID where this campaign is active. Used for international campaign management. */
  countryId?: InputMaybe<Scalars['BigInt']>;
  /** internal IPP user ID of the person who created this campaign. Used for audit trails and permissions. */
  creatorIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** List of retailer IDs to explicitly exclude from this campaign. */
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Canonical UUID of the IPP (Instacart Partner Platform) user context. */
  ippUserCanonicalUuid?: InputMaybe<Scalars['String']>;
  /** List of retailer IDs that this campaign targets. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** List of store configuration IDs that this campaign targets. */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/**
 * CreateMarketingCampaignRequest initiates the creation of a new marketing campaign
 * across all relevant Instacart systems (TaaS, CRM, Commerce, Campaigns, Roulette).
 */
export type Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignRequest_Input = {
  /**
   * Authorization context of the user creating the campaign.
   * Ensures the user has permission to create campaigns for the specified retailers.
   */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** Campaign definition to create. The ID field should not be set as it will be auto-generated. */
  marketingCampaign?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign_Input>;
};

/**
 * CreateMarketingCampaignResponse returns the created campaign with its assigned ID
 * and any system-generated fields, along with status information about the operation.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignResponse = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CreateMarketingCampaignResponse';
  /**
   * The created campaign with all fields populated, including the auto-generated ID.
   * Will be null/empty if the creation failed.
   */
  marketingCampaign: Maybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign>;
  /** Status indicating whether the creation succeeded or failed, with error details if applicable. */
  status: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/** DiscountType specifies the kind of discount applied to the basket. */
export enum Instacart_Growth_Marketing_Tooling_V1_DiscountType {
  DiscountTypeCreditBack = 'DISCOUNT_TYPE_CREDIT_BACK',
  DiscountTypeDollarOff = 'DISCOUNT_TYPE_DOLLAR_OFF',
  DiscountTypePercentageOff = 'DISCOUNT_TYPE_PERCENTAGE_OFF',
  DiscountTypeUnknown = 'DISCOUNT_TYPE_UNKNOWN'
}

/**
 * Experiment defines A/B test or multivariate test configuration for the campaign.
 * Allows testing different campaign variations to determine optimal performance.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Experiment';
  /** Reference to an existing Roulette feature flag experiment by its configuration. */
  existing: Maybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature>;
  /** Define a new experiment with its own variants and preconditions. */
  new: Maybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition>;
};

/**
 * ExperimentDefinition contains the complete configuration for a new experiment,
 * including preconditions and all variants to be tested.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Experiment_ExperimentDefinition';
  /** Human-readable name for this experiment feature in Roulette. */
  name: Maybe<Scalars['String']>;
  /**
   * Roulette features that must be assigned for users to be eligible for this experiment.
   * These are preconditions checked before variant assignment.
   */
  roulettePreconditions: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition>>>;
  /**
   * List of variants in this experiment. Users are randomly assigned to one variant
   * based on the weights specified. Weights must sum to 100.
   */
  variants: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant>>>;
};

/**
 * ExperimentDefinition contains the complete configuration for a new experiment,
 * including preconditions and all variants to be tested.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition_Input = {
  /** Human-readable name for this experiment feature in Roulette. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Roulette features that must be assigned for users to be eligible for this experiment.
   * These are preconditions checked before variant assignment.
   */
  roulettePreconditions?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition_Input>>>;
  /**
   * List of variants in this experiment. Users are randomly assigned to one variant
   * based on the weights specified. Weights must sum to 100.
   */
  variants?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant_Input>>>;
};

/** ExperimentVariant represents a single variation in an A/B or multivariate test. */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Experiment_ExperimentVariant';
  /** Whether this variant is the default/control variant. */
  isDefault: Maybe<Scalars['Boolean']>;
  /** Human-readable name for this variant (e.g., "Control", "Treatment A", "20% Discount"). */
  name: Maybe<Scalars['String']>;
  /**
   * Weight for traffic allocation as a percentage (0-100). All variant weights must sum to 100.
   * For example, weights of [50, 50] split traffic evenly, [80, 20] gives 80% to the first variant.
   */
  weight: Maybe<Scalars['BigInt']>;
};

/** ExperimentVariant represents a single variation in an A/B or multivariate test. */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant_Input = {
  /** Whether this variant is the default/control variant. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Human-readable name for this variant (e.g., "Control", "Treatment A", "20% Discount"). */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Weight for traffic allocation as a percentage (0-100). All variant weights must sum to 100.
   * For example, weights of [50, 50] split traffic evenly, [80, 20] gives 80% to the first variant.
   */
  weight?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Experiment defines A/B test or multivariate test configuration for the campaign.
 * Allows testing different campaign variations to determine optimal performance.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_Input = {
  /** Reference to an existing Roulette feature flag experiment by its configuration. */
  existing?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input>;
  /** Define a new experiment with its own variants and preconditions. */
  new?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition_Input>;
};

/** FeeRewardInput defines a fee waiver reward. */
export type Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_FeeRewardInput';
  /** Which fee is waived. */
  feeType: Maybe<Instacart_Growth_Marketing_Tooling_V1_FeeType>;
};

/** FeeRewardInput defines a fee waiver reward. */
export type Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput_Input = {
  /** Which fee is waived. */
  feeType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FeeType>;
};

/** FeeType specifies which fulfillment fee is waived by the offer. */
export enum Instacart_Growth_Marketing_Tooling_V1_FeeType {
  FeeTypeDelivery = 'FEE_TYPE_DELIVERY',
  FeeTypePickup = 'FEE_TYPE_PICKUP',
  FeeTypePickupOrDelivery = 'FEE_TYPE_PICKUP_OR_DELIVERY',
  FeeTypePriority = 'FEE_TYPE_PRIORITY',
  FeeTypeService = 'FEE_TYPE_SERVICE',
  FeeTypeUnknown = 'FEE_TYPE_UNKNOWN'
}

/** FundingType specifies how the offer cost is split between Instacart and the retailer. */
export enum Instacart_Growth_Marketing_Tooling_V1_FundingType {
  FundingTypeCustomSplit = 'FUNDING_TYPE_CUSTOM_SPLIT',
  FundingTypeFiftyFifty = 'FUNDING_TYPE_FIFTY_FIFTY',
  FundingTypeFullyInstacart = 'FUNDING_TYPE_FULLY_INSTACART',
  FundingTypeFullyRetailer = 'FUNDING_TYPE_FULLY_RETAILER',
  FundingTypeUnknown = 'FUNDING_TYPE_UNKNOWN'
}

/** GetMarketingCampaignRequest retrieves a marketing campaign by its ID. */
export type Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignRequest_Input = {
  /**
   * Authorization context of the user requesting the campaign.
   * Ensures the user has permission to view campaigns for the specified retailers.
   */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** The unique identifier of the campaign to retrieve. */
  campaignId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * GetMarketingCampaignResponse returns the campaign with all its associated entities.
 * Returns partial data if some entity fetches fail, with errors indicating which failed.
 */
export type Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignResponse = {
  __typename?: 'instacart_growth_marketing_tooling_v1_GetMarketingCampaignResponse';
  /**
   * The retrieved campaign with all associated entities that were successfully fetched.
   * May contain partial data if some entity fetches failed.
   */
  marketingCampaign: Maybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign>;
  /** Status indicating success or partial success with error details for any failed entity fetches. */
  status: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/**
 * MarketingCampaign is the unified representation of a marketing campaign across all Instacart
 * marketing systems. It combines context (who/where), configuration (what/when),
 * targeting (audience), experimentation (variants), messaging (CRM), and incentives (discounts).
 */
export type Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign = {
  __typename?: 'instacart_growth_marketing_tooling_v1_MarketingCampaign';
  /** Operational settings: schedule, budget, treatments, tracking, and custom properties. */
  configuration: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration>;
  /** Scope: which retailers, sites, and countries this campaign applies to. */
  context: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignContext>;
  /** Messaging configuration for delivering communications through various CRM channels. */
  crmConfiguration: Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration>;
  /** A/B testing configuration for comparing different campaign variations. */
  experiment: Maybe<Instacart_Growth_Marketing_Tooling_V1_Experiment>;
  /**
   * Unique identifier for this campaign. Auto-generated on creation.
   * Not required when creating a new campaign.
   */
  id: Maybe<Scalars['BigInt']>;
  /** Flexible metadata field for storing additional campaign information not covered by other fields. */
  meta: Maybe<Scalars['JSON']>;
  /** Human-readable name for this campaign. */
  name: Maybe<Scalars['String']>;
  /** Offer input representing reward, requirements, redemption, and budget. */
  offer: Maybe<Instacart_Growth_Marketing_Tooling_V1_OfferInput>;
  /** Reporting and attribution metadata for the campaign (tags, cost center, finance typology, etc.). */
  reporting: Maybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput>;
  /** Audience criteria: geographic regions and behavioral segments that define eligibility. */
  targeting: Maybe<Instacart_Growth_Marketing_Tooling_V1_Targeting>;
  /** Value grant policy data for discounts, credits, and rewards. */
  valueGrantPolicy: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade>;
};

/**
 * MarketingCampaign is the unified representation of a marketing campaign across all Instacart
 * marketing systems. It combines context (who/where), configuration (what/when),
 * targeting (audience), experimentation (variants), messaging (CRM), and incentives (discounts).
 */
export type Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign_Input = {
  /** Operational settings: schedule, budget, treatments, tracking, and custom properties. */
  configuration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_Input>;
  /** Scope: which retailers, sites, and countries this campaign applies to. */
  context?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignContext_Input>;
  /** Messaging configuration for delivering communications through various CRM channels. */
  crmConfiguration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration_Input>;
  /** A/B testing configuration for comparing different campaign variations. */
  experiment?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_Input>;
  /**
   * Unique identifier for this campaign. Auto-generated on creation.
   * Not required when creating a new campaign.
   */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Flexible metadata field for storing additional campaign information not covered by other fields. */
  meta?: InputMaybe<Scalars['JSON']>;
  /** Human-readable name for this campaign. */
  name?: InputMaybe<Scalars['String']>;
  /** Offer input representing reward, requirements, redemption, and budget. */
  offer?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_OfferInput_Input>;
  /** Reporting and attribution metadata for the campaign (tags, cost center, finance typology, etc.). */
  reporting?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput_Input>;
  /** Audience criteria: geographic regions and behavioral segments that define eligibility. */
  targeting?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Targeting_Input>;
  /** Value grant policy data for discounts, credits, and rewards. */
  valueGrantPolicy?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade_Input>;
};

/**
 * MinimumSpendRequirementInput requires the customer to spend a minimum amount,
 * optionally scoped to specific departments with exclusions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_MinimumSpendRequirementInput';
  /** Minimum spend amount as a string (e.g., "25.00"). */
  amount: Maybe<Scalars['String']>;
  /** Department IDs that count toward the minimum spend when scope is INSTACART_DEPARTMENT. */
  departmentIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether to exclude alcohol items from the minimum spend calculation. */
  excludeAlcohol: Maybe<Scalars['Boolean']>;
  /** Whether to exclude brand items from the minimum spend calculation. */
  excludeBrands: Maybe<Scalars['Boolean']>;
  /** Whether to exclude collection items from the minimum spend calculation. */
  excludeCollections: Maybe<Scalars['Boolean']>;
  /** Specific brand IDs to exclude from the minimum spend calculation. */
  excludedBrandIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Specific collection IDs to exclude from the minimum spend calculation. */
  excludedCollectionIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether the minimum spend applies to the full basket or specific departments. */
  scope: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementScope>;
};

/**
 * MinimumSpendRequirementInput requires the customer to spend a minimum amount,
 * optionally scoped to specific departments with exclusions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput_Input = {
  /** Minimum spend amount as a string (e.g., "25.00"). */
  amount?: InputMaybe<Scalars['String']>;
  /** Department IDs that count toward the minimum spend when scope is INSTACART_DEPARTMENT. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to exclude alcohol items from the minimum spend calculation. */
  excludeAlcohol?: InputMaybe<Scalars['Boolean']>;
  /** Whether to exclude brand items from the minimum spend calculation. */
  excludeBrands?: InputMaybe<Scalars['Boolean']>;
  /** Whether to exclude collection items from the minimum spend calculation. */
  excludeCollections?: InputMaybe<Scalars['Boolean']>;
  /** Specific brand IDs to exclude from the minimum spend calculation. */
  excludedBrandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specific collection IDs to exclude from the minimum spend calculation. */
  excludedCollectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether the minimum spend applies to the full basket or specific departments. */
  scope?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementScope>;
};

/**
 * OfferInput is the top-level offer definition containing reward, requirements,
 * redemption rules, and budget restrictions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_OfferInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_OfferInput';
  /** Budget caps and funding split configuration. */
  budgetRestrictions: Maybe<Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput>;
  /** How many times and under what conditions the offer can be redeemed. */
  redemption: Maybe<Instacart_Growth_Marketing_Tooling_V1_RedemptionInput>;
  /** Conditions the customer must meet to be eligible for the offer. */
  requirements: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementInput>;
  /** What the customer receives (discount or fee waiver). */
  reward: Maybe<Instacart_Growth_Marketing_Tooling_V1_RewardInput>;
};

/**
 * OfferInput is the top-level offer definition containing reward, requirements,
 * redemption rules, and budget restrictions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_OfferInput_Input = {
  /** Budget caps and funding split configuration. */
  budgetRestrictions?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput_Input>;
  /** How many times and under what conditions the offer can be redeemed. */
  redemption?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RedemptionInput_Input>;
  /** Conditions the customer must meet to be eligible for the offer. */
  requirements?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementInput_Input>;
  /** What the customer receives (discount or fee waiver). */
  reward?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RewardInput_Input>;
};

/**
 * RedemptionInput controls how many times and under what conditions the offer
 * can be redeemed by customers.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RedemptionInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RedemptionInput';
  /** Whether this offer is available on the Instacart marketplace (non-retailer-specific). */
  allowMarketplace: Maybe<Scalars['Boolean']>;
  /** Coupon code customers must enter to redeem the offer. */
  couponCode: Maybe<Scalars['String']>;
  /** Total number of coupons available for this offer. */
  couponCount: Maybe<Scalars['String']>;
  /** Maximum number of times a single customer can redeem this offer. */
  customerRedemptionLimit: Maybe<Scalars['String']>;
  /** UTM parameters for tracking offer attribution. */
  utmParams: Maybe<Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput>;
};

/**
 * RedemptionInput controls how many times and under what conditions the offer
 * can be redeemed by customers.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RedemptionInput_Input = {
  /** Whether this offer is available on the Instacart marketplace (non-retailer-specific). */
  allowMarketplace?: InputMaybe<Scalars['Boolean']>;
  /** Coupon code customers must enter to redeem the offer. */
  couponCode?: InputMaybe<Scalars['String']>;
  /** Total number of coupons available for this offer. */
  couponCount?: InputMaybe<Scalars['String']>;
  /** Maximum number of times a single customer can redeem this offer. */
  customerRedemptionLimit?: InputMaybe<Scalars['String']>;
  /** UTM parameters for tracking offer attribution. */
  utmParams?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput_Input>;
};

/**
 * ReportingInput contains reporting and attribution metadata for the campaign,
 * including tags, cost center, finance typology, and custom properties.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ReportingInput';
  /** Campaign rollup identifier for aggregating related campaigns in reports. */
  campaignRollup: Maybe<Scalars['String']>;
  /** Tags for categorizing and filtering campaigns in reports. */
  campaignTags: Maybe<Scalars['String']>;
  /** Cost center responsible for this campaign's spend. */
  costCenterOwner: Maybe<Scalars['String']>;
  /** Additional custom key-value properties for extending reporting metadata. */
  customProperties: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty>>>;
  /** Finance typology classification for accounting and billing. */
  financeTypology: Maybe<Scalars['String']>;
  /** Marketing ID for cross-system attribution. */
  marketingId: Maybe<Scalars['String']>;
};

/** Custom property for reporting metadata. */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ReportingInput_CustomProperty';
  /** Property key. */
  key: Maybe<Scalars['String']>;
  /** Property value. */
  value: Maybe<Scalars['String']>;
};

/** Custom property for reporting metadata. */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty_Input = {
  /** Property key. */
  key?: InputMaybe<Scalars['String']>;
  /** Property value. */
  value?: InputMaybe<Scalars['String']>;
};

/**
 * ReportingInput contains reporting and attribution metadata for the campaign,
 * including tags, cost center, finance typology, and custom properties.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput_Input = {
  /** Campaign rollup identifier for aggregating related campaigns in reports. */
  campaignRollup?: InputMaybe<Scalars['String']>;
  /** Tags for categorizing and filtering campaigns in reports. */
  campaignTags?: InputMaybe<Scalars['String']>;
  /** Cost center responsible for this campaign's spend. */
  costCenterOwner?: InputMaybe<Scalars['String']>;
  /** Additional custom key-value properties for extending reporting metadata. */
  customProperties?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty_Input>>>;
  /** Finance typology classification for accounting and billing. */
  financeTypology?: InputMaybe<Scalars['String']>;
  /** Marketing ID for cross-system attribution. */
  marketingId?: InputMaybe<Scalars['String']>;
};

/** RequirementInput defines conditions the customer must meet to qualify for the offer. */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RequirementInput';
  /** Customer must spend a minimum amount (optionally scoped to specific departments). */
  minimumSpend: Maybe<Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput>;
  /** Customer must complete a specific task (e.g., sign up, complete a survey). */
  taskRequired: Maybe<Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput>;
};

/** RequirementInput defines conditions the customer must meet to qualify for the offer. */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementInput_Input = {
  /** Customer must spend a minimum amount (optionally scoped to specific departments). */
  minimumSpend?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput_Input>;
  /** Customer must complete a specific task (e.g., sign up, complete a survey). */
  taskRequired?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput_Input>;
};

/**
 * RequirementScope defines whether the minimum spend applies to the full basket
 * or is scoped to specific Instacart departments.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_RequirementScope {
  RequirementScopeBasket = 'REQUIREMENT_SCOPE_BASKET',
  RequirementScopeInstacartDepartment = 'REQUIREMENT_SCOPE_INSTACART_DEPARTMENT',
  RequirementScopeUnknown = 'REQUIREMENT_SCOPE_UNKNOWN'
}

/**
 * ResponseStatus provides standardized success/failure information for all API responses.
 * It includes detailed error information when operations fail, making it easier to debug
 * and handle errors programmatically.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ResponseStatus = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ResponseStatus';
  /** Error details if success is false. Null/empty if the operation succeeded. */
  errors: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error>>>;
  /** Whether the operation completed successfully. */
  success: Maybe<Scalars['Boolean']>;
};

/** Error contains detailed information about what went wrong during request processing. */
export type Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ResponseStatus_Error';
  /** Machine-readable error code for programmatic error handling. */
  code: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorCode>;
  /**
   * Specific field in the request that caused the error, if applicable.
   * Useful for validation errors to indicate which input was problematic.
   */
  field: Maybe<Scalars['String']>;
  /** Human-readable error message describing what went wrong. */
  message: Maybe<Scalars['String']>;
  /** Which downstream system or service caused the error. */
  source: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorSource>;
};

/** ErrorCode categorizes the type of error that occurred. */
export enum Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorCode {
  /** Server encountered an unexpected condition (server error). */
  ErrorCodeInternalServerError = 'ERROR_CODE_INTERNAL_SERVER_ERROR',
  /** Request was malformed or contained invalid data (client error). */
  ErrorCodeInvalidRequest = 'ERROR_CODE_INVALID_REQUEST',
  /** Unknown or unclassified error. */
  ErrorCodeUnknown = 'ERROR_CODE_UNKNOWN'
}

/**
 * ErrorSource identifies which downstream service or system caused the error,
 * helping with troubleshooting and monitoring.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorSource {
  /** Error from Campaigns service - campaign management system. */
  ErrorSourceCampaigns = 'ERROR_SOURCE_CAMPAIGNS',
  /** Error from Commerce - discount and promotion system. */
  ErrorSourceCommerce = 'ERROR_SOURCE_COMMERCE',
  /** Error from CRMS (CRM Messaging Service) - message delivery system. */
  ErrorSourceCrms = 'ERROR_SOURCE_CRMS',
  /** Error from Roulette - feature flag and experimentation system. */
  ErrorSourceRoulette = 'ERROR_SOURCE_ROULETTE',
  /** Error from TaaS (Targeting as a Service) - audience segmentation system. */
  ErrorSourceTaas = 'ERROR_SOURCE_TAAS',
  /** Unknown source or error originated in this service. */
  ErrorSourceUnknown = 'ERROR_SOURCE_UNKNOWN'
}

/**
 * RewardApplication controls whether the reward applies to the same or different
 * departments as the requirement condition.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_RewardApplication {
  RewardApplicationDifferentFromCondition = 'REWARD_APPLICATION_DIFFERENT_FROM_CONDITION',
  RewardApplicationSameAsCondition = 'REWARD_APPLICATION_SAME_AS_CONDITION',
  RewardApplicationUnknown = 'REWARD_APPLICATION_UNKNOWN'
}

/**
 * RewardInput defines what the customer receives. Either a basket-level
 * discount or a fee waiver.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RewardInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RewardInput';
  /** A discount applied to the customer's basket (dollar off, percentage off, or credit back). */
  basket: Maybe<Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput>;
  /** A fee waiver (delivery, pickup, service, or priority fee). */
  fee: Maybe<Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput>;
};

/**
 * RewardInput defines what the customer receives. Either a basket-level
 * discount or a fee waiver.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RewardInput_Input = {
  /** A discount applied to the customer's basket (dollar off, percentage off, or credit back). */
  basket?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput_Input>;
  /** A fee waiver (delivery, pickup, service, or priority fee). */
  fee?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput_Input>;
};

/**
 * RoulettePrecondition defines a prerequisite Roulette feature that must be assigned
 * before this experiment is evaluated. Used to chain experiments or gate on feature flags.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RoulettePrecondition';
  /**
   * Optional list of variant names that must be assigned for the precondition to pass.
   * If empty, the precondition passes if the feature is assigned to any variant.
   */
  allowedVariants: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UUID of the prerequisite Roulette feature. */
  featureUuid: Maybe<Scalars['String']>;
};

/**
 * RoulettePrecondition defines a prerequisite Roulette feature that must be assigned
 * before this experiment is evaluated. Used to chain experiments or gate on feature flags.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition_Input = {
  /**
   * Optional list of variant names that must be assigned for the precondition to pass.
   * If empty, the precondition passes if the feature is assigned to any variant.
   */
  allowedVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UUID of the prerequisite Roulette feature. */
  featureUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Targeting defines the audience criteria for a campaign, specifying which users
 * should be eligible to receive it based on geography and behavioral segments.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Targeting = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Targeting';
  /**
   * Geographic regions where this campaign is active (e.g., specific metro areas, states).
   * Region IDs correspond to Instacart's internal region taxonomy.
   */
  regionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * Audience segment definition from TaaS (Targeting as a Service).
   * Defines behavioral, demographic, or transactional criteria for user selection.
   */
  targetingSegment: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
};

/**
 * Targeting defines the audience criteria for a campaign, specifying which users
 * should be eligible to receive it based on geography and behavioral segments.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Targeting_Input = {
  /**
   * Geographic regions where this campaign is active (e.g., specific metro areas, states).
   * Region IDs correspond to Instacart's internal region taxonomy.
   */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Audience segment definition from TaaS (Targeting as a Service).
   * Defines behavioral, demographic, or transactional criteria for user selection.
   */
  targetingSegment?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentState_Input>;
};

/** TaskRequiredRequirementInput requires the customer to complete a specific task. */
export type Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_TaskRequiredRequirementInput';
  /** Identifier of the task the customer must complete. */
  taskId: Maybe<Scalars['String']>;
};

/** TaskRequiredRequirementInput requires the customer to complete a specific task. */
export type Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput_Input = {
  /** Identifier of the task the customer must complete. */
  taskId?: InputMaybe<Scalars['String']>;
};

/** UtmParamsInput defines UTM tracking parameters for offer attribution. */
export type Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_UtmParamsInput';
  /** UTM campaign values for campaign-level attribution. */
  campaign: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM content values for creative-level attribution. */
  content: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM medium values (e.g., "email", "social"). */
  medium: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM source values (e.g., "newsletter", "facebook"). */
  source: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM term values for keyword-level attribution. */
  term: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** UtmParamsInput defines UTM tracking parameters for offer attribution. */
export type Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput_Input = {
  /** UTM campaign values for campaign-level attribution. */
  campaign?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM content values for creative-level attribution. */
  content?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM medium values (e.g., "email", "social"). */
  medium?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM source values (e.g., "newsletter", "facebook"). */
  source?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM term values for keyword-level attribution. */
  term?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Request to create a new module */
export type Instacart_Infra_Instaform_V1_CreateModuleRequest_Input = {
  billTo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  keyValuePair?: InputMaybe<Array<InputMaybe<Instacart_Infra_Instaform_V1_KeyValuePair_Input>>>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  /** time when the user started creating a module in ISO 8601 format */
  startedAt?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
  totemSystem?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Instacart_Infra_Instaform_V1_ModuleType>;
};

/** Success if module creation is successful */
export type Instacart_Infra_Instaform_V1_CreateModuleResponse = {
  __typename?: 'instacart_infra_instaform_v1_CreateModuleResponse';
  errorMessage: Maybe<Scalars['String']>;
  moduleId: Maybe<Scalars['Int']>;
  success: Maybe<Scalars['Boolean']>;
};

/** Request to fetch module by module id or module_name */
export type Instacart_Infra_Instaform_V1_GetModuleByNameRequest_Input = {
  moduleName?: InputMaybe<Scalars['String']>;
};

/** Returns Success if module creation is successful */
export type Instacart_Infra_Instaform_V1_GetModuleByNameResponse = {
  __typename?: 'instacart_infra_instaform_v1_GetModuleByNameResponse';
  module: Maybe<Instacart_Infra_Instaform_V1_Module>;
};

/** Request to fetch module based on name, environment or team */
export type Instacart_Infra_Instaform_V1_GetModulesRequest_Input = {
  environment?: InputMaybe<Scalars['String']>;
  moduleName?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
};

/** Response list of modules */
export type Instacart_Infra_Instaform_V1_GetModulesResponse = {
  __typename?: 'instacart_infra_instaform_v1_GetModulesResponse';
  modules: Maybe<Array<Maybe<Instacart_Infra_Instaform_V1_Module>>>;
};

/** Key value pair collected from UI */
export type Instacart_Infra_Instaform_V1_KeyValuePair_Input = {
  elementKey?: InputMaybe<Scalars['String']>;
  elementValue?: InputMaybe<Scalars['String']>;
};

/** Module definition to fetch from backend */
export type Instacart_Infra_Instaform_V1_Module = {
  __typename?: 'instacart_infra_instaform_v1_Module';
  billTo: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdBy: Maybe<Instacart_Infra_Instaform_V1_User>;
  description: Maybe<Scalars['String']>;
  environment: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  owner: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Infra_Instaform_V1_Module_ModuleStatus>;
  team: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Infra_Instaform_V1_ModuleType>;
  updatedAt: Maybe<Scalars['DateTime']>;
  updatedBy: Maybe<Instacart_Infra_Instaform_V1_User>;
  version: Maybe<Scalars['String']>;
};

/** List of supported Module types */
export enum Instacart_Infra_Instaform_V1_ModuleType {
  ModuleTypePbi = 'MODULE_TYPE_PBI',
  ModuleTypeRds = 'MODULE_TYPE_RDS',
  ModuleTypeRdsSharded = 'MODULE_TYPE_RDS_SHARDED',
  ModuleTypeS3 = 'MODULE_TYPE_S3',
  ModuleTypeUnknown = 'MODULE_TYPE_UNKNOWN'
}

export enum Instacart_Infra_Instaform_V1_Module_ModuleStatus {
  ModuleStatusActive = 'MODULE_STATUS_ACTIVE',
  ModuleStatusCreating = 'MODULE_STATUS_CREATING',
  ModuleStatusDeleted = 'MODULE_STATUS_DELETED',
  ModuleStatusDeleting = 'MODULE_STATUS_DELETING',
  ModuleStatusInactive = 'MODULE_STATUS_INACTIVE',
  ModuleStatusLocking = 'MODULE_STATUS_LOCKING',
  ModuleStatusUnknown = 'MODULE_STATUS_UNKNOWN',
  ModuleStatusUpdating = 'MODULE_STATUS_UPDATING'
}

/** Info about instaform users */
export type Instacart_Infra_Instaform_V1_User = {
  __typename?: 'instacart_infra_instaform_v1_User';
  email: Maybe<Scalars['String']>;
  fullname: Maybe<Scalars['String']>;
  username: Maybe<Scalars['String']>;
};

/** Contact details for a team/user */
export type Instacart_Infra_Totem_V1_ContactDetails = {
  __typename?: 'instacart_infra_totem_v1_ContactDetails';
  alert_slack_channels: Maybe<Instacart_Infra_Totem_V1_SlackChannelList>;
  email: Maybe<Scalars['String']>;
  general_slack_channels: Maybe<Instacart_Infra_Totem_V1_SlackChannelList>;
  jira_issue_fields: Maybe<Instacart_Infra_Totem_V1_JiraIssueFields>;
  linear_team: Maybe<Instacart_Infra_Totem_V1_LinearTeam>;
  name: Maybe<Scalars['String']>;
  oncall_slack_group: Maybe<Instacart_Infra_Totem_V1_SlackChannel>;
  opsgenie_responder: Maybe<Instacart_Infra_Totem_V1_OpsgenieResponder>;
};

export enum Instacart_Infra_Totem_V1_EmploymentType {
  EmploymentTypeAgencyContractor = 'EMPLOYMENT_TYPE_AGENCY_CONTRACTOR',
  EmploymentTypeDirectEngagedContractor = 'EMPLOYMENT_TYPE_DIRECT_ENGAGED_CONTRACTOR',
  EmploymentTypeFullTimeEmployee = 'EMPLOYMENT_TYPE_FULL_TIME_EMPLOYEE',
  EmploymentTypeIndependentConsultant = 'EMPLOYMENT_TYPE_INDEPENDENT_CONSULTANT',
  EmploymentTypeUnknown = 'EMPLOYMENT_TYPE_UNKNOWN',
  EmploymentTypeVendor = 'EMPLOYMENT_TYPE_VENDOR'
}

/** Entity details */
export type Instacart_Infra_Totem_V1_Entity = {
  __typename?: 'instacart_infra_totem_v1_Entity';
  created_at: Maybe<Scalars['DateTime']>;
  external_id: Maybe<Scalars['String']>;
  metadata: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  system_name: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Infra_Totem_V1_EntityType>;
  typed_metadata: Maybe<Scalars['JSON']>;
  updated_at: Maybe<Scalars['DateTime']>;
};

/** Information describing the type of entity */
export type Instacart_Infra_Totem_V1_EntityType = {
  __typename?: 'instacart_infra_totem_v1_EntityType';
  display_name: Maybe<Scalars['String']>;
  is_totem_managed: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  ownership_policies: Maybe<Array<Maybe<Instacart_Infra_Totem_V1_OwnershipPolicy>>>;
  /** The name of the entity relationship type for the entity that the system is inherited from */
  system_inheritance_relationship_type: Maybe<Scalars['String']>;
};

/** Request the Entity with a given name */
export type Instacart_Infra_Totem_V1_GetEntityRequest_Input = {
  external_id?: InputMaybe<Scalars['String']>;
  type_name?: InputMaybe<Scalars['String']>;
};

/** The returned Entity */
export type Instacart_Infra_Totem_V1_GetEntityResponse = {
  __typename?: 'instacart_infra_totem_v1_GetEntityResponse';
  entity: Maybe<Instacart_Infra_Totem_V1_Entity>;
};

/** Request the System with a given name */
export type Instacart_Infra_Totem_V1_GetSystemRequest_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** The returned System */
export type Instacart_Infra_Totem_V1_GetSystemResponse = {
  __typename?: 'instacart_infra_totem_v1_GetSystemResponse';
  system: Maybe<Instacart_Infra_Totem_V1_System>;
};

/** Information related to a JIRA issue */
export type Instacart_Infra_Totem_V1_JiraIssueFields = {
  __typename?: 'instacart_infra_totem_v1_JiraIssueFields';
  assignee: Maybe<Scalars['String']>;
  components: Maybe<Array<Maybe<Scalars['String']>>>;
  project: Maybe<Instacart_Infra_Totem_V1_JiraProject>;
};

/** JIRA project information */
export type Instacart_Infra_Totem_V1_JiraProject = {
  __typename?: 'instacart_infra_totem_v1_JiraProject';
  id: Maybe<Scalars['String']>;
  key: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  valid_components: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Linear team information */
export type Instacart_Infra_Totem_V1_LinearTeam = {
  __typename?: 'instacart_infra_totem_v1_LinearTeam';
  id: Maybe<Scalars['String']>;
  key: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export enum Instacart_Infra_Totem_V1_ManagementLevel {
  ManagementLevelDirector = 'MANAGEMENT_LEVEL_DIRECTOR',
  ManagementLevelExecutive = 'MANAGEMENT_LEVEL_EXECUTIVE',
  ManagementLevelIndividualContributor = 'MANAGEMENT_LEVEL_INDIVIDUAL_CONTRIBUTOR',
  ManagementLevelManager = 'MANAGEMENT_LEVEL_MANAGER',
  ManagementLevelSeniorDirector = 'MANAGEMENT_LEVEL_SENIOR_DIRECTOR',
  ManagementLevelSeniorManager = 'MANAGEMENT_LEVEL_SENIOR_MANAGER',
  ManagementLevelUnknown = 'MANAGEMENT_LEVEL_UNKNOWN',
  ManagementLevelVicePresident = 'MANAGEMENT_LEVEL_VICE_PRESIDENT'
}

export enum Instacart_Infra_Totem_V1_OpsgeniePriority {
  OpsgeniePriorityP1 = 'OPSGENIE_PRIORITY_P1',
  OpsgeniePriorityP2 = 'OPSGENIE_PRIORITY_P2',
  OpsgeniePriorityP3 = 'OPSGENIE_PRIORITY_P3',
  OpsgeniePriorityP4 = 'OPSGENIE_PRIORITY_P4',
  OpsgeniePriorityP5 = 'OPSGENIE_PRIORITY_P5',
  OpsgeniePriorityUnknown = 'OPSGENIE_PRIORITY_UNKNOWN'
}

/** Information to find the responder in Opsgenie */
export type Instacart_Infra_Totem_V1_OpsgenieResponder = {
  __typename?: 'instacart_infra_totem_v1_OpsgenieResponder';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  priority: Maybe<Instacart_Infra_Totem_V1_OpsgeniePriority>;
  type: Maybe<Instacart_Infra_Totem_V1_OpsgenieResponderType>;
};

export enum Instacart_Infra_Totem_V1_OpsgenieResponderType {
  OpsgenieResponderTypeEscalation = 'OPSGENIE_RESPONDER_TYPE_ESCALATION',
  OpsgenieResponderTypeSchedule = 'OPSGENIE_RESPONDER_TYPE_SCHEDULE',
  OpsgenieResponderTypeTeam = 'OPSGENIE_RESPONDER_TYPE_TEAM',
  OpsgenieResponderTypeUnknown = 'OPSGENIE_RESPONDER_TYPE_UNKNOWN',
  OpsgenieResponderTypeUser = 'OPSGENIE_RESPONDER_TYPE_USER'
}

export enum Instacart_Infra_Totem_V1_OwnerType {
  OwnerTypeTeam = 'OWNER_TYPE_TEAM',
  OwnerTypeUnknown = 'OWNER_TYPE_UNKNOWN',
  OwnerTypeUser = 'OWNER_TYPE_USER'
}

/** An entity's ownership policy */
export type Instacart_Infra_Totem_V1_OwnershipPolicy = {
  __typename?: 'instacart_infra_totem_v1_OwnershipPolicy';
  name: Maybe<Scalars['String']>;
  owner_type: Maybe<Instacart_Infra_Totem_V1_OwnerType>;
  required_contact_fields: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Details to lookup a channel in Slack */
export type Instacart_Infra_Totem_V1_SlackChannel = {
  __typename?: 'instacart_infra_totem_v1_SlackChannel';
  handle: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  type: Maybe<Instacart_Infra_Totem_V1_SlackChannelType>;
};

/** A list of SlackChannels */
export type Instacart_Infra_Totem_V1_SlackChannelList = {
  __typename?: 'instacart_infra_totem_v1_SlackChannelList';
  channels: Maybe<Array<Maybe<Instacart_Infra_Totem_V1_SlackChannel>>>;
};

export enum Instacart_Infra_Totem_V1_SlackChannelType {
  SlackChannelTypePrivate = 'SLACK_CHANNEL_TYPE_PRIVATE',
  SlackChannelTypePublic = 'SLACK_CHANNEL_TYPE_PUBLIC',
  SlackChannelTypeUnknown = 'SLACK_CHANNEL_TYPE_UNKNOWN',
  SlackChannelTypeUser = 'SLACK_CHANNEL_TYPE_USER',
  SlackChannelTypeUserGroup = 'SLACK_CHANNEL_TYPE_USER_GROUP'
}

/** System details */
export type Instacart_Infra_Totem_V1_System = {
  __typename?: 'instacart_infra_totem_v1_System';
  contact_details: Maybe<Instacart_Infra_Totem_V1_ContactDetails>;
  created_at: Maybe<Scalars['DateTime']>;
  display_name: Maybe<Scalars['String']>;
  metadata: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  owner_team: Maybe<Instacart_Infra_Totem_V1_Team>;
  owner_user: Maybe<Instacart_Infra_Totem_V1_User>;
  typed_metadata: Maybe<Scalars['JSON']>;
  updated_at: Maybe<Scalars['DateTime']>;
};

/** Details related to a Team at instacart */
export type Instacart_Infra_Totem_V1_Team = {
  __typename?: 'instacart_infra_totem_v1_Team';
  cost_center: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['DateTime']>;
  default_contact_card_name: Maybe<Scalars['String']>;
  default_system_name: Maybe<Scalars['String']>;
  lead_username: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  parent_team_name: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Infra_Totem_V1_TeamStatus>;
  updated_at: Maybe<Scalars['DateTime']>;
  workday_id: Maybe<Scalars['String']>;
  workday_org_name: Maybe<Scalars['String']>;
};

export enum Instacart_Infra_Totem_V1_TeamStatus {
  TeamStatusActive = 'TEAM_STATUS_ACTIVE',
  TeamStatusInactive = 'TEAM_STATUS_INACTIVE',
  TeamStatusUnknown = 'TEAM_STATUS_UNKNOWN'
}

/** Details of a user */
export type Instacart_Infra_Totem_V1_User = {
  __typename?: 'instacart_infra_totem_v1_User';
  created_at: Maybe<Scalars['DateTime']>;
  default_system_name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  employment_type: Maybe<Instacart_Infra_Totem_V1_EmploymentType>;
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  github_username: Maybe<Scalars['String']>;
  hire_date: Maybe<Scalars['String']>;
  job_title: Maybe<Scalars['String']>;
  last_name: Maybe<Scalars['String']>;
  management_level: Maybe<Instacart_Infra_Totem_V1_ManagementLevel>;
  manager_username: Maybe<Scalars['String']>;
  opsgenie_responder: Maybe<Instacart_Infra_Totem_V1_OpsgenieResponder>;
  slack_channel: Maybe<Instacart_Infra_Totem_V1_SlackChannel>;
  status: Maybe<Instacart_Infra_Totem_V1_UserStatus>;
  team_name: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['DateTime']>;
  username: Maybe<Scalars['String']>;
  work_location: Maybe<Scalars['String']>;
};

export enum Instacart_Infra_Totem_V1_UserStatus {
  UserStatusActive = 'USER_STATUS_ACTIVE',
  UserStatusInactive = 'USER_STATUS_INACTIVE',
  UserStatusUnknown = 'USER_STATUS_UNKNOWN'
}

export type Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestRequest_Input = {
  /** ID of the associated OpsEscalationRequest */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** contains all the required information to update a request note record */
  requestNote?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_AddRequestNoteToOpsEscalationRequestResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  requestNote: Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusRequest_Input = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  updateOpsEscalationRequestStatusRequests?: InputMaybe<Array<InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusRequest_Input>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_BulkUpdateOpsEscalationRequestStatusResponse';
  /** Any error messages that occurred during the update */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether all operations succeeded or not */
  success: Maybe<Scalars['Boolean']>;
};

/** attributes needed to create an OpsEscalationRequest record and its associated RequestNotes */
export type Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestInput_Input = {
  opsEscalationRequestInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestInput_Input>;
  requestNoteInputs?: InputMaybe<Array<InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsRequest_Input = {
  /** Array of objects with data for creating/updating an OpsEscalationRequest record and its associated request notes */
  opsEscalationRequests?: InputMaybe<Array<InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestInput_Input>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_CreateOpsEscalationRequestsResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteRequest_Input = {
  /** Content of the request note */
  requestNoteInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInputData_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_CreateRequestNoteResponse';
  /** Any erors from the operation */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new request note */
  requestNote: Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>;
  /** Whether the create succeeded or not */
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesRequest_Input = {
  /** IDs of the request notes to be deleted */
  requestNoteIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_DeleteOpsEscalationRequestRequestNotesResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsRequest_Input = {
  /** List of OpsEscalationRequest IDs to be deleted */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the DeleteOpsEscalationRequests request */
export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_DeleteOpsEscalationRequestsResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Did the operation succeed? */
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteRequest_Input = {
  /** IPP canonical ID of the person who created the request note. Must match to be ablet to delete the note. */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** ID of the note to delete */
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_DeleteRequestNoteResponse';
  /** Any erors from the operation */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether the delete succeeded or not */
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestRequest_Input = {
  /** ID of the OpsEscalationRequest to fetch. */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_GetOpsEscalationRequestResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The OpsEscalationRequest data, returned if found. */
  opsEscalationRequest: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>;
};

/**
 * Request for listing duplicate OpsEscalationRequests based on matching by
 * multiple existing escalation request IDs
 */
export type Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsRequest_Input = {
  /** ID of the OpsEscalationRequest for which we are looking for duplicates */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the BulkListDuplicateOpsEscalationRequests request */
export type Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_ListBulkDuplicateOpsEscalationRequestsResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of duplicate requests found per OpsEscalationRequest ID */
  opsEscalationRequestDuplicates: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestDuplicates>>>;
};

/**
 * Request for listing duplicate OpsEscalationRequests based on matching by
 * existing escalation request ID OR warehouse location IDs.
 */
export type Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsRequest_Input = {
  /** ID of the OpsEscalationRequest for which we are looking for duplicates */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** ID of warehouse location IDs to find duplicate requests for */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the ListDuplicateOpsEscalationRequests request. */
export type Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_ListDuplicateOpsEscalationRequestsResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  opsEscalationRequests: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>>>;
};

/** Request for listing OpsEscalationRequests with filters and pagination. */
export type Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsRequest_Input = {
  /** Select ops_escalation_requests assigned to users with provided IPP canonical ids */
  assignedToIppAccountCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Select ops_escalation_requests created by users with provided IPP canonical ids */
  createdByIppAccountCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Time in UTC for filtering requests that are created between the from and to datetimes */
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  /** Find ops_escalation_requests that end after this date. */
  endsAfter?: InputMaybe<Scalars['DateTime']>;
  /** Select ops_escalation_requests with provided ops escalation request ids */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Information on how to paginate the results of a list/filter operation. This feeds into the will_paginate gem */
  paginationInstruction?: InputMaybe<Instacart_Logistics_V1_PaginationInstruction_Input>;
  /**
   * Select ops_escalation_requests with provided priorities
   * Deprecated: Use request_priorities instead.
   */
  priorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Select ops_escalation_requests with provided priorities */
  requestPriorities?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Select ops_escalation_requests with provided request_reasons */
  requestReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Information on how to sort the results (list of attribute and direction) */
  sortingInstruction?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_SortingInstruction_Input>>>;
  /** Find ops_escalation_requests that start before this date. */
  startsBefore?: InputMaybe<Scalars['DateTime']>;
  /** Select ops_escalation_requests with provided statuses */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Select ops_escalation_requests with provided warehouse_ids */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Select ops_escalation_requests with provided warehouse_location_ids */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Select ops_escalation_requests with provided zone_ids */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the ListOpsEscalationRequests request. */
export type Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_ListOpsEscalationRequestsResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  opsEscalationRequests: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>>>;
  /** How many total events match the criteria */
  opsEscalationRequestsCount: Maybe<Scalars['Int']>;
  /** How the results are paginated */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Valid noteable types */
export enum Instacart_Logistics_Marketplace_Ops_V1_NoteableType {
  NoteableTypeUnspecified = 'NOTEABLE_TYPE_UNSPECIFIED',
  OpsEscalationRequest = 'OPS_ESCALATION_REQUEST'
}

/**
 * OpsEscalationRequestData captures the details necessary for handling an operational escalation request,
 * such as a store closure or a system outage. It includes identification, timing, and categorization of the request.
 */
export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_OpsEscalationRequestData';
  /** IPP canonical ID of the person assigned to handle the request. */
  assignedToIppAccountCanonicalId: Maybe<Scalars['String']>;
  /** Standard Rails timestamps */
  createdAt: Maybe<Scalars['DateTime']>;
  /** IPP canonical ID of the person who created the request. */
  createdByIppAccountCanonicalId: Maybe<Scalars['String']>;
  endsAt: Maybe<Scalars['DateTime']>;
  /** DB row id */
  id: Maybe<Scalars['BigInt']>;
  /** List of location IDs that are part of this request. */
  locationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Type of location associated with the escalation request. */
  locationType: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsLocationType>;
  /** Metadata related to the request in JSON format. */
  metadata: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata>;
  /** Optional URL to the issue/ticket associated with the request. */
  optionalIssueUrl: Maybe<Scalars['String']>;
  /** If this request has been “intervened”, it will have a parent fulfillment event id */
  parentFulfillmentEventId: Maybe<Scalars['BigInt']>;
  /**
   * Priority level of the escalation request.
   * Deprecated: Use request_priority instead.
   */
  priority: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestPriority>;
  /** Additional configurations related to the request in JSON format. */
  requestConfigurations: Maybe<Scalars['JSON']>;
  /** Array of request notes associated with the OpsEscalationRequest. */
  requestNotes: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>>>;
  /** Priority level of the escalation request. */
  requestPriority: Maybe<Scalars['BigInt']>;
  /** Specific reason for the escalation request. */
  requestReason: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestReason>;
  /** Type of escalation request. */
  requestType: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestType>;
  /** Time in UTC for start_at and end_at of the ops escalation request. */
  startsAt: Maybe<Scalars['DateTime']>;
  /** Current status of the escalation request. */
  status: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestStatus>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Used for handling duplicate requests per OpsEscalationRequest ID */
export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestDuplicates = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_OpsEscalationRequestDuplicates';
  /** List of duplicate OpsEscalationRequests found for the given ID */
  duplicateRequests: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>>>;
  /** ID of the OpsEscalationRequest for which we are looking for duplicates */
  opsEscalationRequestId: Maybe<Scalars['BigInt']>;
};

/** OpsEscalationRequestInput represents the input data for creating or updating an OpsEscalationRequest. */
export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestInput_Input = {
  /** IPP canonical ID of the person assigned to handle the request. */
  assignedToIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IPP canonical ID of the person who created the request. */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** List of location IDs that are part of this request. */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Type of location associated with the escalation request. */
  locationType?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsLocationType>;
  /** Metadata related to the request. Currently includes only warehouse_id */
  metadata?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata_Input>;
  /** Optional URL to the issue/ticket associated with the request. */
  optionalIssueUrl?: InputMaybe<Scalars['String']>;
  /**
   * Priority level of the escalation request.
   * Deprecated: Use request_priority instead.
   */
  priority?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestPriority>;
  /** Additional configurations related to the request in JSON format. */
  requestConfigurations?: InputMaybe<Scalars['JSON']>;
  /** Priority level of the escalation request. */
  requestPriority?: InputMaybe<Scalars['BigInt']>;
  /** Specific reason for the escalation request. */
  requestReason?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestReason>;
  /** Type of escalation request. */
  requestType?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestType>;
  /** Time in UTC for start_at and end_at of the ops escalation request. */
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_OpsEscalationRequestMetadata';
  additionalRequestContext: Maybe<Scalars['String']>;
  warehouseId: Maybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata_Input = {
  additionalRequestContext?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Definitions of enums for location types, statuses, request types, reasons, and priorities. */
export enum Instacart_Logistics_Marketplace_Ops_V1_OpsLocationType {
  LocationTypeUnspecified = 'LOCATION_TYPE_UNSPECIFIED',
  WarehouseLocation = 'WAREHOUSE_LOCATION'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestPriority {
  CrtRequest = 'CRT_REQUEST',
  PriorityUnspecified = 'PRIORITY_UNSPECIFIED',
  TempStoreClosure = 'TEMP_STORE_CLOSURE'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestReason {
  AdminConfigurationIssue = 'ADMIN_CONFIGURATION_ISSUE',
  BdWhlRequest = 'BD_WHL_REQUEST',
  CityEvent = 'CITY_EVENT',
  CrtIncident = 'CRT_INCIDENT',
  EmergencyClosure = 'EMERGENCY_CLOSURE',
  HolidayHours = 'HOLIDAY_HOURS',
  IncorrectGeolocationAddress = 'INCORRECT_GEOLOCATION_ADDRESS',
  IncorrectStoreHours = 'INCORRECT_STORE_HOURS',
  MaintenanceClosure = 'MAINTENANCE_CLOSURE',
  PermanentClosure = 'PERMANENT_CLOSURE',
  PickupDeviceIssues = 'PICKUP_DEVICE_ISSUES',
  PosOutageHours = 'POS_OUTAGE_HOURS',
  PowerOutage = 'POWER_OUTAGE',
  ReopenStore = 'REOPEN_STORE',
  RequestReasonUnspecified = 'REQUEST_REASON_UNSPECIFIED',
  TemporaryStoreClosure = 'TEMPORARY_STORE_CLOSURE',
  WhlIssuesExtremeWeather = 'WHL_ISSUES_EXTREME_WEATHER'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestStatus {
  Duplicate = 'DUPLICATE',
  Expired = 'EXPIRED',
  InterventionCompleted = 'INTERVENTION_COMPLETED',
  InterventionCreated = 'INTERVENTION_CREATED',
  InterventionInProgress = 'INTERVENTION_IN_PROGRESS',
  NewRequest = 'NEW_REQUEST',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  WontDo = 'WONT_DO'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestType {
  IncorrectGeolocationAddressRequest = 'INCORRECT_GEOLOCATION_ADDRESS_REQUEST',
  IncorrectStoreHoursRequest = 'INCORRECT_STORE_HOURS_REQUEST',
  PermanentClosureRequest = 'PERMANENT_CLOSURE_REQUEST',
  ReopenStoreRequest = 'REOPEN_STORE_REQUEST',
  RequestTypeUnspecified = 'REQUEST_TYPE_UNSPECIFIED',
  StoreClosure = 'STORE_CLOSURE'
}

/** A request note object */
export type Instacart_Logistics_Marketplace_Ops_V1_RequestNote = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_RequestNote';
  /** Content of the request note */
  content: Maybe<Scalars['String']>;
  /** Standard Rails timestamps */
  createdAt: Maybe<Scalars['DateTime']>;
  /** IPP canonical ID of the person who created the request note */
  createdByIppAccountCanonicalId: Maybe<Scalars['String']>;
  /** DB row id */
  id: Maybe<Scalars['BigInt']>;
  /** IDs of IPP accounts tagged in the request note. */
  ippAccountCanonicalTaggedIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The ID of the ops escalation request note is assigned to */
  opsEscalationRequestId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** input data to create a new RequestNote record */
export type Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInputData_Input = {
  /** Content of the request note */
  content?: InputMaybe<Scalars['String']>;
  /** IPP canonical ID of the person who created the request */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IPP canonical IDs of users tagged in the request note */
  ippAccountCanonicalTaggedIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the record associated with the note */
  noteableId?: InputMaybe<Scalars['BigInt']>;
  /** IPP canonical IDs of users tagged in the request note */
  noteableType?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_NoteableType>;
};

/** input data to create a RequestNote record when creating an OpsEscalationRequest */
export type Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input = {
  /** Content of the request note */
  content?: InputMaybe<Scalars['String']>;
  /** IPP canonical ID of the person who created the request */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IPP canonical IDs of users tagged in the request note */
  ippAccountCanonicalTaggedIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteRequest_Input = {
  /** contains all the required information to update a request note record */
  requestNote?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>;
  /** ID of the request note to be updated */
  requestNoteId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateOpsEscalationRequestRequestNoteResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusRequest_Input = {
  /** Optional - The user who is performing the request */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** The new status to set */
  newStatus?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestStatus>;
  /** The ID of the OpsEscalationRequest to update */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Optional note to add to the updated OpsEscalationRequest */
  requestNote?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateOpsEscalationRequestStatusResponse';
  /** Any error messages that occurred during the update */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsRequest_Input = {
  /** Optional - the user who is performing the request */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IDs of OpsEscalationRequests to be updated */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** basic data for creating/updating an OpsEscalationRequest record */
  opsEscalationRequestInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestInput_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateOpsEscalationRequestsResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteRequest_Input = {
  /** ID of the note to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Content of the request note. Created by must match the existing user */
  requestNoteInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInputData_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateRequestNoteResponse';
  /** Any erors from the operation */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The update request note */
  requestNote: Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>;
  /** Whether the update succeeded or not */
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_V1_AddLocationsToParentEventRequest_Input = {
  /** Email of the creator */
  creator?: InputMaybe<Scalars['String']>;
  /** Array of IDs to be added (they will be of the same type as the parent event) */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** The ID of the parent event that locations will be added to */
  parentFulfillmentEventId?: InputMaybe<Scalars['BigInt']>;
  /** For restricted availability events, we might have new warehouses that are impacted */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_AddLocationsToParentEventResponse = {
  __typename?: 'instacart_logistics_v1_AddLocationsToParentEventResponse';
  /** Error message that occured during operation */
  error: Maybe<Scalars['String']>;
  /** Did the operation succeed? */
  success: Maybe<Scalars['Boolean']>;
};

/** Data shared by all types of fulfillment events */
export type Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input = {
  /** The email of the creator of the event, this will also be the first owner */
  creator?: InputMaybe<Scalars['String']>;
  /** The end time of the event (deprecated, use ends_at_string instead) */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  endsAtString?: InputMaybe<Scalars['String']>;
  /** The type of the event */
  eventType?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventType>;
  /** A link, typically a Jira link, to the reason for the event */
  infoUrl?: InputMaybe<Scalars['String']>;
  /** Location ids, a child event will be created for each location id */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Location type, which will apply to all location ids */
  locationType?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  /** Name/description of the event */
  name?: InputMaybe<Scalars['String']>;
  /** The severity level of the event */
  severityLevel?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>;
  /** The start time of the event (deprecated, use starts_at_string instead) */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** to avoid timezone issues we are going to set starts_at and ends_at as strings */
  startsAtString?: InputMaybe<Scalars['String']>;
  /** Any tags associated with the event, optional */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Request to cancel a list of fulfillment events */
export type Instacart_Logistics_V1_CancelFulfillmentEventsRequest_Input = {
  /** Email of the creator (user cancelling the events) */
  creator?: InputMaybe<Scalars['String']>;
  /** List of fulfillment event ids to cancel */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be cancelled asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to cancel a list of fulfillment events */
export type Instacart_Logistics_V1_CancelFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_CancelFulfillmentEventsResponse';
  /** List of canceled fulfillment event ids */
  canceledFulfillmentEventIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Values specific to a fulfillment capacity-impacting event */
export type Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input = {
  /** Expected rate of increasing of delivery time */
  deliveryMultiple?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  /** The percentage by which to adjust capacity for the location, a negative number */
  suggestedCapacityLevel?: InputMaybe<Scalars['Int']>;
};

/**
 * Values specific to a store closure event
 * More documentation here https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Closure-event%3A-Level-4
 */
export type Instacart_Logistics_V1_ClosureFulfillmentEventData = {
  __typename?: 'instacart_logistics_v1_ClosureFulfillmentEventData';
  addDeliveryBlock: Maybe<Scalars['Boolean']>;
  /** Allow staged delivery orders to be batched instead of reassigning to alternative open stores */
  batchStagedBatches: Maybe<Scalars['Boolean']>;
  /** Cancel shifts */
  cancelAllPartnerShifts: Maybe<Scalars['Boolean']>;
  /** Disable delivery options */
  disableDeliveryOptions: Maybe<Scalars['Boolean']>;
  disableIssOptions: Maybe<Scalars['Boolean']>;
  disablePickupOptions: Maybe<Scalars['Boolean']>;
  /** Keep shifts */
  keepAllIssShifts: Maybe<Scalars['Boolean']>;
  keepIssShiftsForPickup: Maybe<Scalars['Boolean']>;
  keepWarehouseLocationEnabled: Maybe<Scalars['Boolean']>;
  setWarehouseLocationsToPickupOnly: Maybe<Scalars['Boolean']>;
  /**
   * Reschedule orders
   * Skip rescheduling impacted orders except staged orders
   */
  skipDeliveriesRescheduling: Maybe<Scalars['Boolean']>;
  /** Zero out staffing levels */
  zeroOutStaffing: Maybe<Scalars['Boolean']>;
};

/**
 * Values specific to a store closure event
 * More documentation here https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Closure-event%3A-Level-4
 */
export type Instacart_Logistics_V1_ClosureFulfillmentEventData_Input = {
  addDeliveryBlock?: InputMaybe<Scalars['Boolean']>;
  /** Allow staged delivery orders to be batched instead of reassigning to alternative open stores */
  batchStagedBatches?: InputMaybe<Scalars['Boolean']>;
  /** Cancel shifts */
  cancelAllPartnerShifts?: InputMaybe<Scalars['Boolean']>;
  /** Disable delivery options */
  disableDeliveryOptions?: InputMaybe<Scalars['Boolean']>;
  disableIssOptions?: InputMaybe<Scalars['Boolean']>;
  disablePickupOptions?: InputMaybe<Scalars['Boolean']>;
  /** Keep shifts */
  keepAllIssShifts?: InputMaybe<Scalars['Boolean']>;
  keepIssShiftsForPickup?: InputMaybe<Scalars['Boolean']>;
  keepWarehouseLocationEnabled?: InputMaybe<Scalars['Boolean']>;
  setWarehouseLocationsToPickupOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * Reschedule orders
   * Skip rescheduling impacted orders except staged orders
   */
  skipDeliveriesRescheduling?: InputMaybe<Scalars['Boolean']>;
  /** Zero out staffing levels */
  zeroOutStaffing?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_V1_CreateClosureEventApprovalRequestRequest_Input = {
  /** The closure event request to create an approval request for */
  eventRequest?: InputMaybe<Instacart_Logistics_V1_CreateClosureEventRequest_Input>;
};

export type Instacart_Logistics_V1_CreateClosureEventApprovalRequestResponse = {
  __typename?: 'instacart_logistics_v1_CreateClosureEventApprovalRequestResponse';
  /** The ID of the created approval request */
  createdApprovalRequestId: Maybe<Scalars['String']>;
  /** Error message that occurred during operation */
  error: Maybe<Scalars['String']>;
};

/** Request to create a new closure event */
export type Instacart_Logistics_V1_CreateClosureEventRequest_Input = {
  /** The event data that is specific to closure events */
  closureData?: InputMaybe<Instacart_Logistics_V1_ClosureFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** Whether event should be created asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to create a new closure event */
export type Instacart_Logistics_V1_CreateClosureEventResponse = {
  __typename?: 'instacart_logistics_v1_CreateClosureEventResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new parent event, includes paginated child events */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /**
   * Impact data for the created child events
   * Key is one of: shifts staffing delivery_blocks delivery_options pickup_options order_deliveries
   */
  impactData: Maybe<Scalars['JSON']>;
  /** The pagination information for the child events */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Parameters needed for creating new fulfillment capacity impacting events */
export type Instacart_Logistics_V1_CreateFulfillmentEventRequest_Input = {
  /** The event data that is specific to capacity-impacting events */
  capacityImpactData?: InputMaybe<Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** Whether event should be created asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Returns the created event and any errors */
export type Instacart_Logistics_V1_CreateFulfillmentEventResponse = {
  __typename?: 'instacart_logistics_v1_CreateFulfillmentEventResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new parent event, includes paginated child events */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestRequest_Input = {
  /** The restricted availability event request to create an approval request for */
  eventRequest?: InputMaybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventRequest_Input>;
};

export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestResponse = {
  __typename?: 'instacart_logistics_v1_CreateRestrictedAvailabilityEventApprovalRequestResponse';
  /** The ID of the created approval request (deprecated, use created_approval_request_id instead) */
  approvalRequestId: Maybe<Scalars['BigInt']>;
  /** The ID of the created approval request */
  createdApprovalRequestId: Maybe<Scalars['String']>;
  /** Error message that occurred during operation */
  error: Maybe<Scalars['String']>;
};

/** Request to create a new restricted availability event */
export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** The IPP account canonical ID of the user performing the request */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** The ID of the associated OpsEscalationRequest (optional) */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Whether event should be created asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
  /** The event data that is specific to restricted availability events */
  restrictedAvailabilityData?: InputMaybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input>;
  /** The warehouse_ids that will be impacted (optional) */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response to create a new restricted availability event */
export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventResponse = {
  __typename?: 'instacart_logistics_v1_CreateRestrictedAvailabilityEventResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new parent event, includes paginated child events */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** A fulfillment event is a temporary event that affects the capacity of a location. */
export type Instacart_Logistics_V1_FulfillmentEventData = {
  __typename?: 'instacart_logistics_v1_FulfillmentEventData';
  /**
   * The percentage by which to adjust staffing for the location.
   * When there are overlapping events affecting the same location, the lowest value is used.
   */
  adjustStaffingPercentage: Maybe<Scalars['Int']>;
  /** The number of children for this event */
  childCount: Maybe<Scalars['Int']>;
  /** Child events, if this is a parent event */
  childEvents: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
  /** A list of the location ids associated with the event's child events, if this is a parent event */
  childLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Additional data for closure events */
  closureData: Maybe<Instacart_Logistics_V1_ClosureFulfillmentEventData>;
  closureEventDataMetadata: Maybe<Instacart_Logistics_V1_ClosureFulfillmentEventData>;
  /** Standard Rails timestamps */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Original creator of the event - email address if it was a person, system name if it's a system, e.g. "apollo" */
  creator: Maybe<Scalars['String']>;
  /** Message shown to customers about the event */
  customerMessage: Maybe<Scalars['String']>;
  /** Deleted time, if the event was cancelled before it started */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Expected rate of increasing of delivery time */
  deliveryMultiple: Maybe<Instacart_Types_V1_BigDecimal>;
  endsAt: Maybe<Scalars['DateTime']>;
  /** General type of event (see enum above) */
  eventType: Maybe<Instacart_Logistics_V1_FulfillmentEventType>;
  /** Whether we should forgive shoppers for cancelling shifts */
  forgiveReliabilityIncident: Maybe<Scalars['Boolean']>;
  /** DB row id */
  id: Maybe<Scalars['BigInt']>;
  /** Link to a Jira ticket or other documentation for the event */
  infoUrl: Maybe<Scalars['String']>;
  /** Location data, if this is a child event */
  location: Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>;
  /**
   * When a list of parent events is retrieved, we only need to know the location type and count of children
   * When a single parent event is retrieved, we need to know the full details of the children
   */
  locationType: Maybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  /** Name of the event */
  name: Maybe<Scalars['String']>;
  /** Most recent updater of the event - email address if it was a person, system name if it's a system, e.g. "apollo" */
  owner: Maybe<Scalars['String']>;
  /**
   * Parent event id, if this is a child event
   * Note: some historical events are child events but do not have a parent event id
   */
  parentFulfillmentEventId: Maybe<Scalars['BigInt']>;
  /** Additional data for restricted availability events */
  restrictedAvailabilityData: Maybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData>;
  restrictedAvailabilityEventDataMetadata: Maybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData>;
  /** A comma-separated list of shift types for looking up staffing_levels */
  roleTypes: Maybe<Scalars['String']>;
  /** Severity (see enum above) */
  severityLevel: Maybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>;
  /** Start and end time */
  startsAt: Maybe<Scalars['DateTime']>;
  /**
   * Event status as computed from the start and end times of the event relative to the current time.
   * Status is DELETED if the event has been soft-deleted.
   */
  status: Maybe<Instacart_Logistics_V1_FulfillmentEventStatus>;
  /**
   * The percentage by which to adjust capacity for the location.
   * When there are overlapping events affecting the same location, the highest value is used.
   */
  suggestedCapacityLevel: Maybe<Scalars['Int']>;
  /** Tags associated by the events */
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Timezone as it turns out google.protobuf.Timestamp is only in UTC, so we need this to do conversions */
  timeZone: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Whether or not this event was automatically created by weather data */
  weatherEvent: Maybe<Scalars['Boolean']>;
  /** Zone for the event */
  zoneId: Maybe<Scalars['BigInt']>;
};

/** Rich(er) data about the location associated with the fulfillment event */
export type Instacart_Logistics_V1_FulfillmentEventLocationData = {
  __typename?: 'instacart_logistics_v1_FulfillmentEventLocationData';
  /** DB row id */
  id: Maybe<Scalars['BigInt']>;
  locationType: Maybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  /** Name from association table */
  name: Maybe<Scalars['String']>;
};

/** Possible types of locations associated with a fulfillment event */
export enum Instacart_Logistics_V1_FulfillmentEventLocationType {
  Country = 'COUNTRY',
  LocationTypeUnspecified = 'LOCATION_TYPE_UNSPECIFIED',
  PostalCode = 'POSTAL_CODE',
  Region = 'REGION',
  WarehouseLocation = 'WAREHOUSE_LOCATION',
  WarehouseZone = 'WAREHOUSE_ZONE',
  Zone = 'ZONE'
}

/**
 * Event severities, see more at
 * https://docs.google.com/document/d/1lSGwGQU-0_ED55yH9P-TDFaCxVdXqaLV/edit#heading=h.994m78oh6kur
 *
 * Fulfillment capacity-impacting events (severities 1-3, formerly "Weather events")
 * These types of events cause a reduction in the number of orders we can fulfill. The capacity level (reduction)
 * for these events can be set to anything from -5 to -100. We can also customize the delivery multiple
 * (the factor indicating expected delivery time increase) and customer facing messages for these events.
 *
 * Closure event/extreme weather event (severity 4)
 * This severity causes closure of specific stores (WarehouseLocation).
 *
 * Restricted availability (severity 5, previous known as "safe mode")
 * This severity causes the system to restrict available service options, e.g. disallow all delivery orders.
 *
 * Note that while levels 1-3 and 6 are related, the severity levels are not necessarily contiguous or strictly
 * ordered.
 */
export enum Instacart_Logistics_V1_FulfillmentEventSeverityLevel {
  EventSeverityUnspecified = 'EVENT_SEVERITY_UNSPECIFIED',
  HighCapacityImpact = 'HIGH_CAPACITY_IMPACT',
  LowCapacityImpact = 'LOW_CAPACITY_IMPACT',
  MediumCapacityImpact = 'MEDIUM_CAPACITY_IMPACT',
  RestrictedServiceOptions = 'RESTRICTED_SERVICE_OPTIONS',
  StoreClosure = 'STORE_CLOSURE',
  /**
   * this is a new severity level that is used to indicate that the event has no capacity impact;
   * since 0 is reserved for "unspecified", and other values were already defined, we use 6 here.
   */
  ZeroCapacityImpact = 'ZERO_CAPACITY_IMPACT'
}

/**
 * Event status, computed from the start and end times of the event relative to the current time. Status is
 * DELETED if the event has been soft-deleted.
 */
export enum Instacart_Logistics_V1_FulfillmentEventStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  EventStatusUnspecified = 'EVENT_STATUS_UNSPECIFIED',
  InProgress = 'IN_PROGRESS',
  Upcoming = 'UPCOMING'
}

/**
 * Event types, see more at
 * https://docs.google.com/document/d/1lSGwGQU-0_ED55yH9P-TDFaCxVdXqaLV/edit#heading=h.rs2ipnbn0urn
 * Note: We are expecting a new and more comprehensive list of types in the future.
 */
export enum Instacart_Logistics_V1_FulfillmentEventType {
  AirQuality = 'AIR_QUALITY',
  CityEvent = 'CITY_EVENT',
  Cold = 'COLD',
  Cultural = 'CULTURAL',
  EventTypeUnspecified = 'EVENT_TYPE_UNSPECIFIED',
  Experiment = 'EXPERIMENT',
  Flood = 'FLOOD',
  Heatwave = 'HEATWAVE',
  Holiday = 'HOLIDAY',
  Hurricane = 'HURRICANE',
  Other = 'OTHER',
  Outage = 'OUTAGE',
  Rain = 'RAIN',
  Snow = 'SNOW',
  Tornado = 'TORNADO',
  TropicalStorm = 'TROPICAL_STORM',
  Wildfire = 'WILDFIRE',
  Wind = 'WIND',
  WinterStorm = 'WINTER_STORM'
}

export type Instacart_Logistics_V1_GetFulfillmentEventRequest_Input = {
  fulfillmentEventId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_V1_GetFulfillmentEventResponse = {
  __typename?: 'instacart_logistics_v1_GetFulfillmentEventResponse';
  createdAt: Maybe<Scalars['DateTime']>;
  customerMessage: Maybe<Scalars['String']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Expected rate of increasing of delivery time */
  deliveryMultiple: Maybe<Scalars['Float']>;
  endsAt: Maybe<Scalars['DateTime']>;
  eventType: Maybe<Instacart_Logistics_V1_GetFulfillmentEventResponse_EventType>;
  /** Whether we should forgive shoppers for cancelling shifts */
  forgiveReliabilityIncident: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['BigInt']>;
  locationId: Maybe<Scalars['BigInt']>;
  locationType: Maybe<Instacart_Logistics_V1_GetFulfillmentEventResponse_LocationType>;
  locked: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  /** Author of the event */
  owner: Maybe<Scalars['String']>;
  roleTypes: Maybe<Scalars['String']>;
  /** Level of the fulfillment event */
  severityLevel: Maybe<Scalars['Int']>;
  shopperMessage: Maybe<Scalars['String']>;
  startsAt: Maybe<Scalars['DateTime']>;
  /** Adjustment of the capacity level */
  suggestedCapacityLevel: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  weatherEvent: Maybe<Scalars['Boolean']>;
  zoneId: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Logistics_V1_GetFulfillmentEventResponse_EventType {
  Cultural = 'CULTURAL',
  Experiment = 'EXPERIMENT',
  Other = 'OTHER',
  Rain = 'RAIN',
  Snow = 'SNOW'
}

export enum Instacart_Logistics_V1_GetFulfillmentEventResponse_LocationType {
  Country = 'COUNTRY',
  PostalCode = 'POSTAL_CODE',
  Region = 'REGION',
  WarehouseLocation = 'WAREHOUSE_LOCATION',
  WarehouseZone = 'WAREHOUSE_ZONE',
  Zone = 'ZONE'
}

export type Instacart_Logistics_V1_GetFulfillmentEventsByIdRequest_Input = {
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_GetFulfillmentEventsByIdResponse = {
  __typename?: 'instacart_logistics_v1_GetFulfillmentEventsByIdResponse';
  fulfillmentEvents: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
};

export type Instacart_Logistics_V1_ListChildFulfillmentEventsRequest_Input = {
  /** Find events created by these users */
  creators?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events which end after this date. */
  endsAfter?: InputMaybe<Scalars['DateTime']>;
  /** Select events with these statuses */
  eventStatuses?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventStatus>>>;
  /** Select events with these event types */
  eventTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventType>>>;
  /** Find an event with one of these owners (most recent updater) */
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Information on how to paginate the results of a list/filter operation. This feeds into the will_paginate gem. */
  paginationInstruction?: InputMaybe<Instacart_Logistics_V1_PaginationInstruction_Input>;
  /**
   * The parent event id from which a set of location-specific events were generated; this will return
   * a list of only the child events for that parent.
   */
  parentEventId?: InputMaybe<Scalars['BigInt']>;
  /** Find events with these postal codes */
  postalCodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events with these regions */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** A search string that matches the event name or link content (e.g. Jira ticket id). */
  searchString?: InputMaybe<Scalars['String']>;
  /** Select events with these severity levels */
  severityLevels?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>>>;
  /**
   * Information on how to sort the results (list of attribute and direction); currently the front-end only
   * supports a single sort attribute but this is a list in case users ask for more nuance in future.
   */
  sortingInstruction?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_SortingInstruction_Input>>>;
  /** Find events which start before this date. */
  startsBefore?: InputMaybe<Scalars['DateTime']>;
  /** Select events with these tags */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events with these warehouse locations */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events with these zones */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_ListChildFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_ListChildFulfillmentEventsResponse';
  /** How many total events match the criteria */
  eventCount: Maybe<Scalars['Int']>;
  /** Paginated and sorted array of child fulfillment events for a specified parent event that match the given criteria. */
  fulfillmentEvents: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
  /** How the results are paginated */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Return all creators, sorted alphabetically */
export type Instacart_Logistics_V1_ListCreatorsResponse = {
  __typename?: 'instacart_logistics_v1_ListCreatorsResponse';
  /** List of creators */
  creators: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Request fulfillment events according to specified criteria. All parameters are optional. */
export type Instacart_Logistics_V1_ListFulfillmentEventsRequest_Input = {
  /** Find events with these countries */
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events created by these users */
  creators?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events which end after this date. */
  endsAfter?: InputMaybe<Scalars['DateTime']>;
  /** Select events with these statuses */
  eventStatuses?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventStatus>>>;
  /** Select events with these event types */
  eventTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventType>>>;
  /** Select only events where the location_type matches this value (typically WarehouseLocation is selected here) */
  locationTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventLocationType>>>;
  /** Find an event with one of these owners (most recent updater) */
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Information on how to paginate the results of a list/filter operation. This feeds into the will_paginate gem. */
  paginationInstruction?: InputMaybe<Instacart_Logistics_V1_PaginationInstruction_Input>;
  /**
   * The parent event id from which a set of location-specific events were generated; this will return
   * a list of only the child events for that parent.
   */
  parentEventId?: InputMaybe<Scalars['BigInt']>;
  /** Find events with these postal codes */
  postalCodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events in selected region (not used, see region_ids) */
  regionId?: InputMaybe<Scalars['BigInt']>;
  /** Find events with these regions */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** A search string that matches the event name or link content (e.g. Jira ticket id). */
  searchString?: InputMaybe<Scalars['String']>;
  /** Select events with these severity levels */
  severityLevels?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>>>;
  /**
   * Information on how to sort the results (list of attribute and direction); currently the front-end only
   * supports a single sort attribute but this is a list in case users ask for more nuance in future.
   */
  sortingInstruction?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_SortingInstruction_Input>>>;
  /** Find events which start before this date. */
  startsBefore?: InputMaybe<Scalars['DateTime']>;
  /** Select events with these tags */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events with these warehouse locations */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events with these zones */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_ListFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_ListFulfillmentEventsResponse';
  /** How many total events match the criteria */
  eventCount: Maybe<Scalars['Int']>;
  /**
   * Paginated and sorted array of fulfillment events that match the given criteria.
   *
   * If a parent event id was not specified in the search criteria, this ia a list of parent events
   * where each parent event contains a list of location-specific child events.
   *
   * If the search criteria includes a parent_event_id, then this will return just that parent, with
   * child events nested as usual.
   */
  fulfillmentEvents: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
  /** How the results are paginated */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Return all tags, sorted alphabetically */
export type Instacart_Logistics_V1_ListTagsResponse = {
  __typename?: 'instacart_logistics_v1_ListTagsResponse';
  /** List of creators */
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Commonly used data structures for pagination */
export type Instacart_Logistics_V1_PaginationInstruction = {
  __typename?: 'instacart_logistics_v1_PaginationInstruction';
  /** The page of results to show, will default if nil */
  page: Maybe<Scalars['Int']>;
  /** The number of results to show per page, will default if nil */
  perPage: Maybe<Scalars['Int']>;
};

/** Commonly used data structures for pagination */
export type Instacart_Logistics_V1_PaginationInstruction_Input = {
  /** The page of results to show, will default if nil */
  page?: InputMaybe<Scalars['Int']>;
  /** The number of results to show per page, will default if nil */
  perPage?: InputMaybe<Scalars['Int']>;
};

/**
 * Restricted availability event data
 * More documentation here:https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Safe-Mode
 */
export type Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData = {
  __typename?: 'instacart_logistics_v1_RestrictedAvailabilityFulfillmentEventData';
  isWarehouseAndZoneScoped: Maybe<Scalars['Boolean']>;
  isWarehouseScoped: Maybe<Scalars['Boolean']>;
  restrictServiceOptionTypes: Maybe<Array<Maybe<Instacart_Logistics_V1_RestrictedServiceOptionType>>>;
  storeCloseBuffer: Maybe<Scalars['Int']>;
  warehouseIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * Restricted availability event data
 * More documentation here:https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Safe-Mode
 */
export type Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input = {
  isWarehouseAndZoneScoped?: InputMaybe<Scalars['Boolean']>;
  isWarehouseScoped?: InputMaybe<Scalars['Boolean']>;
  restrictServiceOptionTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_RestrictedServiceOptionType>>>;
  storeCloseBuffer?: InputMaybe<Scalars['Int']>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Types of service options that can be restricted */
export enum Instacart_Logistics_V1_RestrictedServiceOptionType {
  Asap = 'ASAP',
  /** WHL specific restrictions */
  BatchingForDelivery = 'BATCHING_FOR_DELIVERY',
  BatchingForInflightOrders = 'BATCHING_FOR_INFLIGHT_ORDERS',
  BatchingForPickup = 'BATCHING_FOR_PICKUP',
  FiveHour = 'FIVE_HOUR',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  LimitedAvailabilityFiveHour = 'LIMITED_AVAILABILITY_FIVE_HOUR',
  LimitedAvailabilityFourHour = 'LIMITED_AVAILABILITY_FOUR_HOUR',
  LimitedAvailabilityThreeHour = 'LIMITED_AVAILABILITY_THREE_HOUR',
  LimitedAvailabilityTwoHour = 'LIMITED_AVAILABILITY_TWO_HOUR',
  Pickup = 'PICKUP',
  PickupEta = 'PICKUP_ETA',
  PriorityEta = 'PRIORITY_ETA',
  PriorityEtaByEndAt = 'PRIORITY_ETA_BY_END_AT',
  PriorityEtaPickup = 'PRIORITY_ETA_PICKUP',
  RetailerLocationAvailabilityForDeliveryAndPickup = 'RETAILER_LOCATION_AVAILABILITY_FOR_DELIVERY_AND_PICKUP',
  ScheduledAvailabilityOneHour = 'SCHEDULED_AVAILABILITY_ONE_HOUR',
  StandardEta = 'STANDARD_ETA',
  StandardEtaByEndAt = 'STANDARD_ETA_BY_END_AT',
  ThreeHourScheduledDelivery = 'THREE_HOUR_SCHEDULED_DELIVERY',
  TwoHour = 'TWO_HOUR',
  UnspecifiedRestrictedServiceOptionType = 'UNSPECIFIED_RESTRICTED_SERVICE_OPTION_TYPE'
}

/** Information on how to sort the results of a list/filter operation */
export enum Instacart_Logistics_V1_SortingDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
  SortingDirectionUnspecified = 'SORTING_DIRECTION_UNSPECIFIED'
}

export type Instacart_Logistics_V1_SortingInstruction_Input = {
  /** The direction to sort, defaults to ascending */
  direction?: InputMaybe<Instacart_Logistics_V1_SortingDirection>;
  /** The name of the field to sort on, e.g. starts_at */
  fieldName?: InputMaybe<Scalars['String']>;
};

/**
 * Request to update one or more closure events
 * All events must be children of the same parent
 */
export type Instacart_Logistics_V1_UpdateClosureEventsRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** IDs of the events to update */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be updated asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to update one or more closure events */
export type Instacart_Logistics_V1_UpdateClosureEventsResponse = {
  __typename?: 'instacart_logistics_v1_UpdateClosureEventsResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The updated parent event, includes paginated child events */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/**
 * Request to update one or more fulfillment events
 * All events must be children of the same parent
 */
export type Instacart_Logistics_V1_UpdateFulfillmentEventsRequest_Input = {
  /** The event data that is specific to capacity-impacting events */
  capacityImpactData?: InputMaybe<Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** IDs of the events to update */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be update asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to update one or more fulfillment events */
export type Instacart_Logistics_V1_UpdateFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_UpdateFulfillmentEventsResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The updated parent event, includes paginated child events */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/**
 * Request to update one or more restricted availability events
 * All events must be children of the same parent
 */
export type Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** IDs of the events to update */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be updated asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
  /** The event data that is specific to restricted availability events */
  restrictedAvailabilityData?: InputMaybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input>;
};

/** Response to update a restricted availability event */
export type Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsResponse = {
  __typename?: 'instacart_logistics_v1_UpdateRestrictedAvailabilityEventsResponse';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The updated parent event, includes paginated child events */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Request to validate a closure event */
export type Instacart_Logistics_V1_ValidateNewClosureEventRequest_Input = {
  /** The event data that is specific to closure events */
  closureData?: InputMaybe<Instacart_Logistics_V1_ClosureFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
};

/** Response to validate a closure event */
export type Instacart_Logistics_V1_ValidateNewClosureEventResponse = {
  __typename?: 'instacart_logistics_v1_ValidateNewClosureEventResponse';
  /** Any errors that occurred during validation */
  errors: Maybe<Array<Maybe<Instacart_Logistics_V1_ValidationError>>>;
  /** The validated or created event */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** A list of locations, with names and ids */
  locations: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>>>;
  /** Does the event require approval? */
  requiresApproval: Maybe<Scalars['Boolean']>;
  /** Is the event valid? */
  valid: Maybe<Scalars['Boolean']>;
};

/** Parameters needed for validating new fulfillment capacity impacting events */
export type Instacart_Logistics_V1_ValidateNewFulfillmentEventRequest_Input = {
  /** The event data that is specific to capacity-impacting events */
  capacityImpactData?: InputMaybe<Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
};

/** Returns the validated or created event and any errors */
export type Instacart_Logistics_V1_ValidateNewFulfillmentEventResponse = {
  __typename?: 'instacart_logistics_v1_ValidateNewFulfillmentEventResponse';
  /** Any errors that occurred during validation */
  errors: Maybe<Array<Maybe<Instacart_Logistics_V1_ValidationError>>>;
  /** Data for the new parent event */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** A list of locations, with names and ids */
  locations: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>>>;
  /** Does the event require approval? */
  requiresApproval: Maybe<Scalars['Boolean']>;
  /** Is the event valid? */
  valid: Maybe<Scalars['Boolean']>;
};

/** Request to validate a restricted availability event */
export type Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** The event data that is specific to restricted availability events */
  restrictedAvailabilityData?: InputMaybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input>;
};

/** Response to validate a restricted availability event */
export type Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventResponse = {
  __typename?: 'instacart_logistics_v1_ValidateNewRestrictedAvailabilityEventResponse';
  /** Any errors that occurred during validation */
  errors: Maybe<Array<Maybe<Instacart_Logistics_V1_ValidationError>>>;
  /** The validated or created event */
  event: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** A list of locations, with names and ids */
  locations: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>>>;
  /** Does the event require approval? */
  requiresApproval: Maybe<Scalars['Boolean']>;
  /** Is the event valid? */
  valid: Maybe<Scalars['Boolean']>;
};

/** Validation error messages for a field, one field might have more than one error */
export type Instacart_Logistics_V1_ValidationError = {
  __typename?: 'instacart_logistics_v1_ValidationError';
  /** The error messages */
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of the field with the error, corresponds to the field name in FulfillmentEventData */
  fieldName: Maybe<Scalars['String']>;
};

/** AggregationPeriod defines the time period for data aggregation. */
export enum Instacart_Massops_V1_AggregationPeriod {
  /** Aggregate by month */
  AggregationPeriodMonth = 'AGGREGATION_PERIOD_MONTH',
  /** Aggregate by quarter */
  AggregationPeriodQuarter = 'AGGREGATION_PERIOD_QUARTER',
  /** Default unknown value */
  AggregationPeriodUnknown = 'AGGREGATION_PERIOD_UNKNOWN',
  /** Aggregate by week */
  AggregationPeriodWeek = 'AGGREGATION_PERIOD_WEEK'
}

/**
 * AllowedValueOption represents a single allowed value option for a allowed value.
 * It pairs a display label (for UI presentation) with the underlying value that will be used in execution.
 */
export type Instacart_Massops_V1_AllowedValueOption = {
  __typename?: 'instacart_massops_v1_AllowedValueOption';
  /** Display label for the allowed value */
  description: Maybe<Scalars['String']>;
  /** The underlying value (can be string, number, boolean, etc.) */
  value: Maybe<Scalars['String']>;
};

/** Artifact represents an external reference or artifact associated with an intervention. */
export type Instacart_Massops_V1_Artifact = {
  __typename?: 'instacart_massops_v1_Artifact';
  /** The artifact reference (e.g., ticket ID, incident ID) */
  reference: Maybe<Scalars['String']>;
  /** The type of artifact */
  type: Maybe<Instacart_Massops_V1_ArtifactType>;
};

/** ArtifactType defines the type of artifact associated with an intervention. */
export enum Instacart_Massops_V1_ArtifactType {
  /** Incident report */
  ArtifactTypeIncident = 'ARTIFACT_TYPE_INCIDENT',
  /** JIRA ticket */
  ArtifactTypeJira = 'ARTIFACT_TYPE_JIRA',
  /** Other artifact type */
  ArtifactTypeOther = 'ARTIFACT_TYPE_OTHER',
  /** Default unknown value */
  ArtifactTypeUnknown = 'ARTIFACT_TYPE_UNKNOWN'
}

/** ArtifactTypeCounts contains the count of interventions for each artifact type. */
export type Instacart_Massops_V1_ArtifactTypeCounts = {
  __typename?: 'instacart_massops_v1_ArtifactTypeCounts';
  /** Count of incident-related interventions */
  incident: Maybe<Scalars['BigInt']>;
  /** Count of JIRA-related interventions */
  jira: Maybe<Scalars['BigInt']>;
  /** Count of other artifact type interventions */
  other: Maybe<Scalars['BigInt']>;
  /** Count of interventions with unknown artifact type */
  unknown: Maybe<Scalars['BigInt']>;
};

/** ArtifactTypeTimeSeries represents counts by artifact type for a single time period. */
export type Instacart_Massops_V1_ArtifactTypeTimeSeries = {
  __typename?: 'instacart_massops_v1_ArtifactTypeTimeSeries';
  /** Counts for each artifact type in this period */
  counts: Maybe<Instacart_Massops_V1_ArtifactTypeCounts>;
  /** The end of the time period */
  endDate: Maybe<Scalars['DateTime']>;
  /** The start of the time period (e.g., start of week, month, or quarter) */
  startDate: Maybe<Scalars['DateTime']>;
};

/** Artifact represents an external reference or artifact associated with an intervention. */
export type Instacart_Massops_V1_Artifact_Input = {
  /** The artifact reference (e.g., ticket ID, incident ID) */
  reference?: InputMaybe<Scalars['String']>;
  /** The type of artifact */
  type?: InputMaybe<Instacart_Massops_V1_ArtifactType>;
};

/** CancelInterventionRequest is the request message for canceling an intervention. */
export type Instacart_Massops_V1_CancelInterventionRequest_Input = {
  /** The UUID of the intervention to cancel */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** CancelInterventionResponse is the response message for successful cancellation. */
export type Instacart_Massops_V1_CancelInterventionResponse = {
  __typename?: 'instacart_massops_v1_CancelInterventionResponse';
  /** The canceled intervention with updated state and canceled_at timestamp */
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * CommunicationSettings configures notification settings for an intervention.
 * It includes email and SMS notification configurations with multi-locale support.
 */
export type Instacart_Massops_V1_CommunicationSettings = {
  __typename?: 'instacart_massops_v1_CommunicationSettings';
  /** Email notification configuration */
  email: Maybe<Instacart_Massops_V1_EmailSettings>;
  /** SMS notification configuration */
  sms: Maybe<Instacart_Massops_V1_SmsSettings>;
};

/**
 * CommunicationSettings configures notification settings for an intervention.
 * It includes email and SMS notification configurations with multi-locale support.
 */
export type Instacart_Massops_V1_CommunicationSettings_Input = {
  /** Email notification configuration */
  email?: InputMaybe<Instacart_Massops_V1_EmailSettings_Input>;
  /** SMS notification configuration */
  sms?: InputMaybe<Instacart_Massops_V1_SmsSettings_Input>;
};

/** CreateInterventionRequest is the request message for creating a new intervention. */
export type Instacart_Massops_V1_CreateInterventionRequest_Input = {
  /** Artifact associated with this intervention */
  artifact?: InputMaybe<Instacart_Massops_V1_Artifact_Input>;
  /** Description of what this intervention will do */
  description?: InputMaybe<Scalars['String']>;
  /** The type of intervention to create */
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** User-friendly name for the intervention */
  name?: InputMaybe<Scalars['String']>;
  /** Parameters for the intervention (must match required_intervention_params) */
  params?: InputMaybe<Scalars['JSON']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** skipped step ids */
  skippedStepIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** CreateInterventionResponse contains the created intervention's metadata. */
export type Instacart_Massops_V1_CreateInterventionResponse = {
  __typename?: 'instacart_massops_v1_CreateInterventionResponse';
  /** When the intervention was created */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The UUID of the newly created intervention */
  interventionUuid: Maybe<Scalars['String']>;
};

/** DownloadInterventionDataRequest is the request message for downloading intervention CSV data. */
export type Instacart_Massops_V1_DownloadInterventionDataRequest_Input = {
  /** The UUID of the intervention to download data for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** DownloadInterventionDataResponse contains the presigned URL to download the full CSV data. */
export type Instacart_Massops_V1_DownloadInterventionDataResponse = {
  __typename?: 'instacart_massops_v1_DownloadInterventionDataResponse';
  /** Presigned URL to download the CSV data file */
  url: Maybe<Scalars['String']>;
};

/** EmailSettings configures email notifications with multi-locale support. */
export type Instacart_Massops_V1_EmailSettings = {
  __typename?: 'instacart_massops_v1_EmailSettings';
  /**
   * Locale-specific email content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content: Maybe<Scalars['JSON']>;
  /** Whether email notifications are enabled */
  enabled: Maybe<Scalars['Boolean']>;
};

/** EmailSettings configures email notifications with multi-locale support. */
export type Instacart_Massops_V1_EmailSettings_Input = {
  /**
   * Locale-specific email content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content?: InputMaybe<Scalars['JSON']>;
  /** Whether email notifications are enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/**
 * EstimatedImpact contains pre-execution estimates for an intervention.
 * Populated from the pre-execution summary; present when computed.
 */
export type Instacart_Massops_V1_EstimatedImpact = {
  __typename?: 'instacart_massops_v1_EstimatedImpact';
  /** Estimated financial impact; present only when intervention type has financial impact */
  financialImpact: Maybe<Instacart_Massops_V1_FinancialImpactSummary>;
  /** Number of unique orders affected; 0 if not applicable */
  impactedOrderCount: Maybe<Scalars['BigInt']>;
  /** Number of unique users affected; 0 if not applicable */
  impactedUserCount: Maybe<Scalars['BigInt']>;
};

/** ExecuteInterventionRequest is the request message for starting an intervention's execution. */
export type Instacart_Massops_V1_ExecuteInterventionRequest_Input = {
  /** The UUID of the intervention to execute */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ExecuteInterventionResponse is the response message for successful execution start. */
export type Instacart_Massops_V1_ExecuteInterventionResponse = {
  __typename?: 'instacart_massops_v1_ExecuteInterventionResponse';
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * ExecutionMetadata tracks the progress and status of an intervention's execution.
 * It provides counters for tasks in various states.
 */
export type Instacart_Massops_V1_ExecutionMetadata = {
  __typename?: 'instacart_massops_v1_ExecutionMetadata';
  /** Average duration per task in milliseconds */
  avgDurationPerTaskMs: Maybe<Scalars['Float']>;
  /** Number of tasks that are brand new */
  brandNewTasksCount: Maybe<Scalars['BigInt']>;
  /** Number of tasks successfully completed */
  completedTasksCount: Maybe<Scalars['BigInt']>;
  /** Number of tasks currently being executed */
  executingTasksCount: Maybe<Scalars['BigInt']>;
  /** Number of tasks that failed during execution */
  failedTasksCount: Maybe<Scalars['BigInt']>;
  /** Total execution duration in milliseconds */
  totalDurationMs: Maybe<Scalars['BigInt']>;
  /** Total number of tasks in the intervention */
  totalTasksCount: Maybe<Scalars['BigInt']>;
};

/**
 * ExecutionSummary contains post-execution results for an intervention.
 * Populated after execution completes; reflects actual realized impact.
 */
export type Instacart_Massops_V1_ExecutionSummary = {
  __typename?: 'instacart_massops_v1_ExecutionSummary';
  /** Actual financial impact from completed tasks; present when intervention type has financial impact */
  financialImpact: Maybe<Instacart_Massops_V1_FinancialImpactSummary>;
  /** Timestamp when this summary was generated */
  generatedAt: Maybe<Scalars['DateTime']>;
  /** List of locale codes affected (e.g., "en_US", "fr_CA") from actual execution data */
  impactedLocales: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Actual number of unique orders affected */
  impactedOrderCount: Maybe<Scalars['BigInt']>;
  /** Actual number of unique users affected */
  impactedUserCount: Maybe<Scalars['BigInt']>;
  /** Post-execution warning messages (e.g., "financial impact exceeded estimate by 20%") */
  warningMessages: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** FinancialImpactStatus defines the status of financial impact for an intervention. */
export enum Instacart_Massops_V1_FinancialImpactStatus {
  /** Financial impact known and estimated amounts are populated */
  FinancialImpactStatusEstimated = 'FINANCIAL_IMPACT_STATUS_ESTIMATED',
  /** Has financial impact but cannot be estimated pre-execution */
  FinancialImpactStatusIndeterminate = 'FINANCIAL_IMPACT_STATUS_INDETERMINATE',
  /** No financial impact */
  FinancialImpactStatusNone = 'FINANCIAL_IMPACT_STATUS_NONE',
  /** Default unknown value */
  FinancialImpactStatusUnknown = 'FINANCIAL_IMPACT_STATUS_UNKNOWN'
}

/**
 * FinancialSummary contains monetary impact analysis for the intervention.
 * This provides a pre-execution estimate based on uploaded data and intervention parameters.
 */
export type Instacart_Massops_V1_FinancialImpactSummary = {
  __typename?: 'instacart_massops_v1_FinancialImpactSummary';
  /** Estimated financial impact grouped by currency code (e.g., "USD", "CAD") */
  estimatedImpactByCurrency: Maybe<Scalars['JSON']>;
  /** Financial impact status (none/estimated/indeterminate) */
  status: Maybe<Instacart_Massops_V1_FinancialImpactStatus>;
  /** Total estimated financial impact converted to USD across all currencies */
  totalEstimatedImpact: Maybe<GoogleTypeMoney>;
  /** warning message for financial impact */
  warningMessage: Maybe<Scalars['String']>;
};

/** IncidentFilter contains essential query parameters for filtering incidents. */
export type Instacart_Massops_V1_GetIncidentRequest_IncidentFilter_Input = {
  /** Slack channel filter */
  slackChannelName?: InputMaybe<Scalars['String']>;
};

/** GetIncidentRequest is the request message for getting a single incident from the incident service. */
export type Instacart_Massops_V1_GetIncidentRequest_Input = {
  /** Filter criteria for incidents */
  filter?: InputMaybe<Instacart_Massops_V1_GetIncidentRequest_IncidentFilter_Input>;
  /** Request context */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetIncidentResponse contains a single incident. */
export type Instacart_Massops_V1_GetIncidentResponse = {
  __typename?: 'instacart_massops_v1_GetIncidentResponse';
  /** The incident matching the filter */
  incident: Maybe<Instacart_Massops_V1_Incident>;
};

/** GetInterventionCommunicationSettingsRequest is the request message for retrieving communication settings. */
export type Instacart_Massops_V1_GetInterventionCommunicationSettingsRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCommunicationSettingsResponse contains the communication settings for an intervention. */
export type Instacart_Massops_V1_GetInterventionCommunicationSettingsResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCommunicationSettingsResponse';
  /** The communication settings for the intervention */
  communicationSettings: Maybe<Instacart_Massops_V1_CommunicationSettings>;
};

/** GetInterventionCountsByArtifactTypeRequest is the request message for retrieving intervention counts by artifact type. */
export type Instacart_Massops_V1_GetInterventionCountsByArtifactTypeRequest_Input = {
  /** Filter for time range and aggregation period */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCountsByArtifactTypeResponse contains intervention counts grouped by artifact type over time. */
export type Instacart_Massops_V1_GetInterventionCountsByArtifactTypeResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCountsByArtifactTypeResponse';
  /** Time series data points, one for each aggregation period */
  timeSeries: Maybe<Array<Maybe<Instacart_Massops_V1_ArtifactTypeTimeSeries>>>;
};

/** GetInterventionCountsByIncidentRequest is the request message for retrieving incident-related intervention counts. */
export type Instacart_Massops_V1_GetInterventionCountsByIncidentRequest_Input = {
  /** Filter for time range and aggregation period */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCountsByIncidentResponse contains incident-related intervention counts grouped by incident. */
export type Instacart_Massops_V1_GetInterventionCountsByIncidentResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCountsByIncidentResponse';
  /** Time series data points, one for each aggregation period */
  timeSeries: Maybe<Array<Maybe<Instacart_Massops_V1_IncidentEventTimeSeries>>>;
  /** Total incident-related interventions across the entire selected time range */
  totalIncidentRelated: Maybe<Scalars['BigInt']>;
};

/** GetInterventionCountsByInterventionTypeRequest is the request message for retrieving intervention counts by intervention type. */
export type Instacart_Massops_V1_GetInterventionCountsByInterventionTypeRequest_Input = {
  /** Filter for time range and aggregation period */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCountsByInterventionTypeResponse contains intervention counts categorized by incident-related and non-incident-related types over time. */
export type Instacart_Massops_V1_GetInterventionCountsByInterventionTypeResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCountsByInterventionTypeResponse';
  /** Time series data points, one for each aggregation period */
  timeSeries: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionCategoryTimeSeries>>>;
  /** Overall totals across the entire selected time range */
  totalIncidentRelated: Maybe<Scalars['BigInt']>;
  totalNonIncidentRelated: Maybe<Scalars['BigInt']>;
};

/**
 * GetInterventionPreExecutionSummaryRequest is the request message for retrieving
 * the pre-execution summary for a specific intervention.
 */
export type Instacart_Massops_V1_GetInterventionPreExecutionSummaryRequest_Input = {
  /** The UUID of the intervention to retrieve the summary for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionPreExecutionSummaryResponse contains the pre-execution summary for an intervention. */
export type Instacart_Massops_V1_GetInterventionPreExecutionSummaryResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionPreExecutionSummaryResponse';
  /** The pre-execution summary with estimated impact and validation results */
  preExecutionSummary: Maybe<Instacart_Massops_V1_PreExecutionSummary>;
};

/** GetInterventionRequest is the request message for retrieving a specific intervention. */
export type Instacart_Massops_V1_GetInterventionRequest_Input = {
  /** The UUID of the intervention to retrieve */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionResponse contains the requested intervention details. */
export type Instacart_Massops_V1_GetInterventionResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionResponse';
  /** The requested intervention with all its details */
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/** GetInterventionStatisticsRequest is the request message for retrieving intervention statistics. */
export type Instacart_Massops_V1_GetInterventionStatisticsRequest_Input = {
  /** Optional filter for statistics */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionStatisticsResponse contains aggregate statistics about interventions. */
export type Instacart_Massops_V1_GetInterventionStatisticsResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionStatisticsResponse';
  /** Total counts for each intervention workflow state */
  stateCounts: Maybe<Instacart_Massops_V1_InterventionStateCounts>;
  timeSeries: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionStateTimeSeries>>>;
  /**
   * Total number of interventions in the date range
   * Time series data points, one for each aggregation period
   */
  totalCount: Maybe<Scalars['BigInt']>;
};

/**
 * GetInterventionTypeIdForInterventionRequest is the request message for retrieving
 * the intervention type ID for an intervention UUID.
 */
export type Instacart_Massops_V1_GetInterventionTypeIdForInterventionRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionTypeIdForInterventionResponse contains the intervention type ID. */
export type Instacart_Massops_V1_GetInterventionTypeIdForInterventionResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionTypeIdForInterventionResponse';
  /** The intervention type ID */
  interventionTypeId: Maybe<Scalars['String']>;
};

/** GetInterventionTypeRequest is the request message for retrieving a specific intervention type. */
export type Instacart_Massops_V1_GetInterventionTypeRequest_Input = {
  /** The ID of the intervention type to retrieve */
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionTypeResponse contains the requested intervention type details. */
export type Instacart_Massops_V1_GetInterventionTypeResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionTypeResponse';
  /** The requested intervention type */
  interventionType: Maybe<Instacart_Massops_V1_InterventionType>;
};

/** GetNotificationTemplateRequest is the request message for retrieving a notification template. */
export type Instacart_Massops_V1_GetNotificationTemplateRequest_Input = {
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** Template ID to retrieve */
  templateId?: InputMaybe<Scalars['String']>;
};

/** GetNotificationTemplateResponse contains the full notification template details. */
export type Instacart_Massops_V1_GetNotificationTemplateResponse = {
  __typename?: 'instacart_massops_v1_GetNotificationTemplateResponse';
  /** Full template details */
  template: Maybe<Instacart_Massops_V1_NotificationTemplate>;
};

/**
 * GetTotalFinancialImpactRequest is the request message for retrieving
 * the total financial impact across interventions.
 */
export type Instacart_Massops_V1_GetTotalFinancialImpactRequest_Input = {
  /** Optional filter for time range (e.g., start_date, end_date) */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetTotalFinancialImpactResponse contains the total financial impact. */
export type Instacart_Massops_V1_GetTotalFinancialImpactResponse = {
  __typename?: 'instacart_massops_v1_GetTotalFinancialImpactResponse';
  /** Breakdown by currency code (e.g., "USD", "CAD") */
  impactByCurrency: Maybe<Scalars['JSON']>;
  /** Threshold values for monthly, quarterly, yearly periods */
  threshold: Maybe<Instacart_Massops_V1_Threshold>;
  /** Total aggregated financial impact (typically in USD) */
  totalFinancialImpact: Maybe<GoogleTypeMoney>;
};

/** Incident represents an incident from the incident service. */
export type Instacart_Massops_V1_Incident = {
  __typename?: 'instacart_massops_v1_Incident';
  /** Timestamps */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Core incident fields */
  id: Maybe<Scalars['String']>;
  incidentName: Maybe<Scalars['String']>;
  incidentStatus: Maybe<Scalars['String']>;
  /** URL to view the incident */
  incidentUrl: Maybe<Scalars['String']>;
  severity: Maybe<Scalars['Int']>;
  /** Slack integration */
  slackChannelName: Maybe<Scalars['String']>;
};

/** IncidentEventCounts contains the count of events for a specific incident. */
export type Instacart_Massops_V1_IncidentEventCounts = {
  __typename?: 'instacart_massops_v1_IncidentEventCounts';
  /** The incident name/reference (e.g., incident ID or Jira key) */
  incidentReference: Maybe<Scalars['String']>;
  /** Total interventions for this specific incident */
  totalCount: Maybe<Scalars['BigInt']>;
};

/** IncidentEventTimeSeries represents incident-related counts for a single time period. */
export type Instacart_Massops_V1_IncidentEventTimeSeries = {
  __typename?: 'instacart_massops_v1_IncidentEventTimeSeries';
  endDate: Maybe<Scalars['DateTime']>;
  incidentCounts: Maybe<Array<Maybe<Instacart_Massops_V1_IncidentEventCounts>>>;
  startDate: Maybe<Scalars['DateTime']>;
};

/**
 * Intervention represents an instance of a mass operation that can be executed.
 * It contains the configuration, state, and execution metadata.
 */
export type Instacart_Massops_V1_Intervention = {
  __typename?: 'instacart_massops_v1_Intervention';
  /** Artifact associated with this intervention */
  artifact: Maybe<Instacart_Massops_V1_Artifact>;
  /** When the intervention execution canceled */
  canceledAt: Maybe<Scalars['DateTime']>;
  /** When the intervention execution completed */
  completedAt: Maybe<Scalars['DateTime']>;
  /** When the intervention was created */
  createdAt: Maybe<Scalars['DateTime']>;
  /** ID of the user who created this intervention */
  creatorId: Maybe<Scalars['String']>;
  /** A flag that shows if intervention has data uploaded */
  dataUploaded: Maybe<Scalars['Boolean']>;
  /** User-provided description of the intervention's purpose */
  description: Maybe<Scalars['String']>;
  /** Pre-execution estimates (impacted users/orders, estimated financial impact); present when computed */
  estimatedImpact: Maybe<Instacart_Massops_V1_EstimatedImpact>;
  /** When the intervention execution started */
  executedAt: Maybe<Scalars['DateTime']>;
  /** Execution progress and statistics */
  executionMetadata: Maybe<Instacart_Massops_V1_ExecutionMetadata>;
  /** Post-execution summary (actual impact); present when execution has completed */
  executionSummary: Maybe<Instacart_Massops_V1_ExecutionSummary>;
  /** ID of the user who executed this intervention */
  executorId: Maybe<Scalars['String']>;
  /** The type of intervention this instance is based on */
  interventionTypeId: Maybe<Scalars['String']>;
  /** User-provided name for this intervention */
  name: Maybe<Scalars['String']>;
  /** Intervention params */
  params: Maybe<Scalars['JSON']>;
  /** Intervention execution results */
  result: Maybe<Scalars['JSON']>;
  /** Step IDs that were skipped during intervention creation */
  skippedStepIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Current state (e.g., pending, executing, completed, failed) */
  state: Maybe<Scalars['String']>;
  /** When the intervention was updated */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this intervention instance */
  uuid: Maybe<Scalars['String']>;
};

/**
 * InterventionApprovalRequest represents an approval request associated with an intervention.
 * It matches the database schema for the approval_requests table.
 */
export type Instacart_Massops_V1_InterventionApprovalRequest = {
  __typename?: 'instacart_massops_v1_InterventionApprovalRequest';
  /** Whether this approval request is currently active (boolean) */
  active: Maybe<Scalars['Boolean']>;
  /** Internal approval request ID */
  approvalRequestId: Maybe<Scalars['String']>;
  /** When the approval request was created (timestamp) */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Related intervention UUID (varchar) */
  interventionUuid: Maybe<Scalars['String']>;
  /** When the approval request was last updated (timestamp) */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** InterventionCategoryCounts contains the count of interventions categorized by incident-related and non-incident-related types. */
export type Instacart_Massops_V1_InterventionCategoryCounts = {
  __typename?: 'instacart_massops_v1_InterventionCategoryCounts';
  /** intervention_type_id -> count for incident-related interventions */
  incidentRelated: Maybe<Scalars['JSON']>;
  /** intervention_type_id -> count for non-incident-related interventions */
  nonIncidentRelated: Maybe<Scalars['JSON']>;
};

/** InterventionCategoryTimeSeries represents counts by intervention category for a single time period. */
export type Instacart_Massops_V1_InterventionCategoryTimeSeries = {
  __typename?: 'instacart_massops_v1_InterventionCategoryTimeSeries';
  counts: Maybe<Instacart_Massops_V1_InterventionCategoryCounts>;
  endDate: Maybe<Scalars['DateTime']>;
  /** Totals for this specific time period */
  periodTotalIncidentRelated: Maybe<Scalars['BigInt']>;
  periodTotalNonIncidentRelated: Maybe<Scalars['BigInt']>;
  startDate: Maybe<Scalars['DateTime']>;
};

/** InterventionStateCounts contains the count of interventions in each workflow state. */
export type Instacart_Massops_V1_InterventionStateCounts = {
  __typename?: 'instacart_massops_v1_InterventionStateCounts';
  approved: Maybe<Scalars['BigInt']>;
  canceled: Maybe<Scalars['BigInt']>;
  completed: Maybe<Scalars['BigInt']>;
  completedWithFailure: Maybe<Scalars['BigInt']>;
  createdTasks: Maybe<Scalars['BigInt']>;
  creatingTasks: Maybe<Scalars['BigInt']>;
  draft: Maybe<Scalars['BigInt']>;
  executing: Maybe<Scalars['BigInt']>;
  failed: Maybe<Scalars['BigInt']>;
  pendingApproval: Maybe<Scalars['BigInt']>;
  rejected: Maybe<Scalars['BigInt']>;
  scheduled: Maybe<Scalars['BigInt']>;
  taskCreationFailed: Maybe<Scalars['BigInt']>;
};

/** InterventionStateTimeSeries represents intervention state counts for a single time period. */
export type Instacart_Massops_V1_InterventionStateTimeSeries = {
  __typename?: 'instacart_massops_v1_InterventionStateTimeSeries';
  /** The end of the time period */
  endDate: Maybe<Scalars['DateTime']>;
  /** The start of the time period (e.g., start of week, month, or quarter) */
  startDate: Maybe<Scalars['DateTime']>;
  /** Counts for each intervention state in this period */
  stateCounts: Maybe<Instacart_Massops_V1_InterventionStateCounts>;
};

/** InterventionStatisticFilter defines filter criteria for intervention statistics queries. */
export type Instacart_Massops_V1_InterventionStatisticFilter_Input = {
  /** The time period to aggregate by (week, month, or quarter) */
  aggregation?: InputMaybe<Instacart_Massops_V1_AggregationPeriod>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Filter by created at time range (inclusive) */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/**
 * InterventionType defines a template for creating interventions.
 * It specifies what parameters are required and what kind of operations will be performed.
 */
export type Instacart_Massops_V1_InterventionType = {
  __typename?: 'instacart_massops_v1_InterventionType';
  /** Whether approval is required for this intervention type */
  approvalRequired: Maybe<Scalars['Boolean']>;
  /** Whether customer communication is supported for this intervention type */
  customerCommunicationSupported: Maybe<Scalars['Boolean']>;
  /** Detailed description of what this intervention type does */
  description: Maybe<Scalars['String']>;
  /** Whether this intervention_type has financial_impact */
  hasFinancialImpact: Maybe<Scalars['Boolean']>;
  /** Unique identifier for this intervention type */
  interventionTypeId: Maybe<Scalars['String']>;
  /** Human-readable name of the intervention type */
  name: Maybe<Scalars['String']>;
  /** Parameters required at the intervention level */
  requiredInterventionParams: Maybe<Array<Maybe<Instacart_Massops_V1_ParamDefinition>>>;
  /** Parameters required for each task in the intervention */
  requiredTaskParams: Maybe<Array<Maybe<Instacart_Massops_V1_ParamDefinition>>>;
  /** Steps that define the workflow of this intervention type */
  steps: Maybe<Array<Maybe<Instacart_Massops_V1_StepDefinition>>>;
};

/** Filter to apply to the list of approval requests */
export type Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Filter_Input = {
  /**
   * Filter by active status. If true, returns only active approval requests.
   * If false, returns only inactive approval requests.
   * If not set, returns all approval requests.
   */
  active?: InputMaybe<Scalars['Boolean']>;
};

/** ListInterventionApprovalRequestsRequest is the request message for listing approval requests. */
export type Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Input = {
  /** Optional filter to apply to the approval request list */
  filter?: InputMaybe<Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Filter_Input>;
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionApprovalRequestsResponse contains the list of approval requests. */
export type Instacart_Massops_V1_ListInterventionApprovalRequestsResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionApprovalRequestsResponse';
  /** List of approval requests */
  approvalRequests: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionApprovalRequest>>>;
};

/** ListInterventionTypesRequest is the request message for listing all available intervention types. */
export type Instacart_Massops_V1_ListInterventionTypesRequest_Input = {
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionTypesResponse contains all available intervention types. */
export type Instacart_Massops_V1_ListInterventionTypesResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionTypesResponse';
  /** List of all available intervention types */
  interventionTypes: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionType>>>;
};

/** Filter to apply to the list of interventions */
export type Instacart_Massops_V1_ListInterventionsRequest_Filter_Input = {
  /** Filter by artifact reference containing the keywords */
  artifactReference?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Filter by intervention type IDs
   * If multiple IDs are provided, filters using OR logic
   * If none is provided, it will not apply a filter on intervention_type_id
   */
  interventionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by name containing the keywords */
  name?: InputMaybe<Scalars['String']>;
  /** Filter by created at time range */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Filter by workflow states (e.g., "pending", "executing", "completed", "failed")
   * If multiple states are provided, filters using OR logic
   * If none is provided, it will not apply a filter on state
   */
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** ListInterventionsRequest is the request message for listing interventions with pagination. */
export type Instacart_Massops_V1_ListInterventionsRequest_Input = {
  /** Optional filter to apply to the intervention list */
  filter?: InputMaybe<Instacart_Massops_V1_ListInterventionsRequest_Filter_Input>;
  /** Number of interventions to return per page (optional) */
  pageSize?: InputMaybe<Scalars['BigInt']>;
  pageToken?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionsResponse contains a paginated list of interventions. */
export type Instacart_Massops_V1_ListInterventionsResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionsResponse';
  /** List of interventions for the current page */
  interventions: Maybe<Array<Maybe<Instacart_Massops_V1_Intervention>>>;
  /** Token to retrieve the next page (optional) */
  nextPageToken: Maybe<Scalars['String']>;
  /** Total number of interventions across all pages */
  totalCount: Maybe<Scalars['BigInt']>;
};

/** ListNotificationTemplatesRequest is the request message for listing notification templates. */
export type Instacart_Massops_V1_ListNotificationTemplatesRequest_Input = {
  /** Optional filter by intervention type */
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListNotificationTemplatesResponse contains all available notification templates. */
export type Instacart_Massops_V1_ListNotificationTemplatesResponse = {
  __typename?: 'instacart_massops_v1_ListNotificationTemplatesResponse';
  /** List of available templates */
  templates: Maybe<Array<Maybe<Instacart_Massops_V1_NotificationTemplateMetaData>>>;
};

/** Filter to apply to the list of tasks */
export type Instacart_Massops_V1_ListTasksRequest_Filter_Input = {
  /**
   * Filter by task states (e.g., "pending", "executing", "completed", "failed")
   * If multiple states are provided, filters using OR logic
   * If none is provided, it will not apply a filter on state
   */
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** ListTasksRequest is the request message for listing tasks within an intervention. */
export type Instacart_Massops_V1_ListTasksRequest_Input = {
  /** Optional filter to apply to the task list */
  filter?: InputMaybe<Instacart_Massops_V1_ListTasksRequest_Filter_Input>;
  /** The UUID of the intervention whose tasks to list */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Number of tasks to return per page (optional) */
  pageSize?: InputMaybe<Scalars['BigInt']>;
  /** Token for retrieving the next page (optional) */
  pageToken?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListTasksResponse contains a paginated list of tasks for an intervention. */
export type Instacart_Massops_V1_ListTasksResponse = {
  __typename?: 'instacart_massops_v1_ListTasksResponse';
  /** Token to retrieve the next page (optional) */
  nextPageToken: Maybe<Scalars['String']>;
  /** List of tasks for the current page */
  tasks: Maybe<Array<Maybe<Instacart_Massops_V1_Task>>>;
  /** Total number of tasks across all pages */
  totalCount: Maybe<Scalars['BigInt']>;
};

/** ListTemplateVariablesRequest is the request message for listing template variables. */
export type Instacart_Massops_V1_ListTemplateVariablesRequest_Input = {
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListTemplateVariablesResponse contains all supported template variables. */
export type Instacart_Massops_V1_ListTemplateVariablesResponse = {
  __typename?: 'instacart_massops_v1_ListTemplateVariablesResponse';
  /** List of all supported variables */
  variables: Maybe<Array<Maybe<Instacart_Massops_V1_TemplateVariable>>>;
};

/** NotificationChannel defines the communication channels for notifications. */
export enum Instacart_Massops_V1_NotificationChannel {
  /** Email channel */
  NotificationChannelEmail = 'NOTIFICATION_CHANNEL_EMAIL',
  /** SMS channel */
  NotificationChannelSms = 'NOTIFICATION_CHANNEL_SMS',
  /** Default unknown value */
  NotificationChannelUnknown = 'NOTIFICATION_CHANNEL_UNKNOWN'
}

/** NotificationTemplate represents a full notification template with all details. */
export type Instacart_Massops_V1_NotificationTemplate = {
  __typename?: 'instacart_massops_v1_NotificationTemplate';
  /** Content for all locales, keyed by locale code */
  content: Maybe<Scalars['JSON']>;
  /** Description of when to use */
  description: Maybe<Scalars['String']>;
  /** Human-readable name */
  name: Maybe<Scalars['String']>;
  /** Supported channels (EMAIL, SMS) */
  supportedChannels: Maybe<Array<Maybe<Instacart_Massops_V1_NotificationChannel>>>;
  /** Available locale codes */
  supportedLocales: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Unique identifier */
  templateId: Maybe<Scalars['String']>;
  /** Warnings for template usage */
  warnings: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** NotificationTemplateMetaData represents metadata of a notification template. */
export type Instacart_Massops_V1_NotificationTemplateMetaData = {
  __typename?: 'instacart_massops_v1_NotificationTemplateMetaData';
  /** Human-readable name of the template */
  name: Maybe<Scalars['String']>;
  /** Unique identifier for the template */
  templateId: Maybe<Scalars['String']>;
};

/**
 * ParamDefinition describes a parameter that can be used in an intervention type.
 * It defines the parameter's metadata including name, type, and description.
 */
export type Instacart_Massops_V1_ParamDefinition = {
  __typename?: 'instacart_massops_v1_ParamDefinition';
  /** The allowed values for the parameter */
  allowedValues: Maybe<Array<Maybe<Instacart_Massops_V1_AllowedValueOption>>>;
  /** Default value for the parameter */
  defaultValue: Maybe<Scalars['String']>;
  /** Human-readable description of the parameter */
  description: Maybe<Scalars['String']>;
  /** The parameter name */
  name: Maybe<Scalars['String']>;
  /** Whether this parameter is required */
  required: Maybe<Scalars['Boolean']>;
  /** NEW - param required only if ANY of these steps is included */
  requiredIfStepIncluded: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The data type: string, integer, or boolean */
  type: Maybe<Scalars['String']>;
};

/** ParameterSummary contains count and distribution analysis for a specific parameter. */
export type Instacart_Massops_V1_ParameterSummary = {
  __typename?: 'instacart_massops_v1_ParameterSummary';
  /** Name of the parameter (e.g., "user_id", "order_id") */
  paramName: Maybe<Scalars['String']>;
  /** Value distribution across defined ranges (optional) */
  rangeCounts: Maybe<Array<Maybe<Instacart_Massops_V1_RangeCount>>>;
  /** Sum of all values for this parameter (only applicable when param is monetary value or quantity value) */
  sum: Maybe<Scalars['Float']>;
  /** Total count of unique values for this parameter */
  uniqueCount: Maybe<Scalars['BigInt']>;
  /** Warning message for this parameter (e.g., "5 invalid values detected") */
  warningMessage: Maybe<Scalars['String']>;
};

/**
 * PreExecutionSummary contains pre-run analysis for an intervention.
 * This provides estimates and validation results before execution begins.
 * It matches the PreExecutionSummary struct in massops/internal/data_access.
 */
export type Instacart_Massops_V1_PreExecutionSummary = {
  __typename?: 'instacart_massops_v1_PreExecutionSummary';
  /** Error message when status is FAILED */
  errorMessage: Maybe<Scalars['String']>;
  /** Monetary impact analysis (present only if intervention involves amounts) */
  financialImpactSummary: Maybe<Instacart_Massops_V1_FinancialImpactSummary>;
  /** Timestamp when this summary was generated */
  generatedAt: Maybe<Scalars['DateTime']>;
  /** True if any parameter has a warning */
  hasWarnings: Maybe<Scalars['Boolean']>;
  /** List of locale codes affected (e.g., "en-US", "fr-CA") */
  impactedLocales: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Number of unique orders affected; from order_delivery_id param UniqueCount, or 0 if not applicable */
  impactedOrderCount: Maybe<Scalars['BigInt']>;
  /** Number of unique users affected; from user_id param UniqueCount, or 0 if not applicable */
  impactedUserCount: Maybe<Scalars['BigInt']>;
  /** Count and distribution analysis per parameter */
  parameterSummaries: Maybe<Array<Maybe<Instacart_Massops_V1_ParameterSummary>>>;
  /** Status of the pre-execution summary computation (computing, success, failed) */
  status: Maybe<Instacart_Massops_V1_PreExecutionSummaryStatus>;
  /** Total number of tasks that will be created from the uploaded data */
  totalTasks: Maybe<Scalars['BigInt']>;
  /** List of warning messages */
  warningMessages: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** PreExecutionSummaryStatus defines the status of pre-execution summary computation. */
export enum Instacart_Massops_V1_PreExecutionSummaryStatus {
  /** Summary is currently being computed */
  PreExecutionSummaryStatusComputing = 'PRE_EXECUTION_SUMMARY_STATUS_COMPUTING',
  /** Summary computation failed */
  PreExecutionSummaryStatusFailed = 'PRE_EXECUTION_SUMMARY_STATUS_FAILED',
  /** Summary computation completed successfully */
  PreExecutionSummaryStatusSuccess = 'PRE_EXECUTION_SUMMARY_STATUS_SUCCESS',
  /** Default unknown value */
  PreExecutionSummaryStatusUnknown = 'PRE_EXECUTION_SUMMARY_STATUS_UNKNOWN'
}

/** PreviewInterventionDataRequest is the request message for previewing intervention CSV data. */
export type Instacart_Massops_V1_PreviewInterventionDataRequest_Input = {
  /** The UUID of the intervention to preview data for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** PreviewInterventionDataResponse contains the preview of CSV data for the intervention. */
export type Instacart_Massops_V1_PreviewInterventionDataResponse = {
  __typename?: 'instacart_massops_v1_PreviewInterventionDataResponse';
  /** Column names from the CSV */
  columns: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Data rows as key-value pairs (up to 10 rows) */
  rows: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** RangeCount represents a single bucket in a value distribution histogram. */
export type Instacart_Massops_V1_RangeCount = {
  __typename?: 'instacart_massops_v1_RangeCount';
  /** Number of items falling within this range */
  count: Maybe<Scalars['BigInt']>;
  /** Upper bound of the range (exclusive, except for last bucket) */
  maxValue: Maybe<Scalars['Float']>;
  /** Lower bound of the range (inclusive) */
  minValue: Maybe<Scalars['Float']>;
  /** Display label for the range (e.g., "1-100", "100-1000", ">1000") */
  rangeLabel: Maybe<Scalars['String']>;
};

/** RequestContext provides context information for requests. */
export type Instacart_Massops_V1_RequestContext_Input = {
  /** Resource name identifying the calling client, e.g. "clients/1" */
  client?: InputMaybe<Scalars['String']>;
  /** The ID of the user making the request */
  userId?: InputMaybe<Scalars['String']>;
};

/** RequestInterventionApprovalRequest is the request message for requesting approval of an intervention. */
export type Instacart_Massops_V1_RequestInterventionApprovalRequest_Input = {
  /** The UUID of the intervention to request approval for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** RequestInterventionApprovalResponse is the response message for successful approval request. */
export type Instacart_Massops_V1_RequestInterventionApprovalResponse = {
  __typename?: 'instacart_massops_v1_RequestInterventionApprovalResponse';
  /** The approval request id (optional) */
  approvalRequestId: Maybe<Scalars['String']>;
  /** The intervention with updated state (pending_approval) */
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/** SmsSettings configures SMS notifications with multi-locale support. */
export type Instacart_Massops_V1_SmsSettings = {
  __typename?: 'instacart_massops_v1_SmsSettings';
  /**
   * Locale-specific SMS content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content: Maybe<Scalars['JSON']>;
  /** Whether SMS notifications are enabled */
  enabled: Maybe<Scalars['Boolean']>;
};

/** SmsSettings configures SMS notifications with multi-locale support. */
export type Instacart_Massops_V1_SmsSettings_Input = {
  /**
   * Locale-specific SMS content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content?: InputMaybe<Scalars['JSON']>;
  /** Whether SMS notifications are enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/**
 * StepDefinition describes a step in an intervention type.
 * It defines the step's metadata including unique identifier, name, and description.
 */
export type Instacart_Massops_V1_StepDefinition = {
  __typename?: 'instacart_massops_v1_StepDefinition';
  /** Human-readable description of the step */
  description: Maybe<Scalars['String']>;
  /** Unique identifier for this step */
  id: Maybe<Scalars['String']>;
  /** The step name */
  name: Maybe<Scalars['String']>;
  /** NEW */
  optional: Maybe<Scalars['Boolean']>;
  /** Output parameters produced by this step */
  outputParams: Maybe<Array<Maybe<Instacart_Massops_V1_ParamDefinition>>>;
};

/** StepExecutionResult represents the execution result of a single step in a task. */
export type Instacart_Massops_V1_StepExecutionResult = {
  __typename?: 'instacart_massops_v1_StepExecutionResult';
  /** Step execution duration in milliseconds */
  durationMs: Maybe<Scalars['BigInt']>;
  /** Error message (only populated on failure) */
  error: Maybe<Scalars['String']>;
  /** Step's output values (only populated on success) */
  outputs: Maybe<Scalars['JSON']>;
  /** Unique identifier of the step */
  stepId: Maybe<Scalars['String']>;
  /** Human-readable name of the step */
  stepName: Maybe<Scalars['String']>;
  /** Whether the step executed successfully */
  success: Maybe<Scalars['Boolean']>;
};

/**
 * SyncInterventionApprovalResultRequest receives approval callback from external systems.
 * This endpoint syncs the approval decision state from external approval workflows.
 */
export type Instacart_Massops_V1_SyncInterventionApprovalResultRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** SyncInterventionApprovalResultResponse contains the updated intervention after syncing approval result. */
export type Instacart_Massops_V1_SyncInterventionApprovalResultResponse = {
  __typename?: 'instacart_massops_v1_SyncInterventionApprovalResultResponse';
  /** The intervention with updated state based on approval decision */
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * Task represents an individual unit of work within an intervention.
 * Each task operates on a specific entity or performs a specific action.
 */
export type Instacart_Massops_V1_Task = {
  __typename?: 'instacart_massops_v1_Task';
  /** When the task execution completed */
  completedAt: Maybe<Scalars['DateTime']>;
  /** When the task was created */
  createdAt: Maybe<Scalars['DateTime']>;
  /** When the task execution started */
  executedAt: Maybe<Scalars['DateTime']>;
  /** Financial impact of this task (may be null if intervention type has no financial impact or step hasn't executed yet) */
  financialImpact: Maybe<GoogleTypeMoney>;
  /** Task-specific params and parameters */
  params: Maybe<Scalars['JSON']>;
  /** Task execution results */
  result: Maybe<Scalars['JSON']>;
  /** Current state (e.g., pending, executing, completed, failed) */
  state: Maybe<Scalars['String']>;
  /** Array of step execution results for this task */
  stepResults: Maybe<Array<Maybe<Instacart_Massops_V1_StepExecutionResult>>>;
  /** When the task was updated */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this task */
  uuid: Maybe<Scalars['String']>;
};

/** TemplateVariable represents a variable that can be used in notification templates. */
export type Instacart_Massops_V1_TemplateVariable = {
  __typename?: 'instacart_massops_v1_TemplateVariable';
  /** Human-readable description */
  description: Maybe<Scalars['String']>;
  /** Variable name (e.g., "first_name") */
  name: Maybe<Scalars['String']>;
};

/** Threshold contains threshold values for monthly, quarterly, and yearly periods. */
export type Instacart_Massops_V1_Threshold = {
  __typename?: 'instacart_massops_v1_Threshold';
  /** Threshold value for monthly period */
  monthlyThreshold: Maybe<Scalars['BigInt']>;
  /** Threshold value for quarterly period */
  quarterlyThreshold: Maybe<Scalars['BigInt']>;
  /** Threshold value for yearly period */
  yearlyThreshold: Maybe<Scalars['BigInt']>;
};

/** UpdateInterventionCommunicationSettingsRequest is the request message for updating communication settings for an intervention. */
export type Instacart_Massops_V1_UpdateInterventionCommunicationSettingsRequest_Input = {
  /** The communication settings to update */
  communicationSettings?: InputMaybe<Instacart_Massops_V1_CommunicationSettings_Input>;
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** UpdateInterventionCommunicationSettingsResponse contains the updated intervention with new communication settings. */
export type Instacart_Massops_V1_UpdateInterventionCommunicationSettingsResponse = {
  __typename?: 'instacart_massops_v1_UpdateInterventionCommunicationSettingsResponse';
  /** The intervention with updated communication settings */
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/** UpdateInterventionRequest is the request message for updating an intervention. */
export type Instacart_Massops_V1_UpdateInterventionRequest_Input = {
  /** Artifact associated with this intervention */
  artifact?: InputMaybe<Instacart_Massops_V1_Artifact_Input>;
  /** Optional: new description for the intervention */
  description?: InputMaybe<Scalars['String']>;
  /** The UUID of the intervention to update */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Optional: new name for the intervention */
  name?: InputMaybe<Scalars['String']>;
  /** Optional: new parameters/inputs for the intervention (maps to inputs field) */
  params?: InputMaybe<Scalars['JSON']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** UpdateInterventionResponse contains the updated intervention details. */
export type Instacart_Massops_V1_UpdateInterventionResponse = {
  __typename?: 'instacart_massops_v1_UpdateInterventionResponse';
  /** The updated intervention with all its details */
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/** UploadInterventionDataRequest is the request message for uploading task data to an intervention. */
export type Instacart_Massops_V1_UploadInterventionDataRequest_Input = {
  /** CSV data containing tasks to be processed */
  csvContent?: InputMaybe<Scalars['String']>;
  /** The UUID of the intervention to upload data to */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** UploadInterventionDataResponse is the response message for successful data upload. */
export type Instacart_Massops_V1_UploadInterventionDataResponse = {
  __typename?: 'instacart_massops_v1_UploadInterventionDataResponse';
  intervention: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * Represents an approvable record, which can be of different types
 * Currently only ColumnMapRecord is used, but this structure allows for future extension, i.e. ValidationMaps
 */
export type Instacart_Partners_Data_Ingestion_V1_ApprovableRecord = {
  __typename?: 'instacart_partners_data_ingestion_v1_ApprovableRecord';
  columnMap: Maybe<Instacart_Partners_Data_Ingestion_V1_ColumnMapRecord>;
};

/** Represents a change approval request */
export type Instacart_Partners_Data_Ingestion_V1_ChangeApprovalRequest = {
  __typename?: 'instacart_partners_data_ingestion_v1_ChangeApprovalRequest';
  changeType: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  latestRevision: Maybe<Instacart_Partners_Data_Ingestion_V1_ApprovableRecord>;
  recordType: Maybe<Scalars['String']>;
  sourceRecord: Maybe<Instacart_Partners_Data_Ingestion_V1_ApprovableRecord>;
  sourceRecordId: Maybe<Scalars['BigInt']>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Represents a column map record */
export type Instacart_Partners_Data_Ingestion_V1_ColumnMapRecord = {
  __typename?: 'instacart_partners_data_ingestion_v1_ColumnMapRecord';
  fileNameMatcher: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  ingestionType: Maybe<Scalars['String']>;
  map: Maybe<Scalars['JSON']>;
  mapType: Maybe<Scalars['String']>;
  normalizedSchema: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['BigInt']>;
  rawSchema: Maybe<Scalars['String']>;
  tombstone: Maybe<Scalars['Boolean']>;
};

/** Request message for getting a change approval request by its ID */
export type Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing the requested change approval request and includes relevant approvable records */
export type Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestResponse = {
  __typename?: 'instacart_partners_data_ingestion_v1_GetChangeApprovalRequestResponse';
  changeApprovalRequest: Maybe<Instacart_Partners_Data_Ingestion_V1_ChangeApprovalRequest>;
};

/** Request to bulk create configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsRequest_Input = {
  /** The configurations to create */
  partnerConfigurationsToCreate?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_CreatePartnerConfigurationInput_Input>>>;
};

/** Response to bulk create partner configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_BulkCreatePartnerConfigurationsResponse';
  /** The configurations created */
  partnerConfigurations: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/** Request to bulk delete configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsRequest_Input = {
  /** The user or system who deleted the configuration */
  deletedBy?: InputMaybe<Scalars['String']>;
  /** The IDs of the configurations to delete */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response to bulk delete partner configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_BulkDeletePartnerConfigurationsResponse';
  /** Whether the delete was successful. It is an all-or-nothing operation */
  success: Maybe<Scalars['Boolean']>;
};

/** Request to bulk update configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsRequest_Input = {
  /** The configurations to update */
  partnerConfigurationsToUpdate?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_UpdatePartnerConfigurationInput_Input>>>;
};

/** Response to bulk update partner configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_BulkUpdatePartnerConfigurationsResponse';
  /** The configurations updated */
  partnerConfigurations: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/**
 * Maps to Csv::ColumnProfile on backend
 * Represents profiling statistics for a single column
 */
export type Instacart_Partners_Partners_V1_ColumnProfile = {
  __typename?: 'instacart_partners_partners_v1_ColumnProfile';
  cardinality: Maybe<Scalars['BigInt']>;
  max: Maybe<Scalars['Float']>;
  mean: Maybe<Scalars['Float']>;
  /** Numeric statistics (only present for numeric columns) */
  min: Maybe<Scalars['Float']>;
  mode: Maybe<Array<Maybe<Scalars['Float']>>>;
  name: Maybe<Scalars['String']>;
  sampleSize: Maybe<Scalars['BigInt']>;
  /** "numeric", "text", "unknown" */
  type: Maybe<Scalars['String']>;
  uniqueValues: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Enum to represent the configurable type of partner configuration model. */
export enum Instacart_Partners_Partners_V1_ConfigurableType {
  ConfigurableTypeHierarchy = 'CONFIGURABLE_TYPE_HIERARCHY',
  ConfigurableTypeRetailer = 'CONFIGURABLE_TYPE_RETAILER',
  ConfigurableTypeRetailerLocation = 'CONFIGURABLE_TYPE_RETAILER_LOCATION',
  ConfigurableTypeUnknown = 'CONFIGURABLE_TYPE_UNKNOWN',
  ConfigurableTypeZone = 'CONFIGURABLE_TYPE_ZONE'
}

/**
 * Object to represent a configuration setting.
 * The configuration setting could be either a string, boolean or integer
 * While there exists a value_jsonb column in the table, it should not be used for new configurations
 */
export type Instacart_Partners_Partners_V1_ConfigurationSetting = {
  __typename?: 'instacart_partners_partners_v1_ConfigurationSetting';
  /** boolean_setting represents the setting value if the config is a boolean */
  booleanSetting: Maybe<Scalars['Boolean']>;
  /** json_setting represents the setting value if the config is jsonb */
  jsonSetting: Maybe<Scalars['JSON']>;
  /** key_value_settings is deprecated and should not be used */
  keyValueSettings: Maybe<Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap>;
  /**
   * number_setting represents the setting value if the config is an number (integer or float)
   * Note that protobuf will default this to 0.0 if it is not provided
   */
  numberSetting: Maybe<Scalars['Float']>;
  /** string_setting represents the setting value if the config is a string */
  stringSetting: Maybe<Scalars['String']>;
};

/**
 * Object to represent a configuration setting.
 * The configuration setting could be either a string, boolean or integer
 * While there exists a value_jsonb column in the table, it should not be used for new configurations
 */
export type Instacart_Partners_Partners_V1_ConfigurationSetting_Input = {
  /** boolean_setting represents the setting value if the config is a boolean */
  booleanSetting?: InputMaybe<Scalars['Boolean']>;
  /** json_setting represents the setting value if the config is jsonb */
  jsonSetting?: InputMaybe<Scalars['JSON']>;
  /** key_value_settings is deprecated and should not be used */
  keyValueSettings?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap_Input>;
  /**
   * number_setting represents the setting value if the config is an number (integer or float)
   * Note that protobuf will default this to 0.0 if it is not provided
   */
  numberSetting?: InputMaybe<Scalars['Float']>;
  /** string_setting represents the setting value if the config is a string */
  stringSetting?: InputMaybe<Scalars['String']>;
};

/** Object to represent key-value pairs. Should no longer be used. */
export type Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap = {
  __typename?: 'instacart_partners_partners_v1_ConfigurationSetting_SettingsMap';
  settings: Maybe<Scalars['JSON']>;
};

/** Object to represent key-value pairs. Should no longer be used. */
export type Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap_Input = {
  settings?: InputMaybe<Scalars['JSON']>;
};

/** --- CreateFlipNote --- */
export type Instacart_Partners_Partners_V1_CreateFlipNoteRequest_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['BigInt']>;
  productEnrollmentId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for CreateFlipNote: the newly created note. */
export type Instacart_Partners_Partners_V1_CreateFlipNoteResponse = {
  __typename?: 'instacart_partners_partners_v1_CreateFlipNoteResponse';
  note: Maybe<Instacart_Partners_Partners_V1_FlipNote>;
};

/** Input to create a configuration for a given configuration information. */
export type Instacart_Partners_Partners_V1_CreatePartnerConfigurationInput_Input = {
  /** Key used for the hierarchical configuration.  If this is set, the service will assume it is a hierarchical config */
  compositeKey?: InputMaybe<Scalars['String']>;
  /** The ID of the entity to create a configuration for */
  configurableId?: InputMaybe<Scalars['BigInt']>;
  /** The type of configurable entity to create a configuration for */
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The user or system who created the configuration */
  createdBy?: InputMaybe<Scalars['String']>;
  /** The end time of the configuration */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Deprecated - The type of partner configuration to create. Use partner_configuration_type_id instead */
  partnerConfigurationType?: InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>;
  /** The ID of the partner configuration type to create a configuration for */
  partnerConfigurationTypeId?: InputMaybe<Scalars['BigInt']>;
  /** The configuration setting to create */
  setting?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurationSetting_Input>;
  /** The start time of the configuration */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Request to create a new partner configuration type. */
export type Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeRequest_Input = {
  /** The configurable type (e.g. RetailerLocation) that can be assigned the configuration */
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The user or system who created the configuration type */
  createdBy?: InputMaybe<Scalars['String']>;
  /** The data type of the configuration type */
  dataType?: InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeDataType>;
  /** The description of the configuration type */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the configuration type */
  name?: InputMaybe<Scalars['String']>;
};

/** Response to create a new partner configuration type. */
export type Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeResponse = {
  __typename?: 'instacart_partners_partners_v1_CreatePartnerConfigurationTypeResponse';
  /** The configuration type created */
  partnerConfigurationType: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>;
};

/** Maps to Csv::CsvDebug on backend */
export type Instacart_Partners_Partners_V1_CsvDebug = {
  __typename?: 'instacart_partners_partners_v1_CsvDebug';
  columnCount: Maybe<Scalars['BigInt']>;
  /**
   * Maps expected column names to actual CSV headers (e.g., {"email": "Email Address"})
   * Used by FuzzyHeaders mixin and potentially other header mapping strategies
   */
  detectedHeaderMappings: Maybe<Scalars['JSON']>;
  profile: Maybe<Instacart_Partners_Partners_V1_CsvProfile>;
  rowCount: Maybe<Scalars['BigInt']>;
};

/** Maps to Csv::CsvIssue on backend */
export type Instacart_Partners_Partners_V1_CsvIssue = {
  __typename?: 'instacart_partners_partners_v1_CsvIssue';
  code: Maybe<Scalars['String']>;
  column: Maybe<Scalars['BigInt']>;
  message: Maybe<Scalars['String']>;
  row: Maybe<Scalars['BigInt']>;
  severity: Maybe<Instacart_Partners_Partners_V1_CsvIssue_Severity>;
};

export enum Instacart_Partners_Partners_V1_CsvIssue_Severity {
  SeverityError = 'SEVERITY_ERROR',
  SeverityUnknown = 'SEVERITY_UNKNOWN',
  SeverityWarning = 'SEVERITY_WARNING'
}

/**
 * Maps to Csv::CsvProfile on backend
 * Contains metadata about the CSV structure and column-level statistics
 */
export type Instacart_Partners_Partners_V1_CsvProfile = {
  __typename?: 'instacart_partners_partners_v1_CsvProfile';
  columns: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_ColumnProfile>>>;
};

/** Maps to Csv::CsvValidationResult on backend */
export type Instacart_Partners_Partners_V1_CsvValidationResult = {
  __typename?: 'instacart_partners_partners_v1_CsvValidationResult';
  debugInfo: Maybe<Instacart_Partners_Partners_V1_DebugInfo>;
  errors: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_CsvIssue>>>;
  warnings: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_CsvIssue>>>;
};

/** Maps to Csv::DebugInfo on backend */
export type Instacart_Partners_Partners_V1_DebugInfo = {
  __typename?: 'instacart_partners_partners_v1_DebugInfo';
  csvDebug: Maybe<Instacart_Partners_Partners_V1_CsvDebug>;
  custom: Maybe<Scalars['JSON']>;
};

/** --- DeleteFlipNote --- */
export type Instacart_Partners_Partners_V1_DeleteFlipNoteRequest_Input = {
  deletedBy?: InputMaybe<Scalars['String']>;
  noteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for DeleteFlipNote: whether the soft-delete succeeded. */
export type Instacart_Partners_Partners_V1_DeleteFlipNoteResponse = {
  __typename?: 'instacart_partners_partners_v1_DeleteFlipNoteResponse';
  success: Maybe<Scalars['Boolean']>;
};

/** Request to delete an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeRequest_Input = {
  /** The ID of the configuration type to delete */
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response to delete an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeResponse = {
  __typename?: 'instacart_partners_partners_v1_DeletePartnerConfigurationTypeResponse';
  /** Whether the delete was successful */
  success: Maybe<Scalars['Boolean']>;
};

/** Feature column metadata (sent once per feature in response). */
export type Instacart_Partners_Partners_V1_FlipDashboardColumn = {
  __typename?: 'instacart_partners_partners_v1_FlipDashboardColumn';
  displayName: Maybe<Scalars['String']>;
  featureGroupDisplayName: Maybe<Scalars['String']>;
  featureGroupName: Maybe<Scalars['String']>;
  featureId: Maybe<Scalars['BigInt']>;
  name: Maybe<Scalars['String']>;
  sortOrder: Maybe<Scalars['Int']>;
};

/** A single row in the dashboard matrix (one enrollment). */
export type Instacart_Partners_Partners_V1_FlipDashboardRow = {
  __typename?: 'instacart_partners_partners_v1_FlipDashboardRow';
  /** Enrollment info */
  enrollmentId: Maybe<Scalars['BigInt']>;
  enrollmentStatus: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>;
  /** Feature statuses: key = feature name, value = cell data */
  features: Maybe<Scalars['JSON']>;
  partnerId: Maybe<Scalars['BigInt']>;
  partnerName: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
  /** Retailer's current SFX version data (synced from Store Configurations RPC) */
  sfxVersion: Maybe<Instacart_Partners_Partners_V1_FlipSfxVersion>;
  /** Retailer's site identity metadata (synced from Store Configurations RPC) */
  siteInfo: Maybe<Instacart_Partners_Partners_V1_FlipSiteInfo>;
  /** Store configuration ID from the retailer's whitelabel site */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  tierDisplayName: Maybe<Scalars['String']>;
  tierKey: Maybe<Scalars['String']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
};

/** Summary statistics for the dashboard. */
export type Instacart_Partners_Partners_V1_FlipDashboardSummary = {
  __typename?: 'instacart_partners_partners_v1_FlipDashboardSummary';
  enabledCount: Maybe<Scalars['Int']>;
  totalEnrollments: Maybe<Scalars['Int']>;
  totalFeatures: Maybe<Scalars['Int']>;
};

/** Tooltip detail for a dashboard cell (e.g., Carrot Ads rev share breakdown). */
export type Instacart_Partners_Partners_V1_FlipDisplayDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipDisplayDetail';
  entries: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipDisplayDetailEntry>>>;
};

/** A single label:value row in a display detail tooltip. */
export type Instacart_Partners_Partners_V1_FlipDisplayDetailEntry = {
  __typename?: 'instacart_partners_partners_v1_FlipDisplayDetailEntry';
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** How feature items contribute to the overall feature status. */
export enum Instacart_Partners_Partners_V1_FlipEnabledLogic {
  /** ON only if ALL items are ON */
  FlipEnabledLogicAllEnabled = 'FLIP_ENABLED_LOGIC_ALL_ENABLED',
  /** ON if ANY item is ON */
  FlipEnabledLogicAnyEnabled = 'FLIP_ENABLED_LOGIC_ANY_ENABLED',
  FlipEnabledLogicUnknown = 'FLIP_ENABLED_LOGIC_UNKNOWN'
}

/** Status of a feature enablement or feature item enablement. */
export enum Instacart_Partners_Partners_V1_FlipEnablementStatus {
  FlipEnablementStatusDisabled = 'FLIP_ENABLEMENT_STATUS_DISABLED',
  FlipEnablementStatusEnabled = 'FLIP_ENABLEMENT_STATUS_ENABLED',
  FlipEnablementStatusFailed = 'FLIP_ENABLEMENT_STATUS_FAILED',
  FlipEnablementStatusPendingDisable = 'FLIP_ENABLEMENT_STATUS_PENDING_DISABLE',
  FlipEnablementStatusPendingEnable = 'FLIP_ENABLEMENT_STATUS_PENDING_ENABLE',
  FlipEnablementStatusSuspended = 'FLIP_ENABLEMENT_STATUS_SUSPENDED',
  FlipEnablementStatusUnknown = 'FLIP_ENABLEMENT_STATUS_UNKNOWN'
}

/** Enrollment info for the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentDetail';
  id: Maybe<Scalars['BigInt']>;
  partnerId: Maybe<Scalars['BigInt']>;
  partnerName: Maybe<Scalars['String']>;
  productDisplayName: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
  /** Retailer's current SFX version data (synced from Store Configurations RPC) */
  sfxVersion: Maybe<Instacart_Partners_Partners_V1_FlipSfxVersion>;
  /** Retailer's site identity metadata (synced from Store Configurations RPC) */
  siteInfo: Maybe<Instacart_Partners_Partners_V1_FlipSiteInfo>;
  status: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>;
  /** Store configuration ID from the retailer's whitelabel site */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  tierDisplayName: Maybe<Scalars['String']>;
  tierKey: Maybe<Scalars['String']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
};

/** A single feature in the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentFeatureDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentFeatureDetail';
  description: Maybe<Scalars['String']>;
  /** Resolved detail entries for enabled items when a feature defines detail-style display values. */
  displayDetail: Maybe<Instacart_Partners_Partners_V1_FlipDisplayDetail>;
  /** Resolved display labels for enabled items when a feature defines label-style display values. */
  displayItems: Maybe<Array<Maybe<Scalars['String']>>>;
  displayName: Maybe<Scalars['String']>;
  enabledLogic: Maybe<Instacart_Partners_Partners_V1_FlipEnabledLogic>;
  items: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentItemDetail>>>;
  minimumTierDisplayName: Maybe<Scalars['String']>;
  minimumTierKey: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  showItems: Maybe<Scalars['Boolean']>;
  status: Maybe<Instacart_Partners_Partners_V1_FlipEnablementStatus>;
};

/** A group of features for the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentFeatureGroup = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentFeatureGroup';
  collapsedByDefault: Maybe<Scalars['Boolean']>;
  displayName: Maybe<Scalars['String']>;
  features: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentFeatureDetail>>>;
  icon: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** A single feature item in the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentItemDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentItemDetail';
  attributeName: Maybe<Scalars['String']>;
  /** Included when show_value is true */
  currentValue: Maybe<Scalars['String']>;
  expectedValue: Maybe<Scalars['String']>;
  /** item display name */
  name: Maybe<Scalars['String']>;
  status: Maybe<Instacart_Partners_Partners_V1_FlipEnablementStatus>;
  valueLogic: Maybe<Instacart_Partners_Partners_V1_FlipValueLogic>;
};

/** A single enrollment with site metadata (no feature matrix). */
export type Instacart_Partners_Partners_V1_FlipEnrollmentRow = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentRow';
  /** When the enrollment was created */
  createdAt: Maybe<Scalars['DateTime']>;
  enrollmentId: Maybe<Scalars['BigInt']>;
  enrollmentStatus: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>;
  /** When the enrollment was activated */
  onboardedAt: Maybe<Scalars['DateTime']>;
  partnerId: Maybe<Scalars['BigInt']>;
  partnerName: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
  /** Retailer's current SFX version data (synced from Store Configurations RPC) */
  sfxVersion: Maybe<Instacart_Partners_Partners_V1_FlipSfxVersion>;
  /** Retailer's site identity metadata (synced from Store Configurations RPC) */
  siteInfo: Maybe<Instacart_Partners_Partners_V1_FlipSiteInfo>;
  /** Store configuration ID from the retailer's whitelabel site */
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  tierDisplayName: Maybe<Scalars['String']>;
  tierKey: Maybe<Scalars['String']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
};

/** Status of a product enrollment. */
export enum Instacart_Partners_Partners_V1_FlipEnrollmentStatus {
  FlipEnrollmentStatusActive = 'FLIP_ENROLLMENT_STATUS_ACTIVE',
  FlipEnrollmentStatusChurned = 'FLIP_ENROLLMENT_STATUS_CHURNED',
  FlipEnrollmentStatusOnboarding = 'FLIP_ENROLLMENT_STATUS_ONBOARDING',
  FlipEnrollmentStatusPaused = 'FLIP_ENROLLMENT_STATUS_PAUSED',
  FlipEnrollmentStatusUnknown = 'FLIP_ENROLLMENT_STATUS_UNKNOWN'
}

/** A product capability (e.g., IC+, Loyalty, $0 Delivery Fee). */
export type Instacart_Partners_Partners_V1_FlipFeature = {
  __typename?: 'instacart_partners_partners_v1_FlipFeature';
  description: Maybe<Scalars['String']>;
  displayConfig: Maybe<Scalars['JSON']>;
  displayName: Maybe<Scalars['String']>;
  enabledLogic: Maybe<Instacart_Partners_Partners_V1_FlipEnabledLogic>;
  featureGroupId: Maybe<Scalars['BigInt']>;
  featureGroupName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  /**
   * Optionally included
   * Minimum SFX version required for this feature (e.g., "R2024_11_0").
   * Nil means available on all SFX versions.
   */
  items: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipFeatureItem>>>;
  /** snake_case identifier */
  name: Maybe<Scalars['String']>;
  releaseVersion: Maybe<Scalars['String']>;
  sortOrder: Maybe<Scalars['Int']>;
  status: Maybe<Instacart_Partners_Partners_V1_FlipFeatureStatus>;
};

/** A logical grouping of features for dashboard organization. */
export type Instacart_Partners_Partners_V1_FlipFeatureGroup = {
  __typename?: 'instacart_partners_partners_v1_FlipFeatureGroup';
  collapsedByDefault: Maybe<Scalars['Boolean']>;
  displayName: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  /** snake_case identifier */
  name: Maybe<Scalars['String']>;
  sortOrder: Maybe<Scalars['Int']>;
};

/** Links a feature to an OnboardingAttribute with evaluation logic. */
export type Instacart_Partners_Partners_V1_FlipFeatureItem = {
  __typename?: 'instacart_partners_partners_v1_FlipFeatureItem';
  /** OnboardingAttribute.attribute_name */
  attributeName: Maybe<Scalars['String']>;
  expectedValue: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  itemName: Maybe<Scalars['String']>;
  /** Stable snake_case identifier for programmatic use (e.g., "icplus_gift_cards", "loyalty_provider"). */
  name: Maybe<Scalars['String']>;
  showValue: Maybe<Scalars['Boolean']>;
  sortOrder: Maybe<Scalars['Int']>;
  valueLogic: Maybe<Instacart_Partners_Partners_V1_FlipValueLogic>;
};

/** Status of a feature in the catalog. */
export enum Instacart_Partners_Partners_V1_FlipFeatureStatus {
  FlipFeatureStatusDeprecated = 'FLIP_FEATURE_STATUS_DEPRECATED',
  FlipFeatureStatusDraft = 'FLIP_FEATURE_STATUS_DRAFT',
  FlipFeatureStatusReleased = 'FLIP_FEATURE_STATUS_RELEASED',
  FlipFeatureStatusUnknown = 'FLIP_FEATURE_STATUS_UNKNOWN'
}

/** A user-created text annotation on a site × feature intersection. */
export type Instacart_Partners_Partners_V1_FlipNote = {
  __typename?: 'instacart_partners_partners_v1_FlipNote';
  body: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdBy: Maybe<Scalars['String']>;
  /** When the note was soft-deleted (not set for active notes). */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Reason the note was deleted. */
  deletionReason: Maybe<Instacart_Partners_Partners_V1_FlipNoteDeletionReason>;
  featureId: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  /** Whether this note has been soft-deleted. */
  isDeleted: Maybe<Scalars['Boolean']>;
  /** Whether this note has been edited (has revisions or is itself a revision). */
  isEdited: Maybe<Scalars['Boolean']>;
  metadata: Maybe<Scalars['JSON']>;
  productEnrollmentId: Maybe<Scalars['BigInt']>;
  /** ID of the original root note (0 for root notes, non-zero for revisions). */
  rootNoteId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  updatedBy: Maybe<Scalars['String']>;
};

/** Reason a note was soft-deleted. */
export enum Instacart_Partners_Partners_V1_FlipNoteDeletionReason {
  FlipNoteDeletionReasonUnknown = 'FLIP_NOTE_DELETION_REASON_UNKNOWN',
  FlipNoteDeletionReasonUserDeleted = 'FLIP_NOTE_DELETION_REASON_USER_DELETED',
  FlipNoteDeletionReasonVersioned = 'FLIP_NOTE_DELETION_REASON_VERSIONED'
}

/**
 * SFX release version data for a retailer's enrollment.
 * Synced from Store Configurations RPC by SyncVersionService.
 */
export type Instacart_Partners_Partners_V1_FlipSfxVersion = {
  __typename?: 'instacart_partners_partners_v1_FlipSfxVersion';
  /** Current SFX release version (e.g., "2024.40"). Nil for fastlane retailers. */
  current: Maybe<Scalars['String']>;
  /** Whether the retailer has delayed release enabled. */
  delayedRelease: Maybe<Scalars['Boolean']>;
  /** "fastlane" (latest version) or "slowlane" (pinned/delayed release). */
  track: Maybe<Scalars['String']>;
  /** When the version data was last synced (ISO 8601). */
  updatedAt: Maybe<Scalars['String']>;
};

/**
 * Site identity metadata for a retailer's enrollment.
 * Synced from Store Configurations RPC (settings + branding domains) by SyncVersionService.
 */
export type Instacart_Partners_Partners_V1_FlipSiteInfo = {
  __typename?: 'instacart_partners_partners_v1_FlipSiteInfo';
  /** The retailer's branded display name (e.g., "ALDI"). */
  brandedName: Maybe<Scalars['String']>;
  /** The retailer's storefront domain (e.g., "shop.aldi.us"). */
  domainName: Maybe<Scalars['String']>;
  /** URL of the retailer's default logo (light variant). */
  logoUrl: Maybe<Scalars['String']>;
  /** When the site info was last synced (ISO 8601). */
  updatedAt: Maybe<Scalars['String']>;
};

/** Value logic for evaluating a feature item. */
export enum Instacart_Partners_Partners_V1_FlipValueLogic {
  FlipValueLogicEquals = 'FLIP_VALUE_LOGIC_EQUALS',
  FlipValueLogicFalsy = 'FLIP_VALUE_LOGIC_FALSY',
  FlipValueLogicNotEquals = 'FLIP_VALUE_LOGIC_NOT_EQUALS',
  FlipValueLogicPresent = 'FLIP_VALUE_LOGIC_PRESENT',
  FlipValueLogicTruthy = 'FLIP_VALUE_LOGIC_TRUTHY',
  FlipValueLogicUnknown = 'FLIP_VALUE_LOGIC_UNKNOWN'
}

/** GetCsvValidationResult rpc request */
export type Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_Input = {
  /** unique identifier for the validation result */
  id?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** response type */
  responseType?: InputMaybe<Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_ResponseType>;
};

export enum Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_ResponseType {
  ResponseTypePresignedUrl = 'RESPONSE_TYPE_PRESIGNED_URL',
  ResponseTypeResult = 'RESPONSE_TYPE_RESULT',
  ResponseTypeUnknown = 'RESPONSE_TYPE_UNKNOWN'
}

/** GetCsvValidationResult rpc response */
export type Instacart_Partners_Partners_V1_GetCsvValidationResultResponse = {
  __typename?: 'instacart_partners_partners_v1_GetCsvValidationResultResponse';
  presignedUrl: Maybe<Scalars['String']>;
  result: Maybe<Instacart_Partners_Partners_V1_CsvValidationResult>;
};

/** Request for GetFlipDashboard: paginated enrollments with feature statuses for a product. */
export type Instacart_Partners_Partners_V1_GetFlipDashboardRequest_Input = {
  /** Date range filter */
  enabledSince?: InputMaybe<Scalars['DateTime']>;
  enabledUntil?: InputMaybe<Scalars['DateTime']>;
  enablementStatusFilter?: InputMaybe<Instacart_Partners_Partners_V1_FlipEnablementStatus>;
  /**
   * Filter status evaluation to specific configurations (feature items).
   * When populated, enablement_status_filter applies at the FeatureItemEnablement
   * level for items matching these names, instead of at the FeatureEnablement level.
   * Values correspond to FlipFeatureItem.name (e.g., "icplus_gift_cards", "loyalty_provider").
   */
  featureItemNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter columns to specific features */
  featureNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Pagination (uses common.proto) */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** Filter enrollments to specific partners */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Required: which product to show the dashboard for */
  productName?: InputMaybe<Scalars['String']>;
  /** Filters */
  search?: InputMaybe<Scalars['String']>;
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
  /** Filter enrollments to specific whitelabel sites */
  whitelabelSiteIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for GetFlipDashboard: rows, columns, summary, and pagination metadata. */
export type Instacart_Partners_Partners_V1_GetFlipDashboardResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipDashboardResponse';
  /** Columns: feature metadata for column headers (sent once, not per row) */
  columns: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipDashboardColumn>>>;
  /** Pagination metadata */
  paginationInstruction: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  /** Rows: one per product enrollment */
  rows: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipDashboardRow>>>;
  /** Summary metrics */
  summary: Maybe<Instacart_Partners_Partners_V1_FlipDashboardSummary>;
};

/** Request for GetFlipEnrollmentDetail: fetch a single enrollment's feature matrix. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailRequest_Input = {
  productEnrollmentId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for GetFlipEnrollmentDetail: enrollment info with grouped features and items. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipEnrollmentDetailResponse';
  enrollment: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentDetail>;
  featureGroups: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentFeatureGroup>>>;
};

/** Request for GetFlipEnrollments: paginated enrollments with site metadata. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentsRequest_Input = {
  /** Pagination (uses common.proto) */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** Filter to specific partners */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: filter by product name (e.g., "whitelabel") */
  productName?: InputMaybe<Scalars['String']>;
  /** Filters */
  search?: InputMaybe<Scalars['String']>;
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
  /** Filter by enrollment status (multiple allowed) */
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>>>;
  /** Filter to specific whitelabel sites */
  whitelabelSiteIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for GetFlipEnrollments: enrollment rows with pagination metadata. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipEnrollmentsResponse';
  enrollments: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentRow>>>;
  paginationInstruction: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
};

/** Response for GetFlipFeatureGroups: list of feature groups ordered by sort_order. */
export type Instacart_Partners_Partners_V1_GetFlipFeatureGroupsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipFeatureGroupsResponse';
  featureGroups: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipFeatureGroup>>>;
};

/** Request for GetFlipFeatures: optional filters for the feature catalog. */
export type Instacart_Partners_Partners_V1_GetFlipFeaturesRequest_Input = {
  /** Optional: filter by feature group name */
  featureGroupName?: InputMaybe<Scalars['String']>;
  /** Optional: include draft features (default: false, only released) */
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  /** Optional: filter by product name (only features available for this product) */
  productName?: InputMaybe<Scalars['String']>;
};

/** Response for GetFlipFeatures: list of features with items and metadata. */
export type Instacart_Partners_Partners_V1_GetFlipFeaturesResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipFeaturesResponse';
  features: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipFeature>>>;
};

/** --- GetFlipNoteHistory --- */
export type Instacart_Partners_Partners_V1_GetFlipNoteHistoryRequest_Input = {
  /** Any note ID (root or revision). The response contains the full version chain. */
  noteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for GetFlipNoteHistory: all versions of a note ordered by created_at ASC. */
export type Instacart_Partners_Partners_V1_GetFlipNoteHistoryResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipNoteHistoryResponse';
  notes: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipNote>>>;
};

/** Request to get paginated partner configuration types. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedRequest_Input = {
  /** The type of configurables to filter by */
  configurableTypes?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>>>;
  /** Information on how to paginate the results of the request. */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** Information on how to sort the results (list of attribute and direction) */
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
};

/** Response to get paginated partner configuration types. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedResponse = {
  __typename?: 'instacart_partners_partners_v1_GetPartnerConfigurationTypesPaginatedResponse';
  /** How many total configuration types match the criteria */
  count: Maybe<Scalars['BigInt']>;
  /** How the results are paginated */
  paginationInstruction: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  partnerConfigurationTypes: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>>>;
};

/** Used to filter by multiple configurable types at once */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_ConfigurableTypeIdsMap_Input = {
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Request to get paginated configurations. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_Input = {
  /** Fetches only hierarchical configs that are childern of the given prefix */
  compositeKeyPrefix?: InputMaybe<Scalars['String']>;
  /** Fetches only hierarchical configs with one of these composite keys */
  compositeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The IDs of the entities to get configurations for, optional */
  configurableIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Used to filter by multiple configurable types at once. Cannot be provided together with configurable_types */
  configurableTypeIdsMap?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_ConfigurableTypeIdsMap_Input>>>;
  /**
   * The types of configurable entities to get configurations for, optional.
   * Only supports one configurable_type at a time.
   * If multiple configurable_types are provided, the request will fail.
   * Cannot be provided together with configurable_type_ids_map.
   */
  configurableTypes?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>>>;
  /** This will filter for configurations that start before the end_time */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Filters out auto generated configurations */
  excludeAutoGeneratedConfigs?: InputMaybe<Scalars['Boolean']>;
  /** Fetches only hierarchical configs with value_jsonb not matching given value */
  excludeJson?: InputMaybe<Scalars['JSON']>;
  /** The IDs of the partner configurations to fetch, optional */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Fetches only hierarchical configs with value_jsonb matching given value */
  includeJson?: InputMaybe<Scalars['JSON']>;
  /** Whether to include the partner configuration type association object in the response */
  includePartnerConfigurationTypeData?: InputMaybe<Scalars['Boolean']>;
  /** Information on how to paginate the results of a list/filter operation */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** The types of partner configurations to get, optional */
  partnerConfigurationTypes?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>>>;
  /** Information on how to sort the results (attribute and direction) */
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
  /** This will filter for configurations that end after the start_time */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** Fetches only configs where value_jsonb contains all the specified key-value pairs (JSONB @> containment) */
  valueJsonbContains?: InputMaybe<Scalars['JSON']>;
};

/** Response to get paginated partner configurations for given configurable information. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedResponse = {
  __typename?: 'instacart_partners_partners_v1_GetPartnerConfigurationsPaginatedResponse';
  /** How many total configurations are returned */
  count: Maybe<Scalars['BigInt']>;
  /** How the results are paginated */
  paginationInstruction: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  /** Data found for the request */
  partnerConfigurations: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/** Request to get configurations for a given configurable type with a list of configurable ids. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsRequest_Input = {
  /** The IDs of the configurable entities to get configurations for */
  configurableIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** The type of configurable entity to get configurations for */
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** This will filter for configurations that start before the end_time */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Whether to include the partner configuration type association object in the response */
  includePartnerConfigurationTypeData?: InputMaybe<Scalars['Boolean']>;
  /** The type of partner configuration to get */
  partnerConfigurationType?: InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>;
  /** This will filter for configurations that end after the start_time */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Response to get partner configurations for given configurable information. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetPartnerConfigurationsResponse';
  /** The configurations found for the request */
  partnerConfigurations: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/** Request message for GetWhitelabelApp (single app by ID) */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppRequest_Input = {
  whitelabelAppId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for GetWhitelabelApp (single app by ID) */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppResponse = {
  __typename?: 'instacart_partners_partners_v1_GetWhitelabelAppResponse';
  whitelabelApp: Maybe<Instacart_Partners_Partners_V1_WhitelabelApp>;
};

/** Request message for GetWhitelabelApps */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppsRequest_Input = {
  betaReleaseStatus?: InputMaybe<Scalars['String']>;
  buildsEnabled?: InputMaybe<Scalars['Boolean']>;
  inProgressStatus?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  platform?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for GetWhitelabelApps */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetWhitelabelAppsResponse';
  pagination: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  whitelabelApps: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_WhitelabelApp>>>;
};

/** --- ListFlipNotes --- */
export type Instacart_Partners_Partners_V1_ListFlipNotesRequest_Input = {
  featureId?: InputMaybe<Scalars['BigInt']>;
  /** When true, includes user-deleted notes alongside active notes. */
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  productEnrollmentId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for ListFlipNotes: paginated notes for the requested site × feature intersection. */
export type Instacart_Partners_Partners_V1_ListFlipNotesResponse = {
  __typename?: 'instacart_partners_partners_v1_ListFlipNotesResponse';
  notes: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipNote>>>;
  paginationInstruction: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
};

/** Generic object to represent pagination details */
export type Instacart_Partners_Partners_V1_PaginationDetails = {
  __typename?: 'instacart_partners_partners_v1_PaginationDetails';
  page: Maybe<Scalars['BigInt']>;
  perPage: Maybe<Scalars['BigInt']>;
  totalCount: Maybe<Scalars['BigInt']>;
  totalPages: Maybe<Scalars['BigInt']>;
};

/** Generic object to represent pagination details */
export type Instacart_Partners_Partners_V1_PaginationDetails_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  perPage?: InputMaybe<Scalars['BigInt']>;
  totalCount?: InputMaybe<Scalars['BigInt']>;
  totalPages?: InputMaybe<Scalars['BigInt']>;
};

/** Object to represent a partner configuration. */
export type Instacart_Partners_Partners_V1_PartnerConfiguration = {
  __typename?: 'instacart_partners_partners_v1_PartnerConfiguration';
  /** Key used to query a node in the hierarchical config */
  compositeKey: Maybe<Scalars['String']>;
  /** The ID of the configuration */
  configurableId: Maybe<Scalars['BigInt']>;
  /** The type of configurable entity */
  configurableType: Maybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The user or system who created the configuration */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The user or system who created the configuration */
  createdBy: Maybe<Scalars['String']>;
  /** The end time of the configuration */
  endTime: Maybe<Scalars['DateTime']>;
  /** The ID of the configuration */
  id: Maybe<Scalars['BigInt']>;
  /** The type of partner configuration */
  partnerConfigurationType: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>;
  /** The associated partner configuration type record; requires request to specify whether to include it or not via include_partner_configuration_type_data field */
  partnerConfigurationTypeData: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>;
  /** The configuration setting */
  setting: Maybe<Instacart_Partners_Partners_V1_ConfigurationSetting>;
  /** The start time of the configuration */
  startTime: Maybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration */
  updatedBy: Maybe<Scalars['String']>;
};

/** Enum to represent the type of partner configuration. */
export enum Instacart_Partners_Partners_V1_PartnerConfigurationType {
  PartnerConfigurationTypeBatching = 'PARTNER_CONFIGURATION_TYPE_BATCHING',
  PartnerConfigurationTypeCxOrderPolicies = 'PARTNER_CONFIGURATION_TYPE_CX_ORDER_POLICIES',
  PartnerConfigurationTypeFulfillmentHierarchy = 'PARTNER_CONFIGURATION_TYPE_FULFILLMENT_HIERARCHY',
  PartnerConfigurationTypeIsSaverStore = 'PARTNER_CONFIGURATION_TYPE_IS_SAVER_STORE',
  PartnerConfigurationTypeServiceOptionAvailability = 'PARTNER_CONFIGURATION_TYPE_SERVICE_OPTION_AVAILABILITY',
  PartnerConfigurationTypeUnknown = 'PARTNER_CONFIGURATION_TYPE_UNKNOWN'
}

/** Object to represent a partner configuration type. */
export type Instacart_Partners_Partners_V1_PartnerConfigurationTypeData = {
  __typename?: 'instacart_partners_partners_v1_PartnerConfigurationTypeData';
  /** The configurable type (e.g. RetailerLocation) that can be assigned the configuration */
  configurableType: Maybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The date the configuration type was created */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The user or system who created the configuration type */
  createdBy: Maybe<Scalars['String']>;
  /** The data type of the configuration type */
  dataType: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeDataType>;
  /** The description of the configuration type */
  description: Maybe<Scalars['String']>;
  /** The ID of the configuration type */
  id: Maybe<Scalars['BigInt']>;
  /** The name of the configuration type */
  name: Maybe<Scalars['String']>;
  /** The date the configuration type was updated */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration type */
  updatedBy: Maybe<Scalars['String']>;
};

/** Enum to represent the data type of partner configuration type. */
export enum Instacart_Partners_Partners_V1_PartnerConfigurationTypeDataType {
  PartnerConfigurationTypeDataTypeBoolean = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_BOOLEAN',
  PartnerConfigurationTypeDataTypeJsonb = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_JSONB',
  PartnerConfigurationTypeDataTypeNumber = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_NUMBER',
  PartnerConfigurationTypeDataTypeString = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_STRING',
  PartnerConfigurationTypeDataTypeUnknown = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_UNKNOWN'
}

/** Request message for Releasing an WhitelabelApp to Production. */
export type Instacart_Partners_Partners_V1_ReleaseAppToProductionRequest_Input = {
  versionNumber?: InputMaybe<Scalars['String']>;
  whitelabelAppId?: InputMaybe<Scalars['String']>;
};

/** Response message for Releasing a WhitelabelApp */
export type Instacart_Partners_Partners_V1_ReleaseAppToProductionResponse = {
  __typename?: 'instacart_partners_partners_v1_ReleaseAppToProductionResponse';
  success: Maybe<Scalars['Boolean']>;
};

/** Generic object to represent sorting details */
export type Instacart_Partners_Partners_V1_SortingDetails_Input = {
  /** The direction to sort, defaults to ascending */
  direction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDirection>;
  /** The name of the field to sort on, e.g. starts_at */
  fieldName?: InputMaybe<Scalars['String']>;
};

/** Sorting direction enum */
export enum Instacart_Partners_Partners_V1_SortingDirection {
  SortingDirectionAsc = 'SORTING_DIRECTION_ASC',
  SortingDirectionDesc = 'SORTING_DIRECTION_DESC',
  SortingDirectionUnknown = 'SORTING_DIRECTION_UNKNOWN'
}

/** --- UpdateFlipNote --- */
export type Instacart_Partners_Partners_V1_UpdateFlipNoteRequest_Input = {
  body?: InputMaybe<Scalars['String']>;
  noteId?: InputMaybe<Scalars['BigInt']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Response for UpdateFlipNote: the updated note. */
export type Instacart_Partners_Partners_V1_UpdateFlipNoteResponse = {
  __typename?: 'instacart_partners_partners_v1_UpdateFlipNoteResponse';
  note: Maybe<Instacart_Partners_Partners_V1_FlipNote>;
};

/** Input to update a configuration for a given configuration information. */
export type Instacart_Partners_Partners_V1_UpdatePartnerConfigurationInput_Input = {
  /** The end time of the configuration */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the configuration to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The configuration setting to update */
  setting?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurationSetting_Input>;
  /** The start time of the configuration */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Request to update an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeRequest_Input = {
  /** The description of the configuration type */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the configuration type to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The user or system who updated the configuration type */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Response to update an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeResponse = {
  __typename?: 'instacart_partners_partners_v1_UpdatePartnerConfigurationTypeResponse';
  /** The configuration type updated */
  partnerConfigurationType: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>;
};

/** Request message for updating a WhitelabelApp */
export type Instacart_Partners_Partners_V1_UpdateWhitelabelAppRequest_Input = {
  accountId?: InputMaybe<Scalars['String']>;
  appId?: InputMaybe<Scalars['String']>;
  appStoreId?: InputMaybe<Scalars['String']>;
  betaReleaseDate?: InputMaybe<Scalars['DateTime']>;
  betaReleaseStatus?: InputMaybe<Scalars['String']>;
  betaReleaseVersion?: InputMaybe<Scalars['String']>;
  buildsEnabled?: InputMaybe<Scalars['Boolean']>;
  currentReleaseDate?: InputMaybe<Scalars['DateTime']>;
  currentReleaseVersion?: InputMaybe<Scalars['String']>;
  inProgressDate?: InputMaybe<Scalars['DateTime']>;
  inProgressStatus?: InputMaybe<Scalars['String']>;
  inProgressVersion?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  scheme?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  updatedByUserUuid?: InputMaybe<Scalars['String']>;
  whitelabelAppId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for updating a WhitelabelApp */
export type Instacart_Partners_Partners_V1_UpdateWhitelabelAppResponse = {
  __typename?: 'instacart_partners_partners_v1_UpdateWhitelabelAppResponse';
  whitelabelApp: Maybe<Instacart_Partners_Partners_V1_WhitelabelApp>;
};

/** Object to represent a WhitelabelApp */
export type Instacart_Partners_Partners_V1_WhitelabelApp = {
  __typename?: 'instacart_partners_partners_v1_WhitelabelApp';
  accountId: Maybe<Scalars['String']>;
  accountName: Maybe<Scalars['String']>;
  appId: Maybe<Scalars['String']>;
  appStoreId: Maybe<Scalars['String']>;
  betaReleaseDate: Maybe<Scalars['DateTime']>;
  betaReleaseStatus: Maybe<Scalars['String']>;
  betaReleaseVersion: Maybe<Scalars['String']>;
  buildsEnabled: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  createdByUserUuid: Maybe<Scalars['String']>;
  currentReleaseDate: Maybe<Scalars['DateTime']>;
  currentReleaseVersion: Maybe<Scalars['String']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['BigInt']>;
  inProgressDate: Maybe<Scalars['DateTime']>;
  inProgressStatus: Maybe<Scalars['String']>;
  inProgressVersion: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  platform: Maybe<Scalars['String']>;
  scheme: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  updatedByUserUuid: Maybe<Scalars['String']>;
  whitelabelSiteId: Maybe<Scalars['BigInt']>;
};

/** CheckHealthRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_CheckHealthRequest_Input = {
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** GetAutomationsResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetAutomationsResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetAutomationsResponse';
  /** GetAutomationsResponse */
  automations: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetConnectionsResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetConnectionsResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetConnectionsResponse';
  connections: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetStoresResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetStoresResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetStoresResponse';
  stores: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetSyncStrategiesResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetSyncStrategiesResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetSyncStrategiesResponse';
  syncStrategies: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** PutAutomationRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationRequest_Input = {
  automation?: InputMaybe<Scalars['JSON']>;
};

/** PutAutomationResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutAutomationResponse';
  /** PutAutomationResponse */
  automation: Maybe<Scalars['JSON']>;
};

/** PutConnectionRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionRequest_Input = {
  connection?: InputMaybe<Scalars['JSON']>;
};

/** PutConnectionResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutConnectionResponse';
  /** PutConnectionResponse */
  connection: Maybe<Scalars['JSON']>;
};

/** PutStoreRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreRequest_Input = {
  /** PutStoreRequest */
  store?: InputMaybe<Scalars['JSON']>;
};

/** PutStoreResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutStoreResponse';
  /** PutStoreResponse */
  store: Maybe<Scalars['JSON']>;
};

/** PutSyncStrategyRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyRequest_Input = {
  syncStrategy?: InputMaybe<Scalars['JSON']>;
};

/** PutSyncStrategyResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutSyncStrategyResponse';
  /** PutSyncStrategyResponse */
  syncStrategy: Maybe<Scalars['JSON']>;
};

export type Instacart_Retailer_Tools_Growth_Targeting_V1_GetTargetingFeaturesRequest_Input = {
  isWholesaler?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesRequest_Input>;
  sfxVersion?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** PRIMITIVES */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Entitlement = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_Entitlement';
  createdAt: Maybe<Scalars['DateTime']>;
  /** which environment was this entitlement from */
  fromEnv: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment>;
  /** true if the entitlement is integrated into IPP and that entitlement changes are expected to near immediately change the Retailer UX on IPP, false otherwise. */
  hasIppIntegration: Maybe<Scalars['Boolean']>;
  /** the main identifier for this entitlement */
  id: Maybe<Scalars['String']>;
  /** more human readable name / display string */
  name: Maybe<Scalars['String']>;
  /** the slack handle to contact for the team/individual that owns the entitlement */
  ownerSlackHandle: Maybe<Scalars['String']>;
  /** true if the entitlement requires some form of manual effort in order to unlock the feature gated, false otherise. */
  requiresManualMigration: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_EntitlementShallowDetails';
  entitlement: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Entitlement>;
  /** how many packages use this entitlement */
  numReferencingPackages: Maybe<Scalars['Int']>;
  /** how many retailers reference this entitlement */
  numReferencingRetailerAdditionalEntitlements: Maybe<Scalars['Int']>;
};

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementsSearchByType {
  EntitlementIdOrName = 'ENTITLEMENT_ID_OR_NAME',
  EnumEntitlementUsagesSearchTypeUnspecified = 'ENUM_ENTITLEMENT_USAGES_SEARCH_TYPE_UNSPECIFIED'
}

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment {
  DevelopmentEnvironment = 'DEVELOPMENT_ENVIRONMENT',
  ProductionEnvironment = 'PRODUCTION_ENVIRONMENT',
  StagingEnvironment = 'STAGING_ENVIRONMENT',
  UnspecifiedEnvironment = 'UNSPECIFIED_ENVIRONMENT'
}

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsRequest_Input = {
  byEntitlementId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetEntitlementDetailsResponse';
  entitlement: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Entitlement>;
  packages: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails>>>;
  retailerEntitlementProfiles: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails>>>;
};

/** ENTITLEMENTS API */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsRequest_Input = {
  searchBy?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementsSearchByType>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetEntitlementsResponse';
  entitlements: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails>>>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsRequest_Input = {
  byPackageId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetPackageDetailsResponse';
  entitlements: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails>>>;
  package: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Package>;
  retailerEntitlementProfiles: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails>>>;
};

/** PACKAGES API */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesRequest_Input = {
  searchBy?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackagesSearchByType>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetPackagesResponse';
  packages: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails>>>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsRequest_Input = {
  byRetailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetRetailerEntitlementProfileDetailsResponse';
  additionalEntitlements: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails>>>;
  packages: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails>>>;
  retailerEntitlementProfile: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfile>;
};

/** RETAILER ENTITLEMENT PROFILES API */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesRequest_Input = {
  searchBy?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfilesSearchByType>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetRetailerEntitlementProfilesResponse';
  retailerEntitlementProfiles: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails>>>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Package = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_Package';
  createdAt: Maybe<Scalars['DateTime']>;
  /** a list of the entitlement IDs that are included in this package */
  entitlementIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** which environment was this package from */
  fromEnv: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment>;
  /** the main identifier for this package */
  id: Maybe<Scalars['String']>;
  /** more human readable name / display string */
  name: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_PackageShallowDetails';
  /** how many entitlements are in this package */
  numEntitlements: Maybe<Scalars['Int']>;
  /** how many retailers reference this package */
  numReferencingRetailerEntitlementProfiles: Maybe<Scalars['Int']>;
  package: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Package>;
};

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackagesSearchByType {
  EnumPackagesSearchTypeUnspecified = 'ENUM_PACKAGES_SEARCH_TYPE_UNSPECIFIED',
  PackageIdOrName = 'PACKAGE_ID_OR_NAME'
}

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfile = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_RetailerEntitlementProfile';
  /** the list of a la carte entitlements given to this retailer profile */
  additionalEntitlementIds: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  /** the denormalized list of IDs this retailer is entitled to. this destructures the packages referenced entitlements. */
  denormalizedEntitlementIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** which environment was this retailer profile from */
  fromEnv: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment>;
  /** the list of packages applied to this retailer profile */
  packageIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the canonical warehouse model */
  warehouseId: Maybe<Scalars['BigInt']>;
  /** the canonical warehouse model */
  warehouseName: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_RetailerEntitlementProfileShallowDetails';
  /** how many custom additional entitlements are used by this retailer (not included via packages) */
  numAdditionalEntitlements: Maybe<Scalars['Int']>;
  /** how many packages are used by this retailer */
  numPackages: Maybe<Scalars['Int']>;
  retailerEntitlementProfile: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfile>;
};

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfilesSearchByType {
  EnumRetailerEntitlementProfilesSearchTypeUnspecified = 'ENUM_RETAILER_ENTITLEMENT_PROFILES_SEARCH_TYPE_UNSPECIFIED',
  RetalerId = 'RETALER_ID'
}

/**
 * Defines partners, retailers, and retailer locations that the current user is
 * authorized to access
 */
export type Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCreateCustomExportResponse';
  customExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filterSelectionOptionsList?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions_Input>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCreateCustomReportResponse';
  customReport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
  success: Maybe<Scalars['Boolean']>;
};

/** CSV Exports */
export type Instacart_Retailer_Tools_V2_InsightsPortalCustomExport = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCustomExport';
  createdAt: Maybe<Scalars['DateTime']>;
  dashboardSlug: Maybe<Scalars['String']>;
  dimensions: Maybe<Array<Maybe<Scalars['String']>>>;
  downloadUrl: Maybe<Scalars['String']>;
  filters: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection>>>;
  generationState: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport_GenerationState>;
  id: Maybe<Scalars['BigInt']>;
  metrics: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  orderBys: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy>>>;
  schema: Maybe<Scalars['String']>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalCustomExport_GenerationState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Custom Reports */
export type Instacart_Retailer_Tools_V2_InsightsPortalCustomReport = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCustomReport';
  createdAt: Maybe<Scalars['DateTime']>;
  dashboardSlug: Maybe<Scalars['String']>;
  dimensions: Maybe<Array<Maybe<Scalars['String']>>>;
  filterSelectionOptionsList: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions>>>;
  filters: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection>>>;
  id: Maybe<Scalars['BigInt']>;
  metrics: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  orderBys: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy>>>;
  schema: Maybe<Scalars['String']>;
};

/** Controls which data source the query is executed on */
export enum Instacart_Retailer_Tools_V2_InsightsPortalDataSource {
  Clickhouse = 'CLICKHOUSE',
  Default = 'DEFAULT',
  Snowflake = 'SNOWFLAKE'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalDeleteCustomExportResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalDownloadCustomExportResponse';
  customExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>;
  downloadUrl: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dataSource?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDataSource>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  owner?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOwner>;
  queryTags?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalQueryTag_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
  whitelistFilterOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterOptionsResponse';
  filterOptions: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOptions>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOption = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterOptionsResponse_FilterOption';
  displayValue: Maybe<Scalars['String']>;
  idValue: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOptions = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterOptionsResponse_FilterOptions';
  name: Maybe<Scalars['String']>;
  options: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOption>>>;
};

/** Defines selected values for a filter to be applied to schema metrics. */
export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelection';
  dateFilter: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter>;
  dimFilter: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter>;
  name: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelectionOption';
  label: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption_Input = {
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelectionOptions';
  dimension: Maybe<Scalars['String']>;
  options: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions_Input = {
  dimension?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption_Input>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelection_DateFilter';
  comparisonEnd: Maybe<Scalars['DateTime']>;
  comparisonPeriod: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_ComparisonPeriod>;
  comparisonStart: Maybe<Scalars['DateTime']>;
  dateRange: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_DateRange>;
  end: Maybe<Scalars['DateTime']>;
  start: Maybe<Scalars['DateTime']>;
  weekStartDay: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Weekday>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_ComparisonPeriod {
  LastPeriod = 'LAST_PERIOD',
  LastPeriodDayOfWeekMatch = 'LAST_PERIOD_DAY_OF_WEEK_MATCH',
  LastYear = 'LAST_YEAR',
  LastYearDayOfWeekMatch = 'LAST_YEAR_DAY_OF_WEEK_MATCH',
  None = 'NONE'
}

export enum Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_DateRange {
  FiveWeeksAgo = 'FIVE_WEEKS_AGO',
  FourWeeksAgo = 'FOUR_WEEKS_AGO',
  Last_1Year = 'LAST_1_YEAR',
  Last_2Years = 'LAST_2_YEARS',
  Last_7Days = 'LAST_7_DAYS',
  Last_28Days = 'LAST_28_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_84Days = 'LAST_84_DAYS',
  Last_90Days = 'LAST_90_DAYS',
  Last_120Days = 'LAST_120_DAYS',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  QuarterToDate = 'QUARTER_TO_DATE',
  ThreeWeeksAgo = 'THREE_WEEKS_AGO',
  TwoWeeksAgo = 'TWO_WEEKS_AGO',
  Undefined = 'UNDEFINED',
  YearToDate = 'YEAR_TO_DATE',
  Yesterday = 'YESTERDAY'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Input = {
  comparisonEnd?: InputMaybe<Scalars['DateTime']>;
  comparisonPeriod?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_ComparisonPeriod>;
  comparisonStart?: InputMaybe<Scalars['DateTime']>;
  dateRange?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_DateRange>;
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
  weekStartDay?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Weekday>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelection_DimensionFilter';
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Defines selected values for a filter to be applied to schema metrics. */
export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input = {
  dateFilter?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Input>;
  dimFilter?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter_Input>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalGetCustomExportResponse';
  customExport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalGetCustomReportResponse';
  customReport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalListCustomExportsResponse';
  customExports: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalListCustomReportsResponse';
  customReports: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>>>;
};

/** Multi Dimension Dataset */
export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dataSource?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDataSource>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  includeCount?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  owner?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOwner>;
  queryTags?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalQueryTag_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse';
  headers: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Header>>>;
  rows: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Row>>>;
  totalRows: Maybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Header = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Header';
  dimensionName: Maybe<Scalars['String']>;
  metricName: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Item';
  comparison: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item_InsightsPortalComparison>;
  dimensionName: Maybe<Scalars['String']>;
  metricName: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item_InsightsPortalComparison = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Item_InsightsPortalComparison';
  absoluteChange: Maybe<Scalars['String']>;
  percentChange: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Row = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Row';
  items: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalOrderBy = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalOrderBy';
  columnName: Maybe<Scalars['String']>;
  orderDirection: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderDirection>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input = {
  columnName?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderDirection>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  None = 'NONE'
}

/**
 * Pre-defined list of query "owners". Each owner manages their own connection
 * to Snowflake/Clickhouse using isc env vars.
 */
export enum Instacart_Retailer_Tools_V2_InsightsPortalOwner {
  Async = 'ASYNC',
  RetailerTools = 'RETAILER_TOOLS',
  Unspecified = 'UNSPECIFIED'
}

/** Used for tagging query logs and metrics in Datadog. */
export type Instacart_Retailer_Tools_V2_InsightsPortalQueryTag_Input = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalRegenerateCustomExportResponse';
  success: Maybe<Scalars['Boolean']>;
};

/**
 * The name of a pre-defined schema.
 * Each schema defines certain metrics that can be queried and
 * filters that can be applied to those metrics.
 */
export enum Instacart_Retailer_Tools_V2_InsightsPortalSchema {
  AdsCoupon = 'ADS_COUPON',
  AdsDisplay = 'ADS_DISPLAY',
  AdsDisplayBanner = 'ADS_DISPLAY_BANNER',
  AdsOverview = 'ADS_OVERVIEW',
  AdsSponsoredProduct = 'ADS_SPONSORED_PRODUCT',
  AdsSponsoredProductV2 = 'ADS_SPONSORED_PRODUCT_V2',
  AggAwarenessCampaigns = 'AGG_AWARENESS_CAMPAIGNS',
  AggAwarenessCampaignsStitchOrderDelivery = 'AGG_AWARENESS_CAMPAIGNS_STITCH_ORDER_DELIVERY',
  AggMerchCollections = 'AGG_MERCH_COLLECTIONS',
  AggMerchCollectionsRollup = 'AGG_MERCH_COLLECTIONS_ROLLUP',
  AggMerchFlyers = 'AGG_MERCH_FLYERS',
  AggMerchPlacements = 'AGG_MERCH_PLACEMENTS',
  AggWarehouseLocationPerformance = 'AGG_WAREHOUSE_LOCATION_PERFORMANCE',
  AggWarehousePerformance = 'AGG_WAREHOUSE_PERFORMANCE',
  CancelledOrders = 'CANCELLED_ORDERS',
  DeliveryPerformance = 'DELIVERY_PERFORMANCE',
  DimUserDailyCaper = 'DIM_USER_DAILY_CAPER',
  FactCampaignImpressionsPerformance = 'FACT_CAMPAIGN_IMPRESSIONS_PERFORMANCE',
  FactCampaignPerformance = 'FACT_CAMPAIGN_PERFORMANCE',
  FactCampaignPerformanceStitchFactCampaignImpressionsPerformance = 'FACT_CAMPAIGN_PERFORMANCE_STITCH_FACT_CAMPAIGN_IMPRESSIONS_PERFORMANCE',
  FactCampaignPerformanceStitchOrderDelivery = 'FACT_CAMPAIGN_PERFORMANCE_STITCH_ORDER_DELIVERY',
  FactCaperSessionPerformance = 'FACT_CAPER_SESSION_PERFORMANCE',
  FactCaperSessionPerformanceAuditPerformance = 'FACT_CAPER_SESSION_PERFORMANCE_AUDIT_PERFORMANCE',
  FactCaperSessionPerformanceCartOperations = 'FACT_CAPER_SESSION_PERFORMANCE_CART_OPERATIONS',
  FutureScheduledOrders = 'FUTURE_SCHEDULED_ORDERS',
  ImageCoverage = 'IMAGE_COVERAGE',
  InventoryIntelligenceOosSignalsAgg = 'INVENTORY_INTELLIGENCE_OOS_SIGNALS_AGG',
  MissingImage_90DayRetailerInsights = 'MISSING_IMAGE_90DAY_RETAILER_INSIGHTS',
  OrderDelivery = 'ORDER_DELIVERY',
  OrderItem = 'ORDER_ITEM',
  OrderItemStitchProductByCategoryBenchmark = 'ORDER_ITEM_STITCH_PRODUCT_BY_CATEGORY_BENCHMARK',
  PickupWarehouseLocation = 'PICKUP_WAREHOUSE_LOCATION',
  ProductByCategoryBenchmark = 'PRODUCT_BY_CATEGORY_BENCHMARK',
  ProductByPartnerBenchmark = 'PRODUCT_BY_PARTNER_BENCHMARK',
  SearchTerm = 'SEARCH_TERM',
  SearchTermByPartnerBenchmark = 'SEARCH_TERM_BY_PARTNER_BENCHMARK',
  SearchTermByTermBenchmark = 'SEARCH_TERM_BY_TERM_BENCHMARK',
  SearchTermStitchSearchTermByTermBenchmark = 'SEARCH_TERM_STITCH_SEARCH_TERM_BY_TERM_BENCHMARK',
  Unknown = 'UNKNOWN'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalSetCustomReportDisabledResponse';
  customReport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filterSelectionOptionsList?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions_Input>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  id?: InputMaybe<Scalars['String']>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalUpdateCustomReportResponse';
  customReport: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
  success: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailers_V1_AppeasementDetail = {
  __typename?: 'instacart_retailers_v1_AppeasementDetail';
  /** The response status of the appeasement request (clear, warning, danger) */
  appeasementRequestResponse: Maybe<Instacart_Retailers_V1_AppeasementRequestResponse>;
  appeasementType: Maybe<Instacart_Retailers_V1_AppeasementType>;
  createdAt: Maybe<Scalars['DateTime']>;
  /** IPP requester ID */
  ippRequesterId: Maybe<Scalars['String']>;
  note: Maybe<Scalars['String']>;
  orderId: Maybe<Scalars['BigInt']>;
  reason: Maybe<Scalars['String']>;
  /** customer ID */
  recipientId: Maybe<Scalars['BigInt']>;
  /** partner ID */
  requesterId: Maybe<Scalars['BigInt']>;
  storeConfigurationId: Maybe<Scalars['BigInt']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  value: Maybe<GoogleTypeMoney>;
};

export enum Instacart_Retailers_V1_AppeasementRequestResponse {
  AppeasementRequestResponseClear = 'APPEASEMENT_REQUEST_RESPONSE_CLEAR',
  AppeasementRequestResponseDanger = 'APPEASEMENT_REQUEST_RESPONSE_DANGER',
  AppeasementRequestResponseUnspecified = 'APPEASEMENT_REQUEST_RESPONSE_UNSPECIFIED',
  AppeasementRequestResponseWarning = 'APPEASEMENT_REQUEST_RESPONSE_WARNING'
}

export enum Instacart_Retailers_V1_AppeasementResponseStatus {
  DeniedAppeasementResponseStatus = 'DENIED_APPEASEMENT_RESPONSE_STATUS',
  ErrorAppeasementResponseStatus = 'ERROR_APPEASEMENT_RESPONSE_STATUS',
  SuccessAppeasementResponseStatus = 'SUCCESS_APPEASEMENT_RESPONSE_STATUS',
  TooManyRequestsAppeasementResponseStatus = 'TOO_MANY_REQUESTS_APPEASEMENT_RESPONSE_STATUS',
  /** Default value */
  UnknownAppeasementResponseStatus = 'UNKNOWN_APPEASEMENT_RESPONSE_STATUS'
}

/** The type of appeasement being requested/offered */
export enum Instacart_Retailers_V1_AppeasementType {
  AppeasementTypeUnspecified = 'APPEASEMENT_TYPE_UNSPECIFIED',
  Credit = 'CREDIT',
  FreeDelivery = 'FREE_DELIVERY',
  FreeExpress = 'FREE_EXPRESS',
  Redelivery = 'REDELIVERY',
  Refund = 'REFUND'
}

export type Instacart_Retailers_V1_GetAppeasementsByUserRequest_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetAppeasementsByUserResponse = {
  __typename?: 'instacart_retailers_v1_GetAppeasementsByUserResponse';
  appeasements: Maybe<Array<Maybe<Instacart_Retailers_V1_AppeasementDetail>>>;
  /** Limit of the appeasements */
  limit: Maybe<Scalars['BigInt']>;
  /** Offset of the appeasements */
  offset: Maybe<Scalars['BigInt']>;
  status: Maybe<Instacart_Retailers_V1_AppeasementResponseStatus>;
  /** Total count of appeasements */
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetCreditsByUserRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetCreditsByUserResponse = {
  __typename?: 'instacart_retailers_v1_GetCreditsByUserResponse';
  totalBalance: Maybe<GoogleTypeMoney>;
};

/** To get all StoreConfigurations with pagination and filtering options for IPP admin consumption */
export type Instacart_Retailers_V1_GetStoreConfigurationsForRetailersRequest_Input = {
  filters?: InputMaybe<Instacart_Retailers_V1_StoreConfigurationFilters_Input>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetWidgetsConfigRequest_Input = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetWidgetsConfigResponse = {
  __typename?: 'instacart_retailers_v1_GetWidgetsConfigResponse';
  config: Maybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_GiveAppeasementsRequest_Input = {
  amountInCents?: InputMaybe<Scalars['BigInt']>;
  ippRequesterId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  reason?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  uiOrigin?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GiveAppeasementsResponse = {
  __typename?: 'instacart_retailers_v1_GiveAppeasementsResponse';
  status: Maybe<Instacart_Retailers_V1_AppeasementResponseStatus>;
};

export type Instacart_Retailers_V1_PartnerAccessModificationRules = {
  __typename?: 'instacart_retailers_v1_PartnerAccessModificationRules';
  /**
   * Consumers should be able to enforce rules on either or both of these fields being present.
   * If both are present, the rules should be applied as an OR.
   * If both are absent/empty, the rules should be ignored.
   * If either contains a -1, every access is denied.
   */
  allowlistPartnerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  allowlistRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Retailers_V1_PartnerAccessSettings = {
  __typename?: 'instacart_retailers_v1_PartnerAccessSettings';
  modificationRules: Maybe<Instacart_Retailers_V1_PartnerAccessModificationRules>;
  /** OPTIONAL version of visible_to_partners_on_ipp */
  optionalVisibleToPartnersOnIpp: Maybe<Scalars['Boolean']>;
  visibleToPartnersOnIpp: Maybe<Scalars['Boolean']>;
};

/** Filters to be applied to the StoreConfigurations */
export type Instacart_Retailers_V1_StoreConfigurationFilters_Input = {
  /** active flag in SC */
  active?: InputMaybe<Scalars['Boolean']>;
  /** branded_name in SC settings */
  brandedNameIncludes?: InputMaybe<Scalars['String']>;
  /** domain_name in SC settings */
  domainNameIncludes?: InputMaybe<Scalars['String']>;
  /** search term that could be matched to branded_name, domain_name, or more */
  searchTerm?: InputMaybe<Scalars['String']>;
};

/** A model specifically for IPP's consumption, to surface to retailers */
export type Instacart_Retailers_V1_StoreConfigurationForRetailers = {
  __typename?: 'instacart_retailers_v1_StoreConfigurationForRetailers';
  active: Maybe<Scalars['Boolean']>;
  allowAllWarehouses: Maybe<Scalars['Boolean']>;
  brandedName: Maybe<Scalars['String']>;
  clientConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  createdAt: Maybe<Scalars['DateTime']>;
  deApplicationPlatform: Maybe<Scalars['String']>;
  domainName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  legal: Maybe<Instacart_Retailers_V1_StoreConfigurationLegal>;
  logoUrl: Maybe<Scalars['String']>;
  partnerAccessSettings: Maybe<Instacart_Retailers_V1_PartnerAccessSettings>;
  slug: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  userIsolationContextId: Maybe<Scalars['BigInt']>;
  whitelistedWarehouseIds: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Retailers_V1_StoreConfigurationLegal = {
  __typename?: 'instacart_retailers_v1_StoreConfigurationLegal';
  shortName: Maybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_StoreConfigurationsForRetailersResponse = {
  __typename?: 'instacart_retailers_v1_StoreConfigurationsForRetailersResponse';
  storeConfigs: Maybe<Array<Maybe<Instacart_Retailers_V1_StoreConfigurationForRetailers>>>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_UpsertWidgetsConfigRequest_Input = {
  config?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_UpsertWidgetsConfigResponse = {
  __typename?: 'instacart_retailers_v1_UpsertWidgetsConfigResponse';
  config: Maybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_ValidateWidgetsConfigRequest_Input = {
  config?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_ValidateWidgetsConfigResponse = {
  __typename?: 'instacart_retailers_v1_ValidateWidgetsConfigResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A |Criterion| is a specification for a boolean function of one value.
 * Values can be evaluated by criteria, yielding either "true" or "false".
 * There several kinds of criteria - exact matches (e.g. "value == 42"),
 * ranges ("0 < value < 50"), even regex matches.  More kinds can and will
 * be added in the future.
 */
export type Instacart_Roulette_V1_Criterion = {
  __typename?: 'instacart_roulette_v1_Criterion';
  boolMatch: Maybe<Instacart_Roulette_V1_Criterion_BoolCriterion>;
  caperVersion: Maybe<Instacart_Roulette_V1_Criterion_CaperVersionCriterion>;
  dayOfWeek: Maybe<Instacart_Roulette_V1_Criterion_DayOfWeekCriterion>;
  group: Maybe<Instacart_Roulette_V1_Criterion_GroupCriterion>;
  numberRange: Maybe<Instacart_Roulette_V1_Criterion_NumberRangeCriterion>;
  numericMatch: Maybe<Instacart_Roulette_V1_Criterion_NumberCriterion>;
  semver: Maybe<Instacart_Roulette_V1_Criterion_SemverCriterion>;
  stringMatch: Maybe<Instacart_Roulette_V1_Criterion_StringCriterion>;
};

/** A criterion expecting a boolean value. */
export type Instacart_Roulette_V1_Criterion_BoolCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_BoolCriterion';
  expected: Maybe<Scalars['Boolean']>;
};

/** A criterion expecting a boolean value. */
export type Instacart_Roulette_V1_Criterion_BoolCriterion_Input = {
  expected?: InputMaybe<Scalars['Boolean']>;
};

/**
 * A Caper version criterion makes a claim about a Caper version string,
 * in an expression language identical to that of |SemverCriterion|.
 *
 * A Caper version is nearly the same as a semantic version, but with
 * important differences.  It contains major, minor, and patch components,
 * along with tags denoting the type of release.  For example:
 * 2025.8.2-v01
 *
 * Where they differ from semvers is in their comparison semantics.  Semver
 * specifies that 1.0.0 < 1.0.0-alpha, whereas in Caper versions,
 * tagged releases are considered as having _higher_ precedence than untagged
 * versions.  The tags are constrained, and not arbitrary.  Store-specific
 * builds are indicated by a semver "build tag" (e.g. "+kroger"), and are
 * ignored in criterion evaluation.
 *
 * The release types, in lesser-to-greater order:
 * 1.0.0
 * 1.0.0-nightly01
 * 1.0.0-nightly02
 * 1.0.0-r01       // "r" is a beta release
 * 1.0.0-rc01      // release candidates going through QA
 * 1.0.0-v01       // official releases
 *
 * Valid operators, as with semvers, are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_CaperVersionCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_CaperVersionCriterion';
  expression: Maybe<Scalars['String']>;
};

/**
 * A Caper version criterion makes a claim about a Caper version string,
 * in an expression language identical to that of |SemverCriterion|.
 *
 * A Caper version is nearly the same as a semantic version, but with
 * important differences.  It contains major, minor, and patch components,
 * along with tags denoting the type of release.  For example:
 * 2025.8.2-v01
 *
 * Where they differ from semvers is in their comparison semantics.  Semver
 * specifies that 1.0.0 < 1.0.0-alpha, whereas in Caper versions,
 * tagged releases are considered as having _higher_ precedence than untagged
 * versions.  The tags are constrained, and not arbitrary.  Store-specific
 * builds are indicated by a semver "build tag" (e.g. "+kroger"), and are
 * ignored in criterion evaluation.
 *
 * The release types, in lesser-to-greater order:
 * 1.0.0
 * 1.0.0-nightly01
 * 1.0.0-nightly02
 * 1.0.0-r01       // "r" is a beta release
 * 1.0.0-rc01      // release candidates going through QA
 * 1.0.0-v01       // official releases
 *
 * Valid operators, as with semvers, are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_CaperVersionCriterion_Input = {
  expression?: InputMaybe<Scalars['String']>;
};

/**
 * A criteron which is satisfied on the specified days of the week.
 *
 * TODO: I'm not happy with the placement of this check as a Criterion;
 * it's not really a function of request input.  Not sure what would
 * be better.
 */
export type Instacart_Roulette_V1_Criterion_DayOfWeekCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_DayOfWeekCriterion';
  days: Maybe<Array<Maybe<Instacart_Roulette_V1_DayOfWeek>>>;
};

/**
 * A criteron which is satisfied on the specified days of the week.
 *
 * TODO: I'm not happy with the placement of this check as a Criterion;
 * it's not really a function of request input.  Not sure what would
 * be better.
 */
export type Instacart_Roulette_V1_Criterion_DayOfWeekCriterion_Input = {
  days?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_DayOfWeek>>>;
};

/**
 * A group criterion makes a claim that a given value is present
 * within the group.
 */
export type Instacart_Roulette_V1_Criterion_GroupCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_GroupCriterion';
  groupId: Maybe<Scalars['String']>;
};

/**
 * A group criterion makes a claim that a given value is present
 * within the group.
 */
export type Instacart_Roulette_V1_Criterion_GroupCriterion_Input = {
  groupId?: InputMaybe<Scalars['String']>;
};

/**
 * A |Criterion| is a specification for a boolean function of one value.
 * Values can be evaluated by criteria, yielding either "true" or "false".
 * There several kinds of criteria - exact matches (e.g. "value == 42"),
 * ranges ("0 < value < 50"), even regex matches.  More kinds can and will
 * be added in the future.
 */
export type Instacart_Roulette_V1_Criterion_Input = {
  boolMatch?: InputMaybe<Instacart_Roulette_V1_Criterion_BoolCriterion_Input>;
  caperVersion?: InputMaybe<Instacart_Roulette_V1_Criterion_CaperVersionCriterion_Input>;
  dayOfWeek?: InputMaybe<Instacart_Roulette_V1_Criterion_DayOfWeekCriterion_Input>;
  group?: InputMaybe<Instacart_Roulette_V1_Criterion_GroupCriterion_Input>;
  numberRange?: InputMaybe<Instacart_Roulette_V1_Criterion_NumberRangeCriterion_Input>;
  numericMatch?: InputMaybe<Instacart_Roulette_V1_Criterion_NumberCriterion_Input>;
  semver?: InputMaybe<Instacart_Roulette_V1_Criterion_SemverCriterion_Input>;
  stringMatch?: InputMaybe<Instacart_Roulette_V1_Criterion_StringCriterion_Input>;
};

/** A criterion expecting a specific integer value. */
export type Instacart_Roulette_V1_Criterion_NumberCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_NumberCriterion';
  expected: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** A criterion expecting a specific integer value. */
export type Instacart_Roulette_V1_Criterion_NumberCriterion_Input = {
  expected?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/**
 * A numeric-range criterion, containing an inclusive minimum value
 * and an exclusive maximum value.  It evaluates to true if the value
 * given is numeric and falls within the range defined.
 */
export type Instacart_Roulette_V1_Criterion_NumberRangeCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_NumberRangeCriterion';
  maxExclusive: Maybe<Scalars['BigInt']>;
  minInclusive: Maybe<Scalars['BigInt']>;
};

/**
 * A numeric-range criterion, containing an inclusive minimum value
 * and an exclusive maximum value.  It evaluates to true if the value
 * given is numeric and falls within the range defined.
 */
export type Instacart_Roulette_V1_Criterion_NumberRangeCriterion_Input = {
  maxExclusive?: InputMaybe<Scalars['BigInt']>;
  minInclusive?: InputMaybe<Scalars['BigInt']>;
};

/**
 * A semantic version criterion makes a claim about a version string;
 * for details of semantic versions see https://semver.org/.
 *
 * A SemverCriterion consists of an expression.  An expression is a
 * combination of a comparison operator and a semantic version, for
 * example ">= 0.1.0".  In this example, the criterion is satisfied
 * by any semantic version comparing greater-than or equal-to version
 * "0.1.0".
 *
 * Valid operators are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_SemverCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_SemverCriterion';
  expression: Maybe<Scalars['String']>;
};

/**
 * A semantic version criterion makes a claim about a version string;
 * for details of semantic versions see https://semver.org/.
 *
 * A SemverCriterion consists of an expression.  An expression is a
 * combination of a comparison operator and a semantic version, for
 * example ">= 0.1.0".  In this example, the criterion is satisfied
 * by any semantic version comparing greater-than or equal-to version
 * "0.1.0".
 *
 * Valid operators are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_SemverCriterion_Input = {
  expression?: InputMaybe<Scalars['String']>;
};

/**
 * A criterion for a string value.
 * It may be an exact match (case sensitive or insensitive), or
 * it may be a regular expression.
 */
export type Instacart_Roulette_V1_Criterion_StringCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_StringCriterion';
  caseSensitive: Maybe<Scalars['Boolean']>;
  expected: Maybe<Array<Maybe<Scalars['String']>>>;
  regex: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A criterion for a string value.
 * It may be an exact match (case sensitive or insensitive), or
 * it may be a regular expression.
 */
export type Instacart_Roulette_V1_Criterion_StringCriterion_Input = {
  caseSensitive?: InputMaybe<Scalars['Boolean']>;
  expected?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * HACK: copied verbatim from instacart.types.v1 to avoid
 * go's ridiculous habit of panicking when > 1 package
 * relies on the same enum.
 */
export enum Instacart_Roulette_V1_DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  ReservedDay = 'RESERVED_DAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Instacart_Roulette_V1_Feature = {
  __typename?: 'instacart_roulette_v1_Feature';
  /**
   * When a feature is archived, it should be hidden from user interfaces but
   * may still be enabled.
   */
  archived: Maybe<Scalars['Boolean']>;
  /** Zero or more request IDs may be manually assigned to a named variant. */
  assignments: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature_StaticAssignment>>>;
  /** Zero or more request IDs may be explicitly opted in to a feature. */
  deprecatedStaticAssignments: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A domain is a logical grouping of features, e.g. "customers" or "ads".
   * It is useful in that requests to list features may be scoped to one or
   * more domains, potentially making feature assignment faster on those
   * clients by avoiding
   */
  domain: Maybe<Scalars['String']>;
  /** When false, the feature is disabled and no assignments to it will be made. */
  enabled: Maybe<Scalars['Boolean']>;
  /**
   * Defines the particular method used to compute hashes when evaluating
   * this feature.
   */
  hashSpec: Maybe<Instacart_Roulette_V1_HashSpec>;
  /** Is this feature a rollback of another feature? */
  isRollback: Maybe<Scalars['Boolean']>;
  /**
   * The metadata field can be used to store data for extensions that are not
   * related to core Roulette functionality, e.g. canary configuration.
   */
  metadata: Maybe<Instacart_Roulette_V1_Feature_Metadata>;
  /** A human-readable name for the feature. */
  name: Maybe<Scalars['String']>;
  /**
   * Text describing the feature.  It might be a description of the related
   * experiment, a JIRA link, an Expy link, or nothing.
   */
  notes: Maybe<Scalars['String']>;
  /**
   * The date after which the owner of this Feature should be nudged in order
   * to perform some cleanup, perhaps removing this Feature from Roulette
   */
  notifyDate: Maybe<Scalars['DateTime']>;
  /**
   * A PartitionKind identifies on which kind of input partitioning will be
   * performed.
   */
  partitionKind: Maybe<Instacart_Roulette_V1_Feature_PartitionKind>;
  /** A pending approval is a request to approve or reject a feature update */
  pendingApproval: Maybe<Instacart_Roulette_V1_PendingApproval>;
  /**
   * Whether the feature is marked as "permanent".
   * Permanent features won't get notified if the feature/toggle has been fully enabled for a predefined period of time
   */
  permanent: Maybe<Instacart_Roulette_V1_Feature_Permanent>;
  /**
   * The Precondition associated with this feature, if any.  This field is
   * optional.
   *
   * This field is deprecated; use [preconditions] instead.
   */
  precondition: Maybe<Instacart_Roulette_V1_Feature_Precondition>;
  /**
   * The Preconditions associated with this feature, if any.  This field is
   * optional.
   */
  preconditions: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature_Precondition>>>;
  rollback: Maybe<Instacart_Roulette_V1_Feature_Rollback>;
  /**
   * The rules by which the feature will be assigned.
   * A feature will always have at least one ruleset, and at most one ruleset
   * at a time will be enabled.
   */
  rulesets: Maybe<Array<Maybe<Instacart_Roulette_V1_Ruleset>>>;
  /**
   * A randomly-generated value that will be incorporated into the request-ID
   * hash.  This value must be strongly random, as it is what ensures the even
   * distribution of feature assignments.
   */
  salt: Maybe<Scalars['BigInt']>;
  /** Specifies the totem system name under which we will create an entity */
  systemName: Maybe<Scalars['String']>;
  /**
   * When true, every single exposure of this feature will be recorded
   * and available for analysis.  When false (the default), only aggregated
   * exposure statistics will be reported.
   */
  trackAllExposures: Maybe<Scalars['Boolean']>;
  /** The user who created this feature version */
  user: Maybe<Instacart_Roulette_V1_User>;
  /** A string uniquely identifying this feature.  This is an immutable identifier. */
  uuid: Maybe<Scalars['String']>;
  variantValueType: Maybe<Instacart_Roulette_V1_VariantValueType>;
  /**
   * A feature has one or more variants into which users will be assigned;
   * a variant represents an observable difference in the experience of the
   * feature (e.g. "teal button" vs "turquoise button" in the "blue button" feature).
   * Of the variants defined, different percentages of assigned users can be
   * slotted.  By default, users will be evenly distributed across variants,
   * but this is configurable for each ruleset.
   *
   * Exactly one variant in each feature must be the "default" variant - that is,
   * the control group.  This variant serves as the "fall-through" - when a user
   * is not assigned to a variant by any ruleset in the feature, they will "fall through"
   * to this default variant.
   */
  variants: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature_Variant>>>;
  /**
   * Any modification to the feature or to its rulesets will result in its
   * version being incremented.
   */
  version: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Input = {
  /**
   * When a feature is archived, it should be hidden from user interfaces but
   * may still be enabled.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Zero or more request IDs may be manually assigned to a named variant. */
  assignments?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Feature_StaticAssignment_Input>>>;
  /** Zero or more request IDs may be explicitly opted in to a feature. */
  deprecatedStaticAssignments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * A domain is a logical grouping of features, e.g. "customers" or "ads".
   * It is useful in that requests to list features may be scoped to one or
   * more domains, potentially making feature assignment faster on those
   * clients by avoiding
   */
  domain?: InputMaybe<Scalars['String']>;
  /** When false, the feature is disabled and no assignments to it will be made. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Defines the particular method used to compute hashes when evaluating
   * this feature.
   */
  hashSpec?: InputMaybe<Instacart_Roulette_V1_HashSpec_Input>;
  /** Is this feature a rollback of another feature? */
  isRollback?: InputMaybe<Scalars['Boolean']>;
  /**
   * The metadata field can be used to store data for extensions that are not
   * related to core Roulette functionality, e.g. canary configuration.
   */
  metadata?: InputMaybe<Instacart_Roulette_V1_Feature_Metadata_Input>;
  /** A human-readable name for the feature. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Text describing the feature.  It might be a description of the related
   * experiment, a JIRA link, an Expy link, or nothing.
   */
  notes?: InputMaybe<Scalars['String']>;
  /**
   * The date after which the owner of this Feature should be nudged in order
   * to perform some cleanup, perhaps removing this Feature from Roulette
   */
  notifyDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * A PartitionKind identifies on which kind of input partitioning will be
   * performed.
   */
  partitionKind?: InputMaybe<Instacart_Roulette_V1_Feature_PartitionKind_Input>;
  /** A pending approval is a request to approve or reject a feature update */
  pendingApproval?: InputMaybe<Instacart_Roulette_V1_PendingApproval_Input>;
  /**
   * Whether the feature is marked as "permanent".
   * Permanent features won't get notified if the feature/toggle has been fully enabled for a predefined period of time
   */
  permanent?: InputMaybe<Instacart_Roulette_V1_Feature_Permanent_Input>;
  /**
   * The Precondition associated with this feature, if any.  This field is
   * optional.
   *
   * This field is deprecated; use [preconditions] instead.
   */
  precondition?: InputMaybe<Instacart_Roulette_V1_Feature_Precondition_Input>;
  /**
   * The Preconditions associated with this feature, if any.  This field is
   * optional.
   */
  preconditions?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Feature_Precondition_Input>>>;
  rollback?: InputMaybe<Instacart_Roulette_V1_Feature_Rollback_Input>;
  /**
   * The rules by which the feature will be assigned.
   * A feature will always have at least one ruleset, and at most one ruleset
   * at a time will be enabled.
   */
  rulesets?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Ruleset_Input>>>;
  /**
   * A randomly-generated value that will be incorporated into the request-ID
   * hash.  This value must be strongly random, as it is what ensures the even
   * distribution of feature assignments.
   */
  salt?: InputMaybe<Scalars['BigInt']>;
  /** Specifies the totem system name under which we will create an entity */
  systemName?: InputMaybe<Scalars['String']>;
  /**
   * When true, every single exposure of this feature will be recorded
   * and available for analysis.  When false (the default), only aggregated
   * exposure statistics will be reported.
   */
  trackAllExposures?: InputMaybe<Scalars['Boolean']>;
  /** The user who created this feature version */
  user?: InputMaybe<Instacart_Roulette_V1_User_Input>;
  /** A string uniquely identifying this feature.  This is an immutable identifier. */
  uuid?: InputMaybe<Scalars['String']>;
  variantValueType?: InputMaybe<Instacart_Roulette_V1_VariantValueType_Input>;
  /**
   * A feature has one or more variants into which users will be assigned;
   * a variant represents an observable difference in the experience of the
   * feature (e.g. "teal button" vs "turquoise button" in the "blue button" feature).
   * Of the variants defined, different percentages of assigned users can be
   * slotted.  By default, users will be evenly distributed across variants,
   * but this is configurable for each ruleset.
   *
   * Exactly one variant in each feature must be the "default" variant - that is,
   * the control group.  This variant serves as the "fall-through" - when a user
   * is not assigned to a variant by any ruleset in the feature, they will "fall through"
   * to this default variant.
   */
  variants?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Feature_Variant_Input>>>;
  /**
   * Any modification to the feature or to its rulesets will result in its
   * version being incremented.
   */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Metadata = {
  __typename?: 'instacart_roulette_v1_Feature_Metadata';
  /**
   * Each extension should have its own top-level key, with its schema
   * defined outside Roulette.
   */
  extensions: Maybe<Scalars['JSON']>;
};

export type Instacart_Roulette_V1_Feature_Metadata_Input = {
  /**
   * Each extension should have its own top-level key, with its schema
   * defined outside Roulette.
   */
  extensions?: InputMaybe<Scalars['JSON']>;
};

export type Instacart_Roulette_V1_Feature_PartitionKind = {
  __typename?: 'instacart_roulette_v1_Feature_PartitionKind';
  idDayKind: Maybe<Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod>;
  idKind: Maybe<Instacart_Roulette_V1_Feature_PartitionKind_IdMod>;
};

/**
 * An ::IdDayMod feature will ensure that, within a single day, a
 * consistent set of requestors will be assigned to the feature, but that
 * set will be different on each weekday.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod = {
  __typename?: 'instacart_roulette_v1_Feature_PartitionKind_IdDayMod';
  /** A JSON Path, as in PartitionKind::IdMod#selector. */
  selector: Maybe<Scalars['String']>;
};

/**
 * An ::IdDayMod feature will ensure that, within a single day, a
 * consistent set of requestors will be assigned to the feature, but that
 * set will be different on each weekday.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod_Input = {
  /** A JSON Path, as in PartitionKind::IdMod#selector. */
  selector?: InputMaybe<Scalars['String']>;
};

/**
 * A PartitionKind::IdMod represents ID-based partitioning.  It identifies
 * a single attribute from the input object to serve as the request ID,
 * which will subsequently be hashed and used for bucketing.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdMod = {
  __typename?: 'instacart_roulette_v1_Feature_PartitionKind_IdMod';
  /**
   * A JSON Path identifying an input value to serve as the "request ID".
   * This may in practice be a shopper ID (e.g. "$.shopper_id"), customer
   * ID, Kochava identifier, Ahoy visitor token, or any other input.
   *
   * If a given request does not include the expected attribute, it will
   * not be assigned the feature.
   */
  selector: Maybe<Scalars['String']>;
};

/**
 * A PartitionKind::IdMod represents ID-based partitioning.  It identifies
 * a single attribute from the input object to serve as the request ID,
 * which will subsequently be hashed and used for bucketing.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdMod_Input = {
  /**
   * A JSON Path identifying an input value to serve as the "request ID".
   * This may in practice be a shopper ID (e.g. "$.shopper_id"), customer
   * ID, Kochava identifier, Ahoy visitor token, or any other input.
   *
   * If a given request does not include the expected attribute, it will
   * not be assigned the feature.
   */
  selector?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_PartitionKind_Input = {
  idDayKind?: InputMaybe<Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod_Input>;
  idKind?: InputMaybe<Instacart_Roulette_V1_Feature_PartitionKind_IdMod_Input>;
};

export type Instacart_Roulette_V1_Feature_Permanent = {
  __typename?: 'instacart_roulette_v1_Feature_Permanent';
  /** Is the feature permanent */
  isPermanent: Maybe<Scalars['Boolean']>;
  /** The reason for marking the feature as permanent */
  reason: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_Permanent_Input = {
  /** Is the feature permanent */
  isPermanent?: InputMaybe<Scalars['Boolean']>;
  /** The reason for marking the feature as permanent */
  reason?: InputMaybe<Scalars['String']>;
};

/**
 * A Precondition in a Feature means that evaluations of the feature are
 * predicated on the evaluation of another feature, identified by the
 * given feature_uuid.  If that feature evaluates to a positive assignment,
 * or to a specific variant, then evaluation of _this_ feature proceeds.
 *
 * If the Precondition is not satisfied, then this feature is deemed not
 * to match - both rulesets and static assignments are ignored.
 */
export type Instacart_Roulette_V1_Feature_Precondition = {
  __typename?: 'instacart_roulette_v1_Feature_Precondition';
  /**
   * The variant(s) expected to have been assigned.
   *
   * If present, may not be empty.
   */
  allowedVariants: Maybe<Instacart_Roulette_V1_VariantList>;
  /** Set if the precondition depends on a percentage of the target feature's traffic */
  exclusiveGroup: Maybe<Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition>;
  /** The UUID identifying the feature targeted by this precondition. */
  featureUuid: Maybe<Scalars['String']>;
  /** Whether or not the target feature should have been assigned. */
  shouldBeAssigned: Maybe<Scalars['Boolean']>;
};

export type Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition = {
  __typename?: 'instacart_roulette_v1_Feature_Precondition_ExclusiveGroupPrecondition';
  /**
   * The variant(s) that have been assigned.
   * This should be treated as read-only by the clients; the server will ignore this
   * and assign allowed_variants strictly based on `percentage`.
   */
  allowedVariants: Maybe<Instacart_Roulette_V1_VariantList>;
  /**
   * For what percentage of the Exclusive Group's traffic should this
   * precondition pass?
   */
  percentage: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition_Input = {
  /**
   * The variant(s) that have been assigned.
   * This should be treated as read-only by the clients; the server will ignore this
   * and assign allowed_variants strictly based on `percentage`.
   */
  allowedVariants?: InputMaybe<Instacart_Roulette_V1_VariantList_Input>;
  /**
   * For what percentage of the Exclusive Group's traffic should this
   * precondition pass?
   */
  percentage?: InputMaybe<Scalars['BigInt']>;
};

/**
 * A Precondition in a Feature means that evaluations of the feature are
 * predicated on the evaluation of another feature, identified by the
 * given feature_uuid.  If that feature evaluates to a positive assignment,
 * or to a specific variant, then evaluation of _this_ feature proceeds.
 *
 * If the Precondition is not satisfied, then this feature is deemed not
 * to match - both rulesets and static assignments are ignored.
 */
export type Instacart_Roulette_V1_Feature_Precondition_Input = {
  /**
   * The variant(s) expected to have been assigned.
   *
   * If present, may not be empty.
   */
  allowedVariants?: InputMaybe<Instacart_Roulette_V1_VariantList_Input>;
  /** Set if the precondition depends on a percentage of the target feature's traffic */
  exclusiveGroup?: InputMaybe<Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition_Input>;
  /** The UUID identifying the feature targeted by this precondition. */
  featureUuid?: InputMaybe<Scalars['String']>;
  /** Whether or not the target feature should have been assigned. */
  shouldBeAssigned?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Roulette_V1_Feature_Rollback = {
  __typename?: 'instacart_roulette_v1_Feature_Rollback';
  /** The note specified when the feature is rolled back */
  note: Maybe<Scalars['String']>;
  /** The version of the feature this feature is a rollback of */
  version: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Rollback_Input = {
  /** The note specified when the feature is rolled back */
  note?: InputMaybe<Scalars['String']>;
  /** The version of the feature this feature is a rollback of */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_StaticAssignment = {
  __typename?: 'instacart_roulette_v1_Feature_StaticAssignment';
  requestId: Maybe<Scalars['String']>;
  variantName: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_StaticAssignment_Input = {
  requestId?: InputMaybe<Scalars['String']>;
  variantName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_Variant = {
  __typename?: 'instacart_roulette_v1_Feature_Variant';
  isDefault: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  value: Maybe<Instacart_Roulette_V1_Feature_VariantValue>;
};

/** The Value of the variant */
export type Instacart_Roulette_V1_Feature_VariantValue = {
  __typename?: 'instacart_roulette_v1_Feature_VariantValue';
  encoding: Maybe<Instacart_Roulette_V1_Feature_VariantValue_Encoding>;
  raw: Maybe<Scalars['String']>;
};

/** The encoding method of the variant value */
export enum Instacart_Roulette_V1_Feature_VariantValue_Encoding {
  Json = 'JSON',
  Unspecified = 'UNSPECIFIED'
}

/** The Value of the variant */
export type Instacart_Roulette_V1_Feature_VariantValue_Input = {
  encoding?: InputMaybe<Instacart_Roulette_V1_Feature_VariantValue_Encoding>;
  raw?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_Variant_Input = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Instacart_Roulette_V1_Feature_VariantValue_Input>;
};

export type Instacart_Roulette_V1_GetFeatureByNameAndVersionRequest_Input = {
  /** Include the associated fields, e.g., Preconditions, Rulesets, etc */
  includeAssociations?: InputMaybe<Scalars['Boolean']>;
  /** The name of the feature */
  name?: InputMaybe<Scalars['String']>;
  /**
   * The version of the feature to fetch
   * If 0 is passed in, the latest version of the feature will be returned.
   */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_GetFeatureByNameAndVersionResponse = {
  __typename?: 'instacart_roulette_v1_GetFeatureByNameAndVersionResponse';
  feature: Maybe<Instacart_Roulette_V1_Feature>;
};

export type Instacart_Roulette_V1_GetFeaturesRequest_Input = {
  /**
   * A pagination token which, when set, will cause the next batch of features to be returned.
   * This value is expected to be empty for initial fetches, and for subsequent fetches will be
   * the value most recently provided by the server in a |GetFeaturesResponse|.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * A list of domains for which features are requested.  If no domains are
   * given, features from all domains will be returned.
   */
  domain?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The maximum number of features to return for this request.  If zero or unset,
   * all features will be returned.
   */
  limit?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_GetFeaturesResponse = {
  __typename?: 'instacart_roulette_v1_GetFeaturesResponse';
  /**
   * A pagination token.  Should be provided verbatim in the next |GetFeaturesRequest|.
   *
   * Notes on pagination:
   *
   * Pagination is of |Feature| only.  Each response will contain all groups depended on by
   * the features contained within that response.  Consequently, the same group may appear
   * many times in a series of responses; clients *MUST* dedupliate accordingly.
   *
   * In this design, pagination takes advantage of Roulette's append-only dataset.
   * Cursors identify the most-recently-modified feature that has yet been returned to a client.
   * Because all changes to existing features result in a new version, it's guaranteed that a
   * given cursor will always incorporate updates, without the need to maintain any kind of
   * additional state on the back end.
   */
  cursor: Maybe<Scalars['String']>;
  features: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature>>>;
  groups: Maybe<Array<Maybe<Instacart_Roulette_V1_Group>>>;
  status: Maybe<Instacart_Roulette_V1_ResultStatus>;
};

/**
 * A |Group| is a named collection of values, used in criteria to
 * assert a user's membership in that group.  For example we might
 * have a group called 'west_coast_zones', containing every zone
 * that we deem to be on the West Coast; this can be used in multiple
 * features to filter requests to only those pertaining to those zones.
 * Another obvious group would be 'admins'.
 */
export type Instacart_Roulette_V1_Group = {
  __typename?: 'instacart_roulette_v1_Group';
  /** The unique human-readable name of the group. */
  id: Maybe<Scalars['String']>;
  /** The group's members. */
  values: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Any modification to a Group will cause its version to be incremented. */
  version: Maybe<Scalars['BigInt']>;
};

/** Specifies a hash function for use when evaluating a feature. */
export type Instacart_Roulette_V1_HashSpec = {
  __typename?: 'instacart_roulette_v1_HashSpec';
  simple: Maybe<Instacart_Roulette_V1_HashSpec_Simple>;
  weightedRendezvous: Maybe<Instacart_Roulette_V1_HashSpec_WeightedRendezvous>;
};

/**
 * Spells out particular hashing algorithms.  All algorithms here
 * are, unless otherwise specified, the 64-bit variant.
 */
export enum Instacart_Roulette_V1_HashSpec_HashPrimitive {
  Unspecified = 'UNSPECIFIED',
  /**
   * xxhash is an extremely fast non-cryptographic hash algorithm.
   * see https://cyan4973.github.io/xxHash/
   *
   * This is currently the only supported hash primitive.
   */
  Xxhash = 'XXHASH'
}

/** Specifies a hash function for use when evaluating a feature. */
export type Instacart_Roulette_V1_HashSpec_Input = {
  simple?: InputMaybe<Instacart_Roulette_V1_HashSpec_Simple_Input>;
  weightedRendezvous?: InputMaybe<Instacart_Roulette_V1_HashSpec_WeightedRendezvous_Input>;
};

/**
 * The Simple specification is just the application of the bare primitive
 * to an identifier, and the 64-bit output is used as-is.
 *
 * Generally should never be used for new features.
 */
export type Instacart_Roulette_V1_HashSpec_Simple = {
  __typename?: 'instacart_roulette_v1_HashSpec_Simple';
  hashPrimitive: Maybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/**
 * The Simple specification is just the application of the bare primitive
 * to an identifier, and the 64-bit output is used as-is.
 *
 * Generally should never be used for new features.
 */
export type Instacart_Roulette_V1_HashSpec_Simple_Input = {
  hashPrimitive?: InputMaybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/**
 * Specifies that the "Weighted Rendezvous Hash" approach should be used.
 * This is a variant of consistent hashing that allows for changing variant
 * weights without unduly disrupting existing assignments.
 *
 * Note for implementers:
 * There are numerous variants of WRH; we've settled on the following particulars:
 * - Logarithmic approach to applying weights; the precise equation for scoring is
 * `score = -nodeWeight / ln(combineHashes(hash(key), hash(node)) / MAX_UINT64)`
 * - xorshift* to combine key and node hashcodes
 * - nodes traversed in ascending lexicographic order
 *
 * For example: https://github.com/benjamin-bader/rendezvous/blob/v0.2.0/rendezvous.go
 */
export type Instacart_Roulette_V1_HashSpec_WeightedRendezvous = {
  __typename?: 'instacart_roulette_v1_HashSpec_WeightedRendezvous';
  hashPrimitive: Maybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/**
 * Specifies that the "Weighted Rendezvous Hash" approach should be used.
 * This is a variant of consistent hashing that allows for changing variant
 * weights without unduly disrupting existing assignments.
 *
 * Note for implementers:
 * There are numerous variants of WRH; we've settled on the following particulars:
 * - Logarithmic approach to applying weights; the precise equation for scoring is
 * `score = -nodeWeight / ln(combineHashes(hash(key), hash(node)) / MAX_UINT64)`
 * - xorshift* to combine key and node hashcodes
 * - nodes traversed in ascending lexicographic order
 *
 * For example: https://github.com/benjamin-bader/rendezvous/blob/v0.2.0/rendezvous.go
 */
export type Instacart_Roulette_V1_HashSpec_WeightedRendezvous_Input = {
  hashPrimitive?: InputMaybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/** Override feature update approval rules */
export type Instacart_Roulette_V1_Override_Input = {
  /** JIRA/Linear ticket link for the override */
  link?: InputMaybe<Scalars['String']>;
  /** The reason for the override */
  reason?: InputMaybe<Scalars['String']>;
  /** The email of the user who is overriding the feature update approval rules */
  userEmail?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Pagination_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

/** A pending approval is a request to approve or reject a feature update */
export type Instacart_Roulette_V1_PendingApproval = {
  __typename?: 'instacart_roulette_v1_PendingApproval';
  /** Whether this feature has a pending approval */
  hasPendingApproval: Maybe<Scalars['Boolean']>;
  /** The request id of the pending approval */
  requestId: Maybe<Scalars['String']>;
};

/** A pending approval is a request to approve or reject a feature update */
export type Instacart_Roulette_V1_PendingApproval_Input = {
  /** Whether this feature has a pending approval */
  hasPendingApproval?: InputMaybe<Scalars['Boolean']>;
  /** The request id of the pending approval */
  requestId?: InputMaybe<Scalars['String']>;
};

/** A ResultStatus struct describes the outcome of a RouletteService RPC operation. */
export type Instacart_Roulette_V1_ResultStatus = {
  __typename?: 'instacart_roulette_v1_ResultStatus';
  /**
   * If the request was unsuccessful, may contain useful diagnostic information.
   * It's not safe to assume this will be available or useful in the general case.
   */
  data: Maybe<Scalars['JSON']>;
  /** Indicates the disposition of the request */
  status: Maybe<Instacart_Roulette_V1_ResultStatus_Status>;
};

export enum Instacart_Roulette_V1_ResultStatus_Status {
  /**
   * Indicates that some mutating operation failed due to a versioning conflict -
   * someone else touched the feature before you did, and your version was consequently
   * out-of-date.
   */
  Conflict = 'CONFLICT',
  /** The server got itself into trouble. */
  InternalError = 'INTERNAL_ERROR',
  /** Indicates that the request was invalid. */
  InvalidRequest = 'INVALID_REQUEST',
  /** Indicates that the resource was not found. */
  NotFound = 'NOT_FOUND',
  /** Indicates that all went as requested. */
  Ok = 'OK',
  /** Indicates that the developers forgot to set a status code :( */
  Unknown = 'UNKNOWN'
}

/**
 * A Ruleset defines the rules governing how a feature is assigned.
 *
 * A ruleset may be enabled or disabled; if the latter, it will not be used
 * for assignment at all.
 *
 * The process of ruleset evaluation is as follows:
 * As input, a ruleset is applied to an associative array (hash, object, map, etc)
 * and a hashed identifier (see [Feature.request_id_selector]).  Based on the hash,
 * an exposure percentage is applied - whatever the exposure percentage is, that
 * proportion of requests are considered for assignment.  (Another way to say that
 * is that 1.0 - [exposure_percentage] percent of requests are excluded.)
 *
 * Of the requests included in the exposure, the population is further winnowed by
 * any defined rules
 */
export type Instacart_Roulette_V1_Ruleset = {
  __typename?: 'instacart_roulette_v1_Ruleset';
  enabled: Maybe<Scalars['Boolean']>;
  /**
   * A value between zero and one.  This is the "top of the funnel",
   * and represents the proportion of requests considered for assignment.
   * For example, given an |exposure_percentage| of 0.3, 30% of requests
   * would proceed to be evaluated against the ruleset, and 70% would
   * be screened out.
   */
  exposurePercentage: Maybe<Scalars['Float']>;
  name: Maybe<Scalars['String']>;
  /**
   * The rules to be evaulated for each request.
   * The input to a rule is a structured document (e.g. a JSON object);
   * consequently, a rule consists of a |path| and some criteria.
   * Paths are JSON Path (https://github.com/json-path/JsonPath) strings
   * denoting a specific value in the input, and criteria are one or more
   * well-defined conditions.
   *
   * Successive rules have a logical "AND" relationship.
   */
  rules: Maybe<Array<Maybe<Instacart_Roulette_V1_Ruleset_Rule>>>;
  /**
   * A ruleset can define proportional weights for each of the feature's
   * variants.  By default, all variants are equally-weighted; if no variant
   * weights are specified, it is assumed that all have an equal default
   * weight.
   *
   * If weights are provided, then there must be one weight for every variant
   * defined for the featue; it is an error to provide any fewer or any more
   * weights.
   *
   * Weights are positive integers.  The sum of all weights must equal
   * 10,000.  This is an arbitrary constraint intended to make it easy to
   * reason about weights in terms of percentages.
   *
   * For example, given three variants "a", "b", and "c", if we wanted
   * 50% of assignments in "a", 30% in "b", and 20% in "c", the corresponding
   * weights would be:
   * {
   * "a": 5000,
   * "b": 3000,
   * "c": 2000,
   * }
   */
  variantWeights: Maybe<Array<Maybe<Instacart_Roulette_V1_Ruleset_VariantWeight>>>;
};

/**
 * A Ruleset defines the rules governing how a feature is assigned.
 *
 * A ruleset may be enabled or disabled; if the latter, it will not be used
 * for assignment at all.
 *
 * The process of ruleset evaluation is as follows:
 * As input, a ruleset is applied to an associative array (hash, object, map, etc)
 * and a hashed identifier (see [Feature.request_id_selector]).  Based on the hash,
 * an exposure percentage is applied - whatever the exposure percentage is, that
 * proportion of requests are considered for assignment.  (Another way to say that
 * is that 1.0 - [exposure_percentage] percent of requests are excluded.)
 *
 * Of the requests included in the exposure, the population is further winnowed by
 * any defined rules
 */
export type Instacart_Roulette_V1_Ruleset_Input = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * A value between zero and one.  This is the "top of the funnel",
   * and represents the proportion of requests considered for assignment.
   * For example, given an |exposure_percentage| of 0.3, 30% of requests
   * would proceed to be evaluated against the ruleset, and 70% would
   * be screened out.
   */
  exposurePercentage?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * The rules to be evaulated for each request.
   * The input to a rule is a structured document (e.g. a JSON object);
   * consequently, a rule consists of a |path| and some criteria.
   * Paths are JSON Path (https://github.com/json-path/JsonPath) strings
   * denoting a specific value in the input, and criteria are one or more
   * well-defined conditions.
   *
   * Successive rules have a logical "AND" relationship.
   */
  rules?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Ruleset_Rule_Input>>>;
  /**
   * A ruleset can define proportional weights for each of the feature's
   * variants.  By default, all variants are equally-weighted; if no variant
   * weights are specified, it is assumed that all have an equal default
   * weight.
   *
   * If weights are provided, then there must be one weight for every variant
   * defined for the featue; it is an error to provide any fewer or any more
   * weights.
   *
   * Weights are positive integers.  The sum of all weights must equal
   * 10,000.  This is an arbitrary constraint intended to make it easy to
   * reason about weights in terms of percentages.
   *
   * For example, given three variants "a", "b", and "c", if we wanted
   * 50% of assignments in "a", 30% in "b", and 20% in "c", the corresponding
   * weights would be:
   * {
   * "a": 5000,
   * "b": 3000,
   * "c": 2000,
   * }
   */
  variantWeights?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Ruleset_VariantWeight_Input>>>;
};

export type Instacart_Roulette_V1_Ruleset_Rule = {
  __typename?: 'instacart_roulette_v1_Ruleset_Rule';
  /**
   * Multiple criteria have a logical "OR" relationship.
   * If any of the criteria in the list are satisfied by
   * the rule input, then the rule evaluates successfully.
   *
   * For example, given a rule of the form
   * {
   * "path": "$.email", criteria: [
   * {"type": "string", "expected": "foo"},
   * {"type": "string", "expected": "bar"},
   * ]
   * },
   *
   * the rule would match input like {"email": "foo"}.
   */
  criteria: Maybe<Array<Maybe<Instacart_Roulette_V1_Criterion>>>;
  /** A |path| is a JSON Path notation descr */
  path: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Ruleset_Rule_Input = {
  /**
   * Multiple criteria have a logical "OR" relationship.
   * If any of the criteria in the list are satisfied by
   * the rule input, then the rule evaluates successfully.
   *
   * For example, given a rule of the form
   * {
   * "path": "$.email", criteria: [
   * {"type": "string", "expected": "foo"},
   * {"type": "string", "expected": "bar"},
   * ]
   * },
   *
   * the rule would match input like {"email": "foo"}.
   */
  criteria?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Criterion_Input>>>;
  /** A |path| is a JSON Path notation descr */
  path?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Ruleset_VariantWeight = {
  __typename?: 'instacart_roulette_v1_Ruleset_VariantWeight';
  variant: Maybe<Scalars['String']>;
  weight: Maybe<Scalars['Int']>;
};

export type Instacart_Roulette_V1_Ruleset_VariantWeight_Input = {
  variant?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Operator {
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Operator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Operator {
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Operator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Operator>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Operator {
  Equals = 'EQUALS'
}

/** `Criterion` represents a single filter criterion on a feature attribute */
export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_Input = {
  domainName?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Input>;
  featureName?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Input>;
  featureUuid?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Input>;
  groupId?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Input>;
  hasPendingApproval?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Input>;
  preconditionName?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Input>;
  preconditionUuid?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Input>;
};

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Operator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Operator {
  Equals = 'EQUALS'
}

/**
 * `Filters` is a collection of criteria to be applied to the feature search
 * The criteria are AND'ed
 */
export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Input = {
  criteria?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_Input>>>;
};

export type Instacart_Roulette_V1_SearchFeaturesRequest_Input = {
  filters?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Input>;
  pagination?: InputMaybe<Instacart_Roulette_V1_Pagination_Input>;
  sort?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Input>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Attribute {
  ByName = 'BY_NAME'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Sort_By_Input = {
  attribute?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Attribute>;
  direction?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Direction>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Input = {
  attributes?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_By_Input>>>;
};

export type Instacart_Roulette_V1_SearchFeaturesResponse = {
  __typename?: 'instacart_roulette_v1_SearchFeaturesResponse';
  features: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature>>>;
  status: Maybe<Instacart_Roulette_V1_ResultStatus>;
  totalCount: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_StoreFeatureRequest_Input = {
  /**
   * The feature to be stored.
   *
   * If this feature (identified by UUID) does not exist, it will be stored
   * as is.  If it does exist, then this feature's version must match the stored
   * version exactly.  If it does not, the request fails and |ResultStatus.CONFICT|
   * will be returned.  If it does match, then the feature will be stored and its
   * version will be incremented.
   *
   * Note that for a brand-new feature, the version must be explicitly set to zero.
   */
  feature?: InputMaybe<Instacart_Roulette_V1_Feature_Input>;
  /** Override feature update approval rules */
  override?: InputMaybe<Instacart_Roulette_V1_Override_Input>;
};

export type Instacart_Roulette_V1_StoreFeatureResponse = {
  __typename?: 'instacart_roulette_v1_StoreFeatureResponse';
  status: Maybe<Instacart_Roulette_V1_ResultStatus>;
  /**
   * If |status| is OK or CONFLICT, this field will contain the current version
   * of the stored feature.
   */
  version: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_User = {
  __typename?: 'instacart_roulette_v1_User';
  /** User's email */
  email: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_User_Input = {
  /** User's email */
  email?: InputMaybe<Scalars['String']>;
};

/**
 * A list of zero or more variants.
 *
 * NOTE:
 * Useful only in that it allows embedding a repeated value
 * within a oneof.  If that's not your use-case, just use
 * a repeated field.
 */
export type Instacart_Roulette_V1_VariantList = {
  __typename?: 'instacart_roulette_v1_VariantList';
  variantName: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A list of zero or more variants.
 *
 * NOTE:
 * Useful only in that it allows embedding a repeated value
 * within a oneof.  If that's not your use-case, just use
 * a repeated field.
 */
export type Instacart_Roulette_V1_VariantList_Input = {
  variantName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The configuration associated with a variant */
export type Instacart_Roulette_V1_VariantValueType = {
  __typename?: 'instacart_roulette_v1_VariantValueType';
  /** Is the type user defined or predefined */
  isUserDefined: Maybe<Scalars['Boolean']>;
  /** The name of the variant value type */
  typeName: Maybe<Instacart_Roulette_V1_VariantValueType_TypeName>;
};

/** The configuration associated with a variant */
export type Instacart_Roulette_V1_VariantValueType_Input = {
  /** Is the type user defined or predefined */
  isUserDefined?: InputMaybe<Scalars['Boolean']>;
  /** The name of the variant value type */
  typeName?: InputMaybe<Instacart_Roulette_V1_VariantValueType_TypeName>;
};

/** The variant value type names */
export enum Instacart_Roulette_V1_VariantValueType_TypeName {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  ListOfBooleans = 'LIST_OF_BOOLEANS',
  ListOfFloats = 'LIST_OF_FLOATS',
  ListOfIntegers = 'LIST_OF_INTEGERS',
  ListOfStrings = 'LIST_OF_STRINGS',
  String = 'STRING',
  Unspecified = 'UNSPECIFIED'
}

/**
 * Represents an accurate fractional value
 * Similar to google.type.Money
 */
export type Instacart_Types_V1_BigDecimal = {
  __typename?: 'instacart_types_v1_BigDecimal';
  /**
   * Nano units of the amount (10^-9)
   * Must be same sign as units
   * Example: The value -1.25 is represented as units=-1 and nanos=-250000000
   */
  nanos: Maybe<Scalars['Int']>;
  /** Whole units part of the amount */
  units: Maybe<Scalars['BigInt']>;
};

/**
 * Represents an accurate fractional value
 * Similar to google.type.Money
 */
export type Instacart_Types_V1_BigDecimal_Input = {
  /**
   * Nano units of the amount (10^-9)
   * Must be same sign as units
   * Example: The value -1.25 is represented as units=-1 and nanos=-250000000
   */
  nanos?: InputMaybe<Scalars['Int']>;
  /** Whole units part of the amount */
  units?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasuredQuantity = {
  __typename?: 'instacart_types_v1_MeasuredQuantity';
  /**
   * The quantity in relevant units. Quantity may be positive, negative or zero in a message.
   * The semantics of negative quantities are application-specific.
   */
  quantity: Maybe<Scalars['Float']>;
  /**
   * The measurement unit for this quantity. If this is the unknown MeasurementUnit
   * then the quantity field cannot be deterministically interpreted without
   * outside knowledge or heuristics. Valid MeasurementUnits should be used for all
   * new data.
   */
  unit: Maybe<Instacart_Types_V1_MeasurementUnit>;
};

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasuredQuantity_Input = {
  /**
   * The quantity in relevant units. Quantity may be positive, negative or zero in a message.
   * The semantics of negative quantities are application-specific.
   */
  quantity?: InputMaybe<Scalars['Float']>;
  /**
   * The measurement unit for this quantity. If this is the unknown MeasurementUnit
   * then the quantity field cannot be deterministically interpreted without
   * outside knowledge or heuristics. Valid MeasurementUnits should be used for all
   * new data.
   */
  unit?: InputMaybe<Instacart_Types_V1_MeasurementUnit_Input>;
};

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasurementUnit = {
  __typename?: 'instacart_types_v1_MeasurementUnit';
  /** Cost unit of the item. */
  costUnit: Maybe<Instacart_Types_V1_MeasurementUnit_CostUnit>;
  /**
   * Represents the case-sensitive symbols (c/s) defined by the
   * UCUM specification. Non-matching MeasurementUnits *might* be
   * convertible within the UCUM system by an application that
   * understands the semantics of UCUM symbols, base units, and
   * derived units.
   *
   * Simple equality comparison of a MeasurementUnit requires only
   * a case-sensitive comparison of `unit_code`.
   * Confirming that a `unit_code` is valid in the UCUM system requires
   * a full understanding the specification.
   * The protobuf default string value is explicitly *not* a valid symbol
   * in the UCUM system and represents an unknown MeasurementUnit
   * rather than a literal code. An unknown unit code does not match any
   * other unit code (including unknown).
   *
   * Note that the Arbitrary Unit code "[arb'U]" is used to represent "per each" quantities
   * where the concept of "each" is relative to an identified thing.
   * See: https://en.wikipedia.org/wiki/Arbitrary_unit
   *
   * Common unit_codes used in Instacart flows include:
   * Arbitrary Unit (per each):               "[arb'U]"
   * US Fluid Ounce (fluid volume):           "[foz_us]"
   * Avoirdupois Pound (mass aka weight):     "[lb_av]"
   */
  unitCode: Maybe<Scalars['String']>;
};

export enum Instacart_Types_V1_MeasurementUnit_CostUnit {
  CostUnitUnspecified = 'COST_UNIT_UNSPECIFIED',
  /** Unit is measured as each */
  Each = 'EACH',
  /** Fluid Ounce */
  FlOz = 'FL_OZ',
  /** Gallons */
  Gallon = 'GALLON',
  /** grams, 1/1000 of a KG */
  Gram = 'GRAM',
  /** Kilogram */
  Kg = 'KG',
  /** Pounds */
  Lb = 'LB',
  /** 1 L = 1 Liter = 1_000 MilliLiter */
  Liter = 'LITER',
  /** MilliLiter, and not MegaLiter */
  Ml = 'ML',
  /** Ounce */
  Oz = 'OZ',
  /** Pint; 1/2 of a Gallon */
  Pint = 'PINT',
  /** Quart; 1/4 of a Gallon */
  Quart = 'QUART'
}

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasurementUnit_Input = {
  /** Cost unit of the item. */
  costUnit?: InputMaybe<Instacart_Types_V1_MeasurementUnit_CostUnit>;
  /**
   * Represents the case-sensitive symbols (c/s) defined by the
   * UCUM specification. Non-matching MeasurementUnits *might* be
   * convertible within the UCUM system by an application that
   * understands the semantics of UCUM symbols, base units, and
   * derived units.
   *
   * Simple equality comparison of a MeasurementUnit requires only
   * a case-sensitive comparison of `unit_code`.
   * Confirming that a `unit_code` is valid in the UCUM system requires
   * a full understanding the specification.
   * The protobuf default string value is explicitly *not* a valid symbol
   * in the UCUM system and represents an unknown MeasurementUnit
   * rather than a literal code. An unknown unit code does not match any
   * other unit code (including unknown).
   *
   * Note that the Arbitrary Unit code "[arb'U]" is used to represent "per each" quantities
   * where the concept of "each" is relative to an identified thing.
   * See: https://en.wikipedia.org/wiki/Arbitrary_unit
   *
   * Common unit_codes used in Instacart flows include:
   * Arbitrary Unit (per each):               "[arb'U]"
   * US Fluid Ounce (fluid volume):           "[foz_us]"
   * Avoirdupois Pound (mass aka weight):     "[lb_av]"
   */
  unitCode?: InputMaybe<Scalars['String']>;
};

/**
 * Contextual information used for identifying the
 * marketplace/pbi/connect configurations associated
 * with a request
 */
export type Instacart_Types_V1_RequestContext_Input = {
  /**
   * NOTE: this ID is still a proposal/wip
   * for replacing the multiple identifiers long term
   */
  applicationId?: InputMaybe<Scalars['Int']>;
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  /** ISO numeric code */
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

/** AuditContext */
export type Instacart_Upos_Config_V1_AuditContext = {
  __typename?: 'instacart_upos_config_v1_AuditContext';
  agentId: Maybe<Scalars['String']>;
};

/** AuditContext */
export type Instacart_Upos_Config_V1_AuditContext_Input = {
  agentId?: InputMaybe<Scalars['String']>;
};

/** GetIntegrationVersionsRequest */
export type Instacart_Upos_Config_V1_GetIntegrationVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetIntegrationVersionsResponse */
export type Instacart_Upos_Config_V1_GetIntegrationVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetIntegrationVersionsResponse';
  versions: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetIntegrationsResponse */
export type Instacart_Upos_Config_V1_GetIntegrationsResponse = {
  __typename?: 'instacart_upos_config_v1_GetIntegrationsResponse';
  integrations: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetProfileVersionsRequest */
export type Instacart_Upos_Config_V1_GetProfileVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetProfileVersionsResponse */
export type Instacart_Upos_Config_V1_GetProfileVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetProfileVersionsResponse';
  versions: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetProfilesResponse */
export type Instacart_Upos_Config_V1_GetProfilesResponse = {
  __typename?: 'instacart_upos_config_v1_GetProfilesResponse';
  profiles: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetRetailerVersionsRequest */
export type Instacart_Upos_Config_V1_GetRetailerVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetRetailerVersionsResponse */
export type Instacart_Upos_Config_V1_GetRetailerVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetRetailerVersionsResponse';
  versions: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetRetailersResponse */
export type Instacart_Upos_Config_V1_GetRetailersResponse = {
  __typename?: 'instacart_upos_config_v1_GetRetailersResponse';
  retailers: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetStoreVersionsRequest */
export type Instacart_Upos_Config_V1_GetStoreVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetStoreVersionsResponse */
export type Instacart_Upos_Config_V1_GetStoreVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetStoreVersionsResponse';
  versions: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetStoresResponse */
export type Instacart_Upos_Config_V1_GetStoresResponse = {
  __typename?: 'instacart_upos_config_v1_GetStoresResponse';
  stores: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** PutIntegrationRequest */
export type Instacart_Upos_Config_V1_PutIntegrationRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  integration?: InputMaybe<Scalars['JSON']>;
};

/** PutIntegrationResponse */
export type Instacart_Upos_Config_V1_PutIntegrationResponse = {
  __typename?: 'instacart_upos_config_v1_PutIntegrationResponse';
  integration: Maybe<Scalars['JSON']>;
};

/** PutProfileRequest */
export type Instacart_Upos_Config_V1_PutProfileRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  profile?: InputMaybe<Scalars['JSON']>;
};

/** PutProfileResponse */
export type Instacart_Upos_Config_V1_PutProfileResponse = {
  __typename?: 'instacart_upos_config_v1_PutProfileResponse';
  profile: Maybe<Scalars['JSON']>;
};

/** PutRetailerRequest */
export type Instacart_Upos_Config_V1_PutRetailerRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  retailer?: InputMaybe<Scalars['JSON']>;
};

/** PutRetailerResponse */
export type Instacart_Upos_Config_V1_PutRetailerResponse = {
  __typename?: 'instacart_upos_config_v1_PutRetailerResponse';
  retailer: Maybe<Scalars['JSON']>;
};

/** PutStoreRequest */
export type Instacart_Upos_Config_V1_PutStoreRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  store?: InputMaybe<Scalars['JSON']>;
};

/** PutStoreResponse */
export type Instacart_Upos_Config_V1_PutStoreResponse = {
  __typename?: 'instacart_upos_config_v1_PutStoreResponse';
  store: Maybe<Scalars['JSON']>;
};

/** Version */
export type Instacart_Upos_Config_V1_Version = {
  __typename?: 'instacart_upos_config_v1_Version';
  auditContext: Maybe<Instacart_Upos_Config_V1_AuditContext>;
  create: Maybe<Scalars['instacart_upos_config_v1_Version_Create']>;
  createdAt: Maybe<Scalars['DateTime']>;
  update: Maybe<Instacart_Upos_Config_V1_Version_Update>;
};

/** Update */
export type Instacart_Upos_Config_V1_Version_Update = {
  __typename?: 'instacart_upos_config_v1_Version_Update';
  record: Maybe<Scalars['JSON']>;
};

/** GetIntegrationStatusesResponse */
export type Instacart_Upos_Status_V1_GetIntegrationStatusesResponse = {
  __typename?: 'instacart_upos_status_v1_GetIntegrationStatusesResponse';
  statuses: Maybe<Array<Maybe<Instacart_Upos_Status_V1_IntegrationStatus>>>;
};

/** The status of a retailer location integration */
export type Instacart_Upos_Status_V1_IntegrationStatus = {
  __typename?: 'instacart_upos_status_v1_IntegrationStatus';
  comment: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  emails: Maybe<Array<Maybe<Scalars['String']>>>;
  healthyStatus: Maybe<Instacart_Upos_Status_V1_IntegrationStatus_Healthy>;
  integrationName: Maybe<Scalars['String']>;
  links: Maybe<Scalars['JSON']>;
  restartable: Maybe<Scalars['Boolean']>;
  retailerLocationId: Maybe<Scalars['BigInt']>;
  retailerName: Maybe<Scalars['String']>;
  undeterminedStatus: Maybe<Scalars['instacart_upos_status_v1_IntegrationStatus_Undetermined']>;
  unhealthyStatus: Maybe<Instacart_Upos_Status_V1_IntegrationStatus_Unhealthy>;
};

/** Returned if status is healthy */
export type Instacart_Upos_Status_V1_IntegrationStatus_Healthy = {
  __typename?: 'instacart_upos_status_v1_IntegrationStatus_Healthy';
  debugInfo: Maybe<Scalars['JSON']>;
  firstCheckedAt: Maybe<Scalars['DateTime']>;
  healthySince: Maybe<Scalars['DateTime']>;
  lastCheckedAt: Maybe<Scalars['DateTime']>;
};

/** Returned if status is unhealthy */
export type Instacart_Upos_Status_V1_IntegrationStatus_Unhealthy = {
  __typename?: 'instacart_upos_status_v1_IntegrationStatus_Unhealthy';
  debugInfo: Maybe<Scalars['JSON']>;
  firstCheckedAt: Maybe<Scalars['DateTime']>;
  lastCheckedAt: Maybe<Scalars['DateTime']>;
  reason: Maybe<Scalars['String']>;
  unhealthySince: Maybe<Scalars['DateTime']>;
};

/** Request to create a new step with its initial version */
export type Instacart_Waves_V1_CreateNewStepRequest_Input = {
  /** required: step configuration (JSONB) */
  attributes?: InputMaybe<Scalars['JSON']>;
  /** required: name, owner, type, step_category */
  step?: InputMaybe<Instacart_Waves_V1_Step_Input>;
};

/** Response after creating a new step */
export type Instacart_Waves_V1_CreateNewStepResponse = {
  __typename?: 'instacart_waves_v1_CreateNewStepResponse';
  /** created step ID */
  id: Maybe<Scalars['BigInt']>;
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
};

/** Request to create a new step version */
export type Instacart_Waves_V1_CreateNewStepVersionRequest_Input = {
  attributes?: InputMaybe<Scalars['JSON']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_why?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
};

/** Response after creating a new step version */
export type Instacart_Waves_V1_CreateNewStepVersionResponse = {
  __typename?: 'instacart_waves_v1_CreateNewStepVersionResponse';
  id: Maybe<Scalars['BigInt']>;
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
};

/** Request to create or update a scheduled workflow (upsert operation). */
export type Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowRequest_Input = {
  spec?: InputMaybe<Instacart_Waves_V1_ScheduleSpec_Input>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  workflow_input?: InputMaybe<Instacart_Waves_V1_WorkflowLoopInput_Input>;
};

/** Response containing the result of creating or updating a scheduled workflow. */
export type Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowResponse = {
  __typename?: 'instacart_waves_v1_CreateOrUpdateScheduledWorkflowResponse';
  message: Maybe<Scalars['String']>;
  schedule_id: Maybe<Scalars['String']>;
};

/** Request to create a new step filter tag */
export type Instacart_Waves_V1_CreateStepFilterTagRequest_Input = {
  filter_metadata?: InputMaybe<Scalars['JSON']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tag_name?: InputMaybe<Scalars['String']>;
  /** Optional */
  tag_value?: InputMaybe<Scalars['String']>;
};

/** Response after creating a step filter tag */
export type Instacart_Waves_V1_CreateStepFilterTagResponse = {
  __typename?: 'instacart_waves_v1_CreateStepFilterTagResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  tag: Maybe<Instacart_Waves_V1_StepFilterTag>;
};

/** Request to delete an existing scheduled workflow. */
export type Instacart_Waves_V1_DeleteScheduledWorkflowRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response confirming the deletion of a scheduled workflow. */
export type Instacart_Waves_V1_DeleteScheduledWorkflowResponse = {
  __typename?: 'instacart_waves_v1_DeleteScheduledWorkflowResponse';
  message: Maybe<Scalars['String']>;
};

/** Request to delete a step filter tag */
export type Instacart_Waves_V1_DeleteStepFilterTagRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
  tag_name?: InputMaybe<Scalars['String']>;
};

/** Response after deleting a step filter tag */
export type Instacart_Waves_V1_DeleteStepFilterTagResponse = {
  __typename?: 'instacart_waves_v1_DeleteStepFilterTagResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
};

/** Request to describe snowflake table's schema */
export type Instacart_Waves_V1_DescribeSnowflakeTableRequest_Input = {
  /** Format: database.schema.table */
  table_name?: InputMaybe<Scalars['String']>;
};

/** Response containing snowflake table schema information */
export type Instacart_Waves_V1_DescribeSnowflakeTableResponse = {
  __typename?: 'instacart_waves_v1_DescribeSnowflakeTableResponse';
  columns: Maybe<Array<Maybe<Instacart_Waves_V1_SnowflakeColumn>>>;
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
};

/** Request to get paginated step version history */
export type Instacart_Waves_V1_GetStepVersionHistoryRequest_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing step version history */
export type Instacart_Waves_V1_GetStepVersionHistoryResponse = {
  __typename?: 'instacart_waves_v1_GetStepVersionHistoryResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  step_versions: Maybe<Array<Maybe<Instacart_Waves_V1_StepVersion>>>;
};

/** Request to get a specific step version */
export type Instacart_Waves_V1_GetStepVersionRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the requested step version */
export type Instacart_Waves_V1_GetStepVersionResponse = {
  __typename?: 'instacart_waves_v1_GetStepVersionResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  step_version: Maybe<Instacart_Waves_V1_StepVersion>;
};

/** Request for GetWorkflowRun endpoint */
export type Instacart_Waves_V1_GetWorkflowRunRequest_Input = {
  workflow_run_id?: InputMaybe<Scalars['String']>;
};

/** Response for GetWorkflowRun endpoint */
export type Instacart_Waves_V1_GetWorkflowRunResponse = {
  __typename?: 'instacart_waves_v1_GetWorkflowRunResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  step_run_details: Maybe<Array<Maybe<Instacart_Waves_V1_StepRunDetail>>>;
  workflow_status: Maybe<Scalars['String']>;
};

/** Request to list step filter tags for a given step */
export type Instacart_Waves_V1_ListStepFilterTagsRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing list of step filter tags */
export type Instacart_Waves_V1_ListStepFilterTagsResponse = {
  __typename?: 'instacart_waves_v1_ListStepFilterTagsResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  tags: Maybe<Array<Maybe<Instacart_Waves_V1_StepFilterTag>>>;
};

/** Request to list step runs with pagination */
export type Instacart_Waves_V1_ListStepRunsRequest_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  step_version_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing step runs with pagination info */
export type Instacart_Waves_V1_ListStepRunsResponse = {
  __typename?: 'instacart_waves_v1_ListStepRunsResponse';
  current_page: Maybe<Scalars['BigInt']>;
  message: Maybe<Scalars['String']>;
  page_count: Maybe<Scalars['BigInt']>;
  status_code: Maybe<Scalars['Int']>;
  step_runs: Maybe<Array<Maybe<Instacart_Waves_V1_StepRun>>>;
};

/** Request to list step versions with filters */
export type Instacart_Waves_V1_ListStepVersionsRequest_Input = {
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  step_type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing filtered step versions */
export type Instacart_Waves_V1_ListStepVersionsResponse = {
  __typename?: 'instacart_waves_v1_ListStepVersionsResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  step_versions: Maybe<Array<Maybe<Instacart_Waves_V1_StepVersion>>>;
};

/** Request to list steps */
export type Instacart_Waves_V1_ListStepsRequest_Input = {
  enable_schedule?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_filter_tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  step_type?: InputMaybe<Scalars['String']>;
};

/** Response containing list of steps */
export type Instacart_Waves_V1_ListStepsResponse = {
  __typename?: 'instacart_waves_v1_ListStepsResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  steps: Maybe<Array<Maybe<Instacart_Waves_V1_Step>>>;
  total_result_count: Maybe<Scalars['BigInt']>;
};

/** Request for ListWorkflowRuns endpoint */
export type Instacart_Waves_V1_ListWorkflowRunsRequest_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  pipeline_step_version_id?: InputMaybe<Scalars['String']>;
};

/** Response for ListWorkflowRuns endpoint */
export type Instacart_Waves_V1_ListWorkflowRunsResponse = {
  __typename?: 'instacart_waves_v1_ListWorkflowRunsResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
  workflow_run_ids: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Interval-based schedule specification for regular recurring executions. */
export type Instacart_Waves_V1_ScheduleIntervalSpec_Input = {
  every?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['String']>;
};

/** Schedule specification defining when and how often a workflow should run. */
export type Instacart_Waves_V1_ScheduleSpec_Input = {
  cron_expressions?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<Instacart_Waves_V1_ScheduleIntervalSpec_Input>;
};

/** Schema information for a single Snowflake table column */
export type Instacart_Waves_V1_SnowflakeColumn = {
  __typename?: 'instacart_waves_v1_SnowflakeColumn';
  check: Maybe<Scalars['String']>;
  comment: Maybe<Scalars['String']>;
  default: Maybe<Scalars['String']>;
  expression: Maybe<Scalars['String']>;
  kind: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  nullable: Maybe<Scalars['Boolean']>;
  policy_name: Maybe<Scalars['String']>;
  primary_key: Maybe<Scalars['Boolean']>;
  privacy_domain: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  unique_key: Maybe<Scalars['Boolean']>;
};

/** Representation of Step Object */
export type Instacart_Waves_V1_Step = {
  __typename?: 'instacart_waves_v1_Step';
  /** required */
  description: Maybe<Scalars['String']>;
  filter_tags: Maybe<Array<Maybe<Instacart_Waves_V1_StepFilterTag>>>;
  id: Maybe<Scalars['BigInt']>;
  latest_step_version_enable_schedule: Maybe<Scalars['Boolean']>;
  /** required */
  name: Maybe<Scalars['String']>;
  /** required */
  owner: Maybe<Scalars['String']>;
  /** required */
  step_category: Maybe<Instacart_Waves_V1_StepCategory>;
  tombstoned: Maybe<Scalars['Boolean']>;
  /** required */
  type: Maybe<Scalars['String']>;
};

/** Category of a step */
export enum Instacart_Waves_V1_StepCategory {
  StepCategoryApiService = 'STEP_CATEGORY_API_SERVICE',
  StepCategoryAudit = 'STEP_CATEGORY_AUDIT',
  StepCategoryExtractionModel = 'STEP_CATEGORY_EXTRACTION_MODEL',
  StepCategoryInput = 'STEP_CATEGORY_INPUT',
  StepCategoryNormalization = 'STEP_CATEGORY_NORMALIZATION',
  StepCategoryPipeline = 'STEP_CATEGORY_PIPELINE',
  StepCategoryPublish = 'STEP_CATEGORY_PUBLISH',
  StepCategoryUnknown = 'STEP_CATEGORY_UNKNOWN',
  StepCategoryValidation = 'STEP_CATEGORY_VALIDATION'
}

/** Represents a single step filter tag */
export type Instacart_Waves_V1_StepFilterTag = {
  __typename?: 'instacart_waves_v1_StepFilterTag';
  created_at: Maybe<Scalars['String']>;
  filter_metadata: Maybe<Scalars['JSON']>;
  step_id: Maybe<Scalars['BigInt']>;
  tag_name: Maybe<Scalars['String']>;
  tag_value: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['String']>;
};

/** Represents a single step filter tag */
export type Instacart_Waves_V1_StepFilterTag_Input = {
  created_at?: InputMaybe<Scalars['String']>;
  filter_metadata?: InputMaybe<Scalars['JSON']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tag_name?: InputMaybe<Scalars['String']>;
  tag_value?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Representation of a step run */
export type Instacart_Waves_V1_StepRun = {
  __typename?: 'instacart_waves_v1_StepRun';
  created_at: Maybe<Scalars['DateTime']>;
  dashboard_url: Maybe<Scalars['String']>;
  failed_reasons: Maybe<Scalars['String']>;
  failed_task_count: Maybe<Scalars['BigInt']>;
  id: Maybe<Scalars['BigInt']>;
  product_count: Maybe<Scalars['BigInt']>;
  requester: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  state_message: Maybe<Scalars['String']>;
  version: Maybe<Scalars['BigInt']>;
};

/** Representation of the details in a step run. */
export type Instacart_Waves_V1_StepRunDetail = {
  __typename?: 'instacart_waves_v1_StepRunDetail';
  inputs: Maybe<Array<Maybe<Scalars['String']>>>;
  outputs: Maybe<Array<Maybe<Scalars['String']>>>;
  pipeline_step_id: Maybe<Scalars['String']>;
  run_metadata: Maybe<Scalars['JSON']>;
  status: Maybe<Scalars['String']>;
  step_id: Maybe<Scalars['BigInt']>;
  step_run_id: Maybe<Scalars['BigInt']>;
};

/** Representation of a step version */
export type Instacart_Waves_V1_StepVersion = {
  __typename?: 'instacart_waves_v1_StepVersion';
  attributes: Maybe<Scalars['JSON']>;
  created_at: Maybe<Scalars['DateTime']>;
  created_by: Maybe<Scalars['String']>;
  created_why: Maybe<Scalars['String']>;
  id: Maybe<Scalars['BigInt']>;
  state: Maybe<Scalars['String']>;
  step: Maybe<Instacart_Waves_V1_Step>;
  step_id: Maybe<Scalars['BigInt']>;
  tombstoned: Maybe<Scalars['Boolean']>;
  version: Maybe<Scalars['BigInt']>;
};

/** Representation of Step Object */
export type Instacart_Waves_V1_Step_Input = {
  /** required */
  description?: InputMaybe<Scalars['String']>;
  filter_tags?: InputMaybe<Array<InputMaybe<Instacart_Waves_V1_StepFilterTag_Input>>>;
  id?: InputMaybe<Scalars['BigInt']>;
  latest_step_version_enable_schedule?: InputMaybe<Scalars['Boolean']>;
  /** required */
  name?: InputMaybe<Scalars['String']>;
  /** required */
  owner?: InputMaybe<Scalars['String']>;
  /** required */
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
  /** required */
  type?: InputMaybe<Scalars['String']>;
};

/** Request to soft delete a step */
export type Instacart_Waves_V1_TombstoneStepRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
  tombstoned_by?: InputMaybe<Scalars['String']>;
};

/** Response to soft delete a step */
export type Instacart_Waves_V1_TombstoneStepResponse = {
  __typename?: 'instacart_waves_v1_TombstoneStepResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
};

/** Request to update a step's owner and/or description */
export type Instacart_Waves_V1_UpdateStepRequest_Input = {
  description?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after updating a step */
export type Instacart_Waves_V1_UpdateStepResponse = {
  __typename?: 'instacart_waves_v1_UpdateStepResponse';
  message: Maybe<Scalars['String']>;
  status_code: Maybe<Scalars['Int']>;
};

/** Individual input item containing key-value data for workflow processing. */
export type Instacart_Waves_V1_WorkflowInputItem_Input = {
  data?: InputMaybe<Scalars['JSON']>;
};

/** Input parameters for WAVES workflow execution. */
export type Instacart_Waves_V1_WorkflowLoopInput_Input = {
  first_step_version_id?: InputMaybe<Scalars['BigInt']>;
  input?: InputMaybe<Array<InputMaybe<Instacart_Waves_V1_WorkflowInputItem_Input>>>;
  input_s3_file?: InputMaybe<Scalars['String']>;
  is_test?: InputMaybe<Scalars['Boolean']>;
  requester?: InputMaybe<Scalars['String']>;
};

export type AiAgentConversationUpsertMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  messages: Array<ChatMessageInput> | ChatMessageInput;
}>;


export type AiAgentConversationUpsertMutation = { __typename?: 'Mutation', aiAgentConversationUpsert: { __typename?: 'AiAgentConversationUpsertPayload', success: true } };

export type AiAgentExecuteMutationVariables = Exact<{
  input: AgentRequestInput;
}>;


export type AiAgentExecuteMutation = { __typename?: 'Mutation', aiAgentExecute: { __typename?: 'AgentResponse', finalResult: string, summary: string, messages: Array<{ __typename?: 'Message', content: string, role: Role, toolCallId: string, toolCalls: Array<{ __typename?: 'ToolCall', id: string, type: string, function: { __typename?: 'Function', name: string, arguments: string } }> }> } };

export type AcceptPartnerAgreementMutationVariables = Exact<{
  partnerId: Scalars['ID'];
  agreementType: AgreementTypeEnum;
}>;


export type AcceptPartnerAgreementMutation = { __typename?: 'Mutation', enterpriseAccountAcceptPartnerAgreement: { __typename?: 'EnterpriseAccountAcceptPartnerAgreementPayload', acceptedPartnerAgreement: { __typename?: 'EnterpriseAcceptedPartnerAgreement', partnerId: string, agreementType: AgreementTypeEnum } } };

export type FetchCurrentEnterpriseAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentEnterpriseAccountQuery = { __typename?: 'Query', currentEnterpriseAccount: { __typename?: 'EnterpriseAccount', canonicalId: string, id: string, createdAt: string, givenName: string, surname: string, email: string, accountStateValid: boolean, isInternal: boolean, authServiceRequired: boolean, assignedPartnerIds: Array<string>, assignedRetailerIds: Array<string>, assignedRetailerLocationIds: Array<string>, mfaEnabled: boolean, mfaEnabledAt: string, mfaDeactivatedAt: string, isImpersonating: boolean, userLocale: string, canUpdatePartnerWriteAccess: boolean, hasAllPartnersWriteAccess: boolean, authentication: { __typename?: 'EnterpriseAuthenticationEmailPassword', emailVerified: boolean }, featureToggles: Array<{ __typename?: 'FeatureToggle', name: string }>, featureExperiments: Array<{ __typename?: 'FeatureExperiment', name: string, variant: string }>, policies: { __typename?: 'AccessControlPolicies', viewAdminToolsSection: boolean, viewRetailerDashboardSection: boolean }, internalAccessConfiguration: { __typename?: 'EnterpriseInternalAccessConfiguration', hasAllPartnersFullAccess: boolean, hasFullPartnerAccess: boolean, hasFullRetailerAccess: boolean, hasNothingAccessible: boolean }, roles: Array<{ __typename?: 'EnterpriseRole', slug: string }>, permissions: Array<{ __typename?: 'EnterprisePermission', slug: string }>, acceptedPartnerAgreements: Array<{ __typename?: 'EnterpriseAcceptedPartnerAgreement', partnerId: string, agreementType: AgreementTypeEnum }>, hiddenSettings: { __typename?: 'EnterpriseAccountSettingsHiddenSettings', rsatPulseSurvey: { __typename?: 'EnterpriseAccountSettingsRsatPulseSurvey', lastSeenTime: string, seenCount: number, slug: RsatPulseSurveySlugEnum, hasSubmitted: boolean } }, partnerWriteAccess: Array<{ __typename?: 'EnterprisePartnerWriteAccess', partnerId: string, partner: { __typename?: 'Partner', id: string, name: string } }> } };

export type FetchCurrentEnterpriseAccountCoreQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentEnterpriseAccountCoreQuery = { __typename?: 'Query', currentEnterpriseAccount: { __typename?: 'EnterpriseAccount', canonicalId: string, id: string, createdAt: string, givenName: string, surname: string, email: string, accountStateValid: boolean, isInternal: boolean, authServiceRequired: boolean, assignedPartnerIds: Array<string>, assignedRetailerIds: Array<string>, assignedRetailerLocationIds: Array<string>, mfaEnabled: boolean, mfaEnabledAt: string, mfaDeactivatedAt: string, isImpersonating: boolean, userLocale: string, canUpdatePartnerWriteAccess: boolean, hasAllPartnersWriteAccess: boolean, authentication: { __typename?: 'EnterpriseAuthenticationEmailPassword', emailVerified: boolean }, featureExperiments: Array<{ __typename?: 'FeatureExperiment', name: string, variant: string }>, policies: { __typename?: 'AccessControlPolicies', viewAdminToolsSection: boolean, viewRetailerDashboardSection: boolean }, internalAccessConfiguration: { __typename?: 'EnterpriseInternalAccessConfiguration', hasAllPartnersFullAccess: boolean, hasFullPartnerAccess: boolean, hasFullRetailerAccess: boolean, hasNothingAccessible: boolean }, roles: Array<{ __typename?: 'EnterpriseRole', slug: string }>, permissions: Array<{ __typename?: 'EnterprisePermission', slug: string }>, acceptedPartnerAgreements: Array<{ __typename?: 'EnterpriseAcceptedPartnerAgreement', partnerId: string, agreementType: AgreementTypeEnum }>, hiddenSettings: { __typename?: 'EnterpriseAccountSettingsHiddenSettings', rsatPulseSurvey: { __typename?: 'EnterpriseAccountSettingsRsatPulseSurvey', lastSeenTime: string, seenCount: number, slug: RsatPulseSurveySlugEnum, hasSubmitted: boolean } }, partnerWriteAccess: Array<{ __typename?: 'EnterprisePartnerWriteAccess', partnerId: string, partner: { __typename?: 'Partner', id: string, name: string } }> } };

export type FetchCurrentEnterpriseAccountFeatureTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentEnterpriseAccountFeatureTogglesQuery = { __typename?: 'Query', currentEnterpriseAccount: { __typename?: 'EnterpriseAccount', id: string, featureToggles: Array<{ __typename?: 'FeatureToggle', name: string }> } };

export type GetPermissionsQueryVariables = Exact<{
  roleId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetPermissionsQuery = { __typename?: 'Query', permissions: Array<{ __typename?: 'Permission', slug: string, isRetailerRoleAssignable: boolean }> };

export type RequestBreakGlassPartnerWriteAccessMutationVariables = Exact<{
  partnerIds: Array<Scalars['ID']> | Scalars['ID'];
  userJustification: Scalars['String'];
  ticketUrl: Scalars['String'];
}>;


export type RequestBreakGlassPartnerWriteAccessMutation = { __typename?: 'Mutation', enterpriseAccountRequestBreakGlassPartnerWriteAccess: { __typename?: 'EnterpriseAccountRequestBreakGlassPartnerWriteAccessPayload', success: true } };

export type UpdateHiddenSettingsMutationVariables = Exact<{
  hiddenSettings: HiddenSettingsInput;
}>;


export type UpdateHiddenSettingsMutation = { __typename?: 'Mutation', enterpriseAccountUpdateHiddenSettings: { __typename?: 'EnterpriseAccountUpdateHiddenSettingsPayload', success: boolean } };

export type UpdateUserLocaleMutationVariables = Exact<{
  userLocale: Scalars['String'];
}>;


export type UpdateUserLocaleMutation = { __typename?: 'Mutation', enterpriseAccountUpdateUserLocale: { __typename?: 'EnterpriseAccountUpdateUserLocalePayload', success: boolean } };

export type FetchFeatureToggleFullyEnabledQueryVariables = Exact<{
  featureName: Scalars['String'];
}>;


export type FetchFeatureToggleFullyEnabledQuery = { __typename?: 'Query', featureToggleFullyEnabled: { __typename?: 'FeatureTogglesEnabledCheck', enabled: boolean } };

export type CurrentEnterpriseAccountOverviewFragmentFragment = { __typename?: 'EnterpriseAccount', canonicalId: string, id: string, createdAt: string, givenName: string, surname: string, email: string, accountStateValid: boolean, isInternal: boolean, authServiceRequired: boolean, assignedPartnerIds: Array<string>, assignedRetailerIds: Array<string>, assignedRetailerLocationIds: Array<string>, mfaEnabled: boolean, mfaEnabledAt: string, mfaDeactivatedAt: string, isImpersonating: boolean, userLocale: string, canUpdatePartnerWriteAccess: boolean, hasAllPartnersWriteAccess: boolean, authentication: { __typename?: 'EnterpriseAuthenticationEmailPassword', emailVerified: boolean }, featureToggles: Array<{ __typename?: 'FeatureToggle', name: string }>, featureExperiments: Array<{ __typename?: 'FeatureExperiment', name: string, variant: string }>, policies: { __typename?: 'AccessControlPolicies', viewAdminToolsSection: boolean, viewRetailerDashboardSection: boolean }, internalAccessConfiguration: { __typename?: 'EnterpriseInternalAccessConfiguration', hasAllPartnersFullAccess: boolean, hasFullPartnerAccess: boolean, hasFullRetailerAccess: boolean, hasNothingAccessible: boolean }, roles: Array<{ __typename?: 'EnterpriseRole', slug: string }>, permissions: Array<{ __typename?: 'EnterprisePermission', slug: string }>, acceptedPartnerAgreements: Array<{ __typename?: 'EnterpriseAcceptedPartnerAgreement', partnerId: string, agreementType: AgreementTypeEnum }>, hiddenSettings: { __typename?: 'EnterpriseAccountSettingsHiddenSettings', rsatPulseSurvey: { __typename?: 'EnterpriseAccountSettingsRsatPulseSurvey', lastSeenTime: string, seenCount: number, slug: RsatPulseSurveySlugEnum, hasSubmitted: boolean } }, partnerWriteAccess: Array<{ __typename?: 'EnterprisePartnerWriteAccess', partnerId: string, partner: { __typename?: 'Partner', id: string, name: string } }> };

export type LookupAccountForImpersonationQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  canonicalIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LookupAccountForImpersonationQuery = { __typename?: 'Query', enterpriseAccountSearch: { __typename?: 'EnterpriseAccountConnection', edges: Array<{ __typename?: 'EnterpriseAccountEdge', node: { __typename?: 'EnterpriseAccount', canonicalId: string, givenName: string, surname: string, email: string, canImpersonate: boolean, impersonateFailureReason: string, impersonateMissingPermissionsSlugs: Array<string> } }>, meta: { __typename?: 'ConnectionMeta', totalCount: number } } };

export type StartImpersonationMutationVariables = Exact<{
  impersonatedCanonicalId: Scalars['ID'];
  breakglass?: InputMaybe<Scalars['Boolean']>;
  breakglassReason?: InputMaybe<Scalars['String']>;
  breakglassJiraTicket?: InputMaybe<Scalars['String']>;
  breakglassAdditionalInfo?: InputMaybe<Scalars['String']>;
}>;


export type StartImpersonationMutation = { __typename?: 'Mutation', enterpriseAccountEnableImpersonation: { __typename?: 'EnterpriseAccountEnableImpersonationPayload', success: true } };

export type CheckLaunchOnboardingProgressByPartnerQueryVariables = Exact<{
  partnerId: Scalars['BigInt'];
}>;


export type CheckLaunchOnboardingProgressByPartnerQuery = { __typename?: 'Query', onboardingServiceCheckLaunchOnboardingProgressByPartner: { __typename?: 'CheckLaunchOnboardingProgressByPartnerResponse', workflowState: string } };

export type FetchPartnersQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type FetchPartnersQuery = { __typename?: 'Query', partners: Array<{ __typename?: 'Partner', id: string, name: string, partnerType: string, retailers: Array<{ __typename?: 'Retailer', id: string, logo: { __typename?: 'Logo', url: string } }> }> };

export type GetAllPartnersForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPartnersForUserQuery = { __typename?: 'Query', partnerSearchArray: Array<{ __typename?: 'Partner', id: string, name: string, partnerType: string }> };

export type GetAllPartnersForUserPaginatedQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllPartnersForUserPaginatedQuery = { __typename?: 'Query', partnerRetailerSearch: { __typename?: 'PartnerConnection', nodes: Array<{ __typename?: 'Partner', id: string, name: string, partnerType: string, retailers: Array<{ __typename?: 'Retailer', id: string, name: string, logo: { __typename?: 'Logo', url: string } }> }> } };

export type GetRetailersForPartnerQueryVariables = Exact<{
  partnerId: Scalars['ID'];
}>;


export type GetRetailersForPartnerQuery = { __typename?: 'Query', partner: { __typename?: 'Partner', id: string, name: string, partnerType: string, featureToggles: Array<{ __typename?: 'FeatureToggle', name: string }>, featureTogglesByRetailer: Array<{ __typename?: 'FeatureToggleByRetailerId', retailerId: string, featureToggles: Array<{ __typename?: 'FeatureToggle', name: string }> }>, retailers: Array<{ __typename?: 'Retailer', id: string, name: string, locationFeatures: Array<LocationFeatureEnum>, slug: string, warehouseGroup: { __typename?: 'WarehouseGroup', franchisorId: string, franchisorName: string }, featureEntitlements: Array<{ __typename?: 'FeatureEntitlement', id: string, name: string }>, country: { __typename?: 'Country', id: string, name: string }, logo: { __typename?: 'Logo', url: string } }> } };

export type FetchDepartmentsAndAislesItemsMeshQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['BigInt']>;
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode: InstacartCustomersSharedV1Locale;
}>;


export type FetchDepartmentsAndAislesItemsMeshQuery = { __typename?: 'Query', retailerToolsServiceGetItems: { __typename?: 'GetItemsResponse', totalCount: string, results: Array<{ __typename?: 'Item', localeCode: string, primaryAisleId: string, primaryImageUrl: string, productCodes: Array<string>, productDisplayName: string, productId: string, retailerId: string, retailerReferenceCode: string }> } };

export type FetchDepartmentsAndAislesProductsInfoMeshQueryVariables = Exact<{
  retailerId: Scalars['BigInt'];
  productIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;


export type FetchDepartmentsAndAislesProductsInfoMeshQuery = { __typename?: 'Query', catalogToolsApiServiceGetRetailerProductData: { __typename?: 'GetRetailerProductDataResponse', retailerProductData: Array<{ __typename?: 'RetailerProductData', productId: string, availableItemsCount: string }> } };

export type FetchDepartmentsAndAislesProductsMeshQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['BigInt']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  offset?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  localeCode: InstacartCustomersSharedV1Locale;
  withUnclassifiedProducts?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchDepartmentsAndAislesProductsMeshQuery = { __typename?: 'Query', retailerToolsServiceGetRetailerProducts: { __typename?: 'GetRetailerProductsResponse', totalCount: string, results: Array<{ __typename?: 'RetailerProduct', productDisplayName: string, primaryImageUrl: string, productId: string, productCodes: Array<string> }> } };

export type FetchPrimaryAisleProductCountQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['BigInt']>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
}>;


export type FetchPrimaryAisleProductCountQuery = { __typename?: 'Query', retailerToolsServiceGetRetailerProducts: { __typename?: 'GetRetailerProductsResponse', totalCount: string } };

export type RetailerSatisfactionSurveyMutationVariables = Exact<{
  retailerId?: InputMaybe<Scalars['ID']>;
  accountId: Scalars['ID'];
  partnerId?: InputMaybe<Scalars['ID']>;
  urlPath: Scalars['String'];
  surveyResponses: Array<RetailerSatisfactionSurveyResponse> | RetailerSatisfactionSurveyResponse;
  shownAt: Scalars['String'];
  submittedAt: Scalars['String'];
  milestoneSlug?: InputMaybe<Scalars['String']>;
  workflowSlug?: InputMaybe<Scalars['String']>;
}>;


export type RetailerSatisfactionSurveyMutation = { __typename?: 'Mutation', retailerSatisfactionSurveySubmissionCreate: { __typename?: 'SubmissionCreatePayload', success: boolean } };

export type RetailerSatisfactionSurveyFrequencyQueryVariables = Exact<{ [key: string]: never; }>;


export type RetailerSatisfactionSurveyFrequencyQuery = { __typename?: 'Query', retailerSatisfactionSurveySubmissionFrequency: Array<{ __typename?: 'RetailerSatisfactionSurveyTypesSubmissionRecord', milestoneSlug: string, workflowSlug: string, submittedAt: any }> };

export type GetAllRetailerLocationsForRetailerQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetAllRetailerLocationsForRetailerQuery = { __typename?: 'Query', retailerLocationSearchArray: Array<{ __typename?: 'RetailerLocation', id: string, name: string, street: string, city: string, state: string, zipCode: string, locationCode: string, active: boolean, pickup: boolean, pickingModel: PickingModelEnum, fulfillmentModels: Array<FulfillmentModelEnum>, partnerAlcoholDelivery: boolean, partnerDeliveryDriversEnabled: boolean, hybridPickingEnabled: boolean, retailerId: string }> };

export type V4GetRetailersLocationsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type V4GetRetailersLocationsQuery = { __typename?: 'Query', instacart_customers_partners_v1_PartnersService_GetRetailerLocations: { __typename?: 'instacart_customers_partners_v1_GetRetailerLocationsResponse', retailerLocations: Array<{ __typename?: 'instacart_customers_partners_v1_RetailerLocation', active: boolean, addressCounty: string, addressId: string, bagFeeRateCents: string, city: string, id: string, issEnabled: boolean, latitude: number, locationCode: string, longitude: number, name: string, partnerPickup: boolean, pickup: boolean, pickupOnly: boolean, postalCode: string, retailerId: string, state: string, streetAddress: string, inventoryAreaId: string, zipPlusFour: string }> } };

export type V4GetRetailersLocationsByRetailerQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type V4GetRetailersLocationsByRetailerQuery = { __typename?: 'Query', instacart_customers_partners_v1_PartnersService_GetRetailerLocationsByRetailer: { __typename?: 'instacart_customers_partners_v1_GetRetailerLocationsByRetailerResponse', retailerLocations: Array<{ __typename?: 'instacart_customers_partners_v1_RetailerLocation', active: boolean, addressCounty: string, addressId: string, bagFeeRateCents: string, city: string, id: string, latitude: number, locationCode: string, longitude: number, name: string, postalCode: string, retailerId: string, state: string, streetAddress: string }> } };

export type GetRetailerQueryVariables = Exact<{
  retailerId: Scalars['ID'];
}>;


export type GetRetailerQuery = { __typename?: 'Query', retailer: { __typename?: 'Retailer', id: string, name: string, locationFeatures: Array<LocationFeatureEnum>, slug: string, partner: { __typename?: 'Partner', id: string, name: string, partnerType: string }, featureToggles: Array<{ __typename?: 'FeatureToggle', name: string }>, featureEntitlements: Array<{ __typename?: 'FeatureEntitlement', id: string, name: string }>, country: { __typename?: 'Country', id: string, name: string }, logo: { __typename?: 'Logo', url: string } } };

export type GetRetailerLocalesMeshQueryVariables = Exact<{
  retailerId: Scalars['BigInt'];
}>;


export type GetRetailerLocalesMeshQuery = { __typename?: 'Query', catalogToolsApiServiceGetLocalesByRetailer: { __typename?: 'GetLocalesByRetailerResponse', retailerLocales: Array<{ __typename?: 'RetailerLocale', localeId: string, localeCode: string }> } };

export type GetRetailerSearchQueryVariables = Exact<{
  partnerId: Scalars['ID'];
  retailerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  name: Scalars['String'];
}>;


export type GetRetailerSearchQuery = { __typename?: 'Query', retailerSearchArray: Array<{ __typename?: 'Retailer', id: string, name: string, logo: { __typename?: 'Logo', url: string } }> };

export type V4GetRetailersQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type V4GetRetailersQuery = { __typename?: 'Query', instacart_customers_partners_v1_PartnersService_GetRetailers: { __typename?: 'instacart_customers_partners_v1_GetRetailersResponse', retailers: Array<{ __typename?: 'instacart_customers_partners_v1_Retailer', adminOnly: boolean, allowAlcohol: boolean, allowSpecialRequests: boolean, backgroundColorHex: string, backgroundImagePath: string, categories: Array<string>, countrySlug: string, description: string, franchiseeId: string, id: string, logoImagePath: string, name: string, priceTransparencyDescription: string, priceTransparencyFlag: string, retailerType: string, slug: string }> } };

export type GetStoreConfigsQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID'];
  storeConfigRelationship: StoreConfigurationRelationshipEnum;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetStoreConfigsQuery = { __typename?: 'Query', storeConfigurationsByRetailerIds: Array<{ __typename?: 'InstacartStoreConfiguration', id: string, slug: string, brandedName: string, whitelistedWarehouseIds: Array<string>, domainName: string, deApplicationPlatform: string, createdAt: string, updatedAt: string, allowAllWarehouses: boolean, logoUrl: string, userAccessToModify: boolean, active: boolean, userIsolationContextId: string, clientConfigurationIds: Array<string>, legal: { __typename?: 'InstacartStoreConfigurationLegal', shortName: string }, partnerAccessSettings: { __typename?: 'InstacartStoreConfigurationPartnerAccessSettings', visibleToPartnersOnIpp: boolean, modificationRules: { __typename?: 'InstacartStoreConfigurationModificationRules', allowlistPartnerIds: Array<string> } } }> };

export type GetStoreConfigsByPartnerIdQueryVariables = Exact<{
  partnerId: Scalars['ID'];
  storeConfigRelationship: StoreConfigurationRelationshipEnum;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetStoreConfigsByPartnerIdQuery = { __typename?: 'Query', storeConfigurationsByPartnerId: Array<{ __typename?: 'InstacartStoreConfiguration', id: string, slug: string, brandedName: string, whitelistedWarehouseIds: Array<string>, domainName: string, deApplicationPlatform: string, createdAt: string, updatedAt: string, allowAllWarehouses: boolean, logoUrl: string, userAccessToModify: boolean, active: boolean, userIsolationContextId: string, clientConfigurationIds: Array<string>, legal: { __typename?: 'InstacartStoreConfigurationLegal', shortName: string }, partnerAccessSettings: { __typename?: 'InstacartStoreConfigurationPartnerAccessSettings', visibleToPartnersOnIpp: boolean, modificationRules: { __typename?: 'InstacartStoreConfigurationModificationRules', allowlistPartnerIds: Array<string> } } }> };

export type CreateStoreGroupMutationVariables = Exact<{
  name: Scalars['String'];
  partnerId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CreateStoreGroupMutation = { __typename?: 'Mutation', retailerLocationGroupCreate: { __typename?: 'RetailerLocationGroupCreatePayload', retailerLocationGroup: { __typename?: 'RetailersRetailerLocationGroup', id: string, name: string, updatedAt: string, retailerLocationIds: Array<string> } } };

export type GetStoreGroupsByRetailerQueryVariables = Exact<{
  partnerId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetStoreGroupsByRetailerQuery = { __typename?: 'Query', retailerLocationGroupsByRetailer: { __typename?: 'RetailersRetailerLocationGroupConnection', nodes: Array<{ __typename?: 'RetailersRetailerLocationGroup', id: string, name: string, retailerLocationIds: Array<string> }> } };

export type GetTaxonomyNodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxonomyNodesQuery = { __typename?: 'Query', taxonomyNodes: Array<{ __typename?: 'CatalogTaxonomyNode', id: string, name: string, parentId: string }> };

export type GetTotemEntityQueryVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type GetTotemEntityQuery = { __typename?: 'Query', instacart_infra_totem_v1_TotemService_GetEntity: { __typename?: 'instacart_infra_totem_v1_GetEntityResponse', entity: { __typename?: 'instacart_infra_totem_v1_Entity', name: string, external_id: string, system_name: string, metadata: any } } };

export type GetTotemSystemQueryVariables = Exact<{
  systemName: Scalars['String'];
}>;


export type GetTotemSystemQuery = { __typename?: 'Query', instacart_infra_totem_v1_TotemService_GetSystem: { __typename?: 'instacart_infra_totem_v1_GetSystemResponse', system: { __typename?: 'instacart_infra_totem_v1_System', name: string, owner_team: { __typename?: 'instacart_infra_totem_v1_Team', workday_org_name: string, name: string }, contact_details: { __typename?: 'instacart_infra_totem_v1_ContactDetails', general_slack_channels: { __typename?: 'instacart_infra_totem_v1_SlackChannelList', channels: Array<{ __typename?: 'instacart_infra_totem_v1_SlackChannel', id: string, handle: string, type: Instacart_Infra_Totem_V1_SlackChannelType }> }, oncall_slack_group: { __typename?: 'instacart_infra_totem_v1_SlackChannel', type: Instacart_Infra_Totem_V1_SlackChannelType, handle: string }, opsgenie_responder: { __typename?: 'instacart_infra_totem_v1_OpsgenieResponder', id: string, name: string } } } } };

export type GetTotemSystemLimitedQueryVariables = Exact<{
  systemName: Scalars['String'];
}>;


export type GetTotemSystemLimitedQuery = { __typename?: 'Query', instacart_infra_totem_v1_TotemService_GetSystem: { __typename?: 'instacart_infra_totem_v1_GetSystemResponse', system: { __typename?: 'instacart_infra_totem_v1_System', name: string, owner_team: { __typename?: 'instacart_infra_totem_v1_Team', name: string }, contact_details: { __typename?: 'instacart_infra_totem_v1_ContactDetails', oncall_slack_group: { __typename?: 'instacart_infra_totem_v1_SlackChannel', handle: string }, opsgenie_responder: { __typename?: 'instacart_infra_totem_v1_OpsgenieResponder', name: string } } } } };

export type SearchEnterpriseAccountsAccountSelectQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['ID'];
  canonicalIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SearchEnterpriseAccountsAccountSelectQuery = { __typename?: 'Query', enterpriseAccountSearch: { __typename?: 'EnterpriseAccountConnection', edges: Array<{ __typename?: 'EnterpriseAccountEdge', node: { __typename?: 'EnterpriseAccount', givenName: string, surname: string, email: string, canonicalId: string } }> } };

export type FetchAislesForDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID'];
}>;


export type FetchAislesForDepartmentQuery = { __typename?: 'Query', catalogDepartment: { __typename?: 'CatalogDepartment', aisles: Array<{ __typename?: 'CatalogAisle', id: string, name: string }> } };

export type FetchDepartmentsForRetailerQueryVariables = Exact<{
  retailerId: Scalars['ID'];
}>;


export type FetchDepartmentsForRetailerQuery = { __typename?: 'Query', retailer: { __typename?: 'Retailer', departments: Array<{ __typename?: 'CatalogDepartment', id: string, name: string }> } };

export type StopImpersonationSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type StopImpersonationSessionMutation = { __typename?: 'Mutation', enterpriseAccountDisableImpersonation: { __typename?: 'EnterpriseAccountDisableImpersonationPayload', success: true } };

export type ListStoreGroupsQueryVariables = Exact<{
  partnerId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  matchType?: InputMaybe<RetailerLocationGroupQuery>;
  numGroups?: InputMaybe<Scalars['Int']>;
  afterGroup?: InputMaybe<Scalars['String']>;
}>;


export type ListStoreGroupsQuery = { __typename?: 'Query', retailerLocationGroupsByRetailer: { __typename?: 'RetailersRetailerLocationGroupConnection', edges: Array<{ __typename?: 'RetailersRetailerLocationGroupEdge', cursor: string, node: { __typename?: 'RetailersRetailerLocationGroup', id: string, name: string, updatedAt: string, retailerLocationIds: Array<string>, retailerIds: Array<string> } }> } };

export type CreateTempOverrideMutationVariables = Exact<{
  data: Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityInput_Input>> | InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityInput_Input>;
}>;


export type CreateTempOverrideMutation = { __typename?: 'Mutation', instacart_catalog_admin_v1_TempOverrideService_Create: any };

export type GetCatalogItemsQueryVariables = Exact<{
  data: Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Input;
}>;


export type GetCatalogItemsQuery = { __typename?: 'Query', instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetItems: { __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetItemsResponse', results: { __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetItemsResponse_Results', totalCount: string, items: Array<{ __typename?: 'instacart_customers_product_retrieval_v1_Item', itemId: string, itemAttributes: { __typename?: 'instacart_customers_product_retrieval_v1_ItemAttributes', retailerId: number, productId: number, inventoryAreaId: number, elasticItemId: string, generatedAt: any, alcoholic: boolean, available: boolean, balanceOnHandQty: number, bottleDepositBankId: number, bottleDepositCents: number, bottleDepositCurrency: string, codeSetVersion: number, cost: string, costPricePerUnit: string, costUnit: string, fullPrice: string, hasRetailerPromotion: boolean, isAlcoholic: boolean, itemType: string, loyaltyAllowed: boolean, loyaltyCostPriceCents: number, loyaltyCostPriceCurrency: string, loyaltyCostPriceEndAt: any, loyaltyCostPricePerUnit: string, loyaltyCostPriceStartAt: any, loyaltyPrice: string, loyaltyPriceActive: boolean, loyaltyPriceEndAt: any, loyaltyPriceStartAt: any, onSale: boolean, parWeight: number, price: string, priceMultiple: number, pricePerUnit: string, productType: string, recentlyShoppedAt: any, retailerProductScoreBrowseCtrPopV0: number, regionId: number, retailerSpecifiedAlcoholic: boolean, retailerSalesTaxRate: number, saleAllowed: boolean, salePriceCents: number, saleCostPricePerUnit: string, saleEndAt: any, saleStartAt: any, searchable: boolean, taxable: boolean, unataAvailable: boolean, unit: string, unitCount: number, unitPrice: number, unlisted: boolean, useWeight: boolean, visible: boolean, createdAt: any, updatedAt: any, promotionDiscountBeginsAt: any, promotionDiscountEndsAt: any, bogoBuy: number, bogoGet: number, maxInCart: number, temporaryOverrideElasticItemId: string, fullText: string, maxCart: number, cancelLeadTime: number, isCatering: boolean, orderLeadTime: number, usaSnapEligible: boolean, fulfillPickup: boolean, fulfillDelivery: boolean, fulfillInstore: boolean, loyaltyMembersOnly: boolean, promotionGroupId: string, isHot: boolean, salesType: string, localeCode: string, availabilityStartDate: any, availabilityEndDate: any, isPackagedByWeight: boolean, retailerProductExperimentVariantId: number, retailerPromotionFractionApproximation: number, usaEbtcashEligible: boolean, sfBbTempFlag: boolean, palletQuantity: string, inAssortment: boolean, sizeUomVariable: string, mentosItemPartialRowId: string, catalogEntityId: string, surfaceId: string, pricedBySoldByType: string, eversightPricing: string, unataInAssortment: boolean, proviDistributorIds: Array<string>, excludeMarkup: boolean, rewardProgram: string, rewardValue: number, rewardUnit: string, retailerDepartment: string }, retailerProductsAttributes: { __typename?: 'instacart_customers_product_retrieval_v1_RetailerProductsAttributes', size: string, sizeUom: string, brandName: string, largeImageUrl: string, primaryImageUrl: string, aisleIds: string, aisleNames: string, displayName: string, productCodes: string }, inventoryAreaAttributes: { __typename?: 'instacart_customers_product_retrieval_v1_InventoryAreaAttributes', inventoryAreaId: string, name: string, regionId: string, warehouseId: string } }> } } };

export type ListTempTakedownOverridesQueryVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input>> | InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input>>;
}>;


export type ListTempTakedownOverridesQuery = { __typename?: 'Query', instacart_catalog_admin_v1_TempOverrideService_List: { __typename?: 'instacart_catalog_admin_v1_TempOverrideServiceListResponse', tempOverrideEntities: Array<{ __typename?: 'instacart_catalog_admin_v1_TempOverrideEntityOutput', entityId: { __typename?: 'instacart_catalog_admin_v1_TempOverrideEntityId', itemId: string, localeId: string, productId: string, retailerId: string, surfaceId: string }, tempOverrideAttrs: Array<{ __typename?: 'instacart_catalog_admin_v1_TempOverrideAttrOutput', attribute: string, createdAt: any }> }> } };

export type RetailerProductAggregateDataQueryVariables = Exact<{
  retailerId: Scalars['BigInt'];
  productIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;


export type RetailerProductAggregateDataQuery = { __typename?: 'Query', catalogToolsApiServiceGetRetailerProductData: { __typename?: 'GetRetailerProductDataResponse', retailerProductData: Array<{ __typename?: 'RetailerProductData', retailerId: string, productId: string, maxPriceCents: string, minPriceCents: string, availableItemsCount: string, visibleItemsCount: string, itemsCount: string, generatedAt: any }> } };

export type RetailerProductSearchQueryVariables = Exact<{
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['BigInt'];
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type RetailerProductSearchQuery = { __typename?: 'Query', retailerToolsServiceGetRetailerProducts: { __typename?: 'GetRetailerProductsResponse', totalCount: string, results: Array<{ __typename?: 'RetailerProduct', localeCode: string, primaryAisleId: string, primaryDepartmentId: string, primaryImageUrl: string, productCodes: Array<string>, productDisplayName: string, productId: string, retailerId: string, retailerReferenceCode: string, score: number, aisles: Array<{ __typename?: 'RetailerProductAisle', id: string, name: string }>, departments: Array<{ __typename?: 'RetailerProductDepartment', id: string, name: string }> }> } };

export type GetIcPlatformVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIcPlatformVersionsQuery = { __typename?: 'Query', retailersServiceGetPlatformVersions: { __typename?: 'GetPlatformVersionsResponse', platformVersion: string, platformVersionRouletteName: string, nextPlatformVersion: string, nextPlatformVersionRouletteName: string } };

export const CurrentEnterpriseAccountOverviewFragmentFragmentDoc = gql`
    fragment CurrentEnterpriseAccountOverviewFragment on EnterpriseAccount {
  canonicalId
  id
  createdAt
  givenName
  surname
  email
  accountStateValid
  isInternal
  authServiceRequired
  assignedPartnerIds
  assignedRetailerIds
  assignedRetailerLocationIds
  authentication {
    ... on EnterpriseAuthenticationEmailPassword {
      emailVerified
    }
  }
  featureToggles {
    name
  }
  featureExperiments {
    name
    variant
  }
  policies {
    viewAdminToolsSection
    viewRetailerDashboardSection
  }
  internalAccessConfiguration {
    hasAllPartnersFullAccess
    hasFullPartnerAccess
    hasFullRetailerAccess
    hasNothingAccessible
  }
  roles {
    slug
  }
  permissions {
    slug
  }
  mfaEnabled
  mfaEnabledAt
  mfaDeactivatedAt
  acceptedPartnerAgreements {
    partnerId
    agreementType
  }
  isImpersonating
  hiddenSettings {
    rsatPulseSurvey {
      lastSeenTime
      seenCount
      slug
      hasSubmitted
    }
  }
  userLocale
  canUpdatePartnerWriteAccess
  partnerWriteAccess {
    partnerId
    partner {
      id
      name
    }
  }
  hasAllPartnersWriteAccess
}
    `;
export const AiAgentConversationUpsertDocument = gql`
    mutation AiAgentConversationUpsert($conversationId: ID!, $messages: [ChatMessageInput!]!) {
  aiAgentConversationUpsert(conversationId: $conversationId, messages: $messages) {
    success
  }
}
    `;

/**
 * __useAiAgentConversationUpsertMutation__
 *
 * To run a mutation, you first call `useAiAgentConversationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiAgentConversationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiAgentConversationUpsertMutation, { data, loading, error }] = useAiAgentConversationUpsertMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useAiAgentConversationUpsertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiAgentConversationUpsertMutation, AiAgentConversationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiAgentConversationUpsertMutation, AiAgentConversationUpsertMutationVariables>(AiAgentConversationUpsertDocument, options);
      }
export type AiAgentConversationUpsertMutationHookResult = ReturnType<typeof useAiAgentConversationUpsertMutation>;
export type AiAgentConversationUpsertMutationResult = ApolloReactCommon.MutationResult<AiAgentConversationUpsertMutation>;
export type AiAgentConversationUpsertMutationOptions = ApolloReactCommon.BaseMutationOptions<AiAgentConversationUpsertMutation, AiAgentConversationUpsertMutationVariables>;
export const AiAgentExecuteDocument = gql`
    mutation AiAgentExecute($input: AgentRequestInput!) {
  aiAgentExecute(input: $input) {
    messages {
      content
      role
      toolCalls {
        id
        type
        function {
          name
          arguments
        }
      }
      toolCallId
    }
    finalResult
    summary
  }
}
    `;

/**
 * __useAiAgentExecuteMutation__
 *
 * To run a mutation, you first call `useAiAgentExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiAgentExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiAgentExecuteMutation, { data, loading, error }] = useAiAgentExecuteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiAgentExecuteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AiAgentExecuteMutation, AiAgentExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AiAgentExecuteMutation, AiAgentExecuteMutationVariables>(AiAgentExecuteDocument, options);
      }
export type AiAgentExecuteMutationHookResult = ReturnType<typeof useAiAgentExecuteMutation>;
export type AiAgentExecuteMutationResult = ApolloReactCommon.MutationResult<AiAgentExecuteMutation>;
export type AiAgentExecuteMutationOptions = ApolloReactCommon.BaseMutationOptions<AiAgentExecuteMutation, AiAgentExecuteMutationVariables>;
export const AcceptPartnerAgreementDocument = gql`
    mutation acceptPartnerAgreement($partnerId: ID!, $agreementType: AgreementTypeEnum!) {
  enterpriseAccountAcceptPartnerAgreement(
    partnerId: $partnerId
    agreementType: $agreementType
  ) {
    acceptedPartnerAgreement {
      partnerId
      agreementType
    }
  }
}
    `;

/**
 * __useAcceptPartnerAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptPartnerAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPartnerAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPartnerAgreementMutation, { data, loading, error }] = useAcceptPartnerAgreementMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      agreementType: // value for 'agreementType'
 *   },
 * });
 */
export function useAcceptPartnerAgreementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptPartnerAgreementMutation, AcceptPartnerAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptPartnerAgreementMutation, AcceptPartnerAgreementMutationVariables>(AcceptPartnerAgreementDocument, options);
      }
export type AcceptPartnerAgreementMutationHookResult = ReturnType<typeof useAcceptPartnerAgreementMutation>;
export type AcceptPartnerAgreementMutationResult = ApolloReactCommon.MutationResult<AcceptPartnerAgreementMutation>;
export type AcceptPartnerAgreementMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptPartnerAgreementMutation, AcceptPartnerAgreementMutationVariables>;
export const FetchCurrentEnterpriseAccountDocument = gql`
    query fetchCurrentEnterpriseAccount {
  currentEnterpriseAccount {
    ...CurrentEnterpriseAccountOverviewFragment
  }
}
    ${CurrentEnterpriseAccountOverviewFragmentFragmentDoc}`;

/**
 * __useFetchCurrentEnterpriseAccountQuery__
 *
 * To run a query within a React component, call `useFetchCurrentEnterpriseAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentEnterpriseAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentEnterpriseAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentEnterpriseAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchCurrentEnterpriseAccountQuery, FetchCurrentEnterpriseAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchCurrentEnterpriseAccountQuery, FetchCurrentEnterpriseAccountQueryVariables>(FetchCurrentEnterpriseAccountDocument, options);
      }
export function useFetchCurrentEnterpriseAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchCurrentEnterpriseAccountQuery, FetchCurrentEnterpriseAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchCurrentEnterpriseAccountQuery, FetchCurrentEnterpriseAccountQueryVariables>(FetchCurrentEnterpriseAccountDocument, options);
        }
export type FetchCurrentEnterpriseAccountQueryHookResult = ReturnType<typeof useFetchCurrentEnterpriseAccountQuery>;
export type FetchCurrentEnterpriseAccountLazyQueryHookResult = ReturnType<typeof useFetchCurrentEnterpriseAccountLazyQuery>;
export type FetchCurrentEnterpriseAccountQueryResult = ApolloReactCommon.QueryResult<FetchCurrentEnterpriseAccountQuery, FetchCurrentEnterpriseAccountQueryVariables>;
export const FetchCurrentEnterpriseAccountCoreDocument = gql`
    query fetchCurrentEnterpriseAccountCore {
  currentEnterpriseAccount {
    canonicalId
    id
    createdAt
    givenName
    surname
    email
    accountStateValid
    isInternal
    authServiceRequired
    assignedPartnerIds
    assignedRetailerIds
    assignedRetailerLocationIds
    authentication {
      ... on EnterpriseAuthenticationEmailPassword {
        emailVerified
      }
    }
    featureExperiments {
      name
      variant
    }
    policies {
      viewAdminToolsSection
      viewRetailerDashboardSection
    }
    internalAccessConfiguration {
      hasAllPartnersFullAccess
      hasFullPartnerAccess
      hasFullRetailerAccess
      hasNothingAccessible
    }
    roles {
      slug
    }
    permissions {
      slug
    }
    mfaEnabled
    mfaEnabledAt
    mfaDeactivatedAt
    acceptedPartnerAgreements {
      partnerId
      agreementType
    }
    isImpersonating
    hiddenSettings {
      rsatPulseSurvey {
        lastSeenTime
        seenCount
        slug
        hasSubmitted
      }
    }
    userLocale
    canUpdatePartnerWriteAccess
    partnerWriteAccess {
      partnerId
      partner {
        id
        name
      }
    }
    hasAllPartnersWriteAccess
  }
}
    `;

/**
 * __useFetchCurrentEnterpriseAccountCoreQuery__
 *
 * To run a query within a React component, call `useFetchCurrentEnterpriseAccountCoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentEnterpriseAccountCoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentEnterpriseAccountCoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentEnterpriseAccountCoreQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchCurrentEnterpriseAccountCoreQuery, FetchCurrentEnterpriseAccountCoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchCurrentEnterpriseAccountCoreQuery, FetchCurrentEnterpriseAccountCoreQueryVariables>(FetchCurrentEnterpriseAccountCoreDocument, options);
      }
export function useFetchCurrentEnterpriseAccountCoreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchCurrentEnterpriseAccountCoreQuery, FetchCurrentEnterpriseAccountCoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchCurrentEnterpriseAccountCoreQuery, FetchCurrentEnterpriseAccountCoreQueryVariables>(FetchCurrentEnterpriseAccountCoreDocument, options);
        }
export type FetchCurrentEnterpriseAccountCoreQueryHookResult = ReturnType<typeof useFetchCurrentEnterpriseAccountCoreQuery>;
export type FetchCurrentEnterpriseAccountCoreLazyQueryHookResult = ReturnType<typeof useFetchCurrentEnterpriseAccountCoreLazyQuery>;
export type FetchCurrentEnterpriseAccountCoreQueryResult = ApolloReactCommon.QueryResult<FetchCurrentEnterpriseAccountCoreQuery, FetchCurrentEnterpriseAccountCoreQueryVariables>;
export const FetchCurrentEnterpriseAccountFeatureTogglesDocument = gql`
    query fetchCurrentEnterpriseAccountFeatureToggles {
  currentEnterpriseAccount {
    id
    featureToggles {
      name
    }
  }
}
    `;

/**
 * __useFetchCurrentEnterpriseAccountFeatureTogglesQuery__
 *
 * To run a query within a React component, call `useFetchCurrentEnterpriseAccountFeatureTogglesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentEnterpriseAccountFeatureTogglesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentEnterpriseAccountFeatureTogglesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentEnterpriseAccountFeatureTogglesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchCurrentEnterpriseAccountFeatureTogglesQuery, FetchCurrentEnterpriseAccountFeatureTogglesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchCurrentEnterpriseAccountFeatureTogglesQuery, FetchCurrentEnterpriseAccountFeatureTogglesQueryVariables>(FetchCurrentEnterpriseAccountFeatureTogglesDocument, options);
      }
export function useFetchCurrentEnterpriseAccountFeatureTogglesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchCurrentEnterpriseAccountFeatureTogglesQuery, FetchCurrentEnterpriseAccountFeatureTogglesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchCurrentEnterpriseAccountFeatureTogglesQuery, FetchCurrentEnterpriseAccountFeatureTogglesQueryVariables>(FetchCurrentEnterpriseAccountFeatureTogglesDocument, options);
        }
export type FetchCurrentEnterpriseAccountFeatureTogglesQueryHookResult = ReturnType<typeof useFetchCurrentEnterpriseAccountFeatureTogglesQuery>;
export type FetchCurrentEnterpriseAccountFeatureTogglesLazyQueryHookResult = ReturnType<typeof useFetchCurrentEnterpriseAccountFeatureTogglesLazyQuery>;
export type FetchCurrentEnterpriseAccountFeatureTogglesQueryResult = ApolloReactCommon.QueryResult<FetchCurrentEnterpriseAccountFeatureTogglesQuery, FetchCurrentEnterpriseAccountFeatureTogglesQueryVariables>;
export const GetPermissionsDocument = gql`
    query getPermissions($roleId: ID, $retailerId: ID) {
  permissions(roleId: $roleId, retailerId: $retailerId) {
    slug
    isRetailerRoleAssignable
  }
}
    `;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsQueryResult = ApolloReactCommon.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const RequestBreakGlassPartnerWriteAccessDocument = gql`
    mutation requestBreakGlassPartnerWriteAccess($partnerIds: [ID!]!, $userJustification: String!, $ticketUrl: String!) {
  enterpriseAccountRequestBreakGlassPartnerWriteAccess(
    partnerIds: $partnerIds
    userJustification: $userJustification
    ticketUrl: $ticketUrl
  ) {
    success
  }
}
    `;

/**
 * __useRequestBreakGlassPartnerWriteAccessMutation__
 *
 * To run a mutation, you first call `useRequestBreakGlassPartnerWriteAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBreakGlassPartnerWriteAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBreakGlassPartnerWriteAccessMutation, { data, loading, error }] = useRequestBreakGlassPartnerWriteAccessMutation({
 *   variables: {
 *      partnerIds: // value for 'partnerIds'
 *      userJustification: // value for 'userJustification'
 *      ticketUrl: // value for 'ticketUrl'
 *   },
 * });
 */
export function useRequestBreakGlassPartnerWriteAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestBreakGlassPartnerWriteAccessMutation, RequestBreakGlassPartnerWriteAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestBreakGlassPartnerWriteAccessMutation, RequestBreakGlassPartnerWriteAccessMutationVariables>(RequestBreakGlassPartnerWriteAccessDocument, options);
      }
export type RequestBreakGlassPartnerWriteAccessMutationHookResult = ReturnType<typeof useRequestBreakGlassPartnerWriteAccessMutation>;
export type RequestBreakGlassPartnerWriteAccessMutationResult = ApolloReactCommon.MutationResult<RequestBreakGlassPartnerWriteAccessMutation>;
export type RequestBreakGlassPartnerWriteAccessMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestBreakGlassPartnerWriteAccessMutation, RequestBreakGlassPartnerWriteAccessMutationVariables>;
export const UpdateHiddenSettingsDocument = gql`
    mutation updateHiddenSettings($hiddenSettings: HiddenSettingsInput!) {
  enterpriseAccountUpdateHiddenSettings(hiddenSettings: $hiddenSettings) {
    success
  }
}
    `;

/**
 * __useUpdateHiddenSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateHiddenSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHiddenSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHiddenSettingsMutation, { data, loading, error }] = useUpdateHiddenSettingsMutation({
 *   variables: {
 *      hiddenSettings: // value for 'hiddenSettings'
 *   },
 * });
 */
export function useUpdateHiddenSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHiddenSettingsMutation, UpdateHiddenSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHiddenSettingsMutation, UpdateHiddenSettingsMutationVariables>(UpdateHiddenSettingsDocument, options);
      }
export type UpdateHiddenSettingsMutationHookResult = ReturnType<typeof useUpdateHiddenSettingsMutation>;
export type UpdateHiddenSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateHiddenSettingsMutation>;
export type UpdateHiddenSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateHiddenSettingsMutation, UpdateHiddenSettingsMutationVariables>;
export const UpdateUserLocaleDocument = gql`
    mutation updateUserLocale($userLocale: String!) {
  enterpriseAccountUpdateUserLocale(userLocale: $userLocale) {
    success
  }
}
    `;

/**
 * __useUpdateUserLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateUserLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLocaleMutation, { data, loading, error }] = useUpdateUserLocaleMutation({
 *   variables: {
 *      userLocale: // value for 'userLocale'
 *   },
 * });
 */
export function useUpdateUserLocaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>(UpdateUserLocaleDocument, options);
      }
export type UpdateUserLocaleMutationHookResult = ReturnType<typeof useUpdateUserLocaleMutation>;
export type UpdateUserLocaleMutationResult = ApolloReactCommon.MutationResult<UpdateUserLocaleMutation>;
export type UpdateUserLocaleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;
export const FetchFeatureToggleFullyEnabledDocument = gql`
    query fetchFeatureToggleFullyEnabled($featureName: String!) {
  featureToggleFullyEnabled(featureName: $featureName) {
    enabled
  }
}
    `;

/**
 * __useFetchFeatureToggleFullyEnabledQuery__
 *
 * To run a query within a React component, call `useFetchFeatureToggleFullyEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFeatureToggleFullyEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFeatureToggleFullyEnabledQuery({
 *   variables: {
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useFetchFeatureToggleFullyEnabledQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchFeatureToggleFullyEnabledQuery, FetchFeatureToggleFullyEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchFeatureToggleFullyEnabledQuery, FetchFeatureToggleFullyEnabledQueryVariables>(FetchFeatureToggleFullyEnabledDocument, options);
      }
export function useFetchFeatureToggleFullyEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchFeatureToggleFullyEnabledQuery, FetchFeatureToggleFullyEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchFeatureToggleFullyEnabledQuery, FetchFeatureToggleFullyEnabledQueryVariables>(FetchFeatureToggleFullyEnabledDocument, options);
        }
export type FetchFeatureToggleFullyEnabledQueryHookResult = ReturnType<typeof useFetchFeatureToggleFullyEnabledQuery>;
export type FetchFeatureToggleFullyEnabledLazyQueryHookResult = ReturnType<typeof useFetchFeatureToggleFullyEnabledLazyQuery>;
export type FetchFeatureToggleFullyEnabledQueryResult = ApolloReactCommon.QueryResult<FetchFeatureToggleFullyEnabledQuery, FetchFeatureToggleFullyEnabledQueryVariables>;
export const LookupAccountForImpersonationDocument = gql`
    query lookupAccountForImpersonation($email: String, $canonicalIds: [ID!], $limit: Int) {
  enterpriseAccountSearch(
    email: $email
    canonicalIds: $canonicalIds
    limit: $limit
  ) {
    edges {
      node {
        canonicalId
        givenName
        surname
        email
        canImpersonate
        impersonateFailureReason
        impersonateMissingPermissionsSlugs
      }
    }
    meta {
      totalCount
    }
  }
}
    `;

/**
 * __useLookupAccountForImpersonationQuery__
 *
 * To run a query within a React component, call `useLookupAccountForImpersonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupAccountForImpersonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupAccountForImpersonationQuery({
 *   variables: {
 *      email: // value for 'email'
 *      canonicalIds: // value for 'canonicalIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLookupAccountForImpersonationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LookupAccountForImpersonationQuery, LookupAccountForImpersonationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LookupAccountForImpersonationQuery, LookupAccountForImpersonationQueryVariables>(LookupAccountForImpersonationDocument, options);
      }
export function useLookupAccountForImpersonationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LookupAccountForImpersonationQuery, LookupAccountForImpersonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LookupAccountForImpersonationQuery, LookupAccountForImpersonationQueryVariables>(LookupAccountForImpersonationDocument, options);
        }
export type LookupAccountForImpersonationQueryHookResult = ReturnType<typeof useLookupAccountForImpersonationQuery>;
export type LookupAccountForImpersonationLazyQueryHookResult = ReturnType<typeof useLookupAccountForImpersonationLazyQuery>;
export type LookupAccountForImpersonationQueryResult = ApolloReactCommon.QueryResult<LookupAccountForImpersonationQuery, LookupAccountForImpersonationQueryVariables>;
export const StartImpersonationDocument = gql`
    mutation startImpersonation($impersonatedCanonicalId: ID!, $breakglass: Boolean, $breakglassReason: String, $breakglassJiraTicket: String, $breakglassAdditionalInfo: String) {
  enterpriseAccountEnableImpersonation(
    impersonatedCanonicalId: $impersonatedCanonicalId
    breakglass: $breakglass
    breakglassReason: $breakglassReason
    breakglassJiraTicket: $breakglassJiraTicket
    breakglassAdditionalInfo: $breakglassAdditionalInfo
  ) {
    success
  }
}
    `;

/**
 * __useStartImpersonationMutation__
 *
 * To run a mutation, you first call `useStartImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImpersonationMutation, { data, loading, error }] = useStartImpersonationMutation({
 *   variables: {
 *      impersonatedCanonicalId: // value for 'impersonatedCanonicalId'
 *      breakglass: // value for 'breakglass'
 *      breakglassReason: // value for 'breakglassReason'
 *      breakglassJiraTicket: // value for 'breakglassJiraTicket'
 *      breakglassAdditionalInfo: // value for 'breakglassAdditionalInfo'
 *   },
 * });
 */
export function useStartImpersonationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartImpersonationMutation, StartImpersonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartImpersonationMutation, StartImpersonationMutationVariables>(StartImpersonationDocument, options);
      }
export type StartImpersonationMutationHookResult = ReturnType<typeof useStartImpersonationMutation>;
export type StartImpersonationMutationResult = ApolloReactCommon.MutationResult<StartImpersonationMutation>;
export type StartImpersonationMutationOptions = ApolloReactCommon.BaseMutationOptions<StartImpersonationMutation, StartImpersonationMutationVariables>;
export const CheckLaunchOnboardingProgressByPartnerDocument = gql`
    query checkLaunchOnboardingProgressByPartner($partnerId: BigInt!) {
  onboardingServiceCheckLaunchOnboardingProgressByPartner(
    input: {partnerId: $partnerId}
  ) {
    workflowState
  }
}
    `;

/**
 * __useCheckLaunchOnboardingProgressByPartnerQuery__
 *
 * To run a query within a React component, call `useCheckLaunchOnboardingProgressByPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckLaunchOnboardingProgressByPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckLaunchOnboardingProgressByPartnerQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useCheckLaunchOnboardingProgressByPartnerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckLaunchOnboardingProgressByPartnerQuery, CheckLaunchOnboardingProgressByPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckLaunchOnboardingProgressByPartnerQuery, CheckLaunchOnboardingProgressByPartnerQueryVariables>(CheckLaunchOnboardingProgressByPartnerDocument, options);
      }
export function useCheckLaunchOnboardingProgressByPartnerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckLaunchOnboardingProgressByPartnerQuery, CheckLaunchOnboardingProgressByPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckLaunchOnboardingProgressByPartnerQuery, CheckLaunchOnboardingProgressByPartnerQueryVariables>(CheckLaunchOnboardingProgressByPartnerDocument, options);
        }
export type CheckLaunchOnboardingProgressByPartnerQueryHookResult = ReturnType<typeof useCheckLaunchOnboardingProgressByPartnerQuery>;
export type CheckLaunchOnboardingProgressByPartnerLazyQueryHookResult = ReturnType<typeof useCheckLaunchOnboardingProgressByPartnerLazyQuery>;
export type CheckLaunchOnboardingProgressByPartnerQueryResult = ApolloReactCommon.QueryResult<CheckLaunchOnboardingProgressByPartnerQuery, CheckLaunchOnboardingProgressByPartnerQueryVariables>;
export const FetchPartnersDocument = gql`
    query fetchPartners($ids: [ID!]!) {
  partners(ids: $ids) {
    id
    name
    retailers {
      id
      logo {
        url
      }
    }
    partnerType
  }
}
    `;

/**
 * __useFetchPartnersQuery__
 *
 * To run a query within a React component, call `useFetchPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPartnersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchPartnersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchPartnersQuery, FetchPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchPartnersQuery, FetchPartnersQueryVariables>(FetchPartnersDocument, options);
      }
export function useFetchPartnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchPartnersQuery, FetchPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchPartnersQuery, FetchPartnersQueryVariables>(FetchPartnersDocument, options);
        }
export type FetchPartnersQueryHookResult = ReturnType<typeof useFetchPartnersQuery>;
export type FetchPartnersLazyQueryHookResult = ReturnType<typeof useFetchPartnersLazyQuery>;
export type FetchPartnersQueryResult = ApolloReactCommon.QueryResult<FetchPartnersQuery, FetchPartnersQueryVariables>;
export const GetAllPartnersForUserDocument = gql`
    query getAllPartnersForUser {
  partnerSearchArray {
    id
    name
    partnerType
  }
}
    `;

/**
 * __useGetAllPartnersForUserQuery__
 *
 * To run a query within a React component, call `useGetAllPartnersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnersForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPartnersForUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllPartnersForUserQuery, GetAllPartnersForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllPartnersForUserQuery, GetAllPartnersForUserQueryVariables>(GetAllPartnersForUserDocument, options);
      }
export function useGetAllPartnersForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllPartnersForUserQuery, GetAllPartnersForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllPartnersForUserQuery, GetAllPartnersForUserQueryVariables>(GetAllPartnersForUserDocument, options);
        }
export type GetAllPartnersForUserQueryHookResult = ReturnType<typeof useGetAllPartnersForUserQuery>;
export type GetAllPartnersForUserLazyQueryHookResult = ReturnType<typeof useGetAllPartnersForUserLazyQuery>;
export type GetAllPartnersForUserQueryResult = ApolloReactCommon.QueryResult<GetAllPartnersForUserQuery, GetAllPartnersForUserQueryVariables>;
export const GetAllPartnersForUserPaginatedDocument = gql`
    query getAllPartnersForUserPaginated($name: String, $first: Int) {
  partnerRetailerSearch(name: $name, first: $first) {
    nodes {
      id
      name
      partnerType
      retailers {
        id
        name
        logo {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllPartnersForUserPaginatedQuery__
 *
 * To run a query within a React component, call `useGetAllPartnersForUserPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnersForUserPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnersForUserPaginatedQuery({
 *   variables: {
 *      name: // value for 'name'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetAllPartnersForUserPaginatedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllPartnersForUserPaginatedQuery, GetAllPartnersForUserPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllPartnersForUserPaginatedQuery, GetAllPartnersForUserPaginatedQueryVariables>(GetAllPartnersForUserPaginatedDocument, options);
      }
export function useGetAllPartnersForUserPaginatedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllPartnersForUserPaginatedQuery, GetAllPartnersForUserPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllPartnersForUserPaginatedQuery, GetAllPartnersForUserPaginatedQueryVariables>(GetAllPartnersForUserPaginatedDocument, options);
        }
export type GetAllPartnersForUserPaginatedQueryHookResult = ReturnType<typeof useGetAllPartnersForUserPaginatedQuery>;
export type GetAllPartnersForUserPaginatedLazyQueryHookResult = ReturnType<typeof useGetAllPartnersForUserPaginatedLazyQuery>;
export type GetAllPartnersForUserPaginatedQueryResult = ApolloReactCommon.QueryResult<GetAllPartnersForUserPaginatedQuery, GetAllPartnersForUserPaginatedQueryVariables>;
export const GetRetailersForPartnerDocument = gql`
    query getRetailersForPartner($partnerId: ID!) {
  partner(id: $partnerId) {
    id
    name
    partnerType
    featureToggles {
      name
    }
    featureTogglesByRetailer {
      retailerId
      featureToggles {
        name
      }
    }
    retailers {
      id
      name
      locationFeatures
      warehouseGroup {
        franchisorId
        franchisorName
      }
      featureEntitlements {
        id
        name
      }
      slug
      country {
        id
        name
      }
      logo {
        url
      }
    }
  }
}
    `;

/**
 * __useGetRetailersForPartnerQuery__
 *
 * To run a query within a React component, call `useGetRetailersForPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailersForPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailersForPartnerQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetRetailersForPartnerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRetailersForPartnerQuery, GetRetailersForPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRetailersForPartnerQuery, GetRetailersForPartnerQueryVariables>(GetRetailersForPartnerDocument, options);
      }
export function useGetRetailersForPartnerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRetailersForPartnerQuery, GetRetailersForPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRetailersForPartnerQuery, GetRetailersForPartnerQueryVariables>(GetRetailersForPartnerDocument, options);
        }
export type GetRetailersForPartnerQueryHookResult = ReturnType<typeof useGetRetailersForPartnerQuery>;
export type GetRetailersForPartnerLazyQueryHookResult = ReturnType<typeof useGetRetailersForPartnerLazyQuery>;
export type GetRetailersForPartnerQueryResult = ApolloReactCommon.QueryResult<GetRetailersForPartnerQuery, GetRetailersForPartnerQueryVariables>;
export const FetchDepartmentsAndAislesItemsMeshDocument = gql`
    query fetchDepartmentsAndAislesItemsMesh($retailerId: BigInt, $inventoryAreaId: BigInt, $aisleIds: [BigInt], $departmentIds: [BigInt], $primaryAisleId: BigInt, $primaryDepartmentId: BigInt, $offset: BigInt, $limit: BigInt, $localeCode: InstacartCustomersSharedV1Locale!) {
  retailerToolsServiceGetItems(
    input: {parameters: {limit: $limit, offset: $offset, aisleIds: $aisleIds, departmentIds: $departmentIds, inventoryAreaId: $inventoryAreaId, primaryAisleId: $primaryAisleId, primaryDepartmentId: $primaryDepartmentId, retailerId: $retailerId, localeCode: $localeCode}}
  ) {
    results {
      localeCode
      primaryAisleId
      primaryImageUrl
      productCodes
      productDisplayName
      productId
      retailerId
      retailerReferenceCode
    }
    totalCount
  }
}
    `;

/**
 * __useFetchDepartmentsAndAislesItemsMeshQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsAndAislesItemsMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsAndAislesItemsMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsAndAislesItemsMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      inventoryAreaId: // value for 'inventoryAreaId'
 *      aisleIds: // value for 'aisleIds'
 *      departmentIds: // value for 'departmentIds'
 *      primaryAisleId: // value for 'primaryAisleId'
 *      primaryDepartmentId: // value for 'primaryDepartmentId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      localeCode: // value for 'localeCode'
 *   },
 * });
 */
export function useFetchDepartmentsAndAislesItemsMeshQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchDepartmentsAndAislesItemsMeshQuery, FetchDepartmentsAndAislesItemsMeshQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchDepartmentsAndAislesItemsMeshQuery, FetchDepartmentsAndAislesItemsMeshQueryVariables>(FetchDepartmentsAndAislesItemsMeshDocument, options);
      }
export function useFetchDepartmentsAndAislesItemsMeshLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchDepartmentsAndAislesItemsMeshQuery, FetchDepartmentsAndAislesItemsMeshQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchDepartmentsAndAislesItemsMeshQuery, FetchDepartmentsAndAislesItemsMeshQueryVariables>(FetchDepartmentsAndAislesItemsMeshDocument, options);
        }
export type FetchDepartmentsAndAislesItemsMeshQueryHookResult = ReturnType<typeof useFetchDepartmentsAndAislesItemsMeshQuery>;
export type FetchDepartmentsAndAislesItemsMeshLazyQueryHookResult = ReturnType<typeof useFetchDepartmentsAndAislesItemsMeshLazyQuery>;
export type FetchDepartmentsAndAislesItemsMeshQueryResult = ApolloReactCommon.QueryResult<FetchDepartmentsAndAislesItemsMeshQuery, FetchDepartmentsAndAislesItemsMeshQueryVariables>;
export const FetchDepartmentsAndAislesProductsInfoMeshDocument = gql`
    query fetchDepartmentsAndAislesProductsInfoMesh($retailerId: BigInt!, $productIds: [BigInt!]) {
  catalogToolsApiServiceGetRetailerProductData(
    input: {retailerId: $retailerId, productIds: $productIds}
  ) {
    retailerProductData {
      productId
      availableItemsCount
    }
  }
}
    `;

/**
 * __useFetchDepartmentsAndAislesProductsInfoMeshQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsAndAislesProductsInfoMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsAndAislesProductsInfoMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsAndAislesProductsInfoMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useFetchDepartmentsAndAislesProductsInfoMeshQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchDepartmentsAndAislesProductsInfoMeshQuery, FetchDepartmentsAndAislesProductsInfoMeshQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchDepartmentsAndAislesProductsInfoMeshQuery, FetchDepartmentsAndAislesProductsInfoMeshQueryVariables>(FetchDepartmentsAndAislesProductsInfoMeshDocument, options);
      }
export function useFetchDepartmentsAndAislesProductsInfoMeshLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchDepartmentsAndAislesProductsInfoMeshQuery, FetchDepartmentsAndAislesProductsInfoMeshQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchDepartmentsAndAislesProductsInfoMeshQuery, FetchDepartmentsAndAislesProductsInfoMeshQueryVariables>(FetchDepartmentsAndAislesProductsInfoMeshDocument, options);
        }
export type FetchDepartmentsAndAislesProductsInfoMeshQueryHookResult = ReturnType<typeof useFetchDepartmentsAndAislesProductsInfoMeshQuery>;
export type FetchDepartmentsAndAislesProductsInfoMeshLazyQueryHookResult = ReturnType<typeof useFetchDepartmentsAndAislesProductsInfoMeshLazyQuery>;
export type FetchDepartmentsAndAislesProductsInfoMeshQueryResult = ApolloReactCommon.QueryResult<FetchDepartmentsAndAislesProductsInfoMeshQuery, FetchDepartmentsAndAislesProductsInfoMeshQueryVariables>;
export const FetchDepartmentsAndAislesProductsMeshDocument = gql`
    query fetchDepartmentsAndAislesProductsMesh($retailerId: BigInt, $departmentIds: [BigInt], $aisleIds: [BigInt], $offset: BigInt, $limit: BigInt, $primaryAisleId: BigInt, $primaryDepartmentId: BigInt, $localeCode: InstacartCustomersSharedV1Locale!, $withUnclassifiedProducts: Boolean) {
  retailerToolsServiceGetRetailerProducts(
    input: {parameters: {limit: $limit, offset: $offset, aisleIds: $aisleIds, primaryAisleId: $primaryAisleId, departmentIds: $departmentIds, primaryDepartmentId: $primaryDepartmentId, retailerId: $retailerId, localeCode: $localeCode, withUnclassifiedProducts: $withUnclassifiedProducts}}
  ) {
    results {
      productDisplayName
      primaryImageUrl
      productId
      productCodes
    }
    totalCount
  }
}
    `;

/**
 * __useFetchDepartmentsAndAislesProductsMeshQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsAndAislesProductsMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsAndAislesProductsMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsAndAislesProductsMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      departmentIds: // value for 'departmentIds'
 *      aisleIds: // value for 'aisleIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      primaryAisleId: // value for 'primaryAisleId'
 *      primaryDepartmentId: // value for 'primaryDepartmentId'
 *      localeCode: // value for 'localeCode'
 *      withUnclassifiedProducts: // value for 'withUnclassifiedProducts'
 *   },
 * });
 */
export function useFetchDepartmentsAndAislesProductsMeshQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchDepartmentsAndAislesProductsMeshQuery, FetchDepartmentsAndAislesProductsMeshQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchDepartmentsAndAislesProductsMeshQuery, FetchDepartmentsAndAislesProductsMeshQueryVariables>(FetchDepartmentsAndAislesProductsMeshDocument, options);
      }
export function useFetchDepartmentsAndAislesProductsMeshLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchDepartmentsAndAislesProductsMeshQuery, FetchDepartmentsAndAislesProductsMeshQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchDepartmentsAndAislesProductsMeshQuery, FetchDepartmentsAndAislesProductsMeshQueryVariables>(FetchDepartmentsAndAislesProductsMeshDocument, options);
        }
export type FetchDepartmentsAndAislesProductsMeshQueryHookResult = ReturnType<typeof useFetchDepartmentsAndAislesProductsMeshQuery>;
export type FetchDepartmentsAndAislesProductsMeshLazyQueryHookResult = ReturnType<typeof useFetchDepartmentsAndAislesProductsMeshLazyQuery>;
export type FetchDepartmentsAndAislesProductsMeshQueryResult = ApolloReactCommon.QueryResult<FetchDepartmentsAndAislesProductsMeshQuery, FetchDepartmentsAndAislesProductsMeshQueryVariables>;
export const FetchPrimaryAisleProductCountDocument = gql`
    query fetchPrimaryAisleProductCount($retailerId: BigInt, $primaryAisleId: BigInt) {
  retailerToolsServiceGetRetailerProducts(
    input: {parameters: {primaryAisleId: $primaryAisleId, retailerId: $retailerId}}
  ) {
    totalCount
  }
}
    `;

/**
 * __useFetchPrimaryAisleProductCountQuery__
 *
 * To run a query within a React component, call `useFetchPrimaryAisleProductCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPrimaryAisleProductCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPrimaryAisleProductCountQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      primaryAisleId: // value for 'primaryAisleId'
 *   },
 * });
 */
export function useFetchPrimaryAisleProductCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchPrimaryAisleProductCountQuery, FetchPrimaryAisleProductCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchPrimaryAisleProductCountQuery, FetchPrimaryAisleProductCountQueryVariables>(FetchPrimaryAisleProductCountDocument, options);
      }
export function useFetchPrimaryAisleProductCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchPrimaryAisleProductCountQuery, FetchPrimaryAisleProductCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchPrimaryAisleProductCountQuery, FetchPrimaryAisleProductCountQueryVariables>(FetchPrimaryAisleProductCountDocument, options);
        }
export type FetchPrimaryAisleProductCountQueryHookResult = ReturnType<typeof useFetchPrimaryAisleProductCountQuery>;
export type FetchPrimaryAisleProductCountLazyQueryHookResult = ReturnType<typeof useFetchPrimaryAisleProductCountLazyQuery>;
export type FetchPrimaryAisleProductCountQueryResult = ApolloReactCommon.QueryResult<FetchPrimaryAisleProductCountQuery, FetchPrimaryAisleProductCountQueryVariables>;
export const RetailerSatisfactionSurveyDocument = gql`
    mutation retailerSatisfactionSurvey($retailerId: ID, $accountId: ID!, $partnerId: ID, $urlPath: String!, $surveyResponses: [RetailerSatisfactionSurveyResponse!]!, $shownAt: String!, $submittedAt: String!, $milestoneSlug: String, $workflowSlug: String) {
  retailerSatisfactionSurveySubmissionCreate(
    retailerId: $retailerId
    accountId: $accountId
    partnerId: $partnerId
    urlPath: $urlPath
    surveyResponses: $surveyResponses
    shownAt: $shownAt
    submittedAt: $submittedAt
    milestoneSlug: $milestoneSlug
    workflowSlug: $workflowSlug
  ) {
    success
  }
}
    `;

/**
 * __useRetailerSatisfactionSurveyMutation__
 *
 * To run a mutation, you first call `useRetailerSatisfactionSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailerSatisfactionSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailerSatisfactionSurveyMutation, { data, loading, error }] = useRetailerSatisfactionSurveyMutation({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      accountId: // value for 'accountId'
 *      partnerId: // value for 'partnerId'
 *      urlPath: // value for 'urlPath'
 *      surveyResponses: // value for 'surveyResponses'
 *      shownAt: // value for 'shownAt'
 *      submittedAt: // value for 'submittedAt'
 *      milestoneSlug: // value for 'milestoneSlug'
 *      workflowSlug: // value for 'workflowSlug'
 *   },
 * });
 */
export function useRetailerSatisfactionSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetailerSatisfactionSurveyMutation, RetailerSatisfactionSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetailerSatisfactionSurveyMutation, RetailerSatisfactionSurveyMutationVariables>(RetailerSatisfactionSurveyDocument, options);
      }
export type RetailerSatisfactionSurveyMutationHookResult = ReturnType<typeof useRetailerSatisfactionSurveyMutation>;
export type RetailerSatisfactionSurveyMutationResult = ApolloReactCommon.MutationResult<RetailerSatisfactionSurveyMutation>;
export type RetailerSatisfactionSurveyMutationOptions = ApolloReactCommon.BaseMutationOptions<RetailerSatisfactionSurveyMutation, RetailerSatisfactionSurveyMutationVariables>;
export const RetailerSatisfactionSurveyFrequencyDocument = gql`
    query retailerSatisfactionSurveyFrequency {
  retailerSatisfactionSurveySubmissionFrequency {
    milestoneSlug
    workflowSlug
    submittedAt
  }
}
    `;

/**
 * __useRetailerSatisfactionSurveyFrequencyQuery__
 *
 * To run a query within a React component, call `useRetailerSatisfactionSurveyFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerSatisfactionSurveyFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerSatisfactionSurveyFrequencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailerSatisfactionSurveyFrequencyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RetailerSatisfactionSurveyFrequencyQuery, RetailerSatisfactionSurveyFrequencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RetailerSatisfactionSurveyFrequencyQuery, RetailerSatisfactionSurveyFrequencyQueryVariables>(RetailerSatisfactionSurveyFrequencyDocument, options);
      }
export function useRetailerSatisfactionSurveyFrequencyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RetailerSatisfactionSurveyFrequencyQuery, RetailerSatisfactionSurveyFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RetailerSatisfactionSurveyFrequencyQuery, RetailerSatisfactionSurveyFrequencyQueryVariables>(RetailerSatisfactionSurveyFrequencyDocument, options);
        }
export type RetailerSatisfactionSurveyFrequencyQueryHookResult = ReturnType<typeof useRetailerSatisfactionSurveyFrequencyQuery>;
export type RetailerSatisfactionSurveyFrequencyLazyQueryHookResult = ReturnType<typeof useRetailerSatisfactionSurveyFrequencyLazyQuery>;
export type RetailerSatisfactionSurveyFrequencyQueryResult = ApolloReactCommon.QueryResult<RetailerSatisfactionSurveyFrequencyQuery, RetailerSatisfactionSurveyFrequencyQueryVariables>;
export const GetAllRetailerLocationsForRetailerDocument = gql`
    query getAllRetailerLocationsForRetailer($retailerId: ID, $retailerIds: [ID!]) {
  retailerLocationSearchArray(
    retailerId: $retailerId
    retailerIds: $retailerIds
    includeInactiveLocations: true
  ) {
    id
    name
    street
    city
    state
    zipCode
    locationCode
    active
    pickup
    pickingModel
    fulfillmentModels
    partnerAlcoholDelivery
    partnerDeliveryDriversEnabled
    hybridPickingEnabled
    partnerDeliveryDriversEnabled
    retailerId
  }
}
    `;

/**
 * __useGetAllRetailerLocationsForRetailerQuery__
 *
 * To run a query within a React component, call `useGetAllRetailerLocationsForRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRetailerLocationsForRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRetailerLocationsForRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      retailerIds: // value for 'retailerIds'
 *   },
 * });
 */
export function useGetAllRetailerLocationsForRetailerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllRetailerLocationsForRetailerQuery, GetAllRetailerLocationsForRetailerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllRetailerLocationsForRetailerQuery, GetAllRetailerLocationsForRetailerQueryVariables>(GetAllRetailerLocationsForRetailerDocument, options);
      }
export function useGetAllRetailerLocationsForRetailerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllRetailerLocationsForRetailerQuery, GetAllRetailerLocationsForRetailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllRetailerLocationsForRetailerQuery, GetAllRetailerLocationsForRetailerQueryVariables>(GetAllRetailerLocationsForRetailerDocument, options);
        }
export type GetAllRetailerLocationsForRetailerQueryHookResult = ReturnType<typeof useGetAllRetailerLocationsForRetailerQuery>;
export type GetAllRetailerLocationsForRetailerLazyQueryHookResult = ReturnType<typeof useGetAllRetailerLocationsForRetailerLazyQuery>;
export type GetAllRetailerLocationsForRetailerQueryResult = ApolloReactCommon.QueryResult<GetAllRetailerLocationsForRetailerQuery, GetAllRetailerLocationsForRetailerQueryVariables>;
export const V4GetRetailersLocationsDocument = gql`
    query v4GetRetailersLocations($ids: [BigInt], $name: String) {
  instacart_customers_partners_v1_PartnersService_GetRetailerLocations(
    input: {parameters: {ids: $ids, name: $name}, timeoutMs: 10000}
  ) {
    retailerLocations {
      active
      addressCounty
      addressId
      bagFeeRateCents
      city
      id
      issEnabled
      latitude
      locationCode
      longitude
      name
      partnerPickup
      pickup
      pickupOnly
      postalCode
      retailerId
      state
      streetAddress
      inventoryAreaId
      zipPlusFour
    }
  }
}
    `;

/**
 * __useV4GetRetailersLocationsQuery__
 *
 * To run a query within a React component, call `useV4GetRetailersLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV4GetRetailersLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV4GetRetailersLocationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useV4GetRetailersLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<V4GetRetailersLocationsQuery, V4GetRetailersLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<V4GetRetailersLocationsQuery, V4GetRetailersLocationsQueryVariables>(V4GetRetailersLocationsDocument, options);
      }
export function useV4GetRetailersLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<V4GetRetailersLocationsQuery, V4GetRetailersLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<V4GetRetailersLocationsQuery, V4GetRetailersLocationsQueryVariables>(V4GetRetailersLocationsDocument, options);
        }
export type V4GetRetailersLocationsQueryHookResult = ReturnType<typeof useV4GetRetailersLocationsQuery>;
export type V4GetRetailersLocationsLazyQueryHookResult = ReturnType<typeof useV4GetRetailersLocationsLazyQuery>;
export type V4GetRetailersLocationsQueryResult = ApolloReactCommon.QueryResult<V4GetRetailersLocationsQuery, V4GetRetailersLocationsQueryVariables>;
export const V4GetRetailersLocationsByRetailerDocument = gql`
    query v4GetRetailersLocationsByRetailer($retailerId: BigInt, $name: String) {
  instacart_customers_partners_v1_PartnersService_GetRetailerLocationsByRetailer(
    input: {parameters: {retailerId: $retailerId, name: $name}, timeoutMs: 10000}
  ) {
    retailerLocations {
      active
      addressCounty
      addressId
      bagFeeRateCents
      city
      id
      latitude
      locationCode
      longitude
      name
      postalCode
      retailerId
      state
      streetAddress
    }
  }
}
    `;

/**
 * __useV4GetRetailersLocationsByRetailerQuery__
 *
 * To run a query within a React component, call `useV4GetRetailersLocationsByRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useV4GetRetailersLocationsByRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV4GetRetailersLocationsByRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useV4GetRetailersLocationsByRetailerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<V4GetRetailersLocationsByRetailerQuery, V4GetRetailersLocationsByRetailerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<V4GetRetailersLocationsByRetailerQuery, V4GetRetailersLocationsByRetailerQueryVariables>(V4GetRetailersLocationsByRetailerDocument, options);
      }
export function useV4GetRetailersLocationsByRetailerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<V4GetRetailersLocationsByRetailerQuery, V4GetRetailersLocationsByRetailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<V4GetRetailersLocationsByRetailerQuery, V4GetRetailersLocationsByRetailerQueryVariables>(V4GetRetailersLocationsByRetailerDocument, options);
        }
export type V4GetRetailersLocationsByRetailerQueryHookResult = ReturnType<typeof useV4GetRetailersLocationsByRetailerQuery>;
export type V4GetRetailersLocationsByRetailerLazyQueryHookResult = ReturnType<typeof useV4GetRetailersLocationsByRetailerLazyQuery>;
export type V4GetRetailersLocationsByRetailerQueryResult = ApolloReactCommon.QueryResult<V4GetRetailersLocationsByRetailerQuery, V4GetRetailersLocationsByRetailerQueryVariables>;
export const GetRetailerDocument = gql`
    query getRetailer($retailerId: ID!) {
  retailer(id: $retailerId) {
    id
    name
    locationFeatures
    partner {
      id
      name
      partnerType
    }
    featureToggles {
      name
    }
    featureEntitlements {
      id
      name
    }
    slug
    country {
      id
      name
    }
    logo {
      url
    }
  }
}
    `;

/**
 * __useGetRetailerQuery__
 *
 * To run a query within a React component, call `useGetRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useGetRetailerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRetailerQuery, GetRetailerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRetailerQuery, GetRetailerQueryVariables>(GetRetailerDocument, options);
      }
export function useGetRetailerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRetailerQuery, GetRetailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRetailerQuery, GetRetailerQueryVariables>(GetRetailerDocument, options);
        }
export type GetRetailerQueryHookResult = ReturnType<typeof useGetRetailerQuery>;
export type GetRetailerLazyQueryHookResult = ReturnType<typeof useGetRetailerLazyQuery>;
export type GetRetailerQueryResult = ApolloReactCommon.QueryResult<GetRetailerQuery, GetRetailerQueryVariables>;
export const GetRetailerLocalesMeshDocument = gql`
    query getRetailerLocalesMesh($retailerId: BigInt!) {
  catalogToolsApiServiceGetLocalesByRetailer(input: {retailerId: $retailerId}) {
    retailerLocales {
      localeId
      localeCode
    }
  }
}
    `;

/**
 * __useGetRetailerLocalesMeshQuery__
 *
 * To run a query within a React component, call `useGetRetailerLocalesMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailerLocalesMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailerLocalesMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useGetRetailerLocalesMeshQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRetailerLocalesMeshQuery, GetRetailerLocalesMeshQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRetailerLocalesMeshQuery, GetRetailerLocalesMeshQueryVariables>(GetRetailerLocalesMeshDocument, options);
      }
export function useGetRetailerLocalesMeshLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRetailerLocalesMeshQuery, GetRetailerLocalesMeshQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRetailerLocalesMeshQuery, GetRetailerLocalesMeshQueryVariables>(GetRetailerLocalesMeshDocument, options);
        }
export type GetRetailerLocalesMeshQueryHookResult = ReturnType<typeof useGetRetailerLocalesMeshQuery>;
export type GetRetailerLocalesMeshLazyQueryHookResult = ReturnType<typeof useGetRetailerLocalesMeshLazyQuery>;
export type GetRetailerLocalesMeshQueryResult = ApolloReactCommon.QueryResult<GetRetailerLocalesMeshQuery, GetRetailerLocalesMeshQueryVariables>;
export const GetRetailerSearchDocument = gql`
    query getRetailerSearch($partnerId: ID!, $retailerIds: [ID!], $name: String!) {
  retailerSearchArray(
    partnerId: $partnerId
    retailerIds: $retailerIds
    name: $name
  ) {
    id
    name
    logo {
      url
    }
  }
}
    `;

/**
 * __useGetRetailerSearchQuery__
 *
 * To run a query within a React component, call `useGetRetailerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailerSearchQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      retailerIds: // value for 'retailerIds'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRetailerSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRetailerSearchQuery, GetRetailerSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRetailerSearchQuery, GetRetailerSearchQueryVariables>(GetRetailerSearchDocument, options);
      }
export function useGetRetailerSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRetailerSearchQuery, GetRetailerSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRetailerSearchQuery, GetRetailerSearchQueryVariables>(GetRetailerSearchDocument, options);
        }
export type GetRetailerSearchQueryHookResult = ReturnType<typeof useGetRetailerSearchQuery>;
export type GetRetailerSearchLazyQueryHookResult = ReturnType<typeof useGetRetailerSearchLazyQuery>;
export type GetRetailerSearchQueryResult = ApolloReactCommon.QueryResult<GetRetailerSearchQuery, GetRetailerSearchQueryVariables>;
export const V4GetRetailersDocument = gql`
    query v4GetRetailers($ids: [BigInt], $name: String) {
  instacart_customers_partners_v1_PartnersService_GetRetailers(
    input: {parameters: {ids: $ids, name: $name}, timeoutMs: 10000}
  ) {
    retailers {
      adminOnly
      allowAlcohol
      allowSpecialRequests
      backgroundColorHex
      backgroundImagePath
      categories
      countrySlug
      description
      franchiseeId
      id
      logoImagePath
      name
      priceTransparencyDescription
      priceTransparencyFlag
      retailerType
      slug
    }
  }
}
    `;

/**
 * __useV4GetRetailersQuery__
 *
 * To run a query within a React component, call `useV4GetRetailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useV4GetRetailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV4GetRetailersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useV4GetRetailersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<V4GetRetailersQuery, V4GetRetailersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<V4GetRetailersQuery, V4GetRetailersQueryVariables>(V4GetRetailersDocument, options);
      }
export function useV4GetRetailersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<V4GetRetailersQuery, V4GetRetailersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<V4GetRetailersQuery, V4GetRetailersQueryVariables>(V4GetRetailersDocument, options);
        }
export type V4GetRetailersQueryHookResult = ReturnType<typeof useV4GetRetailersQuery>;
export type V4GetRetailersLazyQueryHookResult = ReturnType<typeof useV4GetRetailersLazyQuery>;
export type V4GetRetailersQueryResult = ApolloReactCommon.QueryResult<V4GetRetailersQuery, V4GetRetailersQueryVariables>;
export const GetStoreConfigsDocument = gql`
    query getStoreConfigs($retailerIds: [ID!]!, $storeConfigRelationship: StoreConfigurationRelationshipEnum!, $active: Boolean) {
  storeConfigurationsByRetailerIds(
    retailerIds: $retailerIds
    storeConfigRelationship: $storeConfigRelationship
    active: $active
  ) {
    id
    slug
    brandedName
    whitelistedWarehouseIds
    domainName
    legal {
      shortName
    }
    deApplicationPlatform
    createdAt
    updatedAt
    allowAllWarehouses
    logoUrl
    userAccessToModify
    active
    partnerAccessSettings {
      visibleToPartnersOnIpp
      modificationRules {
        allowlistPartnerIds
      }
    }
    userIsolationContextId
    clientConfigurationIds
  }
}
    `;

/**
 * __useGetStoreConfigsQuery__
 *
 * To run a query within a React component, call `useGetStoreConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreConfigsQuery({
 *   variables: {
 *      retailerIds: // value for 'retailerIds'
 *      storeConfigRelationship: // value for 'storeConfigRelationship'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetStoreConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStoreConfigsQuery, GetStoreConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStoreConfigsQuery, GetStoreConfigsQueryVariables>(GetStoreConfigsDocument, options);
      }
export function useGetStoreConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStoreConfigsQuery, GetStoreConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStoreConfigsQuery, GetStoreConfigsQueryVariables>(GetStoreConfigsDocument, options);
        }
export type GetStoreConfigsQueryHookResult = ReturnType<typeof useGetStoreConfigsQuery>;
export type GetStoreConfigsLazyQueryHookResult = ReturnType<typeof useGetStoreConfigsLazyQuery>;
export type GetStoreConfigsQueryResult = ApolloReactCommon.QueryResult<GetStoreConfigsQuery, GetStoreConfigsQueryVariables>;
export const GetStoreConfigsByPartnerIdDocument = gql`
    query getStoreConfigsByPartnerId($partnerId: ID!, $storeConfigRelationship: StoreConfigurationRelationshipEnum!, $active: Boolean) {
  storeConfigurationsByPartnerId(
    partnerId: $partnerId
    storeConfigRelationship: $storeConfigRelationship
    active: $active
  ) {
    id
    slug
    brandedName
    whitelistedWarehouseIds
    domainName
    legal {
      shortName
    }
    deApplicationPlatform
    createdAt
    updatedAt
    allowAllWarehouses
    logoUrl
    userAccessToModify
    active
    partnerAccessSettings {
      visibleToPartnersOnIpp
      modificationRules {
        allowlistPartnerIds
      }
    }
    userIsolationContextId
    clientConfigurationIds
  }
}
    `;

/**
 * __useGetStoreConfigsByPartnerIdQuery__
 *
 * To run a query within a React component, call `useGetStoreConfigsByPartnerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreConfigsByPartnerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreConfigsByPartnerIdQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      storeConfigRelationship: // value for 'storeConfigRelationship'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetStoreConfigsByPartnerIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStoreConfigsByPartnerIdQuery, GetStoreConfigsByPartnerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStoreConfigsByPartnerIdQuery, GetStoreConfigsByPartnerIdQueryVariables>(GetStoreConfigsByPartnerIdDocument, options);
      }
export function useGetStoreConfigsByPartnerIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStoreConfigsByPartnerIdQuery, GetStoreConfigsByPartnerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStoreConfigsByPartnerIdQuery, GetStoreConfigsByPartnerIdQueryVariables>(GetStoreConfigsByPartnerIdDocument, options);
        }
export type GetStoreConfigsByPartnerIdQueryHookResult = ReturnType<typeof useGetStoreConfigsByPartnerIdQuery>;
export type GetStoreConfigsByPartnerIdLazyQueryHookResult = ReturnType<typeof useGetStoreConfigsByPartnerIdLazyQuery>;
export type GetStoreConfigsByPartnerIdQueryResult = ApolloReactCommon.QueryResult<GetStoreConfigsByPartnerIdQuery, GetStoreConfigsByPartnerIdQueryVariables>;
export const CreateStoreGroupDocument = gql`
    mutation createStoreGroup($name: String!, $partnerId: ID!, $retailerId: ID, $retailerLocationIds: [ID!]) {
  retailerLocationGroupCreate(
    name: $name
    partnerId: $partnerId
    retailerId: $retailerId
    retailerLocationIds: $retailerLocationIds
  ) {
    retailerLocationGroup {
      id
      name
      updatedAt
      retailerLocationIds
    }
  }
}
    `;

/**
 * __useCreateStoreGroupMutation__
 *
 * To run a mutation, you first call `useCreateStoreGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoreGroupMutation, { data, loading, error }] = useCreateStoreGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      partnerId: // value for 'partnerId'
 *      retailerId: // value for 'retailerId'
 *      retailerLocationIds: // value for 'retailerLocationIds'
 *   },
 * });
 */
export function useCreateStoreGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStoreGroupMutation, CreateStoreGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStoreGroupMutation, CreateStoreGroupMutationVariables>(CreateStoreGroupDocument, options);
      }
export type CreateStoreGroupMutationHookResult = ReturnType<typeof useCreateStoreGroupMutation>;
export type CreateStoreGroupMutationResult = ApolloReactCommon.MutationResult<CreateStoreGroupMutation>;
export type CreateStoreGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStoreGroupMutation, CreateStoreGroupMutationVariables>;
export const GetStoreGroupsByRetailerDocument = gql`
    query getStoreGroupsByRetailer($partnerId: ID!, $retailerId: ID) {
  retailerLocationGroupsByRetailer(partnerId: $partnerId, retailerId: $retailerId) {
    nodes {
      id
      name
      retailerLocationIds
    }
  }
}
    `;

/**
 * __useGetStoreGroupsByRetailerQuery__
 *
 * To run a query within a React component, call `useGetStoreGroupsByRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreGroupsByRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreGroupsByRetailerQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useGetStoreGroupsByRetailerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStoreGroupsByRetailerQuery, GetStoreGroupsByRetailerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStoreGroupsByRetailerQuery, GetStoreGroupsByRetailerQueryVariables>(GetStoreGroupsByRetailerDocument, options);
      }
export function useGetStoreGroupsByRetailerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStoreGroupsByRetailerQuery, GetStoreGroupsByRetailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStoreGroupsByRetailerQuery, GetStoreGroupsByRetailerQueryVariables>(GetStoreGroupsByRetailerDocument, options);
        }
export type GetStoreGroupsByRetailerQueryHookResult = ReturnType<typeof useGetStoreGroupsByRetailerQuery>;
export type GetStoreGroupsByRetailerLazyQueryHookResult = ReturnType<typeof useGetStoreGroupsByRetailerLazyQuery>;
export type GetStoreGroupsByRetailerQueryResult = ApolloReactCommon.QueryResult<GetStoreGroupsByRetailerQuery, GetStoreGroupsByRetailerQueryVariables>;
export const GetTaxonomyNodesDocument = gql`
    query getTaxonomyNodes {
  taxonomyNodes {
    id
    name
    parentId
  }
}
    `;

/**
 * __useGetTaxonomyNodesQuery__
 *
 * To run a query within a React component, call `useGetTaxonomyNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxonomyNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxonomyNodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxonomyNodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTaxonomyNodesQuery, GetTaxonomyNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaxonomyNodesQuery, GetTaxonomyNodesQueryVariables>(GetTaxonomyNodesDocument, options);
      }
export function useGetTaxonomyNodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaxonomyNodesQuery, GetTaxonomyNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaxonomyNodesQuery, GetTaxonomyNodesQueryVariables>(GetTaxonomyNodesDocument, options);
        }
export type GetTaxonomyNodesQueryHookResult = ReturnType<typeof useGetTaxonomyNodesQuery>;
export type GetTaxonomyNodesLazyQueryHookResult = ReturnType<typeof useGetTaxonomyNodesLazyQuery>;
export type GetTaxonomyNodesQueryResult = ApolloReactCommon.QueryResult<GetTaxonomyNodesQuery, GetTaxonomyNodesQueryVariables>;
export const GetTotemEntityDocument = gql`
    query getTotemEntity($externalId: String!) {
  instacart_infra_totem_v1_TotemService_GetEntity(
    input: {external_id: $externalId, type_name: "ipp/tool"}
  ) {
    entity {
      name
      external_id
      system_name
      metadata
    }
  }
}
    `;

/**
 * __useGetTotemEntityQuery__
 *
 * To run a query within a React component, call `useGetTotemEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemEntityQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useGetTotemEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTotemEntityQuery, GetTotemEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTotemEntityQuery, GetTotemEntityQueryVariables>(GetTotemEntityDocument, options);
      }
export function useGetTotemEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTotemEntityQuery, GetTotemEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTotemEntityQuery, GetTotemEntityQueryVariables>(GetTotemEntityDocument, options);
        }
export type GetTotemEntityQueryHookResult = ReturnType<typeof useGetTotemEntityQuery>;
export type GetTotemEntityLazyQueryHookResult = ReturnType<typeof useGetTotemEntityLazyQuery>;
export type GetTotemEntityQueryResult = ApolloReactCommon.QueryResult<GetTotemEntityQuery, GetTotemEntityQueryVariables>;
export const GetTotemSystemDocument = gql`
    query getTotemSystem($systemName: String!) {
  instacart_infra_totem_v1_TotemService_GetSystem(input: {name: $systemName}) {
    system {
      name
      owner_team {
        workday_org_name
        name
      }
      contact_details {
        general_slack_channels {
          channels {
            id
            handle
            type
          }
        }
        oncall_slack_group {
          type
          handle
        }
        opsgenie_responder {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetTotemSystemQuery__
 *
 * To run a query within a React component, call `useGetTotemSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemSystemQuery({
 *   variables: {
 *      systemName: // value for 'systemName'
 *   },
 * });
 */
export function useGetTotemSystemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTotemSystemQuery, GetTotemSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTotemSystemQuery, GetTotemSystemQueryVariables>(GetTotemSystemDocument, options);
      }
export function useGetTotemSystemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTotemSystemQuery, GetTotemSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTotemSystemQuery, GetTotemSystemQueryVariables>(GetTotemSystemDocument, options);
        }
export type GetTotemSystemQueryHookResult = ReturnType<typeof useGetTotemSystemQuery>;
export type GetTotemSystemLazyQueryHookResult = ReturnType<typeof useGetTotemSystemLazyQuery>;
export type GetTotemSystemQueryResult = ApolloReactCommon.QueryResult<GetTotemSystemQuery, GetTotemSystemQueryVariables>;
export const GetTotemSystemLimitedDocument = gql`
    query getTotemSystemLimited($systemName: String!) {
  instacart_infra_totem_v1_TotemService_GetSystem(input: {name: $systemName}) {
    system {
      name
      owner_team {
        name
      }
      contact_details {
        oncall_slack_group {
          handle
        }
        opsgenie_responder {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetTotemSystemLimitedQuery__
 *
 * To run a query within a React component, call `useGetTotemSystemLimitedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemSystemLimitedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemSystemLimitedQuery({
 *   variables: {
 *      systemName: // value for 'systemName'
 *   },
 * });
 */
export function useGetTotemSystemLimitedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTotemSystemLimitedQuery, GetTotemSystemLimitedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTotemSystemLimitedQuery, GetTotemSystemLimitedQueryVariables>(GetTotemSystemLimitedDocument, options);
      }
export function useGetTotemSystemLimitedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTotemSystemLimitedQuery, GetTotemSystemLimitedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTotemSystemLimitedQuery, GetTotemSystemLimitedQueryVariables>(GetTotemSystemLimitedDocument, options);
        }
export type GetTotemSystemLimitedQueryHookResult = ReturnType<typeof useGetTotemSystemLimitedQuery>;
export type GetTotemSystemLimitedLazyQueryHookResult = ReturnType<typeof useGetTotemSystemLimitedLazyQuery>;
export type GetTotemSystemLimitedQueryResult = ApolloReactCommon.QueryResult<GetTotemSystemLimitedQuery, GetTotemSystemLimitedQueryVariables>;
export const SearchEnterpriseAccountsAccountSelectDocument = gql`
    query searchEnterpriseAccountsAccountSelect($email: String, $partnerId: ID!, $canonicalIds: [ID!]) {
  enterpriseAccountSearch(
    email: $email
    canonicalIds: $canonicalIds
    partnerId: $partnerId
    limit: 20
  ) {
    edges {
      node {
        givenName
        surname
        email
        canonicalId
      }
    }
  }
}
    `;

/**
 * __useSearchEnterpriseAccountsAccountSelectQuery__
 *
 * To run a query within a React component, call `useSearchEnterpriseAccountsAccountSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEnterpriseAccountsAccountSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEnterpriseAccountsAccountSelectQuery({
 *   variables: {
 *      email: // value for 'email'
 *      partnerId: // value for 'partnerId'
 *      canonicalIds: // value for 'canonicalIds'
 *   },
 * });
 */
export function useSearchEnterpriseAccountsAccountSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchEnterpriseAccountsAccountSelectQuery, SearchEnterpriseAccountsAccountSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchEnterpriseAccountsAccountSelectQuery, SearchEnterpriseAccountsAccountSelectQueryVariables>(SearchEnterpriseAccountsAccountSelectDocument, options);
      }
export function useSearchEnterpriseAccountsAccountSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchEnterpriseAccountsAccountSelectQuery, SearchEnterpriseAccountsAccountSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchEnterpriseAccountsAccountSelectQuery, SearchEnterpriseAccountsAccountSelectQueryVariables>(SearchEnterpriseAccountsAccountSelectDocument, options);
        }
export type SearchEnterpriseAccountsAccountSelectQueryHookResult = ReturnType<typeof useSearchEnterpriseAccountsAccountSelectQuery>;
export type SearchEnterpriseAccountsAccountSelectLazyQueryHookResult = ReturnType<typeof useSearchEnterpriseAccountsAccountSelectLazyQuery>;
export type SearchEnterpriseAccountsAccountSelectQueryResult = ApolloReactCommon.QueryResult<SearchEnterpriseAccountsAccountSelectQuery, SearchEnterpriseAccountsAccountSelectQueryVariables>;
export const FetchAislesForDepartmentDocument = gql`
    query fetchAislesForDepartment($departmentId: ID!) {
  catalogDepartment(id: $departmentId) {
    aisles {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchAislesForDepartmentQuery__
 *
 * To run a query within a React component, call `useFetchAislesForDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAislesForDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAislesForDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useFetchAislesForDepartmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchAislesForDepartmentQuery, FetchAislesForDepartmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchAislesForDepartmentQuery, FetchAislesForDepartmentQueryVariables>(FetchAislesForDepartmentDocument, options);
      }
export function useFetchAislesForDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchAislesForDepartmentQuery, FetchAislesForDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchAislesForDepartmentQuery, FetchAislesForDepartmentQueryVariables>(FetchAislesForDepartmentDocument, options);
        }
export type FetchAislesForDepartmentQueryHookResult = ReturnType<typeof useFetchAislesForDepartmentQuery>;
export type FetchAislesForDepartmentLazyQueryHookResult = ReturnType<typeof useFetchAislesForDepartmentLazyQuery>;
export type FetchAislesForDepartmentQueryResult = ApolloReactCommon.QueryResult<FetchAislesForDepartmentQuery, FetchAislesForDepartmentQueryVariables>;
export const FetchDepartmentsForRetailerDocument = gql`
    query fetchDepartmentsForRetailer($retailerId: ID!) {
  retailer(id: $retailerId) {
    departments {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchDepartmentsForRetailerQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsForRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsForRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsForRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useFetchDepartmentsForRetailerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchDepartmentsForRetailerQuery, FetchDepartmentsForRetailerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchDepartmentsForRetailerQuery, FetchDepartmentsForRetailerQueryVariables>(FetchDepartmentsForRetailerDocument, options);
      }
export function useFetchDepartmentsForRetailerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchDepartmentsForRetailerQuery, FetchDepartmentsForRetailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchDepartmentsForRetailerQuery, FetchDepartmentsForRetailerQueryVariables>(FetchDepartmentsForRetailerDocument, options);
        }
export type FetchDepartmentsForRetailerQueryHookResult = ReturnType<typeof useFetchDepartmentsForRetailerQuery>;
export type FetchDepartmentsForRetailerLazyQueryHookResult = ReturnType<typeof useFetchDepartmentsForRetailerLazyQuery>;
export type FetchDepartmentsForRetailerQueryResult = ApolloReactCommon.QueryResult<FetchDepartmentsForRetailerQuery, FetchDepartmentsForRetailerQueryVariables>;
export const StopImpersonationSessionDocument = gql`
    mutation stopImpersonationSession {
  enterpriseAccountDisableImpersonation {
    success
  }
}
    `;

/**
 * __useStopImpersonationSessionMutation__
 *
 * To run a mutation, you first call `useStopImpersonationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopImpersonationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopImpersonationSessionMutation, { data, loading, error }] = useStopImpersonationSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStopImpersonationSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopImpersonationSessionMutation, StopImpersonationSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopImpersonationSessionMutation, StopImpersonationSessionMutationVariables>(StopImpersonationSessionDocument, options);
      }
export type StopImpersonationSessionMutationHookResult = ReturnType<typeof useStopImpersonationSessionMutation>;
export type StopImpersonationSessionMutationResult = ApolloReactCommon.MutationResult<StopImpersonationSessionMutation>;
export type StopImpersonationSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<StopImpersonationSessionMutation, StopImpersonationSessionMutationVariables>;
export const ListStoreGroupsDocument = gql`
    query listStoreGroups($partnerId: ID!, $retailerId: ID, $retailerIds: [ID!], $matchType: RetailerLocationGroupQuery, $numGroups: Int, $afterGroup: String) {
  retailerLocationGroupsByRetailer(
    partnerId: $partnerId
    retailerId: $retailerId
    retailerIds: $retailerIds
    matchType: $matchType
    first: $numGroups
    after: $afterGroup
  ) {
    edges {
      node {
        id
        name
        updatedAt
        retailerLocationIds
        retailerIds
      }
      cursor
    }
  }
}
    `;

/**
 * __useListStoreGroupsQuery__
 *
 * To run a query within a React component, call `useListStoreGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStoreGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStoreGroupsQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      retailerId: // value for 'retailerId'
 *      retailerIds: // value for 'retailerIds'
 *      matchType: // value for 'matchType'
 *      numGroups: // value for 'numGroups'
 *      afterGroup: // value for 'afterGroup'
 *   },
 * });
 */
export function useListStoreGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListStoreGroupsQuery, ListStoreGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListStoreGroupsQuery, ListStoreGroupsQueryVariables>(ListStoreGroupsDocument, options);
      }
export function useListStoreGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListStoreGroupsQuery, ListStoreGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListStoreGroupsQuery, ListStoreGroupsQueryVariables>(ListStoreGroupsDocument, options);
        }
export type ListStoreGroupsQueryHookResult = ReturnType<typeof useListStoreGroupsQuery>;
export type ListStoreGroupsLazyQueryHookResult = ReturnType<typeof useListStoreGroupsLazyQuery>;
export type ListStoreGroupsQueryResult = ApolloReactCommon.QueryResult<ListStoreGroupsQuery, ListStoreGroupsQueryVariables>;
export const CreateTempOverrideDocument = gql`
    mutation createTempOverride($data: [instacart_catalog_admin_v1_TempOverrideEntityInput_Input]!) {
  instacart_catalog_admin_v1_TempOverrideService_Create(
    input: {tempOverrideEntities: $data}
  )
}
    `;

/**
 * __useCreateTempOverrideMutation__
 *
 * To run a mutation, you first call `useCreateTempOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTempOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTempOverrideMutation, { data, loading, error }] = useCreateTempOverrideMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTempOverrideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTempOverrideMutation, CreateTempOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTempOverrideMutation, CreateTempOverrideMutationVariables>(CreateTempOverrideDocument, options);
      }
export type CreateTempOverrideMutationHookResult = ReturnType<typeof useCreateTempOverrideMutation>;
export type CreateTempOverrideMutationResult = ApolloReactCommon.MutationResult<CreateTempOverrideMutation>;
export type CreateTempOverrideMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTempOverrideMutation, CreateTempOverrideMutationVariables>;
export const GetCatalogItemsDocument = gql`
    query getCatalogItems($data: instacart_customers_product_retrieval_v1_retailer_tools_v1_GetItemsRequest_Input!) {
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetItems(
    input: $data
  ) {
    results {
      items {
        itemId
        itemAttributes {
          retailerId
          productId
          inventoryAreaId
          elasticItemId
          generatedAt
          alcoholic
          available
          balanceOnHandQty
          bottleDepositBankId
          bottleDepositCents
          bottleDepositCurrency
          codeSetVersion
          cost
          costPricePerUnit
          costUnit
          fullPrice
          hasRetailerPromotion
          isAlcoholic
          itemType
          loyaltyAllowed
          loyaltyCostPriceCents
          loyaltyCostPriceCurrency
          loyaltyCostPriceEndAt
          loyaltyCostPricePerUnit
          loyaltyCostPriceStartAt
          loyaltyPrice
          loyaltyPriceActive
          loyaltyPriceEndAt
          loyaltyPriceStartAt
          onSale
          parWeight
          price
          priceMultiple
          pricePerUnit
          productType
          recentlyShoppedAt
          retailerProductScoreBrowseCtrPopV0
          regionId
          retailerSpecifiedAlcoholic
          retailerSalesTaxRate
          saleAllowed
          salePriceCents
          saleCostPricePerUnit
          saleEndAt
          saleStartAt
          searchable
          taxable
          unataAvailable
          unit
          unitCount
          unitPrice
          unlisted
          useWeight
          visible
          createdAt
          updatedAt
          promotionDiscountBeginsAt
          promotionDiscountEndsAt
          bogoBuy
          bogoGet
          maxInCart
          temporaryOverrideElasticItemId
          fullText
          maxCart
          cancelLeadTime
          isCatering
          orderLeadTime
          usaSnapEligible
          fulfillPickup
          fulfillDelivery
          fulfillInstore
          loyaltyMembersOnly
          promotionGroupId
          isHot
          salesType
          localeCode
          availabilityStartDate
          availabilityEndDate
          isPackagedByWeight
          retailerProductExperimentVariantId
          retailerPromotionFractionApproximation
          usaEbtcashEligible
          sfBbTempFlag
          palletQuantity
          inAssortment
          sizeUomVariable
          mentosItemPartialRowId
          catalogEntityId
          surfaceId
          pricedBySoldByType
          eversightPricing
          unataInAssortment
          proviDistributorIds
          excludeMarkup
          rewardProgram
          rewardValue
          rewardUnit
          retailerDepartment
        }
        retailerProductsAttributes {
          size
          sizeUom
          brandName
          largeImageUrl
          primaryImageUrl
          aisleIds
          aisleNames
          displayName
          productCodes
        }
        inventoryAreaAttributes {
          inventoryAreaId
          name
          regionId
          warehouseId
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useGetCatalogItemsQuery__
 *
 * To run a query within a React component, call `useGetCatalogItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogItemsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCatalogItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>(GetCatalogItemsDocument, options);
      }
export function useGetCatalogItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>(GetCatalogItemsDocument, options);
        }
export type GetCatalogItemsQueryHookResult = ReturnType<typeof useGetCatalogItemsQuery>;
export type GetCatalogItemsLazyQueryHookResult = ReturnType<typeof useGetCatalogItemsLazyQuery>;
export type GetCatalogItemsQueryResult = ApolloReactCommon.QueryResult<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>;
export const ListTempTakedownOverridesDocument = gql`
    query listTempTakedownOverrides($data: [instacart_catalog_admin_v1_TempOverrideEntityId_Input]) {
  instacart_catalog_admin_v1_TempOverrideService_List(
    input: {entities: $data, responseEntityType: "item"}
  ) {
    tempOverrideEntities {
      entityId {
        itemId
        localeId
        productId
        retailerId
        surfaceId
      }
      tempOverrideAttrs {
        attribute
        createdAt
      }
    }
  }
}
    `;

/**
 * __useListTempTakedownOverridesQuery__
 *
 * To run a query within a React component, call `useListTempTakedownOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTempTakedownOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTempTakedownOverridesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useListTempTakedownOverridesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListTempTakedownOverridesQuery, ListTempTakedownOverridesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListTempTakedownOverridesQuery, ListTempTakedownOverridesQueryVariables>(ListTempTakedownOverridesDocument, options);
      }
export function useListTempTakedownOverridesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListTempTakedownOverridesQuery, ListTempTakedownOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListTempTakedownOverridesQuery, ListTempTakedownOverridesQueryVariables>(ListTempTakedownOverridesDocument, options);
        }
export type ListTempTakedownOverridesQueryHookResult = ReturnType<typeof useListTempTakedownOverridesQuery>;
export type ListTempTakedownOverridesLazyQueryHookResult = ReturnType<typeof useListTempTakedownOverridesLazyQuery>;
export type ListTempTakedownOverridesQueryResult = ApolloReactCommon.QueryResult<ListTempTakedownOverridesQuery, ListTempTakedownOverridesQueryVariables>;
export const RetailerProductAggregateDataDocument = gql`
    query retailerProductAggregateData($retailerId: BigInt!, $productIds: [BigInt!]) {
  catalogToolsApiServiceGetRetailerProductData(
    input: {retailerId: $retailerId, productIds: $productIds}
  ) {
    retailerProductData {
      retailerId
      productId
      maxPriceCents
      minPriceCents
      availableItemsCount
      visibleItemsCount
      itemsCount
      generatedAt
    }
  }
}
    `;

/**
 * __useRetailerProductAggregateDataQuery__
 *
 * To run a query within a React component, call `useRetailerProductAggregateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerProductAggregateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerProductAggregateDataQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useRetailerProductAggregateDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RetailerProductAggregateDataQuery, RetailerProductAggregateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RetailerProductAggregateDataQuery, RetailerProductAggregateDataQueryVariables>(RetailerProductAggregateDataDocument, options);
      }
export function useRetailerProductAggregateDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RetailerProductAggregateDataQuery, RetailerProductAggregateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RetailerProductAggregateDataQuery, RetailerProductAggregateDataQueryVariables>(RetailerProductAggregateDataDocument, options);
        }
export type RetailerProductAggregateDataQueryHookResult = ReturnType<typeof useRetailerProductAggregateDataQuery>;
export type RetailerProductAggregateDataLazyQueryHookResult = ReturnType<typeof useRetailerProductAggregateDataLazyQuery>;
export type RetailerProductAggregateDataQueryResult = ApolloReactCommon.QueryResult<RetailerProductAggregateDataQuery, RetailerProductAggregateDataQueryVariables>;
export const RetailerProductSearchDocument = gql`
    query retailerProductSearch($aisleIds: [BigInt], $departmentIds: [BigInt], $limit: BigInt, $localeCode: InstacartCustomersSharedV1Locale, $offset: BigInt, $productCodes: [String], $query: String, $retailerId: BigInt!, $retailerReferenceCodes: [String]) {
  retailerToolsServiceGetRetailerProducts(
    input: {parameters: {aisleIds: $aisleIds, departmentIds: $departmentIds, limit: $limit, localeCode: $localeCode, offset: $offset, productCodes: $productCodes, query: $query, retailerId: $retailerId, retailerReferenceCodes: $retailerReferenceCodes}}
  ) {
    results {
      aisles {
        id
        name
      }
      departments {
        id
        name
      }
      localeCode
      primaryAisleId
      primaryDepartmentId
      primaryImageUrl
      productCodes
      productDisplayName
      productId
      retailerId
      retailerReferenceCode
      score
    }
    totalCount
  }
}
    `;

/**
 * __useRetailerProductSearchQuery__
 *
 * To run a query within a React component, call `useRetailerProductSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerProductSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerProductSearchQuery({
 *   variables: {
 *      aisleIds: // value for 'aisleIds'
 *      departmentIds: // value for 'departmentIds'
 *      limit: // value for 'limit'
 *      localeCode: // value for 'localeCode'
 *      offset: // value for 'offset'
 *      productCodes: // value for 'productCodes'
 *      query: // value for 'query'
 *      retailerId: // value for 'retailerId'
 *      retailerReferenceCodes: // value for 'retailerReferenceCodes'
 *   },
 * });
 */
export function useRetailerProductSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RetailerProductSearchQuery, RetailerProductSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RetailerProductSearchQuery, RetailerProductSearchQueryVariables>(RetailerProductSearchDocument, options);
      }
export function useRetailerProductSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RetailerProductSearchQuery, RetailerProductSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RetailerProductSearchQuery, RetailerProductSearchQueryVariables>(RetailerProductSearchDocument, options);
        }
export type RetailerProductSearchQueryHookResult = ReturnType<typeof useRetailerProductSearchQuery>;
export type RetailerProductSearchLazyQueryHookResult = ReturnType<typeof useRetailerProductSearchLazyQuery>;
export type RetailerProductSearchQueryResult = ApolloReactCommon.QueryResult<RetailerProductSearchQuery, RetailerProductSearchQueryVariables>;
export const GetIcPlatformVersionsDocument = gql`
    query getICPlatformVersions {
  retailersServiceGetPlatformVersions {
    platformVersion
    platformVersionRouletteName
    nextPlatformVersion
    nextPlatformVersionRouletteName
  }
}
    `;

/**
 * __useGetIcPlatformVersionsQuery__
 *
 * To run a query within a React component, call `useGetIcPlatformVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIcPlatformVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIcPlatformVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIcPlatformVersionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIcPlatformVersionsQuery, GetIcPlatformVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIcPlatformVersionsQuery, GetIcPlatformVersionsQueryVariables>(GetIcPlatformVersionsDocument, options);
      }
export function useGetIcPlatformVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIcPlatformVersionsQuery, GetIcPlatformVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIcPlatformVersionsQuery, GetIcPlatformVersionsQueryVariables>(GetIcPlatformVersionsDocument, options);
        }
export type GetIcPlatformVersionsQueryHookResult = ReturnType<typeof useGetIcPlatformVersionsQuery>;
export type GetIcPlatformVersionsLazyQueryHookResult = ReturnType<typeof useGetIcPlatformVersionsLazyQuery>;
export type GetIcPlatformVersionsQueryResult = ApolloReactCommon.QueryResult<GetIcPlatformVersionsQuery, GetIcPlatformVersionsQueryVariables>;
export const usePaginatedLookupAccountForImpersonationQuery = withPaginationDetails(useLookupAccountForImpersonationQuery, "enterpriseAccountSearch")
export const usePaginatedGetAllPartnersForUserPaginatedQuery = withPaginationDetails(useGetAllPartnersForUserPaginatedQuery, "partnerRetailerSearch")
export const usePaginatedGetStoreGroupsByRetailerQuery = withPaginationDetails(useGetStoreGroupsByRetailerQuery, "retailerLocationGroupsByRetailer")
export const usePaginatedSearchEnterpriseAccountsAccountSelectQuery = withPaginationDetails(useSearchEnterpriseAccountsAccountSelectQuery, "enterpriseAccountSearch")
export const usePaginatedListStoreGroupsQuery = withPaginationDetails(useListStoreGroupsQuery, "retailerLocationGroupsByRetailer")